(() => {
  "use strict";

  var e,
    b = {},
    p = {};
  function f(e) {
    var t = p[e];
    if (void 0 !== t) return t.exports;
    var r = p[e] = {
      exports: {}
    };
    return b[e].call(r.exports, r, r.exports, f), r.exports;
  }
  f.m = b, e = [], f.O = (t, r, a, n) => {
    if (!r) {
      var c = 1 / 0;
      for (o = 0; o < e.length; o++) {
        for (var [r, a, n] = e[o], l = !0, i = 0; i < r.length; i++) (!1 & n || c >= n) && Object.keys(f.O).every(v => f.O[v](r[i])) ? r.splice(i--, 1) : (l = !1, n < c && (c = n));
        if (l) {
          e.splice(o--, 1);
          var _ = a();
          void 0 !== _ && (t = _);
        }
      }
      return t;
    }
    n = n || 0;
    for (var o = e.length; o > 0 && e[o - 1][2] > n; o--) e[o] = e[o - 1];
    e[o] = [r, a, n];
  }, f.n = e => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return f.d(t, {
      a: t
    }), t;
  }, (() => {
    var t,
      e = Object.getPrototypeOf ? r => Object.getPrototypeOf(r) : r => r.__proto__;
    f.t = function (r, a) {
      if (1 & a && (r = this(r)), 8 & a || "object" == typeof r && r && (4 & a && r.__esModule || 16 & a && "function" == typeof r.then)) return r;
      var n = Object.create(null);
      f.r(n);
      var o = {};
      t = t || [null, e({}), e([]), e(e)];
      for (var c = 2 & a && r; "object" == typeof c && !~t.indexOf(c); c = e(c)) Object.getOwnPropertyNames(c).forEach(l => o[l] = () => r[l]);
      return o.default = () => r, f.d(n, o), n;
    };
  })(), f.d = (e, t) => {
    for (var r in t) f.o(t, r) && !f.o(e, r) && Object.defineProperty(e, r, {
      enumerable: !0,
      get: t[r]
    });
  }, f.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), f.r = e => {
    typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, (() => {
    var e = {
      666: 0
    };
    f.O.j = a => 0 === e[a];
    var t = (a, n) => {
        var i,
          _,
          [o, c, l] = n,
          s = 0;
        if (o.some(d => 0 !== e[d])) {
          for (i in c) f.o(c, i) && (f.m[i] = c[i]);
          if (l) var u = l(f);
        }
        for (a && a(n); s < o.length; s++) f.o(e, _ = o[s]) && e[_] && e[_][0](), e[_] = 0;
        return f.O(u);
      },
      r = self.webpackChunkcedar_artifact_viewer = self.webpackChunkcedar_artifact_viewer || [];
    r.forEach(t.bind(null, 0)), r.push = t.bind(null, r.push.bind(r));
  })();
})();
(self.webpackChunkcedar_artifact_viewer = self.webpackChunkcedar_artifact_viewer || []).push([[429], {
  435: (Fe, Be, $) => {
    "use strict";

    $(609), $(173);
  },
  173: () => {
    (function () {
      "use strict";

      var Fe = new Set("annotation-xml color-profile font-face font-face-src font-face-uri font-face-format font-face-name missing-glyph".split(" "));
      function Be(a) {
        var n = Fe.has(a);
        return a = /^[a-z][.0-9_a-z]*-[\-.0-9_a-z]*$/.test(a), !n && a;
      }
      function $(a) {
        var n = a.isConnected;
        if (void 0 !== n) return n;
        for (; a && !(a.__CE_isImportDocument || a instanceof Document);) a = a.parentNode || (window.ShadowRoot && a instanceof ShadowRoot ? a.host : void 0);
        return !(!a || !(a.__CE_isImportDocument || a instanceof Document));
      }
      function Pe(a, n) {
        for (; n && n !== a && !n.nextSibling;) n = n.parentNode;
        return n && n !== a ? n.nextSibling : null;
      }
      function Re(a, n, u) {
        u = void 0 === u ? new Set() : u;
        for (var h = a; h;) {
          if (h.nodeType === Node.ELEMENT_NODE) {
            var c = h;
            n(c);
            var d = c.localName;
            if ("link" === d && "import" === c.getAttribute("rel")) {
              if ((h = c.import) instanceof Node && !u.has(h)) for (u.add(h), h = h.firstChild; h; h = h.nextSibling) Re(h, n, u);
              h = Pe(a, c);
              continue;
            }
            if ("template" === d) {
              h = Pe(a, c);
              continue;
            }
            if (c = c.__CE_shadowRoot) for (c = c.firstChild; c; c = c.nextSibling) Re(c, n, u);
          }
          h = h.firstChild ? h.firstChild : Pe(a, h);
        }
      }
      function te(a, n, u) {
        a[n] = u;
      }
      function ge() {
        this.a = new Map(), this.g = new Map(), this.c = [], this.f = [], this.b = !1;
      }
      function Ke(a, n) {
        a.b && Re(n, function (u) {
          return me(a, u);
        });
      }
      function me(a, n) {
        if (a.b && !n.__CE_patched) {
          n.__CE_patched = !0;
          for (var u = 0; u < a.c.length; u++) a.c[u](n);
          for (u = 0; u < a.f.length; u++) a.f[u](n);
        }
      }
      function be(a, n) {
        var u = [];
        for (Re(n, function (c) {
          return u.push(c);
        }), n = 0; n < u.length; n++) {
          var h = u[n];
          1 === h.__CE_state ? a.connectedCallback(h) : we(a, h);
        }
      }
      function Ee(a, n) {
        var u = [];
        for (Re(n, function (c) {
          return u.push(c);
        }), n = 0; n < u.length; n++) {
          var h = u[n];
          1 === h.__CE_state && a.disconnectedCallback(h);
        }
      }
      function Oe(a, n, u) {
        var h = (u = void 0 === u ? {} : u).u || new Set(),
          c = u.i || function (y) {
            return we(a, y);
          },
          d = [];
        if (Re(n, function (y) {
          if ("link" === y.localName && "import" === y.getAttribute("rel")) {
            var b = y.import;
            b instanceof Node && (b.__CE_isImportDocument = !0, b.__CE_hasRegistry = !0), b && "complete" === b.readyState ? b.__CE_documentLoadHandled = !0 : y.addEventListener("load", function () {
              var S = y.import;
              if (!S.__CE_documentLoadHandled) {
                S.__CE_documentLoadHandled = !0;
                var B = new Set(h);
                B.delete(S), Oe(a, S, {
                  u: B,
                  i: c
                });
              }
            });
          } else d.push(y);
        }, h), a.b) for (n = 0; n < d.length; n++) me(a, d[n]);
        for (n = 0; n < d.length; n++) c(d[n]);
      }
      function we(a, n) {
        if (void 0 === n.__CE_state) {
          var u = n.ownerDocument;
          if ((u.defaultView || u.__CE_isImportDocument && u.__CE_hasRegistry) && (u = a.a.get(n.localName))) {
            u.constructionStack.push(n);
            var h = u.constructorFunction;
            try {
              try {
                if (new h() !== n) throw Error("The custom element constructor did not produce the element being upgraded.");
              } finally {
                u.constructionStack.pop();
              }
            } catch (y) {
              throw n.__CE_state = 2, y;
            }
            if (n.__CE_state = 1, n.__CE_definition = u, u.attributeChangedCallback) for (u = u.observedAttributes, h = 0; h < u.length; h++) {
              var c = u[h],
                d = n.getAttribute(c);
              null !== d && a.attributeChangedCallback(n, c, null, d, null);
            }
            $(n) && a.connectedCallback(n);
          }
        }
      }
      function De(a) {
        var n = document;
        this.c = a, this.a = n, this.b = void 0, Oe(this.c, this.a), "loading" === this.a.readyState && (this.b = new MutationObserver(this.f.bind(this)), this.b.observe(this.a, {
          childList: !0,
          subtree: !0
        }));
      }
      function Ve(a) {
        a.b && a.b.disconnect();
      }
      function ct() {
        var a = this;
        this.b = this.a = void 0, this.c = new Promise(function (n) {
          a.b = n, a.a && n(a.a);
        });
      }
      function Je(a) {
        if (a.a) throw Error("Already resolved.");
        a.a = void 0, a.b && a.b(void 0);
      }
      function A(a) {
        this.c = !1, this.a = a, this.j = new Map(), this.f = function (n) {
          return n();
        }, this.b = !1, this.g = [], this.o = new De(a);
      }
      ge.prototype.connectedCallback = function (a) {
        var n = a.__CE_definition;
        n.connectedCallback && n.connectedCallback.call(a);
      }, ge.prototype.disconnectedCallback = function (a) {
        var n = a.__CE_definition;
        n.disconnectedCallback && n.disconnectedCallback.call(a);
      }, ge.prototype.attributeChangedCallback = function (a, n, u, h, c) {
        var d = a.__CE_definition;
        d.attributeChangedCallback && -1 < d.observedAttributes.indexOf(n) && d.attributeChangedCallback.call(a, n, u, h, c);
      }, De.prototype.f = function (a) {
        var n = this.a.readyState;
        for ("interactive" !== n && "complete" !== n || Ve(this), n = 0; n < a.length; n++) for (var u = a[n].addedNodes, h = 0; h < u.length; h++) Oe(this.c, u[h]);
      }, A.prototype.l = function (a, n) {
        var u = this;
        if (!(n instanceof Function)) throw new TypeError("Custom element constructors must be functions.");
        if (!Be(a)) throw new SyntaxError("The element name '" + a + "' is not valid.");
        if (this.a.a.get(a)) throw Error("A custom element with name '" + a + "' has already been defined.");
        if (this.c) throw Error("A custom element is already being defined.");
        this.c = !0;
        try {
          var h = function (de) {
              var ze = c[de];
              if (void 0 !== ze && !(ze instanceof Function)) throw Error("The '" + de + "' callback must be a function.");
              return ze;
            },
            c = n.prototype;
          if (!(c instanceof Object)) throw new TypeError("The custom element constructor's prototype is not an object.");
          var d = h("connectedCallback"),
            y = h("disconnectedCallback"),
            b = h("adoptedCallback"),
            S = h("attributeChangedCallback"),
            B = n.observedAttributes || [];
        } catch {
          return;
        } finally {
          this.c = !1;
        }
        (function Me(a, n, u) {
          a.a.set(n, u), a.g.set(u.constructorFunction, u);
        })(this.a, a, n = {
          localName: a,
          constructorFunction: n,
          connectedCallback: d,
          disconnectedCallback: y,
          adoptedCallback: b,
          attributeChangedCallback: S,
          observedAttributes: B,
          constructionStack: []
        }), this.g.push(n), this.b || (this.b = !0, this.f(function () {
          return function Qe(a) {
            if (!1 !== a.b) {
              a.b = !1;
              for (var n = a.g, u = [], h = new Map(), c = 0; c < n.length; c++) h.set(n[c].localName, []);
              for (Oe(a.a, document, {
                i: function (b) {
                  if (void 0 === b.__CE_state) {
                    var S = b.localName,
                      B = h.get(S);
                    B ? B.push(b) : a.a.a.get(S) && u.push(b);
                  }
                }
              }), c = 0; c < u.length; c++) we(a.a, u[c]);
              for (; 0 < n.length;) {
                var d = n.shift();
                c = d.localName, d = h.get(d.localName);
                for (var y = 0; y < d.length; y++) we(a.a, d[y]);
                (c = a.j.get(c)) && Je(c);
              }
            }
          }(u);
        }));
      }, A.prototype.i = function (a) {
        Oe(this.a, a);
      }, A.prototype.get = function (a) {
        if (a = this.a.a.get(a)) return a.constructorFunction;
      }, A.prototype.m = function (a) {
        if (!Be(a)) return Promise.reject(new SyntaxError("'" + a + "' is not a valid custom element name."));
        var n = this.j.get(a);
        return n || (n = new ct(), this.j.set(a, n), this.a.a.get(a) && !this.g.some(function (u) {
          return u.localName === a;
        }) && Je(n)), n.c;
      }, A.prototype.s = function (a) {
        Ve(this.o);
        var n = this.f;
        this.f = function (u) {
          return a(function () {
            return n(u);
          });
        };
      }, window.CustomElementRegistry = A, A.prototype.define = A.prototype.l, A.prototype.upgrade = A.prototype.i, A.prototype.get = A.prototype.get, A.prototype.whenDefined = A.prototype.m, A.prototype.polyfillWrapFlushCallback = A.prototype.s;
      var Ae = window.Document.prototype.createElement,
        fe = window.Document.prototype.createElementNS,
        Mt = window.Document.prototype.importNode,
        ut = window.Document.prototype.prepend,
        Lt = window.Document.prototype.append,
        gt = window.DocumentFragment.prototype.prepend,
        Tt = window.DocumentFragment.prototype.append,
        qe = window.Node.prototype.cloneNode,
        We = window.Node.prototype.appendChild,
        lt = window.Node.prototype.insertBefore,
        Ge = window.Node.prototype.removeChild,
        ft = window.Node.prototype.replaceChild,
        $e = Object.getOwnPropertyDescriptor(window.Node.prototype, "textContent"),
        ht = window.Element.prototype.attachShadow,
        Te = Object.getOwnPropertyDescriptor(window.Element.prototype, "innerHTML"),
        Ie = window.Element.prototype.getAttribute,
        Ne = window.Element.prototype.setAttribute,
        bt = window.Element.prototype.removeAttribute,
        ke = window.Element.prototype.getAttributeNS,
        vt = window.Element.prototype.setAttributeNS,
        et = window.Element.prototype.removeAttributeNS,
        wt = window.Element.prototype.insertAdjacentElement,
        kt = window.Element.prototype.insertAdjacentHTML,
        Ue = window.Element.prototype.prepend,
        tt = window.Element.prototype.append,
        dt = window.Element.prototype.before,
        Ce = window.Element.prototype.after,
        pt = window.Element.prototype.replaceWith,
        _t = window.Element.prototype.remove,
        Ct = window.HTMLElement,
        rt = Object.getOwnPropertyDescriptor(window.HTMLElement.prototype, "innerHTML"),
        St = window.HTMLElement.prototype.insertAdjacentElement,
        Et = window.HTMLElement.prototype.insertAdjacentHTML,
        Ot = new function () {}();
      function nt(a, n, u) {
        function h(c) {
          return function (d) {
            for (var y = [], b = 0; b < arguments.length; ++b) y[b] = arguments[b];
            b = [];
            for (var S = [], B = 0; B < y.length; B++) {
              var de = y[B];
              if (de instanceof Element && $(de) && S.push(de), de instanceof DocumentFragment) for (de = de.firstChild; de; de = de.nextSibling) b.push(de);else b.push(de);
            }
            for (c.apply(this, y), y = 0; y < S.length; y++) Ee(a, S[y]);
            if ($(this)) for (y = 0; y < b.length; y++) (S = b[y]) instanceof Element && be(a, S);
          };
        }
        void 0 !== u.h && (n.prepend = h(u.h)), void 0 !== u.append && (n.append = h(u.append));
      }
      var je = window.customElements;
      if (!je || je.forcePolyfill || "function" != typeof je.define || "function" != typeof je.get) {
        var He = new ge();
        (function Zt() {
          var a = He;
          window.HTMLElement = function () {
            function n() {
              var u = this.constructor,
                h = a.g.get(u);
              if (!h) throw Error("The custom element being constructed was not registered with `customElements`.");
              var c = h.constructionStack;
              if (0 === c.length) return c = Ae.call(document, h.localName), Object.setPrototypeOf(c, u.prototype), c.__CE_state = 1, c.__CE_definition = h, me(a, c), c;
              var d = c[h = c.length - 1];
              if (d === Ot) throw Error("The HTMLElement constructor was either called reentrantly for this constructor or called multiple times.");
              return c[h] = Ot, Object.setPrototypeOf(d, u.prototype), me(a, d), d;
            }
            return n.prototype = Ct.prototype, Object.defineProperty(n.prototype, "constructor", {
              writable: !0,
              configurable: !0,
              enumerable: !1,
              value: n
            }), n;
          }();
        })(), function Pt() {
          var a = He;
          te(Document.prototype, "createElement", function (n) {
            if (this.__CE_hasRegistry) {
              var u = a.a.get(n);
              if (u) return new u.constructorFunction();
            }
            return n = Ae.call(this, n), me(a, n), n;
          }), te(Document.prototype, "importNode", function (n, u) {
            return n = Mt.call(this, n, !!u), this.__CE_hasRegistry ? Oe(a, n) : Ke(a, n), n;
          }), te(Document.prototype, "createElementNS", function (n, u) {
            if (this.__CE_hasRegistry && (null === n || "http://www.w3.org/1999/xhtml" === n)) {
              var h = a.a.get(u);
              if (h) return new h.constructorFunction();
            }
            return n = fe.call(this, n, u), me(a, n), n;
          }), nt(a, Document.prototype, {
            h: ut,
            append: Lt
          });
        }(), nt(He, DocumentFragment.prototype, {
          h: gt,
          append: Tt
        }), function yt() {
          function a(u, h) {
            Object.defineProperty(u, "textContent", {
              enumerable: h.enumerable,
              configurable: !0,
              get: h.get,
              set: function (c) {
                if (this.nodeType === Node.TEXT_NODE) h.set.call(this, c);else {
                  var d = void 0;
                  if (this.firstChild) {
                    var y = this.childNodes,
                      b = y.length;
                    if (0 < b && $(this)) {
                      d = Array(b);
                      for (var S = 0; S < b; S++) d[S] = y[S];
                    }
                  }
                  if (h.set.call(this, c), d) for (c = 0; c < d.length; c++) Ee(n, d[c]);
                }
              }
            });
          }
          var n = He;
          te(Node.prototype, "insertBefore", function (u, h) {
            if (u instanceof DocumentFragment) {
              var c = Array.prototype.slice.apply(u.childNodes);
              if (u = lt.call(this, u, h), $(this)) for (h = 0; h < c.length; h++) be(n, c[h]);
              return u;
            }
            return c = $(u), h = lt.call(this, u, h), c && Ee(n, u), $(this) && be(n, u), h;
          }), te(Node.prototype, "appendChild", function (u) {
            if (u instanceof DocumentFragment) {
              var h = Array.prototype.slice.apply(u.childNodes);
              if (u = We.call(this, u), $(this)) for (var c = 0; c < h.length; c++) be(n, h[c]);
              return u;
            }
            return h = $(u), c = We.call(this, u), h && Ee(n, u), $(this) && be(n, u), c;
          }), te(Node.prototype, "cloneNode", function (u) {
            return u = qe.call(this, !!u), this.ownerDocument.__CE_hasRegistry ? Oe(n, u) : Ke(n, u), u;
          }), te(Node.prototype, "removeChild", function (u) {
            var h = $(u),
              c = Ge.call(this, u);
            return h && Ee(n, u), c;
          }), te(Node.prototype, "replaceChild", function (u, h) {
            if (u instanceof DocumentFragment) {
              var c = Array.prototype.slice.apply(u.childNodes);
              if (u = ft.call(this, u, h), $(this)) for (Ee(n, h), h = 0; h < c.length; h++) be(n, c[h]);
              return u;
            }
            c = $(u);
            var d = ft.call(this, u, h),
              y = $(this);
            return y && Ee(n, h), c && Ee(n, u), y && be(n, u), d;
          }), $e && $e.get ? a(Node.prototype, $e) : function Ye(a, n) {
            a.b = !0, a.c.push(n);
          }(n, function (u) {
            a(u, {
              enumerable: !0,
              configurable: !0,
              get: function () {
                for (var h = [], c = 0; c < this.childNodes.length; c++) {
                  var d = this.childNodes[c];
                  d.nodeType !== Node.COMMENT_NODE && h.push(d.textContent);
                }
                return h.join("");
              },
              set: function (h) {
                for (; this.firstChild;) Ge.call(this, this.firstChild);
                null != h && "" !== h && We.call(this, document.createTextNode(h));
              }
            });
          });
        }(), function ot() {
          function a(c, d) {
            Object.defineProperty(c, "innerHTML", {
              enumerable: d.enumerable,
              configurable: !0,
              get: d.get,
              set: function (y) {
                var b = this,
                  S = void 0;
                if ($(this) && (S = [], Re(this, function (ze) {
                  ze !== b && S.push(ze);
                })), d.set.call(this, y), S) for (var B = 0; B < S.length; B++) {
                  var de = S[B];
                  1 === de.__CE_state && h.disconnectedCallback(de);
                }
                return this.ownerDocument.__CE_hasRegistry ? Oe(h, this) : Ke(h, this), y;
              }
            });
          }
          function n(c, d) {
            te(c, "insertAdjacentElement", function (y, b) {
              var S = $(b);
              return y = d.call(this, y, b), S && Ee(h, b), $(y) && be(h, b), y;
            });
          }
          function u(c, d) {
            function y(b, S) {
              for (var B = []; b !== S; b = b.nextSibling) B.push(b);
              for (S = 0; S < B.length; S++) Oe(h, B[S]);
            }
            te(c, "insertAdjacentHTML", function (b, S) {
              if ("beforebegin" === (b = b.toLowerCase())) {
                var B = this.previousSibling;
                d.call(this, b, S), y(B || this.parentNode.firstChild, this);
              } else if ("afterbegin" === b) B = this.firstChild, d.call(this, b, S), y(this.firstChild, B);else if ("beforeend" === b) B = this.lastChild, d.call(this, b, S), y(B || this.firstChild, null);else {
                if ("afterend" !== b) throw new SyntaxError("The value provided (" + String(b) + ") is not one of 'beforebegin', 'afterbegin', 'beforeend', or 'afterend'.");
                B = this.nextSibling, d.call(this, b, S), y(this.nextSibling, B);
              }
            });
          }
          var h = He;
          ht && te(Element.prototype, "attachShadow", function (c) {
            c = ht.call(this, c);
            var d = h;
            if (d.b && !c.__CE_patched) {
              c.__CE_patched = !0;
              for (var y = 0; y < d.c.length; y++) d.c[y](c);
            }
            return this.__CE_shadowRoot = c;
          }), Te && Te.get ? a(Element.prototype, Te) : rt && rt.get ? a(HTMLElement.prototype, rt) : function Ze(a, n) {
            a.b = !0, a.f.push(n);
          }(h, function (c) {
            a(c, {
              enumerable: !0,
              configurable: !0,
              get: function () {
                return qe.call(this, !0).innerHTML;
              },
              set: function (d) {
                var y = "template" === this.localName,
                  b = y ? this.content : this,
                  S = fe.call(document, this.namespaceURI, this.localName);
                for (S.innerHTML = d; 0 < b.childNodes.length;) Ge.call(b, b.childNodes[0]);
                for (d = y ? S.content : S; 0 < d.childNodes.length;) We.call(b, d.childNodes[0]);
              }
            });
          }), te(Element.prototype, "setAttribute", function (c, d) {
            if (1 !== this.__CE_state) return Ne.call(this, c, d);
            var y = Ie.call(this, c);
            Ne.call(this, c, d), d = Ie.call(this, c), h.attributeChangedCallback(this, c, y, d, null);
          }), te(Element.prototype, "setAttributeNS", function (c, d, y) {
            if (1 !== this.__CE_state) return vt.call(this, c, d, y);
            var b = ke.call(this, c, d);
            vt.call(this, c, d, y), y = ke.call(this, c, d), h.attributeChangedCallback(this, d, b, y, c);
          }), te(Element.prototype, "removeAttribute", function (c) {
            if (1 !== this.__CE_state) return bt.call(this, c);
            var d = Ie.call(this, c);
            bt.call(this, c), null !== d && h.attributeChangedCallback(this, c, d, null, null);
          }), te(Element.prototype, "removeAttributeNS", function (c, d) {
            if (1 !== this.__CE_state) return et.call(this, c, d);
            var y = ke.call(this, c, d);
            et.call(this, c, d);
            var b = ke.call(this, c, d);
            y !== b && h.attributeChangedCallback(this, d, y, b, c);
          }), St ? n(HTMLElement.prototype, St) : wt ? n(Element.prototype, wt) : console.warn("Custom Elements: `Element#insertAdjacentElement` was not patched."), Et ? u(HTMLElement.prototype, Et) : kt ? u(Element.prototype, kt) : console.warn("Custom Elements: `Element#insertAdjacentHTML` was not patched."), nt(h, Element.prototype, {
            h: Ue,
            append: tt
          }), function At(a) {
            function n(h) {
              return function (c) {
                for (var d = [], y = 0; y < arguments.length; ++y) d[y] = arguments[y];
                y = [];
                for (var b = [], S = 0; S < d.length; S++) {
                  var B = d[S];
                  if (B instanceof Element && $(B) && b.push(B), B instanceof DocumentFragment) for (B = B.firstChild; B; B = B.nextSibling) y.push(B);else y.push(B);
                }
                for (h.apply(this, d), d = 0; d < b.length; d++) Ee(a, b[d]);
                if ($(this)) for (d = 0; d < y.length; d++) (b = y[d]) instanceof Element && be(a, b);
              };
            }
            var u = Element.prototype;
            void 0 !== dt && (u.before = n(dt)), void 0 !== dt && (u.after = n(Ce)), void 0 !== pt && te(u, "replaceWith", function (h) {
              for (var c = [], d = 0; d < arguments.length; ++d) c[d] = arguments[d];
              d = [];
              for (var y = [], b = 0; b < c.length; b++) {
                var S = c[b];
                if (S instanceof Element && $(S) && y.push(S), S instanceof DocumentFragment) for (S = S.firstChild; S; S = S.nextSibling) d.push(S);else d.push(S);
              }
              for (b = $(this), pt.apply(this, c), c = 0; c < y.length; c++) Ee(a, y[c]);
              if (b) for (Ee(a, this), c = 0; c < d.length; c++) (y = d[c]) instanceof Element && be(a, y);
            }), void 0 !== _t && te(u, "remove", function () {
              var h = $(this);
              _t.call(this), h && Ee(a, this);
            });
          }(h);
        }(), document.__CE_hasRegistry = !0;
        var Rt = new A(He);
        Object.defineProperty(window, "customElements", {
          configurable: !0,
          enumerable: !0,
          value: Rt
        });
      }
    }).call(self);
  },
  609: function (Fe, Be, $) {
    "use strict";

    var Pe,
      Re,
      te = this && this.__spreadArray || function (ge, Me, Ye) {
        if (Ye || 2 === arguments.length) for (var me, Ze = 0, Ke = Me.length; Ze < Ke; Ze++) (me || !(Ze in Me)) && (me || (me = Array.prototype.slice.call(Me, 0, Ze)), me[Ze] = Me[Ze]);
        return ge.concat(me || Array.prototype.slice.call(Me));
      };
    Pe = function () {
      !function (e) {
        var t = e.performance;
        function r(m) {
          t && t.mark && t.mark(m);
        }
        function o(m, i) {
          t && t.measure && t.measure(m, i);
        }
        r("Zone");
        var f = e.__Zone_symbol_prefix || "__zone_symbol__";
        function v(m) {
          return f + m;
        }
        var E = !0 === e[v("forceDuplicateZoneCheck")];
        if (e.Zone) {
          if (E || "function" != typeof e.Zone.__symbol__) throw new Error("Zone already loaded.");
          return e.Zone;
        }
        var T = function () {
          function m(i, s) {
            this._parent = i, this._name = s ? s.name || "unnamed" : "<root>", this._properties = s && s.properties || {}, this._zoneDelegate = new P(this, this._parent && this._parent._zoneDelegate, s);
          }
          return m.assertZonePatched = function () {
            if (e.Promise !== j.ZoneAwarePromise) throw new Error("Zone.js has detected that ZoneAwarePromise `(window|global).Promise` has been overwritten.\nMost likely cause is that a Promise polyfill has been loaded after Zone.js (Polyfilling Promise api is not necessary when zone.js is loaded. If you must load one, do so before loading zone.js.)");
          }, Object.defineProperty(m, "root", {
            get: function () {
              for (var i = m.current; i.parent;) i = i.parent;
              return i;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(m, "current", {
            get: function () {
              return ne.zone;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(m, "currentTask", {
            get: function () {
              return Se;
            },
            enumerable: !1,
            configurable: !0
          }), m.__load_patch = function (i, s, l) {
            if (void 0 === l && (l = !1), j.hasOwnProperty(i)) {
              if (!l && E) throw Error("Already loaded patch: " + i);
            } else if (!e["__Zone_disable_" + i]) {
              var L = "Zone:" + i;
              r(L), j[i] = s(e, m, ie), o(L, L);
            }
          }, Object.defineProperty(m.prototype, "parent", {
            get: function () {
              return this._parent;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(m.prototype, "name", {
            get: function () {
              return this._name;
            },
            enumerable: !1,
            configurable: !0
          }), m.prototype.get = function (i) {
            var s = this.getZoneWith(i);
            if (s) return s._properties[i];
          }, m.prototype.getZoneWith = function (i) {
            for (var s = this; s;) {
              if (s._properties.hasOwnProperty(i)) return s;
              s = s._parent;
            }
            return null;
          }, m.prototype.fork = function (i) {
            if (!i) throw new Error("ZoneSpec required!");
            return this._zoneDelegate.fork(this, i);
          }, m.prototype.wrap = function (i, s) {
            if ("function" != typeof i) throw new Error("Expecting function got: " + i);
            var l = this._zoneDelegate.intercept(this, i, s),
              L = this;
            return function () {
              return L.runGuarded(l, this, arguments, s);
            };
          }, m.prototype.run = function (i, s, l, L) {
            ne = {
              parent: ne,
              zone: this
            };
            try {
              return this._zoneDelegate.invoke(this, i, s, l, L);
            } finally {
              ne = ne.parent;
            }
          }, m.prototype.runGuarded = function (i, s, l, L) {
            void 0 === s && (s = null), ne = {
              parent: ne,
              zone: this
            };
            try {
              try {
                return this._zoneDelegate.invoke(this, i, s, l, L);
              } catch (se) {
                if (this._zoneDelegate.handleError(this, se)) throw se;
              }
            } finally {
              ne = ne.parent;
            }
          }, m.prototype.runTask = function (i, s, l) {
            if (i.zone != this) throw new Error("A task can only be run in the zone of creation! (Creation: " + (i.zone || N).name + "; Execution: " + this.name + ")");
            if (i.state !== re || i.type !== z && i.type !== I) {
              var L = i.state != Q;
              L && i._transitionTo(Q, J), i.runCount++;
              var se = Se;
              Se = i, ne = {
                parent: ne,
                zone: this
              };
              try {
                i.type == I && i.data && !i.data.isPeriodic && (i.cancelFn = void 0);
                try {
                  return this._zoneDelegate.invokeTask(this, i, s, l);
                } catch (Le) {
                  if (this._zoneDelegate.handleError(this, Le)) throw Le;
                }
              } finally {
                i.state !== re && i.state !== oe && (i.type == z || i.data && i.data.isPeriodic ? L && i._transitionTo(J, Q) : (i.runCount = 0, this._updateTaskCount(i, -1), L && i._transitionTo(re, Q, re))), ne = ne.parent, Se = se;
              }
            }
          }, m.prototype.scheduleTask = function (i) {
            if (i.zone && i.zone !== this) for (var s = this; s;) {
              if (s === i.zone) throw Error("can not reschedule task to ".concat(this.name, " which is descendants of the original zone ").concat(i.zone.name));
              s = s.parent;
            }
            i._transitionTo(q, re);
            var l = [];
            i._zoneDelegates = l, i._zone = this;
            try {
              i = this._zoneDelegate.scheduleTask(this, i);
            } catch (L) {
              throw i._transitionTo(oe, q, re), this._zoneDelegate.handleError(this, L), L;
            }
            return i._zoneDelegates === l && this._updateTaskCount(i, 1), i.state == q && i._transitionTo(J, q), i;
          }, m.prototype.scheduleMicroTask = function (i, s, l, L) {
            return this.scheduleTask(new k(V, i, s, l, L, void 0));
          }, m.prototype.scheduleMacroTask = function (i, s, l, L, se) {
            return this.scheduleTask(new k(I, i, s, l, L, se));
          }, m.prototype.scheduleEventTask = function (i, s, l, L, se) {
            return this.scheduleTask(new k(z, i, s, l, L, se));
          }, m.prototype.cancelTask = function (i) {
            if (i.zone != this) throw new Error("A task can only be cancelled in the zone of creation! (Creation: " + (i.zone || N).name + "; Execution: " + this.name + ")");
            i._transitionTo(M, J, Q);
            try {
              this._zoneDelegate.cancelTask(this, i);
            } catch (s) {
              throw i._transitionTo(oe, M), this._zoneDelegate.handleError(this, s), s;
            }
            return this._updateTaskCount(i, -1), i._transitionTo(re, M), i.runCount = 0, i;
          }, m.prototype._updateTaskCount = function (i, s) {
            var l = i._zoneDelegates;
            -1 == s && (i._zoneDelegates = null);
            for (var L = 0; L < l.length; L++) l[L]._updateTaskCount(i.type, s);
          }, m;
        }();
        T.__symbol__ = v;
        var he,
          C = {
            name: "",
            onHasTask: function (m, i, s, l) {
              return m.hasTask(s, l);
            },
            onScheduleTask: function (m, i, s, l) {
              return m.scheduleTask(s, l);
            },
            onInvokeTask: function (m, i, s, l, L, se) {
              return m.invokeTask(s, l, L, se);
            },
            onCancelTask: function (m, i, s, l) {
              return m.cancelTask(s, l);
            }
          },
          P = function () {
            function m(i, s, l) {
              this._taskCounts = {
                microTask: 0,
                macroTask: 0,
                eventTask: 0
              }, this.zone = i, this._parentDelegate = s, this._forkZS = l && (l && l.onFork ? l : s._forkZS), this._forkDlgt = l && (l.onFork ? s : s._forkDlgt), this._forkCurrZone = l && (l.onFork ? this.zone : s._forkCurrZone), this._interceptZS = l && (l.onIntercept ? l : s._interceptZS), this._interceptDlgt = l && (l.onIntercept ? s : s._interceptDlgt), this._interceptCurrZone = l && (l.onIntercept ? this.zone : s._interceptCurrZone), this._invokeZS = l && (l.onInvoke ? l : s._invokeZS), this._invokeDlgt = l && (l.onInvoke ? s : s._invokeDlgt), this._invokeCurrZone = l && (l.onInvoke ? this.zone : s._invokeCurrZone), this._handleErrorZS = l && (l.onHandleError ? l : s._handleErrorZS), this._handleErrorDlgt = l && (l.onHandleError ? s : s._handleErrorDlgt), this._handleErrorCurrZone = l && (l.onHandleError ? this.zone : s._handleErrorCurrZone), this._scheduleTaskZS = l && (l.onScheduleTask ? l : s._scheduleTaskZS), this._scheduleTaskDlgt = l && (l.onScheduleTask ? s : s._scheduleTaskDlgt), this._scheduleTaskCurrZone = l && (l.onScheduleTask ? this.zone : s._scheduleTaskCurrZone), this._invokeTaskZS = l && (l.onInvokeTask ? l : s._invokeTaskZS), this._invokeTaskDlgt = l && (l.onInvokeTask ? s : s._invokeTaskDlgt), this._invokeTaskCurrZone = l && (l.onInvokeTask ? this.zone : s._invokeTaskCurrZone), this._cancelTaskZS = l && (l.onCancelTask ? l : s._cancelTaskZS), this._cancelTaskDlgt = l && (l.onCancelTask ? s : s._cancelTaskDlgt), this._cancelTaskCurrZone = l && (l.onCancelTask ? this.zone : s._cancelTaskCurrZone), this._hasTaskZS = null, this._hasTaskDlgt = null, this._hasTaskDlgtOwner = null, this._hasTaskCurrZone = null;
              var L = l && l.onHasTask;
              (L || s && s._hasTaskZS) && (this._hasTaskZS = L ? l : C, this._hasTaskDlgt = s, this._hasTaskDlgtOwner = this, this._hasTaskCurrZone = i, l.onScheduleTask || (this._scheduleTaskZS = C, this._scheduleTaskDlgt = s, this._scheduleTaskCurrZone = this.zone), l.onInvokeTask || (this._invokeTaskZS = C, this._invokeTaskDlgt = s, this._invokeTaskCurrZone = this.zone), l.onCancelTask || (this._cancelTaskZS = C, this._cancelTaskDlgt = s, this._cancelTaskCurrZone = this.zone));
            }
            return m.prototype.fork = function (i, s) {
              return this._forkZS ? this._forkZS.onFork(this._forkDlgt, this.zone, i, s) : new T(i, s);
            }, m.prototype.intercept = function (i, s, l) {
              return this._interceptZS ? this._interceptZS.onIntercept(this._interceptDlgt, this._interceptCurrZone, i, s, l) : s;
            }, m.prototype.invoke = function (i, s, l, L, se) {
              return this._invokeZS ? this._invokeZS.onInvoke(this._invokeDlgt, this._invokeCurrZone, i, s, l, L, se) : s.apply(l, L);
            }, m.prototype.handleError = function (i, s) {
              return !this._handleErrorZS || this._handleErrorZS.onHandleError(this._handleErrorDlgt, this._handleErrorCurrZone, i, s);
            }, m.prototype.scheduleTask = function (i, s) {
              var l = s;
              if (this._scheduleTaskZS) this._hasTaskZS && l._zoneDelegates.push(this._hasTaskDlgtOwner), (l = this._scheduleTaskZS.onScheduleTask(this._scheduleTaskDlgt, this._scheduleTaskCurrZone, i, s)) || (l = s);else if (s.scheduleFn) s.scheduleFn(s);else {
                if (s.type != V) throw new Error("Task is missing scheduleFn.");
                ue(s);
              }
              return l;
            }, m.prototype.invokeTask = function (i, s, l, L) {
              return this._invokeTaskZS ? this._invokeTaskZS.onInvokeTask(this._invokeTaskDlgt, this._invokeTaskCurrZone, i, s, l, L) : s.callback.apply(l, L);
            }, m.prototype.cancelTask = function (i, s) {
              var l;
              if (this._cancelTaskZS) l = this._cancelTaskZS.onCancelTask(this._cancelTaskDlgt, this._cancelTaskCurrZone, i, s);else {
                if (!s.cancelFn) throw Error("Task is not cancelable");
                l = s.cancelFn(s);
              }
              return l;
            }, m.prototype.hasTask = function (i, s) {
              try {
                this._hasTaskZS && this._hasTaskZS.onHasTask(this._hasTaskDlgt, this._hasTaskCurrZone, i, s);
              } catch (l) {
                this.handleError(i, l);
              }
            }, m.prototype._updateTaskCount = function (i, s) {
              var l = this._taskCounts,
                L = l[i],
                se = l[i] = L + s;
              if (se < 0) throw new Error("More tasks executed then were scheduled.");
              0 != L && 0 != se || this.hasTask(this.zone, {
                microTask: l.microTask > 0,
                macroTask: l.macroTask > 0,
                eventTask: l.eventTask > 0,
                change: i
              });
            }, m;
          }(),
          k = function () {
            function m(i, s, l, L, se, Le) {
              if (this._zone = null, this.runCount = 0, this._zoneDelegates = null, this._state = "notScheduled", this.type = i, this.source = s, this.data = L, this.scheduleFn = se, this.cancelFn = Le, !l) throw new Error("callback is not defined");
              this.callback = l;
              var _ = this;
              this.invoke = i === z && L && L.useG ? m.invokeTask : function () {
                return m.invokeTask.call(e, _, this, arguments);
              };
            }
            return m.invokeTask = function (i, s, l) {
              i || (i = this), le++;
              try {
                return i.runCount++, i.zone.runTask(i, s, l);
              } finally {
                1 == le && X(), le--;
              }
            }, Object.defineProperty(m.prototype, "zone", {
              get: function () {
                return this._zone;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(m.prototype, "state", {
              get: function () {
                return this._state;
              },
              enumerable: !1,
              configurable: !0
            }), m.prototype.cancelScheduleRequest = function () {
              this._transitionTo(re, q);
            }, m.prototype._transitionTo = function (i, s, l) {
              if (this._state !== s && this._state !== l) throw new Error("".concat(this.type, " '").concat(this.source, "': can not transition to '").concat(i, "', expecting state '").concat(s, "'").concat(l ? " or '" + l + "'" : "", ", was '").concat(this._state, "'."));
              this._state = i, i == re && (this._zoneDelegates = null);
            }, m.prototype.toString = function () {
              return this.data && typeof this.data.handleId < "u" ? this.data.handleId.toString() : Object.prototype.toString.call(this);
            }, m.prototype.toJSON = function () {
              return {
                type: this.type,
                state: this.state,
                source: this.source,
                zone: this.zone.name,
                runCount: this.runCount
              };
            }, m;
          }(),
          D = v("setTimeout"),
          R = v("Promise"),
          x = v("then"),
          F = [],
          K = !1;
        function ee(m) {
          if (he || e[R] && (he = e[R].resolve(0)), he) {
            var i = he[x];
            i || (i = he.then), i.call(he, m);
          } else e[D](m, 0);
        }
        function ue(m) {
          0 === le && 0 === F.length && ee(X), m && F.push(m);
        }
        function X() {
          if (!K) {
            for (K = !0; F.length;) {
              var m = F;
              F = [];
              for (var i = 0; i < m.length; i++) {
                var s = m[i];
                try {
                  s.zone.runTask(s, null, null);
                } catch (l) {
                  ie.onUnhandledError(l);
                }
              }
            }
            ie.microtaskDrainDone(), K = !1;
          }
        }
        var N = {
            name: "NO ZONE"
          },
          re = "notScheduled",
          q = "scheduling",
          J = "scheduled",
          Q = "running",
          M = "canceling",
          oe = "unknown",
          V = "microTask",
          I = "macroTask",
          z = "eventTask",
          j = {},
          ie = {
            symbol: v,
            currentZoneFrame: function () {
              return ne;
            },
            onUnhandledError: ae,
            microtaskDrainDone: ae,
            scheduleMicroTask: ue,
            showUncaughtError: function () {
              return !T[v("ignoreConsoleErrorUncaughtError")];
            },
            patchEventTarget: function () {
              return [];
            },
            patchOnProperties: ae,
            patchMethod: function () {
              return ae;
            },
            bindArguments: function () {
              return [];
            },
            patchThen: function () {
              return ae;
            },
            patchMacroTask: function () {
              return ae;
            },
            patchEventPrototype: function () {
              return ae;
            },
            isIEOrEdge: function () {
              return !1;
            },
            getGlobalObjects: function () {},
            ObjectDefineProperty: function () {
              return ae;
            },
            ObjectGetOwnPropertyDescriptor: function () {},
            ObjectCreate: function () {},
            ArraySlice: function () {
              return [];
            },
            patchClass: function () {
              return ae;
            },
            wrapWithCurrentZone: function () {
              return ae;
            },
            filterProperties: function () {
              return [];
            },
            attachOriginToPatched: function () {
              return ae;
            },
            _redefineProperty: function () {
              return ae;
            },
            patchCallbacks: function () {
              return ae;
            },
            nativeScheduleMicroTask: ee
          },
          ne = {
            parent: null,
            zone: new T(null, null)
          },
          Se = null,
          le = 0;
        function ae() {}
        o("Zone", "Zone"), e.Zone = T;
      }(typeof window < "u" && window || typeof self < "u" && self || global);
      var ge = Object.getOwnPropertyDescriptor,
        Me = Object.defineProperty,
        Ye = Object.getPrototypeOf,
        Ze = Object.create,
        Ke = Array.prototype.slice,
        me = "addEventListener",
        be = "removeEventListener",
        Ee = Zone.__symbol__(me),
        Oe = Zone.__symbol__(be),
        we = "true",
        De = "false",
        Ve = Zone.__symbol__("");
      function ct(e, t) {
        return Zone.current.wrap(e, t);
      }
      function Je(e, t, r, o, f) {
        return Zone.current.scheduleMacroTask(e, t, r, o, f);
      }
      var A = Zone.__symbol__,
        Qe = typeof window < "u",
        Ae = Qe ? window : void 0,
        fe = Qe && Ae || "object" == typeof self && self || global;
      function ut(e, t) {
        for (var r = e.length - 1; r >= 0; r--) "function" == typeof e[r] && (e[r] = ct(e[r], t + "_" + r));
        return e;
      }
      function gt(e) {
        return !e || !1 !== e.writable && !("function" == typeof e.get && typeof e.set > "u");
      }
      var Tt = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope,
        qe = !("nw" in fe) && typeof fe.process < "u" && "[object process]" === {}.toString.call(fe.process),
        We = !qe && !Tt && !(!Qe || !Ae.HTMLElement),
        lt = typeof fe.process < "u" && "[object process]" === {}.toString.call(fe.process) && !Tt && !(!Qe || !Ae.HTMLElement),
        Ge = {},
        ft = function (e) {
          if (e = e || fe.event) {
            var t = Ge[e.type];
            t || (t = Ge[e.type] = A("ON_PROPERTY" + e.type));
            var f,
              r = this || e.target || fe,
              o = r[t];
            return We && r === Ae && "error" === e.type ? !0 === (f = o && o.call(this, e.message, e.filename, e.lineno, e.colno, e.error)) && e.preventDefault() : null != (f = o && o.apply(this, arguments)) && !f && e.preventDefault(), f;
          }
        };
      function $e(e, t, r) {
        var o = ge(e, t);
        if (!o && r && ge(r, t) && (o = {
          enumerable: !0,
          configurable: !0
        }), o && o.configurable) {
          var v = A("on" + t + "patched");
          if (!e.hasOwnProperty(v) || !e[v]) {
            delete o.writable, delete o.value;
            var E = o.get,
              T = o.set,
              C = t.slice(2),
              P = Ge[C];
            P || (P = Ge[C] = A("ON_PROPERTY" + C)), o.set = function (k) {
              var D = this;
              !D && e === fe && (D = fe), D && ("function" == typeof D[P] && D.removeEventListener(C, ft), T && T.call(D, null), D[P] = k, "function" == typeof k && D.addEventListener(C, ft, !1));
            }, o.get = function () {
              var k = this;
              if (!k && e === fe && (k = fe), !k) return null;
              var D = k[P];
              if (D) return D;
              if (E) {
                var R = E.call(this);
                if (R) return o.set.call(this, R), "function" == typeof k.removeAttribute && k.removeAttribute(t), R;
              }
              return null;
            }, Me(e, t, o), e[v] = !0;
          }
        }
      }
      function ht(e, t, r) {
        if (t) for (var o = 0; o < t.length; o++) $e(e, "on" + t[o], r);else {
          var f = [];
          for (var v in e) "on" == v.slice(0, 2) && f.push(v);
          for (var E = 0; E < f.length; E++) $e(e, f[E], r);
        }
      }
      var Te = A("originalInstance");
      function Ie(e) {
        var t = fe[e];
        if (t) {
          fe[A(e)] = t, fe[e] = function () {
            var f = ut(arguments, e);
            switch (f.length) {
              case 0:
                this[Te] = new t();
                break;
              case 1:
                this[Te] = new t(f[0]);
                break;
              case 2:
                this[Te] = new t(f[0], f[1]);
                break;
              case 3:
                this[Te] = new t(f[0], f[1], f[2]);
                break;
              case 4:
                this[Te] = new t(f[0], f[1], f[2], f[3]);
                break;
              default:
                throw new Error("Arg list too long.");
            }
          }, ke(fe[e], t);
          var o,
            r = new t(function () {});
          for (o in r) "XMLHttpRequest" === e && "responseBlob" === o || function (f) {
            "function" == typeof r[f] ? fe[e].prototype[f] = function () {
              return this[Te][f].apply(this[Te], arguments);
            } : Me(fe[e].prototype, f, {
              set: function (v) {
                "function" == typeof v ? (this[Te][f] = ct(v, e + "." + f), ke(this[Te][f], v)) : this[Te][f] = v;
              },
              get: function () {
                return this[Te][f];
              }
            });
          }(o);
          for (o in t) "prototype" !== o && t.hasOwnProperty(o) && (fe[e][o] = t[o]);
        }
      }
      function Ne(e, t, r) {
        for (var o = e; o && !o.hasOwnProperty(t);) o = Ye(o);
        !o && e[t] && (o = e);
        var f = A(t),
          v = null;
        if (o && (!(v = o[f]) || !o.hasOwnProperty(f)) && (v = o[f] = o[t], gt(o && ge(o, t)))) {
          var T = r(v, f, t);
          o[t] = function () {
            return T(this, arguments);
          }, ke(o[t], v);
        }
        return v;
      }
      function bt(e, t, r) {
        var o = null;
        function f(v) {
          var E = v.data;
          return E.args[E.cbIdx] = function () {
            v.invoke.apply(this, arguments);
          }, o.apply(E.target, E.args), v;
        }
        o = Ne(e, t, function (v) {
          return function (E, T) {
            var C = r(E, T);
            return C.cbIdx >= 0 && "function" == typeof T[C.cbIdx] ? Je(C.name, T[C.cbIdx], C, f) : v.apply(E, T);
          };
        });
      }
      function ke(e, t) {
        e[A("OriginalDelegate")] = t;
      }
      var vt = !1,
        et = !1;
      function kt() {
        if (vt) return et;
        vt = !0;
        try {
          var e = Ae.navigator.userAgent;
          (-1 !== e.indexOf("MSIE ") || -1 !== e.indexOf("Trident/") || -1 !== e.indexOf("Edge/")) && (et = !0);
        } catch {}
        return et;
      }
      Zone.__load_patch("ZoneAwarePromise", function (e, t, r) {
        var o = Object.getOwnPropertyDescriptor,
          f = Object.defineProperty;
        var E = r.symbol,
          T = [],
          C = !0 === e[E("DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION")],
          P = E("Promise"),
          k = E("then");
        r.onUnhandledError = function (_) {
          if (r.showUncaughtError()) {
            var w = _ && _.rejection;
            w ? console.error("Unhandled Promise rejection:", w instanceof Error ? w.message : w, "; Zone:", _.zone.name, "; Task:", _.task && _.task.source, "; Value:", w, w instanceof Error ? w.stack : void 0) : console.error(_);
          }
        }, r.microtaskDrainDone = function () {
          for (var _ = function () {
            var w = T.shift();
            try {
              w.zone.runGuarded(function () {
                throw w.throwOriginal ? w.rejection : w;
              });
            } catch (g) {
              !function x(_) {
                r.onUnhandledError(_);
                try {
                  var w = t[R];
                  "function" == typeof w && w.call(this, _);
                } catch {}
              }(g);
            }
          }; T.length;) _();
        };
        var R = E("unhandledPromiseRejectionHandler");
        function F(_) {
          return _ && _.then;
        }
        function K(_) {
          return _;
        }
        function he(_) {
          return s.reject(_);
        }
        var ee = E("state"),
          ue = E("value"),
          X = E("finally"),
          N = E("parentPromiseValue"),
          re = E("parentPromiseState"),
          J = null,
          Q = !0,
          M = !1;
        function V(_, w) {
          return function (g) {
            try {
              ie(_, w, g);
            } catch (p) {
              ie(_, !1, p);
            }
          };
        }
        var I = function () {
            var _ = !1;
            return function (g) {
              return function () {
                _ || (_ = !0, g.apply(null, arguments));
              };
            };
          },
          j = E("currentTaskTrace");
        function ie(_, w, g) {
          var p = I();
          if (_ === g) throw new TypeError("Promise resolved with itself");
          if (_[ee] === J) {
            var O = null;
            try {
              ("object" == typeof g || "function" == typeof g) && (O = g && g.then);
            } catch (U) {
              return p(function () {
                ie(_, !1, U);
              })(), _;
            }
            if (w !== M && g instanceof s && g.hasOwnProperty(ee) && g.hasOwnProperty(ue) && g[ee] !== J) Se(g), ie(_, g[ee], g[ue]);else if (w !== M && "function" == typeof O) try {
              O.call(g, p(V(_, w)), p(V(_, !1)));
            } catch (U) {
              p(function () {
                ie(_, !1, U);
              })();
            } else {
              _[ee] = w;
              var H = _[ue];
              if (_[ue] = g, _[X] === X && w === Q && (_[ee] = _[re], _[ue] = _[N]), w === M && g instanceof Error) {
                var Z = t.currentTask && t.currentTask.data && t.currentTask.data.__creationTrace__;
                Z && f(g, j, {
                  configurable: !0,
                  enumerable: !1,
                  writable: !0,
                  value: Z
                });
              }
              for (var W = 0; W < H.length;) le(_, H[W++], H[W++], H[W++], H[W++]);
              if (0 == H.length && w == M) {
                _[ee] = 0;
                var G = g;
                try {
                  throw new Error("Uncaught (in promise): " + function v(_) {
                    return _ && _.toString === Object.prototype.toString ? (_.constructor && _.constructor.name || "") + ": " + JSON.stringify(_) : _ ? _.toString() : Object.prototype.toString.call(_);
                  }(g) + (g && g.stack ? "\n" + g.stack : ""));
                } catch (U) {
                  G = U;
                }
                C && (G.throwOriginal = !0), G.rejection = g, G.promise = _, G.zone = t.current, G.task = t.currentTask, T.push(G), r.scheduleMicroTask();
              }
            }
          }
          return _;
        }
        var ne = E("rejectionHandledHandler");
        function Se(_) {
          if (0 === _[ee]) {
            try {
              var w = t[ne];
              w && "function" == typeof w && w.call(this, {
                rejection: _[ue],
                promise: _
              });
            } catch {}
            _[ee] = M;
            for (var g = 0; g < T.length; g++) _ === T[g].promise && T.splice(g, 1);
          }
        }
        function le(_, w, g, p, O) {
          Se(_);
          var H = _[ee],
            Z = H ? "function" == typeof p ? p : K : "function" == typeof O ? O : he;
          w.scheduleMicroTask("Promise.then", function () {
            try {
              var W = _[ue],
                G = !!g && X === g[X];
              G && (g[N] = W, g[re] = H);
              var U = w.run(Z, void 0, G && Z !== he && Z !== K ? [] : [W]);
              ie(g, !0, U);
            } catch (Y) {
              ie(g, !1, Y);
            }
          }, g);
        }
        var m = function () {},
          i = e.AggregateError,
          s = function () {
            function _(w) {
              var g = this;
              if (!(g instanceof _)) throw new Error("Must be an instanceof Promise.");
              g[ee] = J, g[ue] = [];
              try {
                var p = I();
                w && w(p(V(g, Q)), p(V(g, M)));
              } catch (O) {
                ie(g, !1, O);
              }
            }
            return _.toString = function () {
              return "function ZoneAwarePromise() { [native code] }";
            }, _.resolve = function (w) {
              return ie(new this(null), Q, w);
            }, _.reject = function (w) {
              return ie(new this(null), M, w);
            }, _.any = function (w) {
              if (!w || "function" != typeof w[Symbol.iterator]) return Promise.reject(new i([], "All promises were rejected"));
              var g = [],
                p = 0;
              try {
                for (var O = 0, H = w; O < H.length; O++) p++, g.push(_.resolve(H[O]));
              } catch {
                return Promise.reject(new i([], "All promises were rejected"));
              }
              if (0 === p) return Promise.reject(new i([], "All promises were rejected"));
              var W = !1,
                G = [];
              return new _(function (U, Y) {
                for (var ce = 0; ce < g.length; ce++) g[ce].then(function (ye) {
                  W || (W = !0, U(ye));
                }, function (ye) {
                  G.push(ye), 0 == --p && (W = !0, Y(new i(G, "All promises were rejected")));
                });
              });
            }, _.race = function (w) {
              var g,
                p,
                O = new this(function (Y, ce) {
                  g = Y, p = ce;
                });
              function H(Y) {
                g(Y);
              }
              function Z(Y) {
                p(Y);
              }
              for (var W = 0, G = w; W < G.length; W++) {
                var U = G[W];
                F(U) || (U = this.resolve(U)), U.then(H, Z);
              }
              return O;
            }, _.all = function (w) {
              return _.allWithCallback(w);
            }, _.allSettled = function (w) {
              return (this && this.prototype instanceof _ ? this : _).allWithCallback(w, {
                thenCallback: function (p) {
                  return {
                    status: "fulfilled",
                    value: p
                  };
                },
                errorCallback: function (p) {
                  return {
                    status: "rejected",
                    reason: p
                  };
                }
              });
            }, _.allWithCallback = function (w, g) {
              for (var p, O, H = new this(function (pe, _e) {
                  p = pe, O = _e;
                }), Z = 2, W = 0, G = [], U = function (pe) {
                  F(pe) || (pe = Y.resolve(pe));
                  var _e = W;
                  try {
                    pe.then(function (ve) {
                      G[_e] = g ? g.thenCallback(ve) : ve, 0 == --Z && p(G);
                    }, function (ve) {
                      g ? (G[_e] = g.errorCallback(ve), 0 == --Z && p(G)) : O(ve);
                    });
                  } catch (ve) {
                    O(ve);
                  }
                  Z++, W++;
                }, Y = this, ce = 0, ye = w; ce < ye.length; ce++) U(ye[ce]);
              return 0 == (Z -= 2) && p(G), H;
            }, Object.defineProperty(_.prototype, Symbol.toStringTag, {
              get: function () {
                return "Promise";
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(_.prototype, Symbol.species, {
              get: function () {
                return _;
              },
              enumerable: !1,
              configurable: !0
            }), _.prototype.then = function (w, g) {
              var p,
                O = null === (p = this.constructor) || void 0 === p ? void 0 : p[Symbol.species];
              (!O || "function" != typeof O) && (O = this.constructor || _);
              var H = new O(m),
                Z = t.current;
              return this[ee] == J ? this[ue].push(Z, H, w, g) : le(this, Z, H, w, g), H;
            }, _.prototype.catch = function (w) {
              return this.then(null, w);
            }, _.prototype.finally = function (w) {
              var g,
                p = null === (g = this.constructor) || void 0 === g ? void 0 : g[Symbol.species];
              (!p || "function" != typeof p) && (p = _);
              var O = new p(m);
              O[X] = X;
              var H = t.current;
              return this[ee] == J ? this[ue].push(H, O, w, w) : le(this, H, O, w, w), O;
            }, _;
          }();
        s.resolve = s.resolve, s.reject = s.reject, s.race = s.race, s.all = s.all;
        var l = e[P] = e.Promise;
        e.Promise = s;
        var L = E("thenPatched");
        function se(_) {
          var w = _.prototype,
            g = o(w, "then");
          if (!g || !1 !== g.writable && g.configurable) {
            var p = w.then;
            w[k] = p, _.prototype.then = function (O, H) {
              var Z = this;
              return new s(function (G, U) {
                p.call(Z, G, U);
              }).then(O, H);
            }, _[L] = !0;
          }
        }
        return r.patchThen = se, l && (se(l), Ne(e, "fetch", function (_) {
          return function Le(_) {
            return function (w, g) {
              var p = _.apply(w, g);
              if (p instanceof s) return p;
              var O = p.constructor;
              return O[L] || se(O), p;
            };
          }(_);
        })), Promise[t.__symbol__("uncaughtPromiseErrors")] = T, s;
      }), Zone.__load_patch("toString", function (e) {
        var t = Function.prototype.toString,
          r = A("OriginalDelegate"),
          o = A("Promise"),
          f = A("Error"),
          v = function () {
            if ("function" == typeof this) {
              var P = this[r];
              if (P) return "function" == typeof P ? t.call(P) : Object.prototype.toString.call(P);
              if (this === Promise) {
                var k = e[o];
                if (k) return t.call(k);
              }
              if (this === Error) {
                var D = e[f];
                if (D) return t.call(D);
              }
            }
            return t.call(this);
          };
        v[r] = t, Function.prototype.toString = v;
        var E = Object.prototype.toString;
        Object.prototype.toString = function () {
          return "function" == typeof Promise && this instanceof Promise ? "[object Promise]" : E.call(this);
        };
      });
      var Ue = !1;
      if (typeof window < "u") try {
        var tt = Object.defineProperty({}, "passive", {
          get: function () {
            Ue = !0;
          }
        });
        window.addEventListener("test", tt, tt), window.removeEventListener("test", tt, tt);
      } catch {
        Ue = !1;
      }
      var ot,
        je,
        He,
        Rt,
        a,
        dt = {
          useG: !0
        },
        Ce = {},
        pt = {},
        _t = new RegExp("^" + Ve + "(\\w+)(true|false)$"),
        Ct = A("propagationStopped");
      function rt(e, t) {
        var r = (t ? t(e) : e) + De,
          o = (t ? t(e) : e) + we,
          f = Ve + r,
          v = Ve + o;
        Ce[e] = {}, Ce[e][De] = f, Ce[e][we] = v;
      }
      function St(e, t, r, o) {
        var f = o && o.add || me,
          v = o && o.rm || be,
          E = o && o.listeners || "eventListeners",
          T = o && o.rmAll || "removeAllListeners",
          C = A(f),
          P = "." + f + ":",
          k = "prependListener",
          R = function (X, N, re) {
            if (!X.isRemoved) {
              var J,
                q = X.callback;
              "object" == typeof q && q.handleEvent && (X.callback = function (oe) {
                return q.handleEvent(oe);
              }, X.originalDelegate = q);
              try {
                X.invoke(X, N, [re]);
              } catch (oe) {
                J = oe;
              }
              var Q = X.options;
              return Q && "object" == typeof Q && Q.once && N[v].call(N, re.type, X.originalDelegate ? X.originalDelegate : X.callback, Q), J;
            }
          };
        function x(X, N, re) {
          if (N = N || e.event) {
            var q = X || N.target || e,
              J = q[Ce[N.type][re ? we : De]];
            if (J) {
              var Q = [];
              if (1 === J.length) (M = R(J[0], q, N)) && Q.push(M);else for (var oe = J.slice(), V = 0; V < oe.length && (!N || !0 !== N[Ct]); V++) {
                var M;
                (M = R(oe[V], q, N)) && Q.push(M);
              }
              if (1 === Q.length) throw Q[0];
              var I = function (z) {
                var j = Q[z];
                t.nativeScheduleMicroTask(function () {
                  throw j;
                });
              };
              for (V = 0; V < Q.length; V++) I(V);
            }
          }
        }
        var F = function (X) {
            return x(this, X, !1);
          },
          K = function (X) {
            return x(this, X, !0);
          };
        function he(X, N) {
          if (!X) return !1;
          var re = !0;
          N && void 0 !== N.useG && (re = N.useG);
          var q = N && N.vh,
            J = !0;
          N && void 0 !== N.chkDup && (J = N.chkDup);
          var Q = !1;
          N && void 0 !== N.rt && (Q = N.rt);
          for (var M = X; M && !M.hasOwnProperty(f);) M = Ye(M);
          if (!M && X[f] && (M = X), !M || M[C]) return !1;
          var ne,
            oe = N && N.eventNameToString,
            V = {},
            I = M[C] = M[f],
            z = M[A(v)] = M[v],
            j = M[A(E)] = M[E],
            ie = M[A(T)] = M[T];
          function Se(p, O) {
            return !Ue && "object" == typeof p && p ? !!p.capture : Ue && O ? "boolean" == typeof p ? {
              capture: p,
              passive: !0
            } : p ? "object" == typeof p && !1 !== p.passive ? Object.assign(Object.assign({}, p), {
              passive: !0
            }) : p : {
              passive: !0
            } : p;
          }
          N && N.prepend && (ne = M[A(N.prepend)] = M[N.prepend]);
          var l = re ? function (p) {
              if (!V.isExisting) return I.call(V.target, V.eventName, V.capture ? K : F, V.options);
            } : function (p) {
              return I.call(V.target, V.eventName, p.invoke, V.options);
            },
            L = re ? function (p) {
              if (!p.isRemoved) {
                var O = Ce[p.eventName],
                  H = void 0;
                O && (H = O[p.capture ? we : De]);
                var Z = H && p.target[H];
                if (Z) for (var W = 0; W < Z.length; W++) if (Z[W] === p) {
                  Z.splice(W, 1), p.isRemoved = !0, 0 === Z.length && (p.allRemoved = !0, p.target[H] = null);
                  break;
                }
              }
              if (p.allRemoved) return z.call(p.target, p.eventName, p.capture ? K : F, p.options);
            } : function (p) {
              return z.call(p.target, p.eventName, p.invoke, p.options);
            },
            Le = N && N.diff ? N.diff : function (p, O) {
              var H = typeof O;
              return "function" === H && p.callback === O || "object" === H && p.originalDelegate === O;
            },
            _ = Zone[A("UNPATCHED_EVENTS")],
            w = e[A("PASSIVE_EVENTS")],
            g = function (p, O, H, Z, W, G) {
              return void 0 === W && (W = !1), void 0 === G && (G = !1), function () {
                var U = this || e,
                  Y = arguments[0];
                N && N.transferEventName && (Y = N.transferEventName(Y));
                var ce = arguments[1];
                if (!ce) return p.apply(this, arguments);
                if (qe && "uncaughtException" === Y) return p.apply(this, arguments);
                var ye = !1;
                if ("function" != typeof ce) {
                  if (!ce.handleEvent) return p.apply(this, arguments);
                  ye = !0;
                }
                if (!q || q(p, ce, U, arguments)) {
                  var xe = Ue && !!w && -1 !== w.indexOf(Y),
                    pe = Se(arguments[2], xe);
                  if (_) for (var _e = 0; _e < _.length; _e++) if (Y === _[_e]) return xe ? p.call(U, Y, ce, pe) : p.apply(this, arguments);
                  var ve = !!pe && ("boolean" == typeof pe || pe.capture),
                    at = !(!pe || "object" != typeof pe) && pe.once,
                    $t = Zone.current,
                    It = Ce[Y];
                  It || (rt(Y, oe), It = Ce[Y]);
                  var Ht = It[ve ? we : De],
                    st = U[Ht],
                    xt = !1;
                  if (st) {
                    if (xt = !0, J) for (_e = 0; _e < st.length; _e++) if (Le(st[_e], ce)) return;
                  } else st = U[Ht] = [];
                  var Nt,
                    Ft = U.constructor.name,
                    Bt = pt[Ft];
                  Bt && (Nt = Bt[Y]), Nt || (Nt = Ft + O + (oe ? oe(Y) : Y)), V.options = pe, at && (V.options.once = !1), V.target = U, V.capture = ve, V.eventName = Y, V.isExisting = xt;
                  var mt = re ? dt : void 0;
                  mt && (mt.taskData = V);
                  var Xe = $t.scheduleEventTask(Nt, ce, mt, H, Z);
                  if (V.target = null, mt && (mt.taskData = null), at && (pe.once = !0), !Ue && "boolean" == typeof Xe.options || (Xe.options = pe), Xe.target = U, Xe.capture = ve, Xe.eventName = Y, ye && (Xe.originalDelegate = ce), G ? st.unshift(Xe) : st.push(Xe), W) return U;
                }
              };
            };
          return M[f] = g(I, P, l, L, Q), ne && (M[k] = g(ne, ".prependListener:", function (p) {
            return ne.call(V.target, V.eventName, p.invoke, V.options);
          }, L, Q, !0)), M[v] = function () {
            var p = this || e,
              O = arguments[0];
            N && N.transferEventName && (O = N.transferEventName(O));
            var H = arguments[2],
              Z = !!H && ("boolean" == typeof H || H.capture),
              W = arguments[1];
            if (!W) return z.apply(this, arguments);
            if (!q || q(z, W, p, arguments)) {
              var U,
                G = Ce[O];
              G && (U = G[Z ? we : De]);
              var Y = U && p[U];
              if (Y) for (var ce = 0; ce < Y.length; ce++) {
                var ye = Y[ce];
                if (Le(ye, W)) return Y.splice(ce, 1), ye.isRemoved = !0, 0 === Y.length && (ye.allRemoved = !0, p[U] = null, "string" == typeof O) && (p[Ve + "ON_PROPERTY" + O] = null), ye.zone.cancelTask(ye), Q ? p : void 0;
              }
              return z.apply(this, arguments);
            }
          }, M[E] = function () {
            var p = this || e,
              O = arguments[0];
            N && N.transferEventName && (O = N.transferEventName(O));
            for (var H = [], Z = Et(p, oe ? oe(O) : O), W = 0; W < Z.length; W++) {
              var G = Z[W];
              H.push(G.originalDelegate ? G.originalDelegate : G.callback);
            }
            return H;
          }, M[T] = function () {
            var p = this || e,
              O = arguments[0];
            if (O) {
              N && N.transferEventName && (O = N.transferEventName(O));
              var Y = Ce[O];
              if (Y) {
                var xe = p[Y[De]],
                  pe = p[Y[we]];
                if (xe) for (var _e = xe.slice(), Z = 0; Z < _e.length; Z++) this[v].call(this, O, (ve = _e[Z]).originalDelegate ? ve.originalDelegate : ve.callback, ve.options);
                if (pe) for (_e = pe.slice(), Z = 0; Z < _e.length; Z++) {
                  var ve;
                  this[v].call(this, O, (ve = _e[Z]).originalDelegate ? ve.originalDelegate : ve.callback, ve.options);
                }
              }
            } else {
              var H = Object.keys(p);
              for (Z = 0; Z < H.length; Z++) {
                var G = _t.exec(H[Z]),
                  U = G && G[1];
                U && "removeListener" !== U && this[T].call(this, U);
              }
              this[T].call(this, "removeListener");
            }
            if (Q) return this;
          }, ke(M[f], I), ke(M[v], z), ie && ke(M[T], ie), j && ke(M[E], j), !0;
        }
        for (var ee = [], ue = 0; ue < r.length; ue++) ee[ue] = he(r[ue], o);
        return ee;
      }
      function Et(e, t) {
        if (!t) {
          var r = [];
          for (var o in e) {
            var f = _t.exec(o),
              v = f && f[1];
            if (v && (!t || v === t)) {
              var E = e[o];
              if (E) for (var T = 0; T < E.length; T++) r.push(E[T]);
            }
          }
          return r;
        }
        var C = Ce[t];
        C || (rt(t), C = Ce[t]);
        var P = e[C[De]],
          k = e[C[we]];
        return P ? k ? P.concat(k) : P.slice() : k ? k.slice() : [];
      }
      function Ot(e, t) {
        var r = e.Event;
        r && r.prototype && t.patchMethod(r.prototype, "stopImmediatePropagation", function (o) {
          return function (f, v) {
            f[Ct] = !0, o && o.apply(f, v);
          };
        });
      }
      function Zt(e, t, r, o, f) {
        var v = Zone.__symbol__(o);
        if (!t[v]) {
          var E = t[v] = t[o];
          t[o] = function (T, C, P) {
            return C && C.prototype && f.forEach(function (k) {
              var D = "".concat(r, ".").concat(o, "::") + k,
                R = C.prototype;
              try {
                if (R.hasOwnProperty(k)) {
                  var x = e.ObjectGetOwnPropertyDescriptor(R, k);
                  x && x.value ? (x.value = e.wrapWithCurrentZone(x.value, D), e._redefineProperty(C.prototype, k, x)) : R[k] && (R[k] = e.wrapWithCurrentZone(R[k], D));
                } else R[k] && (R[k] = e.wrapWithCurrentZone(R[k], D));
              } catch {}
            }), E.call(t, T, C, P);
          }, e.attachOriginToPatched(t[o], E);
        }
      }
      function nt(e, t, r) {
        if (!r || 0 === r.length) return t;
        var o = r.filter(function (v) {
          return v.target === e;
        });
        if (!o || 0 === o.length) return t;
        var f = o[0].ignoreProperties;
        return t.filter(function (v) {
          return -1 === f.indexOf(v);
        });
      }
      function Pt(e, t, r, o) {
        e && ht(e, nt(e, t, r), o);
      }
      function yt(e) {
        return Object.getOwnPropertyNames(e).filter(function (t) {
          return t.startsWith("on") && t.length > 2;
        }).map(function (t) {
          return t.substring(2);
        });
      }
      function At(e, t) {
        if ((!qe || lt) && !Zone[e.symbol("patchEvents")]) {
          var r = t.__Zone_ignore_on_properties,
            o = [];
          if (We) {
            var f = window;
            o = o.concat(["Document", "SVGElement", "Element", "HTMLElement", "HTMLBodyElement", "HTMLMediaElement", "HTMLFrameSetElement", "HTMLFrameElement", "HTMLIFrameElement", "HTMLMarqueeElement", "Worker"]);
            var v = function wt() {
              try {
                var e = Ae.navigator.userAgent;
                if (-1 !== e.indexOf("MSIE ") || -1 !== e.indexOf("Trident/")) return !0;
              } catch {}
              return !1;
            }() ? [{
              target: f,
              ignoreProperties: ["error"]
            }] : [];
            Pt(f, yt(f), r && r.concat(v), Ye(f));
          }
          o = o.concat(["XMLHttpRequest", "XMLHttpRequestEventTarget", "IDBIndex", "IDBRequest", "IDBOpenDBRequest", "IDBDatabase", "IDBTransaction", "IDBCursor", "WebSocket"]);
          for (var E = 0; E < o.length; E++) {
            var T = t[o[E]];
            T && T.prototype && Pt(T.prototype, yt(T.prototype), r);
          }
        }
      }
      function u(e, t, r) {
        var o = r.configurable;
        return d(e, t, r = c(e, t, r), o);
      }
      function h(e, t) {
        return e && e[a] && e[a][t];
      }
      function c(e, t, r) {
        return Object.isFrozen(r) || (r.configurable = !0), r.configurable || (!e[a] && !Object.isFrozen(e) && je(e, a, {
          writable: !0,
          value: {}
        }), e[a] && (e[a][t] = !0)), r;
      }
      function d(e, t, r, o) {
        try {
          return je(e, t, r);
        } catch (E) {
          if (!r.configurable) throw E;
          typeof o > "u" ? delete r.configurable : r.configurable = o;
          try {
            return je(e, t, r);
          } catch (T) {
            var f = !1;
            if (("createdCallback" === t || "attachedCallback" === t || "detachedCallback" === t || "attributeChangedCallback" === t) && (f = !0), !f) throw T;
            var v = null;
            try {
              v = JSON.stringify(r);
            } catch {
              v = r.toString();
            }
            console.log("Attempting to configure '".concat(t, "' with descriptor '").concat(v, "' on object '").concat(e, "' and got error, giving up: ").concat(T));
          }
        }
      }
      function S(e, t) {
        var r = e.getGlobalObjects();
        if ((!r.isNode || r.isMix) && !function B(e, t) {
          var r = e.getGlobalObjects();
          if ((r.isBrowser || r.isMix) && !e.ObjectGetOwnPropertyDescriptor(HTMLElement.prototype, "onclick") && typeof Element < "u") {
            var v = e.ObjectGetOwnPropertyDescriptor(Element.prototype, "onclick");
            if (v && !v.configurable) return !1;
            if (v) {
              e.ObjectDefineProperty(Element.prototype, "onclick", {
                enumerable: !0,
                configurable: !0,
                get: function () {
                  return !0;
                }
              });
              var T = !!document.createElement("div").onclick;
              return e.ObjectDefineProperty(Element.prototype, "onclick", v), T;
            }
          }
          var C = t.XMLHttpRequest;
          if (!C) return !1;
          var P = "onreadystatechange",
            k = C.prototype,
            D = e.ObjectGetOwnPropertyDescriptor(k, P);
          if (D) return e.ObjectDefineProperty(k, P, {
            enumerable: !0,
            configurable: !0,
            get: function () {
              return !0;
            }
          }), T = !!(R = new C()).onreadystatechange, e.ObjectDefineProperty(k, P, D || {}), T;
          var x = e.symbol("fake");
          e.ObjectDefineProperty(k, P, {
            enumerable: !0,
            configurable: !0,
            get: function () {
              return this[x];
            },
            set: function (ee) {
              this[x] = ee;
            }
          });
          var R,
            F = function () {};
          return (R = new C()).onreadystatechange = F, T = R[x] === F, R.onreadystatechange = null, T;
        }(e, t)) {
          var v = typeof WebSocket < "u";
          (function Yt(e) {
            for (var t = e.symbol("unbound"), r = function (f) {
                var v = jt[f],
                  E = "on" + v;
                self.addEventListener(v, function (T) {
                  var P,
                    k,
                    C = T.target;
                  for (k = C ? C.constructor.name + "." + E : "unknown." + E; C;) C[E] && !C[E][t] && ((P = e.wrapWithCurrentZone(C[E], k))[t] = C[E], C[E] = P), C = C.parentElement;
                }, !0);
              }, o = 0; o < jt.length; o++) r(o);
          })(e), e.patchClass("XMLHttpRequest"), v && function b(e, t) {
            var r = e.getGlobalObjects(),
              o = r.ADD_EVENT_LISTENER_STR,
              f = r.REMOVE_EVENT_LISTENER_STR,
              v = t.WebSocket;
            t.EventTarget || e.patchEventTarget(t, e, [v.prototype]), t.WebSocket = function (C, P) {
              var D,
                R,
                k = arguments.length > 1 ? new v(C, P) : new v(C),
                x = e.ObjectGetOwnPropertyDescriptor(k, "onmessage");
              return x && !1 === x.configurable ? (D = e.ObjectCreate(k), R = k, [o, f, "send", "close"].forEach(function (F) {
                D[F] = function () {
                  var K = e.ArraySlice.call(arguments);
                  if (F === o || F === f) {
                    var he = K.length > 0 ? K[0] : void 0;
                    if (he) {
                      var ee = Zone.__symbol__("ON_PROPERTY" + he);
                      k[ee] = D[ee];
                    }
                  }
                  return k[F].apply(k, K);
                };
              })) : D = k, e.patchOnProperties(D, ["close", "error", "message", "open"], R), D;
            };
            var E = t.WebSocket;
            for (var T in v) E[T] = v[T];
          }(e, t), Zone[e.symbol("patchEvents")] = !0;
        }
      }
      Zone.__load_patch("util", function (e, t, r) {
        var o = yt(e);
        r.patchOnProperties = ht, r.patchMethod = Ne, r.bindArguments = ut, r.patchMacroTask = bt;
        var f = t.__symbol__("BLACK_LISTED_EVENTS"),
          v = t.__symbol__("UNPATCHED_EVENTS");
        e[v] && (e[f] = e[v]), e[f] && (t[f] = t[v] = e[f]), r.patchEventPrototype = Ot, r.patchEventTarget = St, r.isIEOrEdge = kt, r.ObjectDefineProperty = Me, r.ObjectGetOwnPropertyDescriptor = ge, r.ObjectCreate = Ze, r.ArraySlice = Ke, r.patchClass = Ie, r.wrapWithCurrentZone = ct, r.filterProperties = nt, r.attachOriginToPatched = ke, r._redefineProperty = Object.defineProperty, r.patchCallbacks = Zt, r.getGlobalObjects = function () {
          return {
            globalSources: pt,
            zoneSymbolEventNames: Ce,
            eventNames: o,
            isBrowser: We,
            isMix: lt,
            isNode: qe,
            TRUE_STR: we,
            FALSE_STR: De,
            ZONE_SYMBOL_PREFIX: Ve,
            ADD_EVENT_LISTENER_STR: me,
            REMOVE_EVENT_LISTENER_STR: be
          };
        };
      });
      var e,
        t,
        jt = te(te(te(te(te(te(te(te([], ["abort", "animationcancel", "animationend", "animationiteration", "auxclick", "beforeinput", "blur", "cancel", "canplay", "canplaythrough", "change", "compositionstart", "compositionupdate", "compositionend", "cuechange", "click", "close", "contextmenu", "curechange", "dblclick", "drag", "dragend", "dragenter", "dragexit", "dragleave", "dragover", "drop", "durationchange", "emptied", "ended", "error", "focus", "focusin", "focusout", "gotpointercapture", "input", "invalid", "keydown", "keypress", "keyup", "load", "loadstart", "loadeddata", "loadedmetadata", "lostpointercapture", "mousedown", "mouseenter", "mouseleave", "mousemove", "mouseout", "mouseover", "mouseup", "mousewheel", "orientationchange", "pause", "play", "playing", "pointercancel", "pointerdown", "pointerenter", "pointerleave", "pointerlockchange", "mozpointerlockchange", "webkitpointerlockerchange", "pointerlockerror", "mozpointerlockerror", "webkitpointerlockerror", "pointermove", "pointout", "pointerover", "pointerup", "progress", "ratechange", "reset", "resize", "scroll", "seeked", "seeking", "select", "selectionchange", "selectstart", "show", "sort", "stalled", "submit", "suspend", "timeupdate", "volumechange", "touchcancel", "touchmove", "touchstart", "touchend", "transitioncancel", "transitionend", "waiting", "wheel"], !0), ["webglcontextrestored", "webglcontextlost", "webglcontextcreationerror"], !0), ["autocomplete", "autocompleteerror"], !0), ["toggle"], !0), ["afterscriptexecute", "beforescriptexecute", "DOMContentLoaded", "freeze", "fullscreenchange", "mozfullscreenchange", "webkitfullscreenchange", "msfullscreenchange", "fullscreenerror", "mozfullscreenerror", "webkitfullscreenerror", "msfullscreenerror", "readystatechange", "visibilitychange", "resume"], !0), ["absolutedeviceorientation", "afterinput", "afterprint", "appinstalled", "beforeinstallprompt", "beforeprint", "beforeunload", "devicelight", "devicemotion", "deviceorientation", "deviceorientationabsolute", "deviceproximity", "hashchange", "languagechange", "message", "mozbeforepaint", "offline", "online", "paint", "pageshow", "pagehide", "popstate", "rejectionhandled", "storage", "unhandledrejection", "unload", "userproximity", "vrdisplayconnected", "vrdisplaydisconnected", "vrdisplaypresentchange"], !0), ["beforecopy", "beforecut", "beforepaste", "copy", "cut", "paste", "dragstart", "loadend", "animationstart", "search", "transitionrun", "transitionstart", "webkitanimationend", "webkitanimationiteration", "webkitanimationstart", "webkittransitionend"], !0), ["activate", "afterupdate", "ariarequest", "beforeactivate", "beforedeactivate", "beforeeditfocus", "beforeupdate", "cellchange", "controlselect", "dataavailable", "datasetchanged", "datasetcomplete", "errorupdate", "filterchange", "layoutcomplete", "losecapture", "move", "moveend", "movestart", "propertychange", "resizeend", "resizestart", "rowenter", "rowexit", "rowsdelete", "rowsinserted", "command", "compassneedscalibration", "deactivate", "help", "mscontentzoom", "msmanipulationstatechanged", "msgesturechange", "msgesturedoubletap", "msgestureend", "msgesturehold", "msgesturestart", "msgesturetap", "msgotpointercapture", "msinertiastart", "mslostpointercapture", "mspointercancel", "mspointerdown", "mspointerenter", "mspointerhover", "mspointerleave", "mspointermove", "mspointerout", "mspointerover", "mspointerup", "pointerout", "mssitemodejumplistitemremoved", "msthumbnailclick", "stop", "storagecommit"], !0);
      e = typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, t = e.__Zone_symbol_prefix || "__zone_symbol__", e[function r(o) {
        return t + o;
      }("legacyPatch")] = function () {
        var o = e.Zone;
        o.__load_patch("defineProperty", function (f, v, E) {
          E._redefineProperty = u, function n() {
            ot = Zone.__symbol__, je = Object[ot("defineProperty")] = Object.defineProperty, He = Object[ot("getOwnPropertyDescriptor")] = Object.getOwnPropertyDescriptor, Rt = Object.create, a = ot("unconfigurables"), Object.defineProperty = function (e, t, r) {
              if (h(e, t)) throw new TypeError("Cannot assign to read only property '" + t + "' of " + e);
              var o = r.configurable;
              return "prototype" !== t && (r = c(e, t, r)), d(e, t, r, o);
            }, Object.defineProperties = function (e, t) {
              Object.keys(t).forEach(function (E) {
                Object.defineProperty(e, E, t[E]);
              });
              for (var r = 0, o = Object.getOwnPropertySymbols(t); r < o.length; r++) {
                var f = o[r];
                Object.getOwnPropertyDescriptor(t, f)?.enumerable && Object.defineProperty(e, f, t[f]);
              }
              return e;
            }, Object.create = function (e, t) {
              return "object" == typeof t && !Object.isFrozen(t) && Object.keys(t).forEach(function (r) {
                t[r] = c(e, r, t[r]);
              }), Rt(e, t);
            }, Object.getOwnPropertyDescriptor = function (e, t) {
              var r = He(e, t);
              return r && h(e, t) && (r.configurable = !1), r;
            };
          }();
        }), o.__load_patch("registerElement", function (f, v, E) {
          !function Kt(e, t) {
            var r = t.getGlobalObjects();
            (r.isBrowser || r.isMix) && "registerElement" in e.document && t.patchCallbacks(t, document, "Document", "registerElement", ["createdCallback", "attachedCallback", "detachedCallback", "attributeChangedCallback"]);
          }(f, E);
        }), o.__load_patch("EventTargetLegacy", function (f, v, E) {
          (function y(e, t) {
            var r = t.getGlobalObjects(),
              o = r.eventNames,
              f = r.globalSources,
              v = r.zoneSymbolEventNames,
              E = r.TRUE_STR,
              T = r.FALSE_STR,
              C = r.ZONE_SYMBOL_PREFIX,
              k = "ApplicationCache,EventSource,FileReader,InputMethodContext,MediaController,MessagePort,Node,Performance,SVGElementInstance,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebKitNamedFlow,Window,Worker,WorkerGlobalScope,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload,IDBRequest,IDBOpenDBRequest,IDBDatabase,IDBTransaction,IDBCursor,DBIndex,WebSocket".split(","),
              D = "EventTarget",
              R = [],
              x = e.wtf,
              F = "Anchor,Area,Audio,BR,Base,BaseFont,Body,Button,Canvas,Content,DList,Directory,Div,Embed,FieldSet,Font,Form,Frame,FrameSet,HR,Head,Heading,Html,IFrame,Image,Input,Keygen,LI,Label,Legend,Link,Map,Marquee,Media,Menu,Meta,Meter,Mod,OList,Object,OptGroup,Option,Output,Paragraph,Pre,Progress,Quote,Script,Select,Source,Span,Style,TableCaption,TableCell,TableCol,Table,TableRow,TableSection,TextArea,Title,Track,UList,Unknown,Video".split(",");
            x ? R = F.map(function (le) {
              return "HTML" + le + "Element";
            }).concat(k) : e[D] ? R.push(D) : R = k;
            for (var K = e.__Zone_disable_IE_check || !1, he = e.__Zone_enable_cross_context_check || !1, ee = t.isIEOrEdge(), X = "[object FunctionWrapper]", N = "function __BROWSERTOOLS_CONSOLE_SAFEFUNC() { [native code] }", re = {
                MSPointerCancel: "pointercancel",
                MSPointerDown: "pointerdown",
                MSPointerEnter: "pointerenter",
                MSPointerHover: "pointerhover",
                MSPointerLeave: "pointerleave",
                MSPointerMove: "pointermove",
                MSPointerOut: "pointerout",
                MSPointerOver: "pointerover",
                MSPointerUp: "pointerup"
              }, q = 0; q < o.length; q++) {
              var oe = C + ((J = o[q]) + T),
                V = C + (J + E);
              v[J] = {}, v[J][T] = oe, v[J][E] = V;
            }
            for (q = 0; q < F.length; q++) for (var I = F[q], z = f[I] = {}, j = 0; j < o.length; j++) {
              var J;
              z[J = o[j]] = I + ".addEventListener:" + J;
            }
            var ne = [];
            for (q = 0; q < R.length; q++) {
              var Se = e[R[q]];
              ne.push(Se && Se.prototype);
            }
            return t.patchEventTarget(e, t, ne, {
              vh: function (le, ae, m, i) {
                if (!K && ee) {
                  if (he) try {
                    if ((s = ae.toString()) === X || s == N) return le.apply(m, i), !1;
                  } catch {
                    return le.apply(m, i), !1;
                  } else {
                    var s;
                    if ((s = ae.toString()) === X || s == N) return le.apply(m, i), !1;
                  }
                } else if (he) try {
                  ae.toString();
                } catch {
                  return le.apply(m, i), !1;
                }
                return !0;
              },
              transferEventName: function (le) {
                return re[le] || le;
              }
            }), Zone[t.symbol("patchEventTarget")] = !!e[D], !0;
          })(f, E), S(E, f);
        });
      };
      var Dt = A("zoneTask");
      function it(e, t, r, o) {
        var f = null,
          v = null;
        r += o;
        var E = {};
        function T(P) {
          var k = P.data;
          return k.args[0] = function () {
            return P.invoke.apply(this, arguments);
          }, k.handleId = f.apply(e, k.args), P;
        }
        function C(P) {
          return v.call(e, P.data.handleId);
        }
        f = Ne(e, t += o, function (P) {
          return function (k, D) {
            if ("function" == typeof D[0]) {
              var R = {
                  isPeriodic: "Interval" === o,
                  delay: "Timeout" === o || "Interval" === o ? D[1] || 0 : void 0,
                  args: D
                },
                x = D[0];
              D[0] = function () {
                try {
                  return x.apply(this, arguments);
                } finally {
                  R.isPeriodic || ("number" == typeof R.handleId ? delete E[R.handleId] : R.handleId && (R.handleId[Dt] = null));
                }
              };
              var F = Je(t, D[0], R, T, C);
              if (!F) return F;
              var K = F.data.handleId;
              return "number" == typeof K ? E[K] = F : K && (K[Dt] = F), K && K.ref && K.unref && "function" == typeof K.ref && "function" == typeof K.unref && (F.ref = K.ref.bind(K), F.unref = K.unref.bind(K)), "number" == typeof K || K ? K : F;
            }
            return P.apply(e, D);
          };
        }), v = Ne(e, r, function (P) {
          return function (k, D) {
            var x,
              R = D[0];
            "number" == typeof R ? x = E[R] : (x = R && R[Dt]) || (x = R), x && "string" == typeof x.type ? "notScheduled" !== x.state && (x.cancelFn && x.data.isPeriodic || 0 === x.runCount) && ("number" == typeof R ? delete E[R] : R && (R[Dt] = null), x.zone.cancelTask(x)) : P.apply(e, D);
          };
        });
      }
      Zone.__load_patch("legacy", function (e) {
        var t = e[Zone.__symbol__("legacyPatch")];
        t && t();
      }), Zone.__load_patch("queueMicrotask", function (e, t, r) {
        r.patchMethod(e, "queueMicrotask", function (o) {
          return function (f, v) {
            t.current.scheduleMicroTask("queueMicrotask", v[0]);
          };
        });
      }), Zone.__load_patch("timers", function (e) {
        var t = "set",
          r = "clear";
        it(e, t, r, "Timeout"), it(e, t, r, "Interval"), it(e, t, r, "Immediate");
      }), Zone.__load_patch("requestAnimationFrame", function (e) {
        it(e, "request", "cancel", "AnimationFrame"), it(e, "mozRequest", "mozCancel", "AnimationFrame"), it(e, "webkitRequest", "webkitCancel", "AnimationFrame");
      }), Zone.__load_patch("blocking", function (e, t) {
        for (var r = ["alert", "prompt", "confirm"], o = 0; o < r.length; o++) Ne(e, r[o], function (v, E, T) {
          return function (C, P) {
            return t.current.run(v, e, P, T);
          };
        });
      }), Zone.__load_patch("EventTarget", function (e, t, r) {
        (function Qt(e, t) {
          t.patchEventPrototype(e, t);
        })(e, r), function Jt(e, t) {
          if (!Zone[t.symbol("patchEventTarget")]) {
            for (var r = t.getGlobalObjects(), o = r.eventNames, f = r.zoneSymbolEventNames, v = r.TRUE_STR, E = r.FALSE_STR, T = r.ZONE_SYMBOL_PREFIX, C = 0; C < o.length; C++) {
              var P = o[C],
                R = T + (P + E),
                x = T + (P + v);
              f[P] = {}, f[P][E] = R, f[P][v] = x;
            }
            var F = e.EventTarget;
            if (F && F.prototype) return t.patchEventTarget(e, t, [F && F.prototype]), !0;
          }
        }(e, r);
        var o = e.XMLHttpRequestEventTarget;
        o && o.prototype && r.patchEventTarget(e, r, [o.prototype]);
      }), Zone.__load_patch("MutationObserver", function (e, t, r) {
        Ie("MutationObserver"), Ie("WebKitMutationObserver");
      }), Zone.__load_patch("IntersectionObserver", function (e, t, r) {
        Ie("IntersectionObserver");
      }), Zone.__load_patch("FileReader", function (e, t, r) {
        Ie("FileReader");
      }), Zone.__load_patch("on_property", function (e, t, r) {
        At(r, e);
      }), Zone.__load_patch("customElements", function (e, t, r) {
        !function qt(e, t) {
          var r = t.getGlobalObjects();
          (r.isBrowser || r.isMix) && e.customElements && "customElements" in e && t.patchCallbacks(t, e.customElements, "customElements", "define", ["connectedCallback", "disconnectedCallback", "adoptedCallback", "attributeChangedCallback"]);
        }(e, r);
      }), Zone.__load_patch("XHR", function (e, t) {
        !function C(P) {
          var k = P.XMLHttpRequest;
          if (k) {
            var D = k.prototype,
              x = D[Ee],
              F = D[Oe];
            if (!x) {
              var K = P.XMLHttpRequestEventTarget;
              if (K) {
                var he = K.prototype;
                x = he[Ee], F = he[Oe];
              }
            }
            var ee = "readystatechange",
              ue = "scheduled",
              q = Ne(D, "open", function () {
                return function (I, z) {
                  return I[o] = 0 == z[2], I[E] = z[1], q.apply(I, z);
                };
              }),
              Q = A("fetchTaskAborting"),
              M = A("fetchTaskScheduling"),
              oe = Ne(D, "send", function () {
                return function (I, z) {
                  if (!0 === t.current[M] || I[o]) return oe.apply(I, z);
                  var j = {
                      target: I,
                      url: I[E],
                      isPeriodic: !1,
                      args: z,
                      aborted: !1
                    },
                    ie = Je("XMLHttpRequest.send", N, j, X, re);
                  I && !0 === I[T] && !j.aborted && ie.state === ue && ie.invoke();
                };
              }),
              V = Ne(D, "abort", function () {
                return function (I, z) {
                  var j = function R(I) {
                    return I[r];
                  }(I);
                  if (j && "string" == typeof j.type) {
                    if (null == j.cancelFn || j.data && j.data.aborted) return;
                    j.zone.cancelTask(j);
                  } else if (!0 === t.current[Q]) return V.apply(I, z);
                };
              });
          }
          function X(I) {
            var z = I.data,
              j = z.target;
            j[v] = !1, j[T] = !1;
            var ie = j[f];
            x || (x = j[Ee], F = j[Oe]), ie && F.call(j, ee, ie);
            var ne = j[f] = function () {
              if (j.readyState === j.DONE) if (!z.aborted && j[v] && I.state === ue) {
                var le = j[t.__symbol__("loadfalse")];
                if (0 !== j.status && le && le.length > 0) {
                  var ae = I.invoke;
                  I.invoke = function () {
                    for (var m = j[t.__symbol__("loadfalse")], i = 0; i < m.length; i++) m[i] === I && m.splice(i, 1);
                    !z.aborted && I.state === ue && ae.call(I);
                  }, le.push(I);
                } else I.invoke();
              } else !z.aborted && !1 === j[v] && (j[T] = !0);
            };
            return x.call(j, ee, ne), j[r] || (j[r] = I), oe.apply(j, z.args), j[v] = !0, I;
          }
          function N() {}
          function re(I) {
            var z = I.data;
            return z.aborted = !0, V.apply(z.target, z.args);
          }
        }(e);
        var r = A("xhrTask"),
          o = A("xhrSync"),
          f = A("xhrListener"),
          v = A("xhrScheduled"),
          E = A("xhrURL"),
          T = A("xhrErrorBeforeScheduled");
      }), Zone.__load_patch("geolocation", function (e) {
        e.navigator && e.navigator.geolocation && function Lt(e, t) {
          for (var r = e.constructor.name, o = function (v) {
              var P,
                k,
                E = t[v],
                T = e[E];
              if (T) {
                if (!gt(ge(e, E))) return "continue";
                e[E] = (k = function () {
                  return P.apply(this, ut(arguments, r + "." + E));
                }, ke(k, P = T), k);
              }
            }, f = 0; f < t.length; f++) o(f);
        }(e.navigator.geolocation, ["getCurrentPosition", "watchPosition"]);
      }), Zone.__load_patch("PromiseRejectionEvent", function (e, t) {
        function r(o) {
          return function (f) {
            Et(e, o).forEach(function (E) {
              var T = e.PromiseRejectionEvent;
              if (T) {
                var C = new T(o, {
                  promise: f.promise,
                  reason: f.rejection
                });
                E.invoke(C);
              }
            });
          };
        }
        e.PromiseRejectionEvent && (t[A("unhandledPromiseRejectionHandler")] = r("unhandledrejection"), t[A("rejectionHandledHandler")] = r("rejectionhandled"));
      });
    }, void 0 !== (Re = Pe.call(Be, $, Be, Fe)) && (Fe.exports = Re);
  }
}, Fe => {
  Fe(Fe.s = 435);
}]);
"use strict";
(self.webpackChunkcedar_artifact_viewer = self.webpackChunkcedar_artifact_viewer || []).push([[179], {
  921: (j0, g3, U0) => {
    function so(n) {
      return "function" == typeof n;
    }
    let G0 = !1;
    const da = {
      Promise: void 0,
      set useDeprecatedSynchronousErrorHandling(n) {
        if (n) {
          const t = new Error();
          console.warn("DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n" + t.stack);
        } else G0 && console.log("RxJS: Back to a better error behavior. Thank you. <3");
        G0 = n;
      },
      get useDeprecatedSynchronousErrorHandling() {
        return G0;
      }
    };
    function Jo(n) {
      setTimeout(() => {
        throw n;
      }, 0);
    }
    const Vl = {
        closed: !0,
        next(n) {},
        error(n) {
          if (da.useDeprecatedSynchronousErrorHandling) throw n;
          Jo(n);
        },
        complete() {}
      },
      $o = Array.isArray || (n => n && "number" == typeof n.length);
    function W0(n) {
      return null !== n && "object" == typeof n;
    }
    const Hl = (() => {
      function n(t) {
        return Error.call(this), this.message = t ? `${t.length} errors occurred during unsubscription:\n${t.map((e, a) => `${a + 1}) ${e.toString()}`).join("\n  ")}` : "", this.name = "UnsubscriptionError", this.errors = t, this;
      }
      return n.prototype = Object.create(Error.prototype), n;
    })();
    class re {
      constructor(t) {
        this.closed = !1, this._parentOrParents = null, this._subscriptions = null, t && (this._ctorUnsubscribe = !0, this._unsubscribe = t);
      }
      unsubscribe() {
        let t;
        if (this.closed) return;
        let {
          _parentOrParents: e,
          _ctorUnsubscribe: a,
          _unsubscribe: i,
          _subscriptions: o
        } = this;
        if (this.closed = !0, this._parentOrParents = null, this._subscriptions = null, e instanceof re) e.remove(this);else if (null !== e) for (let r = 0; r < e.length; ++r) e[r].remove(this);
        if (so(i)) {
          a && (this._unsubscribe = void 0);
          try {
            i.call(this);
          } catch (r) {
            t = r instanceof Hl ? b3(r.errors) : [r];
          }
        }
        if ($o(o)) {
          let r = -1,
            s = o.length;
          for (; ++r < s;) {
            const c = o[r];
            if (W0(c)) try {
              c.unsubscribe();
            } catch (l) {
              t = t || [], l instanceof Hl ? t = t.concat(b3(l.errors)) : t.push(l);
            }
          }
        }
        if (t) throw new Hl(t);
      }
      add(t) {
        let e = t;
        if (!t) return re.EMPTY;
        switch (typeof t) {
          case "function":
            e = new re(t);
          case "object":
            if (e === this || e.closed || "function" != typeof e.unsubscribe) return e;
            if (this.closed) return e.unsubscribe(), e;
            if (!(e instanceof re)) {
              const o = e;
              e = new re(), e._subscriptions = [o];
            }
            break;
          default:
            throw new Error("unrecognized teardown " + t + " added to Subscription.");
        }
        let {
          _parentOrParents: a
        } = e;
        if (null === a) e._parentOrParents = this;else if (a instanceof re) {
          if (a === this) return e;
          e._parentOrParents = [a, this];
        } else {
          if (-1 !== a.indexOf(this)) return e;
          a.push(this);
        }
        const i = this._subscriptions;
        return null === i ? this._subscriptions = [e] : i.push(e), e;
      }
      remove(t) {
        const e = this._subscriptions;
        if (e) {
          const a = e.indexOf(t);
          -1 !== a && e.splice(a, 1);
        }
      }
    }
    var n;
    function b3(n) {
      return n.reduce((t, e) => t.concat(e instanceof Hl ? e.errors : e), []);
    }
    re.EMPTY = ((n = new re()).closed = !0, n);
    const Bl = "function" == typeof Symbol ? Symbol("rxSubscriber") : "@@rxSubscriber_" + Math.random();
    class Qe extends re {
      constructor(t, e, a) {
        switch (super(), this.syncErrorValue = null, this.syncErrorThrown = !1, this.syncErrorThrowable = !1, this.isStopped = !1, arguments.length) {
          case 0:
            this.destination = Vl;
            break;
          case 1:
            if (!t) {
              this.destination = Vl;
              break;
            }
            if ("object" == typeof t) {
              t instanceof Qe ? (this.syncErrorThrowable = t.syncErrorThrowable, this.destination = t, t.add(this)) : (this.syncErrorThrowable = !0, this.destination = new _3(this, t));
              break;
            }
          default:
            this.syncErrorThrowable = !0, this.destination = new _3(this, t, e, a);
        }
      }
      [Bl]() {
        return this;
      }
      static create(t, e, a) {
        const i = new Qe(t, e, a);
        return i.syncErrorThrowable = !1, i;
      }
      next(t) {
        this.isStopped || this._next(t);
      }
      error(t) {
        this.isStopped || (this.isStopped = !0, this._error(t));
      }
      complete() {
        this.isStopped || (this.isStopped = !0, this._complete());
      }
      unsubscribe() {
        this.closed || (this.isStopped = !0, super.unsubscribe());
      }
      _next(t) {
        this.destination.next(t);
      }
      _error(t) {
        this.destination.error(t), this.unsubscribe();
      }
      _complete() {
        this.destination.complete(), this.unsubscribe();
      }
      _unsubscribeAndRecycle() {
        const {
          _parentOrParents: t
        } = this;
        return this._parentOrParents = null, this.unsubscribe(), this.closed = !1, this.isStopped = !1, this._parentOrParents = t, this;
      }
    }
    class _3 extends Qe {
      constructor(t, e, a, i) {
        super(), this._parentSubscriber = t;
        let o,
          r = this;
        so(e) ? o = e : e && (o = e.next, a = e.error, i = e.complete, e !== Vl && (r = Object.create(e), so(r.unsubscribe) && this.add(r.unsubscribe.bind(r)), r.unsubscribe = this.unsubscribe.bind(this))), this._context = r, this._next = o, this._error = a, this._complete = i;
      }
      next(t) {
        if (!this.isStopped && this._next) {
          const {
            _parentSubscriber: e
          } = this;
          da.useDeprecatedSynchronousErrorHandling && e.syncErrorThrowable ? this.__tryOrSetError(e, this._next, t) && this.unsubscribe() : this.__tryOrUnsub(this._next, t);
        }
      }
      error(t) {
        if (!this.isStopped) {
          const {
              _parentSubscriber: e
            } = this,
            {
              useDeprecatedSynchronousErrorHandling: a
            } = da;
          if (this._error) a && e.syncErrorThrowable ? (this.__tryOrSetError(e, this._error, t), this.unsubscribe()) : (this.__tryOrUnsub(this._error, t), this.unsubscribe());else if (e.syncErrorThrowable) a ? (e.syncErrorValue = t, e.syncErrorThrown = !0) : Jo(t), this.unsubscribe();else {
            if (this.unsubscribe(), a) throw t;
            Jo(t);
          }
        }
      }
      complete() {
        if (!this.isStopped) {
          const {
            _parentSubscriber: t
          } = this;
          if (this._complete) {
            const e = () => this._complete.call(this._context);
            da.useDeprecatedSynchronousErrorHandling && t.syncErrorThrowable ? (this.__tryOrSetError(t, e), this.unsubscribe()) : (this.__tryOrUnsub(e), this.unsubscribe());
          } else this.unsubscribe();
        }
      }
      __tryOrUnsub(t, e) {
        try {
          t.call(this._context, e);
        } catch (a) {
          if (this.unsubscribe(), da.useDeprecatedSynchronousErrorHandling) throw a;
          Jo(a);
        }
      }
      __tryOrSetError(t, e, a) {
        if (!da.useDeprecatedSynchronousErrorHandling) throw new Error("bad call");
        try {
          e.call(this._context, a);
        } catch (i) {
          return da.useDeprecatedSynchronousErrorHandling ? (t.syncErrorValue = i, t.syncErrorThrown = !0, !0) : (Jo(i), !0);
        }
        return !1;
      }
      _unsubscribe() {
        const {
          _parentSubscriber: t
        } = this;
        this._context = null, this._parentSubscriber = null, t.unsubscribe();
      }
    }
    const Ls = "function" == typeof Symbol && Symbol.observable || "@@observable";
    function v3(n) {
      return n;
    }
    function y3(...n) {
      return C3(n);
    }
    function C3(n) {
      return 0 === n.length ? v3 : 1 === n.length ? n[0] : function (e) {
        return n.reduce((a, i) => i(a), e);
      };
    }
    let Be = (() => {
      class n {
        constructor(e) {
          this._isScalar = !1, e && (this._subscribe = e);
        }
        lift(e) {
          const a = new n();
          return a.source = this, a.operator = e, a;
        }
        subscribe(e, a, i) {
          const {
              operator: o
            } = this,
            r = function qw(n, t, e) {
              if (n) {
                if (n instanceof Qe) return n;
                if (n[Bl]) return n[Bl]();
              }
              return n || t || e ? new Qe(n, t, e) : new Qe(Vl);
            }(e, a, i);
          if (r.add(o ? o.call(r, this.source) : this.source || da.useDeprecatedSynchronousErrorHandling && !r.syncErrorThrowable ? this._subscribe(r) : this._trySubscribe(r)), da.useDeprecatedSynchronousErrorHandling && r.syncErrorThrowable && (r.syncErrorThrowable = !1, r.syncErrorThrown)) throw r.syncErrorValue;
          return r;
        }
        _trySubscribe(e) {
          try {
            return this._subscribe(e);
          } catch (a) {
            da.useDeprecatedSynchronousErrorHandling && (e.syncErrorThrown = !0, e.syncErrorValue = a), function Yw(n) {
              for (; n;) {
                const {
                  closed: t,
                  destination: e,
                  isStopped: a
                } = n;
                if (t || a) return !1;
                n = e && e instanceof Qe ? e : null;
              }
              return !0;
            }(e) ? e.error(a) : console.warn(a);
          }
        }
        forEach(e, a) {
          return new (a = M3(a))((i, o) => {
            let r;
            r = this.subscribe(s => {
              try {
                e(s);
              } catch (c) {
                o(c), r && r.unsubscribe();
              }
            }, o, i);
          });
        }
        _subscribe(e) {
          const {
            source: a
          } = this;
          return a && a.subscribe(e);
        }
        [Ls]() {
          return this;
        }
        pipe(...e) {
          return 0 === e.length ? this : C3(e)(this);
        }
        toPromise(e) {
          return new (e = M3(e))((a, i) => {
            let o;
            this.subscribe(r => o = r, r => i(r), () => a(o));
          });
        }
      }
      return n.create = t => new n(t), n;
    })();
    function M3(n) {
      if (n || (n = da.Promise || Promise), !n) throw new Error("no Promise impl found");
      return n;
    }
    const co = (() => {
      function n() {
        return Error.call(this), this.message = "object unsubscribed", this.name = "ObjectUnsubscribedError", this;
      }
      return n.prototype = Object.create(Error.prototype), n;
    })();
    class x3 extends re {
      constructor(t, e) {
        super(), this.subject = t, this.subscriber = e, this.closed = !1;
      }
      unsubscribe() {
        if (this.closed) return;
        this.closed = !0;
        const t = this.subject,
          e = t.observers;
        if (this.subject = null, !e || 0 === e.length || t.isStopped || t.closed) return;
        const a = e.indexOf(this.subscriber);
        -1 !== a && e.splice(a, 1);
      }
    }
    class w3 extends Qe {
      constructor(t) {
        super(t), this.destination = t;
      }
    }
    let V = (() => {
      class n extends Be {
        constructor() {
          super(), this.observers = [], this.closed = !1, this.isStopped = !1, this.hasError = !1, this.thrownError = null;
        }
        [Bl]() {
          return new w3(this);
        }
        lift(e) {
          const a = new k3(this, this);
          return a.operator = e, a;
        }
        next(e) {
          if (this.closed) throw new co();
          if (!this.isStopped) {
            const {
                observers: a
              } = this,
              i = a.length,
              o = a.slice();
            for (let r = 0; r < i; r++) o[r].next(e);
          }
        }
        error(e) {
          if (this.closed) throw new co();
          this.hasError = !0, this.thrownError = e, this.isStopped = !0;
          const {
              observers: a
            } = this,
            i = a.length,
            o = a.slice();
          for (let r = 0; r < i; r++) o[r].error(e);
          this.observers.length = 0;
        }
        complete() {
          if (this.closed) throw new co();
          this.isStopped = !0;
          const {
              observers: e
            } = this,
            a = e.length,
            i = e.slice();
          for (let o = 0; o < a; o++) i[o].complete();
          this.observers.length = 0;
        }
        unsubscribe() {
          this.isStopped = !0, this.closed = !0, this.observers = null;
        }
        _trySubscribe(e) {
          if (this.closed) throw new co();
          return super._trySubscribe(e);
        }
        _subscribe(e) {
          if (this.closed) throw new co();
          return this.hasError ? (e.error(this.thrownError), re.EMPTY) : this.isStopped ? (e.complete(), re.EMPTY) : (this.observers.push(e), new x3(this, e));
        }
        asObservable() {
          const e = new Be();
          return e.source = this, e;
        }
      }
      return n.create = (t, e) => new k3(t, e), n;
    })();
    class k3 extends V {
      constructor(t, e) {
        super(), this.destination = t, this.source = e;
      }
      next(t) {
        const {
          destination: e
        } = this;
        e && e.next && e.next(t);
      }
      error(t) {
        const {
          destination: e
        } = this;
        e && e.error && this.destination.error(t);
      }
      complete() {
        const {
          destination: t
        } = this;
        t && t.complete && this.destination.complete();
      }
      _subscribe(t) {
        const {
          source: e
        } = this;
        return e ? this.source.subscribe(t) : re.EMPTY;
      }
    }
    function er(n) {
      return n && "function" == typeof n.schedule;
    }
    function We(n, t) {
      return function (a) {
        if ("function" != typeof n) throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return a.lift(new Kw(n, t));
      };
    }
    class Kw {
      constructor(t, e) {
        this.project = t, this.thisArg = e;
      }
      call(t, e) {
        return e.subscribe(new Qw(t, this.project, this.thisArg));
      }
    }
    class Qw extends Qe {
      constructor(t, e, a) {
        super(t), this.project = e, this.count = 0, this.thisArg = a || this;
      }
      _next(t) {
        let e;
        try {
          e = this.project.call(this.thisArg, t, this.count++);
        } catch (a) {
          return void this.destination.error(a);
        }
        this.destination.next(e);
      }
    }
    const D3 = n => t => {
        for (let e = 0, a = n.length; e < a && !t.closed; e++) t.next(n[e]);
        t.complete();
      },
      jl = function Xw() {
        return "function" == typeof Symbol && Symbol.iterator ? Symbol.iterator : "@@iterator";
      }(),
      O3 = n => n && "number" == typeof n.length && "function" != typeof n;
    function P3(n) {
      return !!n && "function" != typeof n.subscribe && "function" == typeof n.then;
    }
    const Y0 = n => {
      if (n && "function" == typeof n[Ls]) return (n => t => {
        const e = n[Ls]();
        if ("function" != typeof e.subscribe) throw new TypeError("Provided object does not correctly implement Symbol.observable");
        return e.subscribe(t);
      })(n);
      if (O3(n)) return D3(n);
      if (P3(n)) return (n => t => (n.then(e => {
        t.closed || (t.next(e), t.complete());
      }, e => t.error(e)).then(null, Jo), t))(n);
      if (n && "function" == typeof n[jl]) return (n => t => {
        const e = n[jl]();
        for (;;) {
          let a;
          try {
            a = e.next();
          } catch (i) {
            return t.error(i), t;
          }
          if (a.done) {
            t.complete();
            break;
          }
          if (t.next(a.value), t.closed) break;
        }
        return "function" == typeof e.return && t.add(() => {
          e.return && e.return();
        }), t;
      })(n);
      {
        const e = `You provided ${W0(n) ? "an invalid object" : `'${n}'`} where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.`;
        throw new TypeError(e);
      }
    };
    function q0(n, t) {
      return new Be(e => {
        const a = new re();
        let i = 0;
        return a.add(t.schedule(function () {
          i !== n.length ? (e.next(n[i++]), e.closed || a.add(this.schedule())) : e.complete();
        })), a;
      });
    }
    function lo(n, t) {
      return t ? function ok(n, t) {
        if (null != n) {
          if (function ak(n) {
            return n && "function" == typeof n[Ls];
          }(n)) return function ek(n, t) {
            return new Be(e => {
              const a = new re();
              return a.add(t.schedule(() => {
                const i = n[Ls]();
                a.add(i.subscribe({
                  next(o) {
                    a.add(t.schedule(() => e.next(o)));
                  },
                  error(o) {
                    a.add(t.schedule(() => e.error(o)));
                  },
                  complete() {
                    a.add(t.schedule(() => e.complete()));
                  }
                }));
              })), a;
            });
          }(n, t);
          if (P3(n)) return function tk(n, t) {
            return new Be(e => {
              const a = new re();
              return a.add(t.schedule(() => n.then(i => {
                a.add(t.schedule(() => {
                  e.next(i), a.add(t.schedule(() => e.complete()));
                }));
              }, i => {
                a.add(t.schedule(() => e.error(i)));
              }))), a;
            });
          }(n, t);
          if (O3(n)) return q0(n, t);
          if (function ik(n) {
            return n && "function" == typeof n[jl];
          }(n) || "string" == typeof n) return function nk(n, t) {
            if (!n) throw new Error("Iterable cannot be null");
            return new Be(e => {
              const a = new re();
              let i;
              return a.add(() => {
                i && "function" == typeof i.return && i.return();
              }), a.add(t.schedule(() => {
                i = n[jl](), a.add(t.schedule(function () {
                  if (e.closed) return;
                  let o, r;
                  try {
                    const s = i.next();
                    o = s.value, r = s.done;
                  } catch (s) {
                    return void e.error(s);
                  }
                  r ? e.complete() : (e.next(o), this.schedule());
                }));
              })), a;
            });
          }(n, t);
        }
        throw new TypeError((null !== n && typeof n || n) + " is not observable");
      }(n, t) : n instanceof Be ? n : new Be(Y0(n));
    }
    class Ns extends Qe {
      constructor(t) {
        super(), this.parent = t;
      }
      _next(t) {
        this.parent.notifyNext(t);
      }
      _error(t) {
        this.parent.notifyError(t), this.unsubscribe();
      }
      _complete() {
        this.parent.notifyComplete(), this.unsubscribe();
      }
    }
    class Fs extends Qe {
      notifyNext(t) {
        this.destination.next(t);
      }
      notifyError(t) {
        this.destination.error(t);
      }
      notifyComplete() {
        this.destination.complete();
      }
    }
    function Vs(n, t) {
      if (t.closed) return;
      if (n instanceof Be) return n.subscribe(t);
      let e;
      try {
        e = Y0(n)(t);
      } catch (a) {
        t.error(a);
      }
      return e;
    }
    function K0(n, t, e = Number.POSITIVE_INFINITY) {
      return "function" == typeof t ? a => a.pipe(K0((i, o) => lo(n(i, o)).pipe(We((r, s) => t(i, r, o, s))), e)) : ("number" == typeof t && (e = t), a => a.lift(new rk(n, e)));
    }
    class rk {
      constructor(t, e = Number.POSITIVE_INFINITY) {
        this.project = t, this.concurrent = e;
      }
      call(t, e) {
        return e.subscribe(new sk(t, this.project, this.concurrent));
      }
    }
    class sk extends Fs {
      constructor(t, e, a = Number.POSITIVE_INFINITY) {
        super(t), this.project = e, this.concurrent = a, this.hasCompleted = !1, this.buffer = [], this.active = 0, this.index = 0;
      }
      _next(t) {
        this.active < this.concurrent ? this._tryNext(t) : this.buffer.push(t);
      }
      _tryNext(t) {
        let e;
        const a = this.index++;
        try {
          e = this.project(t, a);
        } catch (i) {
          return void this.destination.error(i);
        }
        this.active++, this._innerSub(e);
      }
      _innerSub(t) {
        const e = new Ns(this),
          a = this.destination;
        a.add(e);
        const i = Vs(t, e);
        i !== e && a.add(i);
      }
      _complete() {
        this.hasCompleted = !0, 0 === this.active && 0 === this.buffer.length && this.destination.complete(), this.unsubscribe();
      }
      notifyNext(t) {
        this.destination.next(t);
      }
      notifyComplete() {
        const t = this.buffer;
        this.active--, t.length > 0 ? this._next(t.shift()) : 0 === this.active && this.hasCompleted && this.destination.complete();
      }
    }
    function A3(n = Number.POSITIVE_INFINITY) {
      return K0(v3, n);
    }
    function Q0(n, t) {
      return t ? q0(n, t) : new Be(D3(n));
    }
    function dt(...n) {
      let t = Number.POSITIVE_INFINITY,
        e = null,
        a = n[n.length - 1];
      return er(a) ? (e = n.pop(), n.length > 1 && "number" == typeof n[n.length - 1] && (t = n.pop())) : "number" == typeof a && (t = n.pop()), null === e && 1 === n.length && n[0] instanceof Be ? n[0] : A3(t)(Q0(n, e));
    }
    function S3() {
      return function (t) {
        return t.lift(new ck(t));
      };
    }
    class ck {
      constructor(t) {
        this.connectable = t;
      }
      call(t, e) {
        const {
          connectable: a
        } = this;
        a._refCount++;
        const i = new lk(t, a),
          o = e.subscribe(i);
        return i.closed || (i.connection = a.connect()), o;
      }
    }
    class lk extends Qe {
      constructor(t, e) {
        super(t), this.connectable = e;
      }
      _unsubscribe() {
        const {
          connectable: t
        } = this;
        if (!t) return void (this.connection = null);
        this.connectable = null;
        const e = t._refCount;
        if (e <= 0) return void (this.connection = null);
        if (t._refCount = e - 1, e > 1) return void (this.connection = null);
        const {
            connection: a
          } = this,
          i = t._connection;
        this.connection = null, i && (!a || i === a) && i.unsubscribe();
      }
    }
    class E3 extends Be {
      constructor(t, e) {
        super(), this.source = t, this.subjectFactory = e, this._refCount = 0, this._isComplete = !1;
      }
      _subscribe(t) {
        return this.getSubject().subscribe(t);
      }
      getSubject() {
        const t = this._subject;
        return (!t || t.isStopped) && (this._subject = this.subjectFactory()), this._subject;
      }
      connect() {
        let t = this._connection;
        return t || (this._isComplete = !1, t = this._connection = new re(), t.add(this.source.subscribe(new uk(this.getSubject(), this))), t.closed && (this._connection = null, t = re.EMPTY)), t;
      }
      refCount() {
        return S3()(this);
      }
    }
    const dk = (() => {
      const n = E3.prototype;
      return {
        operator: {
          value: null
        },
        _refCount: {
          value: 0,
          writable: !0
        },
        _subject: {
          value: null,
          writable: !0
        },
        _connection: {
          value: null,
          writable: !0
        },
        _subscribe: {
          value: n._subscribe
        },
        _isComplete: {
          value: n._isComplete,
          writable: !0
        },
        getSubject: {
          value: n.getSubject
        },
        connect: {
          value: n.connect
        },
        refCount: {
          value: n.refCount
        }
      };
    })();
    class uk extends w3 {
      constructor(t, e) {
        super(t), this.connectable = e;
      }
      _error(t) {
        this._unsubscribe(), super._error(t);
      }
      _complete() {
        this.connectable._isComplete = !0, this._unsubscribe(), super._complete();
      }
      _unsubscribe() {
        const t = this.connectable;
        if (t) {
          this.connectable = null;
          const e = t._connection;
          t._refCount = 0, t._subject = null, t._connection = null, e && e.unsubscribe();
        }
      }
    }
    class hk {
      constructor(t, e) {
        this.subjectFactory = t, this.selector = e;
      }
      call(t, e) {
        const {
            selector: a
          } = this,
          i = this.subjectFactory(),
          o = a(i).subscribe(t);
        return o.add(e.subscribe(i)), o;
      }
    }
    function pk() {
      return new V();
    }
    function Ul() {
      return n => S3()(function mk(n, t) {
        return function (a) {
          let i;
          if (i = "function" == typeof n ? n : function () {
            return n;
          }, "function" == typeof t) return a.lift(new hk(i, t));
          const o = Object.create(a, dk);
          return o.source = a, o.subjectFactory = i, o;
        };
      }(pk)(n));
    }
    function Ze(n) {
      for (let t in n) if (n[t] === Ze) return t;
      throw Error("Could not find renamed property on target object.");
    }
    function Z0(n, t) {
      for (const e in t) t.hasOwnProperty(e) && !n.hasOwnProperty(e) && (n[e] = t[e]);
    }
    function Xe(n) {
      if ("string" == typeof n) return n;
      if (Array.isArray(n)) return "[" + n.map(Xe).join(", ") + "]";
      if (null == n) return "" + n;
      if (n.overriddenName) return `${n.overriddenName}`;
      if (n.name) return `${n.name}`;
      const t = n.toString();
      if (null == t) return "" + t;
      const e = t.indexOf("\n");
      return -1 === e ? t : t.substring(0, e);
    }
    function X0(n, t) {
      return null == n || "" === n ? null === t ? "" : t : null == t || "" === t ? n : n + " " + t;
    }
    const gk = Ze({
      __forward_ref__: Ze
    });
    function Pe(n) {
      return n.__forward_ref__ = Pe, n.toString = function () {
        return Xe(this());
      }, n;
    }
    function ue(n) {
      return J0(n) ? n() : n;
    }
    function J0(n) {
      return "function" == typeof n && n.hasOwnProperty(gk) && n.__forward_ref__ === Pe;
    }
    class L extends Error {
      constructor(t, e) {
        super(function Gl(n, t) {
          return `NG0${Math.abs(n)}${t ? ": " + t.trim() : ""}`;
        }(t, e)), this.code = t;
      }
    }
    function ve(n) {
      return "string" == typeof n ? n : null == n ? "" : String(n);
    }
    function Wl(n, t) {
      throw new L(-201, !1);
    }
    function kn(n, t) {
      null == n && function Ye(n, t, e, a) {
        throw new Error(`ASSERTION ERROR: ${n}` + (null == a ? "" : ` [Expected=> ${e} ${a} ${t} <=Actual]`));
      }(t, n, null, "!=");
    }
    function R(n) {
      return {
        token: n.token,
        providedIn: n.providedIn || null,
        factory: n.factory,
        value: void 0
      };
    }
    function U(n) {
      return {
        providers: n.providers || [],
        imports: n.imports || []
      };
    }
    function Yl(n) {
      return T3(n, ql) || T3(n, R3);
    }
    function T3(n, t) {
      return n.hasOwnProperty(t) ? n[t] : null;
    }
    function I3(n) {
      return n && (n.hasOwnProperty($0) || n.hasOwnProperty(wk)) ? n[$0] : null;
    }
    const ql = Ze({
        ɵprov: Ze
      }),
      $0 = Ze({
        ɵinj: Ze
      }),
      R3 = Ze({
        ngInjectableDef: Ze
      }),
      wk = Ze({
        ngInjectorDef: Ze
      });
    var me = (() => ((me = me || {})[me.Default = 0] = "Default", me[me.Host = 1] = "Host", me[me.Self = 2] = "Self", me[me.SkipSelf = 4] = "SkipSelf", me[me.Optional = 8] = "Optional", me))();
    let eu;
    function Gn(n) {
      const t = eu;
      return eu = n, t;
    }
    function z3(n, t, e) {
      const a = Yl(n);
      return a && "root" == a.providedIn ? void 0 === a.value ? a.value = a.factory() : a.value : e & me.Optional ? null : void 0 !== t ? t : void Wl(Xe(n));
    }
    function zi(n) {
      return {
        toString: n
      }.toString();
    }
    var ua = (() => ((ua = ua || {})[ua.OnPush = 0] = "OnPush", ua[ua.Default = 1] = "Default", ua))(),
      fa = (() => (function (n) {
        n[n.Emulated = 0] = "Emulated", n[n.None = 2] = "None", n[n.ShadowDom = 3] = "ShadowDom";
      }(fa || (fa = {})), fa))();
    const Je = (() => typeof globalThis < "u" && globalThis || typeof global < "u" && global || typeof window < "u" && window || typeof self < "u" && typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && self)(),
      tr = {},
      Ue = [],
      Kl = Ze({
        ɵcmp: Ze
      }),
      tu = Ze({
        ɵdir: Ze
      }),
      nu = Ze({
        ɵpipe: Ze
      }),
      L3 = Ze({
        ɵmod: Ze
      }),
      ni = Ze({
        ɵfac: Ze
      }),
      Hs = Ze({
        __NG_ELEMENT_ID__: Ze
      });
    let Dk = 0;
    function q(n) {
      return zi(() => {
        const e = !0 === n.standalone,
          a = {},
          i = {
            type: n.type,
            providersResolver: null,
            decls: n.decls,
            vars: n.vars,
            factory: null,
            template: n.template || null,
            consts: n.consts || null,
            ngContentSelectors: n.ngContentSelectors,
            hostBindings: n.hostBindings || null,
            hostVars: n.hostVars || 0,
            hostAttrs: n.hostAttrs || null,
            contentQueries: n.contentQueries || null,
            declaredInputs: a,
            inputs: null,
            outputs: null,
            exportAs: n.exportAs || null,
            onPush: n.changeDetection === ua.OnPush,
            directiveDefs: null,
            pipeDefs: null,
            standalone: e,
            dependencies: e && n.dependencies || null,
            getStandaloneInjector: null,
            selectors: n.selectors || Ue,
            viewQuery: n.viewQuery || null,
            features: n.features || null,
            data: n.data || {},
            encapsulation: n.encapsulation || fa.Emulated,
            id: "c" + Dk++,
            styles: n.styles || Ue,
            _: null,
            setInput: null,
            schemas: n.schemas || null,
            tView: null
          },
          o = n.dependencies,
          r = n.features;
        return i.inputs = V3(n.inputs, a), i.outputs = V3(n.outputs), r && r.forEach(s => s(i)), i.directiveDefs = o ? () => ("function" == typeof o ? o() : o).map(N3).filter(F3) : null, i.pipeDefs = o ? () => ("function" == typeof o ? o() : o).map(sn).filter(F3) : null, i;
      });
    }
    function au(n, t, e) {
      const a = n.ɵcmp;
      a.directiveDefs = () => ("function" == typeof t ? t() : t).map(N3), a.pipeDefs = () => ("function" == typeof e ? e() : e).map(sn);
    }
    function N3(n) {
      return Ke(n) || rn(n);
    }
    function F3(n) {
      return null !== n;
    }
    function W(n) {
      return zi(() => ({
        type: n.type,
        bootstrap: n.bootstrap || Ue,
        declarations: n.declarations || Ue,
        imports: n.imports || Ue,
        exports: n.exports || Ue,
        transitiveCompileScopes: null,
        schemas: n.schemas || null,
        id: n.id || null
      }));
    }
    function V3(n, t) {
      if (null == n) return tr;
      const e = {};
      for (const a in n) if (n.hasOwnProperty(a)) {
        let i = n[a],
          o = i;
        Array.isArray(i) && (o = i[1], i = i[0]), e[i] = a, t && (t[i] = o);
      }
      return e;
    }
    const P = q;
    function on(n) {
      return {
        type: n.type,
        name: n.name,
        factory: null,
        pure: !1 !== n.pure,
        standalone: !0 === n.standalone,
        onDestroy: n.type.prototype.ngOnDestroy || null
      };
    }
    function Ke(n) {
      return n[Kl] || null;
    }
    function rn(n) {
      return n[tu] || null;
    }
    function sn(n) {
      return n[nu] || null;
    }
    function _n(n) {
      return Array.isArray(n) && "object" == typeof n[1];
    }
    function ha(n) {
      return Array.isArray(n) && !0 === n[1];
    }
    function ru(n) {
      return 0 != (8 & n.flags);
    }
    function Jl(n) {
      return 2 == (2 & n.flags);
    }
    function $l(n) {
      return 1 == (1 & n.flags);
    }
    function pa(n) {
      return null !== n.template;
    }
    function Ek(n) {
      return 0 != (256 & n[2]);
    }
    function po(n, t) {
      return n.hasOwnProperty(ni) ? n[ni] : null;
    }
    class j3 {
      constructor(t, e, a) {
        this.previousValue = t, this.currentValue = e, this.firstChange = a;
      }
      isFirstChange() {
        return this.firstChange;
      }
    }
    function Ve() {
      return U3;
    }
    function U3(n) {
      return n.type.prototype.ngOnChanges && (n.setInput = zk), Rk;
    }
    function Rk() {
      const n = W3(this),
        t = n?.current;
      if (t) {
        const e = n.previous;
        if (e === tr) n.previous = t;else for (let a in t) e[a] = t[a];
        n.current = null, this.ngOnChanges(t);
      }
    }
    function zk(n, t, e, a) {
      const i = W3(n) || function Lk(n, t) {
          return n[G3] = t;
        }(n, {
          previous: tr,
          current: null
        }),
        o = i.current || (i.current = {}),
        r = i.previous,
        s = this.declaredInputs[e],
        c = r[s];
      o[s] = new j3(c && c.currentValue, t, r === tr), n[a] = t;
    }
    Ve.ngInherit = !0;
    const G3 = "__ngSimpleChanges__";
    function W3(n) {
      return n[G3] || null;
    }
    function kt(n) {
      for (; Array.isArray(n);) n = n[0];
      return n;
    }
    function e1(n, t) {
      return kt(t[n]);
    }
    function qn(n, t) {
      return kt(t[n.index]);
    }
    function uu(n, t) {
      return n.data[t];
    }
    function or(n, t) {
      return n[t];
    }
    function Pn(n, t) {
      const e = t[n];
      return _n(e) ? e : e[0];
    }
    function t1(n) {
      return 64 == (64 & n[2]);
    }
    function Li(n, t) {
      return null == t ? null : n[t];
    }
    function Y3(n) {
      n[18] = 0;
    }
    function fu(n, t) {
      n[5] += t;
      let e = n,
        a = n[3];
      for (; null !== a && (1 === t && 1 === e[5] || -1 === t && 0 === e[5]);) a[5] += t, e = a, a = a[3];
    }
    const _e = {
      lFrame: n6(null),
      bindingsEnabled: !0
    };
    function K3() {
      return _e.bindingsEnabled;
    }
    function I() {
      return _e.lFrame.lView;
    }
    function Ne() {
      return _e.lFrame.tView;
    }
    function pe(n) {
      return _e.lFrame.contextLView = n, n[8];
    }
    function ge(n) {
      return _e.lFrame.contextLView = null, n;
    }
    function Rt() {
      let n = Q3();
      for (; null !== n && 64 === n.type;) n = n.parent;
      return n;
    }
    function Q3() {
      return _e.lFrame.currentTNode;
    }
    function Ra(n, t) {
      const e = _e.lFrame;
      e.currentTNode = n, e.isParent = t;
    }
    function mu() {
      return _e.lFrame.isParent;
    }
    function hu() {
      _e.lFrame.isParent = !1;
    }
    function cn() {
      const n = _e.lFrame;
      let t = n.bindingRootIndex;
      return -1 === t && (t = n.bindingRootIndex = n.tView.bindingStartIndex), t;
    }
    function ai() {
      return _e.lFrame.bindingIndex;
    }
    function rr() {
      return _e.lFrame.bindingIndex++;
    }
    function ii(n) {
      const t = _e.lFrame,
        e = t.bindingIndex;
      return t.bindingIndex = t.bindingIndex + n, e;
    }
    function Xk(n, t) {
      const e = _e.lFrame;
      e.bindingIndex = e.bindingRootIndex = n, pu(t);
    }
    function pu(n) {
      _e.lFrame.currentDirectiveIndex = n;
    }
    function gu(n) {
      const t = _e.lFrame.currentDirectiveIndex;
      return -1 === t ? null : n[t];
    }
    function $3() {
      return _e.lFrame.currentQueryIndex;
    }
    function bu(n) {
      _e.lFrame.currentQueryIndex = n;
    }
    function $k(n) {
      const t = n[1];
      return 2 === t.type ? t.declTNode : 1 === t.type ? n[6] : null;
    }
    function e6(n, t, e) {
      if (e & me.SkipSelf) {
        let i = t,
          o = n;
        for (; !(i = i.parent, null !== i || e & me.Host || (i = $k(o), null === i || (o = o[15], 10 & i.type))););
        if (null === i) return !1;
        t = i, n = o;
      }
      const a = _e.lFrame = t6();
      return a.currentTNode = t, a.lView = n, !0;
    }
    function _u(n) {
      const t = t6(),
        e = n[1];
      _e.lFrame = t, t.currentTNode = e.firstChild, t.lView = n, t.tView = e, t.contextLView = n, t.bindingIndex = e.bindingStartIndex, t.inI18n = !1;
    }
    function t6() {
      const n = _e.lFrame,
        t = null === n ? null : n.child;
      return null === t ? n6(n) : t;
    }
    function n6(n) {
      const t = {
        currentTNode: null,
        isParent: !0,
        lView: null,
        tView: null,
        selectedIndex: -1,
        contextLView: null,
        elementDepthCount: 0,
        currentNamespace: null,
        currentDirectiveIndex: -1,
        bindingRootIndex: -1,
        bindingIndex: -1,
        currentQueryIndex: 0,
        parent: n,
        child: null,
        inI18n: !1
      };
      return null !== n && (n.child = t), t;
    }
    function a6() {
      const n = _e.lFrame;
      return _e.lFrame = n.parent, n.currentTNode = null, n.lView = null, n;
    }
    const i6 = a6;
    function vu() {
      const n = a6();
      n.isParent = !0, n.tView = null, n.selectedIndex = -1, n.contextLView = null, n.elementDepthCount = 0, n.currentDirectiveIndex = -1, n.currentNamespace = null, n.bindingRootIndex = -1, n.bindingIndex = -1, n.currentQueryIndex = 0;
    }
    function ln() {
      return _e.lFrame.selectedIndex;
    }
    function Ni(n) {
      _e.lFrame.selectedIndex = n;
    }
    function bt() {
      const n = _e.lFrame;
      return uu(n.tView, n.selectedIndex);
    }
    function Kn() {
      _e.lFrame.currentNamespace = "svg";
    }
    function qs() {
      !function aD() {
        _e.lFrame.currentNamespace = null;
      }();
    }
    function n1(n, t) {
      for (let e = t.directiveStart, a = t.directiveEnd; e < a; e++) {
        const o = n.data[e].type.prototype,
          {
            ngAfterContentInit: r,
            ngAfterContentChecked: s,
            ngAfterViewInit: c,
            ngAfterViewChecked: l,
            ngOnDestroy: d
          } = o;
        r && (n.contentHooks || (n.contentHooks = [])).push(-e, r), s && ((n.contentHooks || (n.contentHooks = [])).push(e, s), (n.contentCheckHooks || (n.contentCheckHooks = [])).push(e, s)), c && (n.viewHooks || (n.viewHooks = [])).push(-e, c), l && ((n.viewHooks || (n.viewHooks = [])).push(e, l), (n.viewCheckHooks || (n.viewCheckHooks = [])).push(e, l)), null != d && (n.destroyHooks || (n.destroyHooks = [])).push(e, d);
      }
    }
    function a1(n, t, e) {
      o6(n, t, 3, e);
    }
    function o1(n, t, e, a) {
      (3 & n[2]) === e && o6(n, t, e, a);
    }
    function yu(n, t) {
      let e = n[2];
      (3 & e) === t && (e &= 2047, e += 1, n[2] = e);
    }
    function o6(n, t, e, a) {
      const o = a ?? -1,
        r = t.length - 1;
      let s = 0;
      for (let c = void 0 !== a ? 65535 & n[18] : 0; c < r; c++) if ("number" == typeof t[c + 1]) {
        if (s = t[c], null != a && s >= a) break;
      } else t[c] < 0 && (n[18] += 65536), (s < o || -1 == o) && (rD(n, e, t, c), n[18] = (4294901760 & n[18]) + c + 2), c++;
    }
    function rD(n, t, e, a) {
      const i = e[a] < 0,
        o = e[a + 1],
        s = n[i ? -e[a] : e[a]];
      if (i) {
        if (n[2] >> 11 < n[18] >> 16 && (3 & n[2]) === t) {
          n[2] += 2048;
          try {
            o.call(s);
          } finally {}
        }
      } else try {
        o.call(s);
      } finally {}
    }
    class Ks {
      constructor(t, e, a) {
        this.factory = t, this.resolving = !1, this.canSeeViewProviders = e, this.injectImpl = a;
      }
    }
    function r1(n, t, e) {
      let a = 0;
      for (; a < e.length;) {
        const i = e[a];
        if ("number" == typeof i) {
          if (0 !== i) break;
          a++;
          const o = e[a++],
            r = e[a++],
            s = e[a++];
          n.setAttribute(t, r, s, o);
        } else {
          const o = i,
            r = e[++a];
          s6(o) ? n.setProperty(t, o, r) : n.setAttribute(t, o, r), a++;
        }
      }
      return a;
    }
    function r6(n) {
      return 3 === n || 4 === n || 6 === n;
    }
    function s6(n) {
      return 64 === n.charCodeAt(0);
    }
    function s1(n, t) {
      if (null !== t && 0 !== t.length) if (null === n || 0 === n.length) n = t.slice();else {
        let e = -1;
        for (let a = 0; a < t.length; a++) {
          const i = t[a];
          "number" == typeof i ? e = i : 0 === e || c6(n, e, i, null, -1 === e || 2 === e ? t[++a] : null);
        }
      }
      return n;
    }
    function c6(n, t, e, a, i) {
      let o = 0,
        r = n.length;
      if (-1 === t) r = -1;else for (; o < n.length;) {
        const s = n[o++];
        if ("number" == typeof s) {
          if (s === t) {
            r = -1;
            break;
          }
          if (s > t) {
            r = o - 1;
            break;
          }
        }
      }
      for (; o < n.length;) {
        const s = n[o];
        if ("number" == typeof s) break;
        if (s === e) {
          if (null === a) return void (null !== i && (n[o + 1] = i));
          if (a === n[o + 1]) return void (n[o + 2] = i);
        }
        o++, null !== a && o++, null !== i && o++;
      }
      -1 !== r && (n.splice(r, 0, t), o = r + 1), n.splice(o++, 0, e), null !== a && n.splice(o++, 0, a), null !== i && n.splice(o++, 0, i);
    }
    function l6(n) {
      return -1 !== n;
    }
    function sr(n) {
      return 32767 & n;
    }
    function cr(n, t) {
      let e = function uD(n) {
          return n >> 16;
        }(n),
        a = t;
      for (; e > 0;) a = a[15], e--;
      return a;
    }
    let Mu = !0;
    function c1(n) {
      const t = Mu;
      return Mu = n, t;
    }
    let fD = 0;
    const za = {};
    function Zs(n, t) {
      const e = wu(n, t);
      if (-1 !== e) return e;
      const a = t[1];
      a.firstCreatePass && (n.injectorIndex = t.length, xu(a.data, n), xu(t, null), xu(a.blueprint, null));
      const i = l1(n, t),
        o = n.injectorIndex;
      if (l6(i)) {
        const r = sr(i),
          s = cr(i, t),
          c = s[1].data;
        for (let l = 0; l < 8; l++) t[o + l] = s[r + l] | c[r + l];
      }
      return t[o + 8] = i, o;
    }
    function xu(n, t) {
      n.push(0, 0, 0, 0, 0, 0, 0, 0, t);
    }
    function wu(n, t) {
      return -1 === n.injectorIndex || n.parent && n.parent.injectorIndex === n.injectorIndex || null === t[n.injectorIndex + 8] ? -1 : n.injectorIndex;
    }
    function l1(n, t) {
      if (n.parent && -1 !== n.parent.injectorIndex) return n.parent.injectorIndex;
      let e = 0,
        a = null,
        i = t;
      for (; null !== i;) {
        if (a = _6(i), null === a) return -1;
        if (e++, i = i[15], -1 !== a.injectorIndex) return a.injectorIndex | e << 16;
      }
      return -1;
    }
    function d1(n, t, e) {
      !function mD(n, t, e) {
        let a;
        "string" == typeof e ? a = e.charCodeAt(0) || 0 : e.hasOwnProperty(Hs) && (a = e[Hs]), null == a && (a = e[Hs] = fD++);
        const i = 255 & a;
        t.data[n + (i >> 5)] |= 1 << i;
      }(n, t, e);
    }
    function f6(n, t, e) {
      if (e & me.Optional || void 0 !== n) return n;
      Wl();
    }
    function m6(n, t, e, a) {
      if (e & me.Optional && void 0 === a && (a = null), 0 == (e & (me.Self | me.Host))) {
        const i = n[9],
          o = Gn(void 0);
        try {
          return i ? i.get(t, a, e & me.Optional) : z3(t, a, e & me.Optional);
        } finally {
          Gn(o);
        }
      }
      return f6(a, 0, e);
    }
    function h6(n, t, e, a = me.Default, i) {
      if (null !== n) {
        if (1024 & t[2]) {
          const r = function _D(n, t, e, a, i) {
            let o = n,
              r = t;
            for (; null !== o && null !== r && 1024 & r[2] && !(256 & r[2]);) {
              const s = p6(o, r, e, a | me.Self, za);
              if (s !== za) return s;
              let c = o.parent;
              if (!c) {
                const l = r[21];
                if (l) {
                  const d = l.get(e, za, a);
                  if (d !== za) return d;
                }
                c = _6(r), r = r[15];
              }
              o = c;
            }
            return i;
          }(n, t, e, a, za);
          if (r !== za) return r;
        }
        const o = p6(n, t, e, a, za);
        if (o !== za) return o;
      }
      return m6(t, e, a, i);
    }
    function p6(n, t, e, a, i) {
      const o = function gD(n) {
        if ("string" == typeof n) return n.charCodeAt(0) || 0;
        const t = n.hasOwnProperty(Hs) ? n[Hs] : void 0;
        return "number" == typeof t ? t >= 0 ? 255 & t : bD : t;
      }(e);
      if ("function" == typeof o) {
        if (!e6(t, n, a)) return a & me.Host ? f6(i, 0, a) : m6(t, e, a, i);
        try {
          const r = o(a);
          if (null != r || a & me.Optional) return r;
          Wl();
        } finally {
          i6();
        }
      } else if ("number" == typeof o) {
        let r = null,
          s = wu(n, t),
          c = -1,
          l = a & me.Host ? t[16][6] : null;
        for ((-1 === s || a & me.SkipSelf) && (c = -1 === s ? l1(n, t) : t[s + 8], -1 !== c && b6(a, !1) ? (r = t[1], s = sr(c), t = cr(c, t)) : s = -1); -1 !== s;) {
          const d = t[1];
          if (g6(o, s, d.data)) {
            const u = pD(s, t, e, r, a, l);
            if (u !== za) return u;
          }
          c = t[s + 8], -1 !== c && b6(a, t[1].data[s + 8] === l) && g6(o, s, t) ? (r = d, s = sr(c), t = cr(c, t)) : s = -1;
        }
      }
      return i;
    }
    function pD(n, t, e, a, i, o) {
      const r = t[1],
        s = r.data[n + 8],
        d = u1(s, r, e, null == a ? Jl(s) && Mu : a != r && 0 != (3 & s.type), i & me.Host && o === s);
      return null !== d ? Xs(t, r, d, s) : za;
    }
    function u1(n, t, e, a, i) {
      const o = n.providerIndexes,
        r = t.data,
        s = 1048575 & o,
        c = n.directiveStart,
        d = o >> 20,
        m = i ? s + d : n.directiveEnd;
      for (let h = a ? s : s + d; h < m; h++) {
        const p = r[h];
        if (h < c && e === p || h >= c && p.type === e) return h;
      }
      if (i) {
        const h = r[c];
        if (h && pa(h) && h.type === e) return c;
      }
      return null;
    }
    function Xs(n, t, e, a) {
      let i = n[e];
      const o = t.data;
      if (function sD(n) {
        return n instanceof Ks;
      }(i)) {
        const r = i;
        r.resolving && function bk(n, t) {
          const e = t ? `. Dependency path: ${t.join(" > ")} > ${n}` : "";
          throw new L(-200, `Circular dependency in DI detected for ${n}${e}`);
        }(function je(n) {
          return "function" == typeof n ? n.name || n.toString() : "object" == typeof n && null != n && "function" == typeof n.type ? n.type.name || n.type.toString() : ve(n);
        }(o[e]));
        const s = c1(r.canSeeViewProviders);
        r.resolving = !0;
        const c = r.injectImpl ? Gn(r.injectImpl) : null;
        e6(n, a, me.Default);
        try {
          i = n[e] = r.factory(void 0, o, n, a), t.firstCreatePass && e >= a.directiveStart && function oD(n, t, e) {
            const {
              ngOnChanges: a,
              ngOnInit: i,
              ngDoCheck: o
            } = t.type.prototype;
            if (a) {
              const r = U3(t);
              (e.preOrderHooks || (e.preOrderHooks = [])).push(n, r), (e.preOrderCheckHooks || (e.preOrderCheckHooks = [])).push(n, r);
            }
            i && (e.preOrderHooks || (e.preOrderHooks = [])).push(0 - n, i), o && ((e.preOrderHooks || (e.preOrderHooks = [])).push(n, o), (e.preOrderCheckHooks || (e.preOrderCheckHooks = [])).push(n, o));
          }(e, o[e], t);
        } finally {
          null !== c && Gn(c), c1(s), r.resolving = !1, i6();
        }
      }
      return i;
    }
    function g6(n, t, e) {
      return !!(e[t + (n >> 5)] & 1 << n);
    }
    function b6(n, t) {
      return !(n & me.Self || n & me.Host && t);
    }
    class lr {
      constructor(t, e) {
        this._tNode = t, this._lView = e;
      }
      get(t, e, a) {
        return h6(this._tNode, this._lView, t, a, e);
      }
    }
    function bD() {
      return new lr(Rt(), I());
    }
    function he(n) {
      return zi(() => {
        const t = n.prototype.constructor,
          e = t[ni] || ku(t),
          a = Object.prototype;
        let i = Object.getPrototypeOf(n.prototype).constructor;
        for (; i && i !== a;) {
          const o = i[ni] || ku(i);
          if (o && o !== e) return o;
          i = Object.getPrototypeOf(i);
        }
        return o => new o();
      });
    }
    function ku(n) {
      return J0(n) ? () => {
        const t = ku(ue(n));
        return t && t();
      } : po(n);
    }
    function _6(n) {
      const t = n[1],
        e = t.type;
      return 2 === e ? t.declTNode : 1 === e ? n[6] : null;
    }
    function qt(n) {
      return function hD(n, t) {
        if ("class" === t) return n.classes;
        if ("style" === t) return n.styles;
        const e = n.attrs;
        if (e) {
          const a = e.length;
          let i = 0;
          for (; i < a;) {
            const o = e[i];
            if (r6(o)) break;
            if (0 === o) i += 2;else if ("number" == typeof o) for (i++; i < a && "string" == typeof e[i];) i++;else {
              if (o === t) return e[i + 1];
              i += 2;
            }
          }
        }
        return null;
      }(Rt(), n);
    }
    const ur = "__parameters__";
    function mr(n, t, e) {
      return zi(() => {
        const a = function Du(n) {
          return function (...e) {
            if (n) {
              const a = n(...e);
              for (const i in a) this[i] = a[i];
            }
          };
        }(t);
        function i(...o) {
          if (this instanceof i) return a.apply(this, o), this;
          const r = new i(...o);
          return s.annotation = r, s;
          function s(c, l, d) {
            const u = c.hasOwnProperty(ur) ? c[ur] : Object.defineProperty(c, ur, {
              value: []
            })[ur];
            for (; u.length <= d;) u.push(null);
            return (u[d] = u[d] || []).push(r), c;
          }
        }
        return e && (i.prototype = Object.create(e.prototype)), i.prototype.ngMetadataName = n, i.annotationCls = i, i;
      });
    }
    class O {
      constructor(t, e) {
        this._desc = t, this.ngMetadataName = "InjectionToken", this.ɵprov = void 0, "number" == typeof e ? this.__NG_ELEMENT_ID__ = e : void 0 !== e && (this.ɵprov = R({
          token: this,
          providedIn: e.providedIn || "root",
          factory: e.factory
        }));
      }
      get multi() {
        return this;
      }
      toString() {
        return `InjectionToken ${this._desc}`;
      }
    }
    function An(n, t) {
      void 0 === t && (t = n);
      for (let e = 0; e < n.length; e++) {
        let a = n[e];
        Array.isArray(a) ? (t === n && (t = n.slice(0, e)), An(a, t)) : t !== n && t.push(a);
      }
      return t;
    }
    function oi(n, t) {
      n.forEach(e => Array.isArray(e) ? oi(e, t) : t(e));
    }
    function y6(n, t, e) {
      t >= n.length ? n.push(e) : n.splice(t, 0, e);
    }
    function f1(n, t) {
      return t >= n.length - 1 ? n.pop() : n.splice(t, 1)[0];
    }
    function ec(n, t) {
      const e = [];
      for (let a = 0; a < n; a++) e.push(t);
      return e;
    }
    function Sn(n, t, e) {
      let a = hr(n, t);
      return a >= 0 ? n[1 | a] = e : (a = ~a, function MD(n, t, e, a) {
        let i = n.length;
        if (i == t) n.push(e, a);else if (1 === i) n.push(a, n[0]), n[0] = e;else {
          for (i--, n.push(n[i - 1], n[i]); i > t;) n[i] = n[i - 2], i--;
          n[t] = e, n[t + 1] = a;
        }
      }(n, a, t, e)), a;
    }
    function Pu(n, t) {
      const e = hr(n, t);
      if (e >= 0) return n[1 | e];
    }
    function hr(n, t) {
      return function x6(n, t, e) {
        let a = 0,
          i = n.length >> e;
        for (; i !== a;) {
          const o = a + (i - a >> 1),
            r = n[o << e];
          if (t === r) return o << e;
          r > t ? i = o : a = o + 1;
        }
        return ~(i << e);
      }(n, t, 1);
    }
    const tc = {},
      Su = "__NG_DI_FLAG__",
      h1 = "ngTempTokenPath",
      SD = /\n/gm,
      w6 = "__source";
    let nc;
    function pr(n) {
      const t = nc;
      return nc = n, t;
    }
    function TD(n, t = me.Default) {
      if (void 0 === nc) throw new L(-203, !1);
      return null === nc ? z3(n, void 0, t) : nc.get(n, t & me.Optional ? null : void 0, t);
    }
    function M(n, t = me.Default) {
      return (function kk() {
        return eu;
      }() || TD)(ue(n), t);
    }
    function La(n, t = me.Default) {
      return "number" != typeof t && (t = 0 | (t.optional && 8) | (t.host && 1) | (t.self && 2) | (t.skipSelf && 4)), M(n, t);
    }
    function Eu(n) {
      const t = [];
      for (let e = 0; e < n.length; e++) {
        const a = ue(n[e]);
        if (Array.isArray(a)) {
          if (0 === a.length) throw new L(900, !1);
          let i,
            o = me.Default;
          for (let r = 0; r < a.length; r++) {
            const s = a[r],
              c = ID(s);
            "number" == typeof c ? -1 === c ? i = s.token : o |= c : i = s;
          }
          t.push(M(i, o));
        } else t.push(M(a));
      }
      return t;
    }
    function ac(n, t) {
      return n[Su] = t, n.prototype[Su] = t, n;
    }
    function ID(n) {
      return n[Su];
    }
    const En = ac(mr("Optional"), 8),
      ga = ac(mr("SkipSelf"), 4);
    let Iu, b1, _1;
    function br(n) {
      return function Ru() {
        if (void 0 === b1 && (b1 = null, Je.trustedTypes)) try {
          b1 = Je.trustedTypes.createPolicy("angular", {
            createHTML: n => n,
            createScript: n => n,
            createScriptURL: n => n
          });
        } catch {}
        return b1;
      }()?.createHTML(n) || n;
    }
    function R6(n) {
      return function zu() {
        if (void 0 === _1 && (_1 = null, Je.trustedTypes)) try {
          _1 = Je.trustedTypes.createPolicy("angular#unsafe-bypass", {
            createHTML: n => n,
            createScript: n => n,
            createScriptURL: n => n
          });
        } catch {}
        return _1;
      }()?.createHTML(n) || n;
    }
    class go {
      constructor(t) {
        this.changingThisBreaksApplicationSecurity = t;
      }
      toString() {
        return `SafeValue must use [property]=binding: ${this.changingThisBreaksApplicationSecurity} (see https://g.co/ng/security#xss)`;
      }
    }
    class KD extends go {
      getTypeName() {
        return "HTML";
      }
    }
    class QD extends go {
      getTypeName() {
        return "Style";
      }
    }
    class ZD extends go {
      getTypeName() {
        return "Script";
      }
    }
    class XD extends go {
      getTypeName() {
        return "URL";
      }
    }
    class JD extends go {
      getTypeName() {
        return "ResourceURL";
      }
    }
    function Tn(n) {
      return n instanceof go ? n.changingThisBreaksApplicationSecurity : n;
    }
    function Na(n, t) {
      const e = function $D(n) {
        return n instanceof go && n.getTypeName() || null;
      }(n);
      if (null != e && e !== t) {
        if ("ResourceURL" === e && "URL" === t) return !0;
        throw new Error(`Required a safe ${t}, got a ${e} (see https://g.co/ng/security#xss)`);
      }
      return e === t;
    }
    class oO {
      constructor(t) {
        this.inertDocumentHelper = t;
      }
      getInertBodyElement(t) {
        t = "<body><remove></remove>" + t;
        try {
          const e = new window.DOMParser().parseFromString(br(t), "text/html").body;
          return null === e ? this.inertDocumentHelper.getInertBodyElement(t) : (e.removeChild(e.firstChild), e);
        } catch {
          return null;
        }
      }
    }
    class rO {
      constructor(t) {
        if (this.defaultDoc = t, this.inertDocument = this.defaultDoc.implementation.createHTMLDocument("sanitization-inert"), null == this.inertDocument.body) {
          const e = this.inertDocument.createElement("html");
          this.inertDocument.appendChild(e);
          const a = this.inertDocument.createElement("body");
          e.appendChild(a);
        }
      }
      getInertBodyElement(t) {
        const e = this.inertDocument.createElement("template");
        if ("content" in e) return e.innerHTML = br(t), e;
        const a = this.inertDocument.createElement("body");
        return a.innerHTML = br(t), this.defaultDoc.documentMode && this.stripCustomNsAttrs(a), a;
      }
      stripCustomNsAttrs(t) {
        const e = t.attributes;
        for (let i = e.length - 1; 0 < i; i--) {
          const r = e.item(i).name;
          ("xmlns:ns1" === r || 0 === r.indexOf("ns1:")) && t.removeAttribute(r);
        }
        let a = t.firstChild;
        for (; a;) a.nodeType === Node.ELEMENT_NODE && this.stripCustomNsAttrs(a), a = a.nextSibling;
      }
    }
    const cO = /^(?:(?:https?|mailto|data|ftp|tel|file|sms):|[^&:/?#]*(?:[/?#]|$))/gi;
    function v1(n) {
      return (n = String(n)).match(cO) ? n : "unsafe:" + n;
    }
    function ri(n) {
      const t = {};
      for (const e of n.split(",")) t[e] = !0;
      return t;
    }
    function rc(...n) {
      const t = {};
      for (const e of n) for (const a in e) e.hasOwnProperty(a) && (t[a] = !0);
      return t;
    }
    const F6 = ri("area,br,col,hr,img,wbr"),
      V6 = ri("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"),
      H6 = ri("rp,rt"),
      Lu = rc(F6, rc(V6, ri("address,article,aside,blockquote,caption,center,del,details,dialog,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,h6,header,hgroup,hr,ins,main,map,menu,nav,ol,pre,section,summary,table,ul")), rc(H6, ri("a,abbr,acronym,audio,b,bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,picture,q,ruby,rp,rt,s,samp,small,source,span,strike,strong,sub,sup,time,track,tt,u,var,video")), rc(H6, V6)),
      Nu = ri("background,cite,href,itemtype,longdesc,poster,src,xlink:href"),
      B6 = rc(Nu, ri("abbr,accesskey,align,alt,autoplay,axis,bgcolor,border,cellpadding,cellspacing,class,clear,color,cols,colspan,compact,controls,coords,datetime,default,dir,download,face,headers,height,hidden,hreflang,hspace,ismap,itemscope,itemprop,kind,label,lang,language,loop,media,muted,nohref,nowrap,open,preload,rel,rev,role,rows,rowspan,rules,scope,scrolling,shape,size,sizes,span,srclang,srcset,start,summary,tabindex,target,title,translate,type,usemap,valign,value,vspace,width"), ri("aria-activedescendant,aria-atomic,aria-autocomplete,aria-busy,aria-checked,aria-colcount,aria-colindex,aria-colspan,aria-controls,aria-current,aria-describedby,aria-details,aria-disabled,aria-dropeffect,aria-errormessage,aria-expanded,aria-flowto,aria-grabbed,aria-haspopup,aria-hidden,aria-invalid,aria-keyshortcuts,aria-label,aria-labelledby,aria-level,aria-live,aria-modal,aria-multiline,aria-multiselectable,aria-orientation,aria-owns,aria-placeholder,aria-posinset,aria-pressed,aria-readonly,aria-relevant,aria-required,aria-roledescription,aria-rowcount,aria-rowindex,aria-rowspan,aria-selected,aria-setsize,aria-sort,aria-valuemax,aria-valuemin,aria-valuenow,aria-valuetext")),
      lO = ri("script,style,template");
    class dO {
      constructor() {
        this.sanitizedSomething = !1, this.buf = [];
      }
      sanitizeChildren(t) {
        let e = t.firstChild,
          a = !0;
        for (; e;) if (e.nodeType === Node.ELEMENT_NODE ? a = this.startElement(e) : e.nodeType === Node.TEXT_NODE ? this.chars(e.nodeValue) : this.sanitizedSomething = !0, a && e.firstChild) e = e.firstChild;else for (; e;) {
          e.nodeType === Node.ELEMENT_NODE && this.endElement(e);
          let i = this.checkClobberedElement(e, e.nextSibling);
          if (i) {
            e = i;
            break;
          }
          e = this.checkClobberedElement(e, e.parentNode);
        }
        return this.buf.join("");
      }
      startElement(t) {
        const e = t.nodeName.toLowerCase();
        if (!Lu.hasOwnProperty(e)) return this.sanitizedSomething = !0, !lO.hasOwnProperty(e);
        this.buf.push("<"), this.buf.push(e);
        const a = t.attributes;
        for (let i = 0; i < a.length; i++) {
          const o = a.item(i),
            r = o.name,
            s = r.toLowerCase();
          if (!B6.hasOwnProperty(s)) {
            this.sanitizedSomething = !0;
            continue;
          }
          let c = o.value;
          Nu[s] && (c = v1(c)), this.buf.push(" ", r, '="', j6(c), '"');
        }
        return this.buf.push(">"), !0;
      }
      endElement(t) {
        const e = t.nodeName.toLowerCase();
        Lu.hasOwnProperty(e) && !F6.hasOwnProperty(e) && (this.buf.push("</"), this.buf.push(e), this.buf.push(">"));
      }
      chars(t) {
        this.buf.push(j6(t));
      }
      checkClobberedElement(t, e) {
        if (e && (t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_CONTAINED_BY) === Node.DOCUMENT_POSITION_CONTAINED_BY) throw new Error(`Failed to sanitize html because the element is clobbered: ${t.outerHTML}`);
        return e;
      }
    }
    const uO = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
      fO = /([^\#-~ |!])/g;
    function j6(n) {
      return n.replace(/&/g, "&amp;").replace(uO, function (t) {
        return "&#" + (1024 * (t.charCodeAt(0) - 55296) + (t.charCodeAt(1) - 56320) + 65536) + ";";
      }).replace(fO, function (t) {
        return "&#" + t.charCodeAt(0) + ";";
      }).replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    let y1;
    function U6(n, t) {
      let e = null;
      try {
        y1 = y1 || function N6(n) {
          const t = new rO(n);
          return function sO() {
            try {
              return !!new window.DOMParser().parseFromString(br(""), "text/html");
            } catch {
              return !1;
            }
          }() ? new oO(t) : t;
        }(n);
        let a = t ? String(t) : "";
        e = y1.getInertBodyElement(a);
        let i = 5,
          o = a;
        do {
          if (0 === i) throw new Error("Failed to sanitize html because the input is unstable");
          i--, a = o, o = e.innerHTML, e = y1.getInertBodyElement(a);
        } while (a !== o);
        return br(new dO().sanitizeChildren(Fu(e) || e));
      } finally {
        if (e) {
          const a = Fu(e) || e;
          for (; a.firstChild;) a.removeChild(a.firstChild);
        }
      }
    }
    function Fu(n) {
      return "content" in n && function mO(n) {
        return n.nodeType === Node.ELEMENT_NODE && "TEMPLATE" === n.nodeName;
      }(n) ? n.content : null;
    }
    var Ge = (() => ((Ge = Ge || {})[Ge.NONE = 0] = "NONE", Ge[Ge.HTML = 1] = "HTML", Ge[Ge.STYLE = 2] = "STYLE", Ge[Ge.SCRIPT = 3] = "SCRIPT", Ge[Ge.URL = 4] = "URL", Ge[Ge.RESOURCE_URL = 5] = "RESOURCE_URL", Ge))();
    function Vu(n) {
      const t = sc();
      return t ? R6(t.sanitize(Ge.HTML, n) || "") : Na(n, "HTML") ? R6(Tn(n)) : U6(function I6() {
        return void 0 !== Iu ? Iu : typeof document < "u" ? document : void 0;
      }(), ve(n));
    }
    function Hu(n) {
      const t = sc();
      return t ? t.sanitize(Ge.URL, n) || "" : Na(n, "URL") ? Tn(n) : v1(ve(n));
    }
    function sc() {
      const n = I();
      return n && n[12];
    }
    const W6 = new O("ENVIRONMENT_INITIALIZER"),
      Y6 = new O("INJECTOR", -1),
      q6 = new O("INJECTOR_DEF_TYPES");
    class K6 {
      get(t, e = tc) {
        if (e === tc) {
          const a = new Error(`NullInjectorError: No provider for ${Xe(t)}!`);
          throw a.name = "NullInjectorError", a;
        }
        return e;
      }
    }
    function yO(...n) {
      return {
        ɵproviders: Q6(0, n)
      };
    }
    function Q6(n, ...t) {
      const e = [],
        a = new Set();
      let i;
      return oi(t, o => {
        const r = o;
        Bu(r, e, [], a) && (i || (i = []), i.push(r));
      }), void 0 !== i && Z6(i, e), e;
    }
    function Z6(n, t) {
      for (let e = 0; e < n.length; e++) {
        const {
          providers: i
        } = n[e];
        oi(i, o => {
          t.push(o);
        });
      }
    }
    function Bu(n, t, e, a) {
      if (!(n = ue(n))) return !1;
      let i = null,
        o = I3(n);
      const r = !o && Ke(n);
      if (o || r) {
        if (r && !r.standalone) return !1;
        i = n;
      } else {
        const c = n.ngModule;
        if (o = I3(c), !o) return !1;
        i = c;
      }
      const s = a.has(i);
      if (r) {
        if (s) return !1;
        if (a.add(i), r.dependencies) {
          const c = "function" == typeof r.dependencies ? r.dependencies() : r.dependencies;
          for (const l of c) Bu(l, t, e, a);
        }
      } else {
        if (!o) return !1;
        {
          if (null != o.imports && !s) {
            let l;
            a.add(i);
            try {
              oi(o.imports, d => {
                Bu(d, t, e, a) && (l || (l = []), l.push(d));
              });
            } finally {}
            void 0 !== l && Z6(l, t);
          }
          if (!s) {
            const l = po(i) || (() => new i());
            t.push({
              provide: i,
              useFactory: l,
              deps: Ue
            }, {
              provide: q6,
              useValue: i,
              multi: !0
            }, {
              provide: W6,
              useValue: () => M(i),
              multi: !0
            });
          }
          const c = o.providers;
          null == c || s || oi(c, d => {
            t.push(d);
          });
        }
      }
      return i !== n && void 0 !== n.providers;
    }
    const CO = Ze({
      provide: String,
      useValue: Ze
    });
    function ju(n) {
      return null !== n && "object" == typeof n && CO in n;
    }
    function bo(n) {
      return "function" == typeof n;
    }
    const Uu = new O("Set Injector scope."),
      C1 = {},
      xO = {};
    let Gu;
    function M1() {
      return void 0 === Gu && (Gu = new K6()), Gu;
    }
    class _r {}
    class $6 extends _r {
      constructor(t, e, a, i) {
        super(), this.parent = e, this.source = a, this.scopes = i, this.records = new Map(), this._ngOnDestroyHooks = new Set(), this._onDestroyHooks = [], this._destroyed = !1, Yu(t, r => this.processProvider(r)), this.records.set(Y6, vr(void 0, this)), i.has("environment") && this.records.set(_r, vr(void 0, this));
        const o = this.records.get(Uu);
        null != o && "string" == typeof o.value && this.scopes.add(o.value), this.injectorDefTypes = new Set(this.get(q6.multi, Ue, me.Self));
      }
      get destroyed() {
        return this._destroyed;
      }
      destroy() {
        this.assertNotDestroyed(), this._destroyed = !0;
        try {
          for (const t of this._ngOnDestroyHooks) t.ngOnDestroy();
          for (const t of this._onDestroyHooks) t();
        } finally {
          this.records.clear(), this._ngOnDestroyHooks.clear(), this.injectorDefTypes.clear(), this._onDestroyHooks.length = 0;
        }
      }
      onDestroy(t) {
        this._onDestroyHooks.push(t);
      }
      runInContext(t) {
        this.assertNotDestroyed();
        const e = pr(this),
          a = Gn(void 0);
        try {
          return t();
        } finally {
          pr(e), Gn(a);
        }
      }
      get(t, e = tc, a = me.Default) {
        this.assertNotDestroyed();
        const i = pr(this),
          o = Gn(void 0);
        try {
          if (!(a & me.SkipSelf)) {
            let s = this.records.get(t);
            if (void 0 === s) {
              const c = function PO(n) {
                return "function" == typeof n || "object" == typeof n && n instanceof O;
              }(t) && Yl(t);
              s = c && this.injectableDefInScope(c) ? vr(Wu(t), C1) : null, this.records.set(t, s);
            }
            if (null != s) return this.hydrate(t, s);
          }
          return (a & me.Self ? M1() : this.parent).get(t, e = a & me.Optional && e === tc ? null : e);
        } catch (r) {
          if ("NullInjectorError" === r.name) {
            if ((r[h1] = r[h1] || []).unshift(Xe(t)), i) throw r;
            return function RD(n, t, e, a) {
              const i = n[h1];
              throw t[w6] && i.unshift(t[w6]), n.message = function zD(n, t, e, a = null) {
                n = n && "\n" === n.charAt(0) && "\u0275" == n.charAt(1) ? n.slice(2) : n;
                let i = Xe(t);
                if (Array.isArray(t)) i = t.map(Xe).join(" -> ");else if ("object" == typeof t) {
                  let o = [];
                  for (let r in t) if (t.hasOwnProperty(r)) {
                    let s = t[r];
                    o.push(r + ":" + ("string" == typeof s ? JSON.stringify(s) : Xe(s)));
                  }
                  i = `{${o.join(", ")}}`;
                }
                return `${e}${a ? "(" + a + ")" : ""}[${i}]: ${n.replace(SD, "\n  ")}`;
              }("\n" + n.message, i, e, a), n.ngTokenPath = i, n[h1] = null, n;
            }(r, t, "R3InjectorError", this.source);
          }
          throw r;
        } finally {
          Gn(o), pr(i);
        }
      }
      resolveInjectorInitializers() {
        const t = pr(this),
          e = Gn(void 0);
        try {
          const a = this.get(W6.multi, Ue, me.Self);
          for (const i of a) i();
        } finally {
          pr(t), Gn(e);
        }
      }
      toString() {
        const t = [],
          e = this.records;
        for (const a of e.keys()) t.push(Xe(a));
        return `R3Injector[${t.join(", ")}]`;
      }
      assertNotDestroyed() {
        if (this._destroyed) throw new L(205, !1);
      }
      processProvider(t) {
        let e = bo(t = ue(t)) ? t : ue(t && t.provide);
        const a = function kO(n) {
          return ju(n) ? vr(void 0, n.useValue) : vr(eg(n), C1);
        }(t);
        if (bo(t) || !0 !== t.multi) this.records.get(e);else {
          let i = this.records.get(e);
          i || (i = vr(void 0, C1, !0), i.factory = () => Eu(i.multi), this.records.set(e, i)), e = t, i.multi.push(t);
        }
        this.records.set(e, a);
      }
      hydrate(t, e) {
        return e.value === C1 && (e.value = xO, e.value = e.factory()), "object" == typeof e.value && e.value && function OO(n) {
          return null !== n && "object" == typeof n && "function" == typeof n.ngOnDestroy;
        }(e.value) && this._ngOnDestroyHooks.add(e.value), e.value;
      }
      injectableDefInScope(t) {
        if (!t.providedIn) return !1;
        const e = ue(t.providedIn);
        return "string" == typeof e ? "any" === e || this.scopes.has(e) : this.injectorDefTypes.has(e);
      }
    }
    function Wu(n) {
      const t = Yl(n),
        e = null !== t ? t.factory : po(n);
      if (null !== e) return e;
      if (n instanceof O) throw new L(204, !1);
      if (n instanceof Function) return function wO(n) {
        const t = n.length;
        if (t > 0) throw ec(t, "?"), new L(204, !1);
        const e = function Mk(n) {
          const t = n && (n[ql] || n[R3]);
          if (t) {
            const e = function xk(n) {
              if (n.hasOwnProperty("name")) return n.name;
              const t = ("" + n).match(/^function\s*([^\s(]+)/);
              return null === t ? "" : t[1];
            }(n);
            return console.warn(`DEPRECATED: DI is instantiating a token "${e}" that inherits its @Injectable decorator but does not provide one itself.\nThis will become an error in a future version of Angular. Please add @Injectable() to the "${e}" class.`), t;
          }
          return null;
        }(n);
        return null !== e ? () => e.factory(n) : () => new n();
      }(n);
      throw new L(204, !1);
    }
    function eg(n, t, e) {
      let a;
      if (bo(n)) {
        const i = ue(n);
        return po(i) || Wu(i);
      }
      if (ju(n)) a = () => ue(n.useValue);else if (function J6(n) {
        return !(!n || !n.useFactory);
      }(n)) a = () => n.useFactory(...Eu(n.deps || []));else if (function X6(n) {
        return !(!n || !n.useExisting);
      }(n)) a = () => M(ue(n.useExisting));else {
        const i = ue(n && (n.useClass || n.provide));
        if (!function DO(n) {
          return !!n.deps;
        }(n)) return po(i) || Wu(i);
        a = () => new i(...Eu(n.deps));
      }
      return a;
    }
    function vr(n, t, e = !1) {
      return {
        factory: n,
        value: t,
        multi: e ? [] : void 0
      };
    }
    function AO(n) {
      return !!n.ɵproviders;
    }
    function Yu(n, t) {
      for (const e of n) Array.isArray(e) ? Yu(e, t) : AO(e) ? Yu(e.ɵproviders, t) : t(e);
    }
    class tg {}
    class TO {
      resolveComponentFactory(t) {
        throw function EO(n) {
          const t = Error(`No component factory found for ${Xe(n)}. Did you add it to @NgModule.entryComponents?`);
          return t.ngComponent = n, t;
        }(t);
      }
    }
    let Vi = (() => {
      class n {}
      return n.NULL = new TO(), n;
    })();
    function IO() {
      return yr(Rt(), I());
    }
    function yr(n, t) {
      return new J(qn(n, t));
    }
    let J = (() => {
      class n {
        constructor(e) {
          this.nativeElement = e;
        }
      }
      return n.__NG_ELEMENT_ID__ = IO, n;
    })();
    function RO(n) {
      return n instanceof J ? n.nativeElement : n;
    }
    class cc {}
    let Hi = (() => {
        class n {}
        return n.__NG_ELEMENT_ID__ = () => function zO() {
          const n = I(),
            e = Pn(Rt().index, n);
          return (_n(e) ? e : n)[11];
        }(), n;
      })(),
      LO = (() => {
        class n {}
        return n.ɵprov = R({
          token: n,
          providedIn: "root",
          factory: () => null
        }), n;
      })();
    class _o {
      constructor(t) {
        this.full = t, this.major = t.split(".")[0], this.minor = t.split(".")[1], this.patch = t.split(".").slice(2).join(".");
      }
    }
    const NO = new _o("14.2.3"),
      qu = {};
    function Ju(n) {
      return n.ngOriginalError;
    }
    class si {
      constructor() {
        this._console = console;
      }
      handleError(t) {
        const e = this._findOriginalError(t);
        this._console.error("ERROR", t), e && this._console.error("ORIGINAL ERROR", e);
      }
      _findOriginalError(t) {
        let e = t && Ju(t);
        for (; e && Ju(e);) e = Ju(e);
        return e || null;
      }
    }
    const $u = new Map();
    let QO = 0;
    const tf = "__ngContext__";
    function Jt(n, t) {
      _n(t) ? (n[tf] = t[20], function XO(n) {
        $u.set(n[20], n);
      }(t)) : n[tf] = t;
    }
    var vn = (() => ((vn = vn || {})[vn.Important = 1] = "Important", vn[vn.DashCase = 2] = "DashCase", vn))();
    function af(n, t) {
      return undefined(n, t);
    }
    function dc(n) {
      const t = n[3];
      return ha(t) ? t[3] : t;
    }
    function rf(n) {
      return gg(n[13]);
    }
    function sf(n) {
      return gg(n[4]);
    }
    function gg(n) {
      for (; null !== n && !ha(n);) n = n[4];
      return n;
    }
    function Mr(n, t, e, a, i) {
      if (null != a) {
        let o,
          r = !1;
        ha(a) ? o = a : _n(a) && (r = !0, a = a[0]);
        const s = kt(a);
        0 === n && null !== e ? null == i ? Mg(t, e, s) : vo(t, e, s, i || null, !0) : 1 === n && null !== e ? vo(t, e, s, i || null, !0) : 2 === n ? function Ag(n, t, e) {
          const a = x1(n, t);
          a && function wP(n, t, e, a) {
            n.removeChild(t, e, a);
          }(n, a, t, e);
        }(t, s, r) : 3 === n && t.destroyNode(s), null != o && function OP(n, t, e, a, i) {
          const o = e[7];
          o !== kt(e) && Mr(t, n, a, o, i);
          for (let s = 10; s < e.length; s++) {
            const c = e[s];
            uc(c[1], c, n, t, a, o);
          }
        }(t, n, o, e, i);
      }
    }
    function lf(n, t, e) {
      return n.createElement(t, e);
    }
    function _g(n, t) {
      const e = n[9],
        a = e.indexOf(t),
        i = t[3];
      512 & t[2] && (t[2] &= -513, fu(i, -1)), e.splice(a, 1);
    }
    function df(n, t) {
      if (n.length <= 10) return;
      const e = 10 + t,
        a = n[e];
      if (a) {
        const i = a[17];
        null !== i && i !== n && _g(i, a), t > 0 && (n[e - 1][4] = a[4]);
        const o = f1(n, 10 + t);
        !function gP(n, t) {
          uc(n, t, t[11], 2, null, null), t[0] = null, t[6] = null;
        }(a[1], a);
        const r = o[19];
        null !== r && r.detachView(o[1]), a[3] = null, a[4] = null, a[2] &= -65;
      }
      return a;
    }
    function vg(n, t) {
      if (!(128 & t[2])) {
        const e = t[11];
        e.destroyNode && uc(n, t, e, 3, null, null), function vP(n) {
          let t = n[13];
          if (!t) return uf(n[1], n);
          for (; t;) {
            let e = null;
            if (_n(t)) e = t[13];else {
              const a = t[10];
              a && (e = a);
            }
            if (!e) {
              for (; t && !t[4] && t !== n;) _n(t) && uf(t[1], t), t = t[3];
              null === t && (t = n), _n(t) && uf(t[1], t), e = t && t[4];
            }
            t = e;
          }
        }(t);
      }
    }
    function uf(n, t) {
      if (!(128 & t[2])) {
        t[2] &= -65, t[2] |= 128, function xP(n, t) {
          let e;
          if (null != n && null != (e = n.destroyHooks)) for (let a = 0; a < e.length; a += 2) {
            const i = t[e[a]];
            if (!(i instanceof Ks)) {
              const o = e[a + 1];
              if (Array.isArray(o)) for (let r = 0; r < o.length; r += 2) {
                const s = i[o[r]],
                  c = o[r + 1];
                try {
                  c.call(s);
                } finally {}
              } else try {
                o.call(i);
              } finally {}
            }
          }
        }(n, t), function MP(n, t) {
          const e = n.cleanup,
            a = t[7];
          let i = -1;
          if (null !== e) for (let o = 0; o < e.length - 1; o += 2) if ("string" == typeof e[o]) {
            const r = e[o + 1],
              s = "function" == typeof r ? r(t) : kt(t[r]),
              c = a[i = e[o + 2]],
              l = e[o + 3];
            "boolean" == typeof l ? s.removeEventListener(e[o], c, l) : l >= 0 ? a[i = l]() : a[i = -l].unsubscribe(), o += 2;
          } else {
            const r = a[i = e[o + 1]];
            e[o].call(r);
          }
          if (null !== a) {
            for (let o = i + 1; o < a.length; o++) (0, a[o])();
            t[7] = null;
          }
        }(n, t), 1 === t[1].type && t[11].destroy();
        const e = t[17];
        if (null !== e && ha(t[3])) {
          e !== t[3] && _g(e, t);
          const a = t[19];
          null !== a && a.detachView(n);
        }
        !function JO(n) {
          $u.delete(n[20]);
        }(t);
      }
    }
    function yg(n, t, e) {
      return function Cg(n, t, e) {
        let a = t;
        for (; null !== a && 40 & a.type;) a = (t = a).parent;
        if (null === a) return e[0];
        if (2 & a.flags) {
          const i = n.data[a.directiveStart].encapsulation;
          if (i === fa.None || i === fa.Emulated) return null;
        }
        return qn(a, e);
      }(n, t.parent, e);
    }
    function vo(n, t, e, a, i) {
      n.insertBefore(t, e, a, i);
    }
    function Mg(n, t, e) {
      n.appendChild(t, e);
    }
    function xg(n, t, e, a, i) {
      null !== a ? vo(n, t, e, a, i) : Mg(n, t, e);
    }
    function x1(n, t) {
      return n.parentNode(t);
    }
    function wg(n, t, e) {
      return Dg(n, t, e);
    }
    let Dg = function kg(n, t, e) {
      return 40 & n.type ? qn(n, e) : null;
    };
    function w1(n, t, e, a) {
      const i = yg(n, a, t),
        o = t[11],
        s = wg(a.parent || t[6], a, t);
      if (null != i) if (Array.isArray(e)) for (let c = 0; c < e.length; c++) xg(o, i, e[c], s, !1);else xg(o, i, e, s, !1);
    }
    function k1(n, t) {
      if (null !== t) {
        const e = t.type;
        if (3 & e) return qn(t, n);
        if (4 & e) return mf(-1, n[t.index]);
        if (8 & e) {
          const a = t.child;
          if (null !== a) return k1(n, a);
          {
            const i = n[t.index];
            return ha(i) ? mf(-1, i) : kt(i);
          }
        }
        if (32 & e) return af(t, n)() || kt(n[t.index]);
        {
          const a = Pg(n, t);
          return null !== a ? Array.isArray(a) ? a[0] : k1(dc(n[16]), a) : k1(n, t.next);
        }
      }
      return null;
    }
    function Pg(n, t) {
      return null !== t ? n[16][6].projection[t.projection] : null;
    }
    function mf(n, t) {
      const e = 10 + n + 1;
      if (e < t.length) {
        const a = t[e],
          i = a[1].firstChild;
        if (null !== i) return k1(a, i);
      }
      return t[7];
    }
    function hf(n, t, e, a, i, o, r) {
      for (; null != e;) {
        const s = a[e.index],
          c = e.type;
        if (r && 0 === t && (s && Jt(kt(s), a), e.flags |= 4), 64 != (64 & e.flags)) if (8 & c) hf(n, t, e.child, a, i, o, !1), Mr(t, n, i, s, o);else if (32 & c) {
          const l = af(e, a);
          let d;
          for (; d = l();) Mr(t, n, i, d, o);
          Mr(t, n, i, s, o);
        } else 16 & c ? Sg(n, t, a, e, i, o) : Mr(t, n, i, s, o);
        e = r ? e.projectionNext : e.next;
      }
    }
    function uc(n, t, e, a, i, o) {
      hf(e, a, n.firstChild, t, i, o, !1);
    }
    function Sg(n, t, e, a, i, o) {
      const r = e[16],
        c = r[6].projection[a.projection];
      if (Array.isArray(c)) for (let l = 0; l < c.length; l++) Mr(t, n, i, c[l], o);else hf(n, t, c, r[3], i, o, !0);
    }
    function Eg(n, t, e) {
      n.setAttribute(t, "style", e);
    }
    function pf(n, t, e) {
      "" === e ? n.removeAttribute(t, "class") : n.setAttribute(t, "class", e);
    }
    function Tg(n, t, e) {
      let a = n.length;
      for (;;) {
        const i = n.indexOf(t, e);
        if (-1 === i) return i;
        if (0 === i || n.charCodeAt(i - 1) <= 32) {
          const o = t.length;
          if (i + o === a || n.charCodeAt(i + o) <= 32) return i;
        }
        e = i + 1;
      }
    }
    const Ig = "ng-template";
    function AP(n, t, e) {
      let a = 0;
      for (; a < n.length;) {
        let i = n[a++];
        if (e && "class" === i) {
          if (i = n[a], -1 !== Tg(i.toLowerCase(), t, 0)) return !0;
        } else if (1 === i) {
          for (; a < n.length && "string" == typeof (i = n[a++]);) if (i.toLowerCase() === t) return !0;
          return !1;
        }
      }
      return !1;
    }
    function Rg(n) {
      return 4 === n.type && n.value !== Ig;
    }
    function SP(n, t, e) {
      return t === (4 !== n.type || e ? n.value : Ig);
    }
    function EP(n, t, e) {
      let a = 4;
      const i = n.attrs || [],
        o = function RP(n) {
          for (let t = 0; t < n.length; t++) if (r6(n[t])) return t;
          return n.length;
        }(i);
      let r = !1;
      for (let s = 0; s < t.length; s++) {
        const c = t[s];
        if ("number" != typeof c) {
          if (!r) if (4 & a) {
            if (a = 2 | 1 & a, "" !== c && !SP(n, c, e) || "" === c && 1 === t.length) {
              if (ba(a)) return !1;
              r = !0;
            }
          } else {
            const l = 8 & a ? c : t[++s];
            if (8 & a && null !== n.attrs) {
              if (!AP(n.attrs, l, e)) {
                if (ba(a)) return !1;
                r = !0;
              }
              continue;
            }
            const u = TP(8 & a ? "class" : c, i, Rg(n), e);
            if (-1 === u) {
              if (ba(a)) return !1;
              r = !0;
              continue;
            }
            if ("" !== l) {
              let m;
              m = u > o ? "" : i[u + 1].toLowerCase();
              const h = 8 & a ? m : null;
              if (h && -1 !== Tg(h, l, 0) || 2 & a && l !== m) {
                if (ba(a)) return !1;
                r = !0;
              }
            }
          }
        } else {
          if (!r && !ba(a) && !ba(c)) return !1;
          if (r && ba(c)) continue;
          r = !1, a = c | 1 & a;
        }
      }
      return ba(a) || r;
    }
    function ba(n) {
      return 0 == (1 & n);
    }
    function TP(n, t, e, a) {
      if (null === t) return -1;
      let i = 0;
      if (a || !e) {
        let o = !1;
        for (; i < t.length;) {
          const r = t[i];
          if (r === n) return i;
          if (3 === r || 6 === r) o = !0;else {
            if (1 === r || 2 === r) {
              let s = t[++i];
              for (; "string" == typeof s;) s = t[++i];
              continue;
            }
            if (4 === r) break;
            if (0 === r) {
              i += 4;
              continue;
            }
          }
          i += o ? 1 : 2;
        }
        return -1;
      }
      return function zP(n, t) {
        let e = n.indexOf(4);
        if (e > -1) for (e++; e < n.length;) {
          const a = n[e];
          if ("number" == typeof a) return -1;
          if (a === t) return e;
          e++;
        }
        return -1;
      }(t, n);
    }
    function zg(n, t, e = !1) {
      for (let a = 0; a < t.length; a++) if (EP(n, t[a], e)) return !0;
      return !1;
    }
    function LP(n, t) {
      e: for (let e = 0; e < t.length; e++) {
        const a = t[e];
        if (n.length === a.length) {
          for (let i = 0; i < n.length; i++) if (n[i] !== a[i]) continue e;
          return !0;
        }
      }
      return !1;
    }
    function Lg(n, t) {
      return n ? ":not(" + t.trim() + ")" : t;
    }
    function NP(n) {
      let t = n[0],
        e = 1,
        a = 2,
        i = "",
        o = !1;
      for (; e < n.length;) {
        let r = n[e];
        if ("string" == typeof r) {
          if (2 & a) {
            const s = n[++e];
            i += "[" + r + (s.length > 0 ? '="' + s + '"' : "") + "]";
          } else 8 & a ? i += "." + r : 4 & a && (i += " " + r);
        } else "" !== i && !ba(r) && (t += Lg(o, i), i = ""), a = r, o = o || !ba(a);
        e++;
      }
      return "" !== i && (t += Lg(o, i)), t;
    }
    const ye = {};
    function g(n) {
      Ng(Ne(), I(), ln() + n, !1);
    }
    function Ng(n, t, e, a) {
      if (!a) if (3 == (3 & t[2])) {
        const o = n.preOrderCheckHooks;
        null !== o && a1(t, o, e);
      } else {
        const o = n.preOrderHooks;
        null !== o && o1(t, o, 0, e);
      }
      Ni(e);
    }
    function Bg(n, t = null, e = null, a) {
      const i = jg(n, t, e, a);
      return i.resolveInjectorInitializers(), i;
    }
    function jg(n, t = null, e = null, a, i = new Set()) {
      const o = [e || Ue, yO(n)];
      return a = a || ("object" == typeof n ? void 0 : Xe(n)), new $6(o, t || M1(), a || null, i);
    }
    let Lt = (() => {
      class n {
        static create(e, a) {
          if (Array.isArray(e)) return Bg({
            name: ""
          }, a, e, "");
          {
            const i = e.name ?? "";
            return Bg({
              name: i
            }, e.parent, e.providers, i);
          }
        }
      }
      return n.THROW_IF_NOT_FOUND = tc, n.NULL = new K6(), n.ɵprov = R({
        token: n,
        providedIn: "any",
        factory: () => M(Y6)
      }), n.__NG_ELEMENT_ID__ = -1, n;
    })();
    function f(n, t = me.Default) {
      const e = I();
      return null === e ? M(n, t) : h6(Rt(), e, ue(n), t);
    }
    function li() {
      throw new Error("invalid");
    }
    function O1(n, t) {
      return n << 17 | t << 2;
    }
    function _a(n) {
      return n >> 17 & 32767;
    }
    function yf(n) {
      return 2 | n;
    }
    function di(n) {
      return (131068 & n) >> 2;
    }
    function Cf(n, t) {
      return -131069 & n | t << 2;
    }
    function Mf(n) {
      return 1 | n;
    }
    function o8(n, t) {
      const e = n.contentQueries;
      if (null !== e) for (let a = 0; a < e.length; a += 2) {
        const i = e[a],
          o = e[a + 1];
        if (-1 !== o) {
          const r = n.data[o];
          bu(i), r.contentQueries(2, t[o], o);
        }
      }
    }
    function S1(n, t, e, a, i, o, r, s, c, l, d) {
      const u = t.blueprint.slice();
      return u[0] = i, u[2] = 76 | a, (null !== d || n && 1024 & n[2]) && (u[2] |= 1024), Y3(u), u[3] = u[15] = n, u[8] = e, u[10] = r || n && n[10], u[11] = s || n && n[11], u[12] = c || n && n[12] || null, u[9] = l || n && n[9] || null, u[6] = o, u[20] = function ZO() {
        return QO++;
      }(), u[21] = d, u[16] = 2 == t.type ? n[16] : u, u;
    }
    function wr(n, t, e, a, i) {
      let o = n.data[t];
      if (null === o) o = function Sf(n, t, e, a, i) {
        const o = Q3(),
          r = mu(),
          c = n.data[t] = function vA(n, t, e, a, i, o) {
            return {
              type: e,
              index: a,
              insertBeforeIndex: null,
              injectorIndex: t ? t.injectorIndex : -1,
              directiveStart: -1,
              directiveEnd: -1,
              directiveStylingLast: -1,
              propertyBindings: null,
              flags: 0,
              providerIndexes: 0,
              value: i,
              attrs: o,
              mergedAttrs: null,
              localNames: null,
              initialInputs: void 0,
              inputs: null,
              outputs: null,
              tViews: null,
              next: null,
              projectionNext: null,
              child: null,
              parent: t,
              projection: null,
              styles: null,
              stylesWithoutHost: null,
              residualStyles: void 0,
              classes: null,
              classesWithoutHost: null,
              residualClasses: void 0,
              classBindings: 0,
              styleBindings: 0
            };
          }(0, r ? o : o && o.parent, e, t, a, i);
        return null === n.firstChild && (n.firstChild = c), null !== o && (r ? null == o.child && null !== c.parent && (o.child = c) : null === o.next && (o.next = c)), c;
      }(n, t, e, a, i), function Zk() {
        return _e.lFrame.inI18n;
      }() && (o.flags |= 64);else if (64 & o.type) {
        o.type = e, o.value = a, o.attrs = i;
        const r = function Ys() {
          const n = _e.lFrame,
            t = n.currentTNode;
          return n.isParent ? t : t.parent;
        }();
        o.injectorIndex = null === r ? -1 : r.injectorIndex;
      }
      return Ra(o, !0), o;
    }
    function kr(n, t, e, a) {
      if (0 === e) return -1;
      const i = t.length;
      for (let o = 0; o < e; o++) t.push(a), n.blueprint.push(a), n.data.push(null);
      return i;
    }
    function Ef(n, t, e) {
      _u(t);
      try {
        const a = n.viewQuery;
        null !== a && Vf(1, a, e);
        const i = n.template;
        null !== i && r8(n, t, i, 1, e), n.firstCreatePass && (n.firstCreatePass = !1), n.staticContentQueries && o8(n, t), n.staticViewQueries && Vf(2, n.viewQuery, e);
        const o = n.components;
        null !== o && function gA(n, t) {
          for (let e = 0; e < t.length; e++) zA(n, t[e]);
        }(t, o);
      } catch (a) {
        throw n.firstCreatePass && (n.incompleteFirstPass = !0, n.firstCreatePass = !1), a;
      } finally {
        t[2] &= -5, vu();
      }
    }
    function E1(n, t, e, a) {
      const i = t[2];
      if (128 != (128 & i)) {
        _u(t);
        try {
          Y3(t), function X3(n) {
            return _e.lFrame.bindingIndex = n;
          }(n.bindingStartIndex), null !== e && r8(n, t, e, 2, a);
          const r = 3 == (3 & i);
          if (r) {
            const l = n.preOrderCheckHooks;
            null !== l && a1(t, l, null);
          } else {
            const l = n.preOrderHooks;
            null !== l && o1(t, l, 0, null), yu(t, 0);
          }
          if (function IA(n) {
            for (let t = rf(n); null !== t; t = sf(t)) {
              if (!t[2]) continue;
              const e = t[9];
              for (let a = 0; a < e.length; a++) {
                const i = e[a],
                  o = i[3];
                0 == (512 & i[2]) && fu(o, 1), i[2] |= 512;
              }
            }
          }(t), function TA(n) {
            for (let t = rf(n); null !== t; t = sf(t)) for (let e = 10; e < t.length; e++) {
              const a = t[e],
                i = a[1];
              t1(a) && E1(i, a, i.template, a[8]);
            }
          }(t), null !== n.contentQueries && o8(n, t), r) {
            const l = n.contentCheckHooks;
            null !== l && a1(t, l);
          } else {
            const l = n.contentHooks;
            null !== l && o1(t, l, 1), yu(t, 1);
          }
          !function hA(n, t) {
            const e = n.hostBindingOpCodes;
            if (null !== e) try {
              for (let a = 0; a < e.length; a++) {
                const i = e[a];
                if (i < 0) Ni(~i);else {
                  const o = i,
                    r = e[++a],
                    s = e[++a];
                  Xk(r, o), s(2, t[o]);
                }
              }
            } finally {
              Ni(-1);
            }
          }(n, t);
          const s = n.components;
          null !== s && function pA(n, t) {
            for (let e = 0; e < t.length; e++) RA(n, t[e]);
          }(t, s);
          const c = n.viewQuery;
          if (null !== c && Vf(2, c, a), r) {
            const l = n.viewCheckHooks;
            null !== l && a1(t, l);
          } else {
            const l = n.viewHooks;
            null !== l && o1(t, l, 2), yu(t, 2);
          }
          !0 === n.firstUpdatePass && (n.firstUpdatePass = !1), t[2] &= -41, 512 & t[2] && (t[2] &= -513, fu(t[3], -1));
        } finally {
          vu();
        }
      }
    }
    function r8(n, t, e, a, i) {
      const o = ln(),
        r = 2 & a;
      try {
        Ni(-1), r && t.length > 22 && Ng(n, t, 22, !1), e(a, i);
      } finally {
        Ni(o);
      }
    }
    function s8(n, t, e) {
      if (ru(t)) {
        const i = t.directiveEnd;
        for (let o = t.directiveStart; o < i; o++) {
          const r = n.data[o];
          r.contentQueries && r.contentQueries(1, e[o], o);
        }
      }
    }
    function Tf(n, t, e) {
      !K3() || (function wA(n, t, e, a) {
        const i = e.directiveStart,
          o = e.directiveEnd;
        n.firstCreatePass || Zs(e, t), Jt(a, t);
        const r = e.initialInputs;
        for (let s = i; s < o; s++) {
          const c = n.data[s],
            l = pa(c);
          l && AA(t, e, c);
          const d = Xs(t, n, s, e);
          Jt(d, t), null !== r && SA(0, s - i, d, c, 0, r), l && (Pn(e.index, t)[8] = d);
        }
      }(n, t, e, qn(e, t)), 128 == (128 & e.flags) && function kA(n, t, e) {
        const a = e.directiveStart,
          i = e.directiveEnd,
          o = e.index,
          r = function Jk() {
            return _e.lFrame.currentDirectiveIndex;
          }();
        try {
          Ni(o);
          for (let s = a; s < i; s++) {
            const c = n.data[s],
              l = t[s];
            pu(s), (null !== c.hostBindings || 0 !== c.hostVars || null !== c.hostAttrs) && h8(c, l);
          }
        } finally {
          Ni(-1), pu(r);
        }
      }(n, t, e));
    }
    function If(n, t, e = qn) {
      const a = t.localNames;
      if (null !== a) {
        let i = t.index + 1;
        for (let o = 0; o < a.length; o += 2) {
          const r = a[o + 1],
            s = -1 === r ? e(t, n) : n[r];
          n[i++] = s;
        }
      }
    }
    function c8(n) {
      const t = n.tView;
      return null === t || t.incompleteFirstPass ? n.tView = Rf(1, null, n.template, n.decls, n.vars, n.directiveDefs, n.pipeDefs, n.viewQuery, n.schemas, n.consts) : t;
    }
    function Rf(n, t, e, a, i, o, r, s, c, l) {
      const d = 22 + a,
        u = d + i,
        m = function bA(n, t) {
          const e = [];
          for (let a = 0; a < t; a++) e.push(a < n ? null : ye);
          return e;
        }(d, u),
        h = "function" == typeof l ? l() : l;
      return m[1] = {
        type: n,
        blueprint: m,
        template: e,
        queries: null,
        viewQuery: s,
        declTNode: t,
        data: m.slice().fill(null, d),
        bindingStartIndex: d,
        expandoStartIndex: u,
        hostBindingOpCodes: null,
        firstCreatePass: !0,
        firstUpdatePass: !0,
        staticViewQueries: !1,
        staticContentQueries: !1,
        preOrderHooks: null,
        preOrderCheckHooks: null,
        contentHooks: null,
        contentCheckHooks: null,
        viewHooks: null,
        viewCheckHooks: null,
        destroyHooks: null,
        cleanup: null,
        contentQueries: null,
        components: null,
        directiveRegistry: "function" == typeof o ? o() : o,
        pipeRegistry: "function" == typeof r ? r() : r,
        firstChild: null,
        schemas: c,
        consts: h,
        incompleteFirstPass: !1
      };
    }
    function l8(n, t, e, a) {
      const i = v8(t);
      null === e ? i.push(a) : (i.push(e), n.firstCreatePass && y8(n).push(a, i.length - 1));
    }
    function d8(n, t, e) {
      for (let a in n) if (n.hasOwnProperty(a)) {
        const i = n[a];
        (e = null === e ? {} : e).hasOwnProperty(a) ? e[a].push(t, i) : e[a] = [t, i];
      }
      return e;
    }
    function u8(n, t) {
      const a = t.directiveEnd,
        i = n.data,
        o = t.attrs,
        r = [];
      let s = null,
        c = null;
      for (let l = t.directiveStart; l < a; l++) {
        const d = i[l],
          u = d.inputs,
          m = null === o || Rg(t) ? null : EA(u, o);
        r.push(m), s = d8(u, l, s), c = d8(d.outputs, l, c);
      }
      null !== s && (s.hasOwnProperty("class") && (t.flags |= 16), s.hasOwnProperty("style") && (t.flags |= 32)), t.initialInputs = r, t.inputs = s, t.outputs = c;
    }
    function In(n, t, e, a, i, o, r, s) {
      const c = qn(t, e);
      let d,
        l = t.inputs;
      !s && null != l && (d = l[a]) ? (Hf(n, e, d, a, i), Jl(t) && f8(e, t.index)) : 3 & t.type && (a = function yA(n) {
        return "class" === n ? "className" : "for" === n ? "htmlFor" : "formaction" === n ? "formAction" : "innerHtml" === n ? "innerHTML" : "readonly" === n ? "readOnly" : "tabindex" === n ? "tabIndex" : n;
      }(a), i = null != r ? r(i, t.value || "", a) : i, o.setProperty(c, a, i));
    }
    function f8(n, t) {
      const e = Pn(t, n);
      16 & e[2] || (e[2] |= 32);
    }
    function zf(n, t, e, a) {
      let i = !1;
      if (K3()) {
        const o = function DA(n, t, e) {
            const a = n.directiveRegistry;
            let i = null;
            if (a) for (let o = 0; o < a.length; o++) {
              const r = a[o];
              zg(e, r.selectors, !1) && (i || (i = []), d1(Zs(e, t), n, r.type), pa(r) ? (p8(n, e), i.unshift(r)) : i.push(r));
            }
            return i;
          }(n, t, e),
          r = null === a ? null : {
            "": -1
          };
        if (null !== o) {
          i = !0, g8(e, n.data.length, o.length);
          for (let d = 0; d < o.length; d++) {
            const u = o[d];
            u.providersResolver && u.providersResolver(u);
          }
          let s = !1,
            c = !1,
            l = kr(n, t, o.length, null);
          for (let d = 0; d < o.length; d++) {
            const u = o[d];
            e.mergedAttrs = s1(e.mergedAttrs, u.hostAttrs), b8(n, e, t, l, u), PA(l, u, r), null !== u.contentQueries && (e.flags |= 8), (null !== u.hostBindings || null !== u.hostAttrs || 0 !== u.hostVars) && (e.flags |= 128);
            const m = u.type.prototype;
            !s && (m.ngOnChanges || m.ngOnInit || m.ngDoCheck) && ((n.preOrderHooks || (n.preOrderHooks = [])).push(e.index), s = !0), !c && (m.ngOnChanges || m.ngDoCheck) && ((n.preOrderCheckHooks || (n.preOrderCheckHooks = [])).push(e.index), c = !0), l++;
          }
          u8(n, e);
        }
        r && function OA(n, t, e) {
          if (t) {
            const a = n.localNames = [];
            for (let i = 0; i < t.length; i += 2) {
              const o = e[t[i + 1]];
              if (null == o) throw new L(-301, !1);
              a.push(t[i], o);
            }
          }
        }(e, a, r);
      }
      return e.mergedAttrs = s1(e.mergedAttrs, e.attrs), i;
    }
    function m8(n, t, e, a, i, o) {
      const r = o.hostBindings;
      if (r) {
        let s = n.hostBindingOpCodes;
        null === s && (s = n.hostBindingOpCodes = []);
        const c = ~t.index;
        (function xA(n) {
          let t = n.length;
          for (; t > 0;) {
            const e = n[--t];
            if ("number" == typeof e && e < 0) return e;
          }
          return 0;
        })(s) != c && s.push(c), s.push(a, i, r);
      }
    }
    function h8(n, t) {
      null !== n.hostBindings && n.hostBindings(1, t);
    }
    function p8(n, t) {
      t.flags |= 2, (n.components || (n.components = [])).push(t.index);
    }
    function PA(n, t, e) {
      if (e) {
        if (t.exportAs) for (let a = 0; a < t.exportAs.length; a++) e[t.exportAs[a]] = n;
        pa(t) && (e[""] = n);
      }
    }
    function g8(n, t, e) {
      n.flags |= 1, n.directiveStart = t, n.directiveEnd = t + e, n.providerIndexes = t;
    }
    function b8(n, t, e, a, i) {
      n.data[a] = i;
      const o = i.factory || (i.factory = po(i.type)),
        r = new Ks(o, pa(i), f);
      n.blueprint[a] = r, e[a] = r, m8(n, t, 0, a, kr(n, e, i.hostVars, ye), i);
    }
    function AA(n, t, e) {
      const a = qn(t, n),
        i = c8(e),
        o = n[10],
        r = T1(n, S1(n, i, null, e.onPush ? 32 : 16, a, t, o, o.createRenderer(a, e), null, null, null));
      n[t.index] = r;
    }
    function Fa(n, t, e, a, i, o) {
      const r = qn(n, t);
      !function Lf(n, t, e, a, i, o, r) {
        if (null == o) n.removeAttribute(t, i, e);else {
          const s = null == r ? ve(o) : r(o, a || "", i);
          n.setAttribute(t, i, s, e);
        }
      }(t[11], r, o, n.value, e, a, i);
    }
    function SA(n, t, e, a, i, o) {
      const r = o[t];
      if (null !== r) {
        const s = a.setInput;
        for (let c = 0; c < r.length;) {
          const l = r[c++],
            d = r[c++],
            u = r[c++];
          null !== s ? a.setInput(e, u, l, d) : e[d] = u;
        }
      }
    }
    function EA(n, t) {
      let e = null,
        a = 0;
      for (; a < t.length;) {
        const i = t[a];
        if (0 !== i) {
          if (5 !== i) {
            if ("number" == typeof i) break;
            n.hasOwnProperty(i) && (null === e && (e = []), e.push(i, n[i], t[a + 1])), a += 2;
          } else a += 2;
        } else a += 4;
      }
      return e;
    }
    function _8(n, t, e, a) {
      return new Array(n, !0, !1, t, null, 0, a, e, null, null);
    }
    function RA(n, t) {
      const e = Pn(t, n);
      if (t1(e)) {
        const a = e[1];
        48 & e[2] ? E1(a, e, a.template, e[8]) : e[5] > 0 && Nf(e);
      }
    }
    function Nf(n) {
      for (let a = rf(n); null !== a; a = sf(a)) for (let i = 10; i < a.length; i++) {
        const o = a[i];
        if (t1(o)) if (512 & o[2]) {
          const r = o[1];
          E1(r, o, r.template, o[8]);
        } else o[5] > 0 && Nf(o);
      }
      const e = n[1].components;
      if (null !== e) for (let a = 0; a < e.length; a++) {
        const i = Pn(e[a], n);
        t1(i) && i[5] > 0 && Nf(i);
      }
    }
    function zA(n, t) {
      const e = Pn(t, n),
        a = e[1];
      (function LA(n, t) {
        for (let e = t.length; e < n.blueprint.length; e++) t.push(n.blueprint[e]);
      })(a, e), Ef(a, e, e[8]);
    }
    function T1(n, t) {
      return n[13] ? n[14][4] = t : n[13] = t, n[14] = t, t;
    }
    function Ff(n) {
      for (; n;) {
        n[2] |= 32;
        const t = dc(n);
        if (Ek(n) && !t) return n;
        n = t;
      }
      return null;
    }
    function I1(n, t, e, a = !0) {
      const i = t[10];
      i.begin && i.begin();
      try {
        E1(n, t, n.template, e);
      } catch (r) {
        throw a && M8(t, r), r;
      } finally {
        i.end && i.end();
      }
    }
    function Vf(n, t, e) {
      bu(0), t(n, e);
    }
    function v8(n) {
      return n[7] || (n[7] = []);
    }
    function y8(n) {
      return n.cleanup || (n.cleanup = []);
    }
    function C8(n, t, e) {
      return (null === n || pa(n)) && (e = function Hk(n) {
        for (; Array.isArray(n);) {
          if ("object" == typeof n[1]) return n;
          n = n[0];
        }
        return null;
      }(e[t.index])), e[11];
    }
    function M8(n, t) {
      const e = n[9],
        a = e ? e.get(si, null) : null;
      a && a.handleError(t);
    }
    function Hf(n, t, e, a, i) {
      for (let o = 0; o < e.length;) {
        const r = e[o++],
          s = e[o++],
          c = t[r],
          l = n.data[r];
        null !== l.setInput ? l.setInput(c, i, a, s) : c[s] = i;
      }
    }
    function ui(n, t, e) {
      const a = e1(t, n);
      !function bg(n, t, e) {
        n.setValue(t, e);
      }(n[11], a, e);
    }
    function R1(n, t, e) {
      let a = e ? n.styles : null,
        i = e ? n.classes : null,
        o = 0;
      if (null !== t) for (let r = 0; r < t.length; r++) {
        const s = t[r];
        "number" == typeof s ? o = s : 1 == o ? i = X0(i, s) : 2 == o && (a = X0(a, s + ": " + t[++r] + ";"));
      }
      e ? n.styles = a : n.stylesWithoutHost = a, e ? n.classes = i : n.classesWithoutHost = i;
    }
    function z1(n, t, e, a, i = !1) {
      for (; null !== e;) {
        const o = t[e.index];
        if (null !== o && a.push(kt(o)), ha(o)) for (let s = 10; s < o.length; s++) {
          const c = o[s],
            l = c[1].firstChild;
          null !== l && z1(c[1], c, l, a);
        }
        const r = e.type;
        if (8 & r) z1(n, t, e.child, a);else if (32 & r) {
          const s = af(e, t);
          let c;
          for (; c = s();) a.push(c);
        } else if (16 & r) {
          const s = Pg(t, e);
          if (Array.isArray(s)) a.push(...s);else {
            const c = dc(t[16]);
            z1(c[1], c, s, a, !0);
          }
        }
        e = i ? e.projectionNext : e.next;
      }
      return a;
    }
    class fc {
      constructor(t, e) {
        this._lView = t, this._cdRefInjectingView = e, this._appRef = null, this._attachedToViewContainer = !1;
      }
      get rootNodes() {
        const t = this._lView,
          e = t[1];
        return z1(e, t, e.firstChild, []);
      }
      get context() {
        return this._lView[8];
      }
      set context(t) {
        this._lView[8] = t;
      }
      get destroyed() {
        return 128 == (128 & this._lView[2]);
      }
      destroy() {
        if (this._appRef) this._appRef.detachView(this);else if (this._attachedToViewContainer) {
          const t = this._lView[3];
          if (ha(t)) {
            const e = t[8],
              a = e ? e.indexOf(this) : -1;
            a > -1 && (df(t, a), f1(e, a));
          }
          this._attachedToViewContainer = !1;
        }
        vg(this._lView[1], this._lView);
      }
      onDestroy(t) {
        l8(this._lView[1], this._lView, null, t);
      }
      markForCheck() {
        Ff(this._cdRefInjectingView || this._lView);
      }
      detach() {
        this._lView[2] &= -65;
      }
      reattach() {
        this._lView[2] |= 64;
      }
      detectChanges() {
        I1(this._lView[1], this._lView, this.context);
      }
      checkNoChanges() {}
      attachToViewContainerRef() {
        if (this._appRef) throw new L(902, !1);
        this._attachedToViewContainer = !0;
      }
      detachFromAppRef() {
        this._appRef = null, function _P(n, t) {
          uc(n, t, t[11], 2, null, null);
        }(this._lView[1], this._lView);
      }
      attachToAppRef(t) {
        if (this._attachedToViewContainer) throw new L(902, !1);
        this._appRef = t;
      }
    }
    class NA extends fc {
      constructor(t) {
        super(t), this._view = t;
      }
      detectChanges() {
        const t = this._view;
        I1(t[1], t, t[8], !1);
      }
      checkNoChanges() {}
      get context() {
        return null;
      }
    }
    class Bf extends Vi {
      constructor(t) {
        super(), this.ngModule = t;
      }
      resolveComponentFactory(t) {
        const e = Ke(t);
        return new mc(e, this.ngModule);
      }
    }
    function x8(n) {
      const t = [];
      for (let e in n) n.hasOwnProperty(e) && t.push({
        propName: n[e],
        templateName: e
      });
      return t;
    }
    class VA {
      constructor(t, e) {
        this.injector = t, this.parentInjector = e;
      }
      get(t, e, a) {
        const i = this.injector.get(t, qu, a);
        return i !== qu || e === qu ? i : this.parentInjector.get(t, e, a);
      }
    }
    class mc extends tg {
      constructor(t, e) {
        super(), this.componentDef = t, this.ngModule = e, this.componentType = t.type, this.selector = function FP(n) {
          return n.map(NP).join(",");
        }(t.selectors), this.ngContentSelectors = t.ngContentSelectors ? t.ngContentSelectors : [], this.isBoundToModule = !!e;
      }
      get inputs() {
        return x8(this.componentDef.inputs);
      }
      get outputs() {
        return x8(this.componentDef.outputs);
      }
      create(t, e, a, i) {
        let o = (i = i || this.ngModule) instanceof _r ? i : i?.injector;
        o && null !== this.componentDef.getStandaloneInjector && (o = this.componentDef.getStandaloneInjector(o) || o);
        const r = o ? new VA(t, o) : t,
          s = r.get(cc, null);
        if (null === s) throw new L(407, !1);
        const c = r.get(LO, null),
          l = s.createRenderer(null, this.componentDef),
          d = this.componentDef.selectors[0][0] || "div",
          u = a ? function _A(n, t, e) {
            return n.selectRootElement(t, e === fa.ShadowDom);
          }(l, a, this.componentDef.encapsulation) : lf(s.createRenderer(null, this.componentDef), d, function FA(n) {
            const t = n.toLowerCase();
            return "svg" === t ? "svg" : "math" === t ? "math" : null;
          }(d)),
          m = this.componentDef.onPush ? 288 : 272,
          h = Rf(0, null, null, 1, 0, null, null, null, null, null),
          p = S1(null, h, null, m, null, null, s, l, c, r, null);
        let v, C;
        _u(p);
        try {
          const k = function jA(n, t, e, a, i, o) {
            const r = e[1];
            e[22] = n;
            const c = wr(r, 22, 2, "#host", null),
              l = c.mergedAttrs = t.hostAttrs;
            null !== l && (R1(c, l, !0), null !== n && (r1(i, n, l), null !== c.classes && pf(i, n, c.classes), null !== c.styles && Eg(i, n, c.styles)));
            const d = a.createRenderer(n, t),
              u = S1(e, c8(t), null, t.onPush ? 32 : 16, e[22], c, a, d, o || null, null, null);
            return r.firstCreatePass && (d1(Zs(c, e), r, t.type), p8(r, c), g8(c, e.length, 1)), T1(e, u), e[22] = u;
          }(u, this.componentDef, p, s, l);
          if (u) if (a) r1(l, u, ["ng-version", NO.full]);else {
            const {
              attrs: T,
              classes: w
            } = function VP(n) {
              const t = [],
                e = [];
              let a = 1,
                i = 2;
              for (; a < n.length;) {
                let o = n[a];
                if ("string" == typeof o) 2 === i ? "" !== o && t.push(o, n[++a]) : 8 === i && e.push(o);else {
                  if (!ba(i)) break;
                  i = o;
                }
                a++;
              }
              return {
                attrs: t,
                classes: e
              };
            }(this.componentDef.selectors[0]);
            T && r1(l, u, T), w && w.length > 0 && pf(l, u, w.join(" "));
          }
          if (C = uu(h, 22), void 0 !== e) {
            const T = C.projection = [];
            for (let w = 0; w < this.ngContentSelectors.length; w++) {
              const N = e[w];
              T.push(null != N ? Array.from(N) : null);
            }
          }
          v = function UA(n, t, e, a) {
            const i = e[1],
              o = function MA(n, t, e) {
                const a = Rt();
                n.firstCreatePass && (e.providersResolver && e.providersResolver(e), b8(n, a, t, kr(n, t, 1, null), e), u8(n, a));
                const i = Xs(t, n, a.directiveStart, a);
                Jt(i, t);
                const o = qn(a, t);
                return o && Jt(o, t), i;
              }(i, e, t);
            if (n[8] = e[8] = o, null !== a) for (const s of a) s(o, t);
            if (t.contentQueries) {
              const s = Rt();
              t.contentQueries(1, o, s.directiveStart);
            }
            const r = Rt();
            return !i.firstCreatePass || null === t.hostBindings && null === t.hostAttrs || (Ni(r.index), m8(e[1], r, 0, r.directiveStart, r.directiveEnd, t), h8(t, o)), o;
          }(k, this.componentDef, p, [GA]), Ef(h, p, null);
        } finally {
          vu();
        }
        return new BA(this.componentType, v, yr(C, p), p, C);
      }
    }
    class BA extends class SO {} {
      constructor(t, e, a, i, o) {
        super(), this.location = a, this._rootLView = i, this._tNode = o, this.instance = e, this.hostView = this.changeDetectorRef = new NA(i), this.componentType = t;
      }
      setInput(t, e) {
        const a = this._tNode.inputs;
        let i;
        if (null !== a && (i = a[t])) {
          const o = this._rootLView;
          Hf(o[1], o, i, t, e), f8(o, this._tNode.index);
        }
      }
      get injector() {
        return new lr(this._tNode, this._rootLView);
      }
      destroy() {
        this.hostView.destroy();
      }
      onDestroy(t) {
        this.hostView.onDestroy(t);
      }
    }
    function GA() {
      const n = Rt();
      n1(I()[1], n);
    }
    function z(n) {
      let t = function w8(n) {
          return Object.getPrototypeOf(n.prototype).constructor;
        }(n.type),
        e = !0;
      const a = [n];
      for (; t;) {
        let i;
        if (pa(n)) i = t.ɵcmp || t.ɵdir;else {
          if (t.ɵcmp) throw new L(903, !1);
          i = t.ɵdir;
        }
        if (i) {
          if (e) {
            a.push(i);
            const r = n;
            r.inputs = jf(n.inputs), r.declaredInputs = jf(n.declaredInputs), r.outputs = jf(n.outputs);
            const s = i.hostBindings;
            s && KA(n, s);
            const c = i.viewQuery,
              l = i.contentQueries;
            if (c && YA(n, c), l && qA(n, l), Z0(n.inputs, i.inputs), Z0(n.declaredInputs, i.declaredInputs), Z0(n.outputs, i.outputs), pa(i) && i.data.animation) {
              const d = n.data;
              d.animation = (d.animation || []).concat(i.data.animation);
            }
          }
          const o = i.features;
          if (o) for (let r = 0; r < o.length; r++) {
            const s = o[r];
            s && s.ngInherit && s(n), s === z && (e = !1);
          }
        }
        t = Object.getPrototypeOf(t);
      }
      !function WA(n) {
        let t = 0,
          e = null;
        for (let a = n.length - 1; a >= 0; a--) {
          const i = n[a];
          i.hostVars = t += i.hostVars, i.hostAttrs = s1(i.hostAttrs, e = s1(e, i.hostAttrs));
        }
      }(a);
    }
    function jf(n) {
      return n === tr ? {} : n === Ue ? [] : n;
    }
    function YA(n, t) {
      const e = n.viewQuery;
      n.viewQuery = e ? (a, i) => {
        t(a, i), e(a, i);
      } : t;
    }
    function qA(n, t) {
      const e = n.contentQueries;
      n.contentQueries = e ? (a, i, o) => {
        t(a, i, o), e(a, i, o);
      } : t;
    }
    function KA(n, t) {
      const e = n.hostBindings;
      n.hostBindings = e ? (a, i) => {
        t(a, i), e(a, i);
      } : t;
    }
    let L1 = null;
    function yo() {
      if (!L1) {
        const n = Je.Symbol;
        if (n && n.iterator) L1 = n.iterator;else {
          const t = Object.getOwnPropertyNames(Map.prototype);
          for (let e = 0; e < t.length; ++e) {
            const a = t[e];
            "entries" !== a && "size" !== a && Map.prototype[a] === Map.prototype.entries && (L1 = a);
          }
        }
      }
      return L1;
    }
    function hc(n) {
      return !!Uf(n) && (Array.isArray(n) || !(n instanceof Map) && yo() in n);
    }
    function Uf(n) {
      return null !== n && ("function" == typeof n || "object" == typeof n);
    }
    function Va(n, t, e) {
      return n[t] = e;
    }
    function $t(n, t, e) {
      return !Object.is(n[t], e) && (n[t] = e, !0);
    }
    function Co(n, t, e, a) {
      const i = $t(n, t, e);
      return $t(n, t + 1, a) || i;
    }
    function X(n, t, e, a) {
      const i = I();
      return $t(i, rr(), t) && (Ne(), Fa(bt(), i, n, t, e, a)), X;
    }
    function Or(n, t, e, a) {
      return $t(n, rr(), e) ? t + ve(e) + a : ye;
    }
    function Ar(n, t, e, a, i, o, r, s) {
      const l = function N1(n, t, e, a, i) {
        const o = Co(n, t, e, a);
        return $t(n, t + 2, i) || o;
      }(n, ai(), e, i, r);
      return ii(3), l ? t + ve(e) + a + ve(i) + o + ve(r) + s : ye;
    }
    function D(n, t, e, a, i, o, r, s) {
      const c = I(),
        l = Ne(),
        d = n + 22,
        u = l.firstCreatePass ? function nS(n, t, e, a, i, o, r, s, c) {
          const l = t.consts,
            d = wr(t, n, 4, r || null, Li(l, s));
          zf(t, e, d, Li(l, c)), n1(t, d);
          const u = d.tViews = Rf(2, d, a, i, o, t.directiveRegistry, t.pipeRegistry, null, t.schemas, l);
          return null !== t.queries && (t.queries.template(t, d), u.queries = t.queries.embeddedTView(d)), d;
        }(d, l, c, t, e, a, i, o, r) : l.data[d];
      Ra(u, !1);
      const m = c[11].createComment("");
      w1(l, c, m, u), Jt(m, c), T1(c, c[d] = _8(m, c, m, u)), $l(u) && Tf(l, c, u), null != r && If(c, u, s);
    }
    function Kt(n) {
      return or(function Qk() {
        return _e.lFrame.contextLView;
      }(), 22 + n);
    }
    function b(n, t, e) {
      const a = I();
      return $t(a, rr(), t) && In(Ne(), bt(), a, n, t, a[11], e, !1), b;
    }
    function Gf(n, t, e, a, i) {
      const r = i ? "class" : "style";
      Hf(n, e, t.inputs[r], r, a);
    }
    function _(n, t, e, a) {
      const i = I(),
        o = Ne(),
        r = 22 + n,
        s = i[11],
        c = i[r] = lf(s, t, function iD() {
          return _e.lFrame.currentNamespace;
        }()),
        l = o.firstCreatePass ? function iS(n, t, e, a, i, o, r) {
          const s = t.consts,
            l = wr(t, n, 2, i, Li(s, o));
          return zf(t, e, l, Li(s, r)), null !== l.attrs && R1(l, l.attrs, !1), null !== l.mergedAttrs && R1(l, l.mergedAttrs, !0), null !== t.queries && t.queries.elementStart(t, l), l;
        }(r, o, i, 0, t, e, a) : o.data[r];
      Ra(l, !0);
      const d = l.mergedAttrs;
      null !== d && r1(s, c, d);
      const u = l.classes;
      null !== u && pf(s, c, u);
      const m = l.styles;
      return null !== m && Eg(s, c, m), 64 != (64 & l.flags) && w1(o, i, c, l), 0 === function Gk() {
        return _e.lFrame.elementDepthCount;
      }() && Jt(c, i), function Wk() {
        _e.lFrame.elementDepthCount++;
      }(), $l(l) && (Tf(o, i, l), s8(o, l, i)), null !== a && If(i, l), _;
    }
    function y() {
      let n = Rt();
      mu() ? hu() : (n = n.parent, Ra(n, !1));
      const t = n;
      !function Yk() {
        _e.lFrame.elementDepthCount--;
      }();
      const e = Ne();
      return e.firstCreatePass && (n1(e, n), ru(n) && e.queries.elementEnd(n)), null != t.classesWithoutHost && function lD(n) {
        return 0 != (16 & n.flags);
      }(t) && Gf(e, t, I(), t.classesWithoutHost, !0), null != t.stylesWithoutHost && function dD(n) {
        return 0 != (32 & n.flags);
      }(t) && Gf(e, t, I(), t.stylesWithoutHost, !1), y;
    }
    function j(n, t, e, a) {
      return _(n, t, e, a), y(), j;
    }
    function fi(n, t, e) {
      const a = I(),
        i = Ne(),
        o = n + 22,
        r = i.firstCreatePass ? function oS(n, t, e, a, i) {
          const o = t.consts,
            r = Li(o, a),
            s = wr(t, n, 8, "ng-container", r);
          return null !== r && R1(s, r, !0), zf(t, e, s, Li(o, i)), null !== t.queries && t.queries.elementStart(t, s), s;
        }(o, i, a, t, e) : i.data[o];
      Ra(r, !0);
      const s = a[o] = a[11].createComment("");
      return w1(i, a, s, r), Jt(s, a), $l(r) && (Tf(i, a, r), s8(i, r, a)), null != e && If(a, r), fi;
    }
    function mi() {
      let n = Rt();
      const t = Ne();
      return mu() ? hu() : (n = n.parent, Ra(n, !1)), t.firstCreatePass && (n1(t, n), ru(n) && t.queries.elementEnd(n)), mi;
    }
    function Rn(n, t, e) {
      return fi(n, t, e), mi(), Rn;
    }
    function Le() {
      return I();
    }
    function F1(n) {
      return !!n && "function" == typeof n.then;
    }
    function R8(n) {
      return !!n && "function" == typeof n.subscribe;
    }
    const z8 = R8;
    function F(n, t, e, a) {
      const i = I(),
        o = Ne(),
        r = Rt();
      return L8(o, i, i[11], r, n, t, 0, a), F;
    }
    function V1(n, t) {
      const e = Rt(),
        a = I(),
        i = Ne();
      return L8(i, a, C8(gu(i.data), e, a), e, n, t), V1;
    }
    function L8(n, t, e, a, i, o, r, s) {
      const c = $l(a),
        d = n.firstCreatePass && y8(n),
        u = t[8],
        m = v8(t);
      let h = !0;
      if (3 & a.type || s) {
        const C = qn(a, t),
          k = s ? s(C) : C,
          T = m.length,
          w = s ? le => s(kt(le[a.index])) : a.index;
        let N = null;
        if (!s && c && (N = function rS(n, t, e, a) {
          const i = n.cleanup;
          if (null != i) for (let o = 0; o < i.length - 1; o += 2) {
            const r = i[o];
            if (r === e && i[o + 1] === a) {
              const s = t[7],
                c = i[o + 2];
              return s.length > c ? s[c] : null;
            }
            "string" == typeof r && (o += 2);
          }
          return null;
        }(n, t, i, a.index)), null !== N) (N.__ngLastListenerFn__ || N).__ngNextListenerFn__ = o, N.__ngLastListenerFn__ = o, h = !1;else {
          o = F8(a, t, u, o, !1);
          const le = e.listen(k, i, o);
          m.push(o, le), d && d.push(i, w, T, T + 1);
        }
      } else o = F8(a, t, u, o, !1);
      const p = a.outputs;
      let v;
      if (h && null !== p && (v = p[i])) {
        const C = v.length;
        if (C) for (let k = 0; k < C; k += 2) {
          const Ce = t[v[k]][v[k + 1]].subscribe(o),
            rt = m.length;
          m.push(o, Ce), d && d.push(i, a.index, rt, -(rt + 1));
        }
      }
    }
    function N8(n, t, e, a) {
      try {
        return !1 !== e(a);
      } catch (i) {
        return M8(n, i), !1;
      }
    }
    function F8(n, t, e, a, i) {
      return function o(r) {
        if (r === Function) return a;
        Ff(2 & n.flags ? Pn(n.index, t) : t);
        let c = N8(t, 0, a, r),
          l = o.__ngNextListenerFn__;
        for (; l;) c = N8(t, 0, l, r) && c, l = l.__ngNextListenerFn__;
        return i && !1 === c && (r.preventDefault(), r.returnValue = !1), c;
      };
    }
    function x(n = 1) {
      return function eD(n) {
        return (_e.lFrame.contextLView = function tD(n, t) {
          for (; n > 0;) t = t[15], n--;
          return t;
        }(n, _e.lFrame.contextLView))[8];
      }(n);
    }
    function sS(n, t) {
      let e = null;
      const a = function IP(n) {
        const t = n.attrs;
        if (null != t) {
          const e = t.indexOf(5);
          if (0 == (1 & e)) return t[e + 1];
        }
        return null;
      }(n);
      for (let i = 0; i < t.length; i++) {
        const o = t[i];
        if ("*" !== o) {
          if (null === a ? zg(n, o, !0) : LP(a, o)) return i;
        } else e = i;
      }
      return e;
    }
    function lt(n) {
      const t = I()[16][6];
      if (!t.projection) {
        const a = t.projection = ec(n ? n.length : 1, null),
          i = a.slice();
        let o = t.child;
        for (; null !== o;) {
          const r = n ? sS(o, n) : 0;
          null !== r && (i[r] ? i[r].projectionNext = o : a[r] = o, i[r] = o), o = o.next;
        }
      }
    }
    function Me(n, t = 0, e) {
      const a = I(),
        i = Ne(),
        o = wr(i, 22 + n, 16, null, e || null);
      null === o.projection && (o.projection = t), hu(), 64 != (64 & o.flags) && function DP(n, t, e) {
        Sg(t[11], 0, t, e, yg(n, e, t), wg(e.parent || t[6], e, t));
      }(i, a, o);
    }
    function zn(n, t, e) {
      return Wf(n, "", t, "", e), zn;
    }
    function Wf(n, t, e, a, i) {
      const o = I(),
        r = Or(o, t, e, a);
      return r !== ye && In(Ne(), bt(), o, n, r, o[11], i, !1), Wf;
    }
    function q8(n, t, e, a, i) {
      const o = n[e + 1],
        r = null === t;
      let s = a ? _a(o) : di(o),
        c = !1;
      for (; 0 !== s && (!1 === c || r);) {
        const d = n[s + 1];
        dS(n[s], t) && (c = !0, n[s + 1] = a ? Mf(d) : yf(d)), s = a ? _a(d) : di(d);
      }
      c && (n[e + 1] = a ? yf(o) : Mf(o));
    }
    function dS(n, t) {
      return null === n || null == t || (Array.isArray(n) ? n[1] : n) === t || !(!Array.isArray(n) || "string" != typeof t) && hr(n, t) >= 0;
    }
    const Nt = {
      textEnd: 0,
      key: 0,
      keyEnd: 0,
      value: 0,
      valueEnd: 0
    };
    function K8(n) {
      return n.substring(Nt.key, Nt.keyEnd);
    }
    function Q8(n, t) {
      const e = Nt.textEnd;
      return e === t ? -1 : (t = Nt.keyEnd = function hS(n, t, e) {
        for (; t < e && n.charCodeAt(t) > 32;) t++;
        return t;
      }(n, Nt.key = t, e), zr(n, t, e));
    }
    function zr(n, t, e) {
      for (; t < e && n.charCodeAt(t) <= 32;) t++;
      return t;
    }
    function en(n, t, e) {
      return va(n, t, e, !1), en;
    }
    function fe(n, t) {
      return va(n, t, null, !0), fe;
    }
    function Ba(n, t) {
      for (let e = function fS(n) {
        return function X8(n) {
          Nt.key = 0, Nt.keyEnd = 0, Nt.value = 0, Nt.valueEnd = 0, Nt.textEnd = n.length;
        }(n), Q8(n, zr(n, 0, Nt.textEnd));
      }(t); e >= 0; e = Q8(t, e)) Sn(n, K8(t), !0);
    }
    function va(n, t, e, a) {
      const i = I(),
        o = Ne(),
        r = ii(2);
      o.firstUpdatePass && t5(o, n, r, a), t !== ye && $t(i, r, t) && a5(o, o.data[ln()], i, i[11], n, i[r + 1] = function kS(n, t) {
        return null == n || ("string" == typeof t ? n += t : "object" == typeof n && (n = Xe(Tn(n)))), n;
      }(t, e), a, r);
    }
    function e5(n, t) {
      return t >= n.expandoStartIndex;
    }
    function t5(n, t, e, a) {
      const i = n.data;
      if (null === i[e + 1]) {
        const o = i[ln()],
          r = e5(n, e);
        r5(o, a) && null === t && !r && (t = !1), t = function vS(n, t, e, a) {
          const i = gu(n);
          let o = a ? t.residualClasses : t.residualStyles;
          if (null === i) 0 === (a ? t.classBindings : t.styleBindings) && (e = gc(e = Yf(null, n, t, e, a), t.attrs, a), o = null);else {
            const r = t.directiveStylingLast;
            if (-1 === r || n[r] !== i) if (e = Yf(i, n, t, e, a), null === o) {
              let c = function yS(n, t, e) {
                const a = e ? t.classBindings : t.styleBindings;
                if (0 !== di(a)) return n[_a(a)];
              }(n, t, a);
              void 0 !== c && Array.isArray(c) && (c = Yf(null, n, t, c[1], a), c = gc(c, t.attrs, a), function CS(n, t, e, a) {
                n[_a(e ? t.classBindings : t.styleBindings)] = a;
              }(n, t, a, c));
            } else o = function MS(n, t, e) {
              let a;
              const i = t.directiveEnd;
              for (let o = 1 + t.directiveStylingLast; o < i; o++) a = gc(a, n[o].hostAttrs, e);
              return gc(a, t.attrs, e);
            }(n, t, a);
          }
          return void 0 !== o && (a ? t.residualClasses = o : t.residualStyles = o), e;
        }(i, o, t, a), function cS(n, t, e, a, i, o) {
          let r = o ? t.classBindings : t.styleBindings,
            s = _a(r),
            c = di(r);
          n[a] = e;
          let d,
            l = !1;
          if (Array.isArray(e)) {
            const u = e;
            d = u[1], (null === d || hr(u, d) > 0) && (l = !0);
          } else d = e;
          if (i) {
            if (0 !== c) {
              const m = _a(n[s + 1]);
              n[a + 1] = O1(m, s), 0 !== m && (n[m + 1] = Cf(n[m + 1], a)), n[s + 1] = function iA(n, t) {
                return 131071 & n | t << 17;
              }(n[s + 1], a);
            } else n[a + 1] = O1(s, 0), 0 !== s && (n[s + 1] = Cf(n[s + 1], a)), s = a;
          } else n[a + 1] = O1(c, 0), 0 === s ? s = a : n[c + 1] = Cf(n[c + 1], a), c = a;
          l && (n[a + 1] = yf(n[a + 1])), q8(n, d, a, !0), q8(n, d, a, !1), function lS(n, t, e, a, i) {
            const o = i ? n.residualClasses : n.residualStyles;
            null != o && "string" == typeof t && hr(o, t) >= 0 && (e[a + 1] = Mf(e[a + 1]));
          }(t, d, n, a, o), r = O1(s, c), o ? t.classBindings = r : t.styleBindings = r;
        }(i, o, t, e, r, a);
      }
    }
    function Yf(n, t, e, a, i) {
      let o = null;
      const r = e.directiveEnd;
      let s = e.directiveStylingLast;
      for (-1 === s ? s = e.directiveStart : s++; s < r && (o = t[s], a = gc(a, o.hostAttrs, i), o !== n);) s++;
      return null !== n && (e.directiveStylingLast = s), a;
    }
    function gc(n, t, e) {
      const a = e ? 1 : 2;
      let i = -1;
      if (null !== t) for (let o = 0; o < t.length; o++) {
        const r = t[o];
        "number" == typeof r ? i = r : i === a && (Array.isArray(n) || (n = void 0 === n ? [] : ["", n]), Sn(n, r, !!e || t[++o]));
      }
      return void 0 === n ? null : n;
    }
    function a5(n, t, e, a, i, o, r, s) {
      if (!(3 & t.type)) return;
      const c = n.data,
        l = c[s + 1];
      H1(function Xg(n) {
        return 1 == (1 & n);
      }(l) ? o5(c, t, e, i, di(l), r) : void 0) || (H1(o) || function Zg(n) {
        return 2 == (2 & n);
      }(l) && (o = o5(c, null, e, i, s, r)), function PP(n, t, e, a, i) {
        if (t) i ? n.addClass(e, a) : n.removeClass(e, a);else {
          let o = -1 === a.indexOf("-") ? void 0 : vn.DashCase;
          null == i ? n.removeStyle(e, a, o) : ("string" == typeof i && i.endsWith("!important") && (i = i.slice(0, -10), o |= vn.Important), n.setStyle(e, a, i, o));
        }
      }(a, r, e1(ln(), e), i, o));
    }
    function o5(n, t, e, a, i, o) {
      const r = null === t;
      let s;
      for (; i > 0;) {
        const c = n[i],
          l = Array.isArray(c),
          d = l ? c[1] : c,
          u = null === d;
        let m = e[i + 1];
        m === ye && (m = u ? Ue : void 0);
        let h = u ? Pu(m, a) : d === a ? m : void 0;
        if (l && !H1(h) && (h = Pu(c, a)), H1(h) && (s = h, r)) return s;
        const p = n[i + 1];
        i = r ? _a(p) : di(p);
      }
      if (null !== t) {
        let c = o ? t.residualClasses : t.residualStyles;
        null != c && (s = Pu(c, a));
      }
      return s;
    }
    function H1(n) {
      return void 0 !== n;
    }
    function r5(n, t) {
      return 0 != (n.flags & (t ? 16 : 32));
    }
    function S(n, t = "") {
      const e = I(),
        a = Ne(),
        i = n + 22,
        o = a.firstCreatePass ? wr(a, i, 1, t, null) : a.data[i],
        r = e[i] = function cf(n, t) {
          return n.createText(t);
        }(e[11], t);
      w1(a, e, r, o), Ra(o, !1);
    }
    function Ie(n) {
      return Fe("", n, ""), Ie;
    }
    function Fe(n, t, e) {
      const a = I(),
        i = Or(a, n, t, e);
      return i !== ye && ui(a, ln(), i), Fe;
    }
    function qf(n, t, e, a, i) {
      const o = I(),
        r = function Pr(n, t, e, a, i, o) {
          const s = Co(n, ai(), e, i);
          return ii(2), s ? t + ve(e) + a + ve(i) + o : ye;
        }(o, n, t, e, a, i);
      return r !== ye && ui(o, ln(), r), qf;
    }
    function Kf(n, t, e, a, i, o, r) {
      const s = I(),
        c = Ar(s, n, t, e, a, i, o, r);
      return c !== ye && ui(s, ln(), c), Kf;
    }
    function m5(n, t, e) {
      !function ya(n, t, e, a) {
        const i = Ne(),
          o = ii(2);
        i.firstUpdatePass && t5(i, null, o, a);
        const r = I();
        if (e !== ye && $t(r, o, e)) {
          const s = i.data[ln()];
          if (r5(s, a) && !e5(i, o)) {
            let c = a ? s.classesWithoutHost : s.stylesWithoutHost;
            null !== c && (e = X0(c, e || "")), Gf(i, s, r, e, a);
          } else !function wS(n, t, e, a, i, o, r, s) {
            i === ye && (i = Ue);
            let c = 0,
              l = 0,
              d = 0 < i.length ? i[0] : null,
              u = 0 < o.length ? o[0] : null;
            for (; null !== d || null !== u;) {
              const m = c < i.length ? i[c + 1] : void 0,
                h = l < o.length ? o[l + 1] : void 0;
              let v,
                p = null;
              d === u ? (c += 2, l += 2, m !== h && (p = u, v = h)) : null === u || null !== d && d < u ? (c += 2, p = d) : (l += 2, p = u, v = h), null !== p && a5(n, t, e, a, p, v, r, s), d = c < i.length ? i[c] : null, u = l < o.length ? o[l] : null;
            }
          }(i, s, r, r[11], r[o + 1], r[o + 1] = function xS(n, t, e) {
            if (null == e || "" === e) return Ue;
            const a = [],
              i = Tn(e);
            if (Array.isArray(i)) for (let o = 0; o < i.length; o++) n(a, i[o], !0);else if ("object" == typeof i) for (const o in i) i.hasOwnProperty(o) && n(a, o, i[o]);else "string" == typeof i && t(a, i);
            return a;
          }(n, t, e), a, o);
        }
      }(Sn, Ba, Or(I(), n, t, e), !0);
    }
    function Zn(n, t, e) {
      const a = I();
      return $t(a, rr(), t) && In(Ne(), bt(), a, n, t, a[11], e, !0), Zn;
    }
    function B1(n, t, e) {
      const a = I();
      if ($t(a, rr(), t)) {
        const o = Ne(),
          r = bt();
        In(o, r, a, n, t, C8(gu(o.data), r, a), e, !0);
      }
      return B1;
    }
    const Nr = "en-US";
    let k5 = Nr;
    function Xf(n, t, e, a, i) {
      if (n = ue(n), Array.isArray(n)) for (let o = 0; o < n.length; o++) Xf(n[o], t, e, a, i);else {
        const o = Ne(),
          r = I();
        let s = bo(n) ? n : ue(n.provide),
          c = eg(n);
        const l = Rt(),
          d = 1048575 & l.providerIndexes,
          u = l.directiveStart,
          m = l.providerIndexes >> 20;
        if (bo(n) || !n.multi) {
          const h = new Ks(c, i, f),
            p = $f(s, t, i ? d : d + m, u);
          -1 === p ? (d1(Zs(l, r), o, s), Jf(o, n, t.length), t.push(s), l.directiveStart++, l.directiveEnd++, i && (l.providerIndexes += 1048576), e.push(h), r.push(h)) : (e[p] = h, r[p] = h);
        } else {
          const h = $f(s, t, d + m, u),
            p = $f(s, t, d, d + m),
            v = h >= 0 && e[h],
            C = p >= 0 && e[p];
          if (i && !C || !i && !v) {
            d1(Zs(l, r), o, s);
            const k = function jE(n, t, e, a, i) {
              const o = new Ks(n, e, f);
              return o.multi = [], o.index = t, o.componentProviders = 0, Z5(o, i, a && !e), o;
            }(i ? BE : HE, e.length, i, a, c);
            !i && C && (e[p].providerFactory = k), Jf(o, n, t.length, 0), t.push(s), l.directiveStart++, l.directiveEnd++, i && (l.providerIndexes += 1048576), e.push(k), r.push(k);
          } else Jf(o, n, h > -1 ? h : p, Z5(e[i ? p : h], c, !i && a));
          !i && a && C && e[p].componentProviders++;
        }
      }
    }
    function Jf(n, t, e, a) {
      const i = bo(t),
        o = function MO(n) {
          return !!n.useClass;
        }(t);
      if (i || o) {
        const c = (o ? ue(t.useClass) : t).prototype.ngOnDestroy;
        if (c) {
          const l = n.destroyHooks || (n.destroyHooks = []);
          if (!i && t.multi) {
            const d = l.indexOf(e);
            -1 === d ? l.push(e, [a, c]) : l[d + 1].push(a, c);
          } else l.push(e, c);
        }
      }
    }
    function Z5(n, t, e) {
      return e && n.componentProviders++, n.multi.push(t) - 1;
    }
    function $f(n, t, e, a) {
      for (let i = e; i < a; i++) if (t[i] === n) return i;
      return -1;
    }
    function HE(n, t, e, a) {
      return em(this.multi, []);
    }
    function BE(n, t, e, a) {
      const i = this.multi;
      let o;
      if (this.providerFactory) {
        const r = this.providerFactory.componentProviders,
          s = Xs(e, e[1], this.providerFactory.index, a);
        o = s.slice(0, r), em(i, o);
        for (let c = r; c < s.length; c++) o.push(s[c]);
      } else o = [], em(i, o);
      return o;
    }
    function em(n, t) {
      for (let e = 0; e < n.length; e++) t.push((0, n[e])());
      return t;
    }
    function G(n, t = []) {
      return e => {
        e.providersResolver = (a, i) => function VE(n, t, e) {
          const a = Ne();
          if (a.firstCreatePass) {
            const i = pa(n);
            Xf(e, a.data, a.blueprint, i, !0), Xf(t, a.data, a.blueprint, i, !1);
          }
        }(a, i ? i(n) : n, t);
      };
    }
    class Fr {}
    class X5 extends Fr {
      constructor(t, e) {
        super(), this._parent = e, this._bootstrapComponents = [], this.destroyCbs = [], this.componentFactoryResolver = new Bf(this);
        const a = function Dn(n, t) {
          const e = n[L3] || null;
          if (!e && !0 === t) throw new Error(`Type ${Xe(n)} does not have '\u0275mod' property.`);
          return e;
        }(t);
        this._bootstrapComponents = function ci(n) {
          return n instanceof Function ? n() : n;
        }(a.bootstrap), this._r3Injector = jg(t, e, [{
          provide: Fr,
          useValue: this
        }, {
          provide: Vi,
          useValue: this.componentFactoryResolver
        }], Xe(t), new Set(["environment"])), this._r3Injector.resolveInjectorInitializers(), this.instance = this._r3Injector.get(t);
      }
      get injector() {
        return this._r3Injector;
      }
      destroy() {
        const t = this._r3Injector;
        !t.destroyed && t.destroy(), this.destroyCbs.forEach(e => e()), this.destroyCbs = null;
      }
      onDestroy(t) {
        this.destroyCbs.push(t);
      }
    }
    class tm extends class UE {} {
      constructor(t) {
        super(), this.moduleType = t;
      }
      create(t) {
        return new X5(this.moduleType, t);
      }
    }
    function Vr(n, t, e, a) {
      return rb(I(), cn(), n, t, e, a);
    }
    function ob(n, t, e, a, i) {
      return function sb(n, t, e, a, i, o, r) {
        const s = t + e;
        return Co(n, s, i, o) ? Va(n, s + 2, r ? a.call(r, i, o) : a(i, o)) : Mc(n, s + 2);
      }(I(), cn(), n, t, e, a, i);
    }
    function Mc(n, t) {
      const e = n[t];
      return e === ye ? void 0 : e;
    }
    function rb(n, t, e, a, i, o) {
      const r = t + e;
      return $t(n, r, i) ? Va(n, r + 1, o ? a.call(o, i) : a(i)) : Mc(n, r + 1);
    }
    function Dt(n, t) {
      const e = Ne();
      let a;
      const i = n + 22;
      e.firstCreatePass ? (a = function dT(n, t) {
        if (t) for (let e = t.length - 1; e >= 0; e--) {
          const a = t[e];
          if (n === a.name) return a;
        }
      }(t, e.pipeRegistry), e.data[i] = a, a.onDestroy && (e.destroyHooks || (e.destroyHooks = [])).push(i, a.onDestroy)) : a = e.data[i];
      const o = a.factory || (a.factory = po(a.type)),
        r = Gn(f);
      try {
        const s = c1(!1),
          c = o();
        return c1(s), function aS(n, t, e, a) {
          e >= n.data.length && (n.data[e] = null, n.blueprint[e] = null), t[e] = a;
        }(e, I(), i, c), c;
      } finally {
        Gn(r);
      }
    }
    function Ot(n, t, e) {
      const a = n + 22,
        i = I(),
        o = or(i, a);
      return function xc(n, t) {
        return n[1].data[t].pure;
      }(i, a) ? rb(i, cn(), t, o.transform, e, o) : o.transform(e);
    }
    function am(n) {
      return t => {
        setTimeout(n, void 0, t);
      };
    }
    const E = class pT extends V {
      constructor(t = !1) {
        super(), this.__isAsync = t;
      }
      emit(t) {
        super.next(t);
      }
      subscribe(t, e, a) {
        let i = t,
          o = e || (() => null),
          r = a;
        if (t && "object" == typeof t) {
          const c = t;
          i = c.next?.bind(c), o = c.error?.bind(c), r = c.complete?.bind(c);
        }
        this.__isAsync && (o = am(o), i && (i = am(i)), r && (r = am(r)));
        const s = super.subscribe({
          next: i,
          error: o,
          complete: r
        });
        return t instanceof re && t.add(s), s;
      }
    };
    function gT() {
      return this._results[yo()]();
    }
    class Hr {
      constructor(t = !1) {
        this._emitDistinctChangesOnly = t, this.dirty = !0, this._results = [], this._changesDetected = !1, this._changes = null, this.length = 0, this.first = void 0, this.last = void 0;
        const e = yo(),
          a = Hr.prototype;
        a[e] || (a[e] = gT);
      }
      get changes() {
        return this._changes || (this._changes = new E());
      }
      get(t) {
        return this._results[t];
      }
      map(t) {
        return this._results.map(t);
      }
      filter(t) {
        return this._results.filter(t);
      }
      find(t) {
        return this._results.find(t);
      }
      reduce(t, e) {
        return this._results.reduce(t, e);
      }
      forEach(t) {
        this._results.forEach(t);
      }
      some(t) {
        return this._results.some(t);
      }
      toArray() {
        return this._results.slice();
      }
      toString() {
        return this._results.toString();
      }
      reset(t, e) {
        const a = this;
        a.dirty = !1;
        const i = An(t);
        (this._changesDetected = !function yD(n, t, e) {
          if (n.length !== t.length) return !1;
          for (let a = 0; a < n.length; a++) {
            let i = n[a],
              o = t[a];
            if (e && (i = e(i), o = e(o)), o !== i) return !1;
          }
          return !0;
        }(a._results, i, e)) && (a._results = i, a.length = i.length, a.last = i[this.length - 1], a.first = i[0]);
      }
      notifyOnChanges() {
        this._changes && (this._changesDetected || !this._emitDistinctChangesOnly) && this._changes.emit(this);
      }
      setDirty() {
        this.dirty = !0;
      }
      destroy() {
        this.changes.complete(), this.changes.unsubscribe();
      }
    }
    let vt = (() => {
      class n {}
      return n.__NG_ELEMENT_ID__ = vT, n;
    })();
    const bT = vt,
      _T = class extends bT {
        constructor(t, e, a) {
          super(), this._declarationLView = t, this._declarationTContainer = e, this.elementRef = a;
        }
        createEmbeddedView(t, e) {
          const a = this._declarationTContainer.tViews,
            i = S1(this._declarationLView, a, t, 16, null, a.declTNode, null, null, null, null, e || null);
          i[17] = this._declarationLView[this._declarationTContainer.index];
          const r = this._declarationLView[19];
          return null !== r && (i[19] = r.createEmbeddedView(a)), Ef(a, i, t), new fc(i);
        }
      };
    function vT() {
      return Y1(Rt(), I());
    }
    function Y1(n, t) {
      return 4 & n.type ? new _T(t, n, yr(n, t)) : null;
    }
    let ut = (() => {
      class n {}
      return n.__NG_ELEMENT_ID__ = yT, n;
    })();
    function yT() {
      return mb(Rt(), I());
    }
    const CT = ut,
      ub = class extends CT {
        constructor(t, e, a) {
          super(), this._lContainer = t, this._hostTNode = e, this._hostLView = a;
        }
        get element() {
          return yr(this._hostTNode, this._hostLView);
        }
        get injector() {
          return new lr(this._hostTNode, this._hostLView);
        }
        get parentInjector() {
          const t = l1(this._hostTNode, this._hostLView);
          if (l6(t)) {
            const e = cr(t, this._hostLView),
              a = sr(t);
            return new lr(e[1].data[a + 8], e);
          }
          return new lr(null, this._hostLView);
        }
        clear() {
          for (; this.length > 0;) this.remove(this.length - 1);
        }
        get(t) {
          const e = fb(this._lContainer);
          return null !== e && e[t] || null;
        }
        get length() {
          return this._lContainer.length - 10;
        }
        createEmbeddedView(t, e, a) {
          let i, o;
          "number" == typeof a ? i = a : null != a && (i = a.index, o = a.injector);
          const r = t.createEmbeddedView(e || {}, o);
          return this.insert(r, i), r;
        }
        createComponent(t, e, a, i, o) {
          const r = t && !function $s(n) {
            return "function" == typeof n;
          }(t);
          let s;
          if (r) s = e;else {
            const u = e || {};
            s = u.index, a = u.injector, i = u.projectableNodes, o = u.environmentInjector || u.ngModuleRef;
          }
          const c = r ? t : new mc(Ke(t)),
            l = a || this.parentInjector;
          if (!o && null == c.ngModule) {
            const m = (r ? l : this.parentInjector).get(_r, null);
            m && (o = m);
          }
          const d = c.create(l, i, void 0, o);
          return this.insert(d.hostView, s), d;
        }
        insert(t, e) {
          const a = t._lView,
            i = a[1];
          if (function Uk(n) {
            return ha(n[3]);
          }(a)) {
            const d = this.indexOf(t);
            if (-1 !== d) this.detach(d);else {
              const u = a[3],
                m = new ub(u, u[6], u[3]);
              m.detach(m.indexOf(t));
            }
          }
          const o = this._adjustIndex(e),
            r = this._lContainer;
          !function yP(n, t, e, a) {
            const i = 10 + a,
              o = e.length;
            a > 0 && (e[i - 1][4] = t), a < o - 10 ? (t[4] = e[i], y6(e, 10 + a, t)) : (e.push(t), t[4] = null), t[3] = e;
            const r = t[17];
            null !== r && e !== r && function CP(n, t) {
              const e = n[9];
              t[16] !== t[3][3][16] && (n[2] = !0), null === e ? n[9] = [t] : e.push(t);
            }(r, t);
            const s = t[19];
            null !== s && s.insertView(n), t[2] |= 64;
          }(i, a, r, o);
          const s = mf(o, r),
            c = a[11],
            l = x1(c, r[7]);
          return null !== l && function bP(n, t, e, a, i, o) {
            a[0] = i, a[6] = t, uc(n, a, e, 1, i, o);
          }(i, r[6], c, a, l, s), t.attachToViewContainerRef(), y6(im(r), o, t), t;
        }
        move(t, e) {
          return this.insert(t, e);
        }
        indexOf(t) {
          const e = fb(this._lContainer);
          return null !== e ? e.indexOf(t) : -1;
        }
        remove(t) {
          const e = this._adjustIndex(t, -1),
            a = df(this._lContainer, e);
          a && (f1(im(this._lContainer), e), vg(a[1], a));
        }
        detach(t) {
          const e = this._adjustIndex(t, -1),
            a = df(this._lContainer, e);
          return a && null != f1(im(this._lContainer), e) ? new fc(a) : null;
        }
        _adjustIndex(t, e = 0) {
          return t ?? this.length + e;
        }
      };
    function fb(n) {
      return n[8];
    }
    function im(n) {
      return n[8] || (n[8] = []);
    }
    function mb(n, t) {
      let e;
      const a = t[n.index];
      if (ha(a)) e = a;else {
        let i;
        if (8 & n.type) i = kt(a);else {
          const o = t[11];
          i = o.createComment("");
          const r = qn(n, t);
          vo(o, x1(o, r), i, function kP(n, t) {
            return n.nextSibling(t);
          }(o, r), !1);
        }
        t[n.index] = e = _8(a, t, i, n), T1(t, e);
      }
      return new ub(e, n, t);
    }
    class om {
      constructor(t) {
        this.queryList = t, this.matches = null;
      }
      clone() {
        return new om(this.queryList);
      }
      setDirty() {
        this.queryList.setDirty();
      }
    }
    class rm {
      constructor(t = []) {
        this.queries = t;
      }
      createEmbeddedView(t) {
        const e = t.queries;
        if (null !== e) {
          const a = null !== t.contentQueries ? t.contentQueries[0] : e.length,
            i = [];
          for (let o = 0; o < a; o++) {
            const r = e.getByIndex(o);
            i.push(this.queries[r.indexInDeclarationView].clone());
          }
          return new rm(i);
        }
        return null;
      }
      insertView(t) {
        this.dirtyQueriesWithMatches(t);
      }
      detachView(t) {
        this.dirtyQueriesWithMatches(t);
      }
      dirtyQueriesWithMatches(t) {
        for (let e = 0; e < this.queries.length; e++) null !== _b(t, e).matches && this.queries[e].setDirty();
      }
    }
    class hb {
      constructor(t, e, a = null) {
        this.predicate = t, this.flags = e, this.read = a;
      }
    }
    class sm {
      constructor(t = []) {
        this.queries = t;
      }
      elementStart(t, e) {
        for (let a = 0; a < this.queries.length; a++) this.queries[a].elementStart(t, e);
      }
      elementEnd(t) {
        for (let e = 0; e < this.queries.length; e++) this.queries[e].elementEnd(t);
      }
      embeddedTView(t) {
        let e = null;
        for (let a = 0; a < this.length; a++) {
          const i = null !== e ? e.length : 0,
            o = this.getByIndex(a).embeddedTView(t, i);
          o && (o.indexInDeclarationView = a, null !== e ? e.push(o) : e = [o]);
        }
        return null !== e ? new sm(e) : null;
      }
      template(t, e) {
        for (let a = 0; a < this.queries.length; a++) this.queries[a].template(t, e);
      }
      getByIndex(t) {
        return this.queries[t];
      }
      get length() {
        return this.queries.length;
      }
      track(t) {
        this.queries.push(t);
      }
    }
    class cm {
      constructor(t, e = -1) {
        this.metadata = t, this.matches = null, this.indexInDeclarationView = -1, this.crossesNgTemplate = !1, this._appliesToNextNode = !0, this._declarationNodeIndex = e;
      }
      elementStart(t, e) {
        this.isApplyingToNode(e) && this.matchTNode(t, e);
      }
      elementEnd(t) {
        this._declarationNodeIndex === t.index && (this._appliesToNextNode = !1);
      }
      template(t, e) {
        this.elementStart(t, e);
      }
      embeddedTView(t, e) {
        return this.isApplyingToNode(t) ? (this.crossesNgTemplate = !0, this.addMatch(-t.index, e), new cm(this.metadata)) : null;
      }
      isApplyingToNode(t) {
        if (this._appliesToNextNode && 1 != (1 & this.metadata.flags)) {
          const e = this._declarationNodeIndex;
          let a = t.parent;
          for (; null !== a && 8 & a.type && a.index !== e;) a = a.parent;
          return e === (null !== a ? a.index : -1);
        }
        return this._appliesToNextNode;
      }
      matchTNode(t, e) {
        const a = this.metadata.predicate;
        if (Array.isArray(a)) for (let i = 0; i < a.length; i++) {
          const o = a[i];
          this.matchTNodeWithReadOption(t, e, wT(e, o)), this.matchTNodeWithReadOption(t, e, u1(e, t, o, !1, !1));
        } else a === vt ? 4 & e.type && this.matchTNodeWithReadOption(t, e, -1) : this.matchTNodeWithReadOption(t, e, u1(e, t, a, !1, !1));
      }
      matchTNodeWithReadOption(t, e, a) {
        if (null !== a) {
          const i = this.metadata.read;
          if (null !== i) {
            if (i === J || i === ut || i === vt && 4 & e.type) this.addMatch(e.index, -2);else {
              const o = u1(e, t, i, !1, !1);
              null !== o && this.addMatch(e.index, o);
            }
          } else this.addMatch(e.index, a);
        }
      }
      addMatch(t, e) {
        null === this.matches ? this.matches = [t, e] : this.matches.push(t, e);
      }
    }
    function wT(n, t) {
      const e = n.localNames;
      if (null !== e) for (let a = 0; a < e.length; a += 2) if (e[a] === t) return e[a + 1];
      return null;
    }
    function DT(n, t, e, a) {
      return -1 === e ? function kT(n, t) {
        return 11 & n.type ? yr(n, t) : 4 & n.type ? Y1(n, t) : null;
      }(t, n) : -2 === e ? function OT(n, t, e) {
        return e === J ? yr(t, n) : e === vt ? Y1(t, n) : e === ut ? mb(t, n) : void 0;
      }(n, t, a) : Xs(n, n[1], e, t);
    }
    function pb(n, t, e, a) {
      const i = t[19].queries[a];
      if (null === i.matches) {
        const o = n.data,
          r = e.matches,
          s = [];
        for (let c = 0; c < r.length; c += 2) {
          const l = r[c];
          s.push(l < 0 ? null : DT(t, o[l], r[c + 1], e.metadata.read));
        }
        i.matches = s;
      }
      return i.matches;
    }
    function lm(n, t, e, a) {
      const i = n.queries.getByIndex(e),
        o = i.matches;
      if (null !== o) {
        const r = pb(n, t, i, e);
        for (let s = 0; s < o.length; s += 2) {
          const c = o[s];
          if (c > 0) a.push(r[s / 2]);else {
            const l = o[s + 1],
              d = t[-c];
            for (let u = 10; u < d.length; u++) {
              const m = d[u];
              m[17] === m[3] && lm(m[1], m, l, a);
            }
            if (null !== d[9]) {
              const u = d[9];
              for (let m = 0; m < u.length; m++) {
                const h = u[m];
                lm(h[1], h, l, a);
              }
            }
          }
        }
      }
      return a;
    }
    function H(n) {
      const t = I(),
        e = Ne(),
        a = $3();
      bu(a + 1);
      const i = _b(e, a);
      if (n.dirty && function jk(n) {
        return 4 == (4 & n[2]);
      }(t) === (2 == (2 & i.metadata.flags))) {
        if (null === i.matches) n.reset([]);else {
          const o = i.crossesNgTemplate ? lm(e, t, a, []) : pb(e, t, i, a);
          n.reset(o, RO), n.notifyOnChanges();
        }
        return !0;
      }
      return !1;
    }
    function be(n, t, e) {
      const a = Ne();
      a.firstCreatePass && (bb(a, new hb(n, t, e), -1), 2 == (2 & t) && (a.staticViewQueries = !0)), gb(a, I(), t);
    }
    function De(n, t, e, a) {
      const i = Ne();
      if (i.firstCreatePass) {
        const o = Rt();
        bb(i, new hb(t, e, a), o.index), function AT(n, t) {
          const e = n.contentQueries || (n.contentQueries = []);
          t !== (e.length ? e[e.length - 1] : -1) && e.push(n.queries.length - 1, t);
        }(i, n), 2 == (2 & e) && (i.staticContentQueries = !0);
      }
      gb(i, I(), e);
    }
    function B() {
      return function PT(n, t) {
        return n[19].queries[t].queryList;
      }(I(), $3());
    }
    function gb(n, t, e) {
      const a = new Hr(4 == (4 & e));
      l8(n, t, a, a.destroy), null === t[19] && (t[19] = new rm()), t[19].queries.push(new om(a));
    }
    function bb(n, t, e) {
      null === n.queries && (n.queries = new sm()), n.queries.track(new cm(t, e));
    }
    function _b(n, t) {
      return n.queries.getByIndex(t);
    }
    function q1(n, t) {
      return Y1(n, t);
    }
    function Q1(...n) {}
    const Nb = new O("Application Initializer");
    let Z1 = (() => {
      class n {
        constructor(e) {
          this.appInits = e, this.resolve = Q1, this.reject = Q1, this.initialized = !1, this.done = !1, this.donePromise = new Promise((a, i) => {
            this.resolve = a, this.reject = i;
          });
        }
        runInitializers() {
          if (this.initialized) return;
          const e = [],
            a = () => {
              this.done = !0, this.resolve();
            };
          if (this.appInits) for (let i = 0; i < this.appInits.length; i++) {
            const o = this.appInits[i]();
            if (F1(o)) e.push(o);else if (z8(o)) {
              const r = new Promise((s, c) => {
                o.subscribe({
                  complete: s,
                  error: c
                });
              });
              e.push(r);
            }
          }
          Promise.all(e).then(() => {
            a();
          }).catch(i => {
            this.reject(i);
          }), 0 === e.length && a(), this.initialized = !0;
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(Nb, 8));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac,
        providedIn: "root"
      }), n;
    })();
    const Ur = new O("AppId", {
      providedIn: "root",
      factory: function Fb() {
        return `${hm()}${hm()}${hm()}`;
      }
    });
    function hm() {
      return String.fromCharCode(97 + Math.floor(25 * Math.random()));
    }
    const Vb = new O("Platform Initializer"),
      X1 = new O("Platform ID", {
        providedIn: "platform",
        factory: () => "unknown"
      }),
      QT = new O("appBootstrapListener"),
      Ft = new O("AnimationModuleType"),
      ja = new O("LocaleId", {
        providedIn: "root",
        factory: () => La(ja, me.Optional | me.SkipSelf) || function ZT() {
          return typeof $localize < "u" && $localize.locale || Nr;
        }()
      }),
      tI = (() => Promise.resolve(0))();
    function pm(n) {
      typeof Zone > "u" ? tI.then(() => {
        n && n.apply(null, null);
      }) : Zone.current.scheduleMicroTask("scheduleMicrotask", n);
    }
    class ae {
      constructor({
        enableLongStackTrace: t = !1,
        shouldCoalesceEventChangeDetection: e = !1,
        shouldCoalesceRunChangeDetection: a = !1
      }) {
        if (this.hasPendingMacrotasks = !1, this.hasPendingMicrotasks = !1, this.isStable = !0, this.onUnstable = new E(!1), this.onMicrotaskEmpty = new E(!1), this.onStable = new E(!1), this.onError = new E(!1), typeof Zone > "u") throw new L(908, !1);
        Zone.assertZonePatched();
        const i = this;
        if (i._nesting = 0, i._outer = i._inner = Zone.current, Zone.AsyncStackTaggingZoneSpec) {
          const o = Zone.AsyncStackTaggingZoneSpec;
          i._inner = i._inner.fork(new o("Angular"));
        }
        Zone.TaskTrackingZoneSpec && (i._inner = i._inner.fork(new Zone.TaskTrackingZoneSpec())), t && Zone.longStackTraceZoneSpec && (i._inner = i._inner.fork(Zone.longStackTraceZoneSpec)), i.shouldCoalesceEventChangeDetection = !a && e, i.shouldCoalesceRunChangeDetection = a, i.lastRequestAnimationFrameId = -1, i.nativeRequestAnimationFrame = function nI() {
          let n = Je.requestAnimationFrame,
            t = Je.cancelAnimationFrame;
          if (typeof Zone < "u" && n && t) {
            const e = n[Zone.__symbol__("OriginalDelegate")];
            e && (n = e);
            const a = t[Zone.__symbol__("OriginalDelegate")];
            a && (t = a);
          }
          return {
            nativeRequestAnimationFrame: n,
            nativeCancelAnimationFrame: t
          };
        }().nativeRequestAnimationFrame, function oI(n) {
          const t = () => {
            !function iI(n) {
              n.isCheckStableRunning || -1 !== n.lastRequestAnimationFrameId || (n.lastRequestAnimationFrameId = n.nativeRequestAnimationFrame.call(Je, () => {
                n.fakeTopEventTask || (n.fakeTopEventTask = Zone.root.scheduleEventTask("fakeTopEventTask", () => {
                  n.lastRequestAnimationFrameId = -1, bm(n), n.isCheckStableRunning = !0, gm(n), n.isCheckStableRunning = !1;
                }, void 0, () => {}, () => {})), n.fakeTopEventTask.invoke();
              }), bm(n));
            }(n);
          };
          n._inner = n._inner.fork({
            name: "angular",
            properties: {
              isAngularZone: !0
            },
            onInvokeTask: (e, a, i, o, r, s) => {
              try {
                return jb(n), e.invokeTask(i, o, r, s);
              } finally {
                (n.shouldCoalesceEventChangeDetection && "eventTask" === o.type || n.shouldCoalesceRunChangeDetection) && t(), Ub(n);
              }
            },
            onInvoke: (e, a, i, o, r, s, c) => {
              try {
                return jb(n), e.invoke(i, o, r, s, c);
              } finally {
                n.shouldCoalesceRunChangeDetection && t(), Ub(n);
              }
            },
            onHasTask: (e, a, i, o) => {
              e.hasTask(i, o), a === i && ("microTask" == o.change ? (n._hasPendingMicrotasks = o.microTask, bm(n), gm(n)) : "macroTask" == o.change && (n.hasPendingMacrotasks = o.macroTask));
            },
            onHandleError: (e, a, i, o) => (e.handleError(i, o), n.runOutsideAngular(() => n.onError.emit(o)), !1)
          });
        }(i);
      }
      static isInAngularZone() {
        return typeof Zone < "u" && !0 === Zone.current.get("isAngularZone");
      }
      static assertInAngularZone() {
        if (!ae.isInAngularZone()) throw new L(909, !1);
      }
      static assertNotInAngularZone() {
        if (ae.isInAngularZone()) throw new L(909, !1);
      }
      run(t, e, a) {
        return this._inner.run(t, e, a);
      }
      runTask(t, e, a, i) {
        const o = this._inner,
          r = o.scheduleEventTask("NgZoneEvent: " + i, t, aI, Q1, Q1);
        try {
          return o.runTask(r, e, a);
        } finally {
          o.cancelTask(r);
        }
      }
      runGuarded(t, e, a) {
        return this._inner.runGuarded(t, e, a);
      }
      runOutsideAngular(t) {
        return this._outer.run(t);
      }
    }
    const aI = {};
    function gm(n) {
      if (0 == n._nesting && !n.hasPendingMicrotasks && !n.isStable) try {
        n._nesting++, n.onMicrotaskEmpty.emit(null);
      } finally {
        if (n._nesting--, !n.hasPendingMicrotasks) try {
          n.runOutsideAngular(() => n.onStable.emit(null));
        } finally {
          n.isStable = !0;
        }
      }
    }
    function bm(n) {
      n.hasPendingMicrotasks = !!(n._hasPendingMicrotasks || (n.shouldCoalesceEventChangeDetection || n.shouldCoalesceRunChangeDetection) && -1 !== n.lastRequestAnimationFrameId);
    }
    function jb(n) {
      n._nesting++, n.isStable && (n.isStable = !1, n.onUnstable.emit(null));
    }
    function Ub(n) {
      n._nesting--, gm(n);
    }
    class rI {
      constructor() {
        this.hasPendingMicrotasks = !1, this.hasPendingMacrotasks = !1, this.isStable = !0, this.onUnstable = new E(), this.onMicrotaskEmpty = new E(), this.onStable = new E(), this.onError = new E();
      }
      run(t, e, a) {
        return t.apply(e, a);
      }
      runGuarded(t, e, a) {
        return t.apply(e, a);
      }
      runOutsideAngular(t) {
        return t();
      }
      runTask(t, e, a, i) {
        return t.apply(e, a);
      }
    }
    const Gb = new O(""),
      J1 = new O("");
    let ym,
      _m = (() => {
        class n {
          constructor(e, a, i) {
            this._ngZone = e, this.registry = a, this._pendingCount = 0, this._isZoneStable = !0, this._didWork = !1, this._callbacks = [], this.taskTrackingZone = null, ym || (function sI(n) {
              ym = n;
            }(i), i.addToWindow(a)), this._watchAngularEvents(), e.run(() => {
              this.taskTrackingZone = typeof Zone > "u" ? null : Zone.current.get("TaskTrackingZone");
            });
          }
          _watchAngularEvents() {
            this._ngZone.onUnstable.subscribe({
              next: () => {
                this._didWork = !0, this._isZoneStable = !1;
              }
            }), this._ngZone.runOutsideAngular(() => {
              this._ngZone.onStable.subscribe({
                next: () => {
                  ae.assertNotInAngularZone(), pm(() => {
                    this._isZoneStable = !0, this._runCallbacksIfReady();
                  });
                }
              });
            });
          }
          increasePendingRequestCount() {
            return this._pendingCount += 1, this._didWork = !0, this._pendingCount;
          }
          decreasePendingRequestCount() {
            if (this._pendingCount -= 1, this._pendingCount < 0) throw new Error("pending async requests below zero");
            return this._runCallbacksIfReady(), this._pendingCount;
          }
          isStable() {
            return this._isZoneStable && 0 === this._pendingCount && !this._ngZone.hasPendingMacrotasks;
          }
          _runCallbacksIfReady() {
            if (this.isStable()) pm(() => {
              for (; 0 !== this._callbacks.length;) {
                let e = this._callbacks.pop();
                clearTimeout(e.timeoutId), e.doneCb(this._didWork);
              }
              this._didWork = !1;
            });else {
              let e = this.getPendingTasks();
              this._callbacks = this._callbacks.filter(a => !a.updateCb || !a.updateCb(e) || (clearTimeout(a.timeoutId), !1)), this._didWork = !0;
            }
          }
          getPendingTasks() {
            return this.taskTrackingZone ? this.taskTrackingZone.macroTasks.map(e => ({
              source: e.source,
              creationLocation: e.creationLocation,
              data: e.data
            })) : [];
          }
          addCallback(e, a, i) {
            let o = -1;
            a && a > 0 && (o = setTimeout(() => {
              this._callbacks = this._callbacks.filter(r => r.timeoutId !== o), e(this._didWork, this.getPendingTasks());
            }, a)), this._callbacks.push({
              doneCb: e,
              timeoutId: o,
              updateCb: i
            });
          }
          whenStable(e, a, i) {
            if (i && !this.taskTrackingZone) throw new Error('Task tracking zone is required when passing an update callback to whenStable(). Is "zone.js/plugins/task-tracking" loaded?');
            this.addCallback(e, a, i), this._runCallbacksIfReady();
          }
          getPendingRequestCount() {
            return this._pendingCount;
          }
          registerApplication(e) {
            this.registry.registerApplication(e, this);
          }
          unregisterApplication(e) {
            this.registry.unregisterApplication(e);
          }
          findProviders(e, a, i) {
            return [];
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(ae), M(vm), M(J1));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac
        }), n;
      })(),
      vm = (() => {
        class n {
          constructor() {
            this._applications = new Map();
          }
          registerApplication(e, a) {
            this._applications.set(e, a);
          }
          unregisterApplication(e) {
            this._applications.delete(e);
          }
          unregisterAllApplications() {
            this._applications.clear();
          }
          getTestability(e) {
            return this._applications.get(e) || null;
          }
          getAllTestabilities() {
            return Array.from(this._applications.values());
          }
          getAllRootElements() {
            return Array.from(this._applications.keys());
          }
          findTestabilityInTree(e, a = !0) {
            return ym?.findTestabilityInTree(this, e, a) ?? null;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "platform"
        }), n;
      })(),
      Ui = null;
    const Wb = new O("AllowMultipleToken"),
      Cm = new O("PlatformDestroyListeners");
    function qb(n, t, e = []) {
      const a = `Platform: ${t}`,
        i = new O(a);
      return (o = []) => {
        let r = Mm();
        if (!r || r.injector.get(Wb, !1)) {
          const s = [...e, ...o, {
            provide: i,
            useValue: !0
          }];
          n ? n(s) : function dI(n) {
            if (Ui && !Ui.get(Wb, !1)) throw new L(400, !1);
            Ui = n;
            const t = n.get(Qb);
            (function Yb(n) {
              const t = n.get(Vb, null);
              t && t.forEach(e => e());
            })(n);
          }(function Kb(n = [], t) {
            return Lt.create({
              name: t,
              providers: [{
                provide: Uu,
                useValue: "platform"
              }, {
                provide: Cm,
                useValue: new Set([() => Ui = null])
              }, ...n]
            });
          }(s, a));
        }
        return function fI(n) {
          const t = Mm();
          if (!t) throw new L(401, !1);
          return t;
        }();
      };
    }
    function Mm() {
      return Ui?.get(Qb) ?? null;
    }
    let Qb = (() => {
      class n {
        constructor(e) {
          this._injector = e, this._modules = [], this._destroyListeners = [], this._destroyed = !1;
        }
        bootstrapModuleFactory(e, a) {
          const i = function Xb(n, t) {
              let e;
              return e = "noop" === n ? new rI() : ("zone.js" === n ? void 0 : n) || new ae(t), e;
            }(a?.ngZone, function Zb(n) {
              return {
                enableLongStackTrace: !1,
                shouldCoalesceEventChangeDetection: !(!n || !n.ngZoneEventCoalescing) || !1,
                shouldCoalesceRunChangeDetection: !(!n || !n.ngZoneRunCoalescing) || !1
              };
            }(a)),
            o = [{
              provide: ae,
              useValue: i
            }];
          return i.run(() => {
            const r = Lt.create({
                providers: o,
                parent: this.injector,
                name: e.moduleType.name
              }),
              s = e.create(r),
              c = s.injector.get(si, null);
            if (!c) throw new L(402, !1);
            return i.runOutsideAngular(() => {
              const l = i.onError.subscribe({
                next: d => {
                  c.handleError(d);
                }
              });
              s.onDestroy(() => {
                $1(this._modules, s), l.unsubscribe();
              });
            }), function Jb(n, t, e) {
              try {
                const a = e();
                return F1(a) ? a.catch(i => {
                  throw t.runOutsideAngular(() => n.handleError(i)), i;
                }) : a;
              } catch (a) {
                throw t.runOutsideAngular(() => n.handleError(a)), a;
              }
            }(c, i, () => {
              const l = s.injector.get(Z1);
              return l.runInitializers(), l.donePromise.then(() => (function D5(n) {
                kn(n, "Expected localeId to be defined"), "string" == typeof n && (k5 = n.toLowerCase().replace(/_/g, "-"));
              }(s.injector.get(ja, Nr) || Nr), this._moduleDoBootstrap(s), s));
            });
          });
        }
        bootstrapModule(e, a = []) {
          const i = $b({}, a);
          return function cI(n, t, e) {
            const a = new tm(e);
            return Promise.resolve(a);
          }(0, 0, e).then(o => this.bootstrapModuleFactory(o, i));
        }
        _moduleDoBootstrap(e) {
          const a = e.injector.get(Gr);
          if (e._bootstrapComponents.length > 0) e._bootstrapComponents.forEach(i => a.bootstrap(i));else {
            if (!e.instance.ngDoBootstrap) throw new L(403, !1);
            e.instance.ngDoBootstrap(a);
          }
          this._modules.push(e);
        }
        onDestroy(e) {
          this._destroyListeners.push(e);
        }
        get injector() {
          return this._injector;
        }
        destroy() {
          if (this._destroyed) throw new L(404, !1);
          this._modules.slice().forEach(a => a.destroy()), this._destroyListeners.forEach(a => a());
          const e = this._injector.get(Cm, null);
          e && (e.forEach(a => a()), e.clear()), this._destroyed = !0;
        }
        get destroyed() {
          return this._destroyed;
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(Lt));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac,
        providedIn: "platform"
      }), n;
    })();
    function $b(n, t) {
      return Array.isArray(t) ? t.reduce($b, n) : {
        ...n,
        ...t
      };
    }
    let Gr = (() => {
      class n {
        constructor(e, a, i) {
          this._zone = e, this._injector = a, this._exceptionHandler = i, this._bootstrapListeners = [], this._views = [], this._runningTick = !1, this._stable = !0, this._destroyed = !1, this._destroyListeners = [], this.componentTypes = [], this.components = [], this._onMicrotaskEmptySubscription = this._zone.onMicrotaskEmpty.subscribe({
            next: () => {
              this._zone.run(() => {
                this.tick();
              });
            }
          });
          const o = new Be(s => {
              this._stable = this._zone.isStable && !this._zone.hasPendingMacrotasks && !this._zone.hasPendingMicrotasks, this._zone.runOutsideAngular(() => {
                s.next(this._stable), s.complete();
              });
            }),
            r = new Be(s => {
              let c;
              this._zone.runOutsideAngular(() => {
                c = this._zone.onStable.subscribe(() => {
                  ae.assertNotInAngularZone(), pm(() => {
                    !this._stable && !this._zone.hasPendingMacrotasks && !this._zone.hasPendingMicrotasks && (this._stable = !0, s.next(!0));
                  });
                });
              });
              const l = this._zone.onUnstable.subscribe(() => {
                ae.assertInAngularZone(), this._stable && (this._stable = !1, this._zone.runOutsideAngular(() => {
                  s.next(!1);
                }));
              });
              return () => {
                c.unsubscribe(), l.unsubscribe();
              };
            });
          this.isStable = dt(o, r.pipe(Ul()));
        }
        get destroyed() {
          return this._destroyed;
        }
        get injector() {
          return this._injector;
        }
        bootstrap(e, a) {
          const i = e instanceof tg;
          if (!this._injector.get(Z1).done) throw !i && function Bs(n) {
            const t = Ke(n) || rn(n) || sn(n);
            return null !== t && t.standalone;
          }(e), new L(405, false);
          let r;
          r = i ? e : this._injector.get(Vi).resolveComponentFactory(e), this.componentTypes.push(r.componentType);
          const s = function lI(n) {
              return n.isBoundToModule;
            }(r) ? void 0 : this._injector.get(Fr),
            l = r.create(Lt.NULL, [], a || r.selector, s),
            d = l.location.nativeElement,
            u = l.injector.get(Gb, null);
          return u?.registerApplication(d), l.onDestroy(() => {
            this.detachView(l.hostView), $1(this.components, l), u?.unregisterApplication(d);
          }), this._loadComponent(l), l;
        }
        tick() {
          if (this._runningTick) throw new L(101, !1);
          try {
            this._runningTick = !0;
            for (let e of this._views) e.detectChanges();
          } catch (e) {
            this._zone.runOutsideAngular(() => this._exceptionHandler.handleError(e));
          } finally {
            this._runningTick = !1;
          }
        }
        attachView(e) {
          const a = e;
          this._views.push(a), a.attachToAppRef(this);
        }
        detachView(e) {
          const a = e;
          $1(this._views, a), a.detachFromAppRef();
        }
        _loadComponent(e) {
          this.attachView(e.hostView), this.tick(), this.components.push(e), this._injector.get(QT, []).concat(this._bootstrapListeners).forEach(i => i(e));
        }
        ngOnDestroy() {
          if (!this._destroyed) try {
            this._destroyListeners.forEach(e => e()), this._views.slice().forEach(e => e.destroy()), this._onMicrotaskEmptySubscription.unsubscribe();
          } finally {
            this._destroyed = !0, this._views = [], this._bootstrapListeners = [], this._destroyListeners = [];
          }
        }
        onDestroy(e) {
          return this._destroyListeners.push(e), () => $1(this._destroyListeners, e);
        }
        destroy() {
          if (this._destroyed) throw new L(406, !1);
          const e = this._injector;
          e.destroy && !e.destroyed && e.destroy();
        }
        get viewCount() {
          return this._views.length;
        }
        warnIfDestroyed() {}
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(ae), M(_r), M(si));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac,
        providedIn: "root"
      }), n;
    })();
    function $1(n, t) {
      const e = n.indexOf(t);
      e > -1 && n.splice(e, 1);
    }
    let t7 = !0,
      Se = (() => {
        class n {}
        return n.__NG_ELEMENT_ID__ = pI, n;
      })();
    function pI(n) {
      return function gI(n, t, e) {
        if (Jl(n) && !e) {
          const a = Pn(n.index, t);
          return new fc(a, a);
        }
        return 47 & n.type ? new fc(t[16], t) : null;
      }(Rt(), I(), 16 == (16 & n));
    }
    class s7 {
      constructor() {}
      supports(t) {
        return hc(t);
      }
      create(t) {
        return new MI(t);
      }
    }
    const CI = (n, t) => t;
    class MI {
      constructor(t) {
        this.length = 0, this._linkedRecords = null, this._unlinkedRecords = null, this._previousItHead = null, this._itHead = null, this._itTail = null, this._additionsHead = null, this._additionsTail = null, this._movesHead = null, this._movesTail = null, this._removalsHead = null, this._removalsTail = null, this._identityChangesHead = null, this._identityChangesTail = null, this._trackByFn = t || CI;
      }
      forEachItem(t) {
        let e;
        for (e = this._itHead; null !== e; e = e._next) t(e);
      }
      forEachOperation(t) {
        let e = this._itHead,
          a = this._removalsHead,
          i = 0,
          o = null;
        for (; e || a;) {
          const r = !a || e && e.currentIndex < l7(a, i, o) ? e : a,
            s = l7(r, i, o),
            c = r.currentIndex;
          if (r === a) i--, a = a._nextRemoved;else if (e = e._next, null == r.previousIndex) i++;else {
            o || (o = []);
            const l = s - i,
              d = c - i;
            if (l != d) {
              for (let m = 0; m < l; m++) {
                const h = m < o.length ? o[m] : o[m] = 0,
                  p = h + m;
                d <= p && p < l && (o[m] = h + 1);
              }
              o[r.previousIndex] = d - l;
            }
          }
          s !== c && t(r, s, c);
        }
      }
      forEachPreviousItem(t) {
        let e;
        for (e = this._previousItHead; null !== e; e = e._nextPrevious) t(e);
      }
      forEachAddedItem(t) {
        let e;
        for (e = this._additionsHead; null !== e; e = e._nextAdded) t(e);
      }
      forEachMovedItem(t) {
        let e;
        for (e = this._movesHead; null !== e; e = e._nextMoved) t(e);
      }
      forEachRemovedItem(t) {
        let e;
        for (e = this._removalsHead; null !== e; e = e._nextRemoved) t(e);
      }
      forEachIdentityChange(t) {
        let e;
        for (e = this._identityChangesHead; null !== e; e = e._nextIdentityChange) t(e);
      }
      diff(t) {
        if (null == t && (t = []), !hc(t)) throw new L(900, !1);
        return this.check(t) ? this : null;
      }
      onDestroy() {}
      check(t) {
        this._reset();
        let i,
          o,
          r,
          e = this._itHead,
          a = !1;
        if (Array.isArray(t)) {
          this.length = t.length;
          for (let s = 0; s < this.length; s++) o = t[s], r = this._trackByFn(s, o), null !== e && Object.is(e.trackById, r) ? (a && (e = this._verifyReinsertion(e, o, r, s)), Object.is(e.item, o) || this._addIdentityChange(e, o)) : (e = this._mismatch(e, o, r, s), a = !0), e = e._next;
        } else i = 0, function $A(n, t) {
          if (Array.isArray(n)) for (let e = 0; e < n.length; e++) t(n[e]);else {
            const e = n[yo()]();
            let a;
            for (; !(a = e.next()).done;) t(a.value);
          }
        }(t, s => {
          r = this._trackByFn(i, s), null !== e && Object.is(e.trackById, r) ? (a && (e = this._verifyReinsertion(e, s, r, i)), Object.is(e.item, s) || this._addIdentityChange(e, s)) : (e = this._mismatch(e, s, r, i), a = !0), e = e._next, i++;
        }), this.length = i;
        return this._truncate(e), this.collection = t, this.isDirty;
      }
      get isDirty() {
        return null !== this._additionsHead || null !== this._movesHead || null !== this._removalsHead || null !== this._identityChangesHead;
      }
      _reset() {
        if (this.isDirty) {
          let t;
          for (t = this._previousItHead = this._itHead; null !== t; t = t._next) t._nextPrevious = t._next;
          for (t = this._additionsHead; null !== t; t = t._nextAdded) t.previousIndex = t.currentIndex;
          for (this._additionsHead = this._additionsTail = null, t = this._movesHead; null !== t; t = t._nextMoved) t.previousIndex = t.currentIndex;
          this._movesHead = this._movesTail = null, this._removalsHead = this._removalsTail = null, this._identityChangesHead = this._identityChangesTail = null;
        }
      }
      _mismatch(t, e, a, i) {
        let o;
        return null === t ? o = this._itTail : (o = t._prev, this._remove(t)), null !== (t = null === this._unlinkedRecords ? null : this._unlinkedRecords.get(a, null)) ? (Object.is(t.item, e) || this._addIdentityChange(t, e), this._reinsertAfter(t, o, i)) : null !== (t = null === this._linkedRecords ? null : this._linkedRecords.get(a, i)) ? (Object.is(t.item, e) || this._addIdentityChange(t, e), this._moveAfter(t, o, i)) : t = this._addAfter(new xI(e, a), o, i), t;
      }
      _verifyReinsertion(t, e, a, i) {
        let o = null === this._unlinkedRecords ? null : this._unlinkedRecords.get(a, null);
        return null !== o ? t = this._reinsertAfter(o, t._prev, i) : t.currentIndex != i && (t.currentIndex = i, this._addToMoves(t, i)), t;
      }
      _truncate(t) {
        for (; null !== t;) {
          const e = t._next;
          this._addToRemovals(this._unlink(t)), t = e;
        }
        null !== this._unlinkedRecords && this._unlinkedRecords.clear(), null !== this._additionsTail && (this._additionsTail._nextAdded = null), null !== this._movesTail && (this._movesTail._nextMoved = null), null !== this._itTail && (this._itTail._next = null), null !== this._removalsTail && (this._removalsTail._nextRemoved = null), null !== this._identityChangesTail && (this._identityChangesTail._nextIdentityChange = null);
      }
      _reinsertAfter(t, e, a) {
        null !== this._unlinkedRecords && this._unlinkedRecords.remove(t);
        const i = t._prevRemoved,
          o = t._nextRemoved;
        return null === i ? this._removalsHead = o : i._nextRemoved = o, null === o ? this._removalsTail = i : o._prevRemoved = i, this._insertAfter(t, e, a), this._addToMoves(t, a), t;
      }
      _moveAfter(t, e, a) {
        return this._unlink(t), this._insertAfter(t, e, a), this._addToMoves(t, a), t;
      }
      _addAfter(t, e, a) {
        return this._insertAfter(t, e, a), this._additionsTail = null === this._additionsTail ? this._additionsHead = t : this._additionsTail._nextAdded = t, t;
      }
      _insertAfter(t, e, a) {
        const i = null === e ? this._itHead : e._next;
        return t._next = i, t._prev = e, null === i ? this._itTail = t : i._prev = t, null === e ? this._itHead = t : e._next = t, null === this._linkedRecords && (this._linkedRecords = new c7()), this._linkedRecords.put(t), t.currentIndex = a, t;
      }
      _remove(t) {
        return this._addToRemovals(this._unlink(t));
      }
      _unlink(t) {
        null !== this._linkedRecords && this._linkedRecords.remove(t);
        const e = t._prev,
          a = t._next;
        return null === e ? this._itHead = a : e._next = a, null === a ? this._itTail = e : a._prev = e, t;
      }
      _addToMoves(t, e) {
        return t.previousIndex === e || (this._movesTail = null === this._movesTail ? this._movesHead = t : this._movesTail._nextMoved = t), t;
      }
      _addToRemovals(t) {
        return null === this._unlinkedRecords && (this._unlinkedRecords = new c7()), this._unlinkedRecords.put(t), t.currentIndex = null, t._nextRemoved = null, null === this._removalsTail ? (this._removalsTail = this._removalsHead = t, t._prevRemoved = null) : (t._prevRemoved = this._removalsTail, this._removalsTail = this._removalsTail._nextRemoved = t), t;
      }
      _addIdentityChange(t, e) {
        return t.item = e, this._identityChangesTail = null === this._identityChangesTail ? this._identityChangesHead = t : this._identityChangesTail._nextIdentityChange = t, t;
      }
    }
    class xI {
      constructor(t, e) {
        this.item = t, this.trackById = e, this.currentIndex = null, this.previousIndex = null, this._nextPrevious = null, this._prev = null, this._next = null, this._prevDup = null, this._nextDup = null, this._prevRemoved = null, this._nextRemoved = null, this._nextAdded = null, this._nextMoved = null, this._nextIdentityChange = null;
      }
    }
    class wI {
      constructor() {
        this._head = null, this._tail = null;
      }
      add(t) {
        null === this._head ? (this._head = this._tail = t, t._nextDup = null, t._prevDup = null) : (this._tail._nextDup = t, t._prevDup = this._tail, t._nextDup = null, this._tail = t);
      }
      get(t, e) {
        let a;
        for (a = this._head; null !== a; a = a._nextDup) if ((null === e || e <= a.currentIndex) && Object.is(a.trackById, t)) return a;
        return null;
      }
      remove(t) {
        const e = t._prevDup,
          a = t._nextDup;
        return null === e ? this._head = a : e._nextDup = a, null === a ? this._tail = e : a._prevDup = e, null === this._head;
      }
    }
    class c7 {
      constructor() {
        this.map = new Map();
      }
      put(t) {
        const e = t.trackById;
        let a = this.map.get(e);
        a || (a = new wI(), this.map.set(e, a)), a.add(t);
      }
      get(t, e) {
        const i = this.map.get(t);
        return i ? i.get(t, e) : null;
      }
      remove(t) {
        const e = t.trackById;
        return this.map.get(e).remove(t) && this.map.delete(e), t;
      }
      get isEmpty() {
        return 0 === this.map.size;
      }
      clear() {
        this.map.clear();
      }
    }
    function l7(n, t, e) {
      const a = n.previousIndex;
      if (null === a) return a;
      let i = 0;
      return e && a < e.length && (i = e[a]), a + t + i;
    }
    class d7 {
      constructor() {}
      supports(t) {
        return t instanceof Map || Uf(t);
      }
      create() {
        return new kI();
      }
    }
    class kI {
      constructor() {
        this._records = new Map(), this._mapHead = null, this._appendAfter = null, this._previousMapHead = null, this._changesHead = null, this._changesTail = null, this._additionsHead = null, this._additionsTail = null, this._removalsHead = null, this._removalsTail = null;
      }
      get isDirty() {
        return null !== this._additionsHead || null !== this._changesHead || null !== this._removalsHead;
      }
      forEachItem(t) {
        let e;
        for (e = this._mapHead; null !== e; e = e._next) t(e);
      }
      forEachPreviousItem(t) {
        let e;
        for (e = this._previousMapHead; null !== e; e = e._nextPrevious) t(e);
      }
      forEachChangedItem(t) {
        let e;
        for (e = this._changesHead; null !== e; e = e._nextChanged) t(e);
      }
      forEachAddedItem(t) {
        let e;
        for (e = this._additionsHead; null !== e; e = e._nextAdded) t(e);
      }
      forEachRemovedItem(t) {
        let e;
        for (e = this._removalsHead; null !== e; e = e._nextRemoved) t(e);
      }
      diff(t) {
        if (t) {
          if (!(t instanceof Map || Uf(t))) throw new L(900, !1);
        } else t = new Map();
        return this.check(t) ? this : null;
      }
      onDestroy() {}
      check(t) {
        this._reset();
        let e = this._mapHead;
        if (this._appendAfter = null, this._forEach(t, (a, i) => {
          if (e && e.key === i) this._maybeAddToChanges(e, a), this._appendAfter = e, e = e._next;else {
            const o = this._getOrCreateRecordForKey(i, a);
            e = this._insertBeforeOrAppend(e, o);
          }
        }), e) {
          e._prev && (e._prev._next = null), this._removalsHead = e;
          for (let a = e; null !== a; a = a._nextRemoved) a === this._mapHead && (this._mapHead = null), this._records.delete(a.key), a._nextRemoved = a._next, a.previousValue = a.currentValue, a.currentValue = null, a._prev = null, a._next = null;
        }
        return this._changesTail && (this._changesTail._nextChanged = null), this._additionsTail && (this._additionsTail._nextAdded = null), this.isDirty;
      }
      _insertBeforeOrAppend(t, e) {
        if (t) {
          const a = t._prev;
          return e._next = t, e._prev = a, t._prev = e, a && (a._next = e), t === this._mapHead && (this._mapHead = e), this._appendAfter = t, t;
        }
        return this._appendAfter ? (this._appendAfter._next = e, e._prev = this._appendAfter) : this._mapHead = e, this._appendAfter = e, null;
      }
      _getOrCreateRecordForKey(t, e) {
        if (this._records.has(t)) {
          const i = this._records.get(t);
          this._maybeAddToChanges(i, e);
          const o = i._prev,
            r = i._next;
          return o && (o._next = r), r && (r._prev = o), i._next = null, i._prev = null, i;
        }
        const a = new DI(t);
        return this._records.set(t, a), a.currentValue = e, this._addToAdditions(a), a;
      }
      _reset() {
        if (this.isDirty) {
          let t;
          for (this._previousMapHead = this._mapHead, t = this._previousMapHead; null !== t; t = t._next) t._nextPrevious = t._next;
          for (t = this._changesHead; null !== t; t = t._nextChanged) t.previousValue = t.currentValue;
          for (t = this._additionsHead; null != t; t = t._nextAdded) t.previousValue = t.currentValue;
          this._changesHead = this._changesTail = null, this._additionsHead = this._additionsTail = null, this._removalsHead = null;
        }
      }
      _maybeAddToChanges(t, e) {
        Object.is(e, t.currentValue) || (t.previousValue = t.currentValue, t.currentValue = e, this._addToChanges(t));
      }
      _addToAdditions(t) {
        null === this._additionsHead ? this._additionsHead = this._additionsTail = t : (this._additionsTail._nextAdded = t, this._additionsTail = t);
      }
      _addToChanges(t) {
        null === this._changesHead ? this._changesHead = this._changesTail = t : (this._changesTail._nextChanged = t, this._changesTail = t);
      }
      _forEach(t, e) {
        t instanceof Map ? t.forEach(e) : Object.keys(t).forEach(a => e(t[a], a));
      }
    }
    class DI {
      constructor(t) {
        this.key = t, this.previousValue = null, this.currentValue = null, this._nextPrevious = null, this._next = null, this._prev = null, this._nextAdded = null, this._nextRemoved = null, this._nextChanged = null;
      }
    }
    function u7() {
      return new Xn([new s7()]);
    }
    let Xn = (() => {
      class n {
        constructor(e) {
          this.factories = e;
        }
        static create(e, a) {
          if (null != a) {
            const i = a.factories.slice();
            e = e.concat(i);
          }
          return new n(e);
        }
        static extend(e) {
          return {
            provide: n,
            useFactory: a => n.create(e, a || u7()),
            deps: [[n, new ga(), new En()]]
          };
        }
        find(e) {
          const a = this.factories.find(i => i.supports(e));
          if (null != a) return a;
          throw new L(901, !1);
        }
      }
      return n.ɵprov = R({
        token: n,
        providedIn: "root",
        factory: u7
      }), n;
    })();
    function f7() {
      return new kc([new d7()]);
    }
    let kc = (() => {
      class n {
        constructor(e) {
          this.factories = e;
        }
        static create(e, a) {
          if (a) {
            const i = a.factories.slice();
            e = e.concat(i);
          }
          return new n(e);
        }
        static extend(e) {
          return {
            provide: n,
            useFactory: a => n.create(e, a || f7()),
            deps: [[n, new ga(), new En()]]
          };
        }
        find(e) {
          const a = this.factories.find(i => i.supports(e));
          if (a) return a;
          throw new L(901, !1);
        }
      }
      return n.ɵprov = R({
        token: n,
        providedIn: "root",
        factory: f7
      }), n;
    })();
    const AI = qb(null, "core", []);
    let SI = (() => {
      class n {
        constructor(e) {}
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(Gr));
      }, n.ɵmod = W({
        type: n
      }), n.ɵinj = U({}), n;
    })();
    function Om(n) {
      return "boolean" == typeof n ? n : null != n && "false" !== n;
    }
    let nd = null;
    function Ua() {
      return nd;
    }
    const ie = new O("DocumentToken");
    let m7 = (() => {
        class n {
          historyGo(e) {
            throw new Error("Not implemented");
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵprov = R({
          token: n,
          factory: function () {
            return function RI() {
              return M(h7);
            }();
          },
          providedIn: "platform"
        }), n;
      })(),
      h7 = (() => {
        class n extends m7 {
          constructor(e) {
            super(), this._doc = e, this._init();
          }
          _init() {
            this.location = window.location, this._history = window.history;
          }
          getBaseHrefFromDOM() {
            return Ua().getBaseHref(this._doc);
          }
          onPopState(e) {
            const a = Ua().getGlobalEventTarget(this._doc, "window");
            return a.addEventListener("popstate", e, !1), () => a.removeEventListener("popstate", e);
          }
          onHashChange(e) {
            const a = Ua().getGlobalEventTarget(this._doc, "window");
            return a.addEventListener("hashchange", e, !1), () => a.removeEventListener("hashchange", e);
          }
          get href() {
            return this.location.href;
          }
          get protocol() {
            return this.location.protocol;
          }
          get hostname() {
            return this.location.hostname;
          }
          get port() {
            return this.location.port;
          }
          get pathname() {
            return this.location.pathname;
          }
          get search() {
            return this.location.search;
          }
          get hash() {
            return this.location.hash;
          }
          set pathname(e) {
            this.location.pathname = e;
          }
          pushState(e, a, i) {
            p7() ? this._history.pushState(e, a, i) : this.location.hash = i;
          }
          replaceState(e, a, i) {
            p7() ? this._history.replaceState(e, a, i) : this.location.hash = i;
          }
          forward() {
            this._history.forward();
          }
          back() {
            this._history.back();
          }
          historyGo(e = 0) {
            this._history.go(e);
          }
          getState() {
            return this._history.state;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(ie));
        }, n.ɵprov = R({
          token: n,
          factory: function () {
            return function zI() {
              return new h7(M(ie));
            }();
          },
          providedIn: "platform"
        }), n;
      })();
    function p7() {
      return !!window.history.pushState;
    }
    function g7(n, t) {
      if (0 == n.length) return t;
      if (0 == t.length) return n;
      let e = 0;
      return n.endsWith("/") && e++, t.startsWith("/") && e++, 2 == e ? n + t.substring(1) : 1 == e ? n + t : n + "/" + t;
    }
    function b7(n) {
      const t = n.match(/#|\?|$/),
        e = t && t.index || n.length;
      return n.slice(0, e - ("/" === n[e - 1] ? 1 : 0)) + n.slice(e);
    }
    function wo(n) {
      return n && "?" !== n[0] ? "?" + n : n;
    }
    let Pm = (() => {
      class n {
        historyGo(e) {
          throw new Error("Not implemented");
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)();
      }, n.ɵprov = R({
        token: n,
        factory: function () {
          return La(NI);
        },
        providedIn: "root"
      }), n;
    })();
    const LI = new O("appBaseHref");
    let NI = (() => {
        class n extends Pm {
          constructor(e, a) {
            super(), this._platformLocation = e, this._removeListenerFns = [], this._baseHref = a ?? this._platformLocation.getBaseHrefFromDOM() ?? La(ie).location?.origin ?? "";
          }
          ngOnDestroy() {
            for (; this._removeListenerFns.length;) this._removeListenerFns.pop()();
          }
          onPopState(e) {
            this._removeListenerFns.push(this._platformLocation.onPopState(e), this._platformLocation.onHashChange(e));
          }
          getBaseHref() {
            return this._baseHref;
          }
          prepareExternalUrl(e) {
            return g7(this._baseHref, e);
          }
          path(e = !1) {
            const a = this._platformLocation.pathname + wo(this._platformLocation.search),
              i = this._platformLocation.hash;
            return i && e ? `${a}${i}` : a;
          }
          pushState(e, a, i, o) {
            const r = this.prepareExternalUrl(i + wo(o));
            this._platformLocation.pushState(e, a, r);
          }
          replaceState(e, a, i, o) {
            const r = this.prepareExternalUrl(i + wo(o));
            this._platformLocation.replaceState(e, a, r);
          }
          forward() {
            this._platformLocation.forward();
          }
          back() {
            this._platformLocation.back();
          }
          getState() {
            return this._platformLocation.getState();
          }
          historyGo(e = 0) {
            this._platformLocation.historyGo?.(e);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(m7), M(LI, 8));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      Am = (() => {
        class n {
          constructor(e) {
            this._subject = new E(), this._urlChangeListeners = [], this._urlChangeSubscription = null, this._locationStrategy = e;
            const a = this._locationStrategy.getBaseHref();
            this._baseHref = b7(_7(a)), this._locationStrategy.onPopState(i => {
              this._subject.emit({
                url: this.path(!0),
                pop: !0,
                state: i.state,
                type: i.type
              });
            });
          }
          ngOnDestroy() {
            this._urlChangeSubscription?.unsubscribe(), this._urlChangeListeners = [];
          }
          path(e = !1) {
            return this.normalize(this._locationStrategy.path(e));
          }
          getState() {
            return this._locationStrategy.getState();
          }
          isCurrentPathEqualTo(e, a = "") {
            return this.path() == this.normalize(e + wo(a));
          }
          normalize(e) {
            return n.stripTrailingSlash(function VI(n, t) {
              return n && t.startsWith(n) ? t.substring(n.length) : t;
            }(this._baseHref, _7(e)));
          }
          prepareExternalUrl(e) {
            return e && "/" !== e[0] && (e = "/" + e), this._locationStrategy.prepareExternalUrl(e);
          }
          go(e, a = "", i = null) {
            this._locationStrategy.pushState(i, "", e, a), this._notifyUrlChangeListeners(this.prepareExternalUrl(e + wo(a)), i);
          }
          replaceState(e, a = "", i = null) {
            this._locationStrategy.replaceState(i, "", e, a), this._notifyUrlChangeListeners(this.prepareExternalUrl(e + wo(a)), i);
          }
          forward() {
            this._locationStrategy.forward();
          }
          back() {
            this._locationStrategy.back();
          }
          historyGo(e = 0) {
            this._locationStrategy.historyGo?.(e);
          }
          onUrlChange(e) {
            return this._urlChangeListeners.push(e), this._urlChangeSubscription || (this._urlChangeSubscription = this.subscribe(a => {
              this._notifyUrlChangeListeners(a.url, a.state);
            })), () => {
              const a = this._urlChangeListeners.indexOf(e);
              this._urlChangeListeners.splice(a, 1), 0 === this._urlChangeListeners.length && (this._urlChangeSubscription?.unsubscribe(), this._urlChangeSubscription = null);
            };
          }
          _notifyUrlChangeListeners(e = "", a) {
            this._urlChangeListeners.forEach(i => i(e, a));
          }
          subscribe(e, a, i) {
            return this._subject.subscribe({
              next: e,
              error: a,
              complete: i
            });
          }
        }
        return n.normalizeQueryParams = wo, n.joinWithSlash = g7, n.stripTrailingSlash = b7, n.ɵfac = function (e) {
          return new (e || n)(M(Pm));
        }, n.ɵprov = R({
          token: n,
          factory: function () {
            return function FI() {
              return new Am(M(Pm));
            }();
          },
          providedIn: "root"
        }), n;
      })();
    function _7(n) {
      return n.replace(/\/index.html$/, "");
    }
    function O7(n, t) {
      t = encodeURIComponent(t);
      for (const e of n.split(";")) {
        const a = e.indexOf("="),
          [i, o] = -1 == a ? [e, ""] : [e.slice(0, a), e.slice(a + 1)];
        if (i.trim() === t) return decodeURIComponent(o);
      }
      return null;
    }
    let ko = (() => {
      class n {
        constructor(e, a, i, o) {
          this._iterableDiffers = e, this._keyValueDiffers = a, this._ngEl = i, this._renderer = o, this._iterableDiffer = null, this._keyValueDiffer = null, this._initialClasses = [], this._rawClass = null;
        }
        set klass(e) {
          this._removeClasses(this._initialClasses), this._initialClasses = "string" == typeof e ? e.split(/\s+/) : [], this._applyClasses(this._initialClasses), this._applyClasses(this._rawClass);
        }
        set ngClass(e) {
          this._removeClasses(this._rawClass), this._applyClasses(this._initialClasses), this._iterableDiffer = null, this._keyValueDiffer = null, this._rawClass = "string" == typeof e ? e.split(/\s+/) : e, this._rawClass && (hc(this._rawClass) ? this._iterableDiffer = this._iterableDiffers.find(this._rawClass).create() : this._keyValueDiffer = this._keyValueDiffers.find(this._rawClass).create());
        }
        ngDoCheck() {
          if (this._iterableDiffer) {
            const e = this._iterableDiffer.diff(this._rawClass);
            e && this._applyIterableChanges(e);
          } else if (this._keyValueDiffer) {
            const e = this._keyValueDiffer.diff(this._rawClass);
            e && this._applyKeyValueChanges(e);
          }
        }
        _applyKeyValueChanges(e) {
          e.forEachAddedItem(a => this._toggleClass(a.key, a.currentValue)), e.forEachChangedItem(a => this._toggleClass(a.key, a.currentValue)), e.forEachRemovedItem(a => {
            a.previousValue && this._toggleClass(a.key, !1);
          });
        }
        _applyIterableChanges(e) {
          e.forEachAddedItem(a => {
            if ("string" != typeof a.item) throw new Error(`NgClass can only toggle CSS classes expressed as strings, got ${Xe(a.item)}`);
            this._toggleClass(a.item, !0);
          }), e.forEachRemovedItem(a => this._toggleClass(a.item, !1));
        }
        _applyClasses(e) {
          e && (Array.isArray(e) || e instanceof Set ? e.forEach(a => this._toggleClass(a, !0)) : Object.keys(e).forEach(a => this._toggleClass(a, !!e[a])));
        }
        _removeClasses(e) {
          e && (Array.isArray(e) || e instanceof Set ? e.forEach(a => this._toggleClass(a, !1)) : Object.keys(e).forEach(a => this._toggleClass(a, !1)));
        }
        _toggleClass(e, a) {
          (e = e.trim()) && e.split(/\s+/g).forEach(i => {
            a ? this._renderer.addClass(this._ngEl.nativeElement, i) : this._renderer.removeClass(this._ngEl.nativeElement, i);
          });
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(f(Xn), f(kc), f(J), f(Hi));
      }, n.ɵdir = P({
        type: n,
        selectors: [["", "ngClass", ""]],
        inputs: {
          klass: ["class", "klass"],
          ngClass: "ngClass"
        },
        standalone: !0
      }), n;
    })();
    class xR {
      constructor(t, e, a, i) {
        this.$implicit = t, this.ngForOf = e, this.index = a, this.count = i;
      }
      get first() {
        return 0 === this.index;
      }
      get last() {
        return this.index === this.count - 1;
      }
      get even() {
        return this.index % 2 == 0;
      }
      get odd() {
        return !this.even;
      }
    }
    let ea = (() => {
      class n {
        constructor(e, a, i) {
          this._viewContainer = e, this._template = a, this._differs = i, this._ngForOf = null, this._ngForOfDirty = !0, this._differ = null;
        }
        set ngForOf(e) {
          this._ngForOf = e, this._ngForOfDirty = !0;
        }
        set ngForTrackBy(e) {
          this._trackByFn = e;
        }
        get ngForTrackBy() {
          return this._trackByFn;
        }
        set ngForTemplate(e) {
          e && (this._template = e);
        }
        ngDoCheck() {
          if (this._ngForOfDirty) {
            this._ngForOfDirty = !1;
            const e = this._ngForOf;
            !this._differ && e && (this._differ = this._differs.find(e).create(this.ngForTrackBy));
          }
          if (this._differ) {
            const e = this._differ.diff(this._ngForOf);
            e && this._applyChanges(e);
          }
        }
        _applyChanges(e) {
          const a = this._viewContainer;
          e.forEachOperation((i, o, r) => {
            if (null == i.previousIndex) a.createEmbeddedView(this._template, new xR(i.item, this._ngForOf, -1, -1), null === r ? void 0 : r);else if (null == r) a.remove(null === o ? void 0 : o);else if (null !== o) {
              const s = a.get(o);
              a.move(s, r), S7(s, i);
            }
          });
          for (let i = 0, o = a.length; i < o; i++) {
            const s = a.get(i).context;
            s.index = i, s.count = o, s.ngForOf = this._ngForOf;
          }
          e.forEachIdentityChange(i => {
            S7(a.get(i.currentIndex), i);
          });
        }
        static ngTemplateContextGuard(e, a) {
          return !0;
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(f(ut), f(vt), f(Xn));
      }, n.ɵdir = P({
        type: n,
        selectors: [["", "ngFor", "", "ngForOf", ""]],
        inputs: {
          ngForOf: "ngForOf",
          ngForTrackBy: "ngForTrackBy",
          ngForTemplate: "ngForTemplate"
        },
        standalone: !0
      }), n;
    })();
    function S7(n, t) {
      n.context.$implicit = t.item;
    }
    let mt = (() => {
      class n {
        constructor(e, a) {
          this._viewContainer = e, this._context = new kR(), this._thenTemplateRef = null, this._elseTemplateRef = null, this._thenViewRef = null, this._elseViewRef = null, this._thenTemplateRef = a;
        }
        set ngIf(e) {
          this._context.$implicit = this._context.ngIf = e, this._updateView();
        }
        set ngIfThen(e) {
          E7("ngIfThen", e), this._thenTemplateRef = e, this._thenViewRef = null, this._updateView();
        }
        set ngIfElse(e) {
          E7("ngIfElse", e), this._elseTemplateRef = e, this._elseViewRef = null, this._updateView();
        }
        _updateView() {
          this._context.$implicit ? this._thenViewRef || (this._viewContainer.clear(), this._elseViewRef = null, this._thenTemplateRef && (this._thenViewRef = this._viewContainer.createEmbeddedView(this._thenTemplateRef, this._context))) : this._elseViewRef || (this._viewContainer.clear(), this._thenViewRef = null, this._elseTemplateRef && (this._elseViewRef = this._viewContainer.createEmbeddedView(this._elseTemplateRef, this._context)));
        }
        static ngTemplateContextGuard(e, a) {
          return !0;
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(f(ut), f(vt));
      }, n.ɵdir = P({
        type: n,
        selectors: [["", "ngIf", ""]],
        inputs: {
          ngIf: "ngIf",
          ngIfThen: "ngIfThen",
          ngIfElse: "ngIfElse"
        },
        standalone: !0
      }), n;
    })();
    class kR {
      constructor() {
        this.$implicit = null, this.ngIf = null;
      }
    }
    function E7(n, t) {
      if (t && !t.createEmbeddedView) throw new Error(`${n} must be a TemplateRef, but received '${Xe(t)}'.`);
    }
    class Vm {
      constructor(t, e) {
        this._viewContainerRef = t, this._templateRef = e, this._created = !1;
      }
      create() {
        this._created = !0, this._viewContainerRef.createEmbeddedView(this._templateRef);
      }
      destroy() {
        this._created = !1, this._viewContainerRef.clear();
      }
      enforceState(t) {
        t && !this._created ? this.create() : !t && this._created && this.destroy();
      }
    }
    let Gi = (() => {
        class n {
          constructor() {
            this._defaultUsed = !1, this._caseCount = 0, this._lastCaseCheckIndex = 0, this._lastCasesMatched = !1;
          }
          set ngSwitch(e) {
            this._ngSwitch = e, 0 === this._caseCount && this._updateDefaultCases(!0);
          }
          _addCase() {
            return this._caseCount++;
          }
          _addDefault(e) {
            this._defaultViews || (this._defaultViews = []), this._defaultViews.push(e);
          }
          _matchCase(e) {
            const a = e == this._ngSwitch;
            return this._lastCasesMatched = this._lastCasesMatched || a, this._lastCaseCheckIndex++, this._lastCaseCheckIndex === this._caseCount && (this._updateDefaultCases(!this._lastCasesMatched), this._lastCaseCheckIndex = 0, this._lastCasesMatched = !1), a;
          }
          _updateDefaultCases(e) {
            if (this._defaultViews && e !== this._defaultUsed) {
              this._defaultUsed = e;
              for (let a = 0; a < this._defaultViews.length; a++) this._defaultViews[a].enforceState(e);
            }
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "ngSwitch", ""]],
          inputs: {
            ngSwitch: "ngSwitch"
          },
          standalone: !0
        }), n;
      })(),
      Wr = (() => {
        class n {
          constructor(e, a, i) {
            this.ngSwitch = i, i._addCase(), this._view = new Vm(e, a);
          }
          ngDoCheck() {
            this._view.enforceState(this.ngSwitch._matchCase(this.ngSwitchCase));
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(ut), f(vt), f(Gi, 9));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "ngSwitchCase", ""]],
          inputs: {
            ngSwitchCase: "ngSwitchCase"
          },
          standalone: !0
        }), n;
      })(),
      T7 = (() => {
        class n {
          constructor(e, a, i) {
            i._addDefault(new Vm(e, a));
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(ut), f(vt), f(Gi, 9));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "ngSwitchDefault", ""]],
          standalone: !0
        }), n;
      })(),
      fd = (() => {
        class n {
          constructor(e, a, i) {
            this._ngEl = e, this._differs = a, this._renderer = i, this._ngStyle = null, this._differ = null;
          }
          set ngStyle(e) {
            this._ngStyle = e, !this._differ && e && (this._differ = this._differs.find(e).create());
          }
          ngDoCheck() {
            if (this._differ) {
              const e = this._differ.diff(this._ngStyle);
              e && this._applyChanges(e);
            }
          }
          _setStyle(e, a) {
            const [i, o] = e.split("."),
              r = -1 === i.indexOf("-") ? void 0 : vn.DashCase;
            null != a ? this._renderer.setStyle(this._ngEl.nativeElement, i, o ? `${a}${o}` : a, r) : this._renderer.removeStyle(this._ngEl.nativeElement, i, r);
          }
          _applyChanges(e) {
            e.forEachRemovedItem(a => this._setStyle(a.key, null)), e.forEachAddedItem(a => this._setStyle(a.key, a.currentValue)), e.forEachChangedItem(a => this._setStyle(a.key, a.currentValue));
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(kc), f(Hi));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "ngStyle", ""]],
          inputs: {
            ngStyle: "ngStyle"
          },
          standalone: !0
        }), n;
      })();
    class PR {
      createSubscription(t, e) {
        return t.subscribe({
          next: e,
          error: a => {
            throw a;
          }
        });
      }
      dispose(t) {
        t.unsubscribe();
      }
    }
    class AR {
      createSubscription(t, e) {
        return t.then(e, a => {
          throw a;
        });
      }
      dispose(t) {}
    }
    const SR = new AR(),
      ER = new PR();
    let md = (() => {
        class n {
          constructor(e) {
            this._latestValue = null, this._subscription = null, this._obj = null, this._strategy = null, this._ref = e;
          }
          ngOnDestroy() {
            this._subscription && this._dispose(), this._ref = null;
          }
          transform(e) {
            return this._obj ? e !== this._obj ? (this._dispose(), this.transform(e)) : this._latestValue : (e && this._subscribe(e), this._latestValue);
          }
          _subscribe(e) {
            this._obj = e, this._strategy = this._selectStrategy(e), this._subscription = this._strategy.createSubscription(e, a => this._updateLatestValue(e, a));
          }
          _selectStrategy(e) {
            if (F1(e)) return SR;
            if (R8(e)) return ER;
            throw function xa(n, t) {
              return new L(2100, !1);
            }();
          }
          _dispose() {
            this._strategy.dispose(this._subscription), this._latestValue = null, this._subscription = null, this._obj = null;
          }
          _updateLatestValue(e, a) {
            e === this._obj && (this._latestValue = a, this._ref.markForCheck());
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Se, 16));
        }, n.ɵpipe = on({
          name: "async",
          type: n,
          pure: !1,
          standalone: !0
        }), n;
      })(),
      R7 = (() => {
        class n {
          transform(e) {
            return JSON.stringify(e, null, 2);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵpipe = on({
          name: "json",
          type: n,
          pure: !1,
          standalone: !0
        }), n;
      })(),
      yt = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({}), n;
      })();
    const L7 = "browser";
    class F7 {}
    class Gm extends class pz extends class II {} {
      constructor() {
        super(...arguments), this.supportsDOMEvents = !0;
      }
    } {
      static makeCurrent() {
        !function TI(n) {
          nd || (nd = n);
        }(new Gm());
      }
      onAndCancel(t, e, a) {
        return t.addEventListener(e, a, !1), () => {
          t.removeEventListener(e, a, !1);
        };
      }
      dispatchEvent(t, e) {
        t.dispatchEvent(e);
      }
      remove(t) {
        t.parentNode && t.parentNode.removeChild(t);
      }
      createElement(t, e) {
        return (e = e || this.getDefaultDocument()).createElement(t);
      }
      createHtmlDocument() {
        return document.implementation.createHTMLDocument("fakeTitle");
      }
      getDefaultDocument() {
        return document;
      }
      isElementNode(t) {
        return t.nodeType === Node.ELEMENT_NODE;
      }
      isShadowRoot(t) {
        return t instanceof DocumentFragment;
      }
      getGlobalEventTarget(t, e) {
        return "window" === e ? window : "document" === e ? t : "body" === e ? t.body : null;
      }
      getBaseHref(t) {
        const e = function gz() {
          return Ac = Ac || document.querySelector("base"), Ac ? Ac.getAttribute("href") : null;
        }();
        return null == e ? null : function bz(n) {
          pd = pd || document.createElement("a"), pd.setAttribute("href", n);
          const t = pd.pathname;
          return "/" === t.charAt(0) ? t : `/${t}`;
        }(e);
      }
      resetBaseElement() {
        Ac = null;
      }
      getUserAgent() {
        return window.navigator.userAgent;
      }
      getCookie(t) {
        return O7(document.cookie, t);
      }
    }
    let pd,
      Ac = null;
    const j7 = new O("TRANSITION_ID"),
      vz = [{
        provide: Nb,
        useFactory: function _z(n, t, e) {
          return () => {
            e.get(Z1).donePromise.then(() => {
              const a = Ua(),
                i = t.querySelectorAll(`style[ng-transition="${n}"]`);
              for (let o = 0; o < i.length; o++) a.remove(i[o]);
            });
          };
        },
        deps: [j7, ie, Lt],
        multi: !0
      }];
    let Cz = (() => {
      class n {
        build() {
          return new XMLHttpRequest();
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)();
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac
      }), n;
    })();
    const gd = new O("EventManagerPlugins");
    let bd = (() => {
      class n {
        constructor(e, a) {
          this._zone = a, this._eventNameToPlugin = new Map(), e.forEach(i => i.manager = this), this._plugins = e.slice().reverse();
        }
        addEventListener(e, a, i) {
          return this._findPluginFor(a).addEventListener(e, a, i);
        }
        addGlobalEventListener(e, a, i) {
          return this._findPluginFor(a).addGlobalEventListener(e, a, i);
        }
        getZone() {
          return this._zone;
        }
        _findPluginFor(e) {
          const a = this._eventNameToPlugin.get(e);
          if (a) return a;
          const i = this._plugins;
          for (let o = 0; o < i.length; o++) {
            const r = i[o];
            if (r.supports(e)) return this._eventNameToPlugin.set(e, r), r;
          }
          throw new Error(`No event manager plugin found for event ${e}`);
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(gd), M(ae));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac
      }), n;
    })();
    class U7 {
      constructor(t) {
        this._doc = t;
      }
      addGlobalEventListener(t, e, a) {
        const i = Ua().getGlobalEventTarget(this._doc, t);
        if (!i) throw new Error(`Unsupported event target ${i} for event ${e}`);
        return this.addEventListener(i, e, a);
      }
    }
    let G7 = (() => {
        class n {
          constructor() {
            this._stylesSet = new Set();
          }
          addStyles(e) {
            const a = new Set();
            e.forEach(i => {
              this._stylesSet.has(i) || (this._stylesSet.add(i), a.add(i));
            }), this.onStylesAdded(a);
          }
          onStylesAdded(e) {}
          getAllStyles() {
            return Array.from(this._stylesSet);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac
        }), n;
      })(),
      Sc = (() => {
        class n extends G7 {
          constructor(e) {
            super(), this._doc = e, this._hostNodes = new Map(), this._hostNodes.set(e.head, []);
          }
          _addStylesToHost(e, a, i) {
            e.forEach(o => {
              const r = this._doc.createElement("style");
              r.textContent = o, i.push(a.appendChild(r));
            });
          }
          addHost(e) {
            const a = [];
            this._addStylesToHost(this._stylesSet, e, a), this._hostNodes.set(e, a);
          }
          removeHost(e) {
            const a = this._hostNodes.get(e);
            a && a.forEach(W7), this._hostNodes.delete(e);
          }
          onStylesAdded(e) {
            this._hostNodes.forEach((a, i) => {
              this._addStylesToHost(e, i, a);
            });
          }
          ngOnDestroy() {
            this._hostNodes.forEach(e => e.forEach(W7));
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(ie));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac
        }), n;
      })();
    function W7(n) {
      Ua().remove(n);
    }
    const Wm = {
        svg: "http://www.w3.org/2000/svg",
        xhtml: "http://www.w3.org/1999/xhtml",
        xlink: "http://www.w3.org/1999/xlink",
        xml: "http://www.w3.org/XML/1998/namespace",
        xmlns: "http://www.w3.org/2000/xmlns/",
        math: "http://www.w3.org/1998/MathML/"
      },
      Ym = /%COMP%/g;
    function _d(n, t, e) {
      for (let a = 0; a < t.length; a++) {
        let i = t[a];
        Array.isArray(i) ? _d(n, i, e) : (i = i.replace(Ym, n), e.push(i));
      }
      return e;
    }
    function K7(n) {
      return t => {
        if ("__ngUnwrap__" === t) return n;
        !1 === n(t) && (t.preventDefault(), t.returnValue = !1);
      };
    }
    let vd = (() => {
      class n {
        constructor(e, a, i) {
          this.eventManager = e, this.sharedStylesHost = a, this.appId = i, this.rendererByCompId = new Map(), this.defaultRenderer = new qm(e);
        }
        createRenderer(e, a) {
          if (!e || !a) return this.defaultRenderer;
          switch (a.encapsulation) {
            case fa.Emulated:
              {
                let i = this.rendererByCompId.get(a.id);
                return i || (i = new Oz(this.eventManager, this.sharedStylesHost, a, this.appId), this.rendererByCompId.set(a.id, i)), i.applyToHost(e), i;
              }
            case 1:
            case fa.ShadowDom:
              return new Pz(this.eventManager, this.sharedStylesHost, e, a);
            default:
              if (!this.rendererByCompId.has(a.id)) {
                const i = _d(a.id, a.styles, []);
                this.sharedStylesHost.addStyles(i), this.rendererByCompId.set(a.id, this.defaultRenderer);
              }
              return this.defaultRenderer;
          }
        }
        begin() {}
        end() {}
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(bd), M(Sc), M(Ur));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac
      }), n;
    })();
    class qm {
      constructor(t) {
        this.eventManager = t, this.data = Object.create(null), this.destroyNode = null;
      }
      destroy() {}
      createElement(t, e) {
        return e ? document.createElementNS(Wm[e] || e, t) : document.createElement(t);
      }
      createComment(t) {
        return document.createComment(t);
      }
      createText(t) {
        return document.createTextNode(t);
      }
      appendChild(t, e) {
        (Z7(t) ? t.content : t).appendChild(e);
      }
      insertBefore(t, e, a) {
        t && (Z7(t) ? t.content : t).insertBefore(e, a);
      }
      removeChild(t, e) {
        t && t.removeChild(e);
      }
      selectRootElement(t, e) {
        let a = "string" == typeof t ? document.querySelector(t) : t;
        if (!a) throw new Error(`The selector "${t}" did not match any elements`);
        return e || (a.textContent = ""), a;
      }
      parentNode(t) {
        return t.parentNode;
      }
      nextSibling(t) {
        return t.nextSibling;
      }
      setAttribute(t, e, a, i) {
        if (i) {
          e = i + ":" + e;
          const o = Wm[i];
          o ? t.setAttributeNS(o, e, a) : t.setAttribute(e, a);
        } else t.setAttribute(e, a);
      }
      removeAttribute(t, e, a) {
        if (a) {
          const i = Wm[a];
          i ? t.removeAttributeNS(i, e) : t.removeAttribute(`${a}:${e}`);
        } else t.removeAttribute(e);
      }
      addClass(t, e) {
        t.classList.add(e);
      }
      removeClass(t, e) {
        t.classList.remove(e);
      }
      setStyle(t, e, a, i) {
        i & (vn.DashCase | vn.Important) ? t.style.setProperty(e, a, i & vn.Important ? "important" : "") : t.style[e] = a;
      }
      removeStyle(t, e, a) {
        a & vn.DashCase ? t.style.removeProperty(e) : t.style[e] = "";
      }
      setProperty(t, e, a) {
        t[e] = a;
      }
      setValue(t, e) {
        t.nodeValue = e;
      }
      listen(t, e, a) {
        return "string" == typeof t ? this.eventManager.addGlobalEventListener(t, e, K7(a)) : this.eventManager.addEventListener(t, e, K7(a));
      }
    }
    function Z7(n) {
      return "TEMPLATE" === n.tagName && void 0 !== n.content;
    }
    class Oz extends qm {
      constructor(t, e, a, i) {
        super(t), this.component = a;
        const o = _d(i + "-" + a.id, a.styles, []);
        e.addStyles(o), this.contentAttr = function wz(n) {
          return "_ngcontent-%COMP%".replace(Ym, n);
        }(i + "-" + a.id), this.hostAttr = function kz(n) {
          return "_nghost-%COMP%".replace(Ym, n);
        }(i + "-" + a.id);
      }
      applyToHost(t) {
        super.setAttribute(t, this.hostAttr, "");
      }
      createElement(t, e) {
        const a = super.createElement(t, e);
        return super.setAttribute(a, this.contentAttr, ""), a;
      }
    }
    class Pz extends qm {
      constructor(t, e, a, i) {
        super(t), this.sharedStylesHost = e, this.hostEl = a, this.shadowRoot = a.attachShadow({
          mode: "open"
        }), this.sharedStylesHost.addHost(this.shadowRoot);
        const o = _d(i.id, i.styles, []);
        for (let r = 0; r < o.length; r++) {
          const s = document.createElement("style");
          s.textContent = o[r], this.shadowRoot.appendChild(s);
        }
      }
      nodeOrShadowRoot(t) {
        return t === this.hostEl ? this.shadowRoot : t;
      }
      destroy() {
        this.sharedStylesHost.removeHost(this.shadowRoot);
      }
      appendChild(t, e) {
        return super.appendChild(this.nodeOrShadowRoot(t), e);
      }
      insertBefore(t, e, a) {
        return super.insertBefore(this.nodeOrShadowRoot(t), e, a);
      }
      removeChild(t, e) {
        return super.removeChild(this.nodeOrShadowRoot(t), e);
      }
      parentNode(t) {
        return this.nodeOrShadowRoot(super.parentNode(this.nodeOrShadowRoot(t)));
      }
    }
    let Az = (() => {
      class n extends U7 {
        constructor(e) {
          super(e);
        }
        supports(e) {
          return !0;
        }
        addEventListener(e, a, i) {
          return e.addEventListener(a, i, !1), () => this.removeEventListener(e, a, i);
        }
        removeEventListener(e, a, i) {
          return e.removeEventListener(a, i);
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(ie));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac
      }), n;
    })();
    const X7 = ["alt", "control", "meta", "shift"],
      Sz = {
        "\b": "Backspace",
        "\t": "Tab",
        "\x7f": "Delete",
        "\x1b": "Escape",
        Del: "Delete",
        Esc: "Escape",
        Left: "ArrowLeft",
        Right: "ArrowRight",
        Up: "ArrowUp",
        Down: "ArrowDown",
        Menu: "ContextMenu",
        Scroll: "ScrollLock",
        Win: "OS"
      },
      Ez = {
        alt: n => n.altKey,
        control: n => n.ctrlKey,
        meta: n => n.metaKey,
        shift: n => n.shiftKey
      };
    let Tz = (() => {
      class n extends U7 {
        constructor(e) {
          super(e);
        }
        supports(e) {
          return null != n.parseEventName(e);
        }
        addEventListener(e, a, i) {
          const o = n.parseEventName(a),
            r = n.eventCallback(o.fullKey, i, this.manager.getZone());
          return this.manager.getZone().runOutsideAngular(() => Ua().onAndCancel(e, o.domEventName, r));
        }
        static parseEventName(e) {
          const a = e.toLowerCase().split("."),
            i = a.shift();
          if (0 === a.length || "keydown" !== i && "keyup" !== i) return null;
          const o = n._normalizeKey(a.pop());
          let r = "",
            s = a.indexOf("code");
          if (s > -1 && (a.splice(s, 1), r = "code."), X7.forEach(l => {
            const d = a.indexOf(l);
            d > -1 && (a.splice(d, 1), r += l + ".");
          }), r += o, 0 != a.length || 0 === o.length) return null;
          const c = {};
          return c.domEventName = i, c.fullKey = r, c;
        }
        static matchEventFullKeyCode(e, a) {
          let i = Sz[e.key] || e.key,
            o = "";
          return a.indexOf("code.") > -1 && (i = e.code, o = "code."), !(null == i || !i) && (i = i.toLowerCase(), " " === i ? i = "space" : "." === i && (i = "dot"), X7.forEach(r => {
            r !== i && (0, Ez[r])(e) && (o += r + ".");
          }), o += i, o === a);
        }
        static eventCallback(e, a, i) {
          return o => {
            n.matchEventFullKeyCode(o, e) && i.runGuarded(() => a(o));
          };
        }
        static _normalizeKey(e) {
          return "esc" === e ? "escape" : e;
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(ie));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac
      }), n;
    })();
    const $7 = [{
        provide: X1,
        useValue: L7
      }, {
        provide: Vb,
        useValue: function Iz() {
          Gm.makeCurrent();
        },
        multi: !0
      }, {
        provide: ie,
        useFactory: function zz() {
          return function WD(n) {
            Iu = n;
          }(document), document;
        },
        deps: []
      }],
      e9 = qb(AI, "browser", $7),
      t9 = new O(""),
      n9 = [{
        provide: J1,
        useClass: class yz {
          addToWindow(t) {
            Je.getAngularTestability = (a, i = !0) => {
              const o = t.findTestabilityInTree(a, i);
              if (null == o) throw new Error("Could not find testability for element.");
              return o;
            }, Je.getAllAngularTestabilities = () => t.getAllTestabilities(), Je.getAllAngularRootElements = () => t.getAllRootElements(), Je.frameworkStabilizers || (Je.frameworkStabilizers = []), Je.frameworkStabilizers.push(a => {
              const i = Je.getAllAngularTestabilities();
              let o = i.length,
                r = !1;
              const s = function (c) {
                r = r || c, o--, 0 == o && a(r);
              };
              i.forEach(function (c) {
                c.whenStable(s);
              });
            });
          }
          findTestabilityInTree(t, e, a) {
            return null == e ? null : t.getTestability(e) ?? (a ? Ua().isShadowRoot(e) ? this.findTestabilityInTree(t, e.host, !0) : this.findTestabilityInTree(t, e.parentElement, !0) : null);
          }
        },
        deps: []
      }, {
        provide: Gb,
        useClass: _m,
        deps: [ae, vm, J1]
      }, {
        provide: _m,
        useClass: _m,
        deps: [ae, vm, J1]
      }],
      a9 = [{
        provide: Uu,
        useValue: "root"
      }, {
        provide: si,
        useFactory: function Rz() {
          return new si();
        },
        deps: []
      }, {
        provide: gd,
        useClass: Az,
        multi: !0,
        deps: [ie, ae, X1]
      }, {
        provide: gd,
        useClass: Tz,
        multi: !0,
        deps: [ie]
      }, {
        provide: vd,
        useClass: vd,
        deps: [bd, Sc, Ur]
      }, {
        provide: cc,
        useExisting: vd
      }, {
        provide: G7,
        useExisting: Sc
      }, {
        provide: Sc,
        useClass: Sc,
        deps: [ie]
      }, {
        provide: bd,
        useClass: bd,
        deps: [gd, ae]
      }, {
        provide: F7,
        useClass: Cz,
        deps: []
      }, []];
    let yd = (() => {
      class n {
        constructor(e) {}
        static withServerTransition(e) {
          return {
            ngModule: n,
            providers: [{
              provide: Ur,
              useValue: e.appId
            }, {
              provide: j7,
              useExisting: Ur
            }, vz]
          };
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(t9, 12));
      }, n.ɵmod = W({
        type: n
      }), n.ɵinj = U({
        providers: [...a9, ...n9],
        imports: [yt, SI]
      }), n;
    })();
    typeof window < "u" && window;
    let Cd = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵprov = R({
          token: n,
          factory: function (e) {
            let a = null;
            return a = e ? new (e || n)() : M(r9), a;
          },
          providedIn: "root"
        }), n;
      })(),
      r9 = (() => {
        class n extends Cd {
          constructor(e) {
            super(), this._doc = e;
          }
          sanitize(e, a) {
            if (null == a) return null;
            switch (e) {
              case Ge.NONE:
                return a;
              case Ge.HTML:
                return Na(a, "HTML") ? Tn(a) : U6(this._doc, String(a)).toString();
              case Ge.STYLE:
                return Na(a, "Style") ? Tn(a) : a;
              case Ge.SCRIPT:
                if (Na(a, "Script")) return Tn(a);
                throw new Error("unsafe value used in a script context");
              case Ge.URL:
                return Na(a, "URL") ? Tn(a) : v1(String(a));
              case Ge.RESOURCE_URL:
                if (Na(a, "ResourceURL")) return Tn(a);
                throw new Error("unsafe value used in a resource URL context (see https://g.co/ng/security#xss)");
              default:
                throw new Error(`Unexpected SecurityContext ${e} (see https://g.co/ng/security#xss)`);
            }
          }
          bypassSecurityTrustHtml(e) {
            return function eO(n) {
              return new KD(n);
            }(e);
          }
          bypassSecurityTrustStyle(e) {
            return function tO(n) {
              return new QD(n);
            }(e);
          }
          bypassSecurityTrustScript(e) {
            return function nO(n) {
              return new ZD(n);
            }(e);
          }
          bypassSecurityTrustUrl(e) {
            return function aO(n) {
              return new XD(n);
            }(e);
          }
          bypassSecurityTrustResourceUrl(e) {
            return function iO(n) {
              return new JD(n);
            }(e);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(ie));
        }, n.ɵprov = R({
          token: n,
          factory: function (e) {
            let a = null;
            return a = e ? new e() : function Gz(n) {
              return new r9(n.get(ie));
            }(M(Lt)), a;
          },
          providedIn: "root"
        }), n;
      })();
    class Wz extends re {
      constructor(t, e) {
        super();
      }
      schedule(t, e = 0) {
        return this;
      }
    }
    class Md extends Wz {
      constructor(t, e) {
        super(t, e), this.scheduler = t, this.work = e, this.pending = !1;
      }
      schedule(t, e = 0) {
        if (this.closed) return this;
        this.state = t;
        const a = this.id,
          i = this.scheduler;
        return null != a && (this.id = this.recycleAsyncId(i, a, e)), this.pending = !0, this.delay = e, this.id = this.id || this.requestAsyncId(i, this.id, e), this;
      }
      requestAsyncId(t, e, a = 0) {
        return setInterval(t.flush.bind(t, this), a);
      }
      recycleAsyncId(t, e, a = 0) {
        if (null !== a && this.delay === a && !1 === this.pending) return e;
        clearInterval(e);
      }
      execute(t, e) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = !1;
        const a = this._execute(t, e);
        if (a) return a;
        !1 === this.pending && null != this.id && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
      }
      _execute(t, e) {
        let i,
          a = !1;
        try {
          this.work(t);
        } catch (o) {
          a = !0, i = !!o && o || new Error(o);
        }
        if (a) return this.unsubscribe(), i;
      }
      _unsubscribe() {
        const t = this.id,
          e = this.scheduler,
          a = e.actions,
          i = a.indexOf(this);
        this.work = null, this.state = null, this.pending = !1, this.scheduler = null, -1 !== i && a.splice(i, 1), null != t && (this.id = this.recycleAsyncId(e, t, null)), this.delay = null;
      }
    }
    let c9 = (() => {
      class n {
        constructor(e, a = n.now) {
          this.SchedulerAction = e, this.now = a;
        }
        schedule(e, a = 0, i) {
          return new this.SchedulerAction(this, e).schedule(i, a);
        }
      }
      return n.now = () => Date.now(), n;
    })();
    class wa extends c9 {
      constructor(t, e = c9.now) {
        super(t, () => wa.delegate && wa.delegate !== this ? wa.delegate.now() : e()), this.actions = [], this.active = !1, this.scheduled = void 0;
      }
      schedule(t, e = 0, a) {
        return wa.delegate && wa.delegate !== this ? wa.delegate.schedule(t, e, a) : super.schedule(t, e, a);
      }
      flush(t) {
        const {
          actions: e
        } = this;
        if (this.active) return void e.push(t);
        let a;
        this.active = !0;
        do {
          if (a = t.execute(t.state, t.delay)) break;
        } while (t = e.shift());
        if (this.active = !1, a) {
          for (; t = e.shift();) t.unsubscribe();
          throw a;
        }
      }
    }
    const Kz = new class qz extends wa {}(class Yz extends Md {
        constructor(t, e) {
          super(t, e), this.scheduler = t, this.work = e;
        }
        schedule(t, e = 0) {
          return e > 0 ? super.schedule(t, e) : (this.delay = e, this.state = t, this.scheduler.flush(this), this);
        }
        execute(t, e) {
          return e > 0 || this.closed ? super.execute(t, e) : this._execute(t, e);
        }
        requestAsyncId(t, e, a = 0) {
          return null !== a && a > 0 || null === a && this.delay > 0 ? super.requestAsyncId(t, e, a) : t.flush(this);
        }
      }),
      Ec = new Be(n => n.complete());
    function xd(n) {
      return n ? function Qz(n) {
        return new Be(t => n.schedule(() => t.complete()));
      }(n) : Ec;
    }
    function nt(...n) {
      let t = n[n.length - 1];
      return er(t) ? (n.pop(), q0(n, t)) : Q0(n);
    }
    function l9(n, t) {
      return new Be(t ? e => t.schedule(Zz, 0, {
        error: n,
        subscriber: e
      }) : e => e.error(n));
    }
    function Zz({
      error: n,
      subscriber: t
    }) {
      t.error(n);
    }
    class Cn {
      constructor(t, e, a) {
        this.kind = t, this.value = e, this.error = a, this.hasValue = "N" === t;
      }
      observe(t) {
        switch (this.kind) {
          case "N":
            return t.next && t.next(this.value);
          case "E":
            return t.error && t.error(this.error);
          case "C":
            return t.complete && t.complete();
        }
      }
      do(t, e, a) {
        switch (this.kind) {
          case "N":
            return t && t(this.value);
          case "E":
            return e && e(this.error);
          case "C":
            return a && a();
        }
      }
      accept(t, e, a) {
        return t && "function" == typeof t.next ? this.observe(t) : this.do(t, e, a);
      }
      toObservable() {
        switch (this.kind) {
          case "N":
            return nt(this.value);
          case "E":
            return l9(this.error);
          case "C":
            return xd();
        }
        throw new Error("unexpected notification kind value");
      }
      static createNext(t) {
        return typeof t < "u" ? new Cn("N", t) : Cn.undefinedValueNotification;
      }
      static createError(t) {
        return new Cn("E", void 0, t);
      }
      static createComplete() {
        return Cn.completeNotification;
      }
    }
    Cn.completeNotification = new Cn("C"), Cn.undefinedValueNotification = new Cn("N", void 0);
    class wd extends Qe {
      constructor(t, e, a = 0) {
        super(t), this.scheduler = e, this.delay = a;
      }
      static dispatch(t) {
        const {
          notification: e,
          destination: a
        } = t;
        e.observe(a), this.unsubscribe();
      }
      scheduleMessage(t) {
        this.destination.add(this.scheduler.schedule(wd.dispatch, this.delay, new Jz(t, this.destination)));
      }
      _next(t) {
        this.scheduleMessage(Cn.createNext(t));
      }
      _error(t) {
        this.scheduleMessage(Cn.createError(t)), this.unsubscribe();
      }
      _complete() {
        this.scheduleMessage(Cn.createComplete()), this.unsubscribe();
      }
    }
    class Jz {
      constructor(t, e) {
        this.notification = t, this.destination = e;
      }
    }
    class Zm extends V {
      constructor(t = Number.POSITIVE_INFINITY, e = Number.POSITIVE_INFINITY, a) {
        super(), this.scheduler = a, this._events = [], this._infiniteTimeWindow = !1, this._bufferSize = t < 1 ? 1 : t, this._windowTime = e < 1 ? 1 : e, e === Number.POSITIVE_INFINITY ? (this._infiniteTimeWindow = !0, this.next = this.nextInfiniteTimeWindow) : this.next = this.nextTimeWindow;
      }
      nextInfiniteTimeWindow(t) {
        if (!this.isStopped) {
          const e = this._events;
          e.push(t), e.length > this._bufferSize && e.shift();
        }
        super.next(t);
      }
      nextTimeWindow(t) {
        this.isStopped || (this._events.push(new $z(this._getNow(), t)), this._trimBufferThenGetEvents()), super.next(t);
      }
      _subscribe(t) {
        const e = this._infiniteTimeWindow,
          a = e ? this._events : this._trimBufferThenGetEvents(),
          i = this.scheduler,
          o = a.length;
        let r;
        if (this.closed) throw new co();
        if (this.isStopped || this.hasError ? r = re.EMPTY : (this.observers.push(t), r = new x3(this, t)), i && t.add(t = new wd(t, i)), e) for (let s = 0; s < o && !t.closed; s++) t.next(a[s]);else for (let s = 0; s < o && !t.closed; s++) t.next(a[s].value);
        return this.hasError ? t.error(this.thrownError) : this.isStopped && t.complete(), r;
      }
      _getNow() {
        return (this.scheduler || Kz).now();
      }
      _trimBufferThenGetEvents() {
        const t = this._getNow(),
          e = this._bufferSize,
          a = this._windowTime,
          i = this._events,
          o = i.length;
        let r = 0;
        for (; r < o && !(t - i[r].time < a);) r++;
        return o > e && (r = Math.max(r, o - e)), r > 0 && i.splice(0, r), i;
      }
    }
    class $z {
      constructor(t, e) {
        this.time = t, this.value = e;
      }
    }
    function gi(n, t) {
      return "function" == typeof t ? e => e.pipe(gi((a, i) => lo(n(a, i)).pipe(We((o, r) => t(a, o, i, r))))) : e => e.lift(new eL(n));
    }
    class eL {
      constructor(t) {
        this.project = t;
      }
      call(t, e) {
        return e.subscribe(new tL(t, this.project));
      }
    }
    class tL extends Fs {
      constructor(t, e) {
        super(t), this.project = e, this.index = 0;
      }
      _next(t) {
        let e;
        const a = this.index++;
        try {
          e = this.project(t, a);
        } catch (i) {
          return void this.destination.error(i);
        }
        this._innerSub(e);
      }
      _innerSub(t) {
        const e = this.innerSubscription;
        e && e.unsubscribe();
        const a = new Ns(this),
          i = this.destination;
        i.add(a), this.innerSubscription = Vs(t, a), this.innerSubscription !== a && i.add(this.innerSubscription);
      }
      _complete() {
        const {
          innerSubscription: t
        } = this;
        (!t || t.closed) && super._complete(), this.unsubscribe();
      }
      _unsubscribe() {
        this.innerSubscription = void 0;
      }
      notifyComplete() {
        this.innerSubscription = void 0, this.isStopped && super._complete();
      }
      notifyNext(t) {
        this.destination.next(t);
      }
    }
    const kd = {
      schedule(n, t) {
        const e = setTimeout(n, t);
        return () => clearTimeout(e);
      },
      scheduleBeforeRender(n) {
        if (typeof window > "u") return kd.schedule(n, 0);
        if (typeof window.requestAnimationFrame > "u") return kd.schedule(n, 16);
        const t = window.requestAnimationFrame(n);
        return () => window.cancelAnimationFrame(t);
      }
    };
    let Xm;
    function dL(n, t, e) {
      let a = e;
      return function aL(n) {
        return !!n && n.nodeType === Node.ELEMENT_NODE;
      }(n) && t.some((i, o) => !("*" === i || !function oL(n, t) {
        if (!Xm) {
          const e = Element.prototype;
          Xm = e.matches || e.matchesSelector || e.mozMatchesSelector || e.msMatchesSelector || e.oMatchesSelector || e.webkitMatchesSelector;
        }
        return n.nodeType === Node.ELEMENT_NODE && Xm.call(n, t);
      }(n, i) || (a = o, 0))), a;
    }
    class fL {
      constructor(t, e) {
        this.componentFactory = e.get(Vi).resolveComponentFactory(t);
      }
      create(t) {
        return new mL(this.componentFactory, t);
      }
    }
    class mL {
      constructor(t, e) {
        this.componentFactory = t, this.injector = e, this.eventEmitters = new Zm(1), this.events = this.eventEmitters.pipe(gi(a => dt(...a))), this.componentRef = null, this.viewChangeDetectorRef = null, this.inputChanges = null, this.hasInputChanges = !1, this.implementsOnChanges = !1, this.scheduledChangeDetectionFn = null, this.scheduledDestroyFn = null, this.initialInputValues = new Map(), this.unchangedInputs = new Set(this.componentFactory.inputs.map(({
          propName: a
        }) => a)), this.ngZone = this.injector.get(ae), this.elementZone = typeof Zone > "u" ? null : this.ngZone.run(() => Zone.current);
      }
      connect(t) {
        this.runInZone(() => {
          if (null !== this.scheduledDestroyFn) return this.scheduledDestroyFn(), void (this.scheduledDestroyFn = null);
          null === this.componentRef && this.initializeComponent(t);
        });
      }
      disconnect() {
        this.runInZone(() => {
          null === this.componentRef || null !== this.scheduledDestroyFn || (this.scheduledDestroyFn = kd.schedule(() => {
            null !== this.componentRef && (this.componentRef.destroy(), this.componentRef = null, this.viewChangeDetectorRef = null);
          }, 10));
        });
      }
      getInputValue(t) {
        return this.runInZone(() => null === this.componentRef ? this.initialInputValues.get(t) : this.componentRef.instance[t]);
      }
      setInputValue(t, e) {
        this.runInZone(() => {
          null !== this.componentRef ? function rL(n, t) {
            return n === t || n != n && t != t;
          }(e, this.getInputValue(t)) && (void 0 !== e || !this.unchangedInputs.has(t)) || (this.recordInputChange(t, e), this.unchangedInputs.delete(t), this.hasInputChanges = !0, this.componentRef.instance[t] = e, this.scheduleDetectChanges()) : this.initialInputValues.set(t, e);
        });
      }
      initializeComponent(t) {
        const e = Lt.create({
            providers: [],
            parent: this.injector
          }),
          a = function lL(n, t) {
            const e = n.childNodes,
              a = t.map(() => []);
            let i = -1;
            t.some((o, r) => "*" === o && (i = r, !0));
            for (let o = 0, r = e.length; o < r; ++o) {
              const s = e[o],
                c = dL(s, t, i);
              -1 !== c && a[c].push(s);
            }
            return a;
          }(t, this.componentFactory.ngContentSelectors);
        this.componentRef = this.componentFactory.create(e, a, t), this.viewChangeDetectorRef = this.componentRef.injector.get(Se), this.implementsOnChanges = function iL(n) {
          return "function" == typeof n;
        }(this.componentRef.instance.ngOnChanges), this.initializeInputs(), this.initializeOutputs(this.componentRef), this.detectChanges(), this.injector.get(Gr).attachView(this.componentRef.hostView);
      }
      initializeInputs() {
        this.componentFactory.inputs.forEach(({
          propName: t
        }) => {
          this.initialInputValues.has(t) && this.setInputValue(t, this.initialInputValues.get(t));
        }), this.initialInputValues.clear();
      }
      initializeOutputs(t) {
        const e = this.componentFactory.outputs.map(({
          propName: a,
          templateName: i
        }) => t.instance[a].pipe(We(r => ({
          name: i,
          value: r
        }))));
        this.eventEmitters.next(e);
      }
      callNgOnChanges(t) {
        if (!this.implementsOnChanges || null === this.inputChanges) return;
        const e = this.inputChanges;
        this.inputChanges = null, t.instance.ngOnChanges(e);
      }
      markViewForCheck(t) {
        this.hasInputChanges && (this.hasInputChanges = !1, t.markForCheck());
      }
      scheduleDetectChanges() {
        this.scheduledChangeDetectionFn || (this.scheduledChangeDetectionFn = kd.scheduleBeforeRender(() => {
          this.scheduledChangeDetectionFn = null, this.detectChanges();
        }));
      }
      recordInputChange(t, e) {
        if (!this.implementsOnChanges) return;
        null === this.inputChanges && (this.inputChanges = {});
        const a = this.inputChanges[t];
        if (a) return void (a.currentValue = e);
        const i = this.unchangedInputs.has(t),
          o = i ? void 0 : this.getInputValue(t);
        this.inputChanges[t] = new j3(o, e, i);
      }
      detectChanges() {
        null !== this.componentRef && (this.callNgOnChanges(this.componentRef), this.markViewForCheck(this.viewChangeDetectorRef), this.componentRef.changeDetectorRef.detectChanges());
      }
      runInZone(t) {
        return this.elementZone && Zone.current !== this.elementZone ? this.ngZone.run(t) : t();
      }
    }
    class hL extends HTMLElement {
      constructor() {
        super(...arguments), this.ngElementEventsSubscription = null;
      }
    }
    function d9(n, t) {
      const e = function cL(n, t) {
          return t.get(Vi).resolveComponentFactory(n).inputs;
        }(n, t.injector),
        a = t.strategyFactory || new fL(n, t.injector),
        i = function sL(n) {
          const t = {};
          return n.forEach(({
            propName: e,
            templateName: a
          }) => {
            t[function nL(n) {
              return n.replace(/[A-Z]/g, t => `-${t.toLowerCase()}`);
            }(a)] = e;
          }), t;
        }(e);
      class o extends hL {
        constructor(s) {
          super(), this.injector = s;
        }
        get ngElementStrategy() {
          if (!this._ngElementStrategy) {
            const s = this._ngElementStrategy = a.create(this.injector || t.injector);
            e.forEach(({
              propName: c
            }) => {
              if (!this.hasOwnProperty(c)) return;
              const l = this[c];
              delete this[c], s.setInputValue(c, l);
            });
          }
          return this._ngElementStrategy;
        }
        attributeChangedCallback(s, c, l, d) {
          this.ngElementStrategy.setInputValue(i[s], l);
        }
        connectedCallback() {
          let s = !1;
          this.ngElementStrategy.events && (this.subscribeToEvents(), s = !0), this.ngElementStrategy.connect(this), s || this.subscribeToEvents();
        }
        disconnectedCallback() {
          this._ngElementStrategy && this._ngElementStrategy.disconnect(), this.ngElementEventsSubscription && (this.ngElementEventsSubscription.unsubscribe(), this.ngElementEventsSubscription = null);
        }
        subscribeToEvents() {
          this.ngElementEventsSubscription = this.ngElementStrategy.events.subscribe(s => {
            const c = new CustomEvent(s.name, {
              detail: s.value
            });
            this.dispatchEvent(c);
          });
        }
      }
      return o.observedAttributes = Object.keys(i), e.forEach(({
        propName: r
      }) => {
        Object.defineProperty(o.prototype, r, {
          get() {
            return this.ngElementStrategy.getInputValue(r);
          },
          set(s) {
            this.ngElementStrategy.setInputValue(r, s);
          },
          configurable: !0,
          enumerable: !0
        });
      }), o;
    }
    function Dd() {
      return window;
    }
    function Od() {
      return Dd().YT;
    }
    function u9() {
      return Od().Player;
    }
    const Jm = {
      height: 270,
      width: 367
    };
    let f9 = (() => {
        class n {
          constructor(e) {
            this.zone = e, this.ytApiLoaded = !1, this.api = new Zm(1), this.createApi();
          }
          loadPlayerApi(e) {
            const a = Dd().document;
            if (!this.ytApiLoaded) {
              this.ytApiLoaded = !0;
              const i = a.createElement("script");
              i.type = "text/javascript", i.src = `${e.protocol}://www.youtube.com/iframe_api`, a.body.appendChild(i);
            }
          }
          setupPlayer(e, a, i, o = "", r) {
            this.api.subscribe(() => {
              u9 && this.createPlayer(e, a, i, o, r);
            });
          }
          play(e) {
            e.playVideo();
          }
          pause(e) {
            e.pauseVideo();
          }
          playVideo(e, a) {
            a.loadVideoById(e.id.videoId ? e.id.videoId : e.id), this.play(a);
          }
          isPlaying(e) {
            const a = e && e.getPlayerState,
              i = a ? e.getPlayerState() : {};
            return !!a && i !== Od().PlayerState.ENDED && i !== Od().PlayerState.PAUSED;
          }
          createPlayer(e, a, i, o = "", r = {}) {
            const s = {
              height: i.height || Jm.height,
              width: i.width || Jm.width
            };
            return new (u9())(e, {
              ...s,
              events: {
                onReady: l => {
                  this.zone.run(() => a.ready && a.ready.next(l.target));
                },
                onStateChange: l => {
                  this.zone.run(() => a.change && a.change.next(l));
                }
              },
              playerVars: r,
              videoId: o
            });
          }
          toggleFullScreen(e, a) {
            let {
              height: i,
              width: o
            } = Jm;
            a || (i = window.innerHeight, o = window.innerWidth), e.setSize(o, i);
          }
          generateUniqueId() {
            return Math.random().toString(35).substr(2, 7);
          }
          createApi() {
            Dd().onYouTubeIframeAPIReady = () => {
              Dd() && this.api.next(Od());
            };
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(ae));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      $m = (() => {
        class n {
          static forRoot() {
            return {
              ngModule: n,
              providers: [f9]
            };
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [f9]
        }), n;
      })();
    class m9 {}
    const bi = "*";
    function ht(n, t) {
      return {
        type: 7,
        name: n,
        definitions: t,
        options: {}
      };
    }
    function Re(n, t = null) {
      return {
        type: 4,
        styles: t,
        timings: n
      };
    }
    function Pd(n, t = null) {
      return {
        type: 3,
        steps: n,
        options: t
      };
    }
    function h9(n, t = null) {
      return {
        type: 2,
        steps: n,
        options: t
      };
    }
    function Z(n) {
      return {
        type: 6,
        styles: n,
        offset: null
      };
    }
    function xe(n, t, e) {
      return {
        type: 0,
        name: n,
        styles: t,
        options: e
      };
    }
    function Do(n) {
      return {
        type: 5,
        steps: n
      };
    }
    function Ee(n, t, e = null) {
      return {
        type: 1,
        expr: n,
        animation: t,
        options: e
      };
    }
    function Yr(n = null) {
      return {
        type: 9,
        options: n
      };
    }
    function qr(n, t, e = null) {
      return {
        type: 11,
        selector: n,
        animation: t,
        options: e
      };
    }
    function p9(n) {
      Promise.resolve().then(n);
    }
    class Tc {
      constructor(t = 0, e = 0) {
        this._onDoneFns = [], this._onStartFns = [], this._onDestroyFns = [], this._originalOnDoneFns = [], this._originalOnStartFns = [], this._started = !1, this._destroyed = !1, this._finished = !1, this._position = 0, this.parentPlayer = null, this.totalTime = t + e;
      }
      _onFinish() {
        this._finished || (this._finished = !0, this._onDoneFns.forEach(t => t()), this._onDoneFns = []);
      }
      onStart(t) {
        this._originalOnStartFns.push(t), this._onStartFns.push(t);
      }
      onDone(t) {
        this._originalOnDoneFns.push(t), this._onDoneFns.push(t);
      }
      onDestroy(t) {
        this._onDestroyFns.push(t);
      }
      hasStarted() {
        return this._started;
      }
      init() {}
      play() {
        this.hasStarted() || (this._onStart(), this.triggerMicrotask()), this._started = !0;
      }
      triggerMicrotask() {
        p9(() => this._onFinish());
      }
      _onStart() {
        this._onStartFns.forEach(t => t()), this._onStartFns = [];
      }
      pause() {}
      restart() {}
      finish() {
        this._onFinish();
      }
      destroy() {
        this._destroyed || (this._destroyed = !0, this.hasStarted() || this._onStart(), this.finish(), this._onDestroyFns.forEach(t => t()), this._onDestroyFns = []);
      }
      reset() {
        this._started = !1, this._finished = !1, this._onStartFns = this._originalOnStartFns, this._onDoneFns = this._originalOnDoneFns;
      }
      setPosition(t) {
        this._position = this.totalTime ? t * this.totalTime : 1;
      }
      getPosition() {
        return this.totalTime ? this._position / this.totalTime : 1;
      }
      triggerCallback(t) {
        const e = "start" == t ? this._onStartFns : this._onDoneFns;
        e.forEach(a => a()), e.length = 0;
      }
    }
    class g9 {
      constructor(t) {
        this._onDoneFns = [], this._onStartFns = [], this._finished = !1, this._started = !1, this._destroyed = !1, this._onDestroyFns = [], this.parentPlayer = null, this.totalTime = 0, this.players = t;
        let e = 0,
          a = 0,
          i = 0;
        const o = this.players.length;
        0 == o ? p9(() => this._onFinish()) : this.players.forEach(r => {
          r.onDone(() => {
            ++e == o && this._onFinish();
          }), r.onDestroy(() => {
            ++a == o && this._onDestroy();
          }), r.onStart(() => {
            ++i == o && this._onStart();
          });
        }), this.totalTime = this.players.reduce((r, s) => Math.max(r, s.totalTime), 0);
      }
      _onFinish() {
        this._finished || (this._finished = !0, this._onDoneFns.forEach(t => t()), this._onDoneFns = []);
      }
      init() {
        this.players.forEach(t => t.init());
      }
      onStart(t) {
        this._onStartFns.push(t);
      }
      _onStart() {
        this.hasStarted() || (this._started = !0, this._onStartFns.forEach(t => t()), this._onStartFns = []);
      }
      onDone(t) {
        this._onDoneFns.push(t);
      }
      onDestroy(t) {
        this._onDestroyFns.push(t);
      }
      hasStarted() {
        return this._started;
      }
      play() {
        this.parentPlayer || this.init(), this._onStart(), this.players.forEach(t => t.play());
      }
      pause() {
        this.players.forEach(t => t.pause());
      }
      restart() {
        this.players.forEach(t => t.restart());
      }
      finish() {
        this._onFinish(), this.players.forEach(t => t.finish());
      }
      destroy() {
        this._onDestroy();
      }
      _onDestroy() {
        this._destroyed || (this._destroyed = !0, this._onFinish(), this.players.forEach(t => t.destroy()), this._onDestroyFns.forEach(t => t()), this._onDestroyFns = []);
      }
      reset() {
        this.players.forEach(t => t.reset()), this._destroyed = !1, this._finished = !1, this._started = !1;
      }
      setPosition(t) {
        const e = t * this.totalTime;
        this.players.forEach(a => {
          const i = a.totalTime ? Math.min(1, e / a.totalTime) : 1;
          a.setPosition(i);
        });
      }
      getPosition() {
        const t = this.players.reduce((e, a) => null === e || a.totalTime > e.totalTime ? a : e, null);
        return null != t ? t.getPosition() : 0;
      }
      beforeDestroy() {
        this.players.forEach(t => {
          t.beforeDestroy && t.beforeDestroy();
        });
      }
      triggerCallback(t) {
        const e = "start" == t ? this._onStartFns : this._onDoneFns;
        e.forEach(a => a()), e.length = 0;
      }
    }
    function b9(n) {
      return new L(3e3, !1);
    }
    function ZL() {
      return typeof window < "u" && typeof window.document < "u";
    }
    function th() {
      return typeof process < "u" && "[object process]" === {}.toString.call(process);
    }
    function Yi(n) {
      switch (n.length) {
        case 0:
          return new Tc();
        case 1:
          return n[0];
        default:
          return new g9(n);
      }
    }
    function _9(n, t, e, a, i = new Map(), o = new Map()) {
      const r = [],
        s = [];
      let c = -1,
        l = null;
      if (a.forEach(d => {
        const u = d.get("offset"),
          m = u == c,
          h = m && l || new Map();
        d.forEach((p, v) => {
          let C = v,
            k = p;
          if ("offset" !== v) switch (C = t.normalizePropertyName(C, r), k) {
            case "!":
              k = i.get(v);
              break;
            case bi:
              k = o.get(v);
              break;
            default:
              k = t.normalizeStyleValue(v, C, k, r);
          }
          h.set(C, k);
        }), m || s.push(h), l = h, c = u;
      }), r.length) throw function FL(n) {
        return new L(3502, !1);
      }();
      return s;
    }
    function nh(n, t, e, a) {
      switch (t) {
        case "start":
          n.onStart(() => a(e && ah(e, "start", n)));
          break;
        case "done":
          n.onDone(() => a(e && ah(e, "done", n)));
          break;
        case "destroy":
          n.onDestroy(() => a(e && ah(e, "destroy", n)));
      }
    }
    function ah(n, t, e) {
      const o = ih(n.element, n.triggerName, n.fromState, n.toState, t || n.phaseName, e.totalTime ?? n.totalTime, !!e.disabled),
        r = n._data;
      return null != r && (o._data = r), o;
    }
    function ih(n, t, e, a, i = "", o = 0, r) {
      return {
        element: n,
        triggerName: t,
        fromState: e,
        toState: a,
        phaseName: i,
        totalTime: o,
        disabled: !!r
      };
    }
    function Ln(n, t, e) {
      let a = n.get(t);
      return a || n.set(t, a = e), a;
    }
    function v9(n) {
      const t = n.indexOf(":");
      return [n.substring(1, t), n.slice(t + 1)];
    }
    let oh = (n, t) => !1,
      y9 = (n, t, e) => [],
      C9 = null;
    function rh(n) {
      const t = n.parentNode || n.host;
      return t === C9 ? null : t;
    }
    (th() || typeof Element < "u") && (ZL() ? (C9 = (() => document.documentElement)(), oh = (n, t) => {
      for (; t;) {
        if (t === n) return !0;
        t = rh(t);
      }
      return !1;
    }) : oh = (n, t) => n.contains(t), y9 = (n, t, e) => {
      if (e) return Array.from(n.querySelectorAll(t));
      const a = n.querySelector(t);
      return a ? [a] : [];
    });
    let Oo = null,
      M9 = !1;
    const x9 = oh,
      w9 = y9;
    let k9 = (() => {
        class n {
          validateStyleProperty(e) {
            return function JL(n) {
              Oo || (Oo = function $L() {
                return typeof document < "u" ? document.body : null;
              }() || {}, M9 = !!Oo.style && "WebkitAppearance" in Oo.style);
              let t = !0;
              return Oo.style && !function XL(n) {
                return "ebkit" == n.substring(1, 6);
              }(n) && (t = n in Oo.style, !t && M9 && (t = "Webkit" + n.charAt(0).toUpperCase() + n.slice(1) in Oo.style)), t;
            }(e);
          }
          matchesElement(e, a) {
            return !1;
          }
          containsElement(e, a) {
            return x9(e, a);
          }
          getParentElement(e) {
            return rh(e);
          }
          query(e, a, i) {
            return w9(e, a, i);
          }
          computeStyle(e, a, i) {
            return i || "";
          }
          animate(e, a, i, o, r, s = [], c) {
            return new Tc(i, o);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac
        }), n;
      })(),
      sh = (() => {
        class n {}
        return n.NOOP = new k9(), n;
      })();
    const ch = "ng-enter",
      Ad = "ng-leave",
      Sd = "ng-trigger",
      Ed = ".ng-trigger",
      O9 = "ng-animating",
      lh = ".ng-animating";
    function _i(n) {
      if ("number" == typeof n) return n;
      const t = n.match(/^(-?[\.\d]+)(m?s)/);
      return !t || t.length < 2 ? 0 : dh(parseFloat(t[1]), t[2]);
    }
    function dh(n, t) {
      return "s" === t ? 1e3 * n : n;
    }
    function Td(n, t, e) {
      return n.hasOwnProperty("duration") ? n : function nN(n, t, e) {
        let i,
          o = 0,
          r = "";
        if ("string" == typeof n) {
          const s = n.match(/^(-?[\.\d]+)(m?s)(?:\s+(-?[\.\d]+)(m?s))?(?:\s+([-a-z]+(?:\(.+?\))?))?$/i);
          if (null === s) return t.push(b9()), {
            duration: 0,
            delay: 0,
            easing: ""
          };
          i = dh(parseFloat(s[1]), s[2]);
          const c = s[3];
          null != c && (o = dh(parseFloat(c), s[4]));
          const l = s[5];
          l && (r = l);
        } else i = n;
        if (!e) {
          let s = !1,
            c = t.length;
          i < 0 && (t.push(function gL() {
            return new L(3100, !1);
          }()), s = !0), o < 0 && (t.push(function bL() {
            return new L(3101, !1);
          }()), s = !0), s && t.splice(c, 0, b9());
        }
        return {
          duration: i,
          delay: o,
          easing: r
        };
      }(n, t, e);
    }
    function Ic(n, t = {}) {
      return Object.keys(n).forEach(e => {
        t[e] = n[e];
      }), t;
    }
    function P9(n) {
      const t = new Map();
      return Object.keys(n).forEach(e => {
        t.set(e, n[e]);
      }), t;
    }
    function qi(n, t = new Map(), e) {
      if (e) for (let [a, i] of e) t.set(a, i);
      for (let [a, i] of n) t.set(a, i);
      return t;
    }
    function S9(n, t, e) {
      return e ? t + ":" + e + ";" : "";
    }
    function E9(n) {
      let t = "";
      for (let e = 0; e < n.style.length; e++) {
        const a = n.style.item(e);
        t += S9(0, a, n.style.getPropertyValue(a));
      }
      for (const e in n.style) n.style.hasOwnProperty(e) && !e.startsWith("_") && (t += S9(0, rN(e), n.style[e]));
      n.setAttribute("style", t);
    }
    function Ga(n, t, e) {
      n.style && (t.forEach((a, i) => {
        const o = fh(i);
        e && !e.has(i) && e.set(i, n.style[o]), n.style[o] = a;
      }), th() && E9(n));
    }
    function Po(n, t) {
      n.style && (t.forEach((e, a) => {
        const i = fh(a);
        n.style[i] = "";
      }), th() && E9(n));
    }
    function Rc(n) {
      return Array.isArray(n) ? 1 == n.length ? n[0] : h9(n) : n;
    }
    const uh = new RegExp("{{\\s*(.+?)\\s*}}", "g");
    function T9(n) {
      let t = [];
      if ("string" == typeof n) {
        let e;
        for (; e = uh.exec(n);) t.push(e[1]);
        uh.lastIndex = 0;
      }
      return t;
    }
    function zc(n, t, e) {
      const a = n.toString(),
        i = a.replace(uh, (o, r) => {
          let s = t[r];
          return null == s && (e.push(function vL(n) {
            return new L(3003, !1);
          }()), s = ""), s.toString();
        });
      return i == a ? n : i;
    }
    function Id(n) {
      const t = [];
      let e = n.next();
      for (; !e.done;) t.push(e.value), e = n.next();
      return t;
    }
    const oN = /-+([a-z0-9])/g;
    function fh(n) {
      return n.replace(oN, (...t) => t[1].toUpperCase());
    }
    function rN(n) {
      return n.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
    }
    function Nn(n, t, e) {
      switch (t.type) {
        case 7:
          return n.visitTrigger(t, e);
        case 0:
          return n.visitState(t, e);
        case 1:
          return n.visitTransition(t, e);
        case 2:
          return n.visitSequence(t, e);
        case 3:
          return n.visitGroup(t, e);
        case 4:
          return n.visitAnimate(t, e);
        case 5:
          return n.visitKeyframes(t, e);
        case 6:
          return n.visitStyle(t, e);
        case 8:
          return n.visitReference(t, e);
        case 9:
          return n.visitAnimateChild(t, e);
        case 10:
          return n.visitAnimateRef(t, e);
        case 11:
          return n.visitQuery(t, e);
        case 12:
          return n.visitStagger(t, e);
        default:
          throw function yL(n) {
            return new L(3004, !1);
          }();
      }
    }
    function I9(n, t) {
      return window.getComputedStyle(n)[t];
    }
    function fN(n, t) {
      const e = [];
      return "string" == typeof n ? n.split(/\s*,\s*/).forEach(a => function mN(n, t, e) {
        if (":" == n[0]) {
          const c = function hN(n, t) {
            switch (n) {
              case ":enter":
                return "void => *";
              case ":leave":
                return "* => void";
              case ":increment":
                return (e, a) => parseFloat(a) > parseFloat(e);
              case ":decrement":
                return (e, a) => parseFloat(a) < parseFloat(e);
              default:
                return t.push(function RL(n) {
                  return new L(3016, !1);
                }()), "* => *";
            }
          }(n, e);
          if ("function" == typeof c) return void t.push(c);
          n = c;
        }
        const a = n.match(/^(\*|[-\w]+)\s*(<?[=-]>)\s*(\*|[-\w]+)$/);
        if (null == a || a.length < 4) return e.push(function IL(n) {
          return new L(3015, !1);
        }()), t;
        const i = a[1],
          o = a[2],
          r = a[3];
        t.push(R9(i, r));
        "<" == o[0] && !("*" == i && "*" == r) && t.push(R9(r, i));
      }(a, e, t)) : e.push(n), e;
    }
    const Nd = new Set(["true", "1"]),
      Fd = new Set(["false", "0"]);
    function R9(n, t) {
      const e = Nd.has(n) || Fd.has(n),
        a = Nd.has(t) || Fd.has(t);
      return (i, o) => {
        let r = "*" == n || n == i,
          s = "*" == t || t == o;
        return !r && e && "boolean" == typeof i && (r = i ? Nd.has(n) : Fd.has(n)), !s && a && "boolean" == typeof o && (s = o ? Nd.has(t) : Fd.has(t)), r && s;
      };
    }
    const pN = new RegExp("s*:selfs*,?", "g");
    function mh(n, t, e, a) {
      return new gN(n).build(t, e, a);
    }
    class gN {
      constructor(t) {
        this._driver = t;
      }
      build(t, e, a) {
        const i = new vN(e);
        return this._resetContextStyleTimingState(i), Nn(this, Rc(t), i);
      }
      _resetContextStyleTimingState(t) {
        t.currentQuerySelector = "", t.collectedStyles = new Map(), t.collectedStyles.set("", new Map()), t.currentTime = 0;
      }
      visitTrigger(t, e) {
        let a = e.queryCount = 0,
          i = e.depCount = 0;
        const o = [],
          r = [];
        return "@" == t.name.charAt(0) && e.errors.push(function ML() {
          return new L(3006, !1);
        }()), t.definitions.forEach(s => {
          if (this._resetContextStyleTimingState(e), 0 == s.type) {
            const c = s,
              l = c.name;
            l.toString().split(/\s*,\s*/).forEach(d => {
              c.name = d, o.push(this.visitState(c, e));
            }), c.name = l;
          } else if (1 == s.type) {
            const c = this.visitTransition(s, e);
            a += c.queryCount, i += c.depCount, r.push(c);
          } else e.errors.push(function xL() {
            return new L(3007, !1);
          }());
        }), {
          type: 7,
          name: t.name,
          states: o,
          transitions: r,
          queryCount: a,
          depCount: i,
          options: null
        };
      }
      visitState(t, e) {
        const a = this.visitStyle(t.styles, e),
          i = t.options && t.options.params || null;
        if (a.containsDynamicStyles) {
          const o = new Set(),
            r = i || {};
          a.styles.forEach(s => {
            s instanceof Map && s.forEach(c => {
              T9(c).forEach(l => {
                r.hasOwnProperty(l) || o.add(l);
              });
            });
          }), o.size && (Id(o.values()), e.errors.push(function wL(n, t) {
            return new L(3008, !1);
          }()));
        }
        return {
          type: 0,
          name: t.name,
          style: a,
          options: i ? {
            params: i
          } : null
        };
      }
      visitTransition(t, e) {
        e.queryCount = 0, e.depCount = 0;
        const a = Nn(this, Rc(t.animation), e);
        return {
          type: 1,
          matchers: fN(t.expr, e.errors),
          animation: a,
          queryCount: e.queryCount,
          depCount: e.depCount,
          options: Ao(t.options)
        };
      }
      visitSequence(t, e) {
        return {
          type: 2,
          steps: t.steps.map(a => Nn(this, a, e)),
          options: Ao(t.options)
        };
      }
      visitGroup(t, e) {
        const a = e.currentTime;
        let i = 0;
        const o = t.steps.map(r => {
          e.currentTime = a;
          const s = Nn(this, r, e);
          return i = Math.max(i, e.currentTime), s;
        });
        return e.currentTime = i, {
          type: 3,
          steps: o,
          options: Ao(t.options)
        };
      }
      visitAnimate(t, e) {
        const a = function CN(n, t) {
          if (n.hasOwnProperty("duration")) return n;
          if ("number" == typeof n) return hh(Td(n, t).duration, 0, "");
          const e = n;
          if (e.split(/\s+/).some(o => "{" == o.charAt(0) && "{" == o.charAt(1))) {
            const o = hh(0, 0, "");
            return o.dynamic = !0, o.strValue = e, o;
          }
          const i = Td(e, t);
          return hh(i.duration, i.delay, i.easing);
        }(t.timings, e.errors);
        e.currentAnimateTimings = a;
        let i,
          o = t.styles ? t.styles : Z({});
        if (5 == o.type) i = this.visitKeyframes(o, e);else {
          let r = t.styles,
            s = !1;
          if (!r) {
            s = !0;
            const l = {};
            a.easing && (l.easing = a.easing), r = Z(l);
          }
          e.currentTime += a.duration + a.delay;
          const c = this.visitStyle(r, e);
          c.isEmptyStep = s, i = c;
        }
        return e.currentAnimateTimings = null, {
          type: 4,
          timings: a,
          style: i,
          options: null
        };
      }
      visitStyle(t, e) {
        const a = this._makeStyleAst(t, e);
        return this._validateStyleAst(a, e), a;
      }
      _makeStyleAst(t, e) {
        const a = [],
          i = Array.isArray(t.styles) ? t.styles : [t.styles];
        for (let s of i) "string" == typeof s ? s === bi ? a.push(s) : e.errors.push(new L(3002, !1)) : a.push(P9(s));
        let o = !1,
          r = null;
        return a.forEach(s => {
          if (s instanceof Map && (s.has("easing") && (r = s.get("easing"), s.delete("easing")), !o)) for (let c of s.values()) if (c.toString().indexOf("{{") >= 0) {
            o = !0;
            break;
          }
        }), {
          type: 6,
          styles: a,
          easing: r,
          offset: t.offset,
          containsDynamicStyles: o,
          options: null
        };
      }
      _validateStyleAst(t, e) {
        const a = e.currentAnimateTimings;
        let i = e.currentTime,
          o = e.currentTime;
        a && o > 0 && (o -= a.duration + a.delay), t.styles.forEach(r => {
          "string" != typeof r && r.forEach((s, c) => {
            const l = e.collectedStyles.get(e.currentQuerySelector),
              d = l.get(c);
            let u = !0;
            d && (o != i && o >= d.startTime && i <= d.endTime && (e.errors.push(function DL(n, t, e, a, i) {
              return new L(3010, !1);
            }()), u = !1), o = d.startTime), u && l.set(c, {
              startTime: o,
              endTime: i
            }), e.options && function iN(n, t, e) {
              const a = t.params || {},
                i = T9(n);
              i.length && i.forEach(o => {
                a.hasOwnProperty(o) || e.push(function _L(n) {
                  return new L(3001, !1);
                }());
              });
            }(s, e.options, e.errors);
          });
        });
      }
      visitKeyframes(t, e) {
        const a = {
          type: 5,
          styles: [],
          options: null
        };
        if (!e.currentAnimateTimings) return e.errors.push(function OL() {
          return new L(3011, !1);
        }()), a;
        let o = 0;
        const r = [];
        let s = !1,
          c = !1,
          l = 0;
        const d = t.steps.map(k => {
          const T = this._makeStyleAst(k, e);
          let w = null != T.offset ? T.offset : function yN(n) {
              if ("string" == typeof n) return null;
              let t = null;
              if (Array.isArray(n)) n.forEach(e => {
                if (e instanceof Map && e.has("offset")) {
                  const a = e;
                  t = parseFloat(a.get("offset")), a.delete("offset");
                }
              });else if (n instanceof Map && n.has("offset")) {
                const e = n;
                t = parseFloat(e.get("offset")), e.delete("offset");
              }
              return t;
            }(T.styles),
            N = 0;
          return null != w && (o++, N = T.offset = w), c = c || N < 0 || N > 1, s = s || N < l, l = N, r.push(N), T;
        });
        c && e.errors.push(function PL() {
          return new L(3012, !1);
        }()), s && e.errors.push(function AL() {
          return new L(3200, !1);
        }());
        const u = t.steps.length;
        let m = 0;
        o > 0 && o < u ? e.errors.push(function SL() {
          return new L(3202, !1);
        }()) : 0 == o && (m = 1 / (u - 1));
        const h = u - 1,
          p = e.currentTime,
          v = e.currentAnimateTimings,
          C = v.duration;
        return d.forEach((k, T) => {
          const w = m > 0 ? T == h ? 1 : m * T : r[T],
            N = w * C;
          e.currentTime = p + v.delay + N, v.duration = N, this._validateStyleAst(k, e), k.offset = w, a.styles.push(k);
        }), a;
      }
      visitReference(t, e) {
        return {
          type: 8,
          animation: Nn(this, Rc(t.animation), e),
          options: Ao(t.options)
        };
      }
      visitAnimateChild(t, e) {
        return e.depCount++, {
          type: 9,
          options: Ao(t.options)
        };
      }
      visitAnimateRef(t, e) {
        return {
          type: 10,
          animation: this.visitReference(t.animation, e),
          options: Ao(t.options)
        };
      }
      visitQuery(t, e) {
        const a = e.currentQuerySelector,
          i = t.options || {};
        e.queryCount++, e.currentQuery = t;
        const [o, r] = function bN(n) {
          const t = !!n.split(/\s*,\s*/).find(e => ":self" == e);
          return t && (n = n.replace(pN, "")), n = n.replace(/@\*/g, Ed).replace(/@\w+/g, e => Ed + "-" + e.slice(1)).replace(/:animating/g, lh), [n, t];
        }(t.selector);
        e.currentQuerySelector = a.length ? a + " " + o : o, Ln(e.collectedStyles, e.currentQuerySelector, new Map());
        const s = Nn(this, Rc(t.animation), e);
        return e.currentQuery = null, e.currentQuerySelector = a, {
          type: 11,
          selector: o,
          limit: i.limit || 0,
          optional: !!i.optional,
          includeSelf: r,
          animation: s,
          originalSelector: t.selector,
          options: Ao(t.options)
        };
      }
      visitStagger(t, e) {
        e.currentQuery || e.errors.push(function EL() {
          return new L(3013, !1);
        }());
        const a = "full" === t.timings ? {
          duration: 0,
          delay: 0,
          easing: "full"
        } : Td(t.timings, e.errors, !0);
        return {
          type: 12,
          animation: Nn(this, Rc(t.animation), e),
          timings: a,
          options: null
        };
      }
    }
    class vN {
      constructor(t) {
        this.errors = t, this.queryCount = 0, this.depCount = 0, this.currentTransition = null, this.currentQuery = null, this.currentQuerySelector = null, this.currentAnimateTimings = null, this.currentTime = 0, this.collectedStyles = new Map(), this.options = null, this.unsupportedCSSPropertiesFound = new Set();
      }
    }
    function Ao(n) {
      return n ? (n = Ic(n)).params && (n.params = function _N(n) {
        return n ? Ic(n) : null;
      }(n.params)) : n = {}, n;
    }
    function hh(n, t, e) {
      return {
        duration: n,
        delay: t,
        easing: e
      };
    }
    function ph(n, t, e, a, i, o, r = null, s = !1) {
      return {
        type: 1,
        element: n,
        keyframes: t,
        preStyleProps: e,
        postStyleProps: a,
        duration: i,
        delay: o,
        totalTime: i + o,
        easing: r,
        subTimeline: s
      };
    }
    class Vd {
      constructor() {
        this._map = new Map();
      }
      get(t) {
        return this._map.get(t) || [];
      }
      append(t, e) {
        let a = this._map.get(t);
        a || this._map.set(t, a = []), a.push(...e);
      }
      has(t) {
        return this._map.has(t);
      }
      clear() {
        this._map.clear();
      }
    }
    const wN = new RegExp(":enter", "g"),
      DN = new RegExp(":leave", "g");
    function gh(n, t, e, a, i, o = new Map(), r = new Map(), s, c, l = []) {
      return new ON().buildKeyframes(n, t, e, a, i, o, r, s, c, l);
    }
    class ON {
      buildKeyframes(t, e, a, i, o, r, s, c, l, d = []) {
        l = l || new Vd();
        const u = new bh(t, e, l, i, o, d, []);
        u.options = c;
        const m = c.delay ? _i(c.delay) : 0;
        u.currentTimeline.delayNextStep(m), u.currentTimeline.setStyles([r], null, u.errors, c), Nn(this, a, u);
        const h = u.timelines.filter(p => p.containsAnimation());
        if (h.length && s.size) {
          let p;
          for (let v = h.length - 1; v >= 0; v--) {
            const C = h[v];
            if (C.element === e) {
              p = C;
              break;
            }
          }
          p && !p.allowOnlyTimelineStyles() && p.setStyles([s], null, u.errors, c);
        }
        return h.length ? h.map(p => p.buildKeyframes()) : [ph(e, [], [], [], 0, m, "", !1)];
      }
      visitTrigger(t, e) {}
      visitState(t, e) {}
      visitTransition(t, e) {}
      visitAnimateChild(t, e) {
        const a = e.subInstructions.get(e.element);
        if (a) {
          const i = e.createSubContext(t.options),
            o = e.currentTimeline.currentTime,
            r = this._visitSubInstructions(a, i, i.options);
          o != r && e.transformIntoNewTimeline(r);
        }
        e.previousNode = t;
      }
      visitAnimateRef(t, e) {
        const a = e.createSubContext(t.options);
        a.transformIntoNewTimeline(), this._applyAnimationRefDelays([t.options, t.animation.options], e, a), this.visitReference(t.animation, a), e.transformIntoNewTimeline(a.currentTimeline.currentTime), e.previousNode = t;
      }
      _applyAnimationRefDelays(t, e, a) {
        for (const i of t) {
          const o = i?.delay;
          if (o) {
            const r = "number" == typeof o ? o : _i(zc(o, i?.params ?? {}, e.errors));
            a.delayNextStep(r);
          }
        }
      }
      _visitSubInstructions(t, e, a) {
        let o = e.currentTimeline.currentTime;
        const r = null != a.duration ? _i(a.duration) : null,
          s = null != a.delay ? _i(a.delay) : null;
        return 0 !== r && t.forEach(c => {
          const l = e.appendInstructionToTimeline(c, r, s);
          o = Math.max(o, l.duration + l.delay);
        }), o;
      }
      visitReference(t, e) {
        e.updateOptions(t.options, !0), Nn(this, t.animation, e), e.previousNode = t;
      }
      visitSequence(t, e) {
        const a = e.subContextCount;
        let i = e;
        const o = t.options;
        if (o && (o.params || o.delay) && (i = e.createSubContext(o), i.transformIntoNewTimeline(), null != o.delay)) {
          6 == i.previousNode.type && (i.currentTimeline.snapshotCurrentStyles(), i.previousNode = Hd);
          const r = _i(o.delay);
          i.delayNextStep(r);
        }
        t.steps.length && (t.steps.forEach(r => Nn(this, r, i)), i.currentTimeline.applyStylesToKeyframe(), i.subContextCount > a && i.transformIntoNewTimeline()), e.previousNode = t;
      }
      visitGroup(t, e) {
        const a = [];
        let i = e.currentTimeline.currentTime;
        const o = t.options && t.options.delay ? _i(t.options.delay) : 0;
        t.steps.forEach(r => {
          const s = e.createSubContext(t.options);
          o && s.delayNextStep(o), Nn(this, r, s), i = Math.max(i, s.currentTimeline.currentTime), a.push(s.currentTimeline);
        }), a.forEach(r => e.currentTimeline.mergeTimelineCollectedStyles(r)), e.transformIntoNewTimeline(i), e.previousNode = t;
      }
      _visitTiming(t, e) {
        if (t.dynamic) {
          const a = t.strValue;
          return Td(e.params ? zc(a, e.params, e.errors) : a, e.errors);
        }
        return {
          duration: t.duration,
          delay: t.delay,
          easing: t.easing
        };
      }
      visitAnimate(t, e) {
        const a = e.currentAnimateTimings = this._visitTiming(t.timings, e),
          i = e.currentTimeline;
        a.delay && (e.incrementTime(a.delay), i.snapshotCurrentStyles());
        const o = t.style;
        5 == o.type ? this.visitKeyframes(o, e) : (e.incrementTime(a.duration), this.visitStyle(o, e), i.applyStylesToKeyframe()), e.currentAnimateTimings = null, e.previousNode = t;
      }
      visitStyle(t, e) {
        const a = e.currentTimeline,
          i = e.currentAnimateTimings;
        !i && a.hasCurrentStyleProperties() && a.forwardFrame();
        const o = i && i.easing || t.easing;
        t.isEmptyStep ? a.applyEmptyStep(o) : a.setStyles(t.styles, o, e.errors, e.options), e.previousNode = t;
      }
      visitKeyframes(t, e) {
        const a = e.currentAnimateTimings,
          i = e.currentTimeline.duration,
          o = a.duration,
          s = e.createSubContext().currentTimeline;
        s.easing = a.easing, t.styles.forEach(c => {
          s.forwardTime((c.offset || 0) * o), s.setStyles(c.styles, c.easing, e.errors, e.options), s.applyStylesToKeyframe();
        }), e.currentTimeline.mergeTimelineCollectedStyles(s), e.transformIntoNewTimeline(i + o), e.previousNode = t;
      }
      visitQuery(t, e) {
        const a = e.currentTimeline.currentTime,
          i = t.options || {},
          o = i.delay ? _i(i.delay) : 0;
        o && (6 === e.previousNode.type || 0 == a && e.currentTimeline.hasCurrentStyleProperties()) && (e.currentTimeline.snapshotCurrentStyles(), e.previousNode = Hd);
        let r = a;
        const s = e.invokeQuery(t.selector, t.originalSelector, t.limit, t.includeSelf, !!i.optional, e.errors);
        e.currentQueryTotal = s.length;
        let c = null;
        s.forEach((l, d) => {
          e.currentQueryIndex = d;
          const u = e.createSubContext(t.options, l);
          o && u.delayNextStep(o), l === e.element && (c = u.currentTimeline), Nn(this, t.animation, u), u.currentTimeline.applyStylesToKeyframe(), r = Math.max(r, u.currentTimeline.currentTime);
        }), e.currentQueryIndex = 0, e.currentQueryTotal = 0, e.transformIntoNewTimeline(r), c && (e.currentTimeline.mergeTimelineCollectedStyles(c), e.currentTimeline.snapshotCurrentStyles()), e.previousNode = t;
      }
      visitStagger(t, e) {
        const a = e.parentContext,
          i = e.currentTimeline,
          o = t.timings,
          r = Math.abs(o.duration),
          s = r * (e.currentQueryTotal - 1);
        let c = r * e.currentQueryIndex;
        switch (o.duration < 0 ? "reverse" : o.easing) {
          case "reverse":
            c = s - c;
            break;
          case "full":
            c = a.currentStaggerTime;
        }
        const d = e.currentTimeline;
        c && d.delayNextStep(c);
        const u = d.currentTime;
        Nn(this, t.animation, e), e.previousNode = t, a.currentStaggerTime = i.currentTime - u + (i.startTime - a.currentTimeline.startTime);
      }
    }
    const Hd = {};
    class bh {
      constructor(t, e, a, i, o, r, s, c) {
        this._driver = t, this.element = e, this.subInstructions = a, this._enterClassName = i, this._leaveClassName = o, this.errors = r, this.timelines = s, this.parentContext = null, this.currentAnimateTimings = null, this.previousNode = Hd, this.subContextCount = 0, this.options = {}, this.currentQueryIndex = 0, this.currentQueryTotal = 0, this.currentStaggerTime = 0, this.currentTimeline = c || new Bd(this._driver, e, 0), s.push(this.currentTimeline);
      }
      get params() {
        return this.options.params;
      }
      updateOptions(t, e) {
        if (!t) return;
        const a = t;
        let i = this.options;
        null != a.duration && (i.duration = _i(a.duration)), null != a.delay && (i.delay = _i(a.delay));
        const o = a.params;
        if (o) {
          let r = i.params;
          r || (r = this.options.params = {}), Object.keys(o).forEach(s => {
            (!e || !r.hasOwnProperty(s)) && (r[s] = zc(o[s], r, this.errors));
          });
        }
      }
      _copyOptions() {
        const t = {};
        if (this.options) {
          const e = this.options.params;
          if (e) {
            const a = t.params = {};
            Object.keys(e).forEach(i => {
              a[i] = e[i];
            });
          }
        }
        return t;
      }
      createSubContext(t = null, e, a) {
        const i = e || this.element,
          o = new bh(this._driver, i, this.subInstructions, this._enterClassName, this._leaveClassName, this.errors, this.timelines, this.currentTimeline.fork(i, a || 0));
        return o.previousNode = this.previousNode, o.currentAnimateTimings = this.currentAnimateTimings, o.options = this._copyOptions(), o.updateOptions(t), o.currentQueryIndex = this.currentQueryIndex, o.currentQueryTotal = this.currentQueryTotal, o.parentContext = this, this.subContextCount++, o;
      }
      transformIntoNewTimeline(t) {
        return this.previousNode = Hd, this.currentTimeline = this.currentTimeline.fork(this.element, t), this.timelines.push(this.currentTimeline), this.currentTimeline;
      }
      appendInstructionToTimeline(t, e, a) {
        const i = {
            duration: e ?? t.duration,
            delay: this.currentTimeline.currentTime + (a ?? 0) + t.delay,
            easing: ""
          },
          o = new PN(this._driver, t.element, t.keyframes, t.preStyleProps, t.postStyleProps, i, t.stretchStartingKeyframe);
        return this.timelines.push(o), i;
      }
      incrementTime(t) {
        this.currentTimeline.forwardTime(this.currentTimeline.duration + t);
      }
      delayNextStep(t) {
        t > 0 && this.currentTimeline.delayNextStep(t);
      }
      invokeQuery(t, e, a, i, o, r) {
        let s = [];
        if (i && s.push(this.element), t.length > 0) {
          t = (t = t.replace(wN, "." + this._enterClassName)).replace(DN, "." + this._leaveClassName);
          let l = this._driver.query(this.element, t, 1 != a);
          0 !== a && (l = a < 0 ? l.slice(l.length + a, l.length) : l.slice(0, a)), s.push(...l);
        }
        return !o && 0 == s.length && r.push(function TL(n) {
          return new L(3014, !1);
        }()), s;
      }
    }
    class Bd {
      constructor(t, e, a, i) {
        this._driver = t, this.element = e, this.startTime = a, this._elementTimelineStylesLookup = i, this.duration = 0, this._previousKeyframe = new Map(), this._currentKeyframe = new Map(), this._keyframes = new Map(), this._styleSummary = new Map(), this._localTimelineStyles = new Map(), this._pendingStyles = new Map(), this._backFill = new Map(), this._currentEmptyStepKeyframe = null, this._elementTimelineStylesLookup || (this._elementTimelineStylesLookup = new Map()), this._globalTimelineStyles = this._elementTimelineStylesLookup.get(e), this._globalTimelineStyles || (this._globalTimelineStyles = this._localTimelineStyles, this._elementTimelineStylesLookup.set(e, this._localTimelineStyles)), this._loadKeyframe();
      }
      containsAnimation() {
        switch (this._keyframes.size) {
          case 0:
            return !1;
          case 1:
            return this.hasCurrentStyleProperties();
          default:
            return !0;
        }
      }
      hasCurrentStyleProperties() {
        return this._currentKeyframe.size > 0;
      }
      get currentTime() {
        return this.startTime + this.duration;
      }
      delayNextStep(t) {
        const e = 1 === this._keyframes.size && this._pendingStyles.size;
        this.duration || e ? (this.forwardTime(this.currentTime + t), e && this.snapshotCurrentStyles()) : this.startTime += t;
      }
      fork(t, e) {
        return this.applyStylesToKeyframe(), new Bd(this._driver, t, e || this.currentTime, this._elementTimelineStylesLookup);
      }
      _loadKeyframe() {
        this._currentKeyframe && (this._previousKeyframe = this._currentKeyframe), this._currentKeyframe = this._keyframes.get(this.duration), this._currentKeyframe || (this._currentKeyframe = new Map(), this._keyframes.set(this.duration, this._currentKeyframe));
      }
      forwardFrame() {
        this.duration += 1, this._loadKeyframe();
      }
      forwardTime(t) {
        this.applyStylesToKeyframe(), this.duration = t, this._loadKeyframe();
      }
      _updateStyle(t, e) {
        this._localTimelineStyles.set(t, e), this._globalTimelineStyles.set(t, e), this._styleSummary.set(t, {
          time: this.currentTime,
          value: e
        });
      }
      allowOnlyTimelineStyles() {
        return this._currentEmptyStepKeyframe !== this._currentKeyframe;
      }
      applyEmptyStep(t) {
        t && this._previousKeyframe.set("easing", t);
        for (let [e, a] of this._globalTimelineStyles) this._backFill.set(e, a || bi), this._currentKeyframe.set(e, bi);
        this._currentEmptyStepKeyframe = this._currentKeyframe;
      }
      setStyles(t, e, a, i) {
        e && this._previousKeyframe.set("easing", e);
        const o = i && i.params || {},
          r = function AN(n, t) {
            const e = new Map();
            let a;
            return n.forEach(i => {
              if ("*" === i) {
                a = a || t.keys();
                for (let o of a) e.set(o, bi);
              } else qi(i, e);
            }), e;
          }(t, this._globalTimelineStyles);
        for (let [s, c] of r) {
          const l = zc(c, o, a);
          this._pendingStyles.set(s, l), this._localTimelineStyles.has(s) || this._backFill.set(s, this._globalTimelineStyles.get(s) ?? bi), this._updateStyle(s, l);
        }
      }
      applyStylesToKeyframe() {
        0 != this._pendingStyles.size && (this._pendingStyles.forEach((t, e) => {
          this._currentKeyframe.set(e, t);
        }), this._pendingStyles.clear(), this._localTimelineStyles.forEach((t, e) => {
          this._currentKeyframe.has(e) || this._currentKeyframe.set(e, t);
        }));
      }
      snapshotCurrentStyles() {
        for (let [t, e] of this._localTimelineStyles) this._pendingStyles.set(t, e), this._updateStyle(t, e);
      }
      getFinalKeyframe() {
        return this._keyframes.get(this.duration);
      }
      get properties() {
        const t = [];
        for (let e in this._currentKeyframe) t.push(e);
        return t;
      }
      mergeTimelineCollectedStyles(t) {
        t._styleSummary.forEach((e, a) => {
          const i = this._styleSummary.get(a);
          (!i || e.time > i.time) && this._updateStyle(a, e.value);
        });
      }
      buildKeyframes() {
        this.applyStylesToKeyframe();
        const t = new Set(),
          e = new Set(),
          a = 1 === this._keyframes.size && 0 === this.duration;
        let i = [];
        this._keyframes.forEach((s, c) => {
          const l = qi(s, new Map(), this._backFill);
          l.forEach((d, u) => {
            "!" === d ? t.add(u) : d === bi && e.add(u);
          }), a || l.set("offset", c / this.duration), i.push(l);
        });
        const o = t.size ? Id(t.values()) : [],
          r = e.size ? Id(e.values()) : [];
        if (a) {
          const s = i[0],
            c = new Map(s);
          s.set("offset", 0), c.set("offset", 1), i = [s, c];
        }
        return ph(this.element, i, o, r, this.duration, this.startTime, this.easing, !1);
      }
    }
    class PN extends Bd {
      constructor(t, e, a, i, o, r, s = !1) {
        super(t, e, r.delay), this.keyframes = a, this.preStyleProps = i, this.postStyleProps = o, this._stretchStartingKeyframe = s, this.timings = {
          duration: r.duration,
          delay: r.delay,
          easing: r.easing
        };
      }
      containsAnimation() {
        return this.keyframes.length > 1;
      }
      buildKeyframes() {
        let t = this.keyframes,
          {
            delay: e,
            duration: a,
            easing: i
          } = this.timings;
        if (this._stretchStartingKeyframe && e) {
          const o = [],
            r = a + e,
            s = e / r,
            c = qi(t[0]);
          c.set("offset", 0), o.push(c);
          const l = qi(t[0]);
          l.set("offset", N9(s)), o.push(l);
          const d = t.length - 1;
          for (let u = 1; u <= d; u++) {
            let m = qi(t[u]);
            const h = m.get("offset");
            m.set("offset", N9((e + h * a) / r)), o.push(m);
          }
          a = r, e = 0, i = "", t = o;
        }
        return ph(this.element, t, this.preStyleProps, this.postStyleProps, a, e, i, !0);
      }
    }
    function N9(n, t = 3) {
      const e = Math.pow(10, t - 1);
      return Math.round(n * e) / e;
    }
    class _h {}
    const SN = new Set(["width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "left", "top", "bottom", "right", "fontSize", "outlineWidth", "outlineOffset", "paddingTop", "paddingLeft", "paddingBottom", "paddingRight", "marginTop", "marginLeft", "marginBottom", "marginRight", "borderRadius", "borderWidth", "borderTopWidth", "borderLeftWidth", "borderRightWidth", "borderBottomWidth", "textIndent", "perspective"]);
    class EN extends _h {
      normalizePropertyName(t, e) {
        return fh(t);
      }
      normalizeStyleValue(t, e, a, i) {
        let o = "";
        const r = a.toString().trim();
        if (SN.has(e) && 0 !== a && "0" !== a) if ("number" == typeof a) o = "px";else {
          const s = a.match(/^[+-]?[\d\.]+([a-z]*)$/);
          s && 0 == s[1].length && i.push(function CL(n, t) {
            return new L(3005, !1);
          }());
        }
        return r + o;
      }
    }
    function F9(n, t, e, a, i, o, r, s, c, l, d, u, m) {
      return {
        type: 0,
        element: n,
        triggerName: t,
        isRemovalTransition: i,
        fromState: e,
        fromStyles: o,
        toState: a,
        toStyles: r,
        timelines: s,
        queriedElements: c,
        preStyleProps: l,
        postStyleProps: d,
        totalTime: u,
        errors: m
      };
    }
    const vh = {};
    class V9 {
      constructor(t, e, a) {
        this._triggerName = t, this.ast = e, this._stateStyles = a;
      }
      match(t, e, a, i) {
        return function TN(n, t, e, a, i) {
          return n.some(o => o(t, e, a, i));
        }(this.ast.matchers, t, e, a, i);
      }
      buildStyles(t, e, a) {
        let i = this._stateStyles.get("*");
        return void 0 !== t && (i = this._stateStyles.get(t?.toString()) || i), i ? i.buildStyles(e, a) : new Map();
      }
      build(t, e, a, i, o, r, s, c, l, d) {
        const u = [],
          m = this.ast.options && this.ast.options.params || vh,
          p = this.buildStyles(a, s && s.params || vh, u),
          v = c && c.params || vh,
          C = this.buildStyles(i, v, u),
          k = new Set(),
          T = new Map(),
          w = new Map(),
          N = "void" === i,
          le = {
            params: IN(v, m),
            delay: this.ast.options?.delay
          },
          Ce = d ? [] : gh(t, e, this.ast.animation, o, r, p, C, le, l, u);
        let rt = 0;
        if (Ce.forEach(bn => {
          rt = Math.max(bn.duration + bn.delay, rt);
        }), u.length) return F9(e, this._triggerName, a, i, N, p, C, [], [], T, w, rt, u);
        Ce.forEach(bn => {
          const Wt = bn.element,
            Is = Ln(T, Wt, new Set());
          bn.preStyleProps.forEach(Ia => Is.add(Ia));
          const Ri = Ln(w, Wt, new Set());
          bn.postStyleProps.forEach(Ia => Ri.add(Ia)), Wt !== e && k.add(Wt);
        });
        const gn = Id(k.values());
        return F9(e, this._triggerName, a, i, N, p, C, Ce, gn, T, w, rt);
      }
    }
    function IN(n, t) {
      const e = Ic(t);
      for (const a in n) n.hasOwnProperty(a) && null != n[a] && (e[a] = n[a]);
      return e;
    }
    class RN {
      constructor(t, e, a) {
        this.styles = t, this.defaultParams = e, this.normalizer = a;
      }
      buildStyles(t, e) {
        const a = new Map(),
          i = Ic(this.defaultParams);
        return Object.keys(t).forEach(o => {
          const r = t[o];
          null !== r && (i[o] = r);
        }), this.styles.styles.forEach(o => {
          "string" != typeof o && o.forEach((r, s) => {
            r && (r = zc(r, i, e));
            const c = this.normalizer.normalizePropertyName(s, e);
            r = this.normalizer.normalizeStyleValue(s, c, r, e), a.set(c, r);
          });
        }), a;
      }
    }
    class LN {
      constructor(t, e, a) {
        this.name = t, this.ast = e, this._normalizer = a, this.transitionFactories = [], this.states = new Map(), e.states.forEach(i => {
          this.states.set(i.name, new RN(i.style, i.options && i.options.params || {}, a));
        }), H9(this.states, "true", "1"), H9(this.states, "false", "0"), e.transitions.forEach(i => {
          this.transitionFactories.push(new V9(t, i, this.states));
        }), this.fallbackTransition = function NN(n, t, e) {
          return new V9(n, {
            type: 1,
            animation: {
              type: 2,
              steps: [],
              options: null
            },
            matchers: [(r, s) => !0],
            options: null,
            queryCount: 0,
            depCount: 0
          }, t);
        }(t, this.states);
      }
      get containsQueries() {
        return this.ast.queryCount > 0;
      }
      matchTransition(t, e, a, i) {
        return this.transitionFactories.find(r => r.match(t, e, a, i)) || null;
      }
      matchStyles(t, e, a) {
        return this.fallbackTransition.buildStyles(t, e, a);
      }
    }
    function H9(n, t, e) {
      n.has(t) ? n.has(e) || n.set(e, n.get(t)) : n.has(e) && n.set(t, n.get(e));
    }
    const FN = new Vd();
    class VN {
      constructor(t, e, a) {
        this.bodyNode = t, this._driver = e, this._normalizer = a, this._animations = new Map(), this._playersById = new Map(), this.players = [];
      }
      register(t, e) {
        const a = [],
          o = mh(this._driver, e, a, []);
        if (a.length) throw function VL(n) {
          return new L(3503, !1);
        }();
        this._animations.set(t, o);
      }
      _buildPlayer(t, e, a) {
        const i = t.element,
          o = _9(0, this._normalizer, 0, t.keyframes, e, a);
        return this._driver.animate(i, o, t.duration, t.delay, t.easing, [], !0);
      }
      create(t, e, a = {}) {
        const i = [],
          o = this._animations.get(t);
        let r;
        const s = new Map();
        if (o ? (r = gh(this._driver, e, o, ch, Ad, new Map(), new Map(), a, FN, i), r.forEach(d => {
          const u = Ln(s, d.element, new Map());
          d.postStyleProps.forEach(m => u.set(m, null));
        })) : (i.push(function HL() {
          return new L(3300, !1);
        }()), r = []), i.length) throw function BL(n) {
          return new L(3504, !1);
        }();
        s.forEach((d, u) => {
          d.forEach((m, h) => {
            d.set(h, this._driver.computeStyle(u, h, bi));
          });
        });
        const l = Yi(r.map(d => {
          const u = s.get(d.element);
          return this._buildPlayer(d, new Map(), u);
        }));
        return this._playersById.set(t, l), l.onDestroy(() => this.destroy(t)), this.players.push(l), l;
      }
      destroy(t) {
        const e = this._getPlayer(t);
        e.destroy(), this._playersById.delete(t);
        const a = this.players.indexOf(e);
        a >= 0 && this.players.splice(a, 1);
      }
      _getPlayer(t) {
        const e = this._playersById.get(t);
        if (!e) throw function jL(n) {
          return new L(3301, !1);
        }();
        return e;
      }
      listen(t, e, a, i) {
        const o = ih(e, "", "", "");
        return nh(this._getPlayer(t), a, o, i), () => {};
      }
      command(t, e, a, i) {
        if ("register" == a) return void this.register(t, i[0]);
        if ("create" == a) return void this.create(t, e, i[0] || {});
        const o = this._getPlayer(t);
        switch (a) {
          case "play":
            o.play();
            break;
          case "pause":
            o.pause();
            break;
          case "reset":
            o.reset();
            break;
          case "restart":
            o.restart();
            break;
          case "finish":
            o.finish();
            break;
          case "init":
            o.init();
            break;
          case "setPosition":
            o.setPosition(parseFloat(i[0]));
            break;
          case "destroy":
            this.destroy(t);
        }
      }
    }
    const B9 = "ng-animate-queued",
      yh = "ng-animate-disabled",
      GN = [],
      j9 = {
        namespaceId: "",
        setForRemoval: !1,
        setForMove: !1,
        hasAnimation: !1,
        removedBeforeQueried: !1
      },
      WN = {
        namespaceId: "",
        setForMove: !1,
        setForRemoval: !1,
        hasAnimation: !1,
        removedBeforeQueried: !0
      },
      ta = "__ng_removed";
    class Ch {
      constructor(t, e = "") {
        this.namespaceId = e;
        const a = t && t.hasOwnProperty("value");
        if (this.value = function QN(n) {
          return n ?? null;
        }(a ? t.value : t), a) {
          const o = Ic(t);
          delete o.value, this.options = o;
        } else this.options = {};
        this.options.params || (this.options.params = {});
      }
      get params() {
        return this.options.params;
      }
      absorbOptions(t) {
        const e = t.params;
        if (e) {
          const a = this.options.params;
          Object.keys(e).forEach(i => {
            null == a[i] && (a[i] = e[i]);
          });
        }
      }
    }
    const Lc = "void",
      Mh = new Ch(Lc);
    class YN {
      constructor(t, e, a) {
        this.id = t, this.hostElement = e, this._engine = a, this.players = [], this._triggers = new Map(), this._queue = [], this._elementListeners = new Map(), this._hostClassName = "ng-tns-" + t, na(e, this._hostClassName);
      }
      listen(t, e, a, i) {
        if (!this._triggers.has(e)) throw function UL(n, t) {
          return new L(3302, !1);
        }();
        if (null == a || 0 == a.length) throw function GL(n) {
          return new L(3303, !1);
        }();
        if (!function ZN(n) {
          return "start" == n || "done" == n;
        }(a)) throw function WL(n, t) {
          return new L(3400, !1);
        }();
        const o = Ln(this._elementListeners, t, []),
          r = {
            name: e,
            phase: a,
            callback: i
          };
        o.push(r);
        const s = Ln(this._engine.statesByElement, t, new Map());
        return s.has(e) || (na(t, Sd), na(t, Sd + "-" + e), s.set(e, Mh)), () => {
          this._engine.afterFlush(() => {
            const c = o.indexOf(r);
            c >= 0 && o.splice(c, 1), this._triggers.has(e) || s.delete(e);
          });
        };
      }
      register(t, e) {
        return !this._triggers.has(t) && (this._triggers.set(t, e), !0);
      }
      _getTrigger(t) {
        const e = this._triggers.get(t);
        if (!e) throw function YL(n) {
          return new L(3401, !1);
        }();
        return e;
      }
      trigger(t, e, a, i = !0) {
        const o = this._getTrigger(e),
          r = new xh(this.id, e, t);
        let s = this._engine.statesByElement.get(t);
        s || (na(t, Sd), na(t, Sd + "-" + e), this._engine.statesByElement.set(t, s = new Map()));
        let c = s.get(e);
        const l = new Ch(a, this.id);
        if (!(a && a.hasOwnProperty("value")) && c && l.absorbOptions(c.options), s.set(e, l), c || (c = Mh), l.value !== Lc && c.value === l.value) {
          if (!function $N(n, t) {
            const e = Object.keys(n),
              a = Object.keys(t);
            if (e.length != a.length) return !1;
            for (let i = 0; i < e.length; i++) {
              const o = e[i];
              if (!t.hasOwnProperty(o) || n[o] !== t[o]) return !1;
            }
            return !0;
          }(c.params, l.params)) {
            const v = [],
              C = o.matchStyles(c.value, c.params, v),
              k = o.matchStyles(l.value, l.params, v);
            v.length ? this._engine.reportError(v) : this._engine.afterFlush(() => {
              Po(t, C), Ga(t, k);
            });
          }
          return;
        }
        const m = Ln(this._engine.playersByElement, t, []);
        m.forEach(v => {
          v.namespaceId == this.id && v.triggerName == e && v.queued && v.destroy();
        });
        let h = o.matchTransition(c.value, l.value, t, l.params),
          p = !1;
        if (!h) {
          if (!i) return;
          h = o.fallbackTransition, p = !0;
        }
        return this._engine.totalQueuedPlayers++, this._queue.push({
          element: t,
          triggerName: e,
          transition: h,
          fromState: c,
          toState: l,
          player: r,
          isFallbackTransition: p
        }), p || (na(t, B9), r.onStart(() => {
          Kr(t, B9);
        })), r.onDone(() => {
          let v = this.players.indexOf(r);
          v >= 0 && this.players.splice(v, 1);
          const C = this._engine.playersByElement.get(t);
          if (C) {
            let k = C.indexOf(r);
            k >= 0 && C.splice(k, 1);
          }
        }), this.players.push(r), m.push(r), r;
      }
      deregister(t) {
        this._triggers.delete(t), this._engine.statesByElement.forEach(e => e.delete(t)), this._elementListeners.forEach((e, a) => {
          this._elementListeners.set(a, e.filter(i => i.name != t));
        });
      }
      clearElementCache(t) {
        this._engine.statesByElement.delete(t), this._elementListeners.delete(t);
        const e = this._engine.playersByElement.get(t);
        e && (e.forEach(a => a.destroy()), this._engine.playersByElement.delete(t));
      }
      _signalRemovalForInnerTriggers(t, e) {
        const a = this._engine.driver.query(t, Ed, !0);
        a.forEach(i => {
          if (i[ta]) return;
          const o = this._engine.fetchNamespacesByElement(i);
          o.size ? o.forEach(r => r.triggerLeaveAnimation(i, e, !1, !0)) : this.clearElementCache(i);
        }), this._engine.afterFlushAnimationsDone(() => a.forEach(i => this.clearElementCache(i)));
      }
      triggerLeaveAnimation(t, e, a, i) {
        const o = this._engine.statesByElement.get(t),
          r = new Map();
        if (o) {
          const s = [];
          if (o.forEach((c, l) => {
            if (r.set(l, c.value), this._triggers.has(l)) {
              const d = this.trigger(t, l, Lc, i);
              d && s.push(d);
            }
          }), s.length) return this._engine.markElementAsRemoved(this.id, t, !0, e, r), a && Yi(s).onDone(() => this._engine.processLeaveNode(t)), !0;
        }
        return !1;
      }
      prepareLeaveAnimationListeners(t) {
        const e = this._elementListeners.get(t),
          a = this._engine.statesByElement.get(t);
        if (e && a) {
          const i = new Set();
          e.forEach(o => {
            const r = o.name;
            if (i.has(r)) return;
            i.add(r);
            const c = this._triggers.get(r).fallbackTransition,
              l = a.get(r) || Mh,
              d = new Ch(Lc),
              u = new xh(this.id, r, t);
            this._engine.totalQueuedPlayers++, this._queue.push({
              element: t,
              triggerName: r,
              transition: c,
              fromState: l,
              toState: d,
              player: u,
              isFallbackTransition: !0
            });
          });
        }
      }
      removeNode(t, e) {
        const a = this._engine;
        if (t.childElementCount && this._signalRemovalForInnerTriggers(t, e), this.triggerLeaveAnimation(t, e, !0)) return;
        let i = !1;
        if (a.totalAnimations) {
          const o = a.players.length ? a.playersByQueriedElement.get(t) : [];
          if (o && o.length) i = !0;else {
            let r = t;
            for (; r = r.parentNode;) if (a.statesByElement.get(r)) {
              i = !0;
              break;
            }
          }
        }
        if (this.prepareLeaveAnimationListeners(t), i) a.markElementAsRemoved(this.id, t, !1, e);else {
          const o = t[ta];
          (!o || o === j9) && (a.afterFlush(() => this.clearElementCache(t)), a.destroyInnerAnimations(t), a._onRemovalComplete(t, e));
        }
      }
      insertNode(t, e) {
        na(t, this._hostClassName);
      }
      drainQueuedTransitions(t) {
        const e = [];
        return this._queue.forEach(a => {
          const i = a.player;
          if (i.destroyed) return;
          const o = a.element,
            r = this._elementListeners.get(o);
          r && r.forEach(s => {
            if (s.name == a.triggerName) {
              const c = ih(o, a.triggerName, a.fromState.value, a.toState.value);
              c._data = t, nh(a.player, s.phase, c, s.callback);
            }
          }), i.markedForDestroy ? this._engine.afterFlush(() => {
            i.destroy();
          }) : e.push(a);
        }), this._queue = [], e.sort((a, i) => {
          const o = a.transition.ast.depCount,
            r = i.transition.ast.depCount;
          return 0 == o || 0 == r ? o - r : this._engine.driver.containsElement(a.element, i.element) ? 1 : -1;
        });
      }
      destroy(t) {
        this.players.forEach(e => e.destroy()), this._signalRemovalForInnerTriggers(this.hostElement, t);
      }
      elementContainsData(t) {
        let e = !1;
        return this._elementListeners.has(t) && (e = !0), e = !!this._queue.find(a => a.element === t) || e, e;
      }
    }
    class qN {
      constructor(t, e, a) {
        this.bodyNode = t, this.driver = e, this._normalizer = a, this.players = [], this.newHostElements = new Map(), this.playersByElement = new Map(), this.playersByQueriedElement = new Map(), this.statesByElement = new Map(), this.disabledNodes = new Set(), this.totalAnimations = 0, this.totalQueuedPlayers = 0, this._namespaceLookup = {}, this._namespaceList = [], this._flushFns = [], this._whenQuietFns = [], this.namespacesByHostElement = new Map(), this.collectedEnterElements = [], this.collectedLeaveElements = [], this.onRemovalComplete = (i, o) => {};
      }
      _onRemovalComplete(t, e) {
        this.onRemovalComplete(t, e);
      }
      get queuedPlayers() {
        const t = [];
        return this._namespaceList.forEach(e => {
          e.players.forEach(a => {
            a.queued && t.push(a);
          });
        }), t;
      }
      createNamespace(t, e) {
        const a = new YN(t, e, this);
        return this.bodyNode && this.driver.containsElement(this.bodyNode, e) ? this._balanceNamespaceList(a, e) : (this.newHostElements.set(e, a), this.collectEnterElement(e)), this._namespaceLookup[t] = a;
      }
      _balanceNamespaceList(t, e) {
        const a = this._namespaceList,
          i = this.namespacesByHostElement;
        if (a.length - 1 >= 0) {
          let r = !1,
            s = this.driver.getParentElement(e);
          for (; s;) {
            const c = i.get(s);
            if (c) {
              const l = a.indexOf(c);
              a.splice(l + 1, 0, t), r = !0;
              break;
            }
            s = this.driver.getParentElement(s);
          }
          r || a.unshift(t);
        } else a.push(t);
        return i.set(e, t), t;
      }
      register(t, e) {
        let a = this._namespaceLookup[t];
        return a || (a = this.createNamespace(t, e)), a;
      }
      registerTrigger(t, e, a) {
        let i = this._namespaceLookup[t];
        i && i.register(e, a) && this.totalAnimations++;
      }
      destroy(t, e) {
        if (!t) return;
        const a = this._fetchNamespace(t);
        this.afterFlush(() => {
          this.namespacesByHostElement.delete(a.hostElement), delete this._namespaceLookup[t];
          const i = this._namespaceList.indexOf(a);
          i >= 0 && this._namespaceList.splice(i, 1);
        }), this.afterFlushAnimationsDone(() => a.destroy(e));
      }
      _fetchNamespace(t) {
        return this._namespaceLookup[t];
      }
      fetchNamespacesByElement(t) {
        const e = new Set(),
          a = this.statesByElement.get(t);
        if (a) for (let i of a.values()) if (i.namespaceId) {
          const o = this._fetchNamespace(i.namespaceId);
          o && e.add(o);
        }
        return e;
      }
      trigger(t, e, a, i) {
        if (jd(e)) {
          const o = this._fetchNamespace(t);
          if (o) return o.trigger(e, a, i), !0;
        }
        return !1;
      }
      insertNode(t, e, a, i) {
        if (!jd(e)) return;
        const o = e[ta];
        if (o && o.setForRemoval) {
          o.setForRemoval = !1, o.setForMove = !0;
          const r = this.collectedLeaveElements.indexOf(e);
          r >= 0 && this.collectedLeaveElements.splice(r, 1);
        }
        if (t) {
          const r = this._fetchNamespace(t);
          r && r.insertNode(e, a);
        }
        i && this.collectEnterElement(e);
      }
      collectEnterElement(t) {
        this.collectedEnterElements.push(t);
      }
      markElementAsDisabled(t, e) {
        e ? this.disabledNodes.has(t) || (this.disabledNodes.add(t), na(t, yh)) : this.disabledNodes.has(t) && (this.disabledNodes.delete(t), Kr(t, yh));
      }
      removeNode(t, e, a, i) {
        if (jd(e)) {
          const o = t ? this._fetchNamespace(t) : null;
          if (o ? o.removeNode(e, i) : this.markElementAsRemoved(t, e, !1, i), a) {
            const r = this.namespacesByHostElement.get(e);
            r && r.id !== t && r.removeNode(e, i);
          }
        } else this._onRemovalComplete(e, i);
      }
      markElementAsRemoved(t, e, a, i, o) {
        this.collectedLeaveElements.push(e), e[ta] = {
          namespaceId: t,
          setForRemoval: i,
          hasAnimation: a,
          removedBeforeQueried: !1,
          previousTriggersValues: o
        };
      }
      listen(t, e, a, i, o) {
        return jd(e) ? this._fetchNamespace(t).listen(e, a, i, o) : () => {};
      }
      _buildInstruction(t, e, a, i, o) {
        return t.transition.build(this.driver, t.element, t.fromState.value, t.toState.value, a, i, t.fromState.options, t.toState.options, e, o);
      }
      destroyInnerAnimations(t) {
        let e = this.driver.query(t, Ed, !0);
        e.forEach(a => this.destroyActiveAnimationsForElement(a)), 0 != this.playersByQueriedElement.size && (e = this.driver.query(t, lh, !0), e.forEach(a => this.finishActiveQueriedAnimationOnElement(a)));
      }
      destroyActiveAnimationsForElement(t) {
        const e = this.playersByElement.get(t);
        e && e.forEach(a => {
          a.queued ? a.markedForDestroy = !0 : a.destroy();
        });
      }
      finishActiveQueriedAnimationOnElement(t) {
        const e = this.playersByQueriedElement.get(t);
        e && e.forEach(a => a.finish());
      }
      whenRenderingDone() {
        return new Promise(t => {
          if (this.players.length) return Yi(this.players).onDone(() => t());
          t();
        });
      }
      processLeaveNode(t) {
        const e = t[ta];
        if (e && e.setForRemoval) {
          if (t[ta] = j9, e.namespaceId) {
            this.destroyInnerAnimations(t);
            const a = this._fetchNamespace(e.namespaceId);
            a && a.clearElementCache(t);
          }
          this._onRemovalComplete(t, e.setForRemoval);
        }
        t.classList?.contains(yh) && this.markElementAsDisabled(t, !1), this.driver.query(t, ".ng-animate-disabled", !0).forEach(a => {
          this.markElementAsDisabled(a, !1);
        });
      }
      flush(t = -1) {
        let e = [];
        if (this.newHostElements.size && (this.newHostElements.forEach((a, i) => this._balanceNamespaceList(a, i)), this.newHostElements.clear()), this.totalAnimations && this.collectedEnterElements.length) for (let a = 0; a < this.collectedEnterElements.length; a++) na(this.collectedEnterElements[a], "ng-star-inserted");
        if (this._namespaceList.length && (this.totalQueuedPlayers || this.collectedLeaveElements.length)) {
          const a = [];
          try {
            e = this._flushAnimations(a, t);
          } finally {
            for (let i = 0; i < a.length; i++) a[i]();
          }
        } else for (let a = 0; a < this.collectedLeaveElements.length; a++) this.processLeaveNode(this.collectedLeaveElements[a]);
        if (this.totalQueuedPlayers = 0, this.collectedEnterElements.length = 0, this.collectedLeaveElements.length = 0, this._flushFns.forEach(a => a()), this._flushFns = [], this._whenQuietFns.length) {
          const a = this._whenQuietFns;
          this._whenQuietFns = [], e.length ? Yi(e).onDone(() => {
            a.forEach(i => i());
          }) : a.forEach(i => i());
        }
      }
      reportError(t) {
        throw function qL(n) {
          return new L(3402, !1);
        }();
      }
      _flushAnimations(t, e) {
        const a = new Vd(),
          i = [],
          o = new Map(),
          r = [],
          s = new Map(),
          c = new Map(),
          l = new Map(),
          d = new Set();
        this.disabledNodes.forEach(te => {
          d.add(te);
          const oe = this.driver.query(te, ".ng-animate-queued", !0);
          for (let de = 0; de < oe.length; de++) d.add(oe[de]);
        });
        const u = this.bodyNode,
          m = Array.from(this.statesByElement.keys()),
          h = W9(m, this.collectedEnterElements),
          p = new Map();
        let v = 0;
        h.forEach((te, oe) => {
          const de = ch + v++;
          p.set(oe, de), te.forEach(He => na(He, de));
        });
        const C = [],
          k = new Set(),
          T = new Set();
        for (let te = 0; te < this.collectedLeaveElements.length; te++) {
          const oe = this.collectedLeaveElements[te],
            de = oe[ta];
          de && de.setForRemoval && (C.push(oe), k.add(oe), de.hasAnimation ? this.driver.query(oe, ".ng-star-inserted", !0).forEach(He => k.add(He)) : T.add(oe));
        }
        const w = new Map(),
          N = W9(m, Array.from(k));
        N.forEach((te, oe) => {
          const de = Ad + v++;
          w.set(oe, de), te.forEach(He => na(He, de));
        }), t.push(() => {
          h.forEach((te, oe) => {
            const de = p.get(oe);
            te.forEach(He => Kr(He, de));
          }), N.forEach((te, oe) => {
            const de = w.get(oe);
            te.forEach(He => Kr(He, de));
          }), C.forEach(te => {
            this.processLeaveNode(te);
          });
        });
        const le = [],
          Ce = [];
        for (let te = this._namespaceList.length - 1; te >= 0; te--) this._namespaceList[te].drainQueuedTransitions(e).forEach(de => {
          const He = de.player,
            Yt = de.element;
          if (le.push(He), this.collectedEnterElements.length) {
            const an = Yt[ta];
            if (an && an.setForMove) {
              if (an.previousTriggersValues && an.previousTriggersValues.has(de.triggerName)) {
                const Xo = an.previousTriggersValues.get(de.triggerName),
                  la = this.statesByElement.get(de.element);
                if (la && la.has(de.triggerName)) {
                  const B0 = la.get(de.triggerName);
                  B0.value = Xo, la.set(de.triggerName, B0);
                }
              }
              return void He.destroy();
            }
          }
          const ei = !u || !this.driver.containsElement(u, Yt),
            Un = w.get(Yt),
            ro = p.get(Yt),
            pt = this._buildInstruction(de, a, ro, Un, ei);
          if (pt.errors && pt.errors.length) return void Ce.push(pt);
          if (ei) return He.onStart(() => Po(Yt, pt.fromStyles)), He.onDestroy(() => Ga(Yt, pt.toStyles)), void i.push(He);
          if (de.isFallbackTransition) return He.onStart(() => Po(Yt, pt.fromStyles)), He.onDestroy(() => Ga(Yt, pt.toStyles)), void i.push(He);
          const Ww = [];
          pt.timelines.forEach(an => {
            an.stretchStartingKeyframe = !0, this.disabledNodes.has(an.element) || Ww.push(an);
          }), pt.timelines = Ww, a.append(Yt, pt.timelines), r.push({
            instruction: pt,
            player: He,
            element: Yt
          }), pt.queriedElements.forEach(an => Ln(s, an, []).push(He)), pt.preStyleProps.forEach((an, Xo) => {
            if (an.size) {
              let la = c.get(Xo);
              la || c.set(Xo, la = new Set()), an.forEach((B0, p3) => la.add(p3));
            }
          }), pt.postStyleProps.forEach((an, Xo) => {
            let la = l.get(Xo);
            la || l.set(Xo, la = new Set()), an.forEach((B0, p3) => la.add(p3));
          });
        });
        if (Ce.length) {
          const te = [];
          Ce.forEach(oe => {
            te.push(function KL(n, t) {
              return new L(3505, !1);
            }());
          }), le.forEach(oe => oe.destroy()), this.reportError(te);
        }
        const rt = new Map(),
          gn = new Map();
        r.forEach(te => {
          const oe = te.element;
          a.has(oe) && (gn.set(oe, oe), this._beforeAnimationBuild(te.player.namespaceId, te.instruction, rt));
        }), i.forEach(te => {
          const oe = te.element;
          this._getPreviousPlayers(oe, !1, te.namespaceId, te.triggerName, null).forEach(He => {
            Ln(rt, oe, []).push(He), He.destroy();
          });
        });
        const bn = C.filter(te => q9(te, c, l)),
          Wt = new Map();
        G9(Wt, this.driver, T, l, bi).forEach(te => {
          q9(te, c, l) && bn.push(te);
        });
        const Ri = new Map();
        h.forEach((te, oe) => {
          G9(Ri, this.driver, new Set(te), c, "!");
        }), bn.forEach(te => {
          const oe = Wt.get(te),
            de = Ri.get(te);
          Wt.set(te, new Map([...Array.from(oe?.entries() ?? []), ...Array.from(de?.entries() ?? [])]));
        });
        const Ia = [],
          Rs = [],
          zs = {};
        r.forEach(te => {
          const {
            element: oe,
            player: de,
            instruction: He
          } = te;
          if (a.has(oe)) {
            if (d.has(oe)) return de.onDestroy(() => Ga(oe, He.toStyles)), de.disabled = !0, de.overrideTotalTime(He.totalTime), void i.push(de);
            let Yt = zs;
            if (gn.size > 1) {
              let Un = oe;
              const ro = [];
              for (; Un = Un.parentNode;) {
                const pt = gn.get(Un);
                if (pt) {
                  Yt = pt;
                  break;
                }
                ro.push(Un);
              }
              ro.forEach(pt => gn.set(pt, Yt));
            }
            const ei = this._buildAnimation(de.namespaceId, He, rt, o, Ri, Wt);
            if (de.setRealPlayer(ei), Yt === zs) Ia.push(de);else {
              const Un = this.playersByElement.get(Yt);
              Un && Un.length && (de.parentPlayer = Yi(Un)), i.push(de);
            }
          } else Po(oe, He.fromStyles), de.onDestroy(() => Ga(oe, He.toStyles)), Rs.push(de), d.has(oe) && i.push(de);
        }), Rs.forEach(te => {
          const oe = o.get(te.element);
          if (oe && oe.length) {
            const de = Yi(oe);
            te.setRealPlayer(de);
          }
        }), i.forEach(te => {
          te.parentPlayer ? te.syncPlayerEvents(te.parentPlayer) : te.destroy();
        });
        for (let te = 0; te < C.length; te++) {
          const oe = C[te],
            de = oe[ta];
          if (Kr(oe, Ad), de && de.hasAnimation) continue;
          let He = [];
          if (s.size) {
            let ei = s.get(oe);
            ei && ei.length && He.push(...ei);
            let Un = this.driver.query(oe, lh, !0);
            for (let ro = 0; ro < Un.length; ro++) {
              let pt = s.get(Un[ro]);
              pt && pt.length && He.push(...pt);
            }
          }
          const Yt = He.filter(ei => !ei.destroyed);
          Yt.length ? XN(this, oe, Yt) : this.processLeaveNode(oe);
        }
        return C.length = 0, Ia.forEach(te => {
          this.players.push(te), te.onDone(() => {
            te.destroy();
            const oe = this.players.indexOf(te);
            this.players.splice(oe, 1);
          }), te.play();
        }), Ia;
      }
      elementContainsData(t, e) {
        let a = !1;
        const i = e[ta];
        return i && i.setForRemoval && (a = !0), this.playersByElement.has(e) && (a = !0), this.playersByQueriedElement.has(e) && (a = !0), this.statesByElement.has(e) && (a = !0), this._fetchNamespace(t).elementContainsData(e) || a;
      }
      afterFlush(t) {
        this._flushFns.push(t);
      }
      afterFlushAnimationsDone(t) {
        this._whenQuietFns.push(t);
      }
      _getPreviousPlayers(t, e, a, i, o) {
        let r = [];
        if (e) {
          const s = this.playersByQueriedElement.get(t);
          s && (r = s);
        } else {
          const s = this.playersByElement.get(t);
          if (s) {
            const c = !o || o == Lc;
            s.forEach(l => {
              l.queued || !c && l.triggerName != i || r.push(l);
            });
          }
        }
        return (a || i) && (r = r.filter(s => !(a && a != s.namespaceId || i && i != s.triggerName))), r;
      }
      _beforeAnimationBuild(t, e, a) {
        const o = e.element,
          r = e.isRemovalTransition ? void 0 : t,
          s = e.isRemovalTransition ? void 0 : e.triggerName;
        for (const c of e.timelines) {
          const l = c.element,
            d = l !== o,
            u = Ln(a, l, []);
          this._getPreviousPlayers(l, d, r, s, e.toState).forEach(h => {
            const p = h.getRealPlayer();
            p.beforeDestroy && p.beforeDestroy(), h.destroy(), u.push(h);
          });
        }
        Po(o, e.fromStyles);
      }
      _buildAnimation(t, e, a, i, o, r) {
        const s = e.triggerName,
          c = e.element,
          l = [],
          d = new Set(),
          u = new Set(),
          m = e.timelines.map(p => {
            const v = p.element;
            d.add(v);
            const C = v[ta];
            if (C && C.removedBeforeQueried) return new Tc(p.duration, p.delay);
            const k = v !== c,
              T = function JN(n) {
                const t = [];
                return Y9(n, t), t;
              }((a.get(v) || GN).map(rt => rt.getRealPlayer())).filter(rt => !!rt.element && rt.element === v),
              w = o.get(v),
              N = r.get(v),
              le = _9(0, this._normalizer, 0, p.keyframes, w, N),
              Ce = this._buildPlayer(p, le, T);
            if (p.subTimeline && i && u.add(v), k) {
              const rt = new xh(t, s, v);
              rt.setRealPlayer(Ce), l.push(rt);
            }
            return Ce;
          });
        l.forEach(p => {
          Ln(this.playersByQueriedElement, p.element, []).push(p), p.onDone(() => function KN(n, t, e) {
            let a = n.get(t);
            if (a) {
              if (a.length) {
                const i = a.indexOf(e);
                a.splice(i, 1);
              }
              0 == a.length && n.delete(t);
            }
            return a;
          }(this.playersByQueriedElement, p.element, p));
        }), d.forEach(p => na(p, O9));
        const h = Yi(m);
        return h.onDestroy(() => {
          d.forEach(p => Kr(p, O9)), Ga(c, e.toStyles);
        }), u.forEach(p => {
          Ln(i, p, []).push(h);
        }), h;
      }
      _buildPlayer(t, e, a) {
        return e.length > 0 ? this.driver.animate(t.element, e, t.duration, t.delay, t.easing, a) : new Tc(t.duration, t.delay);
      }
    }
    class xh {
      constructor(t, e, a) {
        this.namespaceId = t, this.triggerName = e, this.element = a, this._player = new Tc(), this._containsRealPlayer = !1, this._queuedCallbacks = new Map(), this.destroyed = !1, this.markedForDestroy = !1, this.disabled = !1, this.queued = !0, this.totalTime = 0;
      }
      setRealPlayer(t) {
        this._containsRealPlayer || (this._player = t, this._queuedCallbacks.forEach((e, a) => {
          e.forEach(i => nh(t, a, void 0, i));
        }), this._queuedCallbacks.clear(), this._containsRealPlayer = !0, this.overrideTotalTime(t.totalTime), this.queued = !1);
      }
      getRealPlayer() {
        return this._player;
      }
      overrideTotalTime(t) {
        this.totalTime = t;
      }
      syncPlayerEvents(t) {
        const e = this._player;
        e.triggerCallback && t.onStart(() => e.triggerCallback("start")), t.onDone(() => this.finish()), t.onDestroy(() => this.destroy());
      }
      _queueEvent(t, e) {
        Ln(this._queuedCallbacks, t, []).push(e);
      }
      onDone(t) {
        this.queued && this._queueEvent("done", t), this._player.onDone(t);
      }
      onStart(t) {
        this.queued && this._queueEvent("start", t), this._player.onStart(t);
      }
      onDestroy(t) {
        this.queued && this._queueEvent("destroy", t), this._player.onDestroy(t);
      }
      init() {
        this._player.init();
      }
      hasStarted() {
        return !this.queued && this._player.hasStarted();
      }
      play() {
        !this.queued && this._player.play();
      }
      pause() {
        !this.queued && this._player.pause();
      }
      restart() {
        !this.queued && this._player.restart();
      }
      finish() {
        this._player.finish();
      }
      destroy() {
        this.destroyed = !0, this._player.destroy();
      }
      reset() {
        !this.queued && this._player.reset();
      }
      setPosition(t) {
        this.queued || this._player.setPosition(t);
      }
      getPosition() {
        return this.queued ? 0 : this._player.getPosition();
      }
      triggerCallback(t) {
        const e = this._player;
        e.triggerCallback && e.triggerCallback(t);
      }
    }
    function jd(n) {
      return n && 1 === n.nodeType;
    }
    function U9(n, t) {
      const e = n.style.display;
      return n.style.display = t ?? "none", e;
    }
    function G9(n, t, e, a, i) {
      const o = [];
      e.forEach(c => o.push(U9(c)));
      const r = [];
      a.forEach((c, l) => {
        const d = new Map();
        c.forEach(u => {
          const m = t.computeStyle(l, u, i);
          d.set(u, m), (!m || 0 == m.length) && (l[ta] = WN, r.push(l));
        }), n.set(l, d);
      });
      let s = 0;
      return e.forEach(c => U9(c, o[s++])), r;
    }
    function W9(n, t) {
      const e = new Map();
      if (n.forEach(s => e.set(s, [])), 0 == t.length) return e;
      const i = new Set(t),
        o = new Map();
      function r(s) {
        if (!s) return 1;
        let c = o.get(s);
        if (c) return c;
        const l = s.parentNode;
        return c = e.has(l) ? l : i.has(l) ? 1 : r(l), o.set(s, c), c;
      }
      return t.forEach(s => {
        const c = r(s);
        1 !== c && e.get(c).push(s);
      }), e;
    }
    function na(n, t) {
      n.classList?.add(t);
    }
    function Kr(n, t) {
      n.classList?.remove(t);
    }
    function XN(n, t, e) {
      Yi(e).onDone(() => n.processLeaveNode(t));
    }
    function Y9(n, t) {
      for (let e = 0; e < n.length; e++) {
        const a = n[e];
        a instanceof g9 ? Y9(a.players, t) : t.push(a);
      }
    }
    function q9(n, t, e) {
      const a = e.get(n);
      if (!a) return !1;
      let i = t.get(n);
      return i ? a.forEach(o => i.add(o)) : t.set(n, a), e.delete(n), !0;
    }
    class Ud {
      constructor(t, e, a) {
        this.bodyNode = t, this._driver = e, this._normalizer = a, this._triggerCache = {}, this.onRemovalComplete = (i, o) => {}, this._transitionEngine = new qN(t, e, a), this._timelineEngine = new VN(t, e, a), this._transitionEngine.onRemovalComplete = (i, o) => this.onRemovalComplete(i, o);
      }
      registerTrigger(t, e, a, i, o) {
        const r = t + "-" + i;
        let s = this._triggerCache[r];
        if (!s) {
          const c = [],
            d = mh(this._driver, o, c, []);
          if (c.length) throw function NL(n, t) {
            return new L(3404, !1);
          }();
          s = function zN(n, t, e) {
            return new LN(n, t, e);
          }(i, d, this._normalizer), this._triggerCache[r] = s;
        }
        this._transitionEngine.registerTrigger(e, i, s);
      }
      register(t, e) {
        this._transitionEngine.register(t, e);
      }
      destroy(t, e) {
        this._transitionEngine.destroy(t, e);
      }
      onInsert(t, e, a, i) {
        this._transitionEngine.insertNode(t, e, a, i);
      }
      onRemove(t, e, a, i) {
        this._transitionEngine.removeNode(t, e, i || !1, a);
      }
      disableAnimations(t, e) {
        this._transitionEngine.markElementAsDisabled(t, e);
      }
      process(t, e, a, i) {
        if ("@" == a.charAt(0)) {
          const [o, r] = v9(a);
          this._timelineEngine.command(o, e, r, i);
        } else this._transitionEngine.trigger(t, e, a, i);
      }
      listen(t, e, a, i, o) {
        if ("@" == a.charAt(0)) {
          const [r, s] = v9(a);
          return this._timelineEngine.listen(r, e, s, o);
        }
        return this._transitionEngine.listen(t, e, a, i, o);
      }
      flush(t = -1) {
        this._transitionEngine.flush(t);
      }
      get players() {
        return this._transitionEngine.players.concat(this._timelineEngine.players);
      }
      whenRenderingDone() {
        return this._transitionEngine.whenRenderingDone();
      }
    }
    let tF = (() => {
      class n {
        constructor(e, a, i) {
          this._element = e, this._startStyles = a, this._endStyles = i, this._state = 0;
          let o = n.initialStylesByElement.get(e);
          o || n.initialStylesByElement.set(e, o = new Map()), this._initialStyles = o;
        }
        start() {
          this._state < 1 && (this._startStyles && Ga(this._element, this._startStyles, this._initialStyles), this._state = 1);
        }
        finish() {
          this.start(), this._state < 2 && (Ga(this._element, this._initialStyles), this._endStyles && (Ga(this._element, this._endStyles), this._endStyles = null), this._state = 1);
        }
        destroy() {
          this.finish(), this._state < 3 && (n.initialStylesByElement.delete(this._element), this._startStyles && (Po(this._element, this._startStyles), this._endStyles = null), this._endStyles && (Po(this._element, this._endStyles), this._endStyles = null), Ga(this._element, this._initialStyles), this._state = 3);
        }
      }
      return n.initialStylesByElement = new WeakMap(), n;
    })();
    function wh(n) {
      let t = null;
      return n.forEach((e, a) => {
        (function nF(n) {
          return "display" === n || "position" === n;
        })(a) && (t = t || new Map(), t.set(a, e));
      }), t;
    }
    class K9 {
      constructor(t, e, a, i) {
        this.element = t, this.keyframes = e, this.options = a, this._specialStyles = i, this._onDoneFns = [], this._onStartFns = [], this._onDestroyFns = [], this._initialized = !1, this._finished = !1, this._started = !1, this._destroyed = !1, this._originalOnDoneFns = [], this._originalOnStartFns = [], this.time = 0, this.parentPlayer = null, this.currentSnapshot = new Map(), this._duration = a.duration, this._delay = a.delay || 0, this.time = this._duration + this._delay;
      }
      _onFinish() {
        this._finished || (this._finished = !0, this._onDoneFns.forEach(t => t()), this._onDoneFns = []);
      }
      init() {
        this._buildPlayer(), this._preparePlayerBeforeStart();
      }
      _buildPlayer() {
        if (this._initialized) return;
        this._initialized = !0;
        const t = this.keyframes;
        this.domPlayer = this._triggerWebAnimation(this.element, t, this.options), this._finalKeyframe = t.length ? t[t.length - 1] : new Map(), this.domPlayer.addEventListener("finish", () => this._onFinish());
      }
      _preparePlayerBeforeStart() {
        this._delay ? this._resetDomPlayerState() : this.domPlayer.pause();
      }
      _convertKeyframesToObject(t) {
        const e = [];
        return t.forEach(a => {
          e.push(Object.fromEntries(a));
        }), e;
      }
      _triggerWebAnimation(t, e, a) {
        return t.animate(this._convertKeyframesToObject(e), a);
      }
      onStart(t) {
        this._originalOnStartFns.push(t), this._onStartFns.push(t);
      }
      onDone(t) {
        this._originalOnDoneFns.push(t), this._onDoneFns.push(t);
      }
      onDestroy(t) {
        this._onDestroyFns.push(t);
      }
      play() {
        this._buildPlayer(), this.hasStarted() || (this._onStartFns.forEach(t => t()), this._onStartFns = [], this._started = !0, this._specialStyles && this._specialStyles.start()), this.domPlayer.play();
      }
      pause() {
        this.init(), this.domPlayer.pause();
      }
      finish() {
        this.init(), this._specialStyles && this._specialStyles.finish(), this._onFinish(), this.domPlayer.finish();
      }
      reset() {
        this._resetDomPlayerState(), this._destroyed = !1, this._finished = !1, this._started = !1, this._onStartFns = this._originalOnStartFns, this._onDoneFns = this._originalOnDoneFns;
      }
      _resetDomPlayerState() {
        this.domPlayer && this.domPlayer.cancel();
      }
      restart() {
        this.reset(), this.play();
      }
      hasStarted() {
        return this._started;
      }
      destroy() {
        this._destroyed || (this._destroyed = !0, this._resetDomPlayerState(), this._onFinish(), this._specialStyles && this._specialStyles.destroy(), this._onDestroyFns.forEach(t => t()), this._onDestroyFns = []);
      }
      setPosition(t) {
        void 0 === this.domPlayer && this.init(), this.domPlayer.currentTime = t * this.time;
      }
      getPosition() {
        return this.domPlayer.currentTime / this.time;
      }
      get totalTime() {
        return this._delay + this._duration;
      }
      beforeDestroy() {
        const t = new Map();
        this.hasStarted() && this._finalKeyframe.forEach((a, i) => {
          "offset" !== i && t.set(i, this._finished ? a : I9(this.element, i));
        }), this.currentSnapshot = t;
      }
      triggerCallback(t) {
        const e = "start" === t ? this._onStartFns : this._onDoneFns;
        e.forEach(a => a()), e.length = 0;
      }
    }
    class aF {
      validateStyleProperty(t) {
        return !0;
      }
      validateAnimatableStyleProperty(t) {
        return !0;
      }
      matchesElement(t, e) {
        return !1;
      }
      containsElement(t, e) {
        return x9(t, e);
      }
      getParentElement(t) {
        return rh(t);
      }
      query(t, e, a) {
        return w9(t, e, a);
      }
      computeStyle(t, e, a) {
        return window.getComputedStyle(t)[e];
      }
      animate(t, e, a, i, o, r = []) {
        const c = {
          duration: a,
          delay: i,
          fill: 0 == i ? "both" : "forwards"
        };
        o && (c.easing = o);
        const l = new Map(),
          d = r.filter(h => h instanceof K9);
        (function sN(n, t) {
          return 0 === n || 0 === t;
        })(a, i) && d.forEach(h => {
          h.currentSnapshot.forEach((p, v) => l.set(v, p));
        });
        let u = function aN(n) {
          return n.length ? n[0] instanceof Map ? n : n.map(t => P9(t)) : [];
        }(e).map(h => qi(h));
        u = function cN(n, t, e) {
          if (e.size && t.length) {
            let a = t[0],
              i = [];
            if (e.forEach((o, r) => {
              a.has(r) || i.push(r), a.set(r, o);
            }), i.length) for (let o = 1; o < t.length; o++) {
              let r = t[o];
              i.forEach(s => r.set(s, I9(n, s)));
            }
          }
          return t;
        }(t, u, l);
        const m = function eF(n, t) {
          let e = null,
            a = null;
          return Array.isArray(t) && t.length ? (e = wh(t[0]), t.length > 1 && (a = wh(t[t.length - 1]))) : t instanceof Map && (e = wh(t)), e || a ? new tF(n, e, a) : null;
        }(t, u);
        return new K9(t, u, c, m);
      }
    }
    let iF = (() => {
      class n extends m9 {
        constructor(e, a) {
          super(), this._nextAnimationId = 0, this._renderer = e.createRenderer(a.body, {
            id: "0",
            encapsulation: fa.None,
            styles: [],
            data: {
              animation: []
            }
          });
        }
        build(e) {
          const a = this._nextAnimationId.toString();
          this._nextAnimationId++;
          const i = Array.isArray(e) ? h9(e) : e;
          return Q9(this._renderer, null, a, "register", [i]), new oF(a, this._renderer);
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(cc), M(ie));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac
      }), n;
    })();
    class oF extends class pL {} {
      constructor(t, e) {
        super(), this._id = t, this._renderer = e;
      }
      create(t, e) {
        return new rF(this._id, t, e || {}, this._renderer);
      }
    }
    class rF {
      constructor(t, e, a, i) {
        this.id = t, this.element = e, this._renderer = i, this.parentPlayer = null, this._started = !1, this.totalTime = 0, this._command("create", a);
      }
      _listen(t, e) {
        return this._renderer.listen(this.element, `@@${this.id}:${t}`, e);
      }
      _command(t, ...e) {
        return Q9(this._renderer, this.element, this.id, t, e);
      }
      onDone(t) {
        this._listen("done", t);
      }
      onStart(t) {
        this._listen("start", t);
      }
      onDestroy(t) {
        this._listen("destroy", t);
      }
      init() {
        this._command("init");
      }
      hasStarted() {
        return this._started;
      }
      play() {
        this._command("play"), this._started = !0;
      }
      pause() {
        this._command("pause");
      }
      restart() {
        this._command("restart");
      }
      finish() {
        this._command("finish");
      }
      destroy() {
        this._command("destroy");
      }
      reset() {
        this._command("reset"), this._started = !1;
      }
      setPosition(t) {
        this._command("setPosition", t);
      }
      getPosition() {
        return this._renderer.engine.players[+this.id]?.getPosition() ?? 0;
      }
    }
    function Q9(n, t, e, a, i) {
      return n.setProperty(t, `@@${e}:${a}`, i);
    }
    const Z9 = "@.disabled";
    let sF = (() => {
      class n {
        constructor(e, a, i) {
          this.delegate = e, this.engine = a, this._zone = i, this._currentId = 0, this._microtaskId = 1, this._animationCallbacksBuffer = [], this._rendererCache = new Map(), this._cdRecurDepth = 0, this.promise = Promise.resolve(0), a.onRemovalComplete = (o, r) => {
            const s = r?.parentNode(o);
            s && r.removeChild(s, o);
          };
        }
        createRenderer(e, a) {
          const o = this.delegate.createRenderer(e, a);
          if (!(e && a && a.data && a.data.animation)) {
            let d = this._rendererCache.get(o);
            return d || (d = new X9("", o, this.engine), this._rendererCache.set(o, d)), d;
          }
          const r = a.id,
            s = a.id + "-" + this._currentId;
          this._currentId++, this.engine.register(s, e);
          const c = d => {
            Array.isArray(d) ? d.forEach(c) : this.engine.registerTrigger(r, s, e, d.name, d);
          };
          return a.data.animation.forEach(c), new cF(this, s, o, this.engine);
        }
        begin() {
          this._cdRecurDepth++, this.delegate.begin && this.delegate.begin();
        }
        _scheduleCountTask() {
          this.promise.then(() => {
            this._microtaskId++;
          });
        }
        scheduleListenerCallback(e, a, i) {
          e >= 0 && e < this._microtaskId ? this._zone.run(() => a(i)) : (0 == this._animationCallbacksBuffer.length && Promise.resolve(null).then(() => {
            this._zone.run(() => {
              this._animationCallbacksBuffer.forEach(o => {
                const [r, s] = o;
                r(s);
              }), this._animationCallbacksBuffer = [];
            });
          }), this._animationCallbacksBuffer.push([a, i]));
        }
        end() {
          this._cdRecurDepth--, 0 == this._cdRecurDepth && this._zone.runOutsideAngular(() => {
            this._scheduleCountTask(), this.engine.flush(this._microtaskId);
          }), this.delegate.end && this.delegate.end();
        }
        whenRenderingDone() {
          return this.engine.whenRenderingDone();
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(cc), M(Ud), M(ae));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac
      }), n;
    })();
    class X9 {
      constructor(t, e, a) {
        this.namespaceId = t, this.delegate = e, this.engine = a, this.destroyNode = this.delegate.destroyNode ? i => e.destroyNode(i) : null;
      }
      get data() {
        return this.delegate.data;
      }
      destroy() {
        this.engine.destroy(this.namespaceId, this.delegate), this.delegate.destroy();
      }
      createElement(t, e) {
        return this.delegate.createElement(t, e);
      }
      createComment(t) {
        return this.delegate.createComment(t);
      }
      createText(t) {
        return this.delegate.createText(t);
      }
      appendChild(t, e) {
        this.delegate.appendChild(t, e), this.engine.onInsert(this.namespaceId, e, t, !1);
      }
      insertBefore(t, e, a, i = !0) {
        this.delegate.insertBefore(t, e, a), this.engine.onInsert(this.namespaceId, e, t, i);
      }
      removeChild(t, e, a) {
        this.engine.onRemove(this.namespaceId, e, this.delegate, a);
      }
      selectRootElement(t, e) {
        return this.delegate.selectRootElement(t, e);
      }
      parentNode(t) {
        return this.delegate.parentNode(t);
      }
      nextSibling(t) {
        return this.delegate.nextSibling(t);
      }
      setAttribute(t, e, a, i) {
        this.delegate.setAttribute(t, e, a, i);
      }
      removeAttribute(t, e, a) {
        this.delegate.removeAttribute(t, e, a);
      }
      addClass(t, e) {
        this.delegate.addClass(t, e);
      }
      removeClass(t, e) {
        this.delegate.removeClass(t, e);
      }
      setStyle(t, e, a, i) {
        this.delegate.setStyle(t, e, a, i);
      }
      removeStyle(t, e, a) {
        this.delegate.removeStyle(t, e, a);
      }
      setProperty(t, e, a) {
        "@" == e.charAt(0) && e == Z9 ? this.disableAnimations(t, !!a) : this.delegate.setProperty(t, e, a);
      }
      setValue(t, e) {
        this.delegate.setValue(t, e);
      }
      listen(t, e, a) {
        return this.delegate.listen(t, e, a);
      }
      disableAnimations(t, e) {
        this.engine.disableAnimations(t, e);
      }
    }
    class cF extends X9 {
      constructor(t, e, a, i) {
        super(e, a, i), this.factory = t, this.namespaceId = e;
      }
      setProperty(t, e, a) {
        "@" == e.charAt(0) ? "." == e.charAt(1) && e == Z9 ? this.disableAnimations(t, a = void 0 === a || !!a) : this.engine.process(this.namespaceId, t, e.slice(1), a) : this.delegate.setProperty(t, e, a);
      }
      listen(t, e, a) {
        if ("@" == e.charAt(0)) {
          const i = function lF(n) {
            switch (n) {
              case "body":
                return document.body;
              case "document":
                return document;
              case "window":
                return window;
              default:
                return n;
            }
          }(t);
          let o = e.slice(1),
            r = "";
          return "@" != o.charAt(0) && ([o, r] = function dF(n) {
            const t = n.indexOf(".");
            return [n.substring(0, t), n.slice(t + 1)];
          }(o)), this.engine.listen(this.namespaceId, i, o, r, s => {
            this.factory.scheduleListenerCallback(s._data || -1, a, s);
          });
        }
        return this.delegate.listen(t, e, a);
      }
    }
    let uF = (() => {
      class n extends Ud {
        constructor(e, a, i, o) {
          super(e.body, a, i);
        }
        ngOnDestroy() {
          this.flush();
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(ie), M(sh), M(_h), M(Gr));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac
      }), n;
    })();
    const J9 = [{
        provide: m9,
        useClass: iF
      }, {
        provide: _h,
        useFactory: function fF() {
          return new EN();
        }
      }, {
        provide: Ud,
        useClass: uF
      }, {
        provide: cc,
        useFactory: function mF(n, t, e) {
          return new sF(n, t, e);
        },
        deps: [vd, Ud, ae]
      }],
      kh = [{
        provide: sh,
        useFactory: () => new aF()
      }, {
        provide: Ft,
        useValue: "BrowserAnimations"
      }, ...J9],
      $9 = [{
        provide: sh,
        useClass: k9
      }, {
        provide: Ft,
        useValue: "NoopAnimations"
      }, ...J9];
    let Dh = (() => {
      class n {
        static withConfig(e) {
          return {
            ngModule: n,
            providers: e.disableAnimations ? $9 : kh
          };
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)();
      }, n.ɵmod = W({
        type: n
      }), n.ɵinj = U({
        providers: kh,
        imports: [yd]
      }), n;
    })();
    function Y(n) {
      return null != n && "false" != `${n}`;
    }
    function xt(n, t = 0) {
      return function hF(n) {
        return !isNaN(parseFloat(n)) && !isNaN(Number(n));
      }(n) ? Number(n) : t;
    }
    function Wd(n) {
      return Array.isArray(n) ? n : [n];
    }
    function St(n) {
      return null == n ? "" : "string" == typeof n ? n : `${n}px`;
    }
    function wt(n) {
      return n instanceof J ? n.nativeElement : n;
    }
    function e_(n, t = /\s+/) {
      const e = [];
      if (null != n) {
        const a = Array.isArray(n) ? n : `${n}`.split(t);
        for (const i of a) {
          const o = `${i}`.trim();
          o && e.push(o);
        }
      }
      return e;
    }
    function Qr(n, t, e, a) {
      return so(e) && (a = e, e = void 0), a ? Qr(n, t, e).pipe(We(i => $o(i) ? a(...i) : a(i))) : new Be(i => {
        t_(n, t, function o(r) {
          i.next(arguments.length > 1 ? Array.prototype.slice.call(arguments) : r);
        }, i, e);
      });
    }
    function t_(n, t, e, a, i) {
      let o;
      if (function bF(n) {
        return n && "function" == typeof n.addEventListener && "function" == typeof n.removeEventListener;
      }(n)) {
        const r = n;
        n.addEventListener(t, e, i), o = () => r.removeEventListener(t, e, i);
      } else if (function gF(n) {
        return n && "function" == typeof n.on && "function" == typeof n.off;
      }(n)) {
        const r = n;
        n.on(t, e), o = () => r.off(t, e);
      } else if (function pF(n) {
        return n && "function" == typeof n.addListener && "function" == typeof n.removeListener;
      }(n)) {
        const r = n;
        n.addListener(t, e), o = () => r.removeListener(t, e);
      } else {
        if (!n || !n.length) throw new TypeError("Invalid event target");
        for (let r = 0, s = n.length; r < s; r++) t_(n[r], t, e, a, i);
      }
      a.add(o);
    }
    const Oh = new class vF extends wa {
      flush(t) {
        this.active = !0, this.scheduled = void 0;
        const {
          actions: e
        } = this;
        let a,
          i = -1,
          o = e.length;
        t = t || e.shift();
        do {
          if (a = t.execute(t.state, t.delay)) break;
        } while (++i < o && (t = e.shift()));
        if (this.active = !1, a) {
          for (; ++i < o && (t = e.shift());) t.unsubscribe();
          throw a;
        }
      }
    }(class _F extends Md {
      constructor(t, e) {
        super(t, e), this.scheduler = t, this.work = e;
      }
      requestAsyncId(t, e, a = 0) {
        return null !== a && a > 0 ? super.requestAsyncId(t, e, a) : (t.actions.push(this), t.scheduled || (t.scheduled = requestAnimationFrame(() => t.flush(null))));
      }
      recycleAsyncId(t, e, a = 0) {
        if (null !== a && a > 0 || null === a && this.delay > 0) return super.recycleAsyncId(t, e, a);
        0 === t.actions.length && (cancelAnimationFrame(e), t.scheduled = void 0);
      }
    });
    let yF = 1;
    const CF = Promise.resolve(),
      Yd = {};
    function n_(n) {
      return n in Yd && (delete Yd[n], !0);
    }
    const a_ = {
        setImmediate(n) {
          const t = yF++;
          return Yd[t] = !0, CF.then(() => n_(t) && n()), t;
        },
        clearImmediate(n) {
          n_(n);
        }
      },
      Zr = (new class xF extends wa {
        flush(t) {
          this.active = !0, this.scheduled = void 0;
          const {
            actions: e
          } = this;
          let a,
            i = -1,
            o = e.length;
          t = t || e.shift();
          do {
            if (a = t.execute(t.state, t.delay)) break;
          } while (++i < o && (t = e.shift()));
          if (this.active = !1, a) {
            for (; ++i < o && (t = e.shift());) t.unsubscribe();
            throw a;
          }
        }
      }(class MF extends Md {
        constructor(t, e) {
          super(t, e), this.scheduler = t, this.work = e;
        }
        requestAsyncId(t, e, a = 0) {
          return null !== a && a > 0 ? super.requestAsyncId(t, e, a) : (t.actions.push(this), t.scheduled || (t.scheduled = a_.setImmediate(t.flush.bind(t, null))));
        }
        recycleAsyncId(t, e, a = 0) {
          if (null !== a && a > 0 || null === a && this.delay > 0) return super.recycleAsyncId(t, e, a);
          0 === t.actions.length && (a_.clearImmediate(e), t.scheduled = void 0);
        }
      }), new wa(Md));
    class kF {
      constructor(t) {
        this.durationSelector = t;
      }
      call(t, e) {
        return e.subscribe(new DF(t, this.durationSelector));
      }
    }
    class DF extends Fs {
      constructor(t, e) {
        super(t), this.durationSelector = e, this.hasValue = !1;
      }
      _next(t) {
        if (this.value = t, this.hasValue = !0, !this.throttled) {
          let e;
          try {
            const {
              durationSelector: i
            } = this;
            e = i(t);
          } catch (i) {
            return this.destination.error(i);
          }
          const a = Vs(e, new Ns(this));
          !a || a.closed ? this.clearThrottle() : this.add(this.throttled = a);
        }
      }
      clearThrottle() {
        const {
          value: t,
          hasValue: e,
          throttled: a
        } = this;
        a && (this.remove(a), this.throttled = void 0, a.unsubscribe()), e && (this.value = void 0, this.hasValue = !1, this.destination.next(t));
      }
      notifyNext() {
        this.clearThrottle();
      }
      notifyComplete() {
        this.clearThrottle();
      }
    }
    function Ph(n) {
      return !$o(n) && n - parseFloat(n) + 1 >= 0;
    }
    function PF(n) {
      const {
        index: t,
        period: e,
        subscriber: a
      } = n;
      if (a.next(t), !a.closed) {
        if (-1 === e) return a.complete();
        n.index = t + 1, this.schedule(n, e);
      }
    }
    function o_(n, t = Zr) {
      return function wF(n) {
        return function (e) {
          return e.lift(new kF(n));
        };
      }(() => function OF(n = 0, t, e) {
        let a = -1;
        return Ph(t) ? a = Number(t) < 1 ? 1 : Number(t) : er(t) && (e = t), er(e) || (e = Zr), new Be(i => {
          const o = Ph(n) ? n : +n - e.now();
          return e.schedule(PF, o, {
            index: 0,
            period: a,
            subscriber: i
          });
        });
      }(n, t));
    }
    function Ht(n, t) {
      return function (a) {
        return a.lift(new AF(n, t));
      };
    }
    class AF {
      constructor(t, e) {
        this.predicate = t, this.thisArg = e;
      }
      call(t, e) {
        return e.subscribe(new SF(t, this.predicate, this.thisArg));
      }
    }
    class SF extends Qe {
      constructor(t, e, a) {
        super(t), this.predicate = e, this.thisArg = a, this.count = 0;
      }
      _next(t) {
        let e;
        try {
          e = this.predicate.call(this.thisArg, t, this.count++);
        } catch (a) {
          return void this.destination.error(a);
        }
        e && this.destination.next(t);
      }
    }
    let Ah;
    try {
      Ah = typeof Intl < "u" && Intl.v8BreakIterator;
    } catch {
      Ah = !1;
    }
    let Xr,
      Ct = (() => {
        class n {
          constructor(e) {
            this._platformId = e, this.isBrowser = this._platformId ? function ZR(n) {
              return n === L7;
            }(this._platformId) : "object" == typeof document && !!document, this.EDGE = this.isBrowser && /(edge)/i.test(navigator.userAgent), this.TRIDENT = this.isBrowser && /(msie|trident)/i.test(navigator.userAgent), this.BLINK = this.isBrowser && !(!window.chrome && !Ah) && typeof CSS < "u" && !this.EDGE && !this.TRIDENT, this.WEBKIT = this.isBrowser && /AppleWebKit/i.test(navigator.userAgent) && !this.BLINK && !this.EDGE && !this.TRIDENT, this.IOS = this.isBrowser && /iPad|iPhone|iPod/.test(navigator.userAgent) && !("MSStream" in window), this.FIREFOX = this.isBrowser && /(firefox|minefield)/i.test(navigator.userAgent), this.ANDROID = this.isBrowser && /android/i.test(navigator.userAgent) && !this.TRIDENT, this.SAFARI = this.isBrowser && /safari/i.test(navigator.userAgent) && this.WEBKIT;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(X1));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })();
    const r_ = ["color", "button", "checkbox", "date", "datetime-local", "email", "file", "hidden", "image", "month", "number", "password", "radio", "range", "reset", "search", "submit", "tel", "text", "time", "url", "week"];
    function s_() {
      if (Xr) return Xr;
      if ("object" != typeof document || !document) return Xr = new Set(r_), Xr;
      let n = document.createElement("input");
      return Xr = new Set(r_.filter(t => (n.setAttribute("type", t), n.type === t))), Xr;
    }
    let Nc, So, Sh;
    function ka(n) {
      return function EF() {
        if (null == Nc && typeof window < "u") try {
          window.addEventListener("test", null, Object.defineProperty({}, "passive", {
            get: () => Nc = !0
          }));
        } finally {
          Nc = Nc || !1;
        }
        return Nc;
      }() ? n : !!n.capture;
    }
    function TF() {
      if (null == So) {
        if ("object" != typeof document || !document || "function" != typeof Element || !Element) return So = !1, So;
        if ("scrollBehavior" in document.documentElement.style) So = !0;else {
          const n = Element.prototype.scrollTo;
          So = !!n && !/\{\s*\[native code\]\s*\}/.test(n.toString());
        }
      }
      return So;
    }
    function Kd(n) {
      if (function IF() {
        if (null == Sh) {
          const n = typeof document < "u" ? document.head : null;
          Sh = !(!n || !n.createShadowRoot && !n.attachShadow);
        }
        return Sh;
      }()) {
        const t = n.getRootNode ? n.getRootNode() : null;
        if (typeof ShadowRoot < "u" && ShadowRoot && t instanceof ShadowRoot) return t;
      }
      return null;
    }
    function Fc() {
      let n = typeof document < "u" && document ? document.activeElement : null;
      for (; n && n.shadowRoot;) {
        const t = n.shadowRoot.activeElement;
        if (t === n) break;
        n = t;
      }
      return n;
    }
    function aa(n) {
      return n.composedPath ? n.composedPath()[0] : n.target;
    }
    function Eh() {
      return typeof __karma__ < "u" && !!__karma__ || typeof jasmine < "u" && !!jasmine || typeof jest < "u" && !!jest || typeof Mocha < "u" && !!Mocha;
    }
    const RF = new O("cdk-dir-doc", {
        providedIn: "root",
        factory: function zF() {
          return La(ie);
        }
      }),
      LF = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;
    let nn = (() => {
        class n {
          constructor(e) {
            if (this.value = "ltr", this.change = new E(), e) {
              const i = e.documentElement ? e.documentElement.dir : null;
              this.value = function NF(n) {
                const t = n?.toLowerCase() || "";
                return "auto" === t && typeof navigator < "u" && navigator?.language ? LF.test(navigator.language) ? "rtl" : "ltr" : "rtl" === t ? "rtl" : "ltr";
              }((e.body ? e.body.dir : null) || i || "ltr");
            }
          }
          ngOnDestroy() {
            this.change.complete();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(RF, 8));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      Jr = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({}), n;
      })(),
      c_ = (() => {
        class n {
          constructor(e, a, i) {
            this._ngZone = e, this._platform = a, this._scrolled = new V(), this._globalSubscription = null, this._scrolledCount = 0, this.scrollContainers = new Map(), this._document = i;
          }
          register(e) {
            this.scrollContainers.has(e) || this.scrollContainers.set(e, e.elementScrolled().subscribe(() => this._scrolled.next(e)));
          }
          deregister(e) {
            const a = this.scrollContainers.get(e);
            a && (a.unsubscribe(), this.scrollContainers.delete(e));
          }
          scrolled(e = 20) {
            return this._platform.isBrowser ? new Be(a => {
              this._globalSubscription || this._addGlobalListener();
              const i = e > 0 ? this._scrolled.pipe(o_(e)).subscribe(a) : this._scrolled.subscribe(a);
              return this._scrolledCount++, () => {
                i.unsubscribe(), this._scrolledCount--, this._scrolledCount || this._removeGlobalListener();
              };
            }) : nt();
          }
          ngOnDestroy() {
            this._removeGlobalListener(), this.scrollContainers.forEach((e, a) => this.deregister(a)), this._scrolled.complete();
          }
          ancestorScrolled(e, a) {
            const i = this.getAncestorScrollContainers(e);
            return this.scrolled(a).pipe(Ht(o => !o || i.indexOf(o) > -1));
          }
          getAncestorScrollContainers(e) {
            const a = [];
            return this.scrollContainers.forEach((i, o) => {
              this._scrollableContainsElement(o, e) && a.push(o);
            }), a;
          }
          _getWindow() {
            return this._document.defaultView || window;
          }
          _scrollableContainsElement(e, a) {
            let i = wt(a),
              o = e.getElementRef().nativeElement;
            do {
              if (i == o) return !0;
            } while (i = i.parentElement);
            return !1;
          }
          _addGlobalListener() {
            this._globalSubscription = this._ngZone.runOutsideAngular(() => Qr(this._getWindow().document, "scroll").subscribe(() => this._scrolled.next()));
          }
          _removeGlobalListener() {
            this._globalSubscription && (this._globalSubscription.unsubscribe(), this._globalSubscription = null);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(ae), M(Ct), M(ie, 8));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      Ki = (() => {
        class n {
          constructor(e, a, i) {
            this._platform = e, this._change = new V(), this._changeListener = o => {
              this._change.next(o);
            }, this._document = i, a.runOutsideAngular(() => {
              if (e.isBrowser) {
                const o = this._getWindow();
                o.addEventListener("resize", this._changeListener), o.addEventListener("orientationchange", this._changeListener);
              }
              this.change().subscribe(() => this._viewportSize = null);
            });
          }
          ngOnDestroy() {
            if (this._platform.isBrowser) {
              const e = this._getWindow();
              e.removeEventListener("resize", this._changeListener), e.removeEventListener("orientationchange", this._changeListener);
            }
            this._change.complete();
          }
          getViewportSize() {
            this._viewportSize || this._updateViewportSize();
            const e = {
              width: this._viewportSize.width,
              height: this._viewportSize.height
            };
            return this._platform.isBrowser || (this._viewportSize = null), e;
          }
          getViewportRect() {
            const e = this.getViewportScrollPosition(),
              {
                width: a,
                height: i
              } = this.getViewportSize();
            return {
              top: e.top,
              left: e.left,
              bottom: e.top + i,
              right: e.left + a,
              height: i,
              width: a
            };
          }
          getViewportScrollPosition() {
            if (!this._platform.isBrowser) return {
              top: 0,
              left: 0
            };
            const e = this._document,
              a = this._getWindow(),
              i = e.documentElement,
              o = i.getBoundingClientRect();
            return {
              top: -o.top || e.body.scrollTop || a.scrollY || i.scrollTop || 0,
              left: -o.left || e.body.scrollLeft || a.scrollX || i.scrollLeft || 0
            };
          }
          change(e = 20) {
            return e > 0 ? this._change.pipe(o_(e)) : this._change;
          }
          _getWindow() {
            return this._document.defaultView || window;
          }
          _updateViewportSize() {
            const e = this._getWindow();
            this._viewportSize = this._platform.isBrowser ? {
              width: e.innerWidth,
              height: e.innerHeight
            } : {
              width: 0,
              height: 0
            };
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(Ct), M(ae), M(ie, 8));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      Wa = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({}), n;
      })(),
      Qd = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [Jr, Wa, Jr, Wa]
        }), n;
      })();
    class Th {
      attach(t) {
        return this._attachedHost = t, t.attach(this);
      }
      detach() {
        let t = this._attachedHost;
        null != t && (this._attachedHost = null, t.detach());
      }
      get isAttached() {
        return null != this._attachedHost;
      }
      setAttachedHost(t) {
        this._attachedHost = t;
      }
    }
    class $r extends Th {
      constructor(t, e, a, i) {
        super(), this.component = t, this.viewContainerRef = e, this.injector = a, this.componentFactoryResolver = i;
      }
    }
    class Vc extends Th {
      constructor(t, e, a, i) {
        super(), this.templateRef = t, this.viewContainerRef = e, this.context = a, this.injector = i;
      }
      get origin() {
        return this.templateRef.elementRef;
      }
      attach(t, e = this.context) {
        return this.context = e, super.attach(t);
      }
      detach() {
        return this.context = void 0, super.detach();
      }
    }
    class HF extends Th {
      constructor(t) {
        super(), this.element = t instanceof J ? t.nativeElement : t;
      }
    }
    class Ih {
      constructor() {
        this._isDisposed = !1, this.attachDomPortal = null;
      }
      hasAttached() {
        return !!this._attachedPortal;
      }
      attach(t) {
        return t instanceof $r ? (this._attachedPortal = t, this.attachComponentPortal(t)) : t instanceof Vc ? (this._attachedPortal = t, this.attachTemplatePortal(t)) : this.attachDomPortal && t instanceof HF ? (this._attachedPortal = t, this.attachDomPortal(t)) : void 0;
      }
      detach() {
        this._attachedPortal && (this._attachedPortal.setAttachedHost(null), this._attachedPortal = null), this._invokeDisposeFn();
      }
      dispose() {
        this.hasAttached() && this.detach(), this._invokeDisposeFn(), this._isDisposed = !0;
      }
      setDisposeFn(t) {
        this._disposeFn = t;
      }
      _invokeDisposeFn() {
        this._disposeFn && (this._disposeFn(), this._disposeFn = null);
      }
    }
    class BF extends Ih {
      constructor(t, e, a, i, o) {
        super(), this.outletElement = t, this._componentFactoryResolver = e, this._appRef = a, this._defaultInjector = i, this.attachDomPortal = r => {
          const s = r.element,
            c = this._document.createComment("dom-portal");
          s.parentNode.insertBefore(c, s), this.outletElement.appendChild(s), this._attachedPortal = r, super.setDisposeFn(() => {
            c.parentNode && c.parentNode.replaceChild(s, c);
          });
        }, this._document = o;
      }
      attachComponentPortal(t) {
        const a = (t.componentFactoryResolver || this._componentFactoryResolver).resolveComponentFactory(t.component);
        let i;
        return t.viewContainerRef ? (i = t.viewContainerRef.createComponent(a, t.viewContainerRef.length, t.injector || t.viewContainerRef.injector), this.setDisposeFn(() => i.destroy())) : (i = a.create(t.injector || this._defaultInjector || Lt.NULL), this._appRef.attachView(i.hostView), this.setDisposeFn(() => {
          this._appRef.viewCount > 0 && this._appRef.detachView(i.hostView), i.destroy();
        })), this.outletElement.appendChild(this._getComponentRootNode(i)), this._attachedPortal = t, i;
      }
      attachTemplatePortal(t) {
        let e = t.viewContainerRef,
          a = e.createEmbeddedView(t.templateRef, t.context, {
            injector: t.injector
          });
        return a.rootNodes.forEach(i => this.outletElement.appendChild(i)), a.detectChanges(), this.setDisposeFn(() => {
          let i = e.indexOf(a);
          -1 !== i && e.remove(i);
        }), this._attachedPortal = t, a;
      }
      dispose() {
        super.dispose(), this.outletElement.remove();
      }
      _getComponentRootNode(t) {
        return t.hostView.rootNodes[0];
      }
    }
    let es = (() => {
        class n extends Ih {
          constructor(e, a, i) {
            super(), this._componentFactoryResolver = e, this._viewContainerRef = a, this._isInitialized = !1, this.attached = new E(), this.attachDomPortal = o => {
              const r = o.element,
                s = this._document.createComment("dom-portal");
              o.setAttachedHost(this), r.parentNode.insertBefore(s, r), this._getRootNode().appendChild(r), this._attachedPortal = o, super.setDisposeFn(() => {
                s.parentNode && s.parentNode.replaceChild(r, s);
              });
            }, this._document = i;
          }
          get portal() {
            return this._attachedPortal;
          }
          set portal(e) {
            this.hasAttached() && !e && !this._isInitialized || (this.hasAttached() && super.detach(), e && super.attach(e), this._attachedPortal = e || null);
          }
          get attachedRef() {
            return this._attachedRef;
          }
          ngOnInit() {
            this._isInitialized = !0;
          }
          ngOnDestroy() {
            super.dispose(), this._attachedPortal = null, this._attachedRef = null;
          }
          attachComponentPortal(e) {
            e.setAttachedHost(this);
            const a = null != e.viewContainerRef ? e.viewContainerRef : this._viewContainerRef,
              o = (e.componentFactoryResolver || this._componentFactoryResolver).resolveComponentFactory(e.component),
              r = a.createComponent(o, a.length, e.injector || a.injector);
            return a !== this._viewContainerRef && this._getRootNode().appendChild(r.hostView.rootNodes[0]), super.setDisposeFn(() => r.destroy()), this._attachedPortal = e, this._attachedRef = r, this.attached.emit(r), r;
          }
          attachTemplatePortal(e) {
            e.setAttachedHost(this);
            const a = this._viewContainerRef.createEmbeddedView(e.templateRef, e.context, {
              injector: e.injector
            });
            return super.setDisposeFn(() => this._viewContainerRef.clear()), this._attachedPortal = e, this._attachedRef = a, this.attached.emit(a), a;
          }
          _getRootNode() {
            const e = this._viewContainerRef.element.nativeElement;
            return e.nodeType === e.ELEMENT_NODE ? e : e.parentNode;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Vi), f(ut), f(ie));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "cdkPortalOutlet", ""]],
          inputs: {
            portal: ["cdkPortalOutlet", "portal"]
          },
          outputs: {
            attached: "attached"
          },
          exportAs: ["cdkPortalOutlet"],
          features: [z]
        }), n;
      })(),
      Ya = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({}), n;
      })();
    const l_ = (() => {
      function n() {
        return Error.call(this), this.message = "argument out of range", this.name = "ArgumentOutOfRangeError", this;
      }
      return n.prototype = Object.create(Error.prototype), n;
    })();
    function $e(n) {
      return t => 0 === n ? xd() : t.lift(new jF(n));
    }
    class jF {
      constructor(t) {
        if (this.total = t, this.total < 0) throw new l_();
      }
      call(t, e) {
        return e.subscribe(new UF(t, this.total));
      }
    }
    class UF extends Qe {
      constructor(t, e) {
        super(t), this.total = e, this.count = 0;
      }
      _next(t) {
        const e = this.total,
          a = ++this.count;
        a <= e && (this.destination.next(t), a === e && (this.destination.complete(), this.unsubscribe()));
      }
    }
    function ne(n) {
      return t => t.lift(new GF(n));
    }
    class GF {
      constructor(t) {
        this.notifier = t;
      }
      call(t, e) {
        const a = new WF(t),
          i = Vs(this.notifier, new Ns(a));
        return i && !a.seenValue ? (a.add(i), e.subscribe(a)) : a;
      }
    }
    class WF extends Fs {
      constructor(t) {
        super(t), this.seenValue = !1;
      }
      notifyNext() {
        this.seenValue = !0, this.complete();
      }
      notifyComplete() {}
    }
    class qF {
      constructor(t, e) {
        this.predicate = t, this.inclusive = e;
      }
      call(t, e) {
        return e.subscribe(new KF(t, this.predicate, this.inclusive));
      }
    }
    class KF extends Qe {
      constructor(t, e, a) {
        super(t), this.predicate = e, this.inclusive = a, this.index = 0;
      }
      _next(t) {
        const e = this.destination;
        let a;
        try {
          a = this.predicate(t, this.index++);
        } catch (i) {
          return void e.error(i);
        }
        this.nextOrComplete(t, a);
      }
      nextOrComplete(t, e) {
        const a = this.destination;
        Boolean(e) ? a.next(t) : (this.inclusive && a.next(t), a.complete());
      }
    }
    function Et(n, ...t) {
      return t.length ? t.some(e => n[e]) : n.altKey || n.shiftKey || n.ctrlKey || n.metaKey;
    }
    const m_ = TF();
    class tV {
      constructor(t, e) {
        this._viewportRuler = t, this._previousHTMLStyles = {
          top: "",
          left: ""
        }, this._isEnabled = !1, this._document = e;
      }
      attach() {}
      enable() {
        if (this._canBeEnabled()) {
          const t = this._document.documentElement;
          this._previousScrollPosition = this._viewportRuler.getViewportScrollPosition(), this._previousHTMLStyles.left = t.style.left || "", this._previousHTMLStyles.top = t.style.top || "", t.style.left = St(-this._previousScrollPosition.left), t.style.top = St(-this._previousScrollPosition.top), t.classList.add("cdk-global-scrollblock"), this._isEnabled = !0;
        }
      }
      disable() {
        if (this._isEnabled) {
          const t = this._document.documentElement,
            a = t.style,
            i = this._document.body.style,
            o = a.scrollBehavior || "",
            r = i.scrollBehavior || "";
          this._isEnabled = !1, a.left = this._previousHTMLStyles.left, a.top = this._previousHTMLStyles.top, t.classList.remove("cdk-global-scrollblock"), m_ && (a.scrollBehavior = i.scrollBehavior = "auto"), window.scroll(this._previousScrollPosition.left, this._previousScrollPosition.top), m_ && (a.scrollBehavior = o, i.scrollBehavior = r);
        }
      }
      _canBeEnabled() {
        if (this._document.documentElement.classList.contains("cdk-global-scrollblock") || this._isEnabled) return !1;
        const e = this._document.body,
          a = this._viewportRuler.getViewportSize();
        return e.scrollHeight > a.height || e.scrollWidth > a.width;
      }
    }
    class nV {
      constructor(t, e, a, i) {
        this._scrollDispatcher = t, this._ngZone = e, this._viewportRuler = a, this._config = i, this._scrollSubscription = null, this._detach = () => {
          this.disable(), this._overlayRef.hasAttached() && this._ngZone.run(() => this._overlayRef.detach());
        };
      }
      attach(t) {
        this._overlayRef = t;
      }
      enable() {
        if (this._scrollSubscription) return;
        const t = this._scrollDispatcher.scrolled(0);
        this._config && this._config.threshold && this._config.threshold > 1 ? (this._initialScrollPosition = this._viewportRuler.getViewportScrollPosition().top, this._scrollSubscription = t.subscribe(() => {
          const e = this._viewportRuler.getViewportScrollPosition().top;
          Math.abs(e - this._initialScrollPosition) > this._config.threshold ? this._detach() : this._overlayRef.updatePosition();
        })) : this._scrollSubscription = t.subscribe(this._detach);
      }
      disable() {
        this._scrollSubscription && (this._scrollSubscription.unsubscribe(), this._scrollSubscription = null);
      }
      detach() {
        this.disable(), this._overlayRef = null;
      }
    }
    class h_ {
      enable() {}
      disable() {}
      attach() {}
    }
    function Lh(n, t) {
      return t.some(e => n.bottom < e.top || n.top > e.bottom || n.right < e.left || n.left > e.right);
    }
    function p_(n, t) {
      return t.some(e => n.top < e.top || n.bottom > e.bottom || n.left < e.left || n.right > e.right);
    }
    class aV {
      constructor(t, e, a, i) {
        this._scrollDispatcher = t, this._viewportRuler = e, this._ngZone = a, this._config = i, this._scrollSubscription = null;
      }
      attach(t) {
        this._overlayRef = t;
      }
      enable() {
        this._scrollSubscription || (this._scrollSubscription = this._scrollDispatcher.scrolled(this._config ? this._config.scrollThrottle : 0).subscribe(() => {
          if (this._overlayRef.updatePosition(), this._config && this._config.autoClose) {
            const e = this._overlayRef.overlayElement.getBoundingClientRect(),
              {
                width: a,
                height: i
              } = this._viewportRuler.getViewportSize();
            Lh(e, [{
              width: a,
              height: i,
              bottom: i,
              right: a,
              top: 0,
              left: 0
            }]) && (this.disable(), this._ngZone.run(() => this._overlayRef.detach()));
          }
        }));
      }
      disable() {
        this._scrollSubscription && (this._scrollSubscription.unsubscribe(), this._scrollSubscription = null);
      }
      detach() {
        this.disable(), this._overlayRef = null;
      }
    }
    let iV = (() => {
      class n {
        constructor(e, a, i, o) {
          this._scrollDispatcher = e, this._viewportRuler = a, this._ngZone = i, this.noop = () => new h_(), this.close = r => new nV(this._scrollDispatcher, this._ngZone, this._viewportRuler, r), this.block = () => new tV(this._viewportRuler, this._document), this.reposition = r => new aV(this._scrollDispatcher, this._viewportRuler, this._ngZone, r), this._document = o;
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(c_), M(Ki), M(ae), M(ie));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac,
        providedIn: "root"
      }), n;
    })();
    class jc {
      constructor(t) {
        if (this.scrollStrategy = new h_(), this.panelClass = "", this.hasBackdrop = !1, this.backdropClass = "cdk-overlay-dark-backdrop", this.disposeOnNavigation = !1, t) {
          const e = Object.keys(t);
          for (const a of e) void 0 !== t[a] && (this[a] = t[a]);
        }
      }
    }
    class oV {
      constructor(t, e) {
        this.connectionPair = t, this.scrollableViewProperties = e;
      }
    }
    let g_ = (() => {
        class n {
          constructor(e) {
            this._attachedOverlays = [], this._document = e;
          }
          ngOnDestroy() {
            this.detach();
          }
          add(e) {
            this.remove(e), this._attachedOverlays.push(e);
          }
          remove(e) {
            const a = this._attachedOverlays.indexOf(e);
            a > -1 && this._attachedOverlays.splice(a, 1), 0 === this._attachedOverlays.length && this.detach();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(ie));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      rV = (() => {
        class n extends g_ {
          constructor(e, a) {
            super(e), this._ngZone = a, this._keydownListener = i => {
              const o = this._attachedOverlays;
              for (let r = o.length - 1; r > -1; r--) if (o[r]._keydownEvents.observers.length > 0) {
                const s = o[r]._keydownEvents;
                this._ngZone ? this._ngZone.run(() => s.next(i)) : s.next(i);
                break;
              }
            };
          }
          add(e) {
            super.add(e), this._isAttached || (this._ngZone ? this._ngZone.runOutsideAngular(() => this._document.body.addEventListener("keydown", this._keydownListener)) : this._document.body.addEventListener("keydown", this._keydownListener), this._isAttached = !0);
          }
          detach() {
            this._isAttached && (this._document.body.removeEventListener("keydown", this._keydownListener), this._isAttached = !1);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(ie), M(ae, 8));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      sV = (() => {
        class n extends g_ {
          constructor(e, a, i) {
            super(e), this._platform = a, this._ngZone = i, this._cursorStyleIsSet = !1, this._pointerDownListener = o => {
              this._pointerDownEventTarget = aa(o);
            }, this._clickListener = o => {
              const r = aa(o),
                s = "click" === o.type && this._pointerDownEventTarget ? this._pointerDownEventTarget : r;
              this._pointerDownEventTarget = null;
              const c = this._attachedOverlays.slice();
              for (let l = c.length - 1; l > -1; l--) {
                const d = c[l];
                if (d._outsidePointerEvents.observers.length < 1 || !d.hasAttached()) continue;
                if (d.overlayElement.contains(r) || d.overlayElement.contains(s)) break;
                const u = d._outsidePointerEvents;
                this._ngZone ? this._ngZone.run(() => u.next(o)) : u.next(o);
              }
            };
          }
          add(e) {
            if (super.add(e), !this._isAttached) {
              const a = this._document.body;
              this._ngZone ? this._ngZone.runOutsideAngular(() => this._addEventListeners(a)) : this._addEventListeners(a), this._platform.IOS && !this._cursorStyleIsSet && (this._cursorOriginalValue = a.style.cursor, a.style.cursor = "pointer", this._cursorStyleIsSet = !0), this._isAttached = !0;
            }
          }
          detach() {
            if (this._isAttached) {
              const e = this._document.body;
              e.removeEventListener("pointerdown", this._pointerDownListener, !0), e.removeEventListener("click", this._clickListener, !0), e.removeEventListener("auxclick", this._clickListener, !0), e.removeEventListener("contextmenu", this._clickListener, !0), this._platform.IOS && this._cursorStyleIsSet && (e.style.cursor = this._cursorOriginalValue, this._cursorStyleIsSet = !1), this._isAttached = !1;
            }
          }
          _addEventListeners(e) {
            e.addEventListener("pointerdown", this._pointerDownListener, !0), e.addEventListener("click", this._clickListener, !0), e.addEventListener("auxclick", this._clickListener, !0), e.addEventListener("contextmenu", this._clickListener, !0);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(ie), M(Ct), M(ae, 8));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      Xd = (() => {
        class n {
          constructor(e, a) {
            this._platform = a, this._document = e;
          }
          ngOnDestroy() {
            this._containerElement?.remove();
          }
          getContainerElement() {
            return this._containerElement || this._createContainer(), this._containerElement;
          }
          _createContainer() {
            const e = "cdk-overlay-container";
            if (this._platform.isBrowser || Eh()) {
              const i = this._document.querySelectorAll(`.${e}[platform="server"], .${e}[platform="test"]`);
              for (let o = 0; o < i.length; o++) i[o].remove();
            }
            const a = this._document.createElement("div");
            a.classList.add(e), Eh() ? a.setAttribute("platform", "test") : this._platform.isBrowser || a.setAttribute("platform", "server"), this._document.body.appendChild(a), this._containerElement = a;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(ie), M(Ct));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })();
    class Uc {
      constructor(t, e, a, i, o, r, s, c, l, d = !1) {
        this._portalOutlet = t, this._host = e, this._pane = a, this._config = i, this._ngZone = o, this._keyboardDispatcher = r, this._document = s, this._location = c, this._outsideClickDispatcher = l, this._animationsDisabled = d, this._backdropElement = null, this._backdropClick = new V(), this._attachments = new V(), this._detachments = new V(), this._locationChanges = re.EMPTY, this._backdropClickHandler = u => this._backdropClick.next(u), this._backdropTransitionendHandler = u => {
          this._disposeBackdrop(u.target);
        }, this._keydownEvents = new V(), this._outsidePointerEvents = new V(), i.scrollStrategy && (this._scrollStrategy = i.scrollStrategy, this._scrollStrategy.attach(this)), this._positionStrategy = i.positionStrategy;
      }
      get overlayElement() {
        return this._pane;
      }
      get backdropElement() {
        return this._backdropElement;
      }
      get hostElement() {
        return this._host;
      }
      attach(t) {
        !this._host.parentElement && this._previousHostParent && this._previousHostParent.appendChild(this._host);
        const e = this._portalOutlet.attach(t);
        return this._positionStrategy && this._positionStrategy.attach(this), this._updateStackingOrder(), this._updateElementSize(), this._updateElementDirection(), this._scrollStrategy && this._scrollStrategy.enable(), this._ngZone.onStable.pipe($e(1)).subscribe(() => {
          this.hasAttached() && this.updatePosition();
        }), this._togglePointerEvents(!0), this._config.hasBackdrop && this._attachBackdrop(), this._config.panelClass && this._toggleClasses(this._pane, this._config.panelClass, !0), this._attachments.next(), this._keyboardDispatcher.add(this), this._config.disposeOnNavigation && (this._locationChanges = this._location.subscribe(() => this.dispose())), this._outsideClickDispatcher.add(this), "function" == typeof e?.onDestroy && e.onDestroy(() => {
          this.hasAttached() && this._ngZone.runOutsideAngular(() => Promise.resolve().then(() => this.detach()));
        }), e;
      }
      detach() {
        if (!this.hasAttached()) return;
        this.detachBackdrop(), this._togglePointerEvents(!1), this._positionStrategy && this._positionStrategy.detach && this._positionStrategy.detach(), this._scrollStrategy && this._scrollStrategy.disable();
        const t = this._portalOutlet.detach();
        return this._detachments.next(), this._keyboardDispatcher.remove(this), this._detachContentWhenStable(), this._locationChanges.unsubscribe(), this._outsideClickDispatcher.remove(this), t;
      }
      dispose() {
        const t = this.hasAttached();
        this._positionStrategy && this._positionStrategy.dispose(), this._disposeScrollStrategy(), this._disposeBackdrop(this._backdropElement), this._locationChanges.unsubscribe(), this._keyboardDispatcher.remove(this), this._portalOutlet.dispose(), this._attachments.complete(), this._backdropClick.complete(), this._keydownEvents.complete(), this._outsidePointerEvents.complete(), this._outsideClickDispatcher.remove(this), this._host?.remove(), this._previousHostParent = this._pane = this._host = null, t && this._detachments.next(), this._detachments.complete();
      }
      hasAttached() {
        return this._portalOutlet.hasAttached();
      }
      backdropClick() {
        return this._backdropClick;
      }
      attachments() {
        return this._attachments;
      }
      detachments() {
        return this._detachments;
      }
      keydownEvents() {
        return this._keydownEvents;
      }
      outsidePointerEvents() {
        return this._outsidePointerEvents;
      }
      getConfig() {
        return this._config;
      }
      updatePosition() {
        this._positionStrategy && this._positionStrategy.apply();
      }
      updatePositionStrategy(t) {
        t !== this._positionStrategy && (this._positionStrategy && this._positionStrategy.dispose(), this._positionStrategy = t, this.hasAttached() && (t.attach(this), this.updatePosition()));
      }
      updateSize(t) {
        this._config = {
          ...this._config,
          ...t
        }, this._updateElementSize();
      }
      setDirection(t) {
        this._config = {
          ...this._config,
          direction: t
        }, this._updateElementDirection();
      }
      addPanelClass(t) {
        this._pane && this._toggleClasses(this._pane, t, !0);
      }
      removePanelClass(t) {
        this._pane && this._toggleClasses(this._pane, t, !1);
      }
      getDirection() {
        const t = this._config.direction;
        return t ? "string" == typeof t ? t : t.value : "ltr";
      }
      updateScrollStrategy(t) {
        t !== this._scrollStrategy && (this._disposeScrollStrategy(), this._scrollStrategy = t, this.hasAttached() && (t.attach(this), t.enable()));
      }
      _updateElementDirection() {
        this._host.setAttribute("dir", this.getDirection());
      }
      _updateElementSize() {
        if (!this._pane) return;
        const t = this._pane.style;
        t.width = St(this._config.width), t.height = St(this._config.height), t.minWidth = St(this._config.minWidth), t.minHeight = St(this._config.minHeight), t.maxWidth = St(this._config.maxWidth), t.maxHeight = St(this._config.maxHeight);
      }
      _togglePointerEvents(t) {
        this._pane.style.pointerEvents = t ? "" : "none";
      }
      _attachBackdrop() {
        const t = "cdk-overlay-backdrop-showing";
        this._backdropElement = this._document.createElement("div"), this._backdropElement.classList.add("cdk-overlay-backdrop"), this._animationsDisabled && this._backdropElement.classList.add("cdk-overlay-backdrop-noop-animation"), this._config.backdropClass && this._toggleClasses(this._backdropElement, this._config.backdropClass, !0), this._host.parentElement.insertBefore(this._backdropElement, this._host), this._backdropElement.addEventListener("click", this._backdropClickHandler), !this._animationsDisabled && typeof requestAnimationFrame < "u" ? this._ngZone.runOutsideAngular(() => {
          requestAnimationFrame(() => {
            this._backdropElement && this._backdropElement.classList.add(t);
          });
        }) : this._backdropElement.classList.add(t);
      }
      _updateStackingOrder() {
        this._host.nextSibling && this._host.parentNode.appendChild(this._host);
      }
      detachBackdrop() {
        const t = this._backdropElement;
        if (t) {
          if (this._animationsDisabled) return void this._disposeBackdrop(t);
          t.classList.remove("cdk-overlay-backdrop-showing"), this._ngZone.runOutsideAngular(() => {
            t.addEventListener("transitionend", this._backdropTransitionendHandler);
          }), t.style.pointerEvents = "none", this._backdropTimeout = this._ngZone.runOutsideAngular(() => setTimeout(() => {
            this._disposeBackdrop(t);
          }, 500));
        }
      }
      _toggleClasses(t, e, a) {
        const i = Wd(e || []).filter(o => !!o);
        i.length && (a ? t.classList.add(...i) : t.classList.remove(...i));
      }
      _detachContentWhenStable() {
        this._ngZone.runOutsideAngular(() => {
          const t = this._ngZone.onStable.pipe(ne(dt(this._attachments, this._detachments))).subscribe(() => {
            (!this._pane || !this._host || 0 === this._pane.children.length) && (this._pane && this._config.panelClass && this._toggleClasses(this._pane, this._config.panelClass, !1), this._host && this._host.parentElement && (this._previousHostParent = this._host.parentElement, this._host.remove()), t.unsubscribe());
          });
        });
      }
      _disposeScrollStrategy() {
        const t = this._scrollStrategy;
        t && (t.disable(), t.detach && t.detach());
      }
      _disposeBackdrop(t) {
        t && (t.removeEventListener("click", this._backdropClickHandler), t.removeEventListener("transitionend", this._backdropTransitionendHandler), t.remove(), this._backdropElement === t && (this._backdropElement = null)), this._backdropTimeout && (clearTimeout(this._backdropTimeout), this._backdropTimeout = void 0);
      }
    }
    const b_ = "cdk-overlay-connected-position-bounding-box",
      cV = /([A-Za-z%]+)$/;
    class __ {
      constructor(t, e, a, i, o) {
        this._viewportRuler = e, this._document = a, this._platform = i, this._overlayContainer = o, this._lastBoundingBoxSize = {
          width: 0,
          height: 0
        }, this._isPushed = !1, this._canPush = !0, this._growAfterOpen = !1, this._hasFlexibleDimensions = !0, this._positionLocked = !1, this._viewportMargin = 0, this._scrollables = [], this._preferredPositions = [], this._positionChanges = new V(), this._resizeSubscription = re.EMPTY, this._offsetX = 0, this._offsetY = 0, this._appliedPanelClasses = [], this.positionChanges = this._positionChanges, this.setOrigin(t);
      }
      get positions() {
        return this._preferredPositions;
      }
      attach(t) {
        this._validatePositions(), t.hostElement.classList.add(b_), this._overlayRef = t, this._boundingBox = t.hostElement, this._pane = t.overlayElement, this._isDisposed = !1, this._isInitialRender = !0, this._lastPosition = null, this._resizeSubscription.unsubscribe(), this._resizeSubscription = this._viewportRuler.change().subscribe(() => {
          this._isInitialRender = !0, this.apply();
        });
      }
      apply() {
        if (this._isDisposed || !this._platform.isBrowser) return;
        if (!this._isInitialRender && this._positionLocked && this._lastPosition) return void this.reapplyLastPosition();
        this._clearPanelClasses(), this._resetOverlayElementStyles(), this._resetBoundingBoxStyles(), this._viewportRect = this._getNarrowedViewportRect(), this._originRect = this._getOriginRect(), this._overlayRect = this._pane.getBoundingClientRect(), this._containerRect = this._overlayContainer.getContainerElement().getBoundingClientRect();
        const t = this._originRect,
          e = this._overlayRect,
          a = this._viewportRect,
          i = this._containerRect,
          o = [];
        let r;
        for (let s of this._preferredPositions) {
          let c = this._getOriginPoint(t, i, s),
            l = this._getOverlayPoint(c, e, s),
            d = this._getOverlayFit(l, e, a, s);
          if (d.isCompletelyWithinViewport) return this._isPushed = !1, void this._applyPosition(s, c);
          this._canFitWithFlexibleDimensions(d, l, a) ? o.push({
            position: s,
            origin: c,
            overlayRect: e,
            boundingBoxRect: this._calculateBoundingBoxRect(c, s)
          }) : (!r || r.overlayFit.visibleArea < d.visibleArea) && (r = {
            overlayFit: d,
            overlayPoint: l,
            originPoint: c,
            position: s,
            overlayRect: e
          });
        }
        if (o.length) {
          let s = null,
            c = -1;
          for (const l of o) {
            const d = l.boundingBoxRect.width * l.boundingBoxRect.height * (l.position.weight || 1);
            d > c && (c = d, s = l);
          }
          return this._isPushed = !1, void this._applyPosition(s.position, s.origin);
        }
        if (this._canPush) return this._isPushed = !0, void this._applyPosition(r.position, r.originPoint);
        this._applyPosition(r.position, r.originPoint);
      }
      detach() {
        this._clearPanelClasses(), this._lastPosition = null, this._previousPushAmount = null, this._resizeSubscription.unsubscribe();
      }
      dispose() {
        this._isDisposed || (this._boundingBox && Io(this._boundingBox.style, {
          top: "",
          left: "",
          right: "",
          bottom: "",
          height: "",
          width: "",
          alignItems: "",
          justifyContent: ""
        }), this._pane && this._resetOverlayElementStyles(), this._overlayRef && this._overlayRef.hostElement.classList.remove(b_), this.detach(), this._positionChanges.complete(), this._overlayRef = this._boundingBox = null, this._isDisposed = !0);
      }
      reapplyLastPosition() {
        if (this._isDisposed || !this._platform.isBrowser) return;
        const t = this._lastPosition;
        if (t) {
          this._originRect = this._getOriginRect(), this._overlayRect = this._pane.getBoundingClientRect(), this._viewportRect = this._getNarrowedViewportRect(), this._containerRect = this._overlayContainer.getContainerElement().getBoundingClientRect();
          const e = this._getOriginPoint(this._originRect, this._containerRect, t);
          this._applyPosition(t, e);
        } else this.apply();
      }
      withScrollableContainers(t) {
        return this._scrollables = t, this;
      }
      withPositions(t) {
        return this._preferredPositions = t, -1 === t.indexOf(this._lastPosition) && (this._lastPosition = null), this._validatePositions(), this;
      }
      withViewportMargin(t) {
        return this._viewportMargin = t, this;
      }
      withFlexibleDimensions(t = !0) {
        return this._hasFlexibleDimensions = t, this;
      }
      withGrowAfterOpen(t = !0) {
        return this._growAfterOpen = t, this;
      }
      withPush(t = !0) {
        return this._canPush = t, this;
      }
      withLockedPosition(t = !0) {
        return this._positionLocked = t, this;
      }
      setOrigin(t) {
        return this._origin = t, this;
      }
      withDefaultOffsetX(t) {
        return this._offsetX = t, this;
      }
      withDefaultOffsetY(t) {
        return this._offsetY = t, this;
      }
      withTransformOriginOn(t) {
        return this._transformOriginSelector = t, this;
      }
      _getOriginPoint(t, e, a) {
        let i, o;
        if ("center" == a.originX) i = t.left + t.width / 2;else {
          const r = this._isRtl() ? t.right : t.left,
            s = this._isRtl() ? t.left : t.right;
          i = "start" == a.originX ? r : s;
        }
        return e.left < 0 && (i -= e.left), o = "center" == a.originY ? t.top + t.height / 2 : "top" == a.originY ? t.top : t.bottom, e.top < 0 && (o -= e.top), {
          x: i,
          y: o
        };
      }
      _getOverlayPoint(t, e, a) {
        let i, o;
        return i = "center" == a.overlayX ? -e.width / 2 : "start" === a.overlayX ? this._isRtl() ? -e.width : 0 : this._isRtl() ? 0 : -e.width, o = "center" == a.overlayY ? -e.height / 2 : "top" == a.overlayY ? 0 : -e.height, {
          x: t.x + i,
          y: t.y + o
        };
      }
      _getOverlayFit(t, e, a, i) {
        const o = y_(e);
        let {
            x: r,
            y: s
          } = t,
          c = this._getOffset(i, "x"),
          l = this._getOffset(i, "y");
        c && (r += c), l && (s += l);
        let m = 0 - s,
          h = s + o.height - a.height,
          p = this._subtractOverflows(o.width, 0 - r, r + o.width - a.width),
          v = this._subtractOverflows(o.height, m, h),
          C = p * v;
        return {
          visibleArea: C,
          isCompletelyWithinViewport: o.width * o.height === C,
          fitsInViewportVertically: v === o.height,
          fitsInViewportHorizontally: p == o.width
        };
      }
      _canFitWithFlexibleDimensions(t, e, a) {
        if (this._hasFlexibleDimensions) {
          const i = a.bottom - e.y,
            o = a.right - e.x,
            r = v_(this._overlayRef.getConfig().minHeight),
            s = v_(this._overlayRef.getConfig().minWidth),
            l = t.fitsInViewportHorizontally || null != s && s <= o;
          return (t.fitsInViewportVertically || null != r && r <= i) && l;
        }
        return !1;
      }
      _pushOverlayOnScreen(t, e, a) {
        if (this._previousPushAmount && this._positionLocked) return {
          x: t.x + this._previousPushAmount.x,
          y: t.y + this._previousPushAmount.y
        };
        const i = y_(e),
          o = this._viewportRect,
          r = Math.max(t.x + i.width - o.width, 0),
          s = Math.max(t.y + i.height - o.height, 0),
          c = Math.max(o.top - a.top - t.y, 0),
          l = Math.max(o.left - a.left - t.x, 0);
        let d = 0,
          u = 0;
        return d = i.width <= o.width ? l || -r : t.x < this._viewportMargin ? o.left - a.left - t.x : 0, u = i.height <= o.height ? c || -s : t.y < this._viewportMargin ? o.top - a.top - t.y : 0, this._previousPushAmount = {
          x: d,
          y: u
        }, {
          x: t.x + d,
          y: t.y + u
        };
      }
      _applyPosition(t, e) {
        if (this._setTransformOrigin(t), this._setOverlayElementStyles(e, t), this._setBoundingBoxStyles(e, t), t.panelClass && this._addPanelClasses(t.panelClass), this._lastPosition = t, this._positionChanges.observers.length) {
          const a = this._getScrollVisibility(),
            i = new oV(t, a);
          this._positionChanges.next(i);
        }
        this._isInitialRender = !1;
      }
      _setTransformOrigin(t) {
        if (!this._transformOriginSelector) return;
        const e = this._boundingBox.querySelectorAll(this._transformOriginSelector);
        let a,
          i = t.overlayY;
        a = "center" === t.overlayX ? "center" : this._isRtl() ? "start" === t.overlayX ? "right" : "left" : "start" === t.overlayX ? "left" : "right";
        for (let o = 0; o < e.length; o++) e[o].style.transformOrigin = `${a} ${i}`;
      }
      _calculateBoundingBoxRect(t, e) {
        const a = this._viewportRect,
          i = this._isRtl();
        let o, r, s, d, u, m;
        if ("top" === e.overlayY) r = t.y, o = a.height - r + this._viewportMargin;else if ("bottom" === e.overlayY) s = a.height - t.y + 2 * this._viewportMargin, o = a.height - s + this._viewportMargin;else {
          const h = Math.min(a.bottom - t.y + a.top, t.y),
            p = this._lastBoundingBoxSize.height;
          o = 2 * h, r = t.y - h, o > p && !this._isInitialRender && !this._growAfterOpen && (r = t.y - p / 2);
        }
        if ("end" === e.overlayX && !i || "start" === e.overlayX && i) m = a.width - t.x + this._viewportMargin, d = t.x - this._viewportMargin;else if ("start" === e.overlayX && !i || "end" === e.overlayX && i) u = t.x, d = a.right - t.x;else {
          const h = Math.min(a.right - t.x + a.left, t.x),
            p = this._lastBoundingBoxSize.width;
          d = 2 * h, u = t.x - h, d > p && !this._isInitialRender && !this._growAfterOpen && (u = t.x - p / 2);
        }
        return {
          top: r,
          left: u,
          bottom: s,
          right: m,
          width: d,
          height: o
        };
      }
      _setBoundingBoxStyles(t, e) {
        const a = this._calculateBoundingBoxRect(t, e);
        !this._isInitialRender && !this._growAfterOpen && (a.height = Math.min(a.height, this._lastBoundingBoxSize.height), a.width = Math.min(a.width, this._lastBoundingBoxSize.width));
        const i = {};
        if (this._hasExactPosition()) i.top = i.left = "0", i.bottom = i.right = i.maxHeight = i.maxWidth = "", i.width = i.height = "100%";else {
          const o = this._overlayRef.getConfig().maxHeight,
            r = this._overlayRef.getConfig().maxWidth;
          i.height = St(a.height), i.top = St(a.top), i.bottom = St(a.bottom), i.width = St(a.width), i.left = St(a.left), i.right = St(a.right), i.alignItems = "center" === e.overlayX ? "center" : "end" === e.overlayX ? "flex-end" : "flex-start", i.justifyContent = "center" === e.overlayY ? "center" : "bottom" === e.overlayY ? "flex-end" : "flex-start", o && (i.maxHeight = St(o)), r && (i.maxWidth = St(r));
        }
        this._lastBoundingBoxSize = a, Io(this._boundingBox.style, i);
      }
      _resetBoundingBoxStyles() {
        Io(this._boundingBox.style, {
          top: "0",
          left: "0",
          right: "0",
          bottom: "0",
          height: "",
          width: "",
          alignItems: "",
          justifyContent: ""
        });
      }
      _resetOverlayElementStyles() {
        Io(this._pane.style, {
          top: "",
          left: "",
          bottom: "",
          right: "",
          position: "",
          transform: ""
        });
      }
      _setOverlayElementStyles(t, e) {
        const a = {},
          i = this._hasExactPosition(),
          o = this._hasFlexibleDimensions,
          r = this._overlayRef.getConfig();
        if (i) {
          const d = this._viewportRuler.getViewportScrollPosition();
          Io(a, this._getExactOverlayY(e, t, d)), Io(a, this._getExactOverlayX(e, t, d));
        } else a.position = "static";
        let s = "",
          c = this._getOffset(e, "x"),
          l = this._getOffset(e, "y");
        c && (s += `translateX(${c}px) `), l && (s += `translateY(${l}px)`), a.transform = s.trim(), r.maxHeight && (i ? a.maxHeight = St(r.maxHeight) : o && (a.maxHeight = "")), r.maxWidth && (i ? a.maxWidth = St(r.maxWidth) : o && (a.maxWidth = "")), Io(this._pane.style, a);
      }
      _getExactOverlayY(t, e, a) {
        let i = {
            top: "",
            bottom: ""
          },
          o = this._getOverlayPoint(e, this._overlayRect, t);
        return this._isPushed && (o = this._pushOverlayOnScreen(o, this._overlayRect, a)), "bottom" === t.overlayY ? i.bottom = this._document.documentElement.clientHeight - (o.y + this._overlayRect.height) + "px" : i.top = St(o.y), i;
      }
      _getExactOverlayX(t, e, a) {
        let r,
          i = {
            left: "",
            right: ""
          },
          o = this._getOverlayPoint(e, this._overlayRect, t);
        return this._isPushed && (o = this._pushOverlayOnScreen(o, this._overlayRect, a)), r = this._isRtl() ? "end" === t.overlayX ? "left" : "right" : "end" === t.overlayX ? "right" : "left", "right" === r ? i.right = this._document.documentElement.clientWidth - (o.x + this._overlayRect.width) + "px" : i.left = St(o.x), i;
      }
      _getScrollVisibility() {
        const t = this._getOriginRect(),
          e = this._pane.getBoundingClientRect(),
          a = this._scrollables.map(i => i.getElementRef().nativeElement.getBoundingClientRect());
        return {
          isOriginClipped: p_(t, a),
          isOriginOutsideView: Lh(t, a),
          isOverlayClipped: p_(e, a),
          isOverlayOutsideView: Lh(e, a)
        };
      }
      _subtractOverflows(t, ...e) {
        return e.reduce((a, i) => a - Math.max(i, 0), t);
      }
      _getNarrowedViewportRect() {
        const t = this._document.documentElement.clientWidth,
          e = this._document.documentElement.clientHeight,
          a = this._viewportRuler.getViewportScrollPosition();
        return {
          top: a.top + this._viewportMargin,
          left: a.left + this._viewportMargin,
          right: a.left + t - this._viewportMargin,
          bottom: a.top + e - this._viewportMargin,
          width: t - 2 * this._viewportMargin,
          height: e - 2 * this._viewportMargin
        };
      }
      _isRtl() {
        return "rtl" === this._overlayRef.getDirection();
      }
      _hasExactPosition() {
        return !this._hasFlexibleDimensions || this._isPushed;
      }
      _getOffset(t, e) {
        return "x" === e ? t.offsetX ?? this._offsetX : t.offsetY ?? this._offsetY;
      }
      _validatePositions() {}
      _addPanelClasses(t) {
        this._pane && Wd(t).forEach(e => {
          "" !== e && -1 === this._appliedPanelClasses.indexOf(e) && (this._appliedPanelClasses.push(e), this._pane.classList.add(e));
        });
      }
      _clearPanelClasses() {
        this._pane && (this._appliedPanelClasses.forEach(t => {
          this._pane.classList.remove(t);
        }), this._appliedPanelClasses = []);
      }
      _getOriginRect() {
        const t = this._origin;
        if (t instanceof J) return t.nativeElement.getBoundingClientRect();
        if (t instanceof Element) return t.getBoundingClientRect();
        const e = t.width || 0,
          a = t.height || 0;
        return {
          top: t.y,
          bottom: t.y + a,
          left: t.x,
          right: t.x + e,
          height: a,
          width: e
        };
      }
    }
    function Io(n, t) {
      for (let e in t) t.hasOwnProperty(e) && (n[e] = t[e]);
      return n;
    }
    function v_(n) {
      if ("number" != typeof n && null != n) {
        const [t, e] = n.split(cV);
        return e && "px" !== e ? null : parseFloat(t);
      }
      return n || null;
    }
    function y_(n) {
      return {
        top: Math.floor(n.top),
        right: Math.floor(n.right),
        bottom: Math.floor(n.bottom),
        left: Math.floor(n.left),
        width: Math.floor(n.width),
        height: Math.floor(n.height)
      };
    }
    const C_ = "cdk-global-overlay-wrapper";
    class lV {
      constructor() {
        this._cssPosition = "static", this._topOffset = "", this._bottomOffset = "", this._alignItems = "", this._xPosition = "", this._xOffset = "", this._width = "", this._height = "", this._isDisposed = !1;
      }
      attach(t) {
        const e = t.getConfig();
        this._overlayRef = t, this._width && !e.width && t.updateSize({
          width: this._width
        }), this._height && !e.height && t.updateSize({
          height: this._height
        }), t.hostElement.classList.add(C_), this._isDisposed = !1;
      }
      top(t = "") {
        return this._bottomOffset = "", this._topOffset = t, this._alignItems = "flex-start", this;
      }
      left(t = "") {
        return this._xOffset = t, this._xPosition = "left", this;
      }
      bottom(t = "") {
        return this._topOffset = "", this._bottomOffset = t, this._alignItems = "flex-end", this;
      }
      right(t = "") {
        return this._xOffset = t, this._xPosition = "right", this;
      }
      start(t = "") {
        return this._xOffset = t, this._xPosition = "start", this;
      }
      end(t = "") {
        return this._xOffset = t, this._xPosition = "end", this;
      }
      width(t = "") {
        return this._overlayRef ? this._overlayRef.updateSize({
          width: t
        }) : this._width = t, this;
      }
      height(t = "") {
        return this._overlayRef ? this._overlayRef.updateSize({
          height: t
        }) : this._height = t, this;
      }
      centerHorizontally(t = "") {
        return this.left(t), this._xPosition = "center", this;
      }
      centerVertically(t = "") {
        return this.top(t), this._alignItems = "center", this;
      }
      apply() {
        if (!this._overlayRef || !this._overlayRef.hasAttached()) return;
        const t = this._overlayRef.overlayElement.style,
          e = this._overlayRef.hostElement.style,
          a = this._overlayRef.getConfig(),
          {
            width: i,
            height: o,
            maxWidth: r,
            maxHeight: s
          } = a,
          c = !("100%" !== i && "100vw" !== i || r && "100%" !== r && "100vw" !== r),
          l = !("100%" !== o && "100vh" !== o || s && "100%" !== s && "100vh" !== s),
          d = this._xPosition,
          u = this._xOffset,
          m = "rtl" === this._overlayRef.getConfig().direction;
        let h = "",
          p = "",
          v = "";
        c ? v = "flex-start" : "center" === d ? (v = "center", m ? p = u : h = u) : m ? "left" === d || "end" === d ? (v = "flex-end", h = u) : ("right" === d || "start" === d) && (v = "flex-start", p = u) : "left" === d || "start" === d ? (v = "flex-start", h = u) : ("right" === d || "end" === d) && (v = "flex-end", p = u), t.position = this._cssPosition, t.marginLeft = c ? "0" : h, t.marginTop = l ? "0" : this._topOffset, t.marginBottom = this._bottomOffset, t.marginRight = c ? "0" : p, e.justifyContent = v, e.alignItems = l ? "flex-start" : this._alignItems;
      }
      dispose() {
        if (this._isDisposed || !this._overlayRef) return;
        const t = this._overlayRef.overlayElement.style,
          e = this._overlayRef.hostElement,
          a = e.style;
        e.classList.remove(C_), a.justifyContent = a.alignItems = t.marginTop = t.marginBottom = t.marginLeft = t.marginRight = t.position = "", this._overlayRef = null, this._isDisposed = !0;
      }
    }
    let dV = (() => {
        class n {
          constructor(e, a, i, o) {
            this._viewportRuler = e, this._document = a, this._platform = i, this._overlayContainer = o;
          }
          global() {
            return new lV();
          }
          flexibleConnectedTo(e) {
            return new __(e, this._viewportRuler, this._document, this._platform, this._overlayContainer);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(Ki), M(ie), M(Ct), M(Xd));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      uV = 0,
      mn = (() => {
        class n {
          constructor(e, a, i, o, r, s, c, l, d, u, m, h) {
            this.scrollStrategies = e, this._overlayContainer = a, this._componentFactoryResolver = i, this._positionBuilder = o, this._keyboardDispatcher = r, this._injector = s, this._ngZone = c, this._document = l, this._directionality = d, this._location = u, this._outsideClickDispatcher = m, this._animationsModuleType = h;
          }
          create(e) {
            const a = this._createHostElement(),
              i = this._createPaneElement(a),
              o = this._createPortalOutlet(i),
              r = new jc(e);
            return r.direction = r.direction || this._directionality.value, new Uc(o, a, i, r, this._ngZone, this._keyboardDispatcher, this._document, this._location, this._outsideClickDispatcher, "NoopAnimations" === this._animationsModuleType);
          }
          position() {
            return this._positionBuilder;
          }
          _createPaneElement(e) {
            const a = this._document.createElement("div");
            return a.id = "cdk-overlay-" + uV++, a.classList.add("cdk-overlay-pane"), e.appendChild(a), a;
          }
          _createHostElement() {
            const e = this._document.createElement("div");
            return this._overlayContainer.getContainerElement().appendChild(e), e;
          }
          _createPortalOutlet(e) {
            return this._appRef || (this._appRef = this._injector.get(Gr)), new BF(e, this._componentFactoryResolver, this._appRef, this._injector, this._document);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(iV), M(Xd), M(Vi), M(dV), M(rV), M(Lt), M(ae), M(ie), M(nn), M(Am), M(sV), M(Ft, 8));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac
        }), n;
      })();
    const fV = [{
        originX: "start",
        originY: "bottom",
        overlayX: "start",
        overlayY: "top"
      }, {
        originX: "start",
        originY: "top",
        overlayX: "start",
        overlayY: "bottom"
      }, {
        originX: "end",
        originY: "top",
        overlayX: "end",
        overlayY: "bottom"
      }, {
        originX: "end",
        originY: "bottom",
        overlayX: "end",
        overlayY: "top"
      }],
      M_ = new O("cdk-connected-overlay-scroll-strategy");
    let x_ = (() => {
        class n {
          constructor(e) {
            this.elementRef = e;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "cdk-overlay-origin", ""], ["", "overlay-origin", ""], ["", "cdkOverlayOrigin", ""]],
          exportAs: ["cdkOverlayOrigin"]
        }), n;
      })(),
      w_ = (() => {
        class n {
          constructor(e, a, i, o, r) {
            this._overlay = e, this._dir = r, this._hasBackdrop = !1, this._lockPosition = !1, this._growAfterOpen = !1, this._flexibleDimensions = !1, this._push = !1, this._backdropSubscription = re.EMPTY, this._attachSubscription = re.EMPTY, this._detachSubscription = re.EMPTY, this._positionSubscription = re.EMPTY, this.viewportMargin = 0, this.open = !1, this.disableClose = !1, this.backdropClick = new E(), this.positionChange = new E(), this.attach = new E(), this.detach = new E(), this.overlayKeydown = new E(), this.overlayOutsideClick = new E(), this._templatePortal = new Vc(a, i), this._scrollStrategyFactory = o, this.scrollStrategy = this._scrollStrategyFactory();
          }
          get offsetX() {
            return this._offsetX;
          }
          set offsetX(e) {
            this._offsetX = e, this._position && this._updatePositionStrategy(this._position);
          }
          get offsetY() {
            return this._offsetY;
          }
          set offsetY(e) {
            this._offsetY = e, this._position && this._updatePositionStrategy(this._position);
          }
          get hasBackdrop() {
            return this._hasBackdrop;
          }
          set hasBackdrop(e) {
            this._hasBackdrop = Y(e);
          }
          get lockPosition() {
            return this._lockPosition;
          }
          set lockPosition(e) {
            this._lockPosition = Y(e);
          }
          get flexibleDimensions() {
            return this._flexibleDimensions;
          }
          set flexibleDimensions(e) {
            this._flexibleDimensions = Y(e);
          }
          get growAfterOpen() {
            return this._growAfterOpen;
          }
          set growAfterOpen(e) {
            this._growAfterOpen = Y(e);
          }
          get push() {
            return this._push;
          }
          set push(e) {
            this._push = Y(e);
          }
          get overlayRef() {
            return this._overlayRef;
          }
          get dir() {
            return this._dir ? this._dir.value : "ltr";
          }
          ngOnDestroy() {
            this._attachSubscription.unsubscribe(), this._detachSubscription.unsubscribe(), this._backdropSubscription.unsubscribe(), this._positionSubscription.unsubscribe(), this._overlayRef && this._overlayRef.dispose();
          }
          ngOnChanges(e) {
            this._position && (this._updatePositionStrategy(this._position), this._overlayRef.updateSize({
              width: this.width,
              minWidth: this.minWidth,
              height: this.height,
              minHeight: this.minHeight
            }), e.origin && this.open && this._position.apply()), e.open && (this.open ? this._attachOverlay() : this._detachOverlay());
          }
          _createOverlay() {
            (!this.positions || !this.positions.length) && (this.positions = fV);
            const e = this._overlayRef = this._overlay.create(this._buildConfig());
            this._attachSubscription = e.attachments().subscribe(() => this.attach.emit()), this._detachSubscription = e.detachments().subscribe(() => this.detach.emit()), e.keydownEvents().subscribe(a => {
              this.overlayKeydown.next(a), 27 === a.keyCode && !this.disableClose && !Et(a) && (a.preventDefault(), this._detachOverlay());
            }), this._overlayRef.outsidePointerEvents().subscribe(a => {
              this.overlayOutsideClick.next(a);
            });
          }
          _buildConfig() {
            const e = this._position = this.positionStrategy || this._createPositionStrategy(),
              a = new jc({
                direction: this._dir,
                positionStrategy: e,
                scrollStrategy: this.scrollStrategy,
                hasBackdrop: this.hasBackdrop
              });
            return (this.width || 0 === this.width) && (a.width = this.width), (this.height || 0 === this.height) && (a.height = this.height), (this.minWidth || 0 === this.minWidth) && (a.minWidth = this.minWidth), (this.minHeight || 0 === this.minHeight) && (a.minHeight = this.minHeight), this.backdropClass && (a.backdropClass = this.backdropClass), this.panelClass && (a.panelClass = this.panelClass), a;
          }
          _updatePositionStrategy(e) {
            const a = this.positions.map(i => ({
              originX: i.originX,
              originY: i.originY,
              overlayX: i.overlayX,
              overlayY: i.overlayY,
              offsetX: i.offsetX || this.offsetX,
              offsetY: i.offsetY || this.offsetY,
              panelClass: i.panelClass || void 0
            }));
            return e.setOrigin(this._getFlexibleConnectedPositionStrategyOrigin()).withPositions(a).withFlexibleDimensions(this.flexibleDimensions).withPush(this.push).withGrowAfterOpen(this.growAfterOpen).withViewportMargin(this.viewportMargin).withLockedPosition(this.lockPosition).withTransformOriginOn(this.transformOriginSelector);
          }
          _createPositionStrategy() {
            const e = this._overlay.position().flexibleConnectedTo(this._getFlexibleConnectedPositionStrategyOrigin());
            return this._updatePositionStrategy(e), e;
          }
          _getFlexibleConnectedPositionStrategyOrigin() {
            return this.origin instanceof x_ ? this.origin.elementRef : this.origin;
          }
          _attachOverlay() {
            this._overlayRef ? this._overlayRef.getConfig().hasBackdrop = this.hasBackdrop : this._createOverlay(), this._overlayRef.hasAttached() || this._overlayRef.attach(this._templatePortal), this.hasBackdrop ? this._backdropSubscription = this._overlayRef.backdropClick().subscribe(e => {
              this.backdropClick.emit(e);
            }) : this._backdropSubscription.unsubscribe(), this._positionSubscription.unsubscribe(), this.positionChange.observers.length > 0 && (this._positionSubscription = this._position.positionChanges.pipe(function YF(n, t = !1) {
              return e => e.lift(new qF(n, t));
            }(() => this.positionChange.observers.length > 0)).subscribe(e => {
              this.positionChange.emit(e), 0 === this.positionChange.observers.length && this._positionSubscription.unsubscribe();
            }));
          }
          _detachOverlay() {
            this._overlayRef && this._overlayRef.detach(), this._backdropSubscription.unsubscribe(), this._positionSubscription.unsubscribe();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(mn), f(vt), f(ut), f(M_), f(nn, 8));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "cdk-connected-overlay", ""], ["", "connected-overlay", ""], ["", "cdkConnectedOverlay", ""]],
          inputs: {
            origin: ["cdkConnectedOverlayOrigin", "origin"],
            positions: ["cdkConnectedOverlayPositions", "positions"],
            positionStrategy: ["cdkConnectedOverlayPositionStrategy", "positionStrategy"],
            offsetX: ["cdkConnectedOverlayOffsetX", "offsetX"],
            offsetY: ["cdkConnectedOverlayOffsetY", "offsetY"],
            width: ["cdkConnectedOverlayWidth", "width"],
            height: ["cdkConnectedOverlayHeight", "height"],
            minWidth: ["cdkConnectedOverlayMinWidth", "minWidth"],
            minHeight: ["cdkConnectedOverlayMinHeight", "minHeight"],
            backdropClass: ["cdkConnectedOverlayBackdropClass", "backdropClass"],
            panelClass: ["cdkConnectedOverlayPanelClass", "panelClass"],
            viewportMargin: ["cdkConnectedOverlayViewportMargin", "viewportMargin"],
            scrollStrategy: ["cdkConnectedOverlayScrollStrategy", "scrollStrategy"],
            open: ["cdkConnectedOverlayOpen", "open"],
            disableClose: ["cdkConnectedOverlayDisableClose", "disableClose"],
            transformOriginSelector: ["cdkConnectedOverlayTransformOriginOn", "transformOriginSelector"],
            hasBackdrop: ["cdkConnectedOverlayHasBackdrop", "hasBackdrop"],
            lockPosition: ["cdkConnectedOverlayLockPosition", "lockPosition"],
            flexibleDimensions: ["cdkConnectedOverlayFlexibleDimensions", "flexibleDimensions"],
            growAfterOpen: ["cdkConnectedOverlayGrowAfterOpen", "growAfterOpen"],
            push: ["cdkConnectedOverlayPush", "push"]
          },
          outputs: {
            backdropClick: "backdropClick",
            positionChange: "positionChange",
            attach: "attach",
            detach: "detach",
            overlayKeydown: "overlayKeydown",
            overlayOutsideClick: "overlayOutsideClick"
          },
          exportAs: ["cdkConnectedOverlay"],
          features: [Ve]
        }), n;
      })();
    const hV = {
      provide: M_,
      deps: [mn],
      useFactory: function mV(n) {
        return () => n.scrollStrategies.reposition();
      }
    };
    let qa = (() => {
      class n {}
      return n.ɵfac = function (e) {
        return new (e || n)();
      }, n.ɵmod = W({
        type: n
      }), n.ɵinj = U({
        providers: [mn, hV],
        imports: [Jr, Ya, Qd, Qd]
      }), n;
    })();
    function k_(...n) {
      if (1 === n.length) {
        const t = n[0];
        if ($o(t)) return Jd(t, null);
        if (W0(t) && Object.getPrototypeOf(t) === Object.prototype) {
          const e = Object.keys(t);
          return Jd(e.map(a => t[a]), e);
        }
      }
      if ("function" == typeof n[n.length - 1]) {
        const t = n.pop();
        return Jd(n = 1 === n.length && $o(n[0]) ? n[0] : n, null).pipe(We(e => t(...e)));
      }
      return Jd(n, null);
    }
    function Jd(n, t) {
      return new Be(e => {
        const a = n.length;
        if (0 === a) return void e.complete();
        const i = new Array(a);
        let o = 0,
          r = 0;
        for (let s = 0; s < a; s++) {
          const c = lo(n[s]);
          let l = !1;
          e.add(c.subscribe({
            next: d => {
              l || (l = !0, r++), i[s] = d;
            },
            error: d => e.error(d),
            complete: () => {
              o++, (o === a || !l) && (r === a && e.next(t ? t.reduce((d, u, m) => (d[u] = i[m], d), {}) : i), e.complete());
            }
          }));
        }
      });
    }
    let D_ = (() => {
        class n {
          constructor(e, a) {
            this._renderer = e, this._elementRef = a, this.onChange = i => {}, this.onTouched = () => {};
          }
          setProperty(e, a) {
            this._renderer.setProperty(this._elementRef.nativeElement, e, a);
          }
          registerOnTouched(e) {
            this.onTouched = e;
          }
          registerOnChange(e) {
            this.onChange = e;
          }
          setDisabledState(e) {
            this.setProperty("disabled", e);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Hi), f(J));
        }, n.ɵdir = P({
          type: n
        }), n;
      })(),
      Ro = (() => {
        class n extends D_ {}
        return n.ɵfac = function () {
          let t;
          return function (a) {
            return (t || (t = he(n)))(a || n);
          };
        }(), n.ɵdir = P({
          type: n,
          features: [z]
        }), n;
      })();
    const Bt = new O("NgValueAccessor"),
      gV = {
        provide: Bt,
        useExisting: Pe(() => yi),
        multi: !0
      },
      _V = new O("CompositionEventMode");
    let yi = (() => {
      class n extends D_ {
        constructor(e, a, i) {
          super(e, a), this._compositionMode = i, this._composing = !1, null == this._compositionMode && (this._compositionMode = !function bV() {
            const n = Ua() ? Ua().getUserAgent() : "";
            return /android (\d+)/.test(n.toLowerCase());
          }());
        }
        writeValue(e) {
          this.setProperty("value", e ?? "");
        }
        _handleInput(e) {
          (!this._compositionMode || this._compositionMode && !this._composing) && this.onChange(e);
        }
        _compositionStart() {
          this._composing = !0;
        }
        _compositionEnd(e) {
          this._composing = !1, this._compositionMode && this.onChange(e);
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(f(Hi), f(J), f(_V, 8));
      }, n.ɵdir = P({
        type: n,
        selectors: [["input", "formControlName", "", 3, "type", "checkbox"], ["textarea", "formControlName", ""], ["input", "formControl", "", 3, "type", "checkbox"], ["textarea", "formControl", ""], ["input", "ngModel", "", 3, "type", "checkbox"], ["textarea", "ngModel", ""], ["", "ngDefaultControl", ""]],
        hostBindings: function (e, a) {
          1 & e && F("input", function (o) {
            return a._handleInput(o.target.value);
          })("blur", function () {
            return a.onTouched();
          })("compositionstart", function () {
            return a._compositionStart();
          })("compositionend", function (o) {
            return a._compositionEnd(o.target.value);
          });
        },
        features: [G([gV]), z]
      }), n;
    })();
    function Qi(n) {
      return null == n || ("string" == typeof n || Array.isArray(n)) && 0 === n.length;
    }
    function P_(n) {
      return null != n && "number" == typeof n.length;
    }
    const jt = new O("NgValidators"),
      Zi = new O("NgAsyncValidators"),
      yV = /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    class Da {
      static min(t) {
        return function A_(n) {
          return t => {
            if (Qi(t.value) || Qi(n)) return null;
            const e = parseFloat(t.value);
            return !isNaN(e) && e < n ? {
              min: {
                min: n,
                actual: t.value
              }
            } : null;
          };
        }(t);
      }
      static max(t) {
        return function S_(n) {
          return t => {
            if (Qi(t.value) || Qi(n)) return null;
            const e = parseFloat(t.value);
            return !isNaN(e) && e > n ? {
              max: {
                max: n,
                actual: t.value
              }
            } : null;
          };
        }(t);
      }
      static required(t) {
        return E_(t);
      }
      static requiredTrue(t) {
        return function T_(n) {
          return !0 === n.value ? null : {
            required: !0
          };
        }(t);
      }
      static email(t) {
        return function I_(n) {
          return Qi(n.value) || yV.test(n.value) ? null : {
            email: !0
          };
        }(t);
      }
      static minLength(t) {
        return function R_(n) {
          return t => Qi(t.value) || !P_(t.value) ? null : t.value.length < n ? {
            minlength: {
              requiredLength: n,
              actualLength: t.value.length
            }
          } : null;
        }(t);
      }
      static maxLength(t) {
        return function z_(n) {
          return t => P_(t.value) && t.value.length > n ? {
            maxlength: {
              requiredLength: n,
              actualLength: t.value.length
            }
          } : null;
        }(t);
      }
      static pattern(t) {
        return function L_(n) {
          if (!n) return $d;
          let t, e;
          return "string" == typeof n ? (e = "", "^" !== n.charAt(0) && (e += "^"), e += n, "$" !== n.charAt(n.length - 1) && (e += "$"), t = new RegExp(e)) : (e = n.toString(), t = n), a => {
            if (Qi(a.value)) return null;
            const i = a.value;
            return t.test(i) ? null : {
              pattern: {
                requiredPattern: e,
                actualValue: i
              }
            };
          };
        }(t);
      }
      static nullValidator(t) {
        return null;
      }
      static compose(t) {
        return j_(t);
      }
      static composeAsync(t) {
        return U_(t);
      }
    }
    function E_(n) {
      return Qi(n.value) ? {
        required: !0
      } : null;
    }
    function $d(n) {
      return null;
    }
    function N_(n) {
      return null != n;
    }
    function F_(n) {
      return F1(n) ? lo(n) : n;
    }
    function V_(n) {
      let t = {};
      return n.forEach(e => {
        t = null != e ? {
          ...t,
          ...e
        } : t;
      }), 0 === Object.keys(t).length ? null : t;
    }
    function H_(n, t) {
      return t.map(e => e(n));
    }
    function B_(n) {
      return n.map(t => function CV(n) {
        return !n.validate;
      }(t) ? t : e => t.validate(e));
    }
    function j_(n) {
      if (!n) return null;
      const t = n.filter(N_);
      return 0 == t.length ? null : function (e) {
        return V_(H_(e, t));
      };
    }
    function Nh(n) {
      return null != n ? j_(B_(n)) : null;
    }
    function U_(n) {
      if (!n) return null;
      const t = n.filter(N_);
      return 0 == t.length ? null : function (e) {
        return k_(H_(e, t).map(F_)).pipe(We(V_));
      };
    }
    function Fh(n) {
      return null != n ? U_(B_(n)) : null;
    }
    function G_(n, t) {
      return null === n ? [t] : Array.isArray(n) ? [...n, t] : [n, t];
    }
    function W_(n) {
      return n._rawValidators;
    }
    function Y_(n) {
      return n._rawAsyncValidators;
    }
    function Vh(n) {
      return n ? Array.isArray(n) ? n : [n] : [];
    }
    function e2(n, t) {
      return Array.isArray(n) ? n.includes(t) : n === t;
    }
    function q_(n, t) {
      const e = Vh(t);
      return Vh(n).forEach(i => {
        e2(e, i) || e.push(i);
      }), e;
    }
    function K_(n, t) {
      return Vh(t).filter(e => !e2(n, e));
    }
    class Q_ {
      constructor() {
        this._rawValidators = [], this._rawAsyncValidators = [], this._onDestroyCallbacks = [];
      }
      get value() {
        return this.control ? this.control.value : null;
      }
      get valid() {
        return this.control ? this.control.valid : null;
      }
      get invalid() {
        return this.control ? this.control.invalid : null;
      }
      get pending() {
        return this.control ? this.control.pending : null;
      }
      get disabled() {
        return this.control ? this.control.disabled : null;
      }
      get enabled() {
        return this.control ? this.control.enabled : null;
      }
      get errors() {
        return this.control ? this.control.errors : null;
      }
      get pristine() {
        return this.control ? this.control.pristine : null;
      }
      get dirty() {
        return this.control ? this.control.dirty : null;
      }
      get touched() {
        return this.control ? this.control.touched : null;
      }
      get status() {
        return this.control ? this.control.status : null;
      }
      get untouched() {
        return this.control ? this.control.untouched : null;
      }
      get statusChanges() {
        return this.control ? this.control.statusChanges : null;
      }
      get valueChanges() {
        return this.control ? this.control.valueChanges : null;
      }
      get path() {
        return null;
      }
      _setValidators(t) {
        this._rawValidators = t || [], this._composedValidatorFn = Nh(this._rawValidators);
      }
      _setAsyncValidators(t) {
        this._rawAsyncValidators = t || [], this._composedAsyncValidatorFn = Fh(this._rawAsyncValidators);
      }
      get validator() {
        return this._composedValidatorFn || null;
      }
      get asyncValidator() {
        return this._composedAsyncValidatorFn || null;
      }
      _registerOnDestroy(t) {
        this._onDestroyCallbacks.push(t);
      }
      _invokeOnDestroyCallbacks() {
        this._onDestroyCallbacks.forEach(t => t()), this._onDestroyCallbacks = [];
      }
      reset(t) {
        this.control && this.control.reset(t);
      }
      hasError(t, e) {
        return !!this.control && this.control.hasError(t, e);
      }
      getError(t, e) {
        return this.control ? this.control.getError(t, e) : null;
      }
    }
    class hn extends Q_ {
      get formDirective() {
        return null;
      }
      get path() {
        return null;
      }
    }
    class Oa extends Q_ {
      constructor() {
        super(...arguments), this._parent = null, this.name = null, this.valueAccessor = null;
      }
    }
    class Z_ {
      constructor(t) {
        this._cd = t;
      }
      get isTouched() {
        return !!this._cd?.control?.touched;
      }
      get isUntouched() {
        return !!this._cd?.control?.untouched;
      }
      get isPristine() {
        return !!this._cd?.control?.pristine;
      }
      get isDirty() {
        return !!this._cd?.control?.dirty;
      }
      get isValid() {
        return !!this._cd?.control?.valid;
      }
      get isInvalid() {
        return !!this._cd?.control?.invalid;
      }
      get isPending() {
        return !!this._cd?.control?.pending;
      }
      get isSubmitted() {
        return !!this._cd?.submitted;
      }
    }
    let oa = (() => {
        class n extends Z_ {
          constructor(e) {
            super(e);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Oa, 2));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "formControlName", ""], ["", "ngModel", ""], ["", "formControl", ""]],
          hostVars: 14,
          hostBindings: function (e, a) {
            2 & e && fe("ng-untouched", a.isUntouched)("ng-touched", a.isTouched)("ng-pristine", a.isPristine)("ng-dirty", a.isDirty)("ng-valid", a.isValid)("ng-invalid", a.isInvalid)("ng-pending", a.isPending);
          },
          features: [z]
        }), n;
      })(),
      zo = (() => {
        class n extends Z_ {
          constructor(e) {
            super(e);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(hn, 10));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "formGroupName", ""], ["", "formArrayName", ""], ["", "ngModelGroup", ""], ["", "formGroup", ""], ["form", 3, "ngNoForm", ""], ["", "ngForm", ""]],
          hostVars: 16,
          hostBindings: function (e, a) {
            2 & e && fe("ng-untouched", a.isUntouched)("ng-touched", a.isTouched)("ng-pristine", a.isPristine)("ng-dirty", a.isDirty)("ng-valid", a.isValid)("ng-invalid", a.isInvalid)("ng-pending", a.isPending)("ng-submitted", a.isSubmitted);
          },
          features: [z]
        }), n;
      })();
    const Gc = "VALID",
      n2 = "INVALID",
      as = "PENDING",
      Wc = "DISABLED";
    function Uh(n) {
      return (a2(n) ? n.validators : n) || null;
    }
    function J_(n) {
      return Array.isArray(n) ? Nh(n) : n || null;
    }
    function Gh(n, t) {
      return (a2(t) ? t.asyncValidators : n) || null;
    }
    function $_(n) {
      return Array.isArray(n) ? Fh(n) : n || null;
    }
    function a2(n) {
      return null != n && !Array.isArray(n) && "object" == typeof n;
    }
    function ev(n, t, e) {
      const a = n.controls;
      if (!(t ? Object.keys(a) : a).length) throw new L(1e3, "");
      if (!a[e]) throw new L(1001, "");
    }
    function tv(n, t, e) {
      n._forEachChild((a, i) => {
        if (void 0 === e[i]) throw new L(1002, "");
      });
    }
    class o2 {
      constructor(t, e) {
        this._pendingDirty = !1, this._hasOwnPendingAsyncValidator = !1, this._pendingTouched = !1, this._onCollectionChange = () => {}, this._parent = null, this.pristine = !0, this.touched = !1, this._onDisabledChange = [], this._rawValidators = t, this._rawAsyncValidators = e, this._composedValidatorFn = J_(this._rawValidators), this._composedAsyncValidatorFn = $_(this._rawAsyncValidators);
      }
      get validator() {
        return this._composedValidatorFn;
      }
      set validator(t) {
        this._rawValidators = this._composedValidatorFn = t;
      }
      get asyncValidator() {
        return this._composedAsyncValidatorFn;
      }
      set asyncValidator(t) {
        this._rawAsyncValidators = this._composedAsyncValidatorFn = t;
      }
      get parent() {
        return this._parent;
      }
      get valid() {
        return this.status === Gc;
      }
      get invalid() {
        return this.status === n2;
      }
      get pending() {
        return this.status == as;
      }
      get disabled() {
        return this.status === Wc;
      }
      get enabled() {
        return this.status !== Wc;
      }
      get dirty() {
        return !this.pristine;
      }
      get untouched() {
        return !this.touched;
      }
      get updateOn() {
        return this._updateOn ? this._updateOn : this.parent ? this.parent.updateOn : "change";
      }
      setValidators(t) {
        this._rawValidators = t, this._composedValidatorFn = J_(t);
      }
      setAsyncValidators(t) {
        this._rawAsyncValidators = t, this._composedAsyncValidatorFn = $_(t);
      }
      addValidators(t) {
        this.setValidators(q_(t, this._rawValidators));
      }
      addAsyncValidators(t) {
        this.setAsyncValidators(q_(t, this._rawAsyncValidators));
      }
      removeValidators(t) {
        this.setValidators(K_(t, this._rawValidators));
      }
      removeAsyncValidators(t) {
        this.setAsyncValidators(K_(t, this._rawAsyncValidators));
      }
      hasValidator(t) {
        return e2(this._rawValidators, t);
      }
      hasAsyncValidator(t) {
        return e2(this._rawAsyncValidators, t);
      }
      clearValidators() {
        this.validator = null;
      }
      clearAsyncValidators() {
        this.asyncValidator = null;
      }
      markAsTouched(t = {}) {
        this.touched = !0, this._parent && !t.onlySelf && this._parent.markAsTouched(t);
      }
      markAllAsTouched() {
        this.markAsTouched({
          onlySelf: !0
        }), this._forEachChild(t => t.markAllAsTouched());
      }
      markAsUntouched(t = {}) {
        this.touched = !1, this._pendingTouched = !1, this._forEachChild(e => {
          e.markAsUntouched({
            onlySelf: !0
          });
        }), this._parent && !t.onlySelf && this._parent._updateTouched(t);
      }
      markAsDirty(t = {}) {
        this.pristine = !1, this._parent && !t.onlySelf && this._parent.markAsDirty(t);
      }
      markAsPristine(t = {}) {
        this.pristine = !0, this._pendingDirty = !1, this._forEachChild(e => {
          e.markAsPristine({
            onlySelf: !0
          });
        }), this._parent && !t.onlySelf && this._parent._updatePristine(t);
      }
      markAsPending(t = {}) {
        this.status = as, !1 !== t.emitEvent && this.statusChanges.emit(this.status), this._parent && !t.onlySelf && this._parent.markAsPending(t);
      }
      disable(t = {}) {
        const e = this._parentMarkedDirty(t.onlySelf);
        this.status = Wc, this.errors = null, this._forEachChild(a => {
          a.disable({
            ...t,
            onlySelf: !0
          });
        }), this._updateValue(), !1 !== t.emitEvent && (this.valueChanges.emit(this.value), this.statusChanges.emit(this.status)), this._updateAncestors({
          ...t,
          skipPristineCheck: e
        }), this._onDisabledChange.forEach(a => a(!0));
      }
      enable(t = {}) {
        const e = this._parentMarkedDirty(t.onlySelf);
        this.status = Gc, this._forEachChild(a => {
          a.enable({
            ...t,
            onlySelf: !0
          });
        }), this.updateValueAndValidity({
          onlySelf: !0,
          emitEvent: t.emitEvent
        }), this._updateAncestors({
          ...t,
          skipPristineCheck: e
        }), this._onDisabledChange.forEach(a => a(!1));
      }
      _updateAncestors(t) {
        this._parent && !t.onlySelf && (this._parent.updateValueAndValidity(t), t.skipPristineCheck || this._parent._updatePristine(), this._parent._updateTouched());
      }
      setParent(t) {
        this._parent = t;
      }
      getRawValue() {
        return this.value;
      }
      updateValueAndValidity(t = {}) {
        this._setInitialStatus(), this._updateValue(), this.enabled && (this._cancelExistingSubscription(), this.errors = this._runValidator(), this.status = this._calculateStatus(), (this.status === Gc || this.status === as) && this._runAsyncValidator(t.emitEvent)), !1 !== t.emitEvent && (this.valueChanges.emit(this.value), this.statusChanges.emit(this.status)), this._parent && !t.onlySelf && this._parent.updateValueAndValidity(t);
      }
      _updateTreeValidity(t = {
        emitEvent: !0
      }) {
        this._forEachChild(e => e._updateTreeValidity(t)), this.updateValueAndValidity({
          onlySelf: !0,
          emitEvent: t.emitEvent
        });
      }
      _setInitialStatus() {
        this.status = this._allControlsDisabled() ? Wc : Gc;
      }
      _runValidator() {
        return this.validator ? this.validator(this) : null;
      }
      _runAsyncValidator(t) {
        if (this.asyncValidator) {
          this.status = as, this._hasOwnPendingAsyncValidator = !0;
          const e = F_(this.asyncValidator(this));
          this._asyncValidationSubscription = e.subscribe(a => {
            this._hasOwnPendingAsyncValidator = !1, this.setErrors(a, {
              emitEvent: t
            });
          });
        }
      }
      _cancelExistingSubscription() {
        this._asyncValidationSubscription && (this._asyncValidationSubscription.unsubscribe(), this._hasOwnPendingAsyncValidator = !1);
      }
      setErrors(t, e = {}) {
        this.errors = t, this._updateControlsErrors(!1 !== e.emitEvent);
      }
      get(t) {
        let e = t;
        return null == e || (Array.isArray(e) || (e = e.split(".")), 0 === e.length) ? null : e.reduce((a, i) => a && a._find(i), this);
      }
      getError(t, e) {
        const a = e ? this.get(e) : this;
        return a && a.errors ? a.errors[t] : null;
      }
      hasError(t, e) {
        return !!this.getError(t, e);
      }
      get root() {
        let t = this;
        for (; t._parent;) t = t._parent;
        return t;
      }
      _updateControlsErrors(t) {
        this.status = this._calculateStatus(), t && this.statusChanges.emit(this.status), this._parent && this._parent._updateControlsErrors(t);
      }
      _initObservables() {
        this.valueChanges = new E(), this.statusChanges = new E();
      }
      _calculateStatus() {
        return this._allControlsDisabled() ? Wc : this.errors ? n2 : this._hasOwnPendingAsyncValidator || this._anyControlsHaveStatus(as) ? as : this._anyControlsHaveStatus(n2) ? n2 : Gc;
      }
      _anyControlsHaveStatus(t) {
        return this._anyControls(e => e.status === t);
      }
      _anyControlsDirty() {
        return this._anyControls(t => t.dirty);
      }
      _anyControlsTouched() {
        return this._anyControls(t => t.touched);
      }
      _updatePristine(t = {}) {
        this.pristine = !this._anyControlsDirty(), this._parent && !t.onlySelf && this._parent._updatePristine(t);
      }
      _updateTouched(t = {}) {
        this.touched = this._anyControlsTouched(), this._parent && !t.onlySelf && this._parent._updateTouched(t);
      }
      _registerOnCollectionChange(t) {
        this._onCollectionChange = t;
      }
      _setUpdateStrategy(t) {
        a2(t) && null != t.updateOn && (this._updateOn = t.updateOn);
      }
      _parentMarkedDirty(t) {
        return !t && !(!this._parent || !this._parent.dirty) && !this._parent._anyControlsDirty();
      }
      _find(t) {
        return null;
      }
    }
    class Ci extends o2 {
      constructor(t, e, a) {
        super(Uh(e), Gh(a, e)), this.controls = t, this._initObservables(), this._setUpdateStrategy(e), this._setUpControls(), this.updateValueAndValidity({
          onlySelf: !0,
          emitEvent: !!this.asyncValidator
        });
      }
      registerControl(t, e) {
        return this.controls[t] ? this.controls[t] : (this.controls[t] = e, e.setParent(this), e._registerOnCollectionChange(this._onCollectionChange), e);
      }
      addControl(t, e, a = {}) {
        this.registerControl(t, e), this.updateValueAndValidity({
          emitEvent: a.emitEvent
        }), this._onCollectionChange();
      }
      removeControl(t, e = {}) {
        this.controls[t] && this.controls[t]._registerOnCollectionChange(() => {}), delete this.controls[t], this.updateValueAndValidity({
          emitEvent: e.emitEvent
        }), this._onCollectionChange();
      }
      setControl(t, e, a = {}) {
        this.controls[t] && this.controls[t]._registerOnCollectionChange(() => {}), delete this.controls[t], e && this.registerControl(t, e), this.updateValueAndValidity({
          emitEvent: a.emitEvent
        }), this._onCollectionChange();
      }
      contains(t) {
        return this.controls.hasOwnProperty(t) && this.controls[t].enabled;
      }
      setValue(t, e = {}) {
        tv(this, 0, t), Object.keys(t).forEach(a => {
          ev(this, !0, a), this.controls[a].setValue(t[a], {
            onlySelf: !0,
            emitEvent: e.emitEvent
          });
        }), this.updateValueAndValidity(e);
      }
      patchValue(t, e = {}) {
        null != t && (Object.keys(t).forEach(a => {
          const i = this.controls[a];
          i && i.patchValue(t[a], {
            onlySelf: !0,
            emitEvent: e.emitEvent
          });
        }), this.updateValueAndValidity(e));
      }
      reset(t = {}, e = {}) {
        this._forEachChild((a, i) => {
          a.reset(t[i], {
            onlySelf: !0,
            emitEvent: e.emitEvent
          });
        }), this._updatePristine(e), this._updateTouched(e), this.updateValueAndValidity(e);
      }
      getRawValue() {
        return this._reduceChildren({}, (t, e, a) => (t[a] = e.getRawValue(), t));
      }
      _syncPendingControls() {
        let t = this._reduceChildren(!1, (e, a) => !!a._syncPendingControls() || e);
        return t && this.updateValueAndValidity({
          onlySelf: !0
        }), t;
      }
      _forEachChild(t) {
        Object.keys(this.controls).forEach(e => {
          const a = this.controls[e];
          a && t(a, e);
        });
      }
      _setUpControls() {
        this._forEachChild(t => {
          t.setParent(this), t._registerOnCollectionChange(this._onCollectionChange);
        });
      }
      _updateValue() {
        this.value = this._reduceValue();
      }
      _anyControls(t) {
        for (const [e, a] of Object.entries(this.controls)) if (this.contains(e) && t(a)) return !0;
        return !1;
      }
      _reduceValue() {
        return this._reduceChildren({}, (e, a, i) => ((a.enabled || this.disabled) && (e[i] = a.value), e));
      }
      _reduceChildren(t, e) {
        let a = t;
        return this._forEachChild((i, o) => {
          a = e(a, i, o);
        }), a;
      }
      _allControlsDisabled() {
        for (const t of Object.keys(this.controls)) if (this.controls[t].enabled) return !1;
        return Object.keys(this.controls).length > 0 || this.disabled;
      }
      _find(t) {
        return this.controls.hasOwnProperty(t) ? this.controls[t] : null;
      }
    }
    class nv extends Ci {}
    function Yc(n, t) {
      Wh(n, t), t.valueAccessor.writeValue(n.value), n.disabled && t.valueAccessor.setDisabledState?.(!0), function AV(n, t) {
        t.valueAccessor.registerOnChange(e => {
          n._pendingValue = e, n._pendingChange = !0, n._pendingDirty = !0, "change" === n.updateOn && av(n, t);
        });
      }(n, t), function EV(n, t) {
        const e = (a, i) => {
          t.valueAccessor.writeValue(a), i && t.viewToModelUpdate(a);
        };
        n.registerOnChange(e), t._registerOnDestroy(() => {
          n._unregisterOnChange(e);
        });
      }(n, t), function SV(n, t) {
        t.valueAccessor.registerOnTouched(() => {
          n._pendingTouched = !0, "blur" === n.updateOn && n._pendingChange && av(n, t), "submit" !== n.updateOn && n.markAsTouched();
        });
      }(n, t), function PV(n, t) {
        if (t.valueAccessor.setDisabledState) {
          const e = a => {
            t.valueAccessor.setDisabledState(a);
          };
          n.registerOnDisabledChange(e), t._registerOnDestroy(() => {
            n._unregisterOnDisabledChange(e);
          });
        }
      }(n, t);
    }
    function s2(n, t, e = !0) {
      const a = () => {};
      t.valueAccessor && (t.valueAccessor.registerOnChange(a), t.valueAccessor.registerOnTouched(a)), l2(n, t), n && (t._invokeOnDestroyCallbacks(), n._registerOnCollectionChange(() => {}));
    }
    function c2(n, t) {
      n.forEach(e => {
        e.registerOnValidatorChange && e.registerOnValidatorChange(t);
      });
    }
    function Wh(n, t) {
      const e = W_(n);
      null !== t.validator ? n.setValidators(G_(e, t.validator)) : "function" == typeof e && n.setValidators([e]);
      const a = Y_(n);
      null !== t.asyncValidator ? n.setAsyncValidators(G_(a, t.asyncValidator)) : "function" == typeof a && n.setAsyncValidators([a]);
      const i = () => n.updateValueAndValidity();
      c2(t._rawValidators, i), c2(t._rawAsyncValidators, i);
    }
    function l2(n, t) {
      let e = !1;
      if (null !== n) {
        if (null !== t.validator) {
          const i = W_(n);
          if (Array.isArray(i) && i.length > 0) {
            const o = i.filter(r => r !== t.validator);
            o.length !== i.length && (e = !0, n.setValidators(o));
          }
        }
        if (null !== t.asyncValidator) {
          const i = Y_(n);
          if (Array.isArray(i) && i.length > 0) {
            const o = i.filter(r => r !== t.asyncValidator);
            o.length !== i.length && (e = !0, n.setAsyncValidators(o));
          }
        }
      }
      const a = () => {};
      return c2(t._rawValidators, a), c2(t._rawAsyncValidators, a), e;
    }
    function av(n, t) {
      n._pendingDirty && n.markAsDirty(), n.setValue(n._pendingValue, {
        emitModelToViewChange: !1
      }), t.viewToModelUpdate(n._pendingValue), n._pendingChange = !1;
    }
    function iv(n, t) {
      Wh(n, t);
    }
    function Yh(n, t) {
      if (!n.hasOwnProperty("model")) return !1;
      const e = n.model;
      return !!e.isFirstChange() || !Object.is(t, e.currentValue);
    }
    function rv(n, t) {
      n._syncPendingControls(), t.forEach(e => {
        const a = e.control;
        "submit" === a.updateOn && a._pendingChange && (e.viewToModelUpdate(a._pendingValue), a._pendingChange = !1);
      });
    }
    function qh(n, t) {
      if (!t) return null;
      let e, a, i;
      return Array.isArray(t), t.forEach(o => {
        o.constructor === yi ? e = o : function RV(n) {
          return Object.getPrototypeOf(n.constructor) === Ro;
        }(o) ? a = o : i = o;
      }), i || a || e || null;
    }
    const LV = {
        provide: hn,
        useExisting: Pe(() => is)
      },
      qc = (() => Promise.resolve())();
    let is = (() => {
      class n extends hn {
        constructor(e, a) {
          super(), this.submitted = !1, this._directives = new Set(), this.ngSubmit = new E(), this.form = new Ci({}, Nh(e), Fh(a));
        }
        ngAfterViewInit() {
          this._setUpdateStrategy();
        }
        get formDirective() {
          return this;
        }
        get control() {
          return this.form;
        }
        get path() {
          return [];
        }
        get controls() {
          return this.form.controls;
        }
        addControl(e) {
          qc.then(() => {
            const a = this._findContainer(e.path);
            e.control = a.registerControl(e.name, e.control), Yc(e.control, e), e.control.updateValueAndValidity({
              emitEvent: !1
            }), this._directives.add(e);
          });
        }
        getControl(e) {
          return this.form.get(e.path);
        }
        removeControl(e) {
          qc.then(() => {
            const a = this._findContainer(e.path);
            a && a.removeControl(e.name), this._directives.delete(e);
          });
        }
        addFormGroup(e) {
          qc.then(() => {
            const a = this._findContainer(e.path),
              i = new Ci({});
            iv(i, e), a.registerControl(e.name, i), i.updateValueAndValidity({
              emitEvent: !1
            });
          });
        }
        removeFormGroup(e) {
          qc.then(() => {
            const a = this._findContainer(e.path);
            a && a.removeControl(e.name);
          });
        }
        getFormGroup(e) {
          return this.form.get(e.path);
        }
        updateModel(e, a) {
          qc.then(() => {
            this.form.get(e.path).setValue(a);
          });
        }
        setValue(e) {
          this.control.setValue(e);
        }
        onSubmit(e) {
          return this.submitted = !0, rv(this.form, this._directives), this.ngSubmit.emit(e), "dialog" === e?.target?.method;
        }
        onReset() {
          this.resetForm();
        }
        resetForm(e) {
          this.form.reset(e), this.submitted = !1;
        }
        _setUpdateStrategy() {
          this.options && null != this.options.updateOn && (this.form._updateOn = this.options.updateOn);
        }
        _findContainer(e) {
          return e.pop(), e.length ? this.form.get(e) : this.form;
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(f(jt, 10), f(Zi, 10));
      }, n.ɵdir = P({
        type: n,
        selectors: [["form", 3, "ngNoForm", "", 3, "formGroup", ""], ["ng-form"], ["", "ngForm", ""]],
        hostBindings: function (e, a) {
          1 & e && F("submit", function (o) {
            return a.onSubmit(o);
          })("reset", function () {
            return a.onReset();
          });
        },
        inputs: {
          options: ["ngFormOptions", "options"]
        },
        outputs: {
          ngSubmit: "ngSubmit"
        },
        exportAs: ["ngForm"],
        features: [G([LV]), z]
      }), n;
    })();
    function sv(n, t) {
      const e = n.indexOf(t);
      e > -1 && n.splice(e, 1);
    }
    function cv(n) {
      return "object" == typeof n && null !== n && 2 === Object.keys(n).length && "value" in n && "disabled" in n;
    }
    const at = class extends o2 {
      constructor(t = null, e, a) {
        super(Uh(e), Gh(a, e)), this.defaultValue = null, this._onChange = [], this._pendingChange = !1, this._applyFormState(t), this._setUpdateStrategy(e), this._initObservables(), this.updateValueAndValidity({
          onlySelf: !0,
          emitEvent: !!this.asyncValidator
        }), a2(e) && (e.nonNullable || e.initialValueIsDefault) && (this.defaultValue = cv(t) ? t.value : t);
      }
      setValue(t, e = {}) {
        this.value = this._pendingValue = t, this._onChange.length && !1 !== e.emitModelToViewChange && this._onChange.forEach(a => a(this.value, !1 !== e.emitViewToModelChange)), this.updateValueAndValidity(e);
      }
      patchValue(t, e = {}) {
        this.setValue(t, e);
      }
      reset(t = this.defaultValue, e = {}) {
        this._applyFormState(t), this.markAsPristine(e), this.markAsUntouched(e), this.setValue(this.value, e), this._pendingChange = !1;
      }
      _updateValue() {}
      _anyControls(t) {
        return !1;
      }
      _allControlsDisabled() {
        return this.disabled;
      }
      registerOnChange(t) {
        this._onChange.push(t);
      }
      _unregisterOnChange(t) {
        sv(this._onChange, t);
      }
      registerOnDisabledChange(t) {
        this._onDisabledChange.push(t);
      }
      _unregisterOnDisabledChange(t) {
        sv(this._onDisabledChange, t);
      }
      _forEachChild(t) {}
      _syncPendingControls() {
        return !("submit" !== this.updateOn || (this._pendingDirty && this.markAsDirty(), this._pendingTouched && this.markAsTouched(), !this._pendingChange) || (this.setValue(this._pendingValue, {
          onlySelf: !0,
          emitModelToViewChange: !1
        }), 0));
      }
      _applyFormState(t) {
        cv(t) ? (this.value = this._pendingValue = t.value, t.disabled ? this.disable({
          onlySelf: !0,
          emitEvent: !1
        }) : this.enable({
          onlySelf: !0,
          emitEvent: !1
        })) : this.value = this._pendingValue = t;
      }
    };
    let Kh = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n,
          selectors: [["form", 3, "ngNoForm", "", 3, "ngNativeValidate", ""]],
          hostAttrs: ["novalidate", ""]
        }), n;
      })(),
      hv = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({}), n;
      })();
    const Qh = new O("NgModelWithFormControlWarning"),
      GV = {
        provide: Oa,
        useExisting: Pe(() => Pa)
      };
    let Pa = (() => {
      class n extends Oa {
        constructor(e, a, i, o) {
          super(), this._ngModelWarningConfig = o, this.update = new E(), this._ngModelWarningSent = !1, this._setValidators(e), this._setAsyncValidators(a), this.valueAccessor = qh(0, i);
        }
        set isDisabled(e) {}
        ngOnChanges(e) {
          if (this._isControlChanged(e)) {
            const a = e.form.previousValue;
            a && s2(a, this, !1), Yc(this.form, this), this.form.updateValueAndValidity({
              emitEvent: !1
            });
          }
          Yh(e, this.viewModel) && (this.form.setValue(this.model), this.viewModel = this.model);
        }
        ngOnDestroy() {
          this.form && s2(this.form, this, !1);
        }
        get path() {
          return [];
        }
        get control() {
          return this.form;
        }
        viewToModelUpdate(e) {
          this.viewModel = e, this.update.emit(e);
        }
        _isControlChanged(e) {
          return e.hasOwnProperty("form");
        }
      }
      return n._ngModelWarningSentOnce = !1, n.ɵfac = function (e) {
        return new (e || n)(f(jt, 10), f(Zi, 10), f(Bt, 10), f(Qh, 8));
      }, n.ɵdir = P({
        type: n,
        selectors: [["", "formControl", ""]],
        inputs: {
          form: ["formControl", "form"],
          isDisabled: ["disabled", "isDisabled"],
          model: ["ngModel", "model"]
        },
        outputs: {
          update: "ngModelChange"
        },
        exportAs: ["ngForm"],
        features: [G([GV]), z, Ve]
      }), n;
    })();
    const WV = {
      provide: hn,
      useExisting: Pe(() => ra)
    };
    let ra = (() => {
      class n extends hn {
        constructor(e, a) {
          super(), this.submitted = !1, this._onCollectionChange = () => this._updateDomValue(), this.directives = [], this.form = null, this.ngSubmit = new E(), this._setValidators(e), this._setAsyncValidators(a);
        }
        ngOnChanges(e) {
          this._checkFormPresent(), e.hasOwnProperty("form") && (this._updateValidators(), this._updateDomValue(), this._updateRegistrations(), this._oldForm = this.form);
        }
        ngOnDestroy() {
          this.form && (l2(this.form, this), this.form._onCollectionChange === this._onCollectionChange && this.form._registerOnCollectionChange(() => {}));
        }
        get formDirective() {
          return this;
        }
        get control() {
          return this.form;
        }
        get path() {
          return [];
        }
        addControl(e) {
          const a = this.form.get(e.path);
          return Yc(a, e), a.updateValueAndValidity({
            emitEvent: !1
          }), this.directives.push(e), a;
        }
        getControl(e) {
          return this.form.get(e.path);
        }
        removeControl(e) {
          s2(e.control || null, e, !1), function zV(n, t) {
            const e = n.indexOf(t);
            e > -1 && n.splice(e, 1);
          }(this.directives, e);
        }
        addFormGroup(e) {
          this._setUpFormContainer(e);
        }
        removeFormGroup(e) {
          this._cleanUpFormContainer(e);
        }
        getFormGroup(e) {
          return this.form.get(e.path);
        }
        addFormArray(e) {
          this._setUpFormContainer(e);
        }
        removeFormArray(e) {
          this._cleanUpFormContainer(e);
        }
        getFormArray(e) {
          return this.form.get(e.path);
        }
        updateModel(e, a) {
          this.form.get(e.path).setValue(a);
        }
        onSubmit(e) {
          return this.submitted = !0, rv(this.form, this.directives), this.ngSubmit.emit(e), "dialog" === e?.target?.method;
        }
        onReset() {
          this.resetForm();
        }
        resetForm(e) {
          this.form.reset(e), this.submitted = !1;
        }
        _updateDomValue() {
          this.directives.forEach(e => {
            const a = e.control,
              i = this.form.get(e.path);
            a !== i && (s2(a || null, e), (n => n instanceof at)(i) && (Yc(i, e), e.control = i));
          }), this.form._updateTreeValidity({
            emitEvent: !1
          });
        }
        _setUpFormContainer(e) {
          const a = this.form.get(e.path);
          iv(a, e), a.updateValueAndValidity({
            emitEvent: !1
          });
        }
        _cleanUpFormContainer(e) {
          if (this.form) {
            const a = this.form.get(e.path);
            a && function TV(n, t) {
              return l2(n, t);
            }(a, e) && a.updateValueAndValidity({
              emitEvent: !1
            });
          }
        }
        _updateRegistrations() {
          this.form._registerOnCollectionChange(this._onCollectionChange), this._oldForm && this._oldForm._registerOnCollectionChange(() => {});
        }
        _updateValidators() {
          Wh(this.form, this), this._oldForm && l2(this._oldForm, this);
        }
        _checkFormPresent() {}
      }
      return n.ɵfac = function (e) {
        return new (e || n)(f(jt, 10), f(Zi, 10));
      }, n.ɵdir = P({
        type: n,
        selectors: [["", "formGroup", ""]],
        hostBindings: function (e, a) {
          1 & e && F("submit", function (o) {
            return a.onSubmit(o);
          })("reset", function () {
            return a.onReset();
          });
        },
        inputs: {
          form: ["formGroup", "form"]
        },
        outputs: {
          ngSubmit: "ngSubmit"
        },
        exportAs: ["ngForm"],
        features: [G([WV]), z, Ve]
      }), n;
    })();
    const KV = {
      provide: Oa,
      useExisting: Pe(() => d2)
    };
    let d2 = (() => {
        class n extends Oa {
          constructor(e, a, i, o, r) {
            super(), this._ngModelWarningConfig = r, this._added = !1, this.update = new E(), this._ngModelWarningSent = !1, this._parent = e, this._setValidators(a), this._setAsyncValidators(i), this.valueAccessor = qh(0, o);
          }
          set isDisabled(e) {}
          ngOnChanges(e) {
            this._added || this._setUpControl(), Yh(e, this.viewModel) && (this.viewModel = this.model, this.formDirective.updateModel(this, this.model));
          }
          ngOnDestroy() {
            this.formDirective && this.formDirective.removeControl(this);
          }
          viewToModelUpdate(e) {
            this.viewModel = e, this.update.emit(e);
          }
          get path() {
            return function r2(n, t) {
              return [...t.path, n];
            }(null == this.name ? this.name : this.name.toString(), this._parent);
          }
          get formDirective() {
            return this._parent ? this._parent.formDirective : null;
          }
          _checkParentType() {}
          _setUpControl() {
            this._checkParentType(), this.control = this.formDirective.addControl(this), this._added = !0;
          }
        }
        return n._ngModelWarningSentOnce = !1, n.ɵfac = function (e) {
          return new (e || n)(f(hn, 13), f(jt, 10), f(Zi, 10), f(Bt, 10), f(Qh, 8));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "formControlName", ""]],
          inputs: {
            name: ["formControlName", "name"],
            isDisabled: ["disabled", "isDisabled"],
            model: ["ngModel", "model"]
          },
          outputs: {
            update: "ngModelChange"
          },
          features: [G([KV]), z, Ve]
        }), n;
      })(),
      Lo = (() => {
        class n {
          constructor() {
            this._validator = $d;
          }
          ngOnChanges(e) {
            if (this.inputName in e) {
              const a = this.normalizeInput(e[this.inputName].currentValue);
              this._enabled = this.enabled(a), this._validator = this._enabled ? this.createValidator(a) : $d, this._onChange && this._onChange();
            }
          }
          validate(e) {
            return this._validator(e);
          }
          registerOnValidatorChange(e) {
            this._onChange = e;
          }
          enabled(e) {
            return null != e;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n,
          features: [Ve]
        }), n;
      })();
    const aH = {
      provide: jt,
      useExisting: Pe(() => No),
      multi: !0
    };
    let No = (() => {
        class n extends Lo {
          constructor() {
            super(...arguments), this.inputName = "required", this.normalizeInput = Om, this.createValidator = e => E_;
          }
          enabled(e) {
            return e;
          }
        }
        return n.ɵfac = function () {
          let t;
          return function (a) {
            return (t || (t = he(n)))(a || n);
          };
        }(), n.ɵdir = P({
          type: n,
          selectors: [["", "required", "", "formControlName", "", 3, "type", "checkbox"], ["", "required", "", "formControl", "", 3, "type", "checkbox"], ["", "required", "", "ngModel", "", 3, "type", "checkbox"]],
          hostVars: 1,
          hostBindings: function (e, a) {
            2 & e && X("required", a._enabled ? "" : null);
          },
          inputs: {
            required: "required"
          },
          features: [G([aH]), z]
        }), n;
      })(),
      Pv = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [hv]
        }), n;
      })(),
      lH = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [Pv]
        }), n;
      })(),
      f2 = (() => {
        class n {
          static withConfig(e) {
            return {
              ngModule: n,
              providers: [{
                provide: Qh,
                useValue: e.warnOnNgModelWithFormControl
              }]
            };
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [Pv]
        }), n;
      })();
    class ep extends o2 {
      constructor(t, e, a) {
        super(Uh(e), Gh(a, e)), this.controls = t, this._initObservables(), this._setUpdateStrategy(e), this._setUpControls(), this.updateValueAndValidity({
          onlySelf: !0,
          emitEvent: !!this.asyncValidator
        });
      }
      at(t) {
        return this.controls[this._adjustIndex(t)];
      }
      push(t, e = {}) {
        this.controls.push(t), this._registerControl(t), this.updateValueAndValidity({
          emitEvent: e.emitEvent
        }), this._onCollectionChange();
      }
      insert(t, e, a = {}) {
        this.controls.splice(t, 0, e), this._registerControl(e), this.updateValueAndValidity({
          emitEvent: a.emitEvent
        });
      }
      removeAt(t, e = {}) {
        let a = this._adjustIndex(t);
        a < 0 && (a = 0), this.controls[a] && this.controls[a]._registerOnCollectionChange(() => {}), this.controls.splice(a, 1), this.updateValueAndValidity({
          emitEvent: e.emitEvent
        });
      }
      setControl(t, e, a = {}) {
        let i = this._adjustIndex(t);
        i < 0 && (i = 0), this.controls[i] && this.controls[i]._registerOnCollectionChange(() => {}), this.controls.splice(i, 1), e && (this.controls.splice(i, 0, e), this._registerControl(e)), this.updateValueAndValidity({
          emitEvent: a.emitEvent
        }), this._onCollectionChange();
      }
      get length() {
        return this.controls.length;
      }
      setValue(t, e = {}) {
        tv(this, 0, t), t.forEach((a, i) => {
          ev(this, !1, i), this.at(i).setValue(a, {
            onlySelf: !0,
            emitEvent: e.emitEvent
          });
        }), this.updateValueAndValidity(e);
      }
      patchValue(t, e = {}) {
        null != t && (t.forEach((a, i) => {
          this.at(i) && this.at(i).patchValue(a, {
            onlySelf: !0,
            emitEvent: e.emitEvent
          });
        }), this.updateValueAndValidity(e));
      }
      reset(t = [], e = {}) {
        this._forEachChild((a, i) => {
          a.reset(t[i], {
            onlySelf: !0,
            emitEvent: e.emitEvent
          });
        }), this._updatePristine(e), this._updateTouched(e), this.updateValueAndValidity(e);
      }
      getRawValue() {
        return this.controls.map(t => t.getRawValue());
      }
      clear(t = {}) {
        this.controls.length < 1 || (this._forEachChild(e => e._registerOnCollectionChange(() => {})), this.controls.splice(0), this.updateValueAndValidity({
          emitEvent: t.emitEvent
        }));
      }
      _adjustIndex(t) {
        return t < 0 ? t + this.length : t;
      }
      _syncPendingControls() {
        let t = this.controls.reduce((e, a) => !!a._syncPendingControls() || e, !1);
        return t && this.updateValueAndValidity({
          onlySelf: !0
        }), t;
      }
      _forEachChild(t) {
        this.controls.forEach((e, a) => {
          t(e, a);
        });
      }
      _updateValue() {
        this.value = this.controls.filter(t => t.enabled || this.disabled).map(t => t.value);
      }
      _anyControls(t) {
        return this.controls.some(e => e.enabled && t(e));
      }
      _setUpControls() {
        this._forEachChild(t => this._registerControl(t));
      }
      _allControlsDisabled() {
        for (const t of this.controls) if (t.enabled) return !1;
        return this.controls.length > 0 || this.disabled;
      }
      _registerControl(t) {
        t.setParent(this), t._registerOnCollectionChange(this._onCollectionChange);
      }
      _find(t) {
        return this.at(t) ?? null;
      }
    }
    function Av(n) {
      return !!n && (void 0 !== n.asyncValidators || void 0 !== n.validators || void 0 !== n.updateOn);
    }
    let tp = (() => {
      class n {
        constructor() {
          this.useNonNullable = !1;
        }
        get nonNullable() {
          const e = new n();
          return e.useNonNullable = !0, e;
        }
        group(e, a = null) {
          const i = this._reduceControls(e);
          let o = {};
          return Av(a) ? o = a : null !== a && (o.validators = a.validator, o.asyncValidators = a.asyncValidator), new Ci(i, o);
        }
        record(e, a = null) {
          const i = this._reduceControls(e);
          return new nv(i, a);
        }
        control(e, a, i) {
          let o = {};
          return this.useNonNullable ? (Av(a) ? o = a : (o.validators = a, o.asyncValidators = i), new at(e, {
            ...o,
            nonNullable: !0
          })) : new at(e, a, i);
        }
        array(e, a, i) {
          const o = e.map(r => this._createControl(r));
          return new ep(o, a, i);
        }
        _reduceControls(e) {
          const a = {};
          return Object.keys(e).forEach(i => {
            a[i] = this._createControl(e[i]);
          }), a;
        }
        _createControl(e) {
          return e instanceof at || e instanceof o2 ? e : Array.isArray(e) ? this.control(e[0], e.length > 1 ? e[1] : null, e.length > 2 ? e[2] : null) : this.control(e);
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)();
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac,
        providedIn: f2
      }), n;
    })();
    class os {
      constructor(t = !1, e, a = !0, i) {
        this._multiple = t, this._emitChanges = a, this.compareWith = i, this._selection = new Set(), this._deselectedToEmit = [], this._selectedToEmit = [], this.changed = new V(), e && e.length && (t ? e.forEach(o => this._markSelected(o)) : this._markSelected(e[0]), this._selectedToEmit.length = 0);
      }
      get selected() {
        return this._selected || (this._selected = Array.from(this._selection.values())), this._selected;
      }
      select(...t) {
        this._verifyValueAssignment(t), t.forEach(a => this._markSelected(a));
        const e = this._hasQueuedChanges();
        return this._emitChangeEvent(), e;
      }
      deselect(...t) {
        this._verifyValueAssignment(t), t.forEach(a => this._unmarkSelected(a));
        const e = this._hasQueuedChanges();
        return this._emitChangeEvent(), e;
      }
      setSelection(...t) {
        this._verifyValueAssignment(t);
        const e = this.selected,
          a = new Set(t);
        t.forEach(o => this._markSelected(o)), e.filter(o => !a.has(o)).forEach(o => this._unmarkSelected(o));
        const i = this._hasQueuedChanges();
        return this._emitChangeEvent(), i;
      }
      toggle(t) {
        return this.isSelected(t) ? this.deselect(t) : this.select(t);
      }
      clear(t = !0) {
        this._unmarkAll();
        const e = this._hasQueuedChanges();
        return t && this._emitChangeEvent(), e;
      }
      isSelected(t) {
        if (this.compareWith) {
          for (const e of this._selection) if (this.compareWith(e, t)) return !0;
          return !1;
        }
        return this._selection.has(t);
      }
      isEmpty() {
        return 0 === this._selection.size;
      }
      hasValue() {
        return !this.isEmpty();
      }
      sort(t) {
        this._multiple && this.selected && this._selected.sort(t);
      }
      isMultipleSelection() {
        return this._multiple;
      }
      _emitChangeEvent() {
        this._selected = null, (this._selectedToEmit.length || this._deselectedToEmit.length) && (this.changed.next({
          source: this,
          added: this._selectedToEmit,
          removed: this._deselectedToEmit
        }), this._deselectedToEmit = [], this._selectedToEmit = []);
      }
      _markSelected(t) {
        this.isSelected(t) || (this._multiple || this._unmarkAll(), this.isSelected(t) || this._selection.add(t), this._emitChanges && this._selectedToEmit.push(t));
      }
      _unmarkSelected(t) {
        this.isSelected(t) && (this._selection.delete(t), this._emitChanges && this._deselectedToEmit.push(t));
      }
      _unmarkAll() {
        this.isEmpty() || this._selection.forEach(t => this._unmarkSelected(t));
      }
      _verifyValueAssignment(t) {}
      _hasQueuedChanges() {
        return !(!this._deselectedToEmit.length && !this._selectedToEmit.length);
      }
    }
    let np = (() => {
      class n {
        constructor() {
          this._listeners = [];
        }
        notify(e, a) {
          for (let i of this._listeners) i(e, a);
        }
        listen(e) {
          return this._listeners.push(e), () => {
            this._listeners = this._listeners.filter(a => e !== a);
          };
        }
        ngOnDestroy() {
          this._listeners = [];
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)();
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac,
        providedIn: "root"
      }), n;
    })();
    function h2(n) {
      return !!n && (n instanceof Be || "function" == typeof n.lift && "function" == typeof n.subscribe);
    }
    class Xi extends V {
      constructor(t) {
        super(), this._value = t;
      }
      get value() {
        return this.getValue();
      }
      _subscribe(t) {
        const e = super._subscribe(t);
        return e && !e.closed && t.next(this._value), e;
      }
      getValue() {
        if (this.hasError) throw this.thrownError;
        if (this.closed) throw new co();
        return this._value;
      }
      next(t) {
        super.next(this._value = t);
      }
    }
    class Tv extends class uH {
      constructor() {
        this.expansionModel = new os(!0);
      }
      toggle(t) {
        this.expansionModel.toggle(this._trackByValue(t));
      }
      expand(t) {
        this.expansionModel.select(this._trackByValue(t));
      }
      collapse(t) {
        this.expansionModel.deselect(this._trackByValue(t));
      }
      isExpanded(t) {
        return this.expansionModel.isSelected(this._trackByValue(t));
      }
      toggleDescendants(t) {
        this.expansionModel.isSelected(this._trackByValue(t)) ? this.collapseDescendants(t) : this.expandDescendants(t);
      }
      collapseAll() {
        this.expansionModel.clear();
      }
      expandDescendants(t) {
        let e = [t];
        e.push(...this.getDescendants(t)), this.expansionModel.select(...e.map(a => this._trackByValue(a)));
      }
      collapseDescendants(t) {
        let e = [t];
        e.push(...this.getDescendants(t)), this.expansionModel.deselect(...e.map(a => this._trackByValue(a)));
      }
      _trackByValue(t) {
        return this.trackBy ? this.trackBy(t) : t;
      }
    } {
      constructor(t, e) {
        super(), this.getChildren = t, this.options = e, this.options && (this.trackBy = this.options.trackBy);
      }
      expandAll() {
        this.expansionModel.clear();
        const t = this.dataNodes.reduce((e, a) => [...e, ...this.getDescendants(a), a], []);
        this.expansionModel.select(...t.map(e => this._trackByValue(e)));
      }
      getDescendants(t) {
        const e = [];
        return this._getDescendants(e, t), e.splice(1);
      }
      _getDescendants(t, e) {
        t.push(e);
        const a = this.getChildren(e);
        Array.isArray(a) ? a.forEach(i => this._getDescendants(t, i)) : h2(a) && a.pipe($e(1), Ht(Boolean)).subscribe(i => {
          for (const o of i) this._getDescendants(t, o);
        });
      }
    }
    const p2 = new O("CDK_TREE_NODE_OUTLET_NODE");
    let Qc = (() => {
      class n {
        constructor(e, a) {
          this.viewContainer = e, this._node = a;
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(f(ut), f(p2, 8));
      }, n.ɵdir = P({
        type: n,
        selectors: [["", "cdkTreeNodeOutlet", ""]]
      }), n;
    })();
    class fH {
      constructor(t) {
        this.$implicit = t;
      }
    }
    let g2 = (() => {
        class n {
          constructor(e) {
            this.template = e;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(vt));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "cdkTreeNodeDef", ""]],
          inputs: {
            when: ["cdkTreeNodeDefWhen", "when"]
          }
        }), n;
      })(),
      Mi = (() => {
        class n {
          constructor(e, a) {
            this._differs = e, this._changeDetectorRef = a, this._onDestroy = new V(), this._levels = new Map(), this.viewChange = new Xi({
              start: 0,
              end: Number.MAX_VALUE
            });
          }
          get dataSource() {
            return this._dataSource;
          }
          set dataSource(e) {
            this._dataSource !== e && this._switchDataSource(e);
          }
          ngOnInit() {
            this._dataDiffer = this._differs.find([]).create(this.trackBy);
          }
          ngOnDestroy() {
            this._nodeOutlet.viewContainer.clear(), this.viewChange.complete(), this._onDestroy.next(), this._onDestroy.complete(), this._dataSource && "function" == typeof this._dataSource.disconnect && this.dataSource.disconnect(this), this._dataSubscription && (this._dataSubscription.unsubscribe(), this._dataSubscription = null);
          }
          ngAfterContentChecked() {
            const e = this._nodeDefs.filter(a => !a.when);
            this._defaultNodeDef = e[0], this.dataSource && this._nodeDefs && !this._dataSubscription && this._observeRenderChanges();
          }
          _switchDataSource(e) {
            this._dataSource && "function" == typeof this._dataSource.disconnect && this.dataSource.disconnect(this), this._dataSubscription && (this._dataSubscription.unsubscribe(), this._dataSubscription = null), e || this._nodeOutlet.viewContainer.clear(), this._dataSource = e, this._nodeDefs && this._observeRenderChanges();
          }
          _observeRenderChanges() {
            let e;
            !function m2(n) {
              return n && "function" == typeof n.connect && !(n instanceof E3);
            }(this._dataSource) ? h2(this._dataSource) ? e = this._dataSource : Array.isArray(this._dataSource) && (e = nt(this._dataSource)) : e = this._dataSource.connect(this), e && (this._dataSubscription = e.pipe(ne(this._onDestroy)).subscribe(a => this.renderNodeChanges(a)));
          }
          renderNodeChanges(e, a = this._dataDiffer, i = this._nodeOutlet.viewContainer, o) {
            const r = a.diff(e);
            !r || (r.forEachOperation((s, c, l) => {
              if (null == s.previousIndex) this.insertNode(e[l], l, i, o);else if (null == l) i.remove(c), this._levels.delete(s.item);else {
                const d = i.get(c);
                i.move(d, l);
              }
            }), this._changeDetectorRef.detectChanges());
          }
          _getNodeDef(e, a) {
            return 1 === this._nodeDefs.length ? this._nodeDefs.first : this._nodeDefs.find(o => o.when && o.when(a, e)) || this._defaultNodeDef;
          }
          insertNode(e, a, i, o) {
            const r = this._getNodeDef(e, a),
              s = new fH(e);
            s.level = this.treeControl.getLevel ? this.treeControl.getLevel(e) : typeof o < "u" && this._levels.has(o) ? this._levels.get(o) + 1 : 0, this._levels.set(e, s.level), (i || this._nodeOutlet.viewContainer).createEmbeddedView(r.template, s, a), Ka.mostRecentTreeNode && (Ka.mostRecentTreeNode.data = e);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Xn), f(Se));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["cdk-tree"]],
          contentQueries: function (e, a, i) {
            if (1 & e && De(i, g2, 5), 2 & e) {
              let o;
              H(o = B()) && (a._nodeDefs = o);
            }
          },
          viewQuery: function (e, a) {
            if (1 & e && be(Qc, 7), 2 & e) {
              let i;
              H(i = B()) && (a._nodeOutlet = i.first);
            }
          },
          hostAttrs: ["role", "tree", 1, "cdk-tree"],
          inputs: {
            dataSource: "dataSource",
            treeControl: "treeControl",
            trackBy: "trackBy"
          },
          exportAs: ["cdkTree"],
          decls: 1,
          vars: 0,
          consts: [["cdkTreeNodeOutlet", ""]],
          template: function (e, a) {
            1 & e && Rn(0, 0);
          },
          dependencies: [Qc],
          encapsulation: 2
        }), n;
      })(),
      Ka = (() => {
        class n {
          constructor(e, a) {
            this._elementRef = e, this._tree = a, this._destroyed = new V(), this._dataChanges = new V(), n.mostRecentTreeNode = this, this.role = "treeitem";
          }
          get role() {
            return "treeitem";
          }
          set role(e) {
            this._elementRef.nativeElement.setAttribute("role", e);
          }
          get data() {
            return this._data;
          }
          set data(e) {
            e !== this._data && (this._data = e, this._setRoleFromData(), this._dataChanges.next());
          }
          get isExpanded() {
            return this._tree.treeControl.isExpanded(this._data);
          }
          get level() {
            return this._tree.treeControl.getLevel ? this._tree.treeControl.getLevel(this._data) : this._parentNodeAriaLevel;
          }
          ngOnInit() {
            this._parentNodeAriaLevel = function mH(n) {
              let t = n.parentElement;
              for (; t && !hH(t);) t = t.parentElement;
              return t ? t.classList.contains("cdk-nested-tree-node") ? xt(t.getAttribute("aria-level")) : 0 : -1;
            }(this._elementRef.nativeElement), this._elementRef.nativeElement.setAttribute("aria-level", `${this.level + 1}`);
          }
          ngOnDestroy() {
            n.mostRecentTreeNode === this && (n.mostRecentTreeNode = null), this._dataChanges.complete(), this._destroyed.next(), this._destroyed.complete();
          }
          focus() {
            this._elementRef.nativeElement.focus();
          }
          _setRoleFromData() {
            this.role = "treeitem";
          }
        }
        return n.mostRecentTreeNode = null, n.ɵfac = function (e) {
          return new (e || n)(f(J), f(Mi));
        }, n.ɵdir = P({
          type: n,
          selectors: [["cdk-tree-node"]],
          hostAttrs: [1, "cdk-tree-node"],
          hostVars: 1,
          hostBindings: function (e, a) {
            2 & e && X("aria-expanded", a.isExpanded);
          },
          inputs: {
            role: "role"
          },
          exportAs: ["cdkTreeNode"]
        }), n;
      })();
    function hH(n) {
      const t = n.classList;
      return !(!t?.contains("cdk-nested-tree-node") && !t?.contains("cdk-tree"));
    }
    let ap = (() => {
        class n extends Ka {
          constructor(e, a, i) {
            super(e, a), this._differs = i;
          }
          ngAfterContentInit() {
            this._dataDiffer = this._differs.find([]).create(this._tree.trackBy);
            const e = this._tree.treeControl.getChildren(this.data);
            Array.isArray(e) ? this.updateChildrenNodes(e) : h2(e) && e.pipe(ne(this._destroyed)).subscribe(a => this.updateChildrenNodes(a)), this.nodeOutlet.changes.pipe(ne(this._destroyed)).subscribe(() => this.updateChildrenNodes());
          }
          ngOnInit() {
            super.ngOnInit();
          }
          ngOnDestroy() {
            this._clear(), super.ngOnDestroy();
          }
          updateChildrenNodes(e) {
            const a = this._getNodeOutlet();
            e && (this._children = e), a && this._children ? this._tree.renderNodeChanges(this._children, this._dataDiffer, a.viewContainer, this._data) : this._dataDiffer.diff([]);
          }
          _clear() {
            const e = this._getNodeOutlet();
            e && (e.viewContainer.clear(), this._dataDiffer.diff([]));
          }
          _getNodeOutlet() {
            const e = this.nodeOutlet;
            return e && e.find(a => !a._node || a._node === this);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(Mi), f(Xn));
        }, n.ɵdir = P({
          type: n,
          selectors: [["cdk-nested-tree-node"]],
          contentQueries: function (e, a, i) {
            if (1 & e && De(i, Qc, 5), 2 & e) {
              let o;
              H(o = B()) && (a.nodeOutlet = o);
            }
          },
          hostAttrs: [1, "cdk-nested-tree-node"],
          inputs: {
            role: "role",
            disabled: "disabled",
            tabIndex: "tabIndex"
          },
          exportAs: ["cdkNestedTreeNode"],
          features: [G([{
            provide: Ka,
            useExisting: n
          }, {
            provide: p2,
            useExisting: n
          }]), z]
        }), n;
      })(),
      op = (() => {
        class n {
          constructor(e, a) {
            this._tree = e, this._treeNode = a, this._recursive = !1;
          }
          get recursive() {
            return this._recursive;
          }
          set recursive(e) {
            this._recursive = Y(e);
          }
          _toggle(e) {
            this.recursive ? this._tree.treeControl.toggleDescendants(this._treeNode.data) : this._tree.treeControl.toggle(this._treeNode.data), e.stopPropagation();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Mi), f(Ka));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "cdkTreeNodeToggle", ""]],
          hostBindings: function (e, a) {
            1 & e && F("click", function (o) {
              return a._toggle(o);
            });
          },
          inputs: {
            recursive: ["cdkTreeNodeToggleRecursive", "recursive"]
          }
        }), n;
      })(),
      Iv = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({}), n;
      })();
    function Ji() {}
    function rs(n, t, e) {
      return function (i) {
        return i.lift(new gH(n, t, e));
      };
    }
    class gH {
      constructor(t, e, a) {
        this.nextOrObserver = t, this.error = e, this.complete = a;
      }
      call(t, e) {
        return e.subscribe(new bH(t, this.nextOrObserver, this.error, this.complete));
      }
    }
    class bH extends Qe {
      constructor(t, e, a, i) {
        super(t), this._tapNext = Ji, this._tapError = Ji, this._tapComplete = Ji, this._tapError = a || Ji, this._tapComplete = i || Ji, so(e) ? (this._context = this, this._tapNext = e) : e && (this._context = e, this._tapNext = e.next || Ji, this._tapError = e.error || Ji, this._tapComplete = e.complete || Ji);
      }
      _next(t) {
        try {
          this._tapNext.call(this._context, t);
        } catch (e) {
          return void this.destination.error(e);
        }
        this.destination.next(t);
      }
      _error(t) {
        try {
          this._tapError.call(this._context, t);
        } catch (e) {
          return void this.destination.error(e);
        }
        this.destination.error(t);
      }
      _complete() {
        try {
          this._tapComplete.call(this._context);
        } catch (t) {
          return void this.destination.error(t);
        }
        return this.destination.complete();
      }
    }
    function b2(n, t = Zr) {
      return e => e.lift(new _H(n, t));
    }
    class _H {
      constructor(t, e) {
        this.dueTime = t, this.scheduler = e;
      }
      call(t, e) {
        return e.subscribe(new vH(t, this.dueTime, this.scheduler));
      }
    }
    class vH extends Qe {
      constructor(t, e, a) {
        super(t), this.dueTime = e, this.scheduler = a, this.debouncedSubscription = null, this.lastValue = null, this.hasValue = !1;
      }
      _next(t) {
        this.clearDebounce(), this.lastValue = t, this.hasValue = !0, this.add(this.debouncedSubscription = this.scheduler.schedule(yH, this.dueTime, this));
      }
      _complete() {
        this.debouncedNext(), this.destination.complete();
      }
      debouncedNext() {
        if (this.clearDebounce(), this.hasValue) {
          const {
            lastValue: t
          } = this;
          this.lastValue = null, this.hasValue = !1, this.destination.next(t);
        }
      }
      clearDebounce() {
        const t = this.debouncedSubscription;
        null !== t && (this.remove(t), t.unsubscribe(), this.debouncedSubscription = null);
      }
    }
    function yH(n) {
      n.debouncedNext();
    }
    function Rv(n) {
      return t => t.lift(new CH(n));
    }
    class CH {
      constructor(t) {
        this.total = t;
      }
      call(t, e) {
        return e.subscribe(new MH(t, this.total));
      }
    }
    class MH extends Qe {
      constructor(t, e) {
        super(t), this.total = e, this.count = 0;
      }
      _next(t) {
        ++this.count > this.total && this.destination.next(t);
      }
    }
    function rp(n, t) {
      return e => e.lift(new xH(n, t));
    }
    class xH {
      constructor(t, e) {
        this.compare = t, this.keySelector = e;
      }
      call(t, e) {
        return e.subscribe(new wH(t, this.compare, this.keySelector));
      }
    }
    class wH extends Qe {
      constructor(t, e, a) {
        super(t), this.keySelector = a, this.hasKey = !1, "function" == typeof e && (this.compare = e);
      }
      compare(t, e) {
        return t === e;
      }
      _next(t) {
        let e;
        try {
          const {
            keySelector: i
          } = this;
          e = i ? i(t) : t;
        } catch (i) {
          return this.destination.error(i);
        }
        let a = !1;
        if (this.hasKey) try {
          const {
            compare: i
          } = this;
          a = i(this.key, e);
        } catch (i) {
          return this.destination.error(i);
        } else this.hasKey = !0;
        a || (this.key = e, this.destination.next(t));
      }
    }
    let zv = (() => {
        class n {
          create(e) {
            return typeof MutationObserver > "u" ? null : new MutationObserver(e);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      kH = (() => {
        class n {
          constructor(e) {
            this._mutationObserverFactory = e, this._observedElements = new Map();
          }
          ngOnDestroy() {
            this._observedElements.forEach((e, a) => this._cleanupObserver(a));
          }
          observe(e) {
            const a = wt(e);
            return new Be(i => {
              const r = this._observeElement(a).subscribe(i);
              return () => {
                r.unsubscribe(), this._unobserveElement(a);
              };
            });
          }
          _observeElement(e) {
            if (this._observedElements.has(e)) this._observedElements.get(e).count++;else {
              const a = new V(),
                i = this._mutationObserverFactory.create(o => a.next(o));
              i && i.observe(e, {
                characterData: !0,
                childList: !0,
                subtree: !0
              }), this._observedElements.set(e, {
                observer: i,
                stream: a,
                count: 1
              });
            }
            return this._observedElements.get(e).stream;
          }
          _unobserveElement(e) {
            this._observedElements.has(e) && (this._observedElements.get(e).count--, this._observedElements.get(e).count || this._cleanupObserver(e));
          }
          _cleanupObserver(e) {
            if (this._observedElements.has(e)) {
              const {
                observer: a,
                stream: i
              } = this._observedElements.get(e);
              a && a.disconnect(), i.complete(), this._observedElements.delete(e);
            }
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(zv));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      sp = (() => {
        class n {
          constructor(e, a, i) {
            this._contentObserver = e, this._elementRef = a, this._ngZone = i, this.event = new E(), this._disabled = !1, this._currentSubscription = null;
          }
          get disabled() {
            return this._disabled;
          }
          set disabled(e) {
            this._disabled = Y(e), this._disabled ? this._unsubscribe() : this._subscribe();
          }
          get debounce() {
            return this._debounce;
          }
          set debounce(e) {
            this._debounce = xt(e), this._subscribe();
          }
          ngAfterContentInit() {
            !this._currentSubscription && !this.disabled && this._subscribe();
          }
          ngOnDestroy() {
            this._unsubscribe();
          }
          _subscribe() {
            this._unsubscribe();
            const e = this._contentObserver.observe(this._elementRef);
            this._ngZone.runOutsideAngular(() => {
              this._currentSubscription = (this.debounce ? e.pipe(b2(this.debounce)) : e).subscribe(this.event);
            });
          }
          _unsubscribe() {
            this._currentSubscription?.unsubscribe();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(kH), f(J), f(ae));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "cdkObserveContent", ""]],
          inputs: {
            disabled: ["cdkObserveContentDisabled", "disabled"],
            debounce: "debounce"
          },
          outputs: {
            event: "cdkObserveContent"
          },
          exportAs: ["cdkObserveContent"]
        }), n;
      })(),
      Zc = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [zv]
        }), n;
      })();
    class DH extends Qe {
      notifyNext(t, e, a, i, o) {
        this.destination.next(e);
      }
      notifyError(t, e) {
        this.destination.error(t);
      }
      notifyComplete(t) {
        this.destination.complete();
      }
    }
    class OH extends Qe {
      constructor(t, e, a) {
        super(), this.parent = t, this.outerValue = e, this.outerIndex = a, this.index = 0;
      }
      _next(t) {
        this.parent.notifyNext(this.outerValue, t, this.outerIndex, this.index++, this);
      }
      _error(t) {
        this.parent.notifyError(t, this), this.unsubscribe();
      }
      _complete() {
        this.parent.notifyComplete(this), this.unsubscribe();
      }
    }
    function PH(n, t, e, a, i = new OH(n, e, a)) {
      if (!i.closed) return t instanceof Be ? t.subscribe(i) : Y0(t)(i);
    }
    const Lv = {};
    function Nv(...n) {
      let t, e;
      return er(n[n.length - 1]) && (e = n.pop()), "function" == typeof n[n.length - 1] && (t = n.pop()), 1 === n.length && $o(n[0]) && (n = n[0]), Q0(n, e).lift(new AH(t));
    }
    class AH {
      constructor(t) {
        this.resultSelector = t;
      }
      call(t, e) {
        return e.subscribe(new SH(t, this.resultSelector));
      }
    }
    class SH extends DH {
      constructor(t, e) {
        super(t), this.resultSelector = e, this.active = 0, this.values = [], this.observables = [];
      }
      _next(t) {
        this.values.push(Lv), this.observables.push(t);
      }
      _complete() {
        const t = this.observables,
          e = t.length;
        if (0 === e) this.destination.complete();else {
          this.active = e, this.toRespond = e;
          for (let a = 0; a < e; a++) this.add(PH(this, t[a], void 0, a));
        }
      }
      notifyComplete(t) {
        0 == (this.active -= 1) && this.destination.complete();
      }
      notifyNext(t, e, a) {
        const i = this.values,
          r = this.toRespond ? i[a] === Lv ? --this.toRespond : this.toRespond : 0;
        i[a] = e, 0 === r && (this.resultSelector ? this._tryResultSelector(i) : this.destination.next(i.slice()));
      }
      _tryResultSelector(t) {
        let e;
        try {
          e = this.resultSelector.apply(this, t);
        } catch (a) {
          return void this.destination.error(a);
        }
        this.destination.next(e);
      }
    }
    function _2(...n) {
      return function EH() {
        return A3(1);
      }()(nt(...n));
    }
    function Gt(...n) {
      const t = n[n.length - 1];
      return er(t) ? (n.pop(), e => _2(n, e, t)) : e => _2(n, e);
    }
    const Fv = new Set();
    let ss,
      TH = (() => {
        class n {
          constructor(e) {
            this._platform = e, this._matchMedia = this._platform.isBrowser && window.matchMedia ? window.matchMedia.bind(window) : RH;
          }
          matchMedia(e) {
            return (this._platform.WEBKIT || this._platform.BLINK) && function IH(n) {
              if (!Fv.has(n)) try {
                ss || (ss = document.createElement("style"), ss.setAttribute("type", "text/css"), document.head.appendChild(ss)), ss.sheet && (ss.sheet.insertRule(`@media ${n} {body{ }}`, 0), Fv.add(n));
              } catch (t) {
                console.error(t);
              }
            }(e), this._matchMedia(e);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(Ct));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })();
    function RH(n) {
      return {
        matches: "all" === n || "" === n,
        media: n,
        addListener: () => {},
        removeListener: () => {}
      };
    }
    let Vv = (() => {
      class n {
        constructor(e, a) {
          this._mediaMatcher = e, this._zone = a, this._queries = new Map(), this._destroySubject = new V();
        }
        ngOnDestroy() {
          this._destroySubject.next(), this._destroySubject.complete();
        }
        isMatched(e) {
          return Hv(Wd(e)).some(i => this._registerQuery(i).mql.matches);
        }
        observe(e) {
          let o = Nv(Hv(Wd(e)).map(r => this._registerQuery(r).observable));
          return o = _2(o.pipe($e(1)), o.pipe(Rv(1), b2(0))), o.pipe(We(r => {
            const s = {
              matches: !1,
              breakpoints: {}
            };
            return r.forEach(({
              matches: c,
              query: l
            }) => {
              s.matches = s.matches || c, s.breakpoints[l] = c;
            }), s;
          }));
        }
        _registerQuery(e) {
          if (this._queries.has(e)) return this._queries.get(e);
          const a = this._mediaMatcher.matchMedia(e),
            o = {
              observable: new Be(r => {
                const s = c => this._zone.run(() => r.next(c));
                return a.addListener(s), () => {
                  a.removeListener(s);
                };
              }).pipe(Gt(a), We(({
                matches: r
              }) => ({
                query: e,
                matches: r
              })), ne(this._destroySubject)),
              mql: a
            };
          return this._queries.set(e, o), o;
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(TH), M(ae));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac,
        providedIn: "root"
      }), n;
    })();
    function Hv(n) {
      return n.map(t => t.split(",")).reduce((t, e) => t.concat(e)).map(t => t.trim());
    }
    function v2(n, t) {
      return (n.getAttribute(t) || "").match(/\S+/g) || [];
    }
    const jv = "cdk-describedby-message",
      y2 = "cdk-describedby-host";
    let cp = 0,
      FH = (() => {
        class n {
          constructor(e, a) {
            this._platform = a, this._messageRegistry = new Map(), this._messagesContainer = null, this._id = "" + cp++, this._document = e, this._id = La(Ur) + "-" + cp++;
          }
          describe(e, a, i) {
            if (!this._canBeDescribed(e, a)) return;
            const o = lp(a, i);
            "string" != typeof a ? (Uv(a, this._id), this._messageRegistry.set(o, {
              messageElement: a,
              referenceCount: 0
            })) : this._messageRegistry.has(o) || this._createMessageElement(a, i), this._isElementDescribedByMessage(e, o) || this._addMessageReference(e, o);
          }
          removeDescription(e, a, i) {
            if (!a || !this._isElementNode(e)) return;
            const o = lp(a, i);
            if (this._isElementDescribedByMessage(e, o) && this._removeMessageReference(e, o), "string" == typeof a) {
              const r = this._messageRegistry.get(o);
              r && 0 === r.referenceCount && this._deleteMessageElement(o);
            }
            0 === this._messagesContainer?.childNodes.length && (this._messagesContainer.remove(), this._messagesContainer = null);
          }
          ngOnDestroy() {
            const e = this._document.querySelectorAll(`[${y2}="${this._id}"]`);
            for (let a = 0; a < e.length; a++) this._removeCdkDescribedByReferenceIds(e[a]), e[a].removeAttribute(y2);
            this._messagesContainer?.remove(), this._messagesContainer = null, this._messageRegistry.clear();
          }
          _createMessageElement(e, a) {
            const i = this._document.createElement("div");
            Uv(i, this._id), i.textContent = e, a && i.setAttribute("role", a), this._createMessagesContainer(), this._messagesContainer.appendChild(i), this._messageRegistry.set(lp(e, a), {
              messageElement: i,
              referenceCount: 0
            });
          }
          _deleteMessageElement(e) {
            this._messageRegistry.get(e)?.messageElement?.remove(), this._messageRegistry.delete(e);
          }
          _createMessagesContainer() {
            if (this._messagesContainer) return;
            const e = "cdk-describedby-message-container",
              a = this._document.querySelectorAll(`.${e}[platform="server"]`);
            for (let o = 0; o < a.length; o++) a[o].remove();
            const i = this._document.createElement("div");
            i.style.visibility = "hidden", i.classList.add(e), i.classList.add("cdk-visually-hidden"), this._platform && !this._platform.isBrowser && i.setAttribute("platform", "server"), this._document.body.appendChild(i), this._messagesContainer = i;
          }
          _removeCdkDescribedByReferenceIds(e) {
            const a = v2(e, "aria-describedby").filter(i => 0 != i.indexOf(jv));
            e.setAttribute("aria-describedby", a.join(" "));
          }
          _addMessageReference(e, a) {
            const i = this._messageRegistry.get(a);
            (function LH(n, t, e) {
              const a = v2(n, t);
              a.some(i => i.trim() == e.trim()) || (a.push(e.trim()), n.setAttribute(t, a.join(" ")));
            })(e, "aria-describedby", i.messageElement.id), e.setAttribute(y2, this._id), i.referenceCount++;
          }
          _removeMessageReference(e, a) {
            const i = this._messageRegistry.get(a);
            i.referenceCount--, function NH(n, t, e) {
              const i = v2(n, t).filter(o => o != e.trim());
              i.length ? n.setAttribute(t, i.join(" ")) : n.removeAttribute(t);
            }(e, "aria-describedby", i.messageElement.id), e.removeAttribute(y2);
          }
          _isElementDescribedByMessage(e, a) {
            const i = v2(e, "aria-describedby"),
              o = this._messageRegistry.get(a),
              r = o && o.messageElement.id;
            return !!r && -1 != i.indexOf(r);
          }
          _canBeDescribed(e, a) {
            if (!this._isElementNode(e)) return !1;
            if (a && "object" == typeof a) return !0;
            const i = null == a ? "" : `${a}`.trim(),
              o = e.getAttribute("aria-label");
            return !(!i || o && o.trim() === i);
          }
          _isElementNode(e) {
            return e.nodeType === this._document.ELEMENT_NODE;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(ie), M(Ct));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })();
    function lp(n, t) {
      return "string" == typeof n ? `${t || ""}/${n}` : n;
    }
    function Uv(n, t) {
      n.id || (n.id = `${jv}-${t}-${cp++}`);
    }
    class Gv {
      constructor(t) {
        this._items = t, this._activeItemIndex = -1, this._activeItem = null, this._wrap = !1, this._letterKeyStream = new V(), this._typeaheadSubscription = re.EMPTY, this._vertical = !0, this._allowedModifierKeys = [], this._homeAndEnd = !1, this._skipPredicateFn = e => e.disabled, this._pressedLetters = [], this.tabOut = new V(), this.change = new V(), t instanceof Hr && t.changes.subscribe(e => {
          if (this._activeItem) {
            const i = e.toArray().indexOf(this._activeItem);
            i > -1 && i !== this._activeItemIndex && (this._activeItemIndex = i);
          }
        });
      }
      skipPredicate(t) {
        return this._skipPredicateFn = t, this;
      }
      withWrap(t = !0) {
        return this._wrap = t, this;
      }
      withVerticalOrientation(t = !0) {
        return this._vertical = t, this;
      }
      withHorizontalOrientation(t) {
        return this._horizontal = t, this;
      }
      withAllowedModifierKeys(t) {
        return this._allowedModifierKeys = t, this;
      }
      withTypeAhead(t = 200) {
        return this._typeaheadSubscription.unsubscribe(), this._typeaheadSubscription = this._letterKeyStream.pipe(rs(e => this._pressedLetters.push(e)), b2(t), Ht(() => this._pressedLetters.length > 0), We(() => this._pressedLetters.join(""))).subscribe(e => {
          const a = this._getItemsArray();
          for (let i = 1; i < a.length + 1; i++) {
            const o = (this._activeItemIndex + i) % a.length,
              r = a[o];
            if (!this._skipPredicateFn(r) && 0 === r.getLabel().toUpperCase().trim().indexOf(e)) {
              this.setActiveItem(o);
              break;
            }
          }
          this._pressedLetters = [];
        }), this;
      }
      withHomeAndEnd(t = !0) {
        return this._homeAndEnd = t, this;
      }
      setActiveItem(t) {
        const e = this._activeItem;
        this.updateActiveItem(t), this._activeItem !== e && this.change.next(this._activeItemIndex);
      }
      onKeydown(t) {
        const e = t.keyCode,
          i = ["altKey", "ctrlKey", "metaKey", "shiftKey"].every(o => !t[o] || this._allowedModifierKeys.indexOf(o) > -1);
        switch (e) {
          case 9:
            return void this.tabOut.next();
          case 40:
            if (this._vertical && i) {
              this.setNextItemActive();
              break;
            }
            return;
          case 38:
            if (this._vertical && i) {
              this.setPreviousItemActive();
              break;
            }
            return;
          case 39:
            if (this._horizontal && i) {
              "rtl" === this._horizontal ? this.setPreviousItemActive() : this.setNextItemActive();
              break;
            }
            return;
          case 37:
            if (this._horizontal && i) {
              "rtl" === this._horizontal ? this.setNextItemActive() : this.setPreviousItemActive();
              break;
            }
            return;
          case 36:
            if (this._homeAndEnd && i) {
              this.setFirstItemActive();
              break;
            }
            return;
          case 35:
            if (this._homeAndEnd && i) {
              this.setLastItemActive();
              break;
            }
            return;
          default:
            return void ((i || Et(t, "shiftKey")) && (t.key && 1 === t.key.length ? this._letterKeyStream.next(t.key.toLocaleUpperCase()) : (e >= 65 && e <= 90 || e >= 48 && e <= 57) && this._letterKeyStream.next(String.fromCharCode(e))));
        }
        this._pressedLetters = [], t.preventDefault();
      }
      get activeItemIndex() {
        return this._activeItemIndex;
      }
      get activeItem() {
        return this._activeItem;
      }
      isTyping() {
        return this._pressedLetters.length > 0;
      }
      setFirstItemActive() {
        this._setActiveItemByIndex(0, 1);
      }
      setLastItemActive() {
        this._setActiveItemByIndex(this._items.length - 1, -1);
      }
      setNextItemActive() {
        this._activeItemIndex < 0 ? this.setFirstItemActive() : this._setActiveItemByDelta(1);
      }
      setPreviousItemActive() {
        this._activeItemIndex < 0 && this._wrap ? this.setLastItemActive() : this._setActiveItemByDelta(-1);
      }
      updateActiveItem(t) {
        const e = this._getItemsArray(),
          a = "number" == typeof t ? t : e.indexOf(t);
        this._activeItem = e[a] ?? null, this._activeItemIndex = a;
      }
      _setActiveItemByDelta(t) {
        this._wrap ? this._setActiveInWrapMode(t) : this._setActiveInDefaultMode(t);
      }
      _setActiveInWrapMode(t) {
        const e = this._getItemsArray();
        for (let a = 1; a <= e.length; a++) {
          const i = (this._activeItemIndex + t * a + e.length) % e.length;
          if (!this._skipPredicateFn(e[i])) return void this.setActiveItem(i);
        }
      }
      _setActiveInDefaultMode(t) {
        this._setActiveItemByIndex(this._activeItemIndex + t, t);
      }
      _setActiveItemByIndex(t, e) {
        const a = this._getItemsArray();
        if (a[t]) {
          for (; this._skipPredicateFn(a[t]);) if (!a[t += e]) return;
          this.setActiveItem(t);
        }
      }
      _getItemsArray() {
        return this._items instanceof Hr ? this._items.toArray() : this._items;
      }
    }
    class Wv extends Gv {
      setActiveItem(t) {
        this.activeItem && this.activeItem.setInactiveStyles(), super.setActiveItem(t), this.activeItem && this.activeItem.setActiveStyles();
      }
    }
    class dp extends Gv {
      constructor() {
        super(...arguments), this._origin = "program";
      }
      setFocusOrigin(t) {
        return this._origin = t, this;
      }
      setActiveItem(t) {
        super.setActiveItem(t), this.activeItem && this.activeItem.focus(this._origin);
      }
    }
    let C2 = (() => {
      class n {
        constructor(e) {
          this._platform = e;
        }
        isDisabled(e) {
          return e.hasAttribute("disabled");
        }
        isVisible(e) {
          return function HH(n) {
            return !!(n.offsetWidth || n.offsetHeight || "function" == typeof n.getClientRects && n.getClientRects().length);
          }(e) && "visible" === getComputedStyle(e).visibility;
        }
        isTabbable(e) {
          if (!this._platform.isBrowser) return !1;
          const a = function VH(n) {
            try {
              return n.frameElement;
            } catch {
              return null;
            }
          }(function KH(n) {
            return n.ownerDocument && n.ownerDocument.defaultView || window;
          }(e));
          if (a && (-1 === qv(a) || !this.isVisible(a))) return !1;
          let i = e.nodeName.toLowerCase(),
            o = qv(e);
          return e.hasAttribute("contenteditable") ? -1 !== o : !("iframe" === i || "object" === i || this._platform.WEBKIT && this._platform.IOS && !function YH(n) {
            let t = n.nodeName.toLowerCase(),
              e = "input" === t && n.type;
            return "text" === e || "password" === e || "select" === t || "textarea" === t;
          }(e)) && ("audio" === i ? !!e.hasAttribute("controls") && -1 !== o : "video" === i ? -1 !== o && (null !== o || this._platform.FIREFOX || e.hasAttribute("controls")) : e.tabIndex >= 0);
        }
        isFocusable(e, a) {
          return function qH(n) {
            return !function jH(n) {
              return function GH(n) {
                return "input" == n.nodeName.toLowerCase();
              }(n) && "hidden" == n.type;
            }(n) && (function BH(n) {
              let t = n.nodeName.toLowerCase();
              return "input" === t || "select" === t || "button" === t || "textarea" === t;
            }(n) || function UH(n) {
              return function WH(n) {
                return "a" == n.nodeName.toLowerCase();
              }(n) && n.hasAttribute("href");
            }(n) || n.hasAttribute("contenteditable") || Yv(n));
          }(e) && !this.isDisabled(e) && (a?.ignoreVisibility || this.isVisible(e));
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(Ct));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac,
        providedIn: "root"
      }), n;
    })();
    function Yv(n) {
      if (!n.hasAttribute("tabindex") || void 0 === n.tabIndex) return !1;
      let t = n.getAttribute("tabindex");
      return !(!t || isNaN(parseInt(t, 10)));
    }
    function qv(n) {
      if (!Yv(n)) return null;
      const t = parseInt(n.getAttribute("tabindex") || "", 10);
      return isNaN(t) ? -1 : t;
    }
    class QH {
      constructor(t, e, a, i, o = !1) {
        this._element = t, this._checker = e, this._ngZone = a, this._document = i, this._hasAttached = !1, this.startAnchorListener = () => this.focusLastTabbableElement(), this.endAnchorListener = () => this.focusFirstTabbableElement(), this._enabled = !0, o || this.attachAnchors();
      }
      get enabled() {
        return this._enabled;
      }
      set enabled(t) {
        this._enabled = t, this._startAnchor && this._endAnchor && (this._toggleAnchorTabIndex(t, this._startAnchor), this._toggleAnchorTabIndex(t, this._endAnchor));
      }
      destroy() {
        const t = this._startAnchor,
          e = this._endAnchor;
        t && (t.removeEventListener("focus", this.startAnchorListener), t.remove()), e && (e.removeEventListener("focus", this.endAnchorListener), e.remove()), this._startAnchor = this._endAnchor = null, this._hasAttached = !1;
      }
      attachAnchors() {
        return !!this._hasAttached || (this._ngZone.runOutsideAngular(() => {
          this._startAnchor || (this._startAnchor = this._createAnchor(), this._startAnchor.addEventListener("focus", this.startAnchorListener)), this._endAnchor || (this._endAnchor = this._createAnchor(), this._endAnchor.addEventListener("focus", this.endAnchorListener));
        }), this._element.parentNode && (this._element.parentNode.insertBefore(this._startAnchor, this._element), this._element.parentNode.insertBefore(this._endAnchor, this._element.nextSibling), this._hasAttached = !0), this._hasAttached);
      }
      focusInitialElementWhenReady(t) {
        return new Promise(e => {
          this._executeOnStable(() => e(this.focusInitialElement(t)));
        });
      }
      focusFirstTabbableElementWhenReady(t) {
        return new Promise(e => {
          this._executeOnStable(() => e(this.focusFirstTabbableElement(t)));
        });
      }
      focusLastTabbableElementWhenReady(t) {
        return new Promise(e => {
          this._executeOnStable(() => e(this.focusLastTabbableElement(t)));
        });
      }
      _getRegionBoundary(t) {
        const e = this._element.querySelectorAll(`[cdk-focus-region-${t}], [cdkFocusRegion${t}], [cdk-focus-${t}]`);
        return "start" == t ? e.length ? e[0] : this._getFirstTabbableElement(this._element) : e.length ? e[e.length - 1] : this._getLastTabbableElement(this._element);
      }
      focusInitialElement(t) {
        const e = this._element.querySelector("[cdk-focus-initial], [cdkFocusInitial]");
        if (e) {
          if (!this._checker.isFocusable(e)) {
            const a = this._getFirstTabbableElement(e);
            return a?.focus(t), !!a;
          }
          return e.focus(t), !0;
        }
        return this.focusFirstTabbableElement(t);
      }
      focusFirstTabbableElement(t) {
        const e = this._getRegionBoundary("start");
        return e && e.focus(t), !!e;
      }
      focusLastTabbableElement(t) {
        const e = this._getRegionBoundary("end");
        return e && e.focus(t), !!e;
      }
      hasAttached() {
        return this._hasAttached;
      }
      _getFirstTabbableElement(t) {
        if (this._checker.isFocusable(t) && this._checker.isTabbable(t)) return t;
        const e = t.children;
        for (let a = 0; a < e.length; a++) {
          const i = e[a].nodeType === this._document.ELEMENT_NODE ? this._getFirstTabbableElement(e[a]) : null;
          if (i) return i;
        }
        return null;
      }
      _getLastTabbableElement(t) {
        if (this._checker.isFocusable(t) && this._checker.isTabbable(t)) return t;
        const e = t.children;
        for (let a = e.length - 1; a >= 0; a--) {
          const i = e[a].nodeType === this._document.ELEMENT_NODE ? this._getLastTabbableElement(e[a]) : null;
          if (i) return i;
        }
        return null;
      }
      _createAnchor() {
        const t = this._document.createElement("div");
        return this._toggleAnchorTabIndex(this._enabled, t), t.classList.add("cdk-visually-hidden"), t.classList.add("cdk-focus-trap-anchor"), t.setAttribute("aria-hidden", "true"), t;
      }
      _toggleAnchorTabIndex(t, e) {
        t ? e.setAttribute("tabindex", "0") : e.removeAttribute("tabindex");
      }
      toggleAnchors(t) {
        this._startAnchor && this._endAnchor && (this._toggleAnchorTabIndex(t, this._startAnchor), this._toggleAnchorTabIndex(t, this._endAnchor));
      }
      _executeOnStable(t) {
        this._ngZone.isStable ? t() : this._ngZone.onStable.pipe($e(1)).subscribe(t);
      }
    }
    let M2 = (() => {
        class n {
          constructor(e, a, i) {
            this._checker = e, this._ngZone = a, this._document = i;
          }
          create(e, a = !1) {
            return new QH(e, this._checker, this._ngZone, this._document, a);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(C2), M(ae), M(ie));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      ZH = (() => {
        class n {
          constructor(e, a, i) {
            this._elementRef = e, this._focusTrapFactory = a, this._previouslyFocusedElement = null, this.focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement, !0);
          }
          get enabled() {
            return this.focusTrap.enabled;
          }
          set enabled(e) {
            this.focusTrap.enabled = Y(e);
          }
          get autoCapture() {
            return this._autoCapture;
          }
          set autoCapture(e) {
            this._autoCapture = Y(e);
          }
          ngOnDestroy() {
            this.focusTrap.destroy(), this._previouslyFocusedElement && (this._previouslyFocusedElement.focus(), this._previouslyFocusedElement = null);
          }
          ngAfterContentInit() {
            this.focusTrap.attachAnchors(), this.autoCapture && this._captureFocus();
          }
          ngDoCheck() {
            this.focusTrap.hasAttached() || this.focusTrap.attachAnchors();
          }
          ngOnChanges(e) {
            const a = e.autoCapture;
            a && !a.firstChange && this.autoCapture && this.focusTrap.hasAttached() && this._captureFocus();
          }
          _captureFocus() {
            this._previouslyFocusedElement = Fc(), this.focusTrap.focusInitialElementWhenReady();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(M2), f(ie));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "cdkTrapFocus", ""]],
          inputs: {
            enabled: ["cdkTrapFocus", "enabled"],
            autoCapture: ["cdkTrapFocusAutoCapture", "autoCapture"]
          },
          exportAs: ["cdkTrapFocus"],
          features: [Ve]
        }), n;
      })();
    function up(n) {
      return 0 === n.buttons || 0 === n.offsetX && 0 === n.offsetY;
    }
    function fp(n) {
      const t = n.touches && n.touches[0] || n.changedTouches && n.changedTouches[0];
      return !(!t || -1 !== t.identifier || null != t.radiusX && 1 !== t.radiusX || null != t.radiusY && 1 !== t.radiusY);
    }
    const XH = new O("cdk-input-modality-detector-options"),
      JH = {
        ignoreKeys: [18, 17, 224, 91, 16]
      },
      cs = ka({
        passive: !0,
        capture: !0
      });
    let $H = (() => {
      class n {
        constructor(e, a, i, o) {
          this._platform = e, this._mostRecentTarget = null, this._modality = new Xi(null), this._lastTouchMs = 0, this._onKeydown = r => {
            this._options?.ignoreKeys?.some(s => s === r.keyCode) || (this._modality.next("keyboard"), this._mostRecentTarget = aa(r));
          }, this._onMousedown = r => {
            Date.now() - this._lastTouchMs < 650 || (this._modality.next(up(r) ? "keyboard" : "mouse"), this._mostRecentTarget = aa(r));
          }, this._onTouchstart = r => {
            fp(r) ? this._modality.next("keyboard") : (this._lastTouchMs = Date.now(), this._modality.next("touch"), this._mostRecentTarget = aa(r));
          }, this._options = {
            ...JH,
            ...o
          }, this.modalityDetected = this._modality.pipe(Rv(1)), this.modalityChanged = this.modalityDetected.pipe(rp()), e.isBrowser && a.runOutsideAngular(() => {
            i.addEventListener("keydown", this._onKeydown, cs), i.addEventListener("mousedown", this._onMousedown, cs), i.addEventListener("touchstart", this._onTouchstart, cs);
          });
        }
        get mostRecentModality() {
          return this._modality.value;
        }
        ngOnDestroy() {
          this._modality.complete(), this._platform.isBrowser && (document.removeEventListener("keydown", this._onKeydown, cs), document.removeEventListener("mousedown", this._onMousedown, cs), document.removeEventListener("touchstart", this._onTouchstart, cs));
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(Ct), M(ae), M(ie), M(XH, 8));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac,
        providedIn: "root"
      }), n;
    })();
    const eB = new O("liveAnnouncerElement", {
        providedIn: "root",
        factory: function tB() {
          return null;
        }
      }),
      nB = new O("LIVE_ANNOUNCER_DEFAULT_OPTIONS");
    let Qv = (() => {
      class n {
        constructor(e, a, i, o) {
          this._ngZone = a, this._defaultOptions = o, this._document = i, this._liveElement = e || this._createLiveElement();
        }
        announce(e, ...a) {
          const i = this._defaultOptions;
          let o, r;
          return 1 === a.length && "number" == typeof a[0] ? r = a[0] : [o, r] = a, this.clear(), clearTimeout(this._previousTimeout), o || (o = i && i.politeness ? i.politeness : "polite"), null == r && i && (r = i.duration), this._liveElement.setAttribute("aria-live", o), this._ngZone.runOutsideAngular(() => (this._currentPromise || (this._currentPromise = new Promise(s => this._currentResolve = s)), clearTimeout(this._previousTimeout), this._previousTimeout = setTimeout(() => {
            this._liveElement.textContent = e, "number" == typeof r && (this._previousTimeout = setTimeout(() => this.clear(), r)), this._currentResolve(), this._currentPromise = this._currentResolve = void 0;
          }, 100), this._currentPromise));
        }
        clear() {
          this._liveElement && (this._liveElement.textContent = "");
        }
        ngOnDestroy() {
          clearTimeout(this._previousTimeout), this._liveElement?.remove(), this._liveElement = null, this._currentResolve?.(), this._currentPromise = this._currentResolve = void 0;
        }
        _createLiveElement() {
          const e = "cdk-live-announcer-element",
            a = this._document.getElementsByClassName(e),
            i = this._document.createElement("div");
          for (let o = 0; o < a.length; o++) a[o].remove();
          return i.classList.add(e), i.classList.add("cdk-visually-hidden"), i.setAttribute("aria-atomic", "true"), i.setAttribute("aria-live", "polite"), this._document.body.appendChild(i), i;
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(eB, 8), M(ae), M(ie), M(nB, 8));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac,
        providedIn: "root"
      }), n;
    })();
    const aB = new O("cdk-focus-monitor-default-options"),
      x2 = ka({
        passive: !0,
        capture: !0
      });
    let Hn = (() => {
        class n {
          constructor(e, a, i, o, r) {
            this._ngZone = e, this._platform = a, this._inputModalityDetector = i, this._origin = null, this._windowFocused = !1, this._originFromTouchInteraction = !1, this._elementInfo = new Map(), this._monitoredElementCount = 0, this._rootNodeFocusListenerCount = new Map(), this._windowFocusListener = () => {
              this._windowFocused = !0, this._windowFocusTimeoutId = window.setTimeout(() => this._windowFocused = !1);
            }, this._stopInputModalityDetector = new V(), this._rootNodeFocusAndBlurListener = s => {
              for (let l = aa(s); l; l = l.parentElement) "focus" === s.type ? this._onFocus(s, l) : this._onBlur(s, l);
            }, this._document = o, this._detectionMode = r?.detectionMode || 0;
          }
          monitor(e, a = !1) {
            const i = wt(e);
            if (!this._platform.isBrowser || 1 !== i.nodeType) return nt(null);
            const o = Kd(i) || this._getDocument(),
              r = this._elementInfo.get(i);
            if (r) return a && (r.checkChildren = !0), r.subject;
            const s = {
              checkChildren: a,
              subject: new V(),
              rootNode: o
            };
            return this._elementInfo.set(i, s), this._registerGlobalListeners(s), s.subject;
          }
          stopMonitoring(e) {
            const a = wt(e),
              i = this._elementInfo.get(a);
            i && (i.subject.complete(), this._setClasses(a), this._elementInfo.delete(a), this._removeGlobalListeners(i));
          }
          focusVia(e, a, i) {
            const o = wt(e);
            o === this._getDocument().activeElement ? this._getClosestElementsInfo(o).forEach(([s, c]) => this._originChanged(s, a, c)) : (this._setOrigin(a), "function" == typeof o.focus && o.focus(i));
          }
          ngOnDestroy() {
            this._elementInfo.forEach((e, a) => this.stopMonitoring(a));
          }
          _getDocument() {
            return this._document || document;
          }
          _getWindow() {
            return this._getDocument().defaultView || window;
          }
          _getFocusOrigin(e) {
            return this._origin ? this._originFromTouchInteraction ? this._shouldBeAttributedToTouch(e) ? "touch" : "program" : this._origin : this._windowFocused && this._lastFocusOrigin ? this._lastFocusOrigin : e && this._isLastInteractionFromInputLabel(e) ? "mouse" : "program";
          }
          _shouldBeAttributedToTouch(e) {
            return 1 === this._detectionMode || !!e?.contains(this._inputModalityDetector._mostRecentTarget);
          }
          _setClasses(e, a) {
            e.classList.toggle("cdk-focused", !!a), e.classList.toggle("cdk-touch-focused", "touch" === a), e.classList.toggle("cdk-keyboard-focused", "keyboard" === a), e.classList.toggle("cdk-mouse-focused", "mouse" === a), e.classList.toggle("cdk-program-focused", "program" === a);
          }
          _setOrigin(e, a = !1) {
            this._ngZone.runOutsideAngular(() => {
              this._origin = e, this._originFromTouchInteraction = "touch" === e && a, 0 === this._detectionMode && (clearTimeout(this._originTimeoutId), this._originTimeoutId = setTimeout(() => this._origin = null, this._originFromTouchInteraction ? 650 : 1));
            });
          }
          _onFocus(e, a) {
            const i = this._elementInfo.get(a),
              o = aa(e);
            !i || !i.checkChildren && a !== o || this._originChanged(a, this._getFocusOrigin(o), i);
          }
          _onBlur(e, a) {
            const i = this._elementInfo.get(a);
            !i || i.checkChildren && e.relatedTarget instanceof Node && a.contains(e.relatedTarget) || (this._setClasses(a), this._emitOrigin(i, null));
          }
          _emitOrigin(e, a) {
            e.subject.observers.length && this._ngZone.run(() => e.subject.next(a));
          }
          _registerGlobalListeners(e) {
            if (!this._platform.isBrowser) return;
            const a = e.rootNode,
              i = this._rootNodeFocusListenerCount.get(a) || 0;
            i || this._ngZone.runOutsideAngular(() => {
              a.addEventListener("focus", this._rootNodeFocusAndBlurListener, x2), a.addEventListener("blur", this._rootNodeFocusAndBlurListener, x2);
            }), this._rootNodeFocusListenerCount.set(a, i + 1), 1 == ++this._monitoredElementCount && (this._ngZone.runOutsideAngular(() => {
              this._getWindow().addEventListener("focus", this._windowFocusListener);
            }), this._inputModalityDetector.modalityDetected.pipe(ne(this._stopInputModalityDetector)).subscribe(o => {
              this._setOrigin(o, !0);
            }));
          }
          _removeGlobalListeners(e) {
            const a = e.rootNode;
            if (this._rootNodeFocusListenerCount.has(a)) {
              const i = this._rootNodeFocusListenerCount.get(a);
              i > 1 ? this._rootNodeFocusListenerCount.set(a, i - 1) : (a.removeEventListener("focus", this._rootNodeFocusAndBlurListener, x2), a.removeEventListener("blur", this._rootNodeFocusAndBlurListener, x2), this._rootNodeFocusListenerCount.delete(a));
            }
            --this._monitoredElementCount || (this._getWindow().removeEventListener("focus", this._windowFocusListener), this._stopInputModalityDetector.next(), clearTimeout(this._windowFocusTimeoutId), clearTimeout(this._originTimeoutId));
          }
          _originChanged(e, a, i) {
            this._setClasses(e, a), this._emitOrigin(i, a), this._lastFocusOrigin = a;
          }
          _getClosestElementsInfo(e) {
            const a = [];
            return this._elementInfo.forEach((i, o) => {
              (o === e || i.checkChildren && o.contains(e)) && a.push([o, i]);
            }), a;
          }
          _isLastInteractionFromInputLabel(e) {
            const {
              _mostRecentTarget: a,
              mostRecentModality: i
            } = this._inputModalityDetector;
            if ("mouse" !== i || !a || a === e || "INPUT" !== e.nodeName && "TEXTAREA" !== e.nodeName || e.disabled) return !1;
            const o = e.labels;
            if (o) for (let r = 0; r < o.length; r++) if (o[r].contains(a)) return !0;
            return !1;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(ae), M(Ct), M($H), M(ie, 8), M(aB, 8));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      iB = (() => {
        class n {
          constructor(e, a) {
            this._elementRef = e, this._focusMonitor = a, this._focusOrigin = null, this.cdkFocusChange = new E();
          }
          get focusOrigin() {
            return this._focusOrigin;
          }
          ngAfterViewInit() {
            const e = this._elementRef.nativeElement;
            this._monitorSubscription = this._focusMonitor.monitor(e, 1 === e.nodeType && e.hasAttribute("cdkMonitorSubtreeFocus")).subscribe(a => {
              this._focusOrigin = a, this.cdkFocusChange.emit(a);
            });
          }
          ngOnDestroy() {
            this._focusMonitor.stopMonitoring(this._elementRef), this._monitorSubscription && this._monitorSubscription.unsubscribe();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(Hn));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "cdkMonitorElementFocus", ""], ["", "cdkMonitorSubtreeFocus", ""]],
          outputs: {
            cdkFocusChange: "cdkFocusChange"
          },
          exportAs: ["cdkMonitorFocus"]
        }), n;
      })();
    const Zv = "cdk-high-contrast-black-on-white",
      Xv = "cdk-high-contrast-white-on-black",
      mp = "cdk-high-contrast-active";
    let Jv = (() => {
        class n {
          constructor(e, a) {
            this._platform = e, this._document = a, this._breakpointSubscription = La(Vv).observe("(forced-colors: active)").subscribe(() => {
              this._hasCheckedHighContrastMode && (this._hasCheckedHighContrastMode = !1, this._applyBodyHighContrastModeCssClasses());
            });
          }
          getHighContrastMode() {
            if (!this._platform.isBrowser) return 0;
            const e = this._document.createElement("div");
            e.style.backgroundColor = "rgb(1,2,3)", e.style.position = "absolute", this._document.body.appendChild(e);
            const a = this._document.defaultView || window,
              i = a && a.getComputedStyle ? a.getComputedStyle(e) : null,
              o = (i && i.backgroundColor || "").replace(/ /g, "");
            switch (e.remove(), o) {
              case "rgb(0,0,0)":
              case "rgb(45,50,54)":
              case "rgb(32,32,32)":
                return 2;
              case "rgb(255,255,255)":
              case "rgb(255,250,239)":
                return 1;
            }
            return 0;
          }
          ngOnDestroy() {
            this._breakpointSubscription.unsubscribe();
          }
          _applyBodyHighContrastModeCssClasses() {
            if (!this._hasCheckedHighContrastMode && this._platform.isBrowser && this._document.body) {
              const e = this._document.body.classList;
              e.remove(mp, Zv, Xv), this._hasCheckedHighContrastMode = !0;
              const a = this.getHighContrastMode();
              1 === a ? e.add(mp, Zv) : 2 === a && e.add(mp, Xv);
            }
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(Ct), M(ie));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      Xc = (() => {
        class n {
          constructor(e) {
            e._applyBodyHighContrastModeCssClasses();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(Jv));
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [Zc]
        }), n;
      })();
    function oB(n, t) {
      if (1 & n && j(0, "mat-pseudo-checkbox", 4), 2 & n) {
        const e = x();
        b("state", e.selected ? "checked" : "unchecked")("disabled", e.disabled);
      }
    }
    function rB(n, t) {
      if (1 & n && (_(0, "span", 5), S(1), y()), 2 & n) {
        const e = x();
        g(1), Fe("(", e.group.label, ")");
      }
    }
    const sB = ["*"],
      lB = new O("mat-sanity-checks", {
        providedIn: "root",
        factory: function cB() {
          return !0;
        }
      });
    let $ = (() => {
      class n {
        constructor(e, a, i) {
          this._sanityChecks = a, this._document = i, this._hasDoneGlobalChecks = !1, e._applyBodyHighContrastModeCssClasses(), this._hasDoneGlobalChecks || (this._hasDoneGlobalChecks = !0);
        }
        _checkIsEnabled(e) {
          return !Eh() && ("boolean" == typeof this._sanityChecks ? this._sanityChecks : !!this._sanityChecks[e]);
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(Jv), M(lB, 8), M(ie));
      }, n.ɵmod = W({
        type: n
      }), n.ɵinj = U({
        imports: [Jr, Jr]
      }), n;
    })();
    function Fo(n) {
      return class extends n {
        constructor(...t) {
          super(...t), this._disabled = !1;
        }
        get disabled() {
          return this._disabled;
        }
        set disabled(t) {
          this._disabled = Y(t);
        }
      };
    }
    function Qa(n, t) {
      return class extends n {
        constructor(...e) {
          super(...e), this.defaultColor = t, this.color = t;
        }
        get color() {
          return this._color;
        }
        set color(e) {
          const a = e || this.defaultColor;
          a !== this._color && (this._color && this._elementRef.nativeElement.classList.remove(`mat-${this._color}`), a && this._elementRef.nativeElement.classList.add(`mat-${a}`), this._color = a);
        }
      };
    }
    function Za(n) {
      return class extends n {
        constructor(...t) {
          super(...t), this._disableRipple = !1;
        }
        get disableRipple() {
          return this._disableRipple;
        }
        set disableRipple(t) {
          this._disableRipple = Y(t);
        }
      };
    }
    function $i(n, t = 0) {
      return class extends n {
        constructor(...e) {
          super(...e), this._tabIndex = t, this.defaultTabIndex = t;
        }
        get tabIndex() {
          return this.disabled ? -1 : this._tabIndex;
        }
        set tabIndex(e) {
          this._tabIndex = null != e ? xt(e) : this.defaultTabIndex;
        }
      };
    }
    function gp(n) {
      return class extends n {
        constructor(...t) {
          super(...t), this.errorState = !1;
        }
        updateErrorState() {
          const t = this.errorState,
            o = (this.errorStateMatcher || this._defaultErrorStateMatcher).isErrorState(this.ngControl ? this.ngControl.control : null, this._parentFormGroup || this._parentForm);
          o !== t && (this.errorState = o, this.stateChanges.next());
        }
      };
    }
    function dB(n) {
      return class extends n {
        constructor(...t) {
          super(...t), this._isInitialized = !1, this._pendingSubscribers = [], this.initialized = new Be(e => {
            this._isInitialized ? this._notifySubscriber(e) : this._pendingSubscribers.push(e);
          });
        }
        _markInitialized() {
          this._isInitialized = !0, this._pendingSubscribers.forEach(this._notifySubscriber), this._pendingSubscribers = null;
        }
        _notifySubscriber(t) {
          t.next(), t.complete();
        }
      };
    }
    const uB = new O("MAT_DATE_LOCALE", {
      providedIn: "root",
      factory: function fB() {
        return La(ja);
      }
    });
    class Qt {
      constructor() {
        this._localeChanges = new V(), this.localeChanges = this._localeChanges;
      }
      getValidDateOrNull(t) {
        return this.isDateInstance(t) && this.isValid(t) ? t : null;
      }
      deserialize(t) {
        return null == t || this.isDateInstance(t) && this.isValid(t) ? t : this.invalid();
      }
      setLocale(t) {
        this.locale = t, this._localeChanges.next();
      }
      compareDate(t, e) {
        return this.getYear(t) - this.getYear(e) || this.getMonth(t) - this.getMonth(e) || this.getDate(t) - this.getDate(e);
      }
      sameDate(t, e) {
        if (t && e) {
          let a = this.isValid(t),
            i = this.isValid(e);
          return a && i ? !this.compareDate(t, e) : a == i;
        }
        return t == e;
      }
      clampDate(t, e, a) {
        return e && this.compareDate(t, e) < 0 ? e : a && this.compareDate(t, a) > 0 ? a : t;
      }
    }
    const Vo = new O("mat-date-formats"),
      mB = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|(?:(?:\+|-)\d{2}:\d{2}))?)?$/;
    function bp(n, t) {
      const e = Array(n);
      for (let a = 0; a < n; a++) e[a] = t(a);
      return e;
    }
    let hB = (() => {
      class n extends Qt {
        constructor(e, a) {
          super(), this.useUtcForDisplay = !1, super.setLocale(e);
        }
        getYear(e) {
          return e.getFullYear();
        }
        getMonth(e) {
          return e.getMonth();
        }
        getDate(e) {
          return e.getDate();
        }
        getDayOfWeek(e) {
          return e.getDay();
        }
        getMonthNames(e) {
          const a = new Intl.DateTimeFormat(this.locale, {
            month: e,
            timeZone: "utc"
          });
          return bp(12, i => this._format(a, new Date(2017, i, 1)));
        }
        getDateNames() {
          const e = new Intl.DateTimeFormat(this.locale, {
            day: "numeric",
            timeZone: "utc"
          });
          return bp(31, a => this._format(e, new Date(2017, 0, a + 1)));
        }
        getDayOfWeekNames(e) {
          const a = new Intl.DateTimeFormat(this.locale, {
            weekday: e,
            timeZone: "utc"
          });
          return bp(7, i => this._format(a, new Date(2017, 0, i + 1)));
        }
        getYearName(e) {
          const a = new Intl.DateTimeFormat(this.locale, {
            year: "numeric",
            timeZone: "utc"
          });
          return this._format(a, e);
        }
        getFirstDayOfWeek() {
          return 0;
        }
        getNumDaysInMonth(e) {
          return this.getDate(this._createDateWithOverflow(this.getYear(e), this.getMonth(e) + 1, 0));
        }
        clone(e) {
          return new Date(e.getTime());
        }
        createDate(e, a, i) {
          let o = this._createDateWithOverflow(e, a, i);
          return o.getMonth(), o;
        }
        today() {
          return new Date();
        }
        parse(e, a) {
          return "number" == typeof e ? new Date(e) : e ? new Date(Date.parse(e)) : null;
        }
        format(e, a) {
          if (!this.isValid(e)) throw Error("NativeDateAdapter: Cannot format invalid date.");
          const i = new Intl.DateTimeFormat(this.locale, {
            ...a,
            timeZone: "utc"
          });
          return this._format(i, e);
        }
        addCalendarYears(e, a) {
          return this.addCalendarMonths(e, 12 * a);
        }
        addCalendarMonths(e, a) {
          let i = this._createDateWithOverflow(this.getYear(e), this.getMonth(e) + a, this.getDate(e));
          return this.getMonth(i) != ((this.getMonth(e) + a) % 12 + 12) % 12 && (i = this._createDateWithOverflow(this.getYear(i), this.getMonth(i), 0)), i;
        }
        addCalendarDays(e, a) {
          return this._createDateWithOverflow(this.getYear(e), this.getMonth(e), this.getDate(e) + a);
        }
        toIso8601(e) {
          return [e.getUTCFullYear(), this._2digit(e.getUTCMonth() + 1), this._2digit(e.getUTCDate())].join("-");
        }
        deserialize(e) {
          if ("string" == typeof e) {
            if (!e) return null;
            if (mB.test(e)) {
              let a = new Date(e);
              if (this.isValid(a)) return a;
            }
          }
          return super.deserialize(e);
        }
        isDateInstance(e) {
          return e instanceof Date;
        }
        isValid(e) {
          return !isNaN(e.getTime());
        }
        invalid() {
          return new Date(NaN);
        }
        _createDateWithOverflow(e, a, i) {
          const o = new Date();
          return o.setFullYear(e, a, i), o.setHours(0, 0, 0, 0), o;
        }
        _2digit(e) {
          return ("00" + e).slice(-2);
        }
        _format(e, a) {
          const i = new Date();
          return i.setUTCFullYear(a.getFullYear(), a.getMonth(), a.getDate()), i.setUTCHours(a.getHours(), a.getMinutes(), a.getSeconds(), a.getMilliseconds()), e.format(i);
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(uB, 8), M(Ct));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac
      }), n;
    })();
    const pB = {
      parse: {
        dateInput: null
      },
      display: {
        dateInput: {
          year: "numeric",
          month: "numeric",
          day: "numeric"
        },
        monthYearLabel: {
          year: "numeric",
          month: "short"
        },
        dateA11yLabel: {
          year: "numeric",
          month: "long",
          day: "numeric"
        },
        monthYearA11yLabel: {
          year: "numeric",
          month: "long"
        }
      }
    };
    let gB = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [{
            provide: Qt,
            useClass: hB
          }]
        }), n;
      })(),
      _p = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [{
            provide: Vo,
            useValue: pB
          }],
          imports: [gB]
        }), n;
      })(),
      ls = (() => {
        class n {
          isErrorState(e, a) {
            return !!(e && e.invalid && (e.touched || a && a.submitted));
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      bB = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "mat-line", ""], ["", "matLine", ""]],
          hostAttrs: [1, "mat-line"]
        }), n;
      })();
    function Jc(n, t, e) {
      n.nativeElement.classList.toggle(t, e);
    }
    let w2 = (() => {
      class n {}
      return n.ɵfac = function (e) {
        return new (e || n)();
      }, n.ɵmod = W({
        type: n
      }), n.ɵinj = U({
        imports: [$, $]
      }), n;
    })();
    class vB {
      constructor(t, e, a, i = !1) {
        this._renderer = t, this.element = e, this.config = a, this._animationForciblyDisabledThroughCss = i, this.state = 3;
      }
      fadeOut() {
        this._renderer.fadeOutRipple(this);
      }
    }
    const ty = {
        enterDuration: 225,
        exitDuration: 150
      },
      vp = ka({
        passive: !0
      }),
      ny = ["mousedown", "touchstart"],
      ay = ["mouseup", "mouseleave", "touchend", "touchcancel"];
    class iy {
      constructor(t, e, a, i) {
        this._target = t, this._ngZone = e, this._isPointerDown = !1, this._activeRipples = new Map(), this._pointerUpEventsRegistered = !1, i.isBrowser && (this._containerElement = wt(a));
      }
      fadeInRipple(t, e, a = {}) {
        const i = this._containerRect = this._containerRect || this._containerElement.getBoundingClientRect(),
          o = {
            ...ty,
            ...a.animation
          };
        a.centered && (t = i.left + i.width / 2, e = i.top + i.height / 2);
        const r = a.radius || function CB(n, t, e) {
            const a = Math.max(Math.abs(n - e.left), Math.abs(n - e.right)),
              i = Math.max(Math.abs(t - e.top), Math.abs(t - e.bottom));
            return Math.sqrt(a * a + i * i);
          }(t, e, i),
          s = t - i.left,
          c = e - i.top,
          l = o.enterDuration,
          d = document.createElement("div");
        d.classList.add("mat-ripple-element"), d.style.left = s - r + "px", d.style.top = c - r + "px", d.style.height = 2 * r + "px", d.style.width = 2 * r + "px", null != a.color && (d.style.backgroundColor = a.color), d.style.transitionDuration = `${l}ms`, this._containerElement.appendChild(d);
        const u = window.getComputedStyle(d),
          h = u.transitionDuration,
          p = "none" === u.transitionProperty || "0s" === h || "0s, 0s" === h,
          v = new vB(this, d, a, p);
        d.style.transform = "scale3d(1, 1, 1)", v.state = 0, a.persistent || (this._mostRecentTransientRipple = v);
        let C = null;
        return !p && (l || o.exitDuration) && this._ngZone.runOutsideAngular(() => {
          const k = () => this._finishRippleTransition(v),
            T = () => this._destroyRipple(v);
          d.addEventListener("transitionend", k), d.addEventListener("transitioncancel", T), C = {
            onTransitionEnd: k,
            onTransitionCancel: T
          };
        }), this._activeRipples.set(v, C), (p || !l) && this._finishRippleTransition(v), v;
      }
      fadeOutRipple(t) {
        if (2 === t.state || 3 === t.state) return;
        const e = t.element,
          a = {
            ...ty,
            ...t.config.animation
          };
        e.style.transitionDuration = `${a.exitDuration}ms`, e.style.opacity = "0", t.state = 2, (t._animationForciblyDisabledThroughCss || !a.exitDuration) && this._finishRippleTransition(t);
      }
      fadeOutAll() {
        this._getActiveRipples().forEach(t => t.fadeOut());
      }
      fadeOutAllNonPersistent() {
        this._getActiveRipples().forEach(t => {
          t.config.persistent || t.fadeOut();
        });
      }
      setupTriggerEvents(t) {
        const e = wt(t);
        !e || e === this._triggerElement || (this._removeTriggerEvents(), this._triggerElement = e, this._registerEvents(ny));
      }
      handleEvent(t) {
        "mousedown" === t.type ? this._onMousedown(t) : "touchstart" === t.type ? this._onTouchStart(t) : this._onPointerUp(), this._pointerUpEventsRegistered || (this._registerEvents(ay), this._pointerUpEventsRegistered = !0);
      }
      _finishRippleTransition(t) {
        0 === t.state ? this._startFadeOutTransition(t) : 2 === t.state && this._destroyRipple(t);
      }
      _startFadeOutTransition(t) {
        const e = t === this._mostRecentTransientRipple,
          {
            persistent: a
          } = t.config;
        t.state = 1, !a && (!e || !this._isPointerDown) && t.fadeOut();
      }
      _destroyRipple(t) {
        const e = this._activeRipples.get(t) ?? null;
        this._activeRipples.delete(t), this._activeRipples.size || (this._containerRect = null), t === this._mostRecentTransientRipple && (this._mostRecentTransientRipple = null), t.state = 3, null !== e && (t.element.removeEventListener("transitionend", e.onTransitionEnd), t.element.removeEventListener("transitioncancel", e.onTransitionCancel)), t.element.remove();
      }
      _onMousedown(t) {
        const e = up(t),
          a = this._lastTouchStartEvent && Date.now() < this._lastTouchStartEvent + 800;
        !this._target.rippleDisabled && !e && !a && (this._isPointerDown = !0, this.fadeInRipple(t.clientX, t.clientY, this._target.rippleConfig));
      }
      _onTouchStart(t) {
        if (!this._target.rippleDisabled && !fp(t)) {
          this._lastTouchStartEvent = Date.now(), this._isPointerDown = !0;
          const e = t.changedTouches;
          for (let a = 0; a < e.length; a++) this.fadeInRipple(e[a].clientX, e[a].clientY, this._target.rippleConfig);
        }
      }
      _onPointerUp() {
        !this._isPointerDown || (this._isPointerDown = !1, this._getActiveRipples().forEach(t => {
          !t.config.persistent && (1 === t.state || t.config.terminateOnPointerUp && 0 === t.state) && t.fadeOut();
        }));
      }
      _registerEvents(t) {
        this._ngZone.runOutsideAngular(() => {
          t.forEach(e => {
            this._triggerElement.addEventListener(e, this, vp);
          });
        });
      }
      _getActiveRipples() {
        return Array.from(this._activeRipples.keys());
      }
      _removeTriggerEvents() {
        this._triggerElement && (ny.forEach(t => {
          this._triggerElement.removeEventListener(t, this, vp);
        }), this._pointerUpEventsRegistered && ay.forEach(t => {
          this._triggerElement.removeEventListener(t, this, vp);
        }));
      }
    }
    const oy = new O("mat-ripple-global-options");
    let Xa = (() => {
        class n {
          constructor(e, a, i, o, r) {
            this._elementRef = e, this._animationMode = r, this.radius = 0, this._disabled = !1, this._isInitialized = !1, this._globalOptions = o || {}, this._rippleRenderer = new iy(this, a, e, i);
          }
          get disabled() {
            return this._disabled;
          }
          set disabled(e) {
            e && this.fadeOutAllNonPersistent(), this._disabled = e, this._setupTriggerEventsIfEnabled();
          }
          get trigger() {
            return this._trigger || this._elementRef.nativeElement;
          }
          set trigger(e) {
            this._trigger = e, this._setupTriggerEventsIfEnabled();
          }
          ngOnInit() {
            this._isInitialized = !0, this._setupTriggerEventsIfEnabled();
          }
          ngOnDestroy() {
            this._rippleRenderer._removeTriggerEvents();
          }
          fadeOutAll() {
            this._rippleRenderer.fadeOutAll();
          }
          fadeOutAllNonPersistent() {
            this._rippleRenderer.fadeOutAllNonPersistent();
          }
          get rippleConfig() {
            return {
              centered: this.centered,
              radius: this.radius,
              color: this.color,
              animation: {
                ...this._globalOptions.animation,
                ...("NoopAnimations" === this._animationMode ? {
                  enterDuration: 0,
                  exitDuration: 0
                } : {}),
                ...this.animation
              },
              terminateOnPointerUp: this._globalOptions.terminateOnPointerUp
            };
          }
          get rippleDisabled() {
            return this.disabled || !!this._globalOptions.disabled;
          }
          _setupTriggerEventsIfEnabled() {
            !this.disabled && this._isInitialized && this._rippleRenderer.setupTriggerEvents(this.trigger);
          }
          launch(e, a = 0, i) {
            return "number" == typeof e ? this._rippleRenderer.fadeInRipple(e, a, {
              ...this.rippleConfig,
              ...i
            }) : this._rippleRenderer.fadeInRipple(0, 0, {
              ...this.rippleConfig,
              ...e
            });
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(ae), f(Ct), f(oy, 8), f(Ft, 8));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "mat-ripple", ""], ["", "matRipple", ""]],
          hostAttrs: [1, "mat-ripple"],
          hostVars: 2,
          hostBindings: function (e, a) {
            2 & e && fe("mat-ripple-unbounded", a.unbounded);
          },
          inputs: {
            color: ["matRippleColor", "color"],
            unbounded: ["matRippleUnbounded", "unbounded"],
            centered: ["matRippleCentered", "centered"],
            radius: ["matRippleRadius", "radius"],
            animation: ["matRippleAnimation", "animation"],
            disabled: ["matRippleDisabled", "disabled"],
            trigger: ["matRippleTrigger", "trigger"]
          },
          exportAs: ["matRipple"]
        }), n;
      })(),
      sa = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [$, $]
        }), n;
      })(),
      ry = (() => {
        class n {
          constructor(e) {
            this._animationMode = e, this.state = "unchecked", this.disabled = !1;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Ft, 8));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-pseudo-checkbox"]],
          hostAttrs: [1, "mat-pseudo-checkbox"],
          hostVars: 8,
          hostBindings: function (e, a) {
            2 & e && fe("mat-pseudo-checkbox-indeterminate", "indeterminate" === a.state)("mat-pseudo-checkbox-checked", "checked" === a.state)("mat-pseudo-checkbox-disabled", a.disabled)("_mat-animation-noopable", "NoopAnimations" === a._animationMode);
          },
          inputs: {
            state: "state",
            disabled: "disabled"
          },
          decls: 0,
          vars: 0,
          template: function (e, a) {},
          styles: ['.mat-pseudo-checkbox{width:16px;height:16px;border:2px solid;border-radius:2px;cursor:pointer;display:inline-block;vertical-align:middle;box-sizing:border-box;position:relative;flex-shrink:0;transition:border-color 90ms cubic-bezier(0, 0, 0.2, 0.1),background-color 90ms cubic-bezier(0, 0, 0.2, 0.1)}.mat-pseudo-checkbox::after{position:absolute;opacity:0;content:"";border-bottom:2px solid currentColor;transition:opacity 90ms cubic-bezier(0, 0, 0.2, 0.1)}.mat-pseudo-checkbox.mat-pseudo-checkbox-checked,.mat-pseudo-checkbox.mat-pseudo-checkbox-indeterminate{border-color:rgba(0,0,0,0)}.mat-pseudo-checkbox._mat-animation-noopable{transition:none !important;animation:none !important}.mat-pseudo-checkbox._mat-animation-noopable::after{transition:none}.mat-pseudo-checkbox-disabled{cursor:default}.mat-pseudo-checkbox-indeterminate::after{top:5px;left:1px;width:10px;opacity:1;border-radius:2px}.mat-pseudo-checkbox-checked::after{top:2.4px;left:1px;width:8px;height:3px;border-left:2px solid currentColor;transform:rotate(-45deg);opacity:1;box-sizing:content-box}'],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })(),
      yp = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [$]
        }), n;
      })();
    const Cp = new O("MAT_OPTION_PARENT_COMPONENT"),
      Mp = new O("MatOptgroup");
    let MB = 0;
    class sy {
      constructor(t, e = !1) {
        this.source = t, this.isUserInput = e;
      }
    }
    let xB = (() => {
        class n {
          constructor(e, a, i, o) {
            this._element = e, this._changeDetectorRef = a, this._parent = i, this.group = o, this._selected = !1, this._active = !1, this._disabled = !1, this._mostRecentViewValue = "", this.id = "mat-option-" + MB++, this.onSelectionChange = new E(), this._stateChanges = new V();
          }
          get multiple() {
            return this._parent && this._parent.multiple;
          }
          get selected() {
            return this._selected;
          }
          get disabled() {
            return this.group && this.group.disabled || this._disabled;
          }
          set disabled(e) {
            this._disabled = Y(e);
          }
          get disableRipple() {
            return !(!this._parent || !this._parent.disableRipple);
          }
          get active() {
            return this._active;
          }
          get viewValue() {
            return (this._getHostElement().textContent || "").trim();
          }
          select() {
            this._selected || (this._selected = !0, this._changeDetectorRef.markForCheck(), this._emitSelectionChangeEvent());
          }
          deselect() {
            this._selected && (this._selected = !1, this._changeDetectorRef.markForCheck(), this._emitSelectionChangeEvent());
          }
          focus(e, a) {
            const i = this._getHostElement();
            "function" == typeof i.focus && i.focus(a);
          }
          setActiveStyles() {
            this._active || (this._active = !0, this._changeDetectorRef.markForCheck());
          }
          setInactiveStyles() {
            this._active && (this._active = !1, this._changeDetectorRef.markForCheck());
          }
          getLabel() {
            return this.viewValue;
          }
          _handleKeydown(e) {
            (13 === e.keyCode || 32 === e.keyCode) && !Et(e) && (this._selectViaInteraction(), e.preventDefault());
          }
          _selectViaInteraction() {
            this.disabled || (this._selected = !this.multiple || !this._selected, this._changeDetectorRef.markForCheck(), this._emitSelectionChangeEvent(!0));
          }
          _getAriaSelected() {
            return this.selected || !this.multiple && null;
          }
          _getTabIndex() {
            return this.disabled ? "-1" : "0";
          }
          _getHostElement() {
            return this._element.nativeElement;
          }
          ngAfterViewChecked() {
            if (this._selected) {
              const e = this.viewValue;
              e !== this._mostRecentViewValue && (this._mostRecentViewValue = e, this._stateChanges.next());
            }
          }
          ngOnDestroy() {
            this._stateChanges.complete();
          }
          _emitSelectionChangeEvent(e = !1) {
            this.onSelectionChange.emit(new sy(this, e));
          }
        }
        return n.ɵfac = function (e) {
          li();
        }, n.ɵdir = P({
          type: n,
          inputs: {
            value: "value",
            id: "id",
            disabled: "disabled"
          },
          outputs: {
            onSelectionChange: "onSelectionChange"
          }
        }), n;
      })(),
      Ho = (() => {
        class n extends xB {
          constructor(e, a, i, o) {
            super(e, a, i, o);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(Se), f(Cp, 8), f(Mp, 8));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-option"]],
          hostAttrs: ["role", "option", 1, "mat-option", "mat-focus-indicator"],
          hostVars: 12,
          hostBindings: function (e, a) {
            1 & e && F("click", function () {
              return a._selectViaInteraction();
            })("keydown", function (o) {
              return a._handleKeydown(o);
            }), 2 & e && (Zn("id", a.id), X("tabindex", a._getTabIndex())("aria-selected", a._getAriaSelected())("aria-disabled", a.disabled.toString()), fe("mat-selected", a.selected)("mat-option-multiple", a.multiple)("mat-active", a.active)("mat-option-disabled", a.disabled));
          },
          exportAs: ["matOption"],
          features: [z],
          ngContentSelectors: sB,
          decls: 5,
          vars: 4,
          consts: [["class", "mat-option-pseudo-checkbox", 3, "state", "disabled", 4, "ngIf"], [1, "mat-option-text"], ["class", "cdk-visually-hidden", 4, "ngIf"], ["mat-ripple", "", 1, "mat-option-ripple", 3, "matRippleTrigger", "matRippleDisabled"], [1, "mat-option-pseudo-checkbox", 3, "state", "disabled"], [1, "cdk-visually-hidden"]],
          template: function (e, a) {
            1 & e && (lt(), D(0, oB, 1, 2, "mat-pseudo-checkbox", 0), _(1, "span", 1), Me(2), y(), D(3, rB, 2, 1, "span", 2), j(4, "div", 3)), 2 & e && (b("ngIf", a.multiple), g(3), b("ngIf", a.group && a.group._inert), g(1), b("matRippleTrigger", a._getHostElement())("matRippleDisabled", a.disabled || a.disableRipple));
          },
          dependencies: [Xa, mt, ry],
          styles: ['.mat-option{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;line-height:48px;height:48px;padding:0 16px;text-align:left;text-decoration:none;max-width:100%;position:relative;cursor:pointer;outline:none;display:flex;flex-direction:row;max-width:100%;box-sizing:border-box;align-items:center;-webkit-tap-highlight-color:rgba(0,0,0,0)}.mat-option[disabled]{cursor:default}[dir=rtl] .mat-option{text-align:right}.mat-option .mat-icon{margin-right:16px;vertical-align:middle}.mat-option .mat-icon svg{vertical-align:top}[dir=rtl] .mat-option .mat-icon{margin-left:16px;margin-right:0}.mat-option[aria-disabled=true]{-webkit-user-select:none;user-select:none;cursor:default}.mat-optgroup .mat-option:not(.mat-option-multiple){padding-left:32px}[dir=rtl] .mat-optgroup .mat-option:not(.mat-option-multiple){padding-left:16px;padding-right:32px}.mat-option.mat-active::before{content:""}.cdk-high-contrast-active .mat-option[aria-disabled=true]{opacity:.5}.cdk-high-contrast-active .mat-option.mat-selected:not(.mat-option-multiple)::after{content:"";position:absolute;top:50%;right:16px;transform:translateY(-50%);width:10px;height:0;border-bottom:solid 10px;border-radius:10px}[dir=rtl] .cdk-high-contrast-active .mat-option.mat-selected:not(.mat-option-multiple)::after{right:auto;left:16px}.mat-option-text{display:inline-block;flex-grow:1;overflow:hidden;text-overflow:ellipsis}.mat-option .mat-option-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-option-pseudo-checkbox{margin-right:8px}[dir=rtl] .mat-option-pseudo-checkbox{margin-left:8px;margin-right:0}'],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })();
    function k2(n, t, e) {
      if (e.length) {
        let a = t.toArray(),
          i = e.toArray(),
          o = 0;
        for (let r = 0; r < n + 1; r++) a[r].group && a[r].group === i[o] && o++;
        return o;
      }
      return 0;
    }
    function cy(n, t, e, a) {
      return n < e ? n : n + t > e + a ? Math.max(0, n - a + t) : e;
    }
    let D2 = (() => {
      class n {}
      return n.ɵfac = function (e) {
        return new (e || n)();
      }, n.ɵmod = W({
        type: n
      }), n.ɵinj = U({
        imports: [sa, yt, $, yp]
      }), n;
    })();
    const wB = $i(Fo(Ka));
    let xp = (() => {
        class n extends wB {
          constructor(e, a, i) {
            super(e, a), this.tabIndex = Number(i) || 0;
          }
          ngOnInit() {
            super.ngOnInit();
          }
          ngOnDestroy() {
            super.ngOnDestroy();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(Mi), qt("tabindex"));
        }, n.ɵdir = P({
          type: n,
          selectors: [["mat-tree-node"]],
          hostAttrs: [1, "mat-tree-node"],
          inputs: {
            role: "role",
            disabled: "disabled",
            tabIndex: "tabIndex"
          },
          exportAs: ["matTreeNode"],
          features: [G([{
            provide: Ka,
            useExisting: n
          }]), z]
        }), n;
      })(),
      wp = (() => {
        class n extends g2 {}
        return n.ɵfac = function () {
          let t;
          return function (a) {
            return (t || (t = he(n)))(a || n);
          };
        }(), n.ɵdir = P({
          type: n,
          selectors: [["", "matTreeNodeDef", ""]],
          inputs: {
            when: ["matTreeNodeDefWhen", "when"],
            data: ["matTreeNode", "data"]
          },
          features: [G([{
            provide: g2,
            useExisting: n
          }]), z]
        }), n;
      })(),
      kp = (() => {
        class n extends ap {
          constructor(e, a, i, o) {
            super(e, a, i), this._disabled = !1, this.tabIndex = Number(o) || 0;
          }
          get disabled() {
            return this._disabled;
          }
          set disabled(e) {
            this._disabled = Y(e);
          }
          get tabIndex() {
            return this.disabled ? -1 : this._tabIndex;
          }
          set tabIndex(e) {
            this._tabIndex = e ?? 0;
          }
          ngOnInit() {
            super.ngOnInit();
          }
          ngAfterContentInit() {
            super.ngAfterContentInit();
          }
          ngOnDestroy() {
            super.ngOnDestroy();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(Mi), f(Xn), qt("tabindex"));
        }, n.ɵdir = P({
          type: n,
          selectors: [["mat-nested-tree-node"]],
          hostAttrs: [1, "mat-nested-tree-node"],
          inputs: {
            role: "role",
            disabled: "disabled",
            tabIndex: "tabIndex",
            node: ["matNestedTreeNode", "node"]
          },
          exportAs: ["matNestedTreeNode"],
          features: [G([{
            provide: ap,
            useExisting: n
          }, {
            provide: Ka,
            useExisting: n
          }, {
            provide: p2,
            useExisting: n
          }]), z]
        }), n;
      })(),
      $c = (() => {
        class n {
          constructor(e, a) {
            this.viewContainer = e, this._node = a;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(ut), f(p2, 8));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "matTreeNodeOutlet", ""]],
          features: [G([{
            provide: Qc,
            useExisting: n
          }])]
        }), n;
      })(),
      Dp = (() => {
        class n extends Mi {}
        return n.ɵfac = function () {
          let t;
          return function (a) {
            return (t || (t = he(n)))(a || n);
          };
        }(), n.ɵcmp = q({
          type: n,
          selectors: [["mat-tree"]],
          viewQuery: function (e, a) {
            if (1 & e && be($c, 7), 2 & e) {
              let i;
              H(i = B()) && (a._nodeOutlet = i.first);
            }
          },
          hostAttrs: ["role", "tree", 1, "mat-tree"],
          exportAs: ["matTree"],
          features: [G([{
            provide: Mi,
            useExisting: n
          }]), z],
          decls: 1,
          vars: 0,
          consts: [["matTreeNodeOutlet", ""]],
          template: function (e, a) {
            1 & e && Rn(0, 0);
          },
          dependencies: [$c],
          styles: [".mat-tree{display:block}.mat-tree-node{display:flex;align-items:center;flex:1;word-wrap:break-word}.mat-nested-tree-node{border-bottom-width:0}"],
          encapsulation: 2
        }), n;
      })(),
      Op = (() => {
        class n extends op {}
        return n.ɵfac = function () {
          let t;
          return function (a) {
            return (t || (t = he(n)))(a || n);
          };
        }(), n.ɵdir = P({
          type: n,
          selectors: [["", "matTreeNodeToggle", ""]],
          inputs: {
            recursive: ["matTreeNodeToggleRecursive", "recursive"]
          },
          features: [G([{
            provide: op,
            useExisting: n
          }]), z]
        }), n;
      })(),
      DB = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [Iv, $, $]
        }), n;
      })();
    class ly extends class dH {} {
      constructor() {
        super(...arguments), this._data = new Xi([]);
      }
      get data() {
        return this._data.value;
      }
      set data(t) {
        this._data.next(t);
      }
      connect(t) {
        return dt(t.viewChange, this._data).pipe(We(() => this.data));
      }
      disconnect() {}
    }
    const dy = function AB(n, t) {
        return n === t || n != n && t != t;
      },
      O2 = function SB(n, t) {
        for (var e = n.length; e--;) if (dy(n[e][0], t)) return e;
        return -1;
      };
    var TB = Array.prototype.splice;
    function ds(n) {
      var t = -1,
        e = null == n ? 0 : n.length;
      for (this.clear(); ++t < e;) {
        var a = n[t];
        this.set(a[0], a[1]);
      }
    }
    ds.prototype.clear = function OB() {
      this.__data__ = [], this.size = 0;
    }, ds.prototype.delete = function IB(n) {
      var t = this.__data__,
        e = O2(t, n);
      return !(e < 0 || (e == t.length - 1 ? t.pop() : TB.call(t, e, 1), --this.size, 0));
    }, ds.prototype.get = function zB(n) {
      var t = this.__data__,
        e = O2(t, n);
      return e < 0 ? void 0 : t[e][1];
    }, ds.prototype.has = function NB(n) {
      return O2(this.__data__, n) > -1;
    }, ds.prototype.set = function VB(n, t) {
      var e = this.__data__,
        a = O2(e, n);
      return a < 0 ? (++this.size, e.push([n, t])) : e[a][1] = t, this;
    };
    const P2 = ds,
      uy = "object" == typeof global && global && global.Object === Object && global;
    var ZB = "object" == typeof self && self && self.Object === Object && self;
    const Ja = uy || ZB || Function("return this")(),
      us = Ja.Symbol;
    var fy = Object.prototype,
      $B = fy.hasOwnProperty,
      ej = fy.toString,
      el = us ? us.toStringTag : void 0;
    var ij = Object.prototype.toString;
    var my = us ? us.toStringTag : void 0;
    const tl = function lj(n) {
        return null == n ? void 0 === n ? "[object Undefined]" : "[object Null]" : my && my in Object(n) ? function tj(n) {
          var t = $B.call(n, el),
            e = n[el];
          try {
            n[el] = void 0;
            var a = !0;
          } catch {}
          var i = ej.call(n);
          return a && (t ? n[el] = e : delete n[el]), i;
        }(n) : function oj(n) {
          return ij.call(n);
        }(n);
      },
      nl = function dj(n) {
        var t = typeof n;
        return null != n && ("object" == t || "function" == t);
      },
      hy = function pj(n) {
        if (!nl(n)) return !1;
        var t = tl(n);
        return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
      },
      Pp = Ja["__core-js_shared__"];
    var py = function () {
      var n = /[^.]+$/.exec(Pp && Pp.keys && Pp.keys.IE_PROTO || "");
      return n ? "Symbol(src)_1." + n : "";
    }();
    var yj = Function.prototype.toString;
    const Bo = function Cj(n) {
      if (null != n) {
        try {
          return yj.call(n);
        } catch {}
        try {
          return n + "";
        } catch {}
      }
      return "";
    };
    var xj = /^\[object .+?Constructor\]$/,
      Pj = RegExp("^" + Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    const Sj = function Aj(n) {
        return !(!nl(n) || function bj(n) {
          return !!py && py in n;
        }(n)) && (hy(n) ? Pj : xj).test(Bo(n));
      },
      jo = function Ij(n, t) {
        var e = function Ej(n, t) {
          return n?.[t];
        }(n, t);
        return Sj(e) ? e : void 0;
      },
      al = jo(Ja, "Map"),
      il = jo(Object, "create");
    var jj = Object.prototype.hasOwnProperty;
    var Yj = Object.prototype.hasOwnProperty;
    function fs(n) {
      var t = -1,
        e = null == n ? 0 : n.length;
      for (this.clear(); ++t < e;) {
        var a = n[t];
        this.set(a[0], a[1]);
      }
    }
    fs.prototype.clear = function Lj() {
      this.__data__ = il ? il(null) : {}, this.size = 0;
    }, fs.prototype.delete = function Fj(n) {
      var t = this.has(n) && delete this.__data__[n];
      return this.size -= t ? 1 : 0, t;
    }, fs.prototype.get = function Uj(n) {
      var t = this.__data__;
      if (il) {
        var e = t[n];
        return "__lodash_hash_undefined__" === e ? void 0 : e;
      }
      return jj.call(t, n) ? t[n] : void 0;
    }, fs.prototype.has = function qj(n) {
      var t = this.__data__;
      return il ? void 0 !== t[n] : Yj.call(t, n);
    }, fs.prototype.set = function Zj(n, t) {
      var e = this.__data__;
      return this.size += this.has(n) ? 0 : 1, e[n] = il && void 0 === t ? "__lodash_hash_undefined__" : t, this;
    };
    const gy = fs,
      A2 = function nU(n, t) {
        var e = n.__data__;
        return function eU(n) {
          var t = typeof n;
          return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== n : null === n;
        }(t) ? e["string" == typeof t ? "string" : "hash"] : e.map;
      };
    function ms(n) {
      var t = -1,
        e = null == n ? 0 : n.length;
      for (this.clear(); ++t < e;) {
        var a = n[t];
        this.set(a[0], a[1]);
      }
    }
    ms.prototype.clear = function Jj() {
      this.size = 0, this.__data__ = {
        hash: new gy(),
        map: new (al || P2)(),
        string: new gy()
      };
    }, ms.prototype.delete = function aU(n) {
      var t = A2(this, n).delete(n);
      return this.size -= t ? 1 : 0, t;
    }, ms.prototype.get = function oU(n) {
      return A2(this, n).get(n);
    }, ms.prototype.has = function sU(n) {
      return A2(this, n).has(n);
    }, ms.prototype.set = function lU(n, t) {
      var e = A2(this, n),
        a = e.size;
      return e.set(n, t), this.size += e.size == a ? 0 : 1, this;
    };
    const uU = ms;
    function hs(n) {
      var t = this.__data__ = new P2(n);
      this.size = t.size;
    }
    hs.prototype.clear = function BB() {
      this.__data__ = new P2(), this.size = 0;
    }, hs.prototype.delete = function UB(n) {
      var t = this.__data__,
        e = t.delete(n);
      return this.size = t.size, e;
    }, hs.prototype.get = function WB(n) {
      return this.__data__.get(n);
    }, hs.prototype.has = function qB(n) {
      return this.__data__.has(n);
    }, hs.prototype.set = function mU(n, t) {
      var e = this.__data__;
      if (e instanceof P2) {
        var a = e.__data__;
        if (!al || a.length < 199) return a.push([n, t]), this.size = ++e.size, this;
        e = this.__data__ = new uU(a);
      }
      return e.set(n, t), this.size = e.size, this;
    };
    const pU = hs;
    var _U = function () {
      try {
        var n = jo(Object, "defineProperty");
        return n({}, "", {}), n;
      } catch {}
    }();
    const by = _U,
      _y = function vU(n, t, e) {
        "__proto__" == t && by ? by(n, t, {
          configurable: !0,
          enumerable: !0,
          value: e,
          writable: !0
        }) : n[t] = e;
      };
    var CU = Object.prototype.hasOwnProperty;
    const vy = function MU(n, t, e) {
        var a = n[t];
        (!CU.call(n, t) || !dy(a, e) || void 0 === e && !(t in n)) && _y(n, t, e);
      },
      S2 = function xU(n, t, e, a) {
        var i = !e;
        e || (e = {});
        for (var o = -1, r = t.length; ++o < r;) {
          var s = t[o],
            c = a ? a(e[s], n[s], s, e, n) : void 0;
          void 0 === c && (c = n[s]), i ? _y(e, s, c) : vy(e, s, c);
        }
        return e;
      },
      ol = function DU(n) {
        return null != n && "object" == typeof n;
      },
      yy = function PU(n) {
        return ol(n) && "[object Arguments]" == tl(n);
      };
    var Cy = Object.prototype,
      AU = Cy.hasOwnProperty,
      SU = Cy.propertyIsEnumerable,
      EU = yy(function () {
        return arguments;
      }()) ? yy : function (n) {
        return ol(n) && AU.call(n, "callee") && !SU.call(n, "callee");
      };
    const TU = EU,
      Ap = Array.isArray;
    var My = "object" == typeof exports && exports && !exports.nodeType && exports,
      xy = My && "object" == typeof module && module && !module.nodeType && module,
      wy = xy && xy.exports === My ? Ja.Buffer : void 0;
    const ky = (wy ? wy.isBuffer : void 0) || function RU() {
      return !1;
    };
    var HU = /^(?:0|[1-9]\d*)$/;
    const jU = function BU(n, t) {
        var e = typeof n;
        return !!(t = t ?? 9007199254740991) && ("number" == e || "symbol" != e && HU.test(n)) && n > -1 && n % 1 == 0 && n < t;
      },
      Dy = function GU(n) {
        return "number" == typeof n && n > -1 && n % 1 == 0 && n <= 9007199254740991;
      };
    var st = {};
    st["[object Float32Array]"] = st["[object Float64Array]"] = st["[object Int8Array]"] = st["[object Int16Array]"] = st["[object Int32Array]"] = st["[object Uint8Array]"] = st["[object Uint8ClampedArray]"] = st["[object Uint16Array]"] = st["[object Uint32Array]"] = !0, st["[object Arguments]"] = st["[object Array]"] = st["[object ArrayBuffer]"] = st["[object Boolean]"] = st["[object DataView]"] = st["[object Date]"] = st["[object Error]"] = st["[object Function]"] = st["[object Map]"] = st["[object Number]"] = st["[object Object]"] = st["[object RegExp]"] = st["[object Set]"] = st["[object String]"] = st["[object WeakMap]"] = !1;
    const Sp = function bG(n) {
      return function (t) {
        return n(t);
      };
    };
    var Oy = "object" == typeof exports && exports && !exports.nodeType && exports,
      rl = Oy && "object" == typeof module && module && !module.nodeType && module,
      Ep = rl && rl.exports === Oy && uy.process;
    const ps = function () {
      try {
        return rl && rl.require && rl.require("util").types || Ep && Ep.binding && Ep.binding("util");
      } catch {}
    }();
    var Py = ps && ps.isTypedArray;
    const CG = Py ? Sp(Py) : function pG(n) {
      return ol(n) && Dy(n.length) && !!st[tl(n)];
    };
    var xG = Object.prototype.hasOwnProperty;
    const Ay = function wG(n, t) {
      var e = Ap(n),
        a = !e && TU(n),
        i = !e && !a && ky(n),
        o = !e && !a && !i && CG(n),
        r = e || a || i || o,
        s = r ? function wU(n, t) {
          for (var e = -1, a = Array(n); ++e < n;) a[e] = t(e);
          return a;
        }(n.length, String) : [],
        c = s.length;
      for (var l in n) (t || xG.call(n, l)) && (!r || !("length" == l || i && ("offset" == l || "parent" == l) || o && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || jU(l, c))) && s.push(l);
      return s;
    };
    var kG = Object.prototype;
    const Tp = function DG(n) {
        var t = n && n.constructor;
        return n === ("function" == typeof t && t.prototype || kG);
      },
      Sy = function OG(n, t) {
        return function (e) {
          return n(t(e));
        };
      },
      AG = Sy(Object.keys, Object);
    var EG = Object.prototype.hasOwnProperty;
    const Ey = function RG(n) {
        return null != n && Dy(n.length) && !hy(n);
      },
      Ip = function zG(n) {
        return Ey(n) ? Ay(n) : function TG(n) {
          if (!Tp(n)) return AG(n);
          var t = [];
          for (var e in Object(n)) EG.call(n, e) && "constructor" != e && t.push(e);
          return t;
        }(n);
      };
    var BG = Object.prototype.hasOwnProperty;
    const UG = function jG(n) {
        if (!nl(n)) return function FG(n) {
          var t = [];
          if (null != n) for (var e in Object(n)) t.push(e);
          return t;
        }(n);
        var t = Tp(n),
          e = [];
        for (var a in n) "constructor" == a && (t || !BG.call(n, a)) || e.push(a);
        return e;
      },
      Rp = function GG(n) {
        return Ey(n) ? Ay(n, !0) : UG(n);
      };
    var Ty = "object" == typeof exports && exports && !exports.nodeType && exports,
      Iy = Ty && "object" == typeof module && module && !module.nodeType && module,
      Ry = Iy && Iy.exports === Ty ? Ja.Buffer : void 0,
      zy = Ry ? Ry.allocUnsafe : void 0;
    const Ly = function eW() {
      return [];
    };
    var nW = Object.prototype.propertyIsEnumerable,
      Ny = Object.getOwnPropertySymbols,
      aW = Ny ? function (n) {
        return null == n ? [] : (n = Object(n), function JG(n, t) {
          for (var e = -1, a = null == n ? 0 : n.length, i = 0, o = []; ++e < a;) {
            var r = n[e];
            t(r, e, n) && (o[i++] = r);
          }
          return o;
        }(Ny(n), function (t) {
          return nW.call(n, t);
        }));
      } : Ly;
    const zp = aW,
      Fy = function rW(n, t) {
        for (var e = -1, a = t.length, i = n.length; ++e < a;) n[i + e] = t[e];
        return n;
      },
      Vy = Sy(Object.getPrototypeOf, Object);
    var lW = Object.getOwnPropertySymbols ? function (n) {
      for (var t = []; n;) Fy(t, zp(n)), n = Vy(n);
      return t;
    } : Ly;
    const Hy = lW,
      By = function fW(n, t, e) {
        var a = t(n);
        return Ap(n) ? a : Fy(a, e(n));
      },
      hW = function mW(n) {
        return By(n, Ip, zp);
      },
      gW = function pW(n) {
        return By(n, Rp, Hy);
      },
      Lp = jo(Ja, "DataView"),
      Np = jo(Ja, "Promise"),
      Fp = jo(Ja, "Set"),
      Vp = jo(Ja, "WeakMap");
    var jy = "[object Map]",
      Uy = "[object Promise]",
      Gy = "[object Set]",
      Wy = "[object WeakMap]",
      Yy = "[object DataView]",
      MW = Bo(Lp),
      xW = Bo(al),
      wW = Bo(Np),
      kW = Bo(Fp),
      DW = Bo(Vp),
      Uo = tl;
    (Lp && Uo(new Lp(new ArrayBuffer(1))) != Yy || al && Uo(new al()) != jy || Np && Uo(Np.resolve()) != Uy || Fp && Uo(new Fp()) != Gy || Vp && Uo(new Vp()) != Wy) && (Uo = function (n) {
      var t = tl(n),
        e = "[object Object]" == t ? n.constructor : void 0,
        a = e ? Bo(e) : "";
      if (a) switch (a) {
        case MW:
          return Yy;
        case xW:
          return jy;
        case wW:
          return Uy;
        case kW:
          return Gy;
        case DW:
          return Wy;
      }
      return t;
    });
    const Hp = Uo;
    var PW = Object.prototype.hasOwnProperty;
    const qy = Ja.Uint8Array,
      Bp = function TW(n) {
        var t = new n.constructor(n.byteLength);
        return new qy(t).set(new qy(n)), t;
      };
    var zW = /\w*$/;
    var Ky = us ? us.prototype : void 0,
      Qy = Ky ? Ky.valueOf : void 0;
    const cY = function sY(n, t, e) {
      var a = n.constructor;
      switch (t) {
        case "[object ArrayBuffer]":
          return Bp(n);
        case "[object Boolean]":
        case "[object Date]":
          return new a(+n);
        case "[object DataView]":
          return function IW(n, t) {
            var e = t ? Bp(n.buffer) : n.buffer;
            return new n.constructor(e, n.byteOffset, n.byteLength);
          }(n, e);
        case "[object Float32Array]":
        case "[object Float64Array]":
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object Int32Array]":
        case "[object Uint8Array]":
        case "[object Uint8ClampedArray]":
        case "[object Uint16Array]":
        case "[object Uint32Array]":
          return function HW(n, t) {
            var e = t ? Bp(n.buffer) : n.buffer;
            return new n.constructor(e, n.byteOffset, n.length);
          }(n, e);
        case "[object Map]":
        case "[object Set]":
          return new a();
        case "[object Number]":
        case "[object String]":
          return new a(n);
        case "[object RegExp]":
          return function LW(n) {
            var t = new n.constructor(n.source, zW.exec(n));
            return t.lastIndex = n.lastIndex, t;
          }(n);
        case "[object Symbol]":
          return function FW(n) {
            return Qy ? Object(Qy.call(n)) : {};
          }(n);
      }
    };
    var Zy = Object.create,
      lY = function () {
        function n() {}
        return function (t) {
          if (!nl(t)) return {};
          if (Zy) return Zy(t);
          n.prototype = t;
          var e = new n();
          return n.prototype = void 0, e;
        };
      }();
    const dY = lY;
    var Xy = ps && ps.isMap;
    const bY = Xy ? Sp(Xy) : function hY(n) {
      return ol(n) && "[object Map]" == Hp(n);
    };
    var Jy = ps && ps.isSet;
    const MY = Jy ? Sp(Jy) : function vY(n) {
      return ol(n) && "[object Set]" == Hp(n);
    };
    var $y = "[object Arguments]",
      eC = "[object Function]",
      tC = "[object Object]",
      it = {};
    it[$y] = it["[object Array]"] = it["[object ArrayBuffer]"] = it["[object DataView]"] = it["[object Boolean]"] = it["[object Date]"] = it["[object Float32Array]"] = it["[object Float64Array]"] = it["[object Int8Array]"] = it["[object Int16Array]"] = it["[object Int32Array]"] = it["[object Map]"] = it["[object Number]"] = it[tC] = it["[object RegExp]"] = it["[object Set]"] = it["[object String]"] = it["[object Symbol]"] = it["[object Uint8Array]"] = it["[object Uint8ClampedArray]"] = it["[object Uint16Array]"] = it["[object Uint32Array]"] = !0, it["[object Error]"] = it[eC] = it["[object WeakMap]"] = !1;
    const QY = function E2(n, t, e, a, i, o) {
        var r,
          s = 1 & t,
          c = 2 & t,
          l = 4 & t;
        if (e && (r = i ? e(n, a, i, o) : e(n)), void 0 !== r) return r;
        if (!nl(n)) return n;
        var d = Ap(n);
        if (d) {
          if (r = function AW(n) {
            var t = n.length,
              e = new n.constructor(t);
            return t && "string" == typeof n[0] && PW.call(n, "index") && (e.index = n.index, e.input = n.input), e;
          }(n), !s) return function ZG(n, t) {
            var e = -1,
              a = n.length;
            for (t || (t = Array(a)); ++e < a;) t[e] = n[e];
            return t;
          }(n, r);
        } else {
          var u = Hp(n),
            m = u == eC || "[object GeneratorFunction]" == u;
          if (ky(n)) return function KG(n, t) {
            if (t) return n.slice();
            var e = n.length,
              a = zy ? zy(e) : new n.constructor(e);
            return n.copy(a), a;
          }(n, s);
          if (u == tC || u == $y || m && !i) {
            if (r = c || m ? {} : function uY(n) {
              return "function" != typeof n.constructor || Tp(n) ? {} : dY(Vy(n));
            }(n), !s) return c ? function dW(n, t) {
              return S2(n, Hy(n), t);
            }(n, function WG(n, t) {
              return n && S2(t, Rp(t), n);
            }(r, n)) : function iW(n, t) {
              return S2(n, zp(n), t);
            }(n, function LG(n, t) {
              return n && S2(t, Ip(t), n);
            }(r, n));
          } else {
            if (!it[u]) return i ? n : {};
            r = cY(n, u, s);
          }
        }
        o || (o = new pU());
        var h = o.get(n);
        if (h) return h;
        o.set(n, r), MY(n) ? n.forEach(function (C) {
          r.add(E2(C, t, e, C, n, o));
        }) : bY(n) && n.forEach(function (C, k) {
          r.set(k, E2(C, t, e, k, n, o));
        });
        var v = d ? void 0 : (l ? c ? gW : hW : c ? Rp : Ip)(n);
        return function gU(n, t) {
          for (var e = -1, a = null == n ? 0 : n.length; ++e < a && !1 !== t(n[e], e, n););
        }(v || n, function (C, k) {
          v && (C = n[k = C]), vy(r, k, E2(C, t, e, k, n, o));
        }), r;
      },
      nC = function JY(n) {
        return QY(n, 5);
      };
    var A = (() => (function (n) {
      n.textfield = "textfield", n.controlled = "controlled", n.link = "link", n.textarea = "textarea", n.radio = "radio", n.checkbox = "checkbox", n.temporal = "temporal", n.email = "email", n.list = "list", n.numeric = "numeric", n.phoneNumber = "phone-number", n.tel = "tel", n.text = "text", n.url = "url", n.number = "number", n.attributeValue = "attribute-value", n.pageBreak = "page-break", n.sectionBreak = "section-break", n.richText = "richtext", n.image = "image", n.youTube = "youtube", n.static = "static", n.element = "element";
    }(A || (A = {})), A))();
    const jp = {
      inputTypes: {
        textfield: {
          cedarType: "textfield",
          iconClass: "fa fa-font",
          label: "Text",
          allowedInElement: !0,
          primaryField: !0,
          hasControlledTerms: !0,
          staticField: !1,
          allowsMultiple: !0,
          allowsValueRecommendation: !0,
          hasInstanceTerm: !0,
          allowsRequired: !0
        },
        controlled: {
          cedarType: "controlled",
          iconClass: "fa fa-font",
          label: "Controlled",
          allowedInElement: !0,
          primaryField: !0,
          hasControlledTerms: !0,
          staticField: !1,
          allowsMultiple: !0,
          allowsValueRecommendation: !0,
          hasInstanceTerm: !0,
          allowsRequired: !0
        },
        link: {
          cedarType: "link",
          iconClass: "fa fa-font",
          label: "Text",
          allowedInElement: !0,
          primaryField: !0,
          hasControlledTerms: !0,
          staticField: !1,
          allowsMultiple: !0,
          allowsValueRecommendation: !0,
          hasInstanceTerm: !0,
          allowsRequired: !0
        },
        textarea: {
          cedarType: "textarea",
          iconClass: "fa fa-paragraph",
          label: "Text Area",
          allowedInElement: !0,
          primaryField: !1,
          hasControlledTerms: !1,
          staticField: !1,
          allowsMultiple: !0,
          allowsValueRecommendation: !1,
          hasInstanceTerm: !1,
          allowsRequired: !0
        },
        radio: {
          cedarType: "radio",
          iconClass: "fa fa-dot-circle-o",
          label: "Multiple Choice",
          allowedInElement: !0,
          primaryField: !1,
          hasControlledTerms: !1,
          staticField: !1,
          allowsMultiple: !1,
          allowsValueRecommendation: !1,
          hasInstanceTerm: !1,
          allowsRequired: !0
        },
        checkbox: {
          cedarType: "checkbox",
          iconClass: "fa fa-check-square-o",
          label: "Checkbox",
          allowedInElement: !0,
          primaryField: !1,
          hasControlledTerms: !1,
          staticField: !1,
          allowsMultiple: !1,
          allowsValueRecommendation: !1,
          hasInstanceTerm: !1,
          allowsRequired: !0
        },
        temporal: {
          cedarType: "temporal",
          iconClass: "fa fa-calendar",
          label: "Temporal",
          allowedInElement: !0,
          primaryField: !0,
          hasControlledTerms: !1,
          staticField: !1,
          allowsMultiple: !0,
          allowsValueRecommendation: !1,
          hasInstanceTerm: !1,
          allowsRequired: !0
        },
        email: {
          cedarType: "email",
          iconClass: "fa fa-envelope",
          label: "Email",
          allowedInElement: !0,
          primaryField: !0,
          hasControlledTerms: !1,
          staticField: !1,
          allowsMultiple: !0,
          allowsValueRecommendation: !1,
          hasInstanceTerm: !1,
          allowsRequired: !0
        },
        list: {
          cedarType: "list",
          iconClass: "fa fa-list",
          allowedInElement: !0,
          primaryField: !1,
          label: "List",
          hasControlledTerms: !1,
          staticField: !1,
          allowsMultiple: !1,
          allowsValueRecommendation: !1,
          hasInstanceTerm: !1,
          allowsRequired: !0
        },
        numeric: {
          cedarType: "numeric",
          iconClass: "fa fa-hashtag",
          allowedInElement: !0,
          primaryField: !0,
          Label: "Number",
          hasControlledTerms: !1,
          staticField: !1,
          allowsMultiple: !0,
          allowsValueRecommendation: !1,
          hasInstanceTerm: !1,
          allowsRequired: !0
        },
        "phone-number": {
          cedarType: "phone-number",
          iconClass: "fa fa-th",
          allowedInElement: !0,
          label: "Phone Number",
          primaryField: !1,
          hasControlledTerms: !1,
          staticField: !1,
          allowsMultiple: !0,
          allowsValueRecommendation: !1,
          hasInstanceTerm: !1,
          allowsRequired: !0
        },
        "attribute-value": {
          cedarType: "attribute-value",
          iconClass: "fa fa-plus-square",
          label: "Attribute Value",
          allowedInElement: !0,
          primaryField: !1,
          hasControlledTerms: !1,
          staticField: !1,
          allowsMultiple: !1,
          allowsValueRecommendation: !1,
          hasInstanceTerm: !1,
          allowsRequired: !1
        },
        "page-break": {
          cedarType: "page-break",
          iconClass: "fa fa-file-o",
          allowedInElement: !1,
          label: "Page Break",
          primaryField: !1,
          hasControlledTerms: !1,
          staticField: !0,
          allowsMultiple: !1,
          allowsValueRecommendation: !1,
          hasInstanceTerm: !1,
          allowsRequired: !1
        },
        "section-break": {
          cedarType: "section-break",
          iconClass: "fa fa-minus",
          allowedInElement: !0,
          label: "Section Break",
          primaryField: !1,
          hasControlledTerms: !1,
          staticField: !0,
          allowsMultiple: !1,
          allowsValueRecommendation: !1,
          hasInstanceTerm: !1,
          allowsRequired: !1
        },
        richtext: {
          cedarType: "richtext",
          iconClass: "fa fa-pencil-square-o",
          allowedInElement: !0,
          label: "Rich Text",
          primaryField: !1,
          hasControlledTerms: !1,
          staticField: !0,
          allowsMultiple: !1,
          allowsValueRecommendation: !1,
          hasInstanceTerm: !1,
          allowsRequired: !1
        },
        image: {
          cedarType: "image",
          iconClass: "fa fa-image",
          allowedInElement: !0,
          label: "Image",
          primaryField: !1,
          hasControlledTerms: !1,
          staticField: !0,
          allowsMultiple: !1,
          allowsValueRecommendation: !1,
          hasInstanceTerm: !1,
          allowsRequired: !1
        },
        youtube: {
          cedarType: "youtube",
          iconClass: "fa fa-youtube-square",
          allowedInElement: !0,
          label: "YouTube Video",
          primaryField: !1,
          hasControlledTerms: !1,
          staticField: !0,
          allowsMultiple: !1,
          allowsValueRecommendation: !1,
          hasInstanceTerm: !1,
          allowsRequired: !1
        }
      },
      labels: {
        copy: "Copy",
        remove: "Remove"
      }
    };
    class pn {
      static isStatic(t) {
        return jp.inputTypes[t].staticField;
      }
      static allowsMultiple(t) {
        return jp.inputTypes[t] && jp.inputTypes[t].allowsMultiple;
      }
      static isNotTextInput(t) {
        return t === A.attributeValue || t === A.controlled || t === A.list || t === A.radio || t === A.checkbox || t === A.temporal || t === A.textarea;
      }
      static isRadioCheckList(t) {
        return pn.isRadio(t) || pn.isCheckbox(t) || pn.isList(t);
      }
      static isCheckbox(t) {
        return t === A.checkbox;
      }
      static isPageBreak(t) {
        return t === A.pageBreak;
      }
      static isTextfield(t) {
        return t === A.textfield;
      }
      static isRadio(t) {
        return t === A.radio;
      }
      static isList(t) {
        return t === A.list;
      }
      static isTemporal(t) {
        return t === A.temporal;
      }
      static isControlled(t) {
        return t === A.controlled;
      }
      static isAttributeValue(t) {
        return t === A.attributeValue;
      }
      static isTel(t) {
        return t === A.tel;
      }
      static isUrl(t) {
        return t === A.url;
      }
      static isNumber(t) {
        return t === A.number;
      }
    }
    let ee = /*#__PURE__*/(() => {
      class ee {
        it;
        constructor() {
          this.it = new pn();
        }
        static isUndefined(t) {
          return null == t;
        }
        static schemaOf(t) {
          return t && "array" === t.type && t.items ? t.items : t;
        }
        static propertiesOf(t) {
          return t.properties;
        }
        static isBasedOn(t) {
          return t["schema:isBasedOn"];
        }
        static getId(t) {
          return t["@id"];
        }
        static isSpecialKey(t) {
          return /(^@)|(^_)|(^schema:)|(^pav:)|(^rdfs:)|(^oslc:)/i.test(t);
        }
        static getLiterals(t) {
          if (t._valueConstraints) return t._valueConstraints.literals;
        }
        static getValueConstraints(t) {
          if (t._valueConstraints) return t._valueConstraints;
        }
        static getHelp(t) {
          return t["schema:description"];
        }
        static getPlaceholder(t) {
          return "placeholder text";
        }
        static getHint(t) {
          return " ";
        }
        static isRequired(t) {
          return t._valueConstraints && t._valueConstraints.requiredValue;
        }
        static getMin(t) {
          return t && t._valueConstraints && t._valueConstraints.minValue;
        }
        static getMax(t) {
          return t && t._valueConstraints && t._valueConstraints.maxValue;
        }
        static getDecimals(t) {
          return t && t._valueConstraints && t._valueConstraints.decimalPlace;
        }
        static getNumeric(t) {
          return t && t._valueConstraints && t._valueConstraints.numberType;
        }
        static getMinStringLength(t) {
          return t && t._valueConstraints && t._valueConstraints.minLength;
        }
        static getMaxStringLength(t) {
          return t && t._valueConstraints && t._valueConstraints.maxLength;
        }
        static getMaxDefaultValue(t) {
          return t._valueConstraints.defaultValue;
        }
        static getName(t) {
          return t["schema:name"];
        }
        static getPrefLabel(t) {
          return t["skos:prefLabel"];
        }
        static getTitle(t, e) {
          return ee.getPrefLabel(t) || e || ee.getName(t);
        }
        static getDescription(t) {
          return t["schema:description"];
        }
        static isElement(t) {
          return "https://schema.metadatacenter.org/core/TemplateElement" === t["@type"];
        }
        static isTemplate(t) {
          return "https://schema.metadatacenter.org/core/Template" === t["@type"];
        }
        static getNodeType(t) {
          let e;
          switch (t) {
            case A.numeric:
            case A.phoneNumber:
            case A.email:
            case A.link:
              e = A.textfield;
              break;
            case A.pageBreak:
            case A.sectionBreak:
            case A.richText:
            case A.image:
            case A.youTube:
              e = A.static;
              break;
            default:
              e = t;
          }
          return e;
        }
        static getNodeSubtype(t) {
          let e;
          switch (t) {
            case A.youTube:
              e = A.youTube;
              break;
            case A.image:
              e = A.image;
              break;
            case A.richText:
              e = A.richText;
              break;
            case A.sectionBreak:
              e = A.sectionBreak;
              break;
            case A.pageBreak:
              e = A.pageBreak;
              break;
            case A.email:
              e = A.email;
              break;
            case A.numeric:
              e = A.number;
              break;
            case A.link:
              e = A.url;
              break;
            case A.phoneNumber:
              e = A.tel;
              break;
            default:
              e = A.text;
          }
          return e;
        }
        static initValue(t, e, a, i, o) {
          let r;
          if (a === A.element) r = this.isUndefined(i) ? {
            "@context": {},
            "@id": t["@id"]
          } : [{
            "@context": {},
            "@id": t["@id"]
          }];else if ("@value" === this.getValueLocation(t, this.getNodeType(a), this.getNodeSubtype(a))) {
            if (this.isUndefined(i)) r = {
              "@value": null
            }, a === A.temporal && (r["@type"] = "xsd:dateTime");else {
              r = [];
              for (let c = 0; c < i; c++) {
                const l = {
                  "@value": null
                };
                a === A.temporal && (l["@type"] = "xsd:dateTime"), r.push(l);
              }
            }
          } else if (a === A.controlled) r = this.isUndefined(i) ? {} : [];else if (this.isUndefined(i)) r = {};else {
            r = [];
            for (let c = 0; c < i; c++) r.push({});
          }
          return r;
        }
        static hasControlledTermValue(t) {
          let e = !1;
          const a = t._valueConstraints;
          if (a) {
            const o = a.valueSets && a.valueSets.length > 0,
              r = a.classes && a.classes.length > 0,
              s = a.branches && a.branches.length > 0;
            e = a.ontologies && a.ontologies.length > 0 || o || r || s;
          }
          return e;
        }
        static getFieldControlledTerms(t, e) {
          if (!pn.isStatic(e) && e !== A.attributeValue) {
            const a = this.propertiesOf(t);
            if (a["@type"] && a["@type"].oneOf && a["@type"].oneOf[1]) return a["@type"].oneOf[1].items.enum;
          }
        }
        static getValueLocation(t, e, a) {
          const i = ee.getFieldControlledTerms(t, e),
            o = ee.hasControlledTermValue(t);
          return i || o || a === A.url ? "@id" : "@value";
        }
        static isField(t) {
          return "https://schema.metadatacenter.org/core/TemplateField" === t["@type"];
        }
        static isStaticField(t) {
          return "https://schema.metadatacenter.org/core/StaticTemplateField" === t["@type"];
        }
        static getOrder(t) {
          return this.isField(t) ? [t["schema:name"]] : t._ui.order;
        }
        static getProperties(t) {
          if (this.isField(t)) {
            const e = {};
            return e[t["schema:name"]] = t, e;
          }
          return t.properties;
        }
        static getLabels(t) {
          return this.isField(t) ? [t["schema:name"]] : t._ui.propertyLabels;
        }
        static getDescriptions(t) {
          return this.isField(t) ? [t["schema:description"]] : t._ui.propertyDescriptions;
        }
        static getPageCount(t) {
          const e = this.getProperties(t);
          let a = 0;
          return this.getOrder(t) && this.getOrder(t).forEach(function (i) {
            const r = ee.getInputType(e[i]);
            pn.isPageBreak(r) && a++;
          }), a + 1;
        }
        static getTitleofPage(t, e) {
          const a = e || 0,
            i = this.getProperties(t),
            o = this.getOrder(t);
          let s,
            r = 0;
          return o && o.forEach(function (c) {
            const l = i[c];
            pn.isPageBreak(ee.getInputType(l)) && (r++, r === a && (s = l["schema:name"]));
          }), s;
        }
        static getDescriptionOfPage(t, e) {
          const a = e || 0,
            i = this.getProperties(t),
            o = this.getOrder(t);
          let s,
            r = 0;
          return o && o.forEach(function (c) {
            const l = i[c];
            pn.isPageBreak(ee.getInputType(l)) && (r++, r === a && (s = l["schema:description"]));
          }), s;
        }
        static getOrderofPage(t, e) {
          const a = e || 0,
            i = this.getProperties(t),
            o = this.getOrder(t);
          let r = 0;
          const s = [],
            c = this;
          return o && o.forEach(function (l) {
            const u = c.getInputType(i[l]);
            pn.isPageBreak(u) ? r++ : r === a && s.push(l);
          }), s;
        }
        static getInputType(t) {
          let e = A.textfield;
          return t && t._ui && t._ui.inputType && (e = t._ui.inputType, pn.isTextfield(e) && this.hasControlledTermValue(t) && (e = A.controlled)), e;
        }
        static getContent(t) {
          return t && t._ui && t._ui._content ? t._ui._content : null;
        }
        static getSize(t) {
          return t && t._ui && t._ui._size ? t._ui._size : null;
        }
        static getHidden(t) {
          return !!(t && t._ui && t._ui.hidden) && t._ui.hidden;
        }
        static isMultiValue(t) {
          return t._valueConstraints && t._valueConstraints.multipleChoice;
        }
        static generateInstanceTypeForNumericField(t) {
          if (Object.hasOwn(t._valueConstraints, "numberType")) return t._valueConstraints.numberType;
        }
        static generateGUID = function () {
          let t = Date.now();
          return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (a) {
            const i = (t + 16 * Math.random()) % 16 | 0;
            return t = Math.floor(t / 16), ("x" === a ? i : 3 & i | 8).toString(16);
          });
        };
        static ɵfac = function (e) {
          return new (e || ee)();
        };
        static ɵprov = R({
          token: ee,
          factory: ee.ɵfac
        });
      }
      return ee;
    })();
    let xi = /*#__PURE__*/(() => {
      class xi {
        it;
        constructor() {
          this.it = new pn();
        }
        static isUndefined(t) {
          return null == t;
        }
        static isBasedOn(t) {
          return t["schema:isBasedOn"];
        }
        static setBasedOn(t, e) {
          return t["schema:isBasedOn"] = e, t;
        }
        static setHelp(t, e) {
          return t["schema:description"] = e, t;
        }
        static setName(t, e) {
          return t["schema:name"] = e, t;
        }
        static getTitle(t) {
          return t["schema:name"];
        }
        static getDescription(t) {
          return t["schema:description"];
        }
        static generateInstanceType(t) {
          const e = this.isUndefined(t.oneOf) ? t.enum : t.oneOf[0].enum;
          if (!this.isUndefined(e)) {
            const a = 1 === e.length ? e[0] : e;
            if (a) return a;
          }
        }
        static generateInstanceTypeForDateField() {
          return "xsd:dateTime";
        }
        static generateInstanceTypeForNumericField(t) {
          if (Object.hasOwn(t._valueConstraints, "numberType")) return t._valueConstraints.numberType;
        }
        static setTextValue(t, e, a, i, o) {
          Array.isArray(t[e]) ? t[e][a][i] = o : t[e][i] = o;
        }
        static setListValue(t, e, a, i, o) {
          if (Array.isArray(t[e])) {
            const r = [];
            for (let s = 0; s < o.length; s++) r.push({
              "@value": o[s]
            });
            t[e] = r;
          } else t[e][i] = o;
        }
        static setRadioValue(t, e, a, i, o) {
          Array.isArray(t[e]) ? t[e][a][i] = o : t[e][i] = o;
        }
        static generateGUID = function () {
          let t = Date.now();
          return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (a) {
            const i = (t + 16 * Math.random()) % 16 | 0;
            return t = Math.floor(t / 16), ("x" === a ? i : 3 & i | 8).toString(16);
          });
        };
        static buildAttributeValue(t, e) {
          const a = [];
          if (t[e] && Array.isArray(t[e])) for (let i = 0; i < t[e].length; i++) {
            const o = t[e][i];
            a.push({
              "@value": t[o]["@value"],
              "rdfs:label": o
            });
          }
          return 0 === a.length && a.push({
            "@value": null,
            "rdfs:label": null
          }), a;
        }
        static setAttributeValue(t, e, a, i, o) {
          const r = t[e][a];
          if (r) {
            if ("value" === i) t[r]["@value"] = o;else {
              const s = t[r]["@value"],
                c = t[e].indexOf(r);
              delete t[r], t["@context"][o] = t["@context"][r], delete t["@context"][r], t[e][c] = o, t[o] = {
                "@value": s
              };
            }
          } else {
            let s = o;
            for (; Object.hasOwn(t, s);) s += "1";
            t["@context"][s] = "https://schema.metadatacenter.org/properties/" + this.generateGUID(), t[e] = [s], t[s] = {
              "@value": o
            };
          }
        }
        static copyAttributeValue(t, e, a) {
          const i = t[e][a],
            o = t[i]["@value"];
          let r = i;
          for (; Object.hasOwn(t, r);) r += "1";
          t["@context"][r] = "https://schema.metadatacenter.org/properties/" + this.generateGUID(), t[e].splice(a + 1, 0, r), t[r] = {
            "@value": o
          };
        }
        static removeAttributeValue(t, e, a) {
          const i = t[e][a];
          delete t["@context"][i], t[e].splice(a, 1), delete t[i];
        }
        static getRadioValue(t, e, a, i) {
          return Array.isArray(t[e]) ? t[e][a][i] : t[e][i];
        }
        static addControlledValue(t, e, a, i) {
          const o = {
            "@id": a,
            "rdfs:label": i
          };
          t[e] = Array.isArray(t[e]) ? t[e] : [t[e]], t[e].push(o);
        }
        static removeControlledValue(t, e, a) {
          t[e].splice(a, 1);
        }
        static setCheckValue(t, e, a, i, o) {
          const r = [];
          for (let s = 0; s < o[a].length; s++) {
            const c = {};
            c[i] = o[a][s], r.push(c);
          }
          t[e] = r;
        }
        static initInstance() {
          return {
            "@context": {
              rdfs: "http://www.w3.org/2000/01/rdf-schema#",
              xsd: "http://www.w3.org/2001/XMLSchema#",
              pav: "http://purl.org/pav/",
              schema: "http://schema.org/",
              oslc: "http://open-services.net/ns/core#",
              skos: "http://www.w3.org/2004/02/skos/core#",
              "rdfs:label": {
                "@type": "xsd:string"
              },
              "schema:isBasedOn": {
                "@type": "@id"
              },
              "schema:name": {
                "@type": "xsd:string"
              },
              "schema:description": {
                "@type": "xsd:string"
              },
              "pav:createdOn": {
                "@type": "xsd:dateTime"
              },
              "pav:createdBy": {
                "@type": "@id"
              },
              "pav:lastUpdatedOn": {
                "@type": "xsd:dateTime"
              },
              "oslc:modifiedBy": {
                "@type": "@id"
              },
              "skos:notation": {
                "@type": "xsd:string"
              }
            },
            "schema:isBasedOn": "",
            "schema:name": "",
            "schema:description": "",
            "pav:createdOn": "",
            "pav:createdBy": "",
            "pav:lastUpdatedOn": "",
            "oslc:modifiedBy": "",
            "@id": ""
          };
        }
        static ɵfac = function (e) {
          return new (e || xi)();
        };
        static ɵprov = R({
          token: xi,
          factory: xi.ɵfac
        });
      }
      return xi;
    })();
    let Aa = /*#__PURE__*/(() => {
      class Aa {
        instance;
        template;
        constructor(t, e) {
          this.instance = t, this.template = e, this.templateSchema = e, this.instanceModel = t;
        }
        get data() {
          return this.dataChange.value;
        }
        formGroup;
        pageIndex;
        dataChange = new Xi([]);
        instanceModel;
        templateSchema;
        static getOptions(t, e) {
          const a = [];
          if (pn.isRadioCheckList(e)) {
            const i = ee.getLiterals(t);
            for (let o = 0; o < i.length; o++) {
              const s = {};
              s.label = i[o].label, s.value = o, a.push(s);
            }
          }
          return a;
        }
        static getNodeType(t, e) {
          let a;
          switch (e) {
            case A.numeric:
            case A.phoneNumber:
            case A.email:
            case A.link:
              a = A.textfield;
              break;
            case A.pageBreak:
            case A.sectionBreak:
            case A.richText:
            case A.image:
            case A.youTube:
              a = A.static;
              break;
            default:
              a = e;
          }
          return a;
        }
        static getNodeSubtype(t) {
          let e;
          switch (t) {
            case A.youTube:
              e = A.youTube;
              break;
            case A.image:
              e = A.image;
              break;
            case A.richText:
              e = A.richText;
              break;
            case A.sectionBreak:
              e = A.sectionBreak;
              break;
            case A.pageBreak:
              e = A.pageBreak;
              break;
            case A.email:
              e = A.email;
              break;
            case A.numeric:
              e = A.number;
              break;
            case A.link:
              e = A.url;
              break;
            case A.phoneNumber:
              e = A.tel;
              break;
            default:
              e = A.text;
          }
          return e;
        }
        static staticNode(t, e, a, i, o, r, s, c, l) {
          const d = ee.getNodeType(a),
            u = ee.getNodeSubtype(a);
          return {
            key: r,
            model: e,
            minItems: 0,
            maxItems: 0,
            itemCount: 0,
            name: ee.getTitle(t, null),
            type: d,
            subtype: u,
            formGroup: c,
            parentGroup: l ? l.formGroup : null,
            parent: l,
            staticValue: ee.getContent(t),
            size: ee.getSize(t)
          };
        }
        static attributeValueNode(t, e, a, i, o, r) {
          const s = Aa.getNodeType(t, A.attributeValue),
            c = Aa.getNodeSubtype(A.attributeValue);
          return {
            key: a,
            name: ee.getTitle(t),
            type: s,
            subtype: c,
            model: e,
            min: ee.getMin(t),
            max: ee.getMax(t),
            itemCount: 0,
            formGroup: o,
            parentGroup: r ? r.formGroup : null,
            parent: r,
            required: ee.isRequired(t),
            valueLocation: ee.getValueLocation(t, s, c),
            help: ee.getHelp(t),
            placeholder: ee.getPlaceholder(t),
            hint: ee.getHint(t)
          };
        }
        getTitle() {
          return this.instance ? ee.getTitle(this.template, null) : "";
        }
        initialize(t, e, a, i) {
          this.templateSchema = a, this.instanceModel = e || {}, this.formGroup = t, this.pageIndex = 0, this.dataChange.next(this.buildTree(this.templateSchema, this.instanceModel, 0, this.formGroup, null, i));
        }
        fieldNode(t, e, a, i, o, r, s, c, l, d) {
          const u = ee.getNodeType(i),
            m = ee.getNodeSubtype(i);
          return {
            key: s,
            name: ee.getTitle(t, a),
            type: u,
            subtype: m,
            model: e,
            minItems: o,
            maxItems: r,
            itemCount: 0,
            hidden: ee.getHidden(t),
            formGroup: l,
            parentGroup: d ? d.formGroup : null,
            parent: d,
            valueLocation: ee.getValueLocation(t, u, m),
            multiSelect: void 0 !== o && u !== A.controlled,
            multipleChoice: ee.isMultiValue(t),
            min: ee.getMin(t),
            max: ee.getMax(t),
            decimals: ee.getDecimals(t),
            minLength: ee.getMinStringLength(t),
            maxLength: ee.getMaxStringLength(t),
            valueConstraints: ee.getValueConstraints(t),
            options: Aa.getOptions(t, i),
            required: ee.isRequired(t),
            help: ee.getHelp(t),
            placeholder: ee.getPlaceholder(t),
            hint: ee.getHint(t)
          };
        }
        getFirst(t, e) {
          return Array.isArray(t) ? t[e] : t;
        }
        elementNode(t, e, a, i, o, r, s, c, l, d, u, m) {
          ee.getNodeType(A.element), ee.getNodeSubtype(A.element);
          const v = {
            key: s,
            name: ee.getTitle(t),
            model: e,
            minItems: i,
            maxItems: o,
            itemCount: r,
            parent: u,
            parentGroup: u ? u.formGroup : null,
            formGroup: new Ci({}),
            multiSelect: void 0 !== i,
            help: ee.getHelp(t)
          };
          return d.addControl(s + r, v.formGroup), t.properties && (v.children = this.buildTree(t, this.getFirst(l, r), c + 1, v.formGroup, v, m)), v;
        }
        buildTree(t, e, a, i, o, r) {
          const s = ee.getOrderofPage(t, r),
            c = ee.getProperties(t),
            l = ee.getLabels(t);
          return s.reduce((d, u) => {
            if (!ee.isSpecialKey(u)) {
              const m = c[u],
                h = m.maxItems,
                p = m.minItems,
                v = ee.schemaOf(m),
                C = ee.getInputType(v),
                k = l[u];
              if (null != e) {
                Object.hasOwn(e, u) || (e["@context"][u] = v["@id"], ee.isElement(v) ? e[u] = ee.initValue(v, u, A.element, p, h) : ee.isField(v) && (e[u] = ee.initValue(v, u, C, p, h)));
                const T = e[u];
                if (ee.isElement(v)) {
                  const w = T.length ? T.length : 1;
                  for (let N = 0; N < w; N++) {
                    const le = this.elementNode(v, e, k, p, h, N, u, a, T, i, o, 0);
                    d = d.concat(le);
                  }
                } else if (ee.isStaticField(v)) {
                  const w = Aa.staticNode(v, e, C, p, h, u, T, i, o);
                  d = d.concat(w);
                } else if (ee.isField(v)) if (pn.isAttributeValue(C)) {
                  const w = xi.buildAttributeValue(e, u),
                    N = Aa.attributeValueNode(v, e, u, w, i, o);
                  d = d.concat(N);
                } else {
                  const w = this.fieldNode(v, e, k, C, p, h, u, T, i, o);
                  d = d.concat(w);
                }
              }
            }
            return d;
          }, []);
        }
        static ɵfac = function (e) {
          return new (e || Aa)(M("instance", 8), M("template", 8));
        };
        static ɵprov = R({
          token: Aa,
          factory: Aa.ɵfac
        });
      }
      return Aa;
    })();
    const $Y = ["help"];
    function eq(n, t) {
      if (1 & n && j(0, "app-static-header", 5), 2 & n) {
        const e = x();
        b("callbackOwnerObject", e.sampleTemplateLoaderObject)("showSampleTemplateLinks", e.showSampleTemplateLinks);
      }
    }
    function tq(n, t) {
      1 & n && (_(0, "button", 8)(1, "mat-icon"), S(2, "help_outline"), y()()), 2 & n && b("matTooltip", x(2).description);
    }
    function nq(n, t) {
      1 & n && (_(0, "button", 8)(1, "mat-icon"), S(2, "help_outline"), y()()), 2 & n && b("matTooltip", x(4).pageDescription);
    }
    function aq(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "div")(1, "div", 14)(2, "h3"), S(3), D(4, nq, 3, 1, "button", 7), y(), _(5, "mat-paginator", 15), F("page", function (i) {
          return pe(e), ge(x(3).onPageChange(i));
        }), y()()();
      }
      if (2 & n) {
        const e = x(3);
        g(3), Fe("", e.pageTitle, " "), g(1), b("ngIf", e.pageDescription), g(1), b("length", e.pageEvent.length)("pageSize", 1)("hidePageSize", !0);
      }
    }
    function iq(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "li", 18), j(1, "button", 19), _(2, "app-question", 20), F("autocomplete", function (i) {
          return pe(e), ge(x(4).onAutocomplete(i));
        }), y()();
      }
      if (2 & n) {
        const e = x().$implicit,
          a = x(3);
        g(2), b("node", e)("mode", a.mode)("autocompleteResults", a.autocompleteResults)("parentGroup", e.formGroup);
      }
    }
    function oq(n, t) {
      if (1 & n && (_(0, "mat-tree-node", 16), D(1, iq, 3, 4, "li", 17), y()), 2 & n) {
        const e = t.$implicit,
          a = x(3);
        g(1), b("ngIf", a.notHidden(e));
      }
    }
    function rq(n, t) {
      if (1 & n && (_(0, "span", 28), S(1), y()), 2 & n) {
        const e = x().$implicit;
        g(1), qf("(", e.itemCount + 1, " of ", e.maxItems || "N", ")");
      }
    }
    function sq(n, t) {
      1 & n && (_(0, "button", 8)(1, "mat-icon"), S(2, "help_outline"), y()()), 2 & n && b("matTooltip", x().$implicit.help);
    }
    function cq(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "button", 29), F("click", function () {
          pe(e);
          const i = x().$implicit;
          return ge(x(3).copyItem(i));
        }), _(1, "mat-icon"), S(2, "add_circle_outline"), y()();
      }
    }
    function lq(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "button", 30), F("click", function () {
          pe(e);
          const i = x().$implicit;
          return ge(x(3).removeItem(i));
        }), _(1, "mat-icon"), S(2, "remove_circle_outline"), y()();
      }
    }
    function dq(n, t) {
      if (1 & n && j(0, "app-element", 33), 2 & n) {
        const e = x(2).$implicit,
          a = x(3);
        b("node", e)("mode", a.mode)("parentGroup", e.parentGroup)("formGroup", e.formGroup)("index", e.itemCount);
      }
    }
    function uq(n, t) {
      if (1 & n && (_(0, "ul"), D(1, dq, 1, 5, "app-element", 31), Rn(2, 32), y()), 2 & n) {
        const e = x().$implicit,
          a = x(3);
        fe("example-tree-invisible", !a.treeControl.isExpanded(e)), g(1), b("ngIf", a.treeControl.isExpanded(e));
      }
    }
    function fq(n, t) {
      if (1 & n && (_(0, "mat-nested-tree-node")(1, "li")(2, "div", 18)(3, "button", 21)(4, "mat-icon", 22), S(5), y()(), _(6, "span")(7, "label", 23), S(8), D(9, rq, 2, 2, "span", 24), y(), D(10, sq, 3, 1, "button", 7), D(11, cq, 3, 0, "button", 25), D(12, lq, 3, 0, "button", 26), y()(), D(13, uq, 3, 3, "ul", 27), y()()), 2 & n) {
        const e = t.$implicit,
          a = x(3);
        g(3), X("aria-label", "toggle " + e.filename), g(2), Fe(" ", a.treeControl.isExpanded(e) ? "expand_more" : "chevron_right", " "), g(2), X("for", e.name), g(1), Fe("", e.name, " "), g(1), b("ngIf", e.multiSelect), g(1), b("ngIf", e.help), g(1), b("ngIf", "edit" === a.mode && e.multiSelect), g(1), b("ngIf", "edit" === a.mode && e.multiSelect), g(1), b("ngIf", a.treeControl.isExpanded(e));
      }
    }
    function mq(n, t) {
      if (1 & n && (_(0, "form", 10), D(1, aq, 6, 5, "div", 4), _(2, "mat-tree", 11), D(3, oq, 2, 1, "mat-tree-node", 12), D(4, fq, 14, 9, "mat-nested-tree-node", 13), y()()), 2 & n) {
        const e = x(2);
        b("formGroup", e.form), g(1), b("ngIf", e.pageEvent.length > 1), g(1), b("dataSource", e.dataSource)("treeControl", e.treeControl), g(2), b("matTreeNodeDefWhen", e.hasNestedChild);
      }
    }
    function hq(n, t) {
      if (1 & n && (_(0, "div", 6)(1, "h2"), S(2), D(3, tq, 3, 1, "button", 7), _(4, "button", 8)(5, "mat-icon"), S(6, "info_outline"), y()()(), D(7, mq, 5, 5, "form", 9), y()), 2 & n) {
        const e = x();
        g(2), Fe("", e.title, " "), g(1), b("ngIf", e.description), g(1), b("matTooltip", e.getTemplateInfo()), g(3), b("ngIf", e.form);
      }
    }
    function pq(n, t) {
      if (1 & n && j(0, "app-source-panels", 34), 2 & n) {
        const e = x();
        b("showTemplateData", e.showTemplateData)("showInstanceData", e.showInstanceData)("expandedTemplateData", !1)("expandedInstanceData", !1)("templateData", e.template)("instanceData", e.instance);
      }
    }
    function gq(n, t) {
      if (1 & n && j(0, "app-sample-templates", 35), 2 & n) {
        const e = x();
        b("callbackOwnerObject", e.sampleTemplateLoaderObject)("expandedSampleTemplateLinks", e.expandedSampleTemplateLinks);
      }
    }
    function bq(n, t) {
      1 & n && j(0, "app-static-footer");
    }
    let qe = /*#__PURE__*/(() => {
      class qe {
        static INNER_VERSION = "2024-01-16 16:50";
        static TEMPLATE_LOCATION_PREFIX = "sampleTemplateLocationPrefix";
        static LOAD_SAMPLE_TEMPLATE_NAME = "loadSampleTemplateName";
        static FALLBACK_LANGUAGE = "fallbackLanguage";
        static DEFAULT_LANGUAGE = "defaultLanguage";
        static SHOW_SPINNER_BEFORE_INIT = "showSpinnerBeforeInit";
        static SHOW_TEMPLATE_DATA = "showTemplateData";
        static SHOW_INSTANCE_DATA = "showInstanceData";
        static SHOW_HEADER = "showHeader";
        static SHOW_FOOTER = "showFooter";
        static SHOW_SAMPLE_TEMPLATE_LINKS = "showSampleTemplateLinks";
        static EXPANDED_SAMPLE_TEMPLATE_LINKS = "expandedSampleTemplateLinks";
        instance;
        template;
        mode;
        autocompleteResults;
        autocomplete = new E();
        formChange = new E();
        help;
        form;
        title;
        description;
        dataSource;
        treeControl;
        database;
        pageEvent;
        pageTitle;
        pageDescription;
        sampleTemplateLoaderObject = null;
        showSampleTemplateLinks = !1;
        showTemplateData;
        showInstanceData;
        showHeader = !1;
        showFooter = !1;
        expandedSampleTemplateLinks = !1;
        constructor(t) {
          this.pageEvent = {
            previousPageIndex: 0,
            pageIndex: 0,
            pageSize: 1,
            length: 0
          }, this.database = t, this.dataSource = new ly(), this.treeControl = new Tv(this._getChildren), this.form = new Ci({}), console.log("CAV:" + qe.INNER_VERSION);
        }
        set config(t) {
          null != t && (Object.hasOwn(t, qe.SHOW_SAMPLE_TEMPLATE_LINKS) && (this.showSampleTemplateLinks = t[qe.SHOW_SAMPLE_TEMPLATE_LINKS]), Object.hasOwn(t, qe.SHOW_TEMPLATE_DATA) && (this.showTemplateData = t[qe.SHOW_TEMPLATE_DATA]), Object.hasOwn(t, qe.SHOW_INSTANCE_DATA) && (this.showInstanceData = t[qe.SHOW_INSTANCE_DATA]), Object.hasOwn(t, qe.SHOW_FOOTER) && (this.showFooter = t[qe.SHOW_FOOTER]), Object.hasOwn(t, qe.SHOW_HEADER) && (this.showHeader = t[qe.SHOW_HEADER]), Object.hasOwn(t, qe.EXPANDED_SAMPLE_TEMPLATE_LINKS) && (this.expandedSampleTemplateLinks = t[qe.EXPANDED_SAMPLE_TEMPLATE_LINKS]));
        }
        ngOnInit() {
          this.initialize();
        }
        onPageChange(t) {
          this.pageEvent = t, this.initialize(), this.pageTitle = ee.getTitleofPage(this.template, t.pageIndex), this.pageDescription = ee.getDescriptionOfPage(this.template, t.pageIndex);
        }
        onAutocomplete(t) {
          this.autocomplete.emit(t);
        }
        ngOnChanges(t) {
          t.autocompleteResults && t.autocompleteResults.currentValue.length > 0 ? this.autocompleteResults = t.autocompleteResults.currentValue : this.initialize();
        }
        hasNestedChild = (t, e) => !e.type;
        notHidden = t => !t.hidden;
        _getChildren = t => t.children;
        initialize() {
          this.instance && this.template && (this.pageEvent.length = ee.getPageCount(this.template), this.title = xi.getTitle(this.instance) || ee.getTitle(this.template), this.description = xi.getDescription(this.instance) || ee.getDescription(this.template), this.database.initialize(this.form, this.instance, this.template, this.pageEvent.pageIndex), this.database.dataChange.subscribe(t => {
            t && t.length > 0 && (this.dataSource = new ly(), this.dataSource.data = t, this.treeControl = new Tv(this._getChildren));
          }), this.emitChanges(this.form.value), this.onChanges());
        }
        isDisabled() {
          return "view" === this.mode;
        }
        isHidden(t) {
          return t.hidden;
        }
        copyItem(t) {
          const e = nC(t.model[t.key][t.itemCount]);
          t.model[t.key].splice(t.itemCount + 1, 0, e);
          const a = nC(t);
          a.model = t.model, a.itemCount++;
          const i = t.parent ? t.parent.children : this.database.data,
            o = i.indexOf(t);
          i.splice(o + 1, 0, a);
          for (let s = o + 2; s < i.length; s++) i[s].key === t.key && i[s].itemCount++;
          this.updateModel(a, t.model), (t.parentGroup || this.form).addControl(a.key + a.itemCount, a.formGroup), this.database.dataChange.next(this.database.data);
        }
        removeItem(t) {
          const e = t.parent ? t.parent.children : this.database.data,
            a = e.indexOf(t);
          e.splice(a, 1);
          for (let o = a; o < e.length; o++) e[o].key === t.key && e[o].itemCount--;
          (t.parentGroup || this.form).removeControl(t.key + t.itemCount), this.database.dataChange.next(this.database.data);
        }
        updateModel(t, e) {
          if (t.model = e, t.children) {
            const a = this,
              i = t.key,
              o = t.itemCount;
            Array.isArray(e[i]) ? t.children.forEach(function (r) {
              a.updateModel(r, e[i][o]);
            }) : t.children.forEach(function (r) {
              a.updateModel(r, e[i]);
            });
          }
        }
        validateAllFormFields(t) {
          Object.keys(t.controls).forEach(e => {
            const a = t.get(e);
            a instanceof at ? a.markAsTouched({
              onlySelf: !0
            }) : a instanceof ep ? a.controls.forEach(i => {
              i.markAsTouched({
                onlySelf: !0
              });
            }) : a instanceof Ci && this.validateAllFormFields(a);
          });
        }
        emitChanges(t) {
          this.validateAllFormFields(this.form), this.formChange.emit({
            title: this.title,
            description: this.description,
            valid: this.form.valid,
            value: t
          });
        }
        onChanges() {
          this.form && this.form.valueChanges && this.form.valueChanges.subscribe(t => {
            this.emitChanges(t);
          });
        }
        parseDate(t) {
          let e;
          if (t) {
            const a = new Date(t);
            a.setMinutes(a.getMinutes() + a.getTimezoneOffset()), e = a;
          }
          return e;
        }
        getTemplateInfo() {
          let t;
          return this.template && Object.hasOwn(this.template, "pav:lastUpdatedOn") && (t = this.parseDate(this.template["pav:lastUpdatedOn"].substring(0, 10)).toDateString()), t;
        }
        dataAvailableForRender() {
          return null != this.template;
        }
        headerDataAvailableForRender() {
          return !0;
        }
        set templateJsonObject(t) {
          this.template = t;
        }
        set instanceJsonObject(t) {
          this.instance = t;
        }
        static ɵfac = function (e) {
          return new (e || qe)(f(Aa));
        };
        static ɵcmp = q({
          type: qe,
          selectors: [["app-cedar-artifact-viewer"]],
          viewQuery: function (e, a) {
            if (1 & e && be($Y, 7), 2 & e) {
              let i;
              H(i = B()) && (a.help = i.first);
            }
          },
          inputs: {
            mode: "mode",
            autocompleteResults: "autocompleteResults",
            sampleTemplateLoaderObject: "sampleTemplateLoaderObject",
            config: "config",
            templateJsonObject: "templateJsonObject",
            instanceJsonObject: "instanceJsonObject"
          },
          outputs: {
            autocomplete: "autocomplete",
            formChange: "formChange"
          },
          features: [G([Aa]), Ve],
          decls: 5,
          vars: 5,
          consts: [[3, "callbackOwnerObject", "showSampleTemplateLinks", 4, "ngIf"], ["class", "cedar-form-body", 4, "ngIf"], [3, "showTemplateData", "showInstanceData", "expandedTemplateData", "expandedInstanceData", "templateData", "instanceData", 4, "ngIf"], [3, "callbackOwnerObject", "expandedSampleTemplateLinks", 4, "ngIf"], [4, "ngIf"], [3, "callbackOwnerObject", "showSampleTemplateLinks"], [1, "cedar-form-body"], ["mat-icon-button", "", "class", "mat-icon-button help", "matTooltipPosition", "right", 3, "matTooltip", 4, "ngIf"], ["mat-icon-button", "", "matTooltipPosition", "right", 1, "mat-icon-button", "help", 3, "matTooltip"], ["class", "cedar-form", 3, "formGroup", 4, "ngIf"], [1, "cedar-form", 3, "formGroup"], [2, "background", "transparent !important", 3, "dataSource", "treeControl"], ["matTreeNodeToggle", "", 4, "matTreeNodeDef"], [4, "matTreeNodeDef", "matTreeNodeDefWhen"], [2, "display", "flex", "justify-content", "space-between", "border-bottom", "1px solid #ccc", "margin-bottom", "40px"], [3, "length", "pageSize", "hidePageSize", "page"], ["matTreeNodeToggle", ""], ["class", "mat-tree-node", 4, "ngIf"], [1, "mat-tree-node"], ["mat-icon-button", "", "disabled", ""], [2, "width", "100%", 3, "node", "mode", "autocompleteResults", "parentGroup", "autocomplete"], ["mat-icon-button", "", "matTreeNodeToggle", ""], [1, "mat-icon-rtl-mirror"], [1, "element-label"], ["style", "font-weight:normal", 4, "ngIf"], ["mat-icon-button", "", "class", "node-add", 3, "click", 4, "ngIf"], ["mat-icon-button", "", "class", "node-remove", 3, "click", 4, "ngIf"], [3, "example-tree-invisible", 4, "ngIf"], [2, "font-weight", "normal"], ["mat-icon-button", "", 1, "node-add", 3, "click"], ["mat-icon-button", "", 1, "node-remove", 3, "click"], [3, "node", "mode", "parentGroup", "formGroup", "index", 4, "ngIf"], ["matTreeNodeOutlet", ""], [3, "node", "mode", "parentGroup", "formGroup", "index"], [3, "showTemplateData", "showInstanceData", "expandedTemplateData", "expandedInstanceData", "templateData", "instanceData"], [3, "callbackOwnerObject", "expandedSampleTemplateLinks"]],
          template: function (e, a) {
            1 & e && (D(0, eq, 1, 2, "app-static-header", 0), D(1, hq, 8, 4, "div", 1), D(2, pq, 1, 6, "app-source-panels", 2), D(3, gq, 1, 2, "app-sample-templates", 3), D(4, bq, 1, 0, "app-static-footer", 4)), 2 & e && (b("ngIf", a.headerDataAvailableForRender() && a.showHeader), g(1), b("ngIf", a.dataAvailableForRender()), g(1), b("ngIf", a.dataAvailableForRender()), g(1), b("ngIf", a.dataAvailableForRender() && a.showSampleTemplateLinks), g(1), b("ngIf", a.dataAvailableForRender() && a.showFooter));
          },
          styles: ['/*!\n * Font Awesome Free 5.9.0 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n */.fa,.fas,.far,.fal,.fab{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;display:inline-block;font-style:normal;font-variant:normal;text-rendering:auto;line-height:1}.fa-lg{font-size:1.33333em;line-height:.75em;vertical-align:-.0667em}.fa-xs{font-size:.75em}.fa-sm{font-size:.875em}.fa-1x{font-size:1em}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-6x{font-size:6em}.fa-7x{font-size:7em}.fa-8x{font-size:8em}.fa-9x{font-size:9em}.fa-10x{font-size:10em}.fa-fw{text-align:center;width:1.25em}.fa-ul{list-style-type:none;margin-left:2.5em;padding-left:0}.fa-ul>li{position:relative}.fa-li{left:-2em;position:absolute;text-align:center;width:2em;line-height:inherit}.fa-border{border:solid .08em #eee;border-radius:.1em;padding:.2em .25em .15em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left,.fas.fa-pull-left,.far.fa-pull-left,.fal.fa-pull-left,.fab.fa-pull-left{margin-right:.3em}.fa.fa-pull-right,.fas.fa-pull-right,.far.fa-pull-right,.fal.fa-pull-right,.fab.fa-pull-right{margin-left:.3em}.fa-spin{animation:fa-spin 2s infinite linear}.fa-pulse{animation:fa-spin 1s infinite steps(8)}@keyframes fa-spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.fa-rotate-90{-ms-filter:"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";transform:rotate(90deg)}.fa-rotate-180{-ms-filter:"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";transform:rotate(180deg)}.fa-rotate-270{-ms-filter:"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";transform:scaleY(-1)}.fa-flip-both,.fa-flip-horizontal.fa-flip-vertical{-ms-filter:"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";transform:scale(-1)}:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270,:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-flip-both{filter:none}.fa-stack{display:inline-block;height:2em;line-height:2em;position:relative;vertical-align:middle;width:2.5em}.fa-stack-1x,.fa-stack-2x{left:0;position:absolute;text-align:center;width:100%}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-500px:before{content:"\\f26e"}.fa-accessible-icon:before{content:"\\f368"}.fa-accusoft:before{content:"\\f369"}.fa-acquisitions-incorporated:before{content:"\\f6af"}.fa-ad:before{content:"\\f641"}.fa-address-book:before{content:"\\f2b9"}.fa-address-card:before{content:"\\f2bb"}.fa-adjust:before{content:"\\f042"}.fa-adn:before{content:"\\f170"}.fa-adobe:before{content:"\\f778"}.fa-adversal:before{content:"\\f36a"}.fa-affiliatetheme:before{content:"\\f36b"}.fa-air-freshener:before{content:"\\f5d0"}.fa-airbnb:before{content:"\\f834"}.fa-algolia:before{content:"\\f36c"}.fa-align-center:before{content:"\\f037"}.fa-align-justify:before{content:"\\f039"}.fa-align-left:before{content:"\\f036"}.fa-align-right:before{content:"\\f038"}.fa-alipay:before{content:"\\f642"}.fa-allergies:before{content:"\\f461"}.fa-amazon:before{content:"\\f270"}.fa-amazon-pay:before{content:"\\f42c"}.fa-ambulance:before{content:"\\f0f9"}.fa-american-sign-language-interpreting:before{content:"\\f2a3"}.fa-amilia:before{content:"\\f36d"}.fa-anchor:before{content:"\\f13d"}.fa-android:before{content:"\\f17b"}.fa-angellist:before{content:"\\f209"}.fa-angle-double-down:before{content:"\\f103"}.fa-angle-double-left:before{content:"\\f100"}.fa-angle-double-right:before{content:"\\f101"}.fa-angle-double-up:before{content:"\\f102"}.fa-angle-down:before{content:"\\f107"}.fa-angle-left:before{content:"\\f104"}.fa-angle-right:before{content:"\\f105"}.fa-angle-up:before{content:"\\f106"}.fa-angry:before{content:"\\f556"}.fa-angrycreative:before{content:"\\f36e"}.fa-angular:before{content:"\\f420"}.fa-ankh:before{content:"\\f644"}.fa-app-store:before{content:"\\f36f"}.fa-app-store-ios:before{content:"\\f370"}.fa-apper:before{content:"\\f371"}.fa-apple:before{content:"\\f179"}.fa-apple-alt:before{content:"\\f5d1"}.fa-apple-pay:before{content:"\\f415"}.fa-archive:before{content:"\\f187"}.fa-archway:before{content:"\\f557"}.fa-arrow-alt-circle-down:before{content:"\\f358"}.fa-arrow-alt-circle-left:before{content:"\\f359"}.fa-arrow-alt-circle-right:before{content:"\\f35a"}.fa-arrow-alt-circle-up:before{content:"\\f35b"}.fa-arrow-circle-down:before{content:"\\f0ab"}.fa-arrow-circle-left:before{content:"\\f0a8"}.fa-arrow-circle-right:before{content:"\\f0a9"}.fa-arrow-circle-up:before{content:"\\f0aa"}.fa-arrow-down:before{content:"\\f063"}.fa-arrow-left:before{content:"\\f060"}.fa-arrow-right:before{content:"\\f061"}.fa-arrow-up:before{content:"\\f062"}.fa-arrows-alt:before{content:"\\f0b2"}.fa-arrows-alt-h:before{content:"\\f337"}.fa-arrows-alt-v:before{content:"\\f338"}.fa-artstation:before{content:"\\f77a"}.fa-assistive-listening-systems:before{content:"\\f2a2"}.fa-asterisk:before{content:"\\f069"}.fa-asymmetrik:before{content:"\\f372"}.fa-at:before{content:"\\f1fa"}.fa-atlas:before{content:"\\f558"}.fa-atlassian:before{content:"\\f77b"}.fa-atom:before{content:"\\f5d2"}.fa-audible:before{content:"\\f373"}.fa-audio-description:before{content:"\\f29e"}.fa-autoprefixer:before{content:"\\f41c"}.fa-avianex:before{content:"\\f374"}.fa-aviato:before{content:"\\f421"}.fa-award:before{content:"\\f559"}.fa-aws:before{content:"\\f375"}.fa-baby:before{content:"\\f77c"}.fa-baby-carriage:before{content:"\\f77d"}.fa-backspace:before{content:"\\f55a"}.fa-backward:before{content:"\\f04a"}.fa-bacon:before{content:"\\f7e5"}.fa-balance-scale:before{content:"\\f24e"}.fa-balance-scale-left:before{content:"\\f515"}.fa-balance-scale-right:before{content:"\\f516"}.fa-ban:before{content:"\\f05e"}.fa-band-aid:before{content:"\\f462"}.fa-bandcamp:before{content:"\\f2d5"}.fa-barcode:before{content:"\\f02a"}.fa-bars:before{content:"\\f0c9"}.fa-baseball-ball:before{content:"\\f433"}.fa-basketball-ball:before{content:"\\f434"}.fa-bath:before{content:"\\f2cd"}.fa-battery-empty:before{content:"\\f244"}.fa-battery-full:before{content:"\\f240"}.fa-battery-half:before{content:"\\f242"}.fa-battery-quarter:before{content:"\\f243"}.fa-battery-three-quarters:before{content:"\\f241"}.fa-battle-net:before{content:"\\f835"}.fa-bed:before{content:"\\f236"}.fa-beer:before{content:"\\f0fc"}.fa-behance:before{content:"\\f1b4"}.fa-behance-square:before{content:"\\f1b5"}.fa-bell:before{content:"\\f0f3"}.fa-bell-slash:before{content:"\\f1f6"}.fa-bezier-curve:before{content:"\\f55b"}.fa-bible:before{content:"\\f647"}.fa-bicycle:before{content:"\\f206"}.fa-biking:before{content:"\\f84a"}.fa-bimobject:before{content:"\\f378"}.fa-binoculars:before{content:"\\f1e5"}.fa-biohazard:before{content:"\\f780"}.fa-birthday-cake:before{content:"\\f1fd"}.fa-bitbucket:before{content:"\\f171"}.fa-bitcoin:before{content:"\\f379"}.fa-bity:before{content:"\\f37a"}.fa-black-tie:before{content:"\\f27e"}.fa-blackberry:before{content:"\\f37b"}.fa-blender:before{content:"\\f517"}.fa-blender-phone:before{content:"\\f6b6"}.fa-blind:before{content:"\\f29d"}.fa-blog:before{content:"\\f781"}.fa-blogger:before{content:"\\f37c"}.fa-blogger-b:before{content:"\\f37d"}.fa-bluetooth:before{content:"\\f293"}.fa-bluetooth-b:before{content:"\\f294"}.fa-bold:before{content:"\\f032"}.fa-bolt:before{content:"\\f0e7"}.fa-bomb:before{content:"\\f1e2"}.fa-bone:before{content:"\\f5d7"}.fa-bong:before{content:"\\f55c"}.fa-book:before{content:"\\f02d"}.fa-book-dead:before{content:"\\f6b7"}.fa-book-medical:before{content:"\\f7e6"}.fa-book-open:before{content:"\\f518"}.fa-book-reader:before{content:"\\f5da"}.fa-bookmark:before{content:"\\f02e"}.fa-bootstrap:before{content:"\\f836"}.fa-border-all:before{content:"\\f84c"}.fa-border-none:before{content:"\\f850"}.fa-border-style:before{content:"\\f853"}.fa-bowling-ball:before{content:"\\f436"}.fa-box:before{content:"\\f466"}.fa-box-open:before{content:"\\f49e"}.fa-boxes:before{content:"\\f468"}.fa-braille:before{content:"\\f2a1"}.fa-brain:before{content:"\\f5dc"}.fa-bread-slice:before{content:"\\f7ec"}.fa-briefcase:before{content:"\\f0b1"}.fa-briefcase-medical:before{content:"\\f469"}.fa-broadcast-tower:before{content:"\\f519"}.fa-broom:before{content:"\\f51a"}.fa-brush:before{content:"\\f55d"}.fa-btc:before{content:"\\f15a"}.fa-buffer:before{content:"\\f837"}.fa-bug:before{content:"\\f188"}.fa-building:before{content:"\\f1ad"}.fa-bullhorn:before{content:"\\f0a1"}.fa-bullseye:before{content:"\\f140"}.fa-burn:before{content:"\\f46a"}.fa-buromobelexperte:before{content:"\\f37f"}.fa-bus:before{content:"\\f207"}.fa-bus-alt:before{content:"\\f55e"}.fa-business-time:before{content:"\\f64a"}.fa-buysellads:before{content:"\\f20d"}.fa-calculator:before{content:"\\f1ec"}.fa-calendar:before{content:"\\f133"}.fa-calendar-alt:before{content:"\\f073"}.fa-calendar-check:before{content:"\\f274"}.fa-calendar-day:before{content:"\\f783"}.fa-calendar-minus:before{content:"\\f272"}.fa-calendar-plus:before{content:"\\f271"}.fa-calendar-times:before{content:"\\f273"}.fa-calendar-week:before{content:"\\f784"}.fa-camera:before{content:"\\f030"}.fa-camera-retro:before{content:"\\f083"}.fa-campground:before{content:"\\f6bb"}.fa-canadian-maple-leaf:before{content:"\\f785"}.fa-candy-cane:before{content:"\\f786"}.fa-cannabis:before{content:"\\f55f"}.fa-capsules:before{content:"\\f46b"}.fa-car:before{content:"\\f1b9"}.fa-car-alt:before{content:"\\f5de"}.fa-car-battery:before{content:"\\f5df"}.fa-car-crash:before{content:"\\f5e1"}.fa-car-side:before{content:"\\f5e4"}.fa-caret-down:before{content:"\\f0d7"}.fa-caret-left:before{content:"\\f0d9"}.fa-caret-right:before{content:"\\f0da"}.fa-caret-square-down:before{content:"\\f150"}.fa-caret-square-left:before{content:"\\f191"}.fa-caret-square-right:before{content:"\\f152"}.fa-caret-square-up:before{content:"\\f151"}.fa-caret-up:before{content:"\\f0d8"}.fa-carrot:before{content:"\\f787"}.fa-cart-arrow-down:before{content:"\\f218"}.fa-cart-plus:before{content:"\\f217"}.fa-cash-register:before{content:"\\f788"}.fa-cat:before{content:"\\f6be"}.fa-cc-amazon-pay:before{content:"\\f42d"}.fa-cc-amex:before{content:"\\f1f3"}.fa-cc-apple-pay:before{content:"\\f416"}.fa-cc-diners-club:before{content:"\\f24c"}.fa-cc-discover:before{content:"\\f1f2"}.fa-cc-jcb:before{content:"\\f24b"}.fa-cc-mastercard:before{content:"\\f1f1"}.fa-cc-paypal:before{content:"\\f1f4"}.fa-cc-stripe:before{content:"\\f1f5"}.fa-cc-visa:before{content:"\\f1f0"}.fa-centercode:before{content:"\\f380"}.fa-centos:before{content:"\\f789"}.fa-certificate:before{content:"\\f0a3"}.fa-chair:before{content:"\\f6c0"}.fa-chalkboard:before{content:"\\f51b"}.fa-chalkboard-teacher:before{content:"\\f51c"}.fa-charging-station:before{content:"\\f5e7"}.fa-chart-area:before{content:"\\f1fe"}.fa-chart-bar:before{content:"\\f080"}.fa-chart-line:before{content:"\\f201"}.fa-chart-pie:before{content:"\\f200"}.fa-check:before{content:"\\f00c"}.fa-check-circle:before{content:"\\f058"}.fa-check-double:before{content:"\\f560"}.fa-check-square:before{content:"\\f14a"}.fa-cheese:before{content:"\\f7ef"}.fa-chess:before{content:"\\f439"}.fa-chess-bishop:before{content:"\\f43a"}.fa-chess-board:before{content:"\\f43c"}.fa-chess-king:before{content:"\\f43f"}.fa-chess-knight:before{content:"\\f441"}.fa-chess-pawn:before{content:"\\f443"}.fa-chess-queen:before{content:"\\f445"}.fa-chess-rook:before{content:"\\f447"}.fa-chevron-circle-down:before{content:"\\f13a"}.fa-chevron-circle-left:before{content:"\\f137"}.fa-chevron-circle-right:before{content:"\\f138"}.fa-chevron-circle-up:before{content:"\\f139"}.fa-chevron-down:before{content:"\\f078"}.fa-chevron-left:before{content:"\\f053"}.fa-chevron-right:before{content:"\\f054"}.fa-chevron-up:before{content:"\\f077"}.fa-child:before{content:"\\f1ae"}.fa-chrome:before{content:"\\f268"}.fa-chromecast:before{content:"\\f838"}.fa-church:before{content:"\\f51d"}.fa-circle:before{content:"\\f111"}.fa-circle-notch:before{content:"\\f1ce"}.fa-city:before{content:"\\f64f"}.fa-clinic-medical:before{content:"\\f7f2"}.fa-clipboard:before{content:"\\f328"}.fa-clipboard-check:before{content:"\\f46c"}.fa-clipboard-list:before{content:"\\f46d"}.fa-clock:before{content:"\\f017"}.fa-clone:before{content:"\\f24d"}.fa-closed-captioning:before{content:"\\f20a"}.fa-cloud:before{content:"\\f0c2"}.fa-cloud-download-alt:before{content:"\\f381"}.fa-cloud-meatball:before{content:"\\f73b"}.fa-cloud-moon:before{content:"\\f6c3"}.fa-cloud-moon-rain:before{content:"\\f73c"}.fa-cloud-rain:before{content:"\\f73d"}.fa-cloud-showers-heavy:before{content:"\\f740"}.fa-cloud-sun:before{content:"\\f6c4"}.fa-cloud-sun-rain:before{content:"\\f743"}.fa-cloud-upload-alt:before{content:"\\f382"}.fa-cloudscale:before{content:"\\f383"}.fa-cloudsmith:before{content:"\\f384"}.fa-cloudversify:before{content:"\\f385"}.fa-cocktail:before{content:"\\f561"}.fa-code:before{content:"\\f121"}.fa-code-branch:before{content:"\\f126"}.fa-codepen:before{content:"\\f1cb"}.fa-codiepie:before{content:"\\f284"}.fa-coffee:before{content:"\\f0f4"}.fa-cog:before{content:"\\f013"}.fa-cogs:before{content:"\\f085"}.fa-coins:before{content:"\\f51e"}.fa-columns:before{content:"\\f0db"}.fa-comment:before{content:"\\f075"}.fa-comment-alt:before{content:"\\f27a"}.fa-comment-dollar:before{content:"\\f651"}.fa-comment-dots:before{content:"\\f4ad"}.fa-comment-medical:before{content:"\\f7f5"}.fa-comment-slash:before{content:"\\f4b3"}.fa-comments:before{content:"\\f086"}.fa-comments-dollar:before{content:"\\f653"}.fa-compact-disc:before{content:"\\f51f"}.fa-compass:before{content:"\\f14e"}.fa-compress:before{content:"\\f066"}.fa-compress-arrows-alt:before{content:"\\f78c"}.fa-concierge-bell:before{content:"\\f562"}.fa-confluence:before{content:"\\f78d"}.fa-connectdevelop:before{content:"\\f20e"}.fa-contao:before{content:"\\f26d"}.fa-cookie:before{content:"\\f563"}.fa-cookie-bite:before{content:"\\f564"}.fa-copy:before{content:"\\f0c5"}.fa-copyright:before{content:"\\f1f9"}.fa-couch:before{content:"\\f4b8"}.fa-cpanel:before{content:"\\f388"}.fa-creative-commons:before{content:"\\f25e"}.fa-creative-commons-by:before{content:"\\f4e7"}.fa-creative-commons-nc:before{content:"\\f4e8"}.fa-creative-commons-nc-eu:before{content:"\\f4e9"}.fa-creative-commons-nc-jp:before{content:"\\f4ea"}.fa-creative-commons-nd:before{content:"\\f4eb"}.fa-creative-commons-pd:before{content:"\\f4ec"}.fa-creative-commons-pd-alt:before{content:"\\f4ed"}.fa-creative-commons-remix:before{content:"\\f4ee"}.fa-creative-commons-sa:before{content:"\\f4ef"}.fa-creative-commons-sampling:before{content:"\\f4f0"}.fa-creative-commons-sampling-plus:before{content:"\\f4f1"}.fa-creative-commons-share:before{content:"\\f4f2"}.fa-creative-commons-zero:before{content:"\\f4f3"}.fa-credit-card:before{content:"\\f09d"}.fa-critical-role:before{content:"\\f6c9"}.fa-crop:before{content:"\\f125"}.fa-crop-alt:before{content:"\\f565"}.fa-cross:before{content:"\\f654"}.fa-crosshairs:before{content:"\\f05b"}.fa-crow:before{content:"\\f520"}.fa-crown:before{content:"\\f521"}.fa-crutch:before{content:"\\f7f7"}.fa-css3:before{content:"\\f13c"}.fa-css3-alt:before{content:"\\f38b"}.fa-cube:before{content:"\\f1b2"}.fa-cubes:before{content:"\\f1b3"}.fa-cut:before{content:"\\f0c4"}.fa-cuttlefish:before{content:"\\f38c"}.fa-d-and-d:before{content:"\\f38d"}.fa-d-and-d-beyond:before{content:"\\f6ca"}.fa-dashcube:before{content:"\\f210"}.fa-database:before{content:"\\f1c0"}.fa-deaf:before{content:"\\f2a4"}.fa-delicious:before{content:"\\f1a5"}.fa-democrat:before{content:"\\f747"}.fa-deploydog:before{content:"\\f38e"}.fa-deskpro:before{content:"\\f38f"}.fa-desktop:before{content:"\\f108"}.fa-dev:before{content:"\\f6cc"}.fa-deviantart:before{content:"\\f1bd"}.fa-dharmachakra:before{content:"\\f655"}.fa-dhl:before{content:"\\f790"}.fa-diagnoses:before{content:"\\f470"}.fa-diaspora:before{content:"\\f791"}.fa-dice:before{content:"\\f522"}.fa-dice-d20:before{content:"\\f6cf"}.fa-dice-d6:before{content:"\\f6d1"}.fa-dice-five:before{content:"\\f523"}.fa-dice-four:before{content:"\\f524"}.fa-dice-one:before{content:"\\f525"}.fa-dice-six:before{content:"\\f526"}.fa-dice-three:before{content:"\\f527"}.fa-dice-two:before{content:"\\f528"}.fa-digg:before{content:"\\f1a6"}.fa-digital-ocean:before{content:"\\f391"}.fa-digital-tachograph:before{content:"\\f566"}.fa-directions:before{content:"\\f5eb"}.fa-discord:before{content:"\\f392"}.fa-discourse:before{content:"\\f393"}.fa-divide:before{content:"\\f529"}.fa-dizzy:before{content:"\\f567"}.fa-dna:before{content:"\\f471"}.fa-dochub:before{content:"\\f394"}.fa-docker:before{content:"\\f395"}.fa-dog:before{content:"\\f6d3"}.fa-dollar-sign:before{content:"\\f155"}.fa-dolly:before{content:"\\f472"}.fa-dolly-flatbed:before{content:"\\f474"}.fa-donate:before{content:"\\f4b9"}.fa-door-closed:before{content:"\\f52a"}.fa-door-open:before{content:"\\f52b"}.fa-dot-circle:before{content:"\\f192"}.fa-dove:before{content:"\\f4ba"}.fa-download:before{content:"\\f019"}.fa-draft2digital:before{content:"\\f396"}.fa-drafting-compass:before{content:"\\f568"}.fa-dragon:before{content:"\\f6d5"}.fa-draw-polygon:before{content:"\\f5ee"}.fa-dribbble:before{content:"\\f17d"}.fa-dribbble-square:before{content:"\\f397"}.fa-dropbox:before{content:"\\f16b"}.fa-drum:before{content:"\\f569"}.fa-drum-steelpan:before{content:"\\f56a"}.fa-drumstick-bite:before{content:"\\f6d7"}.fa-drupal:before{content:"\\f1a9"}.fa-dumbbell:before{content:"\\f44b"}.fa-dumpster:before{content:"\\f793"}.fa-dumpster-fire:before{content:"\\f794"}.fa-dungeon:before{content:"\\f6d9"}.fa-dyalog:before{content:"\\f399"}.fa-earlybirds:before{content:"\\f39a"}.fa-ebay:before{content:"\\f4f4"}.fa-edge:before{content:"\\f282"}.fa-edit:before{content:"\\f044"}.fa-egg:before{content:"\\f7fb"}.fa-eject:before{content:"\\f052"}.fa-elementor:before{content:"\\f430"}.fa-ellipsis-h:before{content:"\\f141"}.fa-ellipsis-v:before{content:"\\f142"}.fa-ello:before{content:"\\f5f1"}.fa-ember:before{content:"\\f423"}.fa-empire:before{content:"\\f1d1"}.fa-envelope:before{content:"\\f0e0"}.fa-envelope-open:before{content:"\\f2b6"}.fa-envelope-open-text:before{content:"\\f658"}.fa-envelope-square:before{content:"\\f199"}.fa-envira:before{content:"\\f299"}.fa-equals:before{content:"\\f52c"}.fa-eraser:before{content:"\\f12d"}.fa-erlang:before{content:"\\f39d"}.fa-ethereum:before{content:"\\f42e"}.fa-ethernet:before{content:"\\f796"}.fa-etsy:before{content:"\\f2d7"}.fa-euro-sign:before{content:"\\f153"}.fa-evernote:before{content:"\\f839"}.fa-exchange-alt:before{content:"\\f362"}.fa-exclamation:before{content:"\\f12a"}.fa-exclamation-circle:before{content:"\\f06a"}.fa-exclamation-triangle:before{content:"\\f071"}.fa-expand:before{content:"\\f065"}.fa-expand-arrows-alt:before{content:"\\f31e"}.fa-expeditedssl:before{content:"\\f23e"}.fa-external-link-alt:before{content:"\\f35d"}.fa-external-link-square-alt:before{content:"\\f360"}.fa-eye:before{content:"\\f06e"}.fa-eye-dropper:before{content:"\\f1fb"}.fa-eye-slash:before{content:"\\f070"}.fa-facebook:before{content:"\\f09a"}.fa-facebook-f:before{content:"\\f39e"}.fa-facebook-messenger:before{content:"\\f39f"}.fa-facebook-square:before{content:"\\f082"}.fa-fan:before{content:"\\f863"}.fa-fantasy-flight-games:before{content:"\\f6dc"}.fa-fast-backward:before{content:"\\f049"}.fa-fast-forward:before{content:"\\f050"}.fa-fax:before{content:"\\f1ac"}.fa-feather:before{content:"\\f52d"}.fa-feather-alt:before{content:"\\f56b"}.fa-fedex:before{content:"\\f797"}.fa-fedora:before{content:"\\f798"}.fa-female:before{content:"\\f182"}.fa-fighter-jet:before{content:"\\f0fb"}.fa-figma:before{content:"\\f799"}.fa-file:before{content:"\\f15b"}.fa-file-alt:before{content:"\\f15c"}.fa-file-archive:before{content:"\\f1c6"}.fa-file-audio:before{content:"\\f1c7"}.fa-file-code:before{content:"\\f1c9"}.fa-file-contract:before{content:"\\f56c"}.fa-file-csv:before{content:"\\f6dd"}.fa-file-download:before{content:"\\f56d"}.fa-file-excel:before{content:"\\f1c3"}.fa-file-export:before{content:"\\f56e"}.fa-file-image:before{content:"\\f1c5"}.fa-file-import:before{content:"\\f56f"}.fa-file-invoice:before{content:"\\f570"}.fa-file-invoice-dollar:before{content:"\\f571"}.fa-file-medical:before{content:"\\f477"}.fa-file-medical-alt:before{content:"\\f478"}.fa-file-pdf:before{content:"\\f1c1"}.fa-file-powerpoint:before{content:"\\f1c4"}.fa-file-prescription:before{content:"\\f572"}.fa-file-signature:before{content:"\\f573"}.fa-file-upload:before{content:"\\f574"}.fa-file-video:before{content:"\\f1c8"}.fa-file-word:before{content:"\\f1c2"}.fa-fill:before{content:"\\f575"}.fa-fill-drip:before{content:"\\f576"}.fa-film:before{content:"\\f008"}.fa-filter:before{content:"\\f0b0"}.fa-fingerprint:before{content:"\\f577"}.fa-fire:before{content:"\\f06d"}.fa-fire-alt:before{content:"\\f7e4"}.fa-fire-extinguisher:before{content:"\\f134"}.fa-firefox:before{content:"\\f269"}.fa-first-aid:before{content:"\\f479"}.fa-first-order:before{content:"\\f2b0"}.fa-first-order-alt:before{content:"\\f50a"}.fa-firstdraft:before{content:"\\f3a1"}.fa-fish:before{content:"\\f578"}.fa-fist-raised:before{content:"\\f6de"}.fa-flag:before{content:"\\f024"}.fa-flag-checkered:before{content:"\\f11e"}.fa-flag-usa:before{content:"\\f74d"}.fa-flask:before{content:"\\f0c3"}.fa-flickr:before{content:"\\f16e"}.fa-flipboard:before{content:"\\f44d"}.fa-flushed:before{content:"\\f579"}.fa-fly:before{content:"\\f417"}.fa-folder:before{content:"\\f07b"}.fa-folder-minus:before{content:"\\f65d"}.fa-folder-open:before{content:"\\f07c"}.fa-folder-plus:before{content:"\\f65e"}.fa-font:before{content:"\\f031"}.fa-font-awesome:before{content:"\\f2b4"}.fa-font-awesome-alt:before{content:"\\f35c"}.fa-font-awesome-flag:before{content:"\\f425"}.fa-font-awesome-logo-full:before{content:"\\f4e6"}.fa-fonticons:before{content:"\\f280"}.fa-fonticons-fi:before{content:"\\f3a2"}.fa-football-ball:before{content:"\\f44e"}.fa-fort-awesome:before{content:"\\f286"}.fa-fort-awesome-alt:before{content:"\\f3a3"}.fa-forumbee:before{content:"\\f211"}.fa-forward:before{content:"\\f04e"}.fa-foursquare:before{content:"\\f180"}.fa-free-code-camp:before{content:"\\f2c5"}.fa-freebsd:before{content:"\\f3a4"}.fa-frog:before{content:"\\f52e"}.fa-frown:before{content:"\\f119"}.fa-frown-open:before{content:"\\f57a"}.fa-fulcrum:before{content:"\\f50b"}.fa-funnel-dollar:before{content:"\\f662"}.fa-futbol:before{content:"\\f1e3"}.fa-galactic-republic:before{content:"\\f50c"}.fa-galactic-senate:before{content:"\\f50d"}.fa-gamepad:before{content:"\\f11b"}.fa-gas-pump:before{content:"\\f52f"}.fa-gavel:before{content:"\\f0e3"}.fa-gem:before{content:"\\f3a5"}.fa-genderless:before{content:"\\f22d"}.fa-get-pocket:before{content:"\\f265"}.fa-gg:before{content:"\\f260"}.fa-gg-circle:before{content:"\\f261"}.fa-ghost:before{content:"\\f6e2"}.fa-gift:before{content:"\\f06b"}.fa-gifts:before{content:"\\f79c"}.fa-git:before{content:"\\f1d3"}.fa-git-alt:before{content:"\\f841"}.fa-git-square:before{content:"\\f1d2"}.fa-github:before{content:"\\f09b"}.fa-github-alt:before{content:"\\f113"}.fa-github-square:before{content:"\\f092"}.fa-gitkraken:before{content:"\\f3a6"}.fa-gitlab:before{content:"\\f296"}.fa-gitter:before{content:"\\f426"}.fa-glass-cheers:before{content:"\\f79f"}.fa-glass-martini:before{content:"\\f000"}.fa-glass-martini-alt:before{content:"\\f57b"}.fa-glass-whiskey:before{content:"\\f7a0"}.fa-glasses:before{content:"\\f530"}.fa-glide:before{content:"\\f2a5"}.fa-glide-g:before{content:"\\f2a6"}.fa-globe:before{content:"\\f0ac"}.fa-globe-africa:before{content:"\\f57c"}.fa-globe-americas:before{content:"\\f57d"}.fa-globe-asia:before{content:"\\f57e"}.fa-globe-europe:before{content:"\\f7a2"}.fa-gofore:before{content:"\\f3a7"}.fa-golf-ball:before{content:"\\f450"}.fa-goodreads:before{content:"\\f3a8"}.fa-goodreads-g:before{content:"\\f3a9"}.fa-google:before{content:"\\f1a0"}.fa-google-drive:before{content:"\\f3aa"}.fa-google-play:before{content:"\\f3ab"}.fa-google-plus:before{content:"\\f2b3"}.fa-google-plus-g:before{content:"\\f0d5"}.fa-google-plus-square:before{content:"\\f0d4"}.fa-google-wallet:before{content:"\\f1ee"}.fa-gopuram:before{content:"\\f664"}.fa-graduation-cap:before{content:"\\f19d"}.fa-gratipay:before{content:"\\f184"}.fa-grav:before{content:"\\f2d6"}.fa-greater-than:before{content:"\\f531"}.fa-greater-than-equal:before{content:"\\f532"}.fa-grimace:before{content:"\\f57f"}.fa-grin:before{content:"\\f580"}.fa-grin-alt:before{content:"\\f581"}.fa-grin-beam:before{content:"\\f582"}.fa-grin-beam-sweat:before{content:"\\f583"}.fa-grin-hearts:before{content:"\\f584"}.fa-grin-squint:before{content:"\\f585"}.fa-grin-squint-tears:before{content:"\\f586"}.fa-grin-stars:before{content:"\\f587"}.fa-grin-tears:before{content:"\\f588"}.fa-grin-tongue:before{content:"\\f589"}.fa-grin-tongue-squint:before{content:"\\f58a"}.fa-grin-tongue-wink:before{content:"\\f58b"}.fa-grin-wink:before{content:"\\f58c"}.fa-grip-horizontal:before{content:"\\f58d"}.fa-grip-lines:before{content:"\\f7a4"}.fa-grip-lines-vertical:before{content:"\\f7a5"}.fa-grip-vertical:before{content:"\\f58e"}.fa-gripfire:before{content:"\\f3ac"}.fa-grunt:before{content:"\\f3ad"}.fa-guitar:before{content:"\\f7a6"}.fa-gulp:before{content:"\\f3ae"}.fa-h-square:before{content:"\\f0fd"}.fa-hacker-news:before{content:"\\f1d4"}.fa-hacker-news-square:before{content:"\\f3af"}.fa-hackerrank:before{content:"\\f5f7"}.fa-hamburger:before{content:"\\f805"}.fa-hammer:before{content:"\\f6e3"}.fa-hamsa:before{content:"\\f665"}.fa-hand-holding:before{content:"\\f4bd"}.fa-hand-holding-heart:before{content:"\\f4be"}.fa-hand-holding-usd:before{content:"\\f4c0"}.fa-hand-lizard:before{content:"\\f258"}.fa-hand-middle-finger:before{content:"\\f806"}.fa-hand-paper:before{content:"\\f256"}.fa-hand-peace:before{content:"\\f25b"}.fa-hand-point-down:before{content:"\\f0a7"}.fa-hand-point-left:before{content:"\\f0a5"}.fa-hand-point-right:before{content:"\\f0a4"}.fa-hand-point-up:before{content:"\\f0a6"}.fa-hand-pointer:before{content:"\\f25a"}.fa-hand-rock:before{content:"\\f255"}.fa-hand-scissors:before{content:"\\f257"}.fa-hand-spock:before{content:"\\f259"}.fa-hands:before{content:"\\f4c2"}.fa-hands-helping:before{content:"\\f4c4"}.fa-handshake:before{content:"\\f2b5"}.fa-hanukiah:before{content:"\\f6e6"}.fa-hard-hat:before{content:"\\f807"}.fa-hashtag:before{content:"\\f292"}.fa-hat-wizard:before{content:"\\f6e8"}.fa-haykal:before{content:"\\f666"}.fa-hdd:before{content:"\\f0a0"}.fa-heading:before{content:"\\f1dc"}.fa-headphones:before{content:"\\f025"}.fa-headphones-alt:before{content:"\\f58f"}.fa-headset:before{content:"\\f590"}.fa-heart:before{content:"\\f004"}.fa-heart-broken:before{content:"\\f7a9"}.fa-heartbeat:before{content:"\\f21e"}.fa-helicopter:before{content:"\\f533"}.fa-highlighter:before{content:"\\f591"}.fa-hiking:before{content:"\\f6ec"}.fa-hippo:before{content:"\\f6ed"}.fa-hips:before{content:"\\f452"}.fa-hire-a-helper:before{content:"\\f3b0"}.fa-history:before{content:"\\f1da"}.fa-hockey-puck:before{content:"\\f453"}.fa-holly-berry:before{content:"\\f7aa"}.fa-home:before{content:"\\f015"}.fa-hooli:before{content:"\\f427"}.fa-hornbill:before{content:"\\f592"}.fa-horse:before{content:"\\f6f0"}.fa-horse-head:before{content:"\\f7ab"}.fa-hospital:before{content:"\\f0f8"}.fa-hospital-alt:before{content:"\\f47d"}.fa-hospital-symbol:before{content:"\\f47e"}.fa-hot-tub:before{content:"\\f593"}.fa-hotdog:before{content:"\\f80f"}.fa-hotel:before{content:"\\f594"}.fa-hotjar:before{content:"\\f3b1"}.fa-hourglass:before{content:"\\f254"}.fa-hourglass-end:before{content:"\\f253"}.fa-hourglass-half:before{content:"\\f252"}.fa-hourglass-start:before{content:"\\f251"}.fa-house-damage:before{content:"\\f6f1"}.fa-houzz:before{content:"\\f27c"}.fa-hryvnia:before{content:"\\f6f2"}.fa-html5:before{content:"\\f13b"}.fa-hubspot:before{content:"\\f3b2"}.fa-i-cursor:before{content:"\\f246"}.fa-ice-cream:before{content:"\\f810"}.fa-icicles:before{content:"\\f7ad"}.fa-icons:before{content:"\\f86d"}.fa-id-badge:before{content:"\\f2c1"}.fa-id-card:before{content:"\\f2c2"}.fa-id-card-alt:before{content:"\\f47f"}.fa-igloo:before{content:"\\f7ae"}.fa-image:before{content:"\\f03e"}.fa-images:before{content:"\\f302"}.fa-imdb:before{content:"\\f2d8"}.fa-inbox:before{content:"\\f01c"}.fa-indent:before{content:"\\f03c"}.fa-industry:before{content:"\\f275"}.fa-infinity:before{content:"\\f534"}.fa-info:before{content:"\\f129"}.fa-info-circle:before{content:"\\f05a"}.fa-instagram:before{content:"\\f16d"}.fa-intercom:before{content:"\\f7af"}.fa-internet-explorer:before{content:"\\f26b"}.fa-invision:before{content:"\\f7b0"}.fa-ioxhost:before{content:"\\f208"}.fa-italic:before{content:"\\f033"}.fa-itch-io:before{content:"\\f83a"}.fa-itunes:before{content:"\\f3b4"}.fa-itunes-note:before{content:"\\f3b5"}.fa-java:before{content:"\\f4e4"}.fa-jedi:before{content:"\\f669"}.fa-jedi-order:before{content:"\\f50e"}.fa-jenkins:before{content:"\\f3b6"}.fa-jira:before{content:"\\f7b1"}.fa-joget:before{content:"\\f3b7"}.fa-joint:before{content:"\\f595"}.fa-joomla:before{content:"\\f1aa"}.fa-journal-whills:before{content:"\\f66a"}.fa-js:before{content:"\\f3b8"}.fa-js-square:before{content:"\\f3b9"}.fa-jsfiddle:before{content:"\\f1cc"}.fa-kaaba:before{content:"\\f66b"}.fa-kaggle:before{content:"\\f5fa"}.fa-key:before{content:"\\f084"}.fa-keybase:before{content:"\\f4f5"}.fa-keyboard:before{content:"\\f11c"}.fa-keycdn:before{content:"\\f3ba"}.fa-khanda:before{content:"\\f66d"}.fa-kickstarter:before{content:"\\f3bb"}.fa-kickstarter-k:before{content:"\\f3bc"}.fa-kiss:before{content:"\\f596"}.fa-kiss-beam:before{content:"\\f597"}.fa-kiss-wink-heart:before{content:"\\f598"}.fa-kiwi-bird:before{content:"\\f535"}.fa-korvue:before{content:"\\f42f"}.fa-landmark:before{content:"\\f66f"}.fa-language:before{content:"\\f1ab"}.fa-laptop:before{content:"\\f109"}.fa-laptop-code:before{content:"\\f5fc"}.fa-laptop-medical:before{content:"\\f812"}.fa-laravel:before{content:"\\f3bd"}.fa-lastfm:before{content:"\\f202"}.fa-lastfm-square:before{content:"\\f203"}.fa-laugh:before{content:"\\f599"}.fa-laugh-beam:before{content:"\\f59a"}.fa-laugh-squint:before{content:"\\f59b"}.fa-laugh-wink:before{content:"\\f59c"}.fa-layer-group:before{content:"\\f5fd"}.fa-leaf:before{content:"\\f06c"}.fa-leanpub:before{content:"\\f212"}.fa-lemon:before{content:"\\f094"}.fa-less:before{content:"\\f41d"}.fa-less-than:before{content:"\\f536"}.fa-less-than-equal:before{content:"\\f537"}.fa-level-down-alt:before{content:"\\f3be"}.fa-level-up-alt:before{content:"\\f3bf"}.fa-life-ring:before{content:"\\f1cd"}.fa-lightbulb:before{content:"\\f0eb"}.fa-line:before{content:"\\f3c0"}.fa-link:before{content:"\\f0c1"}.fa-linkedin:before{content:"\\f08c"}.fa-linkedin-in:before{content:"\\f0e1"}.fa-linode:before{content:"\\f2b8"}.fa-linux:before{content:"\\f17c"}.fa-lira-sign:before{content:"\\f195"}.fa-list:before{content:"\\f03a"}.fa-list-alt:before{content:"\\f022"}.fa-list-ol:before{content:"\\f0cb"}.fa-list-ul:before{content:"\\f0ca"}.fa-location-arrow:before{content:"\\f124"}.fa-lock:before{content:"\\f023"}.fa-lock-open:before{content:"\\f3c1"}.fa-long-arrow-alt-down:before{content:"\\f309"}.fa-long-arrow-alt-left:before{content:"\\f30a"}.fa-long-arrow-alt-right:before{content:"\\f30b"}.fa-long-arrow-alt-up:before{content:"\\f30c"}.fa-low-vision:before{content:"\\f2a8"}.fa-luggage-cart:before{content:"\\f59d"}.fa-lyft:before{content:"\\f3c3"}.fa-magento:before{content:"\\f3c4"}.fa-magic:before{content:"\\f0d0"}.fa-magnet:before{content:"\\f076"}.fa-mail-bulk:before{content:"\\f674"}.fa-mailchimp:before{content:"\\f59e"}.fa-male:before{content:"\\f183"}.fa-mandalorian:before{content:"\\f50f"}.fa-map:before{content:"\\f279"}.fa-map-marked:before{content:"\\f59f"}.fa-map-marked-alt:before{content:"\\f5a0"}.fa-map-marker:before{content:"\\f041"}.fa-map-marker-alt:before{content:"\\f3c5"}.fa-map-pin:before{content:"\\f276"}.fa-map-signs:before{content:"\\f277"}.fa-markdown:before{content:"\\f60f"}.fa-marker:before{content:"\\f5a1"}.fa-mars:before{content:"\\f222"}.fa-mars-double:before{content:"\\f227"}.fa-mars-stroke:before{content:"\\f229"}.fa-mars-stroke-h:before{content:"\\f22b"}.fa-mars-stroke-v:before{content:"\\f22a"}.fa-mask:before{content:"\\f6fa"}.fa-mastodon:before{content:"\\f4f6"}.fa-maxcdn:before{content:"\\f136"}.fa-medal:before{content:"\\f5a2"}.fa-medapps:before{content:"\\f3c6"}.fa-medium:before{content:"\\f23a"}.fa-medium-m:before{content:"\\f3c7"}.fa-medkit:before{content:"\\f0fa"}.fa-medrt:before{content:"\\f3c8"}.fa-meetup:before{content:"\\f2e0"}.fa-megaport:before{content:"\\f5a3"}.fa-meh:before{content:"\\f11a"}.fa-meh-blank:before{content:"\\f5a4"}.fa-meh-rolling-eyes:before{content:"\\f5a5"}.fa-memory:before{content:"\\f538"}.fa-mendeley:before{content:"\\f7b3"}.fa-menorah:before{content:"\\f676"}.fa-mercury:before{content:"\\f223"}.fa-meteor:before{content:"\\f753"}.fa-microchip:before{content:"\\f2db"}.fa-microphone:before{content:"\\f130"}.fa-microphone-alt:before{content:"\\f3c9"}.fa-microphone-alt-slash:before{content:"\\f539"}.fa-microphone-slash:before{content:"\\f131"}.fa-microscope:before{content:"\\f610"}.fa-microsoft:before{content:"\\f3ca"}.fa-minus:before{content:"\\f068"}.fa-minus-circle:before{content:"\\f056"}.fa-minus-square:before{content:"\\f146"}.fa-mitten:before{content:"\\f7b5"}.fa-mix:before{content:"\\f3cb"}.fa-mixcloud:before{content:"\\f289"}.fa-mizuni:before{content:"\\f3cc"}.fa-mobile:before{content:"\\f10b"}.fa-mobile-alt:before{content:"\\f3cd"}.fa-modx:before{content:"\\f285"}.fa-monero:before{content:"\\f3d0"}.fa-money-bill:before{content:"\\f0d6"}.fa-money-bill-alt:before{content:"\\f3d1"}.fa-money-bill-wave:before{content:"\\f53a"}.fa-money-bill-wave-alt:before{content:"\\f53b"}.fa-money-check:before{content:"\\f53c"}.fa-money-check-alt:before{content:"\\f53d"}.fa-monument:before{content:"\\f5a6"}.fa-moon:before{content:"\\f186"}.fa-mortar-pestle:before{content:"\\f5a7"}.fa-mosque:before{content:"\\f678"}.fa-motorcycle:before{content:"\\f21c"}.fa-mountain:before{content:"\\f6fc"}.fa-mouse-pointer:before{content:"\\f245"}.fa-mug-hot:before{content:"\\f7b6"}.fa-music:before{content:"\\f001"}.fa-napster:before{content:"\\f3d2"}.fa-neos:before{content:"\\f612"}.fa-network-wired:before{content:"\\f6ff"}.fa-neuter:before{content:"\\f22c"}.fa-newspaper:before{content:"\\f1ea"}.fa-nimblr:before{content:"\\f5a8"}.fa-node:before{content:"\\f419"}.fa-node-js:before{content:"\\f3d3"}.fa-not-equal:before{content:"\\f53e"}.fa-notes-medical:before{content:"\\f481"}.fa-npm:before{content:"\\f3d4"}.fa-ns8:before{content:"\\f3d5"}.fa-nutritionix:before{content:"\\f3d6"}.fa-object-group:before{content:"\\f247"}.fa-object-ungroup:before{content:"\\f248"}.fa-odnoklassniki:before{content:"\\f263"}.fa-odnoklassniki-square:before{content:"\\f264"}.fa-oil-can:before{content:"\\f613"}.fa-old-republic:before{content:"\\f510"}.fa-om:before{content:"\\f679"}.fa-opencart:before{content:"\\f23d"}.fa-openid:before{content:"\\f19b"}.fa-opera:before{content:"\\f26a"}.fa-optin-monster:before{content:"\\f23c"}.fa-osi:before{content:"\\f41a"}.fa-otter:before{content:"\\f700"}.fa-outdent:before{content:"\\f03b"}.fa-page4:before{content:"\\f3d7"}.fa-pagelines:before{content:"\\f18c"}.fa-pager:before{content:"\\f815"}.fa-paint-brush:before{content:"\\f1fc"}.fa-paint-roller:before{content:"\\f5aa"}.fa-palette:before{content:"\\f53f"}.fa-palfed:before{content:"\\f3d8"}.fa-pallet:before{content:"\\f482"}.fa-paper-plane:before{content:"\\f1d8"}.fa-paperclip:before{content:"\\f0c6"}.fa-parachute-box:before{content:"\\f4cd"}.fa-paragraph:before{content:"\\f1dd"}.fa-parking:before{content:"\\f540"}.fa-passport:before{content:"\\f5ab"}.fa-pastafarianism:before{content:"\\f67b"}.fa-paste:before{content:"\\f0ea"}.fa-patreon:before{content:"\\f3d9"}.fa-pause:before{content:"\\f04c"}.fa-pause-circle:before{content:"\\f28b"}.fa-paw:before{content:"\\f1b0"}.fa-paypal:before{content:"\\f1ed"}.fa-peace:before{content:"\\f67c"}.fa-pen:before{content:"\\f304"}.fa-pen-alt:before{content:"\\f305"}.fa-pen-fancy:before{content:"\\f5ac"}.fa-pen-nib:before{content:"\\f5ad"}.fa-pen-square:before{content:"\\f14b"}.fa-pencil-alt:before{content:"\\f303"}.fa-pencil-ruler:before{content:"\\f5ae"}.fa-penny-arcade:before{content:"\\f704"}.fa-people-carry:before{content:"\\f4ce"}.fa-pepper-hot:before{content:"\\f816"}.fa-percent:before{content:"\\f295"}.fa-percentage:before{content:"\\f541"}.fa-periscope:before{content:"\\f3da"}.fa-person-booth:before{content:"\\f756"}.fa-phabricator:before{content:"\\f3db"}.fa-phoenix-framework:before{content:"\\f3dc"}.fa-phoenix-squadron:before{content:"\\f511"}.fa-phone:before{content:"\\f095"}.fa-phone-alt:before{content:"\\f879"}.fa-phone-slash:before{content:"\\f3dd"}.fa-phone-square:before{content:"\\f098"}.fa-phone-square-alt:before{content:"\\f87b"}.fa-phone-volume:before{content:"\\f2a0"}.fa-photo-video:before{content:"\\f87c"}.fa-php:before{content:"\\f457"}.fa-pied-piper:before{content:"\\f2ae"}.fa-pied-piper-alt:before{content:"\\f1a8"}.fa-pied-piper-hat:before{content:"\\f4e5"}.fa-pied-piper-pp:before{content:"\\f1a7"}.fa-piggy-bank:before{content:"\\f4d3"}.fa-pills:before{content:"\\f484"}.fa-pinterest:before{content:"\\f0d2"}.fa-pinterest-p:before{content:"\\f231"}.fa-pinterest-square:before{content:"\\f0d3"}.fa-pizza-slice:before{content:"\\f818"}.fa-place-of-worship:before{content:"\\f67f"}.fa-plane:before{content:"\\f072"}.fa-plane-arrival:before{content:"\\f5af"}.fa-plane-departure:before{content:"\\f5b0"}.fa-play:before{content:"\\f04b"}.fa-play-circle:before{content:"\\f144"}.fa-playstation:before{content:"\\f3df"}.fa-plug:before{content:"\\f1e6"}.fa-plus:before{content:"\\f067"}.fa-plus-circle:before{content:"\\f055"}.fa-plus-square:before{content:"\\f0fe"}.fa-podcast:before{content:"\\f2ce"}.fa-poll:before{content:"\\f681"}.fa-poll-h:before{content:"\\f682"}.fa-poo:before{content:"\\f2fe"}.fa-poo-storm:before{content:"\\f75a"}.fa-poop:before{content:"\\f619"}.fa-portrait:before{content:"\\f3e0"}.fa-pound-sign:before{content:"\\f154"}.fa-power-off:before{content:"\\f011"}.fa-pray:before{content:"\\f683"}.fa-praying-hands:before{content:"\\f684"}.fa-prescription:before{content:"\\f5b1"}.fa-prescription-bottle:before{content:"\\f485"}.fa-prescription-bottle-alt:before{content:"\\f486"}.fa-print:before{content:"\\f02f"}.fa-procedures:before{content:"\\f487"}.fa-product-hunt:before{content:"\\f288"}.fa-project-diagram:before{content:"\\f542"}.fa-pushed:before{content:"\\f3e1"}.fa-puzzle-piece:before{content:"\\f12e"}.fa-python:before{content:"\\f3e2"}.fa-qq:before{content:"\\f1d6"}.fa-qrcode:before{content:"\\f029"}.fa-question:before{content:"\\f128"}.fa-question-circle:before{content:"\\f059"}.fa-quidditch:before{content:"\\f458"}.fa-quinscape:before{content:"\\f459"}.fa-quora:before{content:"\\f2c4"}.fa-quote-left:before{content:"\\f10d"}.fa-quote-right:before{content:"\\f10e"}.fa-quran:before{content:"\\f687"}.fa-r-project:before{content:"\\f4f7"}.fa-radiation:before{content:"\\f7b9"}.fa-radiation-alt:before{content:"\\f7ba"}.fa-rainbow:before{content:"\\f75b"}.fa-random:before{content:"\\f074"}.fa-raspberry-pi:before{content:"\\f7bb"}.fa-ravelry:before{content:"\\f2d9"}.fa-react:before{content:"\\f41b"}.fa-reacteurope:before{content:"\\f75d"}.fa-readme:before{content:"\\f4d5"}.fa-rebel:before{content:"\\f1d0"}.fa-receipt:before{content:"\\f543"}.fa-recycle:before{content:"\\f1b8"}.fa-red-river:before{content:"\\f3e3"}.fa-reddit:before{content:"\\f1a1"}.fa-reddit-alien:before{content:"\\f281"}.fa-reddit-square:before{content:"\\f1a2"}.fa-redhat:before{content:"\\f7bc"}.fa-redo:before{content:"\\f01e"}.fa-redo-alt:before{content:"\\f2f9"}.fa-registered:before{content:"\\f25d"}.fa-remove-format:before{content:"\\f87d"}.fa-renren:before{content:"\\f18b"}.fa-reply:before{content:"\\f3e5"}.fa-reply-all:before{content:"\\f122"}.fa-replyd:before{content:"\\f3e6"}.fa-republican:before{content:"\\f75e"}.fa-researchgate:before{content:"\\f4f8"}.fa-resolving:before{content:"\\f3e7"}.fa-restroom:before{content:"\\f7bd"}.fa-retweet:before{content:"\\f079"}.fa-rev:before{content:"\\f5b2"}.fa-ribbon:before{content:"\\f4d6"}.fa-ring:before{content:"\\f70b"}.fa-road:before{content:"\\f018"}.fa-robot:before{content:"\\f544"}.fa-rocket:before{content:"\\f135"}.fa-rocketchat:before{content:"\\f3e8"}.fa-rockrms:before{content:"\\f3e9"}.fa-route:before{content:"\\f4d7"}.fa-rss:before{content:"\\f09e"}.fa-rss-square:before{content:"\\f143"}.fa-ruble-sign:before{content:"\\f158"}.fa-ruler:before{content:"\\f545"}.fa-ruler-combined:before{content:"\\f546"}.fa-ruler-horizontal:before{content:"\\f547"}.fa-ruler-vertical:before{content:"\\f548"}.fa-running:before{content:"\\f70c"}.fa-rupee-sign:before{content:"\\f156"}.fa-sad-cry:before{content:"\\f5b3"}.fa-sad-tear:before{content:"\\f5b4"}.fa-safari:before{content:"\\f267"}.fa-salesforce:before{content:"\\f83b"}.fa-sass:before{content:"\\f41e"}.fa-satellite:before{content:"\\f7bf"}.fa-satellite-dish:before{content:"\\f7c0"}.fa-save:before{content:"\\f0c7"}.fa-schlix:before{content:"\\f3ea"}.fa-school:before{content:"\\f549"}.fa-screwdriver:before{content:"\\f54a"}.fa-scribd:before{content:"\\f28a"}.fa-scroll:before{content:"\\f70e"}.fa-sd-card:before{content:"\\f7c2"}.fa-search:before{content:"\\f002"}.fa-search-dollar:before{content:"\\f688"}.fa-search-location:before{content:"\\f689"}.fa-search-minus:before{content:"\\f010"}.fa-search-plus:before{content:"\\f00e"}.fa-searchengin:before{content:"\\f3eb"}.fa-seedling:before{content:"\\f4d8"}.fa-sellcast:before{content:"\\f2da"}.fa-sellsy:before{content:"\\f213"}.fa-server:before{content:"\\f233"}.fa-servicestack:before{content:"\\f3ec"}.fa-shapes:before{content:"\\f61f"}.fa-share:before{content:"\\f064"}.fa-share-alt:before{content:"\\f1e0"}.fa-share-alt-square:before{content:"\\f1e1"}.fa-share-square:before{content:"\\f14d"}.fa-shekel-sign:before{content:"\\f20b"}.fa-shield-alt:before{content:"\\f3ed"}.fa-ship:before{content:"\\f21a"}.fa-shipping-fast:before{content:"\\f48b"}.fa-shirtsinbulk:before{content:"\\f214"}.fa-shoe-prints:before{content:"\\f54b"}.fa-shopping-bag:before{content:"\\f290"}.fa-shopping-basket:before{content:"\\f291"}.fa-shopping-cart:before{content:"\\f07a"}.fa-shopware:before{content:"\\f5b5"}.fa-shower:before{content:"\\f2cc"}.fa-shuttle-van:before{content:"\\f5b6"}.fa-sign:before{content:"\\f4d9"}.fa-sign-in-alt:before{content:"\\f2f6"}.fa-sign-language:before{content:"\\f2a7"}.fa-sign-out-alt:before{content:"\\f2f5"}.fa-signal:before{content:"\\f012"}.fa-signature:before{content:"\\f5b7"}.fa-sim-card:before{content:"\\f7c4"}.fa-simplybuilt:before{content:"\\f215"}.fa-sistrix:before{content:"\\f3ee"}.fa-sitemap:before{content:"\\f0e8"}.fa-sith:before{content:"\\f512"}.fa-skating:before{content:"\\f7c5"}.fa-sketch:before{content:"\\f7c6"}.fa-skiing:before{content:"\\f7c9"}.fa-skiing-nordic:before{content:"\\f7ca"}.fa-skull:before{content:"\\f54c"}.fa-skull-crossbones:before{content:"\\f714"}.fa-skyatlas:before{content:"\\f216"}.fa-skype:before{content:"\\f17e"}.fa-slack:before{content:"\\f198"}.fa-slack-hash:before{content:"\\f3ef"}.fa-slash:before{content:"\\f715"}.fa-sleigh:before{content:"\\f7cc"}.fa-sliders-h:before{content:"\\f1de"}.fa-slideshare:before{content:"\\f1e7"}.fa-smile:before{content:"\\f118"}.fa-smile-beam:before{content:"\\f5b8"}.fa-smile-wink:before{content:"\\f4da"}.fa-smog:before{content:"\\f75f"}.fa-smoking:before{content:"\\f48d"}.fa-smoking-ban:before{content:"\\f54d"}.fa-sms:before{content:"\\f7cd"}.fa-snapchat:before{content:"\\f2ab"}.fa-snapchat-ghost:before{content:"\\f2ac"}.fa-snapchat-square:before{content:"\\f2ad"}.fa-snowboarding:before{content:"\\f7ce"}.fa-snowflake:before{content:"\\f2dc"}.fa-snowman:before{content:"\\f7d0"}.fa-snowplow:before{content:"\\f7d2"}.fa-socks:before{content:"\\f696"}.fa-solar-panel:before{content:"\\f5ba"}.fa-sort:before{content:"\\f0dc"}.fa-sort-alpha-down:before{content:"\\f15d"}.fa-sort-alpha-down-alt:before{content:"\\f881"}.fa-sort-alpha-up:before{content:"\\f15e"}.fa-sort-alpha-up-alt:before{content:"\\f882"}.fa-sort-amount-down:before{content:"\\f160"}.fa-sort-amount-down-alt:before{content:"\\f884"}.fa-sort-amount-up:before{content:"\\f161"}.fa-sort-amount-up-alt:before{content:"\\f885"}.fa-sort-down:before{content:"\\f0dd"}.fa-sort-numeric-down:before{content:"\\f162"}.fa-sort-numeric-down-alt:before{content:"\\f886"}.fa-sort-numeric-up:before{content:"\\f163"}.fa-sort-numeric-up-alt:before{content:"\\f887"}.fa-sort-up:before{content:"\\f0de"}.fa-soundcloud:before{content:"\\f1be"}.fa-sourcetree:before{content:"\\f7d3"}.fa-spa:before{content:"\\f5bb"}.fa-space-shuttle:before{content:"\\f197"}.fa-speakap:before{content:"\\f3f3"}.fa-speaker-deck:before{content:"\\f83c"}.fa-spell-check:before{content:"\\f891"}.fa-spider:before{content:"\\f717"}.fa-spinner:before{content:"\\f110"}.fa-splotch:before{content:"\\f5bc"}.fa-spotify:before{content:"\\f1bc"}.fa-spray-can:before{content:"\\f5bd"}.fa-square:before{content:"\\f0c8"}.fa-square-full:before{content:"\\f45c"}.fa-square-root-alt:before{content:"\\f698"}.fa-squarespace:before{content:"\\f5be"}.fa-stack-exchange:before{content:"\\f18d"}.fa-stack-overflow:before{content:"\\f16c"}.fa-stackpath:before{content:"\\f842"}.fa-stamp:before{content:"\\f5bf"}.fa-star:before{content:"\\f005"}.fa-star-and-crescent:before{content:"\\f699"}.fa-star-half:before{content:"\\f089"}.fa-star-half-alt:before{content:"\\f5c0"}.fa-star-of-david:before{content:"\\f69a"}.fa-star-of-life:before{content:"\\f621"}.fa-staylinked:before{content:"\\f3f5"}.fa-steam:before{content:"\\f1b6"}.fa-steam-square:before{content:"\\f1b7"}.fa-steam-symbol:before{content:"\\f3f6"}.fa-step-backward:before{content:"\\f048"}.fa-step-forward:before{content:"\\f051"}.fa-stethoscope:before{content:"\\f0f1"}.fa-sticker-mule:before{content:"\\f3f7"}.fa-sticky-note:before{content:"\\f249"}.fa-stop:before{content:"\\f04d"}.fa-stop-circle:before{content:"\\f28d"}.fa-stopwatch:before{content:"\\f2f2"}.fa-store:before{content:"\\f54e"}.fa-store-alt:before{content:"\\f54f"}.fa-strava:before{content:"\\f428"}.fa-stream:before{content:"\\f550"}.fa-street-view:before{content:"\\f21d"}.fa-strikethrough:before{content:"\\f0cc"}.fa-stripe:before{content:"\\f429"}.fa-stripe-s:before{content:"\\f42a"}.fa-stroopwafel:before{content:"\\f551"}.fa-studiovinari:before{content:"\\f3f8"}.fa-stumbleupon:before{content:"\\f1a4"}.fa-stumbleupon-circle:before{content:"\\f1a3"}.fa-subscript:before{content:"\\f12c"}.fa-subway:before{content:"\\f239"}.fa-suitcase:before{content:"\\f0f2"}.fa-suitcase-rolling:before{content:"\\f5c1"}.fa-sun:before{content:"\\f185"}.fa-superpowers:before{content:"\\f2dd"}.fa-superscript:before{content:"\\f12b"}.fa-supple:before{content:"\\f3f9"}.fa-surprise:before{content:"\\f5c2"}.fa-suse:before{content:"\\f7d6"}.fa-swatchbook:before{content:"\\f5c3"}.fa-swimmer:before{content:"\\f5c4"}.fa-swimming-pool:before{content:"\\f5c5"}.fa-symfony:before{content:"\\f83d"}.fa-synagogue:before{content:"\\f69b"}.fa-sync:before{content:"\\f021"}.fa-sync-alt:before{content:"\\f2f1"}.fa-syringe:before{content:"\\f48e"}.fa-table:before{content:"\\f0ce"}.fa-table-tennis:before{content:"\\f45d"}.fa-tablet:before{content:"\\f10a"}.fa-tablet-alt:before{content:"\\f3fa"}.fa-tablets:before{content:"\\f490"}.fa-tachometer-alt:before{content:"\\f3fd"}.fa-tag:before{content:"\\f02b"}.fa-tags:before{content:"\\f02c"}.fa-tape:before{content:"\\f4db"}.fa-tasks:before{content:"\\f0ae"}.fa-taxi:before{content:"\\f1ba"}.fa-teamspeak:before{content:"\\f4f9"}.fa-teeth:before{content:"\\f62e"}.fa-teeth-open:before{content:"\\f62f"}.fa-telegram:before{content:"\\f2c6"}.fa-telegram-plane:before{content:"\\f3fe"}.fa-temperature-high:before{content:"\\f769"}.fa-temperature-low:before{content:"\\f76b"}.fa-tencent-weibo:before{content:"\\f1d5"}.fa-tenge:before{content:"\\f7d7"}.fa-terminal:before{content:"\\f120"}.fa-text-height:before{content:"\\f034"}.fa-text-width:before{content:"\\f035"}.fa-th:before{content:"\\f00a"}.fa-th-large:before{content:"\\f009"}.fa-th-list:before{content:"\\f00b"}.fa-the-red-yeti:before{content:"\\f69d"}.fa-theater-masks:before{content:"\\f630"}.fa-themeco:before{content:"\\f5c6"}.fa-themeisle:before{content:"\\f2b2"}.fa-thermometer:before{content:"\\f491"}.fa-thermometer-empty:before{content:"\\f2cb"}.fa-thermometer-full:before{content:"\\f2c7"}.fa-thermometer-half:before{content:"\\f2c9"}.fa-thermometer-quarter:before{content:"\\f2ca"}.fa-thermometer-three-quarters:before{content:"\\f2c8"}.fa-think-peaks:before{content:"\\f731"}.fa-thumbs-down:before{content:"\\f165"}.fa-thumbs-up:before{content:"\\f164"}.fa-thumbtack:before{content:"\\f08d"}.fa-ticket-alt:before{content:"\\f3ff"}.fa-times:before{content:"\\f00d"}.fa-times-circle:before{content:"\\f057"}.fa-tint:before{content:"\\f043"}.fa-tint-slash:before{content:"\\f5c7"}.fa-tired:before{content:"\\f5c8"}.fa-toggle-off:before{content:"\\f204"}.fa-toggle-on:before{content:"\\f205"}.fa-toilet:before{content:"\\f7d8"}.fa-toilet-paper:before{content:"\\f71e"}.fa-toolbox:before{content:"\\f552"}.fa-tools:before{content:"\\f7d9"}.fa-tooth:before{content:"\\f5c9"}.fa-torah:before{content:"\\f6a0"}.fa-torii-gate:before{content:"\\f6a1"}.fa-tractor:before{content:"\\f722"}.fa-trade-federation:before{content:"\\f513"}.fa-trademark:before{content:"\\f25c"}.fa-traffic-light:before{content:"\\f637"}.fa-train:before{content:"\\f238"}.fa-tram:before{content:"\\f7da"}.fa-transgender:before{content:"\\f224"}.fa-transgender-alt:before{content:"\\f225"}.fa-trash:before{content:"\\f1f8"}.fa-trash-alt:before{content:"\\f2ed"}.fa-trash-restore:before{content:"\\f829"}.fa-trash-restore-alt:before{content:"\\f82a"}.fa-tree:before{content:"\\f1bb"}.fa-trello:before{content:"\\f181"}.fa-tripadvisor:before{content:"\\f262"}.fa-trophy:before{content:"\\f091"}.fa-truck:before{content:"\\f0d1"}.fa-truck-loading:before{content:"\\f4de"}.fa-truck-monster:before{content:"\\f63b"}.fa-truck-moving:before{content:"\\f4df"}.fa-truck-pickup:before{content:"\\f63c"}.fa-tshirt:before{content:"\\f553"}.fa-tty:before{content:"\\f1e4"}.fa-tumblr:before{content:"\\f173"}.fa-tumblr-square:before{content:"\\f174"}.fa-tv:before{content:"\\f26c"}.fa-twitch:before{content:"\\f1e8"}.fa-twitter:before{content:"\\f099"}.fa-twitter-square:before{content:"\\f081"}.fa-typo3:before{content:"\\f42b"}.fa-uber:before{content:"\\f402"}.fa-ubuntu:before{content:"\\f7df"}.fa-uikit:before{content:"\\f403"}.fa-umbrella:before{content:"\\f0e9"}.fa-umbrella-beach:before{content:"\\f5ca"}.fa-underline:before{content:"\\f0cd"}.fa-undo:before{content:"\\f0e2"}.fa-undo-alt:before{content:"\\f2ea"}.fa-uniregistry:before{content:"\\f404"}.fa-universal-access:before{content:"\\f29a"}.fa-university:before{content:"\\f19c"}.fa-unlink:before{content:"\\f127"}.fa-unlock:before{content:"\\f09c"}.fa-unlock-alt:before{content:"\\f13e"}.fa-untappd:before{content:"\\f405"}.fa-upload:before{content:"\\f093"}.fa-ups:before{content:"\\f7e0"}.fa-usb:before{content:"\\f287"}.fa-user:before{content:"\\f007"}.fa-user-alt:before{content:"\\f406"}.fa-user-alt-slash:before{content:"\\f4fa"}.fa-user-astronaut:before{content:"\\f4fb"}.fa-user-check:before{content:"\\f4fc"}.fa-user-circle:before{content:"\\f2bd"}.fa-user-clock:before{content:"\\f4fd"}.fa-user-cog:before{content:"\\f4fe"}.fa-user-edit:before{content:"\\f4ff"}.fa-user-friends:before{content:"\\f500"}.fa-user-graduate:before{content:"\\f501"}.fa-user-injured:before{content:"\\f728"}.fa-user-lock:before{content:"\\f502"}.fa-user-md:before{content:"\\f0f0"}.fa-user-minus:before{content:"\\f503"}.fa-user-ninja:before{content:"\\f504"}.fa-user-nurse:before{content:"\\f82f"}.fa-user-plus:before{content:"\\f234"}.fa-user-secret:before{content:"\\f21b"}.fa-user-shield:before{content:"\\f505"}.fa-user-slash:before{content:"\\f506"}.fa-user-tag:before{content:"\\f507"}.fa-user-tie:before{content:"\\f508"}.fa-user-times:before{content:"\\f235"}.fa-users:before{content:"\\f0c0"}.fa-users-cog:before{content:"\\f509"}.fa-usps:before{content:"\\f7e1"}.fa-ussunnah:before{content:"\\f407"}.fa-utensil-spoon:before{content:"\\f2e5"}.fa-utensils:before{content:"\\f2e7"}.fa-vaadin:before{content:"\\f408"}.fa-vector-square:before{content:"\\f5cb"}.fa-venus:before{content:"\\f221"}.fa-venus-double:before{content:"\\f226"}.fa-venus-mars:before{content:"\\f228"}.fa-viacoin:before{content:"\\f237"}.fa-viadeo:before{content:"\\f2a9"}.fa-viadeo-square:before{content:"\\f2aa"}.fa-vial:before{content:"\\f492"}.fa-vials:before{content:"\\f493"}.fa-viber:before{content:"\\f409"}.fa-video:before{content:"\\f03d"}.fa-video-slash:before{content:"\\f4e2"}.fa-vihara:before{content:"\\f6a7"}.fa-vimeo:before{content:"\\f40a"}.fa-vimeo-square:before{content:"\\f194"}.fa-vimeo-v:before{content:"\\f27d"}.fa-vine:before{content:"\\f1ca"}.fa-vk:before{content:"\\f189"}.fa-vnv:before{content:"\\f40b"}.fa-voicemail:before{content:"\\f897"}.fa-volleyball-ball:before{content:"\\f45f"}.fa-volume-down:before{content:"\\f027"}.fa-volume-mute:before{content:"\\f6a9"}.fa-volume-off:before{content:"\\f026"}.fa-volume-up:before{content:"\\f028"}.fa-vote-yea:before{content:"\\f772"}.fa-vr-cardboard:before{content:"\\f729"}.fa-vuejs:before{content:"\\f41f"}.fa-walking:before{content:"\\f554"}.fa-wallet:before{content:"\\f555"}.fa-warehouse:before{content:"\\f494"}.fa-water:before{content:"\\f773"}.fa-wave-square:before{content:"\\f83e"}.fa-waze:before{content:"\\f83f"}.fa-weebly:before{content:"\\f5cc"}.fa-weibo:before{content:"\\f18a"}.fa-weight:before{content:"\\f496"}.fa-weight-hanging:before{content:"\\f5cd"}.fa-weixin:before{content:"\\f1d7"}.fa-whatsapp:before{content:"\\f232"}.fa-whatsapp-square:before{content:"\\f40c"}.fa-wheelchair:before{content:"\\f193"}.fa-whmcs:before{content:"\\f40d"}.fa-wifi:before{content:"\\f1eb"}.fa-wikipedia-w:before{content:"\\f266"}.fa-wind:before{content:"\\f72e"}.fa-window-close:before{content:"\\f410"}.fa-window-maximize:before{content:"\\f2d0"}.fa-window-minimize:before{content:"\\f2d1"}.fa-window-restore:before{content:"\\f2d2"}.fa-windows:before{content:"\\f17a"}.fa-wine-bottle:before{content:"\\f72f"}.fa-wine-glass:before{content:"\\f4e3"}.fa-wine-glass-alt:before{content:"\\f5ce"}.fa-wix:before{content:"\\f5cf"}.fa-wizards-of-the-coast:before{content:"\\f730"}.fa-wolf-pack-battalion:before{content:"\\f514"}.fa-won-sign:before{content:"\\f159"}.fa-wordpress:before{content:"\\f19a"}.fa-wordpress-simple:before{content:"\\f411"}.fa-wpbeginner:before{content:"\\f297"}.fa-wpexplorer:before{content:"\\f2de"}.fa-wpforms:before{content:"\\f298"}.fa-wpressr:before{content:"\\f3e4"}.fa-wrench:before{content:"\\f0ad"}.fa-x-ray:before{content:"\\f497"}.fa-xbox:before{content:"\\f412"}.fa-xing:before{content:"\\f168"}.fa-xing-square:before{content:"\\f169"}.fa-y-combinator:before{content:"\\f23b"}.fa-yahoo:before{content:"\\f19e"}.fa-yammer:before{content:"\\f840"}.fa-yandex:before{content:"\\f413"}.fa-yandex-international:before{content:"\\f414"}.fa-yarn:before{content:"\\f7e3"}.fa-yelp:before{content:"\\f1e9"}.fa-yen-sign:before{content:"\\f157"}.fa-yin-yang:before{content:"\\f6ad"}.fa-yoast:before{content:"\\f2b1"}.fa-youtube:before{content:"\\f167"}.fa-youtube-square:before{content:"\\f431"}.fa-zhihu:before{content:"\\f63f"}.sr-only{border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sr-only-focusable:active,.sr-only-focusable:focus{clip:auto;height:auto;margin:0;overflow:visible;position:static;width:auto}@font-face{font-family:"Font Awesome 5 Brands";font-style:normal;font-weight:400;font-display:auto;src:url(fa-brands-400.eot);src:url(fa-brands-400.eot?#iefix) format("embedded-opentype"),url(fa-brands-400.woff2) format("woff2"),url(fa-brands-400.woff) format("woff"),url(fa-brands-400.ttf) format("truetype"),url(fa-brands-400.svg#fontawesome) format("svg")}.fab{font-family:"Font Awesome 5 Brands"}@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:400;font-display:auto;src:url(fa-regular-400.eot);src:url(fa-regular-400.eot?#iefix) format("embedded-opentype"),url(fa-regular-400.woff2) format("woff2"),url(fa-regular-400.woff) format("woff"),url(fa-regular-400.ttf) format("truetype"),url(fa-regular-400.svg#fontawesome) format("svg")}.far{font-family:"Font Awesome 5 Free";font-weight:400}@font-face{font-family:"Font Awesome 5 Free";font-style:normal;font-weight:900;font-display:auto;src:url(fa-solid-900.eot);src:url(fa-solid-900.eot?#iefix) format("embedded-opentype"),url(fa-solid-900.woff2) format("woff2"),url(fa-solid-900.woff) format("woff"),url(fa-solid-900.ttf) format("truetype"),url(fa-solid-900.svg#fontawesome) format("svg")}.fa,.fas{font-family:"Font Awesome 5 Free";font-weight:900}.mat-badge-content{font-weight:600;font-size:12px;font-family:Roboto,Helvetica Neue,sans-serif}.mat-badge-small .mat-badge-content{font-size:9px}.mat-badge-large .mat-badge-content{font-size:24px}.mat-h1,.mat-headline,.mat-typography .mat-h1,.mat-typography .mat-headline,.mat-typography h1{font:400 24px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h2,.mat-title,.mat-typography .mat-h2,.mat-typography .mat-title,.mat-typography h2{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h3,.mat-subheading-2,.mat-typography .mat-h3,.mat-typography .mat-subheading-2,.mat-typography h3{font:400 16px/28px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h4,.mat-subheading-1,.mat-typography .mat-h4,.mat-typography .mat-subheading-1,.mat-typography h4{font:400 15px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h5,.mat-typography .mat-h5,.mat-typography h5{font:400 11.62px/20px Roboto,Helvetica Neue,sans-serif;margin:0 0 12px}.mat-h6,.mat-typography .mat-h6,.mat-typography h6{font:400 9.38px/20px Roboto,Helvetica Neue,sans-serif;margin:0 0 12px}.mat-body-strong,.mat-body-2,.mat-typography .mat-body-strong,.mat-typography .mat-body-2{font:500 14px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-body,.mat-body-1,.mat-typography .mat-body,.mat-typography .mat-body-1,.mat-typography{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-body p,.mat-body-1 p,.mat-typography .mat-body p,.mat-typography .mat-body-1 p,.mat-typography p{margin:0 0 12px}.mat-small,.mat-caption,.mat-typography .mat-small,.mat-typography .mat-caption{font:400 12px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-display-4,.mat-typography .mat-display-4{font:300 112px/112px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.05em;margin:0 0 56px}.mat-display-3,.mat-typography .mat-display-3{font:400 56px/56px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.02em;margin:0 0 64px}.mat-display-2,.mat-typography .mat-display-2{font:400 45px/48px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.005em;margin:0 0 64px}.mat-display-1,.mat-typography .mat-display-1{font:400 34px/40px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 64px}.mat-bottom-sheet-container{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-button,.mat-raised-button,.mat-icon-button,.mat-stroked-button,.mat-flat-button,.mat-fab,.mat-mini-fab{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-button-toggle,.mat-card{font-family:Roboto,Helvetica Neue,sans-serif}.mat-card-title{font-size:24px;font-weight:500}.mat-card-header .mat-card-title{font-size:20px}.mat-card-subtitle,.mat-card-content{font-size:14px}.mat-checkbox{font-family:Roboto,Helvetica Neue,sans-serif}.mat-checkbox-layout .mat-checkbox-label{line-height:24px}.mat-chip{font-size:14px;font-weight:500}.mat-chip .mat-chip-trailing-icon.mat-icon,.mat-chip .mat-chip-remove.mat-icon{font-size:18px}.mat-table{font-family:Roboto,Helvetica Neue,sans-serif}.mat-header-cell{font-size:12px;font-weight:500}.mat-cell,.mat-footer-cell{font-size:14px}.mat-calendar{font-family:Roboto,Helvetica Neue,sans-serif}.mat-calendar-body{font-size:13px}.mat-calendar-body-label,.mat-calendar-period-button{font-size:14px;font-weight:500}.mat-calendar-table-header th{font-size:11px;font-weight:400}.mat-dialog-title{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-expansion-panel-header{font-family:Roboto,Helvetica Neue,sans-serif;font-size:15px;font-weight:400}.mat-expansion-panel-content{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-form-field{font-size:inherit;font-weight:400;line-height:1.125;font-family:Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-form-field-wrapper{padding-bottom:1.34375em}.mat-form-field-prefix .mat-icon,.mat-form-field-suffix .mat-icon{font-size:150%;line-height:1.125}.mat-form-field-prefix .mat-icon-button,.mat-form-field-suffix .mat-icon-button{height:1.5em;width:1.5em}.mat-form-field-prefix .mat-icon-button .mat-icon,.mat-form-field-suffix .mat-icon-button .mat-icon{height:1.125em;line-height:1.125}.mat-form-field-infix{padding:.5em 0;border-top:.84375em solid transparent}.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.34375em) scale(.75);width:133.3333333333%}.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.34374em) scale(.75);width:133.3333433333%}.mat-form-field-label-wrapper{top:-.84375em;padding-top:.84375em}.mat-form-field-label{top:1.34375em}.mat-form-field-underline{bottom:1.34375em}.mat-form-field-subscript-wrapper{font-size:75%;margin-top:.6666666667em;top:calc(100% - 1.7916666667em)}.mat-form-field-appearance-legacy .mat-form-field-wrapper{padding-bottom:1.25em}.mat-form-field-appearance-legacy .mat-form-field-infix{padding:.4375em 0}.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.001px);width:133.3333333333%}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00101px);width:133.3333433333%}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00102px);width:133.3333533333%}.mat-form-field-appearance-legacy .mat-form-field-label{top:1.28125em}.mat-form-field-appearance-legacy .mat-form-field-underline{bottom:1.25em}.mat-form-field-appearance-legacy .mat-form-field-subscript-wrapper{margin-top:.5416666667em;top:calc(100% - 1.6666666667em)}@media print{.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28122em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28121em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.2812em) scale(.75)}}.mat-form-field-appearance-fill .mat-form-field-infix{padding:.25em 0 .75em}.mat-form-field-appearance-fill .mat-form-field-label{top:1.09375em;margin-top:-.5em}.mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-fill.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-.59375em) scale(.75);width:133.3333333333%}.mat-form-field-appearance-fill.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-.59374em) scale(.75);width:133.3333433333%}.mat-form-field-appearance-outline .mat-form-field-infix{padding:1em 0}.mat-form-field-appearance-outline .mat-form-field-label{top:1.84375em;margin-top:-.25em}.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-outline.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.59375em) scale(.75);width:133.3333333333%}.mat-form-field-appearance-outline.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.59374em) scale(.75);width:133.3333433333%}.mat-grid-tile-header,.mat-grid-tile-footer{font-size:14px}.mat-grid-tile-header .mat-line,.mat-grid-tile-footer .mat-line{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-grid-tile-header .mat-line:nth-child(n+2),.mat-grid-tile-footer .mat-line:nth-child(n+2){font-size:12px}input.mat-input-element{margin-top:-.0625em}.mat-menu-item{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:400}.mat-paginator,.mat-paginator-page-size .mat-select-trigger{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px}.mat-radio-button,.mat-select{font-family:Roboto,Helvetica Neue,sans-serif}.mat-select-trigger{height:1.125em}.mat-slide-toggle-content{font-family:Roboto,Helvetica Neue,sans-serif}.mat-slider-thumb-label-text{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px;font-weight:500}.mat-stepper-vertical,.mat-stepper-horizontal{font-family:Roboto,Helvetica Neue,sans-serif}.mat-step-label{font-size:14px;font-weight:400}.mat-step-sub-label-error{font-weight:400}.mat-step-label-error{font-size:14px}.mat-step-label-selected{font-size:14px;font-weight:500}.mat-tab-group{font-family:Roboto,Helvetica Neue,sans-serif}.mat-tab-label,.mat-tab-link{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-toolbar,.mat-toolbar h1,.mat-toolbar h2,.mat-toolbar h3,.mat-toolbar h4,.mat-toolbar h5,.mat-toolbar h6{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0}.mat-tooltip{font-family:Roboto,Helvetica Neue,sans-serif;font-size:10px;padding-top:6px;padding-bottom:6px}.mat-tooltip-handset{font-size:14px;padding-top:8px;padding-bottom:8px}.mat-list-item,.mat-list-option{font-family:Roboto,Helvetica Neue,sans-serif}.mat-ripple-element{background-color:#0000001a}.mat-option{color:#000000de}.mat-option:hover:not(.mat-option-disabled),.mat-option:focus:not(.mat-option-disabled){background:rgba(0,0,0,.04)}.mat-option.mat-selected:not(.mat-option-multiple):not(.mat-option-disabled){background:rgba(0,0,0,.04)}.mat-option.mat-active{background:rgba(0,0,0,.04);color:#000000de}.mat-option.mat-option-disabled{color:#00000061}.mat-primary .mat-option.mat-selected:not(.mat-option-disabled){color:#5fa0c5}.mat-accent .mat-option.mat-selected:not(.mat-option-disabled){color:#95b8a2}.mat-warn .mat-option.mat-selected:not(.mat-option-disabled){color:#c62e3c}.mat-optgroup-label{color:#0000008a}.mat-optgroup-disabled .mat-optgroup-label{color:#00000061}.mat-pseudo-checkbox{color:#0000008a}.mat-pseudo-checkbox:after{color:#fafafa}.mat-pseudo-checkbox-disabled{color:#b0b0b0}.mat-primary .mat-pseudo-checkbox-checked,.mat-primary .mat-pseudo-checkbox-indeterminate{background:#5fa0c5}.mat-pseudo-checkbox-checked,.mat-pseudo-checkbox-indeterminate,.mat-accent .mat-pseudo-checkbox-checked,.mat-accent .mat-pseudo-checkbox-indeterminate{background:#95b8a2}.mat-warn .mat-pseudo-checkbox-checked,.mat-warn .mat-pseudo-checkbox-indeterminate{background:#c62e3c}.mat-pseudo-checkbox-checked.mat-pseudo-checkbox-disabled,.mat-pseudo-checkbox-indeterminate.mat-pseudo-checkbox-disabled{background:#b0b0b0}.mat-app-background{background-color:#fafafa;color:#000000de}.mat-elevation-z0{box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-elevation-z1{box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.mat-elevation-z2{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-elevation-z3{box-shadow:0 3px 3px -2px #0003,0 3px 4px #00000024,0 1px 8px #0000001f}.mat-elevation-z4{box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mat-elevation-z5{box-shadow:0 3px 5px -1px #0003,0 5px 8px #00000024,0 1px 14px #0000001f}.mat-elevation-z6{box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mat-elevation-z7{box-shadow:0 4px 5px -2px #0003,0 7px 10px 1px #00000024,0 2px 16px 1px #0000001f}.mat-elevation-z8{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.mat-elevation-z9{box-shadow:0 5px 6px -3px #0003,0 9px 12px 1px #00000024,0 3px 16px 2px #0000001f}.mat-elevation-z10{box-shadow:0 6px 6px -3px #0003,0 10px 14px 1px #00000024,0 4px 18px 3px #0000001f}.mat-elevation-z11{box-shadow:0 6px 7px -4px #0003,0 11px 15px 1px #00000024,0 4px 20px 3px #0000001f}.mat-elevation-z12{box-shadow:0 7px 8px -4px #0003,0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f}.mat-elevation-z13{box-shadow:0 7px 8px -4px #0003,0 13px 19px 2px #00000024,0 5px 24px 4px #0000001f}.mat-elevation-z14{box-shadow:0 7px 9px -4px #0003,0 14px 21px 2px #00000024,0 5px 26px 4px #0000001f}.mat-elevation-z15{box-shadow:0 8px 9px -5px #0003,0 15px 22px 2px #00000024,0 6px 28px 5px #0000001f}.mat-elevation-z16{box-shadow:0 8px 10px -5px #0003,0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f}.mat-elevation-z17{box-shadow:0 8px 11px -5px #0003,0 17px 26px 2px #00000024,0 6px 32px 5px #0000001f}.mat-elevation-z18{box-shadow:0 9px 11px -5px #0003,0 18px 28px 2px #00000024,0 7px 34px 6px #0000001f}.mat-elevation-z19{box-shadow:0 9px 12px -6px #0003,0 19px 29px 2px #00000024,0 7px 36px 6px #0000001f}.mat-elevation-z20{box-shadow:0 10px 13px -6px #0003,0 20px 31px 3px #00000024,0 8px 38px 7px #0000001f}.mat-elevation-z21{box-shadow:0 10px 13px -6px #0003,0 21px 33px 3px #00000024,0 8px 40px 7px #0000001f}.mat-elevation-z22{box-shadow:0 10px 14px -6px #0003,0 22px 35px 3px #00000024,0 8px 42px 7px #0000001f}.mat-elevation-z23{box-shadow:0 11px 14px -7px #0003,0 23px 36px 3px #00000024,0 9px 44px 8px #0000001f}.mat-elevation-z24{box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f}.mat-theme-loaded-marker{display:none}.mat-autocomplete-panel{background:white;color:#000000de}.mat-autocomplete-panel:not([class*=mat-elevation-z]){box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mat-autocomplete-panel .mat-option.mat-selected:not(.mat-active):not(:hover){background:white}.mat-autocomplete-panel .mat-option.mat-selected:not(.mat-active):not(:hover):not(.mat-option-disabled){color:#000000de}.mat-badge{position:relative}.mat-badge.mat-badge{overflow:visible}.mat-badge-hidden .mat-badge-content{display:none}.mat-badge-content{position:absolute;text-align:center;display:inline-block;border-radius:50%;transition:transform .2s ease-in-out;transform:scale(.6);overflow:hidden;white-space:nowrap;text-overflow:ellipsis;pointer-events:none}.ng-animate-disabled .mat-badge-content,.mat-badge-content._mat-animation-noopable{transition:none}.mat-badge-content.mat-badge-active{transform:none}.mat-badge-small .mat-badge-content{width:16px;height:16px;line-height:16px}.mat-badge-small.mat-badge-above .mat-badge-content{top:-8px}.mat-badge-small.mat-badge-below .mat-badge-content{bottom:-8px}.mat-badge-small.mat-badge-before .mat-badge-content{left:-16px}[dir=rtl] .mat-badge-small.mat-badge-before .mat-badge-content{left:auto;right:-16px}.mat-badge-small.mat-badge-after .mat-badge-content{right:-16px}[dir=rtl] .mat-badge-small.mat-badge-after .mat-badge-content{right:auto;left:-16px}.mat-badge-small.mat-badge-overlap.mat-badge-before .mat-badge-content{left:-8px}[dir=rtl] .mat-badge-small.mat-badge-overlap.mat-badge-before .mat-badge-content{left:auto;right:-8px}.mat-badge-small.mat-badge-overlap.mat-badge-after .mat-badge-content{right:-8px}[dir=rtl] .mat-badge-small.mat-badge-overlap.mat-badge-after .mat-badge-content{right:auto;left:-8px}.mat-badge-medium .mat-badge-content{width:22px;height:22px;line-height:22px}.mat-badge-medium.mat-badge-above .mat-badge-content{top:-11px}.mat-badge-medium.mat-badge-below .mat-badge-content{bottom:-11px}.mat-badge-medium.mat-badge-before .mat-badge-content{left:-22px}[dir=rtl] .mat-badge-medium.mat-badge-before .mat-badge-content{left:auto;right:-22px}.mat-badge-medium.mat-badge-after .mat-badge-content{right:-22px}[dir=rtl] .mat-badge-medium.mat-badge-after .mat-badge-content{right:auto;left:-22px}.mat-badge-medium.mat-badge-overlap.mat-badge-before .mat-badge-content{left:-11px}[dir=rtl] .mat-badge-medium.mat-badge-overlap.mat-badge-before .mat-badge-content{left:auto;right:-11px}.mat-badge-medium.mat-badge-overlap.mat-badge-after .mat-badge-content{right:-11px}[dir=rtl] .mat-badge-medium.mat-badge-overlap.mat-badge-after .mat-badge-content{right:auto;left:-11px}.mat-badge-large .mat-badge-content{width:28px;height:28px;line-height:28px}.mat-badge-large.mat-badge-above .mat-badge-content{top:-14px}.mat-badge-large.mat-badge-below .mat-badge-content{bottom:-14px}.mat-badge-large.mat-badge-before .mat-badge-content{left:-28px}[dir=rtl] .mat-badge-large.mat-badge-before .mat-badge-content{left:auto;right:-28px}.mat-badge-large.mat-badge-after .mat-badge-content{right:-28px}[dir=rtl] .mat-badge-large.mat-badge-after .mat-badge-content{right:auto;left:-28px}.mat-badge-large.mat-badge-overlap.mat-badge-before .mat-badge-content{left:-14px}[dir=rtl] .mat-badge-large.mat-badge-overlap.mat-badge-before .mat-badge-content{left:auto;right:-14px}.mat-badge-large.mat-badge-overlap.mat-badge-after .mat-badge-content{right:-14px}[dir=rtl] .mat-badge-large.mat-badge-overlap.mat-badge-after .mat-badge-content{right:auto;left:-14px}.mat-badge-content{color:#000;background:#5fa0c5}.cdk-high-contrast-active .mat-badge-content{outline:solid 1px;border-radius:0}.mat-badge-accent .mat-badge-content{background:#95b8a2;color:#000}.mat-badge-warn .mat-badge-content{color:#fff;background:#c62e3c}.mat-badge-disabled .mat-badge-content{background:#b9b9b9;color:#00000061}.mat-bottom-sheet-container{box-shadow:0 8px 10px -5px #0003,0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f;background:white;color:#000000de}.mat-button,.mat-icon-button,.mat-stroked-button{color:inherit;background:transparent}.mat-button.mat-primary,.mat-icon-button.mat-primary,.mat-stroked-button.mat-primary{color:#5fa0c5}.mat-button.mat-accent,.mat-icon-button.mat-accent,.mat-stroked-button.mat-accent{color:#95b8a2}.mat-button.mat-warn,.mat-icon-button.mat-warn,.mat-stroked-button.mat-warn{color:#c62e3c}.mat-button.mat-primary.mat-button-disabled,.mat-button.mat-accent.mat-button-disabled,.mat-button.mat-warn.mat-button-disabled,.mat-button.mat-button-disabled.mat-button-disabled,.mat-icon-button.mat-primary.mat-button-disabled,.mat-icon-button.mat-accent.mat-button-disabled,.mat-icon-button.mat-warn.mat-button-disabled,.mat-icon-button.mat-button-disabled.mat-button-disabled,.mat-stroked-button.mat-primary.mat-button-disabled,.mat-stroked-button.mat-accent.mat-button-disabled,.mat-stroked-button.mat-warn.mat-button-disabled,.mat-stroked-button.mat-button-disabled.mat-button-disabled{color:#00000042}.mat-button.mat-primary .mat-button-focus-overlay,.mat-icon-button.mat-primary .mat-button-focus-overlay,.mat-stroked-button.mat-primary .mat-button-focus-overlay{background-color:#5fa0c5}.mat-button.mat-accent .mat-button-focus-overlay,.mat-icon-button.mat-accent .mat-button-focus-overlay,.mat-stroked-button.mat-accent .mat-button-focus-overlay{background-color:#95b8a2}.mat-button.mat-warn .mat-button-focus-overlay,.mat-icon-button.mat-warn .mat-button-focus-overlay,.mat-stroked-button.mat-warn .mat-button-focus-overlay{background-color:#c62e3c}.mat-button.mat-button-disabled .mat-button-focus-overlay,.mat-icon-button.mat-button-disabled .mat-button-focus-overlay,.mat-stroked-button.mat-button-disabled .mat-button-focus-overlay{background-color:transparent}.mat-button .mat-ripple-element,.mat-icon-button .mat-ripple-element,.mat-stroked-button .mat-ripple-element{opacity:.1;background-color:currentColor}.mat-button-focus-overlay{background:black}.mat-stroked-button:not(.mat-button-disabled){border-color:#0000001f}.mat-flat-button,.mat-raised-button,.mat-fab,.mat-mini-fab{color:#000000de;background-color:#fff}.mat-flat-button.mat-primary,.mat-raised-button.mat-primary,.mat-fab.mat-primary,.mat-mini-fab.mat-primary,.mat-flat-button.mat-accent,.mat-raised-button.mat-accent,.mat-fab.mat-accent,.mat-mini-fab.mat-accent{color:#000}.mat-flat-button.mat-warn,.mat-raised-button.mat-warn,.mat-fab.mat-warn,.mat-mini-fab.mat-warn{color:#fff}.mat-flat-button.mat-primary.mat-button-disabled,.mat-flat-button.mat-accent.mat-button-disabled,.mat-flat-button.mat-warn.mat-button-disabled,.mat-flat-button.mat-button-disabled.mat-button-disabled,.mat-raised-button.mat-primary.mat-button-disabled,.mat-raised-button.mat-accent.mat-button-disabled,.mat-raised-button.mat-warn.mat-button-disabled,.mat-raised-button.mat-button-disabled.mat-button-disabled,.mat-fab.mat-primary.mat-button-disabled,.mat-fab.mat-accent.mat-button-disabled,.mat-fab.mat-warn.mat-button-disabled,.mat-fab.mat-button-disabled.mat-button-disabled,.mat-mini-fab.mat-primary.mat-button-disabled,.mat-mini-fab.mat-accent.mat-button-disabled,.mat-mini-fab.mat-warn.mat-button-disabled,.mat-mini-fab.mat-button-disabled.mat-button-disabled{color:#00000042}.mat-flat-button.mat-primary,.mat-raised-button.mat-primary,.mat-fab.mat-primary,.mat-mini-fab.mat-primary{background-color:#5fa0c5}.mat-flat-button.mat-accent,.mat-raised-button.mat-accent,.mat-fab.mat-accent,.mat-mini-fab.mat-accent{background-color:#95b8a2}.mat-flat-button.mat-warn,.mat-raised-button.mat-warn,.mat-fab.mat-warn,.mat-mini-fab.mat-warn{background-color:#c62e3c}.mat-flat-button.mat-primary.mat-button-disabled,.mat-flat-button.mat-accent.mat-button-disabled,.mat-flat-button.mat-warn.mat-button-disabled,.mat-flat-button.mat-button-disabled.mat-button-disabled,.mat-raised-button.mat-primary.mat-button-disabled,.mat-raised-button.mat-accent.mat-button-disabled,.mat-raised-button.mat-warn.mat-button-disabled,.mat-raised-button.mat-button-disabled.mat-button-disabled,.mat-fab.mat-primary.mat-button-disabled,.mat-fab.mat-accent.mat-button-disabled,.mat-fab.mat-warn.mat-button-disabled,.mat-fab.mat-button-disabled.mat-button-disabled,.mat-mini-fab.mat-primary.mat-button-disabled,.mat-mini-fab.mat-accent.mat-button-disabled,.mat-mini-fab.mat-warn.mat-button-disabled,.mat-mini-fab.mat-button-disabled.mat-button-disabled{background-color:#0000001f}.mat-flat-button.mat-primary .mat-ripple-element,.mat-raised-button.mat-primary .mat-ripple-element,.mat-fab.mat-primary .mat-ripple-element,.mat-mini-fab.mat-primary .mat-ripple-element,.mat-flat-button.mat-accent .mat-ripple-element,.mat-raised-button.mat-accent .mat-ripple-element,.mat-fab.mat-accent .mat-ripple-element,.mat-mini-fab.mat-accent .mat-ripple-element{background-color:#0000001a}.mat-flat-button.mat-warn .mat-ripple-element,.mat-raised-button.mat-warn .mat-ripple-element,.mat-fab.mat-warn .mat-ripple-element,.mat-mini-fab.mat-warn .mat-ripple-element{background-color:#ffffff1a}.mat-stroked-button:not([class*=mat-elevation-z]),.mat-flat-button:not([class*=mat-elevation-z]){box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-raised-button:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-raised-button:not(.mat-button-disabled):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.mat-raised-button.mat-button-disabled:not([class*=mat-elevation-z]){box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-fab:not([class*=mat-elevation-z]),.mat-mini-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mat-fab:not(.mat-button-disabled):active:not([class*=mat-elevation-z]),.mat-mini-fab:not(.mat-button-disabled):active:not([class*=mat-elevation-z]){box-shadow:0 7px 8px -4px #0003,0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f}.mat-fab.mat-button-disabled:not([class*=mat-elevation-z]),.mat-mini-fab.mat-button-disabled:not([class*=mat-elevation-z]){box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-button-toggle-standalone:not([class*=mat-elevation-z]),.mat-button-toggle-group:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-button-toggle-standalone.mat-button-toggle-appearance-standard:not([class*=mat-elevation-z]),.mat-button-toggle-group-appearance-standard:not([class*=mat-elevation-z]){box-shadow:none}.mat-button-toggle{color:#00000061}.mat-button-toggle .mat-button-toggle-focus-overlay{background-color:#0000001f}.mat-button-toggle-appearance-standard{color:#000000de;background:white}.mat-button-toggle-appearance-standard .mat-button-toggle-focus-overlay{background-color:#000}.mat-button-toggle-group-appearance-standard .mat-button-toggle+.mat-button-toggle{border-left:solid 1px #e0e0e0}[dir=rtl] .mat-button-toggle-group-appearance-standard .mat-button-toggle+.mat-button-toggle{border-left:none;border-right:solid 1px #e0e0e0}.mat-button-toggle-group-appearance-standard.mat-button-toggle-vertical .mat-button-toggle+.mat-button-toggle{border-left:none;border-right:none;border-top:solid 1px #e0e0e0}.mat-button-toggle-checked{background-color:#e0e0e0;color:#0000008a}.mat-button-toggle-checked.mat-button-toggle-appearance-standard{color:#000000de}.mat-button-toggle-disabled{color:#00000042;background-color:#eee}.mat-button-toggle-disabled.mat-button-toggle-appearance-standard{background:white}.mat-button-toggle-disabled.mat-button-toggle-checked{background-color:#bdbdbd}.mat-button-toggle-standalone.mat-button-toggle-appearance-standard,.mat-button-toggle-group-appearance-standard{border:solid 1px #e0e0e0}.mat-button-toggle-appearance-standard .mat-button-toggle-label-content{line-height:48px}.mat-card{background:white;color:#000000de}.mat-card:not([class*=mat-elevation-z]){box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.mat-card.mat-card-flat:not([class*=mat-elevation-z]){box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-card-subtitle{color:#0000008a}.mat-checkbox-frame{border-color:#0000008a}.mat-checkbox-checkmark{fill:#fafafa}.mat-checkbox-checkmark-path{stroke:#fafafa!important}.mat-checkbox-mixedmark{background-color:#fafafa}.mat-checkbox-indeterminate.mat-primary .mat-checkbox-background,.mat-checkbox-checked.mat-primary .mat-checkbox-background{background-color:#5fa0c5}.mat-checkbox-indeterminate.mat-accent .mat-checkbox-background,.mat-checkbox-checked.mat-accent .mat-checkbox-background{background-color:#95b8a2}.mat-checkbox-indeterminate.mat-warn .mat-checkbox-background,.mat-checkbox-checked.mat-warn .mat-checkbox-background{background-color:#c62e3c}.mat-checkbox-disabled.mat-checkbox-checked .mat-checkbox-background,.mat-checkbox-disabled.mat-checkbox-indeterminate .mat-checkbox-background{background-color:#b0b0b0}.mat-checkbox-disabled:not(.mat-checkbox-checked) .mat-checkbox-frame{border-color:#b0b0b0}.mat-checkbox-disabled .mat-checkbox-label{color:#00000061}.mat-checkbox .mat-ripple-element{background-color:#000}.mat-checkbox-checked:not(.mat-checkbox-disabled).mat-primary .mat-ripple-element,.mat-checkbox:active:not(.mat-checkbox-disabled).mat-primary .mat-ripple-element{background:#5fa0c5}.mat-checkbox-checked:not(.mat-checkbox-disabled).mat-accent .mat-ripple-element,.mat-checkbox:active:not(.mat-checkbox-disabled).mat-accent .mat-ripple-element{background:#95b8a2}.mat-checkbox-checked:not(.mat-checkbox-disabled).mat-warn .mat-ripple-element,.mat-checkbox:active:not(.mat-checkbox-disabled).mat-warn .mat-ripple-element{background:#c62e3c}.mat-chip.mat-standard-chip{background-color:#e0e0e0;color:#000000de}.mat-chip.mat-standard-chip .mat-chip-remove{color:#000000de;opacity:.4}.mat-chip.mat-standard-chip:not(.mat-chip-disabled):active{box-shadow:0 3px 3px -2px #0003,0 3px 4px #00000024,0 1px 8px #0000001f}.mat-chip.mat-standard-chip:not(.mat-chip-disabled) .mat-chip-remove:hover{opacity:.54}.mat-chip.mat-standard-chip.mat-chip-disabled{opacity:.4}.mat-chip.mat-standard-chip:after{background:black}.mat-chip.mat-standard-chip.mat-chip-selected.mat-primary{background-color:#5fa0c5;color:#000}.mat-chip.mat-standard-chip.mat-chip-selected.mat-primary .mat-chip-remove{color:#000;opacity:.4}.mat-chip.mat-standard-chip.mat-chip-selected.mat-primary .mat-ripple-element{background-color:#0000001a}.mat-chip.mat-standard-chip.mat-chip-selected.mat-warn{background-color:#c62e3c;color:#fff}.mat-chip.mat-standard-chip.mat-chip-selected.mat-warn .mat-chip-remove{color:#fff;opacity:.4}.mat-chip.mat-standard-chip.mat-chip-selected.mat-warn .mat-ripple-element{background-color:#ffffff1a}.mat-chip.mat-standard-chip.mat-chip-selected.mat-accent{background-color:#95b8a2;color:#000}.mat-chip.mat-standard-chip.mat-chip-selected.mat-accent .mat-chip-remove{color:#000;opacity:.4}.mat-chip.mat-standard-chip.mat-chip-selected.mat-accent .mat-ripple-element{background-color:#0000001a}.mat-table{background:white}.mat-table thead,.mat-table tbody,.mat-table tfoot,mat-header-row,mat-row,mat-footer-row,[mat-header-row],[mat-row],[mat-footer-row],.mat-table-sticky{background:inherit}mat-row,mat-header-row,mat-footer-row,th.mat-header-cell,td.mat-cell,td.mat-footer-cell{border-bottom-color:#0000001f}.mat-header-cell{color:#0000008a}.mat-cell,.mat-footer-cell{color:#000000de}.mat-calendar-arrow{fill:#0000008a}.mat-datepicker-toggle,.mat-datepicker-content .mat-calendar-next-button,.mat-datepicker-content .mat-calendar-previous-button{color:#0000008a}.mat-calendar-table-header-divider:after{background:rgba(0,0,0,.12)}.mat-calendar-table-header,.mat-calendar-body-label{color:#0000008a}.mat-calendar-body-cell-content,.mat-date-range-input-separator{color:#000000de;border-color:transparent}.mat-calendar-body-disabled>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){color:#00000061}.mat-form-field-disabled .mat-date-range-input-separator{color:#00000061}.mat-calendar-body-in-preview{color:#0000003d}.mat-calendar-body-today:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){border-color:#00000061}.mat-calendar-body-disabled>.mat-calendar-body-today:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){border-color:#0000002e}.mat-calendar-body-in-range:before{background:rgba(95,160,197,.2)}.mat-calendar-body-comparison-identical,.mat-calendar-body-in-comparison-range:before{background:rgba(249,171,0,.2)}.mat-calendar-body-comparison-bridge-start:before,[dir=rtl] .mat-calendar-body-comparison-bridge-end:before{background:linear-gradient(to right,rgba(95,160,197,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-calendar-body-comparison-bridge-end:before,[dir=rtl] .mat-calendar-body-comparison-bridge-start:before{background:linear-gradient(to left,rgba(95,160,197,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-calendar-body-in-range>.mat-calendar-body-comparison-identical,.mat-calendar-body-in-comparison-range.mat-calendar-body-in-range:after{background:#a8dab5}.mat-calendar-body-comparison-identical.mat-calendar-body-selected,.mat-calendar-body-in-comparison-range>.mat-calendar-body-selected{background:#46a35e}.mat-calendar-body-selected{background-color:#5fa0c5;color:#000}.mat-calendar-body-disabled>.mat-calendar-body-selected{background-color:#5fa0c566}.mat-calendar-body-today.mat-calendar-body-selected{box-shadow:inset 0 0 0 1px #000}.cdk-keyboard-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical),.cdk-program-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#5fa0c54d}@media (hover: hover){.mat-calendar-body-cell:not(.mat-calendar-body-disabled):hover>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#5fa0c54d}}.mat-datepicker-content{box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f;background-color:#fff;color:#000000de}.mat-datepicker-content.mat-accent .mat-calendar-body-in-range:before{background:rgba(149,184,162,.2)}.mat-datepicker-content.mat-accent .mat-calendar-body-comparison-identical,.mat-datepicker-content.mat-accent .mat-calendar-body-in-comparison-range:before{background:rgba(249,171,0,.2)}.mat-datepicker-content.mat-accent .mat-calendar-body-comparison-bridge-start:before,.mat-datepicker-content.mat-accent [dir=rtl] .mat-calendar-body-comparison-bridge-end:before{background:linear-gradient(to right,rgba(149,184,162,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-datepicker-content.mat-accent .mat-calendar-body-comparison-bridge-end:before,.mat-datepicker-content.mat-accent [dir=rtl] .mat-calendar-body-comparison-bridge-start:before{background:linear-gradient(to left,rgba(149,184,162,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-datepicker-content.mat-accent .mat-calendar-body-in-range>.mat-calendar-body-comparison-identical,.mat-datepicker-content.mat-accent .mat-calendar-body-in-comparison-range.mat-calendar-body-in-range:after{background:#a8dab5}.mat-datepicker-content.mat-accent .mat-calendar-body-comparison-identical.mat-calendar-body-selected,.mat-datepicker-content.mat-accent .mat-calendar-body-in-comparison-range>.mat-calendar-body-selected{background:#46a35e}.mat-datepicker-content.mat-accent .mat-calendar-body-selected{background-color:#95b8a2;color:#000}.mat-datepicker-content.mat-accent .mat-calendar-body-disabled>.mat-calendar-body-selected{background-color:#95b8a266}.mat-datepicker-content.mat-accent .mat-calendar-body-today.mat-calendar-body-selected{box-shadow:inset 0 0 0 1px #000}.mat-datepicker-content.mat-accent .cdk-keyboard-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical),.mat-datepicker-content.mat-accent .cdk-program-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#95b8a24d}@media (hover: hover){.mat-datepicker-content.mat-accent .mat-calendar-body-cell:not(.mat-calendar-body-disabled):hover>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#95b8a24d}}.mat-datepicker-content.mat-warn .mat-calendar-body-in-range:before{background:rgba(198,46,60,.2)}.mat-datepicker-content.mat-warn .mat-calendar-body-comparison-identical,.mat-datepicker-content.mat-warn .mat-calendar-body-in-comparison-range:before{background:rgba(249,171,0,.2)}.mat-datepicker-content.mat-warn .mat-calendar-body-comparison-bridge-start:before,.mat-datepicker-content.mat-warn [dir=rtl] .mat-calendar-body-comparison-bridge-end:before{background:linear-gradient(to right,rgba(198,46,60,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-datepicker-content.mat-warn .mat-calendar-body-comparison-bridge-end:before,.mat-datepicker-content.mat-warn [dir=rtl] .mat-calendar-body-comparison-bridge-start:before{background:linear-gradient(to left,rgba(198,46,60,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-datepicker-content.mat-warn .mat-calendar-body-in-range>.mat-calendar-body-comparison-identical,.mat-datepicker-content.mat-warn .mat-calendar-body-in-comparison-range.mat-calendar-body-in-range:after{background:#a8dab5}.mat-datepicker-content.mat-warn .mat-calendar-body-comparison-identical.mat-calendar-body-selected,.mat-datepicker-content.mat-warn .mat-calendar-body-in-comparison-range>.mat-calendar-body-selected{background:#46a35e}.mat-datepicker-content.mat-warn .mat-calendar-body-selected{background-color:#c62e3c;color:#fff}.mat-datepicker-content.mat-warn .mat-calendar-body-disabled>.mat-calendar-body-selected{background-color:#c62e3c66}.mat-datepicker-content.mat-warn .mat-calendar-body-today.mat-calendar-body-selected{box-shadow:inset 0 0 0 1px #fff}.mat-datepicker-content.mat-warn .cdk-keyboard-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical),.mat-datepicker-content.mat-warn .cdk-program-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#c62e3c4d}@media (hover: hover){.mat-datepicker-content.mat-warn .mat-calendar-body-cell:not(.mat-calendar-body-disabled):hover>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#c62e3c4d}}.mat-datepicker-content-touch{box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f}.mat-datepicker-toggle-active{color:#5fa0c5}.mat-datepicker-toggle-active.mat-accent{color:#95b8a2}.mat-datepicker-toggle-active.mat-warn{color:#c62e3c}.mat-date-range-input-inner[disabled]{color:#00000061}.mat-dialog-container{box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f;background:white;color:#000000de}.mat-divider{border-top-color:#0000001f}.mat-divider-vertical{border-right-color:#0000001f}.mat-expansion-panel{background:white;color:#000000de}.mat-expansion-panel:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-action-row{border-top-color:#0000001f}.mat-expansion-panel .mat-expansion-panel-header.cdk-keyboard-focused:not([aria-disabled=true]),.mat-expansion-panel .mat-expansion-panel-header.cdk-program-focused:not([aria-disabled=true]),.mat-expansion-panel:not(.mat-expanded) .mat-expansion-panel-header:hover:not([aria-disabled=true]){background:rgba(0,0,0,.04)}@media (hover: none){.mat-expansion-panel:not(.mat-expanded):not([aria-disabled=true]) .mat-expansion-panel-header:hover{background:white}}.mat-expansion-panel-header-title{color:#000000de}.mat-expansion-panel-header-description,.mat-expansion-indicator:after{color:#0000008a}.mat-expansion-panel-header[aria-disabled=true]{color:#00000042}.mat-expansion-panel-header[aria-disabled=true] .mat-expansion-panel-header-title,.mat-expansion-panel-header[aria-disabled=true] .mat-expansion-panel-header-description{color:inherit}.mat-expansion-panel-header{height:48px}.mat-expansion-panel-header.mat-expanded{height:64px}.mat-form-field-label,.mat-hint{color:#0009}.mat-form-field.mat-focused .mat-form-field-label{color:#5fa0c5}.mat-form-field.mat-focused .mat-form-field-label.mat-accent{color:#95b8a2}.mat-form-field.mat-focused .mat-form-field-label.mat-warn{color:#c62e3c}.mat-focused .mat-form-field-required-marker{color:#95b8a2}.mat-form-field-ripple{background-color:#000000de}.mat-form-field.mat-focused .mat-form-field-ripple{background-color:#5fa0c5}.mat-form-field.mat-focused .mat-form-field-ripple.mat-accent{background-color:#95b8a2}.mat-form-field.mat-focused .mat-form-field-ripple.mat-warn{background-color:#c62e3c}.mat-form-field-type-mat-native-select.mat-focused:not(.mat-form-field-invalid) .mat-form-field-infix:after{color:#5fa0c5}.mat-form-field-type-mat-native-select.mat-focused:not(.mat-form-field-invalid).mat-accent .mat-form-field-infix:after{color:#95b8a2}.mat-form-field-type-mat-native-select.mat-focused:not(.mat-form-field-invalid).mat-warn .mat-form-field-infix:after{color:#c62e3c}.mat-form-field.mat-form-field-invalid .mat-form-field-label,.mat-form-field.mat-form-field-invalid .mat-form-field-label.mat-accent,.mat-form-field.mat-form-field-invalid .mat-form-field-label .mat-form-field-required-marker{color:#c62e3c}.mat-form-field.mat-form-field-invalid .mat-form-field-ripple,.mat-form-field.mat-form-field-invalid .mat-form-field-ripple.mat-accent{background-color:#c62e3c}.mat-error{color:#c62e3c}.mat-form-field-appearance-legacy .mat-form-field-label,.mat-form-field-appearance-legacy .mat-hint{color:#0000008a}.mat-form-field-appearance-legacy .mat-form-field-underline{background-color:#0000006b}.mat-form-field-appearance-legacy.mat-form-field-disabled .mat-form-field-underline{background-image:linear-gradient(to right,rgba(0,0,0,.42) 0%,rgba(0,0,0,.42) 33%,transparent 0%);background-size:4px 100%;background-repeat:repeat-x}.mat-form-field-appearance-standard .mat-form-field-underline{background-color:#0000006b}.mat-form-field-appearance-standard.mat-form-field-disabled .mat-form-field-underline{background-image:linear-gradient(to right,rgba(0,0,0,.42) 0%,rgba(0,0,0,.42) 33%,transparent 0%);background-size:4px 100%;background-repeat:repeat-x}.mat-form-field-appearance-fill .mat-form-field-flex{background-color:#0000000a}.mat-form-field-appearance-fill.mat-form-field-disabled .mat-form-field-flex{background-color:#00000005}.mat-form-field-appearance-fill .mat-form-field-underline:before{background-color:#0000006b}.mat-form-field-appearance-fill.mat-form-field-disabled .mat-form-field-label{color:#00000061}.mat-form-field-appearance-fill.mat-form-field-disabled .mat-form-field-underline:before{background-color:transparent}.mat-form-field-appearance-outline .mat-form-field-outline{color:#0000001f}.mat-form-field-appearance-outline .mat-form-field-outline-thick{color:#000000de}.mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick{color:#5fa0c5}.mat-form-field-appearance-outline.mat-focused.mat-accent .mat-form-field-outline-thick{color:#95b8a2}.mat-form-field-appearance-outline.mat-focused.mat-warn .mat-form-field-outline-thick,.mat-form-field-appearance-outline.mat-form-field-invalid.mat-form-field-invalid .mat-form-field-outline-thick{color:#c62e3c}.mat-form-field-appearance-outline.mat-form-field-disabled .mat-form-field-label{color:#00000061}.mat-form-field-appearance-outline.mat-form-field-disabled .mat-form-field-outline{color:#0000000f}.mat-icon.mat-primary{color:#5fa0c5}.mat-icon.mat-accent{color:#95b8a2}.mat-icon.mat-warn{color:#c62e3c}.mat-form-field-type-mat-native-select .mat-form-field-infix:after{color:#0000008a}.mat-input-element:disabled,.mat-form-field-type-mat-native-select.mat-form-field-disabled .mat-form-field-infix:after{color:#00000061}.mat-input-element{caret-color:#5fa0c5}.mat-input-element::placeholder{color:#0000006b}.mat-input-element::-moz-placeholder{color:#0000006b}.mat-input-element::-webkit-input-placeholder{color:#0000006b}.mat-input-element:-ms-input-placeholder{color:#0000006b}.mat-form-field.mat-accent .mat-input-element{caret-color:#95b8a2}.mat-form-field.mat-warn .mat-input-element,.mat-form-field-invalid .mat-input-element{caret-color:#c62e3c}.mat-form-field-type-mat-native-select.mat-form-field-invalid .mat-form-field-infix:after{color:#c62e3c}.mat-list-base .mat-list-item,.mat-list-base .mat-list-option{color:#000000de}.mat-list-base .mat-subheader{color:#0000008a}.mat-list-base .mat-list-item-disabled{background-color:#eee;color:#00000061}.mat-list-option:hover,.mat-list-option:focus,.mat-nav-list .mat-list-item:hover,.mat-nav-list .mat-list-item:focus,.mat-action-list .mat-list-item:hover,.mat-action-list .mat-list-item:focus{background:rgba(0,0,0,.04)}.mat-list-single-selected-option,.mat-list-single-selected-option:hover,.mat-list-single-selected-option:focus{background:rgba(0,0,0,.12)}.mat-menu-panel{background:white}.mat-menu-panel:not([class*=mat-elevation-z]){box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mat-menu-item{background:transparent;color:#000000de}.mat-menu-item[disabled],.mat-menu-item[disabled] .mat-menu-submenu-icon,.mat-menu-item[disabled] .mat-icon-no-color{color:#00000061}.mat-menu-item .mat-icon-no-color,.mat-menu-submenu-icon{color:#0000008a}.mat-menu-item:hover:not([disabled]),.mat-menu-item.cdk-program-focused:not([disabled]),.mat-menu-item.cdk-keyboard-focused:not([disabled]),.mat-menu-item-highlighted:not([disabled]){background:rgba(0,0,0,.04)}.mat-paginator{background:white}.mat-paginator,.mat-paginator-page-size .mat-select-trigger{color:#0000008a}.mat-paginator-decrement,.mat-paginator-increment{border-top:2px solid rgba(0,0,0,.54);border-right:2px solid rgba(0,0,0,.54)}.mat-paginator-first,.mat-paginator-last{border-top:2px solid rgba(0,0,0,.54)}.mat-icon-button[disabled] .mat-paginator-decrement,.mat-icon-button[disabled] .mat-paginator-increment,.mat-icon-button[disabled] .mat-paginator-first,.mat-icon-button[disabled] .mat-paginator-last{border-color:#00000061}.mat-paginator-container{min-height:56px}.mat-progress-bar-background{fill:#d3e4ed}.mat-progress-bar-buffer{background-color:#d3e4ed}.mat-progress-bar-fill:after{background-color:#5fa0c5}.mat-progress-bar.mat-accent .mat-progress-bar-background{fill:#e1eae4}.mat-progress-bar.mat-accent .mat-progress-bar-buffer{background-color:#e1eae4}.mat-progress-bar.mat-accent .mat-progress-bar-fill:after{background-color:#95b8a2}.mat-progress-bar.mat-warn .mat-progress-bar-background{fill:#edc7cb}.mat-progress-bar.mat-warn .mat-progress-bar-buffer{background-color:#edc7cb}.mat-progress-bar.mat-warn .mat-progress-bar-fill:after{background-color:#c62e3c}.mat-progress-spinner circle,.mat-spinner circle{stroke:#5fa0c5}.mat-progress-spinner.mat-accent circle,.mat-spinner.mat-accent circle{stroke:#95b8a2}.mat-progress-spinner.mat-warn circle,.mat-spinner.mat-warn circle{stroke:#c62e3c}.mat-radio-outer-circle{border-color:#0000008a}.mat-radio-button.mat-primary.mat-radio-checked .mat-radio-outer-circle{border-color:#5fa0c5}.mat-radio-button.mat-primary .mat-radio-inner-circle,.mat-radio-button.mat-primary .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple),.mat-radio-button.mat-primary.mat-radio-checked .mat-radio-persistent-ripple,.mat-radio-button.mat-primary:active .mat-radio-persistent-ripple{background-color:#5fa0c5}.mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle{border-color:#95b8a2}.mat-radio-button.mat-accent .mat-radio-inner-circle,.mat-radio-button.mat-accent .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple),.mat-radio-button.mat-accent.mat-radio-checked .mat-radio-persistent-ripple,.mat-radio-button.mat-accent:active .mat-radio-persistent-ripple{background-color:#95b8a2}.mat-radio-button.mat-warn.mat-radio-checked .mat-radio-outer-circle{border-color:#c62e3c}.mat-radio-button.mat-warn .mat-radio-inner-circle,.mat-radio-button.mat-warn .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple),.mat-radio-button.mat-warn.mat-radio-checked .mat-radio-persistent-ripple,.mat-radio-button.mat-warn:active .mat-radio-persistent-ripple{background-color:#c62e3c}.mat-radio-button.mat-radio-disabled.mat-radio-checked .mat-radio-outer-circle,.mat-radio-button.mat-radio-disabled .mat-radio-outer-circle{border-color:#00000061}.mat-radio-button.mat-radio-disabled .mat-radio-ripple .mat-ripple-element,.mat-radio-button.mat-radio-disabled .mat-radio-inner-circle{background-color:#00000061}.mat-radio-button.mat-radio-disabled .mat-radio-label-content{color:#00000061}.mat-radio-button .mat-ripple-element{background-color:#000}.mat-select-value{color:#000000de}.mat-select-placeholder{color:#0000006b}.mat-select-disabled .mat-select-value{color:#00000061}.mat-select-arrow{color:#0000008a}.mat-select-panel{background:white}.mat-select-panel:not([class*=mat-elevation-z]){box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mat-select-panel .mat-option.mat-selected:not(.mat-option-multiple){background:rgba(0,0,0,.12)}.mat-form-field.mat-focused.mat-primary .mat-select-arrow{color:#5fa0c5}.mat-form-field.mat-focused.mat-accent .mat-select-arrow{color:#95b8a2}.mat-form-field.mat-focused.mat-warn .mat-select-arrow,.mat-form-field .mat-select.mat-select-invalid .mat-select-arrow{color:#c62e3c}.mat-form-field .mat-select.mat-select-disabled .mat-select-arrow{color:#00000061}.mat-drawer-container{background-color:#fafafa;color:#000000de}.mat-drawer{background-color:#fff;color:#000000de}.mat-drawer.mat-drawer-push{background-color:#fff}.mat-drawer:not(.mat-drawer-side){box-shadow:0 8px 10px -5px #0003,0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f}.mat-drawer-side{border-right:solid 1px rgba(0,0,0,.12)}.mat-drawer-side.mat-drawer-end,[dir=rtl] .mat-drawer-side{border-left:solid 1px rgba(0,0,0,.12);border-right:none}[dir=rtl] .mat-drawer-side.mat-drawer-end{border-left:none;border-right:solid 1px rgba(0,0,0,.12)}.mat-drawer-backdrop.mat-drawer-shown{background-color:#0009}.mat-slide-toggle.mat-checked .mat-slide-toggle-thumb{background-color:#95b8a2}.mat-slide-toggle.mat-checked .mat-slide-toggle-bar{background-color:#95b8a28a}.mat-slide-toggle.mat-checked .mat-ripple-element{background-color:#95b8a2}.mat-slide-toggle.mat-primary.mat-checked .mat-slide-toggle-thumb{background-color:#5fa0c5}.mat-slide-toggle.mat-primary.mat-checked .mat-slide-toggle-bar{background-color:#5fa0c58a}.mat-slide-toggle.mat-primary.mat-checked .mat-ripple-element{background-color:#5fa0c5}.mat-slide-toggle.mat-warn.mat-checked .mat-slide-toggle-thumb{background-color:#c62e3c}.mat-slide-toggle.mat-warn.mat-checked .mat-slide-toggle-bar{background-color:#c62e3c8a}.mat-slide-toggle.mat-warn.mat-checked .mat-ripple-element{background-color:#c62e3c}.mat-slide-toggle:not(.mat-checked) .mat-ripple-element{background-color:#000}.mat-slide-toggle-thumb{box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f;background-color:#fafafa}.mat-slide-toggle-bar{background-color:#00000061}.mat-slider-track-background{background-color:#00000042}.mat-slider.mat-primary .mat-slider-track-fill,.mat-slider.mat-primary .mat-slider-thumb,.mat-slider.mat-primary .mat-slider-thumb-label{background-color:#5fa0c5}.mat-slider.mat-primary .mat-slider-thumb-label-text{color:#000}.mat-slider.mat-primary .mat-slider-focus-ring{background-color:#5fa0c533}.mat-slider.mat-accent .mat-slider-track-fill,.mat-slider.mat-accent .mat-slider-thumb,.mat-slider.mat-accent .mat-slider-thumb-label{background-color:#95b8a2}.mat-slider.mat-accent .mat-slider-thumb-label-text{color:#000}.mat-slider.mat-accent .mat-slider-focus-ring{background-color:#95b8a233}.mat-slider.mat-warn .mat-slider-track-fill,.mat-slider.mat-warn .mat-slider-thumb,.mat-slider.mat-warn .mat-slider-thumb-label{background-color:#c62e3c}.mat-slider.mat-warn .mat-slider-thumb-label-text{color:#fff}.mat-slider.mat-warn .mat-slider-focus-ring{background-color:#c62e3c33}.mat-slider:hover .mat-slider-track-background,.mat-slider.cdk-focused .mat-slider-track-background{background-color:#00000061}.mat-slider.mat-slider-disabled .mat-slider-track-background,.mat-slider.mat-slider-disabled .mat-slider-track-fill,.mat-slider.mat-slider-disabled .mat-slider-thumb,.mat-slider.mat-slider-disabled:hover .mat-slider-track-background{background-color:#00000042}.mat-slider.mat-slider-min-value .mat-slider-focus-ring{background-color:#0000001f}.mat-slider.mat-slider-min-value.mat-slider-thumb-label-showing .mat-slider-thumb,.mat-slider.mat-slider-min-value.mat-slider-thumb-label-showing .mat-slider-thumb-label{background-color:#000000de}.mat-slider.mat-slider-min-value.mat-slider-thumb-label-showing.cdk-focused .mat-slider-thumb,.mat-slider.mat-slider-min-value.mat-slider-thumb-label-showing.cdk-focused .mat-slider-thumb-label{background-color:#00000042}.mat-slider.mat-slider-min-value:not(.mat-slider-thumb-label-showing) .mat-slider-thumb{border-color:#00000042;background-color:transparent}.mat-slider.mat-slider-min-value:not(.mat-slider-thumb-label-showing):hover .mat-slider-thumb,.mat-slider.mat-slider-min-value:not(.mat-slider-thumb-label-showing).cdk-focused .mat-slider-thumb{border-color:#00000061}.mat-slider.mat-slider-min-value:not(.mat-slider-thumb-label-showing):hover.mat-slider-disabled .mat-slider-thumb,.mat-slider.mat-slider-min-value:not(.mat-slider-thumb-label-showing).cdk-focused.mat-slider-disabled .mat-slider-thumb{border-color:#00000042}.mat-slider-has-ticks .mat-slider-wrapper:after{border-color:#000000b3}.mat-slider-horizontal .mat-slider-ticks{background-image:repeating-linear-gradient(to right,rgba(0,0,0,.7),rgba(0,0,0,.7) 2px,transparent 0,transparent);background-image:-moz-repeating-linear-gradient(.0001deg,rgba(0,0,0,.7),rgba(0,0,0,.7) 2px,transparent 0,transparent)}.mat-slider-vertical .mat-slider-ticks{background-image:repeating-linear-gradient(to bottom,rgba(0,0,0,.7),rgba(0,0,0,.7) 2px,transparent 0,transparent)}.mat-step-header.cdk-keyboard-focused,.mat-step-header.cdk-program-focused,.mat-step-header:hover:not([aria-disabled]),.mat-step-header:hover[aria-disabled=false]{background-color:#0000000a}.mat-step-header:hover[aria-disabled=true]{cursor:default}@media (hover: none){.mat-step-header:hover{background:none}}.mat-step-header .mat-step-label,.mat-step-header .mat-step-optional{color:#0000008a}.mat-step-header .mat-step-icon{background-color:#0000008a;color:#000}.mat-step-header .mat-step-icon-selected,.mat-step-header .mat-step-icon-state-done,.mat-step-header .mat-step-icon-state-edit{background-color:#5fa0c5;color:#000}.mat-step-header.mat-accent .mat-step-icon{color:#000}.mat-step-header.mat-accent .mat-step-icon-selected,.mat-step-header.mat-accent .mat-step-icon-state-done,.mat-step-header.mat-accent .mat-step-icon-state-edit{background-color:#95b8a2;color:#000}.mat-step-header.mat-warn .mat-step-icon{color:#fff}.mat-step-header.mat-warn .mat-step-icon-selected,.mat-step-header.mat-warn .mat-step-icon-state-done,.mat-step-header.mat-warn .mat-step-icon-state-edit{background-color:#c62e3c;color:#fff}.mat-step-header .mat-step-icon-state-error{background-color:transparent;color:#c62e3c}.mat-step-header .mat-step-label.mat-step-label-active{color:#000000de}.mat-step-header .mat-step-label.mat-step-label-error{color:#c62e3c}.mat-stepper-horizontal,.mat-stepper-vertical{background-color:#fff}.mat-stepper-vertical-line:before{border-left-color:#0000001f}.mat-horizontal-stepper-header:before,.mat-horizontal-stepper-header:after,.mat-stepper-horizontal-line{border-top-color:#0000001f}.mat-horizontal-stepper-header{height:72px}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header,.mat-vertical-stepper-header{padding:24px}.mat-stepper-vertical-line:before{top:-16px;bottom:-16px}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header:after,.mat-stepper-label-position-bottom .mat-horizontal-stepper-header:before{top:36px}.mat-stepper-label-position-bottom .mat-stepper-horizontal-line{top:36px}.mat-sort-header-arrow{color:#757575}.mat-tab-nav-bar,.mat-tab-header{border-bottom:1px solid rgba(0,0,0,.12)}.mat-tab-group-inverted-header .mat-tab-nav-bar,.mat-tab-group-inverted-header .mat-tab-header{border-top:1px solid rgba(0,0,0,.12);border-bottom:none}.mat-tab-label,.mat-tab-link{color:#000000de}.mat-tab-label.mat-tab-disabled,.mat-tab-link.mat-tab-disabled{color:#00000061}.mat-tab-header-pagination-chevron{border-color:#000000de}.mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron{border-color:#00000061}.mat-tab-group[class*=mat-background-]>.mat-tab-header,.mat-tab-nav-bar[class*=mat-background-]{border-bottom:none;border-top:none}.mat-tab-group.mat-primary .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-primary .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-group.mat-primary .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-primary .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-primary .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-primary .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-primary .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-primary .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled){background-color:#3273a34d}.mat-tab-group.mat-primary .mat-ink-bar,.mat-tab-nav-bar.mat-primary .mat-ink-bar{background-color:#5fa0c5}.mat-tab-group.mat-primary.mat-background-primary>.mat-tab-header .mat-ink-bar,.mat-tab-group.mat-primary.mat-background-primary>.mat-tab-link-container .mat-ink-bar,.mat-tab-nav-bar.mat-primary.mat-background-primary>.mat-tab-header .mat-ink-bar,.mat-tab-nav-bar.mat-primary.mat-background-primary>.mat-tab-link-container .mat-ink-bar{background-color:#000}.mat-tab-group.mat-accent .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-accent .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-group.mat-accent .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-accent .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-accent .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-accent .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-accent .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-accent .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled){background-color:#6791754d}.mat-tab-group.mat-accent .mat-ink-bar,.mat-tab-nav-bar.mat-accent .mat-ink-bar{background-color:#95b8a2}.mat-tab-group.mat-accent.mat-background-accent>.mat-tab-header .mat-ink-bar,.mat-tab-group.mat-accent.mat-background-accent>.mat-tab-link-container .mat-ink-bar,.mat-tab-nav-bar.mat-accent.mat-background-accent>.mat-tab-header .mat-ink-bar,.mat-tab-nav-bar.mat-accent.mat-background-accent>.mat-tab-link-container .mat-ink-bar{background-color:#000}.mat-tab-group.mat-warn .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-warn .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-group.mat-warn .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-warn .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-warn .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-warn .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-warn .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-warn .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled){background-color:#a4121a4d}.mat-tab-group.mat-warn .mat-ink-bar,.mat-tab-nav-bar.mat-warn .mat-ink-bar{background-color:#c62e3c}.mat-tab-group.mat-warn.mat-background-warn>.mat-tab-header .mat-ink-bar,.mat-tab-group.mat-warn.mat-background-warn>.mat-tab-link-container .mat-ink-bar,.mat-tab-nav-bar.mat-warn.mat-background-warn>.mat-tab-header .mat-ink-bar,.mat-tab-nav-bar.mat-warn.mat-background-warn>.mat-tab-link-container .mat-ink-bar{background-color:#fff}.mat-tab-group.mat-background-primary .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-primary .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-primary .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-primary .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-primary .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-primary .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-primary .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-primary .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled){background-color:#3273a34d}.mat-tab-group.mat-background-primary>.mat-tab-header,.mat-tab-group.mat-background-primary>.mat-tab-link-container,.mat-tab-group.mat-background-primary>.mat-tab-header-pagination,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header,.mat-tab-nav-bar.mat-background-primary>.mat-tab-link-container,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header-pagination{background-color:#5fa0c5}.mat-tab-group.mat-background-primary>.mat-tab-header .mat-tab-label,.mat-tab-group.mat-background-primary>.mat-tab-link-container .mat-tab-link,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header .mat-tab-label,.mat-tab-nav-bar.mat-background-primary>.mat-tab-link-container .mat-tab-link{color:#000}.mat-tab-group.mat-background-primary>.mat-tab-header .mat-tab-label.mat-tab-disabled,.mat-tab-group.mat-background-primary>.mat-tab-link-container .mat-tab-link.mat-tab-disabled,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header .mat-tab-label.mat-tab-disabled,.mat-tab-nav-bar.mat-background-primary>.mat-tab-link-container .mat-tab-link.mat-tab-disabled{color:#0006}.mat-tab-group.mat-background-primary>.mat-tab-header .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-primary>.mat-tab-header-pagination .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-primary>.mat-tab-link-container .mat-focus-indicator:before,.mat-tab-group.mat-background-primary>.mat-tab-header .mat-focus-indicator:before,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header-pagination .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-primary>.mat-tab-link-container .mat-focus-indicator:before,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header .mat-focus-indicator:before{border-color:#000}.mat-tab-group.mat-background-primary>.mat-tab-header .mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-primary>.mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header .mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron{border-color:#000;opacity:.4}.mat-tab-group.mat-background-primary>.mat-tab-header .mat-ripple-element,.mat-tab-group.mat-background-primary>.mat-tab-link-container .mat-ripple-element,.mat-tab-group.mat-background-primary>.mat-tab-header-pagination .mat-ripple-element,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header .mat-ripple-element,.mat-tab-nav-bar.mat-background-primary>.mat-tab-link-container .mat-ripple-element,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header-pagination .mat-ripple-element{background-color:#000;opacity:.12}.mat-tab-group.mat-background-accent .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-accent .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-accent .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-accent .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-accent .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-accent .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-accent .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-accent .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled){background-color:#6791754d}.mat-tab-group.mat-background-accent>.mat-tab-header,.mat-tab-group.mat-background-accent>.mat-tab-link-container,.mat-tab-group.mat-background-accent>.mat-tab-header-pagination,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header,.mat-tab-nav-bar.mat-background-accent>.mat-tab-link-container,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header-pagination{background-color:#95b8a2}.mat-tab-group.mat-background-accent>.mat-tab-header .mat-tab-label,.mat-tab-group.mat-background-accent>.mat-tab-link-container .mat-tab-link,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header .mat-tab-label,.mat-tab-nav-bar.mat-background-accent>.mat-tab-link-container .mat-tab-link{color:#000}.mat-tab-group.mat-background-accent>.mat-tab-header .mat-tab-label.mat-tab-disabled,.mat-tab-group.mat-background-accent>.mat-tab-link-container .mat-tab-link.mat-tab-disabled,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header .mat-tab-label.mat-tab-disabled,.mat-tab-nav-bar.mat-background-accent>.mat-tab-link-container .mat-tab-link.mat-tab-disabled{color:#0006}.mat-tab-group.mat-background-accent>.mat-tab-header .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-accent>.mat-tab-header-pagination .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-accent>.mat-tab-link-container .mat-focus-indicator:before,.mat-tab-group.mat-background-accent>.mat-tab-header .mat-focus-indicator:before,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header-pagination .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-accent>.mat-tab-link-container .mat-focus-indicator:before,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header .mat-focus-indicator:before{border-color:#000}.mat-tab-group.mat-background-accent>.mat-tab-header .mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-accent>.mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header .mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron{border-color:#000;opacity:.4}.mat-tab-group.mat-background-accent>.mat-tab-header .mat-ripple-element,.mat-tab-group.mat-background-accent>.mat-tab-link-container .mat-ripple-element,.mat-tab-group.mat-background-accent>.mat-tab-header-pagination .mat-ripple-element,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header .mat-ripple-element,.mat-tab-nav-bar.mat-background-accent>.mat-tab-link-container .mat-ripple-element,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header-pagination .mat-ripple-element{background-color:#000;opacity:.12}.mat-tab-group.mat-background-warn .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-warn .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-warn .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-warn .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-warn .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-warn .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-warn .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-warn .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled){background-color:#a4121a4d}.mat-tab-group.mat-background-warn>.mat-tab-header,.mat-tab-group.mat-background-warn>.mat-tab-link-container,.mat-tab-group.mat-background-warn>.mat-tab-header-pagination,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header,.mat-tab-nav-bar.mat-background-warn>.mat-tab-link-container,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header-pagination{background-color:#c62e3c}.mat-tab-group.mat-background-warn>.mat-tab-header .mat-tab-label,.mat-tab-group.mat-background-warn>.mat-tab-link-container .mat-tab-link,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header .mat-tab-label,.mat-tab-nav-bar.mat-background-warn>.mat-tab-link-container .mat-tab-link{color:#fff}.mat-tab-group.mat-background-warn>.mat-tab-header .mat-tab-label.mat-tab-disabled,.mat-tab-group.mat-background-warn>.mat-tab-link-container .mat-tab-link.mat-tab-disabled,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header .mat-tab-label.mat-tab-disabled,.mat-tab-nav-bar.mat-background-warn>.mat-tab-link-container .mat-tab-link.mat-tab-disabled{color:#fff6}.mat-tab-group.mat-background-warn>.mat-tab-header .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-warn>.mat-tab-header-pagination .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-warn>.mat-tab-link-container .mat-focus-indicator:before,.mat-tab-group.mat-background-warn>.mat-tab-header .mat-focus-indicator:before,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header-pagination .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-warn>.mat-tab-link-container .mat-focus-indicator:before,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header .mat-focus-indicator:before{border-color:#fff}.mat-tab-group.mat-background-warn>.mat-tab-header .mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-warn>.mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header .mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron{border-color:#fff;opacity:.4}.mat-tab-group.mat-background-warn>.mat-tab-header .mat-ripple-element,.mat-tab-group.mat-background-warn>.mat-tab-link-container .mat-ripple-element,.mat-tab-group.mat-background-warn>.mat-tab-header-pagination .mat-ripple-element,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header .mat-ripple-element,.mat-tab-nav-bar.mat-background-warn>.mat-tab-link-container .mat-ripple-element,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header-pagination .mat-ripple-element{background-color:#fff;opacity:.12}.mat-toolbar{background:whitesmoke;color:#000000de}.mat-toolbar.mat-primary{background:#5fa0c5;color:#000}.mat-toolbar.mat-accent{background:#95b8a2;color:#000}.mat-toolbar.mat-warn{background:#c62e3c;color:#fff}.mat-toolbar .mat-form-field-underline,.mat-toolbar .mat-form-field-ripple,.mat-toolbar .mat-focused .mat-form-field-ripple{background-color:currentColor}.mat-toolbar .mat-form-field-label,.mat-toolbar .mat-focused .mat-form-field-label,.mat-toolbar .mat-select-value,.mat-toolbar .mat-select-arrow,.mat-toolbar .mat-form-field.mat-focused .mat-select-arrow{color:inherit}.mat-toolbar .mat-input-element{caret-color:currentColor}.mat-toolbar-multiple-rows{min-height:64px}.mat-toolbar-row,.mat-toolbar-single-row{height:64px}@media (max-width: 599px){.mat-toolbar-multiple-rows{min-height:56px}.mat-toolbar-row,.mat-toolbar-single-row{height:56px}}.mat-tooltip{background:rgba(97,97,97,.9)}.mat-tree{background:white}.mat-tree-node,.mat-nested-tree-node{color:#000000de}.mat-tree-node{min-height:48px}.mat-snack-bar-container{color:#ffffffb3;background:#323232;box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mat-simple-snackbar-action{color:#95b8a2}@font-face{font-family:Material Icons;font-style:normal;font-weight:400;src:url(data:font/woff2;charset=utf-8;base64,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) format("woff2")}.material-icons{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;white-space:nowrap;word-wrap:normal;direction:ltr;-webkit-font-feature-settings:"liga";-webkit-font-smoothing:antialiased}@font-face{font-family:Roboto;font-style:normal;font-weight:300;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0460-052F,U+1C80-1C88,U+20B4,U+2DE0-2DFF,U+A640-A69F,U+FE2E-FE2F}@font-face{font-family:Roboto;font-style:normal;font-weight:300;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0301,U+0400-045F,U+0490-0491,U+04B0-04B1,U+2116}@font-face{font-family:Roboto;font-style:normal;font-weight:300;font-display:swap;src:url(data:font/woff2;base64,d09GMgABAAAAAAL0AA4AAAAABWgAAAKhAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGiYbIBw2BmAANBEMCoIYgXYLEAABNgIkAxwEIAWCfAcgG0MEIB6FjWMZAUlSnOnfdgTUmu5RgFQmNmVhEVWnwiGoOsnC1tZ2Kgwq0/F5/6kue7+qewKokoUje8CeFXiDTzntkXSp/a+7+RcH3NohtUS7fTcNvoAee1uAhwRiCIiD1Cs30vwNrbhCwDgDGCAqhBAGOqCDQAAt7jzRVn5pLRwBGahacn8DSb7g04mjTAi7HKU2Iuyua4wFYYAGEFynrNBwyFAe5BggDNshfUETAQPUa4Da3a8oQOawTAdU+AcX9U0MAr0C5AW5D4LAQYTivoQoJQLknmC49z8f7sE7CBAwtlgVLoA6oAeaYBmcgR7oAAqAiFUlzjl3dVbZuTlPdpkwWWewNba6GMjoPHnGjQf2i55xmnn78dKHN+tqZ9+yX3SDYdZNh8W3+eQWBzS2mh1wta7y2jUafATy2xGuboVcd5uVN+69w/jHmzm1LaA2jvKPhScXRdDW3f+TTPHrji+Jpm2V2Lx4EDs0ycXm7ZDzpz8MddzA34efu/hyqAO8flfNTZvhtS+24G/RyC6a3FJAxf2qZ1cCM6QdoE4e9QciGM3+/6ZEyxdAIE66Hxh8al6HS+pXWz9bAJ8f3MIB/qj68S/x96qdv+1oQBMDBKjf/XMEmrO/xL88O38QAIB6WoJeAMI/lBtMjXvRUfr+zQaBuuXw1kRGgB5E7B4qBBo0OMp2gAPYIvHVjoyzcZZfWQmUDTSHVYQ9dzirdQg5FFYTjaKnpTOGEC1SlChCAYVCy0RNKGLRI5yQxcREqA7K6ANWtx61UcZR6xWumqKbYgyFUBogs9Iay6QLUh/j0Ya9wkKIFi5KjAQpH5oTnosj0NKUrJJFwPinCtfFqksPHbVwilG0Ipjo9VCzGE1ttAiliuTIU65GnhGihYvEASp6TQAA);unicode-range:U+1F00-1FFF}@font-face{font-family:Roboto;font-style:normal;font-weight:300;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0370-03FF}@font-face{font-family:Roboto;font-style:normal;font-weight:300;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0102-0103,U+0110-0111,U+0128-0129,U+0168-0169,U+01A0-01A1,U+01AF-01B0,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+1EA0-1EF9,U+20AB}@font-face{font-family:Roboto;font-style:normal;font-weight:300;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0100-02AF,U+0304,U+0308,U+0329,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:Roboto;font-style:normal;font-weight:300;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:Roboto;font-style:normal;font-weight:400;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0460-052F,U+1C80-1C88,U+20B4,U+2DE0-2DFF,U+A640-A69F,U+FE2E-FE2F}@font-face{font-family:Roboto;font-style:normal;font-weight:400;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0301,U+0400-045F,U+0490-0491,U+04B0-04B1,U+2116}@font-face{font-family:Roboto;font-style:normal;font-weight:400;font-display:swap;src:url(data:font/woff2;base64,d09GMgABAAAAAALsAA4AAAAABWAAAAKbAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGiYbIBw2BmAANBEMCoIYgXsLEAABNgIkAxwEIAWCdAcgG0AEAB6HcYyyEjO2Dy0eKLv4XvfsrGs+wIhEBOHOERRRTI2158fc/aln0WYmSJq8uTRSIgUyIVMqpfa/7uYHCqzWDuHREj0f5UuuL+ZAokTaYgiIs5sF5aUutjO7QhBlgMaYvCAIIqqoCggoq0+HjRlX70MGclDLyR3Z8fb0q/ectzCv30obmLesvO5hBhRhcp7kToaLpaRXpL0htKmb5C3rIgzUIwA1fnqrhHSbqXhA3v+sK1wRtcWuhdyg9E5tGXERkaAhroCGeNqCnJxAm6m1Sb58SICvFhXFWnVAAWQoYRjYADJUQQqIYm0uSZKkfpYv1sv21dm9b7kWbV6i3BQ2Z/sOf/hl+ezXH88LRz75pnLuq4/MO/Zx+eyHc3x9VDn3yfx9n1ILyusq3ps75y90fVZ657PJ2iXgF+odHbvzv7Lrm+uTsPR0WJqYcelN7180rHDDnbeWbrx0QHht49uXjCzffOsd5RsvGvHe4yF5o+Ej97/ZMP62+Z+3Wz/08CtZ/FezhpdvG/nb6PMhC9vNvHFx3Du9X47etewROuONg4L0v2eI+L9X7dt0evq+gNihfvWttiuWK4f8VmxWBM/+WK8b8F6Y9evfLf57r9SjuA2URBAobPm/Smni3y3+n1TqgQEACsl5awAI/5AetjNp65A+/38vDAUXaayPL4CMKHYkEFC0DlfIlbAMegyqlmGU2eSTO58TTHX2xLyWvlczc/wY7eDo5WxlYenKyMvNg9Go5MAatqis2Jty2oytLaPupFxOlsgFObsjM05dBxMHVwcMbeFma4xFh8jZxUr2e62Th09I7Bd96I2RI3gzYzqKcsHjqZzGjsamlojTwdmCy9bKFNm7IBcudRU5BU09BQ5eTm5coMaMAw==);unicode-range:U+1F00-1FFF}@font-face{font-family:Roboto;font-style:normal;font-weight:400;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0370-03FF}@font-face{font-family:Roboto;font-style:normal;font-weight:400;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0102-0103,U+0110-0111,U+0128-0129,U+0168-0169,U+01A0-01A1,U+01AF-01B0,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+1EA0-1EF9,U+20AB}@font-face{font-family:Roboto;font-style:normal;font-weight:400;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0100-02AF,U+0304,U+0308,U+0329,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:Roboto;font-style:normal;font-weight:400;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}@font-face{font-family:Roboto;font-style:normal;font-weight:500;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0460-052F,U+1C80-1C88,U+20B4,U+2DE0-2DFF,U+A640-A69F,U+FE2E-FE2F}@font-face{font-family:Roboto;font-style:normal;font-weight:500;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0301,U+0400-045F,U+0490-0491,U+04B0-04B1,U+2116}@font-face{font-family:Roboto;font-style:normal;font-weight:500;font-display:swap;src:url(data:font/woff2;base64,d09GMgABAAAAAAMAAA4AAAAABWwAAAKuAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGiYbIBw2BmAANBEMCoIYgXkLEAABNgIkAxwEIAWDAAcgG0oEAB6D426JQgSiDJGrY+EepR5ejwf4/fWd+/C1EBKYZDS7sRFxHTf9uCJn/m9Of4qsOwRQBbqEex0QSbKziM9Pj42dA85/tYTLU84Cj+f+PIAlq3AtV5GCrQWUqr11TNFedSEUjKs7rSju46fX7RWCSHFAeYQcQRBEKIqiAgIKlGZBdO5a3w4akEBWj6orkgSzThrq5iF0WjfiKGe7e/0dAHkwOR8nW+GblHR72hyEGmzEl02NcDPu9oBKt35NVVBcoyEuIJNhau72SE3EHkhapkdqCiZGhBhliQWUJVETSCQCNfr8o/boWoBjI3miLHqQC4ojH22AaUBxFAUpIBJlJeIVGIvLFI6PlFi4hGYVs0brZ4ZZlT0rbz1SLT+50xlW3X269vh2x+CpO/n7bw02ebvIys0wMkpteMHUIq4PGfxCRBdKjxXGaDRIc42rK+a/qgeebsfBvjGMiQ14cnJjW8fSe6fHlr2NIrgbeH2jS+k9X+md9WJP/5IvZ8LRg1cQ3gz+dJMePnr2/6ZSiy3c9rHc87Zj4tqOx0WLe1U0VR2OOEt9kq4gV/r/NBEyVbPvpL70poCoTunu3LVVZ4nW3xWV8gAKP5VqBMD10Pruq+7/52x5c4B8EQjkzs5oyJ/1JzxT0mgEACA3XjUZACFDut7UuAEqPZepikCuTcprJBVAcSJREzIBeaYSC4kSGAs2BJU5IFLcQjt+sxNAqr55kwOx947iBrvVCRYwpBuDQusVLFWyFCmCVcEwCg8JVsPPK1GwEjxesNZJv6dyHtID6dYP8UnUCvPAemHBGiA+jD6CVgilD8+tWyfSPRiYXwVJDNNkydPUzvrRmeBZvFdArqSTDSCJ3ALcvDp0JBHWjTK8pb0Qvx7N35CkXo0yFRq1qZAgVaJkYiA7H3AA);unicode-range:U+1F00-1FFF}@font-face{font-family:Roboto;font-style:normal;font-weight:500;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0370-03FF}@font-face{font-family:Roboto;font-style:normal;font-weight:500;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0102-0103,U+0110-0111,U+0128-0129,U+0168-0169,U+01A0-01A1,U+01AF-01B0,U+0300-0301,U+0303-0304,U+0308-0309,U+0323,U+0329,U+1EA0-1EF9,U+20AB}@font-face{font-family:Roboto;font-style:normal;font-weight:500;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0100-02AF,U+0304,U+0308,U+0329,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20CF,U+2113,U+2C60-2C7F,U+A720-A7FF}@font-face{font-family:Roboto;font-style:normal;font-weight:500;font-display:swap;src:url(data:font/woff2;base64,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);unicode-range:U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD}.mat-form-field-prefix .mat-icon-button,.mat-form-field-suffix .mat-icon-button{height:1.5em;width:1.5em}.mat-tree{background:transparent!important;background-color:transparent!important}.cedar-form-body{font-family:Open Sans,Ariel,sans-serif;font-size:12px;margin:0;padding:0}@keyframes fadein{0%{opacity:0}to{opacity:1}}html,body.cav-body{height:100%}.cedar-logo{background-image:url(data:image/png;base64,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);background-repeat:no-repeat;background-size:cover;width:70px;height:70px}.toolbar-spacer{flex:1 2 auto}.mat-badge-content{font-weight:600;font-size:12px;font-family:Roboto,Helvetica Neue,sans-serif}.mat-badge-small .mat-badge-content{font-size:9px}.mat-badge-large .mat-badge-content{font-size:24px}.mat-h1,.mat-headline,.mat-typography .mat-h1,.mat-typography .mat-headline,.mat-typography h1{font:400 24px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h2,.mat-title,.mat-typography .mat-h2,.mat-typography .mat-title,.mat-typography h2{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h3,.mat-subheading-2,.mat-typography .mat-h3,.mat-typography .mat-subheading-2,.mat-typography h3{font:400 16px/28px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h4,.mat-subheading-1,.mat-typography .mat-h4,.mat-typography .mat-subheading-1,.mat-typography h4{font:400 15px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h5,.mat-typography .mat-h5,.mat-typography h5{font:400 11.62px/20px Roboto,Helvetica Neue,sans-serif;margin:0 0 12px}.mat-h6,.mat-typography .mat-h6,.mat-typography h6{font:400 9.38px/20px Roboto,Helvetica Neue,sans-serif;margin:0 0 12px}.mat-body-strong,.mat-body-2,.mat-typography .mat-body-strong,.mat-typography .mat-body-2{font:500 14px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-body,.mat-body-1,.mat-typography .mat-body,.mat-typography .mat-body-1,.mat-typography{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-body p,.mat-body-1 p,.mat-typography .mat-body p,.mat-typography .mat-body-1 p,.mat-typography p{margin:0 0 12px}.mat-small,.mat-caption,.mat-typography .mat-small,.mat-typography .mat-caption{font:400 12px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-display-4,.mat-typography .mat-display-4{font:300 112px/112px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.05em;margin:0 0 56px}.mat-display-3,.mat-typography .mat-display-3{font:400 56px/56px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.02em;margin:0 0 64px}.mat-display-2,.mat-typography .mat-display-2{font:400 45px/48px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.005em;margin:0 0 64px}.mat-display-1,.mat-typography .mat-display-1{font:400 34px/40px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 64px}.mat-bottom-sheet-container{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-button,.mat-raised-button,.mat-icon-button,.mat-stroked-button,.mat-flat-button,.mat-fab,.mat-mini-fab{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-button-toggle,.mat-card{font-family:Roboto,Helvetica Neue,sans-serif}.mat-card-title{font-size:24px;font-weight:500}.mat-card-header .mat-card-title{font-size:20px}.mat-card-subtitle,.mat-card-content{font-size:14px}.mat-checkbox{font-family:Roboto,Helvetica Neue,sans-serif}.mat-checkbox-layout .mat-checkbox-label{line-height:24px}.mat-chip{font-size:14px;font-weight:500}.mat-chip .mat-chip-trailing-icon.mat-icon,.mat-chip .mat-chip-remove.mat-icon{font-size:18px}.mat-table{font-family:Roboto,Helvetica Neue,sans-serif}.mat-header-cell{font-size:12px;font-weight:500}.mat-cell,.mat-footer-cell{font-size:14px}.mat-calendar{font-family:Roboto,Helvetica Neue,sans-serif}.mat-calendar-body{font-size:13px}.mat-calendar-body-label,.mat-calendar-period-button{font-size:14px;font-weight:500}.mat-calendar-table-header th{font-size:11px;font-weight:400}.mat-dialog-title{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-expansion-panel-header{font-family:Roboto,Helvetica Neue,sans-serif;font-size:15px;font-weight:400}.mat-expansion-panel-content{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-form-field{font-size:inherit;font-weight:400;line-height:1.125;font-family:Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-form-field-wrapper{padding-bottom:1.34375em}.mat-form-field-prefix .mat-icon,.mat-form-field-suffix .mat-icon{font-size:150%;line-height:1.125}.mat-form-field-prefix .mat-icon-button,.mat-form-field-suffix .mat-icon-button{height:1.5em;width:1.5em}.mat-form-field-prefix .mat-icon-button .mat-icon,.mat-form-field-suffix .mat-icon-button .mat-icon{height:1.125em;line-height:1.125}.mat-form-field-infix{padding:.5em 0;border-top:.84375em solid transparent}.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.34373em) scale(.75);width:133.3333533333%}.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.34372em) scale(.75);width:133.3333633333%}.mat-form-field-label-wrapper{top:-.84375em;padding-top:.84375em}.mat-form-field-label{top:1.34375em}.mat-form-field-underline{bottom:1.34375em}.mat-form-field-subscript-wrapper{font-size:75%;margin-top:.6666666667em;top:calc(100% - 1.7916666667em)}.mat-form-field-appearance-legacy .mat-form-field-wrapper{padding-bottom:1.25em}.mat-form-field-appearance-legacy .mat-form-field-infix{padding:.4375em 0}.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00106px);width:133.3333933333%}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00107px);width:133.3334033333%}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00108px);width:133.3334133333%}.mat-form-field-appearance-legacy .mat-form-field-label{top:1.28125em}.mat-form-field-appearance-legacy .mat-form-field-underline{bottom:1.25em}.mat-form-field-appearance-legacy .mat-form-field-subscript-wrapper{margin-top:.5416666667em;top:calc(100% - 1.6666666667em)}@media print{.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28116em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28115em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28114em) scale(.75)}}.mat-form-field-appearance-fill .mat-form-field-infix{padding:.25em 0 .75em}.mat-form-field-appearance-fill .mat-form-field-label{top:1.09375em;margin-top:-.5em}.mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-fill.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-.59373em) scale(.75);width:133.3333533333%}.mat-form-field-appearance-fill.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-.59372em) scale(.75);width:133.3333633333%}.mat-form-field-appearance-outline .mat-form-field-infix{padding:1em 0}.mat-form-field-appearance-outline .mat-form-field-label{top:1.84375em;margin-top:-.25em}.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-outline.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.59373em) scale(.75);width:133.3333533333%}.mat-form-field-appearance-outline.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.59372em) scale(.75);width:133.3333633333%}.mat-grid-tile-header,.mat-grid-tile-footer{font-size:14px}.mat-grid-tile-header .mat-line,.mat-grid-tile-footer .mat-line{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-grid-tile-header .mat-line:nth-child(n+2),.mat-grid-tile-footer .mat-line:nth-child(n+2){font-size:12px}input.mat-input-element{margin-top:-.0625em}.mat-menu-item{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:400}.mat-paginator,.mat-paginator-page-size .mat-select-trigger{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px}.mat-radio-button,.mat-select{font-family:Roboto,Helvetica Neue,sans-serif}.mat-select-trigger{height:1.125em}.mat-slide-toggle-content{font-family:Roboto,Helvetica Neue,sans-serif}.mat-slider-thumb-label-text{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px;font-weight:500}.mat-stepper-vertical,.mat-stepper-horizontal{font-family:Roboto,Helvetica Neue,sans-serif}.mat-step-label{font-size:14px;font-weight:400}.mat-step-sub-label-error{font-weight:400}.mat-step-label-error{font-size:14px}.mat-step-label-selected{font-size:14px;font-weight:500}.mat-tab-group{font-family:Roboto,Helvetica Neue,sans-serif}.mat-tab-label,.mat-tab-link{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-toolbar,.mat-toolbar h1,.mat-toolbar h2,.mat-toolbar h3,.mat-toolbar h4,.mat-toolbar h5,.mat-toolbar h6{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0}.mat-tooltip{font-family:Roboto,Helvetica Neue,sans-serif;font-size:10px;padding-top:6px;padding-bottom:6px}.mat-tooltip-handset{font-size:14px;padding-top:8px;padding-bottom:8px}.mat-list-item,.mat-list-option{font-family:Roboto,Helvetica Neue,sans-serif}.mat-list-base .mat-list-item{font-size:16px}.mat-list-base .mat-list-item .mat-line{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list-base .mat-list-item .mat-line:nth-child(n+2){font-size:14px}.mat-list-base .mat-list-option{font-size:16px}.mat-list-base .mat-list-option .mat-line{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list-base .mat-list-option .mat-line:nth-child(n+2){font-size:14px}.mat-list-base .mat-subheader{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-list-base[dense] .mat-list-item{font-size:12px}.mat-list-base[dense] .mat-list-item .mat-line{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list-base[dense] .mat-list-item .mat-line:nth-child(n+2){font-size:12px}.mat-list-base[dense] .mat-list-option{font-size:12px}.mat-list-base[dense] .mat-list-option .mat-line{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list-base[dense] .mat-list-option .mat-line:nth-child(n+2){font-size:12px}.mat-list-base[dense] .mat-subheader{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px;font-weight:500}.mat-option{font-family:Roboto,Helvetica Neue,sans-serif;font-size:16px}.mat-optgroup-label{font:500 14px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-simple-snackbar{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px}.mat-simple-snackbar-action{line-height:1;font-family:inherit;font-size:inherit;font-weight:500}.mat-tree{font-family:Roboto,Helvetica Neue,sans-serif}.mat-tree-node,.mat-nested-tree-node{font-weight:400;font-size:14px}.mat-ripple{overflow:hidden;position:relative}.mat-ripple:not(:empty){transform:translateZ(0)}.mat-ripple.mat-ripple-unbounded{overflow:visible}.mat-ripple-element{position:absolute;border-radius:50%;pointer-events:none;transition:opacity,transform 0ms cubic-bezier(0,0,.2,1);transform:scale3d(0,0,0)}.cdk-high-contrast-active .mat-ripple-element{display:none}.cdk-visually-hidden{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap;outline:0;-webkit-appearance:none;-moz-appearance:none;left:0}[dir=rtl] .cdk-visually-hidden{left:auto;right:0}.cdk-overlay-container,.cdk-global-overlay-wrapper{pointer-events:none;top:0;left:0;height:100%;width:100%}.cdk-overlay-container{position:fixed;z-index:1000}.cdk-overlay-container:empty{display:none}.cdk-global-overlay-wrapper{display:flex;position:absolute;z-index:1000}.cdk-overlay-pane{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}.cdk-overlay-backdrop{position:absolute;inset:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:1}.cdk-high-contrast-active .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.6}.cdk-overlay-dark-backdrop{background:rgba(0,0,0,.32)}.cdk-overlay-transparent-backdrop{transition:visibility 1ms linear,opacity 1ms linear;visibility:hidden;opacity:1}.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing{opacity:0;visibility:visible}.cdk-overlay-backdrop-noop-animation{transition:none}.cdk-overlay-connected-position-bounding-box{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}.cdk-global-scrollblock{position:fixed;width:100%;overflow-y:scroll}textarea.cdk-textarea-autosize{resize:none}textarea.cdk-textarea-autosize-measuring{padding:2px 0!important;box-sizing:content-box!important;height:auto!important;overflow:hidden!important}textarea.cdk-textarea-autosize-measuring-firefox{padding:2px 0!important;box-sizing:content-box!important;height:0!important}@keyframes cdk-text-field-autofill-start{}@keyframes cdk-text-field-autofill-end{}.cdk-text-field-autofill-monitored:-webkit-autofill{animation:cdk-text-field-autofill-start 0s 1ms}.cdk-text-field-autofill-monitored:not(:-webkit-autofill){animation:cdk-text-field-autofill-end 0s 1ms}.mat-focus-indicator{position:relative}.mat-focus-indicator:before{inset:0;position:absolute;box-sizing:border-box;pointer-events:none;display:var(--mat-focus-indicator-display, none);border:var(--mat-focus-indicator-border-width, 3px) var(--mat-focus-indicator-border-style, solid) var(--mat-focus-indicator-border-color, transparent);border-radius:var(--mat-focus-indicator-border-radius, 4px)}.mat-focus-indicator:focus:before{content:""}.cdk-high-contrast-active{--mat-focus-indicator-display: block}.mat-mdc-focus-indicator{position:relative}.mat-mdc-focus-indicator:before{inset:0;position:absolute;box-sizing:border-box;pointer-events:none;display:var(--mat-mdc-focus-indicator-display, none);border:var(--mat-mdc-focus-indicator-border-width, 3px) var(--mat-mdc-focus-indicator-border-style, solid) var(--mat-mdc-focus-indicator-border-color, transparent);border-radius:var(--mat-mdc-focus-indicator-border-radius, 4px)}.mat-mdc-focus-indicator:focus:before{content:""}.cdk-high-contrast-active{--mat-mdc-focus-indicator-display: block}.cedar-form{margin:10px 0}.cedar-form ul,.cedar-form li{margin-top:0;margin-bottom:0;list-style-type:none}button.mat-icon-button.help,button.mat-icon-button.node-add,button.mat-icon-button.node-remove{z-index:10;position:relative;min-width:0;width:2em;height:2em;line-height:1em;padding:5px}button.mat-icon-button.help .mat-button-wrapper,button.mat-icon-button.node-add .mat-button-wrapper,button.mat-icon-button.node-remove .mat-button-wrapper{z-index:-100;position:relative;padding:0;margin:0;height:1em;display:inherit}button.mat-icon-button.help .mat-button-wrapper .mat-icon,button.mat-icon-button.node-add .mat-button-wrapper .mat-icon,button.mat-icon-button.node-remove .mat-button-wrapper .mat-icon{font-size:1em;width:1em;height:1em;line-height:1em;padding:0;color:#0000008a;position:relative;top:-.1em}label.element-label{margin:0;font-weight:400;width:100%;padding:0 5px;font-size:larger}.mat-form-field{margin-bottom:10px;width:100%}.mat-tree-node{min-height:0!important}*:focus{outline:none!important;border:0!important}.mat-form-field-disabled .mat-form-field-underline,.mat-form-field-appearance-legacy.mat-form-field-disabled .mat-form-field-underline,.mat-form-field-disabled .mat-form-field-underline{background-image:none!important;border-bottom:1px solid rgba(0,0,0,.54)!important}.mat-form-field-type-mat-native-select.mat-form-field-disabled .mat-form-field-infix:after,.mat-input-element:disabled{color:#000000de!important}.mat-icon-button[disabled][disabled]{color:#0000008a!important}:host ::ng-deep .mat-input-element:disabled{color:#000000de}:host ::ng-deep .mat-select-disabled .mat-select-value{color:#000000de}:host ::ng-deep .mat-option.mat-option-disabled{color:#000000de}:host ::ng-deep .mat-pseudo-checkbox-checked.mat-pseudo-checkbox-disabled,.mat-pseudo-checkbox-indeterminate.mat-pseudo-checkbox-disabled{background-color:#95b8a2}.mat-form-field-appearance-legacy.mat-form-field-disabled .mat-form-field-underline{background-image:none;border-bottom:1px solid rgba(0,0,0,.54)}.mat-radio-button.mat-radio-disabled.mat-radio-checked .mat-radio-inner-circle{background-color:#95b8a2!important}.mat-radio-button.mat-radio-disabled.mat-radio-checked .mat-radio-outer-circle{border-color:#95b8a2!important}.mat-radio-button.mat-radio-disabled .mat-radio-label-content{color:#000000de!important}h2{font-size:1.6rem}\n'],
          encapsulation: 2
        });
      }
      return qe;
    })();
    let sl = /*#__PURE__*/(() => {
      class sl {
        node;
        parentGroup;
        formGroup;
        index;
        mode;
        constructor() {}
        ngOnInit() {
          this.parentGroup && this.parentGroup.addControl(this.node.key, this.formGroup);
        }
        static ɵfac = function (e) {
          return new (e || sl)();
        };
        static ɵcmp = q({
          type: sl,
          selectors: [["app-element"]],
          inputs: {
            node: "node",
            parentGroup: "parentGroup",
            formGroup: "formGroup",
            index: "index",
            mode: "mode"
          },
          features: [G([])],
          decls: 0,
          vars: 0,
          template: function (e, a) {}
        });
      }
      return sl;
    })();
    let eo = /*#__PURE__*/(() => {
      class eo {
        static getValidators(t) {
          const e = [];
          return t.required && e.push(Da.required), t.subtype === A.email && e.push(Da.email), null !== t.min && e.push(Da.min(t.min)), null !== t.max && e.push(Da.max(t.max)), t.subtype === A.numeric && e.push(this.numericValidator()), t.decimals && e.push(this.decimalValidator(t.decimals)), null !== t.minLength && e.push(Da.minLength(t.minLength)), null !== t.maxLength && e.push(Da.maxLength(t.maxLength)), null !== t.pattern && e.push(Da.pattern(t.pattern)), t.subtype === A.url && e.push(this.urlValidator), e;
        }
        static quantityRangeValidator(t, e) {
          return a => void 0 !== a.value && (isNaN(a.value) || a.value < t || a.value > e) ? {
            quantityRange: !0
          } : null;
        }
        static numericValidator() {
          return t => {
            let e = null;
            return t.value && isNaN(Number(t.value)) && (e = {
              numeric: !0
            }), e;
          };
        }
        static decimalValidator(t) {
          return e => {
            let a = null;
            if (t && e.value && !isNaN(Number(e.value))) {
              const i = (Math.floor(e.value) + "").split(".")[0].length,
                o = e.value.split("."),
                r = o[1] && o[1].length,
                s = Number.parseFloat(e.value).toPrecision(i + t);
              r ? t < r && (a = {
                decimal: {
                  actual: r,
                  required: t,
                  suggested: s
                }
              }) : a = {
                decimal: {
                  actual: 0,
                  required: t,
                  suggested: s
                }
              };
            }
            return a;
          };
        }
        static urlValidator(t) {
          return t.pristine ? null : (t.markAsTouched(), /^(http?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/.test(t.value) ? null : {
            url: !0
          });
        }
        static validateAllFormFields(t) {
          Object.keys(t.controls).forEach(e => {
            const a = t.get(e);
            a instanceof at ? a.markAsTouched({
              onlySelf: !0
            }) : a instanceof Ci && this.validateAllFormFields(a);
          });
        }
        static ɵfac = function (e) {
          return new (e || eo)();
        };
        static ɵprov = R({
          token: eo,
          factory: eo.ɵfac
        });
      }
      return eo;
    })();
    var aC = {
        prefix: "fas",
        iconName: "asterisk",
        icon: [512, 512, [], "f069", "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"]
      },
      iC = {
        prefix: "fas",
        iconName: "calendar",
        icon: [448, 512, [], "f133", "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"]
      },
      oC = {
        prefix: "fas",
        iconName: "check-square",
        icon: [448, 512, [], "f14a", "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"]
      },
      rC = {
        prefix: "fas",
        iconName: "dot-circle",
        icon: [512, 512, [], "f192", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"]
      },
      sC = {
        prefix: "fas",
        iconName: "envelope",
        icon: [512, 512, [], "f0e0", "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"]
      },
      cC = {
        prefix: "fas",
        iconName: "font",
        icon: [448, 512, [], "f031", "M432 416h-26.7L275.5 42.7c-2.2-6.4-8.3-10.7-15.1-10.7h-72.8c-6.8 0-12.9 4.3-15.1 10.7L42.7 416H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h136c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-24l26.6-80.8h138.2l26.6 80.8H296c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h136c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM174.4 268.3l42-124.1c4.3-15.2 6.6-28.2 7.6-34.6.8 6.5 2.9 19.5 7.7 34.7l41.3 124z"]
      },
      lC = {
        prefix: "fas",
        iconName: "hashtag",
        icon: [448, 512, [], "f292", "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"]
      },
      dC = {
        prefix: "fas",
        iconName: "link",
        icon: [512, 512, [], "f0c1", "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"]
      },
      uC = {
        prefix: "fas",
        iconName: "list",
        icon: [512, 512, [], "f03a", "M128 116V76c0-8.837 7.163-16 16-16h352c8.837 0 16 7.163 16 16v40c0 8.837-7.163 16-16 16H144c-8.837 0-16-7.163-16-16zm16 176h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zM16 144h64c8.837 0 16-7.163 16-16V64c0-8.837-7.163-16-16-16H16C7.163 48 0 55.163 0 64v64c0 8.837 7.163 16 16 16zm0 160h64c8.837 0 16-7.163 16-16v-64c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v64c0 8.837 7.163 16 16 16zm0 160h64c8.837 0 16-7.163 16-16v-64c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v64c0 8.837 7.163 16 16 16z"]
      },
      fC = {
        prefix: "fas",
        iconName: "paragraph",
        icon: [448, 512, [], "f1dd", "M408 32H177.531C88.948 32 16.045 103.335 16 191.918 15.956 280.321 87.607 352 176 352v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V112h32v344c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V112h40c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24z"]
      },
      mC = {
        prefix: "fas",
        iconName: "phone-square",
        icon: [448, 512, [], "f098", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"]
      },
      hC = {
        prefix: "fas",
        iconName: "plus-square",
        icon: [448, 512, [], "f0fe", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"]
      };
    function cl(n) {
      return (cl = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(n);
    }
    function pC(n, t) {
      for (var e = 0; e < t.length; e++) {
        var a = t[e];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, a.key, a);
      }
    }
    function O1e(n, t, e) {
      return t in n ? Object.defineProperty(n, t, {
        value: e,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[t] = e, n;
    }
    function ze(n) {
      for (var t = 1; t < arguments.length; t++) {
        var e = null != arguments[t] ? arguments[t] : {},
          a = Object.keys(e);
        "function" == typeof Object.getOwnPropertySymbols && (a = a.concat(Object.getOwnPropertySymbols(e).filter(function (i) {
          return Object.getOwnPropertyDescriptor(e, i).enumerable;
        }))), a.forEach(function (i) {
          O1e(n, i, e[i]);
        });
      }
      return n;
    }
    function Up(n, t) {
      return function A1e(n) {
        if (Array.isArray(n)) return n;
      }(n) || function E1e(n, t) {
        var e = [],
          a = !0,
          i = !1,
          o = void 0;
        try {
          for (var s, r = n[Symbol.iterator](); !(a = (s = r.next()).done) && (e.push(s.value), !t || e.length !== t); a = !0);
        } catch (c) {
          i = !0, o = c;
        } finally {
          try {
            !a && null != r.return && r.return();
          } finally {
            if (i) throw o;
          }
        }
        return e;
      }(n, t) || function I1e() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }
    var Wp = {},
      bC = {};
    try {
      typeof window < "u" && (Wp = window), typeof document < "u" && (bC = document), typeof MutationObserver < "u" && MutationObserver, typeof performance < "u" && performance;
    } catch {}
    var yC = (Wp.navigator || {}).userAgent,
      CC = void 0 === yC ? "" : yC,
      gs = Wp,
      Tt = bC,
      wi = !!Tt.documentElement && !!Tt.head && "function" == typeof Tt.addEventListener && "function" == typeof Tt.createElement,
      ki = (~CC.indexOf("MSIE") || CC.indexOf("Trident/"), "___FONT_AWESOME___"),
      kC = "svg-inline--fa",
      AC = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      G1e = AC.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]),
      Go = {
        GROUP: "group",
        SWAP_OPACITY: "swap-opacity",
        PRIMARY: "primary",
        SECONDARY: "secondary"
      },
      SC = (["xs", "sm", "lg", "fw", "ul", "li", "border", "pull-left", "pull-right", "spin", "pulse", "rotate-90", "rotate-180", "rotate-270", "flip-horizontal", "flip-vertical", "flip-both", "stack", "stack-1x", "stack-2x", "inverse", "layers", "layers-text", "layers-counter", Go.GROUP, Go.SWAP_OPACITY, Go.PRIMARY, Go.SECONDARY].concat(AC.map(function (n) {
        return "".concat(n, "x");
      })).concat(G1e.map(function (n) {
        return "w-".concat(n);
      })), gs.FontAwesomeConfig || {});
    Tt && "function" == typeof Tt.querySelector && [["data-family-prefix", "familyPrefix"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach(function (n) {
      var t = Up(n, 2),
        a = t[1],
        i = function K1e(n) {
          return "" === n || "false" !== n && ("true" === n || n);
        }(function q1e(n) {
          var t = Tt.querySelector("script[" + n + "]");
          if (t) return t.getAttribute(n);
        }(t[0]));
      null != i && (SC[a] = i);
    });
    var Kp = ze({}, {
      familyPrefix: "fa",
      replacementClass: kC,
      autoReplaceSvg: !0,
      autoAddCss: !0,
      autoA11y: !0,
      searchPseudoElements: !1,
      observeMutations: !0,
      mutateApproach: "async",
      keepOriginalSource: !0,
      measurePerformance: !1,
      showMissingIcons: !0
    }, SC);
    Kp.autoReplaceSvg || (Kp.observeMutations = !1);
    var we = ze({}, Kp);
    gs.FontAwesomeConfig = we;
    var Di = gs || {};
    Di[ki] || (Di[ki] = {}), Di[ki].styles || (Di[ki].styles = {}), Di[ki].hooks || (Di[ki].hooks = {}), Di[ki].shims || (Di[ki].shims = []);
    var Sa = Di[ki],
      EC = [];
    wi && ((Tt.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Tt.readyState) || Tt.addEventListener("DOMContentLoaded", function n() {
      Tt.removeEventListener("DOMContentLoaded", n), EC.map(function (t) {
        return t();
      });
    }));
    var Zp,
      Qp = "pending",
      TC = "settled",
      R2 = "fulfilled",
      z2 = "rejected",
      $1e = function () {},
      IC = typeof global < "u" && typeof global.process < "u" && "function" == typeof global.process.emit,
      ede = typeof setImmediate > "u" ? setTimeout : setImmediate,
      ll = [];
    function tde() {
      for (var n = 0; n < ll.length; n++) ll[n][0](ll[n][1]);
      ll = [], Zp = !1;
    }
    function L2(n, t) {
      ll.push([n, t]), Zp || (Zp = !0, ede(tde, 0));
    }
    function RC(n) {
      var t = n.owner,
        e = t._state,
        a = t._data,
        i = n[e],
        o = n.then;
      if ("function" == typeof i) {
        e = R2;
        try {
          a = i(a);
        } catch (r) {
          dl(o, r);
        }
      }
      zC(o, a) || (e === R2 && Xp(o, a), e === z2 && dl(o, a));
    }
    function zC(n, t) {
      var e;
      try {
        if (n === t) throw new TypeError("A promises callback cannot return that same promise.");
        if (t && ("function" == typeof t || "object" === cl(t))) {
          var a = t.then;
          if ("function" == typeof a) return a.call(t, function (i) {
            e || (e = !0, t === i ? LC(n, i) : Xp(n, i));
          }, function (i) {
            e || (e = !0, dl(n, i));
          }), !0;
        }
      } catch (i) {
        return e || dl(n, i), !0;
      }
      return !1;
    }
    function Xp(n, t) {
      (n === t || !zC(n, t)) && LC(n, t);
    }
    function LC(n, t) {
      n._state === Qp && (n._state = TC, n._data = t, L2(ade, n));
    }
    function dl(n, t) {
      n._state === Qp && (n._state = TC, n._data = t, L2(ide, n));
    }
    function NC(n) {
      n._then = n._then.forEach(RC);
    }
    function ade(n) {
      n._state = R2, NC(n);
    }
    function ide(n) {
      n._state = z2, NC(n), !n._handled && IC && global.process.emit("unhandledRejection", n._data, n);
    }
    function ode(n) {
      global.process.emit("rejectionHandled", n);
    }
    function Bn(n) {
      if ("function" != typeof n) throw new TypeError("Promise resolver " + n + " is not a function");
      if (!(this instanceof Bn)) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
      this._then = [], function nde(n, t) {
        function a(i) {
          dl(t, i);
        }
        try {
          n(function e(i) {
            Xp(t, i);
          }, a);
        } catch (i) {
          a(i);
        }
      }(n, this);
    }
    Bn.prototype = {
      constructor: Bn,
      _state: Qp,
      _then: null,
      _data: void 0,
      _handled: !1,
      then: function (t, e) {
        var a = {
          owner: this,
          then: new this.constructor($1e),
          fulfilled: t,
          rejected: e
        };
        return (e || t) && !this._handled && (this._handled = !0, this._state === z2 && IC && L2(ode, this)), this._state === R2 || this._state === z2 ? L2(RC, a) : this._then.push(a), a.then;
      },
      catch: function (t) {
        return this.then(null, t);
      }
    }, Bn.all = function (n) {
      if (!Array.isArray(n)) throw new TypeError("You must pass an array to Promise.all().");
      return new Bn(function (t, e) {
        var a = [],
          i = 0;
        function o(c) {
          return i++, function (l) {
            a[c] = l, --i || t(a);
          };
        }
        for (var s, r = 0; r < n.length; r++) (s = n[r]) && "function" == typeof s.then ? s.then(o(r), e) : a[r] = s;
        i || t(a);
      });
    }, Bn.race = function (n) {
      if (!Array.isArray(n)) throw new TypeError("You must pass an array to Promise.race().");
      return new Bn(function (t, e) {
        for (var i, a = 0; a < n.length; a++) (i = n[a]) && "function" == typeof i.then ? i.then(t, e) : t(i);
      });
    }, Bn.resolve = function (n) {
      return n && "object" === cl(n) && n.constructor === Bn ? n : new Bn(function (t) {
        t(n);
      });
    }, Bn.reject = function (n) {
      return new Bn(function (t, e) {
        e(n);
      });
    };
    var Oi = {
      size: 16,
      x: 0,
      y: 0,
      rotate: 0,
      flipX: !1,
      flipY: !1
    };
    function ul() {
      for (var n = 12, t = ""; n-- > 0;) t += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[62 * Math.random() | 0];
      return t;
    }
    function VC(n) {
      return "".concat(n).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    function N2(n) {
      return Object.keys(n || {}).reduce(function (t, e) {
        return t + "".concat(e, ": ").concat(n[e], ";");
      }, "");
    }
    function $p(n) {
      return n.size !== Oi.size || n.x !== Oi.x || n.y !== Oi.y || n.rotate !== Oi.rotate || n.flipX || n.flipY;
    }
    function HC(n) {
      var t = n.transform,
        a = n.iconWidth,
        i = {
          transform: "translate(".concat(n.containerWidth / 2, " 256)")
        },
        o = "translate(".concat(32 * t.x, ", ").concat(32 * t.y, ") "),
        r = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "),
        s = "rotate(".concat(t.rotate, " 0 0)");
      return {
        outer: i,
        inner: {
          transform: "".concat(o, " ").concat(r, " ").concat(s)
        },
        path: {
          transform: "translate(".concat(a / 2 * -1, " -256)")
        }
      };
    }
    var e4 = {
      x: 0,
      y: 0,
      width: "100%",
      height: "100%"
    };
    function BC(n) {
      var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
      return n.attributes && (n.attributes.fill || t) && (n.attributes.fill = "black"), n;
    }
    function ude(n) {
      return "g" === n.tag ? n.children : [n];
    }
    function t4(n) {
      var t = n.icons,
        e = t.main,
        a = t.mask,
        i = n.prefix,
        o = n.iconName,
        r = n.transform,
        s = n.symbol,
        c = n.title,
        l = n.maskId,
        d = n.titleId,
        u = n.extra,
        m = n.watchable,
        h = void 0 !== m && m,
        p = a.found ? a : e,
        v = p.width,
        C = p.height,
        k = "fak" === i,
        T = k ? "" : "fa-w-".concat(Math.ceil(v / C * 16)),
        w = [we.replacementClass, o ? "".concat(we.familyPrefix, "-").concat(o) : "", T].filter(function (Wt) {
          return -1 === u.classes.indexOf(Wt);
        }).filter(function (Wt) {
          return "" !== Wt || !!Wt;
        }).concat(u.classes).join(" "),
        N = {
          children: [],
          attributes: ze({}, u.attributes, {
            "data-prefix": i,
            "data-icon": o,
            class: w,
            role: u.attributes.role || "img",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 ".concat(v, " ").concat(C)
          })
        },
        le = k && !~u.classes.indexOf("fa-fw") ? {
          width: "".concat(v / C * 16 * .0625, "em")
        } : {};
      h && (N.attributes["data-fa-i2svg"] = ""), c && N.children.push({
        tag: "title",
        attributes: {
          id: N.attributes["aria-labelledby"] || "title-".concat(d || ul())
        },
        children: [c]
      });
      var Ce = ze({}, N, {
          prefix: i,
          iconName: o,
          main: e,
          mask: a,
          maskId: l,
          transform: r,
          symbol: s,
          styles: ze({}, le, u.styles)
        }),
        rt = a.found && e.found ? function fde(n) {
          var t = n.children,
            e = n.attributes,
            a = n.main,
            i = n.mask,
            o = n.maskId,
            c = a.icon,
            d = i.icon,
            u = HC({
              transform: n.transform,
              containerWidth: i.width,
              iconWidth: a.width
            }),
            m = {
              tag: "rect",
              attributes: ze({}, e4, {
                fill: "white"
              })
            },
            h = c.children ? {
              children: c.children.map(BC)
            } : {},
            p = {
              tag: "g",
              attributes: ze({}, u.inner),
              children: [BC(ze({
                tag: c.tag,
                attributes: ze({}, c.attributes, u.path)
              }, h))]
            },
            v = {
              tag: "g",
              attributes: ze({}, u.outer),
              children: [p]
            },
            C = "mask-".concat(o || ul()),
            k = "clip-".concat(o || ul()),
            T = {
              tag: "mask",
              attributes: ze({}, e4, {
                id: C,
                maskUnits: "userSpaceOnUse",
                maskContentUnits: "userSpaceOnUse"
              }),
              children: [m, v]
            },
            w = {
              tag: "defs",
              children: [{
                tag: "clipPath",
                attributes: {
                  id: k
                },
                children: ude(d)
              }, T]
            };
          return t.push(w, {
            tag: "rect",
            attributes: ze({
              fill: "currentColor",
              "clip-path": "url(#".concat(k, ")"),
              mask: "url(#".concat(C, ")")
            }, e4)
          }), {
            children: t,
            attributes: e
          };
        }(Ce) : function mde(n) {
          var t = n.children,
            e = n.attributes,
            a = n.main,
            i = n.transform,
            r = N2(n.styles);
          if (r.length > 0 && (e.style = r), $p(i)) {
            var s = HC({
              transform: i,
              containerWidth: a.width,
              iconWidth: a.width
            });
            t.push({
              tag: "g",
              attributes: ze({}, s.outer),
              children: [{
                tag: "g",
                attributes: ze({}, s.inner),
                children: [{
                  tag: a.icon.tag,
                  children: a.icon.children,
                  attributes: ze({}, a.icon.attributes, s.path)
                }]
              }]
            });
          } else t.push(a.icon);
          return {
            children: t,
            attributes: e
          };
        }(Ce),
        bn = rt.attributes;
      return Ce.children = rt.children, Ce.attributes = bn, s ? function pde(n) {
        var e = n.iconName,
          a = n.children,
          o = n.symbol;
        return [{
          tag: "svg",
          attributes: {
            style: "display: none;"
          },
          children: [{
            tag: "symbol",
            attributes: ze({}, n.attributes, {
              id: !0 === o ? "".concat(n.prefix, "-").concat(we.familyPrefix, "-").concat(e) : o
            }),
            children: a
          }]
        }];
      }(Ce) : function hde(n) {
        var t = n.children,
          e = n.main,
          a = n.mask,
          i = n.attributes,
          o = n.styles,
          r = n.transform;
        if ($p(r) && e.found && !a.found) {
          var l = {
            x: e.width / e.height / 2,
            y: .5
          };
          i.style = N2(ze({}, o, {
            "transform-origin": "".concat(l.x + r.x / 16, "em ").concat(l.y + r.y / 16, "em")
          }));
        }
        return [{
          tag: "svg",
          attributes: i,
          children: t
        }];
      }(Ce);
    }
    var o4 = function (t, e, a, i) {
      var c,
        l,
        d,
        o = Object.keys(t),
        r = o.length,
        s = void 0 !== i ? function (t, e) {
          return function (a, i, o, r) {
            return t.call(e, a, i, o, r);
          };
        }(e, i) : e;
      for (void 0 === a ? (c = 1, d = t[o[0]]) : (c = 0, d = a); c < r; c++) d = s(d, t[l = o[c]], l, t);
      return d;
    };
    function YC(n, t) {
      var e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
        a = e.skipHooks,
        i = void 0 !== a && a,
        o = Object.keys(t).reduce(function (r, s) {
          var c = t[s];
          return c.icon ? r[c.iconName] = c.icon : r[s] = c, r;
        }, {});
      "function" != typeof Sa.hooks.addPack || i ? Sa.styles[n] = ze({}, Sa.styles[n] || {}, o) : Sa.hooks.addPack(n, o), "fas" === n && YC("fa", t);
    }
    var qC = Sa.styles,
      vde = Sa.shims,
      XC = function () {
        var t = function (i) {
          return o4(qC, function (o, r, s) {
            return o[s] = o4(r, i, {}), o;
          }, {});
        };
        t(function (a, i, o) {
          return i[3] && (a[i[3]] = o), a;
        }), t(function (a, i, o) {
          var r = i[2];
          return a[o] = o, r.forEach(function (s) {
            a[s] = o;
          }), a;
        });
        var e = "far" in qC;
        o4(vde, function (a, i) {
          var r = i[1];
          return "far" === r && !e && (r = "fas"), a[i[0]] = {
            prefix: r,
            iconName: i[2]
          }, a;
        }, {});
      };
    function $C(n, t, e) {
      if (n && n[t] && n[t][e]) return {
        prefix: t,
        iconName: e,
        icon: n[t][e]
      };
    }
    function vs(n) {
      var t = n.tag,
        e = n.attributes,
        a = void 0 === e ? {} : e,
        i = n.children,
        o = void 0 === i ? [] : i;
      return "string" == typeof n ? VC(n) : "<".concat(t, " ").concat(function lde(n) {
        return Object.keys(n || {}).reduce(function (t, e) {
          return t + "".concat(e, '="').concat(VC(n[e]), '" ');
        }, "").trim();
      }(a), ">").concat(o.map(vs).join(""), "</").concat(t, ">");
    }
    XC();
    function ml(n) {
      this.name = "MissingIcon", this.message = n || "Icon unavailable", this.stack = new Error().stack;
    }
    (ml.prototype = Object.create(Error.prototype)).constructor = ml;
    var H2 = {
        fill: "currentColor"
      },
      oM = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      },
      l4 = (ze({}, H2, {
        d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
      }), ze({}, oM, {
        attributeName: "opacity"
      }));
    function u4(n) {
      var t = n[0],
        e = n[1],
        o = Up(n.slice(4), 1)[0];
      return {
        found: !0,
        width: t,
        height: e,
        icon: Array.isArray(o) ? {
          tag: "g",
          attributes: {
            class: "".concat(we.familyPrefix, "-").concat(Go.GROUP)
          },
          children: [{
            tag: "path",
            attributes: {
              class: "".concat(we.familyPrefix, "-").concat(Go.SECONDARY),
              fill: "currentColor",
              d: o[0]
            }
          }, {
            tag: "path",
            attributes: {
              class: "".concat(we.familyPrefix, "-").concat(Go.PRIMARY),
              fill: "currentColor",
              d: o[1]
            }
          }]
        } : {
          tag: "path",
          attributes: {
            fill: "currentColor",
            d: o
          }
        }
      };
    }
    ze({}, H2, {
      cx: "256",
      cy: "364",
      r: "28"
    }), ze({}, oM, {
      attributeName: "r",
      values: "28;14;28;28;14;28;"
    }), ze({}, l4, {
      values: "1;0;1;1;0;1;"
    }), ze({}, H2, {
      opacity: "1",
      d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
    }), ze({}, l4, {
      values: "1;0;0;0;0;1;"
    }), ze({}, H2, {
      opacity: "0",
      d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
    }), ze({}, l4, {
      values: "0;0;1;1;0;0;"
    });
    var Kde = function () {
      function n() {
        (function k1e(n, t) {
          if (!(n instanceof t)) throw new TypeError("Cannot call a class as a function");
        })(this, n), this.definitions = {};
      }
      return function D1e(n, t, e) {
        t && pC(n.prototype, t), e && pC(n, e);
      }(n, [{
        key: "add",
        value: function () {
          for (var e = this, a = arguments.length, i = new Array(a), o = 0; o < a; o++) i[o] = arguments[o];
          var r = i.reduce(this._pullDefinitions, {});
          Object.keys(r).forEach(function (s) {
            e.definitions[s] = ze({}, e.definitions[s] || {}, r[s]), YC(s, r[s]), XC();
          });
        }
      }, {
        key: "reset",
        value: function () {
          this.definitions = {};
        }
      }, {
        key: "_pullDefinitions",
        value: function (e, a) {
          var i = a.prefix && a.iconName && a.icon ? {
            0: a
          } : a;
          return Object.keys(i).map(function (o) {
            var r = i[o],
              s = r.prefix,
              c = r.iconName,
              l = r.icon;
            e[s] || (e[s] = {}), e[s][c] = l;
          }), e;
        }
      }]), n;
    }();
    function hl() {
      we.autoAddCss && !j2 && (function FC(n) {
        if (n && wi) {
          var t = Tt.createElement("style");
          t.setAttribute("type", "text/css"), t.innerHTML = n;
          for (var e = Tt.head.childNodes, a = null, i = e.length - 1; i > -1; i--) {
            var o = e[i],
              r = (o.tagName || "").toUpperCase();
            ["STYLE", "LINK"].indexOf(r) > -1 && (a = o);
          }
          return Tt.head.insertBefore(t, a), n;
        }
      }(function m4() {
        var n = "fa",
          t = kC,
          e = we.familyPrefix,
          a = we.replacementClass,
          i = 'svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}';
        if (e !== n || a !== t) {
          var o = new RegExp("\\.".concat(n, "\\-"), "g"),
            r = new RegExp("\\--".concat(n, "\\-"), "g"),
            s = new RegExp("\\.".concat(t), "g");
          i = i.replace(o, ".".concat(e, "-")).replace(r, "--".concat(e, "-")).replace(s, ".".concat(a));
        }
        return i;
      }()), j2 = !0);
    }
    function B2(n, t) {
      return Object.defineProperty(n, "abstract", {
        get: t
      }), Object.defineProperty(n, "html", {
        get: function () {
          return n.abstract.map(function (a) {
            return vs(a);
          });
        }
      }), Object.defineProperty(n, "node", {
        get: function () {
          if (wi) {
            var a = Tt.createElement("div");
            return a.innerHTML = n.html, a.children;
          }
        }
      }), n;
    }
    function h4(n) {
      var t = n.prefix,
        e = void 0 === t ? "fa" : t,
        a = n.iconName;
      if (a) return $C(p4.definitions, e, a) || $C(Sa.styles, e, a);
    }
    var p4 = new Kde(),
      j2 = !1,
      dM_transform = function (t) {
        return function (t) {
          var e = {
            size: 16,
            x: 0,
            y: 0,
            flipX: !1,
            flipY: !1,
            rotate: 0
          };
          return t ? t.toLowerCase().split(" ").reduce(function (a, i) {
            var o = i.toLowerCase().split("-"),
              r = o[0],
              s = o.slice(1).join("-");
            if (r && "h" === s) return a.flipX = !0, a;
            if (r && "v" === s) return a.flipY = !0, a;
            if (s = parseFloat(s), isNaN(s)) return a;
            switch (r) {
              case "grow":
                a.size = a.size + s;
                break;
              case "shrink":
                a.size = a.size - s;
                break;
              case "left":
                a.x = a.x - s;
                break;
              case "right":
                a.x = a.x + s;
                break;
              case "up":
                a.y = a.y - s;
                break;
              case "down":
                a.y = a.y + s;
                break;
              case "rotate":
                a.rotate = a.rotate + s;
            }
            return a;
          }, e) : e;
        }(t);
      },
      uM = function Qde(n) {
        return function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            a = (t || {}).icon ? t : h4(t || {}),
            i = e.mask;
          return i && (i = (i || {}).icon ? i : h4(i || {})), n(a, ze({}, e, {
            mask: i
          }));
        };
      }(function (n) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          e = t.transform,
          a = void 0 === e ? Oi : e,
          i = t.symbol,
          o = void 0 !== i && i,
          r = t.mask,
          s = void 0 === r ? null : r,
          c = t.maskId,
          l = void 0 === c ? null : c,
          d = t.title,
          u = void 0 === d ? null : d,
          m = t.titleId,
          h = void 0 === m ? null : m,
          p = t.classes,
          v = void 0 === p ? [] : p,
          C = t.attributes,
          k = void 0 === C ? {} : C,
          T = t.styles,
          w = void 0 === T ? {} : T;
        if (n) {
          var N = n.prefix,
            le = n.iconName,
            Ce = n.icon;
          return B2(ze({
            type: "icon"
          }, n), function () {
            return hl(), we.autoA11y && (u ? k["aria-labelledby"] = "".concat(we.replacementClass, "-title-").concat(h || ul()) : (k["aria-hidden"] = "true", k.focusable = "false")), t4({
              icons: {
                main: u4(Ce),
                mask: s ? u4(s.icon) : {
                  found: !1,
                  width: null,
                  height: null,
                  icon: {}
                }
              },
              prefix: N,
              iconName: le,
              transform: ze({}, Oi, a),
              symbol: o,
              title: u,
              maskId: l,
              titleId: h,
              extra: {
                attributes: k,
                styles: w,
                classes: v
              }
            });
          });
        }
      });
    const fM = {
        prefix: "facedar",
        iconName: "jsonld",
        icon: [400, 400, [], "e001", "m315 246c-4 0-6 0-10 3l-73-122c17-11 28-30 28-51 0-34-28-62-62-62-34 0-60 28-60 62 0 19 9 36 22 47l-86 123c-34 0-61 28-61 62 0 34 27 62 61 62 35 0 62-28 62-62 0-2 0-4 0-4l120 0c0 2 0 4 0 4 0 34 27 62 62 62 34 0 61-28 61-62 0-34-29-62-64-62z m-53 13l-143 0 77-113z m-62-202c11 0 19 8 19 19 0 10-8 19-19 19-10 0-19-11-19-19 0-9 9-19 19-19z m-123 268c-11 0-20-8-20-19 0-10 9-19 20-19 10 0 19 9 19 19 0 11-11 19-19 19z m238 0c-10 0-19-8-19-19 0-10 9-19 19-19 11 0 20 9 20 19 0 11-9 19-20 19z"]
      },
      a2e = ["mat-button", ""],
      i2e = ["*"],
      r2e = ["mat-button", "mat-flat-button", "mat-icon-button", "mat-raised-button", "mat-stroked-button", "mat-mini-fab", "mat-fab"],
      s2e = Qa(Fo(Za(class {
        constructor(n) {
          this._elementRef = n;
        }
      })));
    let Pi = (() => {
        class n extends s2e {
          constructor(e, a, i) {
            super(e), this._focusMonitor = a, this._animationMode = i, this.isRoundButton = this._hasHostAttributes("mat-fab", "mat-mini-fab"), this.isIconButton = this._hasHostAttributes("mat-icon-button");
            for (const o of r2e) this._hasHostAttributes(o) && this._getHostElement().classList.add(o);
            e.nativeElement.classList.add("mat-button-base"), this.isRoundButton && (this.color = "accent");
          }
          ngAfterViewInit() {
            this._focusMonitor.monitor(this._elementRef, !0);
          }
          ngOnDestroy() {
            this._focusMonitor.stopMonitoring(this._elementRef);
          }
          focus(e, a) {
            e ? this._focusMonitor.focusVia(this._getHostElement(), e, a) : this._getHostElement().focus(a);
          }
          _getHostElement() {
            return this._elementRef.nativeElement;
          }
          _isRippleDisabled() {
            return this.disableRipple || this.disabled;
          }
          _hasHostAttributes(...e) {
            return e.some(a => this._getHostElement().hasAttribute(a));
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(Hn), f(Ft, 8));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["button", "mat-button", ""], ["button", "mat-raised-button", ""], ["button", "mat-icon-button", ""], ["button", "mat-fab", ""], ["button", "mat-mini-fab", ""], ["button", "mat-stroked-button", ""], ["button", "mat-flat-button", ""]],
          viewQuery: function (e, a) {
            if (1 & e && be(Xa, 5), 2 & e) {
              let i;
              H(i = B()) && (a.ripple = i.first);
            }
          },
          hostAttrs: [1, "mat-focus-indicator"],
          hostVars: 5,
          hostBindings: function (e, a) {
            2 & e && (X("disabled", a.disabled || null), fe("_mat-animation-noopable", "NoopAnimations" === a._animationMode)("mat-button-disabled", a.disabled));
          },
          inputs: {
            disabled: "disabled",
            disableRipple: "disableRipple",
            color: "color"
          },
          exportAs: ["matButton"],
          features: [z],
          attrs: a2e,
          ngContentSelectors: i2e,
          decls: 4,
          vars: 5,
          consts: [[1, "mat-button-wrapper"], ["matRipple", "", 1, "mat-button-ripple", 3, "matRippleDisabled", "matRippleCentered", "matRippleTrigger"], [1, "mat-button-focus-overlay"]],
          template: function (e, a) {
            1 & e && (lt(), _(0, "span", 0), Me(1), y(), j(2, "span", 1)(3, "span", 2)), 2 & e && (g(2), fe("mat-button-ripple-round", a.isRoundButton || a.isIconButton), b("matRippleDisabled", a._isRippleDisabled())("matRippleCentered", a.isIconButton)("matRippleTrigger", a._getHostElement()));
          },
          dependencies: [Xa],
          styles: [".mat-button .mat-button-focus-overlay,.mat-icon-button .mat-button-focus-overlay{opacity:0}.mat-button:hover:not(.mat-button-disabled) .mat-button-focus-overlay,.mat-stroked-button:hover:not(.mat-button-disabled) .mat-button-focus-overlay{opacity:.04}@media(hover: none){.mat-button:hover:not(.mat-button-disabled) .mat-button-focus-overlay,.mat-stroked-button:hover:not(.mat-button-disabled) .mat-button-focus-overlay{opacity:0}}.mat-button,.mat-icon-button,.mat-stroked-button,.mat-flat-button{box-sizing:border-box;position:relative;-webkit-user-select:none;user-select:none;cursor:pointer;outline:none;border:none;-webkit-tap-highlight-color:rgba(0,0,0,0);display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:64px;line-height:36px;padding:0 16px;border-radius:4px;overflow:visible}.mat-button::-moz-focus-inner,.mat-icon-button::-moz-focus-inner,.mat-stroked-button::-moz-focus-inner,.mat-flat-button::-moz-focus-inner{border:0}.mat-button.mat-button-disabled,.mat-icon-button.mat-button-disabled,.mat-stroked-button.mat-button-disabled,.mat-flat-button.mat-button-disabled{cursor:default}.mat-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-button.cdk-program-focused .mat-button-focus-overlay,.mat-icon-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-icon-button.cdk-program-focused .mat-button-focus-overlay,.mat-stroked-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-stroked-button.cdk-program-focused .mat-button-focus-overlay,.mat-flat-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-flat-button.cdk-program-focused .mat-button-focus-overlay{opacity:.12}.mat-button::-moz-focus-inner,.mat-icon-button::-moz-focus-inner,.mat-stroked-button::-moz-focus-inner,.mat-flat-button::-moz-focus-inner{border:0}.mat-raised-button{box-sizing:border-box;position:relative;-webkit-user-select:none;user-select:none;cursor:pointer;outline:none;border:none;-webkit-tap-highlight-color:rgba(0,0,0,0);display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:64px;line-height:36px;padding:0 16px;border-radius:4px;overflow:visible;transform:translate3d(0, 0, 0);transition:background 400ms cubic-bezier(0.25, 0.8, 0.25, 1),box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1)}.mat-raised-button::-moz-focus-inner{border:0}.mat-raised-button.mat-button-disabled{cursor:default}.mat-raised-button.cdk-keyboard-focused .mat-button-focus-overlay,.mat-raised-button.cdk-program-focused .mat-button-focus-overlay{opacity:.12}.mat-raised-button::-moz-focus-inner{border:0}.mat-raised-button._mat-animation-noopable{transition:none !important;animation:none !important}.mat-stroked-button{border:1px solid currentColor;padding:0 15px;line-height:34px}.mat-stroked-button .mat-button-ripple.mat-ripple,.mat-stroked-button .mat-button-focus-overlay{top:-1px;left:-1px;right:-1px;bottom:-1px}.mat-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;user-select:none;cursor:pointer;outline:none;border:none;-webkit-tap-highlight-color:rgba(0,0,0,0);display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:64px;line-height:36px;padding:0 16px;border-radius:4px;overflow:visible;transform:translate3d(0, 0, 0);transition:background 400ms cubic-bezier(0.25, 0.8, 0.25, 1),box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);min-width:0;border-radius:50%;width:56px;height:56px;padding:0;flex-shrink:0}.mat-fab::-moz-focus-inner{border:0}.mat-fab.mat-button-disabled{cursor:default}.mat-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-fab.cdk-program-focused .mat-button-focus-overlay{opacity:.12}.mat-fab::-moz-focus-inner{border:0}.mat-fab._mat-animation-noopable{transition:none !important;animation:none !important}.mat-fab .mat-button-wrapper{padding:16px 0;display:inline-block;line-height:24px}.mat-mini-fab{box-sizing:border-box;position:relative;-webkit-user-select:none;user-select:none;cursor:pointer;outline:none;border:none;-webkit-tap-highlight-color:rgba(0,0,0,0);display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:64px;line-height:36px;padding:0 16px;border-radius:4px;overflow:visible;transform:translate3d(0, 0, 0);transition:background 400ms cubic-bezier(0.25, 0.8, 0.25, 1),box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);min-width:0;border-radius:50%;width:40px;height:40px;padding:0;flex-shrink:0}.mat-mini-fab::-moz-focus-inner{border:0}.mat-mini-fab.mat-button-disabled{cursor:default}.mat-mini-fab.cdk-keyboard-focused .mat-button-focus-overlay,.mat-mini-fab.cdk-program-focused .mat-button-focus-overlay{opacity:.12}.mat-mini-fab::-moz-focus-inner{border:0}.mat-mini-fab._mat-animation-noopable{transition:none !important;animation:none !important}.mat-mini-fab .mat-button-wrapper{padding:8px 0;display:inline-block;line-height:24px}.mat-icon-button{padding:0;min-width:0;width:40px;height:40px;flex-shrink:0;line-height:40px;border-radius:50%}.mat-icon-button i,.mat-icon-button .mat-icon{line-height:24px}.mat-button-ripple.mat-ripple,.mat-button-focus-overlay{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none;border-radius:inherit}.mat-button-ripple.mat-ripple:not(:empty){transform:translateZ(0)}.mat-button-focus-overlay{opacity:0;transition:opacity 200ms cubic-bezier(0.35, 0, 0.25, 1),background-color 200ms cubic-bezier(0.35, 0, 0.25, 1)}._mat-animation-noopable .mat-button-focus-overlay{transition:none}.mat-button-ripple-round{border-radius:50%;z-index:1}.mat-button .mat-button-wrapper>*,.mat-flat-button .mat-button-wrapper>*,.mat-stroked-button .mat-button-wrapper>*,.mat-raised-button .mat-button-wrapper>*,.mat-icon-button .mat-button-wrapper>*,.mat-fab .mat-button-wrapper>*,.mat-mini-fab .mat-button-wrapper>*{vertical-align:middle}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon-button,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon-button{display:inline-flex;justify-content:center;align-items:center;font-size:inherit;width:2.5em;height:2.5em}.mat-flat-button::before,.mat-raised-button::before,.mat-fab::before,.mat-mini-fab::before{margin:calc(calc(var(--mat-focus-indicator-border-width, 3px) + 2px) * -1)}.mat-stroked-button::before{margin:calc(calc(var(--mat-focus-indicator-border-width, 3px) + 3px) * -1)}.cdk-high-contrast-active .mat-button,.cdk-high-contrast-active .mat-flat-button,.cdk-high-contrast-active .mat-raised-button,.cdk-high-contrast-active .mat-icon-button,.cdk-high-contrast-active .mat-fab,.cdk-high-contrast-active .mat-mini-fab{outline:solid 1px}"],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })(),
      Wo = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [sa, $, $]
        }), n;
      })();
    function U2(n) {
      return function (e) {
        const a = new c2e(n),
          i = e.lift(a);
        return a.caught = i;
      };
    }
    class c2e {
      constructor(t) {
        this.selector = t;
      }
      call(t, e) {
        return e.subscribe(new l2e(t, this.selector, this.caught));
      }
    }
    class l2e extends Fs {
      constructor(t, e, a) {
        super(t), this.selector = e, this.caught = a;
      }
      error(t) {
        if (!this.isStopped) {
          let e;
          try {
            e = this.selector(t, this.caught);
          } catch (o) {
            return void super.error(o);
          }
          this._unsubscribeAndRecycle();
          const a = new Ns(this);
          this.add(a);
          const i = Vs(e, a);
          i !== a && this.add(i);
        }
      }
    }
    class u2e {
      constructor(t) {
        this.callback = t;
      }
      call(t, e) {
        return e.subscribe(new f2e(t, this.callback));
      }
    }
    class f2e extends Qe {
      constructor(t, e) {
        super(t), this.add(new re(e));
      }
    }
    function mM(n, t) {
      return K0(n, t, 1);
    }
    class hM {}
    class pM {}
    class Ai {
      constructor(t) {
        this.normalizedNames = new Map(), this.lazyUpdate = null, t ? this.lazyInit = "string" == typeof t ? () => {
          this.headers = new Map(), t.split("\n").forEach(e => {
            const a = e.indexOf(":");
            if (a > 0) {
              const i = e.slice(0, a),
                o = i.toLowerCase(),
                r = e.slice(a + 1).trim();
              this.maybeSetNormalizedName(i, o), this.headers.has(o) ? this.headers.get(o).push(r) : this.headers.set(o, [r]);
            }
          });
        } : () => {
          this.headers = new Map(), Object.keys(t).forEach(e => {
            let a = t[e];
            const i = e.toLowerCase();
            "string" == typeof a && (a = [a]), a.length > 0 && (this.headers.set(i, a), this.maybeSetNormalizedName(e, i));
          });
        } : this.headers = new Map();
      }
      has(t) {
        return this.init(), this.headers.has(t.toLowerCase());
      }
      get(t) {
        this.init();
        const e = this.headers.get(t.toLowerCase());
        return e && e.length > 0 ? e[0] : null;
      }
      keys() {
        return this.init(), Array.from(this.normalizedNames.values());
      }
      getAll(t) {
        return this.init(), this.headers.get(t.toLowerCase()) || null;
      }
      append(t, e) {
        return this.clone({
          name: t,
          value: e,
          op: "a"
        });
      }
      set(t, e) {
        return this.clone({
          name: t,
          value: e,
          op: "s"
        });
      }
      delete(t, e) {
        return this.clone({
          name: t,
          value: e,
          op: "d"
        });
      }
      maybeSetNormalizedName(t, e) {
        this.normalizedNames.has(e) || this.normalizedNames.set(e, t);
      }
      init() {
        this.lazyInit && (this.lazyInit instanceof Ai ? this.copyFrom(this.lazyInit) : this.lazyInit(), this.lazyInit = null, this.lazyUpdate && (this.lazyUpdate.forEach(t => this.applyUpdate(t)), this.lazyUpdate = null));
      }
      copyFrom(t) {
        t.init(), Array.from(t.headers.keys()).forEach(e => {
          this.headers.set(e, t.headers.get(e)), this.normalizedNames.set(e, t.normalizedNames.get(e));
        });
      }
      clone(t) {
        const e = new Ai();
        return e.lazyInit = this.lazyInit && this.lazyInit instanceof Ai ? this.lazyInit : this, e.lazyUpdate = (this.lazyUpdate || []).concat([t]), e;
      }
      applyUpdate(t) {
        const e = t.name.toLowerCase();
        switch (t.op) {
          case "a":
          case "s":
            let a = t.value;
            if ("string" == typeof a && (a = [a]), 0 === a.length) return;
            this.maybeSetNormalizedName(t.name, e);
            const i = ("a" === t.op ? this.headers.get(e) : void 0) || [];
            i.push(...a), this.headers.set(e, i);
            break;
          case "d":
            const o = t.value;
            if (o) {
              let r = this.headers.get(e);
              if (!r) return;
              r = r.filter(s => -1 === o.indexOf(s)), 0 === r.length ? (this.headers.delete(e), this.normalizedNames.delete(e)) : this.headers.set(e, r);
            } else this.headers.delete(e), this.normalizedNames.delete(e);
        }
      }
      forEach(t) {
        this.init(), Array.from(this.normalizedNames.keys()).forEach(e => t(this.normalizedNames.get(e), this.headers.get(e)));
      }
    }
    class m2e {
      encodeKey(t) {
        return gM(t);
      }
      encodeValue(t) {
        return gM(t);
      }
      decodeKey(t) {
        return decodeURIComponent(t);
      }
      decodeValue(t) {
        return decodeURIComponent(t);
      }
    }
    const p2e = /%(\d[a-f0-9])/gi,
      g2e = {
        40: "@",
        "3A": ":",
        24: "$",
        "2C": ",",
        "3B": ";",
        "3D": "=",
        "3F": "?",
        "2F": "/"
      };
    function gM(n) {
      return encodeURIComponent(n).replace(p2e, (t, e) => g2e[e] ?? t);
    }
    function G2(n) {
      return `${n}`;
    }
    class no {
      constructor(t = {}) {
        if (this.updates = null, this.cloneFrom = null, this.encoder = t.encoder || new m2e(), t.fromString) {
          if (t.fromObject) throw new Error("Cannot specify both fromString and fromObject.");
          this.map = function h2e(n, t) {
            const e = new Map();
            return n.length > 0 && n.replace(/^\?/, "").split("&").forEach(i => {
              const o = i.indexOf("="),
                [r, s] = -1 == o ? [t.decodeKey(i), ""] : [t.decodeKey(i.slice(0, o)), t.decodeValue(i.slice(o + 1))],
                c = e.get(r) || [];
              c.push(s), e.set(r, c);
            }), e;
          }(t.fromString, this.encoder);
        } else t.fromObject ? (this.map = new Map(), Object.keys(t.fromObject).forEach(e => {
          const a = t.fromObject[e],
            i = Array.isArray(a) ? a.map(G2) : [G2(a)];
          this.map.set(e, i);
        })) : this.map = null;
      }
      has(t) {
        return this.init(), this.map.has(t);
      }
      get(t) {
        this.init();
        const e = this.map.get(t);
        return e ? e[0] : null;
      }
      getAll(t) {
        return this.init(), this.map.get(t) || null;
      }
      keys() {
        return this.init(), Array.from(this.map.keys());
      }
      append(t, e) {
        return this.clone({
          param: t,
          value: e,
          op: "a"
        });
      }
      appendAll(t) {
        const e = [];
        return Object.keys(t).forEach(a => {
          const i = t[a];
          Array.isArray(i) ? i.forEach(o => {
            e.push({
              param: a,
              value: o,
              op: "a"
            });
          }) : e.push({
            param: a,
            value: i,
            op: "a"
          });
        }), this.clone(e);
      }
      set(t, e) {
        return this.clone({
          param: t,
          value: e,
          op: "s"
        });
      }
      delete(t, e) {
        return this.clone({
          param: t,
          value: e,
          op: "d"
        });
      }
      toString() {
        return this.init(), this.keys().map(t => {
          const e = this.encoder.encodeKey(t);
          return this.map.get(t).map(a => e + "=" + this.encoder.encodeValue(a)).join("&");
        }).filter(t => "" !== t).join("&");
      }
      clone(t) {
        const e = new no({
          encoder: this.encoder
        });
        return e.cloneFrom = this.cloneFrom || this, e.updates = (this.updates || []).concat(t), e;
      }
      init() {
        null === this.map && (this.map = new Map()), null !== this.cloneFrom && (this.cloneFrom.init(), this.cloneFrom.keys().forEach(t => this.map.set(t, this.cloneFrom.map.get(t))), this.updates.forEach(t => {
          switch (t.op) {
            case "a":
            case "s":
              const e = ("a" === t.op ? this.map.get(t.param) : void 0) || [];
              e.push(G2(t.value)), this.map.set(t.param, e);
              break;
            case "d":
              if (void 0 === t.value) {
                this.map.delete(t.param);
                break;
              }
              {
                let a = this.map.get(t.param) || [];
                const i = a.indexOf(G2(t.value));
                -1 !== i && a.splice(i, 1), a.length > 0 ? this.map.set(t.param, a) : this.map.delete(t.param);
              }
          }
        }), this.cloneFrom = this.updates = null);
      }
    }
    class b2e {
      constructor() {
        this.map = new Map();
      }
      set(t, e) {
        return this.map.set(t, e), this;
      }
      get(t) {
        return this.map.has(t) || this.map.set(t, t.defaultValue()), this.map.get(t);
      }
      delete(t) {
        return this.map.delete(t), this;
      }
      has(t) {
        return this.map.has(t);
      }
      keys() {
        return this.map.keys();
      }
    }
    function bM(n) {
      return typeof ArrayBuffer < "u" && n instanceof ArrayBuffer;
    }
    function _M(n) {
      return typeof Blob < "u" && n instanceof Blob;
    }
    function vM(n) {
      return typeof FormData < "u" && n instanceof FormData;
    }
    class pl {
      constructor(t, e, a, i) {
        let o;
        if (this.url = e, this.body = null, this.reportProgress = !1, this.withCredentials = !1, this.responseType = "json", this.method = t.toUpperCase(), function _2e(n) {
          switch (n) {
            case "DELETE":
            case "GET":
            case "HEAD":
            case "OPTIONS":
            case "JSONP":
              return !1;
            default:
              return !0;
          }
        }(this.method) || i ? (this.body = void 0 !== a ? a : null, o = i) : o = a, o && (this.reportProgress = !!o.reportProgress, this.withCredentials = !!o.withCredentials, o.responseType && (this.responseType = o.responseType), o.headers && (this.headers = o.headers), o.context && (this.context = o.context), o.params && (this.params = o.params)), this.headers || (this.headers = new Ai()), this.context || (this.context = new b2e()), this.params) {
          const r = this.params.toString();
          if (0 === r.length) this.urlWithParams = e;else {
            const s = e.indexOf("?");
            this.urlWithParams = e + (-1 === s ? "?" : s < e.length - 1 ? "&" : "") + r;
          }
        } else this.params = new no(), this.urlWithParams = e;
      }
      serializeBody() {
        return null === this.body ? null : bM(this.body) || _M(this.body) || vM(this.body) || function v2e(n) {
          return typeof URLSearchParams < "u" && n instanceof URLSearchParams;
        }(this.body) || "string" == typeof this.body ? this.body : this.body instanceof no ? this.body.toString() : "object" == typeof this.body || "boolean" == typeof this.body || Array.isArray(this.body) ? JSON.stringify(this.body) : this.body.toString();
      }
      detectContentTypeHeader() {
        return null === this.body || vM(this.body) ? null : _M(this.body) ? this.body.type || null : bM(this.body) ? null : "string" == typeof this.body ? "text/plain" : this.body instanceof no ? "application/x-www-form-urlencoded;charset=UTF-8" : "object" == typeof this.body || "number" == typeof this.body || "boolean" == typeof this.body ? "application/json" : null;
      }
      clone(t = {}) {
        const e = t.method || this.method,
          a = t.url || this.url,
          i = t.responseType || this.responseType,
          o = void 0 !== t.body ? t.body : this.body,
          r = void 0 !== t.withCredentials ? t.withCredentials : this.withCredentials,
          s = void 0 !== t.reportProgress ? t.reportProgress : this.reportProgress;
        let c = t.headers || this.headers,
          l = t.params || this.params;
        const d = t.context ?? this.context;
        return void 0 !== t.setHeaders && (c = Object.keys(t.setHeaders).reduce((u, m) => u.set(m, t.setHeaders[m]), c)), t.setParams && (l = Object.keys(t.setParams).reduce((u, m) => u.set(m, t.setParams[m]), l)), new pl(e, a, o, {
          params: l,
          headers: c,
          context: d,
          reportProgress: s,
          responseType: i,
          withCredentials: r
        });
      }
    }
    var It = (() => ((It = It || {})[It.Sent = 0] = "Sent", It[It.UploadProgress = 1] = "UploadProgress", It[It.ResponseHeader = 2] = "ResponseHeader", It[It.DownloadProgress = 3] = "DownloadProgress", It[It.Response = 4] = "Response", It[It.User = 5] = "User", It))();
    class g4 {
      constructor(t, e = 200, a = "OK") {
        this.headers = t.headers || new Ai(), this.status = void 0 !== t.status ? t.status : e, this.statusText = t.statusText || a, this.url = t.url || null, this.ok = this.status >= 200 && this.status < 300;
      }
    }
    class b4 extends g4 {
      constructor(t = {}) {
        super(t), this.type = It.ResponseHeader;
      }
      clone(t = {}) {
        return new b4({
          headers: t.headers || this.headers,
          status: void 0 !== t.status ? t.status : this.status,
          statusText: t.statusText || this.statusText,
          url: t.url || this.url || void 0
        });
      }
    }
    class W2 extends g4 {
      constructor(t = {}) {
        super(t), this.type = It.Response, this.body = void 0 !== t.body ? t.body : null;
      }
      clone(t = {}) {
        return new W2({
          body: void 0 !== t.body ? t.body : this.body,
          headers: t.headers || this.headers,
          status: void 0 !== t.status ? t.status : this.status,
          statusText: t.statusText || this.statusText,
          url: t.url || this.url || void 0
        });
      }
    }
    class yM extends g4 {
      constructor(t) {
        super(t, 0, "Unknown Error"), this.name = "HttpErrorResponse", this.ok = !1, this.message = this.status >= 200 && this.status < 300 ? `Http failure during parsing for ${t.url || "(unknown url)"}` : `Http failure response for ${t.url || "(unknown url)"}: ${t.status} ${t.statusText}`, this.error = t.error || null;
      }
    }
    function _4(n, t) {
      return {
        body: t,
        headers: n.headers,
        context: n.context,
        observe: n.observe,
        params: n.params,
        reportProgress: n.reportProgress,
        responseType: n.responseType,
        withCredentials: n.withCredentials
      };
    }
    let Yo = (() => {
      class n {
        constructor(e) {
          this.handler = e;
        }
        request(e, a, i = {}) {
          let o;
          if (e instanceof pl) o = e;else {
            let c, l;
            c = i.headers instanceof Ai ? i.headers : new Ai(i.headers), i.params && (l = i.params instanceof no ? i.params : new no({
              fromObject: i.params
            })), o = new pl(e, a, void 0 !== i.body ? i.body : null, {
              headers: c,
              context: i.context,
              params: l,
              reportProgress: i.reportProgress,
              responseType: i.responseType || "json",
              withCredentials: i.withCredentials
            });
          }
          const r = nt(o).pipe(mM(c => this.handler.handle(c)));
          if (e instanceof pl || "events" === i.observe) return r;
          const s = r.pipe(Ht(c => c instanceof W2));
          switch (i.observe || "body") {
            case "body":
              switch (o.responseType) {
                case "arraybuffer":
                  return s.pipe(We(c => {
                    if (null !== c.body && !(c.body instanceof ArrayBuffer)) throw new Error("Response is not an ArrayBuffer.");
                    return c.body;
                  }));
                case "blob":
                  return s.pipe(We(c => {
                    if (null !== c.body && !(c.body instanceof Blob)) throw new Error("Response is not a Blob.");
                    return c.body;
                  }));
                case "text":
                  return s.pipe(We(c => {
                    if (null !== c.body && "string" != typeof c.body) throw new Error("Response is not a string.");
                    return c.body;
                  }));
                default:
                  return s.pipe(We(c => c.body));
              }
            case "response":
              return s;
            default:
              throw new Error(`Unreachable: unhandled observe type ${i.observe}}`);
          }
        }
        delete(e, a = {}) {
          return this.request("DELETE", e, a);
        }
        get(e, a = {}) {
          return this.request("GET", e, a);
        }
        head(e, a = {}) {
          return this.request("HEAD", e, a);
        }
        jsonp(e, a) {
          return this.request("JSONP", e, {
            params: new no().append(a, "JSONP_CALLBACK"),
            observe: "body",
            responseType: "json"
          });
        }
        options(e, a = {}) {
          return this.request("OPTIONS", e, a);
        }
        patch(e, a, i = {}) {
          return this.request("PATCH", e, _4(i, a));
        }
        post(e, a, i = {}) {
          return this.request("POST", e, _4(i, a));
        }
        put(e, a, i = {}) {
          return this.request("PUT", e, _4(i, a));
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(hM));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac
      }), n;
    })();
    class CM {
      constructor(t, e) {
        this.next = t, this.interceptor = e;
      }
      handle(t) {
        return this.interceptor.intercept(t, this.next);
      }
    }
    const MM = new O("HTTP_INTERCEPTORS");
    let y2e = (() => {
      class n {
        intercept(e, a) {
          return a.handle(e);
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)();
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac
      }), n;
    })();
    const C2e = /^\)\]\}',?\n/;
    let xM = (() => {
      class n {
        constructor(e) {
          this.xhrFactory = e;
        }
        handle(e) {
          if ("JSONP" === e.method) throw new Error("Attempted to construct Jsonp request without HttpClientJsonpModule installed.");
          return new Be(a => {
            const i = this.xhrFactory.build();
            if (i.open(e.method, e.urlWithParams), e.withCredentials && (i.withCredentials = !0), e.headers.forEach((h, p) => i.setRequestHeader(h, p.join(","))), e.headers.has("Accept") || i.setRequestHeader("Accept", "application/json, text/plain, */*"), !e.headers.has("Content-Type")) {
              const h = e.detectContentTypeHeader();
              null !== h && i.setRequestHeader("Content-Type", h);
            }
            if (e.responseType) {
              const h = e.responseType.toLowerCase();
              i.responseType = "json" !== h ? h : "text";
            }
            const o = e.serializeBody();
            let r = null;
            const s = () => {
                if (null !== r) return r;
                const h = i.statusText || "OK",
                  p = new Ai(i.getAllResponseHeaders()),
                  v = function M2e(n) {
                    return "responseURL" in n && n.responseURL ? n.responseURL : /^X-Request-URL:/m.test(n.getAllResponseHeaders()) ? n.getResponseHeader("X-Request-URL") : null;
                  }(i) || e.url;
                return r = new b4({
                  headers: p,
                  status: i.status,
                  statusText: h,
                  url: v
                }), r;
              },
              c = () => {
                let {
                    headers: h,
                    status: p,
                    statusText: v,
                    url: C
                  } = s(),
                  k = null;
                204 !== p && (k = typeof i.response > "u" ? i.responseText : i.response), 0 === p && (p = k ? 200 : 0);
                let T = p >= 200 && p < 300;
                if ("json" === e.responseType && "string" == typeof k) {
                  const w = k;
                  k = k.replace(C2e, "");
                  try {
                    k = "" !== k ? JSON.parse(k) : null;
                  } catch (N) {
                    k = w, T && (T = !1, k = {
                      error: N,
                      text: k
                    });
                  }
                }
                T ? (a.next(new W2({
                  body: k,
                  headers: h,
                  status: p,
                  statusText: v,
                  url: C || void 0
                })), a.complete()) : a.error(new yM({
                  error: k,
                  headers: h,
                  status: p,
                  statusText: v,
                  url: C || void 0
                }));
              },
              l = h => {
                const {
                    url: p
                  } = s(),
                  v = new yM({
                    error: h,
                    status: i.status || 0,
                    statusText: i.statusText || "Unknown Error",
                    url: p || void 0
                  });
                a.error(v);
              };
            let d = !1;
            const u = h => {
                d || (a.next(s()), d = !0);
                let p = {
                  type: It.DownloadProgress,
                  loaded: h.loaded
                };
                h.lengthComputable && (p.total = h.total), "text" === e.responseType && !!i.responseText && (p.partialText = i.responseText), a.next(p);
              },
              m = h => {
                let p = {
                  type: It.UploadProgress,
                  loaded: h.loaded
                };
                h.lengthComputable && (p.total = h.total), a.next(p);
              };
            return i.addEventListener("load", c), i.addEventListener("error", l), i.addEventListener("timeout", l), i.addEventListener("abort", l), e.reportProgress && (i.addEventListener("progress", u), null !== o && i.upload && i.upload.addEventListener("progress", m)), i.send(o), a.next({
              type: It.Sent
            }), () => {
              i.removeEventListener("error", l), i.removeEventListener("abort", l), i.removeEventListener("load", c), i.removeEventListener("timeout", l), e.reportProgress && (i.removeEventListener("progress", u), null !== o && i.upload && i.upload.removeEventListener("progress", m)), i.readyState !== i.DONE && i.abort();
            };
          });
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(F7));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac
      }), n;
    })();
    const v4 = new O("XSRF_COOKIE_NAME"),
      y4 = new O("XSRF_HEADER_NAME");
    class wM {}
    let x2e = (() => {
        class n {
          constructor(e, a, i) {
            this.doc = e, this.platform = a, this.cookieName = i, this.lastCookieString = "", this.lastToken = null, this.parseCount = 0;
          }
          getToken() {
            if ("server" === this.platform) return null;
            const e = this.doc.cookie || "";
            return e !== this.lastCookieString && (this.parseCount++, this.lastToken = O7(e, this.cookieName), this.lastCookieString = e), this.lastToken;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(ie), M(X1), M(v4));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac
        }), n;
      })(),
      C4 = (() => {
        class n {
          constructor(e, a) {
            this.tokenService = e, this.headerName = a;
          }
          intercept(e, a) {
            const i = e.url.toLowerCase();
            if ("GET" === e.method || "HEAD" === e.method || i.startsWith("http://") || i.startsWith("https://")) return a.handle(e);
            const o = this.tokenService.getToken();
            return null !== o && !e.headers.has(this.headerName) && (e = e.clone({
              headers: e.headers.set(this.headerName, o)
            })), a.handle(e);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(wM), M(y4));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac
        }), n;
      })(),
      w2e = (() => {
        class n {
          constructor(e, a) {
            this.backend = e, this.injector = a, this.chain = null;
          }
          handle(e) {
            if (null === this.chain) {
              const a = this.injector.get(MM, []);
              this.chain = a.reduceRight((i, o) => new CM(i, o), this.backend);
            }
            return this.chain.handle(e);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(pM), M(Lt));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac
        }), n;
      })(),
      k2e = (() => {
        class n {
          static disable() {
            return {
              ngModule: n,
              providers: [{
                provide: C4,
                useClass: y2e
              }]
            };
          }
          static withOptions(e = {}) {
            return {
              ngModule: n,
              providers: [e.cookieName ? {
                provide: v4,
                useValue: e.cookieName
              } : [], e.headerName ? {
                provide: y4,
                useValue: e.headerName
              } : []]
            };
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [C4, {
            provide: MM,
            useExisting: C4,
            multi: !0
          }, {
            provide: wM,
            useClass: x2e
          }, {
            provide: v4,
            useValue: "XSRF-TOKEN"
          }, {
            provide: y4,
            useValue: "X-XSRF-TOKEN"
          }]
        }), n;
      })(),
      M4 = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [Yo, {
            provide: hM,
            useClass: w2e
          }, xM, {
            provide: pM,
            useExisting: xM
          }],
          imports: [k2e.withOptions({
            cookieName: "XSRF-TOKEN",
            headerName: "X-XSRF-TOKEN"
          })]
        }), n;
      })();
    const D2e = ["*"];
    let Y2;
    function gl(n) {
      return function O2e() {
        if (void 0 === Y2 && (Y2 = null, typeof window < "u")) {
          const n = window;
          void 0 !== n.trustedTypes && (Y2 = n.trustedTypes.createPolicy("angular#components", {
            createHTML: t => t
          }));
        }
        return Y2;
      }()?.createHTML(n) || n;
    }
    function kM(n) {
      return Error(`Unable to find icon with the name "${n}"`);
    }
    function DM(n) {
      return Error(`The URL provided to MatIconRegistry was not trusted as a resource URL via Angular's DomSanitizer. Attempted URL was "${n}".`);
    }
    function OM(n) {
      return Error(`The literal provided to MatIconRegistry was not trusted as safe HTML by Angular's DomSanitizer. Attempted literal was "${n}".`);
    }
    class qo {
      constructor(t, e, a) {
        this.url = t, this.svgText = e, this.options = a;
      }
    }
    let q2 = (() => {
      class n {
        constructor(e, a, i, o) {
          this._httpClient = e, this._sanitizer = a, this._errorHandler = o, this._svgIconConfigs = new Map(), this._iconSetConfigs = new Map(), this._cachedIconsByUrl = new Map(), this._inProgressUrlFetches = new Map(), this._fontCssClassesByAlias = new Map(), this._resolvers = [], this._defaultFontSetClass = ["material-icons", "mat-ligature-font"], this._document = i;
        }
        addSvgIcon(e, a, i) {
          return this.addSvgIconInNamespace("", e, a, i);
        }
        addSvgIconLiteral(e, a, i) {
          return this.addSvgIconLiteralInNamespace("", e, a, i);
        }
        addSvgIconInNamespace(e, a, i, o) {
          return this._addSvgIconConfig(e, a, new qo(i, null, o));
        }
        addSvgIconResolver(e) {
          return this._resolvers.push(e), this;
        }
        addSvgIconLiteralInNamespace(e, a, i, o) {
          const r = this._sanitizer.sanitize(Ge.HTML, i);
          if (!r) throw OM(i);
          const s = gl(r);
          return this._addSvgIconConfig(e, a, new qo("", s, o));
        }
        addSvgIconSet(e, a) {
          return this.addSvgIconSetInNamespace("", e, a);
        }
        addSvgIconSetLiteral(e, a) {
          return this.addSvgIconSetLiteralInNamespace("", e, a);
        }
        addSvgIconSetInNamespace(e, a, i) {
          return this._addSvgIconSetConfig(e, new qo(a, null, i));
        }
        addSvgIconSetLiteralInNamespace(e, a, i) {
          const o = this._sanitizer.sanitize(Ge.HTML, a);
          if (!o) throw OM(a);
          const r = gl(o);
          return this._addSvgIconSetConfig(e, new qo("", r, i));
        }
        registerFontClassAlias(e, a = e) {
          return this._fontCssClassesByAlias.set(e, a), this;
        }
        classNameForFontAlias(e) {
          return this._fontCssClassesByAlias.get(e) || e;
        }
        setDefaultFontSetClass(...e) {
          return this._defaultFontSetClass = e, this;
        }
        getDefaultFontSetClass() {
          return this._defaultFontSetClass;
        }
        getSvgIconFromUrl(e) {
          const a = this._sanitizer.sanitize(Ge.RESOURCE_URL, e);
          if (!a) throw DM(e);
          const i = this._cachedIconsByUrl.get(a);
          return i ? nt(K2(i)) : this._loadSvgIconFromConfig(new qo(e, null)).pipe(rs(o => this._cachedIconsByUrl.set(a, o)), We(o => K2(o)));
        }
        getNamedSvgIcon(e, a = "") {
          const i = PM(a, e);
          let o = this._svgIconConfigs.get(i);
          if (o) return this._getSvgFromConfig(o);
          if (o = this._getIconConfigFromResolvers(a, e), o) return this._svgIconConfigs.set(i, o), this._getSvgFromConfig(o);
          const r = this._iconSetConfigs.get(a);
          return r ? this._getSvgFromIconSetConfigs(e, r) : l9(kM(i));
        }
        ngOnDestroy() {
          this._resolvers = [], this._svgIconConfigs.clear(), this._iconSetConfigs.clear(), this._cachedIconsByUrl.clear();
        }
        _getSvgFromConfig(e) {
          return e.svgText ? nt(K2(this._svgElementFromConfig(e))) : this._loadSvgIconFromConfig(e).pipe(We(a => K2(a)));
        }
        _getSvgFromIconSetConfigs(e, a) {
          const i = this._extractIconWithNameFromAnySet(e, a);
          return i ? nt(i) : k_(a.filter(r => !r.svgText).map(r => this._loadSvgIconSetFromConfig(r).pipe(U2(s => {
            const l = `Loading icon set URL: ${this._sanitizer.sanitize(Ge.RESOURCE_URL, r.url)} failed: ${s.message}`;
            return this._errorHandler.handleError(new Error(l)), nt(null);
          })))).pipe(We(() => {
            const r = this._extractIconWithNameFromAnySet(e, a);
            if (!r) throw kM(e);
            return r;
          }));
        }
        _extractIconWithNameFromAnySet(e, a) {
          for (let i = a.length - 1; i >= 0; i--) {
            const o = a[i];
            if (o.svgText && o.svgText.toString().indexOf(e) > -1) {
              const r = this._svgElementFromConfig(o),
                s = this._extractSvgIconFromSet(r, e, o.options);
              if (s) return s;
            }
          }
          return null;
        }
        _loadSvgIconFromConfig(e) {
          return this._fetchIcon(e).pipe(rs(a => e.svgText = a), We(() => this._svgElementFromConfig(e)));
        }
        _loadSvgIconSetFromConfig(e) {
          return e.svgText ? nt(null) : this._fetchIcon(e).pipe(rs(a => e.svgText = a));
        }
        _extractSvgIconFromSet(e, a, i) {
          const o = e.querySelector(`[id="${a}"]`);
          if (!o) return null;
          const r = o.cloneNode(!0);
          if (r.removeAttribute("id"), "svg" === r.nodeName.toLowerCase()) return this._setSvgAttributes(r, i);
          if ("symbol" === r.nodeName.toLowerCase()) return this._setSvgAttributes(this._toSvgElement(r), i);
          const s = this._svgElementFromString(gl("<svg></svg>"));
          return s.appendChild(r), this._setSvgAttributes(s, i);
        }
        _svgElementFromString(e) {
          const a = this._document.createElement("DIV");
          a.innerHTML = e;
          const i = a.querySelector("svg");
          if (!i) throw Error("<svg> tag not found");
          return i;
        }
        _toSvgElement(e) {
          const a = this._svgElementFromString(gl("<svg></svg>")),
            i = e.attributes;
          for (let o = 0; o < i.length; o++) {
            const {
              name: r,
              value: s
            } = i[o];
            "id" !== r && a.setAttribute(r, s);
          }
          for (let o = 0; o < e.childNodes.length; o++) e.childNodes[o].nodeType === this._document.ELEMENT_NODE && a.appendChild(e.childNodes[o].cloneNode(!0));
          return a;
        }
        _setSvgAttributes(e, a) {
          return e.setAttribute("fit", ""), e.setAttribute("height", "100%"), e.setAttribute("width", "100%"), e.setAttribute("preserveAspectRatio", "xMidYMid meet"), e.setAttribute("focusable", "false"), a && a.viewBox && e.setAttribute("viewBox", a.viewBox), e;
        }
        _fetchIcon(e) {
          const {
              url: a,
              options: i
            } = e,
            o = i?.withCredentials ?? !1;
          if (!this._httpClient) throw function P2e() {
            return Error("Could not find HttpClient provider for use with Angular Material icons. Please include the HttpClientModule from @angular/common/http in your app imports.");
          }();
          if (null == a) throw Error(`Cannot fetch icon from URL "${a}".`);
          const r = this._sanitizer.sanitize(Ge.RESOURCE_URL, a);
          if (!r) throw DM(a);
          const s = this._inProgressUrlFetches.get(r);
          if (s) return s;
          const c = this._httpClient.get(r, {
            responseType: "text",
            withCredentials: o
          }).pipe(We(l => gl(l)), function d2e(n) {
            return t => t.lift(new u2e(n));
          }(() => this._inProgressUrlFetches.delete(r)), Ul());
          return this._inProgressUrlFetches.set(r, c), c;
        }
        _addSvgIconConfig(e, a, i) {
          return this._svgIconConfigs.set(PM(e, a), i), this;
        }
        _addSvgIconSetConfig(e, a) {
          const i = this._iconSetConfigs.get(e);
          return i ? i.push(a) : this._iconSetConfigs.set(e, [a]), this;
        }
        _svgElementFromConfig(e) {
          if (!e.svgElement) {
            const a = this._svgElementFromString(e.svgText);
            this._setSvgAttributes(a, e.options), e.svgElement = a;
          }
          return e.svgElement;
        }
        _getIconConfigFromResolvers(e, a) {
          for (let i = 0; i < this._resolvers.length; i++) {
            const o = this._resolvers[i](a, e);
            if (o) return S2e(o) ? new qo(o.url, null, o.options) : new qo(o, null);
          }
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(Yo, 8), M(Cd), M(ie, 8), M(si));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac,
        providedIn: "root"
      }), n;
    })();
    function K2(n) {
      return n.cloneNode(!0);
    }
    function PM(n, t) {
      return n + ":" + t;
    }
    function S2e(n) {
      return !(!n.url || !n.options);
    }
    const E2e = Qa(class {
        constructor(n) {
          this._elementRef = n;
        }
      }),
      T2e = new O("MAT_ICON_DEFAULT_OPTIONS"),
      I2e = new O("mat-icon-location", {
        providedIn: "root",
        factory: function R2e() {
          const n = La(ie),
            t = n ? n.location : null;
          return {
            getPathname: () => t ? t.pathname + t.search : ""
          };
        }
      }),
      AM = ["clip-path", "color-profile", "src", "cursor", "fill", "filter", "marker", "marker-start", "marker-mid", "marker-end", "mask", "stroke"],
      z2e = AM.map(n => `[${n}]`).join(", "),
      L2e = /^url\(['"]?#(.*?)['"]?\)$/;
    let ao = (() => {
        class n extends E2e {
          constructor(e, a, i, o, r, s) {
            super(e), this._iconRegistry = a, this._location = o, this._errorHandler = r, this._inline = !1, this._previousFontSetClass = [], this._currentIconFetch = re.EMPTY, s && (s.color && (this.color = this.defaultColor = s.color), s.fontSet && (this.fontSet = s.fontSet)), i || e.nativeElement.setAttribute("aria-hidden", "true");
          }
          get inline() {
            return this._inline;
          }
          set inline(e) {
            this._inline = Y(e);
          }
          get svgIcon() {
            return this._svgIcon;
          }
          set svgIcon(e) {
            e !== this._svgIcon && (e ? this._updateSvgIcon(e) : this._svgIcon && this._clearSvgElement(), this._svgIcon = e);
          }
          get fontSet() {
            return this._fontSet;
          }
          set fontSet(e) {
            const a = this._cleanupFontValue(e);
            a !== this._fontSet && (this._fontSet = a, this._updateFontIconClasses());
          }
          get fontIcon() {
            return this._fontIcon;
          }
          set fontIcon(e) {
            const a = this._cleanupFontValue(e);
            a !== this._fontIcon && (this._fontIcon = a, this._updateFontIconClasses());
          }
          _splitIconName(e) {
            if (!e) return ["", ""];
            const a = e.split(":");
            switch (a.length) {
              case 1:
                return ["", a[0]];
              case 2:
                return a;
              default:
                throw Error(`Invalid icon name: "${e}"`);
            }
          }
          ngOnInit() {
            this._updateFontIconClasses();
          }
          ngAfterViewChecked() {
            const e = this._elementsWithExternalReferences;
            if (e && e.size) {
              const a = this._location.getPathname();
              a !== this._previousPath && (this._previousPath = a, this._prependPathToReferences(a));
            }
          }
          ngOnDestroy() {
            this._currentIconFetch.unsubscribe(), this._elementsWithExternalReferences && this._elementsWithExternalReferences.clear();
          }
          _usingFontIcon() {
            return !this.svgIcon;
          }
          _setSvgElement(e) {
            this._clearSvgElement();
            const a = this._location.getPathname();
            this._previousPath = a, this._cacheChildrenWithExternalReferences(e), this._prependPathToReferences(a), this._elementRef.nativeElement.appendChild(e);
          }
          _clearSvgElement() {
            const e = this._elementRef.nativeElement;
            let a = e.childNodes.length;
            for (this._elementsWithExternalReferences && this._elementsWithExternalReferences.clear(); a--;) {
              const i = e.childNodes[a];
              (1 !== i.nodeType || "svg" === i.nodeName.toLowerCase()) && i.remove();
            }
          }
          _updateFontIconClasses() {
            if (!this._usingFontIcon()) return;
            const e = this._elementRef.nativeElement,
              a = (this.fontSet ? this._iconRegistry.classNameForFontAlias(this.fontSet).split(/ +/) : this._iconRegistry.getDefaultFontSetClass()).filter(i => i.length > 0);
            this._previousFontSetClass.forEach(i => e.classList.remove(i)), a.forEach(i => e.classList.add(i)), this._previousFontSetClass = a, this.fontIcon !== this._previousFontIconClass && !a.includes("mat-ligature-font") && (this._previousFontIconClass && e.classList.remove(this._previousFontIconClass), this.fontIcon && e.classList.add(this.fontIcon), this._previousFontIconClass = this.fontIcon);
          }
          _cleanupFontValue(e) {
            return "string" == typeof e ? e.trim().split(" ")[0] : e;
          }
          _prependPathToReferences(e) {
            const a = this._elementsWithExternalReferences;
            a && a.forEach((i, o) => {
              i.forEach(r => {
                o.setAttribute(r.name, `url('${e}#${r.value}')`);
              });
            });
          }
          _cacheChildrenWithExternalReferences(e) {
            const a = e.querySelectorAll(z2e),
              i = this._elementsWithExternalReferences = this._elementsWithExternalReferences || new Map();
            for (let o = 0; o < a.length; o++) AM.forEach(r => {
              const s = a[o],
                c = s.getAttribute(r),
                l = c ? c.match(L2e) : null;
              if (l) {
                let d = i.get(s);
                d || (d = [], i.set(s, d)), d.push({
                  name: r,
                  value: l[1]
                });
              }
            });
          }
          _updateSvgIcon(e) {
            if (this._svgNamespace = null, this._svgName = null, this._currentIconFetch.unsubscribe(), e) {
              const [a, i] = this._splitIconName(e);
              a && (this._svgNamespace = a), i && (this._svgName = i), this._currentIconFetch = this._iconRegistry.getNamedSvgIcon(i, a).pipe($e(1)).subscribe(o => this._setSvgElement(o), o => {
                this._errorHandler.handleError(new Error(`Error retrieving icon ${a}:${i}! ${o.message}`));
              });
            }
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(q2), qt("aria-hidden"), f(I2e), f(si), f(T2e, 8));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-icon"]],
          hostAttrs: ["role", "img", 1, "mat-icon", "notranslate"],
          hostVars: 7,
          hostBindings: function (e, a) {
            2 & e && (X("data-mat-icon-type", a._usingFontIcon() ? "font" : "svg")("data-mat-icon-name", a._svgName || a.fontIcon)("data-mat-icon-namespace", a._svgNamespace || a.fontSet), fe("mat-icon-inline", a.inline)("mat-icon-no-color", "primary" !== a.color && "accent" !== a.color && "warn" !== a.color));
          },
          inputs: {
            color: "color",
            inline: "inline",
            svgIcon: "svgIcon",
            fontSet: "fontSet",
            fontIcon: "fontIcon"
          },
          exportAs: ["matIcon"],
          features: [z],
          ngContentSelectors: D2e,
          decls: 1,
          vars: 0,
          template: function (e, a) {
            1 & e && (lt(), Me(0));
          },
          styles: [".mat-icon{-webkit-user-select:none;user-select:none;background-repeat:no-repeat;display:inline-block;fill:currentColor;height:24px;width:24px;overflow:hidden}.mat-icon.mat-icon-inline{font-size:inherit;height:inherit;line-height:inherit;width:inherit}.mat-icon.mat-ligature-font[fontIcon]::before{content:attr(fontIcon)}[dir=rtl] .mat-icon-rtl-mirror{transform:scale(-1, 1)}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon{display:block}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon-button .mat-icon,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon-button .mat-icon{margin:auto}"],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })(),
      Q2 = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [$, $]
        }), n;
      })();
    const N2e = ["tooltip"],
      SM = "tooltip-panel",
      EM = ka({
        passive: !0
      }),
      TM = new O("mat-tooltip-scroll-strategy"),
      B2e = {
        provide: TM,
        deps: [mn],
        useFactory: function H2e(n) {
          return () => n.scrollStrategies.reposition({
            scrollThrottle: 20
          });
        }
      },
      j2e = new O("mat-tooltip-default-options", {
        providedIn: "root",
        factory: function U2e() {
          return {
            showDelay: 0,
            hideDelay: 0,
            touchendHideDelay: 1500
          };
        }
      });
    let G2e = (() => {
        class n {
          constructor(e, a, i, o, r, s, c, l, d, u, m, h) {
            this._overlay = e, this._elementRef = a, this._scrollDispatcher = i, this._viewContainerRef = o, this._ngZone = r, this._platform = s, this._ariaDescriber = c, this._focusMonitor = l, this._dir = u, this._defaultOptions = m, this._position = "below", this._disabled = !1, this._viewInitialized = !1, this._pointerExitEventsInitialized = !1, this._viewportMargin = 8, this._cssClassPrefix = "mat", this._showDelay = this._defaultOptions.showDelay, this._hideDelay = this._defaultOptions.hideDelay, this.touchGestures = "auto", this._message = "", this._passiveListeners = [], this._destroyed = new V(), this._scrollStrategy = d, this._document = h, m && (m.position && (this.position = m.position), m.touchGestures && (this.touchGestures = m.touchGestures)), u.change.pipe(ne(this._destroyed)).subscribe(() => {
              this._overlayRef && this._updatePosition(this._overlayRef);
            });
          }
          get position() {
            return this._position;
          }
          set position(e) {
            e !== this._position && (this._position = e, this._overlayRef && (this._updatePosition(this._overlayRef), this._tooltipInstance?.show(0), this._overlayRef.updatePosition()));
          }
          get disabled() {
            return this._disabled;
          }
          set disabled(e) {
            this._disabled = Y(e), this._disabled ? this.hide(0) : this._setupPointerEnterEventsIfNeeded();
          }
          get showDelay() {
            return this._showDelay;
          }
          set showDelay(e) {
            this._showDelay = xt(e);
          }
          get hideDelay() {
            return this._hideDelay;
          }
          set hideDelay(e) {
            this._hideDelay = xt(e), this._tooltipInstance && (this._tooltipInstance._mouseLeaveHideDelay = this._hideDelay);
          }
          get message() {
            return this._message;
          }
          set message(e) {
            this._ariaDescriber.removeDescription(this._elementRef.nativeElement, this._message, "tooltip"), this._message = null != e ? String(e).trim() : "", !this._message && this._isTooltipVisible() ? this.hide(0) : (this._setupPointerEnterEventsIfNeeded(), this._updateTooltipMessage(), this._ngZone.runOutsideAngular(() => {
              Promise.resolve().then(() => {
                this._ariaDescriber.describe(this._elementRef.nativeElement, this.message, "tooltip");
              });
            }));
          }
          get tooltipClass() {
            return this._tooltipClass;
          }
          set tooltipClass(e) {
            this._tooltipClass = e, this._tooltipInstance && this._setTooltipClass(this._tooltipClass);
          }
          ngAfterViewInit() {
            this._viewInitialized = !0, this._setupPointerEnterEventsIfNeeded(), this._focusMonitor.monitor(this._elementRef).pipe(ne(this._destroyed)).subscribe(e => {
              e ? "keyboard" === e && this._ngZone.run(() => this.show()) : this._ngZone.run(() => this.hide(0));
            });
          }
          ngOnDestroy() {
            const e = this._elementRef.nativeElement;
            clearTimeout(this._touchstartTimeout), this._overlayRef && (this._overlayRef.dispose(), this._tooltipInstance = null), this._passiveListeners.forEach(([a, i]) => {
              e.removeEventListener(a, i, EM);
            }), this._passiveListeners.length = 0, this._destroyed.next(), this._destroyed.complete(), this._ariaDescriber.removeDescription(e, this.message, "tooltip"), this._focusMonitor.stopMonitoring(e);
          }
          show(e = this.showDelay) {
            if (this.disabled || !this.message || this._isTooltipVisible()) return void this._tooltipInstance?._cancelPendingHide();
            const a = this._createOverlay();
            this._detach(), this._portal = this._portal || new $r(this._tooltipComponent, this._viewContainerRef);
            const i = this._tooltipInstance = a.attach(this._portal).instance;
            i._triggerElement = this._elementRef.nativeElement, i._mouseLeaveHideDelay = this._hideDelay, i.afterHidden().pipe(ne(this._destroyed)).subscribe(() => this._detach()), this._setTooltipClass(this._tooltipClass), this._updateTooltipMessage(), i.show(e);
          }
          hide(e = this.hideDelay) {
            const a = this._tooltipInstance;
            a && (a.isVisible() ? a.hide(e) : this._detach());
          }
          toggle() {
            this._isTooltipVisible() ? this.hide() : this.show();
          }
          _isTooltipVisible() {
            return !!this._tooltipInstance && this._tooltipInstance.isVisible();
          }
          _createOverlay() {
            if (this._overlayRef) return this._overlayRef;
            const e = this._scrollDispatcher.getAncestorScrollContainers(this._elementRef),
              a = this._overlay.position().flexibleConnectedTo(this._elementRef).withTransformOriginOn(`.${this._cssClassPrefix}-tooltip`).withFlexibleDimensions(!1).withViewportMargin(this._viewportMargin).withScrollableContainers(e);
            return a.positionChanges.pipe(ne(this._destroyed)).subscribe(i => {
              this._updateCurrentPositionClass(i.connectionPair), this._tooltipInstance && i.scrollableViewProperties.isOverlayClipped && this._tooltipInstance.isVisible() && this._ngZone.run(() => this.hide(0));
            }), this._overlayRef = this._overlay.create({
              direction: this._dir,
              positionStrategy: a,
              panelClass: `${this._cssClassPrefix}-${SM}`,
              scrollStrategy: this._scrollStrategy()
            }), this._updatePosition(this._overlayRef), this._overlayRef.detachments().pipe(ne(this._destroyed)).subscribe(() => this._detach()), this._overlayRef.outsidePointerEvents().pipe(ne(this._destroyed)).subscribe(() => this._tooltipInstance?._handleBodyInteraction()), this._overlayRef.keydownEvents().pipe(ne(this._destroyed)).subscribe(i => {
              this._isTooltipVisible() && 27 === i.keyCode && !Et(i) && (i.preventDefault(), i.stopPropagation(), this._ngZone.run(() => this.hide(0)));
            }), this._defaultOptions?.disableTooltipInteractivity && this._overlayRef.addPanelClass(`${this._cssClassPrefix}-tooltip-panel-non-interactive`), this._overlayRef;
          }
          _detach() {
            this._overlayRef && this._overlayRef.hasAttached() && this._overlayRef.detach(), this._tooltipInstance = null;
          }
          _updatePosition(e) {
            const a = e.getConfig().positionStrategy,
              i = this._getOrigin(),
              o = this._getOverlayPosition();
            a.withPositions([this._addOffset({
              ...i.main,
              ...o.main
            }), this._addOffset({
              ...i.fallback,
              ...o.fallback
            })]);
          }
          _addOffset(e) {
            return e;
          }
          _getOrigin() {
            const e = !this._dir || "ltr" == this._dir.value,
              a = this.position;
            let i;
            "above" == a || "below" == a ? i = {
              originX: "center",
              originY: "above" == a ? "top" : "bottom"
            } : "before" == a || "left" == a && e || "right" == a && !e ? i = {
              originX: "start",
              originY: "center"
            } : ("after" == a || "right" == a && e || "left" == a && !e) && (i = {
              originX: "end",
              originY: "center"
            });
            const {
              x: o,
              y: r
            } = this._invertPosition(i.originX, i.originY);
            return {
              main: i,
              fallback: {
                originX: o,
                originY: r
              }
            };
          }
          _getOverlayPosition() {
            const e = !this._dir || "ltr" == this._dir.value,
              a = this.position;
            let i;
            "above" == a ? i = {
              overlayX: "center",
              overlayY: "bottom"
            } : "below" == a ? i = {
              overlayX: "center",
              overlayY: "top"
            } : "before" == a || "left" == a && e || "right" == a && !e ? i = {
              overlayX: "end",
              overlayY: "center"
            } : ("after" == a || "right" == a && e || "left" == a && !e) && (i = {
              overlayX: "start",
              overlayY: "center"
            });
            const {
              x: o,
              y: r
            } = this._invertPosition(i.overlayX, i.overlayY);
            return {
              main: i,
              fallback: {
                overlayX: o,
                overlayY: r
              }
            };
          }
          _updateTooltipMessage() {
            this._tooltipInstance && (this._tooltipInstance.message = this.message, this._tooltipInstance._markForCheck(), this._ngZone.onMicrotaskEmpty.pipe($e(1), ne(this._destroyed)).subscribe(() => {
              this._tooltipInstance && this._overlayRef.updatePosition();
            }));
          }
          _setTooltipClass(e) {
            this._tooltipInstance && (this._tooltipInstance.tooltipClass = e, this._tooltipInstance._markForCheck());
          }
          _invertPosition(e, a) {
            return "above" === this.position || "below" === this.position ? "top" === a ? a = "bottom" : "bottom" === a && (a = "top") : "end" === e ? e = "start" : "start" === e && (e = "end"), {
              x: e,
              y: a
            };
          }
          _updateCurrentPositionClass(e) {
            const {
              overlayY: a,
              originX: i,
              originY: o
            } = e;
            let r;
            if (r = "center" === a ? this._dir && "rtl" === this._dir.value ? "end" === i ? "left" : "right" : "start" === i ? "left" : "right" : "bottom" === a && "top" === o ? "above" : "below", r !== this._currentPosition) {
              const s = this._overlayRef;
              if (s) {
                const c = `${this._cssClassPrefix}-${SM}-`;
                s.removePanelClass(c + this._currentPosition), s.addPanelClass(c + r);
              }
              this._currentPosition = r;
            }
          }
          _setupPointerEnterEventsIfNeeded() {
            this._disabled || !this.message || !this._viewInitialized || this._passiveListeners.length || (this._platformSupportsMouseEvents() ? this._passiveListeners.push(["mouseenter", () => {
              this._setupPointerExitEventsIfNeeded(), this.show();
            }]) : "off" !== this.touchGestures && (this._disableNativeGesturesIfNecessary(), this._passiveListeners.push(["touchstart", () => {
              this._setupPointerExitEventsIfNeeded(), clearTimeout(this._touchstartTimeout), this._touchstartTimeout = setTimeout(() => this.show(), 500);
            }])), this._addListeners(this._passiveListeners));
          }
          _setupPointerExitEventsIfNeeded() {
            if (this._pointerExitEventsInitialized) return;
            this._pointerExitEventsInitialized = !0;
            const e = [];
            if (this._platformSupportsMouseEvents()) e.push(["mouseleave", a => {
              const i = a.relatedTarget;
              (!i || !this._overlayRef?.overlayElement.contains(i)) && this.hide();
            }], ["wheel", a => this._wheelListener(a)]);else if ("off" !== this.touchGestures) {
              this._disableNativeGesturesIfNecessary();
              const a = () => {
                clearTimeout(this._touchstartTimeout), this.hide(this._defaultOptions.touchendHideDelay);
              };
              e.push(["touchend", a], ["touchcancel", a]);
            }
            this._addListeners(e), this._passiveListeners.push(...e);
          }
          _addListeners(e) {
            e.forEach(([a, i]) => {
              this._elementRef.nativeElement.addEventListener(a, i, EM);
            });
          }
          _platformSupportsMouseEvents() {
            return !this._platform.IOS && !this._platform.ANDROID;
          }
          _wheelListener(e) {
            if (this._isTooltipVisible()) {
              const a = this._document.elementFromPoint(e.clientX, e.clientY),
                i = this._elementRef.nativeElement;
              a !== i && !i.contains(a) && this.hide();
            }
          }
          _disableNativeGesturesIfNecessary() {
            const e = this.touchGestures;
            if ("off" !== e) {
              const a = this._elementRef.nativeElement,
                i = a.style;
              ("on" === e || "INPUT" !== a.nodeName && "TEXTAREA" !== a.nodeName) && (i.userSelect = i.msUserSelect = i.webkitUserSelect = i.MozUserSelect = "none"), ("on" === e || !a.draggable) && (i.webkitUserDrag = "none"), i.touchAction = "none", i.webkitTapHighlightColor = "transparent";
            }
          }
        }
        return n.ɵfac = function (e) {
          li();
        }, n.ɵdir = P({
          type: n,
          inputs: {
            position: ["matTooltipPosition", "position"],
            disabled: ["matTooltipDisabled", "disabled"],
            showDelay: ["matTooltipShowDelay", "showDelay"],
            hideDelay: ["matTooltipHideDelay", "hideDelay"],
            touchGestures: ["matTooltipTouchGestures", "touchGestures"],
            message: ["matTooltip", "message"],
            tooltipClass: ["matTooltipClass", "tooltipClass"]
          }
        }), n;
      })(),
      ys = (() => {
        class n extends G2e {
          constructor(e, a, i, o, r, s, c, l, d, u, m, h) {
            super(e, a, i, o, r, s, c, l, d, u, m, h), this._tooltipComponent = Y2e;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(mn), f(J), f(c_), f(ut), f(ae), f(Ct), f(FH), f(Hn), f(TM), f(nn, 8), f(j2e, 8), f(ie));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "matTooltip", ""]],
          hostAttrs: [1, "mat-tooltip-trigger"],
          exportAs: ["matTooltip"],
          features: [z]
        }), n;
      })(),
      W2e = (() => {
        class n {
          constructor(e, a) {
            this._changeDetectorRef = e, this._closeOnInteraction = !1, this._isVisible = !1, this._onHide = new V(), this._animationsDisabled = "NoopAnimations" === a;
          }
          show(e) {
            clearTimeout(this._hideTimeoutId), this._showTimeoutId = setTimeout(() => {
              this._toggleVisibility(!0), this._showTimeoutId = void 0;
            }, e);
          }
          hide(e) {
            clearTimeout(this._showTimeoutId), this._hideTimeoutId = setTimeout(() => {
              this._toggleVisibility(!1), this._hideTimeoutId = void 0;
            }, e);
          }
          afterHidden() {
            return this._onHide;
          }
          isVisible() {
            return this._isVisible;
          }
          ngOnDestroy() {
            clearTimeout(this._showTimeoutId), clearTimeout(this._hideTimeoutId), this._onHide.complete(), this._triggerElement = null;
          }
          _handleBodyInteraction() {
            this._closeOnInteraction && this.hide(0);
          }
          _markForCheck() {
            this._changeDetectorRef.markForCheck();
          }
          _handleMouseLeave({
            relatedTarget: e
          }) {
            (!e || !this._triggerElement.contains(e)) && this.hide(this._mouseLeaveHideDelay);
          }
          _onShow() {}
          _handleAnimationEnd({
            animationName: e
          }) {
            (e === this._showAnimation || e === this._hideAnimation) && this._finalizeAnimation(e === this._showAnimation);
          }
          _cancelPendingHide() {
            clearTimeout(this._hideTimeoutId), this._hideTimeoutId = void 0;
          }
          _finalizeAnimation(e) {
            e ? this._closeOnInteraction = !0 : this.isVisible() || this._onHide.next();
          }
          _toggleVisibility(e) {
            const a = this._tooltip.nativeElement,
              i = this._showAnimation,
              o = this._hideAnimation;
            if (a.classList.remove(e ? o : i), a.classList.add(e ? i : o), this._isVisible = e, e && !this._animationsDisabled && "function" == typeof getComputedStyle) {
              const r = getComputedStyle(a);
              ("0s" === r.getPropertyValue("animation-duration") || "none" === r.getPropertyValue("animation-name")) && (this._animationsDisabled = !0);
            }
            e && this._onShow(), this._animationsDisabled && (a.classList.add("_mat-animation-noopable"), this._finalizeAnimation(e));
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Se), f(Ft, 8));
        }, n.ɵdir = P({
          type: n
        }), n;
      })(),
      Y2e = (() => {
        class n extends W2e {
          constructor(e, a, i) {
            super(e, i), this._breakpointObserver = a, this._isHandset = this._breakpointObserver.observe("(max-width: 599.98px) and (orientation: portrait), (max-width: 959.98px) and (orientation: landscape)"), this._showAnimation = "mat-tooltip-show", this._hideAnimation = "mat-tooltip-hide";
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Se), f(Vv), f(Ft, 8));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-tooltip-component"]],
          viewQuery: function (e, a) {
            if (1 & e && be(N2e, 7), 2 & e) {
              let i;
              H(i = B()) && (a._tooltip = i.first);
            }
          },
          hostAttrs: ["aria-hidden", "true"],
          hostVars: 2,
          hostBindings: function (e, a) {
            1 & e && F("mouseleave", function (o) {
              return a._handleMouseLeave(o);
            }), 2 & e && en("zoom", a.isVisible() ? 1 : null);
          },
          features: [z],
          decls: 4,
          vars: 6,
          consts: [[1, "mat-tooltip", 3, "ngClass", "animationend"], ["tooltip", ""]],
          template: function (e, a) {
            if (1 & e && (_(0, "div", 0, 1), F("animationend", function (o) {
              return a._handleAnimationEnd(o);
            }), Dt(2, "async"), S(3), y()), 2 & e) {
              let i;
              fe("mat-tooltip-handset", null == (i = Ot(2, 4, a._isHandset)) ? null : i.matches), b("ngClass", a.tooltipClass), g(3), Ie(a.message);
            }
          },
          dependencies: [ko, md],
          styles: [".mat-tooltip{color:#fff;border-radius:4px;margin:14px;max-width:250px;padding-left:8px;padding-right:8px;overflow:hidden;text-overflow:ellipsis;transform:scale(0)}.mat-tooltip._mat-animation-noopable{animation:none;transform:scale(1)}.cdk-high-contrast-active .mat-tooltip{outline:solid 1px}.mat-tooltip-handset{margin:24px;padding-left:16px;padding-right:16px}.mat-tooltip-panel-non-interactive{pointer-events:none}@keyframes mat-tooltip-show{0%{opacity:0;transform:scale(0)}50%{opacity:.5;transform:scale(0.99)}100%{opacity:1;transform:scale(1)}}@keyframes mat-tooltip-hide{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(1)}}.mat-tooltip-show{animation:mat-tooltip-show 200ms cubic-bezier(0, 0, 0.2, 1) forwards}.mat-tooltip-hide{animation:mat-tooltip-hide 100ms cubic-bezier(0, 0, 0.2, 1) forwards}"],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })(),
      Z2 = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [B2e],
          imports: [Xc, yt, qa, $, $, Wa]
        }), n;
      })();
    const q2e = ["*"],
      Z2e = n => {
        const t = {
          "fa-spin": n.spin,
          "fa-pulse": n.pulse,
          "fa-fw": n.fixedWidth,
          "fa-border": n.border,
          "fa-inverse": n.inverse,
          "fa-layers-counter": n.counter,
          "fa-flip-horizontal": "horizontal" === n.flip || "both" === n.flip,
          "fa-flip-vertical": "vertical" === n.flip || "both" === n.flip,
          [`fa-${n.size}`]: null !== n.size,
          [`fa-rotate-${n.rotate}`]: null !== n.rotate,
          [`fa-pull-${n.pull}`]: null !== n.pull,
          [`fa-stack-${n.stackItemSize}`]: null != n.stackItemSize
        };
        return Object.keys(t).map(e => t[e] ? e : null).filter(e => e);
      };
    let $2e = (() => {
        class n {
          constructor() {
            this.defaultPrefix = "fas", this.fallbackIcon = null;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      e0e = (() => {
        class n {
          constructor() {
            this.definitions = {};
          }
          addIcons(...e) {
            for (const a of e) {
              a.prefix in this.definitions || (this.definitions[a.prefix] = {}), this.definitions[a.prefix][a.iconName] = a;
              for (const i of a.icon[2]) "string" == typeof i && (this.definitions[a.prefix][i] = a);
            }
          }
          addIconPacks(...e) {
            for (const a of e) {
              const i = Object.keys(a).map(o => a[o]);
              this.addIcons(...i);
            }
          }
          getIconDefinition(e, a) {
            return e in this.definitions && a in this.definitions[e] ? this.definitions[e][a] : null;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      t0e = (() => {
        class n {
          constructor() {
            this.stackItemSize = "1x";
          }
          ngOnChanges(e) {
            if ("size" in e) throw new Error('fa-icon is not allowed to customize size when used inside fa-stack. Set size on the enclosing fa-stack instead: <fa-stack size="4x">...</fa-stack>.');
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n,
          selectors: [["fa-icon", "stackItemSize", ""], ["fa-duotone-icon", "stackItemSize", ""]],
          inputs: {
            stackItemSize: "stackItemSize",
            size: "size"
          },
          features: [Ve]
        }), n;
      })(),
      n0e = (() => {
        class n {
          constructor(e, a) {
            this.renderer = e, this.elementRef = a;
          }
          ngOnInit() {
            this.renderer.addClass(this.elementRef.nativeElement, "fa-stack");
          }
          ngOnChanges(e) {
            "size" in e && (null != e.size.currentValue && this.renderer.addClass(this.elementRef.nativeElement, `fa-${e.size.currentValue}`), null != e.size.previousValue && this.renderer.removeClass(this.elementRef.nativeElement, `fa-${e.size.previousValue}`));
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Hi), f(J));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["fa-stack"]],
          inputs: {
            size: "size"
          },
          features: [Ve],
          ngContentSelectors: q2e,
          decls: 1,
          vars: 0,
          template: function (e, a) {
            1 & e && (lt(), Me(0));
          },
          encapsulation: 2
        }), n;
      })(),
      a0e = (() => {
        class n {
          constructor(e, a, i, o, r) {
            this.sanitizer = e, this.config = a, this.iconLibrary = i, this.stackItem = o, this.classes = [], null != r && null == o && console.error('FontAwesome: fa-icon and fa-duotone-icon elements must specify stackItemSize attribute when wrapped into fa-stack. Example: <fa-icon stackItemSize="2x"></fa-icon>.');
          }
          ngOnChanges(e) {
            if (null == this.icon && null == this.config.fallbackIcon) return (() => {
              throw new Error("Property `icon` is required for `fa-icon`/`fa-duotone-icon` components.");
            })();
            let a = null;
            if (a = this.icon ?? this.config.fallbackIcon, e) {
              const i = this.findIconDefinition(a);
              if (null != i) {
                const o = this.buildParams();
                this.renderIcon(i, o);
              }
            }
          }
          render() {
            this.ngOnChanges({});
          }
          findIconDefinition(e) {
            const a = ((n, t) => (n => void 0 !== n.prefix && void 0 !== n.iconName)(n) ? n : Array.isArray(n) && 2 === n.length ? {
              prefix: n[0],
              iconName: n[1]
            } : "string" == typeof n ? {
              prefix: t,
              iconName: n
            } : void 0)(e, this.config.defaultPrefix);
            return "icon" in a ? a : this.iconLibrary.getIconDefinition(a.prefix, a.iconName) ?? ((n => {
              throw new Error(`Could not find icon with iconName=${n.iconName} and prefix=${n.prefix} in the icon library.`);
            })(a), null);
          }
          buildParams() {
            const e = {
                flip: this.flip,
                spin: this.spin,
                pulse: this.pulse,
                border: this.border,
                inverse: this.inverse,
                size: this.size || null,
                pull: this.pull || null,
                rotate: this.rotate || null,
                fixedWidth: "boolean" == typeof this.fixedWidth ? this.fixedWidth : this.config.fixedWidth,
                stackItemSize: null != this.stackItem ? this.stackItem.stackItemSize : null
              },
              a = "string" == typeof this.transform ? dM_transform(this.transform) : this.transform;
            return {
              title: this.title,
              transform: a,
              classes: [...Z2e(e), ...this.classes],
              mask: null != this.mask ? this.findIconDefinition(this.mask) : null,
              styles: null != this.styles ? this.styles : {},
              symbol: this.symbol,
              attributes: {
                role: this.a11yRole
              }
            };
          }
          renderIcon(e, a) {
            const i = uM(e, a);
            this.renderedIconHTML = this.sanitizer.bypassSecurityTrustHtml(i.html.join("\n"));
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Cd), f($2e), f(e0e), f(t0e, 8), f(n0e, 8));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["fa-icon"]],
          hostAttrs: [1, "ng-fa-icon"],
          hostVars: 2,
          hostBindings: function (e, a) {
            2 & e && (Zn("innerHTML", a.renderedIconHTML, Vu), X("title", a.title));
          },
          inputs: {
            icon: "icon",
            title: "title",
            spin: "spin",
            pulse: "pulse",
            mask: "mask",
            styles: "styles",
            flip: "flip",
            size: "size",
            pull: "pull",
            border: "border",
            inverse: "inverse",
            symbol: "symbol",
            rotate: "rotate",
            fixedWidth: "fixedWidth",
            classes: "classes",
            transform: "transform",
            a11yRole: "a11yRole"
          },
          features: [Ve],
          decls: 0,
          vars: 0,
          template: function (e, a) {},
          encapsulation: 2
        }), n;
      })(),
      i0e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({}), n;
      })();
    const o0e = ["connectionContainer"],
      r0e = ["inputContainer"],
      s0e = ["label"];
    function c0e(n, t) {
      1 & n && (fi(0), _(1, "div", 14), j(2, "div", 15)(3, "div", 16)(4, "div", 17), y(), _(5, "div", 18), j(6, "div", 15)(7, "div", 16)(8, "div", 17), y(), mi());
    }
    function l0e(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "div", 19), F("cdkObserveContent", function () {
          return pe(e), ge(x().updateOutlineGap());
        }), Me(1, 1), y();
      }
      2 & n && b("cdkObserveContentDisabled", "outline" != x().appearance);
    }
    function d0e(n, t) {
      if (1 & n && (fi(0), Me(1, 2), _(2, "span"), S(3), y(), mi()), 2 & n) {
        const e = x(2);
        g(3), Ie(e._control.placeholder);
      }
    }
    function u0e(n, t) {
      1 & n && Me(0, 3, ["*ngSwitchCase", "true"]);
    }
    function f0e(n, t) {
      1 & n && (_(0, "span", 23), S(1, " *"), y());
    }
    function m0e(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "label", 20, 21), F("cdkObserveContent", function () {
          return pe(e), ge(x().updateOutlineGap());
        }), D(2, d0e, 4, 1, "ng-container", 12), D(3, u0e, 1, 0, "ng-content", 12), D(4, f0e, 2, 0, "span", 22), y();
      }
      if (2 & n) {
        const e = x();
        fe("mat-empty", e._control.empty && !e._shouldAlwaysFloat())("mat-form-field-empty", e._control.empty && !e._shouldAlwaysFloat())("mat-accent", "accent" == e.color)("mat-warn", "warn" == e.color), b("cdkObserveContentDisabled", "outline" != e.appearance)("id", e._labelId)("ngSwitch", e._hasLabel()), X("for", e._control.id)("aria-owns", e._control.id), g(2), b("ngSwitchCase", !1), g(1), b("ngSwitchCase", !0), g(1), b("ngIf", !e.hideRequiredMarker && e._control.required && !e._control.disabled);
      }
    }
    function h0e(n, t) {
      1 & n && (_(0, "div", 24), Me(1, 4), y());
    }
    function p0e(n, t) {
      if (1 & n && (_(0, "div", 25), j(1, "span", 26), y()), 2 & n) {
        const e = x();
        g(1), fe("mat-accent", "accent" == e.color)("mat-warn", "warn" == e.color);
      }
    }
    function g0e(n, t) {
      1 & n && (_(0, "div"), Me(1, 5), y()), 2 & n && b("@transitionMessages", x()._subscriptAnimationState);
    }
    function b0e(n, t) {
      if (1 & n && (_(0, "div", 30), S(1), y()), 2 & n) {
        const e = x(2);
        b("id", e._hintLabelId), g(1), Ie(e.hintLabel);
      }
    }
    function _0e(n, t) {
      if (1 & n && (_(0, "div", 27), D(1, b0e, 2, 2, "div", 28), Me(2, 6), j(3, "div", 29), Me(4, 7), y()), 2 & n) {
        const e = x();
        b("@transitionMessages", e._subscriptAnimationState), g(1), b("ngIf", e.hintLabel);
      }
    }
    const v0e = ["*", [["", "matPrefix", ""]], [["mat-placeholder"]], [["mat-label"]], [["", "matSuffix", ""]], [["mat-error"]], [["mat-hint", 3, "align", "end"]], [["mat-hint", "align", "end"]]],
      y0e = ["*", "[matPrefix]", "mat-placeholder", "mat-label", "[matSuffix]", "mat-error", "mat-hint:not([align='end'])", "mat-hint[align='end']"];
    let C0e = 0;
    const IM = new O("MatError");
    let x4 = (() => {
      class n {
        constructor(e, a) {
          this.id = "mat-error-" + C0e++, e || a.nativeElement.setAttribute("aria-live", "polite");
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(qt("aria-live"), f(J));
      }, n.ɵdir = P({
        type: n,
        selectors: [["mat-error"]],
        hostAttrs: ["aria-atomic", "true", 1, "mat-error"],
        hostVars: 1,
        hostBindings: function (e, a) {
          2 & e && X("id", a.id);
        },
        inputs: {
          id: "id"
        },
        features: [G([{
          provide: IM,
          useExisting: n
        }])]
      }), n;
    })();
    const M0e = {
      transitionMessages: ht("transitionMessages", [xe("enter", Z({
        opacity: 1,
        transform: "translateY(0%)"
      })), Ee("void => enter", [Z({
        opacity: 0,
        transform: "translateY(-5px)"
      }), Re("300ms cubic-bezier(0.55, 0, 0.55, 0.2)")])])
    };
    let bl = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n
        }), n;
      })(),
      x0e = 0;
    const RM = new O("MatHint");
    let Cs = (() => {
        class n {
          constructor() {
            this.align = "start", this.id = "mat-hint-" + x0e++;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n,
          selectors: [["mat-hint"]],
          hostAttrs: [1, "mat-hint"],
          hostVars: 4,
          hostBindings: function (e, a) {
            2 & e && (X("id", a.id)("align", null), fe("mat-form-field-hint-end", "end" === a.align));
          },
          inputs: {
            align: "align",
            id: "id"
          },
          features: [G([{
            provide: RM,
            useExisting: n
          }])]
        }), n;
      })(),
      zM = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n,
          selectors: [["mat-label"]]
        }), n;
      })(),
      w0e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n,
          selectors: [["mat-placeholder"]]
        }), n;
      })();
    const k0e = new O("MatPrefix"),
      LM = new O("MatSuffix");
    let D0e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "matSuffix", ""]],
          features: [G([{
            provide: LM,
            useExisting: n
          }])]
        }), n;
      })(),
      NM = 0;
    const P0e = Qa(class {
        constructor(n) {
          this._elementRef = n;
        }
      }, "primary"),
      VM = new O("MAT_FORM_FIELD_DEFAULT_OPTIONS"),
      _l = new O("MatFormField");
    let Si = (() => {
        class n extends P0e {
          constructor(e, a, i, o, r, s, c) {
            super(e), this._changeDetectorRef = a, this._dir = i, this._defaults = o, this._platform = r, this._ngZone = s, this._outlineGapCalculationNeededImmediately = !1, this._outlineGapCalculationNeededOnStable = !1, this._destroyed = new V(), this._hideRequiredMarker = !1, this._showAlwaysAnimate = !1, this._subscriptAnimationState = "", this._hintLabel = "", this._hintLabelId = "mat-hint-" + NM++, this._labelId = "mat-form-field-label-" + NM++, this.floatLabel = this._getDefaultFloatLabelState(), this._animationsEnabled = "NoopAnimations" !== c, this.appearance = o?.appearance || "legacy", o && (this._hideRequiredMarker = Boolean(o.hideRequiredMarker), o.color && (this.color = this.defaultColor = o.color));
          }
          get appearance() {
            return this._appearance;
          }
          set appearance(e) {
            const a = this._appearance;
            this._appearance = e || this._defaults?.appearance || "legacy", "outline" === this._appearance && a !== e && (this._outlineGapCalculationNeededOnStable = !0);
          }
          get hideRequiredMarker() {
            return this._hideRequiredMarker;
          }
          set hideRequiredMarker(e) {
            this._hideRequiredMarker = Y(e);
          }
          _shouldAlwaysFloat() {
            return "always" === this.floatLabel && !this._showAlwaysAnimate;
          }
          _canLabelFloat() {
            return "never" !== this.floatLabel;
          }
          get hintLabel() {
            return this._hintLabel;
          }
          set hintLabel(e) {
            this._hintLabel = e, this._processHints();
          }
          get floatLabel() {
            return "legacy" !== this.appearance && "never" === this._floatLabel ? "auto" : this._floatLabel;
          }
          set floatLabel(e) {
            e !== this._floatLabel && (this._floatLabel = e || this._getDefaultFloatLabelState(), this._changeDetectorRef.markForCheck());
          }
          get _control() {
            return this._explicitFormFieldControl || this._controlNonStatic || this._controlStatic;
          }
          set _control(e) {
            this._explicitFormFieldControl = e;
          }
          getLabelId() {
            return this._hasFloatingLabel() ? this._labelId : null;
          }
          getConnectedOverlayOrigin() {
            return this._connectionContainerRef || this._elementRef;
          }
          ngAfterContentInit() {
            this._validateControlChild();
            const e = this._control;
            e.controlType && this._elementRef.nativeElement.classList.add(`mat-form-field-type-${e.controlType}`), e.stateChanges.pipe(Gt(null)).subscribe(() => {
              this._validatePlaceholders(), this._syncDescribedByIds(), this._changeDetectorRef.markForCheck();
            }), e.ngControl && e.ngControl.valueChanges && e.ngControl.valueChanges.pipe(ne(this._destroyed)).subscribe(() => this._changeDetectorRef.markForCheck()), this._ngZone.runOutsideAngular(() => {
              this._ngZone.onStable.pipe(ne(this._destroyed)).subscribe(() => {
                this._outlineGapCalculationNeededOnStable && this.updateOutlineGap();
              });
            }), dt(this._prefixChildren.changes, this._suffixChildren.changes).subscribe(() => {
              this._outlineGapCalculationNeededOnStable = !0, this._changeDetectorRef.markForCheck();
            }), this._hintChildren.changes.pipe(Gt(null)).subscribe(() => {
              this._processHints(), this._changeDetectorRef.markForCheck();
            }), this._errorChildren.changes.pipe(Gt(null)).subscribe(() => {
              this._syncDescribedByIds(), this._changeDetectorRef.markForCheck();
            }), this._dir && this._dir.change.pipe(ne(this._destroyed)).subscribe(() => {
              "function" == typeof requestAnimationFrame ? this._ngZone.runOutsideAngular(() => {
                requestAnimationFrame(() => this.updateOutlineGap());
              }) : this.updateOutlineGap();
            });
          }
          ngAfterContentChecked() {
            this._validateControlChild(), this._outlineGapCalculationNeededImmediately && this.updateOutlineGap();
          }
          ngAfterViewInit() {
            this._subscriptAnimationState = "enter", this._changeDetectorRef.detectChanges();
          }
          ngOnDestroy() {
            this._destroyed.next(), this._destroyed.complete();
          }
          _shouldForward(e) {
            const a = this._control ? this._control.ngControl : null;
            return a && a[e];
          }
          _hasPlaceholder() {
            return !!(this._control && this._control.placeholder || this._placeholderChild);
          }
          _hasLabel() {
            return !(!this._labelChildNonStatic && !this._labelChildStatic);
          }
          _shouldLabelFloat() {
            return this._canLabelFloat() && (this._control && this._control.shouldLabelFloat || this._shouldAlwaysFloat());
          }
          _hideControlPlaceholder() {
            return "legacy" === this.appearance && !this._hasLabel() || this._hasLabel() && !this._shouldLabelFloat();
          }
          _hasFloatingLabel() {
            return this._hasLabel() || "legacy" === this.appearance && this._hasPlaceholder();
          }
          _getDisplayedMessages() {
            return this._errorChildren && this._errorChildren.length > 0 && this._control.errorState ? "error" : "hint";
          }
          _animateAndLockLabel() {
            this._hasFloatingLabel() && this._canLabelFloat() && (this._animationsEnabled && this._label && (this._showAlwaysAnimate = !0, Qr(this._label.nativeElement, "transitionend").pipe($e(1)).subscribe(() => {
              this._showAlwaysAnimate = !1;
            })), this.floatLabel = "always", this._changeDetectorRef.markForCheck());
          }
          _validatePlaceholders() {}
          _processHints() {
            this._validateHints(), this._syncDescribedByIds();
          }
          _validateHints() {}
          _getDefaultFloatLabelState() {
            return this._defaults && this._defaults.floatLabel || "auto";
          }
          _syncDescribedByIds() {
            if (this._control) {
              let e = [];
              if (this._control.userAriaDescribedBy && "string" == typeof this._control.userAriaDescribedBy && e.push(...this._control.userAriaDescribedBy.split(" ")), "hint" === this._getDisplayedMessages()) {
                const a = this._hintChildren ? this._hintChildren.find(o => "start" === o.align) : null,
                  i = this._hintChildren ? this._hintChildren.find(o => "end" === o.align) : null;
                a ? e.push(a.id) : this._hintLabel && e.push(this._hintLabelId), i && e.push(i.id);
              } else this._errorChildren && e.push(...this._errorChildren.map(a => a.id));
              this._control.setDescribedByIds(e);
            }
          }
          _validateControlChild() {}
          updateOutlineGap() {
            const e = this._label ? this._label.nativeElement : null,
              a = this._connectionContainerRef.nativeElement,
              i = ".mat-form-field-outline-start",
              o = ".mat-form-field-outline-gap";
            if ("outline" !== this.appearance || !this._platform.isBrowser) return;
            if (!e || !e.children.length || !e.textContent.trim()) {
              const d = a.querySelectorAll(`${i}, ${o}`);
              for (let u = 0; u < d.length; u++) d[u].style.width = "0";
              return;
            }
            if (!this._isAttachedToDOM()) return void (this._outlineGapCalculationNeededImmediately = !0);
            let r = 0,
              s = 0;
            const c = a.querySelectorAll(i),
              l = a.querySelectorAll(o);
            if (this._label && this._label.nativeElement.children.length) {
              const d = a.getBoundingClientRect();
              if (0 === d.width && 0 === d.height) return this._outlineGapCalculationNeededOnStable = !0, void (this._outlineGapCalculationNeededImmediately = !1);
              const u = this._getStartEnd(d),
                m = e.children,
                h = this._getStartEnd(m[0].getBoundingClientRect());
              let p = 0;
              for (let v = 0; v < m.length; v++) p += m[v].offsetWidth;
              r = Math.abs(h - u) - 5, s = p > 0 ? .75 * p + 10 : 0;
            }
            for (let d = 0; d < c.length; d++) c[d].style.width = `${r}px`;
            for (let d = 0; d < l.length; d++) l[d].style.width = `${s}px`;
            this._outlineGapCalculationNeededOnStable = this._outlineGapCalculationNeededImmediately = !1;
          }
          _getStartEnd(e) {
            return this._dir && "rtl" === this._dir.value ? e.right : e.left;
          }
          _isAttachedToDOM() {
            const e = this._elementRef.nativeElement;
            if (e.getRootNode) {
              const a = e.getRootNode();
              return a && a !== e;
            }
            return document.documentElement.contains(e);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(Se), f(nn, 8), f(VM, 8), f(Ct), f(ae), f(Ft, 8));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-form-field"]],
          contentQueries: function (e, a, i) {
            if (1 & e && (De(i, bl, 5), De(i, bl, 7), De(i, zM, 5), De(i, zM, 7), De(i, w0e, 5), De(i, IM, 5), De(i, RM, 5), De(i, k0e, 5), De(i, LM, 5)), 2 & e) {
              let o;
              H(o = B()) && (a._controlNonStatic = o.first), H(o = B()) && (a._controlStatic = o.first), H(o = B()) && (a._labelChildNonStatic = o.first), H(o = B()) && (a._labelChildStatic = o.first), H(o = B()) && (a._placeholderChild = o.first), H(o = B()) && (a._errorChildren = o), H(o = B()) && (a._hintChildren = o), H(o = B()) && (a._prefixChildren = o), H(o = B()) && (a._suffixChildren = o);
            }
          },
          viewQuery: function (e, a) {
            if (1 & e && (be(o0e, 7), be(r0e, 5), be(s0e, 5)), 2 & e) {
              let i;
              H(i = B()) && (a._connectionContainerRef = i.first), H(i = B()) && (a._inputContainerRef = i.first), H(i = B()) && (a._label = i.first);
            }
          },
          hostAttrs: [1, "mat-form-field"],
          hostVars: 40,
          hostBindings: function (e, a) {
            2 & e && fe("mat-form-field-appearance-standard", "standard" == a.appearance)("mat-form-field-appearance-fill", "fill" == a.appearance)("mat-form-field-appearance-outline", "outline" == a.appearance)("mat-form-field-appearance-legacy", "legacy" == a.appearance)("mat-form-field-invalid", a._control.errorState)("mat-form-field-can-float", a._canLabelFloat())("mat-form-field-should-float", a._shouldLabelFloat())("mat-form-field-has-label", a._hasFloatingLabel())("mat-form-field-hide-placeholder", a._hideControlPlaceholder())("mat-form-field-disabled", a._control.disabled)("mat-form-field-autofilled", a._control.autofilled)("mat-focused", a._control.focused)("ng-untouched", a._shouldForward("untouched"))("ng-touched", a._shouldForward("touched"))("ng-pristine", a._shouldForward("pristine"))("ng-dirty", a._shouldForward("dirty"))("ng-valid", a._shouldForward("valid"))("ng-invalid", a._shouldForward("invalid"))("ng-pending", a._shouldForward("pending"))("_mat-animation-noopable", !a._animationsEnabled);
          },
          inputs: {
            color: "color",
            appearance: "appearance",
            hideRequiredMarker: "hideRequiredMarker",
            hintLabel: "hintLabel",
            floatLabel: "floatLabel"
          },
          exportAs: ["matFormField"],
          features: [G([{
            provide: _l,
            useExisting: n
          }]), z],
          ngContentSelectors: y0e,
          decls: 15,
          vars: 8,
          consts: [[1, "mat-form-field-wrapper"], [1, "mat-form-field-flex", 3, "click"], ["connectionContainer", ""], [4, "ngIf"], ["class", "mat-form-field-prefix", 3, "cdkObserveContentDisabled", "cdkObserveContent", 4, "ngIf"], [1, "mat-form-field-infix"], ["inputContainer", ""], [1, "mat-form-field-label-wrapper"], ["class", "mat-form-field-label", 3, "cdkObserveContentDisabled", "id", "mat-empty", "mat-form-field-empty", "mat-accent", "mat-warn", "ngSwitch", "cdkObserveContent", 4, "ngIf"], ["class", "mat-form-field-suffix", 4, "ngIf"], ["class", "mat-form-field-underline", 4, "ngIf"], [1, "mat-form-field-subscript-wrapper", 3, "ngSwitch"], [4, "ngSwitchCase"], ["class", "mat-form-field-hint-wrapper", 4, "ngSwitchCase"], [1, "mat-form-field-outline"], [1, "mat-form-field-outline-start"], [1, "mat-form-field-outline-gap"], [1, "mat-form-field-outline-end"], [1, "mat-form-field-outline", "mat-form-field-outline-thick"], [1, "mat-form-field-prefix", 3, "cdkObserveContentDisabled", "cdkObserveContent"], [1, "mat-form-field-label", 3, "cdkObserveContentDisabled", "id", "ngSwitch", "cdkObserveContent"], ["label", ""], ["class", "mat-placeholder-required mat-form-field-required-marker", "aria-hidden", "true", 4, "ngIf"], ["aria-hidden", "true", 1, "mat-placeholder-required", "mat-form-field-required-marker"], [1, "mat-form-field-suffix"], [1, "mat-form-field-underline"], [1, "mat-form-field-ripple"], [1, "mat-form-field-hint-wrapper"], ["class", "mat-hint", 3, "id", 4, "ngIf"], [1, "mat-form-field-hint-spacer"], [1, "mat-hint", 3, "id"]],
          template: function (e, a) {
            1 & e && (lt(v0e), _(0, "div", 0)(1, "div", 1, 2), F("click", function (o) {
              return a._control.onContainerClick && a._control.onContainerClick(o);
            }), D(3, c0e, 9, 0, "ng-container", 3), D(4, l0e, 2, 1, "div", 4), _(5, "div", 5, 6), Me(7), _(8, "span", 7), D(9, m0e, 5, 16, "label", 8), y()(), D(10, h0e, 2, 0, "div", 9), y(), D(11, p0e, 2, 4, "div", 10), _(12, "div", 11), D(13, g0e, 2, 1, "div", 12), D(14, _0e, 5, 2, "div", 13), y()()), 2 & e && (g(3), b("ngIf", "outline" == a.appearance), g(1), b("ngIf", a._prefixChildren.length), g(5), b("ngIf", a._hasFloatingLabel()), g(1), b("ngIf", a._suffixChildren.length), g(1), b("ngIf", "outline" != a.appearance), g(1), b("ngSwitch", a._getDisplayedMessages()), g(1), b("ngSwitchCase", "error"), g(1), b("ngSwitchCase", "hint"));
          },
          dependencies: [mt, Gi, Wr, sp],
          styles: [".mat-form-field{display:inline-block;position:relative;text-align:left}[dir=rtl] .mat-form-field{text-align:right}.mat-form-field-wrapper{position:relative}.mat-form-field-flex{display:inline-flex;align-items:baseline;box-sizing:border-box;width:100%}.mat-form-field-prefix,.mat-form-field-suffix{white-space:nowrap;flex:none;position:relative}.mat-form-field-infix{display:block;position:relative;flex:auto;min-width:0;width:180px}.cdk-high-contrast-active .mat-form-field-infix{border-image:linear-gradient(transparent, transparent)}.mat-form-field-label-wrapper{position:absolute;left:0;box-sizing:content-box;width:100%;height:100%;overflow:hidden;pointer-events:none}[dir=rtl] .mat-form-field-label-wrapper{left:auto;right:0}.mat-form-field-label{position:absolute;left:0;font:inherit;pointer-events:none;width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;transform-origin:0 0;transition:transform 400ms cubic-bezier(0.25, 0.8, 0.25, 1),color 400ms cubic-bezier(0.25, 0.8, 0.25, 1),width 400ms cubic-bezier(0.25, 0.8, 0.25, 1);display:none}[dir=rtl] .mat-form-field-label{transform-origin:100% 0;left:auto;right:0}.cdk-high-contrast-active .mat-form-field-disabled .mat-form-field-label{color:GrayText}.mat-form-field-empty.mat-form-field-label,.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label{display:block}.mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{display:none}.mat-form-field-can-float .mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{display:block;transition:none}.mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label,.mat-input-server[placeholder]:not(:placeholder-shown)+.mat-form-field-label-wrapper .mat-form-field-label{display:none}.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label,.mat-form-field-can-float .mat-input-server[placeholder]:not(:placeholder-shown)+.mat-form-field-label-wrapper .mat-form-field-label{display:block}.mat-form-field-label:not(.mat-form-field-empty){transition:none}.mat-form-field-underline{position:absolute;width:100%;pointer-events:none;transform:scale3d(1, 1.0001, 1)}.mat-form-field-ripple{position:absolute;left:0;width:100%;transform-origin:50%;transform:scaleX(0.5);opacity:0;transition:background-color 300ms cubic-bezier(0.55, 0, 0.55, 0.2)}.mat-form-field.mat-focused .mat-form-field-ripple,.mat-form-field.mat-form-field-invalid .mat-form-field-ripple{opacity:1;transform:none;transition:transform 300ms cubic-bezier(0.25, 0.8, 0.25, 1),opacity 100ms cubic-bezier(0.25, 0.8, 0.25, 1),background-color 300ms cubic-bezier(0.25, 0.8, 0.25, 1)}.mat-form-field-subscript-wrapper{position:absolute;box-sizing:border-box;width:100%;overflow:hidden}.mat-form-field-subscript-wrapper .mat-icon,.mat-form-field-label-wrapper .mat-icon{width:1em;height:1em;font-size:inherit;vertical-align:baseline}.mat-form-field-hint-wrapper{display:flex}.mat-form-field-hint-spacer{flex:1 0 1em}.mat-error{display:block}.mat-form-field-control-wrapper{position:relative}.mat-form-field-hint-end{order:1}.mat-form-field._mat-animation-noopable .mat-form-field-label,.mat-form-field._mat-animation-noopable .mat-form-field-ripple{transition:none}", '.mat-form-field-appearance-fill .mat-form-field-flex{border-radius:4px 4px 0 0;padding:.75em .75em 0 .75em}.cdk-high-contrast-active .mat-form-field-appearance-fill .mat-form-field-flex{outline:solid 1px}.cdk-high-contrast-active .mat-form-field-appearance-fill.mat-form-field-disabled .mat-form-field-flex{outline-color:GrayText}.cdk-high-contrast-active .mat-form-field-appearance-fill.mat-focused .mat-form-field-flex{outline:dashed 3px}.mat-form-field-appearance-fill .mat-form-field-underline::before{content:"";display:block;position:absolute;bottom:0;height:1px;width:100%}.mat-form-field-appearance-fill .mat-form-field-ripple{bottom:0;height:2px}.cdk-high-contrast-active .mat-form-field-appearance-fill .mat-form-field-ripple{height:0}.mat-form-field-appearance-fill:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-underline .mat-form-field-ripple{opacity:1;transform:none;transition:opacity 600ms cubic-bezier(0.25, 0.8, 0.25, 1)}.mat-form-field-appearance-fill._mat-animation-noopable:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-underline .mat-form-field-ripple{transition:none}.mat-form-field-appearance-fill .mat-form-field-subscript-wrapper{padding:0 1em}', '.mat-input-element{font:inherit;background:rgba(0,0,0,0);color:currentColor;border:none;outline:none;padding:0;margin:0;width:100%;max-width:100%;vertical-align:bottom;text-align:inherit;box-sizing:content-box}.mat-input-element:-moz-ui-invalid{box-shadow:none}.mat-input-element,.mat-input-element::-webkit-search-cancel-button,.mat-input-element::-webkit-search-decoration,.mat-input-element::-webkit-search-results-button,.mat-input-element::-webkit-search-results-decoration{-webkit-appearance:none}.mat-input-element::-webkit-contacts-auto-fill-button,.mat-input-element::-webkit-caps-lock-indicator,.mat-input-element:not([type=password])::-webkit-credentials-auto-fill-button{visibility:hidden}.mat-input-element[type=date],.mat-input-element[type=datetime],.mat-input-element[type=datetime-local],.mat-input-element[type=month],.mat-input-element[type=week],.mat-input-element[type=time]{line-height:1}.mat-input-element[type=date]::after,.mat-input-element[type=datetime]::after,.mat-input-element[type=datetime-local]::after,.mat-input-element[type=month]::after,.mat-input-element[type=week]::after,.mat-input-element[type=time]::after{content:" ";white-space:pre;width:1px}.mat-input-element::-webkit-inner-spin-button,.mat-input-element::-webkit-calendar-picker-indicator,.mat-input-element::-webkit-clear-button{font-size:.75em}.mat-input-element::placeholder{-webkit-user-select:none;user-select:none;transition:color 400ms 133.3333333333ms cubic-bezier(0.25, 0.8, 0.25, 1)}.mat-input-element::-moz-placeholder{-webkit-user-select:none;user-select:none;transition:color 400ms 133.3333333333ms cubic-bezier(0.25, 0.8, 0.25, 1)}.mat-input-element::-webkit-input-placeholder{-webkit-user-select:none;user-select:none;transition:color 400ms 133.3333333333ms cubic-bezier(0.25, 0.8, 0.25, 1)}.mat-input-element:-ms-input-placeholder{-webkit-user-select:none;user-select:none;transition:color 400ms 133.3333333333ms cubic-bezier(0.25, 0.8, 0.25, 1)}.mat-form-field-hide-placeholder .mat-input-element::placeholder{color:rgba(0,0,0,0) !important;-webkit-text-fill-color:rgba(0,0,0,0);transition:none}.cdk-high-contrast-active .mat-form-field-hide-placeholder .mat-input-element::placeholder{opacity:0}.mat-form-field-hide-placeholder .mat-input-element::-moz-placeholder{color:rgba(0,0,0,0) !important;-webkit-text-fill-color:rgba(0,0,0,0);transition:none}.cdk-high-contrast-active .mat-form-field-hide-placeholder .mat-input-element::-moz-placeholder{opacity:0}.mat-form-field-hide-placeholder .mat-input-element::-webkit-input-placeholder{color:rgba(0,0,0,0) !important;-webkit-text-fill-color:rgba(0,0,0,0);transition:none}.cdk-high-contrast-active .mat-form-field-hide-placeholder .mat-input-element::-webkit-input-placeholder{opacity:0}.mat-form-field-hide-placeholder .mat-input-element:-ms-input-placeholder{color:rgba(0,0,0,0) !important;-webkit-text-fill-color:rgba(0,0,0,0);transition:none}.cdk-high-contrast-active .mat-form-field-hide-placeholder .mat-input-element:-ms-input-placeholder{opacity:0}._mat-animation-noopable .mat-input-element::placeholder{transition:none}._mat-animation-noopable .mat-input-element::-moz-placeholder{transition:none}._mat-animation-noopable .mat-input-element::-webkit-input-placeholder{transition:none}._mat-animation-noopable .mat-input-element:-ms-input-placeholder{transition:none}textarea.mat-input-element{resize:vertical;overflow:auto}textarea.mat-input-element.cdk-textarea-autosize{resize:none}textarea.mat-input-element{padding:2px 0;margin:-2px 0}select.mat-input-element{-moz-appearance:none;-webkit-appearance:none;position:relative;background-color:rgba(0,0,0,0);display:inline-flex;box-sizing:border-box;padding-top:1em;top:-1em;margin-bottom:-1em}select.mat-input-element::-moz-focus-inner{border:0}select.mat-input-element:not(:disabled){cursor:pointer}.mat-form-field-type-mat-native-select .mat-form-field-infix::after{content:"";width:0;height:0;border-left:5px solid rgba(0,0,0,0);border-right:5px solid rgba(0,0,0,0);border-top:5px solid;position:absolute;top:50%;right:0;margin-top:-2.5px;pointer-events:none}[dir=rtl] .mat-form-field-type-mat-native-select .mat-form-field-infix::after{right:auto;left:0}.mat-form-field-type-mat-native-select .mat-input-element{padding-right:15px}[dir=rtl] .mat-form-field-type-mat-native-select .mat-input-element{padding-right:0;padding-left:15px}.mat-form-field-type-mat-native-select .mat-form-field-label-wrapper{max-width:calc(100% - 10px)}.mat-form-field-type-mat-native-select.mat-form-field-appearance-outline .mat-form-field-infix::after{margin-top:-5px}.mat-form-field-type-mat-native-select.mat-form-field-appearance-fill .mat-form-field-infix::after{margin-top:-10px}', ".mat-form-field-appearance-legacy .mat-form-field-label{transform:perspective(100px)}.mat-form-field-appearance-legacy .mat-form-field-prefix .mat-icon,.mat-form-field-appearance-legacy .mat-form-field-suffix .mat-icon{width:1em}.mat-form-field-appearance-legacy .mat-form-field-prefix .mat-icon-button,.mat-form-field-appearance-legacy .mat-form-field-suffix .mat-icon-button{font:inherit;vertical-align:baseline}.mat-form-field-appearance-legacy .mat-form-field-prefix .mat-icon-button .mat-icon,.mat-form-field-appearance-legacy .mat-form-field-suffix .mat-icon-button .mat-icon{font-size:inherit}.mat-form-field-appearance-legacy .mat-form-field-underline{height:1px}.cdk-high-contrast-active .mat-form-field-appearance-legacy .mat-form-field-underline{height:0;border-top:solid 1px}.mat-form-field-appearance-legacy .mat-form-field-ripple{top:0;height:2px;overflow:hidden}.cdk-high-contrast-active .mat-form-field-appearance-legacy .mat-form-field-ripple{height:0;border-top:solid 2px}.mat-form-field-appearance-legacy.mat-form-field-disabled .mat-form-field-underline{background-position:0;background-color:rgba(0,0,0,0)}.cdk-high-contrast-active .mat-form-field-appearance-legacy.mat-form-field-disabled .mat-form-field-underline{border-top-style:dotted;border-top-width:2px;border-top-color:GrayText}.mat-form-field-appearance-legacy.mat-form-field-invalid:not(.mat-focused) .mat-form-field-ripple{height:1px}", ".mat-form-field-appearance-outline .mat-form-field-wrapper{margin:.25em 0}.mat-form-field-appearance-outline .mat-form-field-flex{padding:0 .75em 0 .75em;margin-top:-0.25em;position:relative}.mat-form-field-appearance-outline .mat-form-field-prefix,.mat-form-field-appearance-outline .mat-form-field-suffix{top:.25em}.mat-form-field-appearance-outline .mat-form-field-outline{display:flex;position:absolute;top:.25em;left:0;right:0;bottom:0;pointer-events:none}.mat-form-field-appearance-outline .mat-form-field-outline-start,.mat-form-field-appearance-outline .mat-form-field-outline-end{border:1px solid currentColor;min-width:5px}.mat-form-field-appearance-outline .mat-form-field-outline-start{border-radius:5px 0 0 5px;border-right-style:none}[dir=rtl] .mat-form-field-appearance-outline .mat-form-field-outline-start{border-right-style:solid;border-left-style:none;border-radius:0 5px 5px 0}.mat-form-field-appearance-outline .mat-form-field-outline-end{border-radius:0 5px 5px 0;border-left-style:none;flex-grow:1}[dir=rtl] .mat-form-field-appearance-outline .mat-form-field-outline-end{border-left-style:solid;border-right-style:none;border-radius:5px 0 0 5px}.mat-form-field-appearance-outline .mat-form-field-outline-gap{border-radius:.000001px;border:1px solid currentColor;border-left-style:none;border-right-style:none}.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-outline-gap{border-top-color:rgba(0,0,0,0)}.mat-form-field-appearance-outline .mat-form-field-outline-thick{opacity:0}.mat-form-field-appearance-outline .mat-form-field-outline-thick .mat-form-field-outline-start,.mat-form-field-appearance-outline .mat-form-field-outline-thick .mat-form-field-outline-end,.mat-form-field-appearance-outline .mat-form-field-outline-thick .mat-form-field-outline-gap{border-width:2px}.mat-form-field-appearance-outline.mat-focused .mat-form-field-outline,.mat-form-field-appearance-outline.mat-form-field-invalid .mat-form-field-outline{opacity:0;transition:opacity 100ms cubic-bezier(0.25, 0.8, 0.25, 1)}.mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick,.mat-form-field-appearance-outline.mat-form-field-invalid .mat-form-field-outline-thick{opacity:1}.cdk-high-contrast-active .mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick{border:3px dashed}.mat-form-field-appearance-outline:not(.mat-form-field-disabled) .mat-form-field-flex:hover .mat-form-field-outline{opacity:0;transition:opacity 600ms cubic-bezier(0.25, 0.8, 0.25, 1)}.mat-form-field-appearance-outline:not(.mat-form-field-disabled) .mat-form-field-flex:hover .mat-form-field-outline-thick{opacity:1}.mat-form-field-appearance-outline .mat-form-field-subscript-wrapper{padding:0 1em}.cdk-high-contrast-active .mat-form-field-appearance-outline.mat-form-field-disabled .mat-form-field-outline{color:GrayText}.mat-form-field-appearance-outline._mat-animation-noopable:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-outline,.mat-form-field-appearance-outline._mat-animation-noopable .mat-form-field-outline,.mat-form-field-appearance-outline._mat-animation-noopable .mat-form-field-outline-start,.mat-form-field-appearance-outline._mat-animation-noopable .mat-form-field-outline-end,.mat-form-field-appearance-outline._mat-animation-noopable .mat-form-field-outline-gap{transition:none}", ".mat-form-field-appearance-standard .mat-form-field-flex{padding-top:.75em}.mat-form-field-appearance-standard .mat-form-field-underline{height:1px}.cdk-high-contrast-active .mat-form-field-appearance-standard .mat-form-field-underline{height:0;border-top:solid 1px}.mat-form-field-appearance-standard .mat-form-field-ripple{bottom:0;height:2px}.cdk-high-contrast-active .mat-form-field-appearance-standard .mat-form-field-ripple{height:0;border-top:solid 2px}.mat-form-field-appearance-standard.mat-form-field-disabled .mat-form-field-underline{background-position:0;background-color:rgba(0,0,0,0)}.cdk-high-contrast-active .mat-form-field-appearance-standard.mat-form-field-disabled .mat-form-field-underline{border-top-style:dotted;border-top-width:2px}.mat-form-field-appearance-standard:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-underline .mat-form-field-ripple{opacity:1;transform:none;transition:opacity 600ms cubic-bezier(0.25, 0.8, 0.25, 1)}.mat-form-field-appearance-standard._mat-animation-noopable:not(.mat-form-field-disabled) .mat-form-field-flex:hover~.mat-form-field-underline .mat-form-field-ripple{transition:none}"],
          encapsulation: 2,
          data: {
            animation: [M0e.transitionMessages]
          },
          changeDetection: 0
        }), n;
      })(),
      vl = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [yt, $, Zc, $]
        }), n;
      })();
    const HM = ka({
      passive: !0
    });
    let A0e = (() => {
        class n {
          constructor(e, a) {
            this._platform = e, this._ngZone = a, this._monitoredElements = new Map();
          }
          monitor(e) {
            if (!this._platform.isBrowser) return Ec;
            const a = wt(e),
              i = this._monitoredElements.get(a);
            if (i) return i.subject;
            const o = new V(),
              r = "cdk-text-field-autofilled",
              s = c => {
                "cdk-text-field-autofill-start" !== c.animationName || a.classList.contains(r) ? "cdk-text-field-autofill-end" === c.animationName && a.classList.contains(r) && (a.classList.remove(r), this._ngZone.run(() => o.next({
                  target: c.target,
                  isAutofilled: !1
                }))) : (a.classList.add(r), this._ngZone.run(() => o.next({
                  target: c.target,
                  isAutofilled: !0
                })));
              };
            return this._ngZone.runOutsideAngular(() => {
              a.addEventListener("animationstart", s, HM), a.classList.add("cdk-text-field-autofill-monitored");
            }), this._monitoredElements.set(a, {
              subject: o,
              unlisten: () => {
                a.removeEventListener("animationstart", s, HM);
              }
            }), o;
          }
          stopMonitoring(e) {
            const a = wt(e),
              i = this._monitoredElements.get(a);
            i && (i.unlisten(), i.subject.complete(), a.classList.remove("cdk-text-field-autofill-monitored"), a.classList.remove("cdk-text-field-autofilled"), this._monitoredElements.delete(a));
          }
          ngOnDestroy() {
            this._monitoredElements.forEach((e, a) => this.stopMonitoring(a));
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(Ct), M(ae));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      BM = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({}), n;
      })();
    const jM = new O("MAT_INPUT_VALUE_ACCESSOR"),
      S0e = ["button", "checkbox", "file", "hidden", "image", "radio", "range", "reset", "submit"];
    let E0e = 0;
    const T0e = gp(class {
      constructor(n, t, e, a) {
        this._defaultErrorStateMatcher = n, this._parentForm = t, this._parentFormGroup = e, this.ngControl = a, this.stateChanges = new V();
      }
    });
    let yl = (() => {
        class n extends T0e {
          constructor(e, a, i, o, r, s, c, l, d, u) {
            super(s, o, r, i), this._elementRef = e, this._platform = a, this._autofillMonitor = l, this._formField = u, this._uid = "mat-input-" + E0e++, this.focused = !1, this.stateChanges = new V(), this.controlType = "mat-input", this.autofilled = !1, this._disabled = !1, this._type = "text", this._readonly = !1, this._neverEmptyInputTypes = ["date", "datetime", "datetime-local", "month", "time", "week"].filter(p => s_().has(p)), this._iOSKeyupListener = p => {
              const v = p.target;
              !v.value && 0 === v.selectionStart && 0 === v.selectionEnd && (v.setSelectionRange(1, 1), v.setSelectionRange(0, 0));
            };
            const m = this._elementRef.nativeElement,
              h = m.nodeName.toLowerCase();
            this._inputValueAccessor = c || m, this._previousNativeValue = this.value, this.id = this.id, a.IOS && d.runOutsideAngular(() => {
              e.nativeElement.addEventListener("keyup", this._iOSKeyupListener);
            }), this._isServer = !this._platform.isBrowser, this._isNativeSelect = "select" === h, this._isTextarea = "textarea" === h, this._isInFormField = !!u, this._isNativeSelect && (this.controlType = m.multiple ? "mat-native-select-multiple" : "mat-native-select");
          }
          get disabled() {
            return this.ngControl && null !== this.ngControl.disabled ? this.ngControl.disabled : this._disabled;
          }
          set disabled(e) {
            this._disabled = Y(e), this.focused && (this.focused = !1, this.stateChanges.next());
          }
          get id() {
            return this._id;
          }
          set id(e) {
            this._id = e || this._uid;
          }
          get required() {
            return this._required ?? this.ngControl?.control?.hasValidator(Da.required) ?? !1;
          }
          set required(e) {
            this._required = Y(e);
          }
          get type() {
            return this._type;
          }
          set type(e) {
            this._type = e || "text", this._validateType(), !this._isTextarea && s_().has(this._type) && (this._elementRef.nativeElement.type = this._type);
          }
          get value() {
            return this._inputValueAccessor.value;
          }
          set value(e) {
            e !== this.value && (this._inputValueAccessor.value = e, this.stateChanges.next());
          }
          get readonly() {
            return this._readonly;
          }
          set readonly(e) {
            this._readonly = Y(e);
          }
          ngAfterViewInit() {
            this._platform.isBrowser && this._autofillMonitor.monitor(this._elementRef.nativeElement).subscribe(e => {
              this.autofilled = e.isAutofilled, this.stateChanges.next();
            });
          }
          ngOnChanges() {
            this.stateChanges.next();
          }
          ngOnDestroy() {
            this.stateChanges.complete(), this._platform.isBrowser && this._autofillMonitor.stopMonitoring(this._elementRef.nativeElement), this._platform.IOS && this._elementRef.nativeElement.removeEventListener("keyup", this._iOSKeyupListener);
          }
          ngDoCheck() {
            this.ngControl && this.updateErrorState(), this._dirtyCheckNativeValue(), this._dirtyCheckPlaceholder();
          }
          focus(e) {
            this._elementRef.nativeElement.focus(e);
          }
          _focusChanged(e) {
            e !== this.focused && (this.focused = e, this.stateChanges.next());
          }
          _onInput() {}
          _dirtyCheckPlaceholder() {
            const e = this._formField,
              a = e && "legacy" === e.appearance && !e._hasLabel?.() ? null : this.placeholder;
            if (a !== this._previousPlaceholder) {
              const i = this._elementRef.nativeElement;
              this._previousPlaceholder = a, a ? i.setAttribute("placeholder", a) : i.removeAttribute("placeholder");
            }
          }
          _dirtyCheckNativeValue() {
            const e = this._elementRef.nativeElement.value;
            this._previousNativeValue !== e && (this._previousNativeValue = e, this.stateChanges.next());
          }
          _validateType() {
            S0e.indexOf(this._type);
          }
          _isNeverEmpty() {
            return this._neverEmptyInputTypes.indexOf(this._type) > -1;
          }
          _isBadInput() {
            let e = this._elementRef.nativeElement.validity;
            return e && e.badInput;
          }
          get empty() {
            return !(this._isNeverEmpty() || this._elementRef.nativeElement.value || this._isBadInput() || this.autofilled);
          }
          get shouldLabelFloat() {
            if (this._isNativeSelect) {
              const e = this._elementRef.nativeElement,
                a = e.options[0];
              return this.focused || e.multiple || !this.empty || !!(e.selectedIndex > -1 && a && a.label);
            }
            return this.focused || !this.empty;
          }
          setDescribedByIds(e) {
            e.length ? this._elementRef.nativeElement.setAttribute("aria-describedby", e.join(" ")) : this._elementRef.nativeElement.removeAttribute("aria-describedby");
          }
          onContainerClick() {
            this.focused || this.focus();
          }
          _isInlineSelect() {
            const e = this._elementRef.nativeElement;
            return this._isNativeSelect && (e.multiple || e.size > 1);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(Ct), f(Oa, 10), f(is, 8), f(ra, 8), f(ls), f(jM, 10), f(A0e), f(ae), f(_l, 8));
        }, n.ɵdir = P({
          type: n,
          selectors: [["input", "matInput", ""], ["textarea", "matInput", ""], ["select", "matNativeControl", ""], ["input", "matNativeControl", ""], ["textarea", "matNativeControl", ""]],
          hostAttrs: [1, "mat-input-element", "mat-form-field-autofill-control"],
          hostVars: 12,
          hostBindings: function (e, a) {
            1 & e && F("focus", function () {
              return a._focusChanged(!0);
            })("blur", function () {
              return a._focusChanged(!1);
            })("input", function () {
              return a._onInput();
            }), 2 & e && (Zn("disabled", a.disabled)("required", a.required), X("id", a.id)("data-placeholder", a.placeholder)("name", a.name || null)("readonly", a.readonly && !a._isNativeSelect || null)("aria-invalid", a.empty && a.required ? null : a.errorState)("aria-required", a.required), fe("mat-input-server", a._isServer)("mat-native-select-inline", a._isInlineSelect()));
          },
          inputs: {
            disabled: "disabled",
            id: "id",
            placeholder: "placeholder",
            name: "name",
            required: "required",
            type: "type",
            errorStateMatcher: "errorStateMatcher",
            userAriaDescribedBy: ["aria-describedby", "userAriaDescribedBy"],
            value: "value",
            readonly: "readonly"
          },
          exportAs: ["matInput"],
          features: [G([{
            provide: bl,
            useExisting: n
          }]), z, Ve]
        }), n;
      })(),
      UM = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [ls],
          imports: [BM, vl, $, BM, vl]
        }), n;
      })();
    function I0e(n, t) {
      1 & n && (_(0, "mat-error"), S(1, " Value must be a "), _(2, "strong"), S(3, "URL"), y()());
    }
    function R0e(n, t) {
      1 & n && (_(0, "mat-error"), S(1, " Value must be a "), _(2, "strong"), S(3, "phone number"), y()());
    }
    function z0e(n, t) {
      1 & n && (_(0, "mat-error"), S(1, " Value must be an "), _(2, "strong"), S(3, "email address"), y()());
    }
    function L0e(n, t) {
      1 & n && (_(0, "mat-error"), S(1, " Value must be a "), _(2, "strong"), S(3, "number"), y()());
    }
    function N0e(n, t) {
      if (1 & n && (_(0, "span"), S(1, " instead of "), _(2, "strong"), S(3), y()()), 2 & n) {
        const e = x(2);
        g(3), Ie(e.control.errors.decimal.actual);
      }
    }
    function F0e(n, t) {
      if (1 & n && (_(0, "mat-error"), S(1, " Value must have exactly "), _(2, "strong"), S(3), y(), S(4, " decimal places "), D(5, N0e, 4, 1, "span", 2), S(6), y()), 2 & n) {
        const e = x();
        g(3), Ie(e.control.errors.decimal.required), g(2), b("ngIf", e.control.errors.decimal.actual), g(1), Fe(" , for example, ", e.control.errors.decimal.suggested, " ");
      }
    }
    function V0e(n, t) {
      if (1 & n && (_(0, "mat-error"), S(1), _(2, "strong"), S(3), y()()), 2 & n) {
        const e = x();
        g(1), Fe(" Value ", e.control.errors.min.actual, " must be greater than "), g(2), Ie(e.control.errors.min.min);
      }
    }
    function H0e(n, t) {
      if (1 & n && (_(0, "mat-error"), S(1), _(2, "strong"), S(3), y()()), 2 & n) {
        const e = x();
        g(1), Fe(" Value ", e.control.errors.max.actual, " must be less than "), g(2), Ie(e.control.errors.max.max);
      }
    }
    function B0e(n, t) {
      if (1 & n && (_(0, "mat-error"), S(1), _(2, "strong"), S(3), y()()), 2 & n) {
        const e = x();
        g(1), Fe(" Value length ", e.control.errors.minlength.actualLength, " is less than "), g(2), Ie(e.control.errors.minlength.requiredLength);
      }
    }
    function j0e(n, t) {
      if (1 & n && (_(0, "mat-error"), S(1), _(2, "strong"), S(3), y()()), 2 & n) {
        const e = x();
        g(1), Fe(" Value length ", e.control.errors.maxlength.actualLength, " is greater than "), g(2), Ie(e.control.errors.maxlength.requiredLength);
      }
    }
    function U0e(n, t) {
      1 & n && (_(0, "mat-error"), S(1, " Value is "), _(2, "strong"), S(3, "required"), y()());
    }
    let X2 = /*#__PURE__*/(() => {
      class X2 {
        formGroup;
        control;
        node;
        index;
        disabled;
        changed = new E();
        mode;
        constructor() {}
        ngOnInit() {
          this.formGroup.get("values").setValue(this.getValue(this.node.model[this.node.key], this.node.valueLocation)), this.setValidators(this.formGroup), this.formGroup.get("values").valueChanges.subscribe(t => {
            this.node.model[this.node.key] = this.setValue(t, this.node.model[this.node.key], this.node.valueLocation), this.changed.emit({
              type: this.node.type,
              subtype: this.node.subtype,
              model: this.node.model,
              key: this.node.key,
              index: 0,
              location: this.node.valueLocation,
              value: t
            });
          });
        }
        setValidators(t) {
          const e = eo.getValidators(this.node);
          this.formGroup.get("values").controls.forEach(function (a) {
            a.setValidators(e), a.updateValueAndValidity();
          });
        }
        getValue(t, e) {
          const a = [];
          if (t) {
            if (Array.isArray(t)) for (let i = 0; i < t.length; i++) a.push(t[i][e] || null);else a.push(t[e] || null);
          } else a.push(null);
          return a;
        }
        setVal(t, e) {
          const a = {};
          return a[e] = t || null, a;
        }
        setValue(t, e, a) {
          const i = [];
          return t.length > 1 ? t.forEach(o => {
            i.push(this.setVal(o, a));
          }) : 1 === t.length && i.push(this.setVal(t[0], a)), i;
        }
        static ɵfac = function (e) {
          return new (e || X2)();
        };
        static ɵcmp = q({
          type: X2,
          selectors: [["app-textfield"]],
          inputs: {
            formGroup: "formGroup",
            control: "control",
            node: "node",
            index: "index",
            disabled: "disabled",
            mode: "mode"
          },
          outputs: {
            changed: "changed"
          },
          decls: 14,
          vars: 17,
          consts: [[1, "mat-form-field"], ["matInput", "", 3, "formControl", "type", "min", "max"], [4, "ngIf"]],
          template: function (e, a) {
            1 & e && (_(0, "mat-form-field", 0), j(1, "input", 1), _(2, "mat-hint"), S(3), y(), D(4, I0e, 4, 0, "mat-error", 2), D(5, R0e, 4, 0, "mat-error", 2), D(6, z0e, 4, 0, "mat-error", 2), D(7, L0e, 4, 0, "mat-error", 2), D(8, F0e, 7, 3, "mat-error", 2), D(9, V0e, 4, 2, "mat-error", 2), D(10, H0e, 4, 2, "mat-error", 2), D(11, B0e, 4, 2, "mat-error", 2), D(12, j0e, 4, 2, "mat-error", 2), D(13, U0e, 4, 0, "mat-error", 2), y()), 2 & e && (g(1), b("formControl", a.control)("type", a.node.subtype)("min", a.node.minLength)("max", a.node.maxLength)("min", a.node.min)("max", a.node.max), g(2), Fe("", a.node.hint, " "), g(1), b("ngIf", a.control.hasError("url")), g(1), b("ngIf", a.control.hasError("tel")), g(1), b("ngIf", a.control.hasError("email")), g(1), b("ngIf", a.control.hasError("numeric")), g(1), b("ngIf", a.control.hasError("decimal")), g(1), b("ngIf", a.control.hasError("min")), g(1), b("ngIf", a.control.hasError("max")), g(1), b("ngIf", a.control.hasError("minlength")), g(1), b("ngIf", a.control.hasError("maxlength")), g(1), b("ngIf", a.control.hasError("required")));
          },
          dependencies: [mt, x4, Si, Cs, yi, oa, Pa, yl]
        });
      }
      return X2;
    })();
    function G0e(n, t) {
      1 & n && (_(0, "mat-error"), S(1, " Value is "), _(2, "strong"), S(3, "required"), y()());
    }
    let J2 = /*#__PURE__*/(() => {
      class J2 {
        formGroup;
        control;
        node;
        index;
        changed = new E();
        constructor() {}
        ngOnInit() {
          this.formGroup.get("values").setValue(this.getValue(this.node.model[this.node.key], this.node.valueLocation)), this.formGroup.get("values").valueChanges.subscribe(t => {
            this.node.model[this.node.key] = this.setValue(t, this.node.model[this.node.key], this.node.valueLocation), this.changed.emit({
              type: this.node.type,
              subtype: this.node.subtype,
              model: this.node.model,
              key: this.node.key,
              index: 0,
              location: this.node.valueLocation,
              value: t
            });
          });
        }
        getValue(t, e) {
          const a = [];
          return t ? Array.isArray(t) ? t.forEach((i, o) => {
            a.push(i[e] || null);
          }) : a.push(t[e] || null) : a.push(null), a;
        }
        setValue(t, e, a) {
          let i;
          return t.length > 1 ? (i = [], t.forEach((o, r) => {
            const s = {};
            s[a] = o, i.push(s);
          })) : 1 === t.length && (i = {}, i[a] = t[0]), i;
        }
        static ɵfac = function (e) {
          return new (e || J2)();
        };
        static ɵcmp = q({
          type: J2,
          selectors: [["app-textarea"]],
          inputs: {
            formGroup: "formGroup",
            control: "control",
            node: "node",
            index: "index"
          },
          outputs: {
            changed: "changed"
          },
          decls: 5,
          vars: 4,
          consts: [[1, "example-full-width", "mat-form-field"], ["matInput", "", "type", "text", 3, "formControl", "required"], [4, "ngIf"]],
          template: function (e, a) {
            1 & e && (_(0, "mat-form-field", 0), j(1, "textarea", 1), _(2, "mat-hint"), S(3), y(), D(4, G0e, 4, 0, "mat-error", 2), y()), 2 & e && (g(1), b("formControl", a.control)("required", a.node.required), g(2), Ie(a.node.hint), g(1), b("ngIf", a.control.hasError("required")));
          },
          dependencies: [mt, x4, Si, Cs, yi, oa, No, Pa, yl]
        });
      }
      return J2;
    })();
    const W0e = function (n) {
      return {
        "max-width.px": n
      };
    };
    function Y0e(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "div", 1)(1, "youtube-player", 2), F("ready", function (i) {
          return pe(e), ge(x().savePlayer(i));
        })("change", function (i) {
          return pe(e), ge(x().onChange(i));
        }), y(), _(2, "div", 3)(3, "label"), S(4), y()()();
      }
      if (2 & n) {
        const e = x();
        b("ngStyle", Vr(3, W0e, e.getImageWidth(e.node))), g(1), b("videoId", e.node.staticValue), g(3), Ie(e.node.name);
      }
    }
    let $2 = /*#__PURE__*/(() => {
      class $2 {
        yt;
        formGroup;
        node;
        constructor(t) {
          this.yt = t;
        }
        ngOnInit() {}
        savePlayer(t) {
          this.yt = t;
        }
        onChange(t) {}
        getImageWidth(t) {
          if (t.size && t.size.width && Number.isInteger(t.size.width)) return t.size.width;
        }
        getImageHeight(t) {
          if (t.size && t.size.height && Number.isInteger(t.size.height)) return t.size.height;
        }
        static ɵfac = function (e) {
          return new (e || $2)(f($m));
        };
        static ɵcmp = q({
          type: $2,
          selectors: [["app-youtube"]],
          inputs: {
            formGroup: "formGroup",
            node: "node"
          },
          decls: 1,
          vars: 1,
          consts: [["class", "static-video", 3, "ngStyle", 4, "ngIf"], [1, "static-video", 3, "ngStyle"], [1, "videoPlayer", 3, "videoId", "ready", "change"], [1, "caption"]],
          template: function (e, a) {
            1 & e && D(0, Y0e, 5, 5, "div", 0), 2 & e && b("ngIf", "youtube" == a.node.subtype);
          },
          dependencies: [mt, fd],
          styles: [".videoWrapper[_ngcontent-%COMP%]{position:relative;padding-bottom:320px;padding-top:25px;height:0;@padding : 20px;}.videoWrapper[_ngcontent-%COMP%]   .caption[_ngcontent-%COMP%]{padding:10px;font-style:italic;width:347px}.videoWrapper[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%]{position:absolute;top:0;left:0}.static-video[_ngcontent-%COMP%]{margin:20px 0;width:auto;display:flex;flex-direction:column}.static-video[_ngcontent-%COMP%]   .caption[_ngcontent-%COMP%]{padding:10px;font-style:italic;text-align:center}.static-video[_ngcontent-%COMP%]   .caption[_ngcontent-%COMP%]{padding:10px;font-style:italic;width:347px}"]
        });
      }
      return $2;
    })();
    let e0 = /*#__PURE__*/(() => {
      class e0 {
        formGroup;
        node;
        constructor() {}
        ngOnInit() {}
        static ɵfac = function (e) {
          return new (e || e0)();
        };
        static ɵcmp = q({
          type: e0,
          selectors: [["app-richtext"]],
          inputs: {
            formGroup: "formGroup",
            node: "node"
          },
          decls: 1,
          vars: 1,
          consts: [[3, "innerHTML"]],
          template: function (e, a) {
            1 & e && j(0, "div", 0), 2 & e && b("innerHTML", a.node.staticValue, Vu);
          }
        });
      }
      return e0;
    })();
    const q0e = ["input"],
      K0e = ["label"],
      Q0e = function (n) {
        return {
          enterDuration: n
        };
      },
      Z0e = ["*"],
      X0e = new O("mat-checkbox-default-options", {
        providedIn: "root",
        factory: GM
      });
    function GM() {
      return {
        color: "accent",
        clickAction: "check-indeterminate"
      };
    }
    let J0e = 0;
    const WM = GM(),
      $0e = {
        provide: Bt,
        useExisting: Pe(() => w4),
        multi: !0
      };
    class eue {}
    const tue = $i(Qa(Za(Fo(class {
      constructor(n) {
        this._elementRef = n;
      }
    }))));
    let nue = (() => {
        class n extends tue {
          constructor(e, a, i, o, r, s, c) {
            super(a), this._changeDetectorRef = i, this._ngZone = o, this._animationMode = s, this._options = c, this.ariaLabel = "", this.ariaLabelledby = null, this.labelPosition = "after", this.name = null, this.change = new E(), this.indeterminateChange = new E(), this._onTouched = () => {}, this._currentAnimationClass = "", this._currentCheckState = 0, this._controlValueAccessorChangeFn = () => {}, this._checked = !1, this._disabled = !1, this._indeterminate = !1, this._options = this._options || WM, this.color = this.defaultColor = this._options.color || WM.color, this.tabIndex = parseInt(r) || 0, this.id = this._uniqueId = `${e}${++J0e}`;
          }
          get inputId() {
            return `${this.id || this._uniqueId}-input`;
          }
          get required() {
            return this._required;
          }
          set required(e) {
            this._required = Y(e);
          }
          ngAfterViewInit() {
            this._syncIndeterminate(this._indeterminate);
          }
          get checked() {
            return this._checked;
          }
          set checked(e) {
            const a = Y(e);
            a != this.checked && (this._checked = a, this._changeDetectorRef.markForCheck());
          }
          get disabled() {
            return this._disabled;
          }
          set disabled(e) {
            const a = Y(e);
            a !== this.disabled && (this._disabled = a, this._changeDetectorRef.markForCheck());
          }
          get indeterminate() {
            return this._indeterminate;
          }
          set indeterminate(e) {
            const a = e != this._indeterminate;
            this._indeterminate = Y(e), a && (this._transitionCheckState(this._indeterminate ? 3 : this.checked ? 1 : 2), this.indeterminateChange.emit(this._indeterminate)), this._syncIndeterminate(this._indeterminate);
          }
          _isRippleDisabled() {
            return this.disableRipple || this.disabled;
          }
          _onLabelTextChange() {
            this._changeDetectorRef.detectChanges();
          }
          writeValue(e) {
            this.checked = !!e;
          }
          registerOnChange(e) {
            this._controlValueAccessorChangeFn = e;
          }
          registerOnTouched(e) {
            this._onTouched = e;
          }
          setDisabledState(e) {
            this.disabled = e;
          }
          _getAriaChecked() {
            return this.checked ? "true" : this.indeterminate ? "mixed" : "false";
          }
          _transitionCheckState(e) {
            let a = this._currentCheckState,
              i = this._getAnimationTargetElement();
            if (a !== e && i && (this._currentAnimationClass && i.classList.remove(this._currentAnimationClass), this._currentAnimationClass = this._getAnimationClassForCheckStateTransition(a, e), this._currentCheckState = e, this._currentAnimationClass.length > 0)) {
              i.classList.add(this._currentAnimationClass);
              const o = this._currentAnimationClass;
              this._ngZone.runOutsideAngular(() => {
                setTimeout(() => {
                  i.classList.remove(o);
                }, 1e3);
              });
            }
          }
          _emitChangeEvent() {
            this._controlValueAccessorChangeFn(this.checked), this.change.emit(this._createChangeEvent(this.checked)), this._inputElement && (this._inputElement.nativeElement.checked = this.checked);
          }
          toggle() {
            this.checked = !this.checked, this._controlValueAccessorChangeFn(this.checked);
          }
          _handleInputClick() {
            const e = this._options?.clickAction;
            this.disabled || "noop" === e ? !this.disabled && "noop" === e && (this._inputElement.nativeElement.checked = this.checked, this._inputElement.nativeElement.indeterminate = this.indeterminate) : (this.indeterminate && "check" !== e && Promise.resolve().then(() => {
              this._indeterminate = !1, this.indeterminateChange.emit(this._indeterminate);
            }), this._checked = !this._checked, this._transitionCheckState(this._checked ? 1 : 2), this._emitChangeEvent());
          }
          _onInteractionEvent(e) {
            e.stopPropagation();
          }
          _onBlur() {
            Promise.resolve().then(() => {
              this._onTouched(), this._changeDetectorRef.markForCheck();
            });
          }
          _getAnimationClassForCheckStateTransition(e, a) {
            if ("NoopAnimations" === this._animationMode) return "";
            switch (e) {
              case 0:
                if (1 === a) return this._animationClasses.uncheckedToChecked;
                if (3 == a) return this._checked ? this._animationClasses.checkedToIndeterminate : this._animationClasses.uncheckedToIndeterminate;
                break;
              case 2:
                return 1 === a ? this._animationClasses.uncheckedToChecked : this._animationClasses.uncheckedToIndeterminate;
              case 1:
                return 2 === a ? this._animationClasses.checkedToUnchecked : this._animationClasses.checkedToIndeterminate;
              case 3:
                return 1 === a ? this._animationClasses.indeterminateToChecked : this._animationClasses.indeterminateToUnchecked;
            }
            return "";
          }
          _syncIndeterminate(e) {
            const a = this._inputElement;
            a && (a.nativeElement.indeterminate = e);
          }
        }
        return n.ɵfac = function (e) {
          li();
        }, n.ɵdir = P({
          type: n,
          viewQuery: function (e, a) {
            if (1 & e && (be(q0e, 5), be(K0e, 5), be(Xa, 5)), 2 & e) {
              let i;
              H(i = B()) && (a._inputElement = i.first), H(i = B()) && (a._labelElement = i.first), H(i = B()) && (a.ripple = i.first);
            }
          },
          inputs: {
            ariaLabel: ["aria-label", "ariaLabel"],
            ariaLabelledby: ["aria-labelledby", "ariaLabelledby"],
            ariaDescribedby: ["aria-describedby", "ariaDescribedby"],
            id: "id",
            required: "required",
            labelPosition: "labelPosition",
            name: "name",
            value: "value",
            checked: "checked",
            disabled: "disabled",
            indeterminate: "indeterminate"
          },
          outputs: {
            change: "change",
            indeterminateChange: "indeterminateChange"
          },
          features: [z]
        }), n;
      })(),
      w4 = (() => {
        class n extends nue {
          constructor(e, a, i, o, r, s, c) {
            super("mat-checkbox-", e, a, o, r, s, c), this._focusMonitor = i, this._animationClasses = {
              uncheckedToChecked: "mat-checkbox-anim-unchecked-checked",
              uncheckedToIndeterminate: "mat-checkbox-anim-unchecked-indeterminate",
              checkedToUnchecked: "mat-checkbox-anim-checked-unchecked",
              checkedToIndeterminate: "mat-checkbox-anim-checked-indeterminate",
              indeterminateToChecked: "mat-checkbox-anim-indeterminate-checked",
              indeterminateToUnchecked: "mat-checkbox-anim-indeterminate-unchecked"
            };
          }
          _createChangeEvent(e) {
            const a = new eue();
            return a.source = this, a.checked = e, a;
          }
          _getAnimationTargetElement() {
            return this._elementRef.nativeElement;
          }
          ngAfterViewInit() {
            super.ngAfterViewInit(), this._focusMonitor.monitor(this._elementRef, !0).subscribe(e => {
              e || this._onBlur();
            });
          }
          ngOnDestroy() {
            this._focusMonitor.stopMonitoring(this._elementRef);
          }
          _onInputClick(e) {
            e.stopPropagation(), super._handleInputClick();
          }
          focus(e, a) {
            e ? this._focusMonitor.focusVia(this._inputElement, e, a) : this._inputElement.nativeElement.focus(a);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(Se), f(Hn), f(ae), qt("tabindex"), f(Ft, 8), f(X0e, 8));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-checkbox"]],
          hostAttrs: [1, "mat-checkbox"],
          hostVars: 14,
          hostBindings: function (e, a) {
            2 & e && (Zn("id", a.id), X("tabindex", null)("aria-label", null)("aria-labelledby", null), fe("mat-checkbox-indeterminate", a.indeterminate)("mat-checkbox-checked", a.checked)("mat-checkbox-disabled", a.disabled)("mat-checkbox-label-before", "before" == a.labelPosition)("_mat-animation-noopable", "NoopAnimations" === a._animationMode));
          },
          inputs: {
            disableRipple: "disableRipple",
            color: "color",
            tabIndex: "tabIndex"
          },
          exportAs: ["matCheckbox"],
          features: [G([$0e]), z],
          ngContentSelectors: Z0e,
          decls: 17,
          vars: 21,
          consts: [[1, "mat-checkbox-layout"], ["label", ""], [1, "mat-checkbox-inner-container"], ["type", "checkbox", 1, "mat-checkbox-input", "cdk-visually-hidden", 3, "id", "required", "checked", "disabled", "tabIndex", "change", "click"], ["input", ""], ["matRipple", "", 1, "mat-checkbox-ripple", "mat-focus-indicator", 3, "matRippleTrigger", "matRippleDisabled", "matRippleRadius", "matRippleCentered", "matRippleAnimation"], [1, "mat-ripple-element", "mat-checkbox-persistent-ripple"], [1, "mat-checkbox-frame"], [1, "mat-checkbox-background"], ["version", "1.1", "focusable", "false", "viewBox", "0 0 24 24", "aria-hidden", "true", 1, "mat-checkbox-checkmark"], ["fill", "none", "stroke", "white", "d", "M4.1,12.7 9,17.6 20.3,6.3", 1, "mat-checkbox-checkmark-path"], [1, "mat-checkbox-mixedmark"], [1, "mat-checkbox-label", 3, "cdkObserveContent"], ["checkboxLabel", ""], [2, "display", "none"]],
          template: function (e, a) {
            if (1 & e && (lt(), _(0, "label", 0, 1)(2, "span", 2)(3, "input", 3, 4), F("change", function (o) {
              return a._onInteractionEvent(o);
            })("click", function (o) {
              return a._onInputClick(o);
            }), y(), _(5, "span", 5), j(6, "span", 6), y(), j(7, "span", 7), _(8, "span", 8), Kn(), _(9, "svg", 9), j(10, "path", 10), y(), qs(), j(11, "span", 11), y()(), _(12, "span", 12, 13), F("cdkObserveContent", function () {
              return a._onLabelTextChange();
            }), _(14, "span", 14), S(15, "\xa0"), y(), Me(16), y()()), 2 & e) {
              const i = Kt(1),
                o = Kt(13);
              X("for", a.inputId), g(2), fe("mat-checkbox-inner-container-no-side-margin", !o.textContent || !o.textContent.trim()), g(1), b("id", a.inputId)("required", a.required)("checked", a.checked)("disabled", a.disabled)("tabIndex", a.tabIndex), X("value", a.value)("name", a.name)("aria-label", a.ariaLabel || null)("aria-labelledby", a.ariaLabelledby)("aria-checked", a._getAriaChecked())("aria-describedby", a.ariaDescribedby), g(2), b("matRippleTrigger", i)("matRippleDisabled", a._isRippleDisabled())("matRippleRadius", 20)("matRippleCentered", !0)("matRippleAnimation", Vr(19, Q0e, "NoopAnimations" === a._animationMode ? 0 : 150));
            }
          },
          dependencies: [Xa, sp],
          styles: ['@keyframes mat-checkbox-fade-in-background{0%{opacity:0}50%{opacity:1}}@keyframes mat-checkbox-fade-out-background{0%,50%{opacity:1}100%{opacity:0}}@keyframes mat-checkbox-unchecked-checked-checkmark-path{0%,50%{stroke-dashoffset:22.910259}50%{animation-timing-function:cubic-bezier(0, 0, 0.2, 0.1)}100%{stroke-dashoffset:0}}@keyframes mat-checkbox-unchecked-indeterminate-mixedmark{0%,68.2%{transform:scaleX(0)}68.2%{animation-timing-function:cubic-bezier(0, 0, 0, 1)}100%{transform:scaleX(1)}}@keyframes mat-checkbox-checked-unchecked-checkmark-path{from{animation-timing-function:cubic-bezier(0.4, 0, 1, 1);stroke-dashoffset:0}to{stroke-dashoffset:-22.910259}}@keyframes mat-checkbox-checked-indeterminate-checkmark{from{animation-timing-function:cubic-bezier(0, 0, 0.2, 0.1);opacity:1;transform:rotate(0deg)}to{opacity:0;transform:rotate(45deg)}}@keyframes mat-checkbox-indeterminate-checked-checkmark{from{animation-timing-function:cubic-bezier(0.14, 0, 0, 1);opacity:0;transform:rotate(45deg)}to{opacity:1;transform:rotate(360deg)}}@keyframes mat-checkbox-checked-indeterminate-mixedmark{from{animation-timing-function:cubic-bezier(0, 0, 0.2, 0.1);opacity:0;transform:rotate(-45deg)}to{opacity:1;transform:rotate(0deg)}}@keyframes mat-checkbox-indeterminate-checked-mixedmark{from{animation-timing-function:cubic-bezier(0.14, 0, 0, 1);opacity:1;transform:rotate(0deg)}to{opacity:0;transform:rotate(315deg)}}@keyframes mat-checkbox-indeterminate-unchecked-mixedmark{0%{animation-timing-function:linear;opacity:1;transform:scaleX(1)}32.8%,100%{opacity:0;transform:scaleX(0)}}.mat-checkbox-background,.mat-checkbox-frame{top:0;left:0;right:0;bottom:0;position:absolute;border-radius:2px;box-sizing:border-box;pointer-events:none}.mat-checkbox{display:inline-block;transition:background 400ms cubic-bezier(0.25, 0.8, 0.25, 1),box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);cursor:pointer;-webkit-tap-highlight-color:rgba(0,0,0,0);position:relative}.mat-checkbox._mat-animation-noopable{transition:none !important;animation:none !important}.mat-checkbox .mat-ripple-element:not(.mat-checkbox-persistent-ripple){opacity:.16}.mat-checkbox .mat-checkbox-ripple{position:absolute;left:calc(50% - 20px);top:calc(50% - 20px);height:40px;width:40px;z-index:1;pointer-events:none}.mat-checkbox-layout{-webkit-user-select:none;user-select:none;cursor:inherit;align-items:baseline;vertical-align:middle;display:inline-flex;white-space:nowrap}.mat-checkbox-label{-webkit-user-select:auto;user-select:auto}.mat-checkbox-inner-container{display:inline-block;height:16px;line-height:0;margin:auto;margin-right:8px;order:0;position:relative;vertical-align:middle;white-space:nowrap;width:16px;flex-shrink:0}[dir=rtl] .mat-checkbox-inner-container{margin-left:8px;margin-right:auto}.mat-checkbox-inner-container-no-side-margin{margin-left:0;margin-right:0}.mat-checkbox-frame{background-color:rgba(0,0,0,0);transition:border-color 90ms cubic-bezier(0, 0, 0.2, 0.1);border-width:2px;border-style:solid}._mat-animation-noopable .mat-checkbox-frame{transition:none}.mat-checkbox-background{align-items:center;display:inline-flex;justify-content:center;transition:background-color 90ms cubic-bezier(0, 0, 0.2, 0.1),opacity 90ms cubic-bezier(0, 0, 0.2, 0.1);-webkit-print-color-adjust:exact;color-adjust:exact}._mat-animation-noopable .mat-checkbox-background{transition:none}.cdk-high-contrast-active .mat-checkbox .mat-checkbox-background{background:none}.mat-checkbox-persistent-ripple{display:block;width:100%;height:100%;transform:none}.mat-checkbox-inner-container:hover .mat-checkbox-persistent-ripple{opacity:.04}.mat-checkbox.cdk-keyboard-focused .mat-checkbox-persistent-ripple{opacity:.12}.mat-checkbox-persistent-ripple,.mat-checkbox.mat-checkbox-disabled .mat-checkbox-inner-container:hover .mat-checkbox-persistent-ripple{opacity:0}@media(hover: none){.mat-checkbox-inner-container:hover .mat-checkbox-persistent-ripple{display:none}}.mat-checkbox-checkmark{top:0;left:0;right:0;bottom:0;position:absolute;width:100%}.mat-checkbox-checkmark-path{stroke-dashoffset:22.910259;stroke-dasharray:22.910259;stroke-width:2.1333333333px}.cdk-high-contrast-black-on-white .mat-checkbox-checkmark-path{stroke:#000 !important}.mat-checkbox-mixedmark{width:calc(100% - 6px);height:2px;opacity:0;transform:scaleX(0) rotate(0deg);border-radius:2px}.cdk-high-contrast-active .mat-checkbox-mixedmark{height:0;border-top:solid 2px;margin-top:2px}.mat-checkbox-label-before .mat-checkbox-inner-container{order:1;margin-left:8px;margin-right:auto}[dir=rtl] .mat-checkbox-label-before .mat-checkbox-inner-container{margin-left:auto;margin-right:8px}.mat-checkbox-checked .mat-checkbox-checkmark{opacity:1}.mat-checkbox-checked .mat-checkbox-checkmark-path{stroke-dashoffset:0}.mat-checkbox-checked .mat-checkbox-mixedmark{transform:scaleX(1) rotate(-45deg)}.mat-checkbox-indeterminate .mat-checkbox-checkmark{opacity:0;transform:rotate(45deg)}.mat-checkbox-indeterminate .mat-checkbox-checkmark-path{stroke-dashoffset:0}.mat-checkbox-indeterminate .mat-checkbox-mixedmark{opacity:1;transform:scaleX(1) rotate(0deg)}.mat-checkbox-unchecked .mat-checkbox-background{background-color:rgba(0,0,0,0)}.mat-checkbox-disabled{cursor:default}.cdk-high-contrast-active .mat-checkbox-disabled{opacity:.5}.mat-checkbox-anim-unchecked-checked .mat-checkbox-background{animation:180ms linear 0ms mat-checkbox-fade-in-background}.mat-checkbox-anim-unchecked-checked .mat-checkbox-checkmark-path{animation:180ms linear 0ms mat-checkbox-unchecked-checked-checkmark-path}.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-background{animation:180ms linear 0ms mat-checkbox-fade-in-background}.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-mixedmark{animation:90ms linear 0ms mat-checkbox-unchecked-indeterminate-mixedmark}.mat-checkbox-anim-checked-unchecked .mat-checkbox-background{animation:180ms linear 0ms mat-checkbox-fade-out-background}.mat-checkbox-anim-checked-unchecked .mat-checkbox-checkmark-path{animation:90ms linear 0ms mat-checkbox-checked-unchecked-checkmark-path}.mat-checkbox-anim-checked-indeterminate .mat-checkbox-checkmark{animation:90ms linear 0ms mat-checkbox-checked-indeterminate-checkmark}.mat-checkbox-anim-checked-indeterminate .mat-checkbox-mixedmark{animation:90ms linear 0ms mat-checkbox-checked-indeterminate-mixedmark}.mat-checkbox-anim-indeterminate-checked .mat-checkbox-checkmark{animation:500ms linear 0ms mat-checkbox-indeterminate-checked-checkmark}.mat-checkbox-anim-indeterminate-checked .mat-checkbox-mixedmark{animation:500ms linear 0ms mat-checkbox-indeterminate-checked-mixedmark}.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-background{animation:180ms linear 0ms mat-checkbox-fade-out-background}.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-mixedmark{animation:300ms linear 0ms mat-checkbox-indeterminate-unchecked-mixedmark}.mat-checkbox-input{bottom:0;left:50%}.mat-checkbox-input:focus~.mat-focus-indicator::before{content:""}'],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })(),
      YM = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({}), n;
      })(),
      k4 = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [sa, $, Zc, YM, $, YM]
        }), n;
      })();
    function oue(n, t) {
      if (1 & n && (_(0, "div")(1, "mat-checkbox", 4), S(2), y()()), 2 & n) {
        const e = t.$implicit,
          a = t.index,
          i = x();
        g(1), b("disabled", "view" === i.mode)("formControl", e)("aria-label", i.node.options[a].label), g(1), Fe(" ", i.node.options[a].label, " ");
      }
    }
    let t0 = /*#__PURE__*/(() => {
      class t0 {
        formGroup;
        control;
        node;
        mode;
        index;
        changed = new E();
        ngOnInit() {
          this.formGroup.get("values").setValue(this.getValue(this.node.options, this.node.model[this.node.key], this.node.valueLocation)), this.formGroup.get("values").valueChanges.subscribe(t => {
            this.node.model[this.node.key] = this.setValue(t, this.node.options, this.node.model[this.node.key], this.node.valueLocation), this.changed.emit({
              type: this.node.type,
              subtype: this.node.subtype,
              model: this.node.model,
              key: this.node.key,
              index: 0,
              location: this.node.valueLocation,
              value: t
            });
          });
        }
        setChecked(t, e) {
          e.setValue(t.checked);
        }
        getLiteralMap(t) {
          return t.map(function (a) {
            return a.label;
          });
        }
        getValue(t, e, a) {
          const i = [],
            o = this.getLiteralMap(t);
          if (o.forEach(function () {
            i.push(!1);
          }), e) for (let r = 0; r < e.length; r++) i[o.indexOf(e[r][a])] = !0;
          return i;
        }
        setValue(t, e, a, i) {
          const o = [],
            r = this.getLiteralMap(e);
          for (let s = 0; s < t.length; s++) {
            const c = {};
            c[i] = r[t[s]], o.push(c);
          }
          return o;
        }
        static ɵfac = function (e) {
          return new (e || t0)();
        };
        static ɵcmp = q({
          type: t0,
          selectors: [["app-checkbox"]],
          inputs: {
            formGroup: "formGroup",
            control: "control",
            node: "node",
            mode: "mode",
            index: "index"
          },
          outputs: {
            changed: "changed"
          },
          decls: 4,
          vars: 2,
          consts: [["div", "", 1, "mat-form-field", "mat-form-field-checkbox"], [3, "formGroup"], [4, "ngFor", "ngForOf"], [1, "input-separator"], ["type", "\u201dcheckbox\u201d", 3, "disabled", "formControl", "aria-label"]],
          template: function (e, a) {
            1 & e && (_(0, "div", 0)(1, "div", 1), D(2, oue, 3, 4, "div", 2), y()(), j(3, "div", 3)), 2 & e && (g(1), b("formGroup", a.formGroup), g(1), b("ngForOf", a.formGroup.controls.values.controls));
          },
          dependencies: [ea, oa, zo, Pa, ra, w4],
          styles: ['.mat-badge-content[_ngcontent-%COMP%]{font-weight:600;font-size:12px;font-family:Roboto,Helvetica Neue,sans-serif}.mat-badge-small[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{font-size:9px}.mat-badge-large[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{font-size:24px}.mat-h1[_ngcontent-%COMP%], .mat-headline[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-headline[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font:400 24px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h2[_ngcontent-%COMP%], .mat-title[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-title[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h3[_ngcontent-%COMP%], .mat-subheading-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h3[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-subheading-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font:400 16px/28px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h4[_ngcontent-%COMP%], .mat-subheading-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h4[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-subheading-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{font:400 15px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h5[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h5[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font:400 11.62px/20px Roboto,Helvetica Neue,sans-serif;margin:0 0 12px}.mat-h6[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h6[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font:400 9.38px/20px Roboto,Helvetica Neue,sans-serif;margin:0 0 12px}.mat-body-strong[_ngcontent-%COMP%], .mat-body-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body-strong[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body-2[_ngcontent-%COMP%]{font:500 14px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-body[_ngcontent-%COMP%], .mat-body-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-body[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-body-1[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body-1[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0 0 12px}.mat-small[_ngcontent-%COMP%], .mat-caption[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-small[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-caption[_ngcontent-%COMP%]{font:400 12px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-display-4[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-4[_ngcontent-%COMP%]{font:300 112px/112px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.05em;margin:0 0 56px}.mat-display-3[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-3[_ngcontent-%COMP%]{font:400 56px/56px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.02em;margin:0 0 64px}.mat-display-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-2[_ngcontent-%COMP%]{font:400 45px/48px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.005em;margin:0 0 64px}.mat-display-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-1[_ngcontent-%COMP%]{font:400 34px/40px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 64px}.mat-bottom-sheet-container[_ngcontent-%COMP%]{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-button[_ngcontent-%COMP%], .mat-raised-button[_ngcontent-%COMP%], .mat-icon-button[_ngcontent-%COMP%], .mat-stroked-button[_ngcontent-%COMP%], .mat-flat-button[_ngcontent-%COMP%], .mat-fab[_ngcontent-%COMP%], .mat-mini-fab[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-button-toggle[_ngcontent-%COMP%], .mat-card[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-card-title[_ngcontent-%COMP%]{font-size:24px;font-weight:500}.mat-card-header[_ngcontent-%COMP%]   .mat-card-title[_ngcontent-%COMP%]{font-size:20px}.mat-card-subtitle[_ngcontent-%COMP%], .mat-card-content[_ngcontent-%COMP%]{font-size:14px}.mat-checkbox[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-checkbox-layout[_ngcontent-%COMP%]   .mat-checkbox-label[_ngcontent-%COMP%]{line-height:24px}.mat-chip[_ngcontent-%COMP%]{font-size:14px;font-weight:500}.mat-chip[_ngcontent-%COMP%]   .mat-chip-trailing-icon.mat-icon[_ngcontent-%COMP%], .mat-chip[_ngcontent-%COMP%]   .mat-chip-remove.mat-icon[_ngcontent-%COMP%]{font-size:18px}.mat-table[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-header-cell[_ngcontent-%COMP%]{font-size:12px;font-weight:500}.mat-cell[_ngcontent-%COMP%], .mat-footer-cell[_ngcontent-%COMP%]{font-size:14px}.mat-calendar[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-calendar-body[_ngcontent-%COMP%]{font-size:13px}.mat-calendar-body-label[_ngcontent-%COMP%], .mat-calendar-period-button[_ngcontent-%COMP%]{font-size:14px;font-weight:500}.mat-calendar-table-header[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-size:11px;font-weight:400}.mat-dialog-title[_ngcontent-%COMP%]{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-expansion-panel-header[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:15px;font-weight:400}.mat-expansion-panel-content[_ngcontent-%COMP%]{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-form-field[_ngcontent-%COMP%]{font-size:inherit;font-weight:400;line-height:1.125;font-family:Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-form-field-wrapper[_ngcontent-%COMP%]{padding-bottom:1.34375em}.mat-form-field-prefix[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-form-field-suffix[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{font-size:150%;line-height:1.125}.mat-form-field-prefix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%], .mat-form-field-suffix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]{height:1.5em;width:1.5em}.mat-form-field-prefix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-form-field-suffix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{height:1.125em;line-height:1.125}.mat-form-field-infix[_ngcontent-%COMP%]{padding:.5em 0;border-top:.84375em solid transparent}.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.34375em) scale(.75);width:133.3333333333%}.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.34374em) scale(.75);width:133.3333433333%}.mat-form-field-label-wrapper[_ngcontent-%COMP%]{top:-.84375em;padding-top:.84375em}.mat-form-field-label[_ngcontent-%COMP%]{top:1.34375em}.mat-form-field-underline[_ngcontent-%COMP%]{bottom:1.34375em}.mat-form-field-subscript-wrapper[_ngcontent-%COMP%]{font-size:75%;margin-top:.6666666667em;top:calc(100% - 1.7916666667em)}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-wrapper[_ngcontent-%COMP%]{padding-bottom:1.25em}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]{padding:.4375em 0}.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.001px);width:133.3333333333%}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-form-field-autofill-control[_ngcontent-%COMP%]:-webkit-autofill + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00101px);width:133.3333433333%}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00102px);width:133.3333533333%}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{top:1.28125em}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]{bottom:1.25em}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-subscript-wrapper[_ngcontent-%COMP%]{margin-top:.5416666667em;top:calc(100% - 1.6666666667em)}@media print{.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28122em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-form-field-autofill-control[_ngcontent-%COMP%]:-webkit-autofill + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28121em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.2812em) scale(.75)}}.mat-form-field-appearance-fill[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]{padding:.25em 0 .75em}.mat-form-field-appearance-fill[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{top:1.09375em;margin-top:-.5em}.mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-fill.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-.59375em) scale(.75);width:133.3333333333%}.mat-form-field-appearance-fill.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-.59374em) scale(.75);width:133.3333433333%}.mat-form-field-appearance-outline[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]{padding:1em 0}.mat-form-field-appearance-outline[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{top:1.84375em;margin-top:-.25em}.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-outline.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.59375em) scale(.75);width:133.3333333333%}.mat-form-field-appearance-outline.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.59374em) scale(.75);width:133.3333433333%}.mat-grid-tile-header[_ngcontent-%COMP%], .mat-grid-tile-footer[_ngcontent-%COMP%]{font-size:14px}.mat-grid-tile-header[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%], .mat-grid-tile-footer[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-grid-tile-header[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2), .mat-grid-tile-footer[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2){font-size:12px}input.mat-input-element[_ngcontent-%COMP%]{margin-top:-.0625em}.mat-menu-item[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:400}.mat-paginator[_ngcontent-%COMP%], .mat-paginator-page-size[_ngcontent-%COMP%]   .mat-select-trigger[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px}.mat-radio-button[_ngcontent-%COMP%], .mat-select[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-select-trigger[_ngcontent-%COMP%]{height:1.125em}.mat-slide-toggle-content[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-slider-thumb-label-text[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px;font-weight:500}.mat-stepper-vertical[_ngcontent-%COMP%], .mat-stepper-horizontal[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-step-label[_ngcontent-%COMP%]{font-size:14px;font-weight:400}.mat-step-sub-label-error[_ngcontent-%COMP%]{font-weight:400}.mat-step-label-error[_ngcontent-%COMP%]{font-size:14px}.mat-step-label-selected[_ngcontent-%COMP%]{font-size:14px;font-weight:500}.mat-tab-group[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-tab-label[_ngcontent-%COMP%], .mat-tab-link[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-toolbar[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0}.mat-tooltip[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:10px;padding-top:6px;padding-bottom:6px}.mat-tooltip-handset[_ngcontent-%COMP%]{font-size:14px;padding-top:8px;padding-bottom:8px}.mat-list-item[_ngcontent-%COMP%], .mat-list-option[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-ripple-element[_ngcontent-%COMP%]{background-color:#0000001a}.mat-option[_ngcontent-%COMP%]{color:#000000de}.mat-option[_ngcontent-%COMP%]:hover:not(.mat-option-disabled), .mat-option[_ngcontent-%COMP%]:focus:not(.mat-option-disabled){background:rgba(0,0,0,.04)}.mat-option.mat-selected[_ngcontent-%COMP%]:not(.mat-option-multiple):not(.mat-option-disabled){background:rgba(0,0,0,.04)}.mat-option.mat-active[_ngcontent-%COMP%]{background:rgba(0,0,0,.04);color:#000000de}.mat-option.mat-option-disabled[_ngcontent-%COMP%]{color:#00000061}.mat-primary[_ngcontent-%COMP%]   .mat-option.mat-selected[_ngcontent-%COMP%]:not(.mat-option-disabled){color:#5fa0c5}.mat-accent[_ngcontent-%COMP%]   .mat-option.mat-selected[_ngcontent-%COMP%]:not(.mat-option-disabled){color:#95b8a2}.mat-warn[_ngcontent-%COMP%]   .mat-option.mat-selected[_ngcontent-%COMP%]:not(.mat-option-disabled){color:#c62e3c}.mat-optgroup-label[_ngcontent-%COMP%]{color:#0000008a}.mat-optgroup-disabled[_ngcontent-%COMP%]   .mat-optgroup-label[_ngcontent-%COMP%]{color:#00000061}.mat-pseudo-checkbox[_ngcontent-%COMP%]{color:#0000008a}.mat-pseudo-checkbox[_ngcontent-%COMP%]:after{color:#fafafa}.mat-pseudo-checkbox-disabled[_ngcontent-%COMP%]{color:#b0b0b0}.mat-primary[_ngcontent-%COMP%]   .mat-pseudo-checkbox-checked[_ngcontent-%COMP%], .mat-primary[_ngcontent-%COMP%]   .mat-pseudo-checkbox-indeterminate[_ngcontent-%COMP%]{background:#5fa0c5}.mat-pseudo-checkbox-checked[_ngcontent-%COMP%], .mat-pseudo-checkbox-indeterminate[_ngcontent-%COMP%], .mat-accent[_ngcontent-%COMP%]   .mat-pseudo-checkbox-checked[_ngcontent-%COMP%], .mat-accent[_ngcontent-%COMP%]   .mat-pseudo-checkbox-indeterminate[_ngcontent-%COMP%]{background:#95b8a2}.mat-warn[_ngcontent-%COMP%]   .mat-pseudo-checkbox-checked[_ngcontent-%COMP%], .mat-warn[_ngcontent-%COMP%]   .mat-pseudo-checkbox-indeterminate[_ngcontent-%COMP%]{background:#c62e3c}.mat-pseudo-checkbox-checked.mat-pseudo-checkbox-disabled[_ngcontent-%COMP%], .mat-pseudo-checkbox-indeterminate.mat-pseudo-checkbox-disabled[_ngcontent-%COMP%]{background:#b0b0b0}.mat-app-background[_ngcontent-%COMP%]{background-color:#fafafa;color:#000000de}.mat-elevation-z0[_ngcontent-%COMP%]{box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-elevation-z1[_ngcontent-%COMP%]{box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.mat-elevation-z2[_ngcontent-%COMP%]{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-elevation-z3[_ngcontent-%COMP%]{box-shadow:0 3px 3px -2px #0003,0 3px 4px #00000024,0 1px 8px #0000001f}.mat-elevation-z4[_ngcontent-%COMP%]{box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mat-elevation-z5[_ngcontent-%COMP%]{box-shadow:0 3px 5px -1px #0003,0 5px 8px #00000024,0 1px 14px #0000001f}.mat-elevation-z6[_ngcontent-%COMP%]{box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mat-elevation-z7[_ngcontent-%COMP%]{box-shadow:0 4px 5px -2px #0003,0 7px 10px 1px #00000024,0 2px 16px 1px #0000001f}.mat-elevation-z8[_ngcontent-%COMP%]{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.mat-elevation-z9[_ngcontent-%COMP%]{box-shadow:0 5px 6px -3px #0003,0 9px 12px 1px #00000024,0 3px 16px 2px #0000001f}.mat-elevation-z10[_ngcontent-%COMP%]{box-shadow:0 6px 6px -3px #0003,0 10px 14px 1px #00000024,0 4px 18px 3px #0000001f}.mat-elevation-z11[_ngcontent-%COMP%]{box-shadow:0 6px 7px -4px #0003,0 11px 15px 1px #00000024,0 4px 20px 3px #0000001f}.mat-elevation-z12[_ngcontent-%COMP%]{box-shadow:0 7px 8px -4px #0003,0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f}.mat-elevation-z13[_ngcontent-%COMP%]{box-shadow:0 7px 8px -4px #0003,0 13px 19px 2px #00000024,0 5px 24px 4px #0000001f}.mat-elevation-z14[_ngcontent-%COMP%]{box-shadow:0 7px 9px -4px #0003,0 14px 21px 2px #00000024,0 5px 26px 4px #0000001f}.mat-elevation-z15[_ngcontent-%COMP%]{box-shadow:0 8px 9px -5px #0003,0 15px 22px 2px #00000024,0 6px 28px 5px #0000001f}.mat-elevation-z16[_ngcontent-%COMP%]{box-shadow:0 8px 10px -5px #0003,0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f}.mat-elevation-z17[_ngcontent-%COMP%]{box-shadow:0 8px 11px -5px #0003,0 17px 26px 2px #00000024,0 6px 32px 5px #0000001f}.mat-elevation-z18[_ngcontent-%COMP%]{box-shadow:0 9px 11px -5px #0003,0 18px 28px 2px #00000024,0 7px 34px 6px #0000001f}.mat-elevation-z19[_ngcontent-%COMP%]{box-shadow:0 9px 12px -6px #0003,0 19px 29px 2px #00000024,0 7px 36px 6px #0000001f}.mat-elevation-z20[_ngcontent-%COMP%]{box-shadow:0 10px 13px -6px #0003,0 20px 31px 3px #00000024,0 8px 38px 7px #0000001f}.mat-elevation-z21[_ngcontent-%COMP%]{box-shadow:0 10px 13px -6px #0003,0 21px 33px 3px #00000024,0 8px 40px 7px #0000001f}.mat-elevation-z22[_ngcontent-%COMP%]{box-shadow:0 10px 14px -6px #0003,0 22px 35px 3px #00000024,0 8px 42px 7px #0000001f}.mat-elevation-z23[_ngcontent-%COMP%]{box-shadow:0 11px 14px -7px #0003,0 23px 36px 3px #00000024,0 9px 44px 8px #0000001f}.mat-elevation-z24[_ngcontent-%COMP%]{box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f}.mat-theme-loaded-marker[_ngcontent-%COMP%]{display:none}.mat-autocomplete-panel[_ngcontent-%COMP%]{background:white;color:#000000de}.mat-autocomplete-panel[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-option.mat-selected[_ngcontent-%COMP%]:not(.mat-active):not(:hover){background:white}.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-option.mat-selected[_ngcontent-%COMP%]:not(.mat-active):not(:hover):not(.mat-option-disabled){color:#000000de}.mat-badge[_ngcontent-%COMP%]{position:relative}.mat-badge.mat-badge[_ngcontent-%COMP%]{overflow:visible}.mat-badge-hidden[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{display:none}.mat-badge-content[_ngcontent-%COMP%]{position:absolute;text-align:center;display:inline-block;border-radius:50%;transition:transform .2s ease-in-out;transform:scale(.6);overflow:hidden;white-space:nowrap;text-overflow:ellipsis;pointer-events:none}.ng-animate-disabled[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%], .mat-badge-content._mat-animation-noopable[_ngcontent-%COMP%]{transition:none}.mat-badge-content.mat-badge-active[_ngcontent-%COMP%]{transform:none}.mat-badge-small[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{width:16px;height:16px;line-height:16px}.mat-badge-small.mat-badge-above[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{top:-8px}.mat-badge-small.mat-badge-below[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{bottom:-8px}.mat-badge-small.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:-16px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-small.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:auto;right:-16px}.mat-badge-small.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:-16px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-small.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:auto;left:-16px}.mat-badge-small.mat-badge-overlap.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:-8px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-small.mat-badge-overlap.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:auto;right:-8px}.mat-badge-small.mat-badge-overlap.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:-8px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-small.mat-badge-overlap.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:auto;left:-8px}.mat-badge-medium[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{width:22px;height:22px;line-height:22px}.mat-badge-medium.mat-badge-above[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{top:-11px}.mat-badge-medium.mat-badge-below[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{bottom:-11px}.mat-badge-medium.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:-22px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-medium.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:auto;right:-22px}.mat-badge-medium.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:-22px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-medium.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:auto;left:-22px}.mat-badge-medium.mat-badge-overlap.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:-11px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-medium.mat-badge-overlap.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:auto;right:-11px}.mat-badge-medium.mat-badge-overlap.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:-11px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-medium.mat-badge-overlap.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:auto;left:-11px}.mat-badge-large[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{width:28px;height:28px;line-height:28px}.mat-badge-large.mat-badge-above[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{top:-14px}.mat-badge-large.mat-badge-below[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{bottom:-14px}.mat-badge-large.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:-28px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-large.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:auto;right:-28px}.mat-badge-large.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:-28px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-large.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:auto;left:-28px}.mat-badge-large.mat-badge-overlap.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:-14px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-large.mat-badge-overlap.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:auto;right:-14px}.mat-badge-large.mat-badge-overlap.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:-14px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-large.mat-badge-overlap.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:auto;left:-14px}.mat-badge-content[_ngcontent-%COMP%]{color:#000;background:#5fa0c5}.cdk-high-contrast-active[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{outline:solid 1px;border-radius:0}.mat-badge-accent[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{background:#95b8a2;color:#000}.mat-badge-warn[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{color:#fff;background:#c62e3c}.mat-badge-disabled[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{background:#b9b9b9;color:#00000061}.mat-bottom-sheet-container[_ngcontent-%COMP%]{box-shadow:0 8px 10px -5px #0003,0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f;background:white;color:#000000de}.mat-button[_ngcontent-%COMP%], .mat-icon-button[_ngcontent-%COMP%], .mat-stroked-button[_ngcontent-%COMP%]{color:inherit;background:transparent}.mat-button.mat-primary[_ngcontent-%COMP%], .mat-icon-button.mat-primary[_ngcontent-%COMP%], .mat-stroked-button.mat-primary[_ngcontent-%COMP%]{color:#5fa0c5}.mat-button.mat-accent[_ngcontent-%COMP%], .mat-icon-button.mat-accent[_ngcontent-%COMP%], .mat-stroked-button.mat-accent[_ngcontent-%COMP%]{color:#95b8a2}.mat-button.mat-warn[_ngcontent-%COMP%], .mat-icon-button.mat-warn[_ngcontent-%COMP%], .mat-stroked-button.mat-warn[_ngcontent-%COMP%]{color:#c62e3c}.mat-button.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-button.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-button.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%], .mat-icon-button.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-icon-button.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-icon-button.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-icon-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%], .mat-stroked-button.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-stroked-button.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-stroked-button.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-stroked-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%]{color:#00000042}.mat-button.mat-primary[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%], .mat-icon-button.mat-primary[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%], .mat-stroked-button.mat-primary[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-button.mat-accent[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%], .mat-icon-button.mat-accent[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%], .mat-stroked-button.mat-accent[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-button.mat-warn[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%], .mat-icon-button.mat-warn[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%], .mat-stroked-button.mat-warn[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-button.mat-button-disabled[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%], .mat-icon-button.mat-button-disabled[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%], .mat-stroked-button.mat-button-disabled[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%]{background-color:transparent}.mat-button[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-icon-button[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-stroked-button[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{opacity:.1;background-color:currentColor}.mat-button-focus-overlay[_ngcontent-%COMP%]{background:black}.mat-stroked-button[_ngcontent-%COMP%]:not(.mat-button-disabled){border-color:#0000001f}.mat-flat-button[_ngcontent-%COMP%], .mat-raised-button[_ngcontent-%COMP%], .mat-fab[_ngcontent-%COMP%], .mat-mini-fab[_ngcontent-%COMP%]{color:#000000de;background-color:#fff}.mat-flat-button.mat-primary[_ngcontent-%COMP%], .mat-raised-button.mat-primary[_ngcontent-%COMP%], .mat-fab.mat-primary[_ngcontent-%COMP%], .mat-mini-fab.mat-primary[_ngcontent-%COMP%], .mat-flat-button.mat-accent[_ngcontent-%COMP%], .mat-raised-button.mat-accent[_ngcontent-%COMP%], .mat-fab.mat-accent[_ngcontent-%COMP%], .mat-mini-fab.mat-accent[_ngcontent-%COMP%]{color:#000}.mat-flat-button.mat-warn[_ngcontent-%COMP%], .mat-raised-button.mat-warn[_ngcontent-%COMP%], .mat-fab.mat-warn[_ngcontent-%COMP%], .mat-mini-fab.mat-warn[_ngcontent-%COMP%]{color:#fff}.mat-flat-button.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-flat-button.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-flat-button.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-flat-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%], .mat-raised-button.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-raised-button.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-raised-button.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-raised-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%], .mat-fab.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-fab.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-fab.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-fab.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%], .mat-mini-fab.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-mini-fab.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-mini-fab.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-mini-fab.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%]{color:#00000042}.mat-flat-button.mat-primary[_ngcontent-%COMP%], .mat-raised-button.mat-primary[_ngcontent-%COMP%], .mat-fab.mat-primary[_ngcontent-%COMP%], .mat-mini-fab.mat-primary[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-flat-button.mat-accent[_ngcontent-%COMP%], .mat-raised-button.mat-accent[_ngcontent-%COMP%], .mat-fab.mat-accent[_ngcontent-%COMP%], .mat-mini-fab.mat-accent[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-flat-button.mat-warn[_ngcontent-%COMP%], .mat-raised-button.mat-warn[_ngcontent-%COMP%], .mat-fab.mat-warn[_ngcontent-%COMP%], .mat-mini-fab.mat-warn[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-flat-button.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-flat-button.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-flat-button.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-flat-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%], .mat-raised-button.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-raised-button.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-raised-button.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-raised-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%], .mat-fab.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-fab.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-fab.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-fab.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%], .mat-mini-fab.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-mini-fab.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-mini-fab.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-mini-fab.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%]{background-color:#0000001f}.mat-flat-button.mat-primary[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-raised-button.mat-primary[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-fab.mat-primary[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-mini-fab.mat-primary[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-flat-button.mat-accent[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-raised-button.mat-accent[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-fab.mat-accent[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-mini-fab.mat-accent[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#0000001a}.mat-flat-button.mat-warn[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-raised-button.mat-warn[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-fab.mat-warn[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-mini-fab.mat-warn[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#ffffff1a}.mat-stroked-button[_ngcontent-%COMP%]:not([class*=mat-elevation-z]), .mat-flat-button[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-raised-button[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-raised-button[_ngcontent-%COMP%]:not(.mat-button-disabled):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.mat-raised-button.mat-button-disabled[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-fab[_ngcontent-%COMP%]:not([class*=mat-elevation-z]), .mat-mini-fab[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mat-fab[_ngcontent-%COMP%]:not(.mat-button-disabled):active:not([class*=mat-elevation-z]), .mat-mini-fab[_ngcontent-%COMP%]:not(.mat-button-disabled):active:not([class*=mat-elevation-z]){box-shadow:0 7px 8px -4px #0003,0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f}.mat-fab.mat-button-disabled[_ngcontent-%COMP%]:not([class*=mat-elevation-z]), .mat-mini-fab.mat-button-disabled[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-button-toggle-standalone[_ngcontent-%COMP%]:not([class*=mat-elevation-z]), .mat-button-toggle-group[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-button-toggle-standalone.mat-button-toggle-appearance-standard[_ngcontent-%COMP%]:not([class*=mat-elevation-z]), .mat-button-toggle-group-appearance-standard[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:none}.mat-button-toggle[_ngcontent-%COMP%]{color:#00000061}.mat-button-toggle[_ngcontent-%COMP%]   .mat-button-toggle-focus-overlay[_ngcontent-%COMP%]{background-color:#0000001f}.mat-button-toggle-appearance-standard[_ngcontent-%COMP%]{color:#000000de;background:white}.mat-button-toggle-appearance-standard[_ngcontent-%COMP%]   .mat-button-toggle-focus-overlay[_ngcontent-%COMP%]{background-color:#000}.mat-button-toggle-group-appearance-standard[_ngcontent-%COMP%]   .mat-button-toggle[_ngcontent-%COMP%] + .mat-button-toggle[_ngcontent-%COMP%]{border-left:solid 1px #e0e0e0}[dir=rtl][_ngcontent-%COMP%]   .mat-button-toggle-group-appearance-standard[_ngcontent-%COMP%]   .mat-button-toggle[_ngcontent-%COMP%] + .mat-button-toggle[_ngcontent-%COMP%]{border-left:none;border-right:solid 1px #e0e0e0}.mat-button-toggle-group-appearance-standard.mat-button-toggle-vertical[_ngcontent-%COMP%]   .mat-button-toggle[_ngcontent-%COMP%] + .mat-button-toggle[_ngcontent-%COMP%]{border-left:none;border-right:none;border-top:solid 1px #e0e0e0}.mat-button-toggle-checked[_ngcontent-%COMP%]{background-color:#e0e0e0;color:#0000008a}.mat-button-toggle-checked.mat-button-toggle-appearance-standard[_ngcontent-%COMP%]{color:#000000de}.mat-button-toggle-disabled[_ngcontent-%COMP%]{color:#00000042;background-color:#eee}.mat-button-toggle-disabled.mat-button-toggle-appearance-standard[_ngcontent-%COMP%]{background:white}.mat-button-toggle-disabled.mat-button-toggle-checked[_ngcontent-%COMP%]{background-color:#bdbdbd}.mat-button-toggle-standalone.mat-button-toggle-appearance-standard[_ngcontent-%COMP%], .mat-button-toggle-group-appearance-standard[_ngcontent-%COMP%]{border:solid 1px #e0e0e0}.mat-button-toggle-appearance-standard[_ngcontent-%COMP%]   .mat-button-toggle-label-content[_ngcontent-%COMP%]{line-height:48px}.mat-card[_ngcontent-%COMP%]{background:white;color:#000000de}.mat-card[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.mat-card.mat-card-flat[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-card-subtitle[_ngcontent-%COMP%]{color:#0000008a}.mat-checkbox-frame[_ngcontent-%COMP%]{border-color:#0000008a}.mat-checkbox-checkmark[_ngcontent-%COMP%]{fill:#fafafa}.mat-checkbox-checkmark-path[_ngcontent-%COMP%]{stroke:#fafafa!important}.mat-checkbox-mixedmark[_ngcontent-%COMP%]{background-color:#fafafa}.mat-checkbox-indeterminate.mat-primary[_ngcontent-%COMP%]   .mat-checkbox-background[_ngcontent-%COMP%], .mat-checkbox-checked.mat-primary[_ngcontent-%COMP%]   .mat-checkbox-background[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-checkbox-indeterminate.mat-accent[_ngcontent-%COMP%]   .mat-checkbox-background[_ngcontent-%COMP%], .mat-checkbox-checked.mat-accent[_ngcontent-%COMP%]   .mat-checkbox-background[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-checkbox-indeterminate.mat-warn[_ngcontent-%COMP%]   .mat-checkbox-background[_ngcontent-%COMP%], .mat-checkbox-checked.mat-warn[_ngcontent-%COMP%]   .mat-checkbox-background[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-checkbox-disabled.mat-checkbox-checked[_ngcontent-%COMP%]   .mat-checkbox-background[_ngcontent-%COMP%], .mat-checkbox-disabled.mat-checkbox-indeterminate[_ngcontent-%COMP%]   .mat-checkbox-background[_ngcontent-%COMP%]{background-color:#b0b0b0}.mat-checkbox-disabled[_ngcontent-%COMP%]:not(.mat-checkbox-checked)   .mat-checkbox-frame[_ngcontent-%COMP%]{border-color:#b0b0b0}.mat-checkbox-disabled[_ngcontent-%COMP%]   .mat-checkbox-label[_ngcontent-%COMP%]{color:#00000061}.mat-checkbox[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#000}.mat-checkbox-checked[_ngcontent-%COMP%]:not(.mat-checkbox-disabled).mat-primary   .mat-ripple-element[_ngcontent-%COMP%], .mat-checkbox[_ngcontent-%COMP%]:active:not(.mat-checkbox-disabled).mat-primary   .mat-ripple-element[_ngcontent-%COMP%]{background:#5fa0c5}.mat-checkbox-checked[_ngcontent-%COMP%]:not(.mat-checkbox-disabled).mat-accent   .mat-ripple-element[_ngcontent-%COMP%], .mat-checkbox[_ngcontent-%COMP%]:active:not(.mat-checkbox-disabled).mat-accent   .mat-ripple-element[_ngcontent-%COMP%]{background:#95b8a2}.mat-checkbox-checked[_ngcontent-%COMP%]:not(.mat-checkbox-disabled).mat-warn   .mat-ripple-element[_ngcontent-%COMP%], .mat-checkbox[_ngcontent-%COMP%]:active:not(.mat-checkbox-disabled).mat-warn   .mat-ripple-element[_ngcontent-%COMP%]{background:#c62e3c}.mat-chip.mat-standard-chip[_ngcontent-%COMP%]{background-color:#e0e0e0;color:#000000de}.mat-chip.mat-standard-chip[_ngcontent-%COMP%]   .mat-chip-remove[_ngcontent-%COMP%]{color:#000000de;opacity:.4}.mat-chip.mat-standard-chip[_ngcontent-%COMP%]:not(.mat-chip-disabled):active{box-shadow:0 3px 3px -2px #0003,0 3px 4px #00000024,0 1px 8px #0000001f}.mat-chip.mat-standard-chip[_ngcontent-%COMP%]:not(.mat-chip-disabled)   .mat-chip-remove[_ngcontent-%COMP%]:hover{opacity:.54}.mat-chip.mat-standard-chip.mat-chip-disabled[_ngcontent-%COMP%]{opacity:.4}.mat-chip.mat-standard-chip[_ngcontent-%COMP%]:after{background:black}.mat-chip.mat-standard-chip.mat-chip-selected.mat-primary[_ngcontent-%COMP%]{background-color:#5fa0c5;color:#000}.mat-chip.mat-standard-chip.mat-chip-selected.mat-primary[_ngcontent-%COMP%]   .mat-chip-remove[_ngcontent-%COMP%]{color:#000;opacity:.4}.mat-chip.mat-standard-chip.mat-chip-selected.mat-primary[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#0000001a}.mat-chip.mat-standard-chip.mat-chip-selected.mat-warn[_ngcontent-%COMP%]{background-color:#c62e3c;color:#fff}.mat-chip.mat-standard-chip.mat-chip-selected.mat-warn[_ngcontent-%COMP%]   .mat-chip-remove[_ngcontent-%COMP%]{color:#fff;opacity:.4}.mat-chip.mat-standard-chip.mat-chip-selected.mat-warn[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#ffffff1a}.mat-chip.mat-standard-chip.mat-chip-selected.mat-accent[_ngcontent-%COMP%]{background-color:#95b8a2;color:#000}.mat-chip.mat-standard-chip.mat-chip-selected.mat-accent[_ngcontent-%COMP%]   .mat-chip-remove[_ngcontent-%COMP%]{color:#000;opacity:.4}.mat-chip.mat-standard-chip.mat-chip-selected.mat-accent[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#0000001a}.mat-table[_ngcontent-%COMP%]{background:white}.mat-table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%], .mat-table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%], .mat-table[_ngcontent-%COMP%]   tfoot[_ngcontent-%COMP%], mat-header-row[_ngcontent-%COMP%], mat-row[_ngcontent-%COMP%], mat-footer-row[_ngcontent-%COMP%], [mat-header-row][_ngcontent-%COMP%], [mat-row][_ngcontent-%COMP%], [mat-footer-row][_ngcontent-%COMP%], .mat-table-sticky[_ngcontent-%COMP%]{background:inherit}mat-row[_ngcontent-%COMP%], mat-header-row[_ngcontent-%COMP%], mat-footer-row[_ngcontent-%COMP%], th.mat-header-cell[_ngcontent-%COMP%], td.mat-cell[_ngcontent-%COMP%], td.mat-footer-cell[_ngcontent-%COMP%]{border-bottom-color:#0000001f}.mat-header-cell[_ngcontent-%COMP%]{color:#0000008a}.mat-cell[_ngcontent-%COMP%], .mat-footer-cell[_ngcontent-%COMP%]{color:#000000de}.mat-calendar-arrow[_ngcontent-%COMP%]{fill:#0000008a}.mat-datepicker-toggle[_ngcontent-%COMP%], .mat-datepicker-content[_ngcontent-%COMP%]   .mat-calendar-next-button[_ngcontent-%COMP%], .mat-datepicker-content[_ngcontent-%COMP%]   .mat-calendar-previous-button[_ngcontent-%COMP%]{color:#0000008a}.mat-calendar-table-header-divider[_ngcontent-%COMP%]:after{background:rgba(0,0,0,.12)}.mat-calendar-table-header[_ngcontent-%COMP%], .mat-calendar-body-label[_ngcontent-%COMP%]{color:#0000008a}.mat-calendar-body-cell-content[_ngcontent-%COMP%], .mat-date-range-input-separator[_ngcontent-%COMP%]{color:#000000de;border-color:transparent}.mat-calendar-body-disabled[_ngcontent-%COMP%] > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){color:#00000061}.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-date-range-input-separator[_ngcontent-%COMP%]{color:#00000061}.mat-calendar-body-in-preview[_ngcontent-%COMP%]{color:#0000003d}.mat-calendar-body-today[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){border-color:#00000061}.mat-calendar-body-disabled[_ngcontent-%COMP%] > .mat-calendar-body-today[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){border-color:#0000002e}.mat-calendar-body-in-range[_ngcontent-%COMP%]:before{background:rgba(95,160,197,.2)}.mat-calendar-body-comparison-identical[_ngcontent-%COMP%], .mat-calendar-body-in-comparison-range[_ngcontent-%COMP%]:before{background:rgba(249,171,0,.2)}.mat-calendar-body-comparison-bridge-start[_ngcontent-%COMP%]:before, [dir=rtl][_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-end[_ngcontent-%COMP%]:before{background:linear-gradient(to right,rgba(95,160,197,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-calendar-body-comparison-bridge-end[_ngcontent-%COMP%]:before, [dir=rtl][_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-start[_ngcontent-%COMP%]:before{background:linear-gradient(to left,rgba(95,160,197,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-calendar-body-in-range[_ngcontent-%COMP%] > .mat-calendar-body-comparison-identical[_ngcontent-%COMP%], .mat-calendar-body-in-comparison-range.mat-calendar-body-in-range[_ngcontent-%COMP%]:after{background:#a8dab5}.mat-calendar-body-comparison-identical.mat-calendar-body-selected[_ngcontent-%COMP%], .mat-calendar-body-in-comparison-range[_ngcontent-%COMP%] > .mat-calendar-body-selected[_ngcontent-%COMP%]{background:#46a35e}.mat-calendar-body-selected[_ngcontent-%COMP%]{background-color:#5fa0c5;color:#000}.mat-calendar-body-disabled[_ngcontent-%COMP%] > .mat-calendar-body-selected[_ngcontent-%COMP%]{background-color:#5fa0c566}.mat-calendar-body-today.mat-calendar-body-selected[_ngcontent-%COMP%]{box-shadow:inset 0 0 0 1px #000}.cdk-keyboard-focused[_ngcontent-%COMP%]   .mat-calendar-body-active[_ngcontent-%COMP%] > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical), .cdk-program-focused[_ngcontent-%COMP%]   .mat-calendar-body-active[_ngcontent-%COMP%] > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#5fa0c54d}@media (hover: hover){.mat-calendar-body-cell[_ngcontent-%COMP%]:not(.mat-calendar-body-disabled):hover > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#5fa0c54d}}.mat-datepicker-content[_ngcontent-%COMP%]{box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f;background-color:#fff;color:#000000de}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-in-range[_ngcontent-%COMP%]:before{background:rgba(149,184,162,.2)}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-comparison-identical[_ngcontent-%COMP%], .mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-in-comparison-range[_ngcontent-%COMP%]:before{background:rgba(249,171,0,.2)}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-start[_ngcontent-%COMP%]:before, .mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   [dir=rtl][_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-end[_ngcontent-%COMP%]:before{background:linear-gradient(to right,rgba(149,184,162,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-end[_ngcontent-%COMP%]:before, .mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   [dir=rtl][_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-start[_ngcontent-%COMP%]:before{background:linear-gradient(to left,rgba(149,184,162,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-in-range[_ngcontent-%COMP%] > .mat-calendar-body-comparison-identical[_ngcontent-%COMP%], .mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-in-comparison-range.mat-calendar-body-in-range[_ngcontent-%COMP%]:after{background:#a8dab5}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-comparison-identical.mat-calendar-body-selected[_ngcontent-%COMP%], .mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-in-comparison-range[_ngcontent-%COMP%] > .mat-calendar-body-selected[_ngcontent-%COMP%]{background:#46a35e}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-selected[_ngcontent-%COMP%]{background-color:#95b8a2;color:#000}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-disabled[_ngcontent-%COMP%] > .mat-calendar-body-selected[_ngcontent-%COMP%]{background-color:#95b8a266}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-today.mat-calendar-body-selected[_ngcontent-%COMP%]{box-shadow:inset 0 0 0 1px #000}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .cdk-keyboard-focused[_ngcontent-%COMP%]   .mat-calendar-body-active[_ngcontent-%COMP%] > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical), .mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .cdk-program-focused[_ngcontent-%COMP%]   .mat-calendar-body-active[_ngcontent-%COMP%] > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#95b8a24d}@media (hover: hover){.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-cell[_ngcontent-%COMP%]:not(.mat-calendar-body-disabled):hover > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#95b8a24d}}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-in-range[_ngcontent-%COMP%]:before{background:rgba(198,46,60,.2)}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-comparison-identical[_ngcontent-%COMP%], .mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-in-comparison-range[_ngcontent-%COMP%]:before{background:rgba(249,171,0,.2)}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-start[_ngcontent-%COMP%]:before, .mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   [dir=rtl][_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-end[_ngcontent-%COMP%]:before{background:linear-gradient(to right,rgba(198,46,60,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-end[_ngcontent-%COMP%]:before, .mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   [dir=rtl][_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-start[_ngcontent-%COMP%]:before{background:linear-gradient(to left,rgba(198,46,60,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-in-range[_ngcontent-%COMP%] > .mat-calendar-body-comparison-identical[_ngcontent-%COMP%], .mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-in-comparison-range.mat-calendar-body-in-range[_ngcontent-%COMP%]:after{background:#a8dab5}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-comparison-identical.mat-calendar-body-selected[_ngcontent-%COMP%], .mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-in-comparison-range[_ngcontent-%COMP%] > .mat-calendar-body-selected[_ngcontent-%COMP%]{background:#46a35e}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-selected[_ngcontent-%COMP%]{background-color:#c62e3c;color:#fff}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-disabled[_ngcontent-%COMP%] > .mat-calendar-body-selected[_ngcontent-%COMP%]{background-color:#c62e3c66}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-today.mat-calendar-body-selected[_ngcontent-%COMP%]{box-shadow:inset 0 0 0 1px #fff}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .cdk-keyboard-focused[_ngcontent-%COMP%]   .mat-calendar-body-active[_ngcontent-%COMP%] > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical), .mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .cdk-program-focused[_ngcontent-%COMP%]   .mat-calendar-body-active[_ngcontent-%COMP%] > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#c62e3c4d}@media (hover: hover){.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-cell[_ngcontent-%COMP%]:not(.mat-calendar-body-disabled):hover > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#c62e3c4d}}.mat-datepicker-content-touch[_ngcontent-%COMP%]{box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f}.mat-datepicker-toggle-active[_ngcontent-%COMP%]{color:#5fa0c5}.mat-datepicker-toggle-active.mat-accent[_ngcontent-%COMP%]{color:#95b8a2}.mat-datepicker-toggle-active.mat-warn[_ngcontent-%COMP%]{color:#c62e3c}.mat-date-range-input-inner[disabled][_ngcontent-%COMP%]{color:#00000061}.mat-dialog-container[_ngcontent-%COMP%]{box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f;background:white;color:#000000de}.mat-divider[_ngcontent-%COMP%]{border-top-color:#0000001f}.mat-divider-vertical[_ngcontent-%COMP%]{border-right-color:#0000001f}.mat-expansion-panel[_ngcontent-%COMP%]{background:white;color:#000000de}.mat-expansion-panel[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-action-row[_ngcontent-%COMP%]{border-top-color:#0000001f}.mat-expansion-panel[_ngcontent-%COMP%]   .mat-expansion-panel-header.cdk-keyboard-focused[_ngcontent-%COMP%]:not([aria-disabled=true]), .mat-expansion-panel[_ngcontent-%COMP%]   .mat-expansion-panel-header.cdk-program-focused[_ngcontent-%COMP%]:not([aria-disabled=true]), .mat-expansion-panel[_ngcontent-%COMP%]:not(.mat-expanded)   .mat-expansion-panel-header[_ngcontent-%COMP%]:hover:not([aria-disabled=true]){background:rgba(0,0,0,.04)}@media (hover: none){.mat-expansion-panel[_ngcontent-%COMP%]:not(.mat-expanded):not([aria-disabled=true])   .mat-expansion-panel-header[_ngcontent-%COMP%]:hover{background:white}}.mat-expansion-panel-header-title[_ngcontent-%COMP%]{color:#000000de}.mat-expansion-panel-header-description[_ngcontent-%COMP%], .mat-expansion-indicator[_ngcontent-%COMP%]:after{color:#0000008a}.mat-expansion-panel-header[aria-disabled=true][_ngcontent-%COMP%]{color:#00000042}.mat-expansion-panel-header[aria-disabled=true][_ngcontent-%COMP%]   .mat-expansion-panel-header-title[_ngcontent-%COMP%], .mat-expansion-panel-header[aria-disabled=true][_ngcontent-%COMP%]   .mat-expansion-panel-header-description[_ngcontent-%COMP%]{color:inherit}.mat-expansion-panel-header[_ngcontent-%COMP%]{height:48px}.mat-expansion-panel-header.mat-expanded[_ngcontent-%COMP%]{height:64px}.mat-form-field-label[_ngcontent-%COMP%], .mat-hint[_ngcontent-%COMP%]{color:#0009}.mat-form-field.mat-focused[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{color:#5fa0c5}.mat-form-field.mat-focused[_ngcontent-%COMP%]   .mat-form-field-label.mat-accent[_ngcontent-%COMP%]{color:#95b8a2}.mat-form-field.mat-focused[_ngcontent-%COMP%]   .mat-form-field-label.mat-warn[_ngcontent-%COMP%]{color:#c62e3c}.mat-focused[_ngcontent-%COMP%]   .mat-form-field-required-marker[_ngcontent-%COMP%]{color:#95b8a2}.mat-form-field-ripple[_ngcontent-%COMP%]{background-color:#000000de}.mat-form-field.mat-focused[_ngcontent-%COMP%]   .mat-form-field-ripple[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-form-field.mat-focused[_ngcontent-%COMP%]   .mat-form-field-ripple.mat-accent[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-form-field.mat-focused[_ngcontent-%COMP%]   .mat-form-field-ripple.mat-warn[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-form-field-type-mat-native-select.mat-focused[_ngcontent-%COMP%]:not(.mat-form-field-invalid)   .mat-form-field-infix[_ngcontent-%COMP%]:after{color:#5fa0c5}.mat-form-field-type-mat-native-select.mat-focused[_ngcontent-%COMP%]:not(.mat-form-field-invalid).mat-accent   .mat-form-field-infix[_ngcontent-%COMP%]:after{color:#95b8a2}.mat-form-field-type-mat-native-select.mat-focused[_ngcontent-%COMP%]:not(.mat-form-field-invalid).mat-warn   .mat-form-field-infix[_ngcontent-%COMP%]:after{color:#c62e3c}.mat-form-field.mat-form-field-invalid[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field.mat-form-field-invalid[_ngcontent-%COMP%]   .mat-form-field-label.mat-accent[_ngcontent-%COMP%], .mat-form-field.mat-form-field-invalid[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]   .mat-form-field-required-marker[_ngcontent-%COMP%]{color:#c62e3c}.mat-form-field.mat-form-field-invalid[_ngcontent-%COMP%]   .mat-form-field-ripple[_ngcontent-%COMP%], .mat-form-field.mat-form-field-invalid[_ngcontent-%COMP%]   .mat-form-field-ripple.mat-accent[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-error[_ngcontent-%COMP%]{color:#c62e3c}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-hint[_ngcontent-%COMP%]{color:#0000008a}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]{background-color:#0000006b}.mat-form-field-appearance-legacy.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]{background-image:linear-gradient(to right,rgba(0,0,0,.42) 0%,rgba(0,0,0,.42) 33%,transparent 0%);background-size:4px 100%;background-repeat:repeat-x}.mat-form-field-appearance-standard[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]{background-color:#0000006b}.mat-form-field-appearance-standard.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]{background-image:linear-gradient(to right,rgba(0,0,0,.42) 0%,rgba(0,0,0,.42) 33%,transparent 0%);background-size:4px 100%;background-repeat:repeat-x}.mat-form-field-appearance-fill[_ngcontent-%COMP%]   .mat-form-field-flex[_ngcontent-%COMP%]{background-color:#0000000a}.mat-form-field-appearance-fill.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-form-field-flex[_ngcontent-%COMP%]{background-color:#00000005}.mat-form-field-appearance-fill[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]:before{background-color:#0000006b}.mat-form-field-appearance-fill.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{color:#00000061}.mat-form-field-appearance-fill.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]:before{background-color:transparent}.mat-form-field-appearance-outline[_ngcontent-%COMP%]   .mat-form-field-outline[_ngcontent-%COMP%]{color:#0000001f}.mat-form-field-appearance-outline[_ngcontent-%COMP%]   .mat-form-field-outline-thick[_ngcontent-%COMP%]{color:#000000de}.mat-form-field-appearance-outline.mat-focused[_ngcontent-%COMP%]   .mat-form-field-outline-thick[_ngcontent-%COMP%]{color:#5fa0c5}.mat-form-field-appearance-outline.mat-focused.mat-accent[_ngcontent-%COMP%]   .mat-form-field-outline-thick[_ngcontent-%COMP%]{color:#95b8a2}.mat-form-field-appearance-outline.mat-focused.mat-warn[_ngcontent-%COMP%]   .mat-form-field-outline-thick[_ngcontent-%COMP%], .mat-form-field-appearance-outline.mat-form-field-invalid.mat-form-field-invalid[_ngcontent-%COMP%]   .mat-form-field-outline-thick[_ngcontent-%COMP%]{color:#c62e3c}.mat-form-field-appearance-outline.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{color:#00000061}.mat-form-field-appearance-outline.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-form-field-outline[_ngcontent-%COMP%]{color:#0000000f}.mat-icon.mat-primary[_ngcontent-%COMP%]{color:#5fa0c5}.mat-icon.mat-accent[_ngcontent-%COMP%]{color:#95b8a2}.mat-icon.mat-warn[_ngcontent-%COMP%]{color:#c62e3c}.mat-form-field-type-mat-native-select[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]:after{color:#0000008a}.mat-input-element[_ngcontent-%COMP%]:disabled, .mat-form-field-type-mat-native-select.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]:after{color:#00000061}.mat-input-element[_ngcontent-%COMP%]{caret-color:#5fa0c5}.mat-input-element[_ngcontent-%COMP%]::placeholder{color:#0000006b}.mat-input-element[_ngcontent-%COMP%]::-moz-placeholder{color:#0000006b}.mat-input-element[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#0000006b}.mat-input-element[_ngcontent-%COMP%]:-ms-input-placeholder{color:#0000006b}.mat-form-field.mat-accent[_ngcontent-%COMP%]   .mat-input-element[_ngcontent-%COMP%]{caret-color:#95b8a2}.mat-form-field.mat-warn[_ngcontent-%COMP%]   .mat-input-element[_ngcontent-%COMP%], .mat-form-field-invalid[_ngcontent-%COMP%]   .mat-input-element[_ngcontent-%COMP%]{caret-color:#c62e3c}.mat-form-field-type-mat-native-select.mat-form-field-invalid[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]:after{color:#c62e3c}.mat-list-base[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%], .mat-list-base[_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]{color:#000000de}.mat-list-base[_ngcontent-%COMP%]   .mat-subheader[_ngcontent-%COMP%]{color:#0000008a}.mat-list-base[_ngcontent-%COMP%]   .mat-list-item-disabled[_ngcontent-%COMP%]{background-color:#eee;color:#00000061}.mat-list-option[_ngcontent-%COMP%]:hover, .mat-list-option[_ngcontent-%COMP%]:focus, .mat-nav-list[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]:hover, .mat-nav-list[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]:focus, .mat-action-list[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]:hover, .mat-action-list[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]:focus{background:rgba(0,0,0,.04)}.mat-list-single-selected-option[_ngcontent-%COMP%], .mat-list-single-selected-option[_ngcontent-%COMP%]:hover, .mat-list-single-selected-option[_ngcontent-%COMP%]:focus{background:rgba(0,0,0,.12)}.mat-menu-panel[_ngcontent-%COMP%]{background:white}.mat-menu-panel[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mat-menu-item[_ngcontent-%COMP%]{background:transparent;color:#000000de}.mat-menu-item[disabled][_ngcontent-%COMP%], .mat-menu-item[disabled][_ngcontent-%COMP%]   .mat-menu-submenu-icon[_ngcontent-%COMP%], .mat-menu-item[disabled][_ngcontent-%COMP%]   .mat-icon-no-color[_ngcontent-%COMP%]{color:#00000061}.mat-menu-item[_ngcontent-%COMP%]   .mat-icon-no-color[_ngcontent-%COMP%], .mat-menu-submenu-icon[_ngcontent-%COMP%]{color:#0000008a}.mat-menu-item[_ngcontent-%COMP%]:hover:not([disabled]), .mat-menu-item.cdk-program-focused[_ngcontent-%COMP%]:not([disabled]), .mat-menu-item.cdk-keyboard-focused[_ngcontent-%COMP%]:not([disabled]), .mat-menu-item-highlighted[_ngcontent-%COMP%]:not([disabled]){background:rgba(0,0,0,.04)}.mat-paginator[_ngcontent-%COMP%]{background:white}.mat-paginator[_ngcontent-%COMP%], .mat-paginator-page-size[_ngcontent-%COMP%]   .mat-select-trigger[_ngcontent-%COMP%]{color:#0000008a}.mat-paginator-decrement[_ngcontent-%COMP%], .mat-paginator-increment[_ngcontent-%COMP%]{border-top:2px solid rgba(0,0,0,.54);border-right:2px solid rgba(0,0,0,.54)}.mat-paginator-first[_ngcontent-%COMP%], .mat-paginator-last[_ngcontent-%COMP%]{border-top:2px solid rgba(0,0,0,.54)}.mat-icon-button[disabled][_ngcontent-%COMP%]   .mat-paginator-decrement[_ngcontent-%COMP%], .mat-icon-button[disabled][_ngcontent-%COMP%]   .mat-paginator-increment[_ngcontent-%COMP%], .mat-icon-button[disabled][_ngcontent-%COMP%]   .mat-paginator-first[_ngcontent-%COMP%], .mat-icon-button[disabled][_ngcontent-%COMP%]   .mat-paginator-last[_ngcontent-%COMP%]{border-color:#00000061}.mat-paginator-container[_ngcontent-%COMP%]{min-height:56px}.mat-progress-bar-background[_ngcontent-%COMP%]{fill:#d3e4ed}.mat-progress-bar-buffer[_ngcontent-%COMP%]{background-color:#d3e4ed}.mat-progress-bar-fill[_ngcontent-%COMP%]:after{background-color:#5fa0c5}.mat-progress-bar.mat-accent[_ngcontent-%COMP%]   .mat-progress-bar-background[_ngcontent-%COMP%]{fill:#e1eae4}.mat-progress-bar.mat-accent[_ngcontent-%COMP%]   .mat-progress-bar-buffer[_ngcontent-%COMP%]{background-color:#e1eae4}.mat-progress-bar.mat-accent[_ngcontent-%COMP%]   .mat-progress-bar-fill[_ngcontent-%COMP%]:after{background-color:#95b8a2}.mat-progress-bar.mat-warn[_ngcontent-%COMP%]   .mat-progress-bar-background[_ngcontent-%COMP%]{fill:#edc7cb}.mat-progress-bar.mat-warn[_ngcontent-%COMP%]   .mat-progress-bar-buffer[_ngcontent-%COMP%]{background-color:#edc7cb}.mat-progress-bar.mat-warn[_ngcontent-%COMP%]   .mat-progress-bar-fill[_ngcontent-%COMP%]:after{background-color:#c62e3c}.mat-progress-spinner[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%], .mat-spinner[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:#5fa0c5}.mat-progress-spinner.mat-accent[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%], .mat-spinner.mat-accent[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:#95b8a2}.mat-progress-spinner.mat-warn[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%], .mat-spinner.mat-warn[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:#c62e3c}.mat-radio-outer-circle[_ngcontent-%COMP%]{border-color:#0000008a}.mat-radio-button.mat-primary.mat-radio-checked[_ngcontent-%COMP%]   .mat-radio-outer-circle[_ngcontent-%COMP%]{border-color:#5fa0c5}.mat-radio-button.mat-primary[_ngcontent-%COMP%]   .mat-radio-inner-circle[_ngcontent-%COMP%], .mat-radio-button.mat-primary[_ngcontent-%COMP%]   .mat-radio-ripple[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]:not(.mat-radio-persistent-ripple), .mat-radio-button.mat-primary.mat-radio-checked[_ngcontent-%COMP%]   .mat-radio-persistent-ripple[_ngcontent-%COMP%], .mat-radio-button.mat-primary[_ngcontent-%COMP%]:active   .mat-radio-persistent-ripple[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-radio-button.mat-accent.mat-radio-checked[_ngcontent-%COMP%]   .mat-radio-outer-circle[_ngcontent-%COMP%]{border-color:#95b8a2}.mat-radio-button.mat-accent[_ngcontent-%COMP%]   .mat-radio-inner-circle[_ngcontent-%COMP%], .mat-radio-button.mat-accent[_ngcontent-%COMP%]   .mat-radio-ripple[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]:not(.mat-radio-persistent-ripple), .mat-radio-button.mat-accent.mat-radio-checked[_ngcontent-%COMP%]   .mat-radio-persistent-ripple[_ngcontent-%COMP%], .mat-radio-button.mat-accent[_ngcontent-%COMP%]:active   .mat-radio-persistent-ripple[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-radio-button.mat-warn.mat-radio-checked[_ngcontent-%COMP%]   .mat-radio-outer-circle[_ngcontent-%COMP%]{border-color:#c62e3c}.mat-radio-button.mat-warn[_ngcontent-%COMP%]   .mat-radio-inner-circle[_ngcontent-%COMP%], .mat-radio-button.mat-warn[_ngcontent-%COMP%]   .mat-radio-ripple[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]:not(.mat-radio-persistent-ripple), .mat-radio-button.mat-warn.mat-radio-checked[_ngcontent-%COMP%]   .mat-radio-persistent-ripple[_ngcontent-%COMP%], .mat-radio-button.mat-warn[_ngcontent-%COMP%]:active   .mat-radio-persistent-ripple[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-radio-button.mat-radio-disabled.mat-radio-checked[_ngcontent-%COMP%]   .mat-radio-outer-circle[_ngcontent-%COMP%], .mat-radio-button.mat-radio-disabled[_ngcontent-%COMP%]   .mat-radio-outer-circle[_ngcontent-%COMP%]{border-color:#00000061}.mat-radio-button.mat-radio-disabled[_ngcontent-%COMP%]   .mat-radio-ripple[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-radio-button.mat-radio-disabled[_ngcontent-%COMP%]   .mat-radio-inner-circle[_ngcontent-%COMP%]{background-color:#00000061}.mat-radio-button.mat-radio-disabled[_ngcontent-%COMP%]   .mat-radio-label-content[_ngcontent-%COMP%]{color:#00000061}.mat-radio-button[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#000}.mat-select-value[_ngcontent-%COMP%]{color:#000000de}.mat-select-placeholder[_ngcontent-%COMP%]{color:#0000006b}.mat-select-disabled[_ngcontent-%COMP%]   .mat-select-value[_ngcontent-%COMP%]{color:#00000061}.mat-select-arrow[_ngcontent-%COMP%]{color:#0000008a}.mat-select-panel[_ngcontent-%COMP%]{background:white}.mat-select-panel[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mat-select-panel[_ngcontent-%COMP%]   .mat-option.mat-selected[_ngcontent-%COMP%]:not(.mat-option-multiple){background:rgba(0,0,0,.12)}.mat-form-field.mat-focused.mat-primary[_ngcontent-%COMP%]   .mat-select-arrow[_ngcontent-%COMP%]{color:#5fa0c5}.mat-form-field.mat-focused.mat-accent[_ngcontent-%COMP%]   .mat-select-arrow[_ngcontent-%COMP%]{color:#95b8a2}.mat-form-field.mat-focused.mat-warn[_ngcontent-%COMP%]   .mat-select-arrow[_ngcontent-%COMP%], .mat-form-field[_ngcontent-%COMP%]   .mat-select.mat-select-invalid[_ngcontent-%COMP%]   .mat-select-arrow[_ngcontent-%COMP%]{color:#c62e3c}.mat-form-field[_ngcontent-%COMP%]   .mat-select.mat-select-disabled[_ngcontent-%COMP%]   .mat-select-arrow[_ngcontent-%COMP%]{color:#00000061}.mat-drawer-container[_ngcontent-%COMP%]{background-color:#fafafa;color:#000000de}.mat-drawer[_ngcontent-%COMP%]{background-color:#fff;color:#000000de}.mat-drawer.mat-drawer-push[_ngcontent-%COMP%]{background-color:#fff}.mat-drawer[_ngcontent-%COMP%]:not(.mat-drawer-side){box-shadow:0 8px 10px -5px #0003,0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f}.mat-drawer-side[_ngcontent-%COMP%]{border-right:solid 1px rgba(0,0,0,.12)}.mat-drawer-side.mat-drawer-end[_ngcontent-%COMP%], [dir=rtl][_ngcontent-%COMP%]   .mat-drawer-side[_ngcontent-%COMP%]{border-left:solid 1px rgba(0,0,0,.12);border-right:none}[dir=rtl][_ngcontent-%COMP%]   .mat-drawer-side.mat-drawer-end[_ngcontent-%COMP%]{border-left:none;border-right:solid 1px rgba(0,0,0,.12)}.mat-drawer-backdrop.mat-drawer-shown[_ngcontent-%COMP%]{background-color:#0009}.mat-slide-toggle.mat-checked[_ngcontent-%COMP%]   .mat-slide-toggle-thumb[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-slide-toggle.mat-checked[_ngcontent-%COMP%]   .mat-slide-toggle-bar[_ngcontent-%COMP%]{background-color:#95b8a28a}.mat-slide-toggle.mat-checked[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-slide-toggle.mat-primary.mat-checked[_ngcontent-%COMP%]   .mat-slide-toggle-thumb[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-slide-toggle.mat-primary.mat-checked[_ngcontent-%COMP%]   .mat-slide-toggle-bar[_ngcontent-%COMP%]{background-color:#5fa0c58a}.mat-slide-toggle.mat-primary.mat-checked[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-slide-toggle.mat-warn.mat-checked[_ngcontent-%COMP%]   .mat-slide-toggle-thumb[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-slide-toggle.mat-warn.mat-checked[_ngcontent-%COMP%]   .mat-slide-toggle-bar[_ngcontent-%COMP%]{background-color:#c62e3c8a}.mat-slide-toggle.mat-warn.mat-checked[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-slide-toggle[_ngcontent-%COMP%]:not(.mat-checked)   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#000}.mat-slide-toggle-thumb[_ngcontent-%COMP%]{box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f;background-color:#fafafa}.mat-slide-toggle-bar[_ngcontent-%COMP%]{background-color:#00000061}.mat-slider-track-background[_ngcontent-%COMP%]{background-color:#00000042}.mat-slider.mat-primary[_ngcontent-%COMP%]   .mat-slider-track-fill[_ngcontent-%COMP%], .mat-slider.mat-primary[_ngcontent-%COMP%]   .mat-slider-thumb[_ngcontent-%COMP%], .mat-slider.mat-primary[_ngcontent-%COMP%]   .mat-slider-thumb-label[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-slider.mat-primary[_ngcontent-%COMP%]   .mat-slider-thumb-label-text[_ngcontent-%COMP%]{color:#000}.mat-slider.mat-primary[_ngcontent-%COMP%]   .mat-slider-focus-ring[_ngcontent-%COMP%]{background-color:#5fa0c533}.mat-slider.mat-accent[_ngcontent-%COMP%]   .mat-slider-track-fill[_ngcontent-%COMP%], .mat-slider.mat-accent[_ngcontent-%COMP%]   .mat-slider-thumb[_ngcontent-%COMP%], .mat-slider.mat-accent[_ngcontent-%COMP%]   .mat-slider-thumb-label[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-slider.mat-accent[_ngcontent-%COMP%]   .mat-slider-thumb-label-text[_ngcontent-%COMP%]{color:#000}.mat-slider.mat-accent[_ngcontent-%COMP%]   .mat-slider-focus-ring[_ngcontent-%COMP%]{background-color:#95b8a233}.mat-slider.mat-warn[_ngcontent-%COMP%]   .mat-slider-track-fill[_ngcontent-%COMP%], .mat-slider.mat-warn[_ngcontent-%COMP%]   .mat-slider-thumb[_ngcontent-%COMP%], .mat-slider.mat-warn[_ngcontent-%COMP%]   .mat-slider-thumb-label[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-slider.mat-warn[_ngcontent-%COMP%]   .mat-slider-thumb-label-text[_ngcontent-%COMP%]{color:#fff}.mat-slider.mat-warn[_ngcontent-%COMP%]   .mat-slider-focus-ring[_ngcontent-%COMP%]{background-color:#c62e3c33}.mat-slider[_ngcontent-%COMP%]:hover   .mat-slider-track-background[_ngcontent-%COMP%], .mat-slider.cdk-focused[_ngcontent-%COMP%]   .mat-slider-track-background[_ngcontent-%COMP%]{background-color:#00000061}.mat-slider.mat-slider-disabled[_ngcontent-%COMP%]   .mat-slider-track-background[_ngcontent-%COMP%], .mat-slider.mat-slider-disabled[_ngcontent-%COMP%]   .mat-slider-track-fill[_ngcontent-%COMP%], .mat-slider.mat-slider-disabled[_ngcontent-%COMP%]   .mat-slider-thumb[_ngcontent-%COMP%], .mat-slider.mat-slider-disabled[_ngcontent-%COMP%]:hover   .mat-slider-track-background[_ngcontent-%COMP%]{background-color:#00000042}.mat-slider.mat-slider-min-value[_ngcontent-%COMP%]   .mat-slider-focus-ring[_ngcontent-%COMP%]{background-color:#0000001f}.mat-slider.mat-slider-min-value.mat-slider-thumb-label-showing[_ngcontent-%COMP%]   .mat-slider-thumb[_ngcontent-%COMP%], .mat-slider.mat-slider-min-value.mat-slider-thumb-label-showing[_ngcontent-%COMP%]   .mat-slider-thumb-label[_ngcontent-%COMP%]{background-color:#000000de}.mat-slider.mat-slider-min-value.mat-slider-thumb-label-showing.cdk-focused[_ngcontent-%COMP%]   .mat-slider-thumb[_ngcontent-%COMP%], .mat-slider.mat-slider-min-value.mat-slider-thumb-label-showing.cdk-focused[_ngcontent-%COMP%]   .mat-slider-thumb-label[_ngcontent-%COMP%]{background-color:#00000042}.mat-slider.mat-slider-min-value[_ngcontent-%COMP%]:not(.mat-slider-thumb-label-showing)   .mat-slider-thumb[_ngcontent-%COMP%]{border-color:#00000042;background-color:transparent}.mat-slider.mat-slider-min-value[_ngcontent-%COMP%]:not(.mat-slider-thumb-label-showing):hover   .mat-slider-thumb[_ngcontent-%COMP%], .mat-slider.mat-slider-min-value[_ngcontent-%COMP%]:not(.mat-slider-thumb-label-showing).cdk-focused   .mat-slider-thumb[_ngcontent-%COMP%]{border-color:#00000061}.mat-slider.mat-slider-min-value[_ngcontent-%COMP%]:not(.mat-slider-thumb-label-showing):hover.mat-slider-disabled   .mat-slider-thumb[_ngcontent-%COMP%], .mat-slider.mat-slider-min-value[_ngcontent-%COMP%]:not(.mat-slider-thumb-label-showing).cdk-focused.mat-slider-disabled   .mat-slider-thumb[_ngcontent-%COMP%]{border-color:#00000042}.mat-slider-has-ticks[_ngcontent-%COMP%]   .mat-slider-wrapper[_ngcontent-%COMP%]:after{border-color:#000000b3}.mat-slider-horizontal[_ngcontent-%COMP%]   .mat-slider-ticks[_ngcontent-%COMP%]{background-image:repeating-linear-gradient(to right,rgba(0,0,0,.7),rgba(0,0,0,.7) 2px,transparent 0,transparent);background-image:-moz-repeating-linear-gradient(.0001deg,rgba(0,0,0,.7),rgba(0,0,0,.7) 2px,transparent 0,transparent)}.mat-slider-vertical[_ngcontent-%COMP%]   .mat-slider-ticks[_ngcontent-%COMP%]{background-image:repeating-linear-gradient(to bottom,rgba(0,0,0,.7),rgba(0,0,0,.7) 2px,transparent 0,transparent)}.mat-step-header.cdk-keyboard-focused[_ngcontent-%COMP%], .mat-step-header.cdk-program-focused[_ngcontent-%COMP%], .mat-step-header[_ngcontent-%COMP%]:hover:not([aria-disabled]), .mat-step-header[_ngcontent-%COMP%]:hover[aria-disabled=false]{background-color:#0000000a}.mat-step-header[_ngcontent-%COMP%]:hover[aria-disabled=true]{cursor:default}@media (hover: none){.mat-step-header[_ngcontent-%COMP%]:hover{background:none}}.mat-step-header[_ngcontent-%COMP%]   .mat-step-label[_ngcontent-%COMP%], .mat-step-header[_ngcontent-%COMP%]   .mat-step-optional[_ngcontent-%COMP%]{color:#0000008a}.mat-step-header[_ngcontent-%COMP%]   .mat-step-icon[_ngcontent-%COMP%]{background-color:#0000008a;color:#000}.mat-step-header[_ngcontent-%COMP%]   .mat-step-icon-selected[_ngcontent-%COMP%], .mat-step-header[_ngcontent-%COMP%]   .mat-step-icon-state-done[_ngcontent-%COMP%], .mat-step-header[_ngcontent-%COMP%]   .mat-step-icon-state-edit[_ngcontent-%COMP%]{background-color:#5fa0c5;color:#000}.mat-step-header.mat-accent[_ngcontent-%COMP%]   .mat-step-icon[_ngcontent-%COMP%]{color:#000}.mat-step-header.mat-accent[_ngcontent-%COMP%]   .mat-step-icon-selected[_ngcontent-%COMP%], .mat-step-header.mat-accent[_ngcontent-%COMP%]   .mat-step-icon-state-done[_ngcontent-%COMP%], .mat-step-header.mat-accent[_ngcontent-%COMP%]   .mat-step-icon-state-edit[_ngcontent-%COMP%]{background-color:#95b8a2;color:#000}.mat-step-header.mat-warn[_ngcontent-%COMP%]   .mat-step-icon[_ngcontent-%COMP%]{color:#fff}.mat-step-header.mat-warn[_ngcontent-%COMP%]   .mat-step-icon-selected[_ngcontent-%COMP%], .mat-step-header.mat-warn[_ngcontent-%COMP%]   .mat-step-icon-state-done[_ngcontent-%COMP%], .mat-step-header.mat-warn[_ngcontent-%COMP%]   .mat-step-icon-state-edit[_ngcontent-%COMP%]{background-color:#c62e3c;color:#fff}.mat-step-header[_ngcontent-%COMP%]   .mat-step-icon-state-error[_ngcontent-%COMP%]{background-color:transparent;color:#c62e3c}.mat-step-header[_ngcontent-%COMP%]   .mat-step-label.mat-step-label-active[_ngcontent-%COMP%]{color:#000000de}.mat-step-header[_ngcontent-%COMP%]   .mat-step-label.mat-step-label-error[_ngcontent-%COMP%]{color:#c62e3c}.mat-stepper-horizontal[_ngcontent-%COMP%], .mat-stepper-vertical[_ngcontent-%COMP%]{background-color:#fff}.mat-stepper-vertical-line[_ngcontent-%COMP%]:before{border-left-color:#0000001f}.mat-horizontal-stepper-header[_ngcontent-%COMP%]:before, .mat-horizontal-stepper-header[_ngcontent-%COMP%]:after, .mat-stepper-horizontal-line[_ngcontent-%COMP%]{border-top-color:#0000001f}.mat-horizontal-stepper-header[_ngcontent-%COMP%]{height:72px}.mat-stepper-label-position-bottom[_ngcontent-%COMP%]   .mat-horizontal-stepper-header[_ngcontent-%COMP%], .mat-vertical-stepper-header[_ngcontent-%COMP%]{padding:24px}.mat-stepper-vertical-line[_ngcontent-%COMP%]:before{top:-16px;bottom:-16px}.mat-stepper-label-position-bottom[_ngcontent-%COMP%]   .mat-horizontal-stepper-header[_ngcontent-%COMP%]:after, .mat-stepper-label-position-bottom[_ngcontent-%COMP%]   .mat-horizontal-stepper-header[_ngcontent-%COMP%]:before{top:36px}.mat-stepper-label-position-bottom[_ngcontent-%COMP%]   .mat-stepper-horizontal-line[_ngcontent-%COMP%]{top:36px}.mat-sort-header-arrow[_ngcontent-%COMP%]{color:#757575}.mat-tab-nav-bar[_ngcontent-%COMP%], .mat-tab-header[_ngcontent-%COMP%]{border-bottom:1px solid rgba(0,0,0,.12)}.mat-tab-group-inverted-header[_ngcontent-%COMP%]   .mat-tab-nav-bar[_ngcontent-%COMP%], .mat-tab-group-inverted-header[_ngcontent-%COMP%]   .mat-tab-header[_ngcontent-%COMP%]{border-top:1px solid rgba(0,0,0,.12);border-bottom:none}.mat-tab-label[_ngcontent-%COMP%], .mat-tab-link[_ngcontent-%COMP%]{color:#000000de}.mat-tab-label.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-link.mat-tab-disabled[_ngcontent-%COMP%]{color:#00000061}.mat-tab-header-pagination-chevron[_ngcontent-%COMP%]{border-color:#000000de}.mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%]{border-color:#00000061}.mat-tab-group[class*=mat-background-][_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%], .mat-tab-nav-bar[class*=mat-background-][_ngcontent-%COMP%]{border-bottom:none;border-top:none}.mat-tab-group.mat-primary[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-primary[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-primary[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-primary[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-primary[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-primary[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-primary[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-primary[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled){background-color:#3273a34d}.mat-tab-group.mat-primary[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-primary[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-tab-group.mat-primary.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-group.mat-primary.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-primary.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-primary.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%]{background-color:#000}.mat-tab-group.mat-accent[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-accent[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-accent[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-accent[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-accent[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-accent[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-accent[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-accent[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled){background-color:#6791754d}.mat-tab-group.mat-accent[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-accent[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-tab-group.mat-accent.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-group.mat-accent.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-accent.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-accent.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%]{background-color:#000}.mat-tab-group.mat-warn[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-warn[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-warn[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-warn[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-warn[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-warn[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-warn[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-warn[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled){background-color:#a4121a4d}.mat-tab-group.mat-warn[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-warn[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-tab-group.mat-warn.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-group.mat-warn.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-warn.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-warn.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%]{background-color:#fff}.mat-tab-group.mat-background-primary[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-primary[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-primary[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-primary[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled){background-color:#3273a34d}.mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link[_ngcontent-%COMP%]{color:#000}.mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link.mat-tab-disabled[_ngcontent-%COMP%]{color:#0006}.mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before{border-color:#000}.mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%]{border-color:#000;opacity:.4}.mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#000;opacity:.12}.mat-tab-group.mat-background-accent[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-accent[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-accent[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-accent[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled){background-color:#6791754d}.mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link[_ngcontent-%COMP%]{color:#000}.mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link.mat-tab-disabled[_ngcontent-%COMP%]{color:#0006}.mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before{border-color:#000}.mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%]{border-color:#000;opacity:.4}.mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#000;opacity:.12}.mat-tab-group.mat-background-warn[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-warn[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-warn[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-warn[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled){background-color:#a4121a4d}.mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link[_ngcontent-%COMP%]{color:#fff}.mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link.mat-tab-disabled[_ngcontent-%COMP%]{color:#fff6}.mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before{border-color:#fff}.mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%]{border-color:#fff;opacity:.4}.mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#fff;opacity:.12}.mat-toolbar[_ngcontent-%COMP%]{background:whitesmoke;color:#000000de}.mat-toolbar.mat-primary[_ngcontent-%COMP%]{background:#5fa0c5;color:#000}.mat-toolbar.mat-accent[_ngcontent-%COMP%]{background:#95b8a2;color:#000}.mat-toolbar.mat-warn[_ngcontent-%COMP%]{background:#c62e3c;color:#fff}.mat-toolbar[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   .mat-form-field-ripple[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   .mat-focused[_ngcontent-%COMP%]   .mat-form-field-ripple[_ngcontent-%COMP%]{background-color:currentColor}.mat-toolbar[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   .mat-focused[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   .mat-select-value[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   .mat-select-arrow[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   .mat-form-field.mat-focused[_ngcontent-%COMP%]   .mat-select-arrow[_ngcontent-%COMP%]{color:inherit}.mat-toolbar[_ngcontent-%COMP%]   .mat-input-element[_ngcontent-%COMP%]{caret-color:currentColor}.mat-toolbar-multiple-rows[_ngcontent-%COMP%]{min-height:64px}.mat-toolbar-row[_ngcontent-%COMP%], .mat-toolbar-single-row[_ngcontent-%COMP%]{height:64px}@media (max-width: 599px){.mat-toolbar-multiple-rows[_ngcontent-%COMP%]{min-height:56px}.mat-toolbar-row[_ngcontent-%COMP%], .mat-toolbar-single-row[_ngcontent-%COMP%]{height:56px}}.mat-tooltip[_ngcontent-%COMP%]{background:rgba(97,97,97,.9)}.mat-tree[_ngcontent-%COMP%]{background:white}.mat-tree-node[_ngcontent-%COMP%], .mat-nested-tree-node[_ngcontent-%COMP%]{color:#000000de}.mat-tree-node[_ngcontent-%COMP%]{min-height:48px}.mat-snack-bar-container[_ngcontent-%COMP%]{color:#ffffffb3;background:#323232;box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mat-simple-snackbar-action[_ngcontent-%COMP%]{color:#95b8a2}.mat-badge-content[_ngcontent-%COMP%]{font-weight:600;font-size:12px;font-family:Roboto,Helvetica Neue,sans-serif}.mat-badge-small[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{font-size:9px}.mat-badge-large[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{font-size:24px}.mat-h1[_ngcontent-%COMP%], .mat-headline[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-headline[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font:400 24px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h2[_ngcontent-%COMP%], .mat-title[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-title[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h3[_ngcontent-%COMP%], .mat-subheading-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h3[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-subheading-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font:400 16px/28px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h4[_ngcontent-%COMP%], .mat-subheading-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h4[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-subheading-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{font:400 15px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h5[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h5[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font:400 11.62px/20px Roboto,Helvetica Neue,sans-serif;margin:0 0 12px}.mat-h6[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h6[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font:400 9.38px/20px Roboto,Helvetica Neue,sans-serif;margin:0 0 12px}.mat-body-strong[_ngcontent-%COMP%], .mat-body-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body-strong[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body-2[_ngcontent-%COMP%]{font:500 14px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-body[_ngcontent-%COMP%], .mat-body-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-body[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-body-1[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body-1[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0 0 12px}.mat-small[_ngcontent-%COMP%], .mat-caption[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-small[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-caption[_ngcontent-%COMP%]{font:400 12px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-display-4[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-4[_ngcontent-%COMP%]{font:300 112px/112px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.05em;margin:0 0 56px}.mat-display-3[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-3[_ngcontent-%COMP%]{font:400 56px/56px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.02em;margin:0 0 64px}.mat-display-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-2[_ngcontent-%COMP%]{font:400 45px/48px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.005em;margin:0 0 64px}.mat-display-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-1[_ngcontent-%COMP%]{font:400 34px/40px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 64px}.mat-bottom-sheet-container[_ngcontent-%COMP%]{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-button[_ngcontent-%COMP%], .mat-raised-button[_ngcontent-%COMP%], .mat-icon-button[_ngcontent-%COMP%], .mat-stroked-button[_ngcontent-%COMP%], .mat-flat-button[_ngcontent-%COMP%], .mat-fab[_ngcontent-%COMP%], .mat-mini-fab[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-button-toggle[_ngcontent-%COMP%], .mat-card[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-card-title[_ngcontent-%COMP%]{font-size:24px;font-weight:500}.mat-card-header[_ngcontent-%COMP%]   .mat-card-title[_ngcontent-%COMP%]{font-size:20px}.mat-card-subtitle[_ngcontent-%COMP%], .mat-card-content[_ngcontent-%COMP%]{font-size:14px}.mat-checkbox[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-checkbox-layout[_ngcontent-%COMP%]   .mat-checkbox-label[_ngcontent-%COMP%]{line-height:24px}.mat-chip[_ngcontent-%COMP%]{font-size:14px;font-weight:500}.mat-chip[_ngcontent-%COMP%]   .mat-chip-trailing-icon.mat-icon[_ngcontent-%COMP%], .mat-chip[_ngcontent-%COMP%]   .mat-chip-remove.mat-icon[_ngcontent-%COMP%]{font-size:18px}.mat-table[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-header-cell[_ngcontent-%COMP%]{font-size:12px;font-weight:500}.mat-cell[_ngcontent-%COMP%], .mat-footer-cell[_ngcontent-%COMP%]{font-size:14px}.mat-calendar[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-calendar-body[_ngcontent-%COMP%]{font-size:13px}.mat-calendar-body-label[_ngcontent-%COMP%], .mat-calendar-period-button[_ngcontent-%COMP%]{font-size:14px;font-weight:500}.mat-calendar-table-header[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-size:11px;font-weight:400}.mat-dialog-title[_ngcontent-%COMP%]{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-expansion-panel-header[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:15px;font-weight:400}.mat-expansion-panel-content[_ngcontent-%COMP%]{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-form-field[_ngcontent-%COMP%]{font-size:inherit;font-weight:400;line-height:1.125;font-family:Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-form-field-wrapper[_ngcontent-%COMP%]{padding-bottom:1.34375em}.mat-form-field-prefix[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-form-field-suffix[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{font-size:150%;line-height:1.125}.mat-form-field-prefix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%], .mat-form-field-suffix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]{height:1.5em;width:1.5em}.mat-form-field-prefix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-form-field-suffix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{height:1.125em;line-height:1.125}.mat-form-field-infix[_ngcontent-%COMP%]{padding:.5em 0;border-top:.84375em solid transparent}.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.34373em) scale(.75);width:133.3333533333%}.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.34372em) scale(.75);width:133.3333633333%}.mat-form-field-label-wrapper[_ngcontent-%COMP%]{top:-.84375em;padding-top:.84375em}.mat-form-field-label[_ngcontent-%COMP%]{top:1.34375em}.mat-form-field-underline[_ngcontent-%COMP%]{bottom:1.34375em}.mat-form-field-subscript-wrapper[_ngcontent-%COMP%]{font-size:75%;margin-top:.6666666667em;top:calc(100% - 1.7916666667em)}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-wrapper[_ngcontent-%COMP%]{padding-bottom:1.25em}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]{padding:.4375em 0}.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00106px);width:133.3333933333%}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-form-field-autofill-control[_ngcontent-%COMP%]:-webkit-autofill + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00107px);width:133.3334033333%}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00108px);width:133.3334133333%}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{top:1.28125em}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]{bottom:1.25em}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-subscript-wrapper[_ngcontent-%COMP%]{margin-top:.5416666667em;top:calc(100% - 1.6666666667em)}@media print{.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28116em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-form-field-autofill-control[_ngcontent-%COMP%]:-webkit-autofill + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28115em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28114em) scale(.75)}}.mat-form-field-appearance-fill[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]{padding:.25em 0 .75em}.mat-form-field-appearance-fill[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{top:1.09375em;margin-top:-.5em}.mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-fill.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-.59373em) scale(.75);width:133.3333533333%}.mat-form-field-appearance-fill.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-.59372em) scale(.75);width:133.3333633333%}.mat-form-field-appearance-outline[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]{padding:1em 0}.mat-form-field-appearance-outline[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{top:1.84375em;margin-top:-.25em}.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-outline.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.59373em) scale(.75);width:133.3333533333%}.mat-form-field-appearance-outline.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.59372em) scale(.75);width:133.3333633333%}.mat-grid-tile-header[_ngcontent-%COMP%], .mat-grid-tile-footer[_ngcontent-%COMP%]{font-size:14px}.mat-grid-tile-header[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%], .mat-grid-tile-footer[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-grid-tile-header[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2), .mat-grid-tile-footer[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2){font-size:12px}input.mat-input-element[_ngcontent-%COMP%]{margin-top:-.0625em}.mat-menu-item[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:400}.mat-paginator[_ngcontent-%COMP%], .mat-paginator-page-size[_ngcontent-%COMP%]   .mat-select-trigger[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px}.mat-radio-button[_ngcontent-%COMP%], .mat-select[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-select-trigger[_ngcontent-%COMP%]{height:1.125em}.mat-slide-toggle-content[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-slider-thumb-label-text[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px;font-weight:500}.mat-stepper-vertical[_ngcontent-%COMP%], .mat-stepper-horizontal[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-step-label[_ngcontent-%COMP%]{font-size:14px;font-weight:400}.mat-step-sub-label-error[_ngcontent-%COMP%]{font-weight:400}.mat-step-label-error[_ngcontent-%COMP%]{font-size:14px}.mat-step-label-selected[_ngcontent-%COMP%]{font-size:14px;font-weight:500}.mat-tab-group[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-tab-label[_ngcontent-%COMP%], .mat-tab-link[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-toolbar[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0}.mat-tooltip[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:10px;padding-top:6px;padding-bottom:6px}.mat-tooltip-handset[_ngcontent-%COMP%]{font-size:14px;padding-top:8px;padding-bottom:8px}.mat-list-item[_ngcontent-%COMP%], .mat-list-option[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-list-base[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]{font-size:16px}.mat-list-base[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list-base[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2){font-size:14px}.mat-list-base[_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]{font-size:16px}.mat-list-base[_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list-base[_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2){font-size:14px}.mat-list-base[_ngcontent-%COMP%]   .mat-subheader[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]{font-size:12px}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2){font-size:12px}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]{font-size:12px}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2){font-size:12px}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-subheader[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px;font-weight:500}.mat-option[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:16px}.mat-optgroup-label[_ngcontent-%COMP%]{font:500 14px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-simple-snackbar[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px}.mat-simple-snackbar-action[_ngcontent-%COMP%]{line-height:1;font-family:inherit;font-size:inherit;font-weight:500}.mat-tree[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-tree-node[_ngcontent-%COMP%], .mat-nested-tree-node[_ngcontent-%COMP%]{font-weight:400;font-size:14px}.mat-ripple[_ngcontent-%COMP%]{overflow:hidden;position:relative}.mat-ripple[_ngcontent-%COMP%]:not(:empty){transform:translateZ(0)}.mat-ripple.mat-ripple-unbounded[_ngcontent-%COMP%]{overflow:visible}.mat-ripple-element[_ngcontent-%COMP%]{position:absolute;border-radius:50%;pointer-events:none;transition:opacity,transform 0ms cubic-bezier(0,0,.2,1);transform:scale3d(0,0,0)}.cdk-high-contrast-active[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{display:none}.cdk-visually-hidden[_ngcontent-%COMP%]{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap;outline:0;-webkit-appearance:none;-moz-appearance:none;left:0}[dir=rtl][_ngcontent-%COMP%]   .cdk-visually-hidden[_ngcontent-%COMP%]{left:auto;right:0}.cdk-overlay-container[_ngcontent-%COMP%], .cdk-global-overlay-wrapper[_ngcontent-%COMP%]{pointer-events:none;top:0;left:0;height:100%;width:100%}.cdk-overlay-container[_ngcontent-%COMP%]{position:fixed;z-index:1000}.cdk-overlay-container[_ngcontent-%COMP%]:empty{display:none}.cdk-global-overlay-wrapper[_ngcontent-%COMP%]{display:flex;position:absolute;z-index:1000}.cdk-overlay-pane[_ngcontent-%COMP%]{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}.cdk-overlay-backdrop[_ngcontent-%COMP%]{position:absolute;inset:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:1}.cdk-high-contrast-active[_ngcontent-%COMP%]   .cdk-overlay-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:.6}.cdk-overlay-dark-backdrop[_ngcontent-%COMP%]{background:rgba(0,0,0,.32)}.cdk-overlay-transparent-backdrop[_ngcontent-%COMP%]{transition:visibility 1ms linear,opacity 1ms linear;visibility:hidden;opacity:1}.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:0;visibility:visible}.cdk-overlay-backdrop-noop-animation[_ngcontent-%COMP%]{transition:none}.cdk-overlay-connected-position-bounding-box[_ngcontent-%COMP%]{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}.cdk-global-scrollblock[_ngcontent-%COMP%]{position:fixed;width:100%;overflow-y:scroll}textarea.cdk-textarea-autosize[_ngcontent-%COMP%]{resize:none}textarea.cdk-textarea-autosize-measuring[_ngcontent-%COMP%]{padding:2px 0!important;box-sizing:content-box!important;height:auto!important;overflow:hidden!important}textarea.cdk-textarea-autosize-measuring-firefox[_ngcontent-%COMP%]{padding:2px 0!important;box-sizing:content-box!important;height:0!important}@keyframes cdk-text-field-autofill-start{}@keyframes cdk-text-field-autofill-end{}.cdk-text-field-autofill-monitored[_ngcontent-%COMP%]:-webkit-autofill{animation:cdk-text-field-autofill-start 0s 1ms}.cdk-text-field-autofill-monitored[_ngcontent-%COMP%]:not(:-webkit-autofill){animation:cdk-text-field-autofill-end 0s 1ms}.mat-focus-indicator[_ngcontent-%COMP%]{position:relative}.mat-focus-indicator[_ngcontent-%COMP%]:before{inset:0;position:absolute;box-sizing:border-box;pointer-events:none;display:var(--mat-focus-indicator-display, none);border:var(--mat-focus-indicator-border-width, 3px) var(--mat-focus-indicator-border-style, solid) var(--mat-focus-indicator-border-color, transparent);border-radius:var(--mat-focus-indicator-border-radius, 4px)}.mat-focus-indicator[_ngcontent-%COMP%]:focus:before{content:""}.cdk-high-contrast-active[_ngcontent-%COMP%]{--mat-focus-indicator-display: block}.mat-mdc-focus-indicator[_ngcontent-%COMP%]{position:relative}.mat-mdc-focus-indicator[_ngcontent-%COMP%]:before{inset:0;position:absolute;box-sizing:border-box;pointer-events:none;display:var(--mat-mdc-focus-indicator-display, none);border:var(--mat-mdc-focus-indicator-border-width, 3px) var(--mat-mdc-focus-indicator-border-style, solid) var(--mat-mdc-focus-indicator-border-color, transparent);border-radius:var(--mat-mdc-focus-indicator-border-radius, 4px)}.mat-mdc-focus-indicator[_ngcontent-%COMP%]:focus:before{content:""}.cdk-high-contrast-active[_ngcontent-%COMP%]{--mat-mdc-focus-indicator-display: block}.mat-form-field[_ngcontent-%COMP%]{margin-bottom:10px;width:100%}.mat-form-field-checkbox[_ngcontent-%COMP%]{padding:15px 0 20px}[_nghost-%COMP%]     .mat-checkbox-disabled.mat-checkbox-checked .mat-checkbox-background, .mat-checkbox-disabled.mat-checkbox-indeterminate[_ngcontent-%COMP%]   .mat-checkbox-background[_ngcontent-%COMP%]{background-color:#95b8a2}[_nghost-%COMP%]     .mat-checkbox-disabled:not(.mat-checkbox-checked) .mat-checkbox-frame{border-color:#0000008a}[_nghost-%COMP%]     .mat-checkbox-disabled .mat-checkbox-label{color:#000000de}div.input-separator[_ngcontent-%COMP%]{border-bottom:1px solid #a3a3a3;margin-bottom:20px}']
        });
      }
      return t0;
    })();
    const rue = ["input"],
      sue = function (n) {
        return {
          enterDuration: n
        };
      },
      cue = ["*"],
      lue = new O("mat-radio-default-options", {
        providedIn: "root",
        factory: function due() {
          return {
            color: "accent"
          };
        }
      });
    let qM = 0;
    const uue = {
      provide: Bt,
      useExisting: Pe(() => ZM),
      multi: !0
    };
    class KM {
      constructor(t, e) {
        this.source = t, this.value = e;
      }
    }
    const QM = new O("MatRadioGroup");
    let fue = (() => {
        class n {
          constructor(e) {
            this._changeDetector = e, this._value = null, this._name = "mat-radio-group-" + qM++, this._selected = null, this._isInitialized = !1, this._labelPosition = "after", this._disabled = !1, this._required = !1, this._controlValueAccessorChangeFn = () => {}, this.onTouched = () => {}, this.change = new E();
          }
          get name() {
            return this._name;
          }
          set name(e) {
            this._name = e, this._updateRadioButtonNames();
          }
          get labelPosition() {
            return this._labelPosition;
          }
          set labelPosition(e) {
            this._labelPosition = "before" === e ? "before" : "after", this._markRadiosForCheck();
          }
          get value() {
            return this._value;
          }
          set value(e) {
            this._value !== e && (this._value = e, this._updateSelectedRadioFromValue(), this._checkSelectedRadioButton());
          }
          _checkSelectedRadioButton() {
            this._selected && !this._selected.checked && (this._selected.checked = !0);
          }
          get selected() {
            return this._selected;
          }
          set selected(e) {
            this._selected = e, this.value = e ? e.value : null, this._checkSelectedRadioButton();
          }
          get disabled() {
            return this._disabled;
          }
          set disabled(e) {
            this._disabled = Y(e), this._markRadiosForCheck();
          }
          get required() {
            return this._required;
          }
          set required(e) {
            this._required = Y(e), this._markRadiosForCheck();
          }
          ngAfterContentInit() {
            this._isInitialized = !0;
          }
          _touch() {
            this.onTouched && this.onTouched();
          }
          _updateRadioButtonNames() {
            this._radios && this._radios.forEach(e => {
              e.name = this.name, e._markForCheck();
            });
          }
          _updateSelectedRadioFromValue() {
            this._radios && (null === this._selected || this._selected.value !== this._value) && (this._selected = null, this._radios.forEach(a => {
              a.checked = this.value === a.value, a.checked && (this._selected = a);
            }));
          }
          _emitChangeEvent() {
            this._isInitialized && this.change.emit(new KM(this._selected, this._value));
          }
          _markRadiosForCheck() {
            this._radios && this._radios.forEach(e => e._markForCheck());
          }
          writeValue(e) {
            this.value = e, this._changeDetector.markForCheck();
          }
          registerOnChange(e) {
            this._controlValueAccessorChangeFn = e;
          }
          registerOnTouched(e) {
            this.onTouched = e;
          }
          setDisabledState(e) {
            this.disabled = e, this._changeDetector.markForCheck();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Se));
        }, n.ɵdir = P({
          type: n,
          inputs: {
            color: "color",
            name: "name",
            labelPosition: "labelPosition",
            value: "value",
            selected: "selected",
            disabled: "disabled",
            required: "required"
          },
          outputs: {
            change: "change"
          }
        }), n;
      })(),
      ZM = (() => {
        class n extends fue {}
        return n.ɵfac = function () {
          let t;
          return function (a) {
            return (t || (t = he(n)))(a || n);
          };
        }(), n.ɵdir = P({
          type: n,
          selectors: [["mat-radio-group"]],
          contentQueries: function (e, a, i) {
            if (1 & e && De(i, XM, 5), 2 & e) {
              let o;
              H(o = B()) && (a._radios = o);
            }
          },
          hostAttrs: ["role", "radiogroup", 1, "mat-radio-group"],
          exportAs: ["matRadioGroup"],
          features: [G([uue, {
            provide: QM,
            useExisting: n
          }]), z]
        }), n;
      })();
    class mue {
      constructor(t) {
        this._elementRef = t;
      }
    }
    const hue = Za($i(mue));
    let pue = (() => {
        class n extends hue {
          constructor(e, a, i, o, r, s, c, l) {
            super(a), this._changeDetector = i, this._focusMonitor = o, this._radioDispatcher = r, this._providerOverride = c, this._uniqueId = "mat-radio-" + ++qM, this.id = this._uniqueId, this.change = new E(), this._checked = !1, this._value = null, this._removeUniqueSelectionListener = () => {}, this.radioGroup = e, this._noopAnimations = "NoopAnimations" === s, l && (this.tabIndex = xt(l, 0)), this._removeUniqueSelectionListener = r.listen((d, u) => {
              d !== this.id && u === this.name && (this.checked = !1);
            });
          }
          get checked() {
            return this._checked;
          }
          set checked(e) {
            const a = Y(e);
            this._checked !== a && (this._checked = a, a && this.radioGroup && this.radioGroup.value !== this.value ? this.radioGroup.selected = this : !a && this.radioGroup && this.radioGroup.value === this.value && (this.radioGroup.selected = null), a && this._radioDispatcher.notify(this.id, this.name), this._changeDetector.markForCheck());
          }
          get value() {
            return this._value;
          }
          set value(e) {
            this._value !== e && (this._value = e, null !== this.radioGroup && (this.checked || (this.checked = this.radioGroup.value === e), this.checked && (this.radioGroup.selected = this)));
          }
          get labelPosition() {
            return this._labelPosition || this.radioGroup && this.radioGroup.labelPosition || "after";
          }
          set labelPosition(e) {
            this._labelPosition = e;
          }
          get disabled() {
            return this._disabled || null !== this.radioGroup && this.radioGroup.disabled;
          }
          set disabled(e) {
            this._setDisabled(Y(e));
          }
          get required() {
            return this._required || this.radioGroup && this.radioGroup.required;
          }
          set required(e) {
            this._required = Y(e);
          }
          get color() {
            return this._color || this.radioGroup && this.radioGroup.color || this._providerOverride && this._providerOverride.color || "accent";
          }
          set color(e) {
            this._color = e;
          }
          get inputId() {
            return `${this.id || this._uniqueId}-input`;
          }
          focus(e, a) {
            a ? this._focusMonitor.focusVia(this._inputElement, a, e) : this._inputElement.nativeElement.focus(e);
          }
          _markForCheck() {
            this._changeDetector.markForCheck();
          }
          ngOnInit() {
            this.radioGroup && (this.checked = this.radioGroup.value === this._value, this.checked && (this.radioGroup.selected = this), this.name = this.radioGroup.name);
          }
          ngDoCheck() {
            this._updateTabIndex();
          }
          ngAfterViewInit() {
            this._updateTabIndex(), this._focusMonitor.monitor(this._elementRef, !0).subscribe(e => {
              !e && this.radioGroup && this.radioGroup._touch();
            });
          }
          ngOnDestroy() {
            this._focusMonitor.stopMonitoring(this._elementRef), this._removeUniqueSelectionListener();
          }
          _emitChangeEvent() {
            this.change.emit(new KM(this, this._value));
          }
          _isRippleDisabled() {
            return this.disableRipple || this.disabled;
          }
          _onInputClick(e) {
            e.stopPropagation();
          }
          _onInputInteraction(e) {
            if (e.stopPropagation(), !this.checked && !this.disabled) {
              const a = this.radioGroup && this.value !== this.radioGroup.value;
              this.checked = !0, this._emitChangeEvent(), this.radioGroup && (this.radioGroup._controlValueAccessorChangeFn(this.value), a && this.radioGroup._emitChangeEvent());
            }
          }
          _setDisabled(e) {
            this._disabled !== e && (this._disabled = e, this._changeDetector.markForCheck());
          }
          _updateTabIndex() {
            const e = this.radioGroup;
            let a;
            if (a = e && e.selected && !this.disabled ? e.selected === this ? this.tabIndex : -1 : this.tabIndex, a !== this._previousTabIndex) {
              const i = this._inputElement?.nativeElement;
              i && (i.setAttribute("tabindex", a + ""), this._previousTabIndex = a);
            }
          }
        }
        return n.ɵfac = function (e) {
          li();
        }, n.ɵdir = P({
          type: n,
          viewQuery: function (e, a) {
            if (1 & e && be(rue, 5), 2 & e) {
              let i;
              H(i = B()) && (a._inputElement = i.first);
            }
          },
          inputs: {
            id: "id",
            name: "name",
            ariaLabel: ["aria-label", "ariaLabel"],
            ariaLabelledby: ["aria-labelledby", "ariaLabelledby"],
            ariaDescribedby: ["aria-describedby", "ariaDescribedby"],
            checked: "checked",
            value: "value",
            labelPosition: "labelPosition",
            disabled: "disabled",
            required: "required",
            color: "color"
          },
          outputs: {
            change: "change"
          },
          features: [z]
        }), n;
      })(),
      XM = (() => {
        class n extends pue {
          constructor(e, a, i, o, r, s, c, l) {
            super(e, a, i, o, r, s, c, l);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(QM, 8), f(J), f(Se), f(Hn), f(np), f(Ft, 8), f(lue, 8), qt("tabindex"));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-radio-button"]],
          hostAttrs: [1, "mat-radio-button"],
          hostVars: 17,
          hostBindings: function (e, a) {
            1 & e && F("focus", function () {
              return a._inputElement.nativeElement.focus();
            }), 2 & e && (X("tabindex", null)("id", a.id)("aria-label", null)("aria-labelledby", null)("aria-describedby", null), fe("mat-radio-checked", a.checked)("mat-radio-disabled", a.disabled)("_mat-animation-noopable", a._noopAnimations)("mat-primary", "primary" === a.color)("mat-accent", "accent" === a.color)("mat-warn", "warn" === a.color));
          },
          inputs: {
            disableRipple: "disableRipple",
            tabIndex: "tabIndex"
          },
          exportAs: ["matRadioButton"],
          features: [z],
          ngContentSelectors: cue,
          decls: 13,
          vars: 19,
          consts: [[1, "mat-radio-label"], ["label", ""], [1, "mat-radio-container"], [1, "mat-radio-outer-circle"], [1, "mat-radio-inner-circle"], ["type", "radio", 1, "mat-radio-input", 3, "id", "checked", "disabled", "required", "change", "click"], ["input", ""], ["mat-ripple", "", 1, "mat-radio-ripple", "mat-focus-indicator", 3, "matRippleTrigger", "matRippleDisabled", "matRippleCentered", "matRippleRadius", "matRippleAnimation"], [1, "mat-ripple-element", "mat-radio-persistent-ripple"], [1, "mat-radio-label-content"], [2, "display", "none"]],
          template: function (e, a) {
            if (1 & e && (lt(), _(0, "label", 0, 1)(2, "span", 2), j(3, "span", 3)(4, "span", 4), _(5, "input", 5, 6), F("change", function (o) {
              return a._onInputInteraction(o);
            })("click", function (o) {
              return a._onInputClick(o);
            }), y(), _(7, "span", 7), j(8, "span", 8), y()(), _(9, "span", 9)(10, "span", 10), S(11, "\xa0"), y(), Me(12), y()()), 2 & e) {
              const i = Kt(1);
              X("for", a.inputId), g(5), b("id", a.inputId)("checked", a.checked)("disabled", a.disabled)("required", a.required), X("name", a.name)("value", a.value)("aria-label", a.ariaLabel)("aria-labelledby", a.ariaLabelledby)("aria-describedby", a.ariaDescribedby), g(2), b("matRippleTrigger", i)("matRippleDisabled", a._isRippleDisabled())("matRippleCentered", !0)("matRippleRadius", 20)("matRippleAnimation", Vr(17, sue, a._noopAnimations ? 0 : 150)), g(2), fe("mat-radio-label-before", "before" == a.labelPosition);
            }
          },
          dependencies: [Xa],
          styles: ['.mat-radio-button{display:inline-block;-webkit-tap-highlight-color:rgba(0,0,0,0);outline:0}.mat-radio-label{-webkit-user-select:none;user-select:none;cursor:pointer;display:inline-flex;align-items:center;white-space:nowrap;vertical-align:middle;width:100%}.mat-radio-container{box-sizing:border-box;display:inline-block;position:relative;width:20px;height:20px;flex-shrink:0}.mat-radio-outer-circle{box-sizing:border-box;display:block;height:20px;left:0;position:absolute;top:0;transition:border-color ease 280ms;width:20px;border-width:2px;border-style:solid;border-radius:50%}._mat-animation-noopable .mat-radio-outer-circle{transition:none}.mat-radio-inner-circle{border-radius:50%;box-sizing:border-box;display:block;height:20px;left:0;position:absolute;top:0;opacity:0;transition:transform ease 280ms,background-color ease 280ms,opacity linear 1ms 280ms;width:20px;transform:scale(0.001);-webkit-print-color-adjust:exact;color-adjust:exact}.mat-radio-checked .mat-radio-inner-circle{transform:scale(0.5);opacity:1;transition:transform ease 280ms,background-color ease 280ms}.cdk-high-contrast-active .mat-radio-checked .mat-radio-inner-circle{border:solid 10px}._mat-animation-noopable .mat-radio-inner-circle{transition:none}.mat-radio-label-content{-webkit-user-select:auto;user-select:auto;display:inline-block;order:0;line-height:inherit;padding-left:8px;padding-right:0}[dir=rtl] .mat-radio-label-content{padding-right:8px;padding-left:0}.mat-radio-label-content.mat-radio-label-before{order:-1;padding-left:0;padding-right:8px}[dir=rtl] .mat-radio-label-content.mat-radio-label-before{padding-right:0;padding-left:8px}.mat-radio-disabled,.mat-radio-disabled .mat-radio-label{cursor:default}.mat-radio-button .mat-radio-ripple{position:absolute;left:calc(50% - 20px);top:calc(50% - 20px);height:40px;width:40px;z-index:1;pointer-events:none}.mat-radio-button .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple){opacity:.16}.mat-radio-persistent-ripple{width:100%;height:100%;transform:none;top:0;left:0}.mat-radio-container:hover .mat-radio-persistent-ripple{opacity:.04}.mat-radio-button:not(.mat-radio-disabled).cdk-keyboard-focused .mat-radio-persistent-ripple,.mat-radio-button:not(.mat-radio-disabled).cdk-program-focused .mat-radio-persistent-ripple{opacity:.12}.mat-radio-persistent-ripple,.mat-radio-disabled .mat-radio-container:hover .mat-radio-persistent-ripple{opacity:0}@media(hover: none){.mat-radio-container:hover .mat-radio-persistent-ripple{display:none}}.mat-radio-input{opacity:0;position:absolute;top:0;left:0;margin:0;width:100%;height:100%;cursor:inherit;z-index:-1}.mat-radio-input:focus~.mat-focus-indicator::before{content:""}.cdk-high-contrast-active .mat-radio-disabled{opacity:.5}'],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })(),
      JM = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [sa, $, $]
        }), n;
      })();
    function gue(n, t) {
      if (1 & n && (_(0, "div")(1, "mat-radio-button", 4), S(2), y()()), 2 & n) {
        const e = t.$implicit,
          a = t.index,
          i = x();
        g(1), b("value", a)("aria-label", i.node.options[a].label)("name", i.node.key + "radio"), g(1), Fe(" ", e.label, " ");
      }
    }
    let n0 = /*#__PURE__*/(() => {
      class n0 {
        formGroup;
        node;
        changed = new E();
        constructor() {}
        ngOnInit() {
          this.formGroup.get(this.node.key + "radio").setValue(this.getValue(this.node.options, this.node.model[this.node.key], this.node.valueLocation)), this.formGroup.get(this.node.key + "radio").valueChanges.subscribe(t => {
            this.node.model[this.node.key] = this.setValue(t, this.node.options, this.node.model[this.node.key], this.node.valueLocation), this.changed.emit({
              type: this.node.type,
              subtype: this.node.subtype,
              model: this.node.model,
              key: this.node.key,
              index: 0,
              location: this.node.valueLocation,
              value: t
            });
          });
        }
        getLiteralMap(t) {
          return t.map(function (a) {
            return a.label;
          });
        }
        getValue(t, e, a) {
          return e ? this.getLiteralMap(t).indexOf(e[a]) : null;
        }
        setValue(t, e, a, i) {
          const o = {};
          return o[i] = this.getLiteralMap(e)[t], o;
        }
        static ɵfac = function (e) {
          return new (e || n0)();
        };
        static ɵcmp = q({
          type: n0,
          selectors: [["app-radio"]],
          inputs: {
            formGroup: "formGroup",
            node: "node"
          },
          outputs: {
            changed: "changed"
          },
          decls: 6,
          vars: 5,
          consts: [[1, "mat-form-field", 3, "formGroup"], [3, "formControlName", "required"], [4, "ngFor", "ngForOf"], [1, "input-separator"], [1, "truncate", 3, "value", "aria-label", "name"]],
          template: function (e, a) {
            1 & e && (_(0, "div", 0)(1, "mat-radio-group", 1), D(2, gue, 3, 4, "div", 2), y(), _(3, "mat-hint"), S(4), y()(), j(5, "div", 3)), 2 & e && (b("formGroup", a.formGroup), g(1), b("formControlName", a.node.key + "radio")("required", a.node.required), g(1), b("ngForOf", a.node.options), g(2), Ie(a.node.hint));
          },
          dependencies: [ea, Cs, oa, zo, No, ra, d2, ZM, XM],
          styles: [".mat-radio-button[_ngcontent-%COMP%]{margin-bottom:10px;width:100%}.mat-form-field[_ngcontent-%COMP%]{padding:15px 0 20px}[_nghost-%COMP%]     .mat-radio-label{white-space:normal!important}div.input-separator[_ngcontent-%COMP%]{border-bottom:1px solid #a3a3a3;margin-bottom:20px}"]
        });
      }
      return n0;
    })();
    function a0(n) {
      return new Be(t => {
        let e;
        try {
          e = n();
        } catch (i) {
          return void t.error(i);
        }
        return (e ? lo(e) : xd()).subscribe(t);
      });
    }
    const bue = ["trigger"],
      _ue = ["panel"];
    function vue(n, t) {
      if (1 & n && (_(0, "span", 8), S(1), y()), 2 & n) {
        const e = x();
        g(1), Ie(e.placeholder);
      }
    }
    function yue(n, t) {
      if (1 & n && (_(0, "span", 12), S(1), y()), 2 & n) {
        const e = x(2);
        g(1), Ie(e.triggerValue);
      }
    }
    function Cue(n, t) {
      1 & n && Me(0, 0, ["*ngSwitchCase", "true"]);
    }
    function Mue(n, t) {
      1 & n && (_(0, "span", 9), D(1, yue, 2, 1, "span", 10), D(2, Cue, 1, 0, "ng-content", 11), y()), 2 & n && (b("ngSwitch", !!x().customTrigger), g(2), b("ngSwitchCase", !0));
    }
    function xue(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "div", 13)(1, "div", 14, 15), F("@transformPanel.done", function (i) {
          return pe(e), ge(x()._panelDoneAnimatingStream.next(i.toState));
        })("keydown", function (i) {
          return pe(e), ge(x()._handleKeydown(i));
        }), Me(3, 1), y()();
      }
      if (2 & n) {
        const e = x();
        b("@transformPanelWrap", void 0), g(1), m5("mat-select-panel ", e._getPanelTheme(), ""), en("transform-origin", e._transformOrigin)("font-size", e._triggerFontSize, "px"), b("ngClass", e.panelClass)("@transformPanel", e.multiple ? "showing-multiple" : "showing"), X("id", e.id + "-panel")("aria-multiselectable", e.multiple)("aria-label", e.ariaLabel || null)("aria-labelledby", e._getPanelAriaLabelledby());
      }
    }
    const wue = [[["mat-select-trigger"]], "*"],
      kue = ["mat-select-trigger", "*"],
      $M = {
        transformPanelWrap: ht("transformPanelWrap", [Ee("* => void", qr("@transformPanel", [Yr()], {
          optional: !0
        }))]),
        transformPanel: ht("transformPanel", [xe("void", Z({
          transform: "scaleY(0.8)",
          minWidth: "100%",
          opacity: 0
        })), xe("showing", Z({
          opacity: 1,
          minWidth: "calc(100% + 32px)",
          transform: "scaleY(1)"
        })), xe("showing-multiple", Z({
          opacity: 1,
          minWidth: "calc(100% + 64px)",
          transform: "scaleY(1)"
        })), Ee("void => *", Re("120ms cubic-bezier(0, 0, 0.2, 1)")), Ee("* => void", Re("100ms 25ms linear", Z({
          opacity: 0
        })))])
      };
    let ex = 0;
    const nx = new O("mat-select-scroll-strategy"),
      Aue = new O("MAT_SELECT_CONFIG"),
      Sue = {
        provide: nx,
        deps: [mn],
        useFactory: function Pue(n) {
          return () => n.scrollStrategies.reposition();
        }
      };
    class Eue {
      constructor(t, e) {
        this.source = t, this.value = e;
      }
    }
    const Tue = Za($i(Fo(gp(class {
        constructor(n, t, e, a, i) {
          this._elementRef = n, this._defaultErrorStateMatcher = t, this._parentForm = e, this._parentFormGroup = a, this.ngControl = i, this.stateChanges = new V();
        }
      })))),
      Iue = new O("MatSelectTrigger");
    let Rue = (() => {
        class n extends Tue {
          constructor(e, a, i, o, r, s, c, l, d, u, m, h, p, v) {
            super(r, o, c, l, u), this._viewportRuler = e, this._changeDetectorRef = a, this._ngZone = i, this._dir = s, this._parentFormField = d, this._liveAnnouncer = p, this._defaultOptions = v, this._panelOpen = !1, this._compareWith = (C, k) => C === k, this._uid = "mat-select-" + ex++, this._triggerAriaLabelledBy = null, this._destroy = new V(), this._onChange = () => {}, this._onTouched = () => {}, this._valueId = "mat-select-value-" + ex++, this._panelDoneAnimatingStream = new V(), this._overlayPanelClass = this._defaultOptions?.overlayPanelClass || "", this._focused = !1, this.controlType = "mat-select", this._multiple = !1, this._disableOptionCentering = this._defaultOptions?.disableOptionCentering ?? !1, this.ariaLabel = "", this.optionSelectionChanges = a0(() => {
              const C = this.options;
              return C ? C.changes.pipe(Gt(C), gi(() => dt(...C.map(k => k.onSelectionChange)))) : this._ngZone.onStable.pipe($e(1), gi(() => this.optionSelectionChanges));
            }), this.openedChange = new E(), this._openedStream = this.openedChange.pipe(Ht(C => C), We(() => {})), this._closedStream = this.openedChange.pipe(Ht(C => !C), We(() => {})), this.selectionChange = new E(), this.valueChange = new E(), this.ngControl && (this.ngControl.valueAccessor = this), null != v?.typeaheadDebounceInterval && (this._typeaheadDebounceInterval = v.typeaheadDebounceInterval), this._scrollStrategyFactory = h, this._scrollStrategy = this._scrollStrategyFactory(), this.tabIndex = parseInt(m) || 0, this.id = this.id;
          }
          get focused() {
            return this._focused || this._panelOpen;
          }
          get placeholder() {
            return this._placeholder;
          }
          set placeholder(e) {
            this._placeholder = e, this.stateChanges.next();
          }
          get required() {
            return this._required ?? this.ngControl?.control?.hasValidator(Da.required) ?? !1;
          }
          set required(e) {
            this._required = Y(e), this.stateChanges.next();
          }
          get multiple() {
            return this._multiple;
          }
          set multiple(e) {
            this._multiple = Y(e);
          }
          get disableOptionCentering() {
            return this._disableOptionCentering;
          }
          set disableOptionCentering(e) {
            this._disableOptionCentering = Y(e);
          }
          get compareWith() {
            return this._compareWith;
          }
          set compareWith(e) {
            this._compareWith = e, this._selectionModel && this._initializeSelection();
          }
          get value() {
            return this._value;
          }
          set value(e) {
            this._assignValue(e) && this._onChange(e);
          }
          get typeaheadDebounceInterval() {
            return this._typeaheadDebounceInterval;
          }
          set typeaheadDebounceInterval(e) {
            this._typeaheadDebounceInterval = xt(e);
          }
          get id() {
            return this._id;
          }
          set id(e) {
            this._id = e || this._uid, this.stateChanges.next();
          }
          ngOnInit() {
            this._selectionModel = new os(this.multiple), this.stateChanges.next(), this._panelDoneAnimatingStream.pipe(rp(), ne(this._destroy)).subscribe(() => this._panelDoneAnimating(this.panelOpen));
          }
          ngAfterContentInit() {
            this._initKeyManager(), this._selectionModel.changed.pipe(ne(this._destroy)).subscribe(e => {
              e.added.forEach(a => a.select()), e.removed.forEach(a => a.deselect());
            }), this.options.changes.pipe(Gt(null), ne(this._destroy)).subscribe(() => {
              this._resetOptions(), this._initializeSelection();
            });
          }
          ngDoCheck() {
            const e = this._getTriggerAriaLabelledby(),
              a = this.ngControl;
            if (e !== this._triggerAriaLabelledBy) {
              const i = this._elementRef.nativeElement;
              this._triggerAriaLabelledBy = e, e ? i.setAttribute("aria-labelledby", e) : i.removeAttribute("aria-labelledby");
            }
            a && (this._previousControl !== a.control && (void 0 !== this._previousControl && null !== a.disabled && a.disabled !== this.disabled && (this.disabled = a.disabled), this._previousControl = a.control), this.updateErrorState());
          }
          ngOnChanges(e) {
            (e.disabled || e.userAriaDescribedBy) && this.stateChanges.next(), e.typeaheadDebounceInterval && this._keyManager && this._keyManager.withTypeAhead(this._typeaheadDebounceInterval);
          }
          ngOnDestroy() {
            this._destroy.next(), this._destroy.complete(), this.stateChanges.complete();
          }
          toggle() {
            this.panelOpen ? this.close() : this.open();
          }
          open() {
            this._canOpen() && (this._panelOpen = !0, this._keyManager.withHorizontalOrientation(null), this._highlightCorrectOption(), this._changeDetectorRef.markForCheck());
          }
          close() {
            this._panelOpen && (this._panelOpen = !1, this._keyManager.withHorizontalOrientation(this._isRtl() ? "rtl" : "ltr"), this._changeDetectorRef.markForCheck(), this._onTouched());
          }
          writeValue(e) {
            this._assignValue(e);
          }
          registerOnChange(e) {
            this._onChange = e;
          }
          registerOnTouched(e) {
            this._onTouched = e;
          }
          setDisabledState(e) {
            this.disabled = e, this._changeDetectorRef.markForCheck(), this.stateChanges.next();
          }
          get panelOpen() {
            return this._panelOpen;
          }
          get selected() {
            return this.multiple ? this._selectionModel?.selected || [] : this._selectionModel?.selected[0];
          }
          get triggerValue() {
            if (this.empty) return "";
            if (this._multiple) {
              const e = this._selectionModel.selected.map(a => a.viewValue);
              return this._isRtl() && e.reverse(), e.join(", ");
            }
            return this._selectionModel.selected[0].viewValue;
          }
          _isRtl() {
            return !!this._dir && "rtl" === this._dir.value;
          }
          _handleKeydown(e) {
            this.disabled || (this.panelOpen ? this._handleOpenKeydown(e) : this._handleClosedKeydown(e));
          }
          _handleClosedKeydown(e) {
            const a = e.keyCode,
              i = 40 === a || 38 === a || 37 === a || 39 === a,
              o = 13 === a || 32 === a,
              r = this._keyManager;
            if (!r.isTyping() && o && !Et(e) || (this.multiple || e.altKey) && i) e.preventDefault(), this.open();else if (!this.multiple) {
              const s = this.selected;
              r.onKeydown(e);
              const c = this.selected;
              c && s !== c && this._liveAnnouncer.announce(c.viewValue, 1e4);
            }
          }
          _handleOpenKeydown(e) {
            const a = this._keyManager,
              i = e.keyCode,
              o = 40 === i || 38 === i,
              r = a.isTyping();
            if (o && e.altKey) e.preventDefault(), this.close();else if (r || 13 !== i && 32 !== i || !a.activeItem || Et(e)) {
              if (!r && this._multiple && 65 === i && e.ctrlKey) {
                e.preventDefault();
                const s = this.options.some(c => !c.disabled && !c.selected);
                this.options.forEach(c => {
                  c.disabled || (s ? c.select() : c.deselect());
                });
              } else {
                const s = a.activeItemIndex;
                a.onKeydown(e), this._multiple && o && e.shiftKey && a.activeItem && a.activeItemIndex !== s && a.activeItem._selectViaInteraction();
              }
            } else e.preventDefault(), a.activeItem._selectViaInteraction();
          }
          _onFocus() {
            this.disabled || (this._focused = !0, this.stateChanges.next());
          }
          _onBlur() {
            this._focused = !1, !this.disabled && !this.panelOpen && (this._onTouched(), this._changeDetectorRef.markForCheck(), this.stateChanges.next());
          }
          _onAttached() {
            this._overlayDir.positionChange.pipe($e(1)).subscribe(() => {
              this._changeDetectorRef.detectChanges(), this._positioningSettled();
            });
          }
          _getPanelTheme() {
            return this._parentFormField ? `mat-${this._parentFormField.color}` : "";
          }
          get empty() {
            return !this._selectionModel || this._selectionModel.isEmpty();
          }
          _initializeSelection() {
            Promise.resolve().then(() => {
              this.ngControl && (this._value = this.ngControl.value), this._setSelectionByValue(this._value), this.stateChanges.next();
            });
          }
          _setSelectionByValue(e) {
            if (this._selectionModel.selected.forEach(a => a.setInactiveStyles()), this._selectionModel.clear(), this.multiple && e) Array.isArray(e), e.forEach(a => this._selectOptionByValue(a)), this._sortValues();else {
              const a = this._selectOptionByValue(e);
              a ? this._keyManager.updateActiveItem(a) : this.panelOpen || this._keyManager.updateActiveItem(-1);
            }
            this._changeDetectorRef.markForCheck();
          }
          _selectOptionByValue(e) {
            const a = this.options.find(i => {
              if (this._selectionModel.isSelected(i)) return !1;
              try {
                return null != i.value && this._compareWith(i.value, e);
              } catch {
                return !1;
              }
            });
            return a && this._selectionModel.select(a), a;
          }
          _assignValue(e) {
            return !!(e !== this._value || this._multiple && Array.isArray(e)) && (this.options && this._setSelectionByValue(e), this._value = e, !0);
          }
          _initKeyManager() {
            this._keyManager = new Wv(this.options).withTypeAhead(this._typeaheadDebounceInterval).withVerticalOrientation().withHorizontalOrientation(this._isRtl() ? "rtl" : "ltr").withHomeAndEnd().withAllowedModifierKeys(["shiftKey"]), this._keyManager.tabOut.pipe(ne(this._destroy)).subscribe(() => {
              this.panelOpen && (!this.multiple && this._keyManager.activeItem && this._keyManager.activeItem._selectViaInteraction(), this.focus(), this.close());
            }), this._keyManager.change.pipe(ne(this._destroy)).subscribe(() => {
              this._panelOpen && this.panel ? this._scrollOptionIntoView(this._keyManager.activeItemIndex || 0) : !this._panelOpen && !this.multiple && this._keyManager.activeItem && this._keyManager.activeItem._selectViaInteraction();
            });
          }
          _resetOptions() {
            const e = dt(this.options.changes, this._destroy);
            this.optionSelectionChanges.pipe(ne(e)).subscribe(a => {
              this._onSelect(a.source, a.isUserInput), a.isUserInput && !this.multiple && this._panelOpen && (this.close(), this.focus());
            }), dt(...this.options.map(a => a._stateChanges)).pipe(ne(e)).subscribe(() => {
              this._changeDetectorRef.markForCheck(), this.stateChanges.next();
            });
          }
          _onSelect(e, a) {
            const i = this._selectionModel.isSelected(e);
            null != e.value || this._multiple ? (i !== e.selected && (e.selected ? this._selectionModel.select(e) : this._selectionModel.deselect(e)), a && this._keyManager.setActiveItem(e), this.multiple && (this._sortValues(), a && this.focus())) : (e.deselect(), this._selectionModel.clear(), null != this.value && this._propagateChanges(e.value)), i !== this._selectionModel.isSelected(e) && this._propagateChanges(), this.stateChanges.next();
          }
          _sortValues() {
            if (this.multiple) {
              const e = this.options.toArray();
              this._selectionModel.sort((a, i) => this.sortComparator ? this.sortComparator(a, i, e) : e.indexOf(a) - e.indexOf(i)), this.stateChanges.next();
            }
          }
          _propagateChanges(e) {
            let a = null;
            a = this.multiple ? this.selected.map(i => i.value) : this.selected ? this.selected.value : e, this._value = a, this.valueChange.emit(a), this._onChange(a), this.selectionChange.emit(this._getChangeEvent(a)), this._changeDetectorRef.markForCheck();
          }
          _highlightCorrectOption() {
            this._keyManager && (this.empty ? this._keyManager.setFirstItemActive() : this._keyManager.setActiveItem(this._selectionModel.selected[0]));
          }
          _canOpen() {
            return !this._panelOpen && !this.disabled && this.options?.length > 0;
          }
          focus(e) {
            this._elementRef.nativeElement.focus(e);
          }
          _getPanelAriaLabelledby() {
            if (this.ariaLabel) return null;
            const e = this._parentFormField?.getLabelId();
            return this.ariaLabelledby ? (e ? e + " " : "") + this.ariaLabelledby : e;
          }
          _getAriaActiveDescendant() {
            return this.panelOpen && this._keyManager && this._keyManager.activeItem ? this._keyManager.activeItem.id : null;
          }
          _getTriggerAriaLabelledby() {
            if (this.ariaLabel) return null;
            const e = this._parentFormField?.getLabelId();
            let a = (e ? e + " " : "") + this._valueId;
            return this.ariaLabelledby && (a += " " + this.ariaLabelledby), a;
          }
          _panelDoneAnimating(e) {
            this.openedChange.emit(e);
          }
          setDescribedByIds(e) {
            e.length ? this._elementRef.nativeElement.setAttribute("aria-describedby", e.join(" ")) : this._elementRef.nativeElement.removeAttribute("aria-describedby");
          }
          onContainerClick() {
            this.focus(), this.open();
          }
          get shouldLabelFloat() {
            return this._panelOpen || !this.empty || this._focused && !!this._placeholder;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Ki), f(Se), f(ae), f(ls), f(J), f(nn, 8), f(is, 8), f(ra, 8), f(_l, 8), f(Oa, 10), qt("tabindex"), f(nx), f(Qv), f(Aue, 8));
        }, n.ɵdir = P({
          type: n,
          viewQuery: function (e, a) {
            if (1 & e && (be(bue, 5), be(_ue, 5), be(w_, 5)), 2 & e) {
              let i;
              H(i = B()) && (a.trigger = i.first), H(i = B()) && (a.panel = i.first), H(i = B()) && (a._overlayDir = i.first);
            }
          },
          inputs: {
            userAriaDescribedBy: ["aria-describedby", "userAriaDescribedBy"],
            panelClass: "panelClass",
            placeholder: "placeholder",
            required: "required",
            multiple: "multiple",
            disableOptionCentering: "disableOptionCentering",
            compareWith: "compareWith",
            value: "value",
            ariaLabel: ["aria-label", "ariaLabel"],
            ariaLabelledby: ["aria-labelledby", "ariaLabelledby"],
            errorStateMatcher: "errorStateMatcher",
            typeaheadDebounceInterval: "typeaheadDebounceInterval",
            sortComparator: "sortComparator",
            id: "id"
          },
          outputs: {
            openedChange: "openedChange",
            _openedStream: "opened",
            _closedStream: "closed",
            selectionChange: "selectionChange",
            valueChange: "valueChange"
          },
          features: [z, Ve]
        }), n;
      })(),
      r0 = (() => {
        class n extends Rue {
          constructor() {
            super(...arguments), this._scrollTop = 0, this._triggerFontSize = 0, this._transformOrigin = "top", this._offsetY = 0, this._positions = [{
              originX: "start",
              originY: "top",
              overlayX: "start",
              overlayY: "top"
            }, {
              originX: "start",
              originY: "bottom",
              overlayX: "start",
              overlayY: "bottom"
            }];
          }
          _calculateOverlayScroll(e, a, i) {
            const o = this._getItemHeight();
            return Math.min(Math.max(0, o * e - a + o / 2), i);
          }
          ngOnInit() {
            super.ngOnInit(), this._viewportRuler.change().pipe(ne(this._destroy)).subscribe(() => {
              this.panelOpen && (this._triggerRect = this.trigger.nativeElement.getBoundingClientRect(), this._changeDetectorRef.markForCheck());
            });
          }
          open() {
            super._canOpen() && (super.open(), this._triggerRect = this.trigger.nativeElement.getBoundingClientRect(), this._triggerFontSize = parseInt(getComputedStyle(this.trigger.nativeElement).fontSize || "0"), this._calculateOverlayPosition(), this._ngZone.onStable.pipe($e(1)).subscribe(() => {
              this._triggerFontSize && this._overlayDir.overlayRef && this._overlayDir.overlayRef.overlayElement && (this._overlayDir.overlayRef.overlayElement.style.fontSize = `${this._triggerFontSize}px`);
            }));
          }
          _scrollOptionIntoView(e) {
            const a = k2(e, this.options, this.optionGroups),
              i = this._getItemHeight();
            this.panel.nativeElement.scrollTop = 0 === e && 1 === a ? 0 : cy((e + a) * i, i, this.panel.nativeElement.scrollTop, 256);
          }
          _positioningSettled() {
            this._calculateOverlayOffsetX(), this.panel.nativeElement.scrollTop = this._scrollTop;
          }
          _panelDoneAnimating(e) {
            this.panelOpen ? this._scrollTop = 0 : (this._overlayDir.offsetX = 0, this._changeDetectorRef.markForCheck()), super._panelDoneAnimating(e);
          }
          _getChangeEvent(e) {
            return new Eue(this, e);
          }
          _calculateOverlayOffsetX() {
            const e = this._overlayDir.overlayRef.overlayElement.getBoundingClientRect(),
              a = this._viewportRuler.getViewportSize(),
              i = this._isRtl(),
              o = this.multiple ? 56 : 32;
            let r;
            if (this.multiple) r = 40;else if (this.disableOptionCentering) r = 16;else {
              let l = this._selectionModel.selected[0] || this.options.first;
              r = l && l.group ? 32 : 16;
            }
            i || (r *= -1);
            const s = 0 - (e.left + r - (i ? o : 0)),
              c = e.right + r - a.width + (i ? 0 : o);
            s > 0 ? r += s + 8 : c > 0 && (r -= c + 8), this._overlayDir.offsetX = Math.round(r), this._overlayDir.overlayRef.updatePosition();
          }
          _calculateOverlayOffsetY(e, a, i) {
            const o = this._getItemHeight(),
              r = (o - this._triggerRect.height) / 2,
              s = Math.floor(256 / o);
            let c;
            return this.disableOptionCentering ? 0 : (c = 0 === this._scrollTop ? e * o : this._scrollTop === i ? (e - (this._getItemCount() - s)) * o + (o - (this._getItemCount() * o - 256) % o) : a - o / 2, Math.round(-1 * c - r));
          }
          _checkOverlayWithinViewport(e) {
            const a = this._getItemHeight(),
              i = this._viewportRuler.getViewportSize(),
              o = this._triggerRect.top - 8,
              r = i.height - this._triggerRect.bottom - 8,
              s = Math.abs(this._offsetY),
              l = Math.min(this._getItemCount() * a, 256) - s - this._triggerRect.height;
            l > r ? this._adjustPanelUp(l, r) : s > o ? this._adjustPanelDown(s, o, e) : this._transformOrigin = this._getOriginBasedOnOption();
          }
          _adjustPanelUp(e, a) {
            const i = Math.round(e - a);
            this._scrollTop -= i, this._offsetY -= i, this._transformOrigin = this._getOriginBasedOnOption(), this._scrollTop <= 0 && (this._scrollTop = 0, this._offsetY = 0, this._transformOrigin = "50% bottom 0px");
          }
          _adjustPanelDown(e, a, i) {
            const o = Math.round(e - a);
            if (this._scrollTop += o, this._offsetY += o, this._transformOrigin = this._getOriginBasedOnOption(), this._scrollTop >= i) return this._scrollTop = i, this._offsetY = 0, void (this._transformOrigin = "50% top 0px");
          }
          _calculateOverlayPosition() {
            const e = this._getItemHeight(),
              a = this._getItemCount(),
              i = Math.min(a * e, 256),
              r = a * e - i;
            let s;
            s = this.empty ? 0 : Math.max(this.options.toArray().indexOf(this._selectionModel.selected[0]), 0), s += k2(s, this.options, this.optionGroups);
            const c = i / 2;
            this._scrollTop = this._calculateOverlayScroll(s, c, r), this._offsetY = this._calculateOverlayOffsetY(s, c, r), this._checkOverlayWithinViewport(r);
          }
          _getOriginBasedOnOption() {
            const e = this._getItemHeight(),
              a = (e - this._triggerRect.height) / 2;
            return `50% ${Math.abs(this._offsetY) - a + e / 2}px 0px`;
          }
          _getItemHeight() {
            return 3 * this._triggerFontSize;
          }
          _getItemCount() {
            return this.options.length + this.optionGroups.length;
          }
        }
        return n.ɵfac = function () {
          let t;
          return function (a) {
            return (t || (t = he(n)))(a || n);
          };
        }(), n.ɵcmp = q({
          type: n,
          selectors: [["mat-select"]],
          contentQueries: function (e, a, i) {
            if (1 & e && (De(i, Iue, 5), De(i, Ho, 5), De(i, Mp, 5)), 2 & e) {
              let o;
              H(o = B()) && (a.customTrigger = o.first), H(o = B()) && (a.options = o), H(o = B()) && (a.optionGroups = o);
            }
          },
          hostAttrs: ["role", "combobox", "aria-autocomplete", "none", "aria-haspopup", "true", 1, "mat-select"],
          hostVars: 19,
          hostBindings: function (e, a) {
            1 & e && F("keydown", function (o) {
              return a._handleKeydown(o);
            })("focus", function () {
              return a._onFocus();
            })("blur", function () {
              return a._onBlur();
            }), 2 & e && (X("id", a.id)("tabindex", a.tabIndex)("aria-controls", a.panelOpen ? a.id + "-panel" : null)("aria-expanded", a.panelOpen)("aria-label", a.ariaLabel || null)("aria-required", a.required.toString())("aria-disabled", a.disabled.toString())("aria-invalid", a.errorState)("aria-activedescendant", a._getAriaActiveDescendant()), fe("mat-select-disabled", a.disabled)("mat-select-invalid", a.errorState)("mat-select-required", a.required)("mat-select-empty", a.empty)("mat-select-multiple", a.multiple));
          },
          inputs: {
            disabled: "disabled",
            disableRipple: "disableRipple",
            tabIndex: "tabIndex"
          },
          exportAs: ["matSelect"],
          features: [G([{
            provide: bl,
            useExisting: n
          }, {
            provide: Cp,
            useExisting: n
          }]), z],
          ngContentSelectors: kue,
          decls: 9,
          vars: 12,
          consts: [["cdk-overlay-origin", "", 1, "mat-select-trigger", 3, "click"], ["origin", "cdkOverlayOrigin", "trigger", ""], [1, "mat-select-value", 3, "ngSwitch"], ["class", "mat-select-placeholder mat-select-min-line", 4, "ngSwitchCase"], ["class", "mat-select-value-text", 3, "ngSwitch", 4, "ngSwitchCase"], [1, "mat-select-arrow-wrapper"], [1, "mat-select-arrow"], ["cdk-connected-overlay", "", "cdkConnectedOverlayLockPosition", "", "cdkConnectedOverlayHasBackdrop", "", "cdkConnectedOverlayBackdropClass", "cdk-overlay-transparent-backdrop", 3, "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayScrollStrategy", "cdkConnectedOverlayOrigin", "cdkConnectedOverlayOpen", "cdkConnectedOverlayPositions", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayOffsetY", "backdropClick", "attach", "detach"], [1, "mat-select-placeholder", "mat-select-min-line"], [1, "mat-select-value-text", 3, "ngSwitch"], ["class", "mat-select-min-line", 4, "ngSwitchDefault"], [4, "ngSwitchCase"], [1, "mat-select-min-line"], [1, "mat-select-panel-wrap"], ["role", "listbox", "tabindex", "-1", 3, "ngClass", "keydown"], ["panel", ""]],
          template: function (e, a) {
            if (1 & e && (lt(wue), _(0, "div", 0, 1), F("click", function () {
              return a.toggle();
            }), _(3, "div", 2), D(4, vue, 2, 1, "span", 3), D(5, Mue, 3, 2, "span", 4), y(), _(6, "div", 5), j(7, "div", 6), y()(), D(8, xue, 4, 14, "ng-template", 7), F("backdropClick", function () {
              return a.close();
            })("attach", function () {
              return a._onAttached();
            })("detach", function () {
              return a.close();
            })), 2 & e) {
              const i = Kt(1);
              X("aria-owns", a.panelOpen ? a.id + "-panel" : null), g(3), b("ngSwitch", a.empty), X("id", a._valueId), g(1), b("ngSwitchCase", !0), g(1), b("ngSwitchCase", !1), g(3), b("cdkConnectedOverlayPanelClass", a._overlayPanelClass)("cdkConnectedOverlayScrollStrategy", a._scrollStrategy)("cdkConnectedOverlayOrigin", i)("cdkConnectedOverlayOpen", a.panelOpen)("cdkConnectedOverlayPositions", a._positions)("cdkConnectedOverlayMinWidth", null == a._triggerRect ? null : a._triggerRect.width)("cdkConnectedOverlayOffsetY", a._offsetY);
            }
          },
          dependencies: [ko, Gi, Wr, T7, w_, x_],
          styles: ['.mat-select{display:inline-block;width:100%;outline:none}.mat-select-trigger{display:inline-flex;align-items:center;cursor:pointer;position:relative;box-sizing:border-box;width:100%}.mat-select-disabled .mat-select-trigger{-webkit-user-select:none;user-select:none;cursor:default}.mat-select-value{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mat-select-value-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.mat-select-arrow-wrapper{height:16px;flex-shrink:0;display:inline-flex;align-items:center}.mat-form-field-appearance-fill .mat-select-arrow-wrapper{transform:translateY(-50%)}.mat-form-field-appearance-outline .mat-select-arrow-wrapper{transform:translateY(-25%)}.mat-form-field-appearance-standard.mat-form-field-has-label .mat-select:not(.mat-select-empty) .mat-select-arrow-wrapper{transform:translateY(-50%)}.mat-form-field-appearance-standard .mat-select.mat-select-empty .mat-select-arrow-wrapper{transition:transform 400ms cubic-bezier(0.25, 0.8, 0.25, 1)}._mat-animation-noopable.mat-form-field-appearance-standard .mat-select.mat-select-empty .mat-select-arrow-wrapper{transition:none}.mat-select-arrow{width:0;height:0;border-left:5px solid rgba(0,0,0,0);border-right:5px solid rgba(0,0,0,0);border-top:5px solid;margin:0 4px}.mat-form-field.mat-focused .mat-select-arrow{transform:translateX(0)}.mat-select-panel-wrap{flex-basis:100%}.mat-select-panel{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;padding-top:0;padding-bottom:0;max-height:256px;min-width:100%;border-radius:4px;outline:0}.cdk-high-contrast-active .mat-select-panel{outline:solid 1px}.mat-select-panel .mat-optgroup-label,.mat-select-panel .mat-option{font-size:inherit;line-height:3em;height:3em}.mat-form-field-type-mat-select:not(.mat-form-field-disabled) .mat-form-field-flex{cursor:pointer}.mat-form-field-type-mat-select .mat-form-field-label{width:calc(100% - 18px)}.mat-select-placeholder{transition:color 400ms 133.3333333333ms cubic-bezier(0.25, 0.8, 0.25, 1)}._mat-animation-noopable .mat-select-placeholder{transition:none}.mat-form-field-hide-placeholder .mat-select-placeholder{color:rgba(0,0,0,0);-webkit-text-fill-color:rgba(0,0,0,0);transition:none;display:block}.mat-select-min-line:empty::before{content:" ";white-space:pre;width:1px;display:inline-block;visibility:hidden}'],
          encapsulation: 2,
          data: {
            animation: [$M.transformPanelWrap, $M.transformPanel]
          },
          changeDetection: 0
        }), n;
      })(),
      D4 = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [Sue],
          imports: [yt, qa, D2, $, Wa, vl, D2, $]
        }), n;
      })();
    function zue(n, t) {
      if (1 & n && (_(0, "mat-option", 3), S(1), y()), 2 & n) {
        const e = t.$implicit,
          a = t.index;
        b("disabled", "view" === x().mode)("value", a), g(1), Ie(e.label);
      }
    }
    let s0 = /*#__PURE__*/(() => {
      class s0 {
        formGroup;
        node;
        mode;
        changed = new E();
        constructor() {}
        ngOnInit() {
          this.formGroup.get(this.node.key + "list").setValue(this.getListValue(this.node.options, this.node.model[this.node.key], this.node.valueLocation, this.node.multipleChoice)), this.formGroup.get(this.node.key + "list").valueChanges.subscribe(t => {
            this.node.model[this.node.key] = this.setListValue(t, this.node.options, this.node.model[this.node.key], this.node.valueLocation, this.node.multipleChoice), this.changed.emit({
              type: this.node.type,
              subtype: this.node.subtype,
              model: this.node.model,
              key: this.node.key,
              index: 0,
              location: this.node.valueLocation,
              value: t
            });
          });
        }
        getLiteralMap(t) {
          return t.map(function (a) {
            return a.label;
          });
        }
        getListValue(t, e, a, i) {
          let o = [];
          const r = this.getLiteralMap(t);
          if (e) if (i) for (let s = 0; s < e.length; s++) o.push(r.indexOf(e[s][a]));else o = r.indexOf(e[a]);
          return o;
        }
        setListValue(t, e, a, i, o) {
          let r;
          const s = this.getLiteralMap(e);
          if (o) {
            r = [];
            for (let c = 0; c < t.length; c++) {
              const l = {};
              l[i] = s[t[c]], r.push(l);
            }
          } else r = {}, r[i] = s[t];
          return r;
        }
        static ɵfac = function (e) {
          return new (e || s0)();
        };
        static ɵcmp = q({
          type: s0,
          selectors: [["app-list"]],
          inputs: {
            formGroup: "formGroup",
            node: "node",
            mode: "mode"
          },
          outputs: {
            changed: "changed"
          },
          decls: 5,
          vars: 6,
          consts: [[1, "mat-form-field", "list-opened", 3, "formGroup"], [3, "multiple", "formControlName", "required"], [3, "disabled", "value", 4, "ngFor", "ngForOf"], [3, "disabled", "value"]],
          template: function (e, a) {
            1 & e && (_(0, "mat-form-field", 0)(1, "mat-select", 1), D(2, zue, 2, 3, "mat-option", 2), y(), _(3, "mat-hint"), S(4), y()()), 2 & e && (b("formGroup", a.formGroup), g(1), b("multiple", a.node.multipleChoice)("formControlName", a.node.key + "list")("required", a.node.required), g(1), b("ngForOf", a.node.options), g(2), Ie(a.node.hint));
          },
          dependencies: [ea, Ho, Si, Cs, oa, zo, No, ra, d2, r0],
          styles: [".mat-form-field{margin-bottom:10px;width:100%}\n"],
          encapsulation: 2
        });
      }
      return s0;
    })();
    const Lue = ["mat-calendar-body", ""];
    function Nue(n, t) {
      if (1 & n && (_(0, "tr", 2)(1, "td", 3), S(2), y()()), 2 & n) {
        const e = x();
        g(1), en("padding-top", e._cellPadding)("padding-bottom", e._cellPadding), X("colspan", e.numCols), g(1), Fe(" ", e.label, " ");
      }
    }
    function Fue(n, t) {
      if (1 & n && (_(0, "td", 3), S(1), y()), 2 & n) {
        const e = x(2);
        en("padding-top", e._cellPadding)("padding-bottom", e._cellPadding), X("colspan", e._firstRowOffset), g(1), Fe(" ", e._firstRowOffset >= e.labelMinRequiredCells ? e.label : "", " ");
      }
    }
    function Vue(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "td", 7)(1, "button", 8), F("click", function (i) {
          const r = pe(e).$implicit;
          return ge(x(2)._cellClicked(r, i));
        })("focus", function (i) {
          const r = pe(e).$implicit;
          return ge(x(2)._emitActiveDateChange(r, i));
        }), _(2, "div", 9), S(3), y(), j(4, "div", 10), y()();
      }
      if (2 & n) {
        const e = t.$implicit,
          a = t.index,
          i = x().index,
          o = x();
        en("width", o._cellWidth)("padding-top", o._cellPadding)("padding-bottom", o._cellPadding), X("data-mat-row", i)("data-mat-col", a), g(1), fe("mat-calendar-body-disabled", !e.enabled)("mat-calendar-body-active", o._isActiveCell(i, a))("mat-calendar-body-range-start", o._isRangeStart(e.compareValue))("mat-calendar-body-range-end", o._isRangeEnd(e.compareValue))("mat-calendar-body-in-range", o._isInRange(e.compareValue))("mat-calendar-body-comparison-bridge-start", o._isComparisonBridgeStart(e.compareValue, i, a))("mat-calendar-body-comparison-bridge-end", o._isComparisonBridgeEnd(e.compareValue, i, a))("mat-calendar-body-comparison-start", o._isComparisonStart(e.compareValue))("mat-calendar-body-comparison-end", o._isComparisonEnd(e.compareValue))("mat-calendar-body-in-comparison-range", o._isInComparisonRange(e.compareValue))("mat-calendar-body-preview-start", o._isPreviewStart(e.compareValue))("mat-calendar-body-preview-end", o._isPreviewEnd(e.compareValue))("mat-calendar-body-in-preview", o._isInPreview(e.compareValue)), b("ngClass", e.cssClasses)("tabindex", o._isActiveCell(i, a) ? 0 : -1), X("aria-label", e.ariaLabel)("aria-disabled", !e.enabled || null)("aria-pressed", o._isSelected(e.compareValue))("aria-current", o.todayValue === e.compareValue ? "date" : null), g(1), fe("mat-calendar-body-selected", o._isSelected(e.compareValue))("mat-calendar-body-comparison-identical", o._isComparisonIdentical(e.compareValue))("mat-calendar-body-today", o.todayValue === e.compareValue), g(1), Fe(" ", e.displayValue, " ");
      }
    }
    function Hue(n, t) {
      if (1 & n && (_(0, "tr", 4), D(1, Fue, 2, 6, "td", 5), D(2, Vue, 5, 47, "td", 6), y()), 2 & n) {
        const e = t.$implicit,
          a = t.index,
          i = x();
        g(1), b("ngIf", 0 === a && i._firstRowOffset), g(1), b("ngForOf", e);
      }
    }
    function Bue(n, t) {
      if (1 & n && (_(0, "th", 5)(1, "span", 6), S(2), y(), _(3, "span", 7), S(4), y()()), 2 & n) {
        const e = t.$implicit;
        g(2), Ie(e.long), g(2), Ie(e.narrow);
      }
    }
    const jue = ["*"];
    function Uue(n, t) {}
    function Gue(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "mat-month-view", 5), F("activeDateChange", function (i) {
          return pe(e), ge(x().activeDate = i);
        })("_userSelection", function (i) {
          return pe(e), ge(x()._dateSelected(i));
        }), y();
      }
      if (2 & n) {
        const e = x();
        b("activeDate", e.activeDate)("selected", e.selected)("dateFilter", e.dateFilter)("maxDate", e.maxDate)("minDate", e.minDate)("dateClass", e.dateClass)("comparisonStart", e.comparisonStart)("comparisonEnd", e.comparisonEnd);
      }
    }
    function Wue(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "mat-year-view", 6), F("activeDateChange", function (i) {
          return pe(e), ge(x().activeDate = i);
        })("monthSelected", function (i) {
          return pe(e), ge(x()._monthSelectedInYearView(i));
        })("selectedChange", function (i) {
          return pe(e), ge(x()._goToDateInView(i, "month"));
        }), y();
      }
      if (2 & n) {
        const e = x();
        b("activeDate", e.activeDate)("selected", e.selected)("dateFilter", e.dateFilter)("maxDate", e.maxDate)("minDate", e.minDate)("dateClass", e.dateClass);
      }
    }
    function Yue(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "mat-multi-year-view", 7), F("activeDateChange", function (i) {
          return pe(e), ge(x().activeDate = i);
        })("yearSelected", function (i) {
          return pe(e), ge(x()._yearSelectedInMultiYearView(i));
        })("selectedChange", function (i) {
          return pe(e), ge(x()._goToDateInView(i, "year"));
        }), y();
      }
      if (2 & n) {
        const e = x();
        b("activeDate", e.activeDate)("selected", e.selected)("dateFilter", e.dateFilter)("maxDate", e.maxDate)("minDate", e.minDate)("dateClass", e.dateClass);
      }
    }
    function que(n, t) {}
    const Kue = ["button"];
    function Que(n, t) {
      1 & n && (Kn(), _(0, "svg", 3), j(1, "path", 4), y());
    }
    const Zue = [[["", "matDatepickerToggleIcon", ""]]],
      Xue = ["[matDatepickerToggleIcon]"];
    let Ml = (() => {
      class n {
        constructor() {
          this.changes = new V(), this.calendarLabel = "Calendar", this.openCalendarLabel = "Open calendar", this.closeCalendarLabel = "Close calendar", this.prevMonthLabel = "Previous month", this.nextMonthLabel = "Next month", this.prevYearLabel = "Previous year", this.nextYearLabel = "Next year", this.prevMultiYearLabel = "Previous 24 years", this.nextMultiYearLabel = "Next 24 years", this.switchToMonthViewLabel = "Choose date", this.switchToMultiYearViewLabel = "Choose month and year", this.startDateLabel = "Start date", this.endDateLabel = "End date";
        }
        formatYearRange(e, a) {
          return `${e} \u2013 ${a}`;
        }
        formatYearRangeLabel(e, a) {
          return `${e} to ${a}`;
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)();
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac,
        providedIn: "root"
      }), n;
    })();
    class O4 {
      constructor(t, e, a, i, o = {}, r = t, s) {
        this.value = t, this.displayValue = e, this.ariaLabel = a, this.enabled = i, this.cssClasses = o, this.compareValue = r, this.rawValue = s;
      }
    }
    let xs = (() => {
      class n {
        constructor(e, a) {
          this._elementRef = e, this._ngZone = a, this._focusActiveCellAfterViewChecked = !1, this.numCols = 7, this.activeCell = 0, this.isRange = !1, this.cellAspectRatio = 1, this.previewStart = null, this.previewEnd = null, this.selectedValueChange = new E(), this.previewChange = new E(), this.activeDateChange = new E(), this._enterHandler = i => {
            if (this._skipNextFocus && "focus" === i.type) this._skipNextFocus = !1;else if (i.target && this.isRange) {
              const o = this._getCellFromElement(i.target);
              o && this._ngZone.run(() => this.previewChange.emit({
                value: o.enabled ? o : null,
                event: i
              }));
            }
          }, this._leaveHandler = i => {
            null !== this.previewEnd && this.isRange && i.target && this._getCellFromElement(i.target) && this._ngZone.run(() => this.previewChange.emit({
              value: null,
              event: i
            }));
          }, a.runOutsideAngular(() => {
            const i = e.nativeElement;
            i.addEventListener("mouseenter", this._enterHandler, !0), i.addEventListener("focus", this._enterHandler, !0), i.addEventListener("mouseleave", this._leaveHandler, !0), i.addEventListener("blur", this._leaveHandler, !0);
          });
        }
        ngAfterViewChecked() {
          this._focusActiveCellAfterViewChecked && (this._focusActiveCell(), this._focusActiveCellAfterViewChecked = !1);
        }
        _cellClicked(e, a) {
          e.enabled && this.selectedValueChange.emit({
            value: e.value,
            event: a
          });
        }
        _emitActiveDateChange(e, a) {
          e.enabled && this.activeDateChange.emit({
            value: e.value,
            event: a
          });
        }
        _isSelected(e) {
          return this.startValue === e || this.endValue === e;
        }
        ngOnChanges(e) {
          const a = e.numCols,
            {
              rows: i,
              numCols: o
            } = this;
          (e.rows || a) && (this._firstRowOffset = i && i.length && i[0].length ? o - i[0].length : 0), (e.cellAspectRatio || a || !this._cellPadding) && (this._cellPadding = 50 * this.cellAspectRatio / o + "%"), (a || !this._cellWidth) && (this._cellWidth = 100 / o + "%");
        }
        ngOnDestroy() {
          const e = this._elementRef.nativeElement;
          e.removeEventListener("mouseenter", this._enterHandler, !0), e.removeEventListener("focus", this._enterHandler, !0), e.removeEventListener("mouseleave", this._leaveHandler, !0), e.removeEventListener("blur", this._leaveHandler, !0);
        }
        _isActiveCell(e, a) {
          let i = e * this.numCols + a;
          return e && (i -= this._firstRowOffset), i == this.activeCell;
        }
        _focusActiveCell(e = !0) {
          this._ngZone.runOutsideAngular(() => {
            this._ngZone.onStable.pipe($e(1)).subscribe(() => {
              setTimeout(() => {
                const a = this._elementRef.nativeElement.querySelector(".mat-calendar-body-active");
                a && (e || (this._skipNextFocus = !0), a.focus());
              });
            });
          });
        }
        _scheduleFocusActiveCellAfterViewChecked() {
          this._focusActiveCellAfterViewChecked = !0;
        }
        _isRangeStart(e) {
          return P4(e, this.startValue, this.endValue);
        }
        _isRangeEnd(e) {
          return A4(e, this.startValue, this.endValue);
        }
        _isInRange(e) {
          return S4(e, this.startValue, this.endValue, this.isRange);
        }
        _isComparisonStart(e) {
          return P4(e, this.comparisonStart, this.comparisonEnd);
        }
        _isComparisonBridgeStart(e, a, i) {
          if (!this._isComparisonStart(e) || this._isRangeStart(e) || !this._isInRange(e)) return !1;
          let o = this.rows[a][i - 1];
          if (!o) {
            const r = this.rows[a - 1];
            o = r && r[r.length - 1];
          }
          return o && !this._isRangeEnd(o.compareValue);
        }
        _isComparisonBridgeEnd(e, a, i) {
          if (!this._isComparisonEnd(e) || this._isRangeEnd(e) || !this._isInRange(e)) return !1;
          let o = this.rows[a][i + 1];
          if (!o) {
            const r = this.rows[a + 1];
            o = r && r[0];
          }
          return o && !this._isRangeStart(o.compareValue);
        }
        _isComparisonEnd(e) {
          return A4(e, this.comparisonStart, this.comparisonEnd);
        }
        _isInComparisonRange(e) {
          return S4(e, this.comparisonStart, this.comparisonEnd, this.isRange);
        }
        _isComparisonIdentical(e) {
          return this.comparisonStart === this.comparisonEnd && e === this.comparisonStart;
        }
        _isPreviewStart(e) {
          return P4(e, this.previewStart, this.previewEnd);
        }
        _isPreviewEnd(e) {
          return A4(e, this.previewStart, this.previewEnd);
        }
        _isInPreview(e) {
          return S4(e, this.previewStart, this.previewEnd, this.isRange);
        }
        _getCellFromElement(e) {
          let a;
          if (ax(e) ? a = e : ax(e.parentNode) && (a = e.parentNode), a) {
            const i = a.getAttribute("data-mat-row"),
              o = a.getAttribute("data-mat-col");
            if (i && o) return this.rows[parseInt(i)][parseInt(o)];
          }
          return null;
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(f(J), f(ae));
      }, n.ɵcmp = q({
        type: n,
        selectors: [["", "mat-calendar-body", ""]],
        hostAttrs: [1, "mat-calendar-body"],
        inputs: {
          label: "label",
          rows: "rows",
          todayValue: "todayValue",
          startValue: "startValue",
          endValue: "endValue",
          labelMinRequiredCells: "labelMinRequiredCells",
          numCols: "numCols",
          activeCell: "activeCell",
          isRange: "isRange",
          cellAspectRatio: "cellAspectRatio",
          comparisonStart: "comparisonStart",
          comparisonEnd: "comparisonEnd",
          previewStart: "previewStart",
          previewEnd: "previewEnd"
        },
        outputs: {
          selectedValueChange: "selectedValueChange",
          previewChange: "previewChange",
          activeDateChange: "activeDateChange"
        },
        exportAs: ["matCalendarBody"],
        features: [Ve],
        attrs: Lue,
        decls: 2,
        vars: 2,
        consts: [["aria-hidden", "true", 4, "ngIf"], ["role", "row", 4, "ngFor", "ngForOf"], ["aria-hidden", "true"], [1, "mat-calendar-body-label"], ["role", "row"], ["class", "mat-calendar-body-label", 3, "paddingTop", "paddingBottom", 4, "ngIf"], ["role", "gridcell", "class", "mat-calendar-body-cell-container", 3, "width", "paddingTop", "paddingBottom", 4, "ngFor", "ngForOf"], ["role", "gridcell", 1, "mat-calendar-body-cell-container"], ["type", "button", 1, "mat-calendar-body-cell", 3, "ngClass", "tabindex", "click", "focus"], [1, "mat-calendar-body-cell-content", "mat-focus-indicator"], ["aria-hidden", "true", 1, "mat-calendar-body-cell-preview"]],
        template: function (e, a) {
          1 & e && (D(0, Nue, 3, 6, "tr", 0), D(1, Hue, 3, 2, "tr", 1)), 2 & e && (b("ngIf", a._firstRowOffset < a.labelMinRequiredCells), g(1), b("ngForOf", a.rows));
        },
        dependencies: [ko, ea, mt],
        styles: ['.mat-calendar-body{min-width:224px}.mat-calendar-body-label{height:0;line-height:0;text-align:left;padding-left:4.7142857143%;padding-right:4.7142857143%}.mat-calendar-body-cell-container{position:relative;height:0;line-height:0}.mat-calendar-body-cell{-webkit-user-select:none;user-select:none;cursor:pointer;outline:none;border:none;-webkit-tap-highlight-color:rgba(0,0,0,0);position:absolute;top:0;left:0;width:100%;height:100%;background:none;text-align:center;outline:none;font-family:inherit;margin:0}.mat-calendar-body-cell::-moz-focus-inner{border:0}.mat-calendar-body-cell::before,.mat-calendar-body-cell::after,.mat-calendar-body-cell-preview{content:"";position:absolute;top:5%;left:0;z-index:0;box-sizing:border-box;height:90%;width:100%}.mat-calendar-body-range-start:not(.mat-calendar-body-in-comparison-range)::before,.mat-calendar-body-range-start::after,.mat-calendar-body-comparison-start:not(.mat-calendar-body-comparison-bridge-start)::before,.mat-calendar-body-comparison-start::after,.mat-calendar-body-preview-start .mat-calendar-body-cell-preview{left:5%;width:95%;border-top-left-radius:999px;border-bottom-left-radius:999px}[dir=rtl] .mat-calendar-body-range-start:not(.mat-calendar-body-in-comparison-range)::before,[dir=rtl] .mat-calendar-body-range-start::after,[dir=rtl] .mat-calendar-body-comparison-start:not(.mat-calendar-body-comparison-bridge-start)::before,[dir=rtl] .mat-calendar-body-comparison-start::after,[dir=rtl] .mat-calendar-body-preview-start .mat-calendar-body-cell-preview{left:0;border-radius:0;border-top-right-radius:999px;border-bottom-right-radius:999px}.mat-calendar-body-range-end:not(.mat-calendar-body-in-comparison-range)::before,.mat-calendar-body-range-end::after,.mat-calendar-body-comparison-end:not(.mat-calendar-body-comparison-bridge-end)::before,.mat-calendar-body-comparison-end::after,.mat-calendar-body-preview-end .mat-calendar-body-cell-preview{width:95%;border-top-right-radius:999px;border-bottom-right-radius:999px}[dir=rtl] .mat-calendar-body-range-end:not(.mat-calendar-body-in-comparison-range)::before,[dir=rtl] .mat-calendar-body-range-end::after,[dir=rtl] .mat-calendar-body-comparison-end:not(.mat-calendar-body-comparison-bridge-end)::before,[dir=rtl] .mat-calendar-body-comparison-end::after,[dir=rtl] .mat-calendar-body-preview-end .mat-calendar-body-cell-preview{left:5%;border-radius:0;border-top-left-radius:999px;border-bottom-left-radius:999px}[dir=rtl] .mat-calendar-body-comparison-bridge-start.mat-calendar-body-range-end::after,[dir=rtl] .mat-calendar-body-comparison-bridge-end.mat-calendar-body-range-start::after{width:95%;border-top-right-radius:999px;border-bottom-right-radius:999px}.mat-calendar-body-comparison-start.mat-calendar-body-range-end::after,[dir=rtl] .mat-calendar-body-comparison-start.mat-calendar-body-range-end::after,.mat-calendar-body-comparison-end.mat-calendar-body-range-start::after,[dir=rtl] .mat-calendar-body-comparison-end.mat-calendar-body-range-start::after{width:90%}.mat-calendar-body-in-preview .mat-calendar-body-cell-preview{border-top:dashed 1px;border-bottom:dashed 1px}.mat-calendar-body-preview-start .mat-calendar-body-cell-preview{border-left:dashed 1px}[dir=rtl] .mat-calendar-body-preview-start .mat-calendar-body-cell-preview{border-left:0;border-right:dashed 1px}.mat-calendar-body-preview-end .mat-calendar-body-cell-preview{border-right:dashed 1px}[dir=rtl] .mat-calendar-body-preview-end .mat-calendar-body-cell-preview{border-right:0;border-left:dashed 1px}.mat-calendar-body-disabled{cursor:default}.cdk-high-contrast-active .mat-calendar-body-disabled{opacity:.5}.mat-calendar-body-cell-content{top:5%;left:5%;z-index:1;display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:90%;height:90%;line-height:1;border-width:1px;border-style:solid;border-radius:999px}.mat-calendar-body-cell-content.mat-focus-indicator{position:absolute}.cdk-high-contrast-active .mat-calendar-body-cell-content{border:none}.cdk-high-contrast-active .mat-datepicker-popup:not(:empty),.cdk-high-contrast-active .mat-calendar-body-cell:not(.mat-calendar-body-in-range) .mat-calendar-body-selected{outline:solid 1px}.cdk-high-contrast-active .mat-calendar-body-today{outline:dotted 1px}.cdk-high-contrast-active .mat-calendar-body-cell::before,.cdk-high-contrast-active .mat-calendar-body-cell::after,.cdk-high-contrast-active .mat-calendar-body-selected{background:none}.cdk-high-contrast-active .mat-calendar-body-in-range::before,.cdk-high-contrast-active .mat-calendar-body-comparison-bridge-start::before,.cdk-high-contrast-active .mat-calendar-body-comparison-bridge-end::before{border-top:solid 1px;border-bottom:solid 1px}.cdk-high-contrast-active .mat-calendar-body-range-start::before{border-left:solid 1px}[dir=rtl] .cdk-high-contrast-active .mat-calendar-body-range-start::before{border-left:0;border-right:solid 1px}.cdk-high-contrast-active .mat-calendar-body-range-end::before{border-right:solid 1px}[dir=rtl] .cdk-high-contrast-active .mat-calendar-body-range-end::before{border-right:0;border-left:solid 1px}.cdk-high-contrast-active .mat-calendar-body-in-comparison-range::before{border-top:dashed 1px;border-bottom:dashed 1px}.cdk-high-contrast-active .mat-calendar-body-comparison-start::before{border-left:dashed 1px}[dir=rtl] .cdk-high-contrast-active .mat-calendar-body-comparison-start::before{border-left:0;border-right:dashed 1px}.cdk-high-contrast-active .mat-calendar-body-comparison-end::before{border-right:dashed 1px}[dir=rtl] .cdk-high-contrast-active .mat-calendar-body-comparison-end::before{border-right:0;border-left:dashed 1px}[dir=rtl] .mat-calendar-body-label{text-align:right}'],
        encapsulation: 2,
        changeDetection: 0
      }), n;
    })();
    function ax(n) {
      return "TD" === n.nodeName;
    }
    function P4(n, t, e) {
      return null !== e && t !== e && n < e && n === t;
    }
    function A4(n, t, e) {
      return null !== t && t !== e && n >= t && n === e;
    }
    function S4(n, t, e, a) {
      return a && null !== t && null !== e && t !== e && n >= t && n <= e;
    }
    class xn {
      constructor(t, e) {
        this.start = t, this.end = e;
      }
    }
    let io = (() => {
        class n {
          constructor(e, a) {
            this.selection = e, this._adapter = a, this._selectionChanged = new V(), this.selectionChanged = this._selectionChanged, this.selection = e;
          }
          updateSelection(e, a) {
            const i = this.selection;
            this.selection = e, this._selectionChanged.next({
              selection: e,
              source: a,
              oldValue: i
            });
          }
          ngOnDestroy() {
            this._selectionChanged.complete();
          }
          _isValidDateInstance(e) {
            return this._adapter.isDateInstance(e) && this._adapter.isValid(e);
          }
        }
        return n.ɵfac = function (e) {
          li();
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac
        }), n;
      })(),
      Jue = (() => {
        class n extends io {
          constructor(e) {
            super(null, e);
          }
          add(e) {
            super.updateSelection(e, this);
          }
          isValid() {
            return null != this.selection && this._isValidDateInstance(this.selection);
          }
          isComplete() {
            return null != this.selection;
          }
          clone() {
            const e = new n(this._adapter);
            return e.updateSelection(this.selection, this), e;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(Qt));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac
        }), n;
      })();
    const ix = {
        provide: io,
        deps: [[new En(), new ga(), io], Qt],
        useFactory: function efe(n, t) {
          return n || new Jue(t);
        }
      },
      c0 = new O("MAT_DATE_RANGE_SELECTION_STRATEGY");
    let ox = (() => {
        class n {
          constructor(e, a, i, o, r) {
            this._changeDetectorRef = e, this._dateFormats = a, this._dateAdapter = i, this._dir = o, this._rangeStrategy = r, this._rerenderSubscription = re.EMPTY, this.selectedChange = new E(), this._userSelection = new E(), this.activeDateChange = new E(), this._activeDate = this._dateAdapter.today();
          }
          get activeDate() {
            return this._activeDate;
          }
          set activeDate(e) {
            const a = this._activeDate,
              i = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e)) || this._dateAdapter.today();
            this._activeDate = this._dateAdapter.clampDate(i, this.minDate, this.maxDate), this._hasSameMonthAndYear(a, this._activeDate) || this._init();
          }
          get selected() {
            return this._selected;
          }
          set selected(e) {
            this._selected = e instanceof xn ? e : this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e)), this._setRanges(this._selected);
          }
          get minDate() {
            return this._minDate;
          }
          set minDate(e) {
            this._minDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e));
          }
          get maxDate() {
            return this._maxDate;
          }
          set maxDate(e) {
            this._maxDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e));
          }
          ngAfterContentInit() {
            this._rerenderSubscription = this._dateAdapter.localeChanges.pipe(Gt(null)).subscribe(() => this._init());
          }
          ngOnChanges(e) {
            const a = e.comparisonStart || e.comparisonEnd;
            a && !a.firstChange && this._setRanges(this.selected);
          }
          ngOnDestroy() {
            this._rerenderSubscription.unsubscribe();
          }
          _dateSelected(e) {
            const a = e.value,
              i = this._getDateFromDayOfMonth(a);
            let o, r;
            this._selected instanceof xn ? (o = this._getDateInCurrentMonth(this._selected.start), r = this._getDateInCurrentMonth(this._selected.end)) : o = r = this._getDateInCurrentMonth(this._selected), (o !== a || r !== a) && this.selectedChange.emit(i), this._userSelection.emit({
              value: i,
              event: e.event
            }), this._previewStart = this._previewEnd = null, this._changeDetectorRef.markForCheck();
          }
          _updateActiveDate(e) {
            const i = this._activeDate;
            this.activeDate = this._getDateFromDayOfMonth(e.value), this._dateAdapter.compareDate(i, this.activeDate) && this.activeDateChange.emit(this._activeDate);
          }
          _handleCalendarBodyKeydown(e) {
            const a = this._activeDate,
              i = this._isRtl();
            switch (e.keyCode) {
              case 37:
                this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, i ? 1 : -1);
                break;
              case 39:
                this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, i ? -1 : 1);
                break;
              case 38:
                this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, -7);
                break;
              case 40:
                this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, 7);
                break;
              case 36:
                this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, 1 - this._dateAdapter.getDate(this._activeDate));
                break;
              case 35:
                this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, this._dateAdapter.getNumDaysInMonth(this._activeDate) - this._dateAdapter.getDate(this._activeDate));
                break;
              case 33:
                this.activeDate = e.altKey ? this._dateAdapter.addCalendarYears(this._activeDate, -1) : this._dateAdapter.addCalendarMonths(this._activeDate, -1);
                break;
              case 34:
                this.activeDate = e.altKey ? this._dateAdapter.addCalendarYears(this._activeDate, 1) : this._dateAdapter.addCalendarMonths(this._activeDate, 1);
                break;
              case 13:
              case 32:
                return this._selectionKeyPressed = !0, void (this._canSelect(this._activeDate) && e.preventDefault());
              case 27:
                return void (null != this._previewEnd && !Et(e) && (this._previewStart = this._previewEnd = null, this.selectedChange.emit(null), this._userSelection.emit({
                  value: null,
                  event: e
                }), e.preventDefault(), e.stopPropagation()));
              default:
                return;
            }
            this._dateAdapter.compareDate(a, this.activeDate) && (this.activeDateChange.emit(this.activeDate), this._focusActiveCellAfterViewChecked()), e.preventDefault();
          }
          _handleCalendarBodyKeyup(e) {
            (32 === e.keyCode || 13 === e.keyCode) && (this._selectionKeyPressed && this._canSelect(this._activeDate) && this._dateSelected({
              value: this._dateAdapter.getDate(this._activeDate),
              event: e
            }), this._selectionKeyPressed = !1);
          }
          _init() {
            this._setRanges(this.selected), this._todayDate = this._getCellCompareValue(this._dateAdapter.today()), this._monthLabel = this._dateFormats.display.monthLabel ? this._dateAdapter.format(this.activeDate, this._dateFormats.display.monthLabel) : this._dateAdapter.getMonthNames("short")[this._dateAdapter.getMonth(this.activeDate)].toLocaleUpperCase();
            let e = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), 1);
            this._firstWeekOffset = (7 + this._dateAdapter.getDayOfWeek(e) - this._dateAdapter.getFirstDayOfWeek()) % 7, this._initWeekdays(), this._createWeekCells(), this._changeDetectorRef.markForCheck();
          }
          _focusActiveCell(e) {
            this._matCalendarBody._focusActiveCell(e);
          }
          _focusActiveCellAfterViewChecked() {
            this._matCalendarBody._scheduleFocusActiveCellAfterViewChecked();
          }
          _previewChanged({
            event: e,
            value: a
          }) {
            if (this._rangeStrategy) {
              const o = this._rangeStrategy.createPreview(a ? a.rawValue : null, this.selected, e);
              this._previewStart = this._getCellCompareValue(o.start), this._previewEnd = this._getCellCompareValue(o.end), this._changeDetectorRef.detectChanges();
            }
          }
          _getDateFromDayOfMonth(e) {
            return this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), e);
          }
          _initWeekdays() {
            const e = this._dateAdapter.getFirstDayOfWeek(),
              a = this._dateAdapter.getDayOfWeekNames("narrow");
            let o = this._dateAdapter.getDayOfWeekNames("long").map((r, s) => ({
              long: r,
              narrow: a[s]
            }));
            this._weekdays = o.slice(e).concat(o.slice(0, e));
          }
          _createWeekCells() {
            const e = this._dateAdapter.getNumDaysInMonth(this.activeDate),
              a = this._dateAdapter.getDateNames();
            this._weeks = [[]];
            for (let i = 0, o = this._firstWeekOffset; i < e; i++, o++) {
              7 == o && (this._weeks.push([]), o = 0);
              const r = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), i + 1),
                s = this._shouldEnableDate(r),
                c = this._dateAdapter.format(r, this._dateFormats.display.dateA11yLabel),
                l = this.dateClass ? this.dateClass(r, "month") : void 0;
              this._weeks[this._weeks.length - 1].push(new O4(i + 1, a[i], c, s, l, this._getCellCompareValue(r), r));
            }
          }
          _shouldEnableDate(e) {
            return !!e && (!this.minDate || this._dateAdapter.compareDate(e, this.minDate) >= 0) && (!this.maxDate || this._dateAdapter.compareDate(e, this.maxDate) <= 0) && (!this.dateFilter || this.dateFilter(e));
          }
          _getDateInCurrentMonth(e) {
            return e && this._hasSameMonthAndYear(e, this.activeDate) ? this._dateAdapter.getDate(e) : null;
          }
          _hasSameMonthAndYear(e, a) {
            return !(!e || !a || this._dateAdapter.getMonth(e) != this._dateAdapter.getMonth(a) || this._dateAdapter.getYear(e) != this._dateAdapter.getYear(a));
          }
          _getCellCompareValue(e) {
            if (e) {
              const a = this._dateAdapter.getYear(e),
                i = this._dateAdapter.getMonth(e),
                o = this._dateAdapter.getDate(e);
              return new Date(a, i, o).getTime();
            }
            return null;
          }
          _isRtl() {
            return this._dir && "rtl" === this._dir.value;
          }
          _setRanges(e) {
            e instanceof xn ? (this._rangeStart = this._getCellCompareValue(e.start), this._rangeEnd = this._getCellCompareValue(e.end), this._isRange = !0) : (this._rangeStart = this._rangeEnd = this._getCellCompareValue(e), this._isRange = !1), this._comparisonRangeStart = this._getCellCompareValue(this.comparisonStart), this._comparisonRangeEnd = this._getCellCompareValue(this.comparisonEnd);
          }
          _canSelect(e) {
            return !this.dateFilter || this.dateFilter(e);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Se), f(Vo, 8), f(Qt, 8), f(nn, 8), f(c0, 8));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-month-view"]],
          viewQuery: function (e, a) {
            if (1 & e && be(xs, 5), 2 & e) {
              let i;
              H(i = B()) && (a._matCalendarBody = i.first);
            }
          },
          inputs: {
            activeDate: "activeDate",
            selected: "selected",
            minDate: "minDate",
            maxDate: "maxDate",
            dateFilter: "dateFilter",
            dateClass: "dateClass",
            comparisonStart: "comparisonStart",
            comparisonEnd: "comparisonEnd"
          },
          outputs: {
            selectedChange: "selectedChange",
            _userSelection: "_userSelection",
            activeDateChange: "activeDateChange"
          },
          exportAs: ["matMonthView"],
          features: [Ve],
          decls: 7,
          vars: 13,
          consts: [["role", "grid", 1, "mat-calendar-table"], [1, "mat-calendar-table-header"], ["scope", "col", 4, "ngFor", "ngForOf"], ["aria-hidden", "true", "colspan", "7", 1, "mat-calendar-table-header-divider"], ["mat-calendar-body", "", 3, "label", "rows", "todayValue", "startValue", "endValue", "comparisonStart", "comparisonEnd", "previewStart", "previewEnd", "isRange", "labelMinRequiredCells", "activeCell", "selectedValueChange", "activeDateChange", "previewChange", "keyup", "keydown"], ["scope", "col"], [1, "cdk-visually-hidden"], ["aria-hidden", "true"]],
          template: function (e, a) {
            1 & e && (_(0, "table", 0)(1, "thead", 1)(2, "tr"), D(3, Bue, 5, 2, "th", 2), y(), _(4, "tr"), j(5, "th", 3), y()(), _(6, "tbody", 4), F("selectedValueChange", function (o) {
              return a._dateSelected(o);
            })("activeDateChange", function (o) {
              return a._updateActiveDate(o);
            })("previewChange", function (o) {
              return a._previewChanged(o);
            })("keyup", function (o) {
              return a._handleCalendarBodyKeyup(o);
            })("keydown", function (o) {
              return a._handleCalendarBodyKeydown(o);
            }), y()()), 2 & e && (g(3), b("ngForOf", a._weekdays), g(3), b("label", a._monthLabel)("rows", a._weeks)("todayValue", a._todayDate)("startValue", a._rangeStart)("endValue", a._rangeEnd)("comparisonStart", a._comparisonRangeStart)("comparisonEnd", a._comparisonRangeEnd)("previewStart", a._previewStart)("previewEnd", a._previewEnd)("isRange", a._isRange)("labelMinRequiredCells", 3)("activeCell", a._dateAdapter.getDate(a.activeDate) - 1));
          },
          dependencies: [ea, xs],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })(),
      rx = (() => {
        class n {
          constructor(e, a, i) {
            this._changeDetectorRef = e, this._dateAdapter = a, this._dir = i, this._rerenderSubscription = re.EMPTY, this.selectedChange = new E(), this.yearSelected = new E(), this.activeDateChange = new E(), this._activeDate = this._dateAdapter.today();
          }
          get activeDate() {
            return this._activeDate;
          }
          set activeDate(e) {
            let a = this._activeDate;
            const i = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e)) || this._dateAdapter.today();
            this._activeDate = this._dateAdapter.clampDate(i, this.minDate, this.maxDate), sx(this._dateAdapter, a, this._activeDate, this.minDate, this.maxDate) || this._init();
          }
          get selected() {
            return this._selected;
          }
          set selected(e) {
            this._selected = e instanceof xn ? e : this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e)), this._setSelectedYear(e);
          }
          get minDate() {
            return this._minDate;
          }
          set minDate(e) {
            this._minDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e));
          }
          get maxDate() {
            return this._maxDate;
          }
          set maxDate(e) {
            this._maxDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e));
          }
          ngAfterContentInit() {
            this._rerenderSubscription = this._dateAdapter.localeChanges.pipe(Gt(null)).subscribe(() => this._init());
          }
          ngOnDestroy() {
            this._rerenderSubscription.unsubscribe();
          }
          _init() {
            this._todayYear = this._dateAdapter.getYear(this._dateAdapter.today());
            const a = this._dateAdapter.getYear(this._activeDate) - xl(this._dateAdapter, this.activeDate, this.minDate, this.maxDate);
            this._years = [];
            for (let i = 0, o = []; i < 24; i++) o.push(a + i), 4 == o.length && (this._years.push(o.map(r => this._createCellForYear(r))), o = []);
            this._changeDetectorRef.markForCheck();
          }
          _yearSelected(e) {
            const a = e.value,
              i = this._dateAdapter.createDate(a, 0, 1),
              o = this._getDateFromYear(a);
            this.yearSelected.emit(i), this.selectedChange.emit(o);
          }
          _updateActiveDate(e) {
            const i = this._activeDate;
            this.activeDate = this._getDateFromYear(e.value), this._dateAdapter.compareDate(i, this.activeDate) && this.activeDateChange.emit(this.activeDate);
          }
          _handleCalendarBodyKeydown(e) {
            const a = this._activeDate,
              i = this._isRtl();
            switch (e.keyCode) {
              case 37:
                this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, i ? 1 : -1);
                break;
              case 39:
                this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, i ? -1 : 1);
                break;
              case 38:
                this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, -4);
                break;
              case 40:
                this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, 4);
                break;
              case 36:
                this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, -xl(this._dateAdapter, this.activeDate, this.minDate, this.maxDate));
                break;
              case 35:
                this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, 24 - xl(this._dateAdapter, this.activeDate, this.minDate, this.maxDate) - 1);
                break;
              case 33:
                this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, e.altKey ? -240 : -24);
                break;
              case 34:
                this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, e.altKey ? 240 : 24);
                break;
              case 13:
              case 32:
                this._selectionKeyPressed = !0;
                break;
              default:
                return;
            }
            this._dateAdapter.compareDate(a, this.activeDate) && this.activeDateChange.emit(this.activeDate), this._focusActiveCellAfterViewChecked(), e.preventDefault();
          }
          _handleCalendarBodyKeyup(e) {
            (32 === e.keyCode || 13 === e.keyCode) && (this._selectionKeyPressed && this._yearSelected({
              value: this._dateAdapter.getYear(this._activeDate),
              event: e
            }), this._selectionKeyPressed = !1);
          }
          _getActiveCell() {
            return xl(this._dateAdapter, this.activeDate, this.minDate, this.maxDate);
          }
          _focusActiveCell() {
            this._matCalendarBody._focusActiveCell();
          }
          _focusActiveCellAfterViewChecked() {
            this._matCalendarBody._scheduleFocusActiveCellAfterViewChecked();
          }
          _getDateFromYear(e) {
            const a = this._dateAdapter.getMonth(this.activeDate),
              i = this._dateAdapter.getNumDaysInMonth(this._dateAdapter.createDate(e, a, 1));
            return this._dateAdapter.createDate(e, a, Math.min(this._dateAdapter.getDate(this.activeDate), i));
          }
          _createCellForYear(e) {
            const a = this._dateAdapter.createDate(e, 0, 1),
              i = this._dateAdapter.getYearName(a),
              o = this.dateClass ? this.dateClass(a, "multi-year") : void 0;
            return new O4(e, i, i, this._shouldEnableYear(e), o);
          }
          _shouldEnableYear(e) {
            if (null == e || this.maxDate && e > this._dateAdapter.getYear(this.maxDate) || this.minDate && e < this._dateAdapter.getYear(this.minDate)) return !1;
            if (!this.dateFilter) return !0;
            for (let i = this._dateAdapter.createDate(e, 0, 1); this._dateAdapter.getYear(i) == e; i = this._dateAdapter.addCalendarDays(i, 1)) if (this.dateFilter(i)) return !0;
            return !1;
          }
          _isRtl() {
            return this._dir && "rtl" === this._dir.value;
          }
          _setSelectedYear(e) {
            if (this._selectedYear = null, e instanceof xn) {
              const a = e.start || e.end;
              a && (this._selectedYear = this._dateAdapter.getYear(a));
            } else e && (this._selectedYear = this._dateAdapter.getYear(e));
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Se), f(Qt, 8), f(nn, 8));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-multi-year-view"]],
          viewQuery: function (e, a) {
            if (1 & e && be(xs, 5), 2 & e) {
              let i;
              H(i = B()) && (a._matCalendarBody = i.first);
            }
          },
          inputs: {
            activeDate: "activeDate",
            selected: "selected",
            minDate: "minDate",
            maxDate: "maxDate",
            dateFilter: "dateFilter",
            dateClass: "dateClass"
          },
          outputs: {
            selectedChange: "selectedChange",
            yearSelected: "yearSelected",
            activeDateChange: "activeDateChange"
          },
          exportAs: ["matMultiYearView"],
          decls: 5,
          vars: 7,
          consts: [["role", "grid", 1, "mat-calendar-table"], ["aria-hidden", "true", 1, "mat-calendar-table-header"], ["colspan", "4", 1, "mat-calendar-table-header-divider"], ["mat-calendar-body", "", 3, "rows", "todayValue", "startValue", "endValue", "numCols", "cellAspectRatio", "activeCell", "selectedValueChange", "activeDateChange", "keyup", "keydown"]],
          template: function (e, a) {
            1 & e && (_(0, "table", 0)(1, "thead", 1)(2, "tr"), j(3, "th", 2), y()(), _(4, "tbody", 3), F("selectedValueChange", function (o) {
              return a._yearSelected(o);
            })("activeDateChange", function (o) {
              return a._updateActiveDate(o);
            })("keyup", function (o) {
              return a._handleCalendarBodyKeyup(o);
            })("keydown", function (o) {
              return a._handleCalendarBodyKeydown(o);
            }), y()()), 2 & e && (g(4), b("rows", a._years)("todayValue", a._todayYear)("startValue", a._selectedYear)("endValue", a._selectedYear)("numCols", 4)("cellAspectRatio", 4 / 7)("activeCell", a._getActiveCell()));
          },
          dependencies: [xs],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })();
    function sx(n, t, e, a, i) {
      const o = n.getYear(t),
        r = n.getYear(e),
        s = cx(n, a, i);
      return Math.floor((o - s) / 24) === Math.floor((r - s) / 24);
    }
    function xl(n, t, e, a) {
      return function ife(n, t) {
        return (n % t + t) % t;
      }(n.getYear(t) - cx(n, e, a), 24);
    }
    function cx(n, t, e) {
      let a = 0;
      return e ? a = n.getYear(e) - 24 + 1 : t && (a = n.getYear(t)), a;
    }
    let lx = (() => {
        class n {
          constructor(e, a, i, o) {
            this._changeDetectorRef = e, this._dateFormats = a, this._dateAdapter = i, this._dir = o, this._rerenderSubscription = re.EMPTY, this.selectedChange = new E(), this.monthSelected = new E(), this.activeDateChange = new E(), this._activeDate = this._dateAdapter.today();
          }
          get activeDate() {
            return this._activeDate;
          }
          set activeDate(e) {
            let a = this._activeDate;
            const i = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e)) || this._dateAdapter.today();
            this._activeDate = this._dateAdapter.clampDate(i, this.minDate, this.maxDate), this._dateAdapter.getYear(a) !== this._dateAdapter.getYear(this._activeDate) && this._init();
          }
          get selected() {
            return this._selected;
          }
          set selected(e) {
            this._selected = e instanceof xn ? e : this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e)), this._setSelectedMonth(e);
          }
          get minDate() {
            return this._minDate;
          }
          set minDate(e) {
            this._minDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e));
          }
          get maxDate() {
            return this._maxDate;
          }
          set maxDate(e) {
            this._maxDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e));
          }
          ngAfterContentInit() {
            this._rerenderSubscription = this._dateAdapter.localeChanges.pipe(Gt(null)).subscribe(() => this._init());
          }
          ngOnDestroy() {
            this._rerenderSubscription.unsubscribe();
          }
          _monthSelected(e) {
            const a = e.value,
              i = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), a, 1);
            this.monthSelected.emit(i);
            const o = this._getDateFromMonth(a);
            this.selectedChange.emit(o);
          }
          _updateActiveDate(e) {
            const i = this._activeDate;
            this.activeDate = this._getDateFromMonth(e.value), this._dateAdapter.compareDate(i, this.activeDate) && this.activeDateChange.emit(this.activeDate);
          }
          _handleCalendarBodyKeydown(e) {
            const a = this._activeDate,
              i = this._isRtl();
            switch (e.keyCode) {
              case 37:
                this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, i ? 1 : -1);
                break;
              case 39:
                this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, i ? -1 : 1);
                break;
              case 38:
                this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, -4);
                break;
              case 40:
                this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, 4);
                break;
              case 36:
                this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, -this._dateAdapter.getMonth(this._activeDate));
                break;
              case 35:
                this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, 11 - this._dateAdapter.getMonth(this._activeDate));
                break;
              case 33:
                this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, e.altKey ? -10 : -1);
                break;
              case 34:
                this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, e.altKey ? 10 : 1);
                break;
              case 13:
              case 32:
                this._selectionKeyPressed = !0;
                break;
              default:
                return;
            }
            this._dateAdapter.compareDate(a, this.activeDate) && (this.activeDateChange.emit(this.activeDate), this._focusActiveCellAfterViewChecked()), e.preventDefault();
          }
          _handleCalendarBodyKeyup(e) {
            (32 === e.keyCode || 13 === e.keyCode) && (this._selectionKeyPressed && this._monthSelected({
              value: this._dateAdapter.getMonth(this._activeDate),
              event: e
            }), this._selectionKeyPressed = !1);
          }
          _init() {
            this._setSelectedMonth(this.selected), this._todayMonth = this._getMonthInCurrentYear(this._dateAdapter.today()), this._yearLabel = this._dateAdapter.getYearName(this.activeDate);
            let e = this._dateAdapter.getMonthNames("short");
            this._months = [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]].map(a => a.map(i => this._createCellForMonth(i, e[i]))), this._changeDetectorRef.markForCheck();
          }
          _focusActiveCell() {
            this._matCalendarBody._focusActiveCell();
          }
          _focusActiveCellAfterViewChecked() {
            this._matCalendarBody._scheduleFocusActiveCellAfterViewChecked();
          }
          _getMonthInCurrentYear(e) {
            return e && this._dateAdapter.getYear(e) == this._dateAdapter.getYear(this.activeDate) ? this._dateAdapter.getMonth(e) : null;
          }
          _getDateFromMonth(e) {
            const a = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), e, 1),
              i = this._dateAdapter.getNumDaysInMonth(a);
            return this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), e, Math.min(this._dateAdapter.getDate(this.activeDate), i));
          }
          _createCellForMonth(e, a) {
            const i = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), e, 1),
              o = this._dateAdapter.format(i, this._dateFormats.display.monthYearA11yLabel),
              r = this.dateClass ? this.dateClass(i, "year") : void 0;
            return new O4(e, a.toLocaleUpperCase(), o, this._shouldEnableMonth(e), r);
          }
          _shouldEnableMonth(e) {
            const a = this._dateAdapter.getYear(this.activeDate);
            if (null == e || this._isYearAndMonthAfterMaxDate(a, e) || this._isYearAndMonthBeforeMinDate(a, e)) return !1;
            if (!this.dateFilter) return !0;
            for (let o = this._dateAdapter.createDate(a, e, 1); this._dateAdapter.getMonth(o) == e; o = this._dateAdapter.addCalendarDays(o, 1)) if (this.dateFilter(o)) return !0;
            return !1;
          }
          _isYearAndMonthAfterMaxDate(e, a) {
            if (this.maxDate) {
              const i = this._dateAdapter.getYear(this.maxDate),
                o = this._dateAdapter.getMonth(this.maxDate);
              return e > i || e === i && a > o;
            }
            return !1;
          }
          _isYearAndMonthBeforeMinDate(e, a) {
            if (this.minDate) {
              const i = this._dateAdapter.getYear(this.minDate),
                o = this._dateAdapter.getMonth(this.minDate);
              return e < i || e === i && a < o;
            }
            return !1;
          }
          _isRtl() {
            return this._dir && "rtl" === this._dir.value;
          }
          _setSelectedMonth(e) {
            this._selectedMonth = e instanceof xn ? this._getMonthInCurrentYear(e.start) || this._getMonthInCurrentYear(e.end) : this._getMonthInCurrentYear(e);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Se), f(Vo, 8), f(Qt, 8), f(nn, 8));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-year-view"]],
          viewQuery: function (e, a) {
            if (1 & e && be(xs, 5), 2 & e) {
              let i;
              H(i = B()) && (a._matCalendarBody = i.first);
            }
          },
          inputs: {
            activeDate: "activeDate",
            selected: "selected",
            minDate: "minDate",
            maxDate: "maxDate",
            dateFilter: "dateFilter",
            dateClass: "dateClass"
          },
          outputs: {
            selectedChange: "selectedChange",
            monthSelected: "monthSelected",
            activeDateChange: "activeDateChange"
          },
          exportAs: ["matYearView"],
          decls: 5,
          vars: 9,
          consts: [["role", "grid", 1, "mat-calendar-table"], ["aria-hidden", "true", 1, "mat-calendar-table-header"], ["colspan", "4", 1, "mat-calendar-table-header-divider"], ["mat-calendar-body", "", 3, "label", "rows", "todayValue", "startValue", "endValue", "labelMinRequiredCells", "numCols", "cellAspectRatio", "activeCell", "selectedValueChange", "activeDateChange", "keyup", "keydown"]],
          template: function (e, a) {
            1 & e && (_(0, "table", 0)(1, "thead", 1)(2, "tr"), j(3, "th", 2), y()(), _(4, "tbody", 3), F("selectedValueChange", function (o) {
              return a._monthSelected(o);
            })("activeDateChange", function (o) {
              return a._updateActiveDate(o);
            })("keyup", function (o) {
              return a._handleCalendarBodyKeyup(o);
            })("keydown", function (o) {
              return a._handleCalendarBodyKeydown(o);
            }), y()()), 2 & e && (g(4), b("label", a._yearLabel)("rows", a._months)("todayValue", a._todayMonth)("startValue", a._selectedMonth)("endValue", a._selectedMonth)("labelMinRequiredCells", 2)("numCols", 4)("cellAspectRatio", 4 / 7)("activeCell", a._dateAdapter.getMonth(a.activeDate)));
          },
          dependencies: [xs],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })(),
      ofe = 0,
      rfe = (() => {
        class n {
          constructor(e, a, i, o, r) {
            this._intl = e, this.calendar = a, this._dateAdapter = i, this._dateFormats = o, this._buttonDescriptionId = "mat-calendar-button-" + ofe++, this.calendar.stateChanges.subscribe(() => r.markForCheck());
          }
          get periodButtonText() {
            if ("month" == this.calendar.currentView) return this._dateAdapter.format(this.calendar.activeDate, this._dateFormats.display.monthYearLabel).toLocaleUpperCase();
            if ("year" == this.calendar.currentView) return this._dateAdapter.getYearName(this.calendar.activeDate);
            const a = this._dateAdapter.getYear(this.calendar.activeDate) - xl(this._dateAdapter, this.calendar.activeDate, this.calendar.minDate, this.calendar.maxDate),
              i = a + 24 - 1,
              o = this._dateAdapter.getYearName(this._dateAdapter.createDate(a, 0, 1)),
              r = this._dateAdapter.getYearName(this._dateAdapter.createDate(i, 0, 1));
            return this._intl.formatYearRange(o, r);
          }
          get periodButtonLabel() {
            return "month" == this.calendar.currentView ? this._intl.switchToMultiYearViewLabel : this._intl.switchToMonthViewLabel;
          }
          get prevButtonLabel() {
            return {
              month: this._intl.prevMonthLabel,
              year: this._intl.prevYearLabel,
              "multi-year": this._intl.prevMultiYearLabel
            }[this.calendar.currentView];
          }
          get nextButtonLabel() {
            return {
              month: this._intl.nextMonthLabel,
              year: this._intl.nextYearLabel,
              "multi-year": this._intl.nextMultiYearLabel
            }[this.calendar.currentView];
          }
          currentPeriodClicked() {
            this.calendar.currentView = "month" == this.calendar.currentView ? "multi-year" : "month";
          }
          previousClicked() {
            this.calendar.activeDate = "month" == this.calendar.currentView ? this._dateAdapter.addCalendarMonths(this.calendar.activeDate, -1) : this._dateAdapter.addCalendarYears(this.calendar.activeDate, "year" == this.calendar.currentView ? -1 : -24);
          }
          nextClicked() {
            this.calendar.activeDate = "month" == this.calendar.currentView ? this._dateAdapter.addCalendarMonths(this.calendar.activeDate, 1) : this._dateAdapter.addCalendarYears(this.calendar.activeDate, "year" == this.calendar.currentView ? 1 : 24);
          }
          previousEnabled() {
            return !this.calendar.minDate || !this.calendar.minDate || !this._isSameView(this.calendar.activeDate, this.calendar.minDate);
          }
          nextEnabled() {
            return !this.calendar.maxDate || !this._isSameView(this.calendar.activeDate, this.calendar.maxDate);
          }
          _isSameView(e, a) {
            return "month" == this.calendar.currentView ? this._dateAdapter.getYear(e) == this._dateAdapter.getYear(a) && this._dateAdapter.getMonth(e) == this._dateAdapter.getMonth(a) : "year" == this.calendar.currentView ? this._dateAdapter.getYear(e) == this._dateAdapter.getYear(a) : sx(this._dateAdapter, e, a, this.calendar.minDate, this.calendar.maxDate);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Ml), f(Pe(() => I4)), f(Qt, 8), f(Vo, 8), f(Se));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-calendar-header"]],
          exportAs: ["matCalendarHeader"],
          ngContentSelectors: jue,
          decls: 11,
          vars: 10,
          consts: [[1, "mat-calendar-header"], [1, "mat-calendar-controls"], ["mat-button", "", "type", "button", "aria-live", "polite", 1, "mat-calendar-period-button", 3, "click"], ["viewBox", "0 0 10 5", "focusable", "false", 1, "mat-calendar-arrow"], ["points", "0,0 5,5 10,0"], [1, "mat-calendar-spacer"], ["mat-icon-button", "", "type", "button", 1, "mat-calendar-previous-button", 3, "disabled", "click"], ["mat-icon-button", "", "type", "button", 1, "mat-calendar-next-button", 3, "disabled", "click"]],
          template: function (e, a) {
            1 & e && (lt(), _(0, "div", 0)(1, "div", 1)(2, "button", 2), F("click", function () {
              return a.currentPeriodClicked();
            }), _(3, "span"), S(4), y(), Kn(), _(5, "svg", 3), j(6, "polygon", 4), y()(), qs(), j(7, "div", 5), Me(8), _(9, "button", 6), F("click", function () {
              return a.previousClicked();
            }), y(), _(10, "button", 7), F("click", function () {
              return a.nextClicked();
            }), y()()()), 2 & e && (g(2), X("aria-label", a.periodButtonLabel)("aria-describedby", a._buttonDescriptionId), g(1), X("id", a._buttonDescriptionId), g(1), Ie(a.periodButtonText), g(1), fe("mat-calendar-invert", "month" !== a.calendar.currentView), g(4), b("disabled", !a.previousEnabled()), X("aria-label", a.prevButtonLabel), g(1), b("disabled", !a.nextEnabled()), X("aria-label", a.nextButtonLabel));
          },
          dependencies: [Pi],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })(),
      I4 = (() => {
        class n {
          constructor(e, a, i, o) {
            this._dateAdapter = a, this._dateFormats = i, this._changeDetectorRef = o, this._moveFocusOnNextTick = !1, this.startView = "month", this.selectedChange = new E(), this.yearSelected = new E(), this.monthSelected = new E(), this.viewChanged = new E(!0), this._userSelection = new E(), this.stateChanges = new V(), this._intlChanges = e.changes.subscribe(() => {
              o.markForCheck(), this.stateChanges.next();
            });
          }
          get startAt() {
            return this._startAt;
          }
          set startAt(e) {
            this._startAt = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e));
          }
          get selected() {
            return this._selected;
          }
          set selected(e) {
            this._selected = e instanceof xn ? e : this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e));
          }
          get minDate() {
            return this._minDate;
          }
          set minDate(e) {
            this._minDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e));
          }
          get maxDate() {
            return this._maxDate;
          }
          set maxDate(e) {
            this._maxDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e));
          }
          get activeDate() {
            return this._clampedActiveDate;
          }
          set activeDate(e) {
            this._clampedActiveDate = this._dateAdapter.clampDate(e, this.minDate, this.maxDate), this.stateChanges.next(), this._changeDetectorRef.markForCheck();
          }
          get currentView() {
            return this._currentView;
          }
          set currentView(e) {
            const a = this._currentView !== e ? e : null;
            this._currentView = e, this._moveFocusOnNextTick = !0, this._changeDetectorRef.markForCheck(), a && this.viewChanged.emit(a);
          }
          ngAfterContentInit() {
            this._calendarHeaderPortal = new $r(this.headerComponent || rfe), this.activeDate = this.startAt || this._dateAdapter.today(), this._currentView = this.startView;
          }
          ngAfterViewChecked() {
            this._moveFocusOnNextTick && (this._moveFocusOnNextTick = !1, this.focusActiveCell());
          }
          ngOnDestroy() {
            this._intlChanges.unsubscribe(), this.stateChanges.complete();
          }
          ngOnChanges(e) {
            const a = e.minDate && !this._dateAdapter.sameDate(e.minDate.previousValue, e.minDate.currentValue) ? e.minDate : void 0,
              i = e.maxDate && !this._dateAdapter.sameDate(e.maxDate.previousValue, e.maxDate.currentValue) ? e.maxDate : void 0,
              o = a || i || e.dateFilter;
            if (o && !o.firstChange) {
              const r = this._getCurrentViewComponent();
              r && (this._changeDetectorRef.detectChanges(), r._init());
            }
            this.stateChanges.next();
          }
          focusActiveCell() {
            this._getCurrentViewComponent()._focusActiveCell(!1);
          }
          updateTodaysDate() {
            this._getCurrentViewComponent()._init();
          }
          _dateSelected(e) {
            const a = e.value;
            (this.selected instanceof xn || a && !this._dateAdapter.sameDate(a, this.selected)) && this.selectedChange.emit(a), this._userSelection.emit(e);
          }
          _yearSelectedInMultiYearView(e) {
            this.yearSelected.emit(e);
          }
          _monthSelectedInYearView(e) {
            this.monthSelected.emit(e);
          }
          _goToDateInView(e, a) {
            this.activeDate = e, this.currentView = a;
          }
          _getCurrentViewComponent() {
            return this.monthView || this.yearView || this.multiYearView;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Ml), f(Qt, 8), f(Vo, 8), f(Se));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-calendar"]],
          viewQuery: function (e, a) {
            if (1 & e && (be(ox, 5), be(lx, 5), be(rx, 5)), 2 & e) {
              let i;
              H(i = B()) && (a.monthView = i.first), H(i = B()) && (a.yearView = i.first), H(i = B()) && (a.multiYearView = i.first);
            }
          },
          hostAttrs: [1, "mat-calendar"],
          inputs: {
            headerComponent: "headerComponent",
            startAt: "startAt",
            startView: "startView",
            selected: "selected",
            minDate: "minDate",
            maxDate: "maxDate",
            dateFilter: "dateFilter",
            dateClass: "dateClass",
            comparisonStart: "comparisonStart",
            comparisonEnd: "comparisonEnd"
          },
          outputs: {
            selectedChange: "selectedChange",
            yearSelected: "yearSelected",
            monthSelected: "monthSelected",
            viewChanged: "viewChanged",
            _userSelection: "_userSelection"
          },
          exportAs: ["matCalendar"],
          features: [G([ix]), Ve],
          decls: 5,
          vars: 5,
          consts: [[3, "cdkPortalOutlet"], ["cdkMonitorSubtreeFocus", "", "tabindex", "-1", 1, "mat-calendar-content", 3, "ngSwitch"], [3, "activeDate", "selected", "dateFilter", "maxDate", "minDate", "dateClass", "comparisonStart", "comparisonEnd", "activeDateChange", "_userSelection", 4, "ngSwitchCase"], [3, "activeDate", "selected", "dateFilter", "maxDate", "minDate", "dateClass", "activeDateChange", "monthSelected", "selectedChange", 4, "ngSwitchCase"], [3, "activeDate", "selected", "dateFilter", "maxDate", "minDate", "dateClass", "activeDateChange", "yearSelected", "selectedChange", 4, "ngSwitchCase"], [3, "activeDate", "selected", "dateFilter", "maxDate", "minDate", "dateClass", "comparisonStart", "comparisonEnd", "activeDateChange", "_userSelection"], [3, "activeDate", "selected", "dateFilter", "maxDate", "minDate", "dateClass", "activeDateChange", "monthSelected", "selectedChange"], [3, "activeDate", "selected", "dateFilter", "maxDate", "minDate", "dateClass", "activeDateChange", "yearSelected", "selectedChange"]],
          template: function (e, a) {
            1 & e && (D(0, Uue, 0, 0, "ng-template", 0), _(1, "div", 1), D(2, Gue, 1, 8, "mat-month-view", 2), D(3, Wue, 1, 6, "mat-year-view", 3), D(4, Yue, 1, 6, "mat-multi-year-view", 4), y()), 2 & e && (b("cdkPortalOutlet", a._calendarHeaderPortal), g(1), b("ngSwitch", a.currentView), g(1), b("ngSwitchCase", "month"), g(1), b("ngSwitchCase", "year"), g(1), b("ngSwitchCase", "multi-year"));
          },
          dependencies: [Gi, Wr, iB, es, ox, lx, rx],
          styles: ['.mat-calendar{display:block}.mat-calendar-header{padding:8px 8px 0 8px}.mat-calendar-content{padding:0 8px 8px 8px;outline:none}.mat-calendar-controls{display:flex;margin:5% calc(4.7142857143% - 16px)}.mat-calendar-controls .mat-icon-button:hover .mat-button-focus-overlay{opacity:.04}.mat-calendar-spacer{flex:1 1 auto}.mat-calendar-period-button{min-width:0}.mat-calendar-arrow{display:inline-block;width:10px;height:5px;margin:0 0 0 5px;vertical-align:middle}.mat-calendar-arrow.mat-calendar-invert{transform:rotate(180deg)}[dir=rtl] .mat-calendar-arrow{margin:0 5px 0 0}.cdk-high-contrast-active .mat-calendar-arrow{fill:CanvasText}.mat-calendar-previous-button,.mat-calendar-next-button{position:relative}.mat-calendar-previous-button::after,.mat-calendar-next-button::after{top:0;left:0;right:0;bottom:0;position:absolute;content:"";margin:15.5px;border:0 solid currentColor;border-top-width:2px}[dir=rtl] .mat-calendar-previous-button,[dir=rtl] .mat-calendar-next-button{transform:rotate(180deg)}.mat-calendar-previous-button::after{border-left-width:2px;transform:translateX(2px) rotate(-45deg)}.mat-calendar-next-button::after{border-right-width:2px;transform:translateX(-2px) rotate(45deg)}.mat-calendar-table{border-spacing:0;border-collapse:collapse;width:100%}.mat-calendar-table-header th{text-align:center;padding:0 0 8px 0}.mat-calendar-table-header-divider{position:relative;height:1px}.mat-calendar-table-header-divider::after{content:"";position:absolute;top:0;left:-8px;right:-8px;height:1px}.mat-calendar-body-cell-content::before{margin:calc(calc(var(--mat-focus-indicator-border-width, 3px) + 3px) * -1)}.mat-calendar-body-cell:focus .mat-focus-indicator::before{content:""}'],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })();
    const dx = {
      transformPanel: ht("transformPanel", [Ee("void => enter-dropdown", Re("120ms cubic-bezier(0, 0, 0.2, 1)", Do([Z({
        opacity: 0,
        transform: "scale(1, 0.8)"
      }), Z({
        opacity: 1,
        transform: "scale(1, 1)"
      })]))), Ee("void => enter-dialog", Re("150ms cubic-bezier(0, 0, 0.2, 1)", Do([Z({
        opacity: 0,
        transform: "scale(0.7)"
      }), Z({
        transform: "none",
        opacity: 1
      })]))), Ee("* => void", Re("100ms linear", Z({
        opacity: 0
      })))]),
      fadeInCalendar: ht("fadeInCalendar", [xe("void", Z({
        opacity: 0
      })), xe("enter", Z({
        opacity: 1
      })), Ee("void => *", Re("120ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)"))])
    };
    let sfe = 0;
    const ux = new O("mat-datepicker-scroll-strategy"),
      lfe = {
        provide: ux,
        deps: [mn],
        useFactory: function cfe(n) {
          return () => n.scrollStrategies.reposition();
        }
      },
      dfe = Qa(class {
        constructor(n) {
          this._elementRef = n;
        }
      });
    let ufe = (() => {
        class n extends dfe {
          constructor(e, a, i, o, r, s) {
            super(e), this._changeDetectorRef = a, this._globalModel = i, this._dateAdapter = o, this._rangeSelectionStrategy = r, this._subscriptions = new re(), this._animationDone = new V(), this._actionsPortal = null, this._closeButtonText = s.closeCalendarLabel;
          }
          ngOnInit() {
            this._animationState = this.datepicker.touchUi ? "enter-dialog" : "enter-dropdown";
          }
          ngAfterViewInit() {
            this._subscriptions.add(this.datepicker.stateChanges.subscribe(() => {
              this._changeDetectorRef.markForCheck();
            })), this._calendar.focusActiveCell();
          }
          ngOnDestroy() {
            this._subscriptions.unsubscribe(), this._animationDone.complete();
          }
          _handleUserSelection(e) {
            const a = this._model.selection,
              i = e.value,
              o = a instanceof xn;
            if (o && this._rangeSelectionStrategy) {
              const r = this._rangeSelectionStrategy.selectionFinished(i, a, e.event);
              this._model.updateSelection(r, this);
            } else i && (o || !this._dateAdapter.sameDate(i, a)) && this._model.add(i);
            (!this._model || this._model.isComplete()) && !this._actionsPortal && this.datepicker.close();
          }
          _startExitAnimation() {
            this._animationState = "void", this._changeDetectorRef.markForCheck();
          }
          _getSelected() {
            return this._model.selection;
          }
          _applyPendingSelection() {
            this._model !== this._globalModel && this._globalModel.updateSelection(this._model.selection, this);
          }
          _assignActions(e, a) {
            this._model = e ? this._globalModel.clone() : this._globalModel, this._actionsPortal = e, a && this._changeDetectorRef.detectChanges();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(Se), f(io), f(Qt), f(c0, 8), f(Ml));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-datepicker-content"]],
          viewQuery: function (e, a) {
            if (1 & e && be(I4, 5), 2 & e) {
              let i;
              H(i = B()) && (a._calendar = i.first);
            }
          },
          hostAttrs: [1, "mat-datepicker-content"],
          hostVars: 3,
          hostBindings: function (e, a) {
            1 & e && V1("@transformPanel.done", function () {
              return a._animationDone.next();
            }), 2 & e && (B1("@transformPanel", a._animationState), fe("mat-datepicker-content-touch", a.datepicker.touchUi));
          },
          inputs: {
            color: "color"
          },
          exportAs: ["matDatepickerContent"],
          features: [z],
          decls: 5,
          vars: 24,
          consts: [["cdkTrapFocus", "", "role", "dialog", 1, "mat-datepicker-content-container"], [3, "id", "ngClass", "startAt", "startView", "minDate", "maxDate", "dateFilter", "headerComponent", "selected", "dateClass", "comparisonStart", "comparisonEnd", "yearSelected", "monthSelected", "viewChanged", "_userSelection"], [3, "cdkPortalOutlet"], ["type", "button", "mat-raised-button", "", 1, "mat-datepicker-close-button", 3, "color", "focus", "blur", "click"]],
          template: function (e, a) {
            if (1 & e && (_(0, "div", 0)(1, "mat-calendar", 1), F("yearSelected", function (o) {
              return a.datepicker._selectYear(o);
            })("monthSelected", function (o) {
              return a.datepicker._selectMonth(o);
            })("viewChanged", function (o) {
              return a.datepicker._viewChanged(o);
            })("_userSelection", function (o) {
              return a._handleUserSelection(o);
            }), y(), D(2, que, 0, 0, "ng-template", 2), _(3, "button", 3), F("focus", function () {
              return a._closeButtonFocused = !0;
            })("blur", function () {
              return a._closeButtonFocused = !1;
            })("click", function () {
              return a.datepicker.close();
            }), S(4), y()()), 2 & e) {
              let i;
              fe("mat-datepicker-content-container-with-custom-header", a.datepicker.calendarHeaderComponent)("mat-datepicker-content-container-with-actions", a._actionsPortal), X("aria-modal", !0)("aria-labelledby", null !== (i = a._dialogLabelId) && void 0 !== i ? i : void 0), g(1), b("id", a.datepicker.id)("ngClass", a.datepicker.panelClass)("startAt", a.datepicker.startAt)("startView", a.datepicker.startView)("minDate", a.datepicker._getMinDate())("maxDate", a.datepicker._getMaxDate())("dateFilter", a.datepicker._getDateFilter())("headerComponent", a.datepicker.calendarHeaderComponent)("selected", a._getSelected())("dateClass", a.datepicker.dateClass)("comparisonStart", a.comparisonStart)("comparisonEnd", a.comparisonEnd)("@fadeInCalendar", "enter"), g(1), b("cdkPortalOutlet", a._actionsPortal), g(1), fe("cdk-visually-hidden", !a._closeButtonFocused), b("color", a.color || "primary"), g(1), Ie(a._closeButtonText);
            }
          },
          dependencies: [ko, Pi, ZH, es, I4],
          styles: [".mat-datepicker-content{display:block;border-radius:4px}.mat-datepicker-content .mat-calendar{width:296px;height:354px}.mat-datepicker-content .mat-datepicker-content-container-with-custom-header .mat-calendar{height:auto}.mat-datepicker-content .mat-datepicker-close-button{position:absolute;top:100%;left:0;margin-top:8px}.ng-animating .mat-datepicker-content .mat-datepicker-close-button{display:none}.mat-datepicker-content-container{display:flex;flex-direction:column;justify-content:space-between}.mat-datepicker-content-touch{display:block;max-height:80vh;position:relative;overflow:visible}.mat-datepicker-content-touch .mat-datepicker-content-container{min-height:312px;max-height:788px;min-width:250px;max-width:750px}.mat-datepicker-content-touch .mat-calendar{width:100%;height:auto}@media all and (orientation: landscape){.mat-datepicker-content-touch .mat-datepicker-content-container{width:64vh;height:80vh}}@media all and (orientation: portrait){.mat-datepicker-content-touch .mat-datepicker-content-container{width:80vw;height:100vw}.mat-datepicker-content-touch .mat-datepicker-content-container-with-actions{height:115vw}}"],
          encapsulation: 2,
          data: {
            animation: [dx.transformPanel, dx.fadeInCalendar]
          },
          changeDetection: 0
        }), n;
      })(),
      fx = (() => {
        class n {
          constructor(e, a, i, o, r, s, c) {
            this._overlay = e, this._ngZone = a, this._viewContainerRef = i, this._dateAdapter = r, this._dir = s, this._model = c, this._inputStateChanges = re.EMPTY, this._document = La(ie), this.startView = "month", this._touchUi = !1, this.xPosition = "start", this.yPosition = "below", this._restoreFocus = !0, this.yearSelected = new E(), this.monthSelected = new E(), this.viewChanged = new E(!0), this.openedStream = new E(), this.closedStream = new E(), this._opened = !1, this.id = "mat-datepicker-" + sfe++, this._focusedElementBeforeOpen = null, this._backdropHarnessClass = `${this.id}-backdrop`, this.stateChanges = new V(), this._scrollStrategy = o;
          }
          get startAt() {
            return this._startAt || (this.datepickerInput ? this.datepickerInput.getStartValue() : null);
          }
          set startAt(e) {
            this._startAt = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e));
          }
          get color() {
            return this._color || (this.datepickerInput ? this.datepickerInput.getThemePalette() : void 0);
          }
          set color(e) {
            this._color = e;
          }
          get touchUi() {
            return this._touchUi;
          }
          set touchUi(e) {
            this._touchUi = Y(e);
          }
          get disabled() {
            return void 0 === this._disabled && this.datepickerInput ? this.datepickerInput.disabled : !!this._disabled;
          }
          set disabled(e) {
            const a = Y(e);
            a !== this._disabled && (this._disabled = a, this.stateChanges.next(void 0));
          }
          get restoreFocus() {
            return this._restoreFocus;
          }
          set restoreFocus(e) {
            this._restoreFocus = Y(e);
          }
          get panelClass() {
            return this._panelClass;
          }
          set panelClass(e) {
            this._panelClass = e_(e);
          }
          get opened() {
            return this._opened;
          }
          set opened(e) {
            Y(e) ? this.open() : this.close();
          }
          _getMinDate() {
            return this.datepickerInput && this.datepickerInput.min;
          }
          _getMaxDate() {
            return this.datepickerInput && this.datepickerInput.max;
          }
          _getDateFilter() {
            return this.datepickerInput && this.datepickerInput.dateFilter;
          }
          ngOnChanges(e) {
            const a = e.xPosition || e.yPosition;
            if (a && !a.firstChange && this._overlayRef) {
              const i = this._overlayRef.getConfig().positionStrategy;
              i instanceof __ && (this._setConnectedPositions(i), this.opened && this._overlayRef.updatePosition());
            }
            this.stateChanges.next(void 0);
          }
          ngOnDestroy() {
            this._destroyOverlay(), this.close(), this._inputStateChanges.unsubscribe(), this.stateChanges.complete();
          }
          select(e) {
            this._model.add(e);
          }
          _selectYear(e) {
            this.yearSelected.emit(e);
          }
          _selectMonth(e) {
            this.monthSelected.emit(e);
          }
          _viewChanged(e) {
            this.viewChanged.emit(e);
          }
          registerInput(e) {
            return this._inputStateChanges.unsubscribe(), this.datepickerInput = e, this._inputStateChanges = e.stateChanges.subscribe(() => this.stateChanges.next(void 0)), this._model;
          }
          registerActions(e) {
            this._actionsPortal = e, this._componentRef?.instance._assignActions(e, !0);
          }
          removeActions(e) {
            e === this._actionsPortal && (this._actionsPortal = null, this._componentRef?.instance._assignActions(null, !0));
          }
          open() {
            this._opened || this.disabled || (this._focusedElementBeforeOpen = Fc(), this._openOverlay(), this._opened = !0, this.openedStream.emit());
          }
          close() {
            if (!this._opened) return;
            const e = this._restoreFocus && this._focusedElementBeforeOpen && "function" == typeof this._focusedElementBeforeOpen.focus,
              a = () => {
                this._opened && (this._opened = !1, this.closedStream.emit());
              };
            if (this._componentRef) {
              const {
                instance: i,
                location: o
              } = this._componentRef;
              i._startExitAnimation(), i._animationDone.pipe($e(1)).subscribe(() => {
                const r = this._document.activeElement;
                e && (!r || r === this._document.activeElement || o.nativeElement.contains(r)) && this._focusedElementBeforeOpen.focus(), this._focusedElementBeforeOpen = null, this._destroyOverlay();
              });
            }
            e ? setTimeout(a) : a();
          }
          _applyPendingSelection() {
            this._componentRef?.instance?._applyPendingSelection();
          }
          _forwardContentValues(e) {
            e.datepicker = this, e.color = this.color, e._dialogLabelId = this.datepickerInput.getOverlayLabelId(), e._assignActions(this._actionsPortal, !1);
          }
          _openOverlay() {
            this._destroyOverlay();
            const e = this.touchUi,
              a = new $r(ufe, this._viewContainerRef),
              i = this._overlayRef = this._overlay.create(new jc({
                positionStrategy: e ? this._getDialogStrategy() : this._getDropdownStrategy(),
                hasBackdrop: !0,
                backdropClass: [e ? "cdk-overlay-dark-backdrop" : "mat-overlay-transparent-backdrop", this._backdropHarnessClass],
                direction: this._dir,
                scrollStrategy: e ? this._overlay.scrollStrategies.block() : this._scrollStrategy(),
                panelClass: "mat-datepicker-" + (e ? "dialog" : "popup")
              }));
            this._getCloseStream(i).subscribe(o => {
              o && o.preventDefault(), this.close();
            }), i.keydownEvents().subscribe(o => {
              const r = o.keyCode;
              (38 === r || 40 === r || 37 === r || 39 === r || 33 === r || 34 === r) && o.preventDefault();
            }), this._componentRef = i.attach(a), this._forwardContentValues(this._componentRef.instance), e || this._ngZone.onStable.pipe($e(1)).subscribe(() => i.updatePosition());
          }
          _destroyOverlay() {
            this._overlayRef && (this._overlayRef.dispose(), this._overlayRef = this._componentRef = null);
          }
          _getDialogStrategy() {
            return this._overlay.position().global().centerHorizontally().centerVertically();
          }
          _getDropdownStrategy() {
            const e = this._overlay.position().flexibleConnectedTo(this.datepickerInput.getConnectedOverlayOrigin()).withTransformOriginOn(".mat-datepicker-content").withFlexibleDimensions(!1).withViewportMargin(8).withLockedPosition();
            return this._setConnectedPositions(e);
          }
          _setConnectedPositions(e) {
            const a = "end" === this.xPosition ? "end" : "start",
              i = "start" === a ? "end" : "start",
              o = "above" === this.yPosition ? "bottom" : "top",
              r = "top" === o ? "bottom" : "top";
            return e.withPositions([{
              originX: a,
              originY: r,
              overlayX: a,
              overlayY: o
            }, {
              originX: a,
              originY: o,
              overlayX: a,
              overlayY: r
            }, {
              originX: i,
              originY: r,
              overlayX: i,
              overlayY: o
            }, {
              originX: i,
              originY: o,
              overlayX: i,
              overlayY: r
            }]);
          }
          _getCloseStream(e) {
            return dt(e.backdropClick(), e.detachments(), e.keydownEvents().pipe(Ht(a => 27 === a.keyCode && !Et(a) || this.datepickerInput && Et(a, "altKey") && 38 === a.keyCode)));
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(mn), f(ae), f(ut), f(ux), f(Qt, 8), f(nn, 8), f(io));
        }, n.ɵdir = P({
          type: n,
          inputs: {
            calendarHeaderComponent: "calendarHeaderComponent",
            startAt: "startAt",
            startView: "startView",
            color: "color",
            touchUi: "touchUi",
            disabled: "disabled",
            xPosition: "xPosition",
            yPosition: "yPosition",
            restoreFocus: "restoreFocus",
            dateClass: "dateClass",
            panelClass: "panelClass",
            opened: "opened"
          },
          outputs: {
            yearSelected: "yearSelected",
            monthSelected: "monthSelected",
            viewChanged: "viewChanged",
            openedStream: "opened",
            closedStream: "closed"
          },
          features: [Ve]
        }), n;
      })(),
      ffe = (() => {
        class n extends fx {}
        return n.ɵfac = function () {
          let t;
          return function (a) {
            return (t || (t = he(n)))(a || n);
          };
        }(), n.ɵcmp = q({
          type: n,
          selectors: [["mat-datepicker"]],
          exportAs: ["matDatepicker"],
          features: [G([ix, {
            provide: fx,
            useExisting: n
          }]), z],
          decls: 0,
          vars: 0,
          template: function (e, a) {},
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })();
    class l0 {
      constructor(t, e) {
        this.target = t, this.targetElement = e, this.value = this.target.value;
      }
    }
    let mfe = (() => {
      class n {
        constructor(e, a, i) {
          this._elementRef = e, this._dateAdapter = a, this._dateFormats = i, this.dateChange = new E(), this.dateInput = new E(), this.stateChanges = new V(), this._onTouched = () => {}, this._validatorOnChange = () => {}, this._cvaOnChange = () => {}, this._valueChangesSubscription = re.EMPTY, this._localeSubscription = re.EMPTY, this._parseValidator = () => this._lastValueValid ? null : {
            matDatepickerParse: {
              text: this._elementRef.nativeElement.value
            }
          }, this._filterValidator = o => {
            const r = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(o.value));
            return !r || this._matchesFilter(r) ? null : {
              matDatepickerFilter: !0
            };
          }, this._minValidator = o => {
            const r = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(o.value)),
              s = this._getMinDate();
            return !s || !r || this._dateAdapter.compareDate(s, r) <= 0 ? null : {
              matDatepickerMin: {
                min: s,
                actual: r
              }
            };
          }, this._maxValidator = o => {
            const r = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(o.value)),
              s = this._getMaxDate();
            return !s || !r || this._dateAdapter.compareDate(s, r) >= 0 ? null : {
              matDatepickerMax: {
                max: s,
                actual: r
              }
            };
          }, this._lastValueValid = !1, this._localeSubscription = a.localeChanges.subscribe(() => {
            this._assignValueProgrammatically(this.value);
          });
        }
        get value() {
          return this._model ? this._getValueFromModel(this._model.selection) : this._pendingValue;
        }
        set value(e) {
          this._assignValueProgrammatically(e);
        }
        get disabled() {
          return !!this._disabled || this._parentDisabled();
        }
        set disabled(e) {
          const a = Y(e),
            i = this._elementRef.nativeElement;
          this._disabled !== a && (this._disabled = a, this.stateChanges.next(void 0)), a && this._isInitialized && i.blur && i.blur();
        }
        _getValidators() {
          return [this._parseValidator, this._minValidator, this._maxValidator, this._filterValidator];
        }
        _registerModel(e) {
          this._model = e, this._valueChangesSubscription.unsubscribe(), this._pendingValue && this._assignValue(this._pendingValue), this._valueChangesSubscription = this._model.selectionChanged.subscribe(a => {
            if (this._shouldHandleChangeEvent(a)) {
              const i = this._getValueFromModel(a.selection);
              this._lastValueValid = this._isValidValue(i), this._cvaOnChange(i), this._onTouched(), this._formatValue(i), this.dateInput.emit(new l0(this, this._elementRef.nativeElement)), this.dateChange.emit(new l0(this, this._elementRef.nativeElement));
            }
          });
        }
        ngAfterViewInit() {
          this._isInitialized = !0;
        }
        ngOnChanges(e) {
          (function hfe(n, t) {
            const e = Object.keys(n);
            for (let a of e) {
              const {
                previousValue: i,
                currentValue: o
              } = n[a];
              if (!t.isDateInstance(i) || !t.isDateInstance(o)) return !0;
              if (!t.sameDate(i, o)) return !0;
            }
            return !1;
          })(e, this._dateAdapter) && this.stateChanges.next(void 0);
        }
        ngOnDestroy() {
          this._valueChangesSubscription.unsubscribe(), this._localeSubscription.unsubscribe(), this.stateChanges.complete();
        }
        registerOnValidatorChange(e) {
          this._validatorOnChange = e;
        }
        validate(e) {
          return this._validator ? this._validator(e) : null;
        }
        writeValue(e) {
          this._assignValueProgrammatically(e);
        }
        registerOnChange(e) {
          this._cvaOnChange = e;
        }
        registerOnTouched(e) {
          this._onTouched = e;
        }
        setDisabledState(e) {
          this.disabled = e;
        }
        _onKeydown(e) {
          e.altKey && 40 === e.keyCode && !this._elementRef.nativeElement.readOnly && (this._openPopup(), e.preventDefault());
        }
        _onInput(e) {
          const a = this._lastValueValid;
          let i = this._dateAdapter.parse(e, this._dateFormats.parse.dateInput);
          this._lastValueValid = this._isValidValue(i), i = this._dateAdapter.getValidDateOrNull(i);
          const o = !this._dateAdapter.sameDate(i, this.value);
          !i || o ? this._cvaOnChange(i) : (e && !this.value && this._cvaOnChange(i), a !== this._lastValueValid && this._validatorOnChange()), o && (this._assignValue(i), this.dateInput.emit(new l0(this, this._elementRef.nativeElement)));
        }
        _onChange() {
          this.dateChange.emit(new l0(this, this._elementRef.nativeElement));
        }
        _onBlur() {
          this.value && this._formatValue(this.value), this._onTouched();
        }
        _formatValue(e) {
          this._elementRef.nativeElement.value = null != e ? this._dateAdapter.format(e, this._dateFormats.display.dateInput) : "";
        }
        _assignValue(e) {
          this._model ? (this._assignValueToModel(e), this._pendingValue = null) : this._pendingValue = e;
        }
        _isValidValue(e) {
          return !e || this._dateAdapter.isValid(e);
        }
        _parentDisabled() {
          return !1;
        }
        _assignValueProgrammatically(e) {
          e = this._dateAdapter.deserialize(e), this._lastValueValid = this._isValidValue(e), e = this._dateAdapter.getValidDateOrNull(e), this._assignValue(e), this._formatValue(e);
        }
        _matchesFilter(e) {
          const a = this._getDateFilter();
          return !a || a(e);
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(f(J), f(Qt, 8), f(Vo, 8));
      }, n.ɵdir = P({
        type: n,
        inputs: {
          value: "value",
          disabled: "disabled"
        },
        outputs: {
          dateChange: "dateChange",
          dateInput: "dateInput"
        },
        features: [Ve]
      }), n;
    })();
    const pfe = {
        provide: Bt,
        useExisting: Pe(() => R4),
        multi: !0
      },
      gfe = {
        provide: jt,
        useExisting: Pe(() => R4),
        multi: !0
      };
    let R4 = (() => {
        class n extends mfe {
          constructor(e, a, i, o) {
            super(e, a, i), this._formField = o, this._closedSubscription = re.EMPTY, this._validator = Da.compose(super._getValidators());
          }
          set matDatepicker(e) {
            e && (this._datepicker = e, this._closedSubscription = e.closedStream.subscribe(() => this._onTouched()), this._registerModel(e.registerInput(this)));
          }
          get min() {
            return this._min;
          }
          set min(e) {
            const a = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e));
            this._dateAdapter.sameDate(a, this._min) || (this._min = a, this._validatorOnChange());
          }
          get max() {
            return this._max;
          }
          set max(e) {
            const a = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(e));
            this._dateAdapter.sameDate(a, this._max) || (this._max = a, this._validatorOnChange());
          }
          get dateFilter() {
            return this._dateFilter;
          }
          set dateFilter(e) {
            const a = this._matchesFilter(this.value);
            this._dateFilter = e, this._matchesFilter(this.value) !== a && this._validatorOnChange();
          }
          getConnectedOverlayOrigin() {
            return this._formField ? this._formField.getConnectedOverlayOrigin() : this._elementRef;
          }
          getOverlayLabelId() {
            return this._formField ? this._formField.getLabelId() : this._elementRef.nativeElement.getAttribute("aria-labelledby");
          }
          getThemePalette() {
            return this._formField ? this._formField.color : void 0;
          }
          getStartValue() {
            return this.value;
          }
          ngOnDestroy() {
            super.ngOnDestroy(), this._closedSubscription.unsubscribe();
          }
          _openPopup() {
            this._datepicker && this._datepicker.open();
          }
          _getValueFromModel(e) {
            return e;
          }
          _assignValueToModel(e) {
            this._model && this._model.updateSelection(e, this);
          }
          _getMinDate() {
            return this._min;
          }
          _getMaxDate() {
            return this._max;
          }
          _getDateFilter() {
            return this._dateFilter;
          }
          _shouldHandleChangeEvent(e) {
            return e.source !== this;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(Qt, 8), f(Vo, 8), f(_l, 8));
        }, n.ɵdir = P({
          type: n,
          selectors: [["input", "matDatepicker", ""]],
          hostAttrs: [1, "mat-datepicker-input"],
          hostVars: 6,
          hostBindings: function (e, a) {
            1 & e && F("input", function (o) {
              return a._onInput(o.target.value);
            })("change", function () {
              return a._onChange();
            })("blur", function () {
              return a._onBlur();
            })("keydown", function (o) {
              return a._onKeydown(o);
            }), 2 & e && (Zn("disabled", a.disabled), X("aria-haspopup", a._datepicker ? "dialog" : null)("aria-owns", (null == a._datepicker ? null : a._datepicker.opened) && a._datepicker.id || null)("min", a.min ? a._dateAdapter.toIso8601(a.min) : null)("max", a.max ? a._dateAdapter.toIso8601(a.max) : null)("data-mat-calendar", a._datepicker ? a._datepicker.id : null));
          },
          inputs: {
            matDatepicker: "matDatepicker",
            min: "min",
            max: "max",
            dateFilter: ["matDatepickerFilter", "dateFilter"]
          },
          exportAs: ["matDatepickerInput"],
          features: [G([pfe, gfe, {
            provide: jM,
            useExisting: n
          }]), z]
        }), n;
      })(),
      bfe = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "matDatepickerToggleIcon", ""]]
        }), n;
      })(),
      _fe = (() => {
        class n {
          constructor(e, a, i) {
            this._intl = e, this._changeDetectorRef = a, this._stateChanges = re.EMPTY;
            const o = Number(i);
            this.tabIndex = o || 0 === o ? o : null;
          }
          get disabled() {
            return void 0 === this._disabled && this.datepicker ? this.datepicker.disabled : !!this._disabled;
          }
          set disabled(e) {
            this._disabled = Y(e);
          }
          ngOnChanges(e) {
            e.datepicker && this._watchStateChanges();
          }
          ngOnDestroy() {
            this._stateChanges.unsubscribe();
          }
          ngAfterContentInit() {
            this._watchStateChanges();
          }
          _open(e) {
            this.datepicker && !this.disabled && (this.datepicker.open(), e.stopPropagation());
          }
          _watchStateChanges() {
            const e = this.datepicker ? this.datepicker.stateChanges : nt(),
              a = this.datepicker && this.datepicker.datepickerInput ? this.datepicker.datepickerInput.stateChanges : nt(),
              i = this.datepicker ? dt(this.datepicker.openedStream, this.datepicker.closedStream) : nt();
            this._stateChanges.unsubscribe(), this._stateChanges = dt(this._intl.changes, e, a, i).subscribe(() => this._changeDetectorRef.markForCheck());
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Ml), f(Se), qt("tabindex"));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-datepicker-toggle"]],
          contentQueries: function (e, a, i) {
            if (1 & e && De(i, bfe, 5), 2 & e) {
              let o;
              H(o = B()) && (a._customIcon = o.first);
            }
          },
          viewQuery: function (e, a) {
            if (1 & e && be(Kue, 5), 2 & e) {
              let i;
              H(i = B()) && (a._button = i.first);
            }
          },
          hostAttrs: [1, "mat-datepicker-toggle"],
          hostVars: 8,
          hostBindings: function (e, a) {
            1 & e && F("click", function (o) {
              return a._open(o);
            }), 2 & e && (X("tabindex", null)("data-mat-calendar", a.datepicker ? a.datepicker.id : null), fe("mat-datepicker-toggle-active", a.datepicker && a.datepicker.opened)("mat-accent", a.datepicker && "accent" === a.datepicker.color)("mat-warn", a.datepicker && "warn" === a.datepicker.color));
          },
          inputs: {
            datepicker: ["for", "datepicker"],
            tabIndex: "tabIndex",
            ariaLabel: ["aria-label", "ariaLabel"],
            disabled: "disabled",
            disableRipple: "disableRipple"
          },
          exportAs: ["matDatepickerToggle"],
          features: [Ve],
          ngContentSelectors: Xue,
          decls: 4,
          vars: 6,
          consts: [["mat-icon-button", "", "type", "button", 3, "disabled", "disableRipple"], ["button", ""], ["class", "mat-datepicker-toggle-default-icon", "viewBox", "0 0 24 24", "width", "24px", "height", "24px", "fill", "currentColor", "focusable", "false", 4, "ngIf"], ["viewBox", "0 0 24 24", "width", "24px", "height", "24px", "fill", "currentColor", "focusable", "false", 1, "mat-datepicker-toggle-default-icon"], ["d", "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"]],
          template: function (e, a) {
            1 & e && (lt(Zue), _(0, "button", 0, 1), D(2, Que, 2, 0, "svg", 2), Me(3), y()), 2 & e && (b("disabled", a.disabled)("disableRipple", a.disableRipple), X("aria-haspopup", a.datepicker ? "dialog" : null)("aria-label", a.ariaLabel || a._intl.openCalendarLabel)("tabindex", a.disabled ? -1 : a.tabIndex), g(2), b("ngIf", !a._customIcon));
          },
          dependencies: [mt, Pi],
          styles: [".mat-form-field-appearance-legacy .mat-form-field-prefix .mat-datepicker-toggle-default-icon,.mat-form-field-appearance-legacy .mat-form-field-suffix .mat-datepicker-toggle-default-icon{width:1em}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-datepicker-toggle-default-icon,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-datepicker-toggle-default-icon{display:block;width:1.5em;height:1.5em}.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-prefix .mat-icon-button .mat-datepicker-toggle-default-icon,.mat-form-field:not(.mat-form-field-appearance-legacy) .mat-form-field-suffix .mat-icon-button .mat-datepicker-toggle-default-icon{margin:auto}.cdk-high-contrast-active .mat-datepicker-toggle-default-icon{color:CanvasText}"],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })(),
      z4 = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [Ml, lfe],
          imports: [yt, Wo, qa, Xc, Ya, $, Wa]
        }), n;
      })();
    const vfe = ["picker"],
      yfe = ["toggle"];
    function Cfe(n, t) {
      1 & n && (_(0, "mat-error"), S(1, " Value must be a "), _(2, "strong"), S(3, "date"), y()());
    }
    function Mfe(n, t) {
      1 & n && (_(0, "mat-error"), S(1, " Value is "), _(2, "strong"), S(3, "required"), y()());
    }
    let d0 = /*#__PURE__*/(() => {
      class d0 {
        elementRef;
        picker;
        toggle;
        formGroup;
        control;
        node;
        index;
        changed = new E();
        constructor(t) {
          this.elementRef = t;
        }
        ngOnInit() {
          this.formGroup.get("values").setValue(this.getValue(this.node.model[this.node.key], this.node.valueLocation)), this.formGroup.get("values").valueChanges.subscribe(t => {
            this.node.model[this.node.key] = this.setValue(t, this.node.model[this.node.key], this.node.valueLocation), this.changed.emit({
              type: this.node.type,
              subtype: this.node.subtype,
              model: this.node.model,
              key: this.node.key,
              index: 0,
              location: this.node.valueLocation,
              value: t
            });
          });
        }
        parseDate(t) {
          if (t) {
            const e = new Date(t);
            return e.setMinutes(e.getMinutes() + e.getTimezoneOffset()), e;
          }
          return null;
        }
        getValue(t, e) {
          const a = [];
          if (t) {
            if (Array.isArray(t)) for (let i = 0; i < t.length; i++) a.push(this.parseDate(t[i][e]) || null);else a.push(this.parseDate(t[e]) || null);
          } else a.push(null);
          return a;
        }
        setDate(t, e) {
          const a = {
            "@type": "xsd:dateTime"
          };
          return a[e] = t ? this.parseDate(t).toISOString().substring(0, 10) : null, a;
        }
        setValue(t, e, a) {
          const i = [];
          if (Array.isArray(t)) for (let o = 0; o < t.length; o++) i.push(this.setDate(t[o], a));else i.push(this.setDate(t, a));
          return i;
        }
        static ɵfac = function (e) {
          return new (e || d0)(f(J));
        };
        static ɵcmp = q({
          type: d0,
          selectors: [["app-date"]],
          viewQuery: function (e, a) {
            if (1 & e && (be(vfe, 7), be(yfe, 7)), 2 & e) {
              let i;
              H(i = B()) && (a.picker = i.first), H(i = B()) && (a.toggle = i.first);
            }
          },
          inputs: {
            formGroup: "formGroup",
            control: "control",
            node: "node",
            index: "index"
          },
          outputs: {
            changed: "changed"
          },
          decls: 10,
          vars: 7,
          consts: [[1, "mat-form-field"], ["matInput", "", 3, "required", "matDatepicker", "formControl"], ["matSuffix", "", 3, "for"], ["toggle", ""], ["picker", ""], [4, "ngIf"]],
          template: function (e, a) {
            if (1 & e && (_(0, "mat-form-field", 0), j(1, "input", 1), _(2, "mat-hint"), S(3), y(), j(4, "mat-datepicker-toggle", 2, 3)(6, "mat-datepicker", null, 4), D(8, Cfe, 4, 0, "mat-error", 5), D(9, Mfe, 4, 0, "mat-error", 5), y()), 2 & e) {
              const i = Kt(7);
              g(1), b("required", a.node.required)("matDatepicker", i)("formControl", a.control), g(2), Ie(a.node.hint), g(1), b("for", i), g(4), b("ngIf", a.control.hasError("matDatepickerParse")), g(1), b("ngIf", a.control.hasError("required"));
            }
          },
          dependencies: [mt, x4, Si, Cs, D0e, yi, oa, No, Pa, yl, ffe, R4, _fe],
          styles: [".mat-form-field{margin-bottom:10px;width:100%}\n"],
          encapsulation: 2
        });
      }
      return d0;
    })();
    let u0 = /*#__PURE__*/(() => {
      class u0 {
        formGroup;
        node;
        constructor() {}
        static ɵfac = function (e) {
          return new (e || u0)();
        };
        static ɵcmp = q({
          type: u0,
          selectors: [["app-section"]],
          inputs: {
            formGroup: "formGroup",
            node: "node"
          },
          decls: 2,
          vars: 1,
          consts: [[1, "section-break"]],
          template: function (e, a) {
            1 & e && (_(0, "div", 0), S(1), y()), 2 & e && (g(1), Fe(" ", a.node.name, "\n"));
          },
          styles: ['.mat-badge-content[_ngcontent-%COMP%]{font-weight:600;font-size:12px;font-family:Roboto,Helvetica Neue,sans-serif}.mat-badge-small[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{font-size:9px}.mat-badge-large[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{font-size:24px}.mat-h1[_ngcontent-%COMP%], .mat-headline[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-headline[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font:400 24px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h2[_ngcontent-%COMP%], .mat-title[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-title[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h3[_ngcontent-%COMP%], .mat-subheading-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h3[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-subheading-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font:400 16px/28px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h4[_ngcontent-%COMP%], .mat-subheading-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h4[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-subheading-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{font:400 15px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h5[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h5[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font:400 11.62px/20px Roboto,Helvetica Neue,sans-serif;margin:0 0 12px}.mat-h6[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h6[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font:400 9.38px/20px Roboto,Helvetica Neue,sans-serif;margin:0 0 12px}.mat-body-strong[_ngcontent-%COMP%], .mat-body-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body-strong[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body-2[_ngcontent-%COMP%]{font:500 14px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-body[_ngcontent-%COMP%], .mat-body-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-body[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-body-1[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body-1[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0 0 12px}.mat-small[_ngcontent-%COMP%], .mat-caption[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-small[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-caption[_ngcontent-%COMP%]{font:400 12px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-display-4[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-4[_ngcontent-%COMP%]{font:300 112px/112px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.05em;margin:0 0 56px}.mat-display-3[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-3[_ngcontent-%COMP%]{font:400 56px/56px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.02em;margin:0 0 64px}.mat-display-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-2[_ngcontent-%COMP%]{font:400 45px/48px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.005em;margin:0 0 64px}.mat-display-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-1[_ngcontent-%COMP%]{font:400 34px/40px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 64px}.mat-bottom-sheet-container[_ngcontent-%COMP%]{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-button[_ngcontent-%COMP%], .mat-raised-button[_ngcontent-%COMP%], .mat-icon-button[_ngcontent-%COMP%], .mat-stroked-button[_ngcontent-%COMP%], .mat-flat-button[_ngcontent-%COMP%], .mat-fab[_ngcontent-%COMP%], .mat-mini-fab[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-button-toggle[_ngcontent-%COMP%], .mat-card[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-card-title[_ngcontent-%COMP%]{font-size:24px;font-weight:500}.mat-card-header[_ngcontent-%COMP%]   .mat-card-title[_ngcontent-%COMP%]{font-size:20px}.mat-card-subtitle[_ngcontent-%COMP%], .mat-card-content[_ngcontent-%COMP%]{font-size:14px}.mat-checkbox[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-checkbox-layout[_ngcontent-%COMP%]   .mat-checkbox-label[_ngcontent-%COMP%]{line-height:24px}.mat-chip[_ngcontent-%COMP%]{font-size:14px;font-weight:500}.mat-chip[_ngcontent-%COMP%]   .mat-chip-trailing-icon.mat-icon[_ngcontent-%COMP%], .mat-chip[_ngcontent-%COMP%]   .mat-chip-remove.mat-icon[_ngcontent-%COMP%]{font-size:18px}.mat-table[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-header-cell[_ngcontent-%COMP%]{font-size:12px;font-weight:500}.mat-cell[_ngcontent-%COMP%], .mat-footer-cell[_ngcontent-%COMP%]{font-size:14px}.mat-calendar[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-calendar-body[_ngcontent-%COMP%]{font-size:13px}.mat-calendar-body-label[_ngcontent-%COMP%], .mat-calendar-period-button[_ngcontent-%COMP%]{font-size:14px;font-weight:500}.mat-calendar-table-header[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-size:11px;font-weight:400}.mat-dialog-title[_ngcontent-%COMP%]{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-expansion-panel-header[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:15px;font-weight:400}.mat-expansion-panel-content[_ngcontent-%COMP%]{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-form-field[_ngcontent-%COMP%]{font-size:inherit;font-weight:400;line-height:1.125;font-family:Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-form-field-wrapper[_ngcontent-%COMP%]{padding-bottom:1.34375em}.mat-form-field-prefix[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-form-field-suffix[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{font-size:150%;line-height:1.125}.mat-form-field-prefix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%], .mat-form-field-suffix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]{height:1.5em;width:1.5em}.mat-form-field-prefix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-form-field-suffix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{height:1.125em;line-height:1.125}.mat-form-field-infix[_ngcontent-%COMP%]{padding:.5em 0;border-top:.84375em solid transparent}.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.34375em) scale(.75);width:133.3333333333%}.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.34374em) scale(.75);width:133.3333433333%}.mat-form-field-label-wrapper[_ngcontent-%COMP%]{top:-.84375em;padding-top:.84375em}.mat-form-field-label[_ngcontent-%COMP%]{top:1.34375em}.mat-form-field-underline[_ngcontent-%COMP%]{bottom:1.34375em}.mat-form-field-subscript-wrapper[_ngcontent-%COMP%]{font-size:75%;margin-top:.6666666667em;top:calc(100% - 1.7916666667em)}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-wrapper[_ngcontent-%COMP%]{padding-bottom:1.25em}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]{padding:.4375em 0}.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.001px);width:133.3333333333%}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-form-field-autofill-control[_ngcontent-%COMP%]:-webkit-autofill + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00101px);width:133.3333433333%}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00102px);width:133.3333533333%}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{top:1.28125em}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]{bottom:1.25em}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-subscript-wrapper[_ngcontent-%COMP%]{margin-top:.5416666667em;top:calc(100% - 1.6666666667em)}@media print{.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28122em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-form-field-autofill-control[_ngcontent-%COMP%]:-webkit-autofill + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28121em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.2812em) scale(.75)}}.mat-form-field-appearance-fill[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]{padding:.25em 0 .75em}.mat-form-field-appearance-fill[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{top:1.09375em;margin-top:-.5em}.mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-fill.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-.59375em) scale(.75);width:133.3333333333%}.mat-form-field-appearance-fill.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-.59374em) scale(.75);width:133.3333433333%}.mat-form-field-appearance-outline[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]{padding:1em 0}.mat-form-field-appearance-outline[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{top:1.84375em;margin-top:-.25em}.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-outline.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.59375em) scale(.75);width:133.3333333333%}.mat-form-field-appearance-outline.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.59374em) scale(.75);width:133.3333433333%}.mat-grid-tile-header[_ngcontent-%COMP%], .mat-grid-tile-footer[_ngcontent-%COMP%]{font-size:14px}.mat-grid-tile-header[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%], .mat-grid-tile-footer[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-grid-tile-header[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2), .mat-grid-tile-footer[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2){font-size:12px}input.mat-input-element[_ngcontent-%COMP%]{margin-top:-.0625em}.mat-menu-item[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:400}.mat-paginator[_ngcontent-%COMP%], .mat-paginator-page-size[_ngcontent-%COMP%]   .mat-select-trigger[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px}.mat-radio-button[_ngcontent-%COMP%], .mat-select[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-select-trigger[_ngcontent-%COMP%]{height:1.125em}.mat-slide-toggle-content[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-slider-thumb-label-text[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px;font-weight:500}.mat-stepper-vertical[_ngcontent-%COMP%], .mat-stepper-horizontal[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-step-label[_ngcontent-%COMP%]{font-size:14px;font-weight:400}.mat-step-sub-label-error[_ngcontent-%COMP%]{font-weight:400}.mat-step-label-error[_ngcontent-%COMP%]{font-size:14px}.mat-step-label-selected[_ngcontent-%COMP%]{font-size:14px;font-weight:500}.mat-tab-group[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-tab-label[_ngcontent-%COMP%], .mat-tab-link[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-toolbar[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0}.mat-tooltip[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:10px;padding-top:6px;padding-bottom:6px}.mat-tooltip-handset[_ngcontent-%COMP%]{font-size:14px;padding-top:8px;padding-bottom:8px}.mat-list-item[_ngcontent-%COMP%], .mat-list-option[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-ripple-element[_ngcontent-%COMP%]{background-color:#0000001a}.mat-option[_ngcontent-%COMP%]{color:#000000de}.mat-option[_ngcontent-%COMP%]:hover:not(.mat-option-disabled), .mat-option[_ngcontent-%COMP%]:focus:not(.mat-option-disabled){background:rgba(0,0,0,.04)}.mat-option.mat-selected[_ngcontent-%COMP%]:not(.mat-option-multiple):not(.mat-option-disabled){background:rgba(0,0,0,.04)}.mat-option.mat-active[_ngcontent-%COMP%]{background:rgba(0,0,0,.04);color:#000000de}.mat-option.mat-option-disabled[_ngcontent-%COMP%]{color:#00000061}.mat-primary[_ngcontent-%COMP%]   .mat-option.mat-selected[_ngcontent-%COMP%]:not(.mat-option-disabled){color:#5fa0c5}.mat-accent[_ngcontent-%COMP%]   .mat-option.mat-selected[_ngcontent-%COMP%]:not(.mat-option-disabled){color:#95b8a2}.mat-warn[_ngcontent-%COMP%]   .mat-option.mat-selected[_ngcontent-%COMP%]:not(.mat-option-disabled){color:#c62e3c}.mat-optgroup-label[_ngcontent-%COMP%]{color:#0000008a}.mat-optgroup-disabled[_ngcontent-%COMP%]   .mat-optgroup-label[_ngcontent-%COMP%]{color:#00000061}.mat-pseudo-checkbox[_ngcontent-%COMP%]{color:#0000008a}.mat-pseudo-checkbox[_ngcontent-%COMP%]:after{color:#fafafa}.mat-pseudo-checkbox-disabled[_ngcontent-%COMP%]{color:#b0b0b0}.mat-primary[_ngcontent-%COMP%]   .mat-pseudo-checkbox-checked[_ngcontent-%COMP%], .mat-primary[_ngcontent-%COMP%]   .mat-pseudo-checkbox-indeterminate[_ngcontent-%COMP%]{background:#5fa0c5}.mat-pseudo-checkbox-checked[_ngcontent-%COMP%], .mat-pseudo-checkbox-indeterminate[_ngcontent-%COMP%], .mat-accent[_ngcontent-%COMP%]   .mat-pseudo-checkbox-checked[_ngcontent-%COMP%], .mat-accent[_ngcontent-%COMP%]   .mat-pseudo-checkbox-indeterminate[_ngcontent-%COMP%]{background:#95b8a2}.mat-warn[_ngcontent-%COMP%]   .mat-pseudo-checkbox-checked[_ngcontent-%COMP%], .mat-warn[_ngcontent-%COMP%]   .mat-pseudo-checkbox-indeterminate[_ngcontent-%COMP%]{background:#c62e3c}.mat-pseudo-checkbox-checked.mat-pseudo-checkbox-disabled[_ngcontent-%COMP%], .mat-pseudo-checkbox-indeterminate.mat-pseudo-checkbox-disabled[_ngcontent-%COMP%]{background:#b0b0b0}.mat-app-background[_ngcontent-%COMP%]{background-color:#fafafa;color:#000000de}.mat-elevation-z0[_ngcontent-%COMP%]{box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-elevation-z1[_ngcontent-%COMP%]{box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.mat-elevation-z2[_ngcontent-%COMP%]{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-elevation-z3[_ngcontent-%COMP%]{box-shadow:0 3px 3px -2px #0003,0 3px 4px #00000024,0 1px 8px #0000001f}.mat-elevation-z4[_ngcontent-%COMP%]{box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mat-elevation-z5[_ngcontent-%COMP%]{box-shadow:0 3px 5px -1px #0003,0 5px 8px #00000024,0 1px 14px #0000001f}.mat-elevation-z6[_ngcontent-%COMP%]{box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mat-elevation-z7[_ngcontent-%COMP%]{box-shadow:0 4px 5px -2px #0003,0 7px 10px 1px #00000024,0 2px 16px 1px #0000001f}.mat-elevation-z8[_ngcontent-%COMP%]{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.mat-elevation-z9[_ngcontent-%COMP%]{box-shadow:0 5px 6px -3px #0003,0 9px 12px 1px #00000024,0 3px 16px 2px #0000001f}.mat-elevation-z10[_ngcontent-%COMP%]{box-shadow:0 6px 6px -3px #0003,0 10px 14px 1px #00000024,0 4px 18px 3px #0000001f}.mat-elevation-z11[_ngcontent-%COMP%]{box-shadow:0 6px 7px -4px #0003,0 11px 15px 1px #00000024,0 4px 20px 3px #0000001f}.mat-elevation-z12[_ngcontent-%COMP%]{box-shadow:0 7px 8px -4px #0003,0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f}.mat-elevation-z13[_ngcontent-%COMP%]{box-shadow:0 7px 8px -4px #0003,0 13px 19px 2px #00000024,0 5px 24px 4px #0000001f}.mat-elevation-z14[_ngcontent-%COMP%]{box-shadow:0 7px 9px -4px #0003,0 14px 21px 2px #00000024,0 5px 26px 4px #0000001f}.mat-elevation-z15[_ngcontent-%COMP%]{box-shadow:0 8px 9px -5px #0003,0 15px 22px 2px #00000024,0 6px 28px 5px #0000001f}.mat-elevation-z16[_ngcontent-%COMP%]{box-shadow:0 8px 10px -5px #0003,0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f}.mat-elevation-z17[_ngcontent-%COMP%]{box-shadow:0 8px 11px -5px #0003,0 17px 26px 2px #00000024,0 6px 32px 5px #0000001f}.mat-elevation-z18[_ngcontent-%COMP%]{box-shadow:0 9px 11px -5px #0003,0 18px 28px 2px #00000024,0 7px 34px 6px #0000001f}.mat-elevation-z19[_ngcontent-%COMP%]{box-shadow:0 9px 12px -6px #0003,0 19px 29px 2px #00000024,0 7px 36px 6px #0000001f}.mat-elevation-z20[_ngcontent-%COMP%]{box-shadow:0 10px 13px -6px #0003,0 20px 31px 3px #00000024,0 8px 38px 7px #0000001f}.mat-elevation-z21[_ngcontent-%COMP%]{box-shadow:0 10px 13px -6px #0003,0 21px 33px 3px #00000024,0 8px 40px 7px #0000001f}.mat-elevation-z22[_ngcontent-%COMP%]{box-shadow:0 10px 14px -6px #0003,0 22px 35px 3px #00000024,0 8px 42px 7px #0000001f}.mat-elevation-z23[_ngcontent-%COMP%]{box-shadow:0 11px 14px -7px #0003,0 23px 36px 3px #00000024,0 9px 44px 8px #0000001f}.mat-elevation-z24[_ngcontent-%COMP%]{box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f}.mat-theme-loaded-marker[_ngcontent-%COMP%]{display:none}.mat-autocomplete-panel[_ngcontent-%COMP%]{background:white;color:#000000de}.mat-autocomplete-panel[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-option.mat-selected[_ngcontent-%COMP%]:not(.mat-active):not(:hover){background:white}.mat-autocomplete-panel[_ngcontent-%COMP%]   .mat-option.mat-selected[_ngcontent-%COMP%]:not(.mat-active):not(:hover):not(.mat-option-disabled){color:#000000de}.mat-badge[_ngcontent-%COMP%]{position:relative}.mat-badge.mat-badge[_ngcontent-%COMP%]{overflow:visible}.mat-badge-hidden[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{display:none}.mat-badge-content[_ngcontent-%COMP%]{position:absolute;text-align:center;display:inline-block;border-radius:50%;transition:transform .2s ease-in-out;transform:scale(.6);overflow:hidden;white-space:nowrap;text-overflow:ellipsis;pointer-events:none}.ng-animate-disabled[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%], .mat-badge-content._mat-animation-noopable[_ngcontent-%COMP%]{transition:none}.mat-badge-content.mat-badge-active[_ngcontent-%COMP%]{transform:none}.mat-badge-small[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{width:16px;height:16px;line-height:16px}.mat-badge-small.mat-badge-above[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{top:-8px}.mat-badge-small.mat-badge-below[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{bottom:-8px}.mat-badge-small.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:-16px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-small.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:auto;right:-16px}.mat-badge-small.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:-16px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-small.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:auto;left:-16px}.mat-badge-small.mat-badge-overlap.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:-8px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-small.mat-badge-overlap.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:auto;right:-8px}.mat-badge-small.mat-badge-overlap.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:-8px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-small.mat-badge-overlap.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:auto;left:-8px}.mat-badge-medium[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{width:22px;height:22px;line-height:22px}.mat-badge-medium.mat-badge-above[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{top:-11px}.mat-badge-medium.mat-badge-below[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{bottom:-11px}.mat-badge-medium.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:-22px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-medium.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:auto;right:-22px}.mat-badge-medium.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:-22px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-medium.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:auto;left:-22px}.mat-badge-medium.mat-badge-overlap.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:-11px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-medium.mat-badge-overlap.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:auto;right:-11px}.mat-badge-medium.mat-badge-overlap.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:-11px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-medium.mat-badge-overlap.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:auto;left:-11px}.mat-badge-large[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{width:28px;height:28px;line-height:28px}.mat-badge-large.mat-badge-above[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{top:-14px}.mat-badge-large.mat-badge-below[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{bottom:-14px}.mat-badge-large.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:-28px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-large.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:auto;right:-28px}.mat-badge-large.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:-28px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-large.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:auto;left:-28px}.mat-badge-large.mat-badge-overlap.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:-14px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-large.mat-badge-overlap.mat-badge-before[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{left:auto;right:-14px}.mat-badge-large.mat-badge-overlap.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:-14px}[dir=rtl][_ngcontent-%COMP%]   .mat-badge-large.mat-badge-overlap.mat-badge-after[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{right:auto;left:-14px}.mat-badge-content[_ngcontent-%COMP%]{color:#000;background:#5fa0c5}.cdk-high-contrast-active[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{outline:solid 1px;border-radius:0}.mat-badge-accent[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{background:#95b8a2;color:#000}.mat-badge-warn[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{color:#fff;background:#c62e3c}.mat-badge-disabled[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{background:#b9b9b9;color:#00000061}.mat-bottom-sheet-container[_ngcontent-%COMP%]{box-shadow:0 8px 10px -5px #0003,0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f;background:white;color:#000000de}.mat-button[_ngcontent-%COMP%], .mat-icon-button[_ngcontent-%COMP%], .mat-stroked-button[_ngcontent-%COMP%]{color:inherit;background:transparent}.mat-button.mat-primary[_ngcontent-%COMP%], .mat-icon-button.mat-primary[_ngcontent-%COMP%], .mat-stroked-button.mat-primary[_ngcontent-%COMP%]{color:#5fa0c5}.mat-button.mat-accent[_ngcontent-%COMP%], .mat-icon-button.mat-accent[_ngcontent-%COMP%], .mat-stroked-button.mat-accent[_ngcontent-%COMP%]{color:#95b8a2}.mat-button.mat-warn[_ngcontent-%COMP%], .mat-icon-button.mat-warn[_ngcontent-%COMP%], .mat-stroked-button.mat-warn[_ngcontent-%COMP%]{color:#c62e3c}.mat-button.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-button.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-button.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%], .mat-icon-button.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-icon-button.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-icon-button.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-icon-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%], .mat-stroked-button.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-stroked-button.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-stroked-button.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-stroked-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%]{color:#00000042}.mat-button.mat-primary[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%], .mat-icon-button.mat-primary[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%], .mat-stroked-button.mat-primary[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-button.mat-accent[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%], .mat-icon-button.mat-accent[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%], .mat-stroked-button.mat-accent[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-button.mat-warn[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%], .mat-icon-button.mat-warn[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%], .mat-stroked-button.mat-warn[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-button.mat-button-disabled[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%], .mat-icon-button.mat-button-disabled[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%], .mat-stroked-button.mat-button-disabled[_ngcontent-%COMP%]   .mat-button-focus-overlay[_ngcontent-%COMP%]{background-color:transparent}.mat-button[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-icon-button[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-stroked-button[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{opacity:.1;background-color:currentColor}.mat-button-focus-overlay[_ngcontent-%COMP%]{background:black}.mat-stroked-button[_ngcontent-%COMP%]:not(.mat-button-disabled){border-color:#0000001f}.mat-flat-button[_ngcontent-%COMP%], .mat-raised-button[_ngcontent-%COMP%], .mat-fab[_ngcontent-%COMP%], .mat-mini-fab[_ngcontent-%COMP%]{color:#000000de;background-color:#fff}.mat-flat-button.mat-primary[_ngcontent-%COMP%], .mat-raised-button.mat-primary[_ngcontent-%COMP%], .mat-fab.mat-primary[_ngcontent-%COMP%], .mat-mini-fab.mat-primary[_ngcontent-%COMP%], .mat-flat-button.mat-accent[_ngcontent-%COMP%], .mat-raised-button.mat-accent[_ngcontent-%COMP%], .mat-fab.mat-accent[_ngcontent-%COMP%], .mat-mini-fab.mat-accent[_ngcontent-%COMP%]{color:#000}.mat-flat-button.mat-warn[_ngcontent-%COMP%], .mat-raised-button.mat-warn[_ngcontent-%COMP%], .mat-fab.mat-warn[_ngcontent-%COMP%], .mat-mini-fab.mat-warn[_ngcontent-%COMP%]{color:#fff}.mat-flat-button.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-flat-button.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-flat-button.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-flat-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%], .mat-raised-button.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-raised-button.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-raised-button.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-raised-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%], .mat-fab.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-fab.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-fab.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-fab.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%], .mat-mini-fab.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-mini-fab.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-mini-fab.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-mini-fab.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%]{color:#00000042}.mat-flat-button.mat-primary[_ngcontent-%COMP%], .mat-raised-button.mat-primary[_ngcontent-%COMP%], .mat-fab.mat-primary[_ngcontent-%COMP%], .mat-mini-fab.mat-primary[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-flat-button.mat-accent[_ngcontent-%COMP%], .mat-raised-button.mat-accent[_ngcontent-%COMP%], .mat-fab.mat-accent[_ngcontent-%COMP%], .mat-mini-fab.mat-accent[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-flat-button.mat-warn[_ngcontent-%COMP%], .mat-raised-button.mat-warn[_ngcontent-%COMP%], .mat-fab.mat-warn[_ngcontent-%COMP%], .mat-mini-fab.mat-warn[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-flat-button.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-flat-button.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-flat-button.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-flat-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%], .mat-raised-button.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-raised-button.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-raised-button.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-raised-button.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%], .mat-fab.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-fab.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-fab.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-fab.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%], .mat-mini-fab.mat-primary.mat-button-disabled[_ngcontent-%COMP%], .mat-mini-fab.mat-accent.mat-button-disabled[_ngcontent-%COMP%], .mat-mini-fab.mat-warn.mat-button-disabled[_ngcontent-%COMP%], .mat-mini-fab.mat-button-disabled.mat-button-disabled[_ngcontent-%COMP%]{background-color:#0000001f}.mat-flat-button.mat-primary[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-raised-button.mat-primary[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-fab.mat-primary[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-mini-fab.mat-primary[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-flat-button.mat-accent[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-raised-button.mat-accent[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-fab.mat-accent[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-mini-fab.mat-accent[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#0000001a}.mat-flat-button.mat-warn[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-raised-button.mat-warn[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-fab.mat-warn[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-mini-fab.mat-warn[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#ffffff1a}.mat-stroked-button[_ngcontent-%COMP%]:not([class*=mat-elevation-z]), .mat-flat-button[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-raised-button[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-raised-button[_ngcontent-%COMP%]:not(.mat-button-disabled):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.mat-raised-button.mat-button-disabled[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-fab[_ngcontent-%COMP%]:not([class*=mat-elevation-z]), .mat-mini-fab[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mat-fab[_ngcontent-%COMP%]:not(.mat-button-disabled):active:not([class*=mat-elevation-z]), .mat-mini-fab[_ngcontent-%COMP%]:not(.mat-button-disabled):active:not([class*=mat-elevation-z]){box-shadow:0 7px 8px -4px #0003,0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f}.mat-fab.mat-button-disabled[_ngcontent-%COMP%]:not([class*=mat-elevation-z]), .mat-mini-fab.mat-button-disabled[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-button-toggle-standalone[_ngcontent-%COMP%]:not([class*=mat-elevation-z]), .mat-button-toggle-group[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-button-toggle-standalone.mat-button-toggle-appearance-standard[_ngcontent-%COMP%]:not([class*=mat-elevation-z]), .mat-button-toggle-group-appearance-standard[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:none}.mat-button-toggle[_ngcontent-%COMP%]{color:#00000061}.mat-button-toggle[_ngcontent-%COMP%]   .mat-button-toggle-focus-overlay[_ngcontent-%COMP%]{background-color:#0000001f}.mat-button-toggle-appearance-standard[_ngcontent-%COMP%]{color:#000000de;background:white}.mat-button-toggle-appearance-standard[_ngcontent-%COMP%]   .mat-button-toggle-focus-overlay[_ngcontent-%COMP%]{background-color:#000}.mat-button-toggle-group-appearance-standard[_ngcontent-%COMP%]   .mat-button-toggle[_ngcontent-%COMP%] + .mat-button-toggle[_ngcontent-%COMP%]{border-left:solid 1px #e0e0e0}[dir=rtl][_ngcontent-%COMP%]   .mat-button-toggle-group-appearance-standard[_ngcontent-%COMP%]   .mat-button-toggle[_ngcontent-%COMP%] + .mat-button-toggle[_ngcontent-%COMP%]{border-left:none;border-right:solid 1px #e0e0e0}.mat-button-toggle-group-appearance-standard.mat-button-toggle-vertical[_ngcontent-%COMP%]   .mat-button-toggle[_ngcontent-%COMP%] + .mat-button-toggle[_ngcontent-%COMP%]{border-left:none;border-right:none;border-top:solid 1px #e0e0e0}.mat-button-toggle-checked[_ngcontent-%COMP%]{background-color:#e0e0e0;color:#0000008a}.mat-button-toggle-checked.mat-button-toggle-appearance-standard[_ngcontent-%COMP%]{color:#000000de}.mat-button-toggle-disabled[_ngcontent-%COMP%]{color:#00000042;background-color:#eee}.mat-button-toggle-disabled.mat-button-toggle-appearance-standard[_ngcontent-%COMP%]{background:white}.mat-button-toggle-disabled.mat-button-toggle-checked[_ngcontent-%COMP%]{background-color:#bdbdbd}.mat-button-toggle-standalone.mat-button-toggle-appearance-standard[_ngcontent-%COMP%], .mat-button-toggle-group-appearance-standard[_ngcontent-%COMP%]{border:solid 1px #e0e0e0}.mat-button-toggle-appearance-standard[_ngcontent-%COMP%]   .mat-button-toggle-label-content[_ngcontent-%COMP%]{line-height:48px}.mat-card[_ngcontent-%COMP%]{background:white;color:#000000de}.mat-card[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.mat-card.mat-card-flat[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-card-subtitle[_ngcontent-%COMP%]{color:#0000008a}.mat-checkbox-frame[_ngcontent-%COMP%]{border-color:#0000008a}.mat-checkbox-checkmark[_ngcontent-%COMP%]{fill:#fafafa}.mat-checkbox-checkmark-path[_ngcontent-%COMP%]{stroke:#fafafa!important}.mat-checkbox-mixedmark[_ngcontent-%COMP%]{background-color:#fafafa}.mat-checkbox-indeterminate.mat-primary[_ngcontent-%COMP%]   .mat-checkbox-background[_ngcontent-%COMP%], .mat-checkbox-checked.mat-primary[_ngcontent-%COMP%]   .mat-checkbox-background[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-checkbox-indeterminate.mat-accent[_ngcontent-%COMP%]   .mat-checkbox-background[_ngcontent-%COMP%], .mat-checkbox-checked.mat-accent[_ngcontent-%COMP%]   .mat-checkbox-background[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-checkbox-indeterminate.mat-warn[_ngcontent-%COMP%]   .mat-checkbox-background[_ngcontent-%COMP%], .mat-checkbox-checked.mat-warn[_ngcontent-%COMP%]   .mat-checkbox-background[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-checkbox-disabled.mat-checkbox-checked[_ngcontent-%COMP%]   .mat-checkbox-background[_ngcontent-%COMP%], .mat-checkbox-disabled.mat-checkbox-indeterminate[_ngcontent-%COMP%]   .mat-checkbox-background[_ngcontent-%COMP%]{background-color:#b0b0b0}.mat-checkbox-disabled[_ngcontent-%COMP%]:not(.mat-checkbox-checked)   .mat-checkbox-frame[_ngcontent-%COMP%]{border-color:#b0b0b0}.mat-checkbox-disabled[_ngcontent-%COMP%]   .mat-checkbox-label[_ngcontent-%COMP%]{color:#00000061}.mat-checkbox[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#000}.mat-checkbox-checked[_ngcontent-%COMP%]:not(.mat-checkbox-disabled).mat-primary   .mat-ripple-element[_ngcontent-%COMP%], .mat-checkbox[_ngcontent-%COMP%]:active:not(.mat-checkbox-disabled).mat-primary   .mat-ripple-element[_ngcontent-%COMP%]{background:#5fa0c5}.mat-checkbox-checked[_ngcontent-%COMP%]:not(.mat-checkbox-disabled).mat-accent   .mat-ripple-element[_ngcontent-%COMP%], .mat-checkbox[_ngcontent-%COMP%]:active:not(.mat-checkbox-disabled).mat-accent   .mat-ripple-element[_ngcontent-%COMP%]{background:#95b8a2}.mat-checkbox-checked[_ngcontent-%COMP%]:not(.mat-checkbox-disabled).mat-warn   .mat-ripple-element[_ngcontent-%COMP%], .mat-checkbox[_ngcontent-%COMP%]:active:not(.mat-checkbox-disabled).mat-warn   .mat-ripple-element[_ngcontent-%COMP%]{background:#c62e3c}.mat-chip.mat-standard-chip[_ngcontent-%COMP%]{background-color:#e0e0e0;color:#000000de}.mat-chip.mat-standard-chip[_ngcontent-%COMP%]   .mat-chip-remove[_ngcontent-%COMP%]{color:#000000de;opacity:.4}.mat-chip.mat-standard-chip[_ngcontent-%COMP%]:not(.mat-chip-disabled):active{box-shadow:0 3px 3px -2px #0003,0 3px 4px #00000024,0 1px 8px #0000001f}.mat-chip.mat-standard-chip[_ngcontent-%COMP%]:not(.mat-chip-disabled)   .mat-chip-remove[_ngcontent-%COMP%]:hover{opacity:.54}.mat-chip.mat-standard-chip.mat-chip-disabled[_ngcontent-%COMP%]{opacity:.4}.mat-chip.mat-standard-chip[_ngcontent-%COMP%]:after{background:black}.mat-chip.mat-standard-chip.mat-chip-selected.mat-primary[_ngcontent-%COMP%]{background-color:#5fa0c5;color:#000}.mat-chip.mat-standard-chip.mat-chip-selected.mat-primary[_ngcontent-%COMP%]   .mat-chip-remove[_ngcontent-%COMP%]{color:#000;opacity:.4}.mat-chip.mat-standard-chip.mat-chip-selected.mat-primary[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#0000001a}.mat-chip.mat-standard-chip.mat-chip-selected.mat-warn[_ngcontent-%COMP%]{background-color:#c62e3c;color:#fff}.mat-chip.mat-standard-chip.mat-chip-selected.mat-warn[_ngcontent-%COMP%]   .mat-chip-remove[_ngcontent-%COMP%]{color:#fff;opacity:.4}.mat-chip.mat-standard-chip.mat-chip-selected.mat-warn[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#ffffff1a}.mat-chip.mat-standard-chip.mat-chip-selected.mat-accent[_ngcontent-%COMP%]{background-color:#95b8a2;color:#000}.mat-chip.mat-standard-chip.mat-chip-selected.mat-accent[_ngcontent-%COMP%]   .mat-chip-remove[_ngcontent-%COMP%]{color:#000;opacity:.4}.mat-chip.mat-standard-chip.mat-chip-selected.mat-accent[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#0000001a}.mat-table[_ngcontent-%COMP%]{background:white}.mat-table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%], .mat-table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%], .mat-table[_ngcontent-%COMP%]   tfoot[_ngcontent-%COMP%], mat-header-row[_ngcontent-%COMP%], mat-row[_ngcontent-%COMP%], mat-footer-row[_ngcontent-%COMP%], [mat-header-row][_ngcontent-%COMP%], [mat-row][_ngcontent-%COMP%], [mat-footer-row][_ngcontent-%COMP%], .mat-table-sticky[_ngcontent-%COMP%]{background:inherit}mat-row[_ngcontent-%COMP%], mat-header-row[_ngcontent-%COMP%], mat-footer-row[_ngcontent-%COMP%], th.mat-header-cell[_ngcontent-%COMP%], td.mat-cell[_ngcontent-%COMP%], td.mat-footer-cell[_ngcontent-%COMP%]{border-bottom-color:#0000001f}.mat-header-cell[_ngcontent-%COMP%]{color:#0000008a}.mat-cell[_ngcontent-%COMP%], .mat-footer-cell[_ngcontent-%COMP%]{color:#000000de}.mat-calendar-arrow[_ngcontent-%COMP%]{fill:#0000008a}.mat-datepicker-toggle[_ngcontent-%COMP%], .mat-datepicker-content[_ngcontent-%COMP%]   .mat-calendar-next-button[_ngcontent-%COMP%], .mat-datepicker-content[_ngcontent-%COMP%]   .mat-calendar-previous-button[_ngcontent-%COMP%]{color:#0000008a}.mat-calendar-table-header-divider[_ngcontent-%COMP%]:after{background:rgba(0,0,0,.12)}.mat-calendar-table-header[_ngcontent-%COMP%], .mat-calendar-body-label[_ngcontent-%COMP%]{color:#0000008a}.mat-calendar-body-cell-content[_ngcontent-%COMP%], .mat-date-range-input-separator[_ngcontent-%COMP%]{color:#000000de;border-color:transparent}.mat-calendar-body-disabled[_ngcontent-%COMP%] > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){color:#00000061}.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-date-range-input-separator[_ngcontent-%COMP%]{color:#00000061}.mat-calendar-body-in-preview[_ngcontent-%COMP%]{color:#0000003d}.mat-calendar-body-today[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){border-color:#00000061}.mat-calendar-body-disabled[_ngcontent-%COMP%] > .mat-calendar-body-today[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){border-color:#0000002e}.mat-calendar-body-in-range[_ngcontent-%COMP%]:before{background:rgba(95,160,197,.2)}.mat-calendar-body-comparison-identical[_ngcontent-%COMP%], .mat-calendar-body-in-comparison-range[_ngcontent-%COMP%]:before{background:rgba(249,171,0,.2)}.mat-calendar-body-comparison-bridge-start[_ngcontent-%COMP%]:before, [dir=rtl][_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-end[_ngcontent-%COMP%]:before{background:linear-gradient(to right,rgba(95,160,197,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-calendar-body-comparison-bridge-end[_ngcontent-%COMP%]:before, [dir=rtl][_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-start[_ngcontent-%COMP%]:before{background:linear-gradient(to left,rgba(95,160,197,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-calendar-body-in-range[_ngcontent-%COMP%] > .mat-calendar-body-comparison-identical[_ngcontent-%COMP%], .mat-calendar-body-in-comparison-range.mat-calendar-body-in-range[_ngcontent-%COMP%]:after{background:#a8dab5}.mat-calendar-body-comparison-identical.mat-calendar-body-selected[_ngcontent-%COMP%], .mat-calendar-body-in-comparison-range[_ngcontent-%COMP%] > .mat-calendar-body-selected[_ngcontent-%COMP%]{background:#46a35e}.mat-calendar-body-selected[_ngcontent-%COMP%]{background-color:#5fa0c5;color:#000}.mat-calendar-body-disabled[_ngcontent-%COMP%] > .mat-calendar-body-selected[_ngcontent-%COMP%]{background-color:#5fa0c566}.mat-calendar-body-today.mat-calendar-body-selected[_ngcontent-%COMP%]{box-shadow:inset 0 0 0 1px #000}.cdk-keyboard-focused[_ngcontent-%COMP%]   .mat-calendar-body-active[_ngcontent-%COMP%] > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical), .cdk-program-focused[_ngcontent-%COMP%]   .mat-calendar-body-active[_ngcontent-%COMP%] > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#5fa0c54d}@media (hover: hover){.mat-calendar-body-cell[_ngcontent-%COMP%]:not(.mat-calendar-body-disabled):hover > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#5fa0c54d}}.mat-datepicker-content[_ngcontent-%COMP%]{box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f;background-color:#fff;color:#000000de}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-in-range[_ngcontent-%COMP%]:before{background:rgba(149,184,162,.2)}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-comparison-identical[_ngcontent-%COMP%], .mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-in-comparison-range[_ngcontent-%COMP%]:before{background:rgba(249,171,0,.2)}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-start[_ngcontent-%COMP%]:before, .mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   [dir=rtl][_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-end[_ngcontent-%COMP%]:before{background:linear-gradient(to right,rgba(149,184,162,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-end[_ngcontent-%COMP%]:before, .mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   [dir=rtl][_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-start[_ngcontent-%COMP%]:before{background:linear-gradient(to left,rgba(149,184,162,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-in-range[_ngcontent-%COMP%] > .mat-calendar-body-comparison-identical[_ngcontent-%COMP%], .mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-in-comparison-range.mat-calendar-body-in-range[_ngcontent-%COMP%]:after{background:#a8dab5}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-comparison-identical.mat-calendar-body-selected[_ngcontent-%COMP%], .mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-in-comparison-range[_ngcontent-%COMP%] > .mat-calendar-body-selected[_ngcontent-%COMP%]{background:#46a35e}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-selected[_ngcontent-%COMP%]{background-color:#95b8a2;color:#000}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-disabled[_ngcontent-%COMP%] > .mat-calendar-body-selected[_ngcontent-%COMP%]{background-color:#95b8a266}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-today.mat-calendar-body-selected[_ngcontent-%COMP%]{box-shadow:inset 0 0 0 1px #000}.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .cdk-keyboard-focused[_ngcontent-%COMP%]   .mat-calendar-body-active[_ngcontent-%COMP%] > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical), .mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .cdk-program-focused[_ngcontent-%COMP%]   .mat-calendar-body-active[_ngcontent-%COMP%] > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#95b8a24d}@media (hover: hover){.mat-datepicker-content.mat-accent[_ngcontent-%COMP%]   .mat-calendar-body-cell[_ngcontent-%COMP%]:not(.mat-calendar-body-disabled):hover > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#95b8a24d}}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-in-range[_ngcontent-%COMP%]:before{background:rgba(198,46,60,.2)}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-comparison-identical[_ngcontent-%COMP%], .mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-in-comparison-range[_ngcontent-%COMP%]:before{background:rgba(249,171,0,.2)}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-start[_ngcontent-%COMP%]:before, .mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   [dir=rtl][_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-end[_ngcontent-%COMP%]:before{background:linear-gradient(to right,rgba(198,46,60,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-end[_ngcontent-%COMP%]:before, .mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   [dir=rtl][_ngcontent-%COMP%]   .mat-calendar-body-comparison-bridge-start[_ngcontent-%COMP%]:before{background:linear-gradient(to left,rgba(198,46,60,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-in-range[_ngcontent-%COMP%] > .mat-calendar-body-comparison-identical[_ngcontent-%COMP%], .mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-in-comparison-range.mat-calendar-body-in-range[_ngcontent-%COMP%]:after{background:#a8dab5}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-comparison-identical.mat-calendar-body-selected[_ngcontent-%COMP%], .mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-in-comparison-range[_ngcontent-%COMP%] > .mat-calendar-body-selected[_ngcontent-%COMP%]{background:#46a35e}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-selected[_ngcontent-%COMP%]{background-color:#c62e3c;color:#fff}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-disabled[_ngcontent-%COMP%] > .mat-calendar-body-selected[_ngcontent-%COMP%]{background-color:#c62e3c66}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-today.mat-calendar-body-selected[_ngcontent-%COMP%]{box-shadow:inset 0 0 0 1px #fff}.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .cdk-keyboard-focused[_ngcontent-%COMP%]   .mat-calendar-body-active[_ngcontent-%COMP%] > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical), .mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .cdk-program-focused[_ngcontent-%COMP%]   .mat-calendar-body-active[_ngcontent-%COMP%] > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#c62e3c4d}@media (hover: hover){.mat-datepicker-content.mat-warn[_ngcontent-%COMP%]   .mat-calendar-body-cell[_ngcontent-%COMP%]:not(.mat-calendar-body-disabled):hover > .mat-calendar-body-cell-content[_ngcontent-%COMP%]:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#c62e3c4d}}.mat-datepicker-content-touch[_ngcontent-%COMP%]{box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f}.mat-datepicker-toggle-active[_ngcontent-%COMP%]{color:#5fa0c5}.mat-datepicker-toggle-active.mat-accent[_ngcontent-%COMP%]{color:#95b8a2}.mat-datepicker-toggle-active.mat-warn[_ngcontent-%COMP%]{color:#c62e3c}.mat-date-range-input-inner[disabled][_ngcontent-%COMP%]{color:#00000061}.mat-dialog-container[_ngcontent-%COMP%]{box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f;background:white;color:#000000de}.mat-divider[_ngcontent-%COMP%]{border-top-color:#0000001f}.mat-divider-vertical[_ngcontent-%COMP%]{border-right-color:#0000001f}.mat-expansion-panel[_ngcontent-%COMP%]{background:white;color:#000000de}.mat-expansion-panel[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-action-row[_ngcontent-%COMP%]{border-top-color:#0000001f}.mat-expansion-panel[_ngcontent-%COMP%]   .mat-expansion-panel-header.cdk-keyboard-focused[_ngcontent-%COMP%]:not([aria-disabled=true]), .mat-expansion-panel[_ngcontent-%COMP%]   .mat-expansion-panel-header.cdk-program-focused[_ngcontent-%COMP%]:not([aria-disabled=true]), .mat-expansion-panel[_ngcontent-%COMP%]:not(.mat-expanded)   .mat-expansion-panel-header[_ngcontent-%COMP%]:hover:not([aria-disabled=true]){background:rgba(0,0,0,.04)}@media (hover: none){.mat-expansion-panel[_ngcontent-%COMP%]:not(.mat-expanded):not([aria-disabled=true])   .mat-expansion-panel-header[_ngcontent-%COMP%]:hover{background:white}}.mat-expansion-panel-header-title[_ngcontent-%COMP%]{color:#000000de}.mat-expansion-panel-header-description[_ngcontent-%COMP%], .mat-expansion-indicator[_ngcontent-%COMP%]:after{color:#0000008a}.mat-expansion-panel-header[aria-disabled=true][_ngcontent-%COMP%]{color:#00000042}.mat-expansion-panel-header[aria-disabled=true][_ngcontent-%COMP%]   .mat-expansion-panel-header-title[_ngcontent-%COMP%], .mat-expansion-panel-header[aria-disabled=true][_ngcontent-%COMP%]   .mat-expansion-panel-header-description[_ngcontent-%COMP%]{color:inherit}.mat-expansion-panel-header[_ngcontent-%COMP%]{height:48px}.mat-expansion-panel-header.mat-expanded[_ngcontent-%COMP%]{height:64px}.mat-form-field-label[_ngcontent-%COMP%], .mat-hint[_ngcontent-%COMP%]{color:#0009}.mat-form-field.mat-focused[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{color:#5fa0c5}.mat-form-field.mat-focused[_ngcontent-%COMP%]   .mat-form-field-label.mat-accent[_ngcontent-%COMP%]{color:#95b8a2}.mat-form-field.mat-focused[_ngcontent-%COMP%]   .mat-form-field-label.mat-warn[_ngcontent-%COMP%]{color:#c62e3c}.mat-focused[_ngcontent-%COMP%]   .mat-form-field-required-marker[_ngcontent-%COMP%]{color:#95b8a2}.mat-form-field-ripple[_ngcontent-%COMP%]{background-color:#000000de}.mat-form-field.mat-focused[_ngcontent-%COMP%]   .mat-form-field-ripple[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-form-field.mat-focused[_ngcontent-%COMP%]   .mat-form-field-ripple.mat-accent[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-form-field.mat-focused[_ngcontent-%COMP%]   .mat-form-field-ripple.mat-warn[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-form-field-type-mat-native-select.mat-focused[_ngcontent-%COMP%]:not(.mat-form-field-invalid)   .mat-form-field-infix[_ngcontent-%COMP%]:after{color:#5fa0c5}.mat-form-field-type-mat-native-select.mat-focused[_ngcontent-%COMP%]:not(.mat-form-field-invalid).mat-accent   .mat-form-field-infix[_ngcontent-%COMP%]:after{color:#95b8a2}.mat-form-field-type-mat-native-select.mat-focused[_ngcontent-%COMP%]:not(.mat-form-field-invalid).mat-warn   .mat-form-field-infix[_ngcontent-%COMP%]:after{color:#c62e3c}.mat-form-field.mat-form-field-invalid[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field.mat-form-field-invalid[_ngcontent-%COMP%]   .mat-form-field-label.mat-accent[_ngcontent-%COMP%], .mat-form-field.mat-form-field-invalid[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]   .mat-form-field-required-marker[_ngcontent-%COMP%]{color:#c62e3c}.mat-form-field.mat-form-field-invalid[_ngcontent-%COMP%]   .mat-form-field-ripple[_ngcontent-%COMP%], .mat-form-field.mat-form-field-invalid[_ngcontent-%COMP%]   .mat-form-field-ripple.mat-accent[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-error[_ngcontent-%COMP%]{color:#c62e3c}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-hint[_ngcontent-%COMP%]{color:#0000008a}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]{background-color:#0000006b}.mat-form-field-appearance-legacy.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]{background-image:linear-gradient(to right,rgba(0,0,0,.42) 0%,rgba(0,0,0,.42) 33%,transparent 0%);background-size:4px 100%;background-repeat:repeat-x}.mat-form-field-appearance-standard[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]{background-color:#0000006b}.mat-form-field-appearance-standard.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]{background-image:linear-gradient(to right,rgba(0,0,0,.42) 0%,rgba(0,0,0,.42) 33%,transparent 0%);background-size:4px 100%;background-repeat:repeat-x}.mat-form-field-appearance-fill[_ngcontent-%COMP%]   .mat-form-field-flex[_ngcontent-%COMP%]{background-color:#0000000a}.mat-form-field-appearance-fill.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-form-field-flex[_ngcontent-%COMP%]{background-color:#00000005}.mat-form-field-appearance-fill[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]:before{background-color:#0000006b}.mat-form-field-appearance-fill.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{color:#00000061}.mat-form-field-appearance-fill.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]:before{background-color:transparent}.mat-form-field-appearance-outline[_ngcontent-%COMP%]   .mat-form-field-outline[_ngcontent-%COMP%]{color:#0000001f}.mat-form-field-appearance-outline[_ngcontent-%COMP%]   .mat-form-field-outline-thick[_ngcontent-%COMP%]{color:#000000de}.mat-form-field-appearance-outline.mat-focused[_ngcontent-%COMP%]   .mat-form-field-outline-thick[_ngcontent-%COMP%]{color:#5fa0c5}.mat-form-field-appearance-outline.mat-focused.mat-accent[_ngcontent-%COMP%]   .mat-form-field-outline-thick[_ngcontent-%COMP%]{color:#95b8a2}.mat-form-field-appearance-outline.mat-focused.mat-warn[_ngcontent-%COMP%]   .mat-form-field-outline-thick[_ngcontent-%COMP%], .mat-form-field-appearance-outline.mat-form-field-invalid.mat-form-field-invalid[_ngcontent-%COMP%]   .mat-form-field-outline-thick[_ngcontent-%COMP%]{color:#c62e3c}.mat-form-field-appearance-outline.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{color:#00000061}.mat-form-field-appearance-outline.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-form-field-outline[_ngcontent-%COMP%]{color:#0000000f}.mat-icon.mat-primary[_ngcontent-%COMP%]{color:#5fa0c5}.mat-icon.mat-accent[_ngcontent-%COMP%]{color:#95b8a2}.mat-icon.mat-warn[_ngcontent-%COMP%]{color:#c62e3c}.mat-form-field-type-mat-native-select[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]:after{color:#0000008a}.mat-input-element[_ngcontent-%COMP%]:disabled, .mat-form-field-type-mat-native-select.mat-form-field-disabled[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]:after{color:#00000061}.mat-input-element[_ngcontent-%COMP%]{caret-color:#5fa0c5}.mat-input-element[_ngcontent-%COMP%]::placeholder{color:#0000006b}.mat-input-element[_ngcontent-%COMP%]::-moz-placeholder{color:#0000006b}.mat-input-element[_ngcontent-%COMP%]::-webkit-input-placeholder{color:#0000006b}.mat-input-element[_ngcontent-%COMP%]:-ms-input-placeholder{color:#0000006b}.mat-form-field.mat-accent[_ngcontent-%COMP%]   .mat-input-element[_ngcontent-%COMP%]{caret-color:#95b8a2}.mat-form-field.mat-warn[_ngcontent-%COMP%]   .mat-input-element[_ngcontent-%COMP%], .mat-form-field-invalid[_ngcontent-%COMP%]   .mat-input-element[_ngcontent-%COMP%]{caret-color:#c62e3c}.mat-form-field-type-mat-native-select.mat-form-field-invalid[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]:after{color:#c62e3c}.mat-list-base[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%], .mat-list-base[_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]{color:#000000de}.mat-list-base[_ngcontent-%COMP%]   .mat-subheader[_ngcontent-%COMP%]{color:#0000008a}.mat-list-base[_ngcontent-%COMP%]   .mat-list-item-disabled[_ngcontent-%COMP%]{background-color:#eee;color:#00000061}.mat-list-option[_ngcontent-%COMP%]:hover, .mat-list-option[_ngcontent-%COMP%]:focus, .mat-nav-list[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]:hover, .mat-nav-list[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]:focus, .mat-action-list[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]:hover, .mat-action-list[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]:focus{background:rgba(0,0,0,.04)}.mat-list-single-selected-option[_ngcontent-%COMP%], .mat-list-single-selected-option[_ngcontent-%COMP%]:hover, .mat-list-single-selected-option[_ngcontent-%COMP%]:focus{background:rgba(0,0,0,.12)}.mat-menu-panel[_ngcontent-%COMP%]{background:white}.mat-menu-panel[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mat-menu-item[_ngcontent-%COMP%]{background:transparent;color:#000000de}.mat-menu-item[disabled][_ngcontent-%COMP%], .mat-menu-item[disabled][_ngcontent-%COMP%]   .mat-menu-submenu-icon[_ngcontent-%COMP%], .mat-menu-item[disabled][_ngcontent-%COMP%]   .mat-icon-no-color[_ngcontent-%COMP%]{color:#00000061}.mat-menu-item[_ngcontent-%COMP%]   .mat-icon-no-color[_ngcontent-%COMP%], .mat-menu-submenu-icon[_ngcontent-%COMP%]{color:#0000008a}.mat-menu-item[_ngcontent-%COMP%]:hover:not([disabled]), .mat-menu-item.cdk-program-focused[_ngcontent-%COMP%]:not([disabled]), .mat-menu-item.cdk-keyboard-focused[_ngcontent-%COMP%]:not([disabled]), .mat-menu-item-highlighted[_ngcontent-%COMP%]:not([disabled]){background:rgba(0,0,0,.04)}.mat-paginator[_ngcontent-%COMP%]{background:white}.mat-paginator[_ngcontent-%COMP%], .mat-paginator-page-size[_ngcontent-%COMP%]   .mat-select-trigger[_ngcontent-%COMP%]{color:#0000008a}.mat-paginator-decrement[_ngcontent-%COMP%], .mat-paginator-increment[_ngcontent-%COMP%]{border-top:2px solid rgba(0,0,0,.54);border-right:2px solid rgba(0,0,0,.54)}.mat-paginator-first[_ngcontent-%COMP%], .mat-paginator-last[_ngcontent-%COMP%]{border-top:2px solid rgba(0,0,0,.54)}.mat-icon-button[disabled][_ngcontent-%COMP%]   .mat-paginator-decrement[_ngcontent-%COMP%], .mat-icon-button[disabled][_ngcontent-%COMP%]   .mat-paginator-increment[_ngcontent-%COMP%], .mat-icon-button[disabled][_ngcontent-%COMP%]   .mat-paginator-first[_ngcontent-%COMP%], .mat-icon-button[disabled][_ngcontent-%COMP%]   .mat-paginator-last[_ngcontent-%COMP%]{border-color:#00000061}.mat-paginator-container[_ngcontent-%COMP%]{min-height:56px}.mat-progress-bar-background[_ngcontent-%COMP%]{fill:#d3e4ed}.mat-progress-bar-buffer[_ngcontent-%COMP%]{background-color:#d3e4ed}.mat-progress-bar-fill[_ngcontent-%COMP%]:after{background-color:#5fa0c5}.mat-progress-bar.mat-accent[_ngcontent-%COMP%]   .mat-progress-bar-background[_ngcontent-%COMP%]{fill:#e1eae4}.mat-progress-bar.mat-accent[_ngcontent-%COMP%]   .mat-progress-bar-buffer[_ngcontent-%COMP%]{background-color:#e1eae4}.mat-progress-bar.mat-accent[_ngcontent-%COMP%]   .mat-progress-bar-fill[_ngcontent-%COMP%]:after{background-color:#95b8a2}.mat-progress-bar.mat-warn[_ngcontent-%COMP%]   .mat-progress-bar-background[_ngcontent-%COMP%]{fill:#edc7cb}.mat-progress-bar.mat-warn[_ngcontent-%COMP%]   .mat-progress-bar-buffer[_ngcontent-%COMP%]{background-color:#edc7cb}.mat-progress-bar.mat-warn[_ngcontent-%COMP%]   .mat-progress-bar-fill[_ngcontent-%COMP%]:after{background-color:#c62e3c}.mat-progress-spinner[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%], .mat-spinner[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:#5fa0c5}.mat-progress-spinner.mat-accent[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%], .mat-spinner.mat-accent[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:#95b8a2}.mat-progress-spinner.mat-warn[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%], .mat-spinner.mat-warn[_ngcontent-%COMP%]   circle[_ngcontent-%COMP%]{stroke:#c62e3c}.mat-radio-outer-circle[_ngcontent-%COMP%]{border-color:#0000008a}.mat-radio-button.mat-primary.mat-radio-checked[_ngcontent-%COMP%]   .mat-radio-outer-circle[_ngcontent-%COMP%]{border-color:#5fa0c5}.mat-radio-button.mat-primary[_ngcontent-%COMP%]   .mat-radio-inner-circle[_ngcontent-%COMP%], .mat-radio-button.mat-primary[_ngcontent-%COMP%]   .mat-radio-ripple[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]:not(.mat-radio-persistent-ripple), .mat-radio-button.mat-primary.mat-radio-checked[_ngcontent-%COMP%]   .mat-radio-persistent-ripple[_ngcontent-%COMP%], .mat-radio-button.mat-primary[_ngcontent-%COMP%]:active   .mat-radio-persistent-ripple[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-radio-button.mat-accent.mat-radio-checked[_ngcontent-%COMP%]   .mat-radio-outer-circle[_ngcontent-%COMP%]{border-color:#95b8a2}.mat-radio-button.mat-accent[_ngcontent-%COMP%]   .mat-radio-inner-circle[_ngcontent-%COMP%], .mat-radio-button.mat-accent[_ngcontent-%COMP%]   .mat-radio-ripple[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]:not(.mat-radio-persistent-ripple), .mat-radio-button.mat-accent.mat-radio-checked[_ngcontent-%COMP%]   .mat-radio-persistent-ripple[_ngcontent-%COMP%], .mat-radio-button.mat-accent[_ngcontent-%COMP%]:active   .mat-radio-persistent-ripple[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-radio-button.mat-warn.mat-radio-checked[_ngcontent-%COMP%]   .mat-radio-outer-circle[_ngcontent-%COMP%]{border-color:#c62e3c}.mat-radio-button.mat-warn[_ngcontent-%COMP%]   .mat-radio-inner-circle[_ngcontent-%COMP%], .mat-radio-button.mat-warn[_ngcontent-%COMP%]   .mat-radio-ripple[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]:not(.mat-radio-persistent-ripple), .mat-radio-button.mat-warn.mat-radio-checked[_ngcontent-%COMP%]   .mat-radio-persistent-ripple[_ngcontent-%COMP%], .mat-radio-button.mat-warn[_ngcontent-%COMP%]:active   .mat-radio-persistent-ripple[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-radio-button.mat-radio-disabled.mat-radio-checked[_ngcontent-%COMP%]   .mat-radio-outer-circle[_ngcontent-%COMP%], .mat-radio-button.mat-radio-disabled[_ngcontent-%COMP%]   .mat-radio-outer-circle[_ngcontent-%COMP%]{border-color:#00000061}.mat-radio-button.mat-radio-disabled[_ngcontent-%COMP%]   .mat-radio-ripple[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-radio-button.mat-radio-disabled[_ngcontent-%COMP%]   .mat-radio-inner-circle[_ngcontent-%COMP%]{background-color:#00000061}.mat-radio-button.mat-radio-disabled[_ngcontent-%COMP%]   .mat-radio-label-content[_ngcontent-%COMP%]{color:#00000061}.mat-radio-button[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#000}.mat-select-value[_ngcontent-%COMP%]{color:#000000de}.mat-select-placeholder[_ngcontent-%COMP%]{color:#0000006b}.mat-select-disabled[_ngcontent-%COMP%]   .mat-select-value[_ngcontent-%COMP%]{color:#00000061}.mat-select-arrow[_ngcontent-%COMP%]{color:#0000008a}.mat-select-panel[_ngcontent-%COMP%]{background:white}.mat-select-panel[_ngcontent-%COMP%]:not([class*=mat-elevation-z]){box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mat-select-panel[_ngcontent-%COMP%]   .mat-option.mat-selected[_ngcontent-%COMP%]:not(.mat-option-multiple){background:rgba(0,0,0,.12)}.mat-form-field.mat-focused.mat-primary[_ngcontent-%COMP%]   .mat-select-arrow[_ngcontent-%COMP%]{color:#5fa0c5}.mat-form-field.mat-focused.mat-accent[_ngcontent-%COMP%]   .mat-select-arrow[_ngcontent-%COMP%]{color:#95b8a2}.mat-form-field.mat-focused.mat-warn[_ngcontent-%COMP%]   .mat-select-arrow[_ngcontent-%COMP%], .mat-form-field[_ngcontent-%COMP%]   .mat-select.mat-select-invalid[_ngcontent-%COMP%]   .mat-select-arrow[_ngcontent-%COMP%]{color:#c62e3c}.mat-form-field[_ngcontent-%COMP%]   .mat-select.mat-select-disabled[_ngcontent-%COMP%]   .mat-select-arrow[_ngcontent-%COMP%]{color:#00000061}.mat-drawer-container[_ngcontent-%COMP%]{background-color:#fafafa;color:#000000de}.mat-drawer[_ngcontent-%COMP%]{background-color:#fff;color:#000000de}.mat-drawer.mat-drawer-push[_ngcontent-%COMP%]{background-color:#fff}.mat-drawer[_ngcontent-%COMP%]:not(.mat-drawer-side){box-shadow:0 8px 10px -5px #0003,0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f}.mat-drawer-side[_ngcontent-%COMP%]{border-right:solid 1px rgba(0,0,0,.12)}.mat-drawer-side.mat-drawer-end[_ngcontent-%COMP%], [dir=rtl][_ngcontent-%COMP%]   .mat-drawer-side[_ngcontent-%COMP%]{border-left:solid 1px rgba(0,0,0,.12);border-right:none}[dir=rtl][_ngcontent-%COMP%]   .mat-drawer-side.mat-drawer-end[_ngcontent-%COMP%]{border-left:none;border-right:solid 1px rgba(0,0,0,.12)}.mat-drawer-backdrop.mat-drawer-shown[_ngcontent-%COMP%]{background-color:#0009}.mat-slide-toggle.mat-checked[_ngcontent-%COMP%]   .mat-slide-toggle-thumb[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-slide-toggle.mat-checked[_ngcontent-%COMP%]   .mat-slide-toggle-bar[_ngcontent-%COMP%]{background-color:#95b8a28a}.mat-slide-toggle.mat-checked[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-slide-toggle.mat-primary.mat-checked[_ngcontent-%COMP%]   .mat-slide-toggle-thumb[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-slide-toggle.mat-primary.mat-checked[_ngcontent-%COMP%]   .mat-slide-toggle-bar[_ngcontent-%COMP%]{background-color:#5fa0c58a}.mat-slide-toggle.mat-primary.mat-checked[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-slide-toggle.mat-warn.mat-checked[_ngcontent-%COMP%]   .mat-slide-toggle-thumb[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-slide-toggle.mat-warn.mat-checked[_ngcontent-%COMP%]   .mat-slide-toggle-bar[_ngcontent-%COMP%]{background-color:#c62e3c8a}.mat-slide-toggle.mat-warn.mat-checked[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-slide-toggle[_ngcontent-%COMP%]:not(.mat-checked)   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#000}.mat-slide-toggle-thumb[_ngcontent-%COMP%]{box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f;background-color:#fafafa}.mat-slide-toggle-bar[_ngcontent-%COMP%]{background-color:#00000061}.mat-slider-track-background[_ngcontent-%COMP%]{background-color:#00000042}.mat-slider.mat-primary[_ngcontent-%COMP%]   .mat-slider-track-fill[_ngcontent-%COMP%], .mat-slider.mat-primary[_ngcontent-%COMP%]   .mat-slider-thumb[_ngcontent-%COMP%], .mat-slider.mat-primary[_ngcontent-%COMP%]   .mat-slider-thumb-label[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-slider.mat-primary[_ngcontent-%COMP%]   .mat-slider-thumb-label-text[_ngcontent-%COMP%]{color:#000}.mat-slider.mat-primary[_ngcontent-%COMP%]   .mat-slider-focus-ring[_ngcontent-%COMP%]{background-color:#5fa0c533}.mat-slider.mat-accent[_ngcontent-%COMP%]   .mat-slider-track-fill[_ngcontent-%COMP%], .mat-slider.mat-accent[_ngcontent-%COMP%]   .mat-slider-thumb[_ngcontent-%COMP%], .mat-slider.mat-accent[_ngcontent-%COMP%]   .mat-slider-thumb-label[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-slider.mat-accent[_ngcontent-%COMP%]   .mat-slider-thumb-label-text[_ngcontent-%COMP%]{color:#000}.mat-slider.mat-accent[_ngcontent-%COMP%]   .mat-slider-focus-ring[_ngcontent-%COMP%]{background-color:#95b8a233}.mat-slider.mat-warn[_ngcontent-%COMP%]   .mat-slider-track-fill[_ngcontent-%COMP%], .mat-slider.mat-warn[_ngcontent-%COMP%]   .mat-slider-thumb[_ngcontent-%COMP%], .mat-slider.mat-warn[_ngcontent-%COMP%]   .mat-slider-thumb-label[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-slider.mat-warn[_ngcontent-%COMP%]   .mat-slider-thumb-label-text[_ngcontent-%COMP%]{color:#fff}.mat-slider.mat-warn[_ngcontent-%COMP%]   .mat-slider-focus-ring[_ngcontent-%COMP%]{background-color:#c62e3c33}.mat-slider[_ngcontent-%COMP%]:hover   .mat-slider-track-background[_ngcontent-%COMP%], .mat-slider.cdk-focused[_ngcontent-%COMP%]   .mat-slider-track-background[_ngcontent-%COMP%]{background-color:#00000061}.mat-slider.mat-slider-disabled[_ngcontent-%COMP%]   .mat-slider-track-background[_ngcontent-%COMP%], .mat-slider.mat-slider-disabled[_ngcontent-%COMP%]   .mat-slider-track-fill[_ngcontent-%COMP%], .mat-slider.mat-slider-disabled[_ngcontent-%COMP%]   .mat-slider-thumb[_ngcontent-%COMP%], .mat-slider.mat-slider-disabled[_ngcontent-%COMP%]:hover   .mat-slider-track-background[_ngcontent-%COMP%]{background-color:#00000042}.mat-slider.mat-slider-min-value[_ngcontent-%COMP%]   .mat-slider-focus-ring[_ngcontent-%COMP%]{background-color:#0000001f}.mat-slider.mat-slider-min-value.mat-slider-thumb-label-showing[_ngcontent-%COMP%]   .mat-slider-thumb[_ngcontent-%COMP%], .mat-slider.mat-slider-min-value.mat-slider-thumb-label-showing[_ngcontent-%COMP%]   .mat-slider-thumb-label[_ngcontent-%COMP%]{background-color:#000000de}.mat-slider.mat-slider-min-value.mat-slider-thumb-label-showing.cdk-focused[_ngcontent-%COMP%]   .mat-slider-thumb[_ngcontent-%COMP%], .mat-slider.mat-slider-min-value.mat-slider-thumb-label-showing.cdk-focused[_ngcontent-%COMP%]   .mat-slider-thumb-label[_ngcontent-%COMP%]{background-color:#00000042}.mat-slider.mat-slider-min-value[_ngcontent-%COMP%]:not(.mat-slider-thumb-label-showing)   .mat-slider-thumb[_ngcontent-%COMP%]{border-color:#00000042;background-color:transparent}.mat-slider.mat-slider-min-value[_ngcontent-%COMP%]:not(.mat-slider-thumb-label-showing):hover   .mat-slider-thumb[_ngcontent-%COMP%], .mat-slider.mat-slider-min-value[_ngcontent-%COMP%]:not(.mat-slider-thumb-label-showing).cdk-focused   .mat-slider-thumb[_ngcontent-%COMP%]{border-color:#00000061}.mat-slider.mat-slider-min-value[_ngcontent-%COMP%]:not(.mat-slider-thumb-label-showing):hover.mat-slider-disabled   .mat-slider-thumb[_ngcontent-%COMP%], .mat-slider.mat-slider-min-value[_ngcontent-%COMP%]:not(.mat-slider-thumb-label-showing).cdk-focused.mat-slider-disabled   .mat-slider-thumb[_ngcontent-%COMP%]{border-color:#00000042}.mat-slider-has-ticks[_ngcontent-%COMP%]   .mat-slider-wrapper[_ngcontent-%COMP%]:after{border-color:#000000b3}.mat-slider-horizontal[_ngcontent-%COMP%]   .mat-slider-ticks[_ngcontent-%COMP%]{background-image:repeating-linear-gradient(to right,rgba(0,0,0,.7),rgba(0,0,0,.7) 2px,transparent 0,transparent);background-image:-moz-repeating-linear-gradient(.0001deg,rgba(0,0,0,.7),rgba(0,0,0,.7) 2px,transparent 0,transparent)}.mat-slider-vertical[_ngcontent-%COMP%]   .mat-slider-ticks[_ngcontent-%COMP%]{background-image:repeating-linear-gradient(to bottom,rgba(0,0,0,.7),rgba(0,0,0,.7) 2px,transparent 0,transparent)}.mat-step-header.cdk-keyboard-focused[_ngcontent-%COMP%], .mat-step-header.cdk-program-focused[_ngcontent-%COMP%], .mat-step-header[_ngcontent-%COMP%]:hover:not([aria-disabled]), .mat-step-header[_ngcontent-%COMP%]:hover[aria-disabled=false]{background-color:#0000000a}.mat-step-header[_ngcontent-%COMP%]:hover[aria-disabled=true]{cursor:default}@media (hover: none){.mat-step-header[_ngcontent-%COMP%]:hover{background:none}}.mat-step-header[_ngcontent-%COMP%]   .mat-step-label[_ngcontent-%COMP%], .mat-step-header[_ngcontent-%COMP%]   .mat-step-optional[_ngcontent-%COMP%]{color:#0000008a}.mat-step-header[_ngcontent-%COMP%]   .mat-step-icon[_ngcontent-%COMP%]{background-color:#0000008a;color:#000}.mat-step-header[_ngcontent-%COMP%]   .mat-step-icon-selected[_ngcontent-%COMP%], .mat-step-header[_ngcontent-%COMP%]   .mat-step-icon-state-done[_ngcontent-%COMP%], .mat-step-header[_ngcontent-%COMP%]   .mat-step-icon-state-edit[_ngcontent-%COMP%]{background-color:#5fa0c5;color:#000}.mat-step-header.mat-accent[_ngcontent-%COMP%]   .mat-step-icon[_ngcontent-%COMP%]{color:#000}.mat-step-header.mat-accent[_ngcontent-%COMP%]   .mat-step-icon-selected[_ngcontent-%COMP%], .mat-step-header.mat-accent[_ngcontent-%COMP%]   .mat-step-icon-state-done[_ngcontent-%COMP%], .mat-step-header.mat-accent[_ngcontent-%COMP%]   .mat-step-icon-state-edit[_ngcontent-%COMP%]{background-color:#95b8a2;color:#000}.mat-step-header.mat-warn[_ngcontent-%COMP%]   .mat-step-icon[_ngcontent-%COMP%]{color:#fff}.mat-step-header.mat-warn[_ngcontent-%COMP%]   .mat-step-icon-selected[_ngcontent-%COMP%], .mat-step-header.mat-warn[_ngcontent-%COMP%]   .mat-step-icon-state-done[_ngcontent-%COMP%], .mat-step-header.mat-warn[_ngcontent-%COMP%]   .mat-step-icon-state-edit[_ngcontent-%COMP%]{background-color:#c62e3c;color:#fff}.mat-step-header[_ngcontent-%COMP%]   .mat-step-icon-state-error[_ngcontent-%COMP%]{background-color:transparent;color:#c62e3c}.mat-step-header[_ngcontent-%COMP%]   .mat-step-label.mat-step-label-active[_ngcontent-%COMP%]{color:#000000de}.mat-step-header[_ngcontent-%COMP%]   .mat-step-label.mat-step-label-error[_ngcontent-%COMP%]{color:#c62e3c}.mat-stepper-horizontal[_ngcontent-%COMP%], .mat-stepper-vertical[_ngcontent-%COMP%]{background-color:#fff}.mat-stepper-vertical-line[_ngcontent-%COMP%]:before{border-left-color:#0000001f}.mat-horizontal-stepper-header[_ngcontent-%COMP%]:before, .mat-horizontal-stepper-header[_ngcontent-%COMP%]:after, .mat-stepper-horizontal-line[_ngcontent-%COMP%]{border-top-color:#0000001f}.mat-horizontal-stepper-header[_ngcontent-%COMP%]{height:72px}.mat-stepper-label-position-bottom[_ngcontent-%COMP%]   .mat-horizontal-stepper-header[_ngcontent-%COMP%], .mat-vertical-stepper-header[_ngcontent-%COMP%]{padding:24px}.mat-stepper-vertical-line[_ngcontent-%COMP%]:before{top:-16px;bottom:-16px}.mat-stepper-label-position-bottom[_ngcontent-%COMP%]   .mat-horizontal-stepper-header[_ngcontent-%COMP%]:after, .mat-stepper-label-position-bottom[_ngcontent-%COMP%]   .mat-horizontal-stepper-header[_ngcontent-%COMP%]:before{top:36px}.mat-stepper-label-position-bottom[_ngcontent-%COMP%]   .mat-stepper-horizontal-line[_ngcontent-%COMP%]{top:36px}.mat-sort-header-arrow[_ngcontent-%COMP%]{color:#757575}.mat-tab-nav-bar[_ngcontent-%COMP%], .mat-tab-header[_ngcontent-%COMP%]{border-bottom:1px solid rgba(0,0,0,.12)}.mat-tab-group-inverted-header[_ngcontent-%COMP%]   .mat-tab-nav-bar[_ngcontent-%COMP%], .mat-tab-group-inverted-header[_ngcontent-%COMP%]   .mat-tab-header[_ngcontent-%COMP%]{border-top:1px solid rgba(0,0,0,.12);border-bottom:none}.mat-tab-label[_ngcontent-%COMP%], .mat-tab-link[_ngcontent-%COMP%]{color:#000000de}.mat-tab-label.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-link.mat-tab-disabled[_ngcontent-%COMP%]{color:#00000061}.mat-tab-header-pagination-chevron[_ngcontent-%COMP%]{border-color:#000000de}.mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%]{border-color:#00000061}.mat-tab-group[class*=mat-background-][_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%], .mat-tab-nav-bar[class*=mat-background-][_ngcontent-%COMP%]{border-bottom:none;border-top:none}.mat-tab-group.mat-primary[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-primary[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-primary[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-primary[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-primary[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-primary[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-primary[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-primary[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled){background-color:#3273a34d}.mat-tab-group.mat-primary[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-primary[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-tab-group.mat-primary.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-group.mat-primary.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-primary.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-primary.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%]{background-color:#000}.mat-tab-group.mat-accent[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-accent[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-accent[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-accent[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-accent[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-accent[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-accent[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-accent[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled){background-color:#6791754d}.mat-tab-group.mat-accent[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-accent[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-tab-group.mat-accent.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-group.mat-accent.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-accent.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-accent.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%]{background-color:#000}.mat-tab-group.mat-warn[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-warn[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-warn[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-warn[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-warn[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-warn[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-warn[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-warn[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled){background-color:#a4121a4d}.mat-tab-group.mat-warn[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-warn[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-tab-group.mat-warn.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-group.mat-warn.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-warn.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-warn.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ink-bar[_ngcontent-%COMP%]{background-color:#fff}.mat-tab-group.mat-background-primary[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-primary[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-primary[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-primary[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled){background-color:#3273a34d}.mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]{background-color:#5fa0c5}.mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link[_ngcontent-%COMP%]{color:#000}.mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link.mat-tab-disabled[_ngcontent-%COMP%]{color:#0006}.mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before{border-color:#000}.mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%]{border-color:#000;opacity:.4}.mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-group.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-primary[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#000;opacity:.12}.mat-tab-group.mat-background-accent[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-accent[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-accent[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-accent[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled){background-color:#6791754d}.mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]{background-color:#95b8a2}.mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link[_ngcontent-%COMP%]{color:#000}.mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link.mat-tab-disabled[_ngcontent-%COMP%]{color:#0006}.mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before{border-color:#000}.mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%]{border-color:#000;opacity:.4}.mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-group.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-accent[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#000;opacity:.12}.mat-tab-group.mat-background-warn[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-warn[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-warn[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-group.mat-background-warn[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%]   .mat-tab-label.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%]   .mat-tab-label.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%]   .mat-tab-link.cdk-keyboard-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled), .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%]   .mat-tab-link.cdk-program-focused[_ngcontent-%COMP%]:not(.mat-tab-disabled){background-color:#a4121a4d}.mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]{background-color:#c62e3c}.mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link[_ngcontent-%COMP%]{color:#fff}.mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-label.mat-tab-disabled[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-tab-link.mat-tab-disabled[_ngcontent-%COMP%]{color:#fff6}.mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before, .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-focus-indicator[_ngcontent-%COMP%]:before{border-color:#fff}.mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header-pagination-disabled[_ngcontent-%COMP%]   .mat-tab-header-pagination-chevron[_ngcontent-%COMP%]{border-color:#fff;opacity:.4}.mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-group.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-link-container[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%], .mat-tab-nav-bar.mat-background-warn[_ngcontent-%COMP%] > .mat-tab-header-pagination[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{background-color:#fff;opacity:.12}.mat-toolbar[_ngcontent-%COMP%]{background:whitesmoke;color:#000000de}.mat-toolbar.mat-primary[_ngcontent-%COMP%]{background:#5fa0c5;color:#000}.mat-toolbar.mat-accent[_ngcontent-%COMP%]{background:#95b8a2;color:#000}.mat-toolbar.mat-warn[_ngcontent-%COMP%]{background:#c62e3c;color:#fff}.mat-toolbar[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   .mat-form-field-ripple[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   .mat-focused[_ngcontent-%COMP%]   .mat-form-field-ripple[_ngcontent-%COMP%]{background-color:currentColor}.mat-toolbar[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   .mat-focused[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   .mat-select-value[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   .mat-select-arrow[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   .mat-form-field.mat-focused[_ngcontent-%COMP%]   .mat-select-arrow[_ngcontent-%COMP%]{color:inherit}.mat-toolbar[_ngcontent-%COMP%]   .mat-input-element[_ngcontent-%COMP%]{caret-color:currentColor}.mat-toolbar-multiple-rows[_ngcontent-%COMP%]{min-height:64px}.mat-toolbar-row[_ngcontent-%COMP%], .mat-toolbar-single-row[_ngcontent-%COMP%]{height:64px}@media (max-width: 599px){.mat-toolbar-multiple-rows[_ngcontent-%COMP%]{min-height:56px}.mat-toolbar-row[_ngcontent-%COMP%], .mat-toolbar-single-row[_ngcontent-%COMP%]{height:56px}}.mat-tooltip[_ngcontent-%COMP%]{background:rgba(97,97,97,.9)}.mat-tree[_ngcontent-%COMP%]{background:white}.mat-tree-node[_ngcontent-%COMP%], .mat-nested-tree-node[_ngcontent-%COMP%]{color:#000000de}.mat-tree-node[_ngcontent-%COMP%]{min-height:48px}.mat-snack-bar-container[_ngcontent-%COMP%]{color:#ffffffb3;background:#323232;box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mat-simple-snackbar-action[_ngcontent-%COMP%]{color:#95b8a2}.mat-badge-content[_ngcontent-%COMP%]{font-weight:600;font-size:12px;font-family:Roboto,Helvetica Neue,sans-serif}.mat-badge-small[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{font-size:9px}.mat-badge-large[_ngcontent-%COMP%]   .mat-badge-content[_ngcontent-%COMP%]{font-size:24px}.mat-h1[_ngcontent-%COMP%], .mat-headline[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-headline[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{font:400 24px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h2[_ngcontent-%COMP%], .mat-title[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-title[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h3[_ngcontent-%COMP%], .mat-subheading-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h3[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-subheading-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font:400 16px/28px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h4[_ngcontent-%COMP%], .mat-subheading-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h4[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-subheading-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%]{font:400 15px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h5[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h5[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font:400 11.62px/20px Roboto,Helvetica Neue,sans-serif;margin:0 0 12px}.mat-h6[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-h6[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font:400 9.38px/20px Roboto,Helvetica Neue,sans-serif;margin:0 0 12px}.mat-body-strong[_ngcontent-%COMP%], .mat-body-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body-strong[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body-2[_ngcontent-%COMP%]{font:500 14px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-body[_ngcontent-%COMP%], .mat-body-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-body[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-body-1[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-body-1[_ngcontent-%COMP%]   p[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:0 0 12px}.mat-small[_ngcontent-%COMP%], .mat-caption[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-small[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-caption[_ngcontent-%COMP%]{font:400 12px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-display-4[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-4[_ngcontent-%COMP%]{font:300 112px/112px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.05em;margin:0 0 56px}.mat-display-3[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-3[_ngcontent-%COMP%]{font:400 56px/56px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.02em;margin:0 0 64px}.mat-display-2[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-2[_ngcontent-%COMP%]{font:400 45px/48px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.005em;margin:0 0 64px}.mat-display-1[_ngcontent-%COMP%], .mat-typography[_ngcontent-%COMP%]   .mat-display-1[_ngcontent-%COMP%]{font:400 34px/40px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 64px}.mat-bottom-sheet-container[_ngcontent-%COMP%]{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-button[_ngcontent-%COMP%], .mat-raised-button[_ngcontent-%COMP%], .mat-icon-button[_ngcontent-%COMP%], .mat-stroked-button[_ngcontent-%COMP%], .mat-flat-button[_ngcontent-%COMP%], .mat-fab[_ngcontent-%COMP%], .mat-mini-fab[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-button-toggle[_ngcontent-%COMP%], .mat-card[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-card-title[_ngcontent-%COMP%]{font-size:24px;font-weight:500}.mat-card-header[_ngcontent-%COMP%]   .mat-card-title[_ngcontent-%COMP%]{font-size:20px}.mat-card-subtitle[_ngcontent-%COMP%], .mat-card-content[_ngcontent-%COMP%]{font-size:14px}.mat-checkbox[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-checkbox-layout[_ngcontent-%COMP%]   .mat-checkbox-label[_ngcontent-%COMP%]{line-height:24px}.mat-chip[_ngcontent-%COMP%]{font-size:14px;font-weight:500}.mat-chip[_ngcontent-%COMP%]   .mat-chip-trailing-icon.mat-icon[_ngcontent-%COMP%], .mat-chip[_ngcontent-%COMP%]   .mat-chip-remove.mat-icon[_ngcontent-%COMP%]{font-size:18px}.mat-table[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-header-cell[_ngcontent-%COMP%]{font-size:12px;font-weight:500}.mat-cell[_ngcontent-%COMP%], .mat-footer-cell[_ngcontent-%COMP%]{font-size:14px}.mat-calendar[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-calendar-body[_ngcontent-%COMP%]{font-size:13px}.mat-calendar-body-label[_ngcontent-%COMP%], .mat-calendar-period-button[_ngcontent-%COMP%]{font-size:14px;font-weight:500}.mat-calendar-table-header[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-size:11px;font-weight:400}.mat-dialog-title[_ngcontent-%COMP%]{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-expansion-panel-header[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:15px;font-weight:400}.mat-expansion-panel-content[_ngcontent-%COMP%]{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-form-field[_ngcontent-%COMP%]{font-size:inherit;font-weight:400;line-height:1.125;font-family:Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-form-field-wrapper[_ngcontent-%COMP%]{padding-bottom:1.34375em}.mat-form-field-prefix[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-form-field-suffix[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{font-size:150%;line-height:1.125}.mat-form-field-prefix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%], .mat-form-field-suffix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]{height:1.5em;width:1.5em}.mat-form-field-prefix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .mat-form-field-suffix[_ngcontent-%COMP%]   .mat-icon-button[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{height:1.125em;line-height:1.125}.mat-form-field-infix[_ngcontent-%COMP%]{padding:.5em 0;border-top:.84375em solid transparent}.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.34373em) scale(.75);width:133.3333533333%}.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.34372em) scale(.75);width:133.3333633333%}.mat-form-field-label-wrapper[_ngcontent-%COMP%]{top:-.84375em;padding-top:.84375em}.mat-form-field-label[_ngcontent-%COMP%]{top:1.34375em}.mat-form-field-underline[_ngcontent-%COMP%]{bottom:1.34375em}.mat-form-field-subscript-wrapper[_ngcontent-%COMP%]{font-size:75%;margin-top:.6666666667em;top:calc(100% - 1.7916666667em)}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-wrapper[_ngcontent-%COMP%]{padding-bottom:1.25em}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]{padding:.4375em 0}.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00106px);width:133.3333933333%}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-form-field-autofill-control[_ngcontent-%COMP%]:-webkit-autofill + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00107px);width:133.3334033333%}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00108px);width:133.3334133333%}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{top:1.28125em}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-underline[_ngcontent-%COMP%]{bottom:1.25em}.mat-form-field-appearance-legacy[_ngcontent-%COMP%]   .mat-form-field-subscript-wrapper[_ngcontent-%COMP%]{margin-top:.5416666667em;top:calc(100% - 1.6666666667em)}@media print{.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28116em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-form-field-autofill-control[_ngcontent-%COMP%]:-webkit-autofill + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28115em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.28114em) scale(.75)}}.mat-form-field-appearance-fill[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]{padding:.25em 0 .75em}.mat-form-field-appearance-fill[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{top:1.09375em;margin-top:-.5em}.mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-fill.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-.59373em) scale(.75);width:133.3333533333%}.mat-form-field-appearance-fill.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-.59372em) scale(.75);width:133.3333633333%}.mat-form-field-appearance-outline[_ngcontent-%COMP%]   .mat-form-field-infix[_ngcontent-%COMP%]{padding:1em 0}.mat-form-field-appearance-outline[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{top:1.84375em;margin-top:-.25em}.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%], .mat-form-field-appearance-outline.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[_ngcontent-%COMP%]:focus + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.59373em) scale(.75);width:133.3333533333%}.mat-form-field-appearance-outline.mat-form-field-can-float[_ngcontent-%COMP%]   .mat-input-server[label][_ngcontent-%COMP%]:not(:label-shown) + .mat-form-field-label-wrapper[_ngcontent-%COMP%]   .mat-form-field-label[_ngcontent-%COMP%]{transform:translateY(-1.59372em) scale(.75);width:133.3333633333%}.mat-grid-tile-header[_ngcontent-%COMP%], .mat-grid-tile-footer[_ngcontent-%COMP%]{font-size:14px}.mat-grid-tile-header[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%], .mat-grid-tile-footer[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-grid-tile-header[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2), .mat-grid-tile-footer[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2){font-size:12px}input.mat-input-element[_ngcontent-%COMP%]{margin-top:-.0625em}.mat-menu-item[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:400}.mat-paginator[_ngcontent-%COMP%], .mat-paginator-page-size[_ngcontent-%COMP%]   .mat-select-trigger[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px}.mat-radio-button[_ngcontent-%COMP%], .mat-select[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-select-trigger[_ngcontent-%COMP%]{height:1.125em}.mat-slide-toggle-content[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-slider-thumb-label-text[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px;font-weight:500}.mat-stepper-vertical[_ngcontent-%COMP%], .mat-stepper-horizontal[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-step-label[_ngcontent-%COMP%]{font-size:14px;font-weight:400}.mat-step-sub-label-error[_ngcontent-%COMP%]{font-weight:400}.mat-step-label-error[_ngcontent-%COMP%]{font-size:14px}.mat-step-label-selected[_ngcontent-%COMP%]{font-size:14px;font-weight:500}.mat-tab-group[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-tab-label[_ngcontent-%COMP%], .mat-tab-link[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-toolbar[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h4[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%], .mat-toolbar[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0}.mat-tooltip[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:10px;padding-top:6px;padding-bottom:6px}.mat-tooltip-handset[_ngcontent-%COMP%]{font-size:14px;padding-top:8px;padding-bottom:8px}.mat-list-item[_ngcontent-%COMP%], .mat-list-option[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-list-base[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]{font-size:16px}.mat-list-base[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list-base[_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2){font-size:14px}.mat-list-base[_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]{font-size:16px}.mat-list-base[_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list-base[_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2){font-size:14px}.mat-list-base[_ngcontent-%COMP%]   .mat-subheader[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]{font-size:12px}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-item[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2){font-size:12px}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]{font-size:12px}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-list-option[_ngcontent-%COMP%]   .mat-line[_ngcontent-%COMP%]:nth-child(n+2){font-size:12px}.mat-list-base[dense][_ngcontent-%COMP%]   .mat-subheader[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px;font-weight:500}.mat-option[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:16px}.mat-optgroup-label[_ngcontent-%COMP%]{font:500 14px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-simple-snackbar[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px}.mat-simple-snackbar-action[_ngcontent-%COMP%]{line-height:1;font-family:inherit;font-size:inherit;font-weight:500}.mat-tree[_ngcontent-%COMP%]{font-family:Roboto,Helvetica Neue,sans-serif}.mat-tree-node[_ngcontent-%COMP%], .mat-nested-tree-node[_ngcontent-%COMP%]{font-weight:400;font-size:14px}.mat-ripple[_ngcontent-%COMP%]{overflow:hidden;position:relative}.mat-ripple[_ngcontent-%COMP%]:not(:empty){transform:translateZ(0)}.mat-ripple.mat-ripple-unbounded[_ngcontent-%COMP%]{overflow:visible}.mat-ripple-element[_ngcontent-%COMP%]{position:absolute;border-radius:50%;pointer-events:none;transition:opacity,transform 0ms cubic-bezier(0,0,.2,1);transform:scale3d(0,0,0)}.cdk-high-contrast-active[_ngcontent-%COMP%]   .mat-ripple-element[_ngcontent-%COMP%]{display:none}.cdk-visually-hidden[_ngcontent-%COMP%]{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap;outline:0;-webkit-appearance:none;-moz-appearance:none;left:0}[dir=rtl][_ngcontent-%COMP%]   .cdk-visually-hidden[_ngcontent-%COMP%]{left:auto;right:0}.cdk-overlay-container[_ngcontent-%COMP%], .cdk-global-overlay-wrapper[_ngcontent-%COMP%]{pointer-events:none;top:0;left:0;height:100%;width:100%}.cdk-overlay-container[_ngcontent-%COMP%]{position:fixed;z-index:1000}.cdk-overlay-container[_ngcontent-%COMP%]:empty{display:none}.cdk-global-overlay-wrapper[_ngcontent-%COMP%]{display:flex;position:absolute;z-index:1000}.cdk-overlay-pane[_ngcontent-%COMP%]{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}.cdk-overlay-backdrop[_ngcontent-%COMP%]{position:absolute;inset:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:1}.cdk-high-contrast-active[_ngcontent-%COMP%]   .cdk-overlay-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:.6}.cdk-overlay-dark-backdrop[_ngcontent-%COMP%]{background:rgba(0,0,0,.32)}.cdk-overlay-transparent-backdrop[_ngcontent-%COMP%]{transition:visibility 1ms linear,opacity 1ms linear;visibility:hidden;opacity:1}.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:0;visibility:visible}.cdk-overlay-backdrop-noop-animation[_ngcontent-%COMP%]{transition:none}.cdk-overlay-connected-position-bounding-box[_ngcontent-%COMP%]{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}.cdk-global-scrollblock[_ngcontent-%COMP%]{position:fixed;width:100%;overflow-y:scroll}textarea.cdk-textarea-autosize[_ngcontent-%COMP%]{resize:none}textarea.cdk-textarea-autosize-measuring[_ngcontent-%COMP%]{padding:2px 0!important;box-sizing:content-box!important;height:auto!important;overflow:hidden!important}textarea.cdk-textarea-autosize-measuring-firefox[_ngcontent-%COMP%]{padding:2px 0!important;box-sizing:content-box!important;height:0!important}@keyframes cdk-text-field-autofill-start{}@keyframes cdk-text-field-autofill-end{}.cdk-text-field-autofill-monitored[_ngcontent-%COMP%]:-webkit-autofill{animation:cdk-text-field-autofill-start 0s 1ms}.cdk-text-field-autofill-monitored[_ngcontent-%COMP%]:not(:-webkit-autofill){animation:cdk-text-field-autofill-end 0s 1ms}.mat-focus-indicator[_ngcontent-%COMP%]{position:relative}.mat-focus-indicator[_ngcontent-%COMP%]:before{inset:0;position:absolute;box-sizing:border-box;pointer-events:none;display:var(--mat-focus-indicator-display, none);border:var(--mat-focus-indicator-border-width, 3px) var(--mat-focus-indicator-border-style, solid) var(--mat-focus-indicator-border-color, transparent);border-radius:var(--mat-focus-indicator-border-radius, 4px)}.mat-focus-indicator[_ngcontent-%COMP%]:focus:before{content:""}.cdk-high-contrast-active[_ngcontent-%COMP%]{--mat-focus-indicator-display: block}.mat-mdc-focus-indicator[_ngcontent-%COMP%]{position:relative}.mat-mdc-focus-indicator[_ngcontent-%COMP%]:before{inset:0;position:absolute;box-sizing:border-box;pointer-events:none;display:var(--mat-mdc-focus-indicator-display, none);border:var(--mat-mdc-focus-indicator-border-width, 3px) var(--mat-mdc-focus-indicator-border-style, solid) var(--mat-mdc-focus-indicator-border-color, transparent);border-radius:var(--mat-mdc-focus-indicator-border-radius, 4px)}.mat-mdc-focus-indicator[_ngcontent-%COMP%]:focus:before{content:""}.cdk-high-contrast-active[_ngcontent-%COMP%]{--mat-mdc-focus-indicator-display: block}.section-break[_ngcontent-%COMP%]{color:#2a3c59;font-size:2rem;width:100%;border-bottom:2px solid #2a3c59;margin:20px 0}']
        });
      }
      return u0;
    })();
    function mx(n, t = Zr) {
      const a = function xfe(n) {
        return n instanceof Date && !isNaN(+n);
      }(n) ? +n - t.now() : Math.abs(n);
      return i => i.lift(new wfe(a, t));
    }
    class wfe {
      constructor(t, e) {
        this.delay = t, this.scheduler = e;
      }
      call(t, e) {
        return e.subscribe(new L4(t, this.delay, this.scheduler));
      }
    }
    class L4 extends Qe {
      constructor(t, e, a) {
        super(t), this.delay = e, this.scheduler = a, this.queue = [], this.active = !1, this.errored = !1;
      }
      static dispatch(t) {
        const e = t.source,
          a = e.queue,
          i = t.scheduler,
          o = t.destination;
        for (; a.length > 0 && a[0].time - i.now() <= 0;) a.shift().notification.observe(o);
        if (a.length > 0) {
          const r = Math.max(0, a[0].time - i.now());
          this.schedule(t, r);
        } else this.unsubscribe(), e.active = !1;
      }
      _schedule(t) {
        this.active = !0, this.destination.add(t.schedule(L4.dispatch, this.delay, {
          source: this,
          destination: this.destination,
          scheduler: t
        }));
      }
      scheduleNotification(t) {
        if (!0 === this.errored) return;
        const e = this.scheduler,
          a = new kfe(e.now() + this.delay, t);
        this.queue.push(a), !1 === this.active && this._schedule(e);
      }
      _next(t) {
        this.scheduleNotification(Cn.createNext(t));
      }
      _error(t) {
        this.errored = !0, this.queue = [], this.destination.error(t), this.unsubscribe();
      }
      _complete() {
        this.scheduleNotification(Cn.createComplete()), this.unsubscribe();
      }
    }
    class kfe {
      constructor(t, e) {
        this.time = t, this.notification = e;
      }
    }
    const Dfe = ["panel"];
    function Ofe(n, t) {
      if (1 & n && (_(0, "div", 0, 1), Me(2), y()), 2 & n) {
        const e = t.id,
          a = x();
        b("id", a.id)("ngClass", a._classList), X("aria-label", a.ariaLabel || null)("aria-labelledby", a._getPanelAriaLabelledby(e));
      }
    }
    const Pfe = ["*"];
    let Afe = 0;
    class Sfe {
      constructor(t, e) {
        this.source = t, this.option = e;
      }
    }
    const Efe = Za(class {}),
      hx = new O("mat-autocomplete-default-options", {
        providedIn: "root",
        factory: function Tfe() {
          return {
            autoActiveFirstOption: !1,
            autoSelectActiveOption: !1
          };
        }
      });
    let Ife = (() => {
        class n extends Efe {
          constructor(e, a, i, o) {
            super(), this._changeDetectorRef = e, this._elementRef = a, this._activeOptionChanges = re.EMPTY, this.showPanel = !1, this._isOpen = !1, this.displayWith = null, this.optionSelected = new E(), this.opened = new E(), this.closed = new E(), this.optionActivated = new E(), this._classList = {}, this.id = "mat-autocomplete-" + Afe++, this.inertGroups = o?.SAFARI || !1, this._autoActiveFirstOption = !!i.autoActiveFirstOption, this._autoSelectActiveOption = !!i.autoSelectActiveOption;
          }
          get isOpen() {
            return this._isOpen && this.showPanel;
          }
          get autoActiveFirstOption() {
            return this._autoActiveFirstOption;
          }
          set autoActiveFirstOption(e) {
            this._autoActiveFirstOption = Y(e);
          }
          get autoSelectActiveOption() {
            return this._autoSelectActiveOption;
          }
          set autoSelectActiveOption(e) {
            this._autoSelectActiveOption = Y(e);
          }
          set classList(e) {
            this._classList = e && e.length ? e_(e).reduce((a, i) => (a[i] = !0, a), {}) : {}, this._setVisibilityClasses(this._classList), this._elementRef.nativeElement.className = "";
          }
          ngAfterContentInit() {
            this._keyManager = new Wv(this.options).withWrap(), this._activeOptionChanges = this._keyManager.change.subscribe(e => {
              this.isOpen && this.optionActivated.emit({
                source: this,
                option: this.options.toArray()[e] || null
              });
            }), this._setVisibility();
          }
          ngOnDestroy() {
            this._activeOptionChanges.unsubscribe();
          }
          _setScrollTop(e) {
            this.panel && (this.panel.nativeElement.scrollTop = e);
          }
          _getScrollTop() {
            return this.panel ? this.panel.nativeElement.scrollTop : 0;
          }
          _setVisibility() {
            this.showPanel = !!this.options.length, this._setVisibilityClasses(this._classList), this._changeDetectorRef.markForCheck();
          }
          _emitSelectEvent(e) {
            const a = new Sfe(this, e);
            this.optionSelected.emit(a);
          }
          _getPanelAriaLabelledby(e) {
            return this.ariaLabel ? null : this.ariaLabelledby ? (e ? e + " " : "") + this.ariaLabelledby : e;
          }
          _setVisibilityClasses(e) {
            e[this._visibleClass] = this.showPanel, e[this._hiddenClass] = !this.showPanel;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Se), f(J), f(hx), f(Ct));
        }, n.ɵdir = P({
          type: n,
          viewQuery: function (e, a) {
            if (1 & e && (be(vt, 7), be(Dfe, 5)), 2 & e) {
              let i;
              H(i = B()) && (a.template = i.first), H(i = B()) && (a.panel = i.first);
            }
          },
          inputs: {
            ariaLabel: ["aria-label", "ariaLabel"],
            ariaLabelledby: ["aria-labelledby", "ariaLabelledby"],
            displayWith: "displayWith",
            autoActiveFirstOption: "autoActiveFirstOption",
            autoSelectActiveOption: "autoSelectActiveOption",
            panelWidth: "panelWidth",
            classList: ["class", "classList"]
          },
          outputs: {
            optionSelected: "optionSelected",
            opened: "opened",
            closed: "closed",
            optionActivated: "optionActivated"
          },
          features: [z]
        }), n;
      })(),
      Rfe = (() => {
        class n extends Ife {
          constructor() {
            super(...arguments), this._visibleClass = "mat-autocomplete-visible", this._hiddenClass = "mat-autocomplete-hidden";
          }
        }
        return n.ɵfac = function () {
          let t;
          return function (a) {
            return (t || (t = he(n)))(a || n);
          };
        }(), n.ɵcmp = q({
          type: n,
          selectors: [["mat-autocomplete"]],
          contentQueries: function (e, a, i) {
            if (1 & e && (De(i, Mp, 5), De(i, Ho, 5)), 2 & e) {
              let o;
              H(o = B()) && (a.optionGroups = o), H(o = B()) && (a.options = o);
            }
          },
          hostAttrs: [1, "mat-autocomplete"],
          inputs: {
            disableRipple: "disableRipple"
          },
          exportAs: ["matAutocomplete"],
          features: [G([{
            provide: Cp,
            useExisting: n
          }]), z],
          ngContentSelectors: Pfe,
          decls: 1,
          vars: 0,
          consts: [["role", "listbox", 1, "mat-autocomplete-panel", 3, "id", "ngClass"], ["panel", ""]],
          template: function (e, a) {
            1 & e && (lt(), D(0, Ofe, 3, 4, "ng-template"));
          },
          dependencies: [ko],
          styles: [".mat-autocomplete-panel{min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;visibility:hidden;max-width:none;max-height:256px;position:relative;width:100%;border-bottom-left-radius:4px;border-bottom-right-radius:4px}.mat-autocomplete-panel.mat-autocomplete-visible{visibility:visible}.mat-autocomplete-panel.mat-autocomplete-hidden{visibility:hidden}.mat-autocomplete-panel-above .mat-autocomplete-panel{border-radius:0;border-top-left-radius:4px;border-top-right-radius:4px}.mat-autocomplete-panel .mat-divider-horizontal{margin-top:-1px}.cdk-high-contrast-active .mat-autocomplete-panel{outline:solid 1px}mat-autocomplete{display:none}"],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })();
    const px = new O("mat-autocomplete-scroll-strategy"),
      Lfe = {
        provide: px,
        deps: [mn],
        useFactory: function zfe(n) {
          return () => n.scrollStrategies.reposition();
        }
      },
      Nfe = {
        provide: Bt,
        useExisting: Pe(() => gx),
        multi: !0
      };
    let Ffe = (() => {
        class n {
          constructor(e, a, i, o, r, s, c, l, d, u, m) {
            this._element = e, this._overlay = a, this._viewContainerRef = i, this._zone = o, this._changeDetectorRef = r, this._dir = c, this._formField = l, this._document = d, this._viewportRuler = u, this._defaults = m, this._componentDestroyed = !1, this._autocompleteDisabled = !1, this._manuallyFloatingLabel = !1, this._viewportSubscription = re.EMPTY, this._canOpenOnNextFocus = !0, this._closeKeyEventStream = new V(), this._windowBlurHandler = () => {
              this._canOpenOnNextFocus = this._document.activeElement !== this._element.nativeElement || this.panelOpen;
            }, this._onChange = () => {}, this._onTouched = () => {}, this.position = "auto", this.autocompleteAttribute = "off", this._overlayAttached = !1, this.optionSelections = a0(() => {
              const h = this.autocomplete ? this.autocomplete.options : null;
              return h ? h.changes.pipe(Gt(h), gi(() => dt(...h.map(p => p.onSelectionChange)))) : this._zone.onStable.pipe($e(1), gi(() => this.optionSelections));
            }), this._scrollStrategy = s;
          }
          get autocompleteDisabled() {
            return this._autocompleteDisabled;
          }
          set autocompleteDisabled(e) {
            this._autocompleteDisabled = Y(e);
          }
          ngAfterViewInit() {
            const e = this._getWindow();
            typeof e < "u" && this._zone.runOutsideAngular(() => e.addEventListener("blur", this._windowBlurHandler));
          }
          ngOnChanges(e) {
            e.position && this._positionStrategy && (this._setStrategyPositions(this._positionStrategy), this.panelOpen && this._overlayRef.updatePosition());
          }
          ngOnDestroy() {
            const e = this._getWindow();
            typeof e < "u" && e.removeEventListener("blur", this._windowBlurHandler), this._viewportSubscription.unsubscribe(), this._componentDestroyed = !0, this._destroyPanel(), this._closeKeyEventStream.complete();
          }
          get panelOpen() {
            return this._overlayAttached && this.autocomplete.showPanel;
          }
          openPanel() {
            this._attachOverlay(), this._floatLabel();
          }
          closePanel() {
            this._resetLabel(), this._overlayAttached && (this.panelOpen && this._zone.run(() => {
              this.autocomplete.closed.emit();
            }), this.autocomplete._isOpen = this._overlayAttached = !1, this._pendingAutoselectedOption = null, this._overlayRef && this._overlayRef.hasAttached() && (this._overlayRef.detach(), this._closingActionsSubscription.unsubscribe()), this._componentDestroyed || this._changeDetectorRef.detectChanges());
          }
          updatePosition() {
            this._overlayAttached && this._overlayRef.updatePosition();
          }
          get panelClosingActions() {
            return dt(this.optionSelections, this.autocomplete._keyManager.tabOut.pipe(Ht(() => this._overlayAttached)), this._closeKeyEventStream, this._getOutsideClickStream(), this._overlayRef ? this._overlayRef.detachments().pipe(Ht(() => this._overlayAttached)) : nt()).pipe(We(e => e instanceof sy ? e : null));
          }
          get activeOption() {
            return this.autocomplete && this.autocomplete._keyManager ? this.autocomplete._keyManager.activeItem : null;
          }
          _getOutsideClickStream() {
            return dt(Qr(this._document, "click"), Qr(this._document, "auxclick"), Qr(this._document, "touchend")).pipe(Ht(e => {
              const a = aa(e),
                i = this._formField ? this._formField._elementRef.nativeElement : null,
                o = this.connectedTo ? this.connectedTo.elementRef.nativeElement : null;
              return this._overlayAttached && a !== this._element.nativeElement && this._document.activeElement !== this._element.nativeElement && (!i || !i.contains(a)) && (!o || !o.contains(a)) && !!this._overlayRef && !this._overlayRef.overlayElement.contains(a);
            }));
          }
          writeValue(e) {
            Promise.resolve(null).then(() => this._assignOptionValue(e));
          }
          registerOnChange(e) {
            this._onChange = e;
          }
          registerOnTouched(e) {
            this._onTouched = e;
          }
          setDisabledState(e) {
            this._element.nativeElement.disabled = e;
          }
          _handleKeydown(e) {
            const a = e.keyCode,
              i = Et(e);
            if (27 === a && !i && e.preventDefault(), this.activeOption && 13 === a && this.panelOpen && !i) this.activeOption._selectViaInteraction(), this._resetActiveItem(), e.preventDefault();else if (this.autocomplete) {
              const o = this.autocomplete._keyManager.activeItem,
                r = 38 === a || 40 === a;
              9 === a || r && !i && this.panelOpen ? this.autocomplete._keyManager.onKeydown(e) : r && this._canOpen() && this.openPanel(), (r || this.autocomplete._keyManager.activeItem !== o) && (this._scrollToOption(this.autocomplete._keyManager.activeItemIndex || 0), this.autocomplete.autoSelectActiveOption && this.activeOption && (this._pendingAutoselectedOption || (this._valueBeforeAutoSelection = this._element.nativeElement.value), this._pendingAutoselectedOption = this.activeOption, this._assignOptionValue(this.activeOption.value)));
            }
          }
          _handleInput(e) {
            let a = e.target,
              i = a.value;
            "number" === a.type && (i = "" == i ? null : parseFloat(i)), this._previousValue !== i && (this._previousValue = i, this._pendingAutoselectedOption = null, this._onChange(i), this._canOpen() && this._document.activeElement === e.target && this.openPanel());
          }
          _handleFocus() {
            this._canOpenOnNextFocus ? this._canOpen() && (this._previousValue = this._element.nativeElement.value, this._attachOverlay(), this._floatLabel(!0)) : this._canOpenOnNextFocus = !0;
          }
          _handleClick() {
            this._canOpen() && !this.panelOpen && this.openPanel();
          }
          _floatLabel(e = !1) {
            this._formField && "auto" === this._formField.floatLabel && (e ? this._formField._animateAndLockLabel() : this._formField.floatLabel = "always", this._manuallyFloatingLabel = !0);
          }
          _resetLabel() {
            this._manuallyFloatingLabel && (this._formField.floatLabel = "auto", this._manuallyFloatingLabel = !1);
          }
          _subscribeToClosingActions() {
            return dt(this._zone.onStable.pipe($e(1)), this.autocomplete.options.changes.pipe(rs(() => this._positionStrategy.reapplyLastPosition()), mx(0))).pipe(gi(() => (this._zone.run(() => {
              const i = this.panelOpen;
              this._resetActiveItem(), this.autocomplete._setVisibility(), this._changeDetectorRef.detectChanges(), this.panelOpen && this._overlayRef.updatePosition(), i !== this.panelOpen && (this.panelOpen ? this.autocomplete.opened.emit() : this.autocomplete.closed.emit());
            }), this.panelClosingActions)), $e(1)).subscribe(i => this._setValueAndClose(i));
          }
          _destroyPanel() {
            this._overlayRef && (this.closePanel(), this._overlayRef.dispose(), this._overlayRef = null);
          }
          _assignOptionValue(e) {
            const a = this.autocomplete && this.autocomplete.displayWith ? this.autocomplete.displayWith(e) : e;
            this._updateNativeInputValue(a ?? "");
          }
          _updateNativeInputValue(e) {
            this._formField ? this._formField._control.value = e : this._element.nativeElement.value = e, this._previousValue = e;
          }
          _setValueAndClose(e) {
            const a = e ? e.source : this._pendingAutoselectedOption;
            a && (this._clearPreviousSelectedOption(a), this._assignOptionValue(a.value), this._onChange(a.value), this.autocomplete._emitSelectEvent(a), this._element.nativeElement.focus()), this.closePanel();
          }
          _clearPreviousSelectedOption(e) {
            this.autocomplete.options.forEach(a => {
              a !== e && a.selected && a.deselect();
            });
          }
          _attachOverlay() {
            let e = this._overlayRef;
            e ? (this._positionStrategy.setOrigin(this._getConnectedElement()), e.updateSize({
              width: this._getPanelWidth()
            })) : (this._portal = new Vc(this.autocomplete.template, this._viewContainerRef, {
              id: this._formField?.getLabelId()
            }), e = this._overlay.create(this._getOverlayConfig()), this._overlayRef = e, this._handleOverlayEvents(e), this._viewportSubscription = this._viewportRuler.change().subscribe(() => {
              this.panelOpen && e && e.updateSize({
                width: this._getPanelWidth()
              });
            })), e && !e.hasAttached() && (e.attach(this._portal), this._closingActionsSubscription = this._subscribeToClosingActions());
            const a = this.panelOpen;
            this.autocomplete._setVisibility(), this.autocomplete._isOpen = this._overlayAttached = !0, this.panelOpen && a !== this.panelOpen && this.autocomplete.opened.emit();
          }
          _getOverlayConfig() {
            return new jc({
              positionStrategy: this._getOverlayPosition(),
              scrollStrategy: this._scrollStrategy(),
              width: this._getPanelWidth(),
              direction: this._dir,
              panelClass: this._defaults?.overlayPanelClass
            });
          }
          _getOverlayPosition() {
            const e = this._overlay.position().flexibleConnectedTo(this._getConnectedElement()).withFlexibleDimensions(!1).withPush(!1);
            return this._setStrategyPositions(e), this._positionStrategy = e, e;
          }
          _setStrategyPositions(e) {
            const a = [{
                originX: "start",
                originY: "bottom",
                overlayX: "start",
                overlayY: "top"
              }, {
                originX: "end",
                originY: "bottom",
                overlayX: "end",
                overlayY: "top"
              }],
              i = this._aboveClass,
              o = [{
                originX: "start",
                originY: "top",
                overlayX: "start",
                overlayY: "bottom",
                panelClass: i
              }, {
                originX: "end",
                originY: "top",
                overlayX: "end",
                overlayY: "bottom",
                panelClass: i
              }];
            let r;
            r = "above" === this.position ? o : "below" === this.position ? a : [...a, ...o], e.withPositions(r);
          }
          _getConnectedElement() {
            return this.connectedTo ? this.connectedTo.elementRef : this._formField ? this._formField.getConnectedOverlayOrigin() : this._element;
          }
          _getPanelWidth() {
            return this.autocomplete.panelWidth || this._getHostWidth();
          }
          _getHostWidth() {
            return this._getConnectedElement().nativeElement.getBoundingClientRect().width;
          }
          _resetActiveItem() {
            const e = this.autocomplete;
            e.autoActiveFirstOption ? e._keyManager.setFirstItemActive() : e._keyManager.setActiveItem(-1);
          }
          _canOpen() {
            const e = this._element.nativeElement;
            return !e.readOnly && !e.disabled && !this._autocompleteDisabled;
          }
          _getWindow() {
            return this._document?.defaultView || window;
          }
          _scrollToOption(e) {
            const a = this.autocomplete,
              i = k2(e, a.options, a.optionGroups);
            if (0 === e && 1 === i) a._setScrollTop(0);else if (a.panel) {
              const o = a.options.toArray()[e];
              if (o) {
                const r = o._getHostElement(),
                  s = cy(r.offsetTop, r.offsetHeight, a._getScrollTop(), a.panel.nativeElement.offsetHeight);
                a._setScrollTop(s);
              }
            }
          }
          _handleOverlayEvents(e) {
            e.keydownEvents().subscribe(a => {
              (27 === a.keyCode && !Et(a) || 38 === a.keyCode && Et(a, "altKey")) && (this._pendingAutoselectedOption && (this._updateNativeInputValue(this._valueBeforeAutoSelection ?? ""), this._pendingAutoselectedOption = null), this._closeKeyEventStream.next(), this._resetActiveItem(), a.stopPropagation(), a.preventDefault());
            }), e.outsidePointerEvents().subscribe();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(mn), f(ut), f(ae), f(Se), f(px), f(nn, 8), f(_l, 9), f(ie, 8), f(Ki), f(hx, 8));
        }, n.ɵdir = P({
          type: n,
          inputs: {
            autocomplete: ["matAutocomplete", "autocomplete"],
            position: ["matAutocompletePosition", "position"],
            connectedTo: ["matAutocompleteConnectedTo", "connectedTo"],
            autocompleteAttribute: ["autocomplete", "autocompleteAttribute"],
            autocompleteDisabled: ["matAutocompleteDisabled", "autocompleteDisabled"]
          },
          features: [Ve]
        }), n;
      })(),
      gx = (() => {
        class n extends Ffe {
          constructor() {
            super(...arguments), this._aboveClass = "mat-autocomplete-panel-above";
          }
        }
        return n.ɵfac = function () {
          let t;
          return function (a) {
            return (t || (t = he(n)))(a || n);
          };
        }(), n.ɵdir = P({
          type: n,
          selectors: [["input", "matAutocomplete", ""], ["textarea", "matAutocomplete", ""]],
          hostAttrs: [1, "mat-autocomplete-trigger"],
          hostVars: 7,
          hostBindings: function (e, a) {
            1 & e && F("focusin", function () {
              return a._handleFocus();
            })("blur", function () {
              return a._onTouched();
            })("input", function (o) {
              return a._handleInput(o);
            })("keydown", function (o) {
              return a._handleKeydown(o);
            })("click", function () {
              return a._handleClick();
            }), 2 & e && X("autocomplete", a.autocompleteAttribute)("role", a.autocompleteDisabled ? null : "combobox")("aria-autocomplete", a.autocompleteDisabled ? null : "list")("aria-activedescendant", a.panelOpen && a.activeOption ? a.activeOption.id : null)("aria-expanded", a.autocompleteDisabled ? null : a.panelOpen.toString())("aria-owns", a.autocompleteDisabled || !a.panelOpen || null == a.autocomplete ? null : a.autocomplete.id)("aria-haspopup", a.autocompleteDisabled ? null : "listbox");
          },
          exportAs: ["matAutocompleteTrigger"],
          features: [G([Nfe]), z]
        }), n;
      })(),
      bx = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [Lfe],
          imports: [qa, D2, $, yt, Wa, D2, $]
        }), n;
      })();
    const Vfe = ["*"],
      _x = new O("MatChipRemove"),
      vx = new O("MatChipAvatar"),
      yx = new O("MatChipTrailingIcon");
    class Hfe {
      constructor(t) {
        this._elementRef = t;
      }
    }
    const Bfe = $i(Qa(Za(Hfe), "primary"), -1);
    let f0 = (() => {
        class n extends Bfe {
          constructor(e, a, i, o, r, s, c, l) {
            super(e), this._ngZone = a, this._changeDetectorRef = r, this._hasFocus = !1, this.chipListSelectable = !0, this._chipListMultiple = !1, this._chipListDisabled = !1, this.role = "option", this._selected = !1, this._selectable = !0, this._disabled = !1, this._removable = !0, this._onFocus = new V(), this._onBlur = new V(), this.selectionChange = new E(), this.destroyed = new E(), this.removed = new E(), this._addHostClassName(), this._chipRippleTarget = s.createElement("div"), this._chipRippleTarget.classList.add("mat-chip-ripple"), this._elementRef.nativeElement.appendChild(this._chipRippleTarget), this._chipRipple = new iy(this, a, this._chipRippleTarget, i), this._chipRipple.setupTriggerEvents(e), this.rippleConfig = o || {}, this._animationsDisabled = "NoopAnimations" === c, this.tabIndex = null != l && parseInt(l) || -1;
          }
          get rippleDisabled() {
            return this.disabled || this.disableRipple || this._animationsDisabled || !!this.rippleConfig.disabled;
          }
          get selected() {
            return this._selected;
          }
          set selected(e) {
            const a = Y(e);
            a !== this._selected && (this._selected = a, this._dispatchSelectionChange());
          }
          get value() {
            return void 0 !== this._value ? this._value : this._elementRef.nativeElement.textContent;
          }
          set value(e) {
            this._value = e;
          }
          get selectable() {
            return this._selectable && this.chipListSelectable;
          }
          set selectable(e) {
            this._selectable = Y(e);
          }
          get disabled() {
            return this._chipListDisabled || this._disabled;
          }
          set disabled(e) {
            this._disabled = Y(e);
          }
          get removable() {
            return this._removable;
          }
          set removable(e) {
            this._removable = Y(e);
          }
          get ariaSelected() {
            return this.selectable && (this._chipListMultiple || this.selected) ? this.selected.toString() : null;
          }
          _addHostClassName() {
            const e = "mat-basic-chip",
              a = this._elementRef.nativeElement;
            a.hasAttribute(e) || a.tagName.toLowerCase() === e ? a.classList.add(e) : a.classList.add("mat-standard-chip");
          }
          ngOnDestroy() {
            this.destroyed.emit({
              chip: this
            }), this._chipRipple._removeTriggerEvents();
          }
          select() {
            this._selected || (this._selected = !0, this._dispatchSelectionChange(), this._changeDetectorRef.markForCheck());
          }
          deselect() {
            this._selected && (this._selected = !1, this._dispatchSelectionChange(), this._changeDetectorRef.markForCheck());
          }
          selectViaInteraction() {
            this._selected || (this._selected = !0, this._dispatchSelectionChange(!0), this._changeDetectorRef.markForCheck());
          }
          toggleSelected(e = !1) {
            return this._selected = !this.selected, this._dispatchSelectionChange(e), this._changeDetectorRef.markForCheck(), this.selected;
          }
          focus() {
            this._hasFocus || (this._elementRef.nativeElement.focus(), this._onFocus.next({
              chip: this
            })), this._hasFocus = !0;
          }
          remove() {
            this.removable && this.removed.emit({
              chip: this
            });
          }
          _handleClick(e) {
            this.disabled && e.preventDefault();
          }
          _handleKeydown(e) {
            if (!this.disabled) switch (e.keyCode) {
              case 46:
              case 8:
                this.remove(), e.preventDefault();
                break;
              case 32:
                this.selectable && this.toggleSelected(!0), e.preventDefault();
            }
          }
          _blur() {
            this._ngZone.onStable.pipe($e(1)).subscribe(() => {
              this._ngZone.run(() => {
                this._hasFocus = !1, this._onBlur.next({
                  chip: this
                });
              });
            });
          }
          _dispatchSelectionChange(e = !1) {
            this.selectionChange.emit({
              source: this,
              isUserInput: e,
              selected: this._selected
            });
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(ae), f(Ct), f(oy, 8), f(Se), f(ie), f(Ft, 8), qt("tabindex"));
        }, n.ɵdir = P({
          type: n,
          selectors: [["mat-basic-chip"], ["", "mat-basic-chip", ""], ["mat-chip"], ["", "mat-chip", ""]],
          contentQueries: function (e, a, i) {
            if (1 & e && (De(i, vx, 5), De(i, yx, 5), De(i, _x, 5)), 2 & e) {
              let o;
              H(o = B()) && (a.avatar = o.first), H(o = B()) && (a.trailingIcon = o.first), H(o = B()) && (a.removeIcon = o.first);
            }
          },
          hostAttrs: [1, "mat-chip", "mat-focus-indicator"],
          hostVars: 15,
          hostBindings: function (e, a) {
            1 & e && F("click", function (o) {
              return a._handleClick(o);
            })("keydown", function (o) {
              return a._handleKeydown(o);
            })("focus", function () {
              return a.focus();
            })("blur", function () {
              return a._blur();
            }), 2 & e && (X("tabindex", a.disabled ? null : a.tabIndex)("role", a.role)("disabled", a.disabled || null)("aria-disabled", a.disabled.toString())("aria-selected", a.ariaSelected), fe("mat-chip-selected", a.selected)("mat-chip-with-avatar", a.avatar)("mat-chip-with-trailing-icon", a.trailingIcon || a.removeIcon)("mat-chip-disabled", a.disabled)("_mat-animation-noopable", a._animationsDisabled));
          },
          inputs: {
            color: "color",
            disableRipple: "disableRipple",
            tabIndex: "tabIndex",
            role: "role",
            selected: "selected",
            value: "value",
            selectable: "selectable",
            disabled: "disabled",
            removable: "removable"
          },
          outputs: {
            selectionChange: "selectionChange",
            destroyed: "destroyed",
            removed: "removed"
          },
          exportAs: ["matChip"],
          features: [z]
        }), n;
      })(),
      Cx = (() => {
        class n {
          constructor(e, a) {
            this._parentChip = e, "BUTTON" === a.nativeElement.nodeName && a.nativeElement.setAttribute("type", "button");
          }
          _handleClick(e) {
            const a = this._parentChip;
            a.removable && !a.disabled && a.remove(), e.stopPropagation(), e.preventDefault();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(f0), f(J));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "matChipRemove", ""]],
          hostAttrs: [1, "mat-chip-remove", "mat-chip-trailing-icon"],
          hostBindings: function (e, a) {
            1 & e && F("click", function (o) {
              return a._handleClick(o);
            });
          },
          features: [G([{
            provide: _x,
            useExisting: n
          }])]
        }), n;
      })();
    const Mx = new O("mat-chips-default-options"),
      Gfe = gp(class {
        constructor(n, t, e, a) {
          this._defaultErrorStateMatcher = n, this._parentForm = t, this._parentFormGroup = e, this.ngControl = a, this.stateChanges = new V();
        }
      });
    let Wfe = 0;
    class Yfe {
      constructor(t, e) {
        this.source = t, this.value = e;
      }
    }
    let xx = (() => {
        class n extends Gfe {
          constructor(e, a, i, o, r, s, c) {
            super(s, o, r, c), this._elementRef = e, this._changeDetectorRef = a, this._dir = i, this.controlType = "mat-chip-list", this._lastDestroyedChipIndex = null, this._destroyed = new V(), this._uid = "mat-chip-list-" + Wfe++, this._tabIndex = 0, this._userTabIndex = null, this._onTouched = () => {}, this._onChange = () => {}, this._multiple = !1, this._compareWith = (l, d) => l === d, this._disabled = !1, this.ariaOrientation = "horizontal", this._selectable = !0, this.change = new E(), this.valueChange = new E(), this.ngControl && (this.ngControl.valueAccessor = this);
          }
          get selected() {
            return this.multiple ? this._selectionModel?.selected || [] : this._selectionModel?.selected[0];
          }
          get role() {
            return this._explicitRole ? this._explicitRole : this.empty ? null : "listbox";
          }
          set role(e) {
            this._explicitRole = e;
          }
          get multiple() {
            return this._multiple;
          }
          set multiple(e) {
            this._multiple = Y(e), this._syncChipsState();
          }
          get compareWith() {
            return this._compareWith;
          }
          set compareWith(e) {
            this._compareWith = e, this._selectionModel && this._initializeSelection();
          }
          get value() {
            return this._value;
          }
          set value(e) {
            this.writeValue(e), this._value = e;
          }
          get id() {
            return this._chipInput ? this._chipInput.id : this._uid;
          }
          get required() {
            return this._required ?? this.ngControl?.control?.hasValidator(Da.required) ?? !1;
          }
          set required(e) {
            this._required = Y(e), this.stateChanges.next();
          }
          get placeholder() {
            return this._chipInput ? this._chipInput.placeholder : this._placeholder;
          }
          set placeholder(e) {
            this._placeholder = e, this.stateChanges.next();
          }
          get focused() {
            return this._chipInput && this._chipInput.focused || this._hasFocusedChip();
          }
          get empty() {
            return (!this._chipInput || this._chipInput.empty) && (!this.chips || 0 === this.chips.length);
          }
          get shouldLabelFloat() {
            return !this.empty || this.focused;
          }
          get disabled() {
            return this.ngControl ? !!this.ngControl.disabled : this._disabled;
          }
          set disabled(e) {
            this._disabled = Y(e), this._syncChipsState();
          }
          get selectable() {
            return this._selectable;
          }
          set selectable(e) {
            this._selectable = Y(e), this._syncChipsState();
          }
          set tabIndex(e) {
            this._userTabIndex = e, this._tabIndex = e;
          }
          get chipSelectionChanges() {
            return dt(...this.chips.map(e => e.selectionChange));
          }
          get chipFocusChanges() {
            return dt(...this.chips.map(e => e._onFocus));
          }
          get chipBlurChanges() {
            return dt(...this.chips.map(e => e._onBlur));
          }
          get chipRemoveChanges() {
            return dt(...this.chips.map(e => e.destroyed));
          }
          ngAfterContentInit() {
            this._keyManager = new dp(this.chips).withWrap().withVerticalOrientation().withHomeAndEnd().withHorizontalOrientation(this._dir ? this._dir.value : "ltr"), this._dir && this._dir.change.pipe(ne(this._destroyed)).subscribe(e => this._keyManager.withHorizontalOrientation(e)), this._keyManager.tabOut.pipe(ne(this._destroyed)).subscribe(() => {
              this._allowFocusEscape();
            }), this.chips.changes.pipe(Gt(null), ne(this._destroyed)).subscribe(() => {
              (this.disabled || !this.selectable) && Promise.resolve().then(() => {
                this._syncChipsState();
              }), this._resetChips(), this._initializeSelection(), this._updateTabIndex(), this._updateFocusForDestroyedChips(), this.stateChanges.next();
            });
          }
          ngOnInit() {
            this._selectionModel = new os(this.multiple, void 0, !1), this.stateChanges.next();
          }
          ngDoCheck() {
            this.ngControl && (this.updateErrorState(), this.ngControl.disabled !== this._disabled && (this.disabled = !!this.ngControl.disabled));
          }
          ngOnDestroy() {
            this._destroyed.next(), this._destroyed.complete(), this.stateChanges.complete(), this._dropSubscriptions();
          }
          registerInput(e) {
            this._chipInput = e, this._elementRef.nativeElement.setAttribute("data-mat-chip-input", e.id);
          }
          setDescribedByIds(e) {
            e.length ? this._elementRef.nativeElement.setAttribute("aria-describedby", e.join(" ")) : this._elementRef.nativeElement.removeAttribute("aria-describedby");
          }
          writeValue(e) {
            this.chips && this._setSelectionByValue(e, !1);
          }
          registerOnChange(e) {
            this._onChange = e;
          }
          registerOnTouched(e) {
            this._onTouched = e;
          }
          setDisabledState(e) {
            this.disabled = e, this.stateChanges.next();
          }
          onContainerClick(e) {
            this._originatesFromChip(e) || this.focus();
          }
          focus(e) {
            this.disabled || this._chipInput && this._chipInput.focused || (this.chips.length > 0 ? (this._keyManager.setFirstItemActive(), this.stateChanges.next()) : (this._focusInput(e), this.stateChanges.next()));
          }
          _focusInput(e) {
            this._chipInput && this._chipInput.focus(e);
          }
          _keydown(e) {
            const a = e.target;
            a && a.classList.contains("mat-chip") && (this._keyManager.onKeydown(e), this.stateChanges.next());
          }
          _updateTabIndex() {
            this._tabIndex = this._userTabIndex || (0 === this.chips.length ? -1 : 0);
          }
          _updateFocusForDestroyedChips() {
            if (null != this._lastDestroyedChipIndex) if (this.chips.length) {
              const e = Math.min(this._lastDestroyedChipIndex, this.chips.length - 1);
              this._keyManager.setActiveItem(e);
            } else this.focus();
            this._lastDestroyedChipIndex = null;
          }
          _isValidIndex(e) {
            return e >= 0 && e < this.chips.length;
          }
          _setSelectionByValue(e, a = !0) {
            if (this._clearSelection(), this.chips.forEach(i => i.deselect()), Array.isArray(e)) e.forEach(i => this._selectValue(i, a)), this._sortValues();else {
              const i = this._selectValue(e, a);
              i && a && this._keyManager.setActiveItem(i);
            }
          }
          _selectValue(e, a = !0) {
            const i = this.chips.find(o => null != o.value && this._compareWith(o.value, e));
            return i && (a ? i.selectViaInteraction() : i.select(), this._selectionModel.select(i)), i;
          }
          _initializeSelection() {
            Promise.resolve().then(() => {
              (this.ngControl || this._value) && (this._setSelectionByValue(this.ngControl ? this.ngControl.value : this._value, !1), this.stateChanges.next());
            });
          }
          _clearSelection(e) {
            this._selectionModel.clear(), this.chips.forEach(a => {
              a !== e && a.deselect();
            }), this.stateChanges.next();
          }
          _sortValues() {
            this._multiple && (this._selectionModel.clear(), this.chips.forEach(e => {
              e.selected && this._selectionModel.select(e);
            }), this.stateChanges.next());
          }
          _propagateChanges(e) {
            let a = null;
            a = Array.isArray(this.selected) ? this.selected.map(i => i.value) : this.selected ? this.selected.value : e, this._value = a, this.change.emit(new Yfe(this, a)), this.valueChange.emit(a), this._onChange(a), this._changeDetectorRef.markForCheck();
          }
          _blur() {
            this._hasFocusedChip() || this._keyManager.setActiveItem(-1), this.disabled || (this._chipInput ? setTimeout(() => {
              this.focused || this._markAsTouched();
            }) : this._markAsTouched());
          }
          _markAsTouched() {
            this._onTouched(), this._changeDetectorRef.markForCheck(), this.stateChanges.next();
          }
          _allowFocusEscape() {
            -1 !== this._tabIndex && (this._tabIndex = -1, setTimeout(() => {
              this._tabIndex = this._userTabIndex || 0, this._changeDetectorRef.markForCheck();
            }));
          }
          _resetChips() {
            this._dropSubscriptions(), this._listenToChipsFocus(), this._listenToChipsSelection(), this._listenToChipsRemoved();
          }
          _dropSubscriptions() {
            this._chipFocusSubscription && (this._chipFocusSubscription.unsubscribe(), this._chipFocusSubscription = null), this._chipBlurSubscription && (this._chipBlurSubscription.unsubscribe(), this._chipBlurSubscription = null), this._chipSelectionSubscription && (this._chipSelectionSubscription.unsubscribe(), this._chipSelectionSubscription = null), this._chipRemoveSubscription && (this._chipRemoveSubscription.unsubscribe(), this._chipRemoveSubscription = null);
          }
          _listenToChipsSelection() {
            this._chipSelectionSubscription = this.chipSelectionChanges.subscribe(e => {
              e.source.selected ? this._selectionModel.select(e.source) : this._selectionModel.deselect(e.source), this.multiple || this.chips.forEach(a => {
                !this._selectionModel.isSelected(a) && a.selected && a.deselect();
              }), e.isUserInput && this._propagateChanges();
            });
          }
          _listenToChipsFocus() {
            this._chipFocusSubscription = this.chipFocusChanges.subscribe(e => {
              let a = this.chips.toArray().indexOf(e.chip);
              this._isValidIndex(a) && this._keyManager.updateActiveItem(a), this.stateChanges.next();
            }), this._chipBlurSubscription = this.chipBlurChanges.subscribe(() => {
              this._blur(), this.stateChanges.next();
            });
          }
          _listenToChipsRemoved() {
            this._chipRemoveSubscription = this.chipRemoveChanges.subscribe(e => {
              const a = e.chip,
                i = this.chips.toArray().indexOf(e.chip);
              this._isValidIndex(i) && a._hasFocus && (this._lastDestroyedChipIndex = i);
            });
          }
          _originatesFromChip(e) {
            let a = e.target;
            for (; a && a !== this._elementRef.nativeElement;) {
              if (a.classList.contains("mat-chip")) return !0;
              a = a.parentElement;
            }
            return !1;
          }
          _hasFocusedChip() {
            return this.chips && this.chips.some(e => e._hasFocus);
          }
          _syncChipsState() {
            this.chips && this.chips.forEach(e => {
              e._chipListDisabled = this._disabled, e._chipListMultiple = this.multiple, e.chipListSelectable = this._selectable;
            });
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(Se), f(nn, 8), f(is, 8), f(ra, 8), f(ls), f(Oa, 10));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-chip-list"]],
          contentQueries: function (e, a, i) {
            if (1 & e && De(i, f0, 5), 2 & e) {
              let o;
              H(o = B()) && (a.chips = o);
            }
          },
          hostAttrs: [1, "mat-chip-list"],
          hostVars: 14,
          hostBindings: function (e, a) {
            1 & e && F("focus", function () {
              return a.focus();
            })("blur", function () {
              return a._blur();
            })("keydown", function (o) {
              return a._keydown(o);
            }), 2 & e && (Zn("id", a._uid), X("tabindex", a.disabled ? null : a._tabIndex)("aria-required", a.role ? a.required : null)("aria-disabled", a.disabled.toString())("aria-invalid", a.errorState)("aria-multiselectable", a.multiple)("role", a.role)("aria-orientation", a.ariaOrientation), fe("mat-chip-list-disabled", a.disabled)("mat-chip-list-invalid", a.errorState)("mat-chip-list-required", a.required));
          },
          inputs: {
            role: "role",
            userAriaDescribedBy: ["aria-describedby", "userAriaDescribedBy"],
            errorStateMatcher: "errorStateMatcher",
            multiple: "multiple",
            compareWith: "compareWith",
            value: "value",
            required: "required",
            placeholder: "placeholder",
            disabled: "disabled",
            ariaOrientation: ["aria-orientation", "ariaOrientation"],
            selectable: "selectable",
            tabIndex: "tabIndex"
          },
          outputs: {
            change: "change",
            valueChange: "valueChange"
          },
          exportAs: ["matChipList"],
          features: [G([{
            provide: bl,
            useExisting: n
          }]), z],
          ngContentSelectors: Vfe,
          decls: 2,
          vars: 0,
          consts: [[1, "mat-chip-list-wrapper"]],
          template: function (e, a) {
            1 & e && (lt(), _(0, "div", 0), Me(1), y());
          },
          styles: ['.mat-chip{position:relative;box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0);border:none;-webkit-appearance:none;-moz-appearance:none}.mat-chip::before{margin:calc(calc(var(--mat-focus-indicator-border-width, 3px) + 2px) * -1)}.mat-standard-chip{transition:box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);display:inline-flex;padding:7px 12px;border-radius:16px;align-items:center;cursor:default;min-height:32px;height:1px}.mat-standard-chip._mat-animation-noopable{transition:none !important;animation:none !important}.mat-standard-chip .mat-chip-remove{border:none;-webkit-appearance:none;-moz-appearance:none;padding:0;background:none}.mat-standard-chip .mat-chip-remove.mat-icon,.mat-standard-chip .mat-chip-remove .mat-icon{width:18px;height:18px;font-size:18px}.mat-standard-chip::after{top:0;left:0;right:0;bottom:0;position:absolute;border-radius:inherit;opacity:0;content:"";pointer-events:none;transition:opacity 200ms cubic-bezier(0.35, 0, 0.25, 1)}.mat-standard-chip:hover::after{opacity:.12}.mat-standard-chip:focus{outline:none}.mat-standard-chip:focus::after{opacity:.16}.cdk-high-contrast-active .mat-standard-chip{outline:solid 1px}.cdk-high-contrast-active .mat-standard-chip.mat-chip-selected{outline-width:3px}.mat-standard-chip.mat-chip-disabled::after{opacity:0}.mat-standard-chip.mat-chip-disabled .mat-chip-remove,.mat-standard-chip.mat-chip-disabled .mat-chip-trailing-icon{cursor:default}.mat-standard-chip.mat-chip-with-trailing-icon.mat-chip-with-avatar,.mat-standard-chip.mat-chip-with-avatar{padding-top:0;padding-bottom:0}.mat-standard-chip.mat-chip-with-trailing-icon.mat-chip-with-avatar{padding-right:8px;padding-left:0}[dir=rtl] .mat-standard-chip.mat-chip-with-trailing-icon.mat-chip-with-avatar{padding-left:8px;padding-right:0}.mat-standard-chip.mat-chip-with-trailing-icon{padding-top:7px;padding-bottom:7px;padding-right:8px;padding-left:12px}[dir=rtl] .mat-standard-chip.mat-chip-with-trailing-icon{padding-left:8px;padding-right:12px}.mat-standard-chip.mat-chip-with-avatar{padding-left:0;padding-right:12px}[dir=rtl] .mat-standard-chip.mat-chip-with-avatar{padding-right:0;padding-left:12px}.mat-standard-chip .mat-chip-avatar{width:24px;height:24px;margin-right:8px;margin-left:4px}[dir=rtl] .mat-standard-chip .mat-chip-avatar{margin-left:8px;margin-right:4px}.mat-standard-chip .mat-chip-remove,.mat-standard-chip .mat-chip-trailing-icon{width:18px;height:18px;cursor:pointer}.mat-standard-chip .mat-chip-remove,.mat-standard-chip .mat-chip-trailing-icon{margin-left:8px;margin-right:0}[dir=rtl] .mat-standard-chip .mat-chip-remove,[dir=rtl] .mat-standard-chip .mat-chip-trailing-icon{margin-right:8px;margin-left:0}.mat-chip-ripple{top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none;border-radius:inherit;overflow:hidden;transform:translateZ(0)}.mat-chip-list-wrapper{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;margin:-4px}.mat-chip-list-wrapper input.mat-input-element,.mat-chip-list-wrapper .mat-standard-chip{margin:4px}.mat-chip-list-stacked .mat-chip-list-wrapper{flex-direction:column;align-items:flex-start}.mat-chip-list-stacked .mat-chip-list-wrapper .mat-standard-chip{width:100%}.mat-chip-avatar{border-radius:50%;justify-content:center;align-items:center;display:flex;overflow:hidden;object-fit:cover}input.mat-chip-input{width:150px;margin:4px;flex:1 0 150px}'],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })(),
      qfe = 0,
      wx = (() => {
        class n {
          constructor(e, a) {
            this._elementRef = e, this._defaultOptions = a, this.focused = !1, this._addOnBlur = !1, this.separatorKeyCodes = this._defaultOptions.separatorKeyCodes, this.chipEnd = new E(), this.placeholder = "", this.id = "mat-chip-list-input-" + qfe++, this._disabled = !1, this.inputElement = this._elementRef.nativeElement;
          }
          set chipList(e) {
            e && (this._chipList = e, this._chipList.registerInput(this));
          }
          get addOnBlur() {
            return this._addOnBlur;
          }
          set addOnBlur(e) {
            this._addOnBlur = Y(e);
          }
          get disabled() {
            return this._disabled || this._chipList && this._chipList.disabled;
          }
          set disabled(e) {
            this._disabled = Y(e);
          }
          get empty() {
            return !this.inputElement.value;
          }
          ngOnChanges() {
            this._chipList.stateChanges.next();
          }
          ngOnDestroy() {
            this.chipEnd.complete();
          }
          ngAfterContentInit() {
            this._focusLastChipOnBackspace = this.empty;
          }
          _keydown(e) {
            if (e) {
              if (9 === e.keyCode && !Et(e, "shiftKey") && this._chipList._allowFocusEscape(), 8 === e.keyCode && this._focusLastChipOnBackspace) return this._chipList._keyManager.setLastItemActive(), void e.preventDefault();
              this._focusLastChipOnBackspace = !1;
            }
            this._emitChipEnd(e);
          }
          _keyup(e) {
            !this._focusLastChipOnBackspace && 8 === e.keyCode && this.empty && (this._focusLastChipOnBackspace = !0, e.preventDefault());
          }
          _blur() {
            this.addOnBlur && this._emitChipEnd(), this.focused = !1, this._chipList.focused || this._chipList._blur(), this._chipList.stateChanges.next();
          }
          _focus() {
            this.focused = !0, this._focusLastChipOnBackspace = this.empty, this._chipList.stateChanges.next();
          }
          _emitChipEnd(e) {
            !this.inputElement.value && !!e && this._chipList._keydown(e), (!e || this._isSeparatorKey(e)) && (this.chipEnd.emit({
              input: this.inputElement,
              value: this.inputElement.value,
              chipInput: this
            }), e?.preventDefault());
          }
          _onInput() {
            this._chipList.stateChanges.next();
          }
          focus(e) {
            this.inputElement.focus(e);
          }
          clear() {
            this.inputElement.value = "", this._focusLastChipOnBackspace = !0;
          }
          _isSeparatorKey(e) {
            return !Et(e) && new Set(this.separatorKeyCodes).has(e.keyCode);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(Mx));
        }, n.ɵdir = P({
          type: n,
          selectors: [["input", "matChipInputFor", ""]],
          hostAttrs: [1, "mat-chip-input", "mat-input-element"],
          hostVars: 5,
          hostBindings: function (e, a) {
            1 & e && F("keydown", function (o) {
              return a._keydown(o);
            })("keyup", function (o) {
              return a._keyup(o);
            })("blur", function () {
              return a._blur();
            })("focus", function () {
              return a._focus();
            })("input", function () {
              return a._onInput();
            }), 2 & e && (Zn("id", a.id), X("disabled", a.disabled || null)("placeholder", a.placeholder || null)("aria-invalid", a._chipList && a._chipList.ngControl ? a._chipList.ngControl.invalid : null)("aria-required", a._chipList && a._chipList.required || null));
          },
          inputs: {
            chipList: ["matChipInputFor", "chipList"],
            addOnBlur: ["matChipInputAddOnBlur", "addOnBlur"],
            separatorKeyCodes: ["matChipInputSeparatorKeyCodes", "separatorKeyCodes"],
            placeholder: "placeholder",
            id: "id",
            disabled: "disabled"
          },
          outputs: {
            chipEnd: "matChipInputTokenEnd"
          },
          exportAs: ["matChipInput", "matChipInputFor"],
          features: [Ve]
        }), n;
      })(),
      kx = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [ls, {
            provide: Mx,
            useValue: {
              separatorKeyCodes: [13]
            }
          }],
          imports: [$]
        }), n;
      })();
    const Kfe = ["autocompleteInput"],
      Qfe = ["chipList"];
    function Zfe(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "mat-chip", 10), F("changed", function (i) {
          return pe(e), ge(x().add(i));
        })("removed", function () {
          const o = pe(e).index;
          return ge(x().remove(o));
        }), _(1, "span"), S(2), y(), _(3, "mat-icon", 11), S(4, "cancel"), y()();
      }
      if (2 & n) {
        const e = t.$implicit,
          a = x();
        b("selectable", a.selectable)("removable", a.removable), g(2), Ie(e.value);
      }
    }
    function Xfe(n, t) {
      1 & n && (_(0, "mat-option", 12), j(1, "mat-spinner", 13), y());
    }
    function Jfe(n, t) {
      if (1 & n && (_(0, "mat-option", 14), S(1), y()), 2 & n) {
        const e = t.$implicit;
        b("value", e), g(1), Fe(" ", e.prefLabel, " ");
      }
    }
    let m0 = /*#__PURE__*/(() => {
      class m0 {
        fb;
        allPosts;
        selectable = !0;
        removable = !0;
        isLoading = !1;
        search;
        mode;
        group;
        autocompleteResults;
        valueConstraints;
        selectedOption = new E();
        removedOption = new E();
        autocomplete = new E();
        autocompleteInput;
        chipList;
        constructor(t) {
          this.fb = t;
        }
        filterItems(t, e) {
          return t.filter(function (a) {
            return -1 !== a.prefLabel.toLowerCase().indexOf(e.toLowerCase().toLowerCase());
          });
        }
        ngOnChanges(t) {
          if (t.autocompleteResults && this.group && this.search) {
            let e = t.autocompleteResults.currentValue;
            e = this.filterItems(e, this.search), e = e.sort((a, i) => a.prefLabel.toLowerCase() < i.prefLabel.toLowerCase() ? -1 : a.prefLabel.toLowerCase() > i.prefLabel.toLowerCase() ? 1 : 0), this.isLoading = !1, this.allPosts = e;
          }
        }
        ngOnInit() {
          this.removable = "edit" === this.mode, this.selectable = "edit" === this.mode, this.group.controls.values.controls[0].get("search").valueChanges.pipe(b2(500)).subscribe(t => {
            this.search = t, this.autocomplete.emit({
              search: t,
              constraints: this.valueConstraints
            }), this.isLoading = !0;
          });
        }
        displayFn(t) {
          if (t) return t.prefLabel;
        }
        add(t) {
          const e = t.input,
            a = t.value;
          (a || "").trim() && this.group.controls.values.controls[0].get("chips").push(this.fb.control(a.trim())), e && (e.value = "");
        }
        changed(t) {}
        remove(t) {
          if (this.removable) {
            const e = this.group.controls.values.controls[0].get("chips"),
              a = this.group.controls.values.controls[0].get("ids");
            t >= 0 && (e.removeAt(t), a.removeAt(t)), this.removedOption.emit(t);
          }
        }
        selected(t, e, a) {
          this.autocompleteInput.nativeElement.value = "", this.autocompleteInput.nativeElement.focus(), this.group.controls.values.controls[0].get("chips").push(this.fb.control(a.trim())), this.group.controls.values.controls[0].get("ids").push(this.fb.control(e.toString().trim())), this.selectedOption.emit(t.option.value), this.group.controls.values.controls[0].get("search").setValue("");
        }
        filterCategoryList(t) {
          return "string" != typeof t || "" === t || null === t ? [] : t ? this.allPosts.filter(a => -1 !== a.title.toLowerCase().indexOf(t.toLowerCase())) : this.allPosts;
        }
        focusOnPlaceInput() {
          this.autocompleteInput.nativeElement.focus(), this.autocompleteInput.nativeElement.value = "";
        }
        static ɵfac = function (e) {
          return new (e || m0)(f(tp));
        };
        static ɵcmp = q({
          type: m0,
          selectors: [["app-controlled"]],
          viewQuery: function (e, a) {
            if (1 & e && (be(Kfe, 7), be(Qfe, 7)), 2 & e) {
              let i;
              H(i = B()) && (a.autocompleteInput = i.first), H(i = B()) && (a.chipList = i.first);
            }
          },
          inputs: {
            mode: "mode",
            group: "group",
            autocompleteResults: "autocompleteResults",
            valueConstraints: "valueConstraints"
          },
          outputs: {
            selectedOption: "selectedOption",
            removedOption: "removedOption",
            autocomplete: "autocomplete"
          },
          features: [Ve],
          decls: 11,
          vars: 8,
          consts: [[1, "full-width"], [3, "disabled"], ["chipList", ""], ["class", "chip", 3, "selectable", "removable", "changed", "removed", 4, "ngFor", "ngForOf"], ["type", "text", "aria-label", "Number", "matInput", "", 3, "formControl", "matAutocomplete", "matChipInputFor"], ["autocompleteInput", ""], [3, "displayWith", "changed", "optionSelected"], ["auto", "matAutocomplete"], ["class", "is-loading", 4, "ngIf"], [3, "value", 4, "ngFor", "ngForOf"], [1, "chip", 3, "selectable", "removable", "changed", "removed"], ["matChipRemove", ""], [1, "is-loading"], ["diameter", "20"], [3, "value"]],
          template: function (e, a) {
            if (1 & e && (_(0, "mat-form-field", 0)(1, "mat-chip-list", 1, 2), D(3, Zfe, 5, 3, "mat-chip", 3), j(4, "input", 4, 5), _(6, "mat-autocomplete", 6, 7), F("changed", function (o) {
              return a.changed(o);
            })("optionSelected", function (o) {
              return a.selected(o, a.group.controls.values.controls[0].get("search").value["@id"], a.group.controls.values.controls[0].get("search").value.prefLabel);
            }), D(8, Xfe, 2, 0, "mat-option", 8), fi(9), D(10, Jfe, 2, 2, "mat-option", 9), mi(), y()()()), 2 & e) {
              const i = Kt(2),
                o = Kt(7);
              g(1), b("disabled", "view" === a.mode), g(2), b("ngForOf", a.group.controls.values.controls[0].get("chips").controls), g(1), b("formControl", a.group.controls.values.controls[0].get("search"))("matAutocomplete", o)("matChipInputFor", i), g(2), b("displayWith", a.displayFn), g(2), b("ngIf", a.isLoading), g(2), b("ngForOf", a.allPosts);
            }
          },
          dependencies: [ea, mt, Rfe, gx, Ho, Si, yi, oa, Pa, yl, ao, xx, f0, wx, Cx],
          styles: [".full-width[_ngcontent-%COMP%]{width:100%}.chip[_ngcontent-%COMP%]{margin-top:.4em}.mat-chip.mat-standard-chip.mat-chip-disabled[_ngcontent-%COMP%]{opacity:1}"]
        });
      }
      return m0;
    })();
    const $fe = function (n) {
      return {
        "max-width.px": n
      };
    };
    function eme(n, t) {
      if (1 & n && (_(0, "figure", 1), j(1, "img", 2), _(2, "figcaption", 3)(3, "label"), S(4), y()()()), 2 & n) {
        const e = x();
        b("ngStyle", Vr(5, $fe, e.getImageWidth(e.node))), g(1), zn("src", e.node.staticValue, Hu), zn("width", e.getImageWidth(e.node)), zn("alt", e.node.name), g(3), Ie(e.node.name);
      }
    }
    let h0 = /*#__PURE__*/(() => {
      class h0 {
        formGroup;
        node;
        constructor() {}
        ngOnInit() {}
        getImageWidth(t) {
          let e = 367;
          return t.size && t.size.width && Number.isInteger(t.size.width) && (e = t.size.width), e;
        }
        getImageHeight(t) {
          if (t.size && t.size.height && Number.isInteger(t.size.height)) return t.size.height;
        }
        static ɵfac = function (e) {
          return new (e || h0)();
        };
        static ɵcmp = q({
          type: h0,
          selectors: [["app-image"]],
          inputs: {
            formGroup: "formGroup",
            node: "node"
          },
          decls: 1,
          vars: 1,
          consts: [["class", "static-image", 3, "ngStyle", 4, "ngIf"], [1, "static-image", 3, "ngStyle"], [1, "image", 3, "src", "width", "alt"], [1, "caption"]],
          template: function (e, a) {
            1 & e && D(0, eme, 5, 7, "figure", 0), 2 & e && b("ngIf", "image" == a.node.subtype);
          },
          dependencies: [mt, fd],
          styles: [".static-image[_ngcontent-%COMP%]{margin:20px 0;width:auto;display:flex;flex-direction:column}.static-image[_ngcontent-%COMP%]   .caption[_ngcontent-%COMP%]{padding:10px;font-style:italic;text-align:center}"]
        });
      }
      return h0;
    })();
    function tme(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "button", 6), F("click", function () {
          pe(e);
          const i = x().index,
            o = x();
          return ge(o.copy(o.node, i));
        }), _(1, "mat-icon", 7), S(2, " file_copy "), y()();
      }
    }
    function nme(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "button", 6), F("click", function () {
          pe(e);
          const i = x().index,
            o = x();
          return ge(o.remove(o.node, i));
        }), _(1, "mat-icon", 8), S(2, " delete_forever "), y()();
      }
    }
    function ame(n, t) {
      if (1 & n && (_(0, "div")(1, "div", 1)(2, "div", 2)(3, "mat-form-field", 3), j(4, "input", 4), _(5, "mat-hint"), S(6, "Name"), y()()(), _(7, "div", 3)(8, "mat-form-field", 3)(9, "div", 1), j(10, "input", 4), _(11, "div"), D(12, tme, 3, 0, "button", 5), y(), _(13, "div"), D(14, nme, 3, 0, "button", 5), y()(), _(15, "mat-hint"), S(16, "Value"), y()()()()()), 2 & n) {
        const e = t.$implicit,
          a = x();
        g(4), b("formControl", e.controls.values.controls[0])("type", a.node.type), g(6), b("formControl", e.controls.values.controls[1])("type", a.node.type), g(2), b("ngIf", !a.disabled), g(2), b("ngIf", !a.disabled && a.removeable(a.node));
      }
    }
    let p0 = /*#__PURE__*/(() => {
      class p0 {
        fb;
        formGroup;
        node;
        disabled;
        changed = new E();
        constructor(t) {
          this.fb = t;
        }
        ngOnInit() {
          this.formGroup.get("values").setValue(this.getValue(this.node), this.node), this.watchChanges();
        }
        watchChanges() {
          this.formGroup.get("values").valueChanges.subscribe(t => {
            this.setValue(t, this.node), this.changed.emit({
              type: this.node.type,
              subtype: this.node.subtype,
              model: this.node.model,
              key: this.node.key,
              index: 0,
              location: this.node.valueLocation,
              value: t
            });
          });
        }
        setAttributeValue(t, e, a, i, o) {
          const r = t[e][a];
          if (r) {
            if ("value" === i) t[r]["@value"] = o;else {
              const s = t[r]["@value"],
                c = t[e].indexOf(r);
              delete t[r], t["@context"][o] = t["@context"][r], delete t["@context"][r], t[e][c] = o, t[o] = {
                "@value": s
              };
            }
          } else {
            let s = o;
            for (; Object.hasOwn(t, s);) s += "1";
            t["@context"][s] = "https://schema.metadatacenter.org/properties/" + ee.generateGUID(), t[e] = [s], t[s] = {
              "@value": o
            };
          }
        }
        setValue(t, e) {
          t.forEach((a, i) => {
            this.setAttributeValue(e.model, e.key, i, "label", a.values[0]), this.setAttributeValue(e.model, e.key, i, "value", a.values[1]);
          });
        }
        getValue(t) {
          const e = [];
          if (t.model[t.key]) {
            const a = t.model[t.key].length,
              i = t.model && t.model[t.key] ? t.model[t.key] : [];
            if (0 === a) e.push({
              values: [null, null]
            });else for (let o = 0; o < a; o++) {
              const r = i[o];
              e.push({
                values: [r, t.model[r]["@value"]]
              });
            }
          } else e.push({
            values: [null, null]
          });
          return e;
        }
        buildAV(t, e) {
          const a = [];
          return t.model[t.key].forEach(i => {
            const o = [];
            o.push(new at({
              value: "",
              disabled: e
            })), o.push(new at({
              value: "",
              disabled: e
            }));
            const r = this.fb.group({
              values: this.fb.array(o)
            });
            a.push(r);
          }), a;
        }
        copyAttributeValue(t, e, a) {
          const i = t[e][a],
            o = t[i]["@value"];
          let r = i;
          for (; Object.hasOwn(t, r);) r += "1";
          t["@context"][r] = "https://schema.metadatacenter.org/properties/" + ee.generateGUID(), t[e].splice(a + 1, 0, r), t[r] = {
            "@value": o
          };
        }
        copy(t, e) {
          this.copyAttributeValue(t.model, t.key, e), this.formGroup.setControl("values", this.fb.array(this.buildAV(this.node, this.disabled))), this.formGroup.get("values").setValue(this.getValue(this.node)), this.formGroup.updateValueAndValidity({
            onlySelf: !1,
            emitEvent: !0
          }), this.watchChanges();
        }
        removeAttributeValue(t, e, a) {
          const i = t[e][a];
          delete t["@context"][i], t[e].splice(a, 1), delete t[i];
        }
        removeable(t) {
          return t.model[t.key].length > 1;
        }
        remove(t, e) {
          t.model[t.key].length > 1 && (this.removeAttributeValue(t.model, t.key, e), this.formGroup.setControl("values", this.fb.array(this.buildAV(this.node, this.disabled))), this.formGroup.get("values").setValue(this.getValue(this.node)), this.formGroup.updateValueAndValidity({
            onlySelf: !1,
            emitEvent: !0
          }));
        }
        static ɵfac = function (e) {
          return new (e || p0)(f(tp));
        };
        static ɵcmp = q({
          type: p0,
          selectors: [["app-attribute-value"]],
          inputs: {
            formGroup: "formGroup",
            node: "node",
            disabled: "disabled"
          },
          outputs: {
            changed: "changed"
          },
          decls: 1,
          vars: 1,
          consts: [[4, "ngFor", "ngForOf"], [2, "display", "flex"], [1, "example-full-width", "mat-form-field", 2, "padding-right", "10px"], [1, "example-full-width", "mat-form-field"], ["matInput", "", 3, "formControl", "type"], ["mat-icon-button", "", "add-remove-icons", "", 3, "click", 4, "ngIf"], ["mat-icon-button", "", "add-remove-icons", "", 3, "click"], ["aria-label", "Add attribute value"], ["aria-label", "Remove attribute value"]],
          template: function (e, a) {
            1 & e && D(0, ame, 17, 6, "div", 0), 2 & e && b("ngForOf", a.formGroup.controls.values.controls);
          },
          dependencies: [ea, mt, Si, Cs, yi, oa, Pa, yl, ao, Pi],
          styles: [".mat-form-field[_ngcontent-%COMP%]{margin-bottom:10px;width:100%}.mat-form-field-checkbox[_ngcontent-%COMP%]{padding:15px 0 20px}[_nghost-%COMP%]     .mat-icon-button{padding:0;height:.8em;width:1em;line-height:1em;margin-right:.5em}[_nghost-%COMP%]     .mat-icon{font-size:1em;width:1em;padding:0;position:absolute;top:-.5em;left:0;height:1em;color:#0000008a}"]
        });
      }
      return p0;
    })();
    const ime = ["tooltip"];
    function ome(n, t) {
      if (1 & n && j(0, "app-youtube", 3), 2 & n) {
        const e = x(2);
        b("formGroup", e.formGroup)("node", e.node);
      }
    }
    function rme(n, t) {
      if (1 & n && j(0, "app-image", 3), 2 & n) {
        const e = x(2);
        b("formGroup", e.formGroup)("node", e.node);
      }
    }
    function sme(n, t) {
      if (1 & n && j(0, "app-richtext", 3), 2 & n) {
        const e = x(2);
        b("formGroup", e.formGroup)("node", e.node);
      }
    }
    function cme(n, t) {
      if (1 & n && j(0, "app-section", 3), 2 & n) {
        const e = x(2);
        b("formGroup", e.formGroup)("node", e.node);
      }
    }
    function lme(n, t) {
      if (1 & n && (fi(0), D(1, ome, 1, 2, "app-youtube", 2), D(2, rme, 1, 2, "app-image", 2), D(3, sme, 1, 2, "app-richtext", 2), D(4, cme, 1, 2, "app-section", 2), mi()), 2 & n) {
        const e = x();
        g(1), b("ngIf", "youtube" == e.node.subtype), g(1), b("ngIf", "image" == e.node.subtype), g(1), b("ngIf", "richtext" == e.node.subtype), g(1), b("ngIf", "section-break" == e.node.subtype);
      }
    }
    function dme(n, t) {
      if (1 & n && (_(0, "span", 11), j(1, "fa-icon", 12), y()), 2 & n) {
        const e = x(2);
        g(1), b("icon", e.faAsterisk);
      }
    }
    function ume(n, t) {
      if (1 & n && (_(0, "span", 13), j(1, "fa-icon", 12), y()), 2 & n) {
        const e = x(3);
        g(1), b("icon", e.faEnvelope);
      }
    }
    function fme(n, t) {
      if (1 & n && (_(0, "span", 13), j(1, "fa-icon", 12), y()), 2 & n) {
        const e = x(3);
        g(1), b("icon", e.faHashtag);
      }
    }
    function mme(n, t) {
      if (1 & n && (_(0, "span", 13), j(1, "fa-icon", 12), y()), 2 & n) {
        const e = x(3);
        g(1), b("icon", e.faLink);
      }
    }
    function hme(n, t) {
      if (1 & n && (_(0, "span", 13), j(1, "fa-icon", 12), y()), 2 & n) {
        const e = x(3);
        g(1), b("icon", e.faFont);
      }
    }
    function pme(n, t) {
      if (1 & n && (_(0, "span", 13), j(1, "fa-icon", 12), y()), 2 & n) {
        const e = x(3);
        g(1), b("icon", e.faPhoneSquare);
      }
    }
    function gme(n, t) {
      if (1 & n && (_(0, "span"), D(1, ume, 2, 1, "span", 8), D(2, fme, 2, 1, "span", 8), D(3, mme, 2, 1, "span", 8), D(4, hme, 2, 1, "span", 8), D(5, pme, 2, 1, "span", 8), y()), 2 & n) {
        const e = x(2);
        g(1), b("ngIf", "email" == e.node.subtype), g(1), b("ngIf", "number" == e.node.subtype), g(1), b("ngIf", "url" == e.node.subtype), g(1), b("ngIf", "text" == e.node.subtype), g(1), b("ngIf", "tel" == e.node.subtype);
      }
    }
    function bme(n, t) {
      if (1 & n && (_(0, "span", 13), j(1, "fa-icon", 12), y()), 2 & n) {
        const e = x(2);
        g(1), b("icon", e.faCalendar);
      }
    }
    function _me(n, t) {
      if (1 & n && (_(0, "span", 13), j(1, "fa-icon", 12), y()), 2 & n) {
        const e = x(2);
        g(1), b("icon", e.faParagraph);
      }
    }
    function vme(n, t) {
      if (1 & n && (_(0, "span", 13), j(1, "fa-icon", 12), y()), 2 & n) {
        const e = x(2);
        g(1), b("icon", e.faCheckSquare);
      }
    }
    function yme(n, t) {
      if (1 & n && (_(0, "span", 13), j(1, "fa-icon", 12), y()), 2 & n) {
        const e = x(2);
        g(1), b("icon", e.faList);
      }
    }
    function Cme(n, t) {
      if (1 & n && (_(0, "span", 13), j(1, "fa-icon", 12), y()), 2 & n) {
        const e = x(2);
        g(1), b("icon", e.faDotCircle);
      }
    }
    function Mme(n, t) {
      if (1 & n && (_(0, "span", 13), j(1, "fa-icon", 12), y()), 2 & n) {
        const e = x(2);
        g(1), b("icon", e.faJsonLD);
      }
    }
    function xme(n, t) {
      if (1 & n && (_(0, "span", 13), j(1, "fa-icon", 12), y()), 2 & n) {
        const e = x(2);
        g(1), b("icon", e.faPlusSquare);
      }
    }
    function wme(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "button", 14, 15), F("click", function () {
          pe(e);
          const i = x(2);
          return ge(i.openControlledSource(i.node));
        }), _(2, "mat-icon"), S(3, "open_in_new"), y()();
      }
      2 & n && b("matTooltipClass", "tooltip")("matTooltip", "View constraint details");
    }
    function kme(n, t) {
      if (1 & n && (_(0, "button", 16, 15)(2, "mat-icon"), S(3, "info_outline"), y()()), 2 & n) {
        const e = x(2);
        b("matTooltipClass", "tooltip")("matTooltip", e.getValueConstraints());
      }
    }
    function Dme(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "app-attribute-value", 20), F("changed", function (i) {
          return pe(e), ge(x(3).onChange(i));
        }), y();
      }
      if (2 & n) {
        const e = x(3);
        b("formGroup", e.formGroup)("node", e.node);
      }
    }
    function Ome(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "app-list", 21), F("changed", function (i) {
          return pe(e), ge(x(3).onChange(i));
        }), y();
      }
      if (2 & n) {
        const e = x(3);
        b("formGroup", e.formGroup)("node", e.node)("mode", e.mode);
      }
    }
    function Pme(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "app-controlled", 22), F("autocomplete", function (i) {
          return pe(e), ge(x(3).onAutocomplete(i));
        })("removedOption", function (i) {
          return pe(e), ge(x(3).onRemovedControlled(i));
        })("selectedOption", function (i) {
          return pe(e), ge(x(3).onSelectedControlled(i));
        }), y();
      }
      if (2 & n) {
        const e = x(3);
        b("group", e.formGroup)("mode", e.mode)("valueConstraints", e.node.valueConstraints)("autocompleteResults", e.autocompleteResults);
      }
    }
    function Ame(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "app-checkbox", 21), F("changed", function (i) {
          return pe(e), ge(x(3).onChange(i));
        }), y();
      }
      if (2 & n) {
        const e = x(3);
        b("formGroup", e.formGroup)("node", e.node)("mode", e.mode);
      }
    }
    function Sme(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "app-radio", 20), F("changed", function (i) {
          return pe(e), ge(x(3).onChange(i));
        }), y();
      }
      if (2 & n) {
        const e = x(3);
        b("formGroup", e.formGroup)("node", e.node);
      }
    }
    function Eme(n, t) {
      if (1 & n && (_(0, "div"), D(1, Dme, 1, 2, "app-attribute-value", 17), D(2, Ome, 1, 3, "app-list", 18), D(3, Pme, 1, 4, "app-controlled", 19), D(4, Ame, 1, 3, "app-checkbox", 18), D(5, Sme, 1, 2, "app-radio", 17), y()), 2 & n) {
        const e = x(2);
        g(1), b("ngIf", "attribute-value" == e.node.type), g(1), b("ngIf", "list" == e.node.type), g(1), b("ngIf", "controlled" == e.node.type), g(1), b("ngIf", "checkbox" == e.node.type), g(1), b("ngIf", "radio" == e.node.type);
      }
    }
    function Tme(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "button", 31), F("click", function () {
          pe(e);
          const i = x(2).index,
            o = x(3);
          return ge(o.copyItem(o.node, i));
        }), _(1, "mat-icon"), S(2, "add_circle_outline"), y()();
      }
    }
    function Ime(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "button", 32), F("click", function () {
          pe(e);
          const i = x(2).index,
            o = x(3);
          return ge(o.removeItem(o.node, i));
        }), _(1, "mat-icon"), S(2, "remove_circle_outline"), y()();
      }
    }
    function Rme(n, t) {
      if (1 & n && (_(0, "div", 28), S(1), D(2, Tme, 3, 0, "button", 29), D(3, Ime, 3, 0, "button", 30), y()), 2 & n) {
        const e = x().index,
          a = x(3);
        g(1), Kf(" ", a.node.name, " (", e + 1, " of ", a.node.maxItems || "N", ") "), g(1), b("ngIf", "edit" === a.mode), g(1), b("ngIf", "edit" === a.mode);
      }
    }
    function zme(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "app-textfield", 33), F("changed", function (i) {
          return pe(e), ge(x(4).onChange(i));
        }), y();
      }
      if (2 & n) {
        const e = x(),
          a = e.$implicit,
          i = e.index,
          o = x(3);
        b("formGroup", o.formGroup)("control", a)("node", o.node)("mode", o.mode)("index", i);
      }
    }
    function Lme(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "app-textarea", 34), F("changed", function (i) {
          return pe(e), ge(x(4).onChange(i));
        }), y();
      }
      if (2 & n) {
        const e = x(),
          a = e.$implicit,
          i = e.index,
          o = x(3);
        b("formGroup", o.formGroup)("control", a)("node", o.node)("index", i);
      }
    }
    function Nme(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "app-date", 34), F("changed", function (i) {
          return pe(e), ge(x(4).onChange(i));
        }), y();
      }
      if (2 & n) {
        const e = x(),
          a = e.$implicit,
          i = e.index,
          o = x(3);
        b("formGroup", o.formGroup)("control", a)("node", o.node)("index", i);
      }
    }
    function Fme(n, t) {
      if (1 & n && (_(0, "div"), D(1, Rme, 4, 5, "div", 25), D(2, zme, 1, 5, "app-textfield", 26), D(3, Lme, 1, 4, "app-textarea", 27), D(4, Nme, 1, 4, "app-date", 27), y()), 2 & n) {
        const e = x(3);
        g(1), b("ngIf", e.node.multiSelect), g(1), b("ngSwitchCase", "textfield"), g(1), b("ngSwitchCase", "textarea"), g(1), b("ngSwitchCase", "temporal");
      }
    }
    function Vme(n, t) {
      if (1 & n && (_(0, "div")(1, "div", 23), D(2, Fme, 5, 4, "div", 24), y()()), 2 & n) {
        const e = x(2);
        g(1), b("ngSwitch", e.node.type), g(1), b("ngForOf", e.formGroup.controls.values.controls);
      }
    }
    function Hme(n, t) {
      if (1 & n && (_(0, "div", 4)(1, "label", 5), S(2), y(), D(3, dme, 2, 1, "span", 6), D(4, gme, 6, 5, "span", 7), D(5, bme, 2, 1, "span", 8), D(6, _me, 2, 1, "span", 8), D(7, vme, 2, 1, "span", 8), D(8, yme, 2, 1, "span", 8), D(9, Cme, 2, 1, "span", 8), D(10, Mme, 2, 1, "span", 8), D(11, xme, 2, 1, "span", 8), D(12, wme, 4, 2, "button", 9), D(13, kme, 4, 2, "button", 10), _(14, "div"), S(15), y(), D(16, Eme, 6, 5, "div", 7), D(17, Vme, 3, 2, "div", 7), y()), 2 & n) {
        const e = x();
        b("formGroup", e.formGroup), g(1), X("for", e.node.name), g(1), Fe(" ", e.node.name, " "), g(1), b("ngIf", e.node.required), g(1), b("ngIf", "textfield" == e.node.type), g(1), b("ngIf", "temporal" == e.node.type), g(1), b("ngIf", "textarea" == e.node.type), g(1), b("ngIf", "checkbox" == e.node.type), g(1), b("ngIf", "list" == e.node.type), g(1), b("ngIf", "radio" == e.node.type), g(1), b("ngIf", "controlled" == e.node.type), g(1), b("ngIf", "attribute-value" == e.node.type), g(1), b("ngIf", "controlled" == e.node.type), g(1), b("ngIf", e.getValueConstraints().length), g(2), Ie(e.node.help), g(1), b("ngIf", "attribute-value" == e.node.type || "list" == e.node.type || "controlled" == e.node.type || "checkbox" == e.node.type || "radio" == e.node.type), g(1), b("ngIf", e.node.type && e.allowsMultiple(e.node.type));
      }
    }
    p4.add(fM);
    let wl = /*#__PURE__*/(() => {
      class wl {
        fb;
        tooltip;
        node;
        parentGroup;
        autocompleteResults;
        mode;
        changed = new E();
        autocomplete = new E();
        faAsterisk = aC;
        faEnvelope = sC;
        faHashtag = lC;
        faLink = dC;
        faFont = cC;
        faCalendar = iC;
        faPhoneSquare = mC;
        faParagraph = fC;
        faCheckSquare = oC;
        faList = uC;
        faDotCircle = rC;
        faPlusSquare = hC;
        faJsonLD = fM;
        formGroup;
        showDelay = {
          value: 0
        };
        hideDelay = {
          value: 0
        };
        offScreen = "position:absolute;top:-1000px;left:-1000px";
        constructor(t) {
          this.fb = t;
        }
        onAutocomplete(t) {
          this.autocomplete.emit(t);
        }
        getValueConstraints() {
          let t = "";
          return this.node.valueConstraints && Object.keys(this.node.valueConstraints).forEach(e => {
            const a = this.node.valueConstraints[e];
            if (Array.isArray(a)) for (let i = 0; i < this.node.valueConstraints[e].length; i++) switch (e) {
              case "ontologies":
                t += " " + a[i].acronym + " Ontology\n";
                break;
              case "valueSets":
                t += '"' + a[i].name + " " + a[i].vsCollection + '" Value Set\n';
                break;
              case "classes":
                t += '"' + a[i].prefLabel + '" class of ' + a[i].source + "\n";
                break;
              case "branches":
                t += '"' + a[i].name + '" branch of ' + a[i].acronym + "\n";
                break;
              case "actions":
                "delete" === a[i].action && (t += '"' + a[i].termUri + '" excluded from ' + a[i].sourceUri + "\n");
            } else switch (e) {
              case "numberType":
                t += "Number Type: " + a + ", ";
                break;
              case "unitOfMeasure":
                t += "Unit of Measure: " + a + ", ";
                break;
              case "minValue":
                t += "Min Value: " + a + ", ";
                break;
              case "maxValue":
                t += "Max Value: " + a + ", ";
                break;
              case "decimalPlace":
                t += "Decimal Places: " + a + ", ";
                break;
              case "defaultValue":
                t += "Default Value: " + a + ", ";
                break;
              case "minLength":
                t += "Min Length: " + a + ", ";
                break;
              case "maxLength":
                t += "Max Length: " + a + ", ";
            }
          }), t.trim().replace(/(^,)|(,$)/g, "");
        }
        onChange(t) {
          this.changed.emit({
            type: t.type,
            subtype: t.subtype,
            model: t.model,
            key: t.key,
            index: t.index,
            location: t.valueLocation,
            value: t.value
          });
        }
        mouseover() {}
        mouseout() {}
        ngOnChanges(t) {
          t.autocompleteResults && (this.autocompleteResults = t.autocompleteResults.currentValue);
        }
        ngOnInit() {
          this.autocompleteResults = [];
          const t = eo.getValidators(this.node);
          let e, a;
          switch (this.node.type) {
            case A.static:
            case A.youTube:
            case A.image:
            case A.sectionBreak:
            case A.pageBreak:
            case A.richText:
              this.formGroup = this.fb.group({
                values: this.fb.array([])
              });
              break;
            case A.controlled:
              this.formGroup = this.fb.group({
                values: this.fb.array(this.buildControlled(this.node, !1))
              }), this.parentGroup.setControl(this.node.key, this.formGroup), this.setDisable(this.formGroup, "view" === this.mode);
              break;
            case A.temporal:
            case A.textfield:
            case A.textarea:
              this.formGroup = this.fb.group({
                values: this.fb.array(this.allowMultipleControls(this.node, !1, t))
              }), this.parentGroup.setControl(this.node.key, this.formGroup), this.setDisable(this.formGroup, "view" === this.mode);
              break;
            case A.radio:
              e = this.node.key + "radio", a = {}, a[e] = new at(this.fb.array([])), this.formGroup = this.fb.group(a), this.parentGroup.setControl(this.node.key, this.formGroup), this.setDisable(this.formGroup, "view" === this.mode);
              break;
            case A.checkbox:
              this.formGroup = this.fb.group({
                values: this.fb.array(this.allowMultipleOptions(this.node, !1))
              }), this.parentGroup.setControl(this.node.key, this.formGroup), this.setDisable(this.formGroup, "view" === this.mode);
              break;
            case A.list:
              e = this.node.key + "list", a = {}, a[e] = new at(this.fb.array([])), this.formGroup = this.fb.group(a), this.parentGroup.setControl(this.node.key, this.formGroup);
              break;
            case A.attributeValue:
              this.formGroup = this.fb.group({
                values: this.fb.array(this.buildAV(this.node, !1))
              }), this.parentGroup.setControl(this.node.key, this.formGroup), this.setDisable(this.formGroup, "view" === this.mode);
          }
        }
        setDisable(t, e) {
          e && t.disable();
        }
        onSelectedControlled(t) {
          xi.addControlledValue(this.node.model, this.node.key, t["@id"], t.prefLabel);
        }
        onRemovedControlled(t) {
          xi.removeControlledValue(this.node.model, this.node.key, t);
        }
        allowsMultiple(t) {
          return t !== A.element && pn.allowsMultiple(t);
        }
        get isValid() {
          let t = !1;
          return this.parentGroup && Object.hasOwn(this.parentGroup.controls, this.node.key) && (t = this.parentGroup.controls[this.node.key].valid), t;
        }
        isChecked(t, e) {
          let a = !1;
          return t.model[t.key].forEach((i, o) => {
            i[t.valueLocation] === e && (a = !0);
          }), a;
        }
        copyItem(t, e) {
          const a = eo.getValidators(this.node);
          let i;
          switch (this.node.type) {
            case A.controlled:
              i = Object.assign({}, t.model[t.key][e]), this.node.model[t.key].splice(e, 0, t.model[t.key][e]), this.formGroup.setControl("values", this.fb.array(this.buildControlled(t, !1)));
              break;
            case A.textfield:
            case A.textarea:
            case A.temporal:
              t.model ? Array.isArray(t.model[t.key]) ? (i = Object.assign({}, t.model[t.key][e]), this.node.model[t.key].splice(e, 0, i)) : (i = Object.assign({}, t.model[t.key]), this.node.model[t.key] = [i, i]) : this.node.model[t.key] = [null, null], this.formGroup.setControl("values", this.fb.array(this.allowMultipleControls(t, !1, a)));
          }
        }
        removeItem(t, e) {
          const a = eo.getValidators(this.node);
          switch (t.type) {
            case A.controlled:
              t.model[t.key].splice(e, 1), this.formGroup.setControl("values", this.fb.array(this.buildControlled(t, !1)));
              break;
            case A.textfield:
            case A.textarea:
            case A.temporal:
              t.model[this.node.key].splice(e, 1), this.formGroup.setControl("values", this.fb.array(this.allowMultipleControls(t, !1, a)));
          }
        }
        loadForm(t, e) {}
        allowMultipleOptions(t, e) {
          return t.options.map(i => this.fb.control({
            value: !1,
            disabled: e
          }));
        }
        getLength(t) {
          return Array.isArray(t) ? t.length : 1;
        }
        allowMultipleControls(t, e, a) {
          const i = [];
          if (t.model && t.model[t.key]) for (let o = 0; o < this.getLength(t.model[t.key]); o++) i.push(new at({
            value: null,
            disabled: e,
            validators: a
          }));else i.push(new at({
            value: null,
            disabled: e,
            validators: a
          }));
          return i;
        }
        buildControlled(t, e) {
          const a = [],
            i = [],
            o = [];
          if (t.model[t.key]) {
            if (Array.isArray(t.model[t.key])) {
              t.model[t.key].forEach(s => {
                i.push(s["rdfs:label"]), o.push(s["@id"]);
              });
              const r = this.fb.group({
                chips: this.fb.array(i),
                ids: this.fb.array(o),
                search: new at({
                  disabled: e
                })
              });
              a.push(r);
            } else {
              Object.hasOwn(t.model[t.key], "rdfs:label") && (i.push(t.model[t.key]["rdfs:label"]), o.push(t.model[t.key]["@id"]));
              const r = this.fb.group({
                chips: this.fb.array(i),
                ids: this.fb.array(o),
                search: new at({
                  disabled: e
                })
              });
              a.push(r);
            }
          } else {
            const r = this.fb.group({
              chips: this.fb.array(i),
              ids: this.fb.array(o),
              search: new at({
                disabled: e
              })
            });
            a.push(r);
          }
          return a;
        }
        buildControlledSingle(t, e) {
          const a = [];
          if (Array.isArray(t.model[t.key])) t.model[t.key].forEach(i => {
            const o = this.fb.group({
              chips: this.fb.array([i["rdfs:label"]]),
              ids: this.fb.array([i["@id"]]),
              search: new at({
                disabled: e
              })
            });
            a.push(o);
          });else {
            const i = this.fb.group({
              chips: this.fb.array([t.model[t.key]["rdfs:label"]]),
              ids: this.fb.array([t.model[t.key]["@id"]]),
              search: new at({
                disabled: e
              })
            });
            a.push(i);
          }
          return a;
        }
        buildAV(t, e) {
          const a = [];
          if (t.model[t.key] && t.model[t.key].length) t.model[t.key].forEach(i => {
            const o = [];
            o.push(new at({
              value: "",
              disabled: e
            })), o.push(new at({
              value: "",
              disabled: e
            }));
            const r = this.fb.group({
              values: this.fb.array(o)
            });
            a.push(r);
          });else {
            const i = [];
            i.push(new at({
              value: "",
              disabled: e
            })), i.push(new at({
              value: "",
              disabled: e
            }));
            const o = this.fb.group({
              values: this.fb.array(i)
            });
            a.push(o);
          }
          return a;
        }
        openControlledSource(t) {
          let e = null;
          if (t && t.valueConstraints) {
            const a = t.valueConstraints;
            if (a.classes.length > 0) {
              const i = a.classes[0];
              e = encodeURIComponent(i.source) + "?p=classes&conceptid=" + encodeURIComponent(i.uri);
            } else if (a.ontologies.length > 0) e = encodeURIComponent(a.ontologies[0].acronym);else if (a.branches.length > 0) {
              const i = a.branches[0];
              e = encodeURIComponent(i.acronym) + "?p=classes&conceptid=" + encodeURIComponent(i.uri);
            } else if (a.valueSets.length > 0) {
              const i = a.valueSets[0];
              e = encodeURIComponent(i.vsCollection) + "?p=classes&conceptid=" + encodeURIComponent(i.uri);
            }
            null !== e && window.open("https://bioportal.bioontology.org/ontologies/" + e, "_blank");
          }
        }
        static ɵfac = function (e) {
          return new (e || wl)(f(tp));
        };
        static ɵcmp = q({
          type: wl,
          selectors: [["app-question"]],
          viewQuery: function (e, a) {
            if (1 & e && be(ime, 5), 2 & e) {
              let i;
              H(i = B()) && (a.tooltip = i.first);
            }
          },
          inputs: {
            node: "node",
            parentGroup: "parentGroup",
            autocompleteResults: "autocompleteResults",
            mode: "mode"
          },
          outputs: {
            changed: "changed",
            autocomplete: "autocomplete"
          },
          features: [G([]), Ve],
          decls: 3,
          vars: 2,
          consts: [[4, "ngIf", "ngIfElse"], ["notStaticType", ""], [3, "formGroup", "node", 4, "ngIf"], [3, "formGroup", "node"], [1, "form-group", 3, "formGroup"], [1, "question-label"], ["class", "required", 4, "ngIf"], [4, "ngIf"], ["class", "question-icon", 4, "ngIf"], ["matTooltipPosition", "right", "mat-icon-button", "", "class", "mat-icon-button help", 3, "matTooltipClass", "matTooltip", "click", 4, "ngIf"], ["matTooltipPosition", "right", "mat-icon-button", "", "class", "mat-icon-button help", 3, "matTooltipClass", "matTooltip", 4, "ngIf"], [1, "required"], [3, "icon"], [1, "question-icon"], ["matTooltipPosition", "right", "mat-icon-button", "", 1, "mat-icon-button", "help", 3, "matTooltipClass", "matTooltip", "click"], ["constraints", "matTooltip"], ["matTooltipPosition", "right", "mat-icon-button", "", 1, "mat-icon-button", "help", 3, "matTooltipClass", "matTooltip"], [3, "formGroup", "node", "changed", 4, "ngIf"], [3, "formGroup", "node", "mode", "changed", 4, "ngIf"], [3, "group", "mode", "valueConstraints", "autocompleteResults", "autocomplete", "removedOption", "selectedOption", 4, "ngIf"], [3, "formGroup", "node", "changed"], [3, "formGroup", "node", "mode", "changed"], [3, "group", "mode", "valueConstraints", "autocompleteResults", "autocomplete", "removedOption", "selectedOption"], [3, "ngSwitch"], [4, "ngFor", "ngForOf"], ["style", "padding-top:.5em", 4, "ngIf"], [3, "formGroup", "control", "node", "mode", "index", "changed", 4, "ngSwitchCase"], [3, "formGroup", "control", "node", "index", "changed", 4, "ngSwitchCase"], [2, "padding-top", ".5em"], ["mat-icon-button", "", "class", "node-add", 3, "click", 4, "ngIf"], ["mat-icon-button", "", "class", "node-remove", 3, "click", 4, "ngIf"], ["mat-icon-button", "", 1, "node-add", 3, "click"], ["mat-icon-button", "", 1, "node-remove", 3, "click"], [3, "formGroup", "control", "node", "mode", "index", "changed"], [3, "formGroup", "control", "node", "index", "changed"]],
          template: function (e, a) {
            if (1 & e && (D(0, lme, 5, 4, "ng-container", 0), D(1, Hme, 18, 17, "ng-template", null, 1, q1)), 2 & e) {
              const i = Kt(2);
              b("ngIf", "static" == a.node.type)("ngIfElse", i);
            }
          },
          dependencies: [Pi, ao, ys, zo, ra, ea, mt, Gi, Wr, a0e, X2, J2, $2, e0, t0, n0, s0, d0, u0, m0, h0, p0],
          styles: ['.mat-badge-content{font-weight:600;font-size:12px;font-family:Roboto,Helvetica Neue,sans-serif}.mat-badge-small .mat-badge-content{font-size:9px}.mat-badge-large .mat-badge-content{font-size:24px}.mat-h1,.mat-headline,.mat-typography .mat-h1,.mat-typography .mat-headline,.mat-typography h1{font:400 24px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h2,.mat-title,.mat-typography .mat-h2,.mat-typography .mat-title,.mat-typography h2{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h3,.mat-subheading-2,.mat-typography .mat-h3,.mat-typography .mat-subheading-2,.mat-typography h3{font:400 16px/28px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h4,.mat-subheading-1,.mat-typography .mat-h4,.mat-typography .mat-subheading-1,.mat-typography h4{font:400 15px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h5,.mat-typography .mat-h5,.mat-typography h5{font:400 11.62px/20px Roboto,Helvetica Neue,sans-serif;margin:0 0 12px}.mat-h6,.mat-typography .mat-h6,.mat-typography h6{font:400 9.38px/20px Roboto,Helvetica Neue,sans-serif;margin:0 0 12px}.mat-body-strong,.mat-body-2,.mat-typography .mat-body-strong,.mat-typography .mat-body-2{font:500 14px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-body,.mat-body-1,.mat-typography .mat-body,.mat-typography .mat-body-1,.mat-typography{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-body p,.mat-body-1 p,.mat-typography .mat-body p,.mat-typography .mat-body-1 p,.mat-typography p{margin:0 0 12px}.mat-small,.mat-caption,.mat-typography .mat-small,.mat-typography .mat-caption{font:400 12px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-display-4,.mat-typography .mat-display-4{font:300 112px/112px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.05em;margin:0 0 56px}.mat-display-3,.mat-typography .mat-display-3{font:400 56px/56px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.02em;margin:0 0 64px}.mat-display-2,.mat-typography .mat-display-2{font:400 45px/48px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.005em;margin:0 0 64px}.mat-display-1,.mat-typography .mat-display-1{font:400 34px/40px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 64px}.mat-bottom-sheet-container{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-button,.mat-raised-button,.mat-icon-button,.mat-stroked-button,.mat-flat-button,.mat-fab,.mat-mini-fab{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-button-toggle,.mat-card{font-family:Roboto,Helvetica Neue,sans-serif}.mat-card-title{font-size:24px;font-weight:500}.mat-card-header .mat-card-title{font-size:20px}.mat-card-subtitle,.mat-card-content{font-size:14px}.mat-checkbox{font-family:Roboto,Helvetica Neue,sans-serif}.mat-checkbox-layout .mat-checkbox-label{line-height:24px}.mat-chip{font-size:14px;font-weight:500}.mat-chip .mat-chip-trailing-icon.mat-icon,.mat-chip .mat-chip-remove.mat-icon{font-size:18px}.mat-table{font-family:Roboto,Helvetica Neue,sans-serif}.mat-header-cell{font-size:12px;font-weight:500}.mat-cell,.mat-footer-cell{font-size:14px}.mat-calendar{font-family:Roboto,Helvetica Neue,sans-serif}.mat-calendar-body{font-size:13px}.mat-calendar-body-label,.mat-calendar-period-button{font-size:14px;font-weight:500}.mat-calendar-table-header th{font-size:11px;font-weight:400}.mat-dialog-title{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-expansion-panel-header{font-family:Roboto,Helvetica Neue,sans-serif;font-size:15px;font-weight:400}.mat-expansion-panel-content{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-form-field{font-size:inherit;font-weight:400;line-height:1.125;font-family:Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-form-field-wrapper{padding-bottom:1.34375em}.mat-form-field-prefix .mat-icon,.mat-form-field-suffix .mat-icon{font-size:150%;line-height:1.125}.mat-form-field-prefix .mat-icon-button,.mat-form-field-suffix .mat-icon-button{height:1.5em;width:1.5em}.mat-form-field-prefix .mat-icon-button .mat-icon,.mat-form-field-suffix .mat-icon-button .mat-icon{height:1.125em;line-height:1.125}.mat-form-field-infix{padding:.5em 0;border-top:.84375em solid transparent}.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.34375em) scale(.75);width:133.3333333333%}.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.34374em) scale(.75);width:133.3333433333%}.mat-form-field-label-wrapper{top:-.84375em;padding-top:.84375em}.mat-form-field-label{top:1.34375em}.mat-form-field-underline{bottom:1.34375em}.mat-form-field-subscript-wrapper{font-size:75%;margin-top:.6666666667em;top:calc(100% - 1.7916666667em)}.mat-form-field-appearance-legacy .mat-form-field-wrapper{padding-bottom:1.25em}.mat-form-field-appearance-legacy .mat-form-field-infix{padding:.4375em 0}.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.001px);width:133.3333333333%}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00101px);width:133.3333433333%}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00102px);width:133.3333533333%}.mat-form-field-appearance-legacy .mat-form-field-label{top:1.28125em}.mat-form-field-appearance-legacy .mat-form-field-underline{bottom:1.25em}.mat-form-field-appearance-legacy .mat-form-field-subscript-wrapper{margin-top:.5416666667em;top:calc(100% - 1.6666666667em)}@media print{.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28122em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28121em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.2812em) scale(.75)}}.mat-form-field-appearance-fill .mat-form-field-infix{padding:.25em 0 .75em}.mat-form-field-appearance-fill .mat-form-field-label{top:1.09375em;margin-top:-.5em}.mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-fill.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-.59375em) scale(.75);width:133.3333333333%}.mat-form-field-appearance-fill.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-.59374em) scale(.75);width:133.3333433333%}.mat-form-field-appearance-outline .mat-form-field-infix{padding:1em 0}.mat-form-field-appearance-outline .mat-form-field-label{top:1.84375em;margin-top:-.25em}.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-outline.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.59375em) scale(.75);width:133.3333333333%}.mat-form-field-appearance-outline.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.59374em) scale(.75);width:133.3333433333%}.mat-grid-tile-header,.mat-grid-tile-footer{font-size:14px}.mat-grid-tile-header .mat-line,.mat-grid-tile-footer .mat-line{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-grid-tile-header .mat-line:nth-child(n+2),.mat-grid-tile-footer .mat-line:nth-child(n+2){font-size:12px}input.mat-input-element{margin-top:-.0625em}.mat-menu-item{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:400}.mat-paginator,.mat-paginator-page-size .mat-select-trigger{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px}.mat-radio-button,.mat-select{font-family:Roboto,Helvetica Neue,sans-serif}.mat-select-trigger{height:1.125em}.mat-slide-toggle-content{font-family:Roboto,Helvetica Neue,sans-serif}.mat-slider-thumb-label-text{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px;font-weight:500}.mat-stepper-vertical,.mat-stepper-horizontal{font-family:Roboto,Helvetica Neue,sans-serif}.mat-step-label{font-size:14px;font-weight:400}.mat-step-sub-label-error{font-weight:400}.mat-step-label-error{font-size:14px}.mat-step-label-selected{font-size:14px;font-weight:500}.mat-tab-group{font-family:Roboto,Helvetica Neue,sans-serif}.mat-tab-label,.mat-tab-link{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-toolbar,.mat-toolbar h1,.mat-toolbar h2,.mat-toolbar h3,.mat-toolbar h4,.mat-toolbar h5,.mat-toolbar h6{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0}.mat-tooltip{font-family:Roboto,Helvetica Neue,sans-serif;font-size:10px;padding-top:6px;padding-bottom:6px}.mat-tooltip-handset{font-size:14px;padding-top:8px;padding-bottom:8px}.mat-list-item,.mat-list-option{font-family:Roboto,Helvetica Neue,sans-serif}.mat-ripple-element{background-color:#0000001a}.mat-option{color:#000000de}.mat-option:hover:not(.mat-option-disabled),.mat-option:focus:not(.mat-option-disabled){background:rgba(0,0,0,.04)}.mat-option.mat-selected:not(.mat-option-multiple):not(.mat-option-disabled){background:rgba(0,0,0,.04)}.mat-option.mat-active{background:rgba(0,0,0,.04);color:#000000de}.mat-option.mat-option-disabled{color:#00000061}.mat-primary .mat-option.mat-selected:not(.mat-option-disabled){color:#5fa0c5}.mat-accent .mat-option.mat-selected:not(.mat-option-disabled){color:#95b8a2}.mat-warn .mat-option.mat-selected:not(.mat-option-disabled){color:#c62e3c}.mat-optgroup-label{color:#0000008a}.mat-optgroup-disabled .mat-optgroup-label{color:#00000061}.mat-pseudo-checkbox{color:#0000008a}.mat-pseudo-checkbox:after{color:#fafafa}.mat-pseudo-checkbox-disabled{color:#b0b0b0}.mat-primary .mat-pseudo-checkbox-checked,.mat-primary .mat-pseudo-checkbox-indeterminate{background:#5fa0c5}.mat-pseudo-checkbox-checked,.mat-pseudo-checkbox-indeterminate,.mat-accent .mat-pseudo-checkbox-checked,.mat-accent .mat-pseudo-checkbox-indeterminate{background:#95b8a2}.mat-warn .mat-pseudo-checkbox-checked,.mat-warn .mat-pseudo-checkbox-indeterminate{background:#c62e3c}.mat-pseudo-checkbox-checked.mat-pseudo-checkbox-disabled,.mat-pseudo-checkbox-indeterminate.mat-pseudo-checkbox-disabled{background:#b0b0b0}.mat-app-background{background-color:#fafafa;color:#000000de}.mat-elevation-z0{box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-elevation-z1{box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.mat-elevation-z2{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-elevation-z3{box-shadow:0 3px 3px -2px #0003,0 3px 4px #00000024,0 1px 8px #0000001f}.mat-elevation-z4{box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mat-elevation-z5{box-shadow:0 3px 5px -1px #0003,0 5px 8px #00000024,0 1px 14px #0000001f}.mat-elevation-z6{box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mat-elevation-z7{box-shadow:0 4px 5px -2px #0003,0 7px 10px 1px #00000024,0 2px 16px 1px #0000001f}.mat-elevation-z8{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.mat-elevation-z9{box-shadow:0 5px 6px -3px #0003,0 9px 12px 1px #00000024,0 3px 16px 2px #0000001f}.mat-elevation-z10{box-shadow:0 6px 6px -3px #0003,0 10px 14px 1px #00000024,0 4px 18px 3px #0000001f}.mat-elevation-z11{box-shadow:0 6px 7px -4px #0003,0 11px 15px 1px #00000024,0 4px 20px 3px #0000001f}.mat-elevation-z12{box-shadow:0 7px 8px -4px #0003,0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f}.mat-elevation-z13{box-shadow:0 7px 8px -4px #0003,0 13px 19px 2px #00000024,0 5px 24px 4px #0000001f}.mat-elevation-z14{box-shadow:0 7px 9px -4px #0003,0 14px 21px 2px #00000024,0 5px 26px 4px #0000001f}.mat-elevation-z15{box-shadow:0 8px 9px -5px #0003,0 15px 22px 2px #00000024,0 6px 28px 5px #0000001f}.mat-elevation-z16{box-shadow:0 8px 10px -5px #0003,0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f}.mat-elevation-z17{box-shadow:0 8px 11px -5px #0003,0 17px 26px 2px #00000024,0 6px 32px 5px #0000001f}.mat-elevation-z18{box-shadow:0 9px 11px -5px #0003,0 18px 28px 2px #00000024,0 7px 34px 6px #0000001f}.mat-elevation-z19{box-shadow:0 9px 12px -6px #0003,0 19px 29px 2px #00000024,0 7px 36px 6px #0000001f}.mat-elevation-z20{box-shadow:0 10px 13px -6px #0003,0 20px 31px 3px #00000024,0 8px 38px 7px #0000001f}.mat-elevation-z21{box-shadow:0 10px 13px -6px #0003,0 21px 33px 3px #00000024,0 8px 40px 7px #0000001f}.mat-elevation-z22{box-shadow:0 10px 14px -6px #0003,0 22px 35px 3px #00000024,0 8px 42px 7px #0000001f}.mat-elevation-z23{box-shadow:0 11px 14px -7px #0003,0 23px 36px 3px #00000024,0 9px 44px 8px #0000001f}.mat-elevation-z24{box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f}.mat-theme-loaded-marker{display:none}.mat-autocomplete-panel{background:white;color:#000000de}.mat-autocomplete-panel:not([class*=mat-elevation-z]){box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mat-autocomplete-panel .mat-option.mat-selected:not(.mat-active):not(:hover){background:white}.mat-autocomplete-panel .mat-option.mat-selected:not(.mat-active):not(:hover):not(.mat-option-disabled){color:#000000de}.mat-badge{position:relative}.mat-badge.mat-badge{overflow:visible}.mat-badge-hidden .mat-badge-content{display:none}.mat-badge-content{position:absolute;text-align:center;display:inline-block;border-radius:50%;transition:transform .2s ease-in-out;transform:scale(.6);overflow:hidden;white-space:nowrap;text-overflow:ellipsis;pointer-events:none}.ng-animate-disabled .mat-badge-content,.mat-badge-content._mat-animation-noopable{transition:none}.mat-badge-content.mat-badge-active{transform:none}.mat-badge-small .mat-badge-content{width:16px;height:16px;line-height:16px}.mat-badge-small.mat-badge-above .mat-badge-content{top:-8px}.mat-badge-small.mat-badge-below .mat-badge-content{bottom:-8px}.mat-badge-small.mat-badge-before .mat-badge-content{left:-16px}[dir=rtl] .mat-badge-small.mat-badge-before .mat-badge-content{left:auto;right:-16px}.mat-badge-small.mat-badge-after .mat-badge-content{right:-16px}[dir=rtl] .mat-badge-small.mat-badge-after .mat-badge-content{right:auto;left:-16px}.mat-badge-small.mat-badge-overlap.mat-badge-before .mat-badge-content{left:-8px}[dir=rtl] .mat-badge-small.mat-badge-overlap.mat-badge-before .mat-badge-content{left:auto;right:-8px}.mat-badge-small.mat-badge-overlap.mat-badge-after .mat-badge-content{right:-8px}[dir=rtl] .mat-badge-small.mat-badge-overlap.mat-badge-after .mat-badge-content{right:auto;left:-8px}.mat-badge-medium .mat-badge-content{width:22px;height:22px;line-height:22px}.mat-badge-medium.mat-badge-above .mat-badge-content{top:-11px}.mat-badge-medium.mat-badge-below .mat-badge-content{bottom:-11px}.mat-badge-medium.mat-badge-before .mat-badge-content{left:-22px}[dir=rtl] .mat-badge-medium.mat-badge-before .mat-badge-content{left:auto;right:-22px}.mat-badge-medium.mat-badge-after .mat-badge-content{right:-22px}[dir=rtl] .mat-badge-medium.mat-badge-after .mat-badge-content{right:auto;left:-22px}.mat-badge-medium.mat-badge-overlap.mat-badge-before .mat-badge-content{left:-11px}[dir=rtl] .mat-badge-medium.mat-badge-overlap.mat-badge-before .mat-badge-content{left:auto;right:-11px}.mat-badge-medium.mat-badge-overlap.mat-badge-after .mat-badge-content{right:-11px}[dir=rtl] .mat-badge-medium.mat-badge-overlap.mat-badge-after .mat-badge-content{right:auto;left:-11px}.mat-badge-large .mat-badge-content{width:28px;height:28px;line-height:28px}.mat-badge-large.mat-badge-above .mat-badge-content{top:-14px}.mat-badge-large.mat-badge-below .mat-badge-content{bottom:-14px}.mat-badge-large.mat-badge-before .mat-badge-content{left:-28px}[dir=rtl] .mat-badge-large.mat-badge-before .mat-badge-content{left:auto;right:-28px}.mat-badge-large.mat-badge-after .mat-badge-content{right:-28px}[dir=rtl] .mat-badge-large.mat-badge-after .mat-badge-content{right:auto;left:-28px}.mat-badge-large.mat-badge-overlap.mat-badge-before .mat-badge-content{left:-14px}[dir=rtl] .mat-badge-large.mat-badge-overlap.mat-badge-before .mat-badge-content{left:auto;right:-14px}.mat-badge-large.mat-badge-overlap.mat-badge-after .mat-badge-content{right:-14px}[dir=rtl] .mat-badge-large.mat-badge-overlap.mat-badge-after .mat-badge-content{right:auto;left:-14px}.mat-badge-content{color:#000;background:#5fa0c5}.cdk-high-contrast-active .mat-badge-content{outline:solid 1px;border-radius:0}.mat-badge-accent .mat-badge-content{background:#95b8a2;color:#000}.mat-badge-warn .mat-badge-content{color:#fff;background:#c62e3c}.mat-badge-disabled .mat-badge-content{background:#b9b9b9;color:#00000061}.mat-bottom-sheet-container{box-shadow:0 8px 10px -5px #0003,0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f;background:white;color:#000000de}.mat-button,.mat-icon-button,.mat-stroked-button{color:inherit;background:transparent}.mat-button.mat-primary,.mat-icon-button.mat-primary,.mat-stroked-button.mat-primary{color:#5fa0c5}.mat-button.mat-accent,.mat-icon-button.mat-accent,.mat-stroked-button.mat-accent{color:#95b8a2}.mat-button.mat-warn,.mat-icon-button.mat-warn,.mat-stroked-button.mat-warn{color:#c62e3c}.mat-button.mat-primary.mat-button-disabled,.mat-button.mat-accent.mat-button-disabled,.mat-button.mat-warn.mat-button-disabled,.mat-button.mat-button-disabled.mat-button-disabled,.mat-icon-button.mat-primary.mat-button-disabled,.mat-icon-button.mat-accent.mat-button-disabled,.mat-icon-button.mat-warn.mat-button-disabled,.mat-icon-button.mat-button-disabled.mat-button-disabled,.mat-stroked-button.mat-primary.mat-button-disabled,.mat-stroked-button.mat-accent.mat-button-disabled,.mat-stroked-button.mat-warn.mat-button-disabled,.mat-stroked-button.mat-button-disabled.mat-button-disabled{color:#00000042}.mat-button.mat-primary .mat-button-focus-overlay,.mat-icon-button.mat-primary .mat-button-focus-overlay,.mat-stroked-button.mat-primary .mat-button-focus-overlay{background-color:#5fa0c5}.mat-button.mat-accent .mat-button-focus-overlay,.mat-icon-button.mat-accent .mat-button-focus-overlay,.mat-stroked-button.mat-accent .mat-button-focus-overlay{background-color:#95b8a2}.mat-button.mat-warn .mat-button-focus-overlay,.mat-icon-button.mat-warn .mat-button-focus-overlay,.mat-stroked-button.mat-warn .mat-button-focus-overlay{background-color:#c62e3c}.mat-button.mat-button-disabled .mat-button-focus-overlay,.mat-icon-button.mat-button-disabled .mat-button-focus-overlay,.mat-stroked-button.mat-button-disabled .mat-button-focus-overlay{background-color:transparent}.mat-button .mat-ripple-element,.mat-icon-button .mat-ripple-element,.mat-stroked-button .mat-ripple-element{opacity:.1;background-color:currentColor}.mat-button-focus-overlay{background:black}.mat-stroked-button:not(.mat-button-disabled){border-color:#0000001f}.mat-flat-button,.mat-raised-button,.mat-fab,.mat-mini-fab{color:#000000de;background-color:#fff}.mat-flat-button.mat-primary,.mat-raised-button.mat-primary,.mat-fab.mat-primary,.mat-mini-fab.mat-primary,.mat-flat-button.mat-accent,.mat-raised-button.mat-accent,.mat-fab.mat-accent,.mat-mini-fab.mat-accent{color:#000}.mat-flat-button.mat-warn,.mat-raised-button.mat-warn,.mat-fab.mat-warn,.mat-mini-fab.mat-warn{color:#fff}.mat-flat-button.mat-primary.mat-button-disabled,.mat-flat-button.mat-accent.mat-button-disabled,.mat-flat-button.mat-warn.mat-button-disabled,.mat-flat-button.mat-button-disabled.mat-button-disabled,.mat-raised-button.mat-primary.mat-button-disabled,.mat-raised-button.mat-accent.mat-button-disabled,.mat-raised-button.mat-warn.mat-button-disabled,.mat-raised-button.mat-button-disabled.mat-button-disabled,.mat-fab.mat-primary.mat-button-disabled,.mat-fab.mat-accent.mat-button-disabled,.mat-fab.mat-warn.mat-button-disabled,.mat-fab.mat-button-disabled.mat-button-disabled,.mat-mini-fab.mat-primary.mat-button-disabled,.mat-mini-fab.mat-accent.mat-button-disabled,.mat-mini-fab.mat-warn.mat-button-disabled,.mat-mini-fab.mat-button-disabled.mat-button-disabled{color:#00000042}.mat-flat-button.mat-primary,.mat-raised-button.mat-primary,.mat-fab.mat-primary,.mat-mini-fab.mat-primary{background-color:#5fa0c5}.mat-flat-button.mat-accent,.mat-raised-button.mat-accent,.mat-fab.mat-accent,.mat-mini-fab.mat-accent{background-color:#95b8a2}.mat-flat-button.mat-warn,.mat-raised-button.mat-warn,.mat-fab.mat-warn,.mat-mini-fab.mat-warn{background-color:#c62e3c}.mat-flat-button.mat-primary.mat-button-disabled,.mat-flat-button.mat-accent.mat-button-disabled,.mat-flat-button.mat-warn.mat-button-disabled,.mat-flat-button.mat-button-disabled.mat-button-disabled,.mat-raised-button.mat-primary.mat-button-disabled,.mat-raised-button.mat-accent.mat-button-disabled,.mat-raised-button.mat-warn.mat-button-disabled,.mat-raised-button.mat-button-disabled.mat-button-disabled,.mat-fab.mat-primary.mat-button-disabled,.mat-fab.mat-accent.mat-button-disabled,.mat-fab.mat-warn.mat-button-disabled,.mat-fab.mat-button-disabled.mat-button-disabled,.mat-mini-fab.mat-primary.mat-button-disabled,.mat-mini-fab.mat-accent.mat-button-disabled,.mat-mini-fab.mat-warn.mat-button-disabled,.mat-mini-fab.mat-button-disabled.mat-button-disabled{background-color:#0000001f}.mat-flat-button.mat-primary .mat-ripple-element,.mat-raised-button.mat-primary .mat-ripple-element,.mat-fab.mat-primary .mat-ripple-element,.mat-mini-fab.mat-primary .mat-ripple-element,.mat-flat-button.mat-accent .mat-ripple-element,.mat-raised-button.mat-accent .mat-ripple-element,.mat-fab.mat-accent .mat-ripple-element,.mat-mini-fab.mat-accent .mat-ripple-element{background-color:#0000001a}.mat-flat-button.mat-warn .mat-ripple-element,.mat-raised-button.mat-warn .mat-ripple-element,.mat-fab.mat-warn .mat-ripple-element,.mat-mini-fab.mat-warn .mat-ripple-element{background-color:#ffffff1a}.mat-stroked-button:not([class*=mat-elevation-z]),.mat-flat-button:not([class*=mat-elevation-z]){box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-raised-button:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-raised-button:not(.mat-button-disabled):active:not([class*=mat-elevation-z]){box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.mat-raised-button.mat-button-disabled:not([class*=mat-elevation-z]){box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-fab:not([class*=mat-elevation-z]),.mat-mini-fab:not([class*=mat-elevation-z]){box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mat-fab:not(.mat-button-disabled):active:not([class*=mat-elevation-z]),.mat-mini-fab:not(.mat-button-disabled):active:not([class*=mat-elevation-z]){box-shadow:0 7px 8px -4px #0003,0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f}.mat-fab.mat-button-disabled:not([class*=mat-elevation-z]),.mat-mini-fab.mat-button-disabled:not([class*=mat-elevation-z]){box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-button-toggle-standalone:not([class*=mat-elevation-z]),.mat-button-toggle-group:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-button-toggle-standalone.mat-button-toggle-appearance-standard:not([class*=mat-elevation-z]),.mat-button-toggle-group-appearance-standard:not([class*=mat-elevation-z]){box-shadow:none}.mat-button-toggle{color:#00000061}.mat-button-toggle .mat-button-toggle-focus-overlay{background-color:#0000001f}.mat-button-toggle-appearance-standard{color:#000000de;background:white}.mat-button-toggle-appearance-standard .mat-button-toggle-focus-overlay{background-color:#000}.mat-button-toggle-group-appearance-standard .mat-button-toggle+.mat-button-toggle{border-left:solid 1px #e0e0e0}[dir=rtl] .mat-button-toggle-group-appearance-standard .mat-button-toggle+.mat-button-toggle{border-left:none;border-right:solid 1px #e0e0e0}.mat-button-toggle-group-appearance-standard.mat-button-toggle-vertical .mat-button-toggle+.mat-button-toggle{border-left:none;border-right:none;border-top:solid 1px #e0e0e0}.mat-button-toggle-checked{background-color:#e0e0e0;color:#0000008a}.mat-button-toggle-checked.mat-button-toggle-appearance-standard{color:#000000de}.mat-button-toggle-disabled{color:#00000042;background-color:#eee}.mat-button-toggle-disabled.mat-button-toggle-appearance-standard{background:white}.mat-button-toggle-disabled.mat-button-toggle-checked{background-color:#bdbdbd}.mat-button-toggle-standalone.mat-button-toggle-appearance-standard,.mat-button-toggle-group-appearance-standard{border:solid 1px #e0e0e0}.mat-button-toggle-appearance-standard .mat-button-toggle-label-content{line-height:48px}.mat-card{background:white;color:#000000de}.mat-card:not([class*=mat-elevation-z]){box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f}.mat-card.mat-card-flat:not([class*=mat-elevation-z]){box-shadow:0 0 #0003,0 0 #00000024,0 0 #0000001f}.mat-card-subtitle{color:#0000008a}.mat-checkbox-frame{border-color:#0000008a}.mat-checkbox-checkmark{fill:#fafafa}.mat-checkbox-checkmark-path{stroke:#fafafa!important}.mat-checkbox-mixedmark{background-color:#fafafa}.mat-checkbox-indeterminate.mat-primary .mat-checkbox-background,.mat-checkbox-checked.mat-primary .mat-checkbox-background{background-color:#5fa0c5}.mat-checkbox-indeterminate.mat-accent .mat-checkbox-background,.mat-checkbox-checked.mat-accent .mat-checkbox-background{background-color:#95b8a2}.mat-checkbox-indeterminate.mat-warn .mat-checkbox-background,.mat-checkbox-checked.mat-warn .mat-checkbox-background{background-color:#c62e3c}.mat-checkbox-disabled.mat-checkbox-checked .mat-checkbox-background,.mat-checkbox-disabled.mat-checkbox-indeterminate .mat-checkbox-background{background-color:#b0b0b0}.mat-checkbox-disabled:not(.mat-checkbox-checked) .mat-checkbox-frame{border-color:#b0b0b0}.mat-checkbox-disabled .mat-checkbox-label{color:#00000061}.mat-checkbox .mat-ripple-element{background-color:#000}.mat-checkbox-checked:not(.mat-checkbox-disabled).mat-primary .mat-ripple-element,.mat-checkbox:active:not(.mat-checkbox-disabled).mat-primary .mat-ripple-element{background:#5fa0c5}.mat-checkbox-checked:not(.mat-checkbox-disabled).mat-accent .mat-ripple-element,.mat-checkbox:active:not(.mat-checkbox-disabled).mat-accent .mat-ripple-element{background:#95b8a2}.mat-checkbox-checked:not(.mat-checkbox-disabled).mat-warn .mat-ripple-element,.mat-checkbox:active:not(.mat-checkbox-disabled).mat-warn .mat-ripple-element{background:#c62e3c}.mat-chip.mat-standard-chip{background-color:#e0e0e0;color:#000000de}.mat-chip.mat-standard-chip .mat-chip-remove{color:#000000de;opacity:.4}.mat-chip.mat-standard-chip:not(.mat-chip-disabled):active{box-shadow:0 3px 3px -2px #0003,0 3px 4px #00000024,0 1px 8px #0000001f}.mat-chip.mat-standard-chip:not(.mat-chip-disabled) .mat-chip-remove:hover{opacity:.54}.mat-chip.mat-standard-chip.mat-chip-disabled{opacity:.4}.mat-chip.mat-standard-chip:after{background:black}.mat-chip.mat-standard-chip.mat-chip-selected.mat-primary{background-color:#5fa0c5;color:#000}.mat-chip.mat-standard-chip.mat-chip-selected.mat-primary .mat-chip-remove{color:#000;opacity:.4}.mat-chip.mat-standard-chip.mat-chip-selected.mat-primary .mat-ripple-element{background-color:#0000001a}.mat-chip.mat-standard-chip.mat-chip-selected.mat-warn{background-color:#c62e3c;color:#fff}.mat-chip.mat-standard-chip.mat-chip-selected.mat-warn .mat-chip-remove{color:#fff;opacity:.4}.mat-chip.mat-standard-chip.mat-chip-selected.mat-warn .mat-ripple-element{background-color:#ffffff1a}.mat-chip.mat-standard-chip.mat-chip-selected.mat-accent{background-color:#95b8a2;color:#000}.mat-chip.mat-standard-chip.mat-chip-selected.mat-accent .mat-chip-remove{color:#000;opacity:.4}.mat-chip.mat-standard-chip.mat-chip-selected.mat-accent .mat-ripple-element{background-color:#0000001a}.mat-table{background:white}.mat-table thead,.mat-table tbody,.mat-table tfoot,mat-header-row,mat-row,mat-footer-row,[mat-header-row],[mat-row],[mat-footer-row],.mat-table-sticky{background:inherit}mat-row,mat-header-row,mat-footer-row,th.mat-header-cell,td.mat-cell,td.mat-footer-cell{border-bottom-color:#0000001f}.mat-header-cell{color:#0000008a}.mat-cell,.mat-footer-cell{color:#000000de}.mat-calendar-arrow{fill:#0000008a}.mat-datepicker-toggle,.mat-datepicker-content .mat-calendar-next-button,.mat-datepicker-content .mat-calendar-previous-button{color:#0000008a}.mat-calendar-table-header-divider:after{background:rgba(0,0,0,.12)}.mat-calendar-table-header,.mat-calendar-body-label{color:#0000008a}.mat-calendar-body-cell-content,.mat-date-range-input-separator{color:#000000de;border-color:transparent}.mat-calendar-body-disabled>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){color:#00000061}.mat-form-field-disabled .mat-date-range-input-separator{color:#00000061}.mat-calendar-body-in-preview{color:#0000003d}.mat-calendar-body-today:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){border-color:#00000061}.mat-calendar-body-disabled>.mat-calendar-body-today:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){border-color:#0000002e}.mat-calendar-body-in-range:before{background:rgba(95,160,197,.2)}.mat-calendar-body-comparison-identical,.mat-calendar-body-in-comparison-range:before{background:rgba(249,171,0,.2)}.mat-calendar-body-comparison-bridge-start:before,[dir=rtl] .mat-calendar-body-comparison-bridge-end:before{background:linear-gradient(to right,rgba(95,160,197,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-calendar-body-comparison-bridge-end:before,[dir=rtl] .mat-calendar-body-comparison-bridge-start:before{background:linear-gradient(to left,rgba(95,160,197,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-calendar-body-in-range>.mat-calendar-body-comparison-identical,.mat-calendar-body-in-comparison-range.mat-calendar-body-in-range:after{background:#a8dab5}.mat-calendar-body-comparison-identical.mat-calendar-body-selected,.mat-calendar-body-in-comparison-range>.mat-calendar-body-selected{background:#46a35e}.mat-calendar-body-selected{background-color:#5fa0c5;color:#000}.mat-calendar-body-disabled>.mat-calendar-body-selected{background-color:#5fa0c566}.mat-calendar-body-today.mat-calendar-body-selected{box-shadow:inset 0 0 0 1px #000}.cdk-keyboard-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical),.cdk-program-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#5fa0c54d}@media (hover: hover){.mat-calendar-body-cell:not(.mat-calendar-body-disabled):hover>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#5fa0c54d}}.mat-datepicker-content{box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f;background-color:#fff;color:#000000de}.mat-datepicker-content.mat-accent .mat-calendar-body-in-range:before{background:rgba(149,184,162,.2)}.mat-datepicker-content.mat-accent .mat-calendar-body-comparison-identical,.mat-datepicker-content.mat-accent .mat-calendar-body-in-comparison-range:before{background:rgba(249,171,0,.2)}.mat-datepicker-content.mat-accent .mat-calendar-body-comparison-bridge-start:before,.mat-datepicker-content.mat-accent [dir=rtl] .mat-calendar-body-comparison-bridge-end:before{background:linear-gradient(to right,rgba(149,184,162,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-datepicker-content.mat-accent .mat-calendar-body-comparison-bridge-end:before,.mat-datepicker-content.mat-accent [dir=rtl] .mat-calendar-body-comparison-bridge-start:before{background:linear-gradient(to left,rgba(149,184,162,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-datepicker-content.mat-accent .mat-calendar-body-in-range>.mat-calendar-body-comparison-identical,.mat-datepicker-content.mat-accent .mat-calendar-body-in-comparison-range.mat-calendar-body-in-range:after{background:#a8dab5}.mat-datepicker-content.mat-accent .mat-calendar-body-comparison-identical.mat-calendar-body-selected,.mat-datepicker-content.mat-accent .mat-calendar-body-in-comparison-range>.mat-calendar-body-selected{background:#46a35e}.mat-datepicker-content.mat-accent .mat-calendar-body-selected{background-color:#95b8a2;color:#000}.mat-datepicker-content.mat-accent .mat-calendar-body-disabled>.mat-calendar-body-selected{background-color:#95b8a266}.mat-datepicker-content.mat-accent .mat-calendar-body-today.mat-calendar-body-selected{box-shadow:inset 0 0 0 1px #000}.mat-datepicker-content.mat-accent .cdk-keyboard-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical),.mat-datepicker-content.mat-accent .cdk-program-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#95b8a24d}@media (hover: hover){.mat-datepicker-content.mat-accent .mat-calendar-body-cell:not(.mat-calendar-body-disabled):hover>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#95b8a24d}}.mat-datepicker-content.mat-warn .mat-calendar-body-in-range:before{background:rgba(198,46,60,.2)}.mat-datepicker-content.mat-warn .mat-calendar-body-comparison-identical,.mat-datepicker-content.mat-warn .mat-calendar-body-in-comparison-range:before{background:rgba(249,171,0,.2)}.mat-datepicker-content.mat-warn .mat-calendar-body-comparison-bridge-start:before,.mat-datepicker-content.mat-warn [dir=rtl] .mat-calendar-body-comparison-bridge-end:before{background:linear-gradient(to right,rgba(198,46,60,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-datepicker-content.mat-warn .mat-calendar-body-comparison-bridge-end:before,.mat-datepicker-content.mat-warn [dir=rtl] .mat-calendar-body-comparison-bridge-start:before{background:linear-gradient(to left,rgba(198,46,60,.2) 50%,rgba(249,171,0,.2) 50%)}.mat-datepicker-content.mat-warn .mat-calendar-body-in-range>.mat-calendar-body-comparison-identical,.mat-datepicker-content.mat-warn .mat-calendar-body-in-comparison-range.mat-calendar-body-in-range:after{background:#a8dab5}.mat-datepicker-content.mat-warn .mat-calendar-body-comparison-identical.mat-calendar-body-selected,.mat-datepicker-content.mat-warn .mat-calendar-body-in-comparison-range>.mat-calendar-body-selected{background:#46a35e}.mat-datepicker-content.mat-warn .mat-calendar-body-selected{background-color:#c62e3c;color:#fff}.mat-datepicker-content.mat-warn .mat-calendar-body-disabled>.mat-calendar-body-selected{background-color:#c62e3c66}.mat-datepicker-content.mat-warn .mat-calendar-body-today.mat-calendar-body-selected{box-shadow:inset 0 0 0 1px #fff}.mat-datepicker-content.mat-warn .cdk-keyboard-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical),.mat-datepicker-content.mat-warn .cdk-program-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#c62e3c4d}@media (hover: hover){.mat-datepicker-content.mat-warn .mat-calendar-body-cell:not(.mat-calendar-body-disabled):hover>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#c62e3c4d}}.mat-datepicker-content-touch{box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f}.mat-datepicker-toggle-active{color:#5fa0c5}.mat-datepicker-toggle-active.mat-accent{color:#95b8a2}.mat-datepicker-toggle-active.mat-warn{color:#c62e3c}.mat-date-range-input-inner[disabled]{color:#00000061}.mat-dialog-container{box-shadow:0 11px 15px -7px #0003,0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f;background:white;color:#000000de}.mat-divider{border-top-color:#0000001f}.mat-divider-vertical{border-right-color:#0000001f}.mat-expansion-panel{background:white;color:#000000de}.mat-expansion-panel:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.mat-action-row{border-top-color:#0000001f}.mat-expansion-panel .mat-expansion-panel-header.cdk-keyboard-focused:not([aria-disabled=true]),.mat-expansion-panel .mat-expansion-panel-header.cdk-program-focused:not([aria-disabled=true]),.mat-expansion-panel:not(.mat-expanded) .mat-expansion-panel-header:hover:not([aria-disabled=true]){background:rgba(0,0,0,.04)}@media (hover: none){.mat-expansion-panel:not(.mat-expanded):not([aria-disabled=true]) .mat-expansion-panel-header:hover{background:white}}.mat-expansion-panel-header-title{color:#000000de}.mat-expansion-panel-header-description,.mat-expansion-indicator:after{color:#0000008a}.mat-expansion-panel-header[aria-disabled=true]{color:#00000042}.mat-expansion-panel-header[aria-disabled=true] .mat-expansion-panel-header-title,.mat-expansion-panel-header[aria-disabled=true] .mat-expansion-panel-header-description{color:inherit}.mat-expansion-panel-header{height:48px}.mat-expansion-panel-header.mat-expanded{height:64px}.mat-form-field-label,.mat-hint{color:#0009}.mat-form-field.mat-focused .mat-form-field-label{color:#5fa0c5}.mat-form-field.mat-focused .mat-form-field-label.mat-accent{color:#95b8a2}.mat-form-field.mat-focused .mat-form-field-label.mat-warn{color:#c62e3c}.mat-focused .mat-form-field-required-marker{color:#95b8a2}.mat-form-field-ripple{background-color:#000000de}.mat-form-field.mat-focused .mat-form-field-ripple{background-color:#5fa0c5}.mat-form-field.mat-focused .mat-form-field-ripple.mat-accent{background-color:#95b8a2}.mat-form-field.mat-focused .mat-form-field-ripple.mat-warn{background-color:#c62e3c}.mat-form-field-type-mat-native-select.mat-focused:not(.mat-form-field-invalid) .mat-form-field-infix:after{color:#5fa0c5}.mat-form-field-type-mat-native-select.mat-focused:not(.mat-form-field-invalid).mat-accent .mat-form-field-infix:after{color:#95b8a2}.mat-form-field-type-mat-native-select.mat-focused:not(.mat-form-field-invalid).mat-warn .mat-form-field-infix:after{color:#c62e3c}.mat-form-field.mat-form-field-invalid .mat-form-field-label,.mat-form-field.mat-form-field-invalid .mat-form-field-label.mat-accent,.mat-form-field.mat-form-field-invalid .mat-form-field-label .mat-form-field-required-marker{color:#c62e3c}.mat-form-field.mat-form-field-invalid .mat-form-field-ripple,.mat-form-field.mat-form-field-invalid .mat-form-field-ripple.mat-accent{background-color:#c62e3c}.mat-error{color:#c62e3c}.mat-form-field-appearance-legacy .mat-form-field-label,.mat-form-field-appearance-legacy .mat-hint{color:#0000008a}.mat-form-field-appearance-legacy .mat-form-field-underline{background-color:#0000006b}.mat-form-field-appearance-legacy.mat-form-field-disabled .mat-form-field-underline{background-image:linear-gradient(to right,rgba(0,0,0,.42) 0%,rgba(0,0,0,.42) 33%,transparent 0%);background-size:4px 100%;background-repeat:repeat-x}.mat-form-field-appearance-standard .mat-form-field-underline{background-color:#0000006b}.mat-form-field-appearance-standard.mat-form-field-disabled .mat-form-field-underline{background-image:linear-gradient(to right,rgba(0,0,0,.42) 0%,rgba(0,0,0,.42) 33%,transparent 0%);background-size:4px 100%;background-repeat:repeat-x}.mat-form-field-appearance-fill .mat-form-field-flex{background-color:#0000000a}.mat-form-field-appearance-fill.mat-form-field-disabled .mat-form-field-flex{background-color:#00000005}.mat-form-field-appearance-fill .mat-form-field-underline:before{background-color:#0000006b}.mat-form-field-appearance-fill.mat-form-field-disabled .mat-form-field-label{color:#00000061}.mat-form-field-appearance-fill.mat-form-field-disabled .mat-form-field-underline:before{background-color:transparent}.mat-form-field-appearance-outline .mat-form-field-outline{color:#0000001f}.mat-form-field-appearance-outline .mat-form-field-outline-thick{color:#000000de}.mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick{color:#5fa0c5}.mat-form-field-appearance-outline.mat-focused.mat-accent .mat-form-field-outline-thick{color:#95b8a2}.mat-form-field-appearance-outline.mat-focused.mat-warn .mat-form-field-outline-thick,.mat-form-field-appearance-outline.mat-form-field-invalid.mat-form-field-invalid .mat-form-field-outline-thick{color:#c62e3c}.mat-form-field-appearance-outline.mat-form-field-disabled .mat-form-field-label{color:#00000061}.mat-form-field-appearance-outline.mat-form-field-disabled .mat-form-field-outline{color:#0000000f}.mat-icon.mat-primary{color:#5fa0c5}.mat-icon.mat-accent{color:#95b8a2}.mat-icon.mat-warn{color:#c62e3c}.mat-form-field-type-mat-native-select .mat-form-field-infix:after{color:#0000008a}.mat-input-element:disabled,.mat-form-field-type-mat-native-select.mat-form-field-disabled .mat-form-field-infix:after{color:#00000061}.mat-input-element{caret-color:#5fa0c5}.mat-input-element::placeholder{color:#0000006b}.mat-input-element::-moz-placeholder{color:#0000006b}.mat-input-element::-webkit-input-placeholder{color:#0000006b}.mat-input-element:-ms-input-placeholder{color:#0000006b}.mat-form-field.mat-accent .mat-input-element{caret-color:#95b8a2}.mat-form-field.mat-warn .mat-input-element,.mat-form-field-invalid .mat-input-element{caret-color:#c62e3c}.mat-form-field-type-mat-native-select.mat-form-field-invalid .mat-form-field-infix:after{color:#c62e3c}.mat-list-base .mat-list-item,.mat-list-base .mat-list-option{color:#000000de}.mat-list-base .mat-subheader{color:#0000008a}.mat-list-base .mat-list-item-disabled{background-color:#eee;color:#00000061}.mat-list-option:hover,.mat-list-option:focus,.mat-nav-list .mat-list-item:hover,.mat-nav-list .mat-list-item:focus,.mat-action-list .mat-list-item:hover,.mat-action-list .mat-list-item:focus{background:rgba(0,0,0,.04)}.mat-list-single-selected-option,.mat-list-single-selected-option:hover,.mat-list-single-selected-option:focus{background:rgba(0,0,0,.12)}.mat-menu-panel{background:white}.mat-menu-panel:not([class*=mat-elevation-z]){box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mat-menu-item{background:transparent;color:#000000de}.mat-menu-item[disabled],.mat-menu-item[disabled] .mat-menu-submenu-icon,.mat-menu-item[disabled] .mat-icon-no-color{color:#00000061}.mat-menu-item .mat-icon-no-color,.mat-menu-submenu-icon{color:#0000008a}.mat-menu-item:hover:not([disabled]),.mat-menu-item.cdk-program-focused:not([disabled]),.mat-menu-item.cdk-keyboard-focused:not([disabled]),.mat-menu-item-highlighted:not([disabled]){background:rgba(0,0,0,.04)}.mat-paginator{background:white}.mat-paginator,.mat-paginator-page-size .mat-select-trigger{color:#0000008a}.mat-paginator-decrement,.mat-paginator-increment{border-top:2px solid rgba(0,0,0,.54);border-right:2px solid rgba(0,0,0,.54)}.mat-paginator-first,.mat-paginator-last{border-top:2px solid rgba(0,0,0,.54)}.mat-icon-button[disabled] .mat-paginator-decrement,.mat-icon-button[disabled] .mat-paginator-increment,.mat-icon-button[disabled] .mat-paginator-first,.mat-icon-button[disabled] .mat-paginator-last{border-color:#00000061}.mat-paginator-container{min-height:56px}.mat-progress-bar-background{fill:#d3e4ed}.mat-progress-bar-buffer{background-color:#d3e4ed}.mat-progress-bar-fill:after{background-color:#5fa0c5}.mat-progress-bar.mat-accent .mat-progress-bar-background{fill:#e1eae4}.mat-progress-bar.mat-accent .mat-progress-bar-buffer{background-color:#e1eae4}.mat-progress-bar.mat-accent .mat-progress-bar-fill:after{background-color:#95b8a2}.mat-progress-bar.mat-warn .mat-progress-bar-background{fill:#edc7cb}.mat-progress-bar.mat-warn .mat-progress-bar-buffer{background-color:#edc7cb}.mat-progress-bar.mat-warn .mat-progress-bar-fill:after{background-color:#c62e3c}.mat-progress-spinner circle,.mat-spinner circle{stroke:#5fa0c5}.mat-progress-spinner.mat-accent circle,.mat-spinner.mat-accent circle{stroke:#95b8a2}.mat-progress-spinner.mat-warn circle,.mat-spinner.mat-warn circle{stroke:#c62e3c}.mat-radio-outer-circle{border-color:#0000008a}.mat-radio-button.mat-primary.mat-radio-checked .mat-radio-outer-circle{border-color:#5fa0c5}.mat-radio-button.mat-primary .mat-radio-inner-circle,.mat-radio-button.mat-primary .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple),.mat-radio-button.mat-primary.mat-radio-checked .mat-radio-persistent-ripple,.mat-radio-button.mat-primary:active .mat-radio-persistent-ripple{background-color:#5fa0c5}.mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle{border-color:#95b8a2}.mat-radio-button.mat-accent .mat-radio-inner-circle,.mat-radio-button.mat-accent .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple),.mat-radio-button.mat-accent.mat-radio-checked .mat-radio-persistent-ripple,.mat-radio-button.mat-accent:active .mat-radio-persistent-ripple{background-color:#95b8a2}.mat-radio-button.mat-warn.mat-radio-checked .mat-radio-outer-circle{border-color:#c62e3c}.mat-radio-button.mat-warn .mat-radio-inner-circle,.mat-radio-button.mat-warn .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple),.mat-radio-button.mat-warn.mat-radio-checked .mat-radio-persistent-ripple,.mat-radio-button.mat-warn:active .mat-radio-persistent-ripple{background-color:#c62e3c}.mat-radio-button.mat-radio-disabled.mat-radio-checked .mat-radio-outer-circle,.mat-radio-button.mat-radio-disabled .mat-radio-outer-circle{border-color:#00000061}.mat-radio-button.mat-radio-disabled .mat-radio-ripple .mat-ripple-element,.mat-radio-button.mat-radio-disabled .mat-radio-inner-circle{background-color:#00000061}.mat-radio-button.mat-radio-disabled .mat-radio-label-content{color:#00000061}.mat-radio-button .mat-ripple-element{background-color:#000}.mat-select-value{color:#000000de}.mat-select-placeholder{color:#0000006b}.mat-select-disabled .mat-select-value{color:#00000061}.mat-select-arrow{color:#0000008a}.mat-select-panel{background:white}.mat-select-panel:not([class*=mat-elevation-z]){box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}.mat-select-panel .mat-option.mat-selected:not(.mat-option-multiple){background:rgba(0,0,0,.12)}.mat-form-field.mat-focused.mat-primary .mat-select-arrow{color:#5fa0c5}.mat-form-field.mat-focused.mat-accent .mat-select-arrow{color:#95b8a2}.mat-form-field.mat-focused.mat-warn .mat-select-arrow,.mat-form-field .mat-select.mat-select-invalid .mat-select-arrow{color:#c62e3c}.mat-form-field .mat-select.mat-select-disabled .mat-select-arrow{color:#00000061}.mat-drawer-container{background-color:#fafafa;color:#000000de}.mat-drawer{background-color:#fff;color:#000000de}.mat-drawer.mat-drawer-push{background-color:#fff}.mat-drawer:not(.mat-drawer-side){box-shadow:0 8px 10px -5px #0003,0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f}.mat-drawer-side{border-right:solid 1px rgba(0,0,0,.12)}.mat-drawer-side.mat-drawer-end,[dir=rtl] .mat-drawer-side{border-left:solid 1px rgba(0,0,0,.12);border-right:none}[dir=rtl] .mat-drawer-side.mat-drawer-end{border-left:none;border-right:solid 1px rgba(0,0,0,.12)}.mat-drawer-backdrop.mat-drawer-shown{background-color:#0009}.mat-slide-toggle.mat-checked .mat-slide-toggle-thumb{background-color:#95b8a2}.mat-slide-toggle.mat-checked .mat-slide-toggle-bar{background-color:#95b8a28a}.mat-slide-toggle.mat-checked .mat-ripple-element{background-color:#95b8a2}.mat-slide-toggle.mat-primary.mat-checked .mat-slide-toggle-thumb{background-color:#5fa0c5}.mat-slide-toggle.mat-primary.mat-checked .mat-slide-toggle-bar{background-color:#5fa0c58a}.mat-slide-toggle.mat-primary.mat-checked .mat-ripple-element{background-color:#5fa0c5}.mat-slide-toggle.mat-warn.mat-checked .mat-slide-toggle-thumb{background-color:#c62e3c}.mat-slide-toggle.mat-warn.mat-checked .mat-slide-toggle-bar{background-color:#c62e3c8a}.mat-slide-toggle.mat-warn.mat-checked .mat-ripple-element{background-color:#c62e3c}.mat-slide-toggle:not(.mat-checked) .mat-ripple-element{background-color:#000}.mat-slide-toggle-thumb{box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f;background-color:#fafafa}.mat-slide-toggle-bar{background-color:#00000061}.mat-slider-track-background{background-color:#00000042}.mat-slider.mat-primary .mat-slider-track-fill,.mat-slider.mat-primary .mat-slider-thumb,.mat-slider.mat-primary .mat-slider-thumb-label{background-color:#5fa0c5}.mat-slider.mat-primary .mat-slider-thumb-label-text{color:#000}.mat-slider.mat-primary .mat-slider-focus-ring{background-color:#5fa0c533}.mat-slider.mat-accent .mat-slider-track-fill,.mat-slider.mat-accent .mat-slider-thumb,.mat-slider.mat-accent .mat-slider-thumb-label{background-color:#95b8a2}.mat-slider.mat-accent .mat-slider-thumb-label-text{color:#000}.mat-slider.mat-accent .mat-slider-focus-ring{background-color:#95b8a233}.mat-slider.mat-warn .mat-slider-track-fill,.mat-slider.mat-warn .mat-slider-thumb,.mat-slider.mat-warn .mat-slider-thumb-label{background-color:#c62e3c}.mat-slider.mat-warn .mat-slider-thumb-label-text{color:#fff}.mat-slider.mat-warn .mat-slider-focus-ring{background-color:#c62e3c33}.mat-slider:hover .mat-slider-track-background,.mat-slider.cdk-focused .mat-slider-track-background{background-color:#00000061}.mat-slider.mat-slider-disabled .mat-slider-track-background,.mat-slider.mat-slider-disabled .mat-slider-track-fill,.mat-slider.mat-slider-disabled .mat-slider-thumb,.mat-slider.mat-slider-disabled:hover .mat-slider-track-background{background-color:#00000042}.mat-slider.mat-slider-min-value .mat-slider-focus-ring{background-color:#0000001f}.mat-slider.mat-slider-min-value.mat-slider-thumb-label-showing .mat-slider-thumb,.mat-slider.mat-slider-min-value.mat-slider-thumb-label-showing .mat-slider-thumb-label{background-color:#000000de}.mat-slider.mat-slider-min-value.mat-slider-thumb-label-showing.cdk-focused .mat-slider-thumb,.mat-slider.mat-slider-min-value.mat-slider-thumb-label-showing.cdk-focused .mat-slider-thumb-label{background-color:#00000042}.mat-slider.mat-slider-min-value:not(.mat-slider-thumb-label-showing) .mat-slider-thumb{border-color:#00000042;background-color:transparent}.mat-slider.mat-slider-min-value:not(.mat-slider-thumb-label-showing):hover .mat-slider-thumb,.mat-slider.mat-slider-min-value:not(.mat-slider-thumb-label-showing).cdk-focused .mat-slider-thumb{border-color:#00000061}.mat-slider.mat-slider-min-value:not(.mat-slider-thumb-label-showing):hover.mat-slider-disabled .mat-slider-thumb,.mat-slider.mat-slider-min-value:not(.mat-slider-thumb-label-showing).cdk-focused.mat-slider-disabled .mat-slider-thumb{border-color:#00000042}.mat-slider-has-ticks .mat-slider-wrapper:after{border-color:#000000b3}.mat-slider-horizontal .mat-slider-ticks{background-image:repeating-linear-gradient(to right,rgba(0,0,0,.7),rgba(0,0,0,.7) 2px,transparent 0,transparent);background-image:-moz-repeating-linear-gradient(.0001deg,rgba(0,0,0,.7),rgba(0,0,0,.7) 2px,transparent 0,transparent)}.mat-slider-vertical .mat-slider-ticks{background-image:repeating-linear-gradient(to bottom,rgba(0,0,0,.7),rgba(0,0,0,.7) 2px,transparent 0,transparent)}.mat-step-header.cdk-keyboard-focused,.mat-step-header.cdk-program-focused,.mat-step-header:hover:not([aria-disabled]),.mat-step-header:hover[aria-disabled=false]{background-color:#0000000a}.mat-step-header:hover[aria-disabled=true]{cursor:default}@media (hover: none){.mat-step-header:hover{background:none}}.mat-step-header .mat-step-label,.mat-step-header .mat-step-optional{color:#0000008a}.mat-step-header .mat-step-icon{background-color:#0000008a;color:#000}.mat-step-header .mat-step-icon-selected,.mat-step-header .mat-step-icon-state-done,.mat-step-header .mat-step-icon-state-edit{background-color:#5fa0c5;color:#000}.mat-step-header.mat-accent .mat-step-icon{color:#000}.mat-step-header.mat-accent .mat-step-icon-selected,.mat-step-header.mat-accent .mat-step-icon-state-done,.mat-step-header.mat-accent .mat-step-icon-state-edit{background-color:#95b8a2;color:#000}.mat-step-header.mat-warn .mat-step-icon{color:#fff}.mat-step-header.mat-warn .mat-step-icon-selected,.mat-step-header.mat-warn .mat-step-icon-state-done,.mat-step-header.mat-warn .mat-step-icon-state-edit{background-color:#c62e3c;color:#fff}.mat-step-header .mat-step-icon-state-error{background-color:transparent;color:#c62e3c}.mat-step-header .mat-step-label.mat-step-label-active{color:#000000de}.mat-step-header .mat-step-label.mat-step-label-error{color:#c62e3c}.mat-stepper-horizontal,.mat-stepper-vertical{background-color:#fff}.mat-stepper-vertical-line:before{border-left-color:#0000001f}.mat-horizontal-stepper-header:before,.mat-horizontal-stepper-header:after,.mat-stepper-horizontal-line{border-top-color:#0000001f}.mat-horizontal-stepper-header{height:72px}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header,.mat-vertical-stepper-header{padding:24px}.mat-stepper-vertical-line:before{top:-16px;bottom:-16px}.mat-stepper-label-position-bottom .mat-horizontal-stepper-header:after,.mat-stepper-label-position-bottom .mat-horizontal-stepper-header:before{top:36px}.mat-stepper-label-position-bottom .mat-stepper-horizontal-line{top:36px}.mat-sort-header-arrow{color:#757575}.mat-tab-nav-bar,.mat-tab-header{border-bottom:1px solid rgba(0,0,0,.12)}.mat-tab-group-inverted-header .mat-tab-nav-bar,.mat-tab-group-inverted-header .mat-tab-header{border-top:1px solid rgba(0,0,0,.12);border-bottom:none}.mat-tab-label,.mat-tab-link{color:#000000de}.mat-tab-label.mat-tab-disabled,.mat-tab-link.mat-tab-disabled{color:#00000061}.mat-tab-header-pagination-chevron{border-color:#000000de}.mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron{border-color:#00000061}.mat-tab-group[class*=mat-background-]>.mat-tab-header,.mat-tab-nav-bar[class*=mat-background-]{border-bottom:none;border-top:none}.mat-tab-group.mat-primary .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-primary .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-group.mat-primary .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-primary .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-primary .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-primary .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-primary .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-primary .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled){background-color:#3273a34d}.mat-tab-group.mat-primary .mat-ink-bar,.mat-tab-nav-bar.mat-primary .mat-ink-bar{background-color:#5fa0c5}.mat-tab-group.mat-primary.mat-background-primary>.mat-tab-header .mat-ink-bar,.mat-tab-group.mat-primary.mat-background-primary>.mat-tab-link-container .mat-ink-bar,.mat-tab-nav-bar.mat-primary.mat-background-primary>.mat-tab-header .mat-ink-bar,.mat-tab-nav-bar.mat-primary.mat-background-primary>.mat-tab-link-container .mat-ink-bar{background-color:#000}.mat-tab-group.mat-accent .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-accent .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-group.mat-accent .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-accent .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-accent .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-accent .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-accent .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-accent .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled){background-color:#6791754d}.mat-tab-group.mat-accent .mat-ink-bar,.mat-tab-nav-bar.mat-accent .mat-ink-bar{background-color:#95b8a2}.mat-tab-group.mat-accent.mat-background-accent>.mat-tab-header .mat-ink-bar,.mat-tab-group.mat-accent.mat-background-accent>.mat-tab-link-container .mat-ink-bar,.mat-tab-nav-bar.mat-accent.mat-background-accent>.mat-tab-header .mat-ink-bar,.mat-tab-nav-bar.mat-accent.mat-background-accent>.mat-tab-link-container .mat-ink-bar{background-color:#000}.mat-tab-group.mat-warn .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-warn .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-group.mat-warn .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-warn .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-warn .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-warn .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-warn .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-warn .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled){background-color:#a4121a4d}.mat-tab-group.mat-warn .mat-ink-bar,.mat-tab-nav-bar.mat-warn .mat-ink-bar{background-color:#c62e3c}.mat-tab-group.mat-warn.mat-background-warn>.mat-tab-header .mat-ink-bar,.mat-tab-group.mat-warn.mat-background-warn>.mat-tab-link-container .mat-ink-bar,.mat-tab-nav-bar.mat-warn.mat-background-warn>.mat-tab-header .mat-ink-bar,.mat-tab-nav-bar.mat-warn.mat-background-warn>.mat-tab-link-container .mat-ink-bar{background-color:#fff}.mat-tab-group.mat-background-primary .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-primary .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-primary .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-primary .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-primary .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-primary .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-primary .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-primary .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled){background-color:#3273a34d}.mat-tab-group.mat-background-primary>.mat-tab-header,.mat-tab-group.mat-background-primary>.mat-tab-link-container,.mat-tab-group.mat-background-primary>.mat-tab-header-pagination,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header,.mat-tab-nav-bar.mat-background-primary>.mat-tab-link-container,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header-pagination{background-color:#5fa0c5}.mat-tab-group.mat-background-primary>.mat-tab-header .mat-tab-label,.mat-tab-group.mat-background-primary>.mat-tab-link-container .mat-tab-link,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header .mat-tab-label,.mat-tab-nav-bar.mat-background-primary>.mat-tab-link-container .mat-tab-link{color:#000}.mat-tab-group.mat-background-primary>.mat-tab-header .mat-tab-label.mat-tab-disabled,.mat-tab-group.mat-background-primary>.mat-tab-link-container .mat-tab-link.mat-tab-disabled,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header .mat-tab-label.mat-tab-disabled,.mat-tab-nav-bar.mat-background-primary>.mat-tab-link-container .mat-tab-link.mat-tab-disabled{color:#0006}.mat-tab-group.mat-background-primary>.mat-tab-header .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-primary>.mat-tab-header-pagination .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-primary>.mat-tab-link-container .mat-focus-indicator:before,.mat-tab-group.mat-background-primary>.mat-tab-header .mat-focus-indicator:before,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header-pagination .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-primary>.mat-tab-link-container .mat-focus-indicator:before,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header .mat-focus-indicator:before{border-color:#000}.mat-tab-group.mat-background-primary>.mat-tab-header .mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-primary>.mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header .mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron{border-color:#000;opacity:.4}.mat-tab-group.mat-background-primary>.mat-tab-header .mat-ripple-element,.mat-tab-group.mat-background-primary>.mat-tab-link-container .mat-ripple-element,.mat-tab-group.mat-background-primary>.mat-tab-header-pagination .mat-ripple-element,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header .mat-ripple-element,.mat-tab-nav-bar.mat-background-primary>.mat-tab-link-container .mat-ripple-element,.mat-tab-nav-bar.mat-background-primary>.mat-tab-header-pagination .mat-ripple-element{background-color:#000;opacity:.12}.mat-tab-group.mat-background-accent .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-accent .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-accent .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-accent .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-accent .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-accent .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-accent .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-accent .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled){background-color:#6791754d}.mat-tab-group.mat-background-accent>.mat-tab-header,.mat-tab-group.mat-background-accent>.mat-tab-link-container,.mat-tab-group.mat-background-accent>.mat-tab-header-pagination,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header,.mat-tab-nav-bar.mat-background-accent>.mat-tab-link-container,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header-pagination{background-color:#95b8a2}.mat-tab-group.mat-background-accent>.mat-tab-header .mat-tab-label,.mat-tab-group.mat-background-accent>.mat-tab-link-container .mat-tab-link,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header .mat-tab-label,.mat-tab-nav-bar.mat-background-accent>.mat-tab-link-container .mat-tab-link{color:#000}.mat-tab-group.mat-background-accent>.mat-tab-header .mat-tab-label.mat-tab-disabled,.mat-tab-group.mat-background-accent>.mat-tab-link-container .mat-tab-link.mat-tab-disabled,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header .mat-tab-label.mat-tab-disabled,.mat-tab-nav-bar.mat-background-accent>.mat-tab-link-container .mat-tab-link.mat-tab-disabled{color:#0006}.mat-tab-group.mat-background-accent>.mat-tab-header .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-accent>.mat-tab-header-pagination .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-accent>.mat-tab-link-container .mat-focus-indicator:before,.mat-tab-group.mat-background-accent>.mat-tab-header .mat-focus-indicator:before,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header-pagination .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-accent>.mat-tab-link-container .mat-focus-indicator:before,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header .mat-focus-indicator:before{border-color:#000}.mat-tab-group.mat-background-accent>.mat-tab-header .mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-accent>.mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header .mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron{border-color:#000;opacity:.4}.mat-tab-group.mat-background-accent>.mat-tab-header .mat-ripple-element,.mat-tab-group.mat-background-accent>.mat-tab-link-container .mat-ripple-element,.mat-tab-group.mat-background-accent>.mat-tab-header-pagination .mat-ripple-element,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header .mat-ripple-element,.mat-tab-nav-bar.mat-background-accent>.mat-tab-link-container .mat-ripple-element,.mat-tab-nav-bar.mat-background-accent>.mat-tab-header-pagination .mat-ripple-element{background-color:#000;opacity:.12}.mat-tab-group.mat-background-warn .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-warn .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-warn .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-group.mat-background-warn .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-warn .mat-tab-label.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-warn .mat-tab-label.cdk-program-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-warn .mat-tab-link.cdk-keyboard-focused:not(.mat-tab-disabled),.mat-tab-nav-bar.mat-background-warn .mat-tab-link.cdk-program-focused:not(.mat-tab-disabled){background-color:#a4121a4d}.mat-tab-group.mat-background-warn>.mat-tab-header,.mat-tab-group.mat-background-warn>.mat-tab-link-container,.mat-tab-group.mat-background-warn>.mat-tab-header-pagination,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header,.mat-tab-nav-bar.mat-background-warn>.mat-tab-link-container,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header-pagination{background-color:#c62e3c}.mat-tab-group.mat-background-warn>.mat-tab-header .mat-tab-label,.mat-tab-group.mat-background-warn>.mat-tab-link-container .mat-tab-link,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header .mat-tab-label,.mat-tab-nav-bar.mat-background-warn>.mat-tab-link-container .mat-tab-link{color:#fff}.mat-tab-group.mat-background-warn>.mat-tab-header .mat-tab-label.mat-tab-disabled,.mat-tab-group.mat-background-warn>.mat-tab-link-container .mat-tab-link.mat-tab-disabled,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header .mat-tab-label.mat-tab-disabled,.mat-tab-nav-bar.mat-background-warn>.mat-tab-link-container .mat-tab-link.mat-tab-disabled{color:#fff6}.mat-tab-group.mat-background-warn>.mat-tab-header .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-warn>.mat-tab-header-pagination .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-warn>.mat-tab-link-container .mat-focus-indicator:before,.mat-tab-group.mat-background-warn>.mat-tab-header .mat-focus-indicator:before,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header-pagination .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-warn>.mat-tab-link-container .mat-focus-indicator:before,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header .mat-focus-indicator:before{border-color:#fff}.mat-tab-group.mat-background-warn>.mat-tab-header .mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-group.mat-background-warn>.mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header .mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron{border-color:#fff;opacity:.4}.mat-tab-group.mat-background-warn>.mat-tab-header .mat-ripple-element,.mat-tab-group.mat-background-warn>.mat-tab-link-container .mat-ripple-element,.mat-tab-group.mat-background-warn>.mat-tab-header-pagination .mat-ripple-element,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header .mat-ripple-element,.mat-tab-nav-bar.mat-background-warn>.mat-tab-link-container .mat-ripple-element,.mat-tab-nav-bar.mat-background-warn>.mat-tab-header-pagination .mat-ripple-element{background-color:#fff;opacity:.12}.mat-toolbar{background:whitesmoke;color:#000000de}.mat-toolbar.mat-primary{background:#5fa0c5;color:#000}.mat-toolbar.mat-accent{background:#95b8a2;color:#000}.mat-toolbar.mat-warn{background:#c62e3c;color:#fff}.mat-toolbar .mat-form-field-underline,.mat-toolbar .mat-form-field-ripple,.mat-toolbar .mat-focused .mat-form-field-ripple{background-color:currentColor}.mat-toolbar .mat-form-field-label,.mat-toolbar .mat-focused .mat-form-field-label,.mat-toolbar .mat-select-value,.mat-toolbar .mat-select-arrow,.mat-toolbar .mat-form-field.mat-focused .mat-select-arrow{color:inherit}.mat-toolbar .mat-input-element{caret-color:currentColor}.mat-toolbar-multiple-rows{min-height:64px}.mat-toolbar-row,.mat-toolbar-single-row{height:64px}@media (max-width: 599px){.mat-toolbar-multiple-rows{min-height:56px}.mat-toolbar-row,.mat-toolbar-single-row{height:56px}}.mat-tooltip{background:rgba(97,97,97,.9)}.mat-tree{background:white}.mat-tree-node,.mat-nested-tree-node{color:#000000de}.mat-tree-node{min-height:48px}.mat-snack-bar-container{color:#ffffffb3;background:#323232;box-shadow:0 3px 5px -1px #0003,0 6px 10px #00000024,0 1px 18px #0000001f}.mat-simple-snackbar-action{color:#95b8a2}.mat-badge-content{font-weight:600;font-size:12px;font-family:Roboto,Helvetica Neue,sans-serif}.mat-badge-small .mat-badge-content{font-size:9px}.mat-badge-large .mat-badge-content{font-size:24px}.mat-h1,.mat-headline,.mat-typography .mat-h1,.mat-typography .mat-headline,.mat-typography h1{font:400 24px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h2,.mat-title,.mat-typography .mat-h2,.mat-typography .mat-title,.mat-typography h2{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h3,.mat-subheading-2,.mat-typography .mat-h3,.mat-typography .mat-subheading-2,.mat-typography h3{font:400 16px/28px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h4,.mat-subheading-1,.mat-typography .mat-h4,.mat-typography .mat-subheading-1,.mat-typography h4{font:400 15px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 16px}.mat-h5,.mat-typography .mat-h5,.mat-typography h5{font:400 11.62px/20px Roboto,Helvetica Neue,sans-serif;margin:0 0 12px}.mat-h6,.mat-typography .mat-h6,.mat-typography h6{font:400 9.38px/20px Roboto,Helvetica Neue,sans-serif;margin:0 0 12px}.mat-body-strong,.mat-body-2,.mat-typography .mat-body-strong,.mat-typography .mat-body-2{font:500 14px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-body,.mat-body-1,.mat-typography .mat-body,.mat-typography .mat-body-1,.mat-typography{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-body p,.mat-body-1 p,.mat-typography .mat-body p,.mat-typography .mat-body-1 p,.mat-typography p{margin:0 0 12px}.mat-small,.mat-caption,.mat-typography .mat-small,.mat-typography .mat-caption{font:400 12px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-display-4,.mat-typography .mat-display-4{font:300 112px/112px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.05em;margin:0 0 56px}.mat-display-3,.mat-typography .mat-display-3{font:400 56px/56px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.02em;margin:0 0 64px}.mat-display-2,.mat-typography .mat-display-2{font:400 45px/48px Roboto,Helvetica Neue,sans-serif;letter-spacing:-.005em;margin:0 0 64px}.mat-display-1,.mat-typography .mat-display-1{font:400 34px/40px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0 0 64px}.mat-bottom-sheet-container{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-button,.mat-raised-button,.mat-icon-button,.mat-stroked-button,.mat-flat-button,.mat-fab,.mat-mini-fab{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-button-toggle,.mat-card{font-family:Roboto,Helvetica Neue,sans-serif}.mat-card-title{font-size:24px;font-weight:500}.mat-card-header .mat-card-title{font-size:20px}.mat-card-subtitle,.mat-card-content{font-size:14px}.mat-checkbox{font-family:Roboto,Helvetica Neue,sans-serif}.mat-checkbox-layout .mat-checkbox-label{line-height:24px}.mat-chip{font-size:14px;font-weight:500}.mat-chip .mat-chip-trailing-icon.mat-icon,.mat-chip .mat-chip-remove.mat-icon{font-size:18px}.mat-table{font-family:Roboto,Helvetica Neue,sans-serif}.mat-header-cell{font-size:12px;font-weight:500}.mat-cell,.mat-footer-cell{font-size:14px}.mat-calendar{font-family:Roboto,Helvetica Neue,sans-serif}.mat-calendar-body{font-size:13px}.mat-calendar-body-label,.mat-calendar-period-button{font-size:14px;font-weight:500}.mat-calendar-table-header th{font-size:11px;font-weight:400}.mat-dialog-title{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-expansion-panel-header{font-family:Roboto,Helvetica Neue,sans-serif;font-size:15px;font-weight:400}.mat-expansion-panel-content{font:400 14px/20px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-form-field{font-size:inherit;font-weight:400;line-height:1.125;font-family:Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-form-field-wrapper{padding-bottom:1.34375em}.mat-form-field-prefix .mat-icon,.mat-form-field-suffix .mat-icon{font-size:150%;line-height:1.125}.mat-form-field-prefix .mat-icon-button,.mat-form-field-suffix .mat-icon-button{height:1.5em;width:1.5em}.mat-form-field-prefix .mat-icon-button .mat-icon,.mat-form-field-suffix .mat-icon-button .mat-icon{height:1.125em;line-height:1.125}.mat-form-field-infix{padding:.5em 0;border-top:.84375em solid transparent}.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.34373em) scale(.75);width:133.3333533333%}.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.34372em) scale(.75);width:133.3333633333%}.mat-form-field-label-wrapper{top:-.84375em;padding-top:.84375em}.mat-form-field-label{top:1.34375em}.mat-form-field-underline{bottom:1.34375em}.mat-form-field-subscript-wrapper{font-size:75%;margin-top:.6666666667em;top:calc(100% - 1.7916666667em)}.mat-form-field-appearance-legacy .mat-form-field-wrapper{padding-bottom:1.25em}.mat-form-field-appearance-legacy .mat-form-field-infix{padding:.4375em 0}.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00106px);width:133.3333933333%}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00107px);width:133.3334033333%}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28125em) scale(.75) perspective(100px) translateZ(.00108px);width:133.3334133333%}.mat-form-field-appearance-legacy .mat-form-field-label{top:1.28125em}.mat-form-field-appearance-legacy .mat-form-field-underline{bottom:1.25em}.mat-form-field-appearance-legacy .mat-form-field-subscript-wrapper{margin-top:.5416666667em;top:calc(100% - 1.6666666667em)}@media print{.mat-form-field-appearance-legacy.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28116em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-form-field-autofill-control:-webkit-autofill+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28115em) scale(.75)}.mat-form-field-appearance-legacy.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.28114em) scale(.75)}}.mat-form-field-appearance-fill .mat-form-field-infix{padding:.25em 0 .75em}.mat-form-field-appearance-fill .mat-form-field-label{top:1.09375em;margin-top:-.5em}.mat-form-field-appearance-fill.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-fill.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-.59373em) scale(.75);width:133.3333533333%}.mat-form-field-appearance-fill.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-.59372em) scale(.75);width:133.3333633333%}.mat-form-field-appearance-outline .mat-form-field-infix{padding:1em 0}.mat-form-field-appearance-outline .mat-form-field-label{top:1.84375em;margin-top:-.25em}.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label,.mat-form-field-appearance-outline.mat-form-field-can-float .mat-input-server:focus+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.59373em) scale(.75);width:133.3333533333%}.mat-form-field-appearance-outline.mat-form-field-can-float .mat-input-server[label]:not(:label-shown)+.mat-form-field-label-wrapper .mat-form-field-label{transform:translateY(-1.59372em) scale(.75);width:133.3333633333%}.mat-grid-tile-header,.mat-grid-tile-footer{font-size:14px}.mat-grid-tile-header .mat-line,.mat-grid-tile-footer .mat-line{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-grid-tile-header .mat-line:nth-child(n+2),.mat-grid-tile-footer .mat-line:nth-child(n+2){font-size:12px}input.mat-input-element{margin-top:-.0625em}.mat-menu-item{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:400}.mat-paginator,.mat-paginator-page-size .mat-select-trigger{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px}.mat-radio-button,.mat-select{font-family:Roboto,Helvetica Neue,sans-serif}.mat-select-trigger{height:1.125em}.mat-slide-toggle-content{font-family:Roboto,Helvetica Neue,sans-serif}.mat-slider-thumb-label-text{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px;font-weight:500}.mat-stepper-vertical,.mat-stepper-horizontal{font-family:Roboto,Helvetica Neue,sans-serif}.mat-step-label{font-size:14px;font-weight:400}.mat-step-sub-label-error{font-weight:400}.mat-step-label-error{font-size:14px}.mat-step-label-selected{font-size:14px;font-weight:500}.mat-tab-group{font-family:Roboto,Helvetica Neue,sans-serif}.mat-tab-label,.mat-tab-link{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-toolbar,.mat-toolbar h1,.mat-toolbar h2,.mat-toolbar h3,.mat-toolbar h4,.mat-toolbar h5,.mat-toolbar h6{font:500 20px/32px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal;margin:0}.mat-tooltip{font-family:Roboto,Helvetica Neue,sans-serif;font-size:10px;padding-top:6px;padding-bottom:6px}.mat-tooltip-handset{font-size:14px;padding-top:8px;padding-bottom:8px}.mat-list-item,.mat-list-option{font-family:Roboto,Helvetica Neue,sans-serif}.mat-list-base .mat-list-item{font-size:16px}.mat-list-base .mat-list-item .mat-line{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list-base .mat-list-item .mat-line:nth-child(n+2){font-size:14px}.mat-list-base .mat-list-option{font-size:16px}.mat-list-base .mat-list-option .mat-line{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list-base .mat-list-option .mat-line:nth-child(n+2){font-size:14px}.mat-list-base .mat-subheader{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px;font-weight:500}.mat-list-base[dense] .mat-list-item{font-size:12px}.mat-list-base[dense] .mat-list-item .mat-line{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list-base[dense] .mat-list-item .mat-line:nth-child(n+2){font-size:12px}.mat-list-base[dense] .mat-list-option{font-size:12px}.mat-list-base[dense] .mat-list-option .mat-line{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list-base[dense] .mat-list-option .mat-line:nth-child(n+2){font-size:12px}.mat-list-base[dense] .mat-subheader{font-family:Roboto,Helvetica Neue,sans-serif;font-size:12px;font-weight:500}.mat-option{font-family:Roboto,Helvetica Neue,sans-serif;font-size:16px}.mat-optgroup-label{font:500 14px/24px Roboto,Helvetica Neue,sans-serif;letter-spacing:normal}.mat-simple-snackbar{font-family:Roboto,Helvetica Neue,sans-serif;font-size:14px}.mat-simple-snackbar-action{line-height:1;font-family:inherit;font-size:inherit;font-weight:500}.mat-tree{font-family:Roboto,Helvetica Neue,sans-serif}.mat-tree-node,.mat-nested-tree-node{font-weight:400;font-size:14px}.mat-ripple{overflow:hidden;position:relative}.mat-ripple:not(:empty){transform:translateZ(0)}.mat-ripple.mat-ripple-unbounded{overflow:visible}.mat-ripple-element{position:absolute;border-radius:50%;pointer-events:none;transition:opacity,transform 0ms cubic-bezier(0,0,.2,1);transform:scale3d(0,0,0)}.cdk-high-contrast-active .mat-ripple-element{display:none}.cdk-visually-hidden{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap;outline:0;-webkit-appearance:none;-moz-appearance:none;left:0}[dir=rtl] .cdk-visually-hidden{left:auto;right:0}.cdk-overlay-container,.cdk-global-overlay-wrapper{pointer-events:none;top:0;left:0;height:100%;width:100%}.cdk-overlay-container{position:fixed;z-index:1000}.cdk-overlay-container:empty{display:none}.cdk-global-overlay-wrapper{display:flex;position:absolute;z-index:1000}.cdk-overlay-pane{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}.cdk-overlay-backdrop{position:absolute;inset:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:1}.cdk-high-contrast-active .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.6}.cdk-overlay-dark-backdrop{background:rgba(0,0,0,.32)}.cdk-overlay-transparent-backdrop{transition:visibility 1ms linear,opacity 1ms linear;visibility:hidden;opacity:1}.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing{opacity:0;visibility:visible}.cdk-overlay-backdrop-noop-animation{transition:none}.cdk-overlay-connected-position-bounding-box{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}.cdk-global-scrollblock{position:fixed;width:100%;overflow-y:scroll}textarea.cdk-textarea-autosize{resize:none}textarea.cdk-textarea-autosize-measuring{padding:2px 0!important;box-sizing:content-box!important;height:auto!important;overflow:hidden!important}textarea.cdk-textarea-autosize-measuring-firefox{padding:2px 0!important;box-sizing:content-box!important;height:0!important}@keyframes cdk-text-field-autofill-start{}@keyframes cdk-text-field-autofill-end{}.cdk-text-field-autofill-monitored:-webkit-autofill{animation:cdk-text-field-autofill-start 0s 1ms}.cdk-text-field-autofill-monitored:not(:-webkit-autofill){animation:cdk-text-field-autofill-end 0s 1ms}.mat-focus-indicator{position:relative}.mat-focus-indicator:before{inset:0;position:absolute;box-sizing:border-box;pointer-events:none;display:var(--mat-focus-indicator-display, none);border:var(--mat-focus-indicator-border-width, 3px) var(--mat-focus-indicator-border-style, solid) var(--mat-focus-indicator-border-color, transparent);border-radius:var(--mat-focus-indicator-border-radius, 4px)}.mat-focus-indicator:focus:before{content:""}.cdk-high-contrast-active{--mat-focus-indicator-display: block}.mat-mdc-focus-indicator{position:relative}.mat-mdc-focus-indicator:before{inset:0;position:absolute;box-sizing:border-box;pointer-events:none;display:var(--mat-mdc-focus-indicator-display, none);border:var(--mat-mdc-focus-indicator-border-width, 3px) var(--mat-mdc-focus-indicator-border-style, solid) var(--mat-mdc-focus-indicator-border-color, transparent);border-radius:var(--mat-mdc-focus-indicator-border-radius, 4px)}.mat-mdc-focus-indicator:focus:before{content:""}.cdk-high-contrast-active{--mat-mdc-focus-indicator-display: block}label.question-label{margin:10px 0 0;font-weight:bolder;width:100%}.question-icon{color:#00000061;padding:0 .5em}.required{color:#c62e3c;font-size:.5em;vertical-align:super}.mat-form-field{margin-bottom:10px;width:100%}.form-group{width:100%;padding-right:20px}.example-spacer{flex:1 1 auto}:host ::ng-deep .mat-input-element:disabled{color:currentColor}:host ::ng-deep .mat-select-disabled .mat-select-value{color:currentColor}:host ::ng-deep .mat-radio-disabled .mat-radio-label-content{color:currentColor}:host ::ng-deep .mat-radio-disabled .mat-radio-inner-circle{background-color:currentColor}:host ::ng-deep .mat-radio-disabled .mat-radio-outer-circle{border-color:currentColor!important}:host ::ng-deep .mat-checkbox-disabled .mat-checkbox-label{color:currentColor}:host ::ng-deep .mat-checkbox-disabled .mat-checkbox-frame{border-color:currentColor}:host ::ng-deep .mat-checkbox-disabled .mat-checkbox-disabled.mat-checkbox-checked .mat-checkbox-background{background-color:#b0b0b0}:host ::ng-deep .mat-checkbox-disabled.mat-checkbox-checked .mat-checkbox-label{color:currentColor}:host ::ng-deep .mat-checkbox-disabled.mat-checkbox-checked .mat-checkbox-frame{border-color:currentColor}:host ::ng-deep .mat-checkbox-disabled.mat-checkbox-checked .mat-checkbox-background{background-color:currentColor}:host ::ng-deep .mat-form-field-infix{padding-top:0}:host ::ng-deep .mat-form-field{padding:5px 0}.mat-form-field-radio,.mat-form-field-checkbox{padding:15px 0 20px}.section-break{font-size:2.5vw;width:100%;margin:20px 0}.static-image{margin:20px 0;width:auto;display:flex;flex-direction:column}.static-image .caption{padding:10px;font-style:italic;text-align:center}.static-video{margin:20px 0;width:auto;display:flex;flex-direction:column}.static-video .caption{padding:10px;font-style:italic;text-align:center}.fa-stack{position:relative;display:inline-block;width:3em;height:3em;line-height:3em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;width:100%;text-align:center}.fa-stack-1x{font-size:.8em;color:#fff}.fa-stack-2x{font-size:1.2em}.tooltip{white-space:pre-line}\n'],
          encapsulation: 2
        });
      }
      return wl;
    })();
    const Bme = ["*", [["mat-toolbar-row"]]],
      jme = ["*", "mat-toolbar-row"],
      Ume = Qa(class {
        constructor(n) {
          this._elementRef = n;
        }
      });
    let Gme = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n,
          selectors: [["mat-toolbar-row"]],
          hostAttrs: [1, "mat-toolbar-row"],
          exportAs: ["matToolbarRow"]
        }), n;
      })(),
      Wme = (() => {
        class n extends Ume {
          constructor(e, a, i) {
            super(e), this._platform = a, this._document = i;
          }
          ngAfterViewInit() {
            this._platform.isBrowser && (this._checkToolbarMixedModes(), this._toolbarRows.changes.subscribe(() => this._checkToolbarMixedModes()));
          }
          _checkToolbarMixedModes() {}
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(Ct), f(ie));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-toolbar"]],
          contentQueries: function (e, a, i) {
            if (1 & e && De(i, Gme, 5), 2 & e) {
              let o;
              H(o = B()) && (a._toolbarRows = o);
            }
          },
          hostAttrs: [1, "mat-toolbar"],
          hostVars: 4,
          hostBindings: function (e, a) {
            2 & e && fe("mat-toolbar-multiple-rows", a._toolbarRows.length > 0)("mat-toolbar-single-row", 0 === a._toolbarRows.length);
          },
          inputs: {
            color: "color"
          },
          exportAs: ["matToolbar"],
          features: [z],
          ngContentSelectors: jme,
          decls: 2,
          vars: 0,
          template: function (e, a) {
            1 & e && (lt(Bme), Me(0), Me(1, 1));
          },
          styles: [".cdk-high-contrast-active .mat-toolbar{outline:solid 1px}.mat-toolbar-row,.mat-toolbar-single-row{display:flex;box-sizing:border-box;padding:0 16px;width:100%;flex-direction:row;align-items:center;white-space:nowrap}.mat-toolbar-multiple-rows{display:flex;box-sizing:border-box;flex-direction:column;width:100%}"],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })(),
      Dx = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [$, $]
        }), n;
      })();
    class ot {
      static reservedAttributeName = "__reserved__attribute_name";
      static reservedAttributeValue = "__reserved__attribute_value";
      static reservedDefaultAttributeName = "Attribute Value Field";
      static properties = "properties";
      static atContext = "@context";
      static atId = "@id";
      static atType = "@type";
      static atValue = "@value";
      static schemaIsBasedOn = "schema:isBasedOn";
      static schemaName = "schema:name";
      static schemaDescription = "schema:description";
      static pavDerivedFrom = "pav:derivedFrom";
      static pavCreatedOn = "pav:createdOn";
      static pavCreatedBy = "pav:createdBy";
      static pavLastUpdatedOn = "pav:lastUpdatedOn";
      static oslcModifiedBy = "oslc:modifiedBy";
      static rdfsLabel = "rdfs:label";
      static termUri = "termUri";
      static builtInProperties = new Map([[ot.atId, !0], [ot.atContext, !0], [ot.atType, !0], [ot.schemaIsBasedOn, !0], [ot.schemaName, !0], [ot.schemaDescription, !0], [ot.pavDerivedFrom, !0], [ot.pavCreatedOn, !0], [ot.pavCreatedBy, !0], [ot.pavLastUpdatedOn, !0], [ot.oslcModifiedBy, !0]]);
    }
    let ws = /*#__PURE__*/(() => {
      class ws {
        eventHandler = null;
        constructor() {}
        injectEventHandler(t) {
          this.eventHandler = t;
        }
        trace(t) {
          console.log("TRACE: " + t);
        }
        traceObject(t, e) {
          console.log("TRACE: " + t), console.log(e);
        }
        error(t) {
          console.error("ERROR: " + t);
        }
        errorObject(t, e) {
          console.error("ERROR: " + t), console.error(e);
        }
        static ɵfac = function (e) {
          return new (e || ws)();
        };
        static ɵprov = R({
          token: ws,
          factory: ws.ɵfac,
          providedIn: "root"
        });
      }
      return ws;
    })();
    let Ko = /*#__PURE__*/(() => {
      class Ko {
        http;
        messageHandlerService;
        MAX_CHECK = 500;
        TEMPLATE_FILENAME = "template.json";
        METADATA_FILENAME = "metadata.json";
        TEMPLATE_REGISTRY_FILENAME = "registry.json";
        TEMPLATE_NUMBER = "num";
        TEMPLATE_LABEL = "label";
        allTemplates;
        templateJsonSubject = new Xi(null);
        templateJson$ = this.templateJsonSubject.asObservable();
        metadataJsonSubject = new Xi(null);
        metadataJson$ = this.metadataJsonSubject.asObservable();
        loadedTemplate = null;
        loadedMetadata = null;
        attemptedFileCount = 0;
        templateNum = "";
        constructor(t, e) {
          this.http = t, this.messageHandlerService = e;
        }
        loadTemplate(t, e) {
          t = this.fixedLocationPrefix(t), this.attemptedFileCount = 0, this.templateNum = e, this.loadedTemplate = null, this.loadedMetadata = null, this.loadTemplateFromURL(t + e + "/" + this.TEMPLATE_FILENAME, e), this.loadMetadataFromURL(t + e + "/" + this.METADATA_FILENAME, e);
        }
        loadTemplateFromURL(t, e = null) {
          e || (e = this.templateNumberFromUrl(t)), this.http.get(t).subscribe(a => {
            this.attemptedFileCount++, this.loadedTemplate = a, this.messageHandlerService.trace("Loaded template: " + t + " (" + JSON.stringify(a).length + " characters)"), this.handleLoadedDataFiles();
          }, () => {
            this.attemptedFileCount++, this.loadedTemplate = null, this.messageHandlerService.error("Error while loading sample template from: " + t), this.handleLoadedDataFiles();
          });
        }
        loadMetadataFromURL(t, e = null) {
          e || (e = this.templateNumberFromUrl(t)), this.http.get(t).subscribe(a => {
            this.attemptedFileCount++, this.loadedMetadata = a, this.messageHandlerService.trace("Loaded metadata: " + t + " (" + JSON.stringify(a).length + " characters)"), this.handleLoadedDataFiles();
          }, a => {
            this.attemptedFileCount++, this.loadedMetadata = null, this.messageHandlerService.error("Error while loading sample metadata from: " + t), this.handleLoadedDataFiles();
          });
        }
        handleLoadedDataFiles() {
          if (2 === this.attemptedFileCount) {
            const t = {};
            t[this.templateNum] = this.loadedTemplate, this.templateJsonSubject.next(t);
            const e = {};
            e[this.templateNum] = this.loadedMetadata, this.metadataJsonSubject.next(e);
          }
        }
        getSampleTemplatesFromRegistry(t) {
          return this.allTemplates || (t = this.fixedLocationPrefix(t), this.allTemplates = this.http.get(t + this.TEMPLATE_REGISTRY_FILENAME).pipe(We(a => Object.keys(a).sort().map((i, o) => {
            const r = {};
            return r[this.TEMPLATE_NUMBER] = i, r[this.TEMPLATE_LABEL] = a[i], r;
          })), U2(a => (this.messageHandlerService.errorObject(a.message, a), Ec)))), this.allTemplates;
        }
        getSampleTemplatesDynamically(t) {
          return this.allTemplates || (t = this.fixedLocationPrefix(t), this.buildAllTemplatesDynamically(t)), this.allTemplates;
        }
        buildAllTemplatesDynamically(t) {
          const e = [];
          this.getAllTemplatesSubscription(t).subscribe(a => {
            const i = {};
            i[this.TEMPLATE_NUMBER] = Object.keys(a)[0], i[this.TEMPLATE_LABEL] = Object.values(a)[0], e.push(i);
          }), this.allTemplates = nt(e);
        }
        getAllTemplatesSubscription(t) {
          const e = [],
            a = new V();
          let i = 0;
          for (let o = 1; o <= this.MAX_CHECK; o++) {
            const r = o < 10 ? "0" + o.toString() : o.toString();
            e.push(t + r + "/" + this.TEMPLATE_FILENAME);
          }
          return lo(e).pipe(mM(o => {
            const r = this.templateNumberFromUrl(o);
            return this.getSingleTemplateLabel(o).pipe(We(s => {
              i = 0;
              const c = {};
              return c[r] = "Template " + r + " - " + s, c;
            }), U2(s => (0 === s.status ? i++ : this.messageHandlerService.errorObject(s.message, s), i > 1 && (a.next(), a.complete()), Ec)));
          }), ne(a));
        }
        getSingleTemplateLabel(t) {
          return this.http.get(t).pipe(We(e => null != e && e[ot.schemaName] ? e[ot.schemaName] : null));
        }
        templateNumberFromUrl(t) {
          const a = new RegExp("\\/(\\d+)\\/" + this.TEMPLATE_FILENAME),
            i = t.match(a);
          return i && i.length > 1 ? i[1] : "-1";
        }
        fixedLocationPrefix(t) {
          const a = new RegExp("\\/$");
          return t.match(a) || (t += "/"), t;
        }
        static ɵfac = function (e) {
          return new (e || Ko)(M(Yo), M(ws));
        };
        static ɵprov = R({
          token: Ko,
          factory: Ko.ɵfac,
          providedIn: "root"
        });
      }
      return Ko;
    })();
    function Yme(n, t) {
      if (1 & n && (Kn(), j(0, "circle", 4)), 2 & n) {
        const e = x(),
          a = Kt(1);
        en("animation-name", "mat-progress-spinner-stroke-rotate-" + e._spinnerAnimationLabel)("stroke-dashoffset", e._getStrokeDashOffset(), "px")("stroke-dasharray", e._getStrokeCircumference(), "px")("stroke-width", e._getCircleStrokeWidth(), "%")("transform-origin", e._getCircleTransformOrigin(a)), X("r", e._getCircleRadius());
      }
    }
    function qme(n, t) {
      if (1 & n && (Kn(), j(0, "circle", 4)), 2 & n) {
        const e = x(),
          a = Kt(1);
        en("stroke-dashoffset", e._getStrokeDashOffset(), "px")("stroke-dasharray", e._getStrokeCircumference(), "px")("stroke-width", e._getCircleStrokeWidth(), "%")("transform-origin", e._getCircleTransformOrigin(a)), X("r", e._getCircleRadius());
      }
    }
    const Qme = Qa(class {
        constructor(n) {
          this._elementRef = n;
        }
      }, "primary"),
      Zme = new O("mat-progress-spinner-default-options", {
        providedIn: "root",
        factory: function Xme() {
          return {
            diameter: 100
          };
        }
      });
    class $a extends Qme {
      constructor(t, e, a, i, o, r, s, c) {
        super(t), this._document = a, this._diameter = 100, this._value = 0, this._resizeSubscription = re.EMPTY, this.mode = "determinate";
        const l = $a._diameters;
        this._spinnerAnimationLabel = this._getSpinnerAnimationLabel(), l.has(a.head) || l.set(a.head, new Set([100])), this._noopAnimations = "NoopAnimations" === i && !!o && !o._forceAnimations, "mat-spinner" === t.nativeElement.nodeName.toLowerCase() && (this.mode = "indeterminate"), o && (o.color && (this.color = this.defaultColor = o.color), o.diameter && (this.diameter = o.diameter), o.strokeWidth && (this.strokeWidth = o.strokeWidth)), e.isBrowser && e.SAFARI && s && r && c && (this._resizeSubscription = s.change(150).subscribe(() => {
          "indeterminate" === this.mode && c.run(() => r.markForCheck());
        }));
      }
      get diameter() {
        return this._diameter;
      }
      set diameter(t) {
        this._diameter = xt(t), this._spinnerAnimationLabel = this._getSpinnerAnimationLabel(), this._styleRoot && this._attachStyleNode();
      }
      get strokeWidth() {
        return this._strokeWidth || this.diameter / 10;
      }
      set strokeWidth(t) {
        this._strokeWidth = xt(t);
      }
      get value() {
        return "determinate" === this.mode ? this._value : 0;
      }
      set value(t) {
        this._value = Math.max(0, Math.min(100, xt(t)));
      }
      ngOnInit() {
        const t = this._elementRef.nativeElement;
        this._styleRoot = Kd(t) || this._document.head, this._attachStyleNode(), t.classList.add("mat-progress-spinner-indeterminate-animation");
      }
      ngOnDestroy() {
        this._resizeSubscription.unsubscribe();
      }
      _getCircleRadius() {
        return (this.diameter - 10) / 2;
      }
      _getViewBox() {
        const t = 2 * this._getCircleRadius() + this.strokeWidth;
        return `0 0 ${t} ${t}`;
      }
      _getStrokeCircumference() {
        return 2 * Math.PI * this._getCircleRadius();
      }
      _getStrokeDashOffset() {
        return "determinate" === this.mode ? this._getStrokeCircumference() * (100 - this._value) / 100 : null;
      }
      _getCircleStrokeWidth() {
        return this.strokeWidth / this.diameter * 100;
      }
      _getCircleTransformOrigin(t) {
        const e = 50 * (t.currentScale ?? 1);
        return `${e}% ${e}%`;
      }
      _attachStyleNode() {
        const t = this._styleRoot,
          e = this._diameter,
          a = $a._diameters;
        let i = a.get(t);
        if (!i || !i.has(e)) {
          const o = this._document.createElement("style");
          o.setAttribute("mat-spinner-animation", this._spinnerAnimationLabel), o.textContent = this._getAnimationText(), t.appendChild(o), i || (i = new Set(), a.set(t, i)), i.add(e);
        }
      }
      _getAnimationText() {
        const t = this._getStrokeCircumference();
        return "\n @keyframes mat-progress-spinner-stroke-rotate-DIAMETER {\n    0%      { stroke-dashoffset: START_VALUE;  transform: rotate(0); }\n    12.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(0); }\n    12.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(72.5deg); }\n    25%     { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(72.5deg); }\n\n    25.0001%   { stroke-dashoffset: START_VALUE;  transform: rotate(270deg); }\n    37.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(270deg); }\n    37.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(161.5deg); }\n    50%     { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(161.5deg); }\n\n    50.0001%  { stroke-dashoffset: START_VALUE;  transform: rotate(180deg); }\n    62.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(180deg); }\n    62.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(251.5deg); }\n    75%     { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(251.5deg); }\n\n    75.0001%  { stroke-dashoffset: START_VALUE;  transform: rotate(90deg); }\n    87.5%   { stroke-dashoffset: END_VALUE;    transform: rotate(90deg); }\n    87.5001%  { stroke-dashoffset: END_VALUE;    transform: rotateX(180deg) rotate(341.5deg); }\n    100%    { stroke-dashoffset: START_VALUE;  transform: rotateX(180deg) rotate(341.5deg); }\n  }\n".replace(/START_VALUE/g, "" + .95 * t).replace(/END_VALUE/g, "" + .2 * t).replace(/DIAMETER/g, `${this._spinnerAnimationLabel}`);
      }
      _getSpinnerAnimationLabel() {
        return this.diameter.toString().replace(".", "_");
      }
    }
    $a._diameters = new WeakMap(), $a.ɵfac = function (t) {
      return new (t || $a)(f(J), f(Ct), f(ie, 8), f(Ft, 8), f(Zme), f(Se), f(Ki), f(ae));
    }, $a.ɵcmp = q({
      type: $a,
      selectors: [["mat-progress-spinner"], ["mat-spinner"]],
      hostAttrs: ["role", "progressbar", "tabindex", "-1", 1, "mat-progress-spinner", "mat-spinner"],
      hostVars: 10,
      hostBindings: function (t, e) {
        2 & t && (X("aria-valuemin", "determinate" === e.mode ? 0 : null)("aria-valuemax", "determinate" === e.mode ? 100 : null)("aria-valuenow", "determinate" === e.mode ? e.value : null)("mode", e.mode), en("width", e.diameter, "px")("height", e.diameter, "px"), fe("_mat-animation-noopable", e._noopAnimations));
      },
      inputs: {
        color: "color",
        diameter: "diameter",
        strokeWidth: "strokeWidth",
        mode: "mode",
        value: "value"
      },
      exportAs: ["matProgressSpinner"],
      features: [z],
      decls: 4,
      vars: 8,
      consts: [["preserveAspectRatio", "xMidYMid meet", "focusable", "false", "aria-hidden", "true", 3, "ngSwitch"], ["svg", ""], ["cx", "50%", "cy", "50%", 3, "animation-name", "stroke-dashoffset", "stroke-dasharray", "stroke-width", "transform-origin", 4, "ngSwitchCase"], ["cx", "50%", "cy", "50%", 3, "stroke-dashoffset", "stroke-dasharray", "stroke-width", "transform-origin", 4, "ngSwitchCase"], ["cx", "50%", "cy", "50%"]],
      template: function (t, e) {
        1 & t && (Kn(), _(0, "svg", 0, 1), D(2, Yme, 1, 11, "circle", 2), D(3, qme, 1, 9, "circle", 3), y()), 2 & t && (en("width", e.diameter, "px")("height", e.diameter, "px"), b("ngSwitch", "indeterminate" === e.mode), X("viewBox", e._getViewBox()), g(2), b("ngSwitchCase", !0), g(1), b("ngSwitchCase", !1));
      },
      dependencies: [Gi, Wr],
      styles: [".mat-progress-spinner{display:block;position:relative;overflow:hidden}.mat-progress-spinner svg{position:absolute;transform:rotate(-90deg);top:0;left:0;transform-origin:center;overflow:visible}.mat-progress-spinner circle{fill:rgba(0,0,0,0);transition:stroke-dashoffset 225ms linear}.cdk-high-contrast-active .mat-progress-spinner circle{stroke:CanvasText}.mat-progress-spinner[mode=indeterminate] svg{animation:mat-progress-spinner-linear-rotate 2000ms linear infinite}.mat-progress-spinner[mode=indeterminate] circle{transition-property:stroke;animation-duration:4000ms;animation-timing-function:cubic-bezier(0.35, 0, 0.25, 1);animation-iteration-count:infinite}.mat-progress-spinner._mat-animation-noopable svg,.mat-progress-spinner._mat-animation-noopable circle{animation:none;transition:none}@keyframes mat-progress-spinner-linear-rotate{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes mat-progress-spinner-stroke-rotate-100{0%{stroke-dashoffset:268.606171575px;transform:rotate(0)}12.5%{stroke-dashoffset:56.5486677px;transform:rotate(0)}12.5001%{stroke-dashoffset:56.5486677px;transform:rotateX(180deg) rotate(72.5deg)}25%{stroke-dashoffset:268.606171575px;transform:rotateX(180deg) rotate(72.5deg)}25.0001%{stroke-dashoffset:268.606171575px;transform:rotate(270deg)}37.5%{stroke-dashoffset:56.5486677px;transform:rotate(270deg)}37.5001%{stroke-dashoffset:56.5486677px;transform:rotateX(180deg) rotate(161.5deg)}50%{stroke-dashoffset:268.606171575px;transform:rotateX(180deg) rotate(161.5deg)}50.0001%{stroke-dashoffset:268.606171575px;transform:rotate(180deg)}62.5%{stroke-dashoffset:56.5486677px;transform:rotate(180deg)}62.5001%{stroke-dashoffset:56.5486677px;transform:rotateX(180deg) rotate(251.5deg)}75%{stroke-dashoffset:268.606171575px;transform:rotateX(180deg) rotate(251.5deg)}75.0001%{stroke-dashoffset:268.606171575px;transform:rotate(90deg)}87.5%{stroke-dashoffset:56.5486677px;transform:rotate(90deg)}87.5001%{stroke-dashoffset:56.5486677px;transform:rotateX(180deg) rotate(341.5deg)}100%{stroke-dashoffset:268.606171575px;transform:rotateX(180deg) rotate(341.5deg)}}"],
      encapsulation: 2,
      changeDetection: 0
    });
    let Ox = (() => {
      class n {}
      return n.ɵfac = function (e) {
        return new (e || n)();
      }, n.ɵmod = W({
        type: n
      }), n.ɵinj = U({
        imports: [$, yt, $]
      }), n;
    })();
    const $me = ["searchSelectInput"],
      ehe = ["innerSelectSearch"];
    function the(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "mat-checkbox", 9), F("change", function (i) {
          return pe(e), ge(x()._emitSelectAllBooleanToParent(i.checked));
        }), y();
      }
      if (2 & n) {
        const e = x();
        b("color", null == e.matFormField ? null : e.matFormField.color)("checked", e.toggleAllCheckboxChecked)("indeterminate", e.toggleAllCheckboxIndeterminate)("matTooltip", e.toggleAllCheckboxTooltipMessage)("matTooltipPosition", e.toogleAllCheckboxTooltipPosition);
      }
    }
    function nhe(n, t) {
      1 & n && j(0, "mat-spinner", 10);
    }
    function ahe(n, t) {
      1 & n && Me(0, 1, ["*ngIf", "clearIcon; else defaultIcon"]);
    }
    function ihe(n, t) {
      if (1 & n && (_(0, "mat-icon", 14), S(1), y()), 2 & n) {
        const e = x(2);
        b("svgIcon", e.closeSvgIcon), g(1), Fe(" ", e.closeSvgIcon ? null : e.closeIcon, " ");
      }
    }
    function ohe(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "button", 11), F("click", function () {
          return pe(e), ge(x()._reset(!0));
        }), D(1, ahe, 1, 0, "ng-content", 12), D(2, ihe, 2, 2, "ng-template", null, 13, q1), y();
      }
      if (2 & n) {
        const e = Kt(3),
          a = x();
        g(1), b("ngIf", a.clearIcon)("ngIfElse", e);
      }
    }
    function rhe(n, t) {
      1 & n && Me(0, 2, ["*ngIf", "noEntriesFound; else defaultNoEntriesFound"]);
    }
    function she(n, t) {
      1 & n && S(0), 2 & n && Ie(x(2).noEntriesFoundLabel);
    }
    function che(n, t) {
      if (1 & n && (_(0, "div", 15), D(1, rhe, 1, 0, "ng-content", 12), D(2, she, 1, 1, "ng-template", null, 16, q1), y()), 2 & n) {
        const e = Kt(3),
          a = x();
        g(1), b("ngIf", a.noEntriesFound)("ngIfElse", e);
      }
    }
    const lhe = [[["", 8, "mat-select-search-custom-header-content"]], [["", "ngxMatSelectSearchClear", ""]], [["", "ngxMatSelectNoEntriesFound", ""]]],
      dhe = function (n, t) {
        return {
          "mat-select-search-inner-multiple": n,
          "mat-select-search-inner-toggle-all": t
        };
      },
      uhe = [".mat-select-search-custom-header-content", "[ngxMatSelectSearchClear]", "[ngxMatSelectNoEntriesFound]"];
    let fhe = (() => {
      class n {}
      return n.ɵfac = function (e) {
        return new (e || n)();
      }, n.ɵdir = P({
        type: n,
        selectors: [["", "ngxMatSelectSearchClear", ""]]
      }), n;
    })();
    const mhe = ["ariaLabel", "clearSearchInput", "closeIcon", "closeSvgIcon", "disableInitialFocus", "disableScrollToActiveOnOptionsChanged", "enableClearOnEscapePressed", "hideClearSearchButton", "indexAndLengthScreenReaderText", "noEntriesFoundLabel", "placeholderLabel", "preventHomeEndKeyPropagation", "searching"],
      hhe = new O("mat-selectsearch-default-options");
    let phe = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "ngxMatSelectNoEntriesFound", ""]]
        }), n;
      })(),
      ghe = (() => {
        class n {
          constructor(e, a, i, o = null, r, s = null, c) {
            this.matSelect = e, this.changeDetectorRef = a, this._viewportRuler = i, this.matOption = o, this.liveAnnouncer = r, this.matFormField = s, this.placeholderLabel = "Suche", this.type = "text", this.closeIcon = "close", this.noEntriesFoundLabel = "Keine Optionen gefunden", this.indexAndLengthScreenReaderText = " of ", this.clearSearchInput = !0, this.searching = !1, this.disableInitialFocus = !1, this.enableClearOnEscapePressed = !1, this.preventHomeEndKeyPropagation = !1, this.disableScrollToActiveOnOptionsChanged = !1, this.ariaLabel = "dropdown search", this.showToggleAllCheckbox = !1, this.toggleAllCheckboxChecked = !1, this.toggleAllCheckboxIndeterminate = !1, this.toggleAllCheckboxTooltipMessage = "", this.toogleAllCheckboxTooltipPosition = "below", this.hideClearSearchButton = !1, this.alwaysRestoreSelectedOptionsMulti = !1, this.toggleAll = new E(), this.onTouched = l => {}, this._options$ = new Xi(null), this.optionsList$ = this._options$.pipe(gi(l => l ? l.changes.pipe(We(d => d.toArray()), Gt(l.toArray())) : nt(null))), this.optionsLength$ = this.optionsList$.pipe(We(l => l ? l.length : 0)), this._formControl = new at(""), this._showNoEntriesFound$ = Nv([this._formControl.valueChanges, this.optionsLength$]).pipe(We(([l, d]) => this.noEntriesFoundLabel && l && d === this.getOptionsLengthOffset())), this._onDestroy = new V(), this.applyDefaultOptions(c);
          }
          get isInsideMatOption() {
            return !!this.matOption;
          }
          get value() {
            return this._formControl.value;
          }
          set _options(e) {
            this._options$.next(e);
          }
          get _options() {
            return this._options$.getValue();
          }
          applyDefaultOptions(e) {
            if (e) for (const a of mhe) e.hasOwnProperty(a) && (this[a] = e[a]);
          }
          ngOnInit() {
            const e = "mat-select-search-panel";
            this.matSelect.panelClass ? Array.isArray(this.matSelect.panelClass) ? this.matSelect.panelClass.push(e) : "string" == typeof this.matSelect.panelClass ? this.matSelect.panelClass = [this.matSelect.panelClass, e] : "object" == typeof this.matSelect.panelClass && (this.matSelect.panelClass[e] = !0) : this.matSelect.panelClass = e, this.matOption ? (this.matOption.disabled = !0, this.matOption._getHostElement().classList.add("contains-mat-select-search")) : console.error("<ngx-mat-select-search> must be placed inside a <mat-option> element"), this.matSelect.openedChange.pipe(mx(1), ne(this._onDestroy)).subscribe(a => {
              a ? (this.updateInputWidth(), this.disableInitialFocus || this._focus()) : this.clearSearchInput && this._reset();
            }), this.matSelect.openedChange.pipe($e(1)).pipe(ne(this._onDestroy)).subscribe(() => {
              this.matSelect._keyManager ? this.matSelect._keyManager.change.pipe(ne(this._onDestroy)).subscribe(() => this.adjustScrollTopToFitActiveOptionIntoView()) : console.log("_keyManager was not initialized."), this._options = this.matSelect.options;
              let a = this._options.toArray()[this.getOptionsLengthOffset()];
              this._options.changes.pipe(ne(this._onDestroy)).subscribe(() => {
                setTimeout(() => {
                  const i = this._options.toArray(),
                    o = i[this.getOptionsLengthOffset()],
                    r = this.matSelect._keyManager;
                  r && this.matSelect.panelOpen && ((!this.matSelect.compareWith(a, o) || !r.activeItem || !i.find(c => this.matSelect.compareWith(c, r.activeItem))) && r.setFirstItemActive(), setTimeout(() => {
                    this.updateInputWidth();
                  }), this.disableScrollToActiveOnOptionsChanged || this.adjustScrollTopToFitActiveOptionIntoView()), a = o;
                });
              });
            }), this._showNoEntriesFound$.pipe(ne(this._onDestroy)).subscribe(a => {
              this.matOption && (a ? this.matOption._getHostElement().classList.add("mat-select-search-no-entries-found") : this.matOption._getHostElement().classList.remove("mat-select-search-no-entries-found"));
            }), this._viewportRuler.change().pipe(ne(this._onDestroy)).subscribe(() => {
              this.matSelect.panelOpen && this.updateInputWidth();
            }), this.initMultipleHandling(), this.optionsList$.pipe(ne(this._onDestroy)).subscribe(() => {
              this.changeDetectorRef.markForCheck();
            });
          }
          _emitSelectAllBooleanToParent(e) {
            this.toggleAll.emit(e);
          }
          ngOnDestroy() {
            this._onDestroy.next(), this._onDestroy.complete();
          }
          _isToggleAllCheckboxVisible() {
            return this.matSelect.multiple && this.showToggleAllCheckbox;
          }
          _handleKeydown(e) {
            (e.key && 1 === e.key.length || e.keyCode >= 65 && e.keyCode <= 90 || e.keyCode >= 48 && e.keyCode <= 57 || 32 === e.keyCode || this.preventHomeEndKeyPropagation && (36 === e.keyCode || 35 === e.keyCode)) && e.stopPropagation(), this.matSelect.multiple && e.key && 13 === e.keyCode && setTimeout(() => this._focus()), !0 === this.enableClearOnEscapePressed && 27 === e.keyCode && this.value && (this._reset(!0), e.stopPropagation());
          }
          _handleKeyup(e) {
            if (38 === e.keyCode || 40 === e.keyCode) {
              const a = this.matSelect._getAriaActiveDescendant(),
                i = this._options.toArray().findIndex(o => o.id === a);
              if (-1 !== i) {
                const o = this._options.toArray()[i];
                this.liveAnnouncer.announce(o.viewValue + " " + this.getAriaIndex(i) + this.indexAndLengthScreenReaderText + this.getAriaLength());
              }
            }
          }
          getAriaIndex(e) {
            return 0 === this.getOptionsLengthOffset() ? e + 1 : e;
          }
          getAriaLength() {
            return this._options.toArray().length - this.getOptionsLengthOffset();
          }
          writeValue(e) {
            this._lastExternalInputValue = e, this._formControl.setValue(e), this.changeDetectorRef.markForCheck();
          }
          onBlur() {
            this.onTouched();
          }
          registerOnChange(e) {
            this._formControl.valueChanges.pipe(Ht(a => a !== this._lastExternalInputValue), rs(() => this._lastExternalInputValue = void 0), ne(this._onDestroy)).subscribe(e);
          }
          registerOnTouched(e) {
            this.onTouched = e;
          }
          _focus() {
            if (!this.searchSelectInput || !this.matSelect.panel) return;
            const e = this.matSelect.panel.nativeElement,
              a = e.scrollTop;
            this.searchSelectInput.nativeElement.focus(), e.scrollTop = a;
          }
          _reset(e) {
            this._formControl.setValue(""), e && this._focus();
          }
          initMultipleHandling() {
            this.matSelect.ngControl ? (this.previousSelectedValues = this.matSelect.ngControl.value, this.matSelect.ngControl.valueChanges.pipe(ne(this._onDestroy)).subscribe(e => {
              let a = !1;
              if (this.matSelect.multiple && (this.alwaysRestoreSelectedOptionsMulti || this._formControl.value && this._formControl.value.length) && this.previousSelectedValues && Array.isArray(this.previousSelectedValues)) {
                (!e || !Array.isArray(e)) && (e = []);
                const i = this.matSelect.options.map(o => o.value);
                this.previousSelectedValues.forEach(o => {
                  !e.some(r => this.matSelect.compareWith(r, o)) && !i.some(r => this.matSelect.compareWith(r, o)) && (e.push(o), a = !0);
                });
              }
              this.previousSelectedValues = e, a && this.matSelect._onChange(e);
            })) : this.matSelect.multiple && console.error("the mat-select containing ngx-mat-select-search must have a ngModel or formControl directive when multiple=true");
          }
          adjustScrollTopToFitActiveOptionIntoView() {
            if (this.matSelect.panel && this.matSelect.options.length > 0) {
              const e = this.getMatOptionHeight(),
                a = this.matSelect._keyManager.activeItemIndex || 0,
                i = k2(a, this.matSelect.options, this.matSelect.optionGroups),
                o = (this.matOption ? -1 : 0) + i + a,
                r = this.matSelect.panel.nativeElement.scrollTop,
                s = this.innerSelectSearch.nativeElement.offsetHeight,
                c = Math.floor((256 - s) / e),
                l = Math.round((r + s) / e) - 1;
              l >= o ? this.matSelect.panel.nativeElement.scrollTop = o * e : l + c <= o && (this.matSelect.panel.nativeElement.scrollTop = (o + 1) * e - (256 - s));
            }
          }
          updateInputWidth() {
            if (!this.innerSelectSearch || !this.innerSelectSearch.nativeElement) return;
            let a,
              e = this.innerSelectSearch.nativeElement;
            for (; e = e.parentElement;) if (e.classList.contains("mat-select-panel")) {
              a = e;
              break;
            }
            a && (this.innerSelectSearch.nativeElement.style.width = a.clientWidth + "px");
          }
          getMatOptionHeight() {
            return this.matSelect.options.length > 0 ? this.matSelect.options.first._getHostElement().getBoundingClientRect().height : 0;
          }
          getOptionsLengthOffset() {
            return this.matOption ? 1 : 0;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(r0), f(Se), f(Ki), f(Ho, 8), f(Qv), f(Si, 8), f(hhe, 8));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["ngx-mat-select-search"]],
          contentQueries: function (e, a, i) {
            if (1 & e && (De(i, fhe, 5), De(i, phe, 5)), 2 & e) {
              let o;
              H(o = B()) && (a.clearIcon = o.first), H(o = B()) && (a.noEntriesFound = o.first);
            }
          },
          viewQuery: function (e, a) {
            if (1 & e && (be($me, 7, J), be(ehe, 7, J)), 2 & e) {
              let i;
              H(i = B()) && (a.searchSelectInput = i.first), H(i = B()) && (a.innerSelectSearch = i.first);
            }
          },
          hostVars: 2,
          hostBindings: function (e, a) {
            2 & e && fe("mat-select-search-inside-mat-option", a.isInsideMatOption);
          },
          inputs: {
            placeholderLabel: "placeholderLabel",
            type: "type",
            closeIcon: "closeIcon",
            closeSvgIcon: "closeSvgIcon",
            noEntriesFoundLabel: "noEntriesFoundLabel",
            indexAndLengthScreenReaderText: "indexAndLengthScreenReaderText",
            clearSearchInput: "clearSearchInput",
            searching: "searching",
            disableInitialFocus: "disableInitialFocus",
            enableClearOnEscapePressed: "enableClearOnEscapePressed",
            preventHomeEndKeyPropagation: "preventHomeEndKeyPropagation",
            disableScrollToActiveOnOptionsChanged: "disableScrollToActiveOnOptionsChanged",
            ariaLabel: "ariaLabel",
            showToggleAllCheckbox: "showToggleAllCheckbox",
            toggleAllCheckboxChecked: "toggleAllCheckboxChecked",
            toggleAllCheckboxIndeterminate: "toggleAllCheckboxIndeterminate",
            toggleAllCheckboxTooltipMessage: "toggleAllCheckboxTooltipMessage",
            toogleAllCheckboxTooltipPosition: "toogleAllCheckboxTooltipPosition",
            hideClearSearchButton: "hideClearSearchButton",
            alwaysRestoreSelectedOptionsMulti: "alwaysRestoreSelectedOptionsMulti"
          },
          outputs: {
            toggleAll: "toggleAll"
          },
          features: [G([{
            provide: Bt,
            useExisting: Pe(() => n),
            multi: !0
          }])],
          ngContentSelectors: uhe,
          decls: 11,
          vars: 14,
          consts: [["matInput", "", 1, "mat-select-search-input", "mat-select-search-hidden"], [1, "mat-select-search-inner", "mat-typography", "mat-datepicker-content", "mat-tab-header", 3, "ngClass"], ["innerSelectSearch", ""], ["class", "mat-select-search-toggle-all-checkbox", "matTooltipClass", "ngx-mat-select-search-toggle-all-tooltip", 3, "color", "checked", "indeterminate", "matTooltip", "matTooltipPosition", "change", 4, "ngIf"], ["autocomplete", "off", 1, "mat-select-search-input", "mat-input-element", 3, "type", "formControl", "placeholder", "keydown", "keyup", "blur"], ["searchSelectInput", ""], ["class", "mat-select-search-spinner", "diameter", "16", 4, "ngIf"], ["mat-button", "", "mat-icon-button", "", "aria-label", "Clear", "class", "mat-select-search-clear", 3, "click", 4, "ngIf"], ["class", "mat-select-search-no-entries-found", 4, "ngIf"], ["matTooltipClass", "ngx-mat-select-search-toggle-all-tooltip", 1, "mat-select-search-toggle-all-checkbox", 3, "color", "checked", "indeterminate", "matTooltip", "matTooltipPosition", "change"], ["diameter", "16", 1, "mat-select-search-spinner"], ["mat-button", "", "mat-icon-button", "", "aria-label", "Clear", 1, "mat-select-search-clear", 3, "click"], [4, "ngIf", "ngIfElse"], ["defaultIcon", ""], [3, "svgIcon"], [1, "mat-select-search-no-entries-found"], ["defaultNoEntriesFound", ""]],
          template: function (e, a) {
            1 & e && (lt(lhe), j(0, "input", 0), _(1, "div", 1, 2), D(3, the, 1, 5, "mat-checkbox", 3), _(4, "input", 4, 5), F("keydown", function (o) {
              return a._handleKeydown(o);
            })("keyup", function (o) {
              return a._handleKeyup(o);
            })("blur", function () {
              return a.onBlur();
            }), y(), D(6, nhe, 1, 0, "mat-spinner", 6), D(7, ohe, 4, 2, "button", 7), Me(8), y(), D(9, che, 4, 2, "div", 8), Dt(10, "async")), 2 & e && (g(1), b("ngClass", ob(11, dhe, a.matSelect.multiple, a._isToggleAllCheckboxVisible())), g(2), b("ngIf", a._isToggleAllCheckboxVisible()), g(1), b("type", a.type)("formControl", a._formControl)("placeholder", a.placeholderLabel), X("aria-label", a.ariaLabel), g(2), b("ngIf", a.searching), g(1), b("ngIf", !a.hideClearSearchButton && a.value && !a.searching), g(2), b("ngIf", Ot(10, 9, a._showNoEntriesFound$)));
          },
          dependencies: [w4, $a, Pi, ao, ko, mt, ys, yi, oa, Pa, md],
          styles: [".mat-select-search-hidden[_ngcontent-%COMP%]{visibility:hidden}.mat-select-search-inner[_ngcontent-%COMP%]{position:absolute;top:0;width:100%;border-bottom-width:1px;border-bottom-style:solid;z-index:100;font-size:inherit;box-shadow:none;border-radius:4px 4px 0 0;-webkit-transform:translate3d(0,0,0)}.mat-select-search-inner.mat-select-search-inner-multiple[_ngcontent-%COMP%]{width:100%}.mat-select-search-inner.mat-select-search-inner-multiple.mat-select-search-inner-toggle-all[_ngcontent-%COMP%]{display:flex;align-items:center}.mat-select-search-inner[_ngcontent-%COMP%]   .mat-input-element[_ngcontent-%COMP%]{flex-basis:auto}.mat-select-search-inner[_ngcontent-%COMP%]   .mat-input-element[_ngcontent-%COMP%]:-ms-input-placeholder{-ms-user-select:text}  .mat-select-search-panel{transform:none!important;overflow-x:hidden}.mat-select-search-input[_ngcontent-%COMP%]{padding:16px 44px 16px 16px;box-sizing:border-box;width:100%}[dir=rtl][_nghost-%COMP%]   .mat-select-search-input[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .mat-select-search-input[_ngcontent-%COMP%]{padding-right:16px;padding-left:44px}.mat-select-search-no-entries-found[_ngcontent-%COMP%]{padding:16px}.mat-select-search-clear[_ngcontent-%COMP%]{position:absolute;right:4px;top:5px}[dir=rtl][_nghost-%COMP%]   .mat-select-search-clear[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .mat-select-search-clear[_ngcontent-%COMP%]{right:auto;left:4px}.mat-select-search-spinner[_ngcontent-%COMP%]{position:absolute;right:16px;top:calc(50% - 8px)}[dir=rtl][_nghost-%COMP%]   .mat-select-search-spinner[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .mat-select-search-spinner[_ngcontent-%COMP%]{right:auto;left:16px}.mat-select-search-inside-mat-option[_nghost-%COMP%]   .mat-select-search-input[_ngcontent-%COMP%]{padding-top:0;padding-bottom:0;height:3em;line-height:3em}.mat-select-search-inside-mat-option[_nghost-%COMP%]   .mat-select-search-clear[_ngcontent-%COMP%]{top:3px}  .mat-option[aria-disabled=true].contains-mat-select-search{position:static;padding:0}  .mat-option[aria-disabled=true].contains-mat-select-search .mat-icon{margin-right:0;margin-left:0}  .mat-option[aria-disabled=true].contains-mat-select-search .mat-option-pseudo-checkbox{display:none}  .mat-option[aria-disabled=true].contains-mat-select-search.mat-select-search-no-entries-found{height:6em}.mat-select-search-toggle-all-checkbox[_ngcontent-%COMP%]{padding-left:16px;padding-bottom:2px}[dir=rtl][_nghost-%COMP%]   .mat-select-search-toggle-all-checkbox[_ngcontent-%COMP%], [dir=rtl]   [_nghost-%COMP%]   .mat-select-search-toggle-all-checkbox[_ngcontent-%COMP%]{padding-left:0;padding-right:16px}"],
          changeDetection: 0
        }), n;
      })(),
      bhe = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [[yt, f2, Wo, k4, Q2, Ox, Z2]]
        }), n;
      })();
    function Ax(n, t) {
      let e = !1;
      return arguments.length >= 2 && (e = !0), function (i) {
        return i.lift(new _he(n, t, e));
      };
    }
    class _he {
      constructor(t, e, a = !1) {
        this.accumulator = t, this.seed = e, this.hasSeed = a;
      }
      call(t, e) {
        return e.subscribe(new vhe(t, this.accumulator, this.seed, this.hasSeed));
      }
    }
    class vhe extends Qe {
      constructor(t, e, a, i) {
        super(t), this.accumulator = e, this._seed = a, this.hasSeed = i, this.index = 0;
      }
      get seed() {
        return this._seed;
      }
      set seed(t) {
        this.hasSeed = !0, this._seed = t;
      }
      _next(t) {
        if (this.hasSeed) return this._tryNext(t);
        this.seed = t, this.destination.next(t);
      }
      _tryNext(t) {
        const e = this.index++;
        let a;
        try {
          a = this.accumulator(this.seed, t, e);
        } catch (i) {
          this.destination.error(i);
        }
        this.seed = a, this.destination.next(a);
      }
    }
    function Sx(n) {
      return function (e) {
        return 0 === n ? xd() : e.lift(new yhe(n));
      };
    }
    class yhe {
      constructor(t) {
        if (this.total = t, this.total < 0) throw new l_();
      }
      call(t, e) {
        return e.subscribe(new Che(t, this.total));
      }
    }
    class Che extends Qe {
      constructor(t, e) {
        super(t), this.total = e, this.ring = new Array(), this.count = 0;
      }
      _next(t) {
        const e = this.ring,
          a = this.total,
          i = this.count++;
        e.length < a ? e.push(t) : e[i % a] = t;
      }
      _complete() {
        const t = this.destination;
        let e = this.count;
        if (e > 0) {
          const a = this.count >= this.total ? this.total : this.count,
            i = this.ring;
          for (let o = 0; o < a; o++) {
            const r = e++ % a;
            t.next(i[r]);
          }
        }
        t.complete();
      }
    }
    function Mhe(n = null) {
      return t => t.lift(new xhe(n));
    }
    class xhe {
      constructor(t) {
        this.defaultValue = t;
      }
      call(t, e) {
        return e.subscribe(new whe(t, this.defaultValue));
      }
    }
    class whe extends Qe {
      constructor(t, e) {
        super(t), this.defaultValue = e, this.isEmpty = !0;
      }
      _next(t) {
        this.isEmpty = !1, this.destination.next(t);
      }
      _complete() {
        this.isEmpty && this.destination.next(this.defaultValue), this.destination.complete();
      }
    }
    function Dhe(n, t, e) {
      return 0 === e ? [t] : (n.push(t), n);
    }
    class ks {}
    let Ex = (() => {
      class n extends ks {
        getTranslation(e) {
          return nt({});
        }
      }
      return n.ɵfac = function () {
        let t;
        return function (a) {
          return (t || (t = he(n)))(a || n);
        };
      }(), n.ɵprov = R({
        token: n,
        factory: n.ɵfac
      }), n;
    })();
    class F4 {}
    let Tx = (() => {
      class n {
        handle(e) {
          return e.key;
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)();
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac
      }), n;
    })();
    class g0 {}
    let Ix = (() => {
      class n extends g0 {
        compile(e, a) {
          return e;
        }
        compileTranslations(e, a) {
          return e;
        }
      }
      return n.ɵfac = function () {
        let t;
        return function (a) {
          return (t || (t = he(n)))(a || n);
        };
      }(), n.ɵprov = R({
        token: n,
        factory: n.ɵfac
      }), n;
    })();
    function kl(n, t) {
      if (n === t) return !0;
      if (null === n || null === t) return !1;
      if (n != n && t != t) return !0;
      let i,
        o,
        r,
        e = typeof n;
      if (e == typeof t && "object" == e) {
        if (!Array.isArray(n)) {
          if (Array.isArray(t)) return !1;
          for (o in r = Object.create(null), n) {
            if (!kl(n[o], t[o])) return !1;
            r[o] = !0;
          }
          for (o in t) if (!(o in r) && typeof t[o] < "u") return !1;
          return !0;
        }
        if (!Array.isArray(t)) return !1;
        if ((i = n.length) == t.length) {
          for (o = 0; o < i; o++) if (!kl(n[o], t[o])) return !1;
          return !0;
        }
      }
      return !1;
    }
    function Ta(n) {
      return typeof n < "u" && null !== n;
    }
    function V4(n) {
      return n && "object" == typeof n && !Array.isArray(n);
    }
    function Rx(n, t) {
      let e = Object.assign({}, n);
      return V4(n) && V4(t) && Object.keys(t).forEach(a => {
        V4(t[a]) ? a in n ? e[a] = Rx(n[a], t[a]) : Object.assign(e, {
          [a]: t[a]
        }) : Object.assign(e, {
          [a]: t[a]
        });
      }), e;
    }
    class b0 {}
    let zx = (() => {
      class n extends b0 {
        constructor() {
          super(...arguments), this.templateMatcher = /{{\s?([^{}\s]*)\s?}}/g;
        }
        interpolate(e, a) {
          let i;
          return i = "string" == typeof e ? this.interpolateString(e, a) : "function" == typeof e ? this.interpolateFunction(e, a) : e, i;
        }
        getValue(e, a) {
          let i = a.split(".");
          a = "";
          do {
            a += i.shift(), !Ta(e) || !Ta(e[a]) || "object" != typeof e[a] && i.length ? i.length ? a += "." : e = void 0 : (e = e[a], a = "");
          } while (i.length);
          return e;
        }
        interpolateFunction(e, a) {
          return e(a);
        }
        interpolateString(e, a) {
          return a ? e.replace(this.templateMatcher, (i, o) => {
            let r = this.getValue(a, o);
            return Ta(r) ? r : i;
          }) : e;
        }
      }
      return n.ɵfac = function () {
        let t;
        return function (a) {
          return (t || (t = he(n)))(a || n);
        };
      }(), n.ɵprov = R({
        token: n,
        factory: n.ɵfac
      }), n;
    })();
    class Lx {
      constructor() {
        this.currentLang = this.defaultLang, this.translations = {}, this.langs = [], this.onTranslationChange = new E(), this.onLangChange = new E(), this.onDefaultLangChange = new E();
      }
    }
    const H4 = new O("USE_STORE"),
      B4 = new O("USE_DEFAULT_LANG");
    let Dl = (() => {
        class n {
          constructor(e, a, i, o, r, s = !0, c = !1) {
            this.store = e, this.currentLoader = a, this.compiler = i, this.parser = o, this.missingTranslationHandler = r, this.useDefaultLang = s, this.isolate = c, this.pending = !1, this._onTranslationChange = new E(), this._onLangChange = new E(), this._onDefaultLangChange = new E(), this._langs = [], this._translations = {}, this._translationRequests = {};
          }
          get onTranslationChange() {
            return this.isolate ? this._onTranslationChange : this.store.onTranslationChange;
          }
          get onLangChange() {
            return this.isolate ? this._onLangChange : this.store.onLangChange;
          }
          get onDefaultLangChange() {
            return this.isolate ? this._onDefaultLangChange : this.store.onDefaultLangChange;
          }
          get defaultLang() {
            return this.isolate ? this._defaultLang : this.store.defaultLang;
          }
          set defaultLang(e) {
            this.isolate ? this._defaultLang = e : this.store.defaultLang = e;
          }
          get currentLang() {
            return this.isolate ? this._currentLang : this.store.currentLang;
          }
          set currentLang(e) {
            this.isolate ? this._currentLang = e : this.store.currentLang = e;
          }
          get langs() {
            return this.isolate ? this._langs : this.store.langs;
          }
          set langs(e) {
            this.isolate ? this._langs = e : this.store.langs = e;
          }
          get translations() {
            return this.isolate ? this._translations : this.store.translations;
          }
          set translations(e) {
            this.isolate ? this._translations = e : this.store.translations = e;
          }
          setDefaultLang(e) {
            if (e === this.defaultLang) return;
            let a = this.retrieveTranslations(e);
            typeof a < "u" ? (this.defaultLang || (this.defaultLang = e), a.pipe($e(1)).subscribe(i => {
              this.changeDefaultLang(e);
            })) : this.changeDefaultLang(e);
          }
          getDefaultLang() {
            return this.defaultLang;
          }
          use(e) {
            if (e === this.currentLang) return nt(this.translations[e]);
            let a = this.retrieveTranslations(e);
            return typeof a < "u" ? (this.currentLang || (this.currentLang = e), a.pipe($e(1)).subscribe(i => {
              this.changeLang(e);
            }), a) : (this.changeLang(e), nt(this.translations[e]));
          }
          retrieveTranslations(e) {
            let a;
            return typeof this.translations[e] > "u" && (this._translationRequests[e] = this._translationRequests[e] || this.getTranslation(e), a = this._translationRequests[e]), a;
          }
          getTranslation(e) {
            this.pending = !0;
            const a = this.currentLoader.getTranslation(e).pipe(Ul());
            return this.loadingTranslations = a.pipe($e(1), We(i => this.compiler.compileTranslations(i, e)), Ul()), this.loadingTranslations.subscribe(i => {
              this.translations[e] = i, this.updateLangs(), this.pending = !1;
            }, i => {
              this.pending = !1;
            }), a;
          }
          setTranslation(e, a, i = !1) {
            a = this.compiler.compileTranslations(a, e), this.translations[e] = i && this.translations[e] ? Rx(this.translations[e], a) : a, this.updateLangs(), this.onTranslationChange.emit({
              lang: e,
              translations: this.translations[e]
            });
          }
          getLangs() {
            return this.langs;
          }
          addLangs(e) {
            e.forEach(a => {
              -1 === this.langs.indexOf(a) && this.langs.push(a);
            });
          }
          updateLangs() {
            this.addLangs(Object.keys(this.translations));
          }
          getParsedResult(e, a, i) {
            let o;
            if (a instanceof Array) {
              let r = {},
                s = !1;
              for (let c of a) r[c] = this.getParsedResult(e, c, i), "function" == typeof r[c].subscribe && (s = !0);
              if (s) {
                let c;
                for (let l of a) {
                  let d = "function" == typeof r[l].subscribe ? r[l] : nt(r[l]);
                  c = typeof c > "u" ? d : dt(c, d);
                }
                return c.pipe(function Ohe() {
                  return function khe(n, t) {
                    return arguments.length >= 2 ? function (a) {
                      return y3(Ax(n, t), Sx(1), Mhe(t))(a);
                    } : function (a) {
                      return y3(Ax((i, o, r) => n(i, o, r + 1)), Sx(1))(a);
                    };
                  }(Dhe, []);
                }(), We(l => {
                  let d = {};
                  return l.forEach((u, m) => {
                    d[a[m]] = u;
                  }), d;
                }));
              }
              return r;
            }
            if (e && (o = this.parser.interpolate(this.parser.getValue(e, a), i)), typeof o > "u" && this.defaultLang && this.defaultLang !== this.currentLang && this.useDefaultLang && (o = this.parser.interpolate(this.parser.getValue(this.translations[this.defaultLang], a), i)), typeof o > "u") {
              let r = {
                key: a,
                translateService: this
              };
              typeof i < "u" && (r.interpolateParams = i), o = this.missingTranslationHandler.handle(r);
            }
            return typeof o < "u" ? o : a;
          }
          get(e, a) {
            if (!Ta(e) || !e.length) throw new Error('Parameter "key" required');
            if (this.pending) return Be.create(i => {
              let o = s => {
                  i.next(s), i.complete();
                },
                r = s => {
                  i.error(s);
                };
              this.loadingTranslations.subscribe(s => {
                "function" == typeof (s = this.getParsedResult(s, e, a)).subscribe ? s.subscribe(o, r) : o(s);
              }, r);
            });
            {
              let i = this.getParsedResult(this.translations[this.currentLang], e, a);
              return "function" == typeof i.subscribe ? i : nt(i);
            }
          }
          stream(e, a) {
            if (!Ta(e) || !e.length) throw new Error('Parameter "key" required');
            return _2(this.get(e, a), this.onLangChange.pipe(gi(i => {
              const o = this.getParsedResult(i.translations, e, a);
              return "function" == typeof o.subscribe ? o : nt(o);
            })));
          }
          instant(e, a) {
            if (!Ta(e) || !e.length) throw new Error('Parameter "key" required');
            let i = this.getParsedResult(this.translations[this.currentLang], e, a);
            if (typeof i.subscribe < "u") {
              if (e instanceof Array) {
                let o = {};
                return e.forEach((r, s) => {
                  o[e[s]] = e[s];
                }), o;
              }
              return e;
            }
            return i;
          }
          set(e, a, i = this.currentLang) {
            this.translations[i][e] = this.compiler.compile(a, i), this.updateLangs(), this.onTranslationChange.emit({
              lang: i,
              translations: this.translations[i]
            });
          }
          changeLang(e) {
            this.currentLang = e, this.onLangChange.emit({
              lang: e,
              translations: this.translations[e]
            }), this.defaultLang || this.changeDefaultLang(e);
          }
          changeDefaultLang(e) {
            this.defaultLang = e, this.onDefaultLangChange.emit({
              lang: e,
              translations: this.translations[e]
            });
          }
          reloadLang(e) {
            return this.resetLang(e), this.getTranslation(e);
          }
          resetLang(e) {
            this._translationRequests[e] = void 0, this.translations[e] = void 0;
          }
          getBrowserLang() {
            if (typeof window > "u" || typeof window.navigator > "u") return;
            let e = window.navigator.languages ? window.navigator.languages[0] : null;
            return e = e || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage, -1 !== e.indexOf("-") && (e = e.split("-")[0]), -1 !== e.indexOf("_") && (e = e.split("_")[0]), e;
          }
          getBrowserCultureLang() {
            if (typeof window > "u" || typeof window.navigator > "u") return;
            let e = window.navigator.languages ? window.navigator.languages[0] : null;
            return e = e || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage, e;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(Lx), M(ks), M(g0), M(b0), M(F4), M(B4), M(H4));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac
        }), n;
      })(),
      Ds = (() => {
        class n {
          constructor(e, a) {
            this.translate = e, this._ref = a, this.value = "";
          }
          updateValue(e, a, i) {
            let o = r => {
              this.value = void 0 !== r ? r : e, this.lastKey = e, this._ref.markForCheck();
            };
            if (i) {
              let r = this.translate.getParsedResult(i, e, a);
              "function" == typeof r.subscribe ? r.subscribe(o) : o(r);
            }
            this.translate.get(e, a).subscribe(o);
          }
          transform(e, ...a) {
            if (!e || 0 === e.length) return e;
            if (kl(e, this.lastKey) && kl(a, this.lastParams)) return this.value;
            let i;
            if (Ta(a[0]) && a.length) if ("string" == typeof a[0] && a[0].length) {
              let o = a[0].replace(/(\')?([a-zA-Z0-9_]+)(\')?(\s)?:/g, '"$2":').replace(/:(\s)?(\')(.*?)(\')/g, ':"$3"');
              try {
                i = JSON.parse(o);
              } catch {
                throw new SyntaxError(`Wrong parameter in TranslatePipe. Expected a valid Object, received: ${a[0]}`);
              }
            } else "object" == typeof a[0] && !Array.isArray(a[0]) && (i = a[0]);
            return this.lastKey = e, this.lastParams = a, this.updateValue(e, i), this._dispose(), this.onTranslationChange || (this.onTranslationChange = this.translate.onTranslationChange.subscribe(o => {
              this.lastKey && o.lang === this.translate.currentLang && (this.lastKey = null, this.updateValue(e, i, o.translations));
            })), this.onLangChange || (this.onLangChange = this.translate.onLangChange.subscribe(o => {
              this.lastKey && (this.lastKey = null, this.updateValue(e, i, o.translations));
            })), this.onDefaultLangChange || (this.onDefaultLangChange = this.translate.onDefaultLangChange.subscribe(() => {
              this.lastKey && (this.lastKey = null, this.updateValue(e, i));
            })), this.value;
          }
          _dispose() {
            typeof this.onTranslationChange < "u" && (this.onTranslationChange.unsubscribe(), this.onTranslationChange = void 0), typeof this.onLangChange < "u" && (this.onLangChange.unsubscribe(), this.onLangChange = void 0), typeof this.onDefaultLangChange < "u" && (this.onDefaultLangChange.unsubscribe(), this.onDefaultLangChange = void 0);
          }
          ngOnDestroy() {
            this._dispose();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Dl, 16), f(Se, 16));
        }, n.ɵpipe = on({
          name: "translate",
          type: n,
          pure: !1
        }), n.ɵprov = R({
          token: n,
          factory: n.ɵfac
        }), n;
      })(),
      _0 = (() => {
        class n {
          static forRoot(e = {}) {
            return {
              ngModule: n,
              providers: [e.loader || {
                provide: ks,
                useClass: Ex
              }, e.compiler || {
                provide: g0,
                useClass: Ix
              }, e.parser || {
                provide: b0,
                useClass: zx
              }, e.missingTranslationHandler || {
                provide: F4,
                useClass: Tx
              }, Lx, {
                provide: H4,
                useValue: e.isolate
              }, {
                provide: B4,
                useValue: e.useDefaultLang
              }, Dl]
            };
          }
          static forChild(e = {}) {
            return {
              ngModule: n,
              providers: [e.loader || {
                provide: ks,
                useClass: Ex
              }, e.compiler || {
                provide: g0,
                useClass: Ix
              }, e.parser || {
                provide: b0,
                useClass: zx
              }, e.missingTranslationHandler || {
                provide: F4,
                useClass: Tx
              }, {
                provide: H4,
                useValue: e.isolate
              }, {
                provide: B4,
                useValue: e.useDefaultLang
              }, Dl]
            };
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({}), n;
      })();
    function Phe(n, t) {
      if (1 & n && (_(0, "mat-option", 4), S(1), y()), 2 & n) {
        const e = t.$implicit,
          a = x();
        b("value", e[a.sampleTemplateService.TEMPLATE_NUMBER]), g(1), Ie(e[a.sampleTemplateService.TEMPLATE_LABEL]);
      }
    }
    let v0 = /*#__PURE__*/(() => {
      class v0 {
        sampleTemplateService;
        callbackOwnerObject = null;
        sampleTemplates;
        templateLocationPrefix;
        templateCtrl = new at();
        templateFilterCtrl = new at();
        filteredTemplates = new Zm(1);
        _onDestroy = new V();
        constructor(t) {
          this.sampleTemplateService = t;
        }
        ngOnInit() {
          this.templateLocationPrefix = this.callbackOwnerObject.innerConfig[qe.TEMPLATE_LOCATION_PREFIX], this.sampleTemplateService.getSampleTemplatesFromRegistry(this.templateLocationPrefix).pipe(ne(this._onDestroy)).subscribe(t => {
            this.sampleTemplates = t, this.filteredTemplates.next(this.sampleTemplates);
          }), this.sampleTemplateService.templateJson$.pipe(ne(this._onDestroy)).subscribe(t => {
            this.templateCtrl.setValue(Object.keys(t)[0]);
          }), this.templateFilterCtrl.valueChanges.pipe(ne(this._onDestroy)).subscribe(() => {
            this.filterTemplates();
          });
        }
        ngOnDestroy() {
          this._onDestroy.next(), this._onDestroy.complete();
        }
        filterTemplates() {
          if (!this.sampleTemplates) return;
          let t = this.templateFilterCtrl.value;
          t ? (t = t.toLowerCase(), this.filteredTemplates.next(this.sampleTemplates.filter(e => e[this.sampleTemplateService.TEMPLATE_LABEL].toLowerCase().indexOf(t) > -1))) : this.filteredTemplates.next(this.sampleTemplates.slice());
        }
        loadBuiltinTemplate(t) {
          this.sampleTemplateService.loadTemplate(this.templateLocationPrefix, t), window.scroll(0, 0);
        }
        inputChanged(t) {
          t && this.loadBuiltinTemplate(t.value);
        }
        static ɵfac = function (e) {
          return new (e || v0)(f(Ko));
        };
        static ɵcmp = q({
          type: v0,
          selectors: [["app-sample-template-select"]],
          inputs: {
            callbackOwnerObject: "callbackOwnerObject"
          },
          decls: 9,
          vars: 14,
          consts: [[1, "full-width"], [3, "formControl", "placeholder", "selectionChange"], [3, "formControl", "placeholderLabel", "noEntriesFoundLabel"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]],
          template: function (e, a) {
            1 & e && (_(0, "mat-form-field", 0)(1, "mat-select", 1), F("selectionChange", function (o) {
              return a.inputChanged(o);
            }), Dt(2, "translate"), _(3, "mat-option"), j(4, "ngx-mat-select-search", 2), Dt(5, "translate"), Dt(6, "translate"), y(), D(7, Phe, 2, 2, "mat-option", 3), Dt(8, "async"), y()()), 2 & e && (g(1), zn("placeholder", Ot(2, 6, "Extra.SampleTemplate.Select")), b("formControl", a.templateCtrl), g(3), zn("placeholderLabel", Ot(5, 8, "Extra.SampleTemplate.Find")), zn("noEntriesFoundLabel", Ot(6, 10, "Extra.SampleTemplate.FindNoMatch")), b("formControl", a.templateFilterCtrl), g(3), b("ngForOf", Ot(8, 12, a.filteredTemplates)));
          },
          dependencies: [Ho, Si, r0, ghe, oa, Pa, ea, md, Ds],
          encapsulation: 2
        });
      }
      return v0;
    })();
    function Ahe(n, t) {
      if (1 & n && (_(0, "span", 5), j(1, "app-sample-template-select", 6), y()), 2 & n) {
        const e = x();
        g(1), b("callbackOwnerObject", e.callbackOwnerObject);
      }
    }
    let Ol = /*#__PURE__*/(() => {
      class Ol {
        callbackOwnerObject = null;
        showSampleTemplateLinks = null;
        constructor() {}
        ngOnInit() {}
        static ɵfac = function (e) {
          return new (e || Ol)();
        };
        static ɵcmp = q({
          type: Ol,
          selectors: [["app-static-header"]],
          inputs: {
            callbackOwnerObject: "callbackOwnerObject",
            showSampleTemplateLinks: "showSampleTemplateLinks"
          },
          decls: 7,
          vars: 4,
          consts: [["color", "primary", 2, "height", "75px"], [1, "cedar-logo"], [2, "margin-left", "5px"], [1, "toolbar-spacer"], ["class", "sample-templates-flex", 4, "ngIf"], [1, "sample-templates-flex"], [3, "callbackOwnerObject"]],
          template: function (e, a) {
            1 & e && (_(0, "mat-toolbar", 0), j(1, "span", 1), _(2, "span", 2), S(3), Dt(4, "translate"), y(), j(5, "span", 3), D(6, Ahe, 2, 1, "span", 4), y()), 2 & e && (g(3), Ie(Ot(4, 2, "App.Title")), g(3), b("ngIf", a.showSampleTemplateLinks));
          },
          dependencies: [Wme, mt, v0, Ds],
          styles: [".sample-templates-flex{flex:auto}.sample-templates-flex .mat-form-field{font-size:85%}.sample-templates-flex .mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label{display:none}\n"],
          encapsulation: 2
        });
      }
      return Ol;
    })();
    let jx = (() => {
      class n {}
      return n.ɵfac = function (e) {
        return new (e || n)();
      }, n.ɵmod = W({
        type: n
      }), n.ɵinj = U({
        imports: [Qd]
      }), n;
    })();
    function Ghe(n) {
      const {
        subscriber: t,
        counter: e,
        period: a
      } = n;
      t.next(e), this.schedule({
        subscriber: t,
        counter: e + 1,
        period: a
      }, a);
    }
    function J4(n, t, e) {
      for (let a in t) if (t.hasOwnProperty(a)) {
        const i = t[a];
        i ? n.setProperty(a, i, e?.has(a) ? "important" : "") : n.removeProperty(a);
      }
      return n;
    }
    function Ss(n, t) {
      const e = t ? "" : "none";
      J4(n.style, {
        "touch-action": t ? "" : "none",
        "-webkit-user-drag": t ? "" : "none",
        "-webkit-tap-highlight-color": t ? "" : "transparent",
        "user-select": e,
        "-ms-user-select": e,
        "-webkit-user-select": e,
        "-moz-user-select": e
      });
    }
    function Ux(n, t, e) {
      J4(n.style, {
        position: t ? "" : "fixed",
        top: t ? "" : "0",
        opacity: t ? "" : "0",
        left: t ? "" : "-999em"
      }, e);
    }
    function A0(n, t) {
      return t && "none" != t ? n + " " + t : n;
    }
    function Gx(n) {
      const t = n.toLowerCase().indexOf("ms") > -1 ? 1 : 1e3;
      return parseFloat(n) * t;
    }
    function $4(n, t) {
      return n.getPropertyValue(t).split(",").map(a => a.trim());
    }
    function e3(n) {
      const t = n.getBoundingClientRect();
      return {
        top: t.top,
        right: t.right,
        bottom: t.bottom,
        left: t.left,
        width: t.width,
        height: t.height,
        x: t.x,
        y: t.y
      };
    }
    function t3(n, t, e) {
      const {
        top: a,
        bottom: i,
        left: o,
        right: r
      } = n;
      return e >= a && e <= i && t >= o && t <= r;
    }
    function Sl(n, t, e) {
      n.top += t, n.bottom = n.top + n.height, n.left += e, n.right = n.left + n.width;
    }
    function Wx(n, t, e, a) {
      const {
          top: i,
          right: o,
          bottom: r,
          left: s,
          width: c,
          height: l
        } = n,
        d = c * t,
        u = l * t;
      return a > i - u && a < r + u && e > s - d && e < o + d;
    }
    class Yx {
      constructor(t) {
        this._document = t, this.positions = new Map();
      }
      clear() {
        this.positions.clear();
      }
      cache(t) {
        this.clear(), this.positions.set(this._document, {
          scrollPosition: this.getViewportScrollPosition()
        }), t.forEach(e => {
          this.positions.set(e, {
            scrollPosition: {
              top: e.scrollTop,
              left: e.scrollLeft
            },
            clientRect: e3(e)
          });
        });
      }
      handleScroll(t) {
        const e = aa(t),
          a = this.positions.get(e);
        if (!a) return null;
        const i = a.scrollPosition;
        let o, r;
        if (e === this._document) {
          const l = this.getViewportScrollPosition();
          o = l.top, r = l.left;
        } else o = e.scrollTop, r = e.scrollLeft;
        const s = i.top - o,
          c = i.left - r;
        return this.positions.forEach((l, d) => {
          l.clientRect && e !== d && e.contains(d) && Sl(l.clientRect, s, c);
        }), i.top = o, i.left = r, {
          top: s,
          left: c
        };
      }
      getViewportScrollPosition() {
        return {
          top: window.scrollY,
          left: window.scrollX
        };
      }
    }
    function qx(n) {
      const t = n.cloneNode(!0),
        e = t.querySelectorAll("[id]"),
        a = n.nodeName.toLowerCase();
      t.removeAttribute("id");
      for (let i = 0; i < e.length; i++) e[i].removeAttribute("id");
      return "canvas" === a ? Zx(n, t) : ("input" === a || "select" === a || "textarea" === a) && Qx(n, t), Kx("canvas", n, t, Zx), Kx("input, textarea, select", n, t, Qx), t;
    }
    function Kx(n, t, e, a) {
      const i = t.querySelectorAll(n);
      if (i.length) {
        const o = e.querySelectorAll(n);
        for (let r = 0; r < i.length; r++) a(i[r], o[r]);
      }
    }
    let Yhe = 0;
    function Qx(n, t) {
      "file" !== t.type && (t.value = n.value), "radio" === t.type && t.name && (t.name = `mat-clone-${t.name}-${Yhe++}`);
    }
    function Zx(n, t) {
      const e = t.getContext("2d");
      if (e) try {
        e.drawImage(n, 0, 0);
      } catch {}
    }
    const Xx = ka({
        passive: !0
      }),
      S0 = ka({
        passive: !1
      }),
      n3 = new Set(["position"]);
    class Khe {
      constructor(t, e, a, i, o, r) {
        this._config = e, this._document = a, this._ngZone = i, this._viewportRuler = o, this._dragDropRegistry = r, this._passiveTransform = {
          x: 0,
          y: 0
        }, this._activeTransform = {
          x: 0,
          y: 0
        }, this._hasStartedDragging = !1, this._moveEvents = new V(), this._pointerMoveSubscription = re.EMPTY, this._pointerUpSubscription = re.EMPTY, this._scrollSubscription = re.EMPTY, this._resizeSubscription = re.EMPTY, this._boundaryElement = null, this._nativeInteractionsEnabled = !0, this._handles = [], this._disabledHandles = new Set(), this._direction = "ltr", this.dragStartDelay = 0, this._disabled = !1, this.beforeStarted = new V(), this.started = new V(), this.released = new V(), this.ended = new V(), this.entered = new V(), this.exited = new V(), this.dropped = new V(), this.moved = this._moveEvents, this._pointerDown = s => {
          if (this.beforeStarted.next(), this._handles.length) {
            const c = this._getTargetHandle(s);
            c && !this._disabledHandles.has(c) && !this.disabled && this._initializeDragSequence(c, s);
          } else this.disabled || this._initializeDragSequence(this._rootElement, s);
        }, this._pointerMove = s => {
          const c = this._getPointerPositionOnPage(s);
          if (!this._hasStartedDragging) {
            if (Math.abs(c.x - this._pickupPositionOnPage.x) + Math.abs(c.y - this._pickupPositionOnPage.y) >= this._config.dragStartThreshold) {
              const h = Date.now() >= this._dragStartTime + this._getDragStartDelay(s),
                p = this._dropContainer;
              if (!h) return void this._endDragSequence(s);
              (!p || !p.isDragging() && !p.isReceiving()) && (s.preventDefault(), this._hasStartedDragging = !0, this._ngZone.run(() => this._startDragSequence(s)));
            }
            return;
          }
          s.preventDefault();
          const l = this._getConstrainedPointerPosition(c);
          if (this._hasMoved = !0, this._lastKnownPointerPosition = c, this._updatePointerDirectionDelta(l), this._dropContainer) this._updateActiveDropContainer(l, c);else {
            const d = this.constrainPosition ? this._initialClientRect : this._pickupPositionOnPage,
              u = this._activeTransform;
            u.x = l.x - d.x + this._passiveTransform.x, u.y = l.y - d.y + this._passiveTransform.y, this._applyRootElementTransform(u.x, u.y);
          }
          this._moveEvents.observers.length && this._ngZone.run(() => {
            this._moveEvents.next({
              source: this,
              pointerPosition: l,
              event: s,
              distance: this._getDragDistance(l),
              delta: this._pointerDirectionDelta
            });
          });
        }, this._pointerUp = s => {
          this._endDragSequence(s);
        }, this._nativeDragStart = s => {
          if (this._handles.length) {
            const c = this._getTargetHandle(s);
            c && !this._disabledHandles.has(c) && !this.disabled && s.preventDefault();
          } else this.disabled || s.preventDefault();
        }, this.withRootElement(t).withParent(e.parentDragRef || null), this._parentPositions = new Yx(a), r.registerDragItem(this);
      }
      get disabled() {
        return this._disabled || !(!this._dropContainer || !this._dropContainer.disabled);
      }
      set disabled(t) {
        const e = Y(t);
        e !== this._disabled && (this._disabled = e, this._toggleNativeDragInteractions(), this._handles.forEach(a => Ss(a, e)));
      }
      getPlaceholderElement() {
        return this._placeholder;
      }
      getRootElement() {
        return this._rootElement;
      }
      getVisibleElement() {
        return this.isDragging() ? this.getPlaceholderElement() : this.getRootElement();
      }
      withHandles(t) {
        this._handles = t.map(a => wt(a)), this._handles.forEach(a => Ss(a, this.disabled)), this._toggleNativeDragInteractions();
        const e = new Set();
        return this._disabledHandles.forEach(a => {
          this._handles.indexOf(a) > -1 && e.add(a);
        }), this._disabledHandles = e, this;
      }
      withPreviewTemplate(t) {
        return this._previewTemplate = t, this;
      }
      withPlaceholderTemplate(t) {
        return this._placeholderTemplate = t, this;
      }
      withRootElement(t) {
        const e = wt(t);
        return e !== this._rootElement && (this._rootElement && this._removeRootElementListeners(this._rootElement), this._ngZone.runOutsideAngular(() => {
          e.addEventListener("mousedown", this._pointerDown, S0), e.addEventListener("touchstart", this._pointerDown, Xx), e.addEventListener("dragstart", this._nativeDragStart, S0);
        }), this._initialTransform = void 0, this._rootElement = e), typeof SVGElement < "u" && this._rootElement instanceof SVGElement && (this._ownerSVGElement = this._rootElement.ownerSVGElement), this;
      }
      withBoundaryElement(t) {
        return this._boundaryElement = t ? wt(t) : null, this._resizeSubscription.unsubscribe(), t && (this._resizeSubscription = this._viewportRuler.change(10).subscribe(() => this._containInsideBoundaryOnResize())), this;
      }
      withParent(t) {
        return this._parentDragRef = t, this;
      }
      dispose() {
        this._removeRootElementListeners(this._rootElement), this.isDragging() && this._rootElement?.remove(), this._anchor?.remove(), this._destroyPreview(), this._destroyPlaceholder(), this._dragDropRegistry.removeDragItem(this), this._removeSubscriptions(), this.beforeStarted.complete(), this.started.complete(), this.released.complete(), this.ended.complete(), this.entered.complete(), this.exited.complete(), this.dropped.complete(), this._moveEvents.complete(), this._handles = [], this._disabledHandles.clear(), this._dropContainer = void 0, this._resizeSubscription.unsubscribe(), this._parentPositions.clear(), this._boundaryElement = this._rootElement = this._ownerSVGElement = this._placeholderTemplate = this._previewTemplate = this._anchor = this._parentDragRef = null;
      }
      isDragging() {
        return this._hasStartedDragging && this._dragDropRegistry.isDragging(this);
      }
      reset() {
        this._rootElement.style.transform = this._initialTransform || "", this._activeTransform = {
          x: 0,
          y: 0
        }, this._passiveTransform = {
          x: 0,
          y: 0
        };
      }
      disableHandle(t) {
        !this._disabledHandles.has(t) && this._handles.indexOf(t) > -1 && (this._disabledHandles.add(t), Ss(t, !0));
      }
      enableHandle(t) {
        this._disabledHandles.has(t) && (this._disabledHandles.delete(t), Ss(t, this.disabled));
      }
      withDirection(t) {
        return this._direction = t, this;
      }
      _withDropContainer(t) {
        this._dropContainer = t;
      }
      getFreeDragPosition() {
        const t = this.isDragging() ? this._activeTransform : this._passiveTransform;
        return {
          x: t.x,
          y: t.y
        };
      }
      setFreeDragPosition(t) {
        return this._activeTransform = {
          x: 0,
          y: 0
        }, this._passiveTransform.x = t.x, this._passiveTransform.y = t.y, this._dropContainer || this._applyRootElementTransform(t.x, t.y), this;
      }
      withPreviewContainer(t) {
        return this._previewContainer = t, this;
      }
      _sortFromLastPointerPosition() {
        const t = this._lastKnownPointerPosition;
        t && this._dropContainer && this._updateActiveDropContainer(this._getConstrainedPointerPosition(t), t);
      }
      _removeSubscriptions() {
        this._pointerMoveSubscription.unsubscribe(), this._pointerUpSubscription.unsubscribe(), this._scrollSubscription.unsubscribe();
      }
      _destroyPreview() {
        this._preview?.remove(), this._previewRef?.destroy(), this._preview = this._previewRef = null;
      }
      _destroyPlaceholder() {
        this._placeholder?.remove(), this._placeholderRef?.destroy(), this._placeholder = this._placeholderRef = null;
      }
      _endDragSequence(t) {
        if (this._dragDropRegistry.isDragging(this) && (this._removeSubscriptions(), this._dragDropRegistry.stopDragging(this), this._toggleNativeDragInteractions(), this._handles && (this._rootElement.style.webkitTapHighlightColor = this._rootElementTapHighlight), this._hasStartedDragging)) if (this.released.next({
          source: this,
          event: t
        }), this._dropContainer) this._dropContainer._stopScrolling(), this._animatePreviewToPlaceholder().then(() => {
          this._cleanupDragArtifacts(t), this._cleanupCachedDimensions(), this._dragDropRegistry.stopDragging(this);
        });else {
          this._passiveTransform.x = this._activeTransform.x;
          const e = this._getPointerPositionOnPage(t);
          this._passiveTransform.y = this._activeTransform.y, this._ngZone.run(() => {
            this.ended.next({
              source: this,
              distance: this._getDragDistance(e),
              dropPoint: e,
              event: t
            });
          }), this._cleanupCachedDimensions(), this._dragDropRegistry.stopDragging(this);
        }
      }
      _startDragSequence(t) {
        El(t) && (this._lastTouchEventTime = Date.now()), this._toggleNativeDragInteractions();
        const e = this._dropContainer;
        if (e) {
          const a = this._rootElement,
            i = a.parentNode,
            o = this._placeholder = this._createPlaceholderElement(),
            r = this._anchor = this._anchor || this._document.createComment(""),
            s = this._getShadowRoot();
          i.insertBefore(r, a), this._initialTransform = a.style.transform || "", this._preview = this._createPreviewElement(), Ux(a, !1, n3), this._document.body.appendChild(i.replaceChild(o, a)), this._getPreviewInsertionPoint(i, s).appendChild(this._preview), this.started.next({
            source: this,
            event: t
          }), e.start(), this._initialContainer = e, this._initialIndex = e.getItemIndex(this);
        } else this.started.next({
          source: this,
          event: t
        }), this._initialContainer = this._initialIndex = void 0;
        this._parentPositions.cache(e ? e.getScrollableParents() : []);
      }
      _initializeDragSequence(t, e) {
        this._parentDragRef && e.stopPropagation();
        const a = this.isDragging(),
          i = El(e),
          o = !i && 0 !== e.button,
          r = this._rootElement,
          s = aa(e),
          c = !i && this._lastTouchEventTime && this._lastTouchEventTime + 800 > Date.now(),
          l = i ? fp(e) : up(e);
        if (s && s.draggable && "mousedown" === e.type && e.preventDefault(), a || o || c || l) return;
        if (this._handles.length) {
          const m = r.style;
          this._rootElementTapHighlight = m.webkitTapHighlightColor || "", m.webkitTapHighlightColor = "transparent";
        }
        this._hasStartedDragging = this._hasMoved = !1, this._removeSubscriptions(), this._initialClientRect = this._rootElement.getBoundingClientRect(), this._pointerMoveSubscription = this._dragDropRegistry.pointerMove.subscribe(this._pointerMove), this._pointerUpSubscription = this._dragDropRegistry.pointerUp.subscribe(this._pointerUp), this._scrollSubscription = this._dragDropRegistry.scrolled(this._getShadowRoot()).subscribe(m => this._updateOnScroll(m)), this._boundaryElement && (this._boundaryRect = e3(this._boundaryElement));
        const d = this._previewTemplate;
        this._pickupPositionInElement = d && d.template && !d.matchSize ? {
          x: 0,
          y: 0
        } : this._getPointerPositionInElement(this._initialClientRect, t, e);
        const u = this._pickupPositionOnPage = this._lastKnownPointerPosition = this._getPointerPositionOnPage(e);
        this._pointerDirectionDelta = {
          x: 0,
          y: 0
        }, this._pointerPositionAtLastDirectionChange = {
          x: u.x,
          y: u.y
        }, this._dragStartTime = Date.now(), this._dragDropRegistry.startDragging(this, e);
      }
      _cleanupDragArtifacts(t) {
        Ux(this._rootElement, !0, n3), this._anchor.parentNode.replaceChild(this._rootElement, this._anchor), this._destroyPreview(), this._destroyPlaceholder(), this._initialClientRect = this._boundaryRect = this._previewRect = this._initialTransform = void 0, this._ngZone.run(() => {
          const e = this._dropContainer,
            a = e.getItemIndex(this),
            i = this._getPointerPositionOnPage(t),
            o = this._getDragDistance(i),
            r = e._isOverContainer(i.x, i.y);
          this.ended.next({
            source: this,
            distance: o,
            dropPoint: i,
            event: t
          }), this.dropped.next({
            item: this,
            currentIndex: a,
            previousIndex: this._initialIndex,
            container: e,
            previousContainer: this._initialContainer,
            isPointerOverContainer: r,
            distance: o,
            dropPoint: i,
            event: t
          }), e.drop(this, a, this._initialIndex, this._initialContainer, r, o, i), this._dropContainer = this._initialContainer;
        });
      }
      _updateActiveDropContainer({
        x: t,
        y: e
      }, {
        x: a,
        y: i
      }) {
        let o = this._initialContainer._getSiblingContainerFromPosition(this, t, e);
        !o && this._dropContainer !== this._initialContainer && this._initialContainer._isOverContainer(t, e) && (o = this._initialContainer), o && o !== this._dropContainer && this._ngZone.run(() => {
          this.exited.next({
            item: this,
            container: this._dropContainer
          }), this._dropContainer.exit(this), this._dropContainer = o, this._dropContainer.enter(this, t, e, o === this._initialContainer && o.sortingDisabled ? this._initialIndex : void 0), this.entered.next({
            item: this,
            container: o,
            currentIndex: o.getItemIndex(this)
          });
        }), this.isDragging() && (this._dropContainer._startScrollingIfNecessary(a, i), this._dropContainer._sortItem(this, t, e, this._pointerDirectionDelta), this.constrainPosition ? this._applyPreviewTransform(t, e) : this._applyPreviewTransform(t - this._pickupPositionInElement.x, e - this._pickupPositionInElement.y));
      }
      _createPreviewElement() {
        const t = this._previewTemplate,
          e = this.previewClass,
          a = t ? t.template : null;
        let i;
        if (a && t) {
          const o = t.matchSize ? this._initialClientRect : null,
            r = t.viewContainer.createEmbeddedView(a, t.context);
          r.detectChanges(), i = $x(r, this._document), this._previewRef = r, t.matchSize ? ew(i, o) : i.style.transform = E0(this._pickupPositionOnPage.x, this._pickupPositionOnPage.y);
        } else i = qx(this._rootElement), ew(i, this._initialClientRect), this._initialTransform && (i.style.transform = this._initialTransform);
        return J4(i.style, {
          "pointer-events": "none",
          margin: "0",
          position: "fixed",
          top: "0",
          left: "0",
          "z-index": `${this._config.zIndex || 1e3}`
        }, n3), Ss(i, !1), i.classList.add("cdk-drag-preview"), i.setAttribute("dir", this._direction), e && (Array.isArray(e) ? e.forEach(o => i.classList.add(o)) : i.classList.add(e)), i;
      }
      _animatePreviewToPlaceholder() {
        if (!this._hasMoved) return Promise.resolve();
        const t = this._placeholder.getBoundingClientRect();
        this._preview.classList.add("cdk-drag-animating"), this._applyPreviewTransform(t.left, t.top);
        const e = function Whe(n) {
          const t = getComputedStyle(n),
            e = $4(t, "transition-property"),
            a = e.find(s => "transform" === s || "all" === s);
          if (!a) return 0;
          const i = e.indexOf(a),
            o = $4(t, "transition-duration"),
            r = $4(t, "transition-delay");
          return Gx(o[i]) + Gx(r[i]);
        }(this._preview);
        return 0 === e ? Promise.resolve() : this._ngZone.runOutsideAngular(() => new Promise(a => {
          const i = r => {
              (!r || aa(r) === this._preview && "transform" === r.propertyName) && (this._preview?.removeEventListener("transitionend", i), a(), clearTimeout(o));
            },
            o = setTimeout(i, 1.5 * e);
          this._preview.addEventListener("transitionend", i);
        }));
      }
      _createPlaceholderElement() {
        const t = this._placeholderTemplate,
          e = t ? t.template : null;
        let a;
        return e ? (this._placeholderRef = t.viewContainer.createEmbeddedView(e, t.context), this._placeholderRef.detectChanges(), a = $x(this._placeholderRef, this._document)) : a = qx(this._rootElement), a.style.pointerEvents = "none", a.classList.add("cdk-drag-placeholder"), a;
      }
      _getPointerPositionInElement(t, e, a) {
        const i = e === this._rootElement ? null : e,
          o = i ? i.getBoundingClientRect() : t,
          r = El(a) ? a.targetTouches[0] : a,
          s = this._getViewportScrollPosition();
        return {
          x: o.left - t.left + (r.pageX - o.left - s.left),
          y: o.top - t.top + (r.pageY - o.top - s.top)
        };
      }
      _getPointerPositionOnPage(t) {
        const e = this._getViewportScrollPosition(),
          a = El(t) ? t.touches[0] || t.changedTouches[0] || {
            pageX: 0,
            pageY: 0
          } : t,
          i = a.pageX - e.left,
          o = a.pageY - e.top;
        if (this._ownerSVGElement) {
          const r = this._ownerSVGElement.getScreenCTM();
          if (r) {
            const s = this._ownerSVGElement.createSVGPoint();
            return s.x = i, s.y = o, s.matrixTransform(r.inverse());
          }
        }
        return {
          x: i,
          y: o
        };
      }
      _getConstrainedPointerPosition(t) {
        const e = this._dropContainer ? this._dropContainer.lockAxis : null;
        let {
          x: a,
          y: i
        } = this.constrainPosition ? this.constrainPosition(t, this, this._initialClientRect, this._pickupPositionInElement) : t;
        if ("x" === this.lockAxis || "x" === e ? i = this._pickupPositionOnPage.y : ("y" === this.lockAxis || "y" === e) && (a = this._pickupPositionOnPage.x), this._boundaryRect) {
          const {
              x: o,
              y: r
            } = this._pickupPositionInElement,
            s = this._boundaryRect,
            {
              width: c,
              height: l
            } = this._getPreviewRect(),
            d = s.top + r,
            u = s.bottom - (l - r);
          a = Jx(a, s.left + o, s.right - (c - o)), i = Jx(i, d, u);
        }
        return {
          x: a,
          y: i
        };
      }
      _updatePointerDirectionDelta(t) {
        const {
            x: e,
            y: a
          } = t,
          i = this._pointerDirectionDelta,
          o = this._pointerPositionAtLastDirectionChange,
          r = Math.abs(e - o.x),
          s = Math.abs(a - o.y);
        return r > this._config.pointerDirectionChangeThreshold && (i.x = e > o.x ? 1 : -1, o.x = e), s > this._config.pointerDirectionChangeThreshold && (i.y = a > o.y ? 1 : -1, o.y = a), i;
      }
      _toggleNativeDragInteractions() {
        if (!this._rootElement || !this._handles) return;
        const t = this._handles.length > 0 || !this.isDragging();
        t !== this._nativeInteractionsEnabled && (this._nativeInteractionsEnabled = t, Ss(this._rootElement, t));
      }
      _removeRootElementListeners(t) {
        t.removeEventListener("mousedown", this._pointerDown, S0), t.removeEventListener("touchstart", this._pointerDown, Xx), t.removeEventListener("dragstart", this._nativeDragStart, S0);
      }
      _applyRootElementTransform(t, e) {
        const a = E0(t, e),
          i = this._rootElement.style;
        null == this._initialTransform && (this._initialTransform = i.transform && "none" != i.transform ? i.transform : ""), i.transform = A0(a, this._initialTransform);
      }
      _applyPreviewTransform(t, e) {
        const a = this._previewTemplate?.template ? void 0 : this._initialTransform,
          i = E0(t, e);
        this._preview.style.transform = A0(i, a);
      }
      _getDragDistance(t) {
        const e = this._pickupPositionOnPage;
        return e ? {
          x: t.x - e.x,
          y: t.y - e.y
        } : {
          x: 0,
          y: 0
        };
      }
      _cleanupCachedDimensions() {
        this._boundaryRect = this._previewRect = void 0, this._parentPositions.clear();
      }
      _containInsideBoundaryOnResize() {
        let {
          x: t,
          y: e
        } = this._passiveTransform;
        if (0 === t && 0 === e || this.isDragging() || !this._boundaryElement) return;
        const a = this._rootElement.getBoundingClientRect(),
          i = this._boundaryElement.getBoundingClientRect();
        if (0 === i.width && 0 === i.height || 0 === a.width && 0 === a.height) return;
        const o = i.left - a.left,
          r = a.right - i.right,
          s = i.top - a.top,
          c = a.bottom - i.bottom;
        i.width > a.width ? (o > 0 && (t += o), r > 0 && (t -= r)) : t = 0, i.height > a.height ? (s > 0 && (e += s), c > 0 && (e -= c)) : e = 0, (t !== this._passiveTransform.x || e !== this._passiveTransform.y) && this.setFreeDragPosition({
          y: e,
          x: t
        });
      }
      _getDragStartDelay(t) {
        const e = this.dragStartDelay;
        return "number" == typeof e ? e : El(t) ? e.touch : e ? e.mouse : 0;
      }
      _updateOnScroll(t) {
        const e = this._parentPositions.handleScroll(t);
        if (e) {
          const a = aa(t);
          this._boundaryRect && a !== this._boundaryElement && a.contains(this._boundaryElement) && Sl(this._boundaryRect, e.top, e.left), this._pickupPositionOnPage.x += e.left, this._pickupPositionOnPage.y += e.top, this._dropContainer || (this._activeTransform.x -= e.left, this._activeTransform.y -= e.top, this._applyRootElementTransform(this._activeTransform.x, this._activeTransform.y));
        }
      }
      _getViewportScrollPosition() {
        return this._parentPositions.positions.get(this._document)?.scrollPosition || this._parentPositions.getViewportScrollPosition();
      }
      _getShadowRoot() {
        return void 0 === this._cachedShadowRoot && (this._cachedShadowRoot = Kd(this._rootElement)), this._cachedShadowRoot;
      }
      _getPreviewInsertionPoint(t, e) {
        const a = this._previewContainer || "global";
        if ("parent" === a) return t;
        if ("global" === a) {
          const i = this._document;
          return e || i.fullscreenElement || i.webkitFullscreenElement || i.mozFullScreenElement || i.msFullscreenElement || i.body;
        }
        return wt(a);
      }
      _getPreviewRect() {
        return (!this._previewRect || !this._previewRect.width && !this._previewRect.height) && (this._previewRect = this._preview ? this._preview.getBoundingClientRect() : this._initialClientRect), this._previewRect;
      }
      _getTargetHandle(t) {
        return this._handles.find(e => t.target && (t.target === e || e.contains(t.target)));
      }
    }
    function E0(n, t) {
      return `translate3d(${Math.round(n)}px, ${Math.round(t)}px, 0)`;
    }
    function Jx(n, t, e) {
      return Math.max(t, Math.min(e, n));
    }
    function El(n) {
      return "t" === n.type[0];
    }
    function $x(n, t) {
      const e = n.rootNodes;
      if (1 === e.length && e[0].nodeType === t.ELEMENT_NODE) return e[0];
      const a = t.createElement("div");
      return e.forEach(i => a.appendChild(i)), a;
    }
    function ew(n, t) {
      n.style.width = `${t.width}px`, n.style.height = `${t.height}px`, n.style.transform = E0(t.left, t.top);
    }
    function Tl(n, t) {
      return Math.max(0, Math.min(t, n));
    }
    class Zhe {
      constructor(t, e) {
        this._element = t, this._dragDropRegistry = e, this._itemPositions = [], this.orientation = "vertical", this._previousSwap = {
          drag: null,
          delta: 0,
          overlaps: !1
        };
      }
      start(t) {
        this.withItems(t);
      }
      sort(t, e, a, i) {
        const o = this._itemPositions,
          r = this._getItemIndexFromPointerPosition(t, e, a, i);
        if (-1 === r && o.length > 0) return null;
        const s = "horizontal" === this.orientation,
          c = o.findIndex(C => C.drag === t),
          l = o[r],
          u = l.clientRect,
          m = c > r ? 1 : -1,
          h = this._getItemOffsetPx(o[c].clientRect, u, m),
          p = this._getSiblingOffsetPx(c, o, m),
          v = o.slice();
        return function Qhe(n, t, e) {
          const a = Tl(t, n.length - 1),
            i = Tl(e, n.length - 1);
          if (a === i) return;
          const o = n[a],
            r = i < a ? -1 : 1;
          for (let s = a; s !== i; s += r) n[s] = n[s + r];
          n[i] = o;
        }(o, c, r), o.forEach((C, k) => {
          if (v[k] === C) return;
          const T = C.drag === t,
            w = T ? h : p,
            N = T ? t.getPlaceholderElement() : C.drag.getRootElement();
          C.offset += w, s ? (N.style.transform = A0(`translate3d(${Math.round(C.offset)}px, 0, 0)`, C.initialTransform), Sl(C.clientRect, 0, w)) : (N.style.transform = A0(`translate3d(0, ${Math.round(C.offset)}px, 0)`, C.initialTransform), Sl(C.clientRect, w, 0));
        }), this._previousSwap.overlaps = t3(u, e, a), this._previousSwap.drag = l.drag, this._previousSwap.delta = s ? i.x : i.y, {
          previousIndex: c,
          currentIndex: r
        };
      }
      enter(t, e, a, i) {
        const o = null == i || i < 0 ? this._getItemIndexFromPointerPosition(t, e, a) : i,
          r = this._activeDraggables,
          s = r.indexOf(t),
          c = t.getPlaceholderElement();
        let l = r[o];
        if (l === t && (l = r[o + 1]), !l && (null == o || -1 === o || o < r.length - 1) && this._shouldEnterAsFirstChild(e, a) && (l = r[0]), s > -1 && r.splice(s, 1), l && !this._dragDropRegistry.isDragging(l)) {
          const d = l.getRootElement();
          d.parentElement.insertBefore(c, d), r.splice(o, 0, t);
        } else wt(this._element).appendChild(c), r.push(t);
        c.style.transform = "", this._cacheItemPositions();
      }
      withItems(t) {
        this._activeDraggables = t.slice(), this._cacheItemPositions();
      }
      withSortPredicate(t) {
        this._sortPredicate = t;
      }
      reset() {
        this._activeDraggables.forEach(t => {
          const e = t.getRootElement();
          if (e) {
            const a = this._itemPositions.find(i => i.drag === t)?.initialTransform;
            e.style.transform = a || "";
          }
        }), this._itemPositions = [], this._activeDraggables = [], this._previousSwap.drag = null, this._previousSwap.delta = 0, this._previousSwap.overlaps = !1;
      }
      getActiveItemsSnapshot() {
        return this._activeDraggables;
      }
      getItemIndex(t) {
        return ("horizontal" === this.orientation && "rtl" === this.direction ? this._itemPositions.slice().reverse() : this._itemPositions).findIndex(a => a.drag === t);
      }
      updateOnScroll(t, e) {
        this._itemPositions.forEach(({
          clientRect: a
        }) => {
          Sl(a, t, e);
        }), this._itemPositions.forEach(({
          drag: a
        }) => {
          this._dragDropRegistry.isDragging(a) && a._sortFromLastPointerPosition();
        });
      }
      _cacheItemPositions() {
        const t = "horizontal" === this.orientation;
        this._itemPositions = this._activeDraggables.map(e => {
          const a = e.getVisibleElement();
          return {
            drag: e,
            offset: 0,
            initialTransform: a.style.transform || "",
            clientRect: e3(a)
          };
        }).sort((e, a) => t ? e.clientRect.left - a.clientRect.left : e.clientRect.top - a.clientRect.top);
      }
      _getItemOffsetPx(t, e, a) {
        const i = "horizontal" === this.orientation;
        let o = i ? e.left - t.left : e.top - t.top;
        return -1 === a && (o += i ? e.width - t.width : e.height - t.height), o;
      }
      _getSiblingOffsetPx(t, e, a) {
        const i = "horizontal" === this.orientation,
          o = e[t].clientRect,
          r = e[t + -1 * a];
        let s = o[i ? "width" : "height"] * a;
        if (r) {
          const c = i ? "left" : "top",
            l = i ? "right" : "bottom";
          -1 === a ? s -= r.clientRect[c] - o[l] : s += o[c] - r.clientRect[l];
        }
        return s;
      }
      _shouldEnterAsFirstChild(t, e) {
        if (!this._activeDraggables.length) return !1;
        const a = this._itemPositions,
          i = "horizontal" === this.orientation;
        if (a[0].drag !== this._activeDraggables[0]) {
          const r = a[a.length - 1].clientRect;
          return i ? t >= r.right : e >= r.bottom;
        }
        {
          const r = a[0].clientRect;
          return i ? t <= r.left : e <= r.top;
        }
      }
      _getItemIndexFromPointerPosition(t, e, a, i) {
        const o = "horizontal" === this.orientation,
          r = this._itemPositions.findIndex(({
            drag: s,
            clientRect: c
          }) => {
            if (s === t) return !1;
            if (i) {
              const l = o ? i.x : i.y;
              if (s === this._previousSwap.drag && this._previousSwap.overlaps && l === this._previousSwap.delta) return !1;
            }
            return o ? e >= Math.floor(c.left) && e < Math.floor(c.right) : a >= Math.floor(c.top) && a < Math.floor(c.bottom);
          });
        return -1 !== r && this._sortPredicate(r, t) ? r : -1;
      }
    }
    class Xhe {
      constructor(t, e, a, i, o) {
        this._dragDropRegistry = e, this._ngZone = i, this._viewportRuler = o, this.disabled = !1, this.sortingDisabled = !1, this.autoScrollDisabled = !1, this.autoScrollStep = 2, this.enterPredicate = () => !0, this.sortPredicate = () => !0, this.beforeStarted = new V(), this.entered = new V(), this.exited = new V(), this.dropped = new V(), this.sorted = new V(), this._isDragging = !1, this._draggables = [], this._siblings = [], this._activeSiblings = new Set(), this._viewportScrollSubscription = re.EMPTY, this._verticalScrollDirection = 0, this._horizontalScrollDirection = 0, this._stopScrollTimers = new V(), this._cachedShadowRoot = null, this._startScrollInterval = () => {
          this._stopScrolling(), function Uhe(n = 0, t = Zr) {
            return (!Ph(n) || n < 0) && (n = 0), (!t || "function" != typeof t.schedule) && (t = Zr), new Be(e => (e.add(t.schedule(Ghe, n, {
              subscriber: e,
              counter: 0,
              period: n
            })), e));
          }(0, Oh).pipe(ne(this._stopScrollTimers)).subscribe(() => {
            const r = this._scrollNode,
              s = this.autoScrollStep;
            1 === this._verticalScrollDirection ? r.scrollBy(0, -s) : 2 === this._verticalScrollDirection && r.scrollBy(0, s), 1 === this._horizontalScrollDirection ? r.scrollBy(-s, 0) : 2 === this._horizontalScrollDirection && r.scrollBy(s, 0);
          });
        }, this.element = wt(t), this._document = a, this.withScrollableParents([this.element]), e.registerDropContainer(this), this._parentPositions = new Yx(a), this._sortStrategy = new Zhe(this.element, e), this._sortStrategy.withSortPredicate((r, s) => this.sortPredicate(r, s, this));
      }
      dispose() {
        this._stopScrolling(), this._stopScrollTimers.complete(), this._viewportScrollSubscription.unsubscribe(), this.beforeStarted.complete(), this.entered.complete(), this.exited.complete(), this.dropped.complete(), this.sorted.complete(), this._activeSiblings.clear(), this._scrollNode = null, this._parentPositions.clear(), this._dragDropRegistry.removeDropContainer(this);
      }
      isDragging() {
        return this._isDragging;
      }
      start() {
        this._draggingStarted(), this._notifyReceivingSiblings();
      }
      enter(t, e, a, i) {
        this._draggingStarted(), null == i && this.sortingDisabled && (i = this._draggables.indexOf(t)), this._sortStrategy.enter(t, e, a, i), this._cacheParentPositions(), this._notifyReceivingSiblings(), this.entered.next({
          item: t,
          container: this,
          currentIndex: this.getItemIndex(t)
        });
      }
      exit(t) {
        this._reset(), this.exited.next({
          item: t,
          container: this
        });
      }
      drop(t, e, a, i, o, r, s, c = {}) {
        this._reset(), this.dropped.next({
          item: t,
          currentIndex: e,
          previousIndex: a,
          container: this,
          previousContainer: i,
          isPointerOverContainer: o,
          distance: r,
          dropPoint: s,
          event: c
        });
      }
      withItems(t) {
        const e = this._draggables;
        return this._draggables = t, t.forEach(a => a._withDropContainer(this)), this.isDragging() && (e.filter(i => i.isDragging()).every(i => -1 === t.indexOf(i)) ? this._reset() : this._sortStrategy.withItems(this._draggables)), this;
      }
      withDirection(t) {
        return this._sortStrategy.direction = t, this;
      }
      connectedTo(t) {
        return this._siblings = t.slice(), this;
      }
      withOrientation(t) {
        return this._sortStrategy.orientation = t, this;
      }
      withScrollableParents(t) {
        const e = wt(this.element);
        return this._scrollableElements = -1 === t.indexOf(e) ? [e, ...t] : t.slice(), this;
      }
      getScrollableParents() {
        return this._scrollableElements;
      }
      getItemIndex(t) {
        return this._isDragging ? this._sortStrategy.getItemIndex(t) : this._draggables.indexOf(t);
      }
      isReceiving() {
        return this._activeSiblings.size > 0;
      }
      _sortItem(t, e, a, i) {
        if (this.sortingDisabled || !this._clientRect || !Wx(this._clientRect, .05, e, a)) return;
        const o = this._sortStrategy.sort(t, e, a, i);
        o && this.sorted.next({
          previousIndex: o.previousIndex,
          currentIndex: o.currentIndex,
          container: this,
          item: t
        });
      }
      _startScrollingIfNecessary(t, e) {
        if (this.autoScrollDisabled) return;
        let a,
          i = 0,
          o = 0;
        if (this._parentPositions.positions.forEach((r, s) => {
          s === this._document || !r.clientRect || a || Wx(r.clientRect, .05, t, e) && ([i, o] = function Jhe(n, t, e, a) {
            const i = aw(t, a),
              o = iw(t, e);
            let r = 0,
              s = 0;
            if (i) {
              const c = n.scrollTop;
              1 === i ? c > 0 && (r = 1) : n.scrollHeight - c > n.clientHeight && (r = 2);
            }
            if (o) {
              const c = n.scrollLeft;
              1 === o ? c > 0 && (s = 1) : n.scrollWidth - c > n.clientWidth && (s = 2);
            }
            return [r, s];
          }(s, r.clientRect, t, e), (i || o) && (a = s));
        }), !i && !o) {
          const {
              width: r,
              height: s
            } = this._viewportRuler.getViewportSize(),
            c = {
              width: r,
              height: s,
              top: 0,
              right: r,
              bottom: s,
              left: 0
            };
          i = aw(c, e), o = iw(c, t), a = window;
        }
        a && (i !== this._verticalScrollDirection || o !== this._horizontalScrollDirection || a !== this._scrollNode) && (this._verticalScrollDirection = i, this._horizontalScrollDirection = o, this._scrollNode = a, (i || o) && a ? this._ngZone.runOutsideAngular(this._startScrollInterval) : this._stopScrolling());
      }
      _stopScrolling() {
        this._stopScrollTimers.next();
      }
      _draggingStarted() {
        const t = wt(this.element).style;
        this.beforeStarted.next(), this._isDragging = !0, this._initialScrollSnap = t.msScrollSnapType || t.scrollSnapType || "", t.scrollSnapType = t.msScrollSnapType = "none", this._sortStrategy.start(this._draggables), this._cacheParentPositions(), this._viewportScrollSubscription.unsubscribe(), this._listenToScrollEvents();
      }
      _cacheParentPositions() {
        const t = wt(this.element);
        this._parentPositions.cache(this._scrollableElements), this._clientRect = this._parentPositions.positions.get(t).clientRect;
      }
      _reset() {
        this._isDragging = !1;
        const t = wt(this.element).style;
        t.scrollSnapType = t.msScrollSnapType = this._initialScrollSnap, this._siblings.forEach(e => e._stopReceiving(this)), this._sortStrategy.reset(), this._stopScrolling(), this._viewportScrollSubscription.unsubscribe(), this._parentPositions.clear();
      }
      _isOverContainer(t, e) {
        return null != this._clientRect && t3(this._clientRect, t, e);
      }
      _getSiblingContainerFromPosition(t, e, a) {
        return this._siblings.find(i => i._canReceive(t, e, a));
      }
      _canReceive(t, e, a) {
        if (!this._clientRect || !t3(this._clientRect, e, a) || !this.enterPredicate(t, this)) return !1;
        const i = this._getShadowRoot().elementFromPoint(e, a);
        if (!i) return !1;
        const o = wt(this.element);
        return i === o || o.contains(i);
      }
      _startReceiving(t, e) {
        const a = this._activeSiblings;
        !a.has(t) && e.every(i => this.enterPredicate(i, this) || this._draggables.indexOf(i) > -1) && (a.add(t), this._cacheParentPositions(), this._listenToScrollEvents());
      }
      _stopReceiving(t) {
        this._activeSiblings.delete(t), this._viewportScrollSubscription.unsubscribe();
      }
      _listenToScrollEvents() {
        this._viewportScrollSubscription = this._dragDropRegistry.scrolled(this._getShadowRoot()).subscribe(t => {
          if (this.isDragging()) {
            const e = this._parentPositions.handleScroll(t);
            e && this._sortStrategy.updateOnScroll(e.top, e.left);
          } else this.isReceiving() && this._cacheParentPositions();
        });
      }
      _getShadowRoot() {
        if (!this._cachedShadowRoot) {
          const t = Kd(wt(this.element));
          this._cachedShadowRoot = t || this._document;
        }
        return this._cachedShadowRoot;
      }
      _notifyReceivingSiblings() {
        const t = this._sortStrategy.getActiveItemsSnapshot().filter(e => e.isDragging());
        this._siblings.forEach(e => e._startReceiving(this, t));
      }
    }
    function aw(n, t) {
      const {
          top: e,
          bottom: a,
          height: i
        } = n,
        o = .05 * i;
      return t >= e - o && t <= e + o ? 1 : t >= a - o && t <= a + o ? 2 : 0;
    }
    function iw(n, t) {
      const {
          left: e,
          right: a,
          width: i
        } = n,
        o = .05 * i;
      return t >= e - o && t <= e + o ? 1 : t >= a - o && t <= a + o ? 2 : 0;
    }
    const T0 = ka({
      passive: !1,
      capture: !0
    });
    let $he = (() => {
      class n {
        constructor(e, a) {
          this._ngZone = e, this._dropInstances = new Set(), this._dragInstances = new Set(), this._activeDragInstances = [], this._globalListeners = new Map(), this._draggingPredicate = i => i.isDragging(), this.pointerMove = new V(), this.pointerUp = new V(), this.scroll = new V(), this._preventDefaultWhileDragging = i => {
            this._activeDragInstances.length > 0 && i.preventDefault();
          }, this._persistentTouchmoveListener = i => {
            this._activeDragInstances.length > 0 && (this._activeDragInstances.some(this._draggingPredicate) && i.preventDefault(), this.pointerMove.next(i));
          }, this._document = a;
        }
        registerDropContainer(e) {
          this._dropInstances.has(e) || this._dropInstances.add(e);
        }
        registerDragItem(e) {
          this._dragInstances.add(e), 1 === this._dragInstances.size && this._ngZone.runOutsideAngular(() => {
            this._document.addEventListener("touchmove", this._persistentTouchmoveListener, T0);
          });
        }
        removeDropContainer(e) {
          this._dropInstances.delete(e);
        }
        removeDragItem(e) {
          this._dragInstances.delete(e), this.stopDragging(e), 0 === this._dragInstances.size && this._document.removeEventListener("touchmove", this._persistentTouchmoveListener, T0);
        }
        startDragging(e, a) {
          if (!(this._activeDragInstances.indexOf(e) > -1) && (this._activeDragInstances.push(e), 1 === this._activeDragInstances.length)) {
            const i = a.type.startsWith("touch");
            this._globalListeners.set(i ? "touchend" : "mouseup", {
              handler: o => this.pointerUp.next(o),
              options: !0
            }).set("scroll", {
              handler: o => this.scroll.next(o),
              options: !0
            }).set("selectstart", {
              handler: this._preventDefaultWhileDragging,
              options: T0
            }), i || this._globalListeners.set("mousemove", {
              handler: o => this.pointerMove.next(o),
              options: T0
            }), this._ngZone.runOutsideAngular(() => {
              this._globalListeners.forEach((o, r) => {
                this._document.addEventListener(r, o.handler, o.options);
              });
            });
          }
        }
        stopDragging(e) {
          const a = this._activeDragInstances.indexOf(e);
          a > -1 && (this._activeDragInstances.splice(a, 1), 0 === this._activeDragInstances.length && this._clearGlobalListeners());
        }
        isDragging(e) {
          return this._activeDragInstances.indexOf(e) > -1;
        }
        scrolled(e) {
          const a = [this.scroll];
          return e && e !== this._document && a.push(new Be(i => this._ngZone.runOutsideAngular(() => {
            const r = s => {
              this._activeDragInstances.length && i.next(s);
            };
            return e.addEventListener("scroll", r, !0), () => {
              e.removeEventListener("scroll", r, !0);
            };
          }))), dt(...a);
        }
        ngOnDestroy() {
          this._dragInstances.forEach(e => this.removeDragItem(e)), this._dropInstances.forEach(e => this.removeDropContainer(e)), this._clearGlobalListeners(), this.pointerMove.complete(), this.pointerUp.complete();
        }
        _clearGlobalListeners() {
          this._globalListeners.forEach((e, a) => {
            this._document.removeEventListener(a, e.handler, e.options);
          }), this._globalListeners.clear();
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(ae), M(ie));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac,
        providedIn: "root"
      }), n;
    })();
    const epe = {
      dragStartThreshold: 5,
      pointerDirectionChangeThreshold: 5
    };
    let tpe = (() => {
        class n {
          constructor(e, a, i, o) {
            this._document = e, this._ngZone = a, this._viewportRuler = i, this._dragDropRegistry = o;
          }
          createDrag(e, a = epe) {
            return new Khe(e, a, this._document, this._ngZone, this._viewportRuler, this._dragDropRegistry);
          }
          createDropList(e) {
            return new Xhe(e, this._dragDropRegistry, this._document, this._ngZone, this._viewportRuler);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(ie), M(ae), M(Ki), M($he));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })(),
      npe = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [tpe],
          imports: [Wa]
        }), n;
      })(),
      lpe = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [$, sa, $]
        }), n;
      })(),
      upe = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [yt, $, $]
        }), n;
      })(),
      lw = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({}), n;
      })(),
      wpe = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [lw, sa, $, Zc, lw, $]
        }), n;
      })();
    function kpe(n, t) {
      if (1 & n && (_(0, "mat-option", 19), S(1), y()), 2 & n) {
        const e = t.$implicit;
        b("value", e), g(1), Fe(" ", e, " ");
      }
    }
    function Dpe(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "mat-form-field", 16)(1, "mat-select", 17), F("selectionChange", function (i) {
          return pe(e), ge(x(2)._changePageSize(i.value));
        }), D(2, kpe, 2, 2, "mat-option", 18), y()();
      }
      if (2 & n) {
        const e = x(2);
        b("appearance", e._formFieldAppearance)("color", e.color), g(1), b("value", e.pageSize)("disabled", e.disabled)("panelClass", e.selectConfig.panelClass || "")("disableOptionCentering", e.selectConfig.disableOptionCentering)("aria-label", e._intl.itemsPerPageLabel), g(1), b("ngForOf", e._displayedPageSizeOptions);
      }
    }
    function Ope(n, t) {
      if (1 & n && (_(0, "div", 20), S(1), y()), 2 & n) {
        const e = x(2);
        g(1), Ie(e.pageSize);
      }
    }
    function Ppe(n, t) {
      if (1 & n && (_(0, "div", 12)(1, "div", 13), S(2), y(), D(3, Dpe, 3, 8, "mat-form-field", 14), D(4, Ope, 2, 1, "div", 15), y()), 2 & n) {
        const e = x();
        g(2), Fe(" ", e._intl.itemsPerPageLabel, " "), g(1), b("ngIf", e._displayedPageSizeOptions.length > 1), g(1), b("ngIf", e._displayedPageSizeOptions.length <= 1);
      }
    }
    function Ape(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "button", 21), F("click", function () {
          return pe(e), ge(x().firstPage());
        }), Kn(), _(1, "svg", 7), j(2, "path", 22), y()();
      }
      if (2 & n) {
        const e = x();
        b("matTooltip", e._intl.firstPageLabel)("matTooltipDisabled", e._previousButtonsDisabled())("matTooltipPosition", "above")("disabled", e._previousButtonsDisabled()), X("aria-label", e._intl.firstPageLabel);
      }
    }
    function Spe(n, t) {
      if (1 & n) {
        const e = Le();
        Kn(), qs(), _(0, "button", 23), F("click", function () {
          return pe(e), ge(x().lastPage());
        }), Kn(), _(1, "svg", 7), j(2, "path", 24), y()();
      }
      if (2 & n) {
        const e = x();
        b("matTooltip", e._intl.lastPageLabel)("matTooltipDisabled", e._nextButtonsDisabled())("matTooltipPosition", "above")("disabled", e._nextButtonsDisabled()), X("aria-label", e._intl.lastPageLabel);
      }
    }
    let I0 = (() => {
      class n {
        constructor() {
          this.changes = new V(), this.itemsPerPageLabel = "Items per page:", this.nextPageLabel = "Next page", this.previousPageLabel = "Previous page", this.firstPageLabel = "First page", this.lastPageLabel = "Last page", this.getRangeLabel = (e, a, i) => {
            if (0 == i || 0 == a) return `0 of ${i}`;
            const o = e * a;
            return `${o + 1} \u2013 ${o < (i = Math.max(i, 0)) ? Math.min(o + a, i) : o + a} of ${i}`;
          };
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)();
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac,
        providedIn: "root"
      }), n;
    })();
    const Tpe = {
        provide: I0,
        deps: [[new En(), new ga(), I0]],
        useFactory: function Epe(n) {
          return n || new I0();
        }
      },
      Rpe = new O("MAT_PAGINATOR_DEFAULT_OPTIONS"),
      zpe = Fo(dB(class {}));
    let Lpe = (() => {
        class n extends zpe {
          constructor(e, a, i) {
            if (super(), this._intl = e, this._changeDetectorRef = a, this._pageIndex = 0, this._length = 0, this._pageSizeOptions = [], this._hidePageSize = !1, this._showFirstLastButtons = !1, this.selectConfig = {}, this.page = new E(), this._intlChanges = e.changes.subscribe(() => this._changeDetectorRef.markForCheck()), i) {
              const {
                pageSize: o,
                pageSizeOptions: r,
                hidePageSize: s,
                showFirstLastButtons: c
              } = i;
              null != o && (this._pageSize = o), null != r && (this._pageSizeOptions = r), null != s && (this._hidePageSize = s), null != c && (this._showFirstLastButtons = c);
            }
          }
          get pageIndex() {
            return this._pageIndex;
          }
          set pageIndex(e) {
            this._pageIndex = Math.max(xt(e), 0), this._changeDetectorRef.markForCheck();
          }
          get length() {
            return this._length;
          }
          set length(e) {
            this._length = xt(e), this._changeDetectorRef.markForCheck();
          }
          get pageSize() {
            return this._pageSize;
          }
          set pageSize(e) {
            this._pageSize = Math.max(xt(e), 0), this._updateDisplayedPageSizeOptions();
          }
          get pageSizeOptions() {
            return this._pageSizeOptions;
          }
          set pageSizeOptions(e) {
            this._pageSizeOptions = (e || []).map(a => xt(a)), this._updateDisplayedPageSizeOptions();
          }
          get hidePageSize() {
            return this._hidePageSize;
          }
          set hidePageSize(e) {
            this._hidePageSize = Y(e);
          }
          get showFirstLastButtons() {
            return this._showFirstLastButtons;
          }
          set showFirstLastButtons(e) {
            this._showFirstLastButtons = Y(e);
          }
          ngOnInit() {
            this._initialized = !0, this._updateDisplayedPageSizeOptions(), this._markInitialized();
          }
          ngOnDestroy() {
            this._intlChanges.unsubscribe();
          }
          nextPage() {
            if (!this.hasNextPage()) return;
            const e = this.pageIndex;
            this.pageIndex = this.pageIndex + 1, this._emitPageEvent(e);
          }
          previousPage() {
            if (!this.hasPreviousPage()) return;
            const e = this.pageIndex;
            this.pageIndex = this.pageIndex - 1, this._emitPageEvent(e);
          }
          firstPage() {
            if (!this.hasPreviousPage()) return;
            const e = this.pageIndex;
            this.pageIndex = 0, this._emitPageEvent(e);
          }
          lastPage() {
            if (!this.hasNextPage()) return;
            const e = this.pageIndex;
            this.pageIndex = this.getNumberOfPages() - 1, this._emitPageEvent(e);
          }
          hasPreviousPage() {
            return this.pageIndex >= 1 && 0 != this.pageSize;
          }
          hasNextPage() {
            const e = this.getNumberOfPages() - 1;
            return this.pageIndex < e && 0 != this.pageSize;
          }
          getNumberOfPages() {
            return this.pageSize ? Math.ceil(this.length / this.pageSize) : 0;
          }
          _changePageSize(e) {
            const i = this.pageIndex;
            this.pageIndex = Math.floor(this.pageIndex * this.pageSize / e) || 0, this.pageSize = e, this._emitPageEvent(i);
          }
          _nextButtonsDisabled() {
            return this.disabled || !this.hasNextPage();
          }
          _previousButtonsDisabled() {
            return this.disabled || !this.hasPreviousPage();
          }
          _updateDisplayedPageSizeOptions() {
            !this._initialized || (this.pageSize || (this._pageSize = 0 != this.pageSizeOptions.length ? this.pageSizeOptions[0] : 50), this._displayedPageSizeOptions = this.pageSizeOptions.slice(), -1 === this._displayedPageSizeOptions.indexOf(this.pageSize) && this._displayedPageSizeOptions.push(this.pageSize), this._displayedPageSizeOptions.sort((e, a) => e - a), this._changeDetectorRef.markForCheck());
          }
          _emitPageEvent(e) {
            this.page.emit({
              previousPageIndex: e,
              pageIndex: this.pageIndex,
              pageSize: this.pageSize,
              length: this.length
            });
          }
        }
        return n.ɵfac = function (e) {
          li();
        }, n.ɵdir = P({
          type: n,
          inputs: {
            color: "color",
            pageIndex: "pageIndex",
            length: "length",
            pageSize: "pageSize",
            pageSizeOptions: "pageSizeOptions",
            hidePageSize: "hidePageSize",
            showFirstLastButtons: "showFirstLastButtons",
            selectConfig: "selectConfig"
          },
          outputs: {
            page: "page"
          },
          features: [z]
        }), n;
      })(),
      dw = (() => {
        class n extends Lpe {
          constructor(e, a, i) {
            super(e, a, i), i && null != i.formFieldAppearance && (this._formFieldAppearance = i.formFieldAppearance);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(I0), f(Se), f(Rpe, 8));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-paginator"]],
          hostAttrs: ["role", "group", 1, "mat-paginator"],
          inputs: {
            disabled: "disabled"
          },
          exportAs: ["matPaginator"],
          features: [z],
          decls: 14,
          vars: 14,
          consts: [[1, "mat-paginator-outer-container"], [1, "mat-paginator-container"], ["class", "mat-paginator-page-size", 4, "ngIf"], [1, "mat-paginator-range-actions"], [1, "mat-paginator-range-label"], ["mat-icon-button", "", "type", "button", "class", "mat-paginator-navigation-first", 3, "matTooltip", "matTooltipDisabled", "matTooltipPosition", "disabled", "click", 4, "ngIf"], ["mat-icon-button", "", "type", "button", 1, "mat-paginator-navigation-previous", 3, "matTooltip", "matTooltipDisabled", "matTooltipPosition", "disabled", "click"], ["viewBox", "0 0 24 24", "focusable", "false", 1, "mat-paginator-icon"], ["d", "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"], ["mat-icon-button", "", "type", "button", 1, "mat-paginator-navigation-next", 3, "matTooltip", "matTooltipDisabled", "matTooltipPosition", "disabled", "click"], ["d", "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"], ["mat-icon-button", "", "type", "button", "class", "mat-paginator-navigation-last", 3, "matTooltip", "matTooltipDisabled", "matTooltipPosition", "disabled", "click", 4, "ngIf"], [1, "mat-paginator-page-size"], [1, "mat-paginator-page-size-label"], ["class", "mat-paginator-page-size-select", 3, "appearance", "color", 4, "ngIf"], ["class", "mat-paginator-page-size-value", 4, "ngIf"], [1, "mat-paginator-page-size-select", 3, "appearance", "color"], [3, "value", "disabled", "panelClass", "disableOptionCentering", "aria-label", "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], [1, "mat-paginator-page-size-value"], ["mat-icon-button", "", "type", "button", 1, "mat-paginator-navigation-first", 3, "matTooltip", "matTooltipDisabled", "matTooltipPosition", "disabled", "click"], ["d", "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"], ["mat-icon-button", "", "type", "button", 1, "mat-paginator-navigation-last", 3, "matTooltip", "matTooltipDisabled", "matTooltipPosition", "disabled", "click"], ["d", "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"]],
          template: function (e, a) {
            1 & e && (_(0, "div", 0)(1, "div", 1), D(2, Ppe, 5, 3, "div", 2), _(3, "div", 3)(4, "div", 4), S(5), y(), D(6, Ape, 3, 5, "button", 5), _(7, "button", 6), F("click", function () {
              return a.previousPage();
            }), Kn(), _(8, "svg", 7), j(9, "path", 8), y()(), qs(), _(10, "button", 9), F("click", function () {
              return a.nextPage();
            }), Kn(), _(11, "svg", 7), j(12, "path", 10), y()(), D(13, Spe, 3, 5, "button", 11), y()()()), 2 & e && (g(2), b("ngIf", !a.hidePageSize), g(3), Fe(" ", a._intl.getRangeLabel(a.pageIndex, a.pageSize, a.length), " "), g(1), b("ngIf", a.showFirstLastButtons), g(1), b("matTooltip", a._intl.previousPageLabel)("matTooltipDisabled", a._previousButtonsDisabled())("matTooltipPosition", "above")("disabled", a._previousButtonsDisabled()), X("aria-label", a._intl.previousPageLabel), g(3), b("matTooltip", a._intl.nextPageLabel)("matTooltipDisabled", a._nextButtonsDisabled())("matTooltipPosition", "above")("disabled", a._nextButtonsDisabled()), X("aria-label", a._intl.nextPageLabel), g(3), b("ngIf", a.showFirstLastButtons));
          },
          dependencies: [ea, mt, Pi, Si, r0, Ho, ys],
          styles: [".mat-paginator{display:block}.mat-paginator-outer-container{display:flex}.mat-paginator-container{display:flex;align-items:center;justify-content:flex-end;padding:0 8px;flex-wrap:wrap-reverse;width:100%}.mat-paginator-page-size{display:flex;align-items:baseline;margin-right:8px}[dir=rtl] .mat-paginator-page-size{margin-right:0;margin-left:8px}.mat-paginator-page-size-label{margin:0 4px}.mat-paginator-page-size-select{margin:6px 4px 0 4px;width:56px}.mat-paginator-page-size-select.mat-form-field-appearance-outline{width:64px}.mat-paginator-page-size-select.mat-form-field-appearance-fill{width:64px}.mat-paginator-range-label{margin:0 32px 0 24px}.mat-paginator-range-actions{display:flex;align-items:center}.mat-paginator-icon{display:inline-block;width:28px;fill:currentColor}[dir=rtl] .mat-paginator-icon{transform:rotate(180deg)}.cdk-high-contrast-active .mat-paginator-icon{fill:CanvasText}"],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })(),
      uw = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [Tpe],
          imports: [yt, Wo, D4, Z2, $]
        }), n;
      })(),
      Npe = 0;
    const a3 = new O("CdkAccordion");
    let Fpe = (() => {
        class n {
          constructor() {
            this._stateChanges = new V(), this._openCloseAllActions = new V(), this.id = "cdk-accordion-" + Npe++, this._multi = !1;
          }
          get multi() {
            return this._multi;
          }
          set multi(e) {
            this._multi = Y(e);
          }
          openAll() {
            this._multi && this._openCloseAllActions.next(!0);
          }
          closeAll() {
            this._openCloseAllActions.next(!1);
          }
          ngOnChanges(e) {
            this._stateChanges.next(e);
          }
          ngOnDestroy() {
            this._stateChanges.complete(), this._openCloseAllActions.complete();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n,
          selectors: [["cdk-accordion"], ["", "cdkAccordion", ""]],
          inputs: {
            multi: "multi"
          },
          exportAs: ["cdkAccordion"],
          features: [G([{
            provide: a3,
            useExisting: n
          }]), Ve]
        }), n;
      })(),
      Vpe = 0,
      Hpe = (() => {
        class n {
          constructor(e, a, i) {
            this.accordion = e, this._changeDetectorRef = a, this._expansionDispatcher = i, this._openCloseAllSubscription = re.EMPTY, this.closed = new E(), this.opened = new E(), this.destroyed = new E(), this.expandedChange = new E(), this.id = "cdk-accordion-child-" + Vpe++, this._expanded = !1, this._disabled = !1, this._removeUniqueSelectionListener = () => {}, this._removeUniqueSelectionListener = i.listen((o, r) => {
              this.accordion && !this.accordion.multi && this.accordion.id === r && this.id !== o && (this.expanded = !1);
            }), this.accordion && (this._openCloseAllSubscription = this._subscribeToOpenCloseAllActions());
          }
          get expanded() {
            return this._expanded;
          }
          set expanded(e) {
            e = Y(e), this._expanded !== e && (this._expanded = e, this.expandedChange.emit(e), e ? (this.opened.emit(), this._expansionDispatcher.notify(this.id, this.accordion ? this.accordion.id : this.id)) : this.closed.emit(), this._changeDetectorRef.markForCheck());
          }
          get disabled() {
            return this._disabled;
          }
          set disabled(e) {
            this._disabled = Y(e);
          }
          ngOnDestroy() {
            this.opened.complete(), this.closed.complete(), this.destroyed.emit(), this.destroyed.complete(), this._removeUniqueSelectionListener(), this._openCloseAllSubscription.unsubscribe();
          }
          toggle() {
            this.disabled || (this.expanded = !this.expanded);
          }
          close() {
            this.disabled || (this.expanded = !1);
          }
          open() {
            this.disabled || (this.expanded = !0);
          }
          _subscribeToOpenCloseAllActions() {
            return this.accordion._openCloseAllActions.subscribe(e => {
              this.disabled || (this.expanded = e);
            });
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(a3, 12), f(Se), f(np));
        }, n.ɵdir = P({
          type: n,
          selectors: [["cdk-accordion-item"], ["", "cdkAccordionItem", ""]],
          inputs: {
            expanded: "expanded",
            disabled: "disabled"
          },
          outputs: {
            closed: "closed",
            opened: "opened",
            destroyed: "destroyed",
            expandedChange: "expandedChange"
          },
          exportAs: ["cdkAccordionItem"],
          features: [G([{
            provide: a3,
            useValue: void 0
          }])]
        }), n;
      })(),
      Bpe = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({}), n;
      })();
    const jpe = ["body"];
    function Upe(n, t) {}
    const Gpe = [[["mat-expansion-panel-header"]], "*", [["mat-action-row"]]],
      Wpe = ["mat-expansion-panel-header", "*", "mat-action-row"];
    function Ype(n, t) {
      1 & n && j(0, "span", 2), 2 & n && b("@indicatorRotate", x()._getExpandedState());
    }
    const qpe = [[["mat-panel-title"]], [["mat-panel-description"]], "*"],
      Kpe = ["mat-panel-title", "mat-panel-description", "*"],
      o3 = new O("MAT_ACCORDION"),
      fw = "225ms cubic-bezier(0.4,0.0,0.2,1)",
      mw = {
        indicatorRotate: ht("indicatorRotate", [xe("collapsed, void", Z({
          transform: "rotate(0deg)"
        })), xe("expanded", Z({
          transform: "rotate(180deg)"
        })), Ee("expanded <=> collapsed, void => collapsed", Re(fw))]),
        bodyExpansion: ht("bodyExpansion", [xe("collapsed, void", Z({
          height: "0px",
          visibility: "hidden"
        })), xe("expanded", Z({
          height: "*",
          visibility: "visible"
        })), Ee("expanded <=> collapsed, void => collapsed", Re(fw))])
      },
      hw = new O("MAT_EXPANSION_PANEL");
    let r3 = (() => {
        class n {
          constructor(e, a) {
            this._template = e, this._expansionPanel = a;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(vt), f(hw, 8));
        }, n.ɵdir = P({
          type: n,
          selectors: [["ng-template", "matExpansionPanelContent", ""]]
        }), n;
      })(),
      Qpe = 0;
    const pw = new O("MAT_EXPANSION_PANEL_DEFAULT_OPTIONS");
    let s3 = (() => {
      class n extends Hpe {
        constructor(e, a, i, o, r, s, c) {
          super(e, a, i), this._viewContainerRef = o, this._animationMode = s, this._hideToggle = !1, this.afterExpand = new E(), this.afterCollapse = new E(), this._inputChanges = new V(), this._headerId = "mat-expansion-panel-header-" + Qpe++, this._bodyAnimationDone = new V(), this.accordion = e, this._document = r, this._bodyAnimationDone.pipe(rp((l, d) => l.fromState === d.fromState && l.toState === d.toState)).subscribe(l => {
            "void" !== l.fromState && ("expanded" === l.toState ? this.afterExpand.emit() : "collapsed" === l.toState && this.afterCollapse.emit());
          }), c && (this.hideToggle = c.hideToggle);
        }
        get hideToggle() {
          return this._hideToggle || this.accordion && this.accordion.hideToggle;
        }
        set hideToggle(e) {
          this._hideToggle = Y(e);
        }
        get togglePosition() {
          return this._togglePosition || this.accordion && this.accordion.togglePosition;
        }
        set togglePosition(e) {
          this._togglePosition = e;
        }
        _hasSpacing() {
          return !!this.accordion && this.expanded && "default" === this.accordion.displayMode;
        }
        _getExpandedState() {
          return this.expanded ? "expanded" : "collapsed";
        }
        toggle() {
          this.expanded = !this.expanded;
        }
        close() {
          this.expanded = !1;
        }
        open() {
          this.expanded = !0;
        }
        ngAfterContentInit() {
          this._lazyContent && this._lazyContent._expansionPanel === this && this.opened.pipe(Gt(null), Ht(() => this.expanded && !this._portal), $e(1)).subscribe(() => {
            this._portal = new Vc(this._lazyContent._template, this._viewContainerRef);
          });
        }
        ngOnChanges(e) {
          this._inputChanges.next(e);
        }
        ngOnDestroy() {
          super.ngOnDestroy(), this._bodyAnimationDone.complete(), this._inputChanges.complete();
        }
        _containsFocus() {
          if (this._body) {
            const e = this._document.activeElement,
              a = this._body.nativeElement;
            return e === a || a.contains(e);
          }
          return !1;
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(f(o3, 12), f(Se), f(np), f(ut), f(ie), f(Ft, 8), f(pw, 8));
      }, n.ɵcmp = q({
        type: n,
        selectors: [["mat-expansion-panel"]],
        contentQueries: function (e, a, i) {
          if (1 & e && De(i, r3, 5), 2 & e) {
            let o;
            H(o = B()) && (a._lazyContent = o.first);
          }
        },
        viewQuery: function (e, a) {
          if (1 & e && be(jpe, 5), 2 & e) {
            let i;
            H(i = B()) && (a._body = i.first);
          }
        },
        hostAttrs: [1, "mat-expansion-panel"],
        hostVars: 6,
        hostBindings: function (e, a) {
          2 & e && fe("mat-expanded", a.expanded)("_mat-animation-noopable", "NoopAnimations" === a._animationMode)("mat-expansion-panel-spacing", a._hasSpacing());
        },
        inputs: {
          disabled: "disabled",
          expanded: "expanded",
          hideToggle: "hideToggle",
          togglePosition: "togglePosition"
        },
        outputs: {
          opened: "opened",
          closed: "closed",
          expandedChange: "expandedChange",
          afterExpand: "afterExpand",
          afterCollapse: "afterCollapse"
        },
        exportAs: ["matExpansionPanel"],
        features: [G([{
          provide: o3,
          useValue: void 0
        }, {
          provide: hw,
          useExisting: n
        }]), z, Ve],
        ngContentSelectors: Wpe,
        decls: 7,
        vars: 4,
        consts: [["role", "region", 1, "mat-expansion-panel-content", 3, "id"], ["body", ""], [1, "mat-expansion-panel-body"], [3, "cdkPortalOutlet"]],
        template: function (e, a) {
          1 & e && (lt(Gpe), Me(0), _(1, "div", 0, 1), F("@bodyExpansion.done", function (o) {
            return a._bodyAnimationDone.next(o);
          }), _(3, "div", 2), Me(4, 1), D(5, Upe, 0, 0, "ng-template", 3), y(), Me(6, 2), y()), 2 & e && (g(1), b("@bodyExpansion", a._getExpandedState())("id", a.id), X("aria-labelledby", a._headerId), g(4), b("cdkPortalOutlet", a._portal));
        },
        dependencies: [es],
        styles: ['.mat-expansion-panel{box-sizing:content-box;display:block;margin:0;border-radius:4px;overflow:hidden;transition:margin 225ms cubic-bezier(0.4, 0, 0.2, 1),box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);position:relative}.mat-accordion .mat-expansion-panel:not(.mat-expanded),.mat-accordion .mat-expansion-panel:not(.mat-expansion-panel-spacing){border-radius:0}.mat-accordion .mat-expansion-panel:first-of-type{border-top-right-radius:4px;border-top-left-radius:4px}.mat-accordion .mat-expansion-panel:last-of-type{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.cdk-high-contrast-active .mat-expansion-panel{outline:solid 1px}.mat-expansion-panel.ng-animate-disabled,.ng-animate-disabled .mat-expansion-panel,.mat-expansion-panel._mat-animation-noopable{transition:none}.mat-expansion-panel-content{display:flex;flex-direction:column;overflow:visible}.mat-expansion-panel-content[style*="visibility: hidden"] *{visibility:hidden !important}.mat-expansion-panel-body{padding:0 24px 16px}.mat-expansion-panel-spacing{margin:16px 0}.mat-accordion>.mat-expansion-panel-spacing:first-child,.mat-accordion>*:first-child:not(.mat-expansion-panel) .mat-expansion-panel-spacing{margin-top:0}.mat-accordion>.mat-expansion-panel-spacing:last-child,.mat-accordion>*:last-child:not(.mat-expansion-panel) .mat-expansion-panel-spacing{margin-bottom:0}.mat-action-row{border-top-style:solid;border-top-width:1px;display:flex;flex-direction:row;justify-content:flex-end;padding:16px 8px 16px 24px}.mat-action-row .mat-button-base,.mat-action-row .mat-mdc-button-base{margin-left:8px}[dir=rtl] .mat-action-row .mat-button-base,[dir=rtl] .mat-action-row .mat-mdc-button-base{margin-left:0;margin-right:8px}'],
        encapsulation: 2,
        data: {
          animation: [mw.bodyExpansion]
        },
        changeDetection: 0
      }), n;
    })();
    class Zpe {}
    const Xpe = $i(Zpe);
    let c3 = (() => {
        class n extends Xpe {
          constructor(e, a, i, o, r, s, c) {
            super(), this.panel = e, this._element = a, this._focusMonitor = i, this._changeDetectorRef = o, this._animationMode = s, this._parentChangeSubscription = re.EMPTY;
            const l = e.accordion ? e.accordion._stateChanges.pipe(Ht(d => !(!d.hideToggle && !d.togglePosition))) : Ec;
            this.tabIndex = parseInt(c || "") || 0, this._parentChangeSubscription = dt(e.opened, e.closed, l, e._inputChanges.pipe(Ht(d => !!(d.hideToggle || d.disabled || d.togglePosition)))).subscribe(() => this._changeDetectorRef.markForCheck()), e.closed.pipe(Ht(() => e._containsFocus())).subscribe(() => i.focusVia(a, "program")), r && (this.expandedHeight = r.expandedHeight, this.collapsedHeight = r.collapsedHeight);
          }
          get disabled() {
            return this.panel.disabled;
          }
          _toggle() {
            this.disabled || this.panel.toggle();
          }
          _isExpanded() {
            return this.panel.expanded;
          }
          _getExpandedState() {
            return this.panel._getExpandedState();
          }
          _getPanelId() {
            return this.panel.id;
          }
          _getTogglePosition() {
            return this.panel.togglePosition;
          }
          _showToggle() {
            return !this.panel.hideToggle && !this.panel.disabled;
          }
          _getHeaderHeight() {
            const e = this._isExpanded();
            return e && this.expandedHeight ? this.expandedHeight : !e && this.collapsedHeight ? this.collapsedHeight : null;
          }
          _keydown(e) {
            switch (e.keyCode) {
              case 32:
              case 13:
                Et(e) || (e.preventDefault(), this._toggle());
                break;
              default:
                return void (this.panel.accordion && this.panel.accordion._handleHeaderKeydown(e));
            }
          }
          focus(e, a) {
            e ? this._focusMonitor.focusVia(this._element, e, a) : this._element.nativeElement.focus(a);
          }
          ngAfterViewInit() {
            this._focusMonitor.monitor(this._element).subscribe(e => {
              e && this.panel.accordion && this.panel.accordion._handleHeaderFocus(this);
            });
          }
          ngOnDestroy() {
            this._parentChangeSubscription.unsubscribe(), this._focusMonitor.stopMonitoring(this._element);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(s3, 1), f(J), f(Hn), f(Se), f(pw, 8), f(Ft, 8), qt("tabindex"));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-expansion-panel-header"]],
          hostAttrs: ["role", "button", 1, "mat-expansion-panel-header", "mat-focus-indicator"],
          hostVars: 15,
          hostBindings: function (e, a) {
            1 & e && F("click", function () {
              return a._toggle();
            })("keydown", function (o) {
              return a._keydown(o);
            }), 2 & e && (X("id", a.panel._headerId)("tabindex", a.tabIndex)("aria-controls", a._getPanelId())("aria-expanded", a._isExpanded())("aria-disabled", a.panel.disabled), en("height", a._getHeaderHeight()), fe("mat-expanded", a._isExpanded())("mat-expansion-toggle-indicator-after", "after" === a._getTogglePosition())("mat-expansion-toggle-indicator-before", "before" === a._getTogglePosition())("_mat-animation-noopable", "NoopAnimations" === a._animationMode));
          },
          inputs: {
            tabIndex: "tabIndex",
            expandedHeight: "expandedHeight",
            collapsedHeight: "collapsedHeight"
          },
          features: [z],
          ngContentSelectors: Kpe,
          decls: 5,
          vars: 3,
          consts: [[1, "mat-content"], ["class", "mat-expansion-indicator", 4, "ngIf"], [1, "mat-expansion-indicator"]],
          template: function (e, a) {
            1 & e && (lt(qpe), _(0, "span", 0), Me(1), Me(2, 1), Me(3, 2), y(), D(4, Ype, 1, 1, "span", 1)), 2 & e && (fe("mat-content-hide-toggle", !a._showToggle()), g(4), b("ngIf", a._showToggle()));
          },
          dependencies: [mt],
          styles: ['.mat-expansion-panel-header{display:flex;flex-direction:row;align-items:center;padding:0 24px;border-radius:inherit;transition:height 225ms cubic-bezier(0.4, 0, 0.2, 1)}.mat-expansion-panel-header._mat-animation-noopable{transition:none}.mat-expansion-panel-header:focus,.mat-expansion-panel-header:hover{outline:none}.mat-expansion-panel-header.mat-expanded:focus,.mat-expansion-panel-header.mat-expanded:hover{background:inherit}.mat-expansion-panel-header:not([aria-disabled=true]){cursor:pointer}.mat-expansion-panel-header.mat-expansion-toggle-indicator-before{flex-direction:row-reverse}.mat-expansion-panel-header.mat-expansion-toggle-indicator-before .mat-expansion-indicator{margin:0 16px 0 0}[dir=rtl] .mat-expansion-panel-header.mat-expansion-toggle-indicator-before .mat-expansion-indicator{margin:0 0 0 16px}.mat-content{display:flex;flex:1;flex-direction:row;overflow:hidden}.mat-content.mat-content-hide-toggle{margin-right:8px}[dir=rtl] .mat-content.mat-content-hide-toggle{margin-right:0;margin-left:8px}.mat-expansion-toggle-indicator-before .mat-content.mat-content-hide-toggle{margin-left:24px;margin-right:0}[dir=rtl] .mat-expansion-toggle-indicator-before .mat-content.mat-content-hide-toggle{margin-right:24px;margin-left:0}.mat-expansion-panel-header-title,.mat-expansion-panel-header-description{display:flex;flex-grow:1;flex-basis:0;margin-right:16px;align-items:center}[dir=rtl] .mat-expansion-panel-header-title,[dir=rtl] .mat-expansion-panel-header-description{margin-right:0;margin-left:16px}.mat-expansion-panel-header-description{flex-grow:2}.mat-expansion-indicator::after{border-style:solid;border-width:0 2px 2px 0;content:"";display:inline-block;padding:3px;transform:rotate(45deg);vertical-align:middle}.cdk-high-contrast-active .mat-expansion-panel-content{border-top:1px solid;border-top-left-radius:0;border-top-right-radius:0}'],
          encapsulation: 2,
          data: {
            animation: [mw.indicatorRotate]
          },
          changeDetection: 0
        }), n;
      })(),
      Jpe = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n,
          selectors: [["mat-panel-description"]],
          hostAttrs: [1, "mat-expansion-panel-header-description"]
        }), n;
      })(),
      gw = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n,
          selectors: [["mat-panel-title"]],
          hostAttrs: [1, "mat-expansion-panel-header-title"]
        }), n;
      })(),
      $pe = (() => {
        class n extends Fpe {
          constructor() {
            super(...arguments), this._ownHeaders = new Hr(), this._hideToggle = !1, this.displayMode = "default", this.togglePosition = "after";
          }
          get hideToggle() {
            return this._hideToggle;
          }
          set hideToggle(e) {
            this._hideToggle = Y(e);
          }
          ngAfterContentInit() {
            this._headers.changes.pipe(Gt(this._headers)).subscribe(e => {
              this._ownHeaders.reset(e.filter(a => a.panel.accordion === this)), this._ownHeaders.notifyOnChanges();
            }), this._keyManager = new dp(this._ownHeaders).withWrap().withHomeAndEnd();
          }
          _handleHeaderKeydown(e) {
            this._keyManager.onKeydown(e);
          }
          _handleHeaderFocus(e) {
            this._keyManager.updateActiveItem(e);
          }
          ngOnDestroy() {
            super.ngOnDestroy(), this._ownHeaders.destroy();
          }
        }
        return n.ɵfac = function () {
          let t;
          return function (a) {
            return (t || (t = he(n)))(a || n);
          };
        }(), n.ɵdir = P({
          type: n,
          selectors: [["mat-accordion"]],
          contentQueries: function (e, a, i) {
            if (1 & e && De(i, c3, 5), 2 & e) {
              let o;
              H(o = B()) && (a._headers = o);
            }
          },
          hostAttrs: [1, "mat-accordion"],
          hostVars: 2,
          hostBindings: function (e, a) {
            2 & e && fe("mat-accordion-multi", a.multi);
          },
          inputs: {
            multi: "multi",
            hideToggle: "hideToggle",
            displayMode: "displayMode",
            togglePosition: "togglePosition"
          },
          exportAs: ["matAccordion"],
          features: [G([{
            provide: o3,
            useExisting: n
          }]), z]
        }), n;
      })(),
      bw = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [yt, $, Bpe, Ya]
        }), n;
      })(),
      n4e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [qa, Ya, yt, Wo, $, $]
        }), n;
      })();
    const s4e = {
      provide: new O("mat-menu-scroll-strategy"),
      deps: [mn],
      useFactory: function r4e(n) {
        return () => n.scrollStrategies.reposition();
      }
    };
    let c4e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [s4e],
          imports: [yt, $, sa, qa, Wa, $]
        }), n;
      })(),
      yw = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [w2, $, w2, $]
        }), n;
      })(),
      l3 = (() => {
        class n {
          constructor() {
            this.changes = new V();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })();
    const f4e = {
      provide: l3,
      deps: [[new En(), new ga(), l3]],
      useFactory: function u4e(n) {
        return n || new l3();
      }
    };
    let m4e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [f4e],
          imports: [yt, $]
        }), n;
      })(),
      S4e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [jx, $, $]
        }), n;
      })();
    const T4e = ["*", [["mat-card-footer"]]],
      I4e = ["*", "mat-card-footer"];
    let R4e = (() => {
        class n {
          constructor(e) {
            this._animationMode = e;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(Ft, 8));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-card"]],
          hostAttrs: [1, "mat-card", "mat-focus-indicator"],
          hostVars: 2,
          hostBindings: function (e, a) {
            2 & e && fe("_mat-animation-noopable", "NoopAnimations" === a._animationMode);
          },
          exportAs: ["matCard"],
          ngContentSelectors: I4e,
          decls: 2,
          vars: 0,
          template: function (e, a) {
            1 & e && (lt(T4e), Me(0), Me(1, 1));
          },
          styles: [".mat-card{transition:box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);display:block;position:relative;padding:16px;border-radius:4px}.mat-card._mat-animation-noopable{transition:none !important;animation:none !important}.mat-card>.mat-divider-horizontal{position:absolute;left:0;width:100%}[dir=rtl] .mat-card>.mat-divider-horizontal{left:auto;right:0}.mat-card>.mat-divider-horizontal.mat-divider-inset{position:static;margin:0}[dir=rtl] .mat-card>.mat-divider-horizontal.mat-divider-inset{margin-right:0}.cdk-high-contrast-active .mat-card{outline:solid 1px}.mat-card-actions,.mat-card-subtitle,.mat-card-content{display:block;margin-bottom:16px}.mat-card-title{display:block;margin-bottom:8px}.mat-card-actions{margin-left:-8px;margin-right:-8px;padding:8px 0}.mat-card-actions-align-end{display:flex;justify-content:flex-end}.mat-card-image{width:calc(100% + 32px);margin:0 -16px 16px -16px;display:block;overflow:hidden}.mat-card-image img{width:100%}.mat-card-footer{display:block;margin:0 -16px -16px -16px}.mat-card-actions .mat-button,.mat-card-actions .mat-raised-button,.mat-card-actions .mat-stroked-button{margin:0 8px}.mat-card-header{display:flex;flex-direction:row}.mat-card-header .mat-card-title{margin-bottom:12px}.mat-card-header-text{margin:0 16px}.mat-card-avatar{height:40px;width:40px;border-radius:50%;flex-shrink:0;object-fit:cover}.mat-card-title-group{display:flex;justify-content:space-between}.mat-card-sm-image{width:80px;height:80px}.mat-card-md-image{width:112px;height:112px}.mat-card-lg-image{width:152px;height:152px}.mat-card-xl-image{width:240px;height:240px;margin:-8px}.mat-card-title-group>.mat-card-xl-image{margin:-8px 0 8px}@media(max-width: 599px){.mat-card-title-group{margin:0}.mat-card-xl-image{margin-left:0;margin-right:0}}.mat-card>:first-child,.mat-card-content>:first-child{margin-top:0}.mat-card>:last-child:not(.mat-card-footer),.mat-card-content>:last-child:not(.mat-card-footer){margin-bottom:0}.mat-card-image:first-child{margin-top:-16px;border-top-left-radius:inherit;border-top-right-radius:inherit}.mat-card>.mat-card-actions:last-child{margin-bottom:-8px;padding-bottom:0}.mat-card-actions:not(.mat-card-actions-align-end) .mat-button:first-child,.mat-card-actions:not(.mat-card-actions-align-end) .mat-raised-button:first-child,.mat-card-actions:not(.mat-card-actions-align-end) .mat-stroked-button:first-child{margin-left:0;margin-right:0}.mat-card-actions-align-end .mat-button:last-child,.mat-card-actions-align-end .mat-raised-button:last-child,.mat-card-actions-align-end .mat-stroked-button:last-child{margin-left:0;margin-right:0}.mat-card-title:not(:first-child),.mat-card-subtitle:not(:first-child){margin-top:-4px}.mat-card-header .mat-card-subtitle:not(:first-child){margin-top:-8px}.mat-card>.mat-card-xl-image:first-child{margin-top:-8px}.mat-card>.mat-card-xl-image:last-child{margin-bottom:-8px}"],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })(),
      Dw = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [$, $]
        }), n;
      })(),
      V4e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [yt, $, Ya, sa, Zc, Xc, $]
        }), n;
      })(),
      Ow = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [$, $]
        }), n;
      })();
    const H4e = ["*"],
      j4e = ["text"];
    function U4e(n, t) {
      if (1 & n && j(0, "mat-pseudo-checkbox", 5), 2 & n) {
        const e = x();
        b("state", e.selected ? "checked" : "unchecked")("disabled", e.disabled);
      }
    }
    const G4e = ["*", [["", "mat-list-avatar", ""], ["", "mat-list-icon", ""], ["", "matListAvatar", ""], ["", "matListIcon", ""]]],
      W4e = ["*", "[mat-list-avatar], [mat-list-icon], [matListAvatar], [matListIcon]"];
    let Y4e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "mat-list-avatar", ""], ["", "matListAvatar", ""]],
          hostAttrs: [1, "mat-list-avatar"]
        }), n;
      })(),
      q4e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "mat-list-icon", ""], ["", "matListIcon", ""]],
          hostAttrs: [1, "mat-list-icon"]
        }), n;
      })();
    const K4e = Za(class {}),
      Q4e = Za(class {}),
      Z4e = {
        provide: Bt,
        useExisting: Pe(() => d3),
        multi: !0
      };
    class X4e {
      constructor(t, e) {
        this.source = t, this.options = e;
      }
    }
    let Pw = (() => {
        class n extends Q4e {
          constructor(e, a, i) {
            super(), this._element = e, this._changeDetector = a, this.selectionList = i, this._selected = !1, this._disabled = !1, this._hasFocus = !1, this.selectedChange = new E(), this.checkboxPosition = "after", this._inputsInitialized = !1;
          }
          get color() {
            return this._color || this.selectionList.color;
          }
          set color(e) {
            this._color = e;
          }
          get value() {
            return this._value;
          }
          set value(e) {
            this.selected && !this.selectionList.compareWith(e, this.value) && this._inputsInitialized && (this.selected = !1), this._value = e;
          }
          get disabled() {
            return this._disabled || this.selectionList && this.selectionList.disabled;
          }
          set disabled(e) {
            const a = Y(e);
            a !== this._disabled && (this._disabled = a, this._changeDetector.markForCheck());
          }
          get selected() {
            return this.selectionList.selectedOptions.isSelected(this);
          }
          set selected(e) {
            const a = Y(e);
            a !== this._selected && (this._setSelected(a), (a || this.selectionList.multiple) && this.selectionList._reportValueChange());
          }
          ngOnInit() {
            const e = this.selectionList;
            e._value && e._value.some(i => e.compareWith(this._value, i)) && this._setSelected(!0);
            const a = this._selected;
            Promise.resolve().then(() => {
              (this._selected || a) && (this.selected = !0, this._changeDetector.markForCheck());
            }), this._inputsInitialized = !0;
          }
          ngAfterContentInit() {
            !function _B(n, t, e = "mat") {
              n.changes.pipe(Gt(n)).subscribe(({
                length: a
              }) => {
                Jc(t, `${e}-2-line`, !1), Jc(t, `${e}-3-line`, !1), Jc(t, `${e}-multi-line`, !1), 2 === a || 3 === a ? Jc(t, `${e}-${a}-line`, !0) : a > 3 && Jc(t, `${e}-multi-line`, !0);
              });
            }(this._lines, this._element);
          }
          ngOnDestroy() {
            this.selected && Promise.resolve().then(() => {
              this.selected = !1;
            });
            const e = this._hasFocus,
              a = this.selectionList._removeOptionFromList(this);
            e && a && a.focus();
          }
          toggle() {
            this.selected = !this.selected;
          }
          focus() {
            this._element.nativeElement.focus();
          }
          getLabel() {
            return this._text && this._text.nativeElement.textContent || "";
          }
          _isRippleDisabled() {
            return this.disabled || this.disableRipple || this.selectionList.disableRipple;
          }
          _handleClick() {
            !this.disabled && (this.selectionList.multiple || !this.selected) && (this.toggle(), this.selectionList._emitChangeEvent([this]));
          }
          _handleFocus() {
            this.selectionList._setFocusedOption(this), this._hasFocus = !0;
          }
          _handleBlur() {
            this.selectionList._onTouched(), this._hasFocus = !1;
          }
          _getHostElement() {
            return this._element.nativeElement;
          }
          _setSelected(e) {
            return e !== this._selected && (this._selected = e, e ? this.selectionList.selectedOptions.select(this) : this.selectionList.selectedOptions.deselect(this), this.selectedChange.emit(e), this._changeDetector.markForCheck(), !0);
          }
          _markForCheck() {
            this._changeDetector.markForCheck();
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(Se), f(Pe(() => d3)));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-list-option"]],
          contentQueries: function (e, a, i) {
            if (1 & e && (De(i, Y4e, 5), De(i, q4e, 5), De(i, bB, 5)), 2 & e) {
              let o;
              H(o = B()) && (a._avatar = o.first), H(o = B()) && (a._icon = o.first), H(o = B()) && (a._lines = o);
            }
          },
          viewQuery: function (e, a) {
            if (1 & e && be(j4e, 5), 2 & e) {
              let i;
              H(i = B()) && (a._text = i.first);
            }
          },
          hostAttrs: ["role", "option", 1, "mat-list-item", "mat-list-option", "mat-focus-indicator"],
          hostVars: 15,
          hostBindings: function (e, a) {
            1 & e && F("focus", function () {
              return a._handleFocus();
            })("blur", function () {
              return a._handleBlur();
            })("click", function () {
              return a._handleClick();
            }), 2 & e && (X("aria-selected", a.selected)("aria-disabled", a.disabled)("tabindex", -1), fe("mat-list-item-disabled", a.disabled)("mat-list-item-with-avatar", a._avatar || a._icon)("mat-primary", "primary" === a.color)("mat-accent", "primary" !== a.color && "warn" !== a.color)("mat-warn", "warn" === a.color)("mat-list-single-selected-option", a.selected && !a.selectionList.multiple));
          },
          inputs: {
            disableRipple: "disableRipple",
            checkboxPosition: "checkboxPosition",
            color: "color",
            value: "value",
            disabled: "disabled",
            selected: "selected"
          },
          outputs: {
            selectedChange: "selectedChange"
          },
          exportAs: ["matListOption"],
          features: [z],
          ngContentSelectors: W4e,
          decls: 7,
          vars: 5,
          consts: [[1, "mat-list-item-content"], ["mat-ripple", "", 1, "mat-list-item-ripple", 3, "matRippleTrigger", "matRippleDisabled"], [3, "state", "disabled", 4, "ngIf"], [1, "mat-list-text"], ["text", ""], [3, "state", "disabled"]],
          template: function (e, a) {
            1 & e && (lt(G4e), _(0, "div", 0), j(1, "div", 1), D(2, U4e, 1, 2, "mat-pseudo-checkbox", 2), _(3, "div", 3, 4), Me(5), y(), Me(6, 1), y()), 2 & e && (fe("mat-list-item-content-reverse", "after" == a.checkboxPosition), g(1), b("matRippleTrigger", a._getHostElement())("matRippleDisabled", a._isRippleDisabled()), g(1), b("ngIf", a.selectionList.multiple));
          },
          dependencies: [Xa, ry, mt],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })(),
      d3 = (() => {
        class n extends K4e {
          constructor(e, a, i) {
            super(), this._element = e, this._changeDetector = a, this._focusMonitor = i, this._multiple = !0, this._contentInitialized = !1, this.selectionChange = new E(), this.color = "accent", this.compareWith = (o, r) => o === r, this._disabled = !1, this.selectedOptions = new os(this._multiple), this._tabIndex = -1, this._onChange = o => {}, this._destroyed = new V(), this._onTouched = () => {};
          }
          get disabled() {
            return this._disabled;
          }
          set disabled(e) {
            this._disabled = Y(e), this._markOptionsForCheck();
          }
          get multiple() {
            return this._multiple;
          }
          set multiple(e) {
            const a = Y(e);
            a !== this._multiple && (this._multiple = a, this.selectedOptions = new os(this._multiple, this.selectedOptions.selected));
          }
          ngAfterContentInit() {
            this._contentInitialized = !0, this._keyManager = new dp(this.options).withWrap().withTypeAhead().withHomeAndEnd().skipPredicate(() => !1).withAllowedModifierKeys(["shiftKey"]), this._value && this._setOptionsFromValues(this._value), this._keyManager.tabOut.pipe(ne(this._destroyed)).subscribe(() => {
              this._allowFocusEscape();
            }), this.options.changes.pipe(Gt(null), ne(this._destroyed)).subscribe(() => {
              this._updateTabIndex();
            }), this.selectedOptions.changed.pipe(ne(this._destroyed)).subscribe(e => {
              if (e.added) for (let a of e.added) a.selected = !0;
              if (e.removed) for (let a of e.removed) a.selected = !1;
            }), this._focusMonitor.monitor(this._element).pipe(ne(this._destroyed)).subscribe(e => {
              if ("keyboard" === e || "program" === e) {
                let a = 0;
                for (let i = 0; i < this.options.length; i++) if (this.options.get(i)?.selected) {
                  a = i;
                  break;
                }
                this._keyManager.setActiveItem(a);
              }
            });
          }
          ngOnChanges(e) {
            const a = e.disableRipple,
              i = e.color;
            (a && !a.firstChange || i && !i.firstChange) && this._markOptionsForCheck();
          }
          ngOnDestroy() {
            this._focusMonitor.stopMonitoring(this._element), this._destroyed.next(), this._destroyed.complete(), this._isDestroyed = !0;
          }
          focus(e) {
            this._element.nativeElement.focus(e);
          }
          selectAll() {
            return this._setAllOptionsSelected(!0);
          }
          deselectAll() {
            return this._setAllOptionsSelected(!1);
          }
          _setFocusedOption(e) {
            this._keyManager.updateActiveItem(e);
          }
          _removeOptionFromList(e) {
            const a = this._getOptionIndex(e);
            return a > -1 && this._keyManager.activeItemIndex === a && (a > 0 ? this._keyManager.updateActiveItem(a - 1) : 0 === a && this.options.length > 1 && this._keyManager.updateActiveItem(Math.min(a + 1, this.options.length - 1))), this._keyManager.activeItem;
          }
          _keydown(e) {
            const a = e.keyCode,
              i = this._keyManager,
              o = i.activeItemIndex,
              r = Et(e);
            switch (a) {
              case 32:
              case 13:
                !r && !i.isTyping() && (this._toggleFocusedOption(), e.preventDefault());
                break;
              default:
                if (65 === a && this.multiple && Et(e, "ctrlKey") && !i.isTyping()) {
                  const s = this.options.some(c => !c.disabled && !c.selected);
                  this._setAllOptionsSelected(s, !0, !0), e.preventDefault();
                } else i.onKeydown(e);
            }
            this.multiple && (38 === a || 40 === a) && e.shiftKey && i.activeItemIndex !== o && this._toggleFocusedOption();
          }
          _reportValueChange() {
            if (this.options && !this._isDestroyed) {
              const e = this._getSelectedOptionValues();
              this._onChange(e), this._value = e;
            }
          }
          _emitChangeEvent(e) {
            this.selectionChange.emit(new X4e(this, e));
          }
          writeValue(e) {
            this._value = e, this.options && this._setOptionsFromValues(e || []);
          }
          setDisabledState(e) {
            this.disabled = e;
          }
          registerOnChange(e) {
            this._onChange = e;
          }
          registerOnTouched(e) {
            this._onTouched = e;
          }
          _setOptionsFromValues(e) {
            this.options.forEach(a => a._setSelected(!1)), e.forEach(a => {
              const i = this.options.find(o => !o.selected && this.compareWith(o.value, a));
              i && i._setSelected(!0);
            });
          }
          _getSelectedOptionValues() {
            return this.options.filter(e => e.selected).map(e => e.value);
          }
          _toggleFocusedOption() {
            let e = this._keyManager.activeItemIndex;
            if (null != e && this._isValidIndex(e)) {
              let a = this.options.toArray()[e];
              a && !a.disabled && (this._multiple || !a.selected) && (a.toggle(), this._emitChangeEvent([a]));
            }
          }
          _setAllOptionsSelected(e, a, i) {
            const o = [];
            return this.options.forEach(r => {
              (!a || !r.disabled) && r._setSelected(e) && o.push(r);
            }), o.length && (this._reportValueChange(), i && this._emitChangeEvent(o)), o;
          }
          _isValidIndex(e) {
            return e >= 0 && e < this.options.length;
          }
          _getOptionIndex(e) {
            return this.options.toArray().indexOf(e);
          }
          _markOptionsForCheck() {
            this.options && this.options.forEach(e => e._markForCheck());
          }
          _allowFocusEscape() {
            this._tabIndex = -1, setTimeout(() => {
              this._tabIndex = 0, this._changeDetector.markForCheck();
            });
          }
          _updateTabIndex() {
            this._tabIndex = 0 === this.options.length ? -1 : 0;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(Se), f(Hn));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-selection-list"]],
          contentQueries: function (e, a, i) {
            if (1 & e && De(i, Pw, 5), 2 & e) {
              let o;
              H(o = B()) && (a.options = o);
            }
          },
          hostAttrs: ["role", "listbox", 1, "mat-selection-list", "mat-list-base"],
          hostVars: 3,
          hostBindings: function (e, a) {
            1 & e && F("keydown", function (o) {
              return a._keydown(o);
            }), 2 & e && X("aria-multiselectable", a.multiple)("aria-disabled", a.disabled.toString())("tabindex", a._tabIndex);
          },
          inputs: {
            disableRipple: "disableRipple",
            color: "color",
            compareWith: "compareWith",
            disabled: "disabled",
            multiple: "multiple"
          },
          outputs: {
            selectionChange: "selectionChange"
          },
          exportAs: ["matSelectionList"],
          features: [G([Z4e]), z, Ve],
          ngContentSelectors: H4e,
          decls: 1,
          vars: 0,
          template: function (e, a) {
            1 & e && (lt(), Me(0));
          },
          styles: ['.mat-subheader{display:flex;box-sizing:border-box;padding:16px;align-items:center}.mat-list-base .mat-subheader{margin:0}button.mat-list-item,button.mat-list-option{padding:0;width:100%;background:none;color:inherit;border:none;outline:inherit;-webkit-tap-highlight-color:rgba(0,0,0,0);text-align:left}[dir=rtl] button.mat-list-item,[dir=rtl] button.mat-list-option{text-align:right}button.mat-list-item::-moz-focus-inner,button.mat-list-option::-moz-focus-inner{border:0}.mat-list-base{padding-top:8px;display:block;-webkit-tap-highlight-color:rgba(0,0,0,0)}.mat-list-base .mat-subheader{height:48px;line-height:16px}.mat-list-base .mat-subheader:first-child{margin-top:-8px}.mat-list-base .mat-list-item,.mat-list-base .mat-list-option{display:block;height:48px;-webkit-tap-highlight-color:rgba(0,0,0,0);width:100%;padding:0}.mat-list-base .mat-list-item .mat-list-item-content,.mat-list-base .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list-base .mat-list-item .mat-list-item-content-reverse,.mat-list-base .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list-base .mat-list-item .mat-list-item-ripple,.mat-list-base .mat-list-option .mat-list-item-ripple{display:block;top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list-base .mat-list-item.mat-list-item-with-avatar,.mat-list-base .mat-list-option.mat-list-item-with-avatar{height:56px}.mat-list-base .mat-list-item.mat-2-line,.mat-list-base .mat-list-option.mat-2-line{height:72px}.mat-list-base .mat-list-item.mat-3-line,.mat-list-base .mat-list-option.mat-3-line{height:88px}.mat-list-base .mat-list-item.mat-multi-line,.mat-list-base .mat-list-option.mat-multi-line{height:auto}.mat-list-base .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list-base .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list-base .mat-list-item .mat-list-text,.mat-list-base .mat-list-option .mat-list-text{display:flex;flex-direction:column;flex:auto;box-sizing:border-box;overflow:hidden;padding:0}.mat-list-base .mat-list-item .mat-list-text>*,.mat-list-base .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:normal;font-size:inherit}.mat-list-base .mat-list-item .mat-list-text:empty,.mat-list-base .mat-list-option .mat-list-text:empty{display:none}.mat-list-base .mat-list-item.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-item.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-option.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-option.mat-list-option .mat-list-item-content .mat-list-text{padding-right:0;padding-left:16px}[dir=rtl] .mat-list-base .mat-list-item.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base .mat-list-item.mat-list-option .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base .mat-list-option.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base .mat-list-option.mat-list-option .mat-list-item-content .mat-list-text{padding-right:16px;padding-left:0}.mat-list-base .mat-list-item.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,.mat-list-base .mat-list-item.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base .mat-list-option.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,.mat-list-base .mat-list-option.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-left:0;padding-right:16px}[dir=rtl] .mat-list-base .mat-list-item.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base .mat-list-item.mat-list-option .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base .mat-list-option.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base .mat-list-option.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-right:0;padding-left:16px}.mat-list-base .mat-list-item.mat-list-item-with-avatar.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base .mat-list-item.mat-list-item-with-avatar.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base .mat-list-option.mat-list-item-with-avatar.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base .mat-list-option.mat-list-item-with-avatar.mat-list-option .mat-list-item-content .mat-list-text{padding-right:16px;padding-left:16px}.mat-list-base .mat-list-item .mat-list-avatar,.mat-list-base .mat-list-option .mat-list-avatar{flex-shrink:0;width:40px;height:40px;border-radius:50%;object-fit:cover}.mat-list-base .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list-base .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:72px;width:calc(100% - 72px)}[dir=rtl] .mat-list-base .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list-base .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:72px}.mat-list-base .mat-list-item .mat-list-icon,.mat-list-base .mat-list-option .mat-list-icon{flex-shrink:0;width:24px;height:24px;font-size:24px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list-base .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list-base .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:64px;width:calc(100% - 64px)}[dir=rtl] .mat-list-base .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list-base .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:64px}.mat-list-base .mat-list-item .mat-divider,.mat-list-base .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list-base .mat-list-item .mat-divider,[dir=rtl] .mat-list-base .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list-base .mat-list-item .mat-divider.mat-divider-inset,.mat-list-base .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-list-base[dense]{padding-top:4px;display:block}.mat-list-base[dense] .mat-subheader{height:40px;line-height:8px}.mat-list-base[dense] .mat-subheader:first-child{margin-top:-4px}.mat-list-base[dense] .mat-list-item,.mat-list-base[dense] .mat-list-option{display:block;height:40px;-webkit-tap-highlight-color:rgba(0,0,0,0);width:100%;padding:0}.mat-list-base[dense] .mat-list-item .mat-list-item-content,.mat-list-base[dense] .mat-list-option .mat-list-item-content{display:flex;flex-direction:row;align-items:center;box-sizing:border-box;padding:0 16px;position:relative;height:inherit}.mat-list-base[dense] .mat-list-item .mat-list-item-content-reverse,.mat-list-base[dense] .mat-list-option .mat-list-item-content-reverse{display:flex;align-items:center;padding:0 16px;flex-direction:row-reverse;justify-content:space-around}.mat-list-base[dense] .mat-list-item .mat-list-item-ripple,.mat-list-base[dense] .mat-list-option .mat-list-item-ripple{display:block;top:0;left:0;right:0;bottom:0;position:absolute;pointer-events:none}.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar{height:48px}.mat-list-base[dense] .mat-list-item.mat-2-line,.mat-list-base[dense] .mat-list-option.mat-2-line{height:60px}.mat-list-base[dense] .mat-list-item.mat-3-line,.mat-list-base[dense] .mat-list-option.mat-3-line{height:76px}.mat-list-base[dense] .mat-list-item.mat-multi-line,.mat-list-base[dense] .mat-list-option.mat-multi-line{height:auto}.mat-list-base[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-list-base[dense] .mat-list-option.mat-multi-line .mat-list-item-content{padding-top:16px;padding-bottom:16px}.mat-list-base[dense] .mat-list-item .mat-list-text,.mat-list-base[dense] .mat-list-option .mat-list-text{display:flex;flex-direction:column;flex:auto;box-sizing:border-box;overflow:hidden;padding:0}.mat-list-base[dense] .mat-list-item .mat-list-text>*,.mat-list-base[dense] .mat-list-option .mat-list-text>*{margin:0;padding:0;font-weight:normal;font-size:inherit}.mat-list-base[dense] .mat-list-item .mat-list-text:empty,.mat-list-base[dense] .mat-list-option .mat-list-text:empty{display:none}.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-item.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-option .mat-list-item-content .mat-list-text{padding-right:0;padding-left:16px}[dir=rtl] .mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-item.mat-list-option .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar .mat-list-item-content .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-option.mat-list-option .mat-list-item-content .mat-list-text{padding-right:16px;padding-left:0}.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,.mat-list-base[dense] .mat-list-item.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-left:0;padding-right:16px}[dir=rtl] .mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-item.mat-list-option .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar .mat-list-item-content-reverse .mat-list-text,[dir=rtl] .mat-list-base[dense] .mat-list-option.mat-list-option .mat-list-item-content-reverse .mat-list-text{padding-right:0;padding-left:16px}.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base[dense] .mat-list-item.mat-list-item-with-avatar.mat-list-option .mat-list-item-content .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar.mat-list-option .mat-list-item-content-reverse .mat-list-text,.mat-list-base[dense] .mat-list-option.mat-list-item-with-avatar.mat-list-option .mat-list-item-content .mat-list-text{padding-right:16px;padding-left:16px}.mat-list-base[dense] .mat-list-item .mat-list-avatar,.mat-list-base[dense] .mat-list-option .mat-list-avatar{flex-shrink:0;width:36px;height:36px;border-radius:50%;object-fit:cover}.mat-list-base[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,.mat-list-base[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:68px;width:calc(100% - 68px)}[dir=rtl] .mat-list-base[dense] .mat-list-item .mat-list-avatar~.mat-divider-inset,[dir=rtl] .mat-list-base[dense] .mat-list-option .mat-list-avatar~.mat-divider-inset{margin-left:auto;margin-right:68px}.mat-list-base[dense] .mat-list-item .mat-list-icon,.mat-list-base[dense] .mat-list-option .mat-list-icon{flex-shrink:0;width:20px;height:20px;font-size:20px;box-sizing:content-box;border-radius:50%;padding:4px}.mat-list-base[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,.mat-list-base[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:60px;width:calc(100% - 60px)}[dir=rtl] .mat-list-base[dense] .mat-list-item .mat-list-icon~.mat-divider-inset,[dir=rtl] .mat-list-base[dense] .mat-list-option .mat-list-icon~.mat-divider-inset{margin-left:auto;margin-right:60px}.mat-list-base[dense] .mat-list-item .mat-divider,.mat-list-base[dense] .mat-list-option .mat-divider{position:absolute;bottom:0;left:0;width:100%;margin:0}[dir=rtl] .mat-list-base[dense] .mat-list-item .mat-divider,[dir=rtl] .mat-list-base[dense] .mat-list-option .mat-divider{margin-left:auto;margin-right:0}.mat-list-base[dense] .mat-list-item .mat-divider.mat-divider-inset,.mat-list-base[dense] .mat-list-option .mat-divider.mat-divider-inset{position:absolute}.mat-nav-list a{text-decoration:none;color:inherit}.mat-nav-list .mat-list-item{cursor:pointer;outline:none}mat-action-list .mat-list-item{cursor:pointer;outline:inherit}.mat-list-option:not(.mat-list-item-disabled){cursor:pointer;outline:none}.mat-list-item-disabled{pointer-events:none}.cdk-high-contrast-active .mat-list-item-disabled{opacity:.5}.cdk-high-contrast-active :host .mat-list-item-disabled{opacity:.5}.cdk-high-contrast-active .mat-list-option:hover,.cdk-high-contrast-active .mat-nav-list .mat-list-item:hover,.cdk-high-contrast-active mat-action-list .mat-list-item:hover{outline:dotted 1px;z-index:1}.cdk-high-contrast-active .mat-list-single-selected-option::after{content:"";position:absolute;top:50%;right:16px;transform:translateY(-50%);width:10px;height:0;border-bottom:solid 10px;border-radius:10px}.cdk-high-contrast-active [dir=rtl] .mat-list-single-selected-option::after{right:auto;left:16px}@media(hover: none){.mat-list-option:not(.mat-list-single-selected-option):not(.mat-list-item-disabled):hover,.mat-nav-list .mat-list-item:not(.mat-list-item-disabled):hover,.mat-action-list .mat-list-item:not(.mat-list-item-disabled):hover{background:none}}'],
          encapsulation: 2,
          changeDetection: 0
        }), n;
      })(),
      J4e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [w2, sa, $, yp, yt, w2, $, yp, Ow]
        }), n;
      })(),
      $4e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [Jr]
        }), n;
      })(),
      u3 = (() => {
        class n {
          constructor() {
            this.changes = new V(), this.optionalLabel = "Optional", this.completedLabel = "Completed", this.editableLabel = "Editable";
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac,
          providedIn: "root"
        }), n;
      })();
    const d3e = {
      provide: u3,
      deps: [[new En(), new ga(), u3]],
      useFactory: function l3e(n) {
        return n || new u3();
      }
    };
    let u3e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [d3e, ls],
          imports: [$, yt, Ya, Wo, $4e, Q2, sa, $]
        }), n;
      })(),
      m3e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [yt, $, Wa, Wa, $]
        }), n;
      })(),
      w3e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [yt, $, $]
        }), n;
      })(),
      k3e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [Xc, $, $]
        }), n;
      })();
    function D3e(n, t) {}
    class R0 {
      constructor() {
        this.role = "dialog", this.panelClass = "", this.hasBackdrop = !0, this.backdropClass = "", this.disableClose = !1, this.width = "", this.height = "", this.data = null, this.ariaDescribedBy = null, this.ariaLabelledBy = null, this.ariaLabel = null, this.ariaModal = !0, this.autoFocus = "first-tabbable", this.restoreFocus = !0, this.closeOnNavigation = !0, this.closeOnDestroy = !0;
      }
    }
    let Rw = (() => {
      class n extends Ih {
        constructor(e, a, i, o, r, s, c, l) {
          super(), this._elementRef = e, this._focusTrapFactory = a, this._config = o, this._interactivityChecker = r, this._ngZone = s, this._overlayRef = c, this._focusMonitor = l, this._elementFocusedBeforeDialogWasOpened = null, this._closeInteractionType = null, this.attachDomPortal = d => {
            this._portalOutlet.hasAttached();
            const u = this._portalOutlet.attachDomPortal(d);
            return this._contentAttached(), u;
          }, this._ariaLabelledBy = this._config.ariaLabelledBy || null, this._document = i;
        }
        _contentAttached() {
          this._initializeFocusTrap(), this._handleBackdropClicks(), this._captureInitialFocus();
        }
        _captureInitialFocus() {
          this._trapFocus();
        }
        ngOnDestroy() {
          this._restoreFocus();
        }
        attachComponentPortal(e) {
          this._portalOutlet.hasAttached();
          const a = this._portalOutlet.attachComponentPortal(e);
          return this._contentAttached(), a;
        }
        attachTemplatePortal(e) {
          this._portalOutlet.hasAttached();
          const a = this._portalOutlet.attachTemplatePortal(e);
          return this._contentAttached(), a;
        }
        _recaptureFocus() {
          this._containsFocus() || this._trapFocus();
        }
        _forceFocus(e, a) {
          this._interactivityChecker.isFocusable(e) || (e.tabIndex = -1, this._ngZone.runOutsideAngular(() => {
            const i = () => {
              e.removeEventListener("blur", i), e.removeEventListener("mousedown", i), e.removeAttribute("tabindex");
            };
            e.addEventListener("blur", i), e.addEventListener("mousedown", i);
          })), e.focus(a);
        }
        _focusByCssSelector(e, a) {
          let i = this._elementRef.nativeElement.querySelector(e);
          i && this._forceFocus(i, a);
        }
        _trapFocus() {
          const e = this._elementRef.nativeElement;
          switch (this._config.autoFocus) {
            case !1:
            case "dialog":
              this._containsFocus() || e.focus();
              break;
            case !0:
            case "first-tabbable":
              this._focusTrap.focusInitialElementWhenReady().then(a => {
                a || this._focusDialogContainer();
              });
              break;
            case "first-heading":
              this._focusByCssSelector('h1, h2, h3, h4, h5, h6, [role="heading"]');
              break;
            default:
              this._focusByCssSelector(this._config.autoFocus);
          }
        }
        _restoreFocus() {
          const e = this._config.restoreFocus;
          let a = null;
          if ("string" == typeof e ? a = this._document.querySelector(e) : "boolean" == typeof e ? a = e ? this._elementFocusedBeforeDialogWasOpened : null : e && (a = e), this._config.restoreFocus && a && "function" == typeof a.focus) {
            const i = Fc(),
              o = this._elementRef.nativeElement;
            (!i || i === this._document.body || i === o || o.contains(i)) && (this._focusMonitor ? (this._focusMonitor.focusVia(a, this._closeInteractionType), this._closeInteractionType = null) : a.focus());
          }
          this._focusTrap && this._focusTrap.destroy();
        }
        _focusDialogContainer() {
          this._elementRef.nativeElement.focus && this._elementRef.nativeElement.focus();
        }
        _containsFocus() {
          const e = this._elementRef.nativeElement,
            a = Fc();
          return e === a || e.contains(a);
        }
        _initializeFocusTrap() {
          this._focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement), this._document && (this._elementFocusedBeforeDialogWasOpened = Fc());
        }
        _handleBackdropClicks() {
          this._overlayRef.backdropClick().subscribe(() => {
            this._config.disableClose && this._recaptureFocus();
          });
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(f(J), f(M2), f(ie, 8), f(R0), f(C2), f(ae), f(Uc), f(Hn));
      }, n.ɵcmp = q({
        type: n,
        selectors: [["cdk-dialog-container"]],
        viewQuery: function (e, a) {
          if (1 & e && be(es, 7), 2 & e) {
            let i;
            H(i = B()) && (a._portalOutlet = i.first);
          }
        },
        hostAttrs: ["tabindex", "-1", 1, "cdk-dialog-container"],
        hostVars: 6,
        hostBindings: function (e, a) {
          2 & e && X("id", a._config.id || null)("role", a._config.role)("aria-modal", a._config.ariaModal)("aria-labelledby", a._config.ariaLabel ? null : a._ariaLabelledBy)("aria-label", a._config.ariaLabel)("aria-describedby", a._config.ariaDescribedBy || null);
        },
        features: [z],
        decls: 1,
        vars: 0,
        consts: [["cdkPortalOutlet", ""]],
        template: function (e, a) {
          1 & e && D(0, D3e, 0, 0, "ng-template", 0);
        },
        dependencies: [es],
        styles: [".cdk-dialog-container{display:block;width:100%;height:100%;min-height:inherit;max-height:inherit}"],
        encapsulation: 2
      }), n;
    })();
    class m3 {
      constructor(t, e) {
        this.overlayRef = t, this.config = e, this.closed = new V(), this.disableClose = e.disableClose, this.backdropClick = t.backdropClick(), this.keydownEvents = t.keydownEvents(), this.outsidePointerEvents = t.outsidePointerEvents(), this.id = e.id, this.keydownEvents.subscribe(a => {
          27 === a.keyCode && !this.disableClose && !Et(a) && (a.preventDefault(), this.close(void 0, {
            focusOrigin: "keyboard"
          }));
        }), this.backdropClick.subscribe(() => {
          this.disableClose || this.close(void 0, {
            focusOrigin: "mouse"
          });
        });
      }
      close(t, e) {
        if (this.containerInstance) {
          const a = this.closed;
          this.containerInstance._closeInteractionType = e?.focusOrigin || "program", this.overlayRef.dispose(), a.next(t), a.complete(), this.componentInstance = this.containerInstance = null;
        }
      }
      updatePosition() {
        return this.overlayRef.updatePosition(), this;
      }
      updateSize(t = "", e = "") {
        return this.overlayRef.updateSize({
          width: t,
          height: e
        }), this;
      }
      addPanelClass(t) {
        return this.overlayRef.addPanelClass(t), this;
      }
      removePanelClass(t) {
        return this.overlayRef.removePanelClass(t), this;
      }
    }
    const zw = new O("DialogScrollStrategy"),
      O3e = new O("DialogData"),
      P3e = new O("DefaultDialogConfig"),
      S3e = {
        provide: zw,
        deps: [mn],
        useFactory: function A3e(n) {
          return () => n.scrollStrategies.block();
        }
      };
    let E3e = 0,
      Lw = (() => {
        class n {
          constructor(e, a, i, o, r, s) {
            this._overlay = e, this._injector = a, this._defaultOptions = i, this._parentDialog = o, this._overlayContainer = r, this._openDialogsAtThisLevel = [], this._afterAllClosedAtThisLevel = new V(), this._afterOpenedAtThisLevel = new V(), this._ariaHiddenElements = new Map(), this.afterAllClosed = a0(() => this.openDialogs.length ? this._getAfterAllClosed() : this._getAfterAllClosed().pipe(Gt(void 0))), this._scrollStrategy = s;
          }
          get openDialogs() {
            return this._parentDialog ? this._parentDialog.openDialogs : this._openDialogsAtThisLevel;
          }
          get afterOpened() {
            return this._parentDialog ? this._parentDialog.afterOpened : this._afterOpenedAtThisLevel;
          }
          open(e, a) {
            (a = {
              ...(this._defaultOptions || new R0()),
              ...a
            }).id = a.id || "cdk-dialog-" + E3e++, a.id && this.getDialogById(a.id);
            const o = this._getOverlayConfig(a),
              r = this._overlay.create(o),
              s = new m3(r, a),
              c = this._attachContainer(r, s, a);
            return s.containerInstance = c, this._attachDialogContent(e, s, c, a), this.openDialogs.length || this._hideNonDialogContentFromAssistiveTechnology(), this.openDialogs.push(s), s.closed.subscribe(() => this._removeOpenDialog(s, !0)), this.afterOpened.next(s), s;
          }
          closeAll() {
            h3(this.openDialogs, e => e.close());
          }
          getDialogById(e) {
            return this.openDialogs.find(a => a.id === e);
          }
          ngOnDestroy() {
            h3(this._openDialogsAtThisLevel, e => {
              !1 === e.config.closeOnDestroy && this._removeOpenDialog(e, !1);
            }), h3(this._openDialogsAtThisLevel, e => e.close()), this._afterAllClosedAtThisLevel.complete(), this._afterOpenedAtThisLevel.complete(), this._openDialogsAtThisLevel = [];
          }
          _getOverlayConfig(e) {
            const a = new jc({
              positionStrategy: e.positionStrategy || this._overlay.position().global().centerHorizontally().centerVertically(),
              scrollStrategy: e.scrollStrategy || this._scrollStrategy(),
              panelClass: e.panelClass,
              hasBackdrop: e.hasBackdrop,
              direction: e.direction,
              minWidth: e.minWidth,
              minHeight: e.minHeight,
              maxWidth: e.maxWidth,
              maxHeight: e.maxHeight,
              width: e.width,
              height: e.height,
              disposeOnNavigation: e.closeOnNavigation
            });
            return e.backdropClass && (a.backdropClass = e.backdropClass), a;
          }
          _attachContainer(e, a, i) {
            const o = i.injector || i.viewContainerRef?.injector,
              r = [{
                provide: R0,
                useValue: i
              }, {
                provide: m3,
                useValue: a
              }, {
                provide: Uc,
                useValue: e
              }];
            let s;
            i.container ? "function" == typeof i.container ? s = i.container : (s = i.container.type, r.push(...i.container.providers(i))) : s = Rw;
            const c = new $r(s, i.viewContainerRef, Lt.create({
              parent: o || this._injector,
              providers: r
            }), i.componentFactoryResolver);
            return e.attach(c).instance;
          }
          _attachDialogContent(e, a, i, o) {
            if (e instanceof vt) {
              const r = this._createInjector(o, a, i, void 0);
              let s = {
                $implicit: o.data,
                dialogRef: a
              };
              o.templateContext && (s = {
                ...s,
                ...("function" == typeof o.templateContext ? o.templateContext() : o.templateContext)
              }), i.attachTemplatePortal(new Vc(e, null, s, r));
            } else {
              const r = this._createInjector(o, a, i, this._injector),
                s = i.attachComponentPortal(new $r(e, o.viewContainerRef, r, o.componentFactoryResolver));
              a.componentInstance = s.instance;
            }
          }
          _createInjector(e, a, i, o) {
            const r = e.injector || e.viewContainerRef?.injector,
              s = [{
                provide: O3e,
                useValue: e.data
              }, {
                provide: m3,
                useValue: a
              }];
            return e.providers && ("function" == typeof e.providers ? s.push(...e.providers(a, e, i)) : s.push(...e.providers)), e.direction && (!r || !r.get(nn, null, me.Optional)) && s.push({
              provide: nn,
              useValue: {
                value: e.direction,
                change: nt()
              }
            }), Lt.create({
              parent: r || o,
              providers: s
            });
          }
          _removeOpenDialog(e, a) {
            const i = this.openDialogs.indexOf(e);
            i > -1 && (this.openDialogs.splice(i, 1), this.openDialogs.length || (this._ariaHiddenElements.forEach((o, r) => {
              o ? r.setAttribute("aria-hidden", o) : r.removeAttribute("aria-hidden");
            }), this._ariaHiddenElements.clear(), a && this._getAfterAllClosed().next()));
          }
          _hideNonDialogContentFromAssistiveTechnology() {
            const e = this._overlayContainer.getContainerElement();
            if (e.parentElement) {
              const a = e.parentElement.children;
              for (let i = a.length - 1; i > -1; i--) {
                const o = a[i];
                o !== e && "SCRIPT" !== o.nodeName && "STYLE" !== o.nodeName && !o.hasAttribute("aria-live") && (this._ariaHiddenElements.set(o, o.getAttribute("aria-hidden")), o.setAttribute("aria-hidden", "true"));
              }
            }
          }
          _getAfterAllClosed() {
            const e = this._parentDialog;
            return e ? e._getAfterAllClosed() : this._afterAllClosedAtThisLevel;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(mn), M(Lt), M(P3e, 8), M(n, 12), M(Xd), M(zw));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac
        }), n;
      })();
    function h3(n, t) {
      let e = n.length;
      for (; e--;) t(n[e]);
    }
    let Nw = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [Lw, S3e],
          imports: [qa, Ya, Xc, Ya]
        }), n;
      })(),
      T3e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          imports: [Nw, $, Ya, $]
        }), n;
      })();
    function I3e(n, t) {}
    const Es = {
        params: {
          enterAnimationDuration: "150ms",
          exitAnimationDuration: "75ms"
        }
      },
      R3e = {
        dialogContainer: ht("dialogContainer", [xe("void, exit", Z({
          opacity: 0,
          transform: "scale(0.7)"
        })), xe("enter", Z({
          transform: "none"
        })), Ee("* => enter", Pd([Re("{{enterAnimationDuration}} cubic-bezier(0, 0, 0.2, 1)", Z({
          transform: "none",
          opacity: 1
        })), qr("@*", Yr(), {
          optional: !0
        })]), Es), Ee("* => void, * => exit", Pd([Re("{{exitAnimationDuration}} cubic-bezier(0.4, 0.0, 0.2, 1)", Z({
          opacity: 0
        })), qr("@*", Yr(), {
          optional: !0
        })]), Es)])
      };
    class z0 {
      constructor() {
        this.role = "dialog", this.panelClass = "", this.hasBackdrop = !0, this.backdropClass = "", this.disableClose = !1, this.width = "", this.height = "", this.maxWidth = "80vw", this.data = null, this.ariaDescribedBy = null, this.ariaLabelledBy = null, this.ariaLabel = null, this.ariaModal = !0, this.autoFocus = "first-tabbable", this.restoreFocus = !0, this.delayFocusTrap = !0, this.closeOnNavigation = !0, this.enterAnimationDuration = Es.params.enterAnimationDuration, this.exitAnimationDuration = Es.params.exitAnimationDuration;
      }
    }
    let z3e = (() => {
        class n extends Rw {
          constructor(e, a, i, o, r, s, c, l) {
            super(e, a, i, o, r, s, c, l), this._animationStateChanged = new E();
          }
          _captureInitialFocus() {
            this._config.delayFocusTrap || this._trapFocus();
          }
          _openAnimationDone(e) {
            this._config.delayFocusTrap && this._trapFocus(), this._animationStateChanged.next({
              state: "opened",
              totalTime: e
            });
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(M2), f(ie, 8), f(z0), f(C2), f(ae), f(Uc), f(Hn));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["ng-component"]],
          features: [z],
          decls: 0,
          vars: 0,
          template: function (e, a) {},
          encapsulation: 2
        }), n;
      })(),
      L3e = (() => {
        class n extends z3e {
          constructor(e, a, i, o, r, s, c, l, d) {
            super(e, a, i, o, r, s, c, d), this._changeDetectorRef = l, this._state = "enter";
          }
          _onAnimationDone({
            toState: e,
            totalTime: a
          }) {
            "enter" === e ? this._openAnimationDone(a) : "exit" === e && this._animationStateChanged.next({
              state: "closed",
              totalTime: a
            });
          }
          _onAnimationStart({
            toState: e,
            totalTime: a
          }) {
            "enter" === e ? this._animationStateChanged.next({
              state: "opening",
              totalTime: a
            }) : ("exit" === e || "void" === e) && this._animationStateChanged.next({
              state: "closing",
              totalTime: a
            });
          }
          _startExitAnimation() {
            this._state = "exit", this._changeDetectorRef.markForCheck();
          }
          _getAnimationState() {
            return {
              value: this._state,
              params: {
                enterAnimationDuration: this._config.enterAnimationDuration || Es.params.enterAnimationDuration,
                exitAnimationDuration: this._config.exitAnimationDuration || Es.params.exitAnimationDuration
              }
            };
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(J), f(M2), f(ie, 8), f(z0), f(C2), f(ae), f(Uc), f(Se), f(Hn));
        }, n.ɵcmp = q({
          type: n,
          selectors: [["mat-dialog-container"]],
          hostAttrs: ["tabindex", "-1", 1, "mat-dialog-container"],
          hostVars: 7,
          hostBindings: function (e, a) {
            1 & e && V1("@dialogContainer.start", function (o) {
              return a._onAnimationStart(o);
            })("@dialogContainer.done", function (o) {
              return a._onAnimationDone(o);
            }), 2 & e && (Zn("id", a._config.id), X("aria-modal", a._config.ariaModal)("role", a._config.role)("aria-labelledby", a._config.ariaLabel ? null : a._ariaLabelledBy)("aria-label", a._config.ariaLabel)("aria-describedby", a._config.ariaDescribedBy || null), B1("@dialogContainer", a._getAnimationState()));
          },
          features: [z],
          decls: 1,
          vars: 0,
          consts: [["cdkPortalOutlet", ""]],
          template: function (e, a) {
            1 & e && D(0, I3e, 0, 0, "ng-template", 0);
          },
          dependencies: [es],
          styles: [".mat-dialog-container{display:block;padding:24px;border-radius:4px;box-sizing:border-box;overflow:auto;outline:0;width:100%;height:100%;min-height:inherit;max-height:inherit}.cdk-high-contrast-active .mat-dialog-container{outline:solid 1px}.mat-dialog-content{display:block;margin:0 -24px;padding:0 24px;max-height:65vh;overflow:auto;-webkit-overflow-scrolling:touch}.mat-dialog-title{margin:0 0 20px;display:block}.mat-dialog-actions{padding:8px 0;display:flex;flex-wrap:wrap;min-height:52px;align-items:center;box-sizing:content-box;margin-bottom:-24px}.mat-dialog-actions.mat-dialog-actions-align-center,.mat-dialog-actions[align=center]{justify-content:center}.mat-dialog-actions.mat-dialog-actions-align-end,.mat-dialog-actions[align=end]{justify-content:flex-end}.mat-dialog-actions .mat-button-base+.mat-button-base,.mat-dialog-actions .mat-mdc-button-base+.mat-mdc-button-base{margin-left:8px}[dir=rtl] .mat-dialog-actions .mat-button-base+.mat-button-base,[dir=rtl] .mat-dialog-actions .mat-mdc-button-base+.mat-mdc-button-base{margin-left:0;margin-right:8px}"],
          encapsulation: 2,
          data: {
            animation: [R3e.dialogContainer]
          }
        }), n;
      })();
    class N3e {
      constructor(t, e, a) {
        this._ref = t, this._containerInstance = a, this._afterOpened = new V(), this._beforeClosed = new V(), this._state = 0, this.disableClose = e.disableClose, this.id = t.id, a._animationStateChanged.pipe(Ht(i => "opened" === i.state), $e(1)).subscribe(() => {
          this._afterOpened.next(), this._afterOpened.complete();
        }), a._animationStateChanged.pipe(Ht(i => "closed" === i.state), $e(1)).subscribe(() => {
          clearTimeout(this._closeFallbackTimeout), this._finishDialogClose();
        }), t.overlayRef.detachments().subscribe(() => {
          this._beforeClosed.next(this._result), this._beforeClosed.complete(), this._finishDialogClose();
        }), dt(this.backdropClick(), this.keydownEvents().pipe(Ht(i => 27 === i.keyCode && !this.disableClose && !Et(i)))).subscribe(i => {
          this.disableClose || (i.preventDefault(), function F3e(n, t, e) {
            n._closeInteractionType = t, n.close(e);
          }(this, "keydown" === i.type ? "keyboard" : "mouse"));
        });
      }
      close(t) {
        this._result = t, this._containerInstance._animationStateChanged.pipe(Ht(e => "closing" === e.state), $e(1)).subscribe(e => {
          this._beforeClosed.next(t), this._beforeClosed.complete(), this._ref.overlayRef.detachBackdrop(), this._closeFallbackTimeout = setTimeout(() => this._finishDialogClose(), e.totalTime + 100);
        }), this._state = 1, this._containerInstance._startExitAnimation();
      }
      afterOpened() {
        return this._afterOpened;
      }
      afterClosed() {
        return this._ref.closed;
      }
      beforeClosed() {
        return this._beforeClosed;
      }
      backdropClick() {
        return this._ref.backdropClick;
      }
      keydownEvents() {
        return this._ref.keydownEvents;
      }
      updatePosition(t) {
        let e = this._ref.config.positionStrategy;
        return t && (t.left || t.right) ? t.left ? e.left(t.left) : e.right(t.right) : e.centerHorizontally(), t && (t.top || t.bottom) ? t.top ? e.top(t.top) : e.bottom(t.bottom) : e.centerVertically(), this._ref.updatePosition(), this;
      }
      updateSize(t = "", e = "") {
        return this._ref.updateSize(t, e), this;
      }
      addPanelClass(t) {
        return this._ref.addPanelClass(t), this;
      }
      removePanelClass(t) {
        return this._ref.removePanelClass(t), this;
      }
      getState() {
        return this._state;
      }
      _finishDialogClose() {
        this._state = 2, this._ref.close(this._result, {
          focusOrigin: this._closeInteractionType
        }), this.componentInstance = null;
      }
    }
    const V3e = new O("MatDialogData"),
      H3e = new O("mat-dialog-default-options"),
      Fw = new O("mat-dialog-scroll-strategy"),
      j3e = {
        provide: Fw,
        deps: [mn],
        useFactory: function B3e(n) {
          return () => n.scrollStrategies.block();
        }
      };
    let U3e = 0,
      G3e = (() => {
        class n {
          constructor(e, a, i, o, r, s, c, l, d, u) {
            this._overlay = e, this._defaultOptions = i, this._parentDialog = o, this._dialogRefConstructor = c, this._dialogContainerType = l, this._dialogDataToken = d, this._openDialogsAtThisLevel = [], this._afterAllClosedAtThisLevel = new V(), this._afterOpenedAtThisLevel = new V(), this._idPrefix = "mat-dialog-", this.afterAllClosed = a0(() => this.openDialogs.length ? this._getAfterAllClosed() : this._getAfterAllClosed().pipe(Gt(void 0))), this._scrollStrategy = s, this._dialog = a.get(Lw);
          }
          get openDialogs() {
            return this._parentDialog ? this._parentDialog.openDialogs : this._openDialogsAtThisLevel;
          }
          get afterOpened() {
            return this._parentDialog ? this._parentDialog.afterOpened : this._afterOpenedAtThisLevel;
          }
          _getAfterAllClosed() {
            const e = this._parentDialog;
            return e ? e._getAfterAllClosed() : this._afterAllClosedAtThisLevel;
          }
          open(e, a) {
            let i;
            (a = {
              ...(this._defaultOptions || new z0()),
              ...a
            }).id = a.id || `${this._idPrefix}${U3e++}`, a.scrollStrategy = a.scrollStrategy || this._scrollStrategy();
            const o = this._dialog.open(e, {
              ...a,
              positionStrategy: this._overlay.position().global().centerHorizontally().centerVertically(),
              disableClose: !0,
              closeOnDestroy: !1,
              container: {
                type: this._dialogContainerType,
                providers: () => [{
                  provide: z0,
                  useValue: a
                }, {
                  provide: R0,
                  useValue: a
                }]
              },
              templateContext: () => ({
                dialogRef: i
              }),
              providers: (r, s, c) => (i = new this._dialogRefConstructor(r, a, c), i.updatePosition(a?.position), [{
                provide: this._dialogContainerType,
                useValue: c
              }, {
                provide: this._dialogDataToken,
                useValue: s.data
              }, {
                provide: this._dialogRefConstructor,
                useValue: i
              }])
            });
            return i.componentInstance = o.componentInstance, this.openDialogs.push(i), this.afterOpened.next(i), i.afterClosed().subscribe(() => {
              const r = this.openDialogs.indexOf(i);
              r > -1 && (this.openDialogs.splice(r, 1), this.openDialogs.length || this._getAfterAllClosed().next());
            }), i;
          }
          closeAll() {
            this._closeDialogs(this.openDialogs);
          }
          getDialogById(e) {
            return this.openDialogs.find(a => a.id === e);
          }
          ngOnDestroy() {
            this._closeDialogs(this._openDialogsAtThisLevel), this._afterAllClosedAtThisLevel.complete(), this._afterOpenedAtThisLevel.complete();
          }
          _closeDialogs(e) {
            let a = e.length;
            for (; a--;) e[a].close();
          }
        }
        return n.ɵfac = function (e) {
          li();
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac
        }), n;
      })(),
      W3e = (() => {
        class n extends G3e {
          constructor(e, a, i, o, r, s, c, l) {
            super(e, a, o, s, c, r, N3e, L3e, V3e, l);
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(M(mn), M(Lt), M(Am, 8), M(H3e, 8), M(Fw), M(n, 12), M(Xd), M(Ft, 8));
        }, n.ɵprov = R({
          token: n,
          factory: n.ɵfac
        }), n;
      })(),
      Y3e = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({
          providers: [W3e, j3e],
          imports: [Nw, qa, Ya, $, $]
        }), n;
      })();
    function q3e(n, t) {
      if (1 & n && (_(0, "mat-list-option", 6), S(1), y()), 2 & n) {
        const e = t.$implicit,
          a = x(3);
        b("value", e[a.sampleTemplateService.TEMPLATE_NUMBER]), g(1), Ie(e[a.sampleTemplateService.TEMPLATE_LABEL]);
      }
    }
    function K3e(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "mat-selection-list", 3, 4), F("click", function () {
          pe(e);
          const i = Kt(1);
          return ge(x(2).selectionClicked({
            option: i.selectedOptions.selected[0]
          }));
        }), D(2, q3e, 2, 2, "mat-list-option", 5), y();
      }
      if (2 & n) {
        const e = x(2);
        b("formControl", e.templateCtrl)("multiple", !1), g(2), b("ngForOf", e.sampleTemplates);
      }
    }
    function Q3e(n, t) {
      1 & n && D(0, K3e, 3, 3, "ng-template", 2);
    }
    let Rl = /*#__PURE__*/(() => {
      class Rl {
        http;
        sampleTemplateService;
        callbackOwnerObject = null;
        expandedSampleTemplateLinks;
        templateLocationPrefix;
        templateCtrl = new at();
        sampleTemplates = [];
        _onDestroy = new V();
        constructor(t, e) {
          this.http = t, this.sampleTemplateService = e;
        }
        ngOnInit() {
          this.templateLocationPrefix = this.callbackOwnerObject.innerConfig[qe.TEMPLATE_LOCATION_PREFIX], this.sampleTemplateService.getSampleTemplatesFromRegistry(this.templateLocationPrefix).pipe(ne(this._onDestroy)).subscribe(t => {
            this.sampleTemplates.push(...t);
          }), this.sampleTemplateService.templateJson$.pipe(ne(this._onDestroy)).subscribe(t => {
            this.templateCtrl.setValue([Object.keys(t)[0]]);
          });
        }
        loadBuiltinTemplate(t) {
          this.sampleTemplateService.loadTemplate(this.templateLocationPrefix, t), window.scroll(0, 0);
        }
        selectionClicked({
          option: t
        }) {
          this.loadBuiltinTemplate(t.value);
        }
        ngOnDestroy() {
          this._onDestroy.next(), this._onDestroy.complete();
        }
        static ɵfac = function (e) {
          return new (e || Rl)(f(Yo), f(Ko));
        };
        static ɵcmp = q({
          type: Rl,
          selectors: [["app-sample-templates"]],
          inputs: {
            callbackOwnerObject: "callbackOwnerObject",
            expandedSampleTemplateLinks: "expandedSampleTemplateLinks"
          },
          decls: 8,
          vars: 5,
          consts: [[3, "expanded"], [4, "ngIf"], ["matExpansionPanelContent", ""], [3, "formControl", "multiple", "click"], ["templates", ""], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]],
          template: function (e, a) {
            1 & e && (_(0, "mat-expansion-panel", 0)(1, "mat-expansion-panel-header")(2, "mat-panel-title")(3, "mat-icon"), S(4, "subject"), y(), S(5), Dt(6, "translate"), y()(), D(7, Q3e, 1, 0, null, 1), y()), 2 & e && (zn("expanded", a.expandedSampleTemplateLinks), g(5), Fe(" ", Ot(6, 3, "Extra.SampleTemplate.Title"), " "), g(2), b("ngIf", a.sampleTemplates));
          },
          dependencies: [s3, c3, gw, r3, ao, d3, Pw, oa, Pa, ea, mt, Ds],
          styles: ["app-sample-templates .mat-expansion-panel{max-width:90%;margin:10px auto 0;background-color:#f5f5f5}app-sample-templates .mat-expansion-panel-header-title .mat-icon{margin-right:15px}\n"],
          encapsulation: 2
        });
      }
      return Rl;
    })();
    let zl = /*#__PURE__*/(() => {
      class zl {
        constructor() {}
        ngOnInit() {}
        static ɵfac = function (e) {
          return new (e || zl)();
        };
        static ɵcmp = q({
          type: zl,
          selectors: [["app-static-footer"]],
          decls: 13,
          vars: 6,
          consts: [[1, "wide-container"], [1, "main__footer"], [1, "flex"], ["href", "https://bmir.stanford.edu", "target", "_blank"], [1, "bmir-logo"], [1, "paragraph__section"], ["href", "https://more.metadatacenter.org/tools-training/support/#contact", "target", "_blank"]],
          template: function (e, a) {
            1 & e && (_(0, "div", 0)(1, "footer", 1)(2, "div", 2)(3, "a", 3), j(4, "div", 4), y(), _(5, "div", 5)(6, "p"), S(7), Dt(8, "translate"), y(), _(9, "p")(10, "a", 6), S(11), Dt(12, "translate"), y()()()()()()), 2 & e && (g(7), Fe(" ", Ot(8, 2, "App.Maintained"), " "), g(4), Ie(Ot(12, 4, "App.Contact")));
          },
          dependencies: [Ds],
          styles: [".main__footer{margin:30px auto 0;max-width:80%;padding-top:20px}@media only screen and (max-width: 300px){.main__footer{max-width:100%;padding:0 10px}}@media only screen and (min-width: 301px) and (max-width: 600px){.main__footer{max-width:calc(100% - 4em)}}@media only screen and (min-width: 601px) and (max-width: 700px){.main__footer{max-width:580px}}@media only screen and (min-width: 701px) and (max-width: 1000px){.main__footer{max-width:calc(80% - 4em)}}@media only screen and (min-width: 1001px){.main__footer{max-width:calc(1000px - 4em)}}.main__footer .flex{display:flex;justify-content:center;flex-wrap:wrap}.footer-title{font-weight:lighter;font-family:CrimsonText,serif;font-size:34px;width:100%;white-space:nowrap;text-overflow:ellipsis;margin-bottom:0}.paragraph__section{padding:0;font-size:1.2em;line-height:1.2em;font-weight:lighter}.form__section{position:relative;padding:3em;display:flex;flex-direction:row;justify-content:center;flex-wrap:wrap}.form__section .disclaimer{color:#0000008a;padding:10px;font-size:.8em}.form__section .subscribe{display:flex;justify-content:center;width:25em;border:1px solid rgba(0,0,0,.1);box-shadow:0 8px 6px -6px #0000001a;box-sizing:content-box;border-radius:4px;vertical-align:middle}.form__section .subscribe input,.form__section .subscribe input:active{width:14em;border-width:0;padding:20px;margin:4px}.form__section .subscribe button{margin:5px}.copyright__text{letter-spacing:.1rem;color:#fff}.wide-container{background:#e8e8e8}.bmir-logo{background-image:url(data:image/png;base64,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);background-repeat:no-repeat;background-size:cover;width:120px;height:67px;margin-bottom:20px}a{text-decoration:none}a:hover{text-decoration:underline}\n"],
          encapsulation: 2
        });
      }
      return zl;
    })();
    RegExp(/[&<>"']/g.source);
    const w6e = new O("ng-select-selection-model");
    function k6e() {
      return new D6e();
    }
    class D6e {
      constructor() {
        this._selected = [];
      }
      get value() {
        return this._selected;
      }
      select(t, e, a) {
        if (t.selected = !0, (!t.children || !e && a) && this._selected.push(t), e) if (t.parent) {
          const i = t.parent.children.length,
            o = t.parent.children.filter(r => r.selected).length;
          t.parent.selected = i === o;
        } else t.children && (this._setChildrenSelectedState(t.children, !0), this._removeChildren(t), this._selected = a && this._activeChildren(t) ? [...this._selected.filter(i => i.parent !== t), t] : [...this._selected, ...t.children.filter(i => !i.disabled)]);
      }
      unselect(t, e) {
        if (this._selected = this._selected.filter(a => a !== t), t.selected = !1, e) if (t.parent && t.parent.selected) {
          const a = t.parent.children;
          this._removeParent(t.parent), this._removeChildren(t.parent), this._selected.push(...a.filter(i => i !== t && !i.disabled)), t.parent.selected = !1;
        } else t.children && (this._setChildrenSelectedState(t.children, !1), this._removeChildren(t));
      }
      clear(t) {
        this._selected = t ? this._selected.filter(e => e.disabled) : [];
      }
      _setChildrenSelectedState(t, e) {
        for (const a of t) a.disabled || (a.selected = e);
      }
      _removeChildren(t) {
        this._selected = [...this._selected.filter(e => e.parent !== t), ...t.children.filter(e => e.parent === t && e.disabled && e.selected)];
      }
      _removeParent(t) {
        this._selected = this._selected.filter(e => e !== t);
      }
      _activeChildren(t) {
        return t.children.every(e => !e.disabled || e.selected);
      }
    }
    let jw = (() => {
      class n {}
      return n.ɵfac = function (e) {
        return new (e || n)();
      }, n.ɵmod = W({
        type: n
      }), n.ɵinj = U({
        providers: [{
          provide: w6e,
          useValue: k6e
        }],
        imports: [yt]
      }), n;
    })();
    class O6e {
      constructor(t, e) {
        this._document = e;
        const a = this._textarea = this._document.createElement("textarea"),
          i = a.style;
        i.position = "fixed", i.top = i.opacity = "0", i.left = "-999em", a.setAttribute("aria-hidden", "true"), a.value = t, a.readOnly = !0, this._document.body.appendChild(a);
      }
      copy() {
        const t = this._textarea;
        let e = !1;
        try {
          if (t) {
            const a = this._document.activeElement;
            t.select(), t.setSelectionRange(0, t.value.length), e = this._document.execCommand("copy"), a && a.focus();
          }
        } catch {}
        return e;
      }
      destroy() {
        const t = this._textarea;
        t && (t.remove(), this._textarea = void 0);
      }
    }
    let P6e = (() => {
      class n {
        constructor(e) {
          this._document = e;
        }
        copy(e) {
          const a = this.beginCopy(e),
            i = a.copy();
          return a.destroy(), i;
        }
        beginCopy(e) {
          return new O6e(e, this._document);
        }
      }
      return n.ɵfac = function (e) {
        return new (e || n)(M(ie));
      }, n.ɵprov = R({
        token: n,
        factory: n.ɵfac,
        providedIn: "root"
      }), n;
    })();
    const A6e = new O("CDK_COPY_TO_CLIPBOARD_CONFIG");
    let S6e = (() => {
        class n {
          constructor(e, a, i) {
            this._clipboard = e, this._ngZone = a, this.text = "", this.attempts = 1, this.copied = new E(), this._pending = new Set(), i && null != i.attempts && (this.attempts = i.attempts);
          }
          copy(e = this.attempts) {
            if (e > 1) {
              let a = e;
              const i = this._clipboard.beginCopy(this.text);
              this._pending.add(i);
              const o = () => {
                const r = i.copy();
                r || ! --a || this._destroyed ? (this._currentTimeout = null, this._pending.delete(i), i.destroy(), this.copied.emit(r)) : this._currentTimeout = this._ngZone.runOutsideAngular(() => setTimeout(o, 1));
              };
              o();
            } else this.copied.emit(this._clipboard.copy(this.text));
          }
          ngOnDestroy() {
            this._currentTimeout && clearTimeout(this._currentTimeout), this._pending.forEach(e => e.destroy()), this._pending.clear(), this._destroyed = !0;
          }
        }
        return n.ɵfac = function (e) {
          return new (e || n)(f(P6e), f(ae), f(A6e, 8));
        }, n.ɵdir = P({
          type: n,
          selectors: [["", "cdkCopyToClipboard", ""]],
          hostBindings: function (e, a) {
            1 & e && F("click", function () {
              return a.copy();
            });
          },
          inputs: {
            text: ["cdkCopyToClipboard", "text"],
            attempts: ["cdkCopyToClipboardAttempts", "attempts"]
          },
          outputs: {
            copied: "cdkCopyToClipboardCopied"
          }
        }), n;
      })(),
      Uw = (() => {
        class n {}
        return n.ɵfac = function (e) {
          return new (e || n)();
        }, n.ɵmod = W({
          type: n
        }), n.ɵinj = U({}), n;
      })();
    let N0 = /*#__PURE__*/(() => {
      class N0 {
        static ɵfac = function (e) {
          return new (e || N0)();
        };
        static ɵmod = W({
          type: N0
        });
        static ɵinj = U({
          providers: [z4, _p, {
            provide: VM,
            useValue: {
              appearance: "outline"
            }
          }],
          imports: [yd, M4, Dh, bx, Dw, vl, f2, vl, UM, k4, JM, Q2, bw, Wo, Z2, Uw, Dx, sa, uw, kx, yw, z4, _p, jw, lH, D4, _0]
        });
      }
      return N0;
    })();
    function E6e(n, t) {
      if (1 & n && (_(0, "mat-card")(1, "pre"), S(2), Dt(3, "json"), y()()), 2 & n) {
        const e = x(2);
        g(2), Ie(Ot(3, 1, e.instanceData));
      }
    }
    function T6e(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "mat-expansion-panel", 3)(1, "mat-expansion-panel-header")(2, "mat-panel-title")(3, "mat-icon"), S(4, "device_hub"), y(), S(5), Dt(6, "translate"), y(), _(7, "mat-panel-description"), S(8, " \xa0 "), _(9, "mat-icon", 4), F("click", function (i) {
          return pe(e), ge(x().stopPropagation(i));
        }), Dt(10, "json"), Dt(11, "translate"), S(12, "content_copy "), y()()(), D(13, E6e, 4, 3, "ng-template", 5), y();
      }
      if (2 & n) {
        const e = x();
        zn("expanded", e.expandedInstanceData), g(5), Fe(" ", Ot(6, 4, "Extra.JsonLD.Instance"), " "), g(4), zn("matTooltip", Ot(11, 8, "Generic.Copy")), b("cdkCopyToClipboard", Ot(10, 6, e.instanceData));
      }
    }
    function I6e(n, t) {
      if (1 & n && (_(0, "mat-card")(1, "pre"), S(2), Dt(3, "json"), y()()), 2 & n) {
        const e = x(2);
        g(2), Ie(Ot(3, 1, e.templateData));
      }
    }
    function R6e(n, t) {
      if (1 & n) {
        const e = Le();
        _(0, "mat-expansion-panel", 6)(1, "mat-expansion-panel-header")(2, "mat-panel-title")(3, "mat-icon"), S(4, "view_module"), y(), S(5), Dt(6, "translate"), y(), _(7, "mat-panel-description"), S(8, " \xa0 "), _(9, "mat-icon", 4), F("click", function (i) {
          return pe(e), ge(x().stopPropagation(i));
        }), Dt(10, "json"), Dt(11, "translate"), S(12, "content_copy "), y()()(), D(13, I6e, 4, 3, "ng-template", 5), y();
      }
      if (2 & n) {
        const e = x();
        zn("expanded", e.expandedTemplateData), g(5), Fe(" ", Ot(6, 4, "Extra.JsonSchemaTemplate"), " "), g(4), zn("matTooltip", Ot(11, 8, "Generic.Copy")), b("cdkCopyToClipboard", Ot(10, 6, e.templateData));
      }
    }
    let Nl = /*#__PURE__*/(() => {
      class Nl {
        showTemplateData;
        showInstanceData;
        expandedInstanceData = !1;
        expandedTemplateData = !1;
        templateData = null;
        instanceData = null;
        constructor() {}
        ngOnInit() {}
        stopPropagation(t) {
          t.stopPropagation();
        }
        static ɵfac = function (e) {
          return new (e || Nl)();
        };
        static ɵcmp = q({
          type: Nl,
          selectors: [["app-source-panels"]],
          inputs: {
            showTemplateData: "showTemplateData",
            showInstanceData: "showInstanceData",
            expandedInstanceData: "expandedInstanceData",
            expandedTemplateData: "expandedTemplateData",
            templateData: "templateData",
            instanceData: "instanceData"
          },
          decls: 3,
          vars: 2,
          consts: [["multi", "", 1, "source-accordion"], [3, "expanded", 4, "ngIf"], ["class", "template-data", 3, "expanded", 4, "ngIf"], [3, "expanded"], ["matRipple", "", 3, "cdkCopyToClipboard", "matTooltip", "click"], ["matExpansionPanelContent", ""], [1, "template-data", 3, "expanded"]],
          template: function (e, a) {
            1 & e && (_(0, "mat-accordion", 0), D(1, T6e, 14, 10, "mat-expansion-panel", 1), D(2, R6e, 14, 10, "mat-expansion-panel", 2), y()), 2 & e && (g(1), b("ngIf", a.showInstanceData), g(1), b("ngIf", a.showTemplateData));
          },
          dependencies: [R4e, $pe, s3, c3, gw, Jpe, r3, ao, Xa, ys, mt, S6e, R7, Ds],
          styles: ["app-source-panels .mat-expansion-panel-header-description{justify-content:space-between;align-items:center}app-source-panels .mat-expansion-panel{max-width:90%;margin:0 auto;background-color:#f5f5f5}app-source-panels .mat-expansion-panel pre{font-size:12px;line-height:1.1}app-source-panels .mat-expansion-panel-header-title .mat-icon{margin-right:15px}.mat-expansion-panel.template-data{margin-bottom:10px}\n"],
          encapsulation: 2
        });
      }
      return Nl;
    })();
    let Fl = /*#__PURE__*/(() => {
      class Fl {
        static ɵfac = function (e) {
          return new (e || Fl)();
        };
        static ɵmod = W({
          type: Fl
        });
        static ɵinj = U({
          imports: [jx, Iv, npe, bx, k3e, T3e, Wo, lpe, Dw, k4, kx, u3e, z4, Y3e, Ow, bw, yw, Q2, UM, J4e, c4e, _p, uw, upe, Ox, JM, sa, D4, m3e, w3e, wpe, n4e, m4e, S4e, V4e, Dx, Z2, DB, bhe, jw, Qd, f2, yt, i0e, _0, N0, Uw]
        });
      }
      return Fl;
    })();
    au(qe, [Pi, ao, dw, ys, kp, wp, Op, Dp, xp, $c, Kh, zo, ra, mt, sl, wl, Ol, zl, Rl, Nl], []), au(qe, [Pi, ao, dw, ys, kp, wp, Op, Dp, xp, $c, Kh, zo, ra, mt, sl, wl, Ol, zl, Rl, Nl], []);
    class Gw {
      constructor(t, e = "/assets/i18n/", a = ".json") {
        this.http = t, this.prefix = e, this.suffix = a;
      }
      getTranslation(t) {
        return this.http.get(`${this.prefix}${t}${this.suffix}`);
      }
    }
    let Ii = /*#__PURE__*/(() => {
      class Ii {
        constructor() {}
        static schemaOf(t) {
          return t && "array" === t.type && t.items ? t.items : t;
        }
        static isBasedOn(t) {
          return t["schema:isBasedOn"];
        }
        static getId(t) {
          return t["@id"];
        }
        static getName(t) {
          return t["schema:name"];
        }
        static getHelp(t) {
          return t["schema:description"];
        }
        static initInstance(t) {
          const e = Ii.schemaOf(t);
          return {
            "@context": {
              rdfs: "http://www.w3.org/2000/01/rdf-schema#",
              xsd: "http://www.w3.org/2001/XMLSchema#",
              pav: "http://purl.org/pav/",
              schema: "http://schema.org/",
              oslc: "http://open-services.net/ns/core#",
              skos: "http://www.w3.org/2004/02/skos/core#",
              "rdfs:label": {
                "@type": "xsd:string"
              },
              "schema:isBasedOn": {
                "@type": "@id"
              },
              "schema:name": {
                "@type": "xsd:string"
              },
              "schema:description": {
                "@type": "xsd:string"
              },
              "pav:createdOn": {
                "@type": "xsd:dateTime"
              },
              "pav:createdBy": {
                "@type": "@id"
              },
              "pav:lastUpdatedOn": {
                "@type": "xsd:dateTime"
              },
              "oslc:modifiedBy": {
                "@type": "@id"
              },
              "skos:notation": {
                "@type": "xsd:string"
              }
            },
            "schema:isBasedOn": Ii.getId(e),
            "schema:name": Ii.getName(e),
            "schema:description": Ii.getHelp(e),
            "pav:createdOn": "",
            "pav:createdBy": "",
            "pav:lastUpdatedOn": "",
            "oslc:modifiedBy": "",
            "@id": ""
          };
        }
        static setBasedOn(t, e) {
          return t["schema:isBasedOn"] = e, t;
        }
        static setHelp(t, e) {
          return t["schema:description"] = e, t;
        }
        static setName(t, e) {
          return t["schema:name"] = e, t;
        }
        static ɵfac = function (e) {
          return new (e || Ii)();
        };
        static ɵprov = R({
          token: Ii,
          factory: Ii.ɵfac
        });
      }
      return Ii;
    })();
    function z6e(n, t) {
      if (1 & n && j(0, "app-cedar-artifact-viewer", 2), 2 & n) {
        const e = x();
        b("config", e.innerConfig)("templateJsonObject", e.templateJson)("instanceJsonObject", e.instanceJson)("sampleTemplateLoaderObject", e.sampleTemplateLoaderObject);
      }
    }
    function L6e(n, t) {
      1 & n && (_(0, "div", 3), j(1, "mat-progress-spinner", 4), _(2, "h1"), S(3), Dt(4, "translate"), y()()), 2 & n && (g(3), Ie(Ot(4, 1, "Process.Initializing")));
    }
    let Ts = /*#__PURE__*/(() => {
      class Ts {
        messageHandlerService;
        sampleTemplateService;
        translateService;
        innerConfig = null;
        initialized = !1;
        configSet = !1;
        sampleTemplateLoaderObject = null;
        showSpinnerBeforeInit = !0;
        onDestroySubject = new V();
        templateJson = null;
        instanceJson = null;
        loadedTemplateJson = null;
        loadedMetadataJson = null;
        constructor(t, e, a) {
          this.messageHandlerService = t, this.sampleTemplateService = e, this.translateService = a, this.sampleTemplateLoaderObject = this, this.translateService.setDefaultLang("en"), this.translateService.use("en");
        }
        ngOnInit() {
          this.sampleTemplateService.templateJson$.pipe(ne(this.onDestroySubject)).subscribe(t => {
            this.loadedTemplateJson = t ? Object.values(t)[0] : null, this.triggerUpdateOnInjectedSampleData();
          }), this.sampleTemplateService.metadataJson$.pipe(ne(this.onDestroySubject)).subscribe(t => {
            this.loadedMetadataJson = t ? Object.values(t)[0] : null, this.triggerUpdateOnInjectedSampleData();
          }), this.initialized = !0, this.doInitialize();
        }
        set templateObject(t) {
          this.templateJson = t, this.triggerUpdate();
        }
        set instanceObject(t) {
          this.instanceJson = t, this.triggerUpdate();
        }
        loadConfigFromURL(t, e = null, a = null) {
          const i = this,
            o = new XMLHttpRequest();
          o.onreadystatechange = () => {
            if (o.readyState === XMLHttpRequest.DONE) if (200 === o.status) {
              const r = JSON.parse(o.responseText);
              i.config = r, e && e(r);
            } else a && a(o);
          }, o.open("GET", t, !0), o.send();
        }
        ngOnDestroy() {
          this.onDestroySubject.next(), this.onDestroySubject.complete();
        }
        set config(t) {
          this.messageHandlerService.traceObject("CEDAR Artifact Viewer config set to:", t), null != t && (this.innerConfig = t, this.configSet = !0, this.doInitialize());
        }
        set eventHandler(t) {
          this.messageHandlerService.injectEventHandler(t);
        }
        deleteContext(t) {
          const e = Object.keys(t).length;
          2 === e && Object.hasOwn(t, ot.atId) && Object.hasOwn(t, ot.rdfsLabel) || 1 === e && Object.hasOwn(t, ot.atId) || Object.keys(t).forEach(a => {
            delete t[ot.atContext], delete t[ot.atId], delete t[ot.oslcModifiedBy], delete t[ot.pavCreatedOn], delete t[ot.pavLastUpdatedOn], delete t[ot.pavCreatedBy], delete t[ot.schemaIsBasedOn], delete t[ot.schemaName], delete t[ot.schemaDescription], "object" == typeof t[a] && null !== t[a] && this.deleteContext(t[a]);
          });
        }
        doInitialize() {
          this.initialized && this.configSet && (Object.hasOwn(this.innerConfig, qe.LOAD_SAMPLE_TEMPLATE_NAME) && this.sampleTemplateService.loadTemplate(this.innerConfig[qe.TEMPLATE_LOCATION_PREFIX], this.innerConfig[qe.LOAD_SAMPLE_TEMPLATE_NAME]), Object.hasOwn(this.innerConfig, qe.SHOW_SPINNER_BEFORE_INIT) && (this.showSpinnerBeforeInit = this.innerConfig[qe.SHOW_SPINNER_BEFORE_INIT]), Object.hasOwn(this.innerConfig, qe.FALLBACK_LANGUAGE) && this.translateService.setDefaultLang(this.innerConfig[qe.FALLBACK_LANGUAGE]), Object.hasOwn(this.innerConfig, qe.DEFAULT_LANGUAGE) && this.translateService.use(this.innerConfig[qe.DEFAULT_LANGUAGE]));
        }
        editorDataReady() {
          return null != this.innerConfig && null != this.templateJson;
        }
        triggerUpdateOnInjectedSampleData() {
          null !== this.loadedMetadataJson && (this.instanceJson = this.loadedMetadataJson, this.triggerUpdate()), null != this.loadedTemplateJson && (this.templateJson = this.loadedTemplateJson, this.triggerUpdate());
        }
        triggerUpdate() {
          null !== this.templateJson && null === this.instanceJson && (this.instanceJson = Ii.initInstance(this.templateJson));
        }
        static ɵfac = function (e) {
          return new (e || Ts)(f(ws), f(Ko), f(Dl));
        };
        static ɵcmp = q({
          type: Ts,
          selectors: [["app-cedar-artifact-viewer-wrapper"]],
          inputs: {
            templateObject: "templateObject",
            instanceObject: "instanceObject",
            loadConfigFromURL: "loadConfigFromURL",
            config: "config",
            eventHandler: "eventHandler"
          },
          decls: 2,
          vars: 2,
          consts: [["mode", "view", 3, "config", "templateJsonObject", "instanceJsonObject", "sampleTemplateLoaderObject", 4, "ngIf"], ["class", "spinner-wrapper", 4, "ngIf"], ["mode", "view", 3, "config", "templateJsonObject", "instanceJsonObject", "sampleTemplateLoaderObject"], [1, "spinner-wrapper"], ["diameter", "24", "mode", "indeterminate"]],
          template: function (e, a) {
            1 & e && (D(0, z6e, 1, 4, "app-cedar-artifact-viewer", 0), D(1, L6e, 5, 3, "div", 1)), 2 & e && (b("ngIf", a.editorDataReady()), g(1), b("ngIf", !a.editorDataReady() && a.showSpinnerBeforeInit));
          },
          dependencies: [$a, mt, qe, Ds],
          encapsulation: 2
        });
      }
      return Ts;
    })();
    function N6e(n) {
      return new Gw(n, "/assets/i18n-cav/");
    }
    let F0 = /*#__PURE__*/(() => {
      class F0 {
        injector;
        constructor(t) {
          this.injector = t;
        }
        ngDoBootstrap() {
          const t = d9(Ts, {
            injector: this.injector
          });
          customElements.define("cedar-artifact-viewer", t);
        }
        static ɵfac = function (e) {
          return new (e || F0)(M(Lt));
        };
        static ɵmod = W({
          type: F0
        });
        static ɵinj = U({
          imports: [M4, yd, Dh, $m.forRoot(), qa, Fl, _0.forRoot({
            loader: {
              provide: ks,
              useFactory: N6e,
              deps: [Yo]
            }
          })]
        });
      }
      return F0;
    })();
    const F6e = JSON.parse('{"App":{"Title":"CEDAR Artifact Viewer","Maintained":"CEDAR is maintained by the Stanford Center for Biomedical Informatics Research.","Contact":"Contact CEDAR"},"Generic":{"Copy":"Copy"},"Extra":{"SampleTemplate":{"Title":"Sample templates","Select":"Select template","Find":"Find template...","FindNoMatch":"No matching templates found"},"JsonLD":{"Instance":"JSON-LD - Instance"},"JsonSchemaTemplate":"JSON Schema - Template"},"Process":{"Initializing":"CEDAR Artifact Viewer initializing..."}}');
    var V6e = U0.t(F6e, 2);
    const H6e = JSON.parse('{"App":{"Title":"CEDAR Dokumentum Megjelen\xedt\u0151","Maintained":"A CEDAR-t a Stanford Biomedikai Informatikai Kutat\xe1si K\xf6zpont m\u0171k\xf6dteti.","Contact":"Kapcsolat"},"Generic":{"Copy":"M\xe1sol\xe1s"},"Extra":{"SampleTemplate":{"Title":"Mintasablonok","Select":"V\xe1lassz sablont","Find":"Sablon keres\xe9se...","FindNoMatch":"Nincs egyez\u0151 sablon"},"JsonLD":{"Instance":"JSON-LD - P\xe9ld\xe1ny"},"JsonSchemaTemplate":"JSON S\xe9ma - Sablon"},"Process":{"Initializing":"A CEDAR Dokumentum Megjelen\xedt\u0151 inicializ\xe1l\xe1sa..."}}');
    var B6e = U0.t(H6e, 2);
    class j6e {
      http;
      fallback;
      constructor(t, e) {
        this.http = t, this.fallback = e;
      }
      getTranslation(t) {
        return console.log("GET translation:" + t), new Gw(this.http, "/assets/i18n-cav/").getTranslation(t).pipe(U2(a => (console.log("Translation file not found, using built-in version", a), Object.hasOwn(this.fallback, t) ? Promise.resolve(this.fallback[t]) : Promise.resolve(null))));
      }
    }
    $m.forRoot(), _0.forRoot({
      loader: {
        provide: ks,
        useFactory: t => function U6e(n, t) {
          return new j6e(n, t);
        }(t, {
          en: V6e,
          hu: B6e
        }),
        deps: [Yo]
      }
    });
    (function hI() {
      t7 = !1;
    })(), e9().bootstrapModule(F0).catch(n => console.error(n));
  }
}, j0 => {
  j0(j0.s = 921);
}]);